(function() {
    'use strict';

    angular
        .module('backApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'image.service',
            'infinite-scroll',
            'ui.select2',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('User', User)
        .factory('Charge', Charge)
        .factory('Accounts', Accounts);

    User.$inject = ['$resource'];
    Charge.$inject = ['$resource'];
    Accounts.$inject = ['$resource'];

    function User($resource) {
        var service = $resource('service/api/users/:path/:id', {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'activate': {method: 'GET', params: {path: "activate"}},
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });

        return service;
    }

    function Charge($resource) {
        var service = $resource('/security/api/charge-orders/:path/:id', {}, {
            'get': {
                method: "GET", isArray: true
                // transformResponse: function(data) {
                //     // console.log(data);
                //     // data = angular.fromJson(data);
                //     return data;
                // }
            }
        });

        return service;
    }


    function Accounts($resource) {
        var service = $resource('/security/api/account/resetPassword/:id', {}, {
            'get': {
                method: "GET", isArray: true,
                transformResponse: function(data) {
                    // console.log(data);
                    // data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Module', Module);

    Module.$inject = ['$resource'];

    function Module ($resource) {
        /*模块的列表配置*/
        var modules = [
            {
                name:"商户",
                icon:"store.png",
                id:"store",
                auth:['ROLE_STORE','ROLE_LOGO_SETTING','ROLE_MESSAGE_TEMPLATE'],
                menus:[
                    {
                        name:"商户设置",
                        id:"store",
                        auth:["ROLE_STORE"]
                    },
                    // {
                    //     name:"作品设置",
                    //     id:"store-work",
                    //     auth:["ROLE_STORE"]
                    // },
                    // {
                    //     name:"店铺装修",
                    //     id:"logo-setting",
                    //     auth:["ROLE_LOGO_SETTING"]
                    // },
                    {
                        name:"站内广播",
                        id:"message-notification",
                        auth:["ROLE_MESSAGE_TEMPLATE"]
                    },
                    {
                        name:"自定义色调",
                        id:"hue",
                        auth:["ROLE_LOGO_SETTING"]
                    },
                    // {
                    //     name: "商户充值",
                    //     id: "pay-orderNew",
                    //     auth: ["ROLE_RECHARGE"]
                    // },
                    // {
                    //     name: "消费明细",
                    //     id: "consumption",
                    //     auth: ["ROLE_BILLING_DETAIL"]
                    // },
                    // {
                    //     name: "充值记录",
                    //     id: "pay-order",
                    //     auth: ["ROLE_RECHARGE_RECORD"]
                    // },
                    {
                        name:"电商配置",
                        id:"configuration2",
                        auth:["ROLE_STORE"]
                    },
                    {
                        name:"DIY编辑器",
                        id:"diy-editor-setting",
                        auth:["ROLE_STORE"]
                    },
                    {
                        name:"图库存储",
                        id:"mapDepot",
                        auth:["ROLE_STORE"]
                    },
                ]
            },
            {
                name:"商品",
                icon:"product.png",
                id:"propertyCommercial",
                auth:['ROLE_PRODUCT','ROLE_PRODUCT_XML','ROLE_CATEGORY','ROLE_PROPERTY', 'ROLE_TASK_BILL_FORM','ROLE_PROCESS_OPERATION'],
                menus:[
                    {
                        name:"商品规格",
                        id:"propertyCommercial",
                        auth:["ROLE_PROPERTY"]
                    },
                    {
                        name:"商品分类",
                        id:"category",
                        auth:["ROLE_CATEGORY"]
                    },
                    {
                        name:"商品模板",
                        id:"mould",
                        auth:["ROLE_PRODUCT_XML"]
                    },
                    {
                        name:"商品管理",
                        id:"product",
                        auth:["ROLE_PRODUCT"]
                    },
                    {
                        name:"自定义任务单",
                        id:"taskbill-forms",
                        auth:["ROLE_TASK_BILL_FORM"]
                    },
                    {
                        name:"工艺管理",
                        id:"process",
                        auth:["ROLE_PROCESS_OPERATION"]
                    },
                ]
            },
            {
                name:"模板",
                icon:"productxml.png",
                id:"product-xml",
                auth:['ROLE_THEME_CATEGORY','ROLE_PRODUCT_XML','ROLE_DESIGNER_CONNETCING','ROLE_MASK','ROLE_BACKGROUND','ROLE_FONT_XML','ROLE_CLIPART','ROLE_FONT_MANAGEMENT', 'ROLE_FRAME_CONFIG'],
                menus:[
                    {
                        name:"模板列表",
                        id:"product-xml",
                        auth:["ROLE_PRODUCT_XML"]
                    },
                    {
                        name:"字体管理",
                        id:"font-management",
                        auth:["ROLE_FONT_MANAGEMENT"]
                    },
                    {
                        name:"素材管理",
                        id:"material",
                        classType:"CLIPART",
                        auth:["ROLE_CLIPART"]
                    },
                    // {
                    //     name:"工艺管理",
                    //     id:"material",
                    //     classType:"TECHNIQUE",
                    //     auth:["ROLE_CLIPART"]
                    // },
                    {
                        name:"背景管理",
                        id:"setting",
                        auth:["ROLE_BACKGROUND"]
                    },
                    {
                        name:"蒙版管理",
                        id:"masking",
                        auth:["ROLE_MASK"]
                    },
                    {
                        name:"文字模板",
                        id:"text-xml",
                        auth:["ROLE_FONT_XML"]
                    },
                    {
                        name:"边框",
                        id:"frame-config",
                        auth:["ROLE_FRAME_CONFIG"]
                    },
                    {
                        name:"推荐图片",
                        id:"recommend-pic",
                        auth:["ROLE_PRODUCT_XML"]
                    },
                    {
                        name:"模板分类",
                        id:"theme-classify",
                        classType:"XML",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    {
                        name:"背景分类",
                        id:"theme-classify",
                        classType:"BG",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    {
                        name:"蒙版分类",
                        id:"theme-classify",
                        classType:"MASK",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    {
                        name:"素材分类",
                        id:"theme-classify",
                        classType:"CLIPART",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    // {
                    //     name:"工艺分类",
                    //     id:"theme-classify",
                    //     classType:"TECHNIQUE",
                    //     auth:["ROLE_THEME_CATEGORY"]
                    // },
                    {
                        name:"文字模板分类",
                        id:"theme-classify",
                        classType:"FONT",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    {
                        name:"边框分类",
                        id:"theme-classify",
                        classType:"BORDER",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    {
                        name:"推荐图片分类",
                        id:"theme-classify",
                        classType:"RECOMMENDPIC",
                        auth:["ROLE_THEME_CATEGORY"]
                    },
                    {
                        name:"场景模型",
                        id:"scene",
                        auth:["ROLE_THEME_CATEGORY"]
                    }
                ]
            },
            // {
            //     name:"客户",
            //     icon:"iconyinyue",
            //     id:"customer",
            //     auth:['ROLE_CUSTOMER'],
            //     menus:[
            //         {
            //             name:"客户",
            //             id:"customer",
            //             auth:["ROLE_CUSTOMER"]
            //         }
            //     ]
            // },
            {
                name:"订单",
                icon:"order.png",
                id:"sales-order",
                auth:['ROLE_SALES_ORDER'],
                menus:[
                    {
                        name:"全部订单",
                        id:"sales-order",
                        auth:["ROLE_SALES_ORDER"]
                    }
                ]
            },
            {
                name:"数据",
                icon:"data.png",
                id:"product-analysis",
                auth:['ROLE_STATISTICS'],
                menus:[
                    {
                        name:"商品统计",
                        id:"product-analysis",
                        auth:["ROLE_STATISTICS"]
                    }
                ]
            },
            {
                name:"用户",
                icon:"user_model.png",
                id:"role",
                auth:['ROLE_ROLE','ROLE_USER'],
                menus:[
                    {
                        name:"角色",
                        id:"role",
                        auth:['ROLE_ROLE']
                    },
                    {
                        name:"用户",
                        id:"store-user",
                        auth:['ROLE_USER']
                    }
                ]
            },
            {
                name:"发票",
                icon:"invoice.png",
                id:"invoice",
                auth:['ROLE_INVOICE_LIST','ROLE_INVOICE_SUBMIT','ROLE_INVOICE_INFOMATION','ROLE_INVOICE_EXPRESS'],
                menus:[
                    {
                        name:"发票列表",
                        id:"invoice",
                        auth:['ROLE_INVOICE_LIST']
                    },

                    {
                        name:"发票申请",
                        id:"pay-order2",
                        auth:['ROLE_INVOICE_SUBMIT']
                    },
                    {
                        name:"开票信息",
                        id:"invoice-setting-list",
                        auth:['ROLE_INVOICE_INFOMATION']
                    },
                    {
                        name:"发票寄送",
                        id:"invoice-location",
                        auth:['ROLE_INVOICE_EXPRESS']
                    }
                ]
            },
            {
                name:"财务",
                icon:"caiwu2.png",
                id:"caiwu",
                auth:['ROLE_RECHARGE','ROLE_BILLING_DETAIL','ROLE_RECHARGE_RECORD','ROLE_STORE'],
                menus:[
                    {
                        name: "商户充值",
                        id: "pay-orderNew",
                        auth: ["ROLE_RECHARGE"]
                    },
                    {
                        name: "消费明细",
                        id: "consumption",
                        auth: ["ROLE_BILLING_DETAIL"]
                    },
                    {
                        name: "充值记录",
                        id: "pay-order",
                        auth: ["ROLE_RECHARGE_RECORD"]
                    },
                    {
                        name:"授信记录",
                        id:"creditExtension",
                        auth:["ROLE_STORE"]
                    }
                ]
            }
        ];
        return modules;
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('Register', Register)
        .factory('AccountP', AccountP);

    Register.$inject = ['$resource'];
    AccountP.$inject = ['$resource'];


    function Register ($resource) {
        var resourceUrl =  'security/' + 'api/register/:path';

        return $resource(resourceUrl, {}, {
            'checkLogin': { method: 'GET',params:{path:"checkLogin"}}

        });
    }
    function AccountP($resource) {
        var resourceUrl =  'security/' + 'api/store-users/:path/:id';
        var service = $resource(resourceUrl, {}, {
            'checkPassword': {
                method: "GET",
                params: {
                    path: "checkPassword"
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$localStorage'];

    function Principal ($q, Account, $localStorage) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (res) {
                if(res.status == 200){
                    _identity = res.data.data;
                    $localStorage.user = res.data.data;
                    _authenticated = true;
                    deferred.resolve(_identity);
                }else {
                    _identity = null;
                    _authenticated = false;
                    deferred.resolve(_identity);
                }
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var resourceUrl = 'security/' + 'api/store-users/changePassword/:id';
        return $resource(resourceUrl, {}, {
            'save': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'MessageService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, MessageService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            // LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    // this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account.status == 200) {
                        $translate.use(account.data.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('security/api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.user;
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('security/api/store-users/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) { 
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$q', '$state', '$scope', 'Auth', 'Principal', 'ProfileService', 'LoginService', "$uibModal", '$localStorage', '$sessionStorage', 'Store', '$timeout',
        'Qinius', 'Module', 'MessageService'];

    function NavbarController($q, $state, $scope, Auth, Principal, ProfileService, LoginService, $uibModal, $localStorage, $sessionStorage, Store, $timeout,
                              Qinius, Module, MessageService) {
        var vm = this;
        var pageName = null;
        var arr = null;
        vm.modules = Module;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.account = $localStorage.user;
        vm.menu = $localStorage.menu1;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.shrink = shrink;
        vm.sidebar2Shrik = sidebar2Shrik;
        vm.titleNavbar = titleNavbar;
        vm.passwords = passwords;
        vm.collapseNavbar = collapseNavbar;
        vm.lmenuClick = lmenuClick;

        vm.storeAll = Store.getCurrent();
        vm.domains = Qinius.getDomain();
        $q.all([vm.storeAll.$promise, vm.domains.$promise]).then(function () {
            vm.store = vm.storeAll.data;
            var currentDate = new Date();
            var currentDateStr = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate();
            if (!vm.store.periodOfValidity || new Date(currentDateStr).getTime() > new Date(vm.store.periodOfValidity).getTime()) {
                MessageService.error('商户已过有效期无法登录，请联系平台运营。');
                logout();
                return
            }
            vm.menulogo = vm.store.menuLogo;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            vm.auth = vm.account.authorities;
            if (vm.modules.length > 0) {
                for (var j = 0; j < vm.modules.length; j++) {
                    vm.modules[j].visiable = false;
                    if (vm.auth.length > 0) {
                        for (var i = 0; i < vm.auth.length; i++) {
                            if (vm.modules[j].auth.length > 0 && vm.modules[j].auth.indexOf(vm.auth[i]) > -1) {
                                vm.modules[j].visiable = true;
                                if (vm.modules[j].menus.length > 0) {
                                    for (var k = 0; k < vm.modules[j].menus.length; k++) {
                                        if (vm.modules[j].menus[k].auth.length > 0 && vm.modules[j].menus[k].auth.indexOf(vm.auth[i]) > -1) {
                                            vm.modules[j].menus[k].visiable = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }


            //等待页面加载完成之后 自执行
            vm.subId = sessionStorage.getItem('subId');
            vm.classType = sessionStorage.getItem('classType');
            vm.outerIndex = sessionStorage.getItem('outerIndex');
            if (vm.subId && vm.outerIndex) {
                $timeout(function () {
                    angular.element('#z' + vm.outerIndex).trigger('click');
                    if (vm.classType == 'undefined' || vm.classType == undefined || vm.classType == null || !vm.classType) {
                        angular.element('#' + vm.subId).addClass('navOn');
                    } else {
                        vm.navId = vm.subId;
                    }
                }, 100);
            }

            //列表收缩 展开
            $(".navbar").on('click', '.list-menu', function () {
                if (!$(this).hasClass('on')) {
                    $(this).parent().addClass('shell-nav-li-active').siblings('li').removeClass('shell-nav-li-active');
                    $(this).next('.shell-nav-body').slideDown(200).parent().siblings('li').find('.shell-nav-body').slideUp(200);
                    $(this).addClass('on').parent().siblings('li').find('.list-menu').removeClass('on');
                    $(this).find('.shell-nav-head-fr-show').addClass('rotateIcon').end().parent().siblings('li').find('.shell-nav-head-fr-show').removeClass('rotateIcon');
                    $(this).find('.shell-nav-head-title').addClass('shell-nav-head-title-active').end().parent().siblings('li').find('.shell-nav-head-title').removeClass('shell-nav-head-title-active');
                } else {
                    $(this).removeClass('on');
                    $(this).next('.shell-nav-body').slideUp(200).parent().siblings('li').find('.shell-nav-body').slideUp(200);
                    $(this).find('.shell-nav-head-fr-show').removeClass('rotateIcon');
                    $(this).find('.shell-nav-head-title').removeClass('shell-nav-head-title-active');
                    console.log("?????")
                }
            });
        })
        $scope.backTo = function () {
            sessionStorage.setItem("lmenu", 'a_marketing');
            $state.go("marketing");
            vm.lmenu = "a_marketing";

        }

        $scope.navSelect = function (nav, outerIndex) {
            if (nav.classType) {
                $state.go(nav.id, {classType: nav.classType});
            } else {
                $state.go(nav.id);
            }
            if (nav.classType) {
                vm.classType = nav.classType;
            } else {
                vm.classType = null;
            }
            sessionStorage.setItem('classType', nav.classType);//二级菜单的id
            if (!vm.classType && vm.navId == nav.id) {
                return
            }
            //模板分类
            if ((vm.classType && vm.classType == nav.classType) && vm.navId == nav.id) {
                return
            }
            angular.element('.sub_menu').removeClass('navOn');
            vm.navId = nav.id;

            sessionStorage.setItem('subId', nav.id);//二级菜单的id
            sessionStorage.setItem('outerIndex', outerIndex);//一级菜单index
            sessionStorage.removeItem('tableData');
        };

        // 菜单刷新后定位
        vm.lmenu = sessionStorage.getItem("lmenu") == null ? 'a_storeManagement' : sessionStorage.getItem("lmenu");
        if (vm.lmenu == "null" || vm.lmenu == 'a_storeManagement') {
            sessionStorage.setItem("lmenu", "a_storeManagement");
            lmenuClick('a_storeManagement');
        }
        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
            $(".titleNavbar").eq(vm.menu).find($(".arrowsB")).removeClass('arrows').addClass('arrowsTop');

        });

        var $logo = $(".navbar-logo");
        var $bar1 = $(".sidebar1-btn");
        var $side1 = $(".sidebar1");
        var $bar2 = $(".sidebar2-btn");
        var $side2 = $(".sidebar2");
        var isHide = false;
        var $navbar = $(".navbar-wrap");
        window.showSidebar2Shrink = function (event) {
            if ($navbar.hasClass("sidebar-collapse3")) {
                $(".sidebar2-shrink").removeClass('shidebar2-shrink-left').addClass('shidebar2-shrink-left2');
                return
            }
            $(".sidebar2-shrink").removeClass('shidebar2-shrink-left').addClass('shidebar2-shrink-left');
        };

        window.hideSidebar2Shrink = function (event) {
            if ($navbar.hasClass("sidebar-collapse3")) {
                $(".sidebar2-shrink").removeClass('shidebar2-shrink-left2');
                return
            }
            $(".sidebar2-shrink").removeClass('shidebar2-shrink-left');
        };

        function lmenuClick(a_id) {
            vm.lmenu = a_id;
            sessionStorage.setItem("lmenu", a_id);
            // 首页直接显示
            // if (a_id == "a_home") {
            //     return;
            // }
            setTimeout(function () {
                if ($side2[0] && $side2[0].children[0]) {
                    var childs = $side2[0].children[0];
                    if (childs.childElementCount < 2) {
                        return;
                    }
                    for (var i = 2; i < childs.childElementCount; i++) {
                        var li = childs.children[i];
                        if (li.attributes["style"] && li.attributes["style"].value == "display: none;") {
                            continue;
                        }
                        if (li.attributes["ui-sref"]) {
                            // $state.go(li.attributes["ui-sref"].value);
                            return;
                        }
                    }
                }
            }, 100);

        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            sessionStorage.setItem("lmenu", null);
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }


        var createModal = function (url, controller) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: true,
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }]
                }
            });
        };

        vm.show_logo = true;

        function shrink() {
            $navbar.toggleClass("sidebar-collapse");
            $side2.addClass('transition');
            if (isHide) {
                if ($navbar.hasClass("sidebar-collapse")) {
                    $bar1.removeClass('btn1-shrik1').addClass("btn1-shrik2");
                    $navbar.toggleClass("sidebar-collapse3").toggleClass("sidebar-collapse4");
                    $(".wrap").removeClass("wrap-mar130").removeClass("wrap-mar160").toggleClass("wrap-mar60");
                } else {
                    $bar1.removeClass('btn1-shrik2').addClass("btn1-shrik1");
                    $(".wrap").removeClass("wrap-mar160").removeClass("wrap-mar60").toggleClass("wrap-mar130");
                    $navbar.toggleClass("sidebar-collapse4").toggleClass("sidebar-collapse3");
                }
            } else {
                $bar1.toggleClass('btn1-shrik1').toggleClass("btn1-shrik2");
                $(".wrap").toggleClass("wrap-mar160");
            }

            $logo.addClass('transition');
            $logo.toggleClass("navbar-logo3");
            if ($logo.hasClass("navbar-logo3")) {
                vm.show_logo = false;
            } else {
                vm.show_logo = true;
            }
            return false;
        }

        $scope.resetPassword = function () {
            createModal('app/account/password/password.html', 'PasswordController').result.then(
                function (data) {
                });
        };

        function titleNavbar(i) {
            var $titleNavbar = $(".titleNavbar");
            var $menu1 = $(".menu1");
            // click时清空一级菜单样式
            $titleNavbar.find($(".navbar-title")).css({
                background: '#3c434d'
            });
            $titleNavbar.find($(".arrowsB")).removeClass('arrowsTop').addClass('arrows');
            //若二级菜单为隐藏状态：
            if ($titleNavbar.eq(i).find($menu1).is(':hidden')) {
                //箭头运动状态向下
                $titleNavbar.eq(i).find($(".arrowsB")).removeClass('arrows').addClass('arrowsTop');
                // click时改变一级菜单背景色和字体色
                $titleNavbar.eq(i).find($(".navbar-title")).css({
                    background: '#313840'
                });
                //显示当前二级菜单
                $titleNavbar.eq(i).find($menu1).slideDown(400);

                $localStorage.menu1 = i;
                //隐藏其他二级菜单
                $titleNavbar.eq(i).siblings().find($(".menu1")).hide();

            } else {
                $titleNavbar.eq(i).find($(".arrowsB")).removeClass('arrowsTop').addClass('arrows');
                $titleNavbar.eq(i).find($(".navbar-title")).css({
                    background: '#313840'
                });
                $titleNavbar.eq(i).find($menu1).slideUp(400);
                $titleNavbar.eq(i).siblings().find($menu1).hide();
            }
        }

        function sidebar2Shrik() {
            if (!($(".sidebar2-shrink").hasClass('shidebar2-shrink-left') || $(".sidebar2-shrink").hasClass('shidebar2-shrink-left2'))) {
                return
            }

            $side2.removeClass('transition');
            $(".sidebar2-shrink").removeClass('shidebar2-shrink-left2');
            isHide = !isHide;

            if (isHide) {
                $(".sidebar2").addClass("sidebar2-zIndex");
                $bar2.removeClass('btn2-shrik1').addClass("btn2-shrik2");
            } else {
                $(".sidebar2").removeClass("sidebar2-zIndex");
                $bar2.removeClass('btn2-shrik2').addClass("btn2-shrik1");
            }
            if ($navbar.hasClass("sidebar-collapse")) {
                $(".wrap").toggleClass("wrap-mar160").toggleClass("wrap-mar60");
                $navbar.removeClass("sidebar-collapse3").toggleClass("sidebar-collapse4");
            } else {
                $navbar.removeClass("sidebar-collapse2").removeClass("sidebar-collapse4").toggleClass("sidebar-collapse3");
                $(".wrap").removeClass("wrap-mar160").toggleClass("wrap-mar130");
            }
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function passwords() {
            delete $localStorage.pageName;
            pageName = window.location.hash;
            arr = pageName.split('#')[1].substring(1);
            $localStorage.pageName = arr
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'home',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('initController', initController);

    initController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$timeout', 'Auth', '$rootScope', '$sessionStorage' ];

    function initController($scope, Principal, LoginService, $state, $timeout, Auth, $rootScope, $sessionStorage) {
        var vm = this; 
        $scope.settings = {};

        $scope.getSettings = function(){
            
        }
        

        if($sessionStorage.settings ==null){
            $scope.getSettings(); 
        }else{
            $scope.settings = $sessionStorage.settings;
        }


 
        
         
        
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app2',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'home.title'
            },
            views: {
                'content2@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('home2', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'backApp.storeUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-users.html',
                    controller: 'StoreUserController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global'); 
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal','$translate', 'Store','AuthServerProvider','Module', '$state', '$timeout', 'Auth', '$rootScope', 'MessageService', '$localStorage','$http'];

    function HomeController($scope, Principal,$translate, Store,AuthServerProvider,Module, $state, $timeout, Auth, $rootScope, MessageService, $localStorage,$http) {
        var vm = this;
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.phoneNumber = null;
        vm.password2 = null;
        vm.Module = Module
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        $(".wrap").hide();
        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        // 点击登录事件
        function login(event) {
            if ($scope.tab) {
                vm.UserNameLogin(event)
            } else {
                vm.MobileLogin(event)
            }
        }
        vm.UserNameLogin = function login(event) {
            if (vm.username == null || vm.username == '') {
                MessageService.error("请输入用户名");
                return;
            }
            if (vm.password == null || vm.password == '') {
                MessageService.error("请输入密码");
                return;
            }
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                goHome()
            }).catch(function (error) {
                if (error && error.data && error.data["com.deltazo.westeros.security.UserNotActivatedException"]) {
                    MessageService.error("用户未激活");
                } else {
                    MessageService.error("用户名或密码不正确");
                }
                vm.authenticationError = true;
            });
        }
        // 手机号登录
        vm.MobileLogin = function (event) {

            if (vm.phoneNumber == null) {
                MessageService.error("请输入手机号");
                return;
            }
            if (vm.phoneNumber.length != 11) {
                MessageService.error("手机号应为11位");
                return;
            }
            if (vm.password2 == null || vm.password2 == '') {
                MessageService.error("请输入密码");
                return;
            }
            event.preventDefault();
            $http.post('security/api/authenticate2', {
                phone: vm.phoneNumber,
                password: vm.password2,
                rememberMe: vm.rememberMe
            }).success(function (data, status, headers) {
                if (data.status==400) {
                    MessageService.error('账号或密码有误');
                    return;
                }
                 var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    AuthServerProvider.storeAuthenticationToken(jwt, vm.rememberMe);
                    Principal.identity(true).then(function (account) {
                        if (account !== null) {
                            $translate.use(account.langKey).then(function () {
                                $translate.refresh();
                            });
                        }
                        goHome()
                    });
                }
            })
        }
        function goHome() {
            Store.getCurrent(function (res) {
                if (res.status == 200) {
                    if (!res.data.activated) {
                        MessageService.info("请等待平台管理员审核");
                        return;
                    }
                    var _route = findFirstMatchingMenu(vm.Module,$localStorage.user.authorities)
                    $state.go(_route.id);
                } else {
                    MessageService.error(res.message);
                }
            });
            vm.authenticationError = false;
            $(".wrap").show().css({ margin: '48px 10px 10px 200px' });
            delete $localStorage.menu1;
            delete $localStorage.menu2;
            delete $localStorage.pageName;
            $rootScope.$broadcast('authenticationSuccess');
            if (Auth.getPreviousState()) {
                var previousState = Auth.getPreviousState();
                Auth.resetPreviousState();
                $state.go(previousState.name, previousState.params);
            }
        }

        function findFirstMatchingMenu(a, b) {
            for (var i = 0; i < a.length; i++) {
                var item = a[i];
                for (var j = 0; j < item.menus.length; j++) {
                    var menu = item.menus[j];
                    for (var k = 0; k < menu.auth.length; k++) {
                        if (b.indexOf(menu.auth[k]) !== -1) {
                            return menu;
                        }
                    }
                }
            }
            return null;
        }


        function register() {
            $state.go('register');
        }
        function requestResetPassword() {
            $state.go('requestReset');
        }
        $scope.tab = true
        // tab栏切换
        $scope.func = function (param) {//tab切换的事件
            if (param == 1) {
                $scope.tab = true;
            } else if (param == 2) {
                $scope.tab = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ThemeClassifyDetailController', ThemeClassifyDetailController);

    ThemeClassifyDetailController.$inject = ['$state', 'entity', 'MessageService', '$uibModalInstance', 'ThemeClassify' ,'$uibModal'];

    function ThemeClassifyDetailController($state, entity, MessageService, $uibModalInstance, ThemeClassify, $uibModal) {

        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.multilingual= multilingual;
        if(entity.state == 'add'){
            vm.themeClassify = {
                type: entity.classIfyType,
                name: '',
                seq: '',
                used: true,
            }
            console.log(vm.themeClassify)
        }else {
            vm.themeClassify = entity.data;
        }
        console.log(vm.themeClassify)


        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data: vm.themeClassify.themeClassifyLanguages,
                            key:'name',
                            fieldValue: vm.themeClassify.name,
                            fieldName:'分类名称'
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    vm.themeClassify.themeClassifyLanguages=data;
                }
            });
        }


        function clear () {
            $uibModalInstance.close();
        };

        function save () {
            if(!vm.themeClassify.name){
                MessageService.error("请输入名称");
                return
            }
            if(vm.themeClassify.name == "推荐"){
                MessageService.error("不能使用'推荐'作为分类名字");
                return
            }
            if(!vm.themeClassify.seq || vm.themeClassify.seq < 0){
                MessageService.error("请输入正确的排序序号");
                return false;
            }
            vm.isSaving = true;
            ThemeClassify.save(vm.themeClassify, function(result){
                MessageService.success("操作完成");
                vm.isSaving = false;
                $uibModalInstance.close(result);
            },function(){
                MessageService.error("保存失败");
                vm.isSaving = false;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('theme-classify', {
            parent: 'entity',
            url: '/theme-classify?page&sort&search&classType',
            data: {
                authorities: ["ROLE_THEME_CATEGORY"],
                pageTitle: 'platformApp.themeClassify.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/theme-classify/theme-classify.html',
                    controller: 'ThemeClassifyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        classType: $stateParams.classType
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('themeClassify');
                    $translatePartialLoader.addPart('reprintType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('ThemeClassify', ThemeClassify);

    ThemeClassify.$inject = ['$resource'];

    function ThemeClassify ($resource) {
        var resourceUrl =  'manager/' + 'api/theme-classify/:path/:id';
        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "del":{
                method:"DELETE"
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            "get":{
                method:"GET"
            },
            "save":{
                method:"PUT"
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ThemeClassifyController', ThemeClassifyController)
        .filter('techniqueType', function() {
            return function(item) {
                if(item == 'gold'){
                    return '烫色';
                }else{
                    return item;
                }
            };
        });

    ThemeClassifyController.$inject = ['$state', '$scope', 'ParseLinks', 'MessageService', 'paginationConstants', 'pagingParams', 'ThemeClassify', '$localStorage', '$uibModal'];

    function ThemeClassifyController($state, $scope, ParseLinks, MessageService, paginationConstants, pagingParams, ThemeClassify, $localStorage, $uibModal) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.jump = jump;
        vm.clear = clear;
        vm.search = search;
        vm.classType = pagingParams.classType || 'XML';
        vm.classList = [
            {valur: '模板分类', type: 'XML'},
            {valur: '背景分类', type: 'BG'},
            {valur: '蒙版分类', type: 'MASK'},
            {valur: '素材分类', type: 'CLIPART'},
            {valur: '文字模板分类', type: 'FONT'},
            {valur: '边框分类', type: 'BORDER'}
        ];

        loadAll();
        $scope.delete = function (id) {
            MessageService.confirm("确认要删除该数据么？", function () {
                ThemeClassify.del({id: id}, function () {
                    loadAll();
                });
            }, function () {
            });
        };

        $scope.changeStatue = function (id,e) {
            fn(e);
            ThemeClassify.changeStatue({id: id}, function () {
                loadAll();
            });
        }

         //防止事件冒泡，默认事件
        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }

        function loadAll() {
            if (pagingParams.search) {
                ThemeClassify.byCondition3({
                    items: [
                        {key: "name", op: "like", value: pagingParams.search},
                        {key: "storeId", op: "=", value: vm.classType == 'XML' ? $localStorage.user.storeId : ''},
                        {key: "type", op: "=", value: vm.classType}
                        ],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ThemeClassify.byCondition3({
                    items: [{key: "storeId", op: "=", value: vm.classType == 'XML' ? $localStorage.user.storeId : ''},{key: "type", op: "=", value: vm.classType}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.storeData = [];
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.themeClassifyList = res.data;
                    vm.page = pagingParams.page;
                    for(var i=0; i<res.data.length; i++){
                        if(res.data[i].storeId){
                            vm.storeData.push(res.data[i])
                        }
                    }
                }else{
                    MessageService.error(res.message);
                    return
                }

            }

            function onError(error) {
                MessageService.error("数据加载出错");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $(".navbar").show();
        $(".wrap").show().css({'margin': 'margin: 48px 0 0 130px;'});

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                classType: vm.classType
            });
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            console.log(vm.page);
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }


        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
            loadAll();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        $scope.addClass = function () {
            $uibModal.open({
                templateUrl: 'app/entities/theme-classify/theme-classify-detail.html',
                controller: 'ThemeClassifyDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                size: 'md',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add',
                            classIfyType: vm.classType
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.editClass = function (data) {
            var copy = angular.copy(data);
            $uibModal.open({
                templateUrl: 'app/entities/theme-classify/theme-classify-detail.html',
                controller: 'ThemeClassifyDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'edit',
                            data: copy
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.classCb = function (item) {
            vm.classType = item.type;
            vm.transition();
            // loadAll()
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('text-xml', {
            parent: 'entity',
            url: '/text-xml?page&sort&search',
            data: {
                authorities: ["ROLE_FONT_XML"],
                pageTitle: 'backApp.title.textXml'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/text-xml/text-xml.html',
                    controller: 'TextXmlController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('text-xml-approve', {
            parent: 'text-xml',
            url: '/approve/{id}',
            data: {
                authorities: ["ROLE_FONT_XML"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/text-xml/modal/text-xml-approve.html',
                    controller: 'TextXmlApproveController',
                    controllerAs: 'vm',
                    windowClass:'modal-right',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FontXmls'  , function(FontXmls) {
                            return FontXmls.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('text-xml', null, { reload: 'text-xml' });
                }, function() {
                    $state.go('text-xml');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('FontXmls', FontXmls);

    FontXmls.$inject = ['$resource'];

    function FontXmls ($resource) {
        var resourceUrl =  'manager/' + 'api/font-xmls/:path/:id';
        return $resource(resourceUrl, {}, {
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete': {
                method: 'DELETE'
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "approve":{
                method:"GET",
                params:{
                    path:"approve"
                }
            },
            "reject":{
                method:"GET",
                params:{
                    path:"reject"
                }
            },
            "receive":{
                method:"POST",
                params:{
                    path:"receive"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('TextXmlController', TextXmlController);

    TextXmlController.$inject = ['$scope', '$q', '$state', 'FontXmls', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', '$uibModal'];

    function TextXmlController ($scope, $q, $state, FontXmls, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, $uibModal) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.status = status;

        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        function loadAll () {
            if (pagingParams.search) {
                FontXmls.byCondition2({
                    items: [{key:"name",op:"like",value:pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FontXmls.byCondition2({
                    items:[],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.textXmls = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                    return
                }

            }
            function onError(error) {
                MessageService.error("文字模板获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

 
        $scope.rejected = function(item){
            MessageService.confirm("确认要拒绝该文字模板", function(){
                FontXmls.reject({id:item.id, status:"Rejected", remarks:""},function(){
                    MessageService.success("拒绝成功");
                    loadAll();
                },function(){
                    MessageService.error("拒绝失败");
                })
            })
        };
         
        $scope.delete = function(id){
            MessageService.confirm("确认删除该背景？",function(){
                FontXmls.delete({id: id},function () {
                    MessageService.success("删除成功");
                    loadAll();
                });
            },function(){});
        };
        function status(item) {
            switch (item) {
                case 'Creating':
                    return '新建';
                    break;
                case 'Created':
                    return '已创建';
                    break;
                case 'Approved':
                    return '已通过';
                    break;
                case 'Rejected':
                    return '已拒绝';
                    break;
                case 'Cancelled':
                    return '已取消';
                    break;
                default:
                    return '暂无状态'
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('TextXmlLookController', TextXmlLookController);

    TextXmlLookController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function TextXmlLookController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.cancel = cancel;
        vm.url = entity.url;
        vm.domain = entity.domain;

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('TextXmlApproveController', TextXmlApproveController);

    TextXmlApproveController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'MessageService', 'ThemeClassify', 'FontXmls'];

    function TextXmlApproveController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, MessageService, ThemeClassify, FontXmls) {
        var vm = this;

        vm.textXml = entity;
        vm.clear = clear;
        vm.save = save;
        vm.themes = ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'FONT'}]});
        vm.domains = Qinius.getDomain();
        $q.all([vm.themes.$promise,vm.domains.$promise,vm.textXml.$promise]).then(function(){
            vm.themeClassifies = vm.themes.data;
            vm.textXml = vm.textXml.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.validate = function(){
            if(vm.textXml.themeClassifyId == null || vm.textXml.themeClassifyId==""){
                MessageService.error("请选择分类");
                return false;
            }
            if(!vm.textXml.seq){
                MessageService.error("请输入排序");
                return false;
            }
            return true;
        };

        function save () {
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            FontXmls.approve({id:vm.textXml.id, themeClassifyId: vm.textXml.themeClassifyId},function(res){
                if(res.status == 200){
                    MessageService.success("审核通过");
                    $uibModalInstance.close();
                }else {
                    vm.isSaving = false;
                    MessageService.error(res.message);
                }
            },function(){
                MessageService.error("通过失败");
                vm.isSaving = false;
            })
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('TaskbillFormsController', TaskbillFormsController);

    TaskbillFormsController.$inject = ['$state', '$scope', '$localStorage', 'ParseLinks', 'MessageService', 'paginationConstants', 'pagingParams', 'TaskbillForms', 'Principal'];

    function TaskbillFormsController($state, $scope, $localStorage, ParseLinks, MessageService, paginationConstants, pagingParams, TaskbillForms, Principal) {

        Principal.hasAuthority('ROLE_TASK_BILL_FORM').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有访问自定义任务单的权限！");
                $state.go("producer");
            }
        });

        var vm = this;

        vm.forms = [];
        vm.storeId = $localStorage.user.storeId;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        loadAll();

        function loadAll() {
            var items = [];
            items.push({key: "storeId", op: "=", value: vm.storeId});
            if (pagingParams.search) {
                items.push({key: "name", op: "like", value: pagingParams.search});
            }
            TaskbillForms.findPage({
                items:items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.forms = data || [];
                vm.page = pagingParams.page;
            }

            function onError(error) {
                MessageService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                storeId:vm.storeId
            });
        }

        $scope.delete = function(id){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                TaskbillForms.delete({id: id},function () {
                    loadAll();
                });
            },function(){},true);
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

    }
 })();
(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('TaskbillFormDialogController', TaskbillFormDialogController);

    TaskbillFormDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'Store', '$state', '$uibModal', "MessageService", 'TaskbillForms', 'entity'];

    function TaskbillFormDialogController ($timeout, $scope, $stateParams, Store, $state, $uibModal, MessageService, TaskbillForms, entity) {
        var vm = this;

        vm.form = entity || {
        	name: "",
        	enabled: true,
        	remarks: "",
        	width: 100,
        	height: 100,
        	backgroundColor: "#FFFFFF",
        	items: []
        };
        vm.fields = [];
        vm.panel = {
        	scale: 1,
        	offsetX: 0,
        	offsetY: 0,
        	marginWidth: 10
        };
        vm.selected = null;
        vm.onFormSizeChange = onFormSizeChange;
        vm.close = close;
        vm.save = save;
        vm.onItemMousedown = onItemMousedown;

        init();

        function init() {
        	if (!vm.form.items) {
        		vm.form.items = [];
        	}
        	if (!vm.form.backgroundColor) {
        		vm.form.backgroundColor = "#FFFFFF";
        	}
        	TaskbillForms.fields({}, function (res) {
        		vm.fields = res || [];
        		buildForm(vm.fields);
        	});
        }

        function buildForm(fields) {
        	var pos = 0;
        	for (var i = 0; i < fields.length; i++) {
        		var f = fields[i];

        		var item = null;
        		for (var j = 0; j < vm.form.items.length; j++) {
        			var it = vm.form.items[j];
        			if (f.field == it.field) {
        				item = it;
        				break;
        			}
        		}
        		if (item == null) {
        			vm.form.items.push({
        				id: null,
        				label: f.label,
        				field: f.field,
        				enabled: f.enabled,
        				x: 0,
        				y: pos,
        				width: f.width,
        				height: f.height,
        				text: f.text,
        				fontSize: f.fontSize,
        				bold: f.bold,
        				demoValue: f.demoValue
        			});
        		} else {
        			item.label = f.label;
        			item.text = f.text;
        			item.demoValue = f.demoValue;
        		}
        		pos += 6;
        	}
        	$timeout(function() {
        		onFormSizeChange();	
        	}, 100);

        	registerEvents();
        }

        function registerEvents() {
        	window.addEventListener("resize", onResize);
        	window.addEventListener("mousedown", onMousedown);
        	window.addEventListener("mousemove", onMousemove);
        	window.addEventListener("mouseup", onMouseup);
        	window.addEventListener("mouseleave", onMouseleave);
        }

        function unregisterEvents() {
        	window.removeEventListener("resize", onResize);
        	window.removeEventListener("mousedown", onMousedown);
        	window.removeEventListener("mousemove", onMousemove);
        	window.removeEventListener("mouseup", onMouseup);
        	window.removeEventListener("mouseleave", onMouseleave);
        }

        function mm2px(val) {
        	return (val * 96 / 25.4) ;
        }
        function px2mm(val) {
        	return (val * 25.4 / 96);
        }

        function onResize(e) {
        	onFormSizeChange();
        }

        function onFormSizeChange(e) {
        	if (e) {
        		console.log(e);
        	}
        	if (!vm.form.width || !vm.form.height) {
        		return;
        	}
        	if (vm.form.width < 10 || vm.form.height < 10) {
        		return;
        	}
        	var client = document.getElementById("panel-client");
        	var clientWidth = client.clientWidth;
        	var clientHeight = client.clientHeight;
        	var marginWidth = vm.panel.marginWidth;
        	var formW = mm2px(vm.form.width);
        	var formH = mm2px(vm.form.height);
        	var scaleX = (clientWidth - marginWidth * 2) / formW;
        	var scaleY = (clientHeight - marginWidth * 2) / formH;
        	var scale = Math.min(scaleX, scaleY);
        	// var scale = 1;
        	vm.panel.scale = scale;
        	vm.panel.offsetX = (clientWidth - formW) / 2 - marginWidth;
        	vm.panel.offsetY = (clientHeight - formH) / 2 - marginWidth;

        	fixPositionForItems()
        }

        function fixPositionForItems() {
        	for (var i = 0; i < vm.form.items.length; i++) {
        		var it = vm.form.items[i];
        		if (it.x >= vm.form.width) {
        			it.x = 0;
        		}
        		if (it.y >= vm.form.height) {
        			it.y = 0;
        		}
        	}
        	$scope.$apply();
        }

        function close() {
        	unregisterEvents();
        	$state.go('taskbill-forms', null, { reload: false });
        }

        function validate() {
        	if (!vm.form.name) {
        		MessageService.error("请输入名称");
        		return false;
        	}
        	if (!vm.form.width || vm.form.width < 10) {
        		MessageService.error("请输入有效表单长");
        		return false;
        	}
        	if (!vm.form.height || vm.form.height < 10) {
        		MessageService.error("请输入有效表单宽");
        		return false;
        	}
        	return true;
        }

        function save() {
        	if (!validate()) {
        		return;
        	}
        	vm.isSaving = true;

        	if (!vm.form.id) {
        		TaskbillForms.create(vm.form, onSuccess, onFailed);
        	} else {
        		TaskbillForms.update(vm.form, onSuccess, onFailed);
        	}
        }

        function onSuccess(res) {
        	vm.isSaving = false;
        	MessageService.success("保存成功");
        	unregisterEvents();
        	$state.go('taskbill-forms', null, { reload: true });
        }

        function onFailed(error) {
        	vm.isSaving = false;
        	MessageService.error("保存失败")
        }

        function onMousedown($event) {
        	// console.log('form_mousedown', $event);
        	vm.selected = null;

        }

        function onItemMousedown($event, item) {
        	console.log('item_mousedown', $event, item);
        	vm.selected = {
        		x0: item.x,
        		y0: item.y,
        		mouseX0: $event.pageX,
        		mouseY0: $event.pageY,
        		item: item,
        		dragging: true
        	};
        	$event.preventDefault();
        	$event.stopPropagation();
        }

        function onMousemove($event) {
        	if (!vm.selected) {
        		return;
        	}
        	if (!vm.selected.dragging) {
        		return;
        	}
        	

        	var mouseX = $event.pageX;
        	var mouseY = $event.pageY;
        	var deltaX = (mouseX - vm.selected.mouseX0) / vm.panel.scale;
        	var deltaY = (mouseY - vm.selected.mouseY0) / vm.panel.scale;

        	var newX = vm.selected.x0 + px2mm(deltaX);
        	var newY = vm.selected.y0 + px2mm(deltaY);
        	if (newX < 0) {
        		newX = 0;
        	}
        	if (newY < 0) {
        		newY = 0;
        	}
        	if (newX + vm.selected.item.width > vm.form.width) {
        		newX = vm.form.width - vm.selected.item.width;
        		if (newX < 0) {
        			return;
        		}
        	}
        	if (newY + vm.selected.item.height > vm.form.height) {
        		newY = vm.form.height - vm.selected.item.height;
        		if (newY < 0) {
        			return;
        		}
        	}
        	

        	vm.selected.item.x = newX;
        	vm.selected.item.y = newY;
        	$timeout(function() {
        		$scope.$apply();
        	}, 100);
        }

        function onMouseup($event) {
        	if (!vm.selected) {
        		return;
        	}

        	// console.log("mouseup", $event);
        	vm.selected.dragging = false;
        	$scope.$apply();
        }

        function onMouseleave($event) {
        	if (!vm.selected) {
        		return;
        	}
        	// console.log("mouseleave", $event);
        	vm.selected.dragging = false;
        	$scope.$apply();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('taskbill-forms', {
            parent: 'entity',
            url: '/taskbill-forms?page&sort&search',
            data: {
                authorities: ['ROLE_TASK_BILL_FORM'],
                pageTitle: 'backApp.taskbillForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/taskbill-form/taskbill-form-list.html',
                    controller: 'TaskbillFormsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskbillForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('taskbill-forms.new', {
            parent: 'taskbill-forms',
            url: '/new',
            data: {
                authorities: ["ROLE_TASK_BILL_FORM"],
                pageTitle: 'backApp.taskbillForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/taskbill-form/taskbill-form-dialog.html',
                    controller: 'TaskbillFormDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskbillForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function() {
                    return {
                        name: "",
                        width: 100,
                        height: 100,
                        backgroundColor: "#FFFFFF",
                        enabled: true,
                        items: []
                    };
                }
            }

        })
        .state('taskbill-forms.edit', {
            parent: 'taskbill-forms',
            url: '/{id}/edit',
            data: {
                authorities: ["ROLE_TASK_BILL_FORM"],
                pageTitle: 'backApp.taskbillForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/taskbill-form/taskbill-form-dialog.html',
                    controller: 'TaskbillFormDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskbillForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['TaskbillForms', '$stateParams', function(TaskbillForms, $stateParams) {
                    return TaskbillForms.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('TaskbillForms', TaskbillForms);

    TaskbillForms.$inject = ['$resource'];

    function TaskbillForms ($resource) {
        var resourceUrl =  'manager/' + 'api/taskBillForms/:path/:id';
        return $resource(resourceUrl, {}, {
            "fields":{
                method:"GET",
                params:{
                    path:"fields"
                },
                isArray:true
            },
            "create":{
                method:"POST",
                params:{
                    path: "create"
                }
            },
            "update":{
                method:"POST",
                params: {
                    path: "update"
                }
            },
            "delete":{
                method:"DELETE"
            },
            "get":{
                method:"GET"
            },
            "findAll":{
                method:"POST",
                params: {
                    path: "findAll"
                },
                isArray: true
            },
            "findPage": {
                method: "POST",
                params: {
                    path: "findPage"
                },
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreUserDialogController', StoreUserDialogController);

    StoreUserDialogController.$inject = ['$timeout', '$scope', 'StoreUser1', '$stateParams', '$interval', '$state', '$q', 'Store', 'entity', 'StoreUser', 'Role', 'MessageService', 'VerifyCode'];

    function StoreUserDialogController($timeout, $scope, StoreUser1, $stateParams, $interval, $state, $q, Store, entity, StoreUser, Role, MessageService, VerifyCode) {
        var vm = this;
        vm.storeUser = entity;
        console.log(vm.storeUser);
        vm.clear = clear;
        vm.save = save;
        vm.rolesAll = Role.getAllByCondition2({ items: [{ key: "type", op: "=", value: "STORE" }] });
        $q.all([vm.storeUser.$promise, vm.rolesAll.$promise]).then(function () {
            vm.roles = vm.rolesAll.data;
            if (!!vm.storeUser.id) {
                vm.title = "编辑"
            } else {
                vm.title = "新建"
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('store-user', null, { reload: 'store-user' });
        }
        // 新建验证
        $scope.validate = function () {
            if (vm.storeUser.name == null || vm.storeUser.name == "") {
                MessageService.error("请输入用户名称");
                return false;
            }
            if (!vm.storeUser.phone) {
                if (vm.phone == null || vm.phone == '') {
                    MessageService.error("请输入手机号码");
                    return false;
                }
                if (vm.phone.length != 11) {
                    MessageService.error("手机号码应为11位");
                    return false;
                }
                if (vm.verifyCode == null || vm.verifyCode == '') {
                    MessageService.error("验证码不能为空");
                    return false;
                }
            }
            if (vm.storeUser.roleId == null || vm.storeUser.roleId == "") {
                MessageService.error("请选择角色");
                return false;
            }
            return true;
        }
        // 编辑验证
        $scope.validate2 = function () {
            if (vm.storeUser.name == null || vm.storeUser.name == "") {
                MessageService.error("请输入用户名称");
                return false;
            }
            if (vm.storeUser.roleId == null || vm.storeUser.roleId == "") {
                MessageService.error("请选择角色");
                return false;
            }
            return true;
        }

        function save() {
            if (!$scope.validate()) {
                return;
            }
            if (vm.storeUser.id != null) {
                checkUser(function () {
                    vm.isSaving = true;
                    if (!vm.storeUser.phone) {
                        vm.storeUser.phone = vm.phone;
                        vm.storeUser.code = vm.verifyCode;
                    }
                    StoreUser1.update(vm.storeUser, onSaveSuccess, onSaveError);
                })
            } else {
                checkUser(function () {
                    vm.isSaving = true;
                    vm.storeUser.langKey = "zh-cn";
                    vm.storeUser.phone = vm.phone;
                    vm.storeUser.message = vm.verifyCode;
                    Store.creagteUser(vm.storeUser, onSaveSuccess, onSaveError);
                })
            }
        }
        function onSaveSuccess(result) {
            vm.isSaving = false;
            $scope.$emit('backApp:storeUserUpdate', result);
            $state.go('store-user', null, { reload: 'store-user' });
            MessageService.success("保存成功");
        }
        function onSaveError() {
            vm.storeUser.phone = null;
            vm.isSaving = false;
            MessageService.error("保存失败");
        }
        function checkUser(callback) {
            if (!vm.storeUser.phone) {
                var _data = { phone: vm.phone };
                if (!vm.storeUser.id) {
                    _data.username = vm.storeUser.name
                }
                StoreUser.checkUser2(_data, function (data) {
                    if (!data.data) {
                        MessageService.error("该手机号或者用户名已存在");
                    } else {
                        callback()
                    }
                }, function () {
                    MessageService.error("校验用户名时出错");
                });
            } else {
                callback()
            }
        }
        // 获取验证码
        $scope.paracont = "获取验证码";
        vm.disabled = false;
        //验证码的定时器
        var timer = null;
        $scope.getVerifyCode = function () {
            if (vm.phone == null || vm.phone == "") {
                MessageService.error("请先输入手机号码");
                return;
            }
            if (vm.phone.length != 11) {
                MessageService.error("手机号码应为11位");
                return;
            }
            if (vm.disabled) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            VerifyCode.getVerifyCode2({
                phone: vm.phone,
                incident: "新用户注册"
            }, function (msg) {
                if (msg.status == 200) {
                    MessageService.success(msg.message == null ? '短信发送成功' : msg.message);
                } else {
                    MessageService.error(msg.message == null ? '短信发送失败' : msg.message);
                    return;
                }
                clearInterval(timer);
                timer = $interval(function () {
                    if (vm.countdown > 0) {
                        vm.disabled = true;
                        vm.countdown--;
                        $scope.paracont = "重新发送(" + vm.countdown + ")";
                    } else {
                        vm.disabled = false;
                        $interval.cancel(timer);
                        $scope.paracont = "重发验证码";
                    }
                }, 1000);
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreUserDetailController', StoreUserDetailController);

    StoreUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'StoreUser', '$uibModalInstance'];

    function StoreUserDetailController($scope, $rootScope, $stateParams, entity, StoreUser, $uibModalInstance) {
        var vm = this;

        vm.storeUser = entity.data;
        vm.clear = clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        var unsubscribe = $rootScope.$on('backApp:storeUserUpdate', function(event, result) {
            vm.storeUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('store-user', {
            parent: 'entity',
            url: '/store-user?page&sort&search',
            data: {
                authorities: ["ROLE_USER"],
                pageTitle: 'backApp.storeUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-users.html',
                    controller: 'StoreUserController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-user-detail', {
            parent: 'store-user',
            url: 'store-user/{id}',
            data: {
                authorities: ["ROLE_USER"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-user/store-user-detail.html',
                    controller: 'StoreUserDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StoreUser', function(StoreUser) {
                            return StoreUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('store-user-detail.edit', {
            parent: 'store-user-detail',
            url: '/detail/edit',
            data: {
                authorities: ["ROLE_USER"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-user/store-user-dialog.html',
                    controller: 'StoreUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StoreUser', function(StoreUser) {
                            return StoreUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('store-user.new', {
            parent: 'store-user',
            url: '/new',
            data: {
                authorities: ["ROLE_USER"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-user-dialog.html',
                    controller: 'StoreUserDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        uuid: null,
                        password: null,
                        cancelled: null,
                        scope: null,
                        activated: true,
                        langKey: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-user.edit', {
            parent: 'store-user',
            url: '/{id}/edit',
            data: {
                authorities: ["ROLE_USER"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-user/store-user-dialog.html',
                    controller: 'StoreUserDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['StoreUser','$stateParams', function(StoreUser,$stateParams) {
                    return StoreUser.get({id : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-user.delete', {
            parent: 'store-user',
            url: '/{id}/delete',
            data: {
                authorities: ["ROLE_USER"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-user/store-user-delete-dialog.html',
                    controller: 'StoreUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StoreUser', function(StoreUser) {
                            return StoreUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('store-user', null, { reload: 'store-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('backApp')
        .factory("AgentManagement", AgentManagement)
        .factory('StoreUser', StoreUser)
        .factory('StoreUser1', StoreUser1);

    StoreUser.$inject = ['$resource'];
    StoreUser1.$inject = ['$resource'];
    AgentManagement.$inject = ['$resource'];

    function AgentManagement($resource) {
        var resourceUrl = 'manager/' + 'api/agent-managements/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'updateAgents': {
                method: 'POST',
                params: {
                    path: 'updateAgents'
                },
            }
        });
    }

    function StoreUser($resource) {
        var resourceUrl = 'security/' + 'api/store-users/:path/:id';
        return $resource(resourceUrl, {}, {
            "register": {
                method: 'POST',
                params: {
                    path: "register"
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "resetPassword": {
                method: "GET",
                params: {
                    path: "resetPassword"
                }
            },
            'checkUser': {
                method: "POST",
                params: {
                    path: "checkUser"
                }
            },
            'checkUser2': {
                method: "GET",
                params: {
                    path: "checkUser2"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            }
        });
    }
    function StoreUser1($resource) {
        var resourceUrl = 'manager/' + 'api/store-users/:path/:id';

        return $resource(resourceUrl, {}, {
            "register": {
                method: 'POST',
                params: {
                    path: "register"
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "resetPassword": {
                method: "GET",
                params: {
                    path: "resetPassword"
                }
            },
            "createDefaultRole": {
                method: "GET",
                params: {
                    path: "createDefaultRole"
                }
            },
            "changePassword2": {
                method: "POST",
                params: {
                    path: "changePassword2"
                }
            },
            'checkUser': {
                method: "POST",
                params: {
                    path: "checkUser"
                },
                isArray: true
            },
            'checkUser2': {
                method: "GET",
                params: {
                    path: "checkUser2"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreUserController', StoreUserController);

    StoreUserController.$inject = ['$scope', '$state', 'StoreUser', 'Account', 'ParseLinks',  'paginationConstants', 'pagingParams', 'MessageService', '$uibModal'];

    function StoreUserController ($scope, $state, StoreUser, Account, ParseLinks,   paginationConstants, pagingParams, MessageService, $uibModal) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.account = Account.get();
        vm.jump = jump;


        loadAll();
        $scope.delete = function(id){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                StoreUser.delete({id: id},function () {
                    MessageService.success("删除成功");
                    loadAll();
                });
            },function(){},true);
        };

        $scope.resetPassword = function(user){
            MessageService.confirm("确认要该用户密码还原成初始密码？",function(){
                StoreUser.resetPassword({id: user.id},function () {
                    MessageService.success("该用户密码已设置为初始密码");
                    loadAll();
                });
            },function(){});
        }

        function loadAll () {
            if (pagingParams.search) {
                StoreUser.byCondition({
                    items:[{key:"name",op:"like",value:pagingParams.search}] ,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                StoreUser.byCondition({
                    items:[],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.storeUsers = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("用户加载失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.batchArr = [];
        $scope.selectOne = false;
        $scope.selectAll = false;

        $scope.chooseAll = function () {
            $scope.selectAll = !$scope.selectAll;
            $scope.batchArr = [];
            angular.forEach(vm.storeUsers,function (storeUser,i) {
                if($scope.selectAll){
                    storeUser.select = true;
                    $scope.batchArr.push(storeUser.id);
                    $scope.selectOne = true;
                }else{
                    storeUser.select = false;
                    $scope.selectOne = false;
                }
                // 当前登录用户
                if(storeUser.isCreated||vm.account.name==storeUser.name){
                    storeUser.select = false;
                }
            })
        }

        $scope.chooseOne = function (storeUser) {
            if(storeUser.isCreated||vm.account.name==storeUser.name){
                return
            }
            storeUser.select = !storeUser.select;
            // 选中
            if(storeUser.select){
                $scope.batchArr.push(storeUser.id);
            }else{
                // 未选中
                var ind = $scope.batchArr.indexOf(storeUser.id);
                if (ind >= 0) {
                    $scope.batchArr.splice(ind, 1);
                }
            }

            // 判断全选按钮
            var flag = true;
            angular.forEach(vm.storeUsers,function (storeUser,i) {
                if(!storeUser.select){
                    $scope.selectAll = false;
                    flag = false;
                }
                // 全部选中
                if(i==vm.storeUsers.length-1&&flag){
                    $scope.selectAll = true;
                }
            })

            // 批量按钮的显示
            if($scope.batchArr.length){
                $scope.selectOne = true;
            }else {
                $scope.selectOne = false;
            }
        }

        $scope.deleteBatch = function () {
            MessageService.confirm("entity.action.deleteConfirm",function(){
                StoreUser.deleteBatch({ids: $scope.batchArr},function () {
                    MessageService.success("删除成功");
                    $scope.selectOne = false;
                    $scope.selectAll = false;
                    loadAll();
                },function () {
                    MessageService.error("删除失败");
                })
            },function(){},true);
        }

        $scope.editorPhone = function(storeUser){
            $uibModal.open({
                templateUrl: 'app/entities/store-user/phone-editor.html',
                controller: 'PhoneEditorController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return storeUser;
                    }]
                }
            }).result.then(function (backData) {
                if(backData){
                    loadAll()
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PhoneEditorController', PhoneEditorController);

        PhoneEditorController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MessageService', 'StoreUser1', 'VerifyCode', '$interval'];

    function PhoneEditorController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MessageService, StoreUser1, VerifyCode, $interval) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.data = angular.copy(entity);
        vm.data.phone = null;
        
        $scope.paracont = "获取验证码";
        vm.disabled = false;
        //验证码的定时器
        var timer = null;
        var reg_tel = /^1[0-9]{10}$/
        $scope.getVerifyCode = function () {
            if (!reg_tel.test(vm.data.phone)) {
                MessageService.error("请输入正确的手机号");
                return
            }
        
            if (vm.disabled) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            VerifyCode.getVerifyCode2({
                phone: vm.data.phone,
                incident: "修改手机号"
            }, function (msg) {
                if(msg.status == 400){
                    MessageService.error(msg.message || "发送短信失败,请稍后重试");
                    return
                }
                clearInterval(timer);
                timer = $interval(function () {
                    if (vm.countdown > 0) {
                        vm.disabled = true;
                        vm.countdown--;
                        $scope.paracont = "重新发送(" + vm.countdown + ")";
                    } else {
                        vm.disabled = false;
                        $interval.cancel(timer);
                        $scope.paracont = "重发验证码";
                    }
                }, 1000);
            });
        };

        function save () {
            if (!reg_tel.test(vm.data.phone)) {
                MessageService.error("请输入正确的手机号");
                return
            }
            if (!vm.data.code) {
                MessageService.error("请输入验证码");
                return
            }
            vm.isSaving = true;
            StoreUser1.update({id:vm.data.id,phone:vm.data.phone,code:vm.data.code},onSaveSuccess,onSaveError)
        }

        function onSaveSuccess (res) {
            console.log(res);
            MessageService.success("手机号更新成功");
            $uibModalInstance.close(true);
            vm.isSaving = false;
        }

        function onSaveError (res) {
            console.log(res);
            if (res.data) {
                if (res.data.status == 400 && res.data.message) {
                    MessageService.error(res.data.message);
                    vm.isSaving = false;
                    return;
                }
            }
            MessageService.error("手机号修改失败");
            vm.isSaving = false;
        }

        function clear () {
            $uibModalInstance.dismiss(false);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreWorkEditController', StoreWorkEditController);

    StoreWorkEditController.$inject = ['$scope', '$q', 'OrderSetting', 'entity', 'Store', 'MessageService', '$state', 'StoreWorkEditConfig', 'StoreConfig'];

    function StoreWorkEditController($scope, $q, OrderSetting, entity, Store, MessageService, $state, StoreWorkEditConfig, StoreConfig) {
        var vm = this;
        //保存
        vm.save = save;
        vm.cancel = cancel;
        vm.storeWorkEdit = StoreWorkEditConfig.storeId();

        $q.all([vm.storeWorkEdit.$promise]).then(function () {
            vm.storeWorkEdit = vm.storeWorkEdit.data;
        });
        var flag = true;
        window.showSkuList = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            if (flag) {
                flag = false;
                $(".paybatch-proName").addClass('text-decoration-underline');
                $(".paybatch-tip").show().css({left: e.clientX || 0, top: e.clientY || 0});
            }
        }

        window.hideSkuList = function (e) {
            fn(e);
            $(".paybatch-tip").hide();
            $(".paybatch-proName").removeClass('text-decoration-underline');
            flag = true;
        }
        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

        function save() {
            vm.isSaving = true;
            if (vm.storeWorkEdit.id !== null) {
                StoreWorkEditConfig.update(vm.storeWorkEdit, onSaveSuccess, onSaveError);
            } else {
                StoreWorkEditConfig.save(vm.storeWorkEdit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:storeUpdate', result);
            vm.isSaving = false;
            MessageService.success("保存成功！");
            $state.go('store-work', {reload: true})
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("保存失败！");
            $state.go('store-work',{reload:true})
        }

        function cancel() {
            $state.go("store-work");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreDialog3Controller', StoreDialog3Controller);

    StoreDialog3Controller.$inject = ['$timeout', '$q', '$http', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Store', 'MessageService', 
    'PayOrder', 'RechargeSetting'];

    function StoreDialog3Controller ($timeout, $q, $http, $scope, $stateParams, $uibModalInstance, entity, Store, MessageService, 
        PayOrder, RechargeSetting) {
        var vm = this;

        vm.store = entity;
        vm.clear = clear;  
        vm.activation = activation;
        vm.prepare = false;
        $scope.timer = null;
        vm.payOrderId = null;

        vm.rechargeSettings  = RechargeSetting.getAllByCondition({sort:["id,asc"]});

        $q.all([vm.store.$promise, vm.rechargeSettings.$promise]).then(function(){
            vm.rechargeSettings.sort( function(a, b){return a.seq - b.seq;});
        },function(){})

        $scope.selectedRecgarge = function(rechargeSetting){
            vm.rechargeSetting = rechargeSetting;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            clearInterval($scope.timer);
            $uibModalInstance.dismiss('cancel');
        }

        // 激活操作
        function activation(){
            if (vm.rechargeSetting == null || vm.rechargeSetting.id == null) {
                MessageService.error("请选择充值时间");
                return;
            }
            clearInterval($scope.timer);
            PayOrder.createPayOrder({rechargeSettingId:vm.rechargeSetting.id},function(data){
                vm.payOrderId = data.id;
                $http({
                    url: '/back/manager/api/stores/onLineActivation/'+vm.store.id,
                    method: 'GET',
                    params:{payOrderId: vm.payOrderId},
                    responseType: 'blob'
                    }).success(function(res){
                        vm.prepare = true;
                        var blob = new Blob([res], {type: "image/jpeg"});
                        $scope.image = URL.createObjectURL(blob);
                        //启动一个定时器判断是否完成支付，完成则关闭页面 取消定时器
                        $scope.timer = setInterval(function () {
                            PayOrder.get({id: vm.payOrderId}, function (val) {
                                if (!!val && val.paid) {
                                    clearInterval($scope.timer); 
                                    MessageService.success("支付完成");
                                    $uibModalInstance.close();
                                }
                            }, function () {
                            });
                        }, 2000);
                    })
                },function(){})
            
        } 
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreDialog2Controller', StoreDialog2Controller);

    StoreDialog2Controller.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Store', 'MessageService'];

    function StoreDialog2Controller ($timeout, $scope, $stateParams, $uibModalInstance, entity, Store, MessageService) {
        var vm = this;

        vm.store = entity;
        vm.clear = clear;  
        vm.activation = activation;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        // 激活操作
        function activation(){
            if (vm.store.key == null|| vm.store.key == "") {
                MessageService.error("请输入激活码");
                return ;
            }; 
            MessageService.confirm(vm.store.activated?"你确定进行续时操作吗？":"你确定进行激活操作吗？", function () { 
                Store.activation({
                    id: vm.store.id, 
                    key: vm.store.key
                }, onSaveSuccess, function (){
                    MessageService.error("激活码存在错误");
                });
            }, function () { 
            }); 
        } 

        function onSaveSuccess (result) {
            $scope.$emit('backApp:storeUpdate', result);
            MessageService.success("信息更新成功");
            $uibModalInstance.close(result); 
        } 
        
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreDialogController', StoreDialogController);

    StoreDialogController.$inject = ['$timeout', '$scope', 'StoreWechatSetting', 'entity', 'Store', 'MessageService', '$state', 'OrderSetting', 'Qinius', '$q', '$uibModal', 'StoreApplies'];

    function StoreDialogController($timeout, $scope, StoreWechatSetting, entity, Store, MessageService, $state, OrderSetting, Qinius, $q, $uibModal, StoreApplies) {
        var vm = this;

        vm.store = entity;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;


        var flag = true;
        window.showSkuList = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            if(flag){
                flag = false;
                $(".paybatch-proName").addClass('text-decoration-underline');
                $(".paybatch-tip").show().css({left:e.clientX || 0,top:e.clientY || 0});
            }
        }

        window.hideSkuList = function (e) {
            fn(e);
            $(".paybatch-tip").hide();
            $(".paybatch-proName").removeClass('text-decoration-underline');
            flag = true;
        }

        window.showSkuList2 = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            if(flag){
                flag = false;
                $(".substitutione").addClass('text-decoration-underline');
                $(".substitutione-tip").show().css({left:e.clientX || 0,top:e.clientY || 0});
            }
        }

        window.hideSkuList2 = function (e) {
            fn(e);
            $(".substitutione-tip").hide();
            $(".substitutione").removeClass('text-decoration-underline');
            flag = true;
        }

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }


        //高级设置 商户设置保存方法
        vm.save2 = save2;
        vm.cancel2 = cancel2;
        //高级设置  订单设置保存方法
        vm.save3 = save3;
        //高级设置  订单设置 返回方法
        vm.cancel3 = cancel3;

        vm.storeOrderSetting = OrderSetting.getStoreOrderSetting2();
        vm.domains = Qinius.getDomain();

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.types = [{key:"公众号",value:"WECHAT",selected:false}, {key:"小程序",value:"MINI",selected:false}, {key:"第三方",value:"THIRD",selected:false}]
        $q.all([vm.domains.$promise, vm.store.$promise, vm.storeOrderSetting.$promise]).then(function () {
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if (vm.store.storeType2) {
                for (var i = vm.types.length - 1; i >= 0; i--) {
                    var t = vm.types[i];
                    if(vm.store.storeType2.indexOf(t.value)>=0){
                        t.selected = true;
                    }
                }
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });
        StoreWechatSetting.getPrivateWechatSetting(function (msg) {
            $scope.storeWechatSetting = msg;
        })


        // 表单校验
        $scope.validate = function () {
            if (vm.store.name == null || vm.store.name == "") {
                MessageService.error("请录入名称");
                return false;
            }
            if (vm.store.contact == null || vm.store.contact == "") {
                MessageService.error("请录入联系人");
                return false;
            }
            if (vm.store.phone == null || vm.store.phone == "") {
                MessageService.error("请录入联系方式");
                return false;
            }
            if (vm.store.email == null || vm.store.email == "") {
                MessageService.error("请录入邮箱");
                return false;
            }
            if ((vm.store.storeType == 'Person' || vm.store.storeType == null) &&
                (vm.store.idCard == null || vm.store.idCard == "")) {
                MessageService.error("请录入证件号");
                return false;
            };
            if (vm.store.storeType == 'Company' && (vm.store.companyName == null || vm.store.companyName == "")) {
                MessageService.error("请录入公司名称");
                return false;
            };
            if (vm.store.storeType == 'Company' && (vm.store.companyCode == null || vm.store.companyCode == "")) {
                MessageService.error("请录入公司工商注册码");
                return false;
            };
            if (vm.store.address == null || vm.store.address == "") {
                MessageService.error("请录入地址");
                return false;
            }
            if (vm.store.email == null || vm.store.email == "") {
                MessageService.error("请录入邮箱");
                return false;
            };
            return true;
        }


        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }

        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.store.logo = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }


        window.uploadPic2 = function (event) {
            var files = event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload2(files[0]);
            }
        }

        function qiniuUpload2(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.store.miniIndex = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }

        window.uploadPic3 = function ($event,attr) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload3(files[0],attr);
            }
        }

        function qiniuUpload3(file,attr) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    if(attr=='login'){
                        vm.store.webLoginLogo = data.key;
                    }else{
                        vm.store.webRegisterLogo = data.key;
                    }

                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }

        $scope.removeFile = function (file) {
            vm.store.logo = null;
        }

        $scope.removeFile2 = function (file) {
            vm.store.miniIndex = null;
        }

        $scope.removeFile3 = function (file,attr) {
            if(attr=='login'){
                vm.store.webLoginLogo = null;
            }else{
                vm.store.webRegisterLogo = null;
            }
        }

        function save2() {
            vm.isSaving = true;
            if (vm.store.id !== null) {
                Store.update(vm.store, onSaveSuccess2, onSaveError);
            } else {
                Store.save(vm.store, onSaveSuccess2, onSaveError);
            }
        }

        function onSaveSuccess2(result) {
            $scope.$emit('backApp:storeUpdate', result);
            vm.isSaving = false;
            $state.go("senior", null, { reload: true });
        }


        function cancel2() {
            $state.go("senior");
        }

        $scope.validate = function(){

        }

        function save3() {
            if (vm.store.numberRule == null || vm.store.numberRule.length<4) {
                MessageService.error("输入的订单号前缀不符合规则");
                return false;
            }
            if (/^([0-9]+)$/.test(vm.store.numberRule.substring(1)) && /[a-zA-Z]+/.test(vm.store.numberRule.substring(0,1))) {
            }else{
                MessageService.error("输入的订单号前缀不符合规则");
                return false;
            }
            Store.getAllByCondition({
                items: [{key:"numberRule", op:"=", value:vm.store.numberRule}]
            }, function(data){
                if (vm.store.id !== null) {
                    if ((data.length ==1 && data[0].id != vm.store.id) || data.length>1) {
                        MessageService.error("订单号前缀重复，请重新设定");
                    }else{
                        vm.isSaving = true;
                        Store.update(vm.store, onSaveSuccess3, onSaveError);
                    }
                } else {
                    if (data.length >0) {
                        MessageService.error("订单号前缀重复，请重新设定");
                    }else{
                        vm.isSaving = true;
                        Store.save(vm.store, onSaveSuccess3, onSaveError);
                    }

                }
            }, function(){
                MessageService.error("检查单号前缀失败，请稍后再试");
            });
        }

        function onSaveSuccess3(result) {
            $scope.$emit('backApp:storeUpdate', result);
            vm.isSaving = false;
            vm.storeOrderSetting.platformFlag = false;
            vm.storeOrderSetting.storeId = result.id;
            OrderSetting.updateStoreTimerSetting(vm.storeOrderSetting, function (data) {
                MessageService.success("保存成功！");
                $state.go("sales-setting", null, { reload: true });
            }, function (data) {
                MessageService.error("延时信息保存失败！");
            })
        }

        function cancel3() {
            $state.go("sales-setting");
        }

        function onSaveError(result) {
            MessageService.error("操作失败，请稍后再试！");
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.activationDate = false;
        vm.datePickerOpenStatus.periodOfValidity = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreDetailController', StoreDetailController);

    StoreDetailController.$inject = ['$scope', '$q', 'entity', 'Store', 'MessageService', 'Qinius', '$state', 'StoreWorkEditConfig', 'ECommerceSetting','UidService','$uibModal','JhiLanguageService','$timeout'];

    function StoreDetailController($scope, $q, entity, Store, MessageService, Qinius, $state, StoreWorkEditConfig, ECommerceSetting, UidService, $uibModal,JhiLanguageService,$timeout) {
        var vm = this;
        vm.isEdit = false;
        vm.isEdit2 = false;
        vm.isEdit3 = false;
        vm.isEdit4 = false;
        vm.store = entity;
        console.log(entity);
        vm.storeWorkEdit = StoreWorkEditConfig.storeId();
        vm.domains = Qinius.getDomain();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.availableLanguages = JhiLanguageService.availableLanguages();
        // {key: "中文", value: "zh-cn", selected: false, default:false},
        // {key: "英文", value: "en", selected: false, default:false}


        vm.types = [{key:"公众号",value:"WECHAT",selected:false}, {key:"小程序",value:"MINI",selected:false}, {key:"第三方",value:"THIRD",selected:false}]
        $q.all([vm.domains.$promise, vm.store.$promise, vm.storeWorkEdit.$promise]).then(function () {
            // vm.domains = vm.domains.data;
            vm.store = vm.store.data;
            vm.defalutLangKey = vm.store.defaultLangKey;
            if (vm.store.availableLangKey) {
                for (var i = vm.availableLanguages.length - 1; i >= 0; i--) {
                    var lang = vm.availableLanguages[i];
                    if (vm.store.availableLangKey.indexOf(lang.value) >= 0) {
                        lang.selected = true;
                    }
                    if (vm.defalutLangKey == lang.value){
                        lang.default = true;
                    }
                }
            }

            vm.storeWorkEdit = vm.storeWorkEdit.data;
            ECommerceSetting.getECommerceSettingByStoreId({storeId:vm.store.id},function (resp) {
                if(resp.status == 200){
                    vm.data = resp.data;
                }else {
                    MessageService.error(resp.message);
                }
            });
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if (vm.store.storeType2) {
                for (var i = vm.types.length - 1; i >= 0; i--) {
                    var t = vm.types[i];
                    if(vm.store.storeType2.indexOf(t.value)>=0){
                        t.selected = true;
                    }
                }
            }
        });

        var flag = true;
        window.showSkuList = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            if(flag){
                flag = false;
                $(".paybatch-proName").addClass('text-decoration-underline');
                $(".paybatch-tip").show().css({left:e.clientX || 0,top:e.clientY || 0});
            }
        }

        window.hideSkuList = function (e) {
            fn(e);
            $(".paybatch-tip").hide();
            $(".paybatch-proName").removeClass('text-decoration-underline');
            flag = true;
        }

        window.showSkuList2 = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            if(flag){
                flag = false;
                $(".substitutione").addClass('text-decoration-underline');
                $(".substitutione-tip").show().css({left:e.clientX || 0,top:e.clientY || 0});
            }
        }

        window.hideSkuList2 = function (e) {
            fn(e);
            $(".substitutione-tip").hide();
            $(".substitutione").removeClass('text-decoration-underline');
            flag = true;
        }

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

        $scope.saveWork = function () {
            vm.isSaving = true;
            vm.isEdit = false;
            if (vm.storeWorkEdit.id !== null) {
                StoreWorkEditConfig.update(vm.storeWorkEdit, onSaveSuccess, onSaveError);
            } else {
                StoreWorkEditConfig.save(vm.storeWorkEdit, onSaveSuccess, onSaveError);
            }
        }

        $scope.cancelWork = function () {
            vm.isEdit = false;
            StoreWorkEditConfig.storeId(function (res) {
                vm.storeWorkEdit = res.data;
            });
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:storeUpdate', result);
            vm.isSaving = false;
            MessageService.success("保存成功！");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("保存失败！");
        }

        $scope.saveData = function () {
            vm.isEdit2 = false;
            ECommerceSetting.edit(vm.data,function (res) {
                if(res.status == 200){
                    MessageService.success("修改成功");
                }else {
                    MessageService.error(res.message);
                }
            })
        }
        $scope.cancelData = function () {
            vm.isEdit2 = false;
            ECommerceSetting.getECommerceSettingByStoreId({storeId:vm.store.id},function (resp) {
                if(resp.status == 200){
                    vm.data = resp.data;
                }else {
                    MessageService.error(resp.message);
                }
            });
        }

        window.uploadPic = function ($event,attr) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0],attr);
            }
        }

        function qiniuUpload(file,attr) {
            vm.attr = attr;
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "setting-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    if(attr=='login'){
                        imgSrop($scope.domain + data.key, 600, 300)
                    }else if(attr=='register'){
                        imgSrop($scope.domain + data.key, 600, 300)
                    }else{
                        imgSrop($scope.domain + data.key, 300, 160)
                    }

                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        function imgSrop(url, width, height){
            $uibModal.open({
                templateUrl: 'app/entities/initialization/modal/img-crop.html',
                controller: 'ImgCropController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            url: url,
                            width: width,
                            height: height
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    if(vm.attr=='login'){
                        vm.store.webLoginLogo = data;
                    }else if(vm.attr=='register'){
                        vm.store.webRegisterLogo = data;
                    }else{
                        vm.store.menuLogo = data;
                    }
                    Store.update(vm.store, onSaveSuccess, onSaveError);
                }
            });
        }

        $scope.saveStore = function () {
            vm.isEdit3 = false;
            Store.update(vm.store, onSaveSuccess, onSaveError);
        }


        $scope.cancelStore = function () {
            vm.isEdit3 = false;
            Store.getCurrent(function (res) {
                vm.store = res.data;
            })
        }

        $scope.saveOperation = function () {
            vm.isEdit4 = false;
            vm.store.availableLangKey = [];
            vm.store.defaultLangKey = "";
            for (var i = vm.availableLanguages.length - 1; i >= 0; i--) {
                var t = vm.availableLanguages[i];
                if (t.selected) {
                    vm.store.availableLangKey.push(t.value)
                }
            }
            for (var j = vm.availableLanguages.length - 1;j >= 0; j--){
                if (vm.availableLanguages[j].default){
                    vm.store.defaultLangKey = vm.availableLanguages[j].value;
                }
            }
            Store.update(vm.store, onSaveSuccess, onSaveError);
        }

        $scope.cancelOperation = function () {
            vm.isEdit4 = false;
            Store.getCurrent(function (res) {
                vm.store = res.data;
                if (vm.store.availableLangKey) {
                    angular.forEach(vm.availableLanguages, function(l){
                        l.selected = false;
                        l.default = false;
                    })
                    for (var i = vm.availableLanguages.length - 1; i >= 0; i--) {
                        var lang = vm.availableLanguages[i];
                        if (vm.store.availableLangKey.indexOf(lang.value) >= 0) {
                            lang.selected = true;
                        };
                        if (vm.store.defaultLangKey == lang.value){
                            lang.default = true;
                        }
                    }
                }
            })
        }

        $scope.selectLang = function (lang) {
            var count = 0;
            for (var j=0; j<vm.availableLanguages.length;j++){
                if (vm.availableLanguages[j].selected){
                    count ++;
                }
            }
            if (count == 0 && !lang.selected){
                lang.selected = true;
                return
            }
            if (lang.default && !lang.selected){
                lang.default = false;
                for (var i = vm.availableLanguages.length - 1; i >= 0; i--){
                    var language = vm.availableLanguages[i];
                    if (language.selected){
                        language.default = true;
                        break
                    }
                }
            }
        }

        $scope.defaultLang = function (language){
            for (var i = vm.availableLanguages.length - 1; i >= 0; i--){
                var lang = vm.availableLanguages[i];
                if (lang.default){
                    if (lang.value == language.value){
                        return
                    }
                    lang.default = false;
                }
            }
            language.default = true;
            vm.store.defaultLangKey = language.value;
            Store.update(vm.store, onSaveSuccess, onSaveError);
        }
        vm.multilingual = function (title, name, key, data){
            if(!vm.storeWorkEdit[data]){
                vm.storeWorkEdit[data] = [];
            }
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.storeWorkEdit[data],
                            key: key,
                            fieldValue: name,
                            fieldName: title
                        };
                    }]
                }
            }).result.then(function(res) {
                if (res) {
                    vm.storeWorkEdit[data] = res;
                    console.log(vm.storeWorkEdit)
                }
            })
        }

        //模板背景图更改
        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                    reader.onload = function () {       //  成功读取
                        $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) {     //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "setting-"+ UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.store.faviconLogo = data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.removeFile = function() {
            vm.store.faviconLogo = null;
        }
        /************************************    CMYK转RGB   *****************************************************/

        // ICC文件上传：仅限.icc文件，文件名用UUID拼接保证不重复
        // type: 'cmyk' 源CMYK ICC | 'rgb' 目标RGB ICC
        window.uploadIccFile = function ($event, type) {
            var file = $event.target.files[0];
            if (!file) {
                return;
            }
            // 校验文件扩展名，仅允许 .icc
            var fileName = file.name;
            var dotIndex = fileName.lastIndexOf('.');
            var ext = dotIndex >= 0 ? fileName.substring(dotIndex + 1).toLowerCase() : '';
            if (ext !== 'icc') {
                MessageService.error("仅支持上传.icc文件");
                $event.target.value = '';
                return;
            }
            // 用UUID拼接生成唯一key，避免同名冲突
            var uid = UidService.get();
            var key;
            if (type === 'cmyk') {
                key = 'icc-cmyk-uuid-' + uid + '.icc';
            } else if (type === 'rgb') {
                key = 'icc-rgb-uuid-' + uid + '.icc';
            } else {
                MessageService.error("未知的ICC类型");
                $event.target.value = '';
                return;
            }
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', key);
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    $scope.$apply(function () {
                        if (type === 'cmyk') {
                            vm.store.sourceCmykIccName = fileName;
                            vm.store.sourceCmykIccUrl = $scope.domain + data.key;
                        } else if (type === 'rgb') {
                            vm.store.targetRgbIccName = fileName;
                            vm.store.targetRgbIccUrl = $scope.domain + data.key;
                        }
                    });
                    MessageService.success("ICC文件上传成功");
                },
                error: function (request) {
                    MessageService.error("ICC文件上传失败");
                }
            });
        };

        // 删除已上传的ICC文件
        $scope.removeIccFile = function (type) {
            if (type === 'cmyk') {
                vm.store.sourceCmykIccName = null;
                vm.store.sourceCmykIccUrl = null;
            } else if (type === 'rgb') {
                vm.store.targetRgbIccName = null;
                vm.store.targetRgbIccUrl = null;
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('store', {
                parent: 'entity',
                url: '/store',
                data: {
                    authorities: ['ROLE_STORE'],
                    pageTitle: 'global.menu.entities.store'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/store/store-detail.html',
                        controller: 'StoreDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Store', function ($stateParams, Store) {
                        return Store.getCurrent({}).$promise;
                    }]
                }
            })
            .state('store-work', {
                parent: 'store',
                url: '/work',
                data: {
                    authorities: ['ROLE_STORE'],
                    pageTitle: 'global.menu.entities.store'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/store/store-workEdit.html',
                        controller: 'StoreWorkEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('store-work-edit', {
                parent: 'store',
                url: '/work/edit',
                data: {
                    authorities: ['ROLE_STORE'],
                    pageTitle: 'global.menu.entities.store'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/store/store-workEdit-edit.html',
                        controller: 'StoreWorkEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }]
                }
            })


            .state('store.edit', {
                parent: 'store',
                url: '/edit',
                data: {
                    authorities: ['ROLE_STORE'],
                    pageTitle: 'backApp.store.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/store/store-dialog.html',
                        controller: 'StoreDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Store', function ($stateParams, Store) {
                        return Store.getCurrent({}).$promise;
                    }]
                }
            })
            .state('store.edit2', {
                parent: 'store',
                url: '/{id}/edit2',
                data: {
                    authorities: ['ROLE_STORE']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/store/store-dialog2.html',
                        controller: 'StoreDialog2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Store', function (Store) {
                                return Store.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('store', null, {reload: 'store'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('store.edit3', {
                parent: 'store',
                url: '/{id}/edit3',
                data: {
                    authorities: ['ROLE_STORE']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/store/store-dialog3.html',
                        controller: 'StoreDialog3Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Store', function (Store) {
                                return Store.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('store', null, {reload: 'store'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory("RechargeSetting", RechargeSetting)
        .factory('PlatformAbutment', PlatformAbutment)
        .factory('Store', Store)
        .factory('StoreWorkEditConfig', StoreWorkEditConfig)
        .factory('StoreOrderConfig', StoreOrderConfig)
        .factory('StoreConfig', StoreConfig)
        .factory('VerifyCode', VerifyCode)
        .factory('OrderSetting', OrderSetting);

    PlatformAbutment.$inject = ['$resource'];
    Store.$inject = ['$resource', 'DateUtils'];
    StoreConfig.$inject = ['$resource'];
    StoreWorkEditConfig.$inject = ['$resource'];
    StoreOrderConfig.$inject = ['$resource'];
    VerifyCode.$inject = ['$resource', 'DateUtils'];
    OrderSetting.$inject = ['$resource', 'DateUtils'];

    function PlatformAbutment($resource) {
        var resourceUrl = 'manager/' + 'api/platform-abutment/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                },
                isArray: true
            },
            "getPlatformAbutment": {
                method: "GET",
                params: {
                    path: "getPlatformAbutment"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'PUT'
            },
            'del': {
                method: 'GET',
                params: {
                    path: 'del'
                }
            },
            'changeState': {
                method: 'GET',
                params: {
                    path: 'changeState'
                }
            },
            'reloadToken': {
                method: 'GET',
                params: {
                    path: 'reloadToken'
                }
            }
        });
    }

    RechargeSetting.$inject = ['$resource', 'DateUtils'];

    function RechargeSetting($resource) {
        var resourceUrl = 'manager/' + 'api/recharge-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },

            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'update': {
                method: 'PUT'
            }
        })
    }

    function StoreConfig($resource) {
        var resourceUrl = 'manager/' + 'api/store-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            'getCurrent': {
                method: 'GET',
                params: {
                    path: "current"
                },
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'update': {
                method: 'PUT',
            }
        });
    }

    function StoreWorkEditConfig($resource) {
        var resourceUrl = 'manager/' + 'api/store-work-edit-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            'getCurrent': {
                method: 'GET',
                params: {
                    path: "current"
                },
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'update': {
                method: 'PUT',
            },
            'storeId':{
                method: 'GET',
                params: {
                    path: "storeId"
                },
            }
        });
    }

    function StoreOrderConfig($resource) {
        var resourceUrl = 'manager/' + 'api/store-order-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            "updateLogisticsSetting": {
                method: "GET",
                params: {
                    path: "updateLogisticsSetting"
                }
            },
            "getLogisticsSetting": {
                method: "GET",
                params: {
                    path: "getLogisticsSetting"
                }
            },
            'getCurrent': {
                method: 'GET',
                params: {
                    path: "current"
                },
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'update': {
                method: 'PUT',
            },
            'storeId':{
                method: 'GET',
                params: {
                    path: "storeId"
                },
            }
        });
    }

    function Store($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/stores/:path/:id';

        return $resource(resourceUrl, {}, {
            'getCurrent': {
                method: 'GET',
                params: {
                    path: "current"
                },
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.activationDate = DateUtils.convertLocalDateFromServer(data.activationDate);
                        data.periodOfValidity = DateUtils.convertLocalDateFromServer(data.periodOfValidity);
                    }
                    return data;
                }
            },
            "onLineActivation": {
                method: "GET",
                params: {
                    path: "onLineActivation"
                }
            },
            "activation": {
                method: "GET",
                params: {
                    path: "activation"
                }
            },
            "updateSkin": {
                method: "GET",
                params: {
                    path: "updateSkin"
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "creagteUser":{
                method:"POST",
                params:{
                    path:"createUser"
                }
            },
            "getStoreForAgent": {
                method: "GET",
                params: {
                    path: "getStoreForAgent"
                },
                isArray: true
            },
            "getStoreForJoin": {
                method: "GET",
                params: {
                    path: "getStoreForJoin"
                },
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true
            },
            'signOut': {
                method: 'GET',
                params: {
                    path: "signOut"
                },
            },
            'batchSignOut': {
                method: 'GET',
                params: {
                    path: "batchSignOut"
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.durationOfOperationTo = DateUtils.convertLocalDateFromServer(data.durationOfOperationTo);
                        data.activationDate = DateUtils.convertLocalDateFromServer(data.activationDate);
                        data.periodOfValidity = DateUtils.convertLocalDateFromServer(data.periodOfValidity);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.activationDate = DateUtils.convertLocalDateToServer(copy.activationDate);
                    copy.periodOfValidity = DateUtils.convertLocalDateToServer(copy.periodOfValidity);
                    return angular.toJson(copy);
                }
            },
            'create': {
                method: 'POST',
                params: {
                    path: 'create'
                },
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.activationDate = DateUtils.convertLocalDateToServer(copy.activationDate);
                    copy.periodOfValidity = DateUtils.convertLocalDateToServer(copy.periodOfValidity);
                    return angular.toJson(copy);
                }
            }
        });
    }

    function VerifyCode($resource, DateUtils) {
        var resourceUrl = 'manager' + '/api/verify-codes/:path/:id';
        return $resource(resourceUrl, {}, {
            "getVerifyCode2": {
                method: "GET",
                params: {
                    path: "getVerifyCode2"
                }
            },
            "check": {
                method: "GET",
                params: {
                    path: "check"
                }
            }
        })
    }

    function OrderSetting($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/timer-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            "updateStoreTimerSetting":{
                method: 'PUT',
                params:{
                    path:"updateStoreTimerSetting"
                }
            },
            "getStoreOrderSetting2":{
                method: 'GET',
                params:{
                    path:"getStoreOrderSetting2"
                }
            },
            'update': {
                method: 'PUT'
            },
            'get': {
                method: 'GET',
                params: {
                    path: 'getOrderSetting'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('StoreController', StoreController);

    StoreController.$inject = ['$scope', '$state', 'Store', 'StoreSearch', 'ParseLinks', 'MessageService', 'paginationConstants', 'pagingParams'];

    function StoreController ($scope, $state, Store, StoreSearch, ParseLinks, MessageService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                StoreSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Store.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.stores = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                MessageService.error("商店加载失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('JoinController', JoinController);

    JoinController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'CommodityPrice', 'Product', 'Store', '$state', 'MessageService', '$uibModalInstance', 'StoreApplies'];

    function JoinController ($timeout, $scope, $stateParams, $q, entity, CommodityPrice, Product, Store, $state, MessageService, $uibModalInstance, StoreApplies) {
        var vm = this;
        vm.store = entity;
        vm.cancel = cancel;
        vm.save = save;
        vm.storeList = [];
        vm.saveData = {
            storeName: vm.store.name,
            status: vm.store.status,
            applyType: 'JOIN',
            parentStoreId: ""
        };

        //获取所有上级商户
        Store.getAllByCondition({
            items: [{key:"bigStore",op:"=",value: 'true'}]
        }, function (res) {
            res.forEach(function (item) {
                console.log(item)
                if(!item.cancelled){
                    vm.storeList.push(item)
                }
            })
        })

        $scope.chooseOne = function (item) {
            item.select = !item.select;
            if(item.select){
                vm.saveData.parentStoreId = item.id;
                vm.saveData.parentStoreName = item.name;
                vm.storeList.forEach(function (data) {
                    if(item.id != data.id){
                        data.select = false;
                    }
                })
            }else {
                vm.saveData.parentStoreId = "";
                vm.saveData.parentStoreName = "";
            }
        }


        //确定
        function save() {
            if(!vm.saveData.parentStoreId){
                MessageService.error("请选择要加入的商户");
                return
            }
            StoreApplies.save(vm.saveData, function (res) {
                MessageService.success("加盟申请已提交！");
                $uibModalInstance.close();
            }, function (error) {
                $uibModalInstance.close();
            })
        }

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SettingDialogController', SettingDialogController);

    SettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Backgrounds', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', 'Convert', '$localStorage'];

    function SettingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Backgrounds, MessageService,
        Upload, UidService, ThemeClassify, Convert, $localStorage) {
        var vm = this;

        vm.type = entity.state;
        vm.attachments = [];
        vm.imgs = [];
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                identifier: '',
                keys: [],
                type:'BG'
            }
        }
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'BG'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                Backgrounds.get({id: entity.data.id},function (res) {
                    if(res.status == 200){
                        vm.data = res.data;
                        console.log(vm.data)
                    }else{
                        MessageService.error(res.message);
                        return
                    }
                });
            }

        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }

        $scope.removeFile = function(file, index) {
            vm.attachments.splice(index, 1);
            vm.data.keys.splice(index, 1);
        };

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择背景分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(vm.type == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择背景图片");
                    return
                }
            }else{
                if(!vm.data.identifier){
                    MessageService.error("请选择背景图片");
                    return
                }
            }
            vm.isSaving = true;
            if (vm.data.id != null) {
                Backgrounds.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Backgrounds.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                MessageService.success("背景保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            };

            function onSaveError () {
                MessageService.error("背景保存失败");
                vm.isSaving = false;
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('setting', {
            parent: 'entity',
            url: '/setting?page&sort&search&themeClassifyId',
            data: {
                authorities: ["ROLE_BACKGROUND"],
                pageTitle: 'backApp.title.setting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/setting/setting.html',
                    controller: 'SettingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        themeClassifyId: $stateParams.themeClassifyId,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('title');
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Backgrounds', Backgrounds);

    Backgrounds.$inject = ['$resource'];

    function Backgrounds ($resource) {
        var resourceUrl =  'manager/' + 'api/backgrounds/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "createByStore":{
                method:"POST",
                params:{
                    path:"createByStore"
                }
            },
            "delete":{
                method:"DELETE"
            },
            "themeClassify":{
                method:"GET",
                params:{
                    path:"saveTheme"
                }
            },
            "batchCreateByStore":{
                method:"GET",
                params:{
                    path:"batchCreateByStore"
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SettingController', SettingController);

    SettingController.$inject = ['$scope', '$q', '$state', 'Backgrounds', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', '$uibModal', 'ThemeClassify'];

    function SettingController ($scope, $q, $state, Backgrounds, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, $uibModal, ThemeClassify) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 44;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.themeClassifyId = Number(pagingParams.themeClassifyId);
        vm.jump = jump;
        vm.storeId = JSON.parse(localStorage.getItem('back-user')).storeId;
        vm.class =  ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'BG'}]});
        // {key: "storeId", op: "=", value: vm.storeId},

        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise , vm.class.$promise]).then(function(){
            vm.class = vm.class.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        function loadAll () {
            var items = [];
            if (pagingParams.search) {
                items.push({key:"name,themeClassify.name",op:"like",value:pagingParams.search});
            }
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",op:"=",value:vm.themeClassifyId});
            }
            Backgrounds.byCondition2({
                items: items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.data = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("背景获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                themeClassifyId:vm.themeClassifyId,
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/setting/setting-dialog.html',
                controller: 'SettingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add'
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.edit = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/setting/setting-dialog.html',
                controller: 'SettingDialogController',
                controllerAs: 'vm',
                windowClass:'modal-right',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'edit',
                            data: data
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/setting/setting-dialog.html',
                controller: 'SettingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'look',
                            data: data
                        };
                    }]
                }
            });
        }
        $scope.delete = function(id){
            MessageService.confirm("确认删除该数据？",function(){
                Backgrounds.delete({id: id},function (res) {
                    if(res.status == 200){
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                });
            },function(){});
        };
    }
})();

(function () {
    'use strict';

    var threePreview = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/scene/three-preview.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '<',
            width: '<',
            modelData: '<',
            modelPath: '<',
            modelBlendent: '<',
            pageImg:'<',
            backgroundImg:'<',
            cameraPosition:'<',
            targetPosition:'<',
            onChange: "&"
        },
        controller: ['$scope','$timeout', 'ThreeEnv',
            function ($scope, $timeout, ThreeEnv) {
                var vm = this;
                vm.loading = true;
                vm.error = false;
                vm.viewWidth = vm.width || $(window).width();
                vm.viewHeight = vm.height || $(window).height();
                vm.$onInit = function() {
                    if(vm.pageImg && vm.modelData){
                        for(var i=0; i<vm.modelData.length; i++){
                            if(vm.modelData[i].page!=='' && vm.modelData[i].page!=null){
                                vm.modelData[i].img = vm.pageImg;
                            }
                        }
                    }
                    if(vm.modelBlendent){
                        for(var i=0; i<vm.modelData.length; i++){
                            for(var j=0; j<vm.modelBlendent.modelData.length; j++){
                                if(vm.modelData[i].materialName === vm.modelBlendent.modelData[j].materialName){
                                    vm.modelData[i].color = vm.modelBlendent.modelData[j].color;
                                }
                            }
                        }
                    }else{
                        for(var i=0; i<vm.modelData.length; i++){
                            vm.modelData[i].color = null;
                        }
                    }
                    init();
                }
                vm.$onChanges = function(data) {
                    if (data.pageImg) {
                        vm.pageImg = data.pageImg.currentValue;
                    }
                    if (data.backgroundImg) {
                        vm.backgroundImg = data.backgroundImg.currentValue;
                    }
                    if (data.modelData&&data.modelData.currentValue) {
                        vm.modelData = data.modelData.currentValue;
                    }
                    if(vm.pageImg && vm.modelData){
                        for(var i=0; i<vm.modelData.length; i++){
                            if(vm.modelData[i].page!=='' && vm.modelData[i].page!=null){
                                vm.modelData[i].img = vm.pageImg;
                            }
                        }
                    }
                    initContent1();
                };
                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, gltfScene;
                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                    var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                    l1.name = 'a-light';
                    camera.add(l1);
                    var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI );
                    l2.position.set(6, 0, 6); // ~60º
                    l2.name = 'm-light';
                    l2.castShadow = true;
                    camera.add(l2);
                    var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                    l3.name = 'h-light';
                    camera.add(l3);
                    scene.add(camera);

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView").appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }

                /* 灯光 */
                function initLight() {
                    scene.add(new THREE.AmbientLight(0xdddddd));
                    var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
                    directionalLight.position.set(-4, 8, 4);
                    var dhelper = new THREE.DirectionalLightHelper(directionalLight, 5, 0xff0000);

                    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
                    hemisphereLight.position.set(0, 8, 0);
                    var hHelper = new THREE.HemisphereLightHelper(hemisphereLight, 5);
                    scene.add(directionalLight);
                }

                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    // controls.autoRotate = true;
                    // controls.autoRotateSpeed = -6;
                    controls.addEventListener('change', function () {
                        onChange(camera,controls);
                    });
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        gltfScene = angular.copy(gltf.scene || gltf.scenes[0]);
                        gltf.scene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltf.scene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        controls.reset();
                        gltf.scene.position.x += gltf.scene.position.x - center.x;
                        gltf.scene.position.y += gltf.scene.position.y - center.y;
                        gltf.scene.position.z += gltf.scene.position.z - center.z;
                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        if(vm.cameraPosition){
                            camera.position.set(vm.cameraPosition.x,vm.cameraPosition.y,vm.cameraPosition.z);
                            controls.target.set(vm.targetPosition.x, vm.targetPosition.y, vm.targetPosition.z);
                        }else{
                            camera.position.x += size / 1.0;
                            camera.position.y += size / 1.0;
                            camera.position.z += size / 1.0;
                        }
                        camera.lookAt(center);
                        controls.update();
                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;
                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        loaddingError();
                    })

                }

                function initContent1() {
                    // 加载 glTF 格式的模型
                    if(!vm.modelData){
                        return
                    }
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;
                        gltfScene.traverse(function(child){
                            if (child.isMesh) {
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltfScene);
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        loaddingError();
                    })

                }
                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }

                /* 数据更新 */
                // function update() {
                //     stats.update();
                // }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView");
                    initScene();
                    initCamera(container.clientWidth, container.clientHeight);
                    initRender();
                    // initLight();
                    initControls();
                    // initGui();
                    /* 监听事件 */
                    window.addEventListener('resize', onWindowResize, false);
                    animate();
                }

                /* 循环渲染 */
                function animate() {
                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);
                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        renderer.render(scene, camera);
                        controls.update();
                    };
                    r();
                }
                function onChange(camera,controls) {
                    if(controls && controls.target && camera && camera.position){
                        var _data = {
                            targetPosition:controls.target,
                            cameraPosition:camera.position
                        }
                        console.log(_data)
                        vm.onChange({text: JSON.stringify(_data)});
                    }
                }

                function checkGltfMetalness(gltf) {
                    var metalness = 0;
                    if (gltf && gltf.scene) {
                        metalness = parseGroupMetalness(gltf.scene);
                    }
                    return metalness;
                }

                function parseGroupMetalness(group) {
                    var metalness = 0;
                    if (!group.children) {
                        return metalness;
                    }
                    for (var i = 0; i < group.children.length; i++) {
                        var child = group.children[i];
                        if (child.type == 'Mesh') {
                            if (child.material && child.material.metalness > metalness) {
                                metalness = child.material.metalness;
                            }
                        }
                        else if (child.type == 'Group') {
                            var val = parseGroupMetalness(child);
                            if (val > metalness) {
                                metalness = val;
                            }
                        }
                    }
                    return metalness;
                }

                function updateEnvironment () {
                    ThreeEnv.getEnvMap(renderer).then(
                        function (data) {
                            if (data && data.envMap) {
                                scene.environment = data.envMap;
                            }
                        }
                    );
                }
            }
        ]
    };

    angular
        .module('backApp')
        .component('threePreview', threePreview);
})();


(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('ThreeEnv', ThreeEnv);

    ThreeEnv.$inject = ['$q'];

    function ThreeEnv ($q) {
        var environments = [{
            id: 'comfy-cafe-1',
            name: 'Comfy Cafe',
            path: 'lib/three/env/comfy_cafe_1k.hdr',
            format: '.hdr'
        }, {
            id: 'comfy-cafe-2',
            name: 'Comfy Cafe 2K',
            path: 'lib/three/env/comfy_cafe_2k.hdr',
            format: '.hdr'
        }, {
            id: 'venice-sunset',
            name: 'Venice Sunset',
            path: 'lib/three/env/venice_sunset_1k.hdr',
            format: '.hdr'
        }];
        var envIndex = 0;

        var service = {
            getEnvMap: getEnvMap
        };

        return service;

        function getEnvMap (renderer) {
            if (envIndex < 0) {
                envIndex = 0;
            }
            if (envIndex >= environments.length) {
                envIndex = environments.length - 1;
            }
            var env = environments[envIndex];
            return getCubeMapTexture(renderer, env);
        }

        function getCubeMapTexture (renderer, environment) {
            var path = environment.path;

            var deferred = $q.defer();
            // no envmap
            if ( ! path ) {
                deferred.resolve( { envMap: null } );
                return deferred.promise;
            }
            new THREE.RGBELoader()
            .setDataType( THREE.HalfFloatType )
            .load( path,
                function ( texture ) {
                    var pmremGenerator = new THREE.PMREMGenerator( renderer );
                    pmremGenerator.compileEquirectangularShader();
                    const envMap = pmremGenerator.fromEquirectangular( texture ).texture;
                    pmremGenerator.dispose();

                    var data = {envMap: envMap};
                    deferred.resolve(data);

                },
                undefined, // progress
                deferred.reject );

            return deferred.promise;

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SceneModalController', SceneModalController);

    SceneModalController.$inject = ['$scope','MessageService','entity','$uibModalInstance','Mould2Ds'];

    function SceneModalController ($scope, MessageService,entity,$uibModalInstance,Mould2Ds) {
        var vm = this;
        vm.searchQuery = "";
        vm.data = [];
        vm.selectData = angular.copy(entity)||[];
        vm.search = init;
        init();
        function init() {
            var items = [];
            if(vm.searchQuery){
                items.push({key:"name",op:"like",value:vm.searchQuery})
            }
            Mould2Ds.getAllByCondition2({
                items: items,
                sort: ["id,asc"]
            }, function (res) {
                vm.data = res.data;
                vm.data.forEach(function (data) {
                    vm.selectData.forEach(function (data1) {
                        if(data1.id == data.id){
                            data.selected = true;
                        }
                    })
                })
            }, function (error) {

            });
        }
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        vm.save = function () {
            vm.selectData = [];
            vm.data.forEach(function (data) {
                if(data.selected){
                    vm.selectData.push(data);
                }
            })
            // if(vm.selectData.length == 0){
            //     MessageService.error("请至少选择一个模型")
            //     return
            // }
            $uibModalInstance.close(vm.selectData);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SceneDialogController', SceneDialogController);

    SceneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Mould2Ds', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', '$localStorage'];

    function SceneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Mould2Ds, MessageService,
        Upload, UidService, ThemeClassify, $localStorage) {
        var vm = this;
        vm.type = entity.state;
        if(vm.type == 'look'){
            vm.page = 3;
        }else{
            vm.page = 1;
        }
        vm.data = entity.data || {
            name:'',
            cover:'',
            modelData:null,
            modelPath:null,
            background:null,
            targetPosition:null,
            cameraPosition:null,
        };
        vm.cancel = cancel;
        vm.save = save;
        vm.domains = Qinius.getDomain();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        $q.all([vm.domains.$promise, vm.data.$promise]).then(function(){
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(vm.data.id&&vm.data.modelData){
                vm.modelData=[];
                var _data = angular.copy(vm.data.modelData);
                var _modelData = [];
                _data.forEach(function (item) {
                    if(item.page === '' || item.page === null){
                        _modelData.push(item.materialName)
                    }
                })
                _data.forEach(function (item) {
                    if(item.page>=0 && item.page!='' &&item.page != null){
                        var _modelData1 = angular.copy(_modelData);
                        _modelData1.push(item.materialName)
                        vm.modelData.push({materialName:item.materialName,modelData:_modelData1})
                    }
                })
            }
        })


        window.updateImgFile = function ($event) {
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    fileGet(file,function (item) {
                        vm.data.cover = item;
                    });
                }
            });
        }
        window.updateImgFile1 = function ($event) {
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    fileGet(file,function (item) {
                        vm.data.background = item;
                    });
                }
            });
        }
        vm.demoPic = "";
        window.updateImgFile2 = function ($event) {
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    fileGet(file,function (item) {
                        vm.demoPic = item;
                        console.log(vm.demoPic)
                    });
                }
            });
        }
        function fileGet(file,callback) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);

            formData.append('key', "clipArt-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                success: function (data) {
                    callback($scope.domain + data.key);
                },
                error: function (request) {
                    MessageService.error("文件上传失败");
                }
            });

        }

        //上传3D模型
        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }

        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'model-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.data.modelPath = $scope.domain + data.key;
                    gltfInfo(vm.data.modelPath)
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("上传失败");
                }
            });
        };
        function gltfInfo(path) {
            // 加载glTF格式的模型
            vm.data.modelData = [];
            vm.materialMap = [];
            var loader = new THREE.GLTFLoader();
            if (THREE.DRACOLoader) {
                var dracoLoader = new THREE.DRACOLoader();
                if (dracoLoader) {
                    dracoLoader.setDecoderPath("lib/three/draco/");
                    loader.setDRACOLoader( dracoLoader );
                }
            }
            vm.modelLoad = true;
            loader.load(path, function (gltf) {
                gltf.scene.traverse(function(child){
                    if (child.isMesh) {
                        traverseMaterials(child, function(node,i){
                            if(vm.materialMap.indexOf(node.name) == -1){
                                var _modelData = {
                                    materialName:node.name,
                                    page:''
                                };
                                vm.data.modelData.push(_modelData);
                                vm.materialMap.push(node.name);
                            }
                        });
                    }
                });
                modelGltfInit();
                vm.modelLoad = false;
                $scope.$apply();
            }, function (xhr) {
                vm.schedule = (xhr.loaded / xhr.total * 100);
            }, function (error) {
                MessageService.error("3D模型上传失败，请稍后重试！")
                vm.modelLoad = false;
            })
        }
        function modelGltfInit() {
            vm.modelData=[{materialName:'',modelData:[]}];
            vm.changeModelData();
        }
        vm.changeModelData = function () {
            var _data = angular.copy(vm.data.modelData);
            vm.modelData.forEach(function (item1, index1) {
                item1.modelData = [];
            })
            _data.forEach(function (item) {
                item.page="";
                item.img="";
                vm.modelData.forEach(function (item1, index1) {
                    var _modelData = [];
                    vm.modelData.forEach(function (item2, index2) {
                        if(index1 != index2 && item2.materialName){
                            _modelData.push(item2.materialName)
                        }
                    })
                    var _exist = false;
                    _modelData.forEach(function (item3) {
                        if(item3 == item.materialName){
                            _exist = true;
                        }
                    })
                    if(!_exist){
                        item1.modelData.push(item.materialName);
                    }
                })
            })
            _data.forEach(function (item) {
                vm.modelData.forEach(function (item1, index) {
                    if(item.materialName == item1.materialName){
                        item.page = index;
                    }
                })
            })
            vm.data.modelData = "";
            $timeout(function () {
                vm.data.modelData = _data;
                console.log(vm.data.modelData)
            })
        }
        $scope.addModelData = function () {
            vm.modelData.push({materialName:'',modelData:[]});
            vm.changeModelData();
        }
        $scope.deleteModelData = function (index) {
            vm.modelData.splice(index,1);
            vm.changeModelData();
        }

        function traverseMaterials(object, callback) {
            object.traverse(function(node){
                if (!node.isMesh) return;
                var materials = Array.isArray(node.material)
                    ? node.material
                    : [node.material];
                materials.forEach(callback);
            });
        }
        $scope.updateData = function(){
            var _data = {
                cameraPosition: vm.data.cameraPosition,
                targetPosition: vm.data.targetPosition,
            }
            vm.gltfData = angular.copy(_data);
        }
        $scope.updateData();
        vm.gltfChange = function(text){
            if(text){
                $timeout(function () {
                    var _text = JSON.parse(text);
                    vm.data.cameraPosition = _text.cameraPosition;
                    vm.data.targetPosition = _text.targetPosition;
                })
            }
        }
        $scope.clearGltfInfo = function(){
            vm.data.modelPath = null;
            vm.data.modelData = null;
            vm.data.modelBlendent = null;
            vm.data.modelData = [];
        }
        $scope.removeFile = function() {
            vm.data.cover = "";
        };

        function cancel() {
            $uibModalInstance.close();
        }
        vm.next = function () {
            if(!vm.data.name){
                MessageService.error("模型名称不能为空");
                return
            }
            if(!vm.data.cover){
                MessageService.error("模型图片不能为空");
                return
            }
            if(!vm.data.modelPath){
                MessageService.error("3D模型不能为空");
                return
            }
            vm.page = 2;
        }
        function save() {
            var _isExist = false;
            for(var i=0; i<vm.data.modelData.length; i++){
                if(vm.data.modelData[i].page != null || vm.data.modelData[i].page !==''){
                    _isExist = true;
                    break
                }
            }
            if(!_isExist){
                MessageService.error("关联材质不能为空");
                return false
            }
            if(!vm.data.background){
                MessageService.error("场景背景不能为空");
                return
            }
            for(var i=0; i<vm.data.modelData.length; i++){
                vm.data.modelData[i].img="";
            }
            // vm.data.modelData = JSON.stringify(vm.data.modelData);
            vm.isSaving = true;
            if (vm.data.id != null) {
                Mould2Ds.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Mould2Ds.save(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                MessageService.success("保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            };

            function onSaveError () {
                MessageService.error("保存失败");
                vm.isSaving = false;
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('scene', {
            parent: 'entity',
            url: '/scene?page&sort&search',
            data: {
                authorities: ["ROLE_THEME_CATEGORY"],
                pageTitle: 'global.menu.entities.scene'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/scene/scene.html',
                    controller: 'SceneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Mould2Ds', Mould2Ds);

    Mould2Ds.$inject = ['$resource'];

    function Mould2Ds ($resource) {
        var resourceUrl =  'manager/' + 'api/mould-2-ds/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "getone":{
                method:"GET",
                params:{
                    path:"getone"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "batchCreate":{
                method:"GET",
                params:{
                    path:"batchCreate"
                }
            },
            "batchCreateByStore":{
                method:"GET",
                params:{
                    path:"batchCreateByStore"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "save":{
                method:"POST",
            },
            "delete":{
                method:"DELETE",
            },
            "themeClassify":{
                method:"GET",
                params:{
                    path:"saveTheme"
                }
            },
            'update': {
                method:'PUT',
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SceneController', SceneController);

    SceneController.$inject = ['$scope', '$q', '$state', 'Mould2Ds', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', '$uibModal', 'Principal'];

    function SceneController ($scope, $q, $state, Mould2Ds, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, $uibModal, Principal) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        function loadAll () {
            var items = [];
            if (pagingParams.search) {
                items.push({key:"name",op:"like",value:pagingParams.search});
            }
            Mould2Ds.byCondition2({
                items:items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.data = data.data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                MessageService.error("获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/scene/scene-dialog.html',
                controller: 'SceneDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add',
                            data: ""
                        };
                    }]
                }
            }).result.then(function(item) {
                loadAll()
            });
        }
        $scope.edit = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/scene/scene-dialog.html',
                controller: 'SceneDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'edit',
                            data: data
                        };
                    }]
                }
            }).result.then(function(item) {
                loadAll()
            });
        }
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/scene/scene-dialog.html',
                controller: 'SceneDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'look',
                            data: data
                        };
                    }]
                }
            }).result.then(function(item) {
                loadAll()
            });
        }
        $scope.delete = function(id){
            MessageService.confirm("确认删除该模型？",function(){
                Mould2Ds.delete({id: id},function () {
                    MessageService.success("删除成功");
                    loadAll();
                },function () {
                    MessageService.error("删除失败");
                });
            },function(){});
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ThreePreviewController', ThreePreviewController);

    ThreePreviewController.$inject = ['$scope', '$stateParams', 'Qinius', '$http', '$q', 'ImageService', 'PlatformWechatSetting', 'Music', 'Store', 'MessageService','$state', '$uibModalInstance','threeTemplate','threeProductXmlData','$compile','$timeout','Convert', 'ThreeEnv'];

    function ThreePreviewController($scope, $stateParams, Qinius, $http, $q, ImageService, PlatformWechatSetting, Music, Store, MessageService,$state, $uibModalInstance,threeTemplate,threeProductXmlData,$compile,$timeout,Convert, ThreeEnv) {
        var vm = this;
        vm.template = threeTemplate;
        vm.productXml = threeProductXmlData;
        $scope.domains = Qinius.getDomain();
        vm.loading = true;
        vm.error = false;
        vm.data = "";
        vm.clear = clear;
        $q.all([$scope.domains.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            Convert.documentToImg(vm.template, function (res) {
                vm.modelData = vm.productXml.modelData;
                vm.modelPath = vm.productXml.modelPath;
                for(var i=0; i<vm.modelData.length; i++){
                    for(var j=0; j<res.length; j++){
                        if(vm.modelData[i].page === res[j].seq){
                            vm.modelData[i].img = $scope.domain + res[j].key;
                            console.log(vm.modelData[i].img)
                        }
                    }
                }
                init();
                animate();
                vm.viewWidth = $(".threeView-body").width();
                vm.viewHeight = $(".threeView-body").height();
            }, function (error) {
                loaddingError(error.message);
            })
        });
        vm.$onDestroy = function(){
            cancelAnimationFrame(vm.animateFrame);
        }

        function clear () {
            $uibModalInstance.dismiss();
        }
        function loaddingError(message) {
            vm.loading = false;
            vm.error = true;
            vm.errorText = message;
        }
        function loaddingSuccess() {
            vm.loading = false;
            vm.error = false;
        }

        var scene, camera, renderer, controls, guiControls;
        // var stats = initStats();

        /* 场景 */
        function initScene() {
            scene = new THREE.Scene();
            // var materialColor = new THREE.MeshBasicMaterial({
            //     map:THREE.ImageUtils.loadTexture("http://photoavatar-pic-dev.deltazo.com/product-b9d71fbb-0caa-4d5f-ca23-71a1dd41aa74?imageMogr2/auto-orient"),
            //     depthTest: false
            // });
            // materialColor.map.wrapS;
            // materialColor.map.wrapT;
            // console.log(materialColor);
            // var bgPlane = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), materialColor);
            // bgPlane.position.z = -100;
            // bgPlane.scale.set(window.innerWidth * 2, window.innerHeight * 2, 1);
            // scene.add(bgPlane);
        }

        /* 相机 */
        function initCamera() {
            // camera = new THREE.PerspectiveCamera(50, vm.viewWidth / vm.viewHeight, 0.1, 1000);
            // camera.position.x = 80;
            // camera.position.y = 80;
            // camera.position.z = 50;
            // // camera.position.set(80, 80, 30);
            // camera.lookAt(new THREE.Vector3(0, 10, 0));
            camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
            var l1 = new THREE.AmbientLight(0xffffff, 0.3);
            l1.name = 'a-light';
            camera.add(l1);
            var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
            l2.position.set(6, 0, 6); // ~60º
            l2.name = 'm-light';
            l2.castShadow = true;
            camera.add(l2);
            var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
            l3.name = 'h-light';
            camera.add(l3);
            scene.add(camera);
        }

        /* 渲染器 */
        function initRender() {
            renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha:true,
                precision: 'highp',
                preserveDrawingBuffer: true
            });
            renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
            renderer.setSize(vm.viewWidth, vm.viewHeight);
            renderer.shadowMap.enabled = true;
            renderer.physicallyCorrectLights = true;
            renderer.outputEncoding = THREE.sRGBEncoding;
            renderer.minFilter = THREE.LinearFilter;
            renderer.gammaOutput = true;
            renderer.setPixelRatio( window.devicePixelRatio );

            $timeout(function () {
                document.getElementById("threeView1").appendChild(renderer.domElement);
                onWindowResize()
                initContent();
                loaddingSuccess();
                $scope.$apply();
            })
        }

        /* 灯光 */
        function initLight() {
            scene.add(new THREE.AmbientLight(0xdddddd));
            var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
            directionalLight.position.set(-4, 8, 4);
            scene.add(directionalLight);
        }

        /* 控制器 */
        function initControls() {
            controls = new THREE.OrbitControls(camera, renderer.domElement);
            /* 属性参数默认 */
        }

        /* 调试插件 */
        function initGui() {
            guiControls = new function () {};
            var controls = new dat.GUI({width: 200});
        }

        /* 场景中的内容 */
        function initContent() {
            // 加载 glTF 格式的模型
            var loader = new THREE.GLTFLoader();
            if (THREE.DRACOLoader) {
                var dracoLoader = new THREE.DRACOLoader();
                if (dracoLoader) {
                    dracoLoader.setDecoderPath("lib/three/draco/");
                    loader.setDRACOLoader( dracoLoader );
                }
            }
            loader.load(vm.modelPath, function (gltf) {
                var metalness = checkGltfMetalness(gltf);
                var gltfScene = gltf.scene || gltf.scenes[0];
                var clips = gltf.animations || [];
                gltfScene.updateMatrixWorld();
                var box = new THREE.Box3().setFromObject(gltfScene);
                var size = box.getSize(new THREE.Vector3()).length();
                var center = box.getCenter(new THREE.Vector3());
                // controls.reset();
                gltfScene.position.x += gltfScene.position.x - center.x;
                gltfScene.position.y += gltfScene.position.y - center.y;
                gltfScene.position.z += gltfScene.position.z - center.z;

                // 重新设置相机参数
                controls.maxDistance = size * 10;
                camera.near = size / 80;
                camera.far = size * 80;
                camera.updateProjectionMatrix();

                camera.position.copy(center);
                camera.position.x += size / 1.0;
                camera.position.y += size / 1.0;
                camera.position.z += size / 1.0;
                camera.lookAt(center);

                gltf.scene.traverse(function(child){
                    if (child.isMesh) {
                        child.material.depthWrite = !child.material.transparent;
                        var materials = Array.isArray(child.material) ? child.material : [child.material];
                        materials.forEach(function (node) {
                            for(var i=0; i<vm.modelData.length; i++){
                                if(vm.modelData[i].materialName === node.name && vm.modelData[i].img){
                                    var textureLoader = new THREE.TextureLoader();
                                    var map = textureLoader.load(vm.modelData[i].img);
                                    map.flipY = false;

                                    if (node.map) {
                                        // copy current map repeat and offset to the new map
                                        // this is for gltfpack (meshoptimizer) compressed models
                                        // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                        map.repeat.copy(node.map.repeat);
                                        map.offset.copy(node.map.offset);
                                    }

                                    // copy texture encoding from existing one to the loaded texture
                                    map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                    node.map = map;
                                    node.needsUpdate = true;
                                }
                            }
                        });
                    }
                })
                scene.add(gltf.scene);
                if (metalness > 0) {
                    console.log("metalness=" + metalness);
                    updateEnvironment();
                }
                // 判断当前的gltf问价中是否有动画
                if (clips.length !== 0) {
                    var mixer = new THREE.AnimationMixer(gltfScene);
                    mixer.clipAction(gltf.animations[0]).play();
                }
            }, function (xhr) {
                console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            }, function (error) {
                loaddingError();
            })

        }

        function traverseMaterials(object, callback) {
            object.traverse(function(node){
                if (!node.isMesh) return;
                var materials = Array.isArray(node.material)
                    ? node.material
                    : [node.material];
                materials.forEach(callback);
            });
        }

        function getWebGLErrorMessage() {
            var element = document.createElement('div');
            element.id = 'webgl-error-message';
            element.style.fontFamily = 'monospace';
            element.style.fontSize = '13px';
            element.style.fontWeight = 'normal';
            element.style.textAlign = 'center';
            element.style.background = '#fff';
            element.style.color = '#000';
            element.style.padding = '1.5em';
            element.style.width = '400px';
            element.style.margin = '5em auto 0';
            if (!this.webgl) {
                element.innerHTML = window.WebGLRenderingContext ? [
                    'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />',
                    'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
                ].join('\n') : [
                    'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>',
                    'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
                ].join('\n');
            }
            return element;
        };

        /* 性能插件 */
        function initStats() {
            // var stats = new Stats();
            // // document.body.appendChild(stats.domElement);
            // $timeout(function () {
            //     document.getElementById("threeView1").appendChild(stats.domElement);
            // })
            // return stats;
        }

        /* 窗口变动触发 */
        function onWindowResize() {
            var width = $(".threeView-body").width();
            var height = $(".threeView-body").height();
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width, height);
        }

        /* 数据更新 */
        // function update() {
        //     stats.update();
        // }
        /* 初始化 */
        function init() {
            initScene();
            initCamera();
            initRender();
            initLight();
            initControls();
            // initGui();
            /* 监听事件 */
            window.addEventListener('resize', onWindowResize, false);
        }

        /* 循环渲染 */
        function animate() {
            // 每次取消动画
            cancelAnimationFrame(vm.animateFrame);

            var r = function (){
                if (!renderer) {
                    return;
                }
                vm.animateFrame = requestAnimationFrame(r);
                renderer.render(scene, camera);
                controls.update();
            };
            r();
        }

        function checkGltfMetalness(gltf) {
            var metalness = 0;
            if (gltf && gltf.scene) {
                metalness = parseGroupMetalness(gltf.scene);
            }
            return metalness;
        }

        function parseGroupMetalness(group) {
            var metalness = 0;
            if (!group.children) {
                return metalness;
            }
            for (var i = 0; i < group.children.length; i++) {
                var child = group.children[i];
                if (child.type == 'Mesh') {
                    if (child.material && child.material.metalness > metalness) {
                        metalness = child.material.metalness;
                    }
                }
                else if (child.type == 'Group') {
                    var val = parseGroupMetalness(child);
                    if (val > metalness) {
                        metalness = val;
                    }
                }
            }
            return metalness;
        }

        function updateEnvironment () {
            ThreeEnv.getEnvMap(renderer).then(
                function (data) {
                    if (data && data.envMap) {
                        scene.environment = data.envMap;
                    }
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('ThreeEnv', ThreeEnv);

    ThreeEnv.$inject = ['$q'];

    function ThreeEnv ($q) {
        var environments = [{
            id: 'comfy-cafe-1',
            name: 'Comfy Cafe',
            path: 'lib/three/env/comfy_cafe_1k.hdr',
            format: '.hdr'
        }, {
            id: 'comfy-cafe-2',
            name: 'Comfy Cafe 2K',
            path: 'lib/three/env/comfy_cafe_2k.hdr',
            format: '.hdr'
        }, {
            id: 'venice-sunset',
            name: 'Venice Sunset',
            path: 'lib/three/env/venice_sunset_1k.hdr',
            format: '.hdr'
        }];
        var envIndex = 0;

        var service = {
            getEnvMap: getEnvMap
        };

        return service;

        function getEnvMap (renderer) {
            if (envIndex < 0) {
                envIndex = 0;
            }
            if (envIndex >= environments.length) {
                envIndex = environments.length - 1;
            }
            var env = environments[envIndex];
            return getCubeMapTexture(renderer, env);
        }

        function getCubeMapTexture (renderer, environment) {
            var path = environment.path;

            var deferred = $q.defer();
            // no envmap
            if ( ! path ) {
                deferred.resolve( { envMap: null } );
                return deferred.promise;
            }
            console.log("try to loading environment: " + environment.id);
            new THREE.RGBELoader()
            .setDataType( THREE.HalfFloatType )
            .load( path, 
                function ( texture ) {
                    var pmremGenerator = new THREE.PMREMGenerator( renderer );
                    pmremGenerator.compileEquirectangularShader();
                    const envMap = pmremGenerator.fromEquirectangular( texture ).texture;
                    pmremGenerator.dispose();

                    var data = {envMap: envMap};
                    deferred.resolve(data);

                }, 
                undefined, // progress
                deferred.reject );

            return deferred.promise;

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SalesOrderDialogController', SalesOrderDialogController);

    SalesOrderDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams','$q', 'entity', 'SalesOrder', 'Qinius', 'ExpressHistory',
        'MessageService', 'LocationProvice', 'LocationCity', 'LocationDistrict', 'Upload', 'LogisticsCompany','PlatformSetting','$localStorage'];

    function SalesOrderDialogController ($timeout, $scope, $state,$stateParams, $q, entity, SalesOrder, Qinius, ExpressHistory,
                                         MessageService,  LocationProvice, LocationCity, LocationDistrict, Upload, LogisticsCompany, PlatformSetting,$localStorage) {
        var vm = this;

        vm.salesOrder = entity;
        vm.clear = clear;
        vm.save = save;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;
        vm.provinces = LocationProvice.query();
        vm.domains = Qinius.getDomain();
        $scope.selectTab =($stateParams.status == undefined || $stateParams.status == '')?'':$stateParams.status;

        vm.histories = [];
        // vm.histories = ExpressHistory.byCondition({items:[{key:"orderId",op:"=",value:$stateParams.id}]})
        vm.histories = ExpressHistory.byOrderId({orderId:$stateParams.id})

        LogisticsCompany.byCondition({
                items:[{key:"enabled",op:"=",value:true}]
            }, onSuccess2, onError2);
            function onSuccess2(data) {
                vm.logisticsCompanies = data;
                for (var i = vm.logisticsCompanies.length - 1; i >= 0; i--) {
                    var p = vm.logisticsCompanies[i];
                    if (p.name == vm.salesOrder.deliveryCompany) {
                        vm.deliveryCompany = p;
                        break;
                    }
                }
            }
            function onError2(error) {
                MessageService.error("物流公司获取失败");
            }


        $scope.downFile = function(){
            window.open("service/api/sales-orders/downLocationTemplate/"+vm.salesOrder.id);
        };


        $scope.byStatus =function(status){
            if(status == '' || status == undefined){
                $scope.selectTab = '';
            }else{
                $scope.selectTab = status;
            }
            vm.status = status;
            $state.go('sales-order',{'status':vm.status});
        };

        $scope.uploadFile = function(fileWatched) {
            vm.file = fileWatched;
            vm.fileName = fileWatched.name;
            Upload.upload({
                type: 'POST',
                url: 'service/api/sales-orders/importLocation', //上传路径
                data: {
                    id: vm.salesOrder.id,
                    file: vm.file,
                    name: vm.fileName
                }
            }).then(function successCallback(res) {
                vm.salesOrder = res.data;
                for (var j = 0; j < vm.salesOrder.locations.length; j++) {
                    if (vm.salesOrder.locations[j].deleted) {
                        continue;
                    }
                    var location = vm.salesOrder.locations[j];
                    for (var i = vm.provinces.length - 1; i >= 0; i--) {
                        var p = vm.provinces[i];
                        if (p.name == location.province) {
                            location.pro = p;
                            break;
                        }
                    }
                    location.districts = [];
                    location.citys = [];
                    $scope.getCities(location);
                }
            }, function errorCallback(response) {
                MessageService.error("文件导入失败");
            });
        };

        $scope.getCities = function(location){
            if (location.pro != null) {
                LocationCity.findByProvince({
                    provinceId: location.pro.id
                }, function(data) {
                    location.citys = data;
                    for (var z = location.citys.length - 1; z >= 0; z--) {
                        var c = location.citys[z];
                        if (c.name == location.city) {
                            location.ci = c;
                            break;
                        }
                    }
                    $scope.getDistricts(location);
                });
            }
        }

        $scope.getDistricts = function(location){
            if (location.ci != null) {
                LocationDistrict.findByCities({
                    cityId: location.ci.id
                }, function(data) {
                    location.districts = data;
                    for (var y = location.districts.length - 1; y >= 0; y--) {
                        var di = location.districts[y];
                        if (di.name == location.district) {
                            location.dis = di;
                        }
                    }
                });
            }
        }

        $q.all([vm.domains.$promise, vm.salesOrder.$promise, vm.provinces.$promise]).then(function() {
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
            // 初始化城市：省市区
            for (var j = 0; j < vm.salesOrder.locations.length; j++) {
                var location = vm.salesOrder.locations[j];
                for (var i = vm.provinces.length - 1; i >= 0; i--) {
                    var p = vm.provinces[i];
                    if (p.name == location.province) {
                        location.pro = p;
                        break;
                    }
                }
                location.districts = [];
                location.citys = [];
                $scope.getCities(location);
            }
        });

        // 改变省份
        function changeProvince(location) {
            LocationCity.findByProvince({provinceId:location.pro.id},function (data) {
                location.citys = data;
                location.districts = [];
            });
        }

        // 改变城市
        function changeCity(location) {
            if (location.ci == null) {
                return;
            }
            LocationDistrict.findByCities({cityId: location.ci.id},function (data) {
                location.districts = data;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.amountChange = function(amount){
            if (vm.salesOrder[amount] == null) {
                return;
            }
            if (!(/^-?\d+\.?\d{0,2}$/.test(vm.salesOrder[amount]))) {
                MessageService.error("金额只能输入小数点后两位数");
                vm.salesOrder[amount] = Math.round(vm.salesOrder[amount]*100)/100;
                return;
            }

        }

        $scope.goToView = function (orderArticle) {
            if(!orderArticle.articleId){
                MessageService.error("没有作品");
                return;
            }

            PlatformSetting.get({}, function (res) {
                if(!res.data.editorNotifyUrl){
                    MessageService.error("请设置editorNotifyUrl");
                    return;
                }
                window.open(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + orderArticle.id + '/articlePreview2')
            })
        };

        function clear () {
            $state.go('sales-order', {reload: true});
        }

        $scope.validate = function(){
            if (vm.salesOrder.amount < 0) {
                MessageService.error("金额不能小于零");
                return false;
            };
            if (vm.salesOrder.freight<0) {
                MessageService.error("运费不能小于零");
                return false;
            };
            if (vm.salesOrder.discountAmount<0) {
                MessageService.error("折扣不能小于零");
                return false;
            };
            if (vm.salesOrder.payAmount<=0) {
                MessageService.error("应付金额不能小于等于零");
                return false;
            };
            return true;
        }

        function save () {
            var locationQuantity = 0;
            for (var i = vm.salesOrder.locations.length - 1; i >= 0; i--) {
                var l =  vm.salesOrder.locations[i];
                if (l.deleted) {
                    continue;
                }
                if (l.ci == null || l.pro== null || l.dis == null) {
                    MessageService.error("请选择省市区数据");
                    return;
                }else{
                    l.province = l.pro.name;
                    l.city = l.ci.name;
                    l.district = l.dis.name;
                }
                locationQuantity += l.quantity;
            }
            // var quantity = 0;
            // for (var i = vm.salesOrder.orderLines.length - 1; i >= 0; i--) {
            //     var line = vm.salesOrder.orderLines[i];
            //     quantity += line.quantity;
            // }
            // if (locationQuantity> quantity) {
            //     MessageService.error("收货地址数量多余订单数量，请重新设置");
            //     return;
            // }
            if (vm.deliveryCompany !=null ) {
                vm.salesOrder.deliveryCompanyCode = vm.deliveryCompany.code;
                vm.salesOrder.deliveryCompany = vm.deliveryCompany.name;
            }else{
                vm.salesOrder.deliveryCompanyCode = null;
                vm.salesOrder.deliveryCompany = null;
            }

            vm.isSaving = true;

            if (vm.salesOrder.id !== null) {
                SalesOrder.update(vm.salesOrder, onSaveSuccess, onSaveError);
            } else {
                SalesOrder.save(vm.salesOrder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('backApp:salesOrderUpdate', result);
            MessageService.success("保存成功");
            $state.go('sales-order', {reload: true});
            vm.isSaving = false;
        }

        function onSaveError () {
            MessageService.error("保存失败");
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SalesOrderDetailController', SalesOrderDetailController);

    SalesOrderDetailController.$inject = ['$scope', '$q', '$state','$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'SalesOrder',
    'Qinius', 'History', 'MessageService', 'Vert','ProductXmls','$uibModal', 'PlatformSetting','OrderArticle','Product','$localStorage','$timeout'];

    function SalesOrderDetailController($scope, $q, $state,$rootScope, $stateParams, $uibModalInstance, entity, SalesOrder,
     Qinius, History, MessageService, Vert, ProductXmls,$uibModal, PlatformSetting, OrderArticle, Product,$localStorage, $timeout) {
        var vm = this;

        vm.salesOrder = entity.data;
        vm.clear = clear;

        vm.orderId = $stateParams.id;

        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
        });

        if (vm.orderId !=null ) {
            History.getAllByCondition(
            {items:[{key:"classId", op:"=", value: vm.orderId},{key:"className", op:'=', value:"SalesOrder"}],sort:["createdDate,desc"]}, function(data){
                if (data && data.status == 200) {
                    vm.historysCB = data.data;
                    paging();
                }
            });
        }

        $scope.downFile = function(line){
            if (!line.filePath) {
                MessageService.error("作品文件不存在，下载失败");
                return;
            }
            window.open(line.filePath);
        }

        $scope.getLineStatus = function(line){
            if (line == null || !line.status) {
                return;
            }
           switch (line.status) {
                case "New":
                    return "待组版";
                case "Combinationing":
                    return "组版中";
                case "Combinationed":
                    return "组版完成";
                case "CombinationError":
                    return "组版失败";
                case "Completed":
                    return "组版完成";
                case "Cancelled":
                    return "订单行取消";
                default:
                    return "";
            }
        }
        function paging() {
            var nums = 15; //每页出现的数量
            var pages = Math.ceil(vm.historysCB.length/nums); //得到总页数
            var thisDate = function(curr){
                //此处只是演示，实际场景通常是返回已经当前页已经分组好的数据
                var str = [], last = curr*nums - 1;
                last = last >= vm.historysCB.length ? (vm.historysCB.length-1) : last;
                for(var i = (curr*nums - nums); i <= last; i++){
                    str.push(vm.historysCB[i]);
                }
                return str;
            };

            //调用分页
            laypage({
                cont: 'biuuu_city',
                curr: vm.page, //初始化当前页
                pages: pages,
                skip: true, //是否开启跳页
                first: false,
                last: false,
                jump: function(obj){
                    $timeout(function () {
                        vm.historys=thisDate(obj.curr);
                        vm.page = obj.curr;
                    })
                }
            });
        }


        $scope.getLength = function(des){
            if (des.length > 20) {
                return des.substring(0,19)+"...";
            }else{
                return des;
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('backApp:salesOrderUpdate', function(event, result) {
            vm.salesOrder = result;
        });

        $scope.editorArticle = function(line){
            PlatformSetting.get({}, function (res) {
                if(!res.data.editorNotifyUrl){
                    MessageService.error("请设置editorNotifyUrl");
                    return;
                }
                // OrderArticle.getAuth({id: line.orderArticle.id}, function (res1) {
                //     if(res1.status == 200){
                //         if(line.orderArticle.editorType == "PICTURE" || line.orderArticle.editorType == "PICTURE_PRO") {
                //             window.open(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + line.orderArticle.id + '/printOrder?authorization=' + res1.data)
                //         }else{
                //             window.open(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + line.orderArticle.id + '/photobookOrder?authorization=' + res1.data)
                //         }
                //     }else{
                //         MessageService.error(res1.message || "获取token失败，请稍后再试！");
                //     }
                // })
                var orderArticle = line.orderArticle || {};
                OrderArticle.getAuth({id: orderArticle.id}, function (res1) {
                    if(res1.status == 200) {
                        var auth_token = res1.data || "";
                        console.log(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + orderArticle.id + '/articleDesign2?auth=' + auth_token)
                        window.open(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + orderArticle.id + '/articleDesign2?auth=' + auth_token);
                    } else {
                        MessageService.error(res1.message || "获取token失败，请稍后再试！");
                    }
                });
            })
        };
        $scope.goToView = function (orderArticle) {
            if(!orderArticle.articleId){
                MessageService.error("没有作品");
                return;
            }
            PlatformSetting.get({}, function (res) {
                if(!res.data.editorNotifyUrl){
                    MessageService.error("请设置editorNotifyUrl");
                    return;
                }
                console.log(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + orderArticle.id + '/articlePreview2')
                window.open(res.data.editorNotifyUrl + '/#/' + vm.salesOrder.storeId + '/' + orderArticle.id + '/articlePreview2')
            })
        };

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SalesOrderExportDialogController', SalesOrderExportDialogController);

    SalesOrderExportDialogController.$inject = ['$http', '$timeout', '$localStorage', '$stateParams',  '$q', '$uibModalInstance', '$scope',
     'Product', 'Store', 'MessageService', 'Category', 'DateUtils' ];

    function SalesOrderExportDialogController ($http, $timeout, $localStorage, $stateParams, $q, $uibModalInstance, $scope,
      Product, Store, MessageService, Category, DateUtils ) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.openCalendar = openCalendar;
        vm.dateformat = dateformat;
        vm.export = exportData;
        vm.account = $localStorage.user;

        vm.clear = clear;
        vm.categorysAll = Category.storeGetAllByCondition({items:[]});
        vm.productsAll = Product.getAllByCondition({items: []});
        vm.storeId = $localStorage.user.storeId;
        console.log(vm.storeId)

        
        $q.all([vm.categorysAll.$promise,vm.productsAll.$promise]).then(function() {
            vm.categorys = vm.categorysAll.data;
            vm.products = vm.productsAll.data;
        });

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }

        function exportData(){
            if (!vm.endTime || !vm.startTime) {
                MessageService.error("请录入下单时间");
                return;
            }
            if ((vm.endTime -vm.startTime)/24/3600/1000>31) {
                MessageService.error("下单时间间距不能超过31天");
                return;
            }
            var json_str = getItems();
            var params = "";

            if (vm.startTime !=null) {
                params = params + "&startDate=" + new Date(Date.parse(vm.startTime) -8 * 60 * 60 * 1000);
            };
            if (vm.endTime !=null) {
                params = params + "&endDate=" +new Date(Date.parse(vm.endTime) + 16 * 60 * 60 * 1000 - 1000);
            };
 
            //商户名
            if (vm.storeId !=null) {
                params = params + "&storeId="+vm.storeId;
            };
           
            if (vm.status !=null && vm.status !="") {
                params = params + "&status="+vm.status;
            };
            if (vm.editorType !=null && vm.editorType !="") {
                params = params + "&editorType="+vm.editorType;
            };

            //商品名称
            if (vm.productId !=null) {
                params = params + "&productId="+vm.productId;
            };

            if (params!= "" ) {
                params = params.substring(1);
            }
            

            $http({
                url: 'service/api/sales-orders/byConditionPage/download?items=' + params,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'blob'
            }).success(function(data, status, headers, config) {
                var blob = new Blob([data], {
                    type: "application/vnd.ms-excel"
                });
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "订单详情" + DateUtils.convertLocalDateToServer(Date.now()) + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
            }).error(function(data, status, headers, config) {});

        }

        function getItems() {
            var items=[];
            if (vm.endTime !=null) {
                items.push({key: "createdDate", op: "<=", value: new Date(Date.parse(vm.endTime) + 16 * 60 * 60 * 1000 - 1000)});
            };
            if (vm.startTime !=null) {
                items.push({key: "createdDate", op: ">=", value: new Date(Date.parse(vm.startTime) -8 * 60 * 60 * 1000)});
            };
            //商品分类
            if (vm.categoryId !=null) {
                items.push({key:"orderLines.orderArticle.categoryStoreId",op:"=",value:vm.categoryId});
            };
            //商品名称
            if (vm.productName !=null) {
                items.push({key:"orderLines.orderArticle.productName",op:"=",value:vm.productName});
            };
            //商户名
            if (vm.storeId !=null) {
                items.push({key:"storeId",op:"=",value:vm.storeId});
            };
            //订单来源
            if (vm.sourceType !=null) {
                items.push({key:"sourceType",op:"=",value:vm.sourceType});
            };
            if (vm.status !=null && vm.status !="") {
                items.push({key:"status",op:"=",value:vm.status});
            };
            if(vm.branchStore!=null){
                items.push({key:"branchStoreId",op:"=",value:vm.branchStore.id});
            }

            return items;
        }


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }




    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sales-order', {
                parent: 'entity',
                 url: '/sales-order?page&sort&search&status&startTime&endTime&productId&categoryId&deleted&productName&payRefundStatus',
                data: {
                    authorities: ['ROLE_SALES_ORDER'],
                    pageTitle: 'backApp.salesOrder.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sales-order/sales-orders.html',
                        controller: 'SalesOrderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            status: $stateParams.status,
                            startTime: $stateParams.startTime,
                            endTime:$stateParams.endTime,
                            productName:$stateParams.productName,
                            categoryId:$stateParams.categoryId,
                            deleted:$stateParams.deleted,
                            payRefundStatus:$stateParams.payRefundStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('salesOrder');
                        $translatePartialLoader.addPart('orderStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('sales-order-detail', {
                parent: 'sales-order',
                url: '/sales-order/{id}',
                data: {
                    authorities: ['ROLE_SALES_ORDER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sales-order/sales-order-detail.html',
                        controller: 'SalesOrderDetailController',
                        controllerAs: 'vm',
                        windowClass:'modal-right',
                        backdrop: 'static',
                        size: 'xs',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('salesOrder');
                                $translatePartialLoader.addPart('orderStatus');
                                return $translate.refresh();
                            }],
                            entity: ['SalesOrder', function(SalesOrder) {
                                return SalesOrder.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('sales-order', {}, {
                            reload: false
                        });
                    }, function() {
                        $state.go('sales-order');
                    });
                }]
            })
            .state('sales-order.edit', {
                parent: 'sales-order',
                url: '/sales-order/{id}/edit/{status}',
                data: {
                    authorities: ['ROLE_SALES_ORDER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sales-order/sales-order-dialog.html',
                        controller: 'SalesOrderDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('salesOrder');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['SalesOrder', '$stateParams',
                        function(SalesOrder, $stateParams) {
                            return SalesOrder.get({id : $stateParams.id}).$promise;
                        }
                    ]
                }
            })
            .state('sales-order-data-export', {
                parent: 'sales-order',
                url: '/sales-order-data-export',
                data: {
                    authorities: ['ROLE_SALES_ORDER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sales-order/sales-order-data-export.html',
                        controller: 'SalesOrderExportDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('salesOrder');
                                $translatePartialLoader.addPart('product');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: ['SalesOrder', function(SalesOrder) {
                                return {};
                            }]
                        }
                    }).result.then(function() {
                        $state.go('sales-order', {}, {
                            reload: false
                        });
                    }, function() {
                        $state.go('sales-order');
                    });
                }]
            })
            .state('order-view-article', {
                parent: 'sales-order',
                url: '/view/{fileName}/{itemValueId}',
                data: {
                    authorities: ['ROLE_SALES_ORDER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sales-order/order-view-article.html',
                        controller: 'OrderViewArticleController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProductXmlFileServes', '$stateParams', function(ProductXmlFileServes, $stateParams) {

                            }]
                        }
                    }).result.then(function() {
                        $state.go('sales-order', null, {
                            reload: false
                        });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('History', History)
        .factory('ExpressHistory', ExpressHistory)
        .factory('SalesOrder', SalesOrder)
        .factory('OrderArticle', OrderArticle);

    SalesOrder.$inject = ['$resource'];

    ExpressHistory.$inject = ['$resource'];

    History.$inject = ['$resource'];
    OrderArticle.$inject = ['$resource'];


    function OrderArticle ($resource) {
        var resourceUrl =  'service/' + 'api/order-articles/:path/:id';
        return $resource(resourceUrl, {}, {
            'getAuth': {
                method: 'GET',
                params: {
                    path: 'getAuth'
                }
            }
        });
    }
    function History ($resource) {
        var resourceUrl =  'service/' + 'api/histories/:path/:id';
        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            }
            // ----------销售分析使用----end-------
        });
    }


    function ExpressHistory ($resource) {
        var resourceUrl =  'service/' + 'api/order-express-histories/:path';
        return $resource(resourceUrl, {}, {
            'byOrderId':{
                method: 'GET',
                params: {
                    path: 'byOrderId'
                },
                isArray: true
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            }
        });
    }


    function SalesOrder ($resource) {
        var resourceUrl =  'service/' + 'api/sales-orders/:path/:id';

        return $resource(resourceUrl, {}, {
            'combinationNotify':{
                method: "GET",
                params: {
                    path: "combinationNotify"
                }
            },
            'justifyOrder':{
                method: "GET",
                params: {
                    path: "justifyOrder"
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            'byConditionPage': {
                method: 'GET',
                params: {
                    path: 'byConditionPage'
                }
            },
            'byCondition2': {
                method: 'POST',
                params: {
                    path: 'byCondition2'
                },
                isArray: true
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                },
                isArray: true
            },
            "updateDelivery":{
                method:"POST",
                params:{
                    path:"updateDelivery"
                }
            },
            "delivery":{
                method:"GET",
                params:{
                    path:"delivery"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            // ----------销售分析使用-----------
            "getOrderNumAndSalesNum": {
                method: "GET",
                params: {
                    path: "getOrderNumAndSalesNum"
                }
            },
            "getOrderNums": {
                method: "GET",
                params: {
                    path: "getOrderNums"
                }
            },
            "yesterdayDate": {
                method: "GET",
                params: {
                    path: "yesterdayDate"
                }
            },
            "getListPage": {
                method: "GET",
                params: {
                    path: "getListPage"
                }
            },
            "getListPage2": {
                method: "GET",
                params: {
                    path: "getListPage2"
                }
            },
            "dateList": {
                method: "GET",
                params: {
                    path: "DateList"
                }
            },
            "getSalesNums": {
                method: "GET",
                params: {
                    path: "getSalesNums"
                }
            },
            "downloadFile": {
                method: "GET",
                params: {
                    path: "downloadFile"
                }
            },
            // ----------销售分析使用----end-------
            "productXmlAnalysis2": {
                method: "GET",
                params: {
                    path: "productXmlAnalysis2"
                }
            },
            "productAnalysis2": {
                method: "GET",
                params: {
                    path: "productAnalysis2"
                }
            },
             "payOrder": {
                method: "GET",
                params: {
                    path: "payOrder"
                }
            },
             "closeOrder": {
                method: "POST",
                params: {
                    path: "closeOrder"
                }
            },
            "rejects": {
                method: "GET",
                params: {
                    path: "rejects"
                }
            },
            "reject": {
                method: "GET",
                params: {
                    path: "reject"
                }
            },
            "approveRefund": {
                method: "GET",
                params: {
                    path: "approveRefund"
                }
            },
            "rejectRefund": {
                method: "GET",
                params: {
                    path: "rejectRefund"
                }
            },
            "getGuideData": {
                method: "GET",
                params: {
                    path: "getGuideData"
                }
            },
            "exportGuideData": {
                method: "GET",
                params: {
                    path: "exportGuideData"
                }
            },
            "download": {
                method: "GET",
                params: {
                    path: "byConditionPage/download"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SalesOrderController', SalesOrderController);

    SalesOrderController.$inject = ['$scope',  '$state', 'SalesOrder', 'ParseLinks', 'paginationConstants', '$http', '$uibModal',
        'pagingParams', 'MessageService', '$stateParams', 'DateUtils', 'Qinius','$localStorage','$q','Category', 'Product','Store'];

    function SalesOrderController ($scope, $state, SalesOrder, ParseLinks, paginationConstants, $http, $uibModal,
                                   pagingParams, MessageService, $stateParams, DateUtils, Qinius,$localStorage, $q, Category, Product,Store) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.deleted = pagingParams.deleted;
        vm.productName = pagingParams.productName;
        vm.status = pagingParams.status;
        vm.startTime = pagingParams.startTime ? new Date(pagingParams.startTime):null;
        vm.endTime = pagingParams.endTime? new Date(pagingParams.endTime):null;
        vm.categoryId = pagingParams.categoryId?Number(pagingParams.categoryId):null;
        vm.payRefundStatus = pagingParams.payRefundStatus;

        vm.jump = jump;
        vm.reject = reject;
        vm.dateformat = dateformat;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;

        vm.isOpen =false;
        $scope.selectTab ='';
        vm.domains = Qinius.getDomain();
        vm.store = Store.getCurrent();
        vm.account = $localStorage.user;

        if(vm.status == '' || vm.status == undefined ){
            $scope.selectTab = '';
        }else{
            $scope.selectTab = vm.status;
        }
        if (!!vm.deleted) {
            $scope.selectTab = 'Deleted';
        }
        if(!!vm.payRefundStatus){
            $scope.selectTab = vm.payRefundStatus;
        }

        $scope.showOrders = function(data){
            data.show = !data.show;
        }

        // 商品品类
        vm.categorys = Category.storeGetAllByCondition({items:[{key: "usable", op: "=", value: "true"}]});

        vm.products = Product.getAllByCondition({
            items: [{key:"prototype",op:"in",value:"Store;StoreSelf"}]
        });

        $q.all([vm.categorys.$promise,vm.products.$promise,vm.store.$promise]).then(function() {
            vm.categorys = vm.categorys.data;
            vm.products = vm.products.data;
            loadAll();
        });

        $scope.delivery = function(data,id) {
            if (id == null) {
                return;
            };
            console.log(data)
            createModal('app/entities/sales-order/sales-order-delivery-dialog.html', 'SalesOrderDeliveryController', data).result.then(function () {
                loadAll();
            });
        }

        var createModal = function (url, controller,data) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: [function() {
                        return {
                            data: data
                        };
                    }]
                }
            });
        };

        $scope.changeCategory = function() {
            if (vm.categoryId != null) {
                Product.getAllByCondition({
                    items: [{key:"categoryStore.id",op:"=",value:vm.categoryId}]
                }, function(data1) {
                    vm.products = data1.data;
                });
            }
        };

        $scope.isSotreSelfProduct = function(so){
            for (var i = so.orderLines.length - 1; i >= 0; i--) {
                var l = so.orderLines[i];
                if (l.orderArticle && l.orderArticle && l.orderArticle.prototype == "Store") {
                    return false;
                }
            }
            return true;
        }

        $scope.shrink = function(){
            vm.isOpen = !vm.isOpen;
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }


        $scope.byStatus =function(status){
            if(status == '' || status == undefined){
                $scope.selectTab = '';
            }else {
                $scope.selectTab = status;
            }
            vm.deleted = "";
            vm.status = status;
            vm.payRefundStatus = "";
            search();
        };

        $scope.getDeleted =function(){
            $scope.selectTab = 'Deleted';
            vm.status = "";
            vm.composition = '';
            vm.noComposition = '';
            vm.payRefundStatus = '';
            vm.deleted = 'Deleted';
            search();
        };

        $scope.getRefund = function(){
            $scope.selectTab = 'Required';
            vm.status = "";
            vm.deleted = '';
            vm.noComposition = '';
            vm.composition = '';
            vm.payRefundStatus = 'Required';
            search();
        };

        $scope.getRefundApproved = function(){
            $scope.selectTab = 'Approved';
            vm.status = "";
            vm.deleted = '';
            vm.noComposition = '';
            vm.composition = '';
            vm.payRefundStatus = 'Approved';
            search();
        };

        $scope.screens = function(){
            search(vm.currentSearch);
        };

        $scope.resetInfo = function(){
            vm.startTime = null;
            vm.endTime = null;
            vm.categoryId = null;
            vm.productName = null;
            vm.page = 1;
            search();
        };

        $scope.checkOrderLineState = function(order){
            var flag = false;
            if (order.status != 'Paid') {
                return flag;
            }
            if (order.orderLines.length > 0) {
                for (var i = order.orderLines.length - 1; i >= 0; i--) {
                    var line = order.orderLines[i];
                    var orderArticle = line.orderArticle;
                    if (orderArticle != null && orderArticle.productType != 'StandardPrint'  &&
                        orderArticle.productType != 'Standard' && (line.status == 'CombinationError' || line.status == 'New' || order.status == "Paid" )){
                        return true;
                    }
                }
            }
            return flag;
        };

        function getItems() {
            var items=[];
            if (vm.endTime !=null) {
                items.push({key: "paidDate", op: "<=", value: new Date(Date.parse(vm.endTime) + 16 * 60 * 60 * 1000 - 1000)});
            };
            if (vm.startTime !=null) {
                items.push({key: "paidDate", op: ">=", value: new Date(Date.parse(vm.startTime) -8 * 60 * 60 * 1000)});
            };

            //商品分类
            if (vm.categoryId !=null) {
                items.push({key:"orderLines.orderArticle.categoryStoreId",op:"=",value:vm.categoryId});
            };
            //商品名称
            if (vm.productName !=null) {
                items.push({key:"orderLines.orderArticle.productName",op:"like",value:vm.productName});
            };

            if (vm.status !=null) {
                if (vm.status != 'CombinationError') {
                    items.push({key: "status", op: "=", value: vm.status});
                }else {
                    items.push({key: "orderLines.status", op: "=", value: vm.status});
                }
            }
            if (vm.deleted =='Deleted') {
                items.push({key:"cancelled",op:"=",value:"true"});
            }
            if (vm.payRefundStatus) {
                items.push({key:"payRefundStatus",op:"=",value:vm.payRefundStatus});
            }

            return items;
        }

        function loadAll () {
            var items = getItems();


            if (pagingParams.search) {
                items.push({key:"number,sourceNumber,orderLines.extPlatformNumber",op:"=",value:pagingParams.search});
            }
            if (vm.deleted == 'Deleted') {
                SalesOrder.byCondition2({
                    items:items,
                    available:false,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }else{
                SalesOrder.byCondition2({
                    items:items,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return ["createdDate,desc"];
            }
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.allPagesCount = Math.ceil(vm.totalItems/20);
            vm.queryCount = vm.totalItems;
            vm.salesOrders = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            MessageService.error("订单获取失败");
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                status:vm.status,
                deleted: vm.deleted,
                startTime: vm.startTime?DateUtils.convertLocalDateToServer(vm.startTime):"",
                endTime: vm.endTime?DateUtils.convertLocalDateToServer(vm.endTime):"",
                productName:vm.productName,
                categoryId:vm.categoryId,
                payRefundStatus:vm.payRefundStatus
            });
        }

        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        function reject(id) {
            SalesOrder.reject({id: id}, function(data) {
                MessageService.success("订单驳回成功");
                loadAll();
            }, function () {
                MessageService.error("订单驳回失败");
            });
        }

        $scope.approveRefund = function (salesorder) {
            SalesOrder.approveRefund({id: salesorder.id}, function(data) {
                MessageService.success("退款成功");
                loadAll();
            }, function () {
                MessageService.error("退款失败");
            });
        }

        $scope.rejectRefund = function (salesorder) {
            SalesOrder.rejectRefund({id: salesorder.id}, function(data) {
                MessageService.success("拒绝退款成功");
                loadAll();
            }, function () {
                MessageService.error("拒绝退款成功");
            });
        }

        $scope.checkOrderLinecombinationError = function(order){
            if (order.status != 'Paid') {
                return false;
            }
            if (order.orderLines.length > 0) {
                for (var i = order.orderLines.length - 1; i >= 0; i--) {
                    var line = order.orderLines[i];
                    if (line.status == 'CombinationError') {
                        return true;
                    }
                }
            }
            return false;
        }

        $scope.combinationError = function (salesOrder) {
            $http({
                url: 'justify/api/downloadErrorLog',
                method: "GET",
                params: {
                    orderNumber:salesOrder.number
                },
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'blob'
            }).success(function (data) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "组版失败日志_" +salesOrder.number+ ".zip";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
            }).error(function () {
                MessageService.error("下载失败，请稍后重试！");
            });
        }

        $scope.justifySalesOrder = function (obj) {
            SalesOrder.justifyOrder({id: obj.id}, function (data) {
                MessageService.success("订单文件组版中...");
            }, function () {
                MessageService.error("订单文件组版失败");
            });
        }

        $scope.pay = function (obj) {
            SalesOrder.payOrder({id: obj.id}, function (data) {
                if (data.status == 200) {
                    MessageService.success("支付成功");
                    loadAll();
                }else{
                    loadAll();
                    MessageService.error(data.message);
                }
            }, function () {
                MessageService.error("订单支付失败");
            });
        }


        $scope.close = function (obj) {
            MessageService.confirm("entity.action.deleteConfirm",function(){
                SalesOrder.closeOrder({id: obj.id}, function (data) {
                    if (data.status == 200) {
                        MessageService.success("关闭成功");
                        loadAll();
                    }else{
                        loadAll();
                        MessageService.error(data.message);
                    }
                }, function () {
                    MessageService.error("订单关闭失败");
                });
            },function(){},true);
        }

        $scope.orderCombinationNotify = function (obj) {
            SalesOrder.combinationNotify({id: obj.id}, function (data) {
                MessageService.success("通知成功");
            }, function () {
                MessageService.error("通知失败");
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('OrderViewArticleController', OrderViewArticleController);

    OrderViewArticleController.$inject = ['$scope', '$stateParams', 'Qinius', 'MessageService', '$q', 'ImageService', '$uibModalInstance',
     'Vert','FontManagement', 'ItemValue'];

    function OrderViewArticleController($scope, $stateParams, Qinius, MessageService, $q, ImageService, $uibModalInstance,
     Vert, FontManagement, ItemValue) {
        var vm = this;
        vm.counts = 0;
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            return arrDPI;
        }
        var unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            return mm / 25.4 * vm.windowDpiW;
        };
        var unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            return px / vm.windowDpiW * 25.4;
        };

        $scope.isShow = false;
        $scope.isFirst = true;
        $scope.isLast = false;
        var $li = $(".templateView-carousel");
        var $leftBtn = $(".leftBtn");
        var $rightBtn = $(".rightBtn");
        var $backBtn = $("#back-btn");


        $scope.k = 0;
        $scope.t = 0;
        $scope.isText = false;
        $scope.isPull = true;

        var allWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $scope.dHeight = vm.dHeight = ((window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 100) / 1.8;
        $scope.dWidth = vm.dWidth = (allWidth - 220) / 1.8;
        $scope.template = {
            pages: {
                page: [{}]
            }
        };
        $scope.document = {
            pages: [{}]
        };
        var artDoc = null;
        $scope.len = 0;
        $scope.domains = Qinius.getDomain();
        $(".modal-content").addClass('opacity0');

        vm.itemValue = ItemValue.get({id:$stateParams.itemValueId});
        
        Vert.xmlToDocument({
            identifier: $stateParams.fileName,
            provider: 'qiniu'
        }, function (res) {
            vm.article = angular.copy(res);
            artDoc = angular.copy(res);
            angular.forEach(artDoc.pages.page, function (page) {
                if (page.backup) {
                    return
                }
                $scope.len++;
                angular.forEach(page.levels.level,function (level) {
                    if(level.imagebox){
                        vm.counts++;
                    }
                })
            });

            getAll(res);

        });
        function getAll(doc) {
            $q.all([$scope.domains.$promise, vm.itemValue.$promise]).then(function () {
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                //取得xml文档内容
                vm.bindingtype = vm.itemValue.data.bindingType||'None';
                if (vm.bindingtype == 'Left2') {
                    $scope.isPull = false;
                    vm.bindingtype = 'Left';
                }
                if (vm.bindingtype == 'Top') {
                    $scope.dHeight = vm.dHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 100;
                }
                localStorage.setItem('bindingtype', vm.bindingtype);
                $scope.maxW = doc.pages.page[0].mediabox.width;
                $scope.minW = doc.pages.page[0].mediabox.width;
                $scope.maxH = doc.pages.page[0].mediabox.height;
                $scope.minH = doc.pages.page[0].mediabox.height;
                $(".modal-content").addClass('opacity0');
                var arrUse = {
                    pages: {
                        page: []
                    }
                };
                angular.forEach(doc.pages.page, function (page) {
                    if (!page.backup) {
                        arrUse.pages.page.push(page);
                    }
                });
                $scope.getDetail(arrUse, 0);
                // $scope.getDetail(doc, 0);
            });
        }

        $scope.getDetail = function (document, index) {
            var obj = document.pages.page[index];

            $(".carousel-wrapper").height(document.pages.page[0].mediabox.height * (document.pages.page.length + 1.7));

            $scope.template = document;
            var bgIdentifier = null;
            if (obj.background && obj.background.resource && obj.background.resource.identifier) {
                bgIdentifier = obj.background.resource.identifier + '?imageMogr2/thumbnail/!40p';
            }
            var isMaxWidth = getScale($scope.dWidth, $scope.dHeight, obj.mediabox.width, obj.mediabox.height, index);

            $scope.template.pages.page[index] = {
                background: angular.copy(obj.background),
                bgImg: bgIdentifier,
                barcode: angular.copy(obj.barcode),
                barcodeM: angular.copy(obj.barcode),
                barcodeRotation: {
                    angle: obj.barcodeRotation ? obj.barcodeRotation.angle : 0
                },
                mediabox: angular.copy(obj.mediabox),
                mediaboxPx: {},
                levels:angular.copy(obj.levels),
                isMaxWidth: isMaxWidth,
                spread: obj.spread,
                centerrotation: obj.centerrotation ? true : false,
                'thumbnailH': isMaxWidth ? $scope.dWidth * 0.8 * unitTransform(obj.mediabox.height) / unitTransform(obj.mediabox.width) : $scope.dHeight * 0.7 * unitTransform(obj.mediabox.width) / unitTransform(obj.mediabox.height),
                pageScaleH: 1,
                pageScaleW: 1
            };

            // $scope.template.pages.page[index].background.offsetx = unitTransform(obj.background.offsetx)
            // $scope.template.pages.page[index].background.offsety = unitTransform(obj.background.offsetx)

            // 无翻页效果
            if (document.pages.page.length < 2 || vm.bindingtype == 'None') {
                $scope.template.pages.page[index].styleScale = (vm.dWidth * 0.7 / (unitTransform(obj.mediabox.width)));
            } else {
                $scope.template.pages.page[index].styleScale = 1;
            }


            // 得到压缩比例后的最高page的高度
            if ($scope.maxPageHeight < $scope.template.pages.page[index].thumbnailH) {
                $scope.maxPageHeight = $scope.template.pages.page[index].thumbnailH;
            }
            if (obj.barcode) {
                $scope.template.pages.page[index].barcode.geometry = getGeometry(obj.barcode.geometry, index)
            }
            $scope.template.pages.page[index].mediaboxPx = getGeometry(obj.mediabox, index)
            $scope.template.pages.page[index].ratio = $scope.template.pages.page[index].mediaboxPx.width / ($scope.template.pages.page[index].mediabox.width/ 25.4 * vm.windowDpiW)

            var background = $scope.template.pages.page[index].background;
            var w = $scope.template.pages.page[index].mediaboxPx.width,
                h = $scope.template.pages.page[index].mediaboxPx.height;

            if (background&&background.resource) {
                getBackgroundSource(obj.background.resource,w,h,background)
                background.offsetXM = angular.copy(background.offsetx);
                background.offsetYM = angular.copy(background.offsety);
                background.offsetx = unitTransform(background.offsetx)* $scope.template.pages.page[index].styleScale
                background.offsety = unitTransform(background.offsety)* $scope.template.pages.page[index].styleScale
            }

            angular.forEach(obj.levels.level,function (level,l) {
                var pageLevel = $scope.template.pages.page[index].levels.level[l];
                if (level.imageart && level.imageart.geometry) {
                    var art = level.imageart;
                    pageLevel.imageart = {
                        geometry: getGeometry(art.geometry, index),
                        rotation: {
                            angle: -art.rotation.angle
                        },
                        type: art.type,
                        resource: {
                            identifier:art.resource.identifier,
                            provider:art.resource.provider
                        },
                        scale:art.scale,
                        widthM: art.geometry.width,
                        heightM: art.geometry.height,
                        XM: art.geometry.x,
                        YM:art.geometry.y,
                        offsetXM: angular.copy(art.offsetx),
                        offsetYM: angular.copy(art.offsety),
                        offsetx: unitTransform(art.offsetx)* $scope.template.pages.page[index].styleScale,
                        offsety: unitTransform(art.offsety)* $scope.template.pages.page[index].styleScale,
                        current: 'imageart',
                        levelI: l,
                        pageI: index,
                        transparency: art.transparency,
                        onlyshow: art.onlyshow,
                        movable: art.movable,
                        editable: art.editable,
                    }
                    var newImg = new Image();
                    newImg.crossOrigin = "Anonymous";
                    newImg.onload = function () {
                        newImg.onload = null;
                        pageLevel.imageart.resource.width = newImg.width;
                        pageLevel.imageart.resource.height = newImg.height;
                    };
                    newImg.src = art.resource.identifier;
                }
                if (level.textbox && level.textbox.geometry) {
                    var text = level.textbox;
                    pageLevel.textbox = {
                        geometry: getGeometry(text.geometry, index),
                        identifier: text.identifier,
                        style: angular.copy(text.style),
                        rotation: {
                            angle: -text.rotation.angle
                        },
                        text: text.text,
                        heightM: text.geometry.height,
                        widthM: text.geometry.width,
                        xM: text.geometry.x,
                        yM: text.geometry.y,
                        styles: 'NORMAL',
                        type: text.type,
                        status: text.status,
                        templateType: vm.edit ? text.type : '',
                        levelI:l,
                        transparency: text.transparency,
                        lineheight: text.style.lineheight,
                        letterspacing: text.style.letterspacing,
                        movable: text.movable,
                        editable: text.editable,
                        fontuuid: text.fontuuid,
                        version:text.version
                    };
                    if(text.fontuuid){
                        //下载字体
                        getFontCSS(text.fontuuid)
                    }
                }

                if(level.imagebox){
                    var img = level.imagebox;
                    pageLevel.imagebox = {
                        geometry: getGeometry(img.geometry, index),
                        mask: angular.copy(img.mask),
                        imgUrl: 'content/images/shattered.png',
                        maskUrl: 'content/images/shattered.png',
                        rotation: angular.copy(img.rotation),
                        scaleW: 1,
                        scaleH: 1,
                        levelI:l,
                        bokehtype: img.bokehtype||'None',
                        image: {
                            resource: {
                                identifier: img.image ? img.image.resource.identifier : '',
                                provider: img.image ? img.image.resource.provider : 'qiniu'
                            },
                            rotation: angular.copy(img.rotation),
                            parameter: (!img.image) || img.image.parameter == null ? [] : angular.fromJson(img.image.parameter),
                            filter: (!img.image) || img.image.filter == null ? '' : img.image.filter,
                            offsetx: img.image?(unitTransform(img.image.offsetx) * $scope.template.pages.page[index].styleScale):0,
                            offsety: img.image?(unitTransform(img.image.offsety) * $scope.template.pages.page[index].styleScale):0,
                            angle: img.image && img.image.angle ? img.image.angle : 0,
                            scale: (!img.image) || img.image.scale == 1 ? 1 : img.image.scale
                        }
                    };

                    if (img.bokehtype!='None' && img.blurredrectangle) {
                        pageLevel.imagebox.blurredrectangle = getGeometry(img.blurredrectangle, index)
                    }

                    if (img.mask.resource.identifier&&img.mask.resource.identifier!=null&&img.mask.resource.identifier!="") {
                        pageLevel.imagebox.maskUrl = img.mask.resource.identifier + '?imageMogr2';
                    }


                    if (img.image && img.image.resource.identifier) {       //qiniu
                        // imageboxes.imgUrl = $scope.domain + img.image.resource.identifier + '?imageMogr2/auto-orient/rotate/' + img.image.angle;
                        pageLevel.imagebox.imgUrl = img.image.resource.identifier + '?imageMogr2/auto-orient/thumbnail/!40p';
                        if (pageLevel.imagebox.image.angle != 0) {
                            pageLevel.imagebox.imgUrl += '/rotate/' + pageLevel.imagebox.image.angle
                        }
                    }
                }
                if (level.textdocument && level.textdocument.geometry) {
                    var textdocument = level.textdocument;
                    pageLevel.textdocument = {
                        background: textdocument.background,
                        geometry: getGeometry(textdocument.geometry,index),
                        widthM: textdocument.geometry.width,
                        heightM: textdocument.geometry.height,
                        offsetXM: textdocument.geometry.x,
                        offsetYM: textdocument.geometry.y,
                        rotation: {
                            angle:textdocument.rotation.angle||0
                        },
                        current: 'textdocument',
                        levels: angular.copy(textdocument.levels),
                        levelI: l,
                        pageI: index,
                        lock: true,
                        transparency: textdocument.transparency,
                        movable: textdocument.movable,
                        editable: textdocument.editable
                    }

                    var backg = pageLevel.textdocument.background;
                    var pageW = pageLevel.textdocument.geometry.width,
                        pageH = pageLevel.textdocument.geometry.height;
                    if(backg.resource.identifier){
                        getBackgroundSource(backg.resource,pageW,pageH,backg)
                        backg.offsetx = unitTransform(backg.offsetx)* $scope.template.pages.page[index].styleScale
                        backg.offsety = unitTransform(backg.offsety)* $scope.template.pages.page[index].styleScale
                        backg.offsetXM = angular.copy(level.textdocument.background.offsetx);
                        backg.offsetYM = angular.copy(level.textdocument.background.offsety);
                    }

                    angular.forEach(textdocument.levels.level, function (lev, n) {
                        if (lev.imageart && lev.imageart.geometry) {
                            var art = lev.imageart;
                            pageLevel.textdocument.levels.level[n].imageart = {
                                geometry: getGeometry(art.geometry,index),
                                rotation: {
                                    angle: -art.rotation.angle
                                },
                                type: art.type,
                                resource: {
                                    identifier:art.resource.identifier,
                                    provider:art.resource.provider
                                },
                                scale:art.scale,
                                widthM: art.geometry.width,
                                heightM: art.geometry.height,
                                XM: art.geometry.x,
                                YM:art.geometry.y,
                                offsetXM: angular.copy(art.offsetx),
                                offsetYM: angular.copy(art.offsety),
                                offsetx: unitTransform(art.offsetx)* $scope.template.pages.page[index].styleScale,
                                offsety: unitTransform(art.offsety)* $scope.template.pages.page[index].styleScale,
                                current: 'imageart',
                                levelI: l,
                                pageI: index,
                                lock: false,
                                transparency: art.transparency,
                                onlyshow: art.onlyshow,
                                movable: art.movable,
                                editable: art.editable,
                            }
                            var newImg = new Image();
                            newImg.crossOrigin = "Anonymous";
                            newImg.onload = function () {
                                newImg.onload = null;
                                pageLevel.textdocument.levels.level[n].imageart.resource.width = newImg.width;
                                pageLevel.textdocument.levels.level[n].imageart.resource.height = newImg.height;
                            };
                            newImg.src = art.resource.identifier;
                        }
                        if (lev.textbox && lev.textbox.geometry) {
                            var text = lev.textbox;
                            pageLevel.textdocument.levels.level[n].textbox = {
                                geometry: getGeometry(text.geometry, index),
                                identifier: text.identifier,
                                rotation: {
                                    angle: -text.rotation.angle
                                },
                                angle: angular.copy(text.angle),
                                status: angular.copy(text.status),
                                style: angular.copy(text.style),
                                type: angular.copy(text.type),
                                text: angular.copy(text.text),
                                fontStyle: [{
                                    style: '',
                                    path: text.identifier
                                }],
                                widthM: text.geometry.width,
                                heightM: text.geometry.height,
                                offsetXM: text.geometry.x,
                                offsetYM: text.geometry.y,
                                current: 'textbox',
                                levelI: n,
                                pageI: index,
                                lock: true,
                                transparency: text.transparency,
                                lineheight: text.style.lineheight,
                                letterspacing: text.style.letterspacing,
                                fontuuid:text.fontuuid,
                                version:text.version
                            }
                            if(text.fontuuid){
                                //下载字体
                                getFontCSS(text.fontuuid)
                            }
                        }
                    })
                }
            })

            if (index < document.pages.page.length - 1) {
                $scope.getDetail(document, index + 1);
            } else {
                $scope.isLeftRotation = !$scope.template.pages.page[0].centerrotation;
                angular.forEach($scope.template.pages.page, function (page, m) {
                    angular.forEach(page.levels.level,function (level,l) {
                        if(level.imagebox){
                            imgScale(level.imagebox, m, l, level.imagebox.maskUrl, level.imagebox.image.offsetx, level.imagebox.image.offsety);
                        }
                    })
                })
            }
            if (vm.counts == 0) {
                var arr = angular.copy($scope.template);
                angular.forEach(arr.pages.page, function (obj, index) {
                    getArr(arr, obj, index);
                });
            }
        };

        function getBackgroundSource(res,pageW,pageH,arr) {
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.onload = function () {
                newImg.onload = null;
                var bgW = newImg.width;
                var bgH = newImg.height;
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                arr.width = w;
                arr.height = h;
                arr.type = 'Pic';
                arr.adaptation = adaptation;
            };
            newImg.src = res.identifier;
        }

        function getFontCSS(item){
            FontManagement.getCss({uuid: item}, function (res) {
                if(res.status == 200){
                    var style=document.createElement("style");
                    style.type='text/css';
                    try{
                        style.appendChild(document.createTextNode(res.data));
                    }catch(ex){
                        style.stylesheet.cssText=res.data;
                    }
                    var Head=document.getElementsByTagName("head")[0];
                    Head.appendChild(style);
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        function getScale(screenW, screenH, pageW, pageH) {
            var newH = angular.copy(screenH);
            if (vm.bindingtype == 'Top' && screenW * 0.7 * pageH / pageW * 2 > screenH) {
                newH = (newH - 100) / 2;
            }

            if (vm.bindingtype == 'Top') {
                if (screenW / newH < pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    return false;
                }
            } else {
                if (screenW / newH > pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    return false;
                }
            }
        }

        function getScale2(screenW, screenH, pageW, pageH) {
            var newH = angular.copy(screenH);
            if (vm.bindingtype == 'Top' && screenW * 0.7 * pageH / pageW * 2 > screenH) {
                newH /= 2;
            }

            if (vm.bindingtype == 'Top') {
                if (screenW / newH < pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    // return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    // return false;
                }
            } else {
                if (screenW / newH > pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    // return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    // return false;
                }
            }

            // $scope.isMaxWidth = true;
        }

        function getGeometry(obj, index) {
            return {
                height: unitTransform(obj.height) * $scope.template.pages.page[index].styleScale,
                width: unitTransform(obj.width) * $scope.template.pages.page[index].styleScale,
                x: unitTransform(obj.x) * $scope.template.pages.page[index].styleScale,
                y: unitTransform(obj.y) * $scope.template.pages.page[index].styleScale
            }
        }

        function imgScale(images, index, id, mask, x, y, flag) {
            var scaleW = 1, scaleH = 1;
            var newImg = document.createElement('img');
            newImg.setAttribute("crossOrigin", 'Anonymous');
            newImg.src = images.imgUrl;
            newImg.onload = function () {
                var w = newImg.width;
                var h = newImg.height;
                var maskWidth = images.geometry.width;
                var maskHight = images.geometry.height;
                if ((newImg.width <= newImg.height || maskWidth <= maskHight) && (newImg.width / newImg.height < maskWidth / maskHight) || newImg.width >= newImg.height && maskWidth >= maskHight && (newImg.width / newImg.height < maskWidth / maskHight)) {
                    newImg.width = maskWidth;
                    newImg.height = maskWidth * h / w;
                } else {
                    newImg.height = maskHight;
                    newImg.width = maskHight * w / h;
                }

                scaleW = newImg.width / w;
                scaleH = newImg.height / h;
                x = x / scaleW;
                y = y / scaleH;

                var img = images.imgUrl;
                if (images.bokehtype == 'Transparent') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        dropPicFinished();
                    });

                } else if (images.bokehtype == 'Blurred') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                    });

                    img = img + '/blur/40x1000';
                    maskd(img, mask, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale||1, function (src) {
                        images.blobUrl = src;
                        dropPicFinished();
                    });

                } else {
                    maskd(img, mask, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale||1, function (src) {
                        images.blobUrl = src;
                        dropPicFinished();
                    });
                }
            };
            newImg.onerror = function () {
                images.imgUrl = images.image.resource.identifier + '?imageMogr2/auto-orient';
                if (images.image.angle != 0) {
                    images.imgUrl += '/rotate/' + images.image.angle
                }
                if (!flag) {
                    imgScale(images, index, id, mask, x, y, true);
                } else {
                    $scope.loading = false;
                    $(".page-loading").hide();
                    $li.show();
                    $scope.isShow = true;
                    $(".save-page").hide();
                }

            }
        }

        function dropPicFinished() {
            $scope.k++;
            if ($scope.k == vm.counts) {
                angular.forEach($scope.template.pages.page, function (obj, index) {
                    getArr($scope.template, obj, index);
                });
            }
        }

        function maskd3(img, src, imagebox, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var geo = imagebox.geometry;
            var blurredRec = imagebox.blurredrectangle;
            var newImg = document.createElement('img');
            // newImg.crossOrigin = "Anonymous";
            newImg.setAttribute("crossOrigin", 'Anonymous');
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = blurredRec.width;
                newImg.height = blurredRec.height;
                var masks = document.createElement('img');
                // masks.crossOrigin = "Anonymous";
                masks.setAttribute("crossOrigin", 'Anonymous');
                masks.src = imagebox.maskUrl;

                masks.onload = function () {
                    masks.width = geo.width;
                    masks.height = geo.height;
                    imagecanvas.width = geo.width;
                    imagecanvas.height = geo.height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, geo.width, geo.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.drawImage(newImg, blurredRec.x, blurredRec.y, blurredRec.width, blurredRec.height);

                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
            };
        }

        function maskd(src, maskUrl, attr, x0, y0, width, height, scaleW, scaleH, scale, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.setAttribute("crossOrigin", 'Anonymous');
            newImg.src = src;
            newImg.width = width;
            newImg.height = height;
            if (newImg.complete) {
                var masks = document.createElement('img');
                masks.setAttribute("crossOrigin", 'Anonymous');
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);
                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
                return
            }
            newImg.onload = function () {
                newImg.onload = null;
                var masks = document.createElement('img');
                masks.setAttribute("crossOrigin", 'Anonymous');
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);
                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
            };
            newImg.src = src;
        }

        function getArr(arrs, obj, index) {
            var w = obj.mediabox.width;
            var h = obj.mediabox.height;
            if (obj.spread) {
                if (w / 2 > $scope.maxW) {
                    $scope.maxW = w / 2;
                }
                if (w / 2 < $scope.minW) {
                    $scope.minW = w / 2;
                }
            } else {
                if (w > $scope.maxW) {
                    $scope.maxW = w;
                }
                if (w < $scope.minW) {
                    $scope.minW = w;
                }
            }

            if (h > $scope.maxH) {
                $scope.maxH = h;
            }
            if (w < $scope.minH) {
                $scope.minH = h;
            }
            $scope.document.pages[index] = {
                arr: obj,
                arr2: '',
                multiple: 0.45,
                multiple2: 0.45,
                width: w,
                height: h,
                spread: obj.spread,
                'marginLeft': 0,
                'thumbnail': 1,
                'thumbnail2': 1,
                id: obj.id,
                mediabox: angular.copy(obj.mediabox)
            };
            setBgImg(index, arrs, obj);
            if (index == $scope.len - 1 && vm.bindingtype != 'None') {
                var page = $scope.document.pages;
                getScale2($scope.dWidth, $scope.dHeight, page[0].mediabox.width, page[0].mediabox.height);
                //第一个page宽度 和 最大page宽度 的比值
                // var pageW = page[0].mediabox.width;
                // if(page[0].spread){
                //     pageW/= 2;
                // }
                // if(pageW>0){
                //     page[0].thumbnail =(pageW / $scope.maxW).toFixed(2)
                // }
                getPageThumbnail(page[0], page[0].spread);
                for (var j = 1; j < page.length; j++) {
                    page[j].halfWidth = ($scope.dWidth * page[j].multiple).toFixed(2);
                    //每个page宽度 和 最大page宽度 的比值
                    getPageThumbnail(page[j], page[0].spread);

                    if (j + 1 != page.length) {
                        getPageThumbnail(page[j + 1], page[j + 1].spread);
                    }
                    //跨页
                    if (page[j].spread == true) {
                        //左右翻页的清空
                        if (vm.bindingtype != 'Left') {
                            if (!$scope.uadHeight) {
                                $scope.uadHeight = page[j - 1].mediabox.height * 2
                            }
                            // page[j].marginTop = $scope.dWidth * 0.7 * ($scope.uadHeight - page[j].mediabox.height) * page[j].thumbnail / page[j].mediabox.width / 2;
                            if ($scope.isMaxWidth) {
                                var newW = $scope.dWidth * 0.7
                            } else {
                                var newW = ($scope.dHeight - 100) / 2 * page[j].mediabox.width / page[j].mediabox.height
                            }
                            page[j].marginTop = newW * ($scope.uadHeight - page[j].mediabox.height) * page[j].thumbnail / page[j].mediabox.width / 2;

                        }

                    } else if (page[j].spread == false && (page[j + 1] || []).spread == false && (j + 2) != page.length) {
                        // console.log(j);
                        var arr = page[j + 1];
                        var arr0 = page[j];
                        page[j] = {
                            id: arr0.id,
                            width: arr0.mediabox.width,
                            height: arr0.mediabox.height,
                            arr: arr0.arr,
                            spread: arr0.spread,
                            multiple: arr0.multiple,
                            thumbnail: arr0.thumbnail,
                            marginLeft: arr0.halfWidth - $scope.dWidth * arr.multiple * arr.thumbnail,
                            id2: arr.id,
                            width2: arr.mediabox.width,
                            height2: arr.mediabox.height,
                            arr2: arr.arr,
                            spread2: arr.spread,
                            multiple2: arr.multiple,
                            thumbnail2: arr.thumbnail
                        };
                        page.splice(j + 1, 1);
                        $scope.uadHeight = arr.mediabox.height + arr0.mediabox.height;
                    }
                    if (j == page.length - 1) {
                        $scope.document.pages = page;
                        $scope.isShow = true;
                        $(".save-page").hide();

                        angular.forEach(page, function (paged) {
                            if (vm.bindingtype == 'Top') {
                                $scope.getPageWaHUad(paged, true);
                                $scope.getPageWaHUad(paged, false);
                            }
                            if (vm.counts > 0 && !$scope.isText) {
                                $scope.$apply(function () {
                                    $scope.document.pages = page;
                                    if ($scope.toggle.now) {
                                        Page.init();
                                    }
                                })
                            }
                        });

                        $scope.$watch('toggle.now', function () {
                            if ($scope.toggle.now) {
                                Page.init();
                            }
                        });
                        $(".un-last:parent").css({width: '50%!important'})
                    }
                }
                $scope.document.pages = page;
                console.log(page)
            }
            if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                $(".save-page").hide();
                $(".rightBtn").hide();
            }
        }

        function getPageThumbnail(page, spread) {
            var pageW = page.mediabox.width;
            if (spread) {
                pageW /= 2;
            }
            if (pageW > 0) {
                page.thumbnail = (pageW / $scope.maxW).toFixed(2)
            }
        }

        function setBgImg(index, documents, obj) {
            // if ((index - 1) > 0 && documents.pages[index].identifier && (index - 1) < (documents.pages.length - 2) && (obj.spread == false && documents.pages[index - 2].spread == false && (index - 2) != 0 && (documents.pages[index - 2].spread2) || (obj.spread == false && (documents.pages[index] || []).spread == false))) {
            //     $scope.template.pages[index - 1].bgImg2 = $scope.domain + documents.pages[index].identifier;
            // }
            if (index <= 2) {
                return
            }
            if (!documents.pages.page[index].identifier) {
                return
            }
            if (index >= (documents.pages.page.length - 1)) {
                return
            }
            if (obj.spread) {
                return
            }
            if (!documents.pages.page[index - 2].spread && (documents.pages.page[index - 2].spread2)) {
                $scope.document.pages[index - 1].arr2 = documents.pages.page[index];
                return
            }
            if (!(documents.pages.page[index] || []).spread) {
                $scope.document.pages[index - 1].arr2 = documents.pages.page[index];
            }
        }

        $scope.getLiW = function (slide) {
            if (vm.bindingtype == 'Top') {
                if ($scope.isMaxWidth) {
                    return $scope.dWidth * 0.7
                } else {
                    return ($scope.dHeight - 100) / 2 * slide.width / slide.height
                }
            } else {
                if ($scope.isMaxWidth) {
                    // return $scope.dWidth * 0.9
                    return ''
                } else {
                    var h = slide.arr2 ? slide.width2 / slide.height2 : slide.width / slide.height;
                    return ($scope.dHeight - 100) * (slide.width / slide.height + h)
                }

            }
        };
        $scope.getUlW = function () {
            if (vm.bindingtype == 'Top') {
                if ($scope.isMaxWidth) {
                    return $scope.dWidth * 0.7
                } else {
                    return ($scope.dHeight - 100) / 2 * $scope.document.pages[0].width / $scope.document.pages[0].height
                }
            } else {
                return $scope.dWidth * 0.9
            }
        };

        $scope.getPageWaHLar = function (slide, flag, marginFlag) {
            if (vm.bindingtype != 'Left') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var w = 0;
                if (!marginFlag) {
                    if (!slide.arr2) {
                        return
                    }

                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * slide.multiple2 * slide.thumbnail2;
                    } else {
                        w = ($scope.dHeight - 100) * slide.width2 / slide.height2 * slide.thumbnail2
                    }

                    slide.arr2.pageScaleW = w / unitTransform(slide.width2);
                    slide.arr2.ratio = w / (slide.arr2.mediabox.width / 25.4 * vm.windowDpiW);
                } else {
                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * slide.multiple * slide.thumbnail;
                    } else {
                        w = ($scope.dHeight - 100) * slide.width / slide.height * slide.thumbnail;
                    }

                    slide.arr.pageScaleW = w / unitTransform(slide.width);
                    slide.arr.ratio = w / (slide.arr.mediabox.width / 25.4 * vm.windowDpiW);

                }
                if (marginFlag && $scope.maxW != $scope.minW) {
                    if (slide.spread) {
                        slide.marginLeft = ($scope.dWidth * 0.9 - w) / 2;
                    } else {
                        slide.marginLeft = ($scope.dWidth * 0.45 - w);
                    }
                }
                return w;
            } else {
                var h = 0;
                if (!marginFlag) {
                    if (!slide.arr2) {
                        return
                    }

                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * slide.multiple2 * slide.height2 * slide.thumbnail2 / slide.width2
                    } else {
                        h = $scope.dHeight - 100
                    }

                    slide.arr2.pageScaleH = h / unitTransform(slide.height2);
                } else {
                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * slide.multiple * slide.height * slide.thumbnail / slide.width
                    } else {
                        h = $scope.dHeight - 100
                    }

                    slide.arr.pageScaleH = h / unitTransform(slide.height);
                }
                return h;
            }
        };
        $scope.getPageWaHUad = function (slide, flag) {
            if (vm.bindingtype != 'Top') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var w1 = 0, w2 = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        w2 = $scope.dWidth * 0.7 * slide.thumbnail2
                    }
                    else {
                        w2 = ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2
                    }
                    slide.w2 = w2;
                    slide.arr2.w = w2;
                    slide.arr2.pageScaleW = w2 / unitTransform(slide.width2);
                    slide.arr2.ratio = w2 / (slide.arr2.mediabox.width / 25.4 * vm.windowDpiW);

                }
                if ($scope.isMaxWidth) {
                    w1 = $scope.dWidth * 0.7 * slide.thumbnail
                } else {
                    w1 = ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail
                }
                slide.w1 = w1;
                slide.arr.w = w1;
                slide.arr.pageScaleW = w1 / unitTransform(slide.width);
                slide.arr.ratio = w1 / (slide.arr.mediabox.width / 25.4 * vm.windowDpiW);
            } else {
                var h1 = 0, h2 = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        h2 = $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2;
                    } else {
                        h2 = ($scope.dHeight - 100) / 2;
                    }
                    slide.h2 = h2;
                    slide.arr2.h = h2;
                    slide.arr2.pageScaleH = h2 / unitTransform(slide.height2);

                }
                if ($scope.isMaxWidth) {
                    h1 = $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                } else {
                    h1 = ($scope.dHeight - 100) / 2;
                }
                slide.h1 = h1;
                slide.arr.h = h1;
                slide.arr.pageScaleH = h1 / unitTransform(slide.height);
            }
        };

        $scope.getPageWaHUad1 = function (slide, flag) {
            if (vm.bindingtype != 'Top') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var w = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * 0.7 * slide.thumbnail2
                    }
                    else {
                        w = ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2
                    }
                    slide.w2 = w;
                    slide.arr2.w = w;
                    slide.arr2.pageScaleW = w / unitTransform(slide.width2);
                    slide.arr2.ratio = w / (slide.arr2.mediabox.width / 25.4 * vm.windowDpiW);

                } else {
                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * 0.7 * slide.thumbnail
                    } else {
                        w = ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail
                    }
                    slide.w1 = w;
                    slide.arr.w = w;
                    slide.arr.pageScaleW = w / unitTransform(slide.width);
                    slide.arr.ratio = w / (slide.arr.mediabox.width / 25.4 * vm.windowDpiW);
                }
                // var w = slide.bgImg2 ? !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2 : $scope.dWidth * 0.7 * slide.thumbnail2 : !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail : $scope.dWidth * 0.7 * slide.thumbnail;
                return w;
            } else {
                var h = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2;
                    } else {
                        h = ($scope.dHeight - 100) / 2;
                    }
                    slide.h2 = h;
                    slide.arr2.h = h;
                    slide.arr2.pageScaleH = h / unitTransform(slide.height2);

                } else {
                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                    } else {
                        h = ($scope.dHeight - 100) / 2;
                    }
                    slide.h1 = h;
                    slide.arr.h = h;
                    slide.arr.pageScaleH = h / unitTransform(slide.height);

                }
                // var h = slide.bgImg2 ? !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 : $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2 : !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 : $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                return h;
            }
        };
        $scope.getPageScaleUad = function (slide, flag) {
            if (vm.bindingtype != 'Top') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var pageScaleW = 0;
                if (slide.arr2) {
                    slide.arr2.pageScaleW = pageScaleW = slide.arr2.w / unitTransform(slide.width2);

                } else {
                    slide.arr.pageScaleW = pageScaleW = slide.arr.w / unitTransform(slide.width);
                }
                return pageScaleW;
            } else {
                var pageScaleH = 0;
                if (slide.arr2) {
                    slide.arr2.pageScaleH = pageScaleH = slide.arr2.h / unitTransform(slide.height2);

                } else {
                    slide.arr.pageScaleH = pageScaleH = slide.arr.h / unitTransform(slide.height);

                }
                return pageScaleH;
            }
        };

        $scope.toggle = {
            now: false
        };
        var Page = (function () {
            var pageI = 0;
            var config = {
                    $bookBlock: $('#bb-bookblock'),
                    $navNext: $('#bb-nav-next'),
                    $navPrev: $('#bb-nav-prev'),
                    $slide1: $('#slide1'),
                    $slide2: $('#slide2')
                },
                init = function () {
                    config = {
                        $bookBlock: $('#bb-bookblock'),
                        $navNext: $('#bb-nav-next'),
                        $navPrev: $('#bb-nav-prev'),
                        $slide1: $('#slide1'),
                        $slide2: $('#slide2')
                    };
                    if (vm.bindingtype == 'Left') {
                        config.$bookBlock.bookblock({
                            speed: 800,
                            shadowSides: 0.8,
                            shadowFlip: 0.7,
                            len: $scope.document.pages.length
                        });
                    } else {
                        $(".bb-item").addClass('lar-noShadow');
                        config.$bookBlock.bookblock({
                            orientation: 'horizontal',
                            speed: 700
                        });
                    }
                    initEvents();
                },
                initEvents = function () {
                    var $slides = config.$bookBlock.children();

                    // add navigation events
                    config.$navNext.on('click touchstart', function () {
                        config.$bookBlock.bookblock('next');
                        pageI = localStorage.getItem('pageI');
                        nextShow(pageI - 1);
                        return false;
                    });

                    config.$navPrev.on('click touchstart', function () {
                        config.$bookBlock.bookblock('prev');
                        pageI = localStorage.getItem('pageI');
                        prevShow(pageI - 0 + 1);
                        return false;
                    });

                    // add swipe events
                    $slides.on({
                        'click': function (event) {
                            fn(event);
                            var index = event.currentTarget.dataset.index;
                            var page = $scope.document.pages[index];

                            var mar = (allWidth - $(".modal-content").width()) / 2;
                            var w = $(".view-article").width() / 2 + mar;

                            if (vm.bindingtype == 'Left') {
                                if (event.clientX > (w)) {
                                    getPageWidth(index - 0 + 1, 'next', config);
                                    nextShow(index);
                                } else {
                                    getPageWidth(index - 1, 'prev', config);
                                    prevShow(index);
                                }
                            } else if (vm.bindingtype == 'Top') {
                                // 120px---->bb-bg 上方高度
                                if (event.pageY > 120 + $(".bb-item").eq(index).height() / 2) {
                                    //最后一页的时候禁止点击
                                    if (index == $scope.document.pages.length - 1) {
                                        return
                                    }
                                    config.$bookBlock.bookblock('next');
                                    nextShow(index);
                                } else {
                                    config.$bookBlock.bookblock('prev');
                                    prevShow(index);
                                }

                                if ($scope.document.pages[index].spread == true) {
                                    $(".bb-horizontal .bb-page").css({top: '50.1%'})
                                }
                            }
                            return false;
                        }
                    });
                };

            return {init: init};

        })();

        function nextShow(index) {
            var len = $scope.document.pages.length;
            $(".leftBtn").show();
            if (index - 0 + 1 == len - 1) {
                $(".rightBtn").hide();
            }
        }

        function prevShow(index) {
            $(".rightBtn").show();
            if (index - 1 == 0) {
                $(".leftBtn").hide();
            }
        }

        function getPageWidth(index, attr, config) {
            if (!$scope.isMaxWidth) {
                var page = $scope.document.pages[index];
                var halfWidth = page.arr2 ? page.width2 / page.height2 : page.width / page.height;
                var w = ($scope.dHeight - 100) * (page.width / page.height + halfWidth);
                // console.log(w);
                $li.width(w);
                $("#bb-bookblock").width(w);
            } else {
                $li.width($("#bb-bookblock").width());
            }
            config.$bookBlock.bookblock(attr);
        }

        $scope.backTo = function () {
            $uibModalInstance.dismiss('cancel');

            $(".listBGC").show();
            $(".modal-content").show().removeClass('opacity0');
        };

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('RoleDialogController', RoleDialogController);

    RoleDialogController.$inject = ['$timeout', '$q', '$scope', '$stateParams', '$state', 'entity', 'Role',
        'Authority', 'MessageService', 'ListService' ];

    function RoleDialogController ($timeout, $q, $scope, $stateParams, $state, entity, Role,
                                   Authority, MessageService, ListService ) {
        var vm = this;

        vm.role = entity;
        vm.clear = clear;
        vm.save = save;
        vm.authorities = Authority.getAllByCondition({items:[]});
        vm.authorities_2 = [];
        vm.mods = [];
        $q.all([vm.role.$promise, vm.authorities.$promise]).then(function(){
            vm.role = vm.role.data;
            vm.authorities = vm.authorities.data;
            if (!!vm.role.id) {
                vm.title = "编辑"
            }else{
                vm.title = "新建"
            }
            vm.role.type = "STORE";
            $scope.groupBy();
            //编辑
            if (vm.role.id) {
                for (var i = 0; i < vm.role.authorities.length; i++) {
                    var au =  vm.role.authorities[i];
                    var result = ListService.inList(au, vm.mods, ["module"]);
                    if (result) {
                        for (var j = result.authorities.length - 1; j >= 0; j--) {
                            var authority = result.authorities[j];
                            if(authority.id == au.id){
                                authority.selected = true;
                                break;
                            }
                        }
                    }
                }

                for (var i = vm.mods.length - 1; i >= 0; i--) {
                    var mod = vm.mods[i];
                    for (var j = mod.authorities.length - 1; j >= 0; j--) {
                        var au = mod.authorities[j];
                        if (!au.selected) {
                            mod.unAllSelect = true;
                            break;
                        }
                    }
                    if (mod.unAllSelect) {
                        mod.selected = false;
                    }else {
                        mod.selected = true;
                    }
                }
            };

        });

        $scope.chooseAuthorty = function(mod, au){
            au.selected = !au.selected;
            if (!au.selected) {
                mod.selected = false;
            }
            for (var i = mod.authorities.length - 1; i >= 0; i--) {
                var auth = mod.authorities[i];
                if (!auth.selected) {
                    mod.selected = false;
                    return;
                }
            }
            mod.selected = true;
        }

        $scope.chooseMod = function(mod){
            if (!mod) {
                return;
            }
            mod.selected = !mod.selected;
            for (var i = mod.authorities.length - 1; i >= 0; i--) {
                var au = mod.authorities[i];
                au.selected = mod.selected;
            }
        }


        $scope.groupBy = function(){
            vm.mods = [];
            if(vm.authorities == null || vm.authorities.length == 0 || vm.role.type == null || vm.role.type == ""){
                return null;
            }
            for (var i = vm.authorities.length - 1; i >= 0; i--) {
                var authority = vm.authorities[i];
                if (authority.jhiType != vm.role.type) {
                    continue;
                }
                var e = ListService.inList(authority,vm.mods ,["module"]);
                if(!e){
                    var r = {module:authority.module,authorities:[]};
                    vm.mods.push(r);
                }

                for (var j = vm.mods.length - 1; j >= 0; j--) {
                    var mod = vm.mods[j];
                    if(authority.module == mod.module){
                        authority.selected = false;
                        mod.authorities.push(authority);
                        break;
                    }
                }
            }
        };

        $scope.authoritySelected = function(authority){
            authority.selected = !authority.selected;

        };


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go('role', null, {reload: 'role'});
        }

        $scope.toPost = function (){
            var postData  ={};
            postData.authorities = [];
            postData.id = vm.role.id;
            postData.name = vm.role.name;
            postData.type = vm.role.type;
            postData.number = vm.role.number;
            postData.cancelled = vm.role.cancelled;
            postData.storeId = vm.role.storeId;
            for (var i = vm.mods.length - 1; i >= 0; i--) {
                var mod = vm.mods[i];
                for (var j = mod.authorities.length - 1; j >= 0; j--) {
                    var au = mod.authorities[j];
                    if (au.selected) {
                        postData.authorities.push(au);
                    }
                }
            }
            return postData;
        };

        $scope.validate = function(){
            if(vm.role.name == null || vm.role.name == ""){
                MessageService.error("请输入名称");
                return false;
            }
            if(vm.role.type == null || vm.role.type == ""){
                MessageService.error("请输入类型");
                return false;
            }
            return true;
        };


        function save () {
            if(!$scope.validate()){
                return
            }
            var data = $scope.toPost();
            data.type = 'STORE';
            vm.isSaving = true;
            if (vm.role.id !== null) {
                Role.update(data, onSaveSuccess, onSaveError);
            } else {
                Role.byStore(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (res) {
            if(res.status == 200){
                $scope.$emit('backApp:roleUpdate', res.data);
                MessageService.success("保存成功！");
                $state.go("role");
            }else {
                MessageService.error(res.message);
            }
        }

        function onSaveError () {
            vm.isSaving = false;
            MessageService.error("保存失败！");
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('RoleDetailController', RoleDetailController);

    RoleDetailController.$inject = ['$scope', '$q', '$rootScope', '$stateParams', 'entity', 'Role', 'ListService','$state'];

    function RoleDetailController($scope, $q, $rootScope, $stateParams, entity, Role, ListService,$state) {
        var vm = this;
        vm.role = entity;
        vm.clear = clear;
        $q.all([vm.role.$promise]).then(function(){
            $scope.groupBy();
        });

        $scope.groupBy = function(){
            vm.mods = [];
            if(vm.role.authorities == null || vm.role.authorities.length == 0){
                return null;
            }
            for (var i = vm.role.authorities.length - 1; i >= 0; i--) {
                var authority = vm.role.authorities[i];
                var e = ListService.inList(authority,vm.mods ,["module"]);
                if(!e){
                    var r = {module:authority.module,authorities:[]};
                    vm.mods.push(r);
                } 

                for (var j = vm.mods.length - 1; j >= 0; j--) {
                    var mod = vm.mods[j];
                    if(authority.module == mod.module){
                        authority.selected = false;
                        mod.authorities.push(authority);
                        break;
                    }
                }
            }
        };
        function clear () {
            $state.go('role', null, {reload: 'role'});
        }
    }
 
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('role', {
                parent: 'entity',
                url: '/role?page&sort&search',
                data: {
                    authorities: ['ROLE_ROLE'],
                    pageTitle: 'backApp.role.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/role/roles.html',
                        controller: 'RoleController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('role-detail', {
                parent: 'role',
                url: '/role/{id}',
                data: {
                    authorities: ['ROLE_ROLE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/role/role-detail.html',
                        controller: 'RoleDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Role','$stateParams', function(Role,$stateParams) {
                        return Role.get({id : $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('role-detail.edit', {
                parent: 'role-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ROLE']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/role/role-dialog.html',
                        controller: 'RoleDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Role', function (Role) {
                                return Role.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('role.new', {
                parent: 'role',
                url: '/new',
                data: {
                    authorities: ['ROLE_ROLE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/role/role-dialog.html',
                        controller: 'RoleDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            data:{
                                name: null,
                                number: null,
                                cancelled: null,
                                id: null,
                                type:null
                            }
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('role.edit', {
                parent: 'role',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ROLE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/role/role-dialog.html',
                        controller: 'RoleDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Role','$stateParams', function(Role,$stateParams) {
                        return Role.get({id : $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('role');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Role', Role)
        .factory('Authority', Authority);

    Role.$inject = ['$resource'];
    Authority.$inject = ['$resource'];

    function Role ($resource) {
        var resourceUrl = 'security/' +  'api/roles/:path/:id';

        return $resource(resourceUrl, {}, {
            'byStore': {
                method: 'POST',
                params: {
                    path: 'byStore'
                }
            },
            'byCondition2': {
                method: 'POST',
                params: {
                    path: 'byCondition2'
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function Authority ($resource) {
        var resourceUrl = 'security/' +  'api/authorities/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('RoleController', RoleController);

    RoleController.$inject = ['$scope', '$state', 'Role', 'ParseLinks',  'pagingParams', 'paginationConstants', 'MessageService','Authority','ListService'];

    function RoleController ($scope, $state, Role, ParseLinks, pagingParams, paginationConstants, MessageService,Authority,ListService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.save = save;
        vm.save2 = save2;
        Authority.getAllByCondition({items:[]},function (res) {
            vm.authorities = res.data;
        });
        vm.role = null;
        vm.mods = [];

        loadAll();

        $scope.delete = function(id,e){
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
            MessageService.confirm("entity.action.deleteConfirm",function(){
                Role.delete({id: id},function () {
                    if(vm.role&&vm.role.id == id){
                        vm.role = null;
                    }
                    loadAll();
                });
            },function(){},true)
        }


        function loadAll () {
            if (pagingParams.search) {
                Role.byCondition2({
                    items: [{key:"name",op:"like",value:pagingParams.search},{key:"type",op:"=",value:"STORE"}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Role.byCondition2({
                    items: [{key:"type",op:"=",value:"STORE"}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.roles = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }

            }
            function onError(error) {
                MessageService.error("角色获取失败");
            }
        }


        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.delbox = function () {
            vm.role = null;
        }

        function save () {
            if(vm.roleName== null || vm.roleName == ""){
                MessageService.error("请输入名称");
                return ;
            }
            var data = {
                name: vm.roleName,
                type: 'STORE',
            }
            vm.isSaving = true;
            Role.byStore(data, onSaveSuccess, onSaveError);
        }
        function save2 () {
            var data = $scope.toPost();
            data.type = 'STORE';
            vm.isSaving = true;
            Role.update(data, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (res) {
            if(res.status == 200){
                $scope.$emit('backApp:roleUpdate', res.data);
                MessageService.success("保存成功！");
                loadAll();
            }else {
                MessageService.error(res.message);
            }
        }

        function onSaveError () {
            vm.isSaving = false;
            MessageService.error("保存失败！");
        }

        $scope.chooseRole = function(role){
            Role.get({id : role.id},function (res) {
                if(res.status==200){
                    vm.role = res.data;
                    $scope.groupBy();
                    setAuthorities();
                }
            })
        }

        function setAuthorities(){
            for (var i = 0; i < vm.role.authorities.length; i++) {
                var au =  vm.role.authorities[i];
                var result = ListService.inList(au, vm.mods, ["module"]);
                if (result) {
                    for (var j = result.authorities.length - 1; j >= 0; j--) {
                        var authority = result.authorities[j];
                        if(authority.id == au.id){
                            authority.selected = true;
                            break;
                        }
                    }
                }
            }

            for (var i = vm.mods.length - 1; i >= 0; i--) {
                var mod = vm.mods[i];
                for (var j = mod.authorities.length - 1; j >= 0; j--) {
                    var au = mod.authorities[j];
                    if (!au.selected) {
                        mod.unAllSelect = true;
                        break;
                    }
                }
                if (mod.unAllSelect) {
                    mod.selected = false;
                }else {
                    mod.selected = true;
                }
            }
            console.log(vm.mods)
        }

        $scope.toPost = function (){
            var postData  ={};
            postData.authorities = [];
            postData.id = vm.role.id;
            postData.name = vm.role.name;
            postData.type = vm.role.type;
            postData.number = vm.role.number;
            postData.cancelled = vm.role.cancelled;
            postData.storeId = vm.role.storeId;
            for (var i = vm.mods.length - 1; i >= 0; i--) {
                var mod = vm.mods[i];
                for (var j = mod.authorities.length - 1; j >= 0; j--) {
                    var au = mod.authorities[j];
                    if (au.selected) {
                        postData.authorities.push(au);
                    }
                }
            }
            return postData;
        };

        $scope.chooseAuthorty = function(mod, au){
            au.selected = !au.selected;
            if (!au.selected) {
                mod.selected = false;
            }
            for (var i = mod.authorities.length - 1; i >= 0; i--) {
                var auth = mod.authorities[i];
                if (!auth.selected) {
                    mod.selected = false;
                    return;
                }
            }
            mod.selected = true;
        }

        $scope.chooseMod = function(mod){
            if (!mod) {
                return;
            }
            mod.selected = !mod.selected;
            for (var i = mod.authorities.length - 1; i >= 0; i--) {
                var au = mod.authorities[i];
                au.selected = mod.selected;
            }
        }

        $scope.groupBy = function(){
            vm.mods = [];
            if(vm.authorities == null || vm.authorities.length == 0 || vm.role.type == null || vm.role.type == ""){
                return null;
            }
            for (var i = vm.authorities.length - 1; i >= 0; i--) {
                var authority = vm.authorities[i];
                if (authority.jhiType != vm.role.type) {
                    continue;
                }
                var e = ListService.inList(authority,vm.mods ,["module"]);
                if(!e){
                    var r = {module:authority.module,authorities:[]};
                    vm.mods.push(r);
                }

                for (var j = vm.mods.length - 1; j >= 0; j--) {
                    var mod = vm.mods[j];
                    if(authority.module == mod.module){
                        authority.selected = false;
                        mod.authorities.push(authority);
                        break;
                    }
                }
            }
        };

        $scope.authoritySelected = function(authority){
            authority.selected = !authority.selected;

        };

    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('RecommendPicDialogController', RecommendPicDialogController);

    RecommendPicDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'RecommendPic', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', '$localStorage'];

    function RecommendPicDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, RecommendPic, MessageService,
        Upload, UidService, ThemeClassify, $localStorage) {
        var vm = this;

        vm.type = entity.state;
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                type: 'RECOMMENDPIC',
                keys: []
            }
        }
        vm.attachments = [];
        vm.imgs = [];
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'RECOMMENDPIC'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                RecommendPic.get({id: entity.data.id},function (res) {
                    if(res.status==200){
                        vm.data = res.data;
                    }else{
                        MessageService.error(res.message);
                        return
                    }
                });
            }

        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "recommendPic-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }
        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            vm.data.keys.splice(index,1);
        };

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择推荐分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(entity.state == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择图片");
                    return
                }
            }
            console.log(vm.data)
            vm.isSaving = true;
            if (vm.data.id != null) {
                RecommendPic.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                RecommendPic.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                MessageService.success("推荐图片保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            };

            function onSaveError () {
                MessageService.error("推荐图片保存失败");
                vm.isSaving = false;
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('recommend-pic', {
            parent: 'entity',
            url: '/recommend-pic?page&sort&search&themeClassifyId',
            data: {
                authorities: ["ROLE_CLIPART"],
                pageTitle: 'backApp.title.recommend-pic'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/recommend-pic/recommend-pic.html',
                    controller: 'RecommendPicController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        themeClassifyId: $stateParams.themeClassifyId,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('RecommendPic', RecommendPic);

    RecommendPic.$inject = ['$resource'];

    function RecommendPic ($resource) {
        var resourceUrl =  'manager/' + 'api/recommend-pics/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "batchCreateByStore":{
                method:"GET",
                params:{
                    path:"batchCreateByStore"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "save":{
                method:"POST",
                params:{
                    path:"save"
                }
            },
            "delete":{
                method:"DELETE",
            },
            'update': {
                method:'PUT',
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('RecommendPicController', RecommendPicController);

    RecommendPicController.$inject = ['$scope', '$q', '$state', 'RecommendPic', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', '$uibModal', '$localStorage', 'ThemeClassify'];

    function RecommendPicController ($scope, $q, $state, RecommendPic, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, $uibModal, $localStorage, ThemeClassify) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 44;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.themeClassifyId = Number(pagingParams.themeClassifyId);
        vm.jump = jump;
        vm.storeId = JSON.parse(localStorage.getItem('back-user')).storeId;
        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        vm.class =  ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'RECOMMENDPIC'}]});
        $q.all([vm.domains.$promise , vm.class.$promise]).then(function(){
            vm.class = vm.class.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        function loadAll () {
            var items = [];
            if (pagingParams.search) {
                items.push({key:"name,themeClassify.name",op:"like",value:pagingParams.search});
            }
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",op:"=",value:vm.themeClassifyId});
            }
            RecommendPic.byCondition2({
                items:items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.data = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("推荐图片获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                themeClassifyId:vm.themeClassifyId,
                
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/recommend-pic/recommend-pic-dialog.html',
                controller: 'RecommendPicDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add'
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.edit = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/recommend-pic/recommend-pic-dialog.html',
                controller: 'RecommendPicDialogController',
                controllerAs: 'vm',
                windowClass:'modal-right',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'edit',
                            data: data
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/recommend-pic/recommend-pic-dialog.html',
                controller: 'RecommendPicDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'look',
                            data: data
                        };
                    }]
                }
            });
        }
        $scope.delete = function(id){
            MessageService.confirm("确认删除该数据？",function(){
                RecommendPic.delete({id: id},function (res) {
                    loadAll();
                });
            },function(){});
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyDialogCommercialController', PropertyDialogCommercialController);

    PropertyDialogCommercialController.$inject = ['$timeout', '$scope', '$state', '$filter', 'entity', 'Property', 'MessageService','$uibModal', 'Qinius', 'UidService','Process'];

    function PropertyDialogCommercialController ($timeout, $scope, $state, $filter, entity, Property, MessageService,$uibModal, Qinius, UidService,Process ) {
        var vm = this;

        vm.domains = Qinius.getDomain();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.processOperationList = []
        vm.domains.$promise.then(function () {
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        });
        vm.allTableList = []
        vm.delTableList = []
        loadAll();
        vm.showAddBtn = false

        function loadAll() {
            Process.query({
                page: 0,
                size: 20,
                // sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                var responseData = data.data || [];
                vm.processOperationList = responseData
                if(vm.property.process && vm.property.processOperationId){
                    vm.allTableList = responseData.find(function(item){
                        return item.id == vm.property.processOperationId
                    }).operationValues || []
                }
                var _propertyValues = vm.property.propertyValues.filter(function(itm){return !itm.cancelled})
                vm.delTableList = vm.property.propertyValues.filter(function(itm){return itm.cancelled})
                if(_propertyValues.length < vm.allTableList.length){
                    vm.showAddBtn = true
                }
            }

            function onError(error) {
            }
        }

        vm.property = entity.data;
        vm.title = "platformApp.property.edit"
        if(!vm.property.id){
            vm.property.propertyType = 'Default';
            vm.title = "platformApp.property.create"
        }

        vm.clear = clear;
        vm.save = save;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go('propertyCommercial', null, { reload: 'property' });
        }
        $scope.processEnableChange = function(){
            var arr = vm.property.propertyValues;
            for (var i = arr.length - 1; i >= 0; i--) {
                var item = arr[i];
                if (item.id == null) {
                    arr.splice(i, 1);
                } else {
                    item.cancelled = true;
                }
            }
            if(!vm.property.process){
                vm.property.processOperationId = null
            }
        }
        $scope.processOperationChange = function(){
            var arr = vm.property.propertyValues;
            for (var i = arr.length - 1; i >= 0; i--) {
                var item = arr[i];
                if (item.id == null) {
                    arr.splice(i, 1);
                } else {
                    item.cancelled = true;
                }
            }

            if(vm.property.processOperationId){
                var currentProcess = vm.processOperationList.find(function(item){
                    return item.id == vm.property.processOperationId
                }) || {operationValues:[]}
                currentProcess.operationValues.forEach(function(itm){
                    var value = {id:null,value:itm.alias,cancelled:false,added:true,uuid:UidService.get(),operationValueId:itm.id,spotColor:itm.spotColor,color:itm.color}
                    if (vm.property.propertyValues == null) {
                        vm.property.propertyValues = [];
                    }
                    vm.property.propertyValues.push(value);
                })
            }
            vm.delTableList = []
            vm.showAddBtn = false
        }
        $scope.validate = function(){
            if(vm.property.name == null || vm.property.name==""){
                MessageService.error($filter('translate')('platformApp.property.proNamePlaceholder'));
                return false;
            }
            return true;
        };

        $scope.addValue = function(){
            if(!$scope.validate()){
                return;
            }
            if(vm.showAddBtn){
                var currentProcessOperation = vm.processOperationList.find(function(item){
                    return item.id == vm.property.processOperationId
                }) || {operationValues: []}
                var delTableList = []
                var operationValues = currentProcessOperation.operationValues || []
                var propertyValues = vm.property.propertyValues || []
                operationValues.forEach(function(operationValue){
                    var exists = propertyValues.some(function(propertyValue){
                        return !propertyValue.cancelled && propertyValue.operationValueId == operationValue.id
                    })
                    if (!exists) {
                        var deletedValue = propertyValues.find(function(propertyValue){
                            return propertyValue.cancelled && propertyValue.operationValueId == operationValue.id
                        })
                        if (deletedValue) {
                            delTableList.push(deletedValue)
                        } else {
                            delTableList.push({id:null,value:operationValue.alias,cancelled:false,added:true,uuid:UidService.get(),operationValueId:operationValue.id,spotColor:operationValue.spotColor,color:operationValue.color})
                        }
                    }
                })
                vm.delTableList = delTableList

                $uibModal.open({
                    templateUrl: 'app/entities/property-commercial/add-property-value.html',
                    controller: 'AddPropertyValueController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'mg',
                    resolve: {
                        msgdata: function() {
                            return {
                                delTableList: delTableList
                            }
                        }
                    }
                }).result.then(function(selectedItems){
                    angular.forEach(selectedItems, function(selectedItem) {
                        var found = false;
                        for (var i = 0; i < vm.property.propertyValues.length; i++) {
                            if (vm.property.propertyValues[i].id === selectedItem.id) {
                                vm.property.propertyValues[i].img = '';
                                vm.property.propertyValues[i].cancelled = false;
                                found = true;
                                break;
                            }
                        }
                        if (!found && selectedItem.operationValueId != null) {
                            var currentProcessOperation = vm.processOperationList.find(function(item){
                                return item.id == vm.property.processOperationId
                            }) || {operationValues: []}
                            var operationValues = currentProcessOperation.operationValues || []
                            var matchedOperationValue = operationValues.find(function(operationValue){
                                return operationValue.id == selectedItem.operationValueId
                            })
                            if (matchedOperationValue) {
                                if (vm.property.propertyValues == null) {
                                    vm.property.propertyValues = [];
                                }
                                vm.property.propertyValues.push({
                                    id: null,
                                    value: matchedOperationValue.alias,
                                    cancelled: false,
                                    added: true,
                                    uuid: UidService.get(),
                                    operationValueId: matchedOperationValue.id,
                                    spotColor: matchedOperationValue.spotColor,
                                    color: matchedOperationValue.color
                                });
                            }
                        }
                        for (var j = vm.delTableList.length - 1; j >= 0; j--) {
                            if (vm.delTableList[j].id === selectedItem.id) {
                                vm.delTableList.splice(j, 1);
                                break;
                            }
                        }
                    });
                    if(vm.delTableList.length === 0){
                        vm.showAddBtn = false;
                    }
                });
            }else{
                var value = {id:null,value:null,cancelled:false,added:true,uuid:UidService.get()}
                if (vm.property.propertyValues == null) {
                    vm.property.propertyValues = [];
                }
                vm.property.propertyValues.push(value);
            }
        };

        $scope.deleteValue = function(value){
            if(value == null || vm.property.propertyValues == null || vm.property.propertyValues.length == 0){
                return;
            }
            if(value.id==null){
                var inde1 = vm.property.propertyValues.indexOf(value);
                vm.property.propertyValues.splice(inde1,1);
            }else{
                value.cancelled = true;
            }

            if(vm.property.process && vm.property.processOperationId){
                value.processOperationId = vm.property.processOperationId
                vm.delTableList.push(value)
                vm.showAddBtn = true
            }
        };

        $scope.removeFile2 = function (value) {
            value.img = null;
        };

        window.xmlLineImgFile = function ($event) {
            var file = $event.target.files[0];
            var uploadValue = vm.uploadTarget;
            if (!file || !uploadValue) {
                return;
            }
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "property-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    $timeout(function () {
                        var domain = ($scope.domain && $scope.domain !== 'undefined') ? $scope.domain : 'https://' + (vm.domains.domains && vm.domains.domains[0] || '') + '/';
                        uploadValue.img = domain + data.key;
                    });
                },
                error: function (request) {
                    $timeout(function () {
                        MessageService.error($filter('translate')('platformApp.property.fileUploadFail'));
                    });
                }
            });
        };

        $scope.goToReadImage = function (pic) {
            $('body').css("overflow", "hidden");
            $(".origin-image-dialog").removeClass('hide1');
            $(".dialog-form").addClass('opacity-zero');
            $(".origin-image-dialog img").attr('src', pic);
            $(".modal-content,.modal-dialog").addClass('clear-model');
        };

        vm.multilingual = function (data, item,fieldName, index) {
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:index>=0 ? vm.property.propertyValues[index][data] : vm.property[data],
                            key: item,
                            fieldValue: index>=0 ? vm.property.propertyValues[index][item] : vm.property[item],
                            fieldName: fieldName
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    if(index>=0){
                        vm.property.propertyValues[index][data] = res;
                    }else{
                        vm.property[data] = res;
                    }
                }
            });
        }


        function save() {
            var isValueNull = false
            for(var i=0;i<vm.property.propertyValues.length;i++){
                var v = vm.property.propertyValues[i];
                if(v.value==null||v.value==''){
                    MessageService.error($filter('translate')('platformApp.property.proValueListPlaceholder'));
                    isValueNull = true
                    break
                }
            }
            if(isValueNull){
                return false;
            }
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if (vm.property.id !== null) {
                Property.update(vm.property, onSaveSuccess, onSaveError);
            } else {
                Property.save(vm.property, onSaveSuccess, onSaveError);
            }
        };

        function onSaveSuccess (res) {
            if(res.status==200){
                $scope.$emit('backApp:propertyUpdate', res.data);
                $state.go('propertyCommercial', null, { reload: 'property' });
                vm.isSaving = false;
                MessageService.success($filter('translate')('platformApp.property.saveSuccess'));
            }else{
                MessageService.error(res.message);
            }

        }

        function onSaveError () {
            MessageService.error($filter('translate')('platformApp.property.saveFail'));
            vm.isSaving = false;
        }


        window.addPropertys=function(event){
            var e = event || window.event;
            if(e && e.keyCode==13){ // enter 键
                var value = {id:null,value:e.target.value,cancelled:false,added:true,uuid:UidService.get()};
                if (vm.property.propertyValues == null) {
                    vm.property.propertyValues = [];
                }
                vm.property.propertyValues.push(value);
                $("#field_value").val('');
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('propertyCommercial', {
            parent: 'entity',
            url: '/propertyCommercial?page&sort&search',
            data: {
                authorities: ["ROLE_PROPERTY"],
                pageTitle: 'global.menu.entities.commoditySpecification'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/property-commercial/properties.html',
                    controller: 'PropertyCommercialController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propertys');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('propertyDetailCommercial', {
            parent: 'propertyCommercial',
            url: '/detail/{id}',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/property-commercial/property-dialog.html',
                    controller: 'PropertyDialogCommercialController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Property', function(Property) {
                            return Property.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propertyCommercialNew', {
            parent: 'propertyCommercial',
            url: '/new',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/property-commercial/property-dialog.html',
                    controller: 'PropertyDialogCommercialController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propertys');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        data:{
                            propertyLanguages:[],
                            propertyValues:[],
                            name: null,
                            cancelled: null,
                            id: null
                        }
                    };
                }
            }
        })
        .state('propertyCommercialEdit', {
            parent: 'propertyCommercial',
            url: '/edit/{id}',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/property-commercial/property-dialog.html',
                    controller: 'PropertyDialogCommercialController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propertys');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Property','$stateParams', function(Property,$stateParams) {
                    return Property.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('backApp')
        .factory('Property', Property);

    Property.$inject = ['$resource'];

    function Property($resource) {
        var resourceUrl = 'manager/' + 'api/properties/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'query': {method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyCommercialController', PropertyCommercialController);

    PropertyCommercialController.$inject = ['$scope', '$state', 'Property', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', '$localStorage'];

    function PropertyCommercialController ($scope, $state, Property, ParseLinks, paginationConstants, pagingParams, MessageService, $localStorage) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                Property.byCondition({
                    items: [{key:"name,alias",op:"like",value:pagingParams.search},{key: "storeId", op: "=", value: $localStorage.user.storeId}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Property.byCondition({
                    items: [{key: "storeId", op: "=", value: $localStorage.user.storeId}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.properties = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }

            }
            function onError(error) {
                MessageService.error("属性获取失败");
            }
        }

        $scope.delete = function(id){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                Property.delete({id: id},function (res) {
                    if(res.status == 200){
                        loadAll();
                    }else{
                        MessageService.error(res.message);
                    }
                });
            },function(){},true);
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0  ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.batchArr = [];
        $scope.selectOne = false;
        $scope.selectAll = false;

        $scope.chooseAll = function () {
            $scope.selectAll = !$scope.selectAll;
            $scope.batchArr = [];
            angular.forEach(vm.properties,function (property,i) {
                if($scope.selectAll){
                    property.select = true;
                    $scope.batchArr.push(property.id);
                    $scope.selectOne = true;
                }else{
                    property.select = false;
                    $scope.selectOne = false;
                }
            })
        }

        $scope.chooseOne = function (property) {
            property.select = !property.select;
            // 选中
            if(property.select){
                $scope.batchArr.push(property.id);
            }else{
                // 未选中
                var ind = $scope.batchArr.indexOf(property.id);
                if (ind >= 0) {
                    $scope.batchArr.splice(ind, 1);
                }
            }

            // 判断全选按钮
            var flag = true;
            angular.forEach(vm.properties,function (property,i) {
                if(!property.select){
                    $scope.selectAll = false;
                    flag = false;
                }
                // 全部选中
                if(i==vm.properties.length-1&&flag){
                    $scope.selectAll = true;
                }
            })

            // 批量按钮的显示
            if($scope.batchArr.length){
                $scope.selectOne = true;
            }else {
                $scope.selectOne = false;
            }
        }

        $scope.deleteBatch = function () {
            MessageService.confirm("entity.action.deleteConfirm",function(){
                Property.deleteBatch({ids: $scope.batchArr},function (res) {
                    if(res.status == 200){
                        MessageService.success("删除成功");
                        $scope.selectOne = false;
                        $scope.selectAll = false;
                        loadAll();
                    }else{
                        MessageService.error(res.message);
                    }
                    
                },function () {
                    MessageService.error("删除失败");
                })
            },function(){},true);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('AddPropertyValueController', AddPropertyValueController);

    AddPropertyValueController.$inject = ['$scope', '$uibModalInstance', 'msgdata'];

    function AddPropertyValueController($scope, $uibModalInstance, msgdata) {
        var vm = this;
        vm.save = save;
        vm.toggleAll = toggleAll;
        vm.toggleItem = toggleItem;
        vm.allChecked = false;

        vm.delList = angular.copy(msgdata.delTableList);
        angular.forEach(vm.delList, function(item) {
            item.selected = false;
        });

        function toggleAll() {
            vm.allChecked = !vm.allChecked;
            angular.forEach(vm.delList, function(item) {
                item.selected = vm.allChecked;
            });
        }

        function toggleItem(item) {
            item.selected = !item.selected;
            var allSelected = vm.delList.length > 0;
            angular.forEach(vm.delList, function(itm) {
                if (!itm.selected) {
                    allSelected = false;
                }
            });
            vm.allChecked = allSelected;
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss();
        };

        function save() {
            var selectedItems = [];
            angular.forEach(vm.delList, function(item) {
                if (item.selected) {
                    selectedItems.push(item);
                }
            });
            $uibModalInstance.close(selectedItems);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyDialogController', PropertyDialogController);

    PropertyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Property', 'MessageService'];

    function PropertyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Property, MessageService ) {
        var vm = this;

        vm.property = entity;
        vm.clear = clear;
        // vm.save = save;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function(){
            if(vm.property.name == null || vm.property.name==""){
                MessageService.error("请输入属性名称");
                return false;
            }
            return true;
        };

        $scope.addValue = function(){
            var value = {id:null,value:null,cancelled:false,added:true}
            if (vm.property.propertyValues == null) {
                vm.property.propertyValues = [];
            }
            vm.property.propertyValues.push(value);
        };

        $scope.deleteValue = function(value){
            if(value == null || vm.property.propertyValues == null || vm.property.propertyValues.length == 0){
                return;
            }
            if(value.added){
                var inde1 = vm.property.propertyValues.indexOf(value);
                vm.property.propertyValues.splice(inde1,1);
            }else{
                value.cancelled= true;
            }
        };


        window.save = function() {
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if (vm.property.id !== null) {
                Property.update(vm.property, onSaveSuccess, onSaveError);
            } else {
                Property.save(vm.property, onSaveSuccess, onSaveError);
            }
        };

        function onSaveSuccess (result) {
            $scope.$emit('backApp:propertyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            MessageService.success("保存成功");
        }

        function onSaveError () {
            MessageService.error("保存失败");
            vm.isSaving = false;
        }


        window.addPropertys=function(event){
            var e = event || window.event;
            if(e && e.keyCode==13){ // enter 键
                var value = {id:null,value:e.target.value,cancelled:false,added:true};
                if (vm.property.propertyValues == null) {
                    vm.property.propertyValues = [];
                }
                vm.property.propertyValues.push(value);
                $("#field_value").val('');
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyDetailController', PropertyDetailController);

    PropertyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'Property', '$timeout'];

    function PropertyDetailController($scope, $rootScope, $stateParams, $uibModalInstance, entity, Property, $timeout) {
        var vm = this;

        vm.property = entity; 
        vm.clear = clear; 

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        var unsubscribe = $rootScope.$on('backApp:propertyUpdate', function(event, result) {
            vm.property = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyDeleteController',PropertyDeleteController);

    PropertyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Property'];

    function PropertyDeleteController($uibModalInstance, entity, Property) {
        var vm = this;

        vm.property = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Property.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('property', {
            parent: 'entity',
            url: '/property?page&sort&search',
            data: {
                authorities: ["ROLE_PROPERTY"],
                pageTitle: 'backApp.property.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/property/properties.html',
                    controller: 'PropertyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('property');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('property-detail', {
                parent: 'property',
                url: '/property/{id}',
                data: {
                    authorities: ["ROLE_PROPERTY"]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/property/property-detail.html',
                        controller: 'PropertyDetailController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('property');
                                return $translate.refresh();
                            }],
                            entity: ['Property', function(Property) {
                                return Property.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('property', {}, {
                            reload: false
                        });
                    }, function() {
                        $state.go('property');
                    });
                }]
            })
        .state('property-detail.edit', {
            parent: 'property-detail',
            url: '/detail/edit',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/property/property-dialog.html',
                    controller: 'PropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Property', function(Property) {
                            return Property.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('property.new', {
            parent: 'property',
            url: '/new',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/property/property-dialog.html',
                    controller: 'PropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                cancelled: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('property', null, { reload: 'property' });
                }, function() {
                    $state.go('property');
                });
            }]
        })
        .state('property.edit', {
            parent: 'property',
            url: '/{id}/edit',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/property/property-dialog.html',
                    controller: 'PropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Property', function(Property) {
                            return Property.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('property', null, { reload: 'property' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('property.delete', {
            parent: 'property',
            url: '/{id}/delete',
            data: {
                authorities: ["ROLE_PROPERTY"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/property/property-delete-dialog.html',
                    controller: 'PropertyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Property', function(Property) {
                            return Property.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('property', null, { reload: 'property' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Property', Property);

    Property.$inject = ['$resource'];

    function Property ($resource) {
        var resourceUrl =  'manager/' + 'api/properties/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyController', PropertyController);

    PropertyController.$inject = ['$scope', '$state', 'Property', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService'];

    function PropertyController ($scope, $state, Property, ParseLinks, paginationConstants, pagingParams, MessageService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                Property.byCondition({
                    items: [{key:"name,alias",op:"like",value:pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Property.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.properties = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                MessageService.error("属性获取失败");
            }
        }

        $scope.delete = function(id){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                Property.delete({id: id},function () {
                    loadAll();
                });
            },function(){},true);
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0  ? 1 : vm.jumpText;
            loadPage(vm.page);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('UpdateProductXmlController', UpdateProductXmlController);

    UpdateProductXmlController.$inject = ['$state', '$scope', 'ParseLinks', 'MessageService', 'paginationConstants', '$uibModal', 'pagingParams',
        'Qinius', 'ProductXmls', 'ProductXmlFileServes', '$localStorage', 'Store', 'Principal','$uibModalInstance','xmlId'];

    function UpdateProductXmlController($state, $scope, ParseLinks, MessageService, paginationConstants, $uibModal, pagingParams,
                                        Qinius, ProductXmls, ProductXmlFileServes, $localStorage, Store, Principal,$uibModalInstance,xmlId) {

        var vm = this;
        $scope.selectAll = false;
        vm.clear = clear;
        vm.productXmls = [];
        vm.xml = xmlId;


        loadAll()
        function loadAll() {
            $scope.batchArr =[];
            ProductXmls.getAllByCondition({
                items: [{key: "id", op: "!=", value: vm.xml.id},
                    {key: "storeId", op: "=", value: $localStorage.user.storeId},
                    {key: "sourceId", op: "=", value: vm.xml.sourceId},
                    {key: "status", op: "=", value: "Approved"}],
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                return ['id,desc'];
            }

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.productXmls = data.data;
            }

            function onError(error) {
                MessageService.error("数据加载出错");
            }
        }
        $scope.afterXml = null;
        // $scope.chooseAll = function() {
        //     $scope.selectAll = !$scope.selectAll;
        //     $scope.batchArr = [];
        //     angular.forEach(vm.productXmls, function(xml, i) {
        //         if ($scope.selectAll) {
        //             xml.select = true;
        //             $scope.batchArr.push(xml);
        //         } else {
        //             $scope.batchArr = [];
        //             xml.select = false;
        //         }
        //     });
        // }

        $scope.chooseOne = function (xml) {
           if ($scope.afterXml != null){
               $scope.afterXml.select = false;
           }
            xml.select = !xml.select;
            // 选中
            if(xml.select){
                $scope.afterXml = xml;
            }else{
                // 未选中
                $scope.afterXml = null;
            }

            // 判断全选按钮
            // var flag = true;
            // angular.forEach(vm.productXmls,function (xml,i) {
            //     if(!xml.select){
            //         $scope.selectAll = false;
            //         flag = false;
            //     }
            //     // 全部选中
            //     if(i==vm.productXmls.length-1&&flag){
            //         $scope.selectAll = true;
            //     }
            // });
        }

        $scope.confirm= function (){
            if ($scope.afterXml != null){
                var afterId = $scope.afterXml.id;
                var beforeId = vm.xml.id;
                ProductXmls.updateProductXml({beforeId:beforeId, afterId:afterId},function (data){
                    $uibModalInstance.close(data);
                    MessageService.success("保存成功");
                },function(){
                    MessageService.error("保存失败");
                })
            }else {
                MessageService.error("请选择同源模板后确认更新");
            }
        }

        $('.modal-body-scroll1').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(vm.productXmls.length < vm.totalItems){
                if((event.currentTarget.scrollHeight-2)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+2)){
                    vm.page++;
                    loadAll()
                }
            }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductXmlVersionController', ProductXmlVersionController);
    ProductXmlVersionController.$inject = ['$scope', '$uibModalInstance', 'MessageService', 'ProductXmls1','xmlId','$timeout'];

    function ProductXmlVersionController( $scope, $uibModalInstance, MessageService, ProductXmls1,xmlId, $timeout) {
        var vm = this;
        vm.productXmlId = xmlId;
        vm.isCover = true;
        vm.productList = [
            {name:'照片书', id:'BOOK',},
            {name:'冲印', id:'PHOTO',},
            {name:'台历', id:'CALENDAR'},
            {name:'万物',id:'THING'},
        ];
        init()
        function init(){
            ProductXmls1.get({id: vm.productXmlId}, function (resp) {
                vm.pages = resp.data.document.pages.page;
                $timeout(function(){
                    swiper();
                })
            })
        }
        vm.productSeq=0;
        $scope.productCb = function(index){
            vm.productSeq=index;
        };
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };
        vm.save = function () {
            var data ={
                id:vm.productXmlId,
                productType:vm.productList[vm.productSeq].id
            };
            if (vm.productList[vm.productSeq].id == 'BOOK' && vm.isCover) {
                data.patternType = 'BOOK';
            }
            ProductXmls1.upgradeProductXml(data,function (res) {
                if(res.status == 200){
                    MessageService.success("模板升级成功");
                    $uibModalInstance.close(true);
                }else{
                    MessageService.error(res.message || "模板升级失败，请稍后重试");
                    $uibModalInstance.close(false);
                }
            },function (error) {
                MessageService.error(error.data.message || "模板升级失败，请稍后重试");
                $uibModalInstance.close(false);
            })
        }

        function swiper() {
            var swiper = new Swiper('.swiper-container', {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductXmlSimpleController', ProductXmlSimpleController);

    ProductXmlSimpleController.$inject = ['$timeout', '$rootScope', '$scope', '$state', '$uibModalInstance', '$q', 'entity', 'MessageService', 'ProductXmls', 'Qinius',
    'UidService', 'Vert'];

    function ProductXmlSimpleController($timeout, $rootScope, $scope, $state, $uibModalInstance, $q, entity, MessageService, ProductXmls, Qinius,
        UidService, Vert) {
        var vm = this;
        vm.productXml = entity;
        vm.clear = clear;
        vm.showPicCheck = showPicCheck;

        function showPicCheck(show){
            vm.productXml.showPic = show;
        }

        $scope.load = function() {
            if (vm.productXml.documentPics == null) {
                vm.productXml.documentPics = [];
            }
            Vert.xmlToDocument({
                identifier: vm.productXml.identifier
            }, function(res) {
                if (res && res.documentpics && res.documentpics.documentpic) {
                    for (var i = res.documentpics.documentpic.length - 1; i >= 0; i--) {
                        var breakBoolean = false;
                        var pic = res.documentpics.documentpic[i];
                        if (pic.resource == null || !pic.resource.identifier) {
                            continue;
                        }
                        for (var j = vm.productXml.documentPics.length - 1; j >= 0; j--) {
                            var orPic = vm.productXml.documentPics[j];
                            if (orPic.cancelled || orPic.deleted) {
                                continue;
                            }
                            if (orPic.seq == pic.seq && orPic.identifier == pic.resource.identifier) {
                                breakBoolean = true;
                                break;
                            }
                        }
                        if (!breakBoolean) {
                            vm.productXml.documentPics.push({
                                seq: pic.seq,
                                identifier: pic.resource.identifier,
                                provider: "Qiniu",
                                added: true
                            });
                        }
                    }
                    vm.productXml.documentPics.sort(function(a, b) {
                        return a.seq - b.seq;
                    });
                    MessageService.info("重载成功");
                }
            });
        }


        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise, vm.productXml.$promise]).then(function(){
            vm.productXml = vm.productXml.data; 
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            vm.productXml.documentPics.sort(function(a, b){
                return a.seq- b.seq;
            })
        });

        $scope.deletePic = function(pic){
            if (pic == null) {
                return;
            }
            if (pic.added) {
                var inde =vm.productXml.documentPics.indexOf(pic);
                if (inde>=0) {
                    vm.productXml.documentPics.splice(inde, 1);
                }
            }else{
                pic.deleted = true;
            }
        };

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        function qiniuUpload(files) {
            var result = [];
            for (var i = files.length - 1; i >= 0; i--) {
                var file = files[i];
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "file" + file.name + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        result.push({ key:data.key})
                        if (result.length == files.length) {
                            result.sort(function(a, b){
                                return a.key.localeCompare(b.key);
                            })
                            if (vm.productXml.documentPics == null) {
                                vm.productXml.documentPics = [];
                            }
                            for (var j = 0 ; j< result.length ; j++) {
                                var seq = vm.productXml.documentPics.length+1;
                                var r = result[j];
                                vm.productXml.documentPics.push({
                                    name:r.key,
                                    seq:seq,
                                    identifier: $scope.domain + r.key,
                                    provider:"Qiniu",
                                    added: true
                                });
                            }
                            $scope.$apply();
                        }

                    },
                    error: function (request) {
                        MessageService.error("图片上传失败");
                    }
                });
            }

        }

        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files !=null && files.length >0) {
            //    qiniuUpload(files);
                var isSort = true;
                var arr = [];
                for (var i = 0; i< files.length  ; i++) {
                    var f = files[i];
                    arr.push(files[i])
                    var name = f.name.substring(0,f.name.indexOf('.'));
                    if (/^[\d\-]+$/.test(name)) {
                        files[i].name1 = name.replace('-','')
                    }else{
                        isSort = false;
                    }
                }
                if (isSort) {
                    arr.sort(function(a,b){
                        return a.name1 - b.name1
                    })
                }
                qiniuUpload(arr);
            }
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('editorApp:productXmlUpdate', function(event, result) {
            vm.productXml = result;
        });

        $scope.$on('$destroy', unsubscribe);

        $scope.save = function(){
            ProductXmls.showPic(vm.productXml, function(res){
                if(res.status == 200){
                    $scope.$emit('editorApp:productXmlUpdate', res.data);
                    $uibModalInstance.close(res.data);
                    MessageService.success("保存成功");
                }else {
                    MessageService.error(res.message);
                }
            },function(){
                MessageService.error("保存失败");
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductXmlCancelArticleController', ProductXmlCancelArticleController);
    ProductXmlCancelArticleController.$inject = ['$scope','Article', '$uibModalInstance', 'MessageService','xmlId', '$q', '$uibModal'];

    function ProductXmlCancelArticleController($scope, Article, $uibModalInstance, MessageService, xmlId,  $q, $uibModal) {
        //编辑第三方的模板 弹出窗口

        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.xmlId = xmlId;
        
        $q.all([ ]).then(function () {
        });
         
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            Article.invalidByProductXmlId({productXmlId:vm.xmlId}, function () {
                MessageService.success("作废成功");
                $uibModalInstance.close();
            }, function(){
                MessageService.error("作废失败");
            });
        }
 
    }

})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductXmlBatchEditController', ProductXmlBatchEditController);
    ProductXmlBatchEditController.$inject = ['$scope', 'Category', 'UidService', '$uibModalInstance', 'MessageService', '$stateParams', 'ProductXmls',
        'ThemeClassify', 'Store', 'entity',   '$q', '$uibModal', '$localStorage'];

    function ProductXmlBatchEditController($scope, Category, UidService, $uibModalInstance, MessageService, $stateParams, ProductXmls,
                                         ThemeClassify, Store, entity,  $q, $uibModal, $localStorage) {
        //编辑第三方的模板 弹出窗口

        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.ids = entity;
        
        $q.all([ ]).then(function () {
        });
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'XML'},{key: "storeId", op: "=", value: $localStorage.user.storeId}]},function (res) {
            if(res.status == 200){
                vm.themeClassifyList = res.data;
            }else {
                MessageService.error(res.message);
            }
        });

        Category.storeGetAllByCondition({items: [{key: "usable", op: "=", value: "true"}]},function (res) {
            if(res.status == 200){
                vm.categories = res.data;
            }else {
                MessageService.error(res.message);
            }
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            if (vm.categoryId == null || vm.categoryId == "") {
                MessageService.error("请选择分类");
                return false;
            }
            if (vm.themeId == null || vm.themeId == "") {
                MessageService.error("请选择模板分类");
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            ProductXmls.batchEdit({ids:vm.ids, categoryId:vm.categoryId, themeId:vm.themeId, 
                type:"Currency" } , function (res) {
                if (res.status == 200) {
                    MessageService.success("保存成功");
                    $uibModalInstance.close(res.data);
                } else {
                    MessageService.error(res.message);
                }
            }, function () {
                MessageService.error("保存失败");
            });
        }

        

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
 
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-xml', {
            parent: 'entity',
            url: '/product-xml?page&sort&search',
            data: {
                authorities: ["ROLE_PRODUCT_XML"],
                pageTitle: 'global.menu.entities.productXml'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-xml/product-xmls.html',
                    controller: 'ProductXmlController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };0
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('page');
                    $translatePartialLoader.addPart('productXml');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('reprintType');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-xml-simple', {
                parent: 'product-xml',
                url: '/{id}/product-xml-simple',
                data: {
                    authorities: ["ROLE_PRODUCT_XML"]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product-xml/product-xml-simple.html',
                        controller: 'ProductXmlSimpleController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowClass:'modal-right',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('productXml');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: ['ProductXmls', function(ProductXmls) {
                                return ProductXmls.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                     }).result.then(function() {
                        $state.go('product-xml', null, { reload: 'product-xml' });
                    }, function() {
                        $state.go('product-xml', null, { reload: 'product-xml' });
                    });
                }]
            })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Article', Article)
        .factory('ProductXmls', ProductXmls)
        .factory('ProductXmls1', ProductXmls1);

    Article.$inject = ['$resource'];
    ProductXmls.$inject = ['$resource'];
    ProductXmls1.$inject = ['$resource'];

     function Article ($resource) {
        var resourceUrl =  'service/' + 'api/articles/:path/:id';
        return $resource(resourceUrl, {}, {
            "invalidByProductXmlId":{
                method:"GET",
                params:{
                    path:"invalidByProductXmlId"
                }
            }
        });
    }
    
    function ProductXmls ($resource) {
        var resourceUrl =  'manager/' + 'api/product-xmls/:path/:id';
        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
             "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "showPic":{
                method:"POST",
                params:{
                    path:"showPic"
                }
            },
            "approve":{
                method:"GET",
                params:{
                    path:"approve"
                }
            },
            "themeClassify":{
                method:"GET",
                params:{
                    path:"saveTheme"
                }
            },
            "batchApprove":{
                method:"GET",
                params:{
                    path:"batchApprove"
                }
            },
            "batchEdit":{
                method:"GET",
                params:{
                    path:"batchEdit"
                }
            },
            "batchDelete":{
                method:"GET",
                params:{
                    path:"batchDelete"
                }
            },
            'update': { method:'PUT' },
            "updateProductXml":{
                method:"GET",
                params:{
                    path:"updateSourceModel",
                },
            },
        });

    }
    function ProductXmls1 ($resource) {
        var resourceUrl =  'fileserves/' + 'api/product-xmls/:path/:id';
        return $resource(resourceUrl, {}, {
            "upgradeProductXml":{
                method:"GET",
                params:{
                    path:"upgradeProductXml"
                }
            }
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductXmlController', ProductXmlController);

    ProductXmlController.$inject = ['$state', '$scope', 'ParseLinks', 'MessageService', 'paginationConstants', '$uibModal', 'pagingParams',
    'Qinius', 'ProductXmls', 'ProductXmlFileServes', '$localStorage', 'Store', 'Article'];

    function ProductXmlController($state, $scope, ParseLinks, MessageService, paginationConstants, $uibModal, pagingParams,
        Qinius, ProductXmls, ProductXmlFileServes, $localStorage, Store, Article) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.jump = jump;
        vm.clear = clear;
        vm.search = search;

        $scope.canEdit = false;
        $scope.canApprove = false;
        $scope.canCancel = false;

        $scope.confirmName = function (id) {
             createModal('app/entities/page/pagesmySuffix-save2.html', 'PageMySuffixSave2Controller', id).result.then(function () {
                 loadAll();
             });
        };

        $scope.updateProductXmls = function (xml){
            createModal1('app/entities/product-xml/update-product-xml.html','UpdateProductXmlController',xml).result.then(function () {
                loadAll();
            });
        }

        var createModal = function (url, controller, id) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                // windowClass: "jh-modal-md",
                windowClass:'modal-right',
                controllerAs: 'vm',
                resolve: {
                    xmlId:id,
                    pageIndex:vm.page,
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };

        var createModal1 = function (url, controller, id) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                controllerAs: 'vm',
                resolve: {
                    xmlId:id,
                    pageIndex:vm.page,
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };


        $scope.cancelArticle = function (id) {
            MessageService.confirm("是否确认作废当前时间之前的所有作品？<br/>注:用户的作品被作废将失效无法制作，重新制作的作品正常编辑下单。", function () {
                Article.invalidByProductXmlId({productXmlId:id}, function () {
                    loadAll();
                    MessageService.success("操作成功");
                }, function(){
                    MessageService.error("操作失败");
                });
            }, function () { });
        };

        $scope.batchEdit = function (id) {
            if (!$scope.canCancel) {
                return;
            }
            var ids= [];
            for (var i =  $scope.batchArr.length - 1; i >= 0; i--) {
                var xml = $scope.batchArr[i];
                ids.push(xml.id);
            }
            var idstr = ids.join(",");
            createModal2('app/entities/product-xml/product-xml-batch-edit.html', 'ProductXmlBatchEditController', idstr).result.then(function () {
                 loadAll();
             });
        };


        var createModal2 = function (url, controller, idstr) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [ '$stateParams', function ( $stateParams) {
                        return idstr;
                    }],
                }
            });
        };


        $scope.batchArr = [];
        $scope.chooseAll = function() {
            $scope.selectAll = !$scope.selectAll;
            $scope.batchArr = [];
            angular.forEach(vm.productXmls, function(xml, i) {
                if ($scope.selectAll) {
                    xml.select = true;
                    $scope.batchArr.push(xml);
                } else {
                    $scope.batchArr = [];
                    xml.select = false;
                }
            });
            $scope.updateBatchAction();
        }

        $scope.chooseOne = function (xml) {
            xml.select = !xml.select;
            // 选中
            if(xml.select){
                $scope.batchArr.push(xml);
            }else{
                // 未选中
                var ind = $scope.batchArr.indexOf(xml);
                if (ind >= 0) {
                    $scope.batchArr.splice(ind, 1);
                }
            }

            // 判断全选按钮
            var flag = true;
            angular.forEach(vm.productXmls,function (xml,i) {
                if(!xml.select){
                    $scope.selectAll = false;
                    flag = false;
                }
                // 全部选中
                if(i==vm.productXmls.length-1&&flag){
                    $scope.selectAll = true;
                }
            });
            $scope.updateBatchAction();
        }

        $scope.updateBatchAction = function(){
            if ($scope.batchArr.length == 0) {
                $scope.canApprove = false;
                $scope.canCancel = false;
                $scope.canEdit = false;
                return;
            }
            $scope.canApprove = true;
            $scope.canCancel = true;
            $scope.canEdit = true;
            for (var i = $scope.batchArr.length - 1; i >= 0; i--) {
                var xml = $scope.batchArr[i];
                if (xml.status != "Created") {
                    $scope.canApprove = false;
                    return;
                }
            }
        }

        $scope.batchUpdateCountTip = function(){
            if (!$scope.canEdit) {
                return;
            }
            var ids= [];
            for (var i =  $scope.batchArr.length - 1; i >= 0; i--) {
                var xml = $scope.batchArr[i];
                ids.push(xml.id);
            }
            var idstr = ids.join(",");
            ProductXmlFileServes.batchUpdateCountTip({ids:idstr}, function(data){
                if (data.status ==200) {
                    loadAll();
                    MessageService.success("操作成功");
                }else{
                    MessageService.error("操作失败");
                }
            }, function(){
                MessageService.error("操作失败");
            })
        }

        $scope.batchUpdateSize = function(){
            if (!$scope.canEdit) {
                return;
            }
            var ids= [];
            for (var i =  $scope.batchArr.length - 1; i >= 0; i--) {
                var xml = $scope.batchArr[i];
                ids.push(xml.id);
            }
            var idstr = ids.join(",");
            ProductXmlFileServes.updatePageSize({ids:idstr}, function(data){
                if (data.status ==200) {
                    loadAll();
                    MessageService.success("操作成功");
                }else{
                    MessageService.error("操作失败");
                }
            }, function(){
                MessageService.error("操作失败");
            })
        }

        $scope.batchDelete = function(){
            if (!$scope.canCancel) {
                return;
            }
            var ids= [];
            for (var i =  $scope.batchArr.length - 1; i >= 0; i--) {
                var xml = $scope.batchArr[i];
                ids.push(xml.id);
            }
            var idstr = ids.join(",");
            MessageService.confirm("确认要删除这些模板？", function () {
                ProductXmls.batchDelete({ids:idstr}, function(data){
                    if (data.status ==200) {
                        loadAll();
                        MessageService.success("操作成功");
                    }else{
                        MessageService.error("操作失败");
                    }
                }, function(){
                    MessageService.error("操作失败");
                })
            }, function () {
            });
        }

         $scope.batchApprove = function( status){
            if (!$scope.canCancel) {
                return;
            }
            var ids= [];
            for (var i =  $scope.batchArr.length - 1; i >= 0; i--) {
                var xml = $scope.batchArr[i];
                if (xml.status == "Approved" || xml.status == "Rejected") {
                    continue;
                }
                if (status=='Approved') {
                    if (xml.categoryId == null) {
                        continue;
                    }
                    if (xml.themeClassifies == null || xml.themeClassifies.length == 0) {
                       continue;
                    }
                    if (xml.type == null) {
                        continue;
                    }
                }
                ids.push(xml.id);
            }
            if (ids.length == 0 && status=='Approved') {
                loadAll();
                return;
            }
            var idstr = ids.join(",");
            MessageService.confirm("确认要审核这些模板？", function () {
                ProductXmls.batchApprove({ids:idstr, status:status}, function(data){
                    if (data.status ==200) {
                        loadAll();
                        MessageService.success("操作成功");
                    }else{
                        MessageService.error("操作失败");
                    }
                }, function(){
                    MessageService.error("操作失败");
                })
            }, function () {
            });
        }

        loadAll();
        $scope.delete = function (id) {
            MessageService.confirm("确认要删除该模板文件么？", function () {
                ProductXmls.delete({id: id}, function () {
                    loadAll();
                });
            }, function () {
            });
        };

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        // $scope.domains = Qinius.getDomain();

        Store.getCurrent(function (res) {
            if(res.status == 200){
                vm.platformSetting = res.data;
            }else{
                MessageService.error(res.message);
            }
        });

        $scope.newEdit = function (xml) {
            var url = vm.platformSetting.productXmlUrl + '/#/page-my-suffix/'+xml.identifier+'/'+vm.platformSetting.productXmlKey+'/'+xml.id+'/'+xml.name;
            window.location.href = url;
        }

        $scope.approve = function(xml, status) {
            if (xml == null || status == null) {
                return;
            }

            if (status=='Approved') {
                if (xml.categoryId == null) {
                    MessageService.error("请先设置分类");
                    return;
                }
                if (xml.themeClassifies == null || xml.themeClassifies.length == 0) {
                    MessageService.error("请先设置分类");
                    return;
                }
                if (xml.type == null) {
                    MessageService.error("请先设置定制类型");
                    return;
                }
            }
            var s = status == 'Approved' ? "审核通过" : "拒绝"
            MessageService.confirm("确认要" + s + "该模板？", function() {
                ProductXmls.approve({
                    id: xml.id,
                    status: status
                }, function(data) {
                    loadAll();
                }, function() {})
            }, function() {})
        }

        function loadAll() {
            $scope.batchArr =[];
            $scope.updateBatchAction();
            if (pagingParams.search) {
                ProductXmls.byCondition({
                    items: [{key: "name,themeClassify.name,number", op: "like", value: pagingParams.search},{key: "storeId", op: "=", value: $localStorage.user.storeId}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProductXmls.byCondition({
                    items: [{key: "storeId", op: "=", value: $localStorage.user.storeId}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                return ['id,desc'];
            }

            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.allPagesCount = Math.ceil(vm.totalItems/20);
                    vm.queryCount = vm.totalItems;
                    vm.productXmls = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }

            }

            function onError(error) {
                MessageService.error("数据加载出错");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $(".navbar").show();
        $(".wrap").show().css({'margin': 'margin: 48px 0 0 130px;'});

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: 'id,desc',
                search: vm.currentSearch
            });
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            console.log(vm.page);
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }


        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
            loadAll();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
        //升级
        $scope.version = function (id) {
            createModal('app/entities/product-xml/product-xml-version.html', 'ProductXmlVersionController', id).result.then(function (item) {
                if(item){
                    loadAll();
                }
            });
        };
        $scope.themeClassifie = function (xml) {
            var _return = '';
            xml.themeClassifies.forEach(function (item) {
                _return = _return + item.name + '；'
            })
            if(_return){
                _return = _return.substring(0, _return.length - 1);
            }
            return _return;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('product-analysis', {
            parent: 'entity',
            url: '/product-analysis',
            data: {
                authorities: ["ROLE_STATISTICS"],
                pageTitle: 'global.menu.entities.productAnalysis'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-analysis/product-analysis.html',
                    controller: 'ProductAnalysisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductAnalysisController', ProductAnalysisController);

    ProductAnalysisController.$inject = ['$scope', '$state', 'ParseLinks', 'MessageService', 'SalesOrder', 'XlsxService', 'Product',
     'Store', 'DateUtils','ProductXmls','$http'];

    function ProductAnalysisController ($scope, $state, ParseLinks, MessageService, SalesOrder, XlsxService, Product,
        Store, DateUtils,ProductXmls,$http) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar =  openCalendar;
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.downLoadFile = downLoadFile;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        //获取商户
        Store.getCurrent({},function (res) {
            vm.data = {
                storeId:res.data.id,
                startDate:'',
                endDate:'',
                productId:'',
                productXmlId:'',
                editorType:'',
                page:0,
                pageSize:20
            };
            productInit();
            getProductXmls();
            init();
        });
        vm.page = 1;
        //编辑器
        vm.editorTypes = [
            {name:'简易编辑器', id:'BOOK_JUNIOR'},
            {name:'高级编辑器', id:'BOOK_SENIOR'},
            {name:'万物编辑器', id:'POSTER'},
            {name:'相册编辑器', id:'NEW_EDITOR'},
            {name:'冲印编辑器', id:'PICTURE'},
            {name:'卡片编辑器', id:'PICTURE_PRO'},
            {name:'证件照编辑器', id:'PHOTO_EDITOR'},
            {name:'表单编辑器', id:'FORM_EDITOR'},
            {name:'动态台历编辑器', id:'CALENDAR_EDITOR'},
            {name:'卡片Pro编辑器', id:'PICTURE_PRO_P'}
        ]
        //获取商品
        function productInit(){
            var items = [{key: "prototype", op: "!=", value: 'Original'},
                {key: "storeId", op: "=", value: vm.data.storeId},
            ];
            Product.getAllByCondition2({
                items:items
            },function(res){
                if(res.status == 200){
                    vm.products = res.data;
                }else {
                    MessageService.error(res.message);
                    return
                }
            })
        }
        $scope.productChange = function () {
            vm.data.productId = vm.product ? vm.product.id : "";
            getProductXmls();
        }
        //获取模板
        function getProductXmls() {
            var items = [
                {key: "storeId", op: "=", value: vm.data.storeId},
                {key: "status", op: "=", value: 'Approved'}
            ];
            if(vm.product){
                items.push({key: "category.id", op: "=", value: vm.product.categoryId})
            }

            ProductXmls.getAllByCondition({
                items: items
            }, function (res) {
                if(res.status == 200){
                    vm.productXmlsAll = res.data;
                }else {
                    MessageService.error(res.message);
                }
            });
        }
        function init() {
            vm.tableData = [];
            vm.data.page = vm.page-1;
            // vm.data.startDate = DateUtils.convertLocalDateToServer(vm.startDate);
            // vm.data.endDate = DateUtils.convertLocalDateToServer(vm.endDate);
            if (!!vm.endDate) {
                vm.data.endDate = new Date(Date.parse(vm.endDate));
            };
            if (!!vm.startDate) {
                vm.data.startDate =  new Date(Date.parse(vm.startDate));
            };
            SalesOrder.byConditionPage(vm.data,function (res) {
                if(res.status == 200){
                    vm.tableData = res.data.productVMS;
                    console.log(vm.tableData)
                    vm.totalItems = res.data.count;
                }else {
                    MessageService.error(res.message);
                }
            })
        }
        function transition() {
            init();
        }
        function search() {
            vm.page = 1;
            init();
        }
        function clear() {
            vm.page = 1;
            vm.product = null;
            vm.data = {
                storeId:vm.data.storeId,
                startDate:'',
                endDate:'',
                productId:'',
                productXmlId:'',
                editorType:'',
                page:0,
                pageSize:20
            };
            vm.startDate = "";
            vm.endDate = "";
            init();
        }
        function downLoadFile(){
            vm.data.page = vm.page-1;
            // vm.data.startDate = DateUtils.convertLocalDateToServer(vm.startDate);
            // vm.data.endDate = DateUtils.convertLocalDateToServer(vm.endDate);
            if (!!vm.endDate) {
                vm.data.endDate = new Date(Date.parse(vm.endDate));
            };
            if (!!vm.startDate) {
                vm.data.startDate =  new Date(Date.parse(vm.startDate));
            };
            $http({
                url: 'service/api/sales-orders/byConditionPage/download',
                method: "GET",
                params: vm.data,
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "商品模板统计" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
            }).error(function (data, status, headers, config) {
            });
        }
        vm.editorTypeStatus = editorTypeStatus;
        function editorTypeStatus(target) {

            // 下面的字段内容与后台枚举[OrderStatus]字段对应
            switch (target) {
                case "BOOK_SENIOR":
                    return "高级编辑器";
                case "BOOK_JUNIOR":
                    return "简易编辑器";
                case "PICTURE":
                    return "冲印编辑器";
                case "PICTURE_PRO":
                    return "卡片编辑器";
                case "POSTER":
                    return "万物编辑器";
                case "NEW_EDITOR":
                    return "相册编辑器";
                case "DIY_EDITOR":
                    return "DIY编辑器";
                case "FORM_EDITOR":
                    return "表单编辑器";
                case "CALENDAR_EDITOR":
                    return "动态台历编辑器";
                case "PHOTO_EDITOR":
                    return "证件照编辑器";
                case "PICTURE_PRO_P":
                    return "卡片Pro编辑器";
                default:
                    return "";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('isOver', isOver);

    isOver.$inject = ['$timeout'];


    function isOver($timeout) {

        return {
            restrict: 'A',
            scope: {
                over: '=isOver'
            },
            link:function(scope, elm, attr){
                if(scope.$parent.$last){
                    scope.over = true;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductViewArticleController', ProductViewArticleController);

    ProductViewArticleController.$inject = ['$scope', '$stateParams', 'Qinius', 'MessageService', '$q', 'ImageService', '$uibModalInstance', 'Vert','FontManagement','entity'];

    function ProductViewArticleController($scope, $stateParams, Qinius, MessageService, $q, ImageService, $uibModalInstance, Vert, FontManagement,entity) {
        var vm = this;
        // $(".modal-content").addClass('opacity0');
        vm.watchSure = true;
        vm.fileName = entity.fileName;
        vm.product = entity.product;
        Vert.xmlToDocument({
            identifier: entity.fileName,
            provider: 'qiniu'
        }, function (res) {
            vm.previewArticle = angular.copy(res);
            // vm.article = angular.copy(res);
            // artDoc = angular.copy(res);
            // angular.forEach(artDoc.pages.page, function (page) {
            //     if (page.backup) {
            //         return
            //     }
            //     $scope.len++;
            //     angular.forEach(page.levels.level,function (level) {
            //         if(level.imagebox){
            //             vm.counts++;
            //         }
            //     })
            // });
            //
            // getAll(res);

        });
        $scope.backTo = function () {
            $uibModalInstance.dismiss('cancel');

            $(".listBGC").show();
            $(".modal-content").show().removeClass('opacity0');
        };
        return
        vm.counts = 0;
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            return arrDPI;
        }
        var unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            return mm / 25.4 * vm.windowDpiW;
        };
        var unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            return px / vm.windowDpiW * 25.4;
        };

        $scope.isShow = false;
        $scope.isFirst = true;
        $scope.isLast = false;
        var $li = $(".templateView-carousel");
        var $leftBtn = $(".leftBtn");
        var $rightBtn = $(".rightBtn");
        var $backBtn = $("#back-btn");


        $scope.k = 0;
        $scope.t = 0;
        $scope.isText = false;
        $scope.isPull = true;
        var allWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $scope.dHeight = vm.dHeight = ((window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 100) / 1.8;
        $scope.dWidth = vm.dWidth = 400;
        $scope.template = {
            pages: {
                page: [{}]
            }
        };
        $scope.document = {
            pages: [{}]
        };
        var artDoc = null;
        $scope.len = 0;

        $scope.domains = Qinius.getDomain();
        $(".modal-content").addClass('opacity0');


        function getAll(doc) {
            $q.all([$scope.domains.$promise]).then(function () {
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                //取得xml文档内容
                vm.bindingtype = entity.bindingtype||'None';
                if (vm.bindingtype == 'Left2') {
                    $scope.isPull = false;
                    vm.bindingtype = 'Left';
                }
                if (vm.bindingtype == 'Top') {
                    $scope.dHeight = vm.dHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 100;
                }
                localStorage.setItem('bindingtype', vm.bindingtype);
                $scope.maxW = doc.pages.page[0].mediabox.width;
                $scope.minW = doc.pages.page[0].mediabox.width;
                $scope.maxH = doc.pages.page[0].mediabox.height;
                $scope.minH = doc.pages.page[0].mediabox.height;
                $(".modal-content").addClass('opacity0');
                var arrUse = {
                    pages: {
                        page: []
                    }
                };
                angular.forEach(doc.pages.page, function (page) {
                    if (!page.backup) {
                        arrUse.pages.page.push(page);
                    }
                });
                $scope.getDetail(arrUse, 0);
                // $scope.getDetail(doc, 0);
            });
        }

        $scope.getDetail = function (document, index) {
            var obj = document.pages.page[index];

            $(".carousel-wrapper").height(document.pages.page[0].mediabox.height * (document.pages.page.length + 1.7));

            $scope.template = document;
            var bgIdentifier = null;
            if (obj.background && obj.background.resource && obj.background.resource.identifier) {
                bgIdentifier = obj.background.resource.identifier + '?imageMogr2/thumbnail/!40p';
            }
            var isMaxWidth = getScale($scope.dWidth, $scope.dHeight, obj.mediabox.width, obj.mediabox.height, index);

            $scope.template.pages.page[index] = {
                background: angular.copy(obj.background),
                bgImg: bgIdentifier,
                barcode: angular.copy(obj.barcode),
                barcodeM: angular.copy(obj.barcode),
                barcodeRotation: {
                    angle: obj.barcodeRotation ? obj.barcodeRotation.angle : 0
                },
                mediabox: angular.copy(obj.mediabox),
                mediaboxPx: {},
                levels:angular.copy(obj.levels),
                isMaxWidth: isMaxWidth,
                spread: obj.spread,
                centerrotation: obj.centerrotation ? true : false,
                'thumbnailH': isMaxWidth ? $scope.dWidth * 0.8 * unitTransform(obj.mediabox.height) / unitTransform(obj.mediabox.width) : $scope.dHeight * 0.7 * unitTransform(obj.mediabox.width) / unitTransform(obj.mediabox.height),
                pageScaleH: 1,
                pageScaleW: 1
            };

            // $scope.template.pages.page[index].background.offsetx = unitTransform(obj.background.offsetx)
            // $scope.template.pages.page[index].background.offsety = unitTransform(obj.background.offsetx)

            // 无翻页效果
            if (document.pages.page.length < 2 || vm.bindingtype == 'None') {
                $scope.template.pages.page[index].styleScale = (vm.dWidth * 0.7 / (unitTransform(obj.mediabox.width)));
            } else {
                $scope.template.pages.page[index].styleScale = 1;
            }


            // 得到压缩比例后的最高page的高度
            if ($scope.maxPageHeight < $scope.template.pages.page[index].thumbnailH) {
                $scope.maxPageHeight = $scope.template.pages.page[index].thumbnailH;
            }
            if (obj.barcode) {
                $scope.template.pages.page[index].barcode.geometry = getGeometry(obj.barcode.geometry, index)
            }
            $scope.template.pages.page[index].mediaboxPx = getGeometry(obj.mediabox, index)
            $scope.template.pages.page[index].ratio = $scope.template.pages.page[index].mediaboxPx.width / ($scope.template.pages.page[index].mediabox.width/ 25.4 * vm.windowDpiW)

            var background = $scope.template.pages.page[index].background;
            var w = $scope.template.pages.page[index].mediaboxPx.width,
                h = $scope.template.pages.page[index].mediaboxPx.height;

            if (background&&background.resource) {
                getBackgroundSource(obj.background.resource,w,h,background)
                background.offsetXM = angular.copy(background.offsetx);
                background.offsetYM = angular.copy(background.offsety);
                background.offsetx = unitTransform(background.offsetx)* $scope.template.pages.page[index].styleScale
                background.offsety = unitTransform(background.offsety)* $scope.template.pages.page[index].styleScale
            }

            angular.forEach(obj.levels.level,function (level,l) {
                var pageLevel = $scope.template.pages.page[index].levels.level[l];
                if (level.imageart && level.imageart.geometry) {
                    var art = level.imageart;
                    pageLevel.imageart = {
                        geometry: getGeometry(art.geometry, index),
                        rotation: {
                            angle: -art.rotation.angle
                        },
                        type: art.type,
                        resource: {
                            identifier:art.resource.identifier,
                            provider:art.resource.provider
                        },
                        scale:art.scale,
                        widthM: art.geometry.width,
                        heightM: art.geometry.height,
                        XM: art.geometry.x,
                        YM:art.geometry.y,
                        offsetXM: angular.copy(art.offsetx),
                        offsetYM: angular.copy(art.offsety),
                        offsetx: unitTransform(art.offsetx)* $scope.template.pages.page[index].styleScale,
                        offsety: unitTransform(art.offsety)* $scope.template.pages.page[index].styleScale,
                        current: 'imageart',
                        levelI: l,
                        pageI: index,
                        transparency: art.transparency,
                        onlyshow: art.onlyshow,
                        movable: art.movable,
                        editable: art.editable,
                    }
                    var newImg = new Image();
                    newImg.crossOrigin = "Anonymous";
                    newImg.onload = function () {
                        newImg.onload = null;
                        pageLevel.imageart.resource.width = newImg.width;
                        pageLevel.imageart.resource.height = newImg.height;
                    };
                    newImg.src = art.resource.identifier;
                }
                if (level.textbox && level.textbox.geometry) {
                    var text = level.textbox;
                    pageLevel.textbox = {
                        geometry: getGeometry(text.geometry, index),
                        identifier: text.identifier,
                        style: angular.copy(text.style),
                        rotation: {
                            angle: -text.rotation.angle
                        },
                        text: text.text,
                        heightM: text.geometry.height,
                        widthM: text.geometry.width,
                        xM: text.geometry.x,
                        yM: text.geometry.y,
                        styles: 'NORMAL',
                        type: text.type,
                        status: text.status,
                        templateType: vm.edit ? text.type : '',
                        levelI:l,
                        transparency: text.transparency,
                        lineheight: text.style.lineheight,
                        letterspacing: text.style.letterspacing,
                        movable: text.movable,
                        editable: text.editable,
                        fontuuid: text.fontuuid,
                        version:text.version
                    };
                    if(text.fontuuid){
                        //下载字体
                        getFontCSS(text.fontuuid)
                    }
                }

                if(level.imagebox&&level.imagebox.geometry){
                    var img = level.imagebox;
                    pageLevel.imagebox = {
                        geometry: getGeometry(img.geometry, index),
                        mask: angular.copy(img.mask),
                        imgUrl: 'content/images/shattered.png',
                        maskUrl: 'content/images/shattered.png',
                        rotation: {
                            angle: -img.rotation.angle
                        },
                        scaleW: 1,
                        scaleH: 1,
                        levelI:l,
                        bokehtype: img.bokehtype||'None',
                        image: {
                            resource: {
                                identifier: img.image ? img.image.resource.identifier : '',
                                provider: img.image ? img.image.resource.provider : 'qiniu'
                            },
                            rotation: angular.copy(img.rotation),
                            parameter: (!img.image) || img.image.parameter == null ? [] : angular.fromJson(img.image.parameter),
                            filter: (!img.image) || img.image.filter == null ? '' : img.image.filter,
                            offsetx: img.image?(unitTransform(img.image.offsetx) * $scope.template.pages.page[index].styleScale):0,
                            offsety: img.image?(unitTransform(img.image.offsety) * $scope.template.pages.page[index].styleScale):0,
                            angle: img.image && img.image.angle ? img.image.angle : 0,
                            scale: (!img.image) || img.image.scale == 1 ? 1 : img.image.scale
                        }
                    };

                    if (img.bokehtype!='None' && img.blurredrectangle) {
                        pageLevel.imagebox.blurredrectangle = getGeometry(img.blurredrectangle, index)
                    }

                    if (img.mask.resource.identifier&&img.mask.resource.identifier!=null&&img.mask.resource.identifier!="") {
                        pageLevel.imagebox.maskUrl = img.mask.resource.identifier + '?imageMogr2';
                    }


                    if (img.image && img.image.resource.identifier) {       //qiniu
                        // imageboxes.imgUrl = $scope.domain + img.image.resource.identifier + '?imageMogr2/auto-orient/rotate/' + img.image.angle;
                        pageLevel.imagebox.imgUrl = img.image.resource.identifier + '?imageMogr2/auto-orient/thumbnail/!40p';
                        if (pageLevel.imagebox.image.angle != 0) {
                            pageLevel.imagebox.imgUrl += '/rotate/' + pageLevel.imagebox.image.angle
                        }
                    }
                }
                if (level.textdocument && level.textdocument.geometry) {
                    var textdocument = level.textdocument;
                    pageLevel.textdocument = {
                        background: textdocument.background,
                        geometry: getGeometry(textdocument.geometry,index),
                        widthM: textdocument.geometry.width,
                        heightM: textdocument.geometry.height,
                        offsetXM: textdocument.geometry.x,
                        offsetYM: textdocument.geometry.y,
                        rotation: {
                            angle:textdocument.rotation.angle||0
                        },
                        current: 'textdocument',
                        levels: angular.copy(textdocument.levels),
                        levelI: l,
                        pageI: index,
                        lock: true,
                        transparency: textdocument.transparency,
                        movable: textdocument.movable,
                        editable: textdocument.editable
                    }

                    var backg = pageLevel.textdocument.background;
                    var pageW = pageLevel.textdocument.geometry.width,
                        pageH = pageLevel.textdocument.geometry.height;
                    if(backg.resource.identifier){
                        getBackgroundSource(backg.resource,pageW,pageH,backg)
                        backg.offsetx = unitTransform(backg.offsetx)* $scope.template.pages.page[index].styleScale
                        backg.offsety = unitTransform(backg.offsety)* $scope.template.pages.page[index].styleScale
                        backg.offsetXM = angular.copy(level.textdocument.background.offsetx);
                        backg.offsetYM = angular.copy(level.textdocument.background.offsety);
                    }

                    angular.forEach(textdocument.levels.level, function (lev, n) {
                        if (lev.imageart && lev.imageart.geometry) {
                            var art = lev.imageart;
                            pageLevel.textdocument.levels.level[n].imageart = {
                                geometry: getGeometry(art.geometry,index),
                                rotation: {
                                    angle: -art.rotation.angle
                                },
                                type: art.type,
                                resource: {
                                    identifier:art.resource.identifier,
                                    provider:art.resource.provider
                                },
                                scale:art.scale,
                                widthM: art.geometry.width,
                                heightM: art.geometry.height,
                                XM: art.geometry.x,
                                YM:art.geometry.y,
                                offsetXM: angular.copy(art.offsetx),
                                offsetYM: angular.copy(art.offsety),
                                offsetx: unitTransform(art.offsetx)* $scope.template.pages.page[index].styleScale,
                                offsety: unitTransform(art.offsety)* $scope.template.pages.page[index].styleScale,
                                current: 'imageart',
                                levelI: l,
                                pageI: index,
                                lock: false,
                                transparency: art.transparency,
                                onlyshow: art.onlyshow,
                                movable: art.movable,
                                editable: art.editable,
                            }
                            var newImg = new Image();
                            newImg.crossOrigin = "Anonymous";
                            newImg.onload = function () {
                                newImg.onload = null;
                                pageLevel.textdocument.levels.level[n].imageart.resource.width = newImg.width;
                                pageLevel.textdocument.levels.level[n].imageart.resource.height = newImg.height;
                            };
                            newImg.src = art.resource.identifier;
                        }
                        if (lev.textbox && lev.textbox.geometry) {
                            var text = lev.textbox;
                            pageLevel.textdocument.levels.level[n].textbox = {
                                geometry: getGeometry(text.geometry, index),
                                identifier: text.identifier,
                                rotation: {
                                    angle: -text.rotation.angle
                                },
                                angle: angular.copy(text.angle),
                                status: angular.copy(text.status),
                                style: angular.copy(text.style),
                                type: angular.copy(text.type),
                                text: angular.copy(text.text),
                                fontStyle: [{
                                    style: '',
                                    path: text.identifier
                                }],
                                widthM: text.geometry.width,
                                heightM: text.geometry.height,
                                offsetXM: text.geometry.x,
                                offsetYM: text.geometry.y,
                                current: 'textbox',
                                levelI: n,
                                pageI: index,
                                lock: true,
                                transparency: text.transparency,
                                lineheight: text.style.lineheight,
                                letterspacing: text.style.letterspacing,
                                fontuuid:text.fontuuid,
                                version:text.version
                            }
                            if(text.fontuuid){
                                //下载字体
                                getFontCSS(text.fontuuid)
                            }
                        }
                    })
                }
            })

            if (index < document.pages.page.length - 1) {
                $scope.getDetail(document, index + 1);
            } else {
                $scope.isLeftRotation = !$scope.template.pages.page[0].centerrotation;
                angular.forEach($scope.template.pages.page, function (page, m) {
                    angular.forEach(page.levels.level,function (level,l) {
                        if(level.imagebox&&level.imagebox.image){
                            imgScale(level.imagebox, m, l, level.imagebox.maskUrl, level.imagebox.image.offsetx, level.imagebox.image.offsety);
                        }else{
                            dropPicFinished()
                        }
                    })
                })
            }
            if (vm.counts == 0) {
                var arr = angular.copy($scope.template);
                angular.forEach(arr.pages.page, function (obj, index) {
                    getArr(arr, obj, index);
                });
            }
        };

        function getBackgroundSource(res,pageW,pageH,arr) {
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.onload = function () {
                newImg.onload = null;
                var bgW = newImg.width;
                var bgH = newImg.height;
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                arr.width = w;
                arr.height = h;
                arr.type = 'Pic';
                arr.adaptation = adaptation;
            };
            newImg.src = res.identifier;
        }

        function getFontCSS(item){
            FontManagement.getCss({uuid: item}, function (res) {
                if(res.status == 200){
                    var style=document.createElement("style");
                    style.type='text/css';
                    try{
                        style.appendChild(document.createTextNode(res.data));
                    }catch(ex){
                        style.stylesheet.cssText=res.data;
                    }
                    var Head=document.getElementsByTagName("head")[0];
                    Head.appendChild(style);
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        function getScale(screenW, screenH, pageW, pageH) {
            var newH = angular.copy(screenH);
            if (vm.bindingtype == 'Top' && screenW * 0.7 * pageH / pageW * 2 > screenH) {
                newH = (newH - 100) / 2;
            }

            if (vm.bindingtype == 'Top') {
                if (screenW / newH < pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    return false;
                }
            } else {
                if (screenW / newH > pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    return false;
                }
            }
        }

        function getScale2(screenW, screenH, pageW, pageH) {
            var newH = angular.copy(screenH);
            if (vm.bindingtype == 'Top' && screenW * 0.7 * pageH / pageW * 2 > screenH) {
                newH /= 2;
            }

            if (vm.bindingtype == 'Top') {
                if (screenW / newH < pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    // return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    // return false;
                }
            } else {
                if (screenW / newH > pageW / pageH) {
                    //宽定，高不定
                    $scope.isMaxWidth = true;
                    // return true;
                } else {
                    //高定，宽不定
                    $scope.isMaxWidth = false;
                    // return false;
                }
            }

            // $scope.isMaxWidth = true;
        }

        function getGeometry(obj, index) {
            return {
                height: unitTransform(obj.height) * $scope.template.pages.page[index].styleScale,
                width: unitTransform(obj.width) * $scope.template.pages.page[index].styleScale,
                x: unitTransform(obj.x) * $scope.template.pages.page[index].styleScale,
                y: unitTransform(obj.y) * $scope.template.pages.page[index].styleScale
            }
        }

        function imgScale(images, index, id, mask, x, y, flag) {
            var scaleW = 1, scaleH = 1;
            var newImg = document.createElement('img');
            newImg.setAttribute("crossOrigin", 'Anonymous');
            newImg.src = images.imgUrl;
            console.log(images.imgUrl)
            newImg.onload = function () {
                var w = newImg.width;
                var h = newImg.height;
                var maskWidth = images.geometry.width;
                var maskHight = images.geometry.height;
                if ((newImg.width <= newImg.height || maskWidth <= maskHight) && (newImg.width / newImg.height < maskWidth / maskHight) || newImg.width >= newImg.height && maskWidth >= maskHight && (newImg.width / newImg.height < maskWidth / maskHight)) {
                    newImg.width = maskWidth;
                    newImg.height = maskWidth * h / w;
                } else {
                    newImg.height = maskHight;
                    newImg.width = maskHight * w / h;
                }

                scaleW = newImg.width / w;
                scaleH = newImg.height / h;
                x = x / scaleW;
                y = y / scaleH;

                var img = images.imgUrl;
                if (images.bokehtype == 'Transparent') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        dropPicFinished();
                    });

                } else if (images.bokehtype == 'Blurred') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                    });

                    img = img + '/blur/40x1000';
                    maskd(img, mask, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale||1, function (src) {
                        images.blobUrl = src;
                        dropPicFinished();
                    });

                } else {
                    maskd(img, mask, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale||1, function (src) {
                        images.blobUrl = src;
                        dropPicFinished();
                    });
                }
            };
            newImg.onerror = function () {
                images.imgUrl = images.image.resource.identifier + '?imageMogr2/auto-orient';
                if (images.image.angle != 0) {
                    images.imgUrl += '/rotate/' + images.image.angle
                }
                if (!flag) {
                    imgScale(images, index, id, mask, x, y, true);
                } else {
                    $scope.loading = false;
                    $(".page-loading").hide();
                    $li.show();
                    $scope.isShow = true;
                    $(".save-page").hide();
                }

            }
        }

        function dropPicFinished() {
            $scope.k++;
            console.log("k: "+$scope.k+" count: "+vm.counts)
            if ($scope.k == vm.counts) {
                angular.forEach($scope.template.pages.page, function (obj, index) {
                    getArr($scope.template, obj, index);
                });
            }
        }

        function maskd3(img, src, imagebox, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var geo = imagebox.geometry;
            var blurredRec = imagebox.blurredrectangle;
            var newImg = document.createElement('img');
            // newImg.crossOrigin = "Anonymous";
            newImg.setAttribute("crossOrigin", 'Anonymous');
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = blurredRec.width;
                newImg.height = blurredRec.height;
                var masks = document.createElement('img');
                // masks.crossOrigin = "Anonymous";
                masks.setAttribute("crossOrigin", 'Anonymous');
                masks.src = imagebox.maskUrl;

                masks.onload = function () {
                    masks.width = geo.width;
                    masks.height = geo.height;
                    imagecanvas.width = geo.width;
                    imagecanvas.height = geo.height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, geo.width, geo.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.drawImage(newImg, blurredRec.x, blurredRec.y, blurredRec.width, blurredRec.height);

                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
            };
        }

        function maskd(src, maskUrl, attr, x0, y0, width, height, scaleW, scaleH, scale, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.setAttribute("crossOrigin", 'Anonymous');
            newImg.src = src;
            newImg.width = width;
            newImg.height = height;
            if (newImg.complete) {
                var masks = document.createElement('img');
                masks.setAttribute("crossOrigin", 'Anonymous');
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);
                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
                return
            }
            newImg.onload = function () {
                newImg.onload = null;
                var masks = document.createElement('img');
                masks.setAttribute("crossOrigin", 'Anonymous');
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);
                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
            };
            newImg.src = src;
        }

        function getArr(arrs, obj, index) {
            var w = obj.mediabox.width;
            var h = obj.mediabox.height;
            if (obj.spread) {
                if (w / 2 > $scope.maxW) {
                    $scope.maxW = w / 2;
                }
                if (w / 2 < $scope.minW) {
                    $scope.minW = w / 2;
                }
            } else {
                if (w > $scope.maxW) {
                    $scope.maxW = w;
                }
                if (w < $scope.minW) {
                    $scope.minW = w;
                }
            }

            if (h > $scope.maxH) {
                $scope.maxH = h;
            }
            if (w < $scope.minH) {
                $scope.minH = h;
            }
            $scope.document.pages[index] = {
                arr: obj,
                arr2: '',
                multiple: 0.45,
                multiple2: 0.45,
                width: w,
                height: h,
                spread: obj.spread,
                'marginLeft': 0,
                'thumbnail': 1,
                'thumbnail2': 1,
                id: obj.id,
                mediabox: angular.copy(obj.mediabox)
            };
            setBgImg(index, arrs, obj);
            if (index == $scope.len - 1 && vm.bindingtype != 'None') {
                var page = $scope.document.pages;
                getScale2($scope.dWidth, $scope.dHeight, page[0].mediabox.width, page[0].mediabox.height);
                //第一个page宽度 和 最大page宽度 的比值
                // var pageW = page[0].mediabox.width;
                // if(page[0].spread){
                //     pageW/= 2;
                // }
                // if(pageW>0){
                //     page[0].thumbnail =(pageW / $scope.maxW).toFixed(2)
                // }
                getPageThumbnail(page[0], page[0].spread);
                for (var j = 1; j < page.length; j++) {
                    page[j].halfWidth = ($scope.dWidth * page[j].multiple).toFixed(2);
                    //每个page宽度 和 最大page宽度 的比值
                    getPageThumbnail(page[j], page[0].spread);

                    if (j + 1 != page.length) {
                        getPageThumbnail(page[j + 1], page[j + 1].spread);
                    }
                    //跨页
                    if (page[j].spread == true) {
                        //左右翻页的清空
                        if (vm.bindingtype != 'Left') {
                            if (!$scope.uadHeight) {
                                $scope.uadHeight = page[j - 1].mediabox.height * 2
                            }
                            // page[j].marginTop = $scope.dWidth * 0.7 * ($scope.uadHeight - page[j].mediabox.height) * page[j].thumbnail / page[j].mediabox.width / 2;
                            if ($scope.isMaxWidth) {
                                var newW = $scope.dWidth * 0.7
                            } else {
                                var newW = ($scope.dHeight - 100) / 2 * page[j].mediabox.width / page[j].mediabox.height
                            }
                            page[j].marginTop = newW * ($scope.uadHeight - page[j].mediabox.height) * page[j].thumbnail / page[j].mediabox.width / 2;

                        }

                    } else if (page[j].spread == false && (page[j + 1] || []).spread == false && (j + 2) != page.length) {
                        // console.log(j);
                        var arr = page[j + 1];
                        var arr0 = page[j];
                        page[j] = {
                            id: arr0.id,
                            width: arr0.mediabox.width,
                            height: arr0.mediabox.height,
                            arr: arr0.arr,
                            spread: arr0.spread,
                            multiple: arr0.multiple,
                            thumbnail: arr0.thumbnail,
                            marginLeft: arr0.halfWidth - $scope.dWidth * arr.multiple * arr.thumbnail,
                            id2: arr.id,
                            width2: arr.mediabox.width,
                            height2: arr.mediabox.height,
                            arr2: arr.arr,
                            spread2: arr.spread,
                            multiple2: arr.multiple,
                            thumbnail2: arr.thumbnail
                        };
                        page.splice(j + 1, 1);
                        $scope.uadHeight = arr.mediabox.height + arr0.mediabox.height;
                    }
                    if (j == page.length - 1) {
                        $scope.document.pages = page;
                        $scope.isShow = true;
                        $(".save-page").hide();

                        angular.forEach(page, function (paged) {
                            if (vm.bindingtype == 'Top') {
                                $scope.getPageWaHUad(paged, true);
                                $scope.getPageWaHUad(paged, false);
                            }
                            if (vm.counts > 0 && !$scope.isText) {
                                $scope.$apply(function () {
                                    $scope.document.pages = page;
                                    if ($scope.toggle.now) {
                                        Page.init();
                                    }
                                })
                            }
                        });

                        $scope.$watch('toggle.now', function () {
                            if ($scope.toggle.now) {
                                Page.init();
                            }
                        });
                        $(".un-last:parent").css({width: '50%!important'})
                    }
                }
                $scope.document.pages = page;
                console.log(page)
            }
            if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                $(".save-page").hide();
                $(".rightBtn").hide();
            }
        }

        function getPageThumbnail(page, spread) {
            var pageW = page.mediabox.width;
            if (spread) {
                pageW /= 2;
            }
            if (pageW > 0) {
                page.thumbnail = (pageW / $scope.maxW).toFixed(2)
            }
        }

        function setBgImg(index, documents, obj) {
            // if ((index - 1) > 0 && documents.pages[index].identifier && (index - 1) < (documents.pages.length - 2) && (obj.spread == false && documents.pages[index - 2].spread == false && (index - 2) != 0 && (documents.pages[index - 2].spread2) || (obj.spread == false && (documents.pages[index] || []).spread == false))) {
            //     $scope.template.pages[index - 1].bgImg2 = $scope.domain + documents.pages[index].identifier;
            // }
            if (index <= 2) {
                return
            }
            if (!documents.pages.page[index].identifier) {
                return
            }
            if (index >= (documents.pages.page.length - 1)) {
                return
            }
            if (obj.spread) {
                return
            }
            if (!documents.pages.page[index - 2].spread && (documents.pages.page[index - 2].spread2)) {
                $scope.document.pages[index - 1].arr2 = documents.pages.page[index];
                return
            }
            if (!(documents.pages.page[index] || []).spread) {
                $scope.document.pages[index - 1].arr2 = documents.pages.page[index];
            }
        }

        $scope.getLiW = function (slide) {
            if (vm.bindingtype == 'Top') {
                if ($scope.isMaxWidth) {
                    return $scope.dWidth * 0.7
                } else {
                    return ($scope.dHeight - 100) / 2 * slide.width / slide.height
                }
            } else {
                if ($scope.isMaxWidth) {
                    // return $scope.dWidth * 0.9
                    return ''
                } else {
                    var h = slide.arr2 ? slide.width2 / slide.height2 : slide.width / slide.height;
                    return ($scope.dHeight - 100) * (slide.width / slide.height + h)
                }

            }
        };
        $scope.getUlW = function () {
            if (vm.bindingtype == 'Top') {
                if ($scope.isMaxWidth) {
                    return $scope.dWidth * 0.7
                } else {
                    return ($scope.dHeight - 100) / 2 * $scope.document.pages[0].width / $scope.document.pages[0].height
                }
            } else {
                return $scope.dWidth * 0.9
            }
        };

        $scope.getPageWaHLar = function (slide, flag, marginFlag) {
            if (vm.bindingtype != 'Left') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var w = 0;
                if (!marginFlag) {
                    if (!slide.arr2) {
                        return
                    }

                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * slide.multiple2 * slide.thumbnail2;
                    } else {
                        w = ($scope.dHeight - 100) * slide.width2 / slide.height2 * slide.thumbnail2
                    }

                    slide.arr2.pageScaleW = w / unitTransform(slide.width2);
                    slide.arr2.ratio = w / (slide.arr2.mediabox.width / 25.4 * vm.windowDpiW);
                } else {
                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * slide.multiple * slide.thumbnail;
                    } else {
                        w = ($scope.dHeight - 100) * slide.width / slide.height * slide.thumbnail;
                    }

                    slide.arr.pageScaleW = w / unitTransform(slide.width);
                    slide.arr.ratio = w / (slide.arr.mediabox.width / 25.4 * vm.windowDpiW);

                }
                if (marginFlag && $scope.maxW != $scope.minW) {
                    if (slide.spread) {
                        slide.marginLeft = ($scope.dWidth * 0.9 - w) / 2;
                    } else {
                        slide.marginLeft = ($scope.dWidth * 0.45 - w);
                    }
                }
                return w;
            } else {
                var h = 0;
                if (!marginFlag) {
                    if (!slide.arr2) {
                        return
                    }

                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * slide.multiple2 * slide.height2 * slide.thumbnail2 / slide.width2
                    } else {
                        h = $scope.dHeight - 100
                    }

                    slide.arr2.pageScaleH = h / unitTransform(slide.height2);
                } else {
                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * slide.multiple * slide.height * slide.thumbnail / slide.width
                    } else {
                        h = $scope.dHeight - 100
                    }

                    slide.arr.pageScaleH = h / unitTransform(slide.height);
                }
                return h;
            }
        };
        $scope.getPageWaHUad = function (slide, flag) {
            if (vm.bindingtype != 'Top') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var w1 = 0, w2 = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        w2 = $scope.dWidth * 0.7 * slide.thumbnail2
                    }
                    else {
                        w2 = ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2
                    }
                    slide.w2 = w2;
                    slide.arr2.w = w2;
                    slide.arr2.pageScaleW = w2 / unitTransform(slide.width2);
                    slide.arr2.ratio = w2 / (slide.arr2.mediabox.width / 25.4 * vm.windowDpiW);

                }
                if ($scope.isMaxWidth) {
                    w1 = $scope.dWidth * 0.7 * slide.thumbnail
                } else {
                    w1 = ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail
                }
                slide.w1 = w1;
                slide.arr.w = w1;
                slide.arr.pageScaleW = w1 / unitTransform(slide.width);
                slide.arr.ratio = w1 / (slide.arr.mediabox.width / 25.4 * vm.windowDpiW);
            } else {
                var h1 = 0, h2 = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        h2 = $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2;
                    } else {
                        h2 = ($scope.dHeight - 100) / 2;
                    }
                    slide.h2 = h2;
                    slide.arr2.h = h2;
                    slide.arr2.pageScaleH = h2 / unitTransform(slide.height2);

                }
                if ($scope.isMaxWidth) {
                    h1 = $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                } else {
                    h1 = ($scope.dHeight - 100) / 2;
                }
                slide.h1 = h1;
                slide.arr.h = h1;
                slide.arr.pageScaleH = h1 / unitTransform(slide.height);
            }
        };

        $scope.getPageWaHUad1 = function (slide, flag) {
            if (vm.bindingtype != 'Top') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var w = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * 0.7 * slide.thumbnail2
                    }
                    else {
                        w = ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2
                    }
                    slide.w2 = w;
                    slide.arr2.w = w;
                    slide.arr2.pageScaleW = w / unitTransform(slide.width2);
                    slide.arr2.ratio = w / (slide.arr2.mediabox.width / 25.4 * vm.windowDpiW);

                } else {
                    if ($scope.isMaxWidth) {
                        w = $scope.dWidth * 0.7 * slide.thumbnail
                    } else {
                        w = ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail
                    }
                    slide.w1 = w;
                    slide.arr.w = w;
                    slide.arr.pageScaleW = w / unitTransform(slide.width);
                    slide.arr.ratio = w / (slide.arr.mediabox.width / 25.4 * vm.windowDpiW);
                }
                // var w = slide.bgImg2 ? !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2 : $scope.dWidth * 0.7 * slide.thumbnail2 : !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail : $scope.dWidth * 0.7 * slide.thumbnail;
                return w;
            } else {
                var h = 0;
                if (slide.arr2) {
                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2;
                    } else {
                        h = ($scope.dHeight - 100) / 2;
                    }
                    slide.h2 = h;
                    slide.arr2.h = h;
                    slide.arr2.pageScaleH = h / unitTransform(slide.height2);

                } else {
                    if ($scope.isMaxWidth) {
                        h = $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                    } else {
                        h = ($scope.dHeight - 100) / 2;
                    }
                    slide.h1 = h;
                    slide.arr.h = h;
                    slide.arr.pageScaleH = h / unitTransform(slide.height);

                }
                // var h = slide.bgImg2 ? !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 : $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2 : !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 : $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                return h;
            }
        };
        $scope.getPageScaleUad = function (slide, flag) {
            if (vm.bindingtype != 'Top') {
                return
            }

            if (!slide) {
                return
            }

            if (!slide.arr) {
                return
            }

            if (flag) {
                var pageScaleW = 0;
                if (slide.arr2) {
                    slide.arr2.pageScaleW = pageScaleW = slide.arr2.w / unitTransform(slide.width2);

                } else {
                    slide.arr.pageScaleW = pageScaleW = slide.arr.w / unitTransform(slide.width);
                }
                return pageScaleW;
            } else {
                var pageScaleH = 0;
                if (slide.arr2) {
                    slide.arr2.pageScaleH = pageScaleH = slide.arr2.h / unitTransform(slide.height2);

                } else {
                    slide.arr.pageScaleH = pageScaleH = slide.arr.h / unitTransform(slide.height);

                }
                return pageScaleH;
            }
        };

        $scope.toggle = {
            now: false
        };
        var Page = (function () {
            var pageI = 0;
            var config = {
                    $bookBlock: $('#bb-bookblock'),
                    $navNext: $('#bb-nav-next'),
                    $navPrev: $('#bb-nav-prev'),
                    $slide1: $('#slide1'),
                    $slide2: $('#slide2')
                },
                init = function () {
                    config = {
                        $bookBlock: $('#bb-bookblock'),
                        $navNext: $('#bb-nav-next'),
                        $navPrev: $('#bb-nav-prev'),
                        $slide1: $('#slide1'),
                        $slide2: $('#slide2')
                    };
                    if (vm.bindingtype == 'Left') {
                        config.$bookBlock.bookblock({
                            speed: 800,
                            shadowSides: 0.8,
                            shadowFlip: 0.7,
                            len: $scope.document.pages.length
                        });
                    } else {
                        $(".bb-item").addClass('lar-noShadow');
                        config.$bookBlock.bookblock({
                            orientation: 'horizontal',
                            speed: 700
                        });
                    }
                    initEvents();
                },
                initEvents = function () {
                    var $slides = config.$bookBlock.children();

                    // add navigation events
                    config.$navNext.on('click touchstart', function () {
                        config.$bookBlock.bookblock('next');
                        pageI = localStorage.getItem('pageI');
                        nextShow(pageI - 1);
                        return false;
                    });

                    config.$navPrev.on('click touchstart', function () {
                        config.$bookBlock.bookblock('prev');
                        pageI = localStorage.getItem('pageI');
                        prevShow(pageI - 0 + 1);
                        return false;
                    });

                    // add swipe events
                    $slides.on({
                        'click': function (event) {
                            fn(event);
                            var index = event.currentTarget.dataset.index;
                            var page = $scope.document.pages[index];

                            var mar = (allWidth - $(".modal-content").width()) / 2;
                            var w = $(".view-article").width() / 2 + mar;

                            if (vm.bindingtype == 'Left') {
                                if (event.clientX > (w)) {
                                    getPageWidth(index - 0 + 1, 'next', config);
                                    nextShow(index);
                                } else {
                                    getPageWidth(index - 1, 'prev', config);
                                    prevShow(index);
                                }
                            } else if (vm.bindingtype == 'Top') {
                                // 120px---->bb-bg 上方高度
                                if (event.pageY > 120 + $(".bb-item").eq(index).height() / 2) {
                                    //最后一页的时候禁止点击
                                    if (index == $scope.document.pages.length - 1) {
                                        return
                                    }
                                    config.$bookBlock.bookblock('next');
                                    nextShow(index);
                                } else {
                                    config.$bookBlock.bookblock('prev');
                                    prevShow(index);
                                }

                                if ($scope.document.pages[index].spread == true) {
                                    $(".bb-horizontal .bb-page").css({top: '50.1%'})
                                }
                            }
                            return false;
                        }
                    });
                };

            return {init: init};

        })();

        function nextShow(index) {
            var len = $scope.document.pages.length;
            $(".leftBtn").show();
            if (index - 0 + 1 == len - 1) {
                $(".rightBtn").hide();
            }
        }

        function prevShow(index) {
            $(".rightBtn").show();
            if (index - 1 == 0) {
                $(".leftBtn").hide();
            }
        }

        function getPageWidth(index, attr, config) {
            if (!$scope.isMaxWidth) {
                var page = $scope.document.pages[index];
                var halfWidth = page.arr2 ? page.width2 / page.height2 : page.width / page.height;
                var w = ($scope.dHeight - 100) * (page.width / page.height + halfWidth);
                // console.log(w);
                $li.width(w);
                $("#bb-bookblock").width(w);
            } else {
                $li.width($("#bb-bookblock").width());
            }
            config.$bookBlock.bookblock(attr);
        }



        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductUpdateCategoryController',ProductUpdateCategoryController);

    ProductUpdateCategoryController.$inject = ['$uibModalInstance', 'entity', 'Category', '$q', 'MessageService', '$scope'];

    function ProductUpdateCategoryController($uibModalInstance, entity, Category, $q, MessageService, $scope) {
        var vm = this;

        vm.ground = entity;
        vm.clear = clear;
        vm.save = save;
        vm.categoryId = null;

        Category.storeGetAllByCondition({items:[{key:"usable", op:"=", value:"true"}]},function (res) {
            vm.categories = res.data;
        })

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.selectedCategory = function(data){
            vm.categoryId = data.id;
        }

        function save() {
            vm.ground.categoryId = vm.categoryId
            $uibModalInstance.close(vm.ground);
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductPutawayController', ProductPutawayController);

    ProductPutawayController.$inject = ['$state', '$timeout', '$scope', '$stateParams', '$q',
    'Product', 'MessageService', 'Store', 'DateUtils', 'CommodityPrice', 'Category', 'Qinius', '$localStorage', 'ParseLinks', '$uibModal'];

    function ProductPutawayController ($state, $timeout, $scope, $stateParams, $q,
        Product, MessageService, Store, DateUtils, CommodityPrice, Category, Qinius, $localStorage, ParseLinks, $uibModal) {
        var vm = this;

        vm.classifyList = [{name: '全部', id: ''}];
        vm.classify = {name: '全部', id: ''};
        vm.products = [];
        vm.itemValueLines = [];
        vm.item = [];
        vm.domains = Qinius.getDomain();
        vm.page = 1;
        vm.search = search;

        $q.all([vm.domains.$promise]).then(function () {
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            //获取分类
            Category.getAllByCondition({}, function (res) {
                if(res.status == 200){
                    for(var i=0; i<res.data.length; i++){
                        if(!res.data[i].cancelled){
                            vm.classifyList.push(res.data[i]);
                        }
                    }
                    productInit()
                }else{
                    MessageService.error(res.message);
                    return
                }

            })
        });
        $scope.classifyCb = function (data) {
            vm.classify = data;
            vm.page = 1;
            productInit()
        }

        //获取商品
        function productInit(){
            vm.products = [];
            var items = [{key: "prototype", op: "=", value: 'Original'},
                {key: "custom", op: "=", value: "false"}];
            if(vm.classify.id){
                items.push({key:"category.id",op:"=",value: vm.classify.id})
            }
            if(vm.keyword){
                items.push({key:"name",op:"like",value: vm.keyword})
            }
            Product.getAllByCondition2({items: items},function(res){
                if(res.status==200){
                    for(var i=0; i<res.data.length; i++){
                        if(!res.data[i].cancelled){
                            vm.products.push(res.data[i])
                        }
                    }
                    Store.getCurrent({}, function (res) {
                        if(res.status==200){
                            var _products = [];
                            for(var i1=0; i1<res.data.products.length; i1++){
                                if(!res.data.products[i1].cancelled){
                                    if(res.data.products[i1].categoryId == vm.classify.id || !vm.classify.id){
                                        _products.push(res.data.products[i1])
                                    }
                                }
                            }

                            for(var i=0; i<_products.length; i++){
                                var _isResult = vm.products.some(function (item) {
                                    if(item.id == _products[i].id){
                                        return true
                                    }
                                })
                                if(!_isResult){
                                    vm.products.push(_products[i])
                                }
                            }
                            Product.grounded({storeId: res.data.id}, function (items) {
                                if(items.status==200){
                                    for(var i2=0; i2<items.data.length; i2++){
                                        for(var i1=vm.products.length-1; i1>=0; i1--){
                                            if(vm.products[i1].id == items.data[i2].id){
                                                vm.products.splice(i1,1)
                                            }
                                        }
                                    }

                                    for(var i=0; i<vm.products.length; i++){
                                        for(var j=0; j<vm.item.length; j++){
                                            if(vm.item[j].id == vm.products[i].id){
                                                vm.products[i].selected = true;
                                            }
                                        }
                                    }
                                    var nums = 20; //每页出现的数量
                                    var pages = Math.ceil(vm.products.length/nums); //得到总页数
                                    var thisDate = function(curr){
                                        //此处只是演示，实际场景通常是返回已经当前页已经分组好的数据
                                        var str = [], last = curr*nums - 1;
                                        last = last >= vm.products.length ? (vm.products.length-1) : last;
                                        for(var i = (curr*nums - nums); i <= last; i++){
                                            str.push(vm.products[i]);
                                        }
                                        return str;
                                    };

                                    //调用分页
                                    laypage({
                                        cont: 'c-paging',
                                        curr: vm.page, //初始化当前页
                                        pages: pages,
                                        skip: true, //是否开启跳页
                                        first: false,
                                        last: false,
                                        jump: function(obj){
                                            $timeout(function () {
                                                vm.products1=thisDate(obj.curr);
                                                vm.page = obj.curr;
                                            })
                                        }
                                    });
                                }else{
                                    MessageService.error(items.message)
                                }
                            })
                        }else{
                            MessageService.error(res.message)
                        }

                    });
                }else{
                    MessageService.error(res.message)
                }

            })
        }
        function search() {
            vm.page = 1;
            productInit()
        }
        //获取选中商品
        $scope.itemValueLinesCb = function (data) {
            data.selected = !data.selected ? true : false;
            if(!data.selected){
                for(var i=0; i<vm.item.length; i++){
                    if(vm.item[i].id == data.id){
                        vm.item.splice(i, 1);
                    }
                }
            }else {
                vm.item.push(data)
            }
        }

        //返回
        $scope.skip = function () {
            $state.go('product')
        }

        var createModal = function (url, controller, item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity:item,
                }
            });
        };


        //保存
        $scope.save = function () {
            if(vm.item.length == 0){
                MessageService.error("请选择需要的商品！");
                return
            }
            var _ids = [];
            for(var i=0; i<vm.item.length; i++){
                _ids.push(vm.item[i].id)
            }
            var ground = {
                ids:_ids
            }
            createModal('app/entities/product/product-update-category.html', 'ProductUpdateCategoryController', ground).result.then(
            function (data) {
                if (!!data.categoryId) {
                    Product.grounding({ids: data.ids, categoryId: data.categoryId}, function (res) {
                        $state.go('product')
                    })

                }else{
                    Product.grounding({ids: data.ids}, function (res) {
                        $state.go('product')
                    })
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductDialogCreateController', ProductDialogCreateController);

    ProductDialogCreateController.$inject = ['$timeout', '$scope', '$state',   '$q', 'entity', 'Product', 'Category', 'ListService', 'UidService',
        'MessageService', 'Qinius', 'ProductXmlLines', 'ProductXmlFileServes','$uibModal', 'Music', 'Mould','PlatformSetting','Store',
        'DiyEditorSetting', 'TaskbillForms', "ProductXmls"
    ];

    function ProductDialogCreateController($timeout, $scope, $state, $q, entity, Product, Category, ListService, UidService,
        MessageService, Qinius, ProductXmlLines, ProductXmlFileServes,$uibModal, Music, Mould, PlatformSetting, Store,
         DiyEditorSetting, TaskbillForms, ProductXmls
    ) {
        var vm = this;
        localStorage.setItem('Production', 'edit');
        $scope.status = localStorage.getItem('Production');
        vm.product = entity.data;
        // vm.product.fileFormat='PDF';
        vm.clear = clear;
        vm.save = save;
        vm.search = search;
        vm.pTicketCheck = pTicketCheck;
        vm.datePickerOpenStatus = {};
        vm.properties=[];
        vm.xmlType='XML';
        vm.title = "编辑"
        if(!vm.product.id){
            vm.title = "新建"
        }else if(vm.product.bokehType!="None"){
            vm.product.bokeh = true;
        }
        DiyEditorSetting.getAllByCondition({
            items: [{key: "cancelled", op: "=", value: "false"}]
        }, function (res) {
            vm.diyEditorSettings = res.data;
        });


        vm.multilingual = multilingual;
        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.product.productLanguages,
                            key:"name",
                            fieldValue:vm.product.name,
                            fieldName:"商品名称"
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    vm.product.productLanguages=data;
                }
            });
        }


        vm.multilingual2 = multilingual2;
        function multilingual2(item){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:item.productXmlLineLanguages,
                            key:"name",
                            fieldValue:item.name,
                            fieldName:"模板展示名称"
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    item.productXmlLineLanguages=data;
                }
            });
        }

        vm.currentXmlLine = {};
        vm.domains = Qinius.getDomain();
        vm.openCalendar = openCalendar;

        vm.store = Store.getCurrent();

        vm.categoriesAll =  Category.storeGetAllByCondition({
            items: [{key: "usable", op: "=", value: "true"}]
        });

        vm.platformSetting = PlatformSetting.get();

        vm.propertyShow = false;
        vm.xmlShow = false;

        vm.editorTypes = [];

        $scope.editorTypeChange = function(){
            vm.product.reverseProcess = false;
            if (vm.product.editorType != 'NEW_EDITOR') {
                vm.product.forceFill = false;
                vm.product.aiFill = false;
            }
            if (vm.product.editorType != 'PICTURE' || vm.product.editorType != 'PICTURE_PRO' || vm.product.editorType != 'PICTURE_PRO_P') {
                vm.product.jhiPackage = false;
            }
        }

        $scope.productTypeChange = function(){
            if (vm.product.productType == 'BOOK') {
                vm.editorTypes = [{name:'相册编辑器',value:'NEW_EDITOR'}];
            }
            if (vm.product.productType == 'CALENDAR') {
                vm.editorTypes = [{name:'相册编辑器',value:'NEW_EDITOR'},{name:'动态台历编辑器',value:'CALENDAR_EDITOR'}];
            }
            if (vm.product.productType == 'PHOTO') {
                vm.editorTypes = [ {name:'冲印编辑器',value:'PICTURE'}, {name:'卡片编辑器',value:'PICTURE_PRO'}, {name:'证件照编辑器',value:'PHOTO_EDITOR'},{name:'卡片Pro编辑器',value:'PICTURE_PRO_P'}];
                // 商品的类型是“冲印”的，设置虚化类型为“透明”并 隐藏“虚化类型”
                vm.product.bokehType = 'Transparent'
            }
            if (vm.product.productType == 'THING') {
                vm.editorTypes = [{name:'万物编辑器',value:'POSTER'},
                {name:'模块化编辑器',value:'DIY_EDITOR'}, {name:'表单编辑器',value:'FORM_EDITOR'}];
            }
            if (vm.product.productType != 'BOOK') {
                vm.product.bindingType = 'Left';
            }
            for (var i = vm.editorTypes.length - 1; i >= 0; i--) {
                var et = vm.editorTypes[i];
                if(!vm.store.authEditorType || vm.store.authEditorType.indexOf(et.value) == -1){
                    vm.editorTypes.splice(i, 1);
                }
            }
        }

        $scope.aiFillChange = function(){
            if (vm.product.aiFill) {
                vm.product.forceFill = false;
            }
        }

        $scope.forceFillChange = function(){
            if (vm.product.forceFill) {
                vm.product.aiFill = false;
            }
        }


        $scope.showTree = function(tree){
            tree.show = !tree.show;
        }

        $scope.productXmlLineCopy = function(itemValue, line){
            var productXmlLine = angular.copy(line);
            productXmlLine.uuid= UidService.get();
            productXmlLine.id = null;
            itemValue.productXmlLines.push(productXmlLine);
        }

        $scope.productXmlLineDelete = function(itemValue, line){
            if (itemValue.productXmls) {
                angular.forEach(itemValue.productXmls, function (p) {
                    if (p.id == line.productXmlId) {
                        p.select = false;
                        p.choose = false;
                    }
                });
            }
            if (!!line.id) {
                line.cancelled = true;
            } else {
                var ind = itemValue.productXmlLines.indexOf(line);
                if (ind >= 0) {
                    itemValue.productXmlLines.splice(ind, 1);
                }
            }
        }

        window.xmlLineProductFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var uuid = $event.target.id;
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get()+".pdf");
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                       for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.cancelled) {
                                continue;
                            }
                            if (item.productXmlLines && item.productXmlLines.length>0) {
                                for (var j = item.productXmlLines.length - 1; j >= 0; j--) {
                                    var line = item.productXmlLines[j];
                                    if (line.uuid == uuid) {
                                        line.fileIdentifier =  $scope.domain + data.key;
                                        break;
                                    }
                                }
                            }
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.itemvalueDefault =  function(itemValue){
            for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                var value = vm.product.itemValues[i];
                if (value.uuid == itemValue.uuid) {
                    continue;
                }
                value.default = false;
            }
        }

        $scope.amountChange = function (itemValue, amount) {
            if (itemValue == null || itemValue[amount] == null) {
                return;
            }
            if (!(/^-?\d+\.?\d{0,2}$/.test(itemValue[amount]))) {
                MessageService.error("金额只能输入小数点后两位数");
                itemValue[amount] = Math.round(itemValue[amount] * 100) / 100;
                return;
            }
        };

        $scope.addItemValue = function () {
            if (vm.product.itemValues == null) {
                vm.product.itemValues = [];
            }
            if (vm.product.defaultObjectProperties == undefined) {
                MessageService.error("请选择规格");
                return;
            }
            var itemValue = { uuid: UidService.get(), objectValues: []};
            for (var i = 0; i < vm.product.defaultObjectProperties.length; i++) {
                var op = vm.product.defaultObjectProperties[i];
                var objectValue = {
                    seq: op.seq,
                    uuid: UidService.get(),
                    propertyValues: op.propertyValues,
                    propertyId: op.propertyId,
                    propertyName: op.propertyName
                };
                itemValue.objectValues.push(objectValue);
            }
            vm.product.itemValues.push(itemValue);
        }

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        vm.music = Music.allByCondition({});
        $q.all([vm.domains.$promise, vm.product.$promise, vm.categoriesAll.$promise, vm.platformSetting.$promise, vm.store.$promise,vm.music.$promise]).then(function () {
            vm.store = vm.store.data;
            vm.platformSetting = vm.platformSetting.data;
            vm.music = vm.music.data;
            vm.categories = vm.categoriesAll.data;
             $scope.productTypeChange();
            vm.forms = TaskbillForms.findAll({ items:[{key: 'storeId', op: '=', value: vm.store.id}] });
            Mould.getAllByCondition({items: [{key:"enable", op:"=", value:"true"}, {key: "storeId", op: "=", value: vm.store.id}]},function (res) {
                if(res.status == 200){
                    vm.moulds = res.data;
                }else{
                    MessageService.error(res.message);
                }
            });

            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if (vm.product.id) {

                if (vm.product.itemValues && vm.product.itemValues.length>0) {
                    for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                        var itemValue = vm.product.itemValues[i];
                        if (itemValue.cancelled) {
                            continue;
                        }
                        if (itemValue.productXmlLines && itemValue.productXmlLines.length > 0) {
                            itemValue.productXmlLines.sort(function(a, b){
                                return a.seq - b.seq;
                            })
                        }
                    }
                    $scope.selectItemValue = vm.product.itemValues[0];
                }
                if (vm.product.objectProperties !=null) {
                    vm.product.defaultObjectProperties = [];
                    for (var i = vm.product.objectProperties.length - 1; i >= 0; i--) {
                        var ob = vm.product.objectProperties[i];
                        vm.properties.push(ob);
                        vm.product.defaultObjectProperties.push(ob);
                    }
                }
                getProductXmls();
            }
        }).then(function () {
        });


        $scope.getObjectPropertyValue = function (op) {
            if (vm.product.itemValues == null || op == null) {
                return;
            }
            var result = ListService.inList2(op, vm.propertiesBk, "propertyId", "id");
            if (result) {
                for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                    var iv = vm.product.itemValues[i];
                    var value = ListService.inList2(result, iv.objectValues, "id", "propertyId");
                    if (value != null) {
                        return value;
                    }
                }
            }

            return null;
        }
        function pTicketCheck(b){
            vm.product.pTicket = b;
        }

        $scope.removeFile = function (field) {
            vm.product[field] = null;
        };

        $scope.removeFile2 = function (itemValue) {
            itemValue.coverImg = null;
        };
        $scope.removeProjectImg = function(){
            vm.product.projectImg = null;
        }

        //产品 coverImg更改
        window.updateImgFile1 = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.product.coverImg = data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };
        //冲印编辑图片上传
        window.updateEditTipPic = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.product.editTipPic = $scope.domain + data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.uploadFile = function (fileWatched, uuid) {
            $timeout(function () {
                var file = fileWatched;
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.uuid == uuid) {
                                item.coverImg = data.key;
                                break;
                            }
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        // 模板封面图片修改
        window.xmlLineImgFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var uuid = $event.target.id
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                       for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.cancelled) {
                                continue;
                            }
                            if (item.productXmlLines && item.productXmlLines.length>0) {
                                for (var j = item.productXmlLines.length - 1; j >= 0; j--) {
                                    var line = item.productXmlLines[j];
                                    if (line.uuid == uuid) {
                                        line.coverImg = $scope.domain + data.key;
                                        break;
                                    }
                                }
                            }
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };


        // itemvalue封面图片修改
        window.itemvalueLineImgFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var uuid = $event.target.id
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.cancelled ) {
                                continue;
                            }
                            if (item.uuid == uuid) {
                                item.coverImg = data.key;
                                break;
                            }
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.goToView = function (line) {
            console.log(line.productXmlIdentifier)
            if(!line.productXmlIdentifier){
                MessageService.error('请选择模板');
                return
            }
            if (!vm.product.bindingType) {
                MessageService.error('请设置翻页方式');
                return
            }
            createModal('app/entities/product/product-view-article.html', 'ProductViewArticleController',line.productXmlIdentifier).result.then(
                function (data) {

                });
        };

        var createModal = function (url, controller,fileName) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',

                resolve: {
                    entity: {
                        fileName: fileName,
                        bindingtype:vm.product.bindingType,
                        product:vm.product,
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }]
                }
            });
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go("product");
        }

        $scope.validate = function () {
            if (vm.product.name == null || vm.product.name == "") {
                MessageService.error("请输入名称");
                return false;
            }
            if (!vm.product.productType) {
                MessageService.error("请选择类型");
                return false;
            }
            if (!vm.product.editorType) {
                MessageService.error("请选择编辑器");
                return false;
            }
            if (vm.product.editorType == 'PICTURE' || vm.product.editorType == 'PICTURE_PRO' || vm.product.editorType == 'PICTURE_PRO_P') {
                if (!vm.product.pictureType) {
                    MessageService.error("请选择冲印类型");
                    return false
                }
            }
            if (vm.product.categoryId == null || vm.product.categoryId == "") {
                MessageService.error("请选择分类");
                return false;
            }
            if (vm.product.fileFormat != 'PDF') {
                vm.product.flatten = false;
            }

            if(vm.product.editorType == 'PICTURE'){
                if(vm.product.editTip && !vm.product.editTipPic){
                    MessageService.error("编辑提示图片不能为空");
                    return false;
                }
            }

            for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                var item = vm.product.itemValues[i];
                if (item.cancelled) {
                    continue;
                }

                for (var j = item.objectValues.length - 1; j >= 0; j--) {
                    var value = item.objectValues[j];
                    if (value.propertyValueId == null || value.propertyValueId == "") {
                        MessageService.error("组合中，请选择规格值");
                        return false;
                    }
                }

                if (item.productXmlLines && item.productXmlLines.length>0) {
                    for (var j = item.productXmlLines.length - 1; j >= 0; j--) {
                        var xml = item.productXmlLines[j];
                        if (xml.cancelled) {
                            continue;
                        }
                        if (xml.name == null || xml.name == "") {
                            MessageService.error("请为模板设置展示名称");
                            return false;
                        }
                        if (xml.coverImg == null || xml.coverImg == "") {
                            MessageService.error("请为模板设置展示图");
                            return false;
                        }
                        if (xml.productXmlId == null || xml.productXmlId == "") {
                            MessageService.error("请选择模板");
                            return false;
                        }
                    }
                }
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            if (vm.product.bokeh == null || vm.product.bokeh == false) {
                vm.product.bokehType = "None";
            }
            vm.product.objectProperties = [];
            if (vm.product.defaultObjectProperties &&  vm.product.defaultObjectProperties.length>0 ) {
                for (var i = vm.product.defaultObjectProperties.length - 1; i >= 0; i--) {
                    var op = vm.product.defaultObjectProperties[i];
                    vm.product.objectProperties.push(op);
                }
            }
            vm.isSaving = true;
            console.log(vm.product);
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:productUpdate', result);
            MessageService.success("保存成功");
            vm.isSaving = false;
            $state.go("product");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("保存失败");
        }

        $scope.buyXml = function (line) {
            ProductXmlLines.payProductXmlLine({id:line.id},function (res) {
                if(res.status == 200){
                    console.log(res.data);
                    line = res.data;
                    MessageService.success(res.message);
                }else{
                    MessageService.error(res.message);
                }
            })
        }


        $scope.goToReadImage = function (pic) {
            // 遮罩层下面内容不滚动
            $('body').css("overflow", "hidden");
            $(".origin-image-dialog").removeClass('hide1');
            $(".dialog-form").addClass('opacity-zero');
            $(".origin-image-dialog img").attr('src', pic);
            $(".modal-content,.modal-dialog").addClass('clear-model');
        }

        window.bbimg = function (o) {
            var pic = o.firstElementChild
            var zoom = parseInt(pic.style.zoom, 10) || 100;
            zoom += event.wheelDelta / 12;
            if (zoom > 0) pic.style.zoom = zoom + '%';
            return false;
        }

        $scope.clickToHide = function () {
            if ($scope.imageClick) {
                $scope.imageClick = false;
                return
            }
            $(".origin-image-dialog").addClass('hide1');
            $(".dialog-form").removeClass('opacity-zero');
            $(".modal-content,.modal-dialog").removeClass('clear-model');
            $('body').css("overflow","auto");
        }


        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        window.moveImgStartDialog = function (ev) {
            fn(ev);
            $scope.imageClick = true;
            var oEvent = ev;
            dragBox.clientX = oEvent.clientX || 0;
            dragBox.clientY = oEvent.clientY || 0;
            drag = true;

            document.addEventListener("mousemove", moveImgOnDialog, true);
            document.addEventListener("mouseup", moveImgEndDialog, true);
        }

        //move事件
        function moveImgOnDialog(ev) {
            var oEvent = ev;
            var oDiv = document.getElementById('origin-pic');
            if (drag) {
                fn(ev);
                if (dragBox.coordX == undefined || dragBox.coordY == undefined) {
                    dragBox.coordX = 0;
                    dragBox.coordY = 0;
                }
                oDiv.style.marginLeft = (dragBox.coordX + oEvent.clientX - dragBox.clientX) + "px";
                oDiv.style.marginTop = (dragBox.coordY + oEvent.clientY - dragBox.clientY) + "px";
            }
            $scope.$digest();
            return false;
        }

        //鼠标松开事件
        function moveImgEndDialog() {
            drag = false;
            dragBox = {};
            var oDiv = document.getElementById('origin-pic');
            dragBox.coordX = parseFloat(oDiv.style.marginLeft);
            dragBox.coordY = parseFloat(oDiv.style.marginTop);
            document.removeEventListener("mousemove", moveImgOnDialog, true);
            document.removeEventListener("mouseup", moveImgEndDialog, true);
            $scope.$digest();
            return false;
        }


        //防止事件冒泡，默认事件
        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }

        vm.datePickerOpenStatus.periodOfValidity = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }


        /**
         * 商品模板选择
         * @type {null}
         */
        var firstMouldId = null;
        $scope.mouldChange = function () {
            // 判断是否选中了相同的参数
            if(firstMouldId!=null&&firstMouldId==vm.product.mouldId){
                return
            }

            firstMouldId=vm.product.mouldId;

            // 模板更新后，规格也更新
            vm.properties=[];
            vm.product.objectProperties = [];
            vm.product.itemValues = [];
            vm.product.defaultObjectProperties =[];
            angular.forEach(vm.moulds,function (m) {
                if(m.id==vm.product.mouldId){
                    vm.product.categoryId = m.categoryId;
                    vm.product.categoryName = m.categoryName;
                    angular.forEach(m.mouldProperties,function (ob) {
                        if(!ob.cancelled){
                            var uuid = UidService.get();
                            var objectProperty = {
                                propertyId: ob.propertyId,
                                propertyName: ob.propertyName,
                                seq: uuid,
                                uuid:uuid,
                            }
                            vm.product.defaultObjectProperties.push(objectProperty);
                            vm.properties.push(ob);
                        }
                    })
                }
            })
        }

        $scope.deleteItemValue = function (itemValue) {
            if (!!itemValue.id) {
                itemValue.cancelled = true;
                itemValue.number = UidService.get();
            } else {
                var ind = vm.product.itemValues.indexOf(itemValue);
                if (ind >= 0) {
                    vm.product.itemValues.splice(ind, 1);
                }
            }
        }

        /**
         * 规格生成弹窗中的选择框
         * @param property
         * @param value
         */
        var arrsDefault = [] ;
        $scope.valueClick = function (property, value) {
            value.selected = !value.selected;
            leadPropertiesClickStatus(vm.properties,property,value,arrsDefault)
        }

        function leadPropertiesClickStatus(allProperties,property,value,arrs) {
            // 一级规格
            if(property.propertyLead){
                angular.forEach(allProperties,function (p) {
                    angular.forEach(p.propertyValues,function (v) {
                        if(value.id==v.leadPropertyValueId){
                            v.selected = value.selected;
                        }
                    })
                })
                return
            }

            var i = 0;
            var arr = [];
            // 二级规格
            if(value.leadPropertyValueId){
                angular.forEach(allProperties,function (p) {
                    angular.forEach(p.propertyValues,function (v) {
                        if(value.leadPropertyValueId==v.id){
                            arr = v;
                        }
                        if(value.selected&&value.leadPropertyValueId==v.id){
                            v.selected = true;
                        }
                        if(value.leadPropertyValueId==v.leadPropertyValueId&&v.selected){
                            i++;
                        }
                    })
                })
            }
            if(i==0){
                arr.selected = false;
            }
        }

        /**
         * 规格生成弹窗中的 生成 按钮
         */
        $scope.propertyGener = function () {
            vm.defalutList = [];
            angular.forEach(vm.properties,function (p) {
                var obj={
                    propertyName:p.propertyName,
                    id:p.id,
                    uuid: UidService.get(),
                    propertyType:p.propertyType,
                    propertyValues:[]
                }
                angular.forEach(p.propertyValues,function (v) {
                    if(v.selected){
                        obj.propertyValues.push(v);
                    }
                })
                if(obj.propertyValues.length){
                    vm.defalutList.push(obj)
                }
            })

            if(vm.properties.length!=vm.defalutList.length){
                MessageService.error("请选取规格")
            } else{
                vm.propertyShow = !vm.propertyShow;
                $scope.propertyValueComfirm(vm.defalutList)
            }

            getProductXmls()
        }

        var items = [];
        function getProductXmls() {
            items = [
                {key: "category.id", op: "=", value: vm.product.categoryId},
                {key: "storeId", op: "=", value: vm.store.id},
                {key: "status", op: "=", value: 'Approved'}
            ];

            ProductXmls.getAllByCondition({
                items: items
            }, function (res) {
                if(res.status == 200){
                    for(var x = 0;x<vm.product.itemValues.length;x++){
                        var itemValue = vm.product.itemValues[x];
                        if (itemValue.cancelled) {
                            continue;
                        }
                        itemValue.productXmls = angular.copy(res.data);
                        var a = [];
                        if (!!itemValue.productXmlLines) {
                            for(var i = 0;i < itemValue.productXmlLines.length;i++){
                                var line = itemValue.productXmlLines[i];
                                if(line.cancelled){
                                    continue
                                }
                                a.push(line.productXmlId);
                            }
                        }

                        var aStr = a.toString();
                        for (var i = 0, len = itemValue.productXmls.length; i < len; i++) {
                            var xml = itemValue.productXmls[i];
                            if (!!xml.modelBlendent) {
                                xml.modelBlendents = xml.modelBlendent
                            }
                            if (aStr.indexOf(xml.id) != -1) {
                                xml.choose = true;
                            }
                        }
                    }
                }else{
                    MessageService.error(res.message);
                }

            });
        }
        /**
         * 规格生成弹窗显示与隐藏
         */
        $scope.modalHide = function () {
            vm.propertyShow = !vm.propertyShow;
            // 记录勾选的规格值
            if(vm.propertyShow){
                vm.propertiesAll = angular.copy(vm.properties)||[];
            }else{
                vm.properties = angular.copy(vm.propertiesAll)||[];
            }
        }



        /**
         * 模板选择弹窗显示与隐藏
         * @param itemValue    vm.product.itemValue
         * @param line     productXmlLine
         */
        $scope.xmlOpen = function (itemValue, line) {
            vm.xmlShow = !vm.xmlShow;
            vm.currentXmlLine = line;
            var selectedId = null;
            angular.forEach(itemValue.productXmls, function (xml) {
                // 所有行置于未选择状态
                xml.select = false;
                // 若该行已被选中
                if (xml.id == line.productXmlId) {
                    vm.thisXmlLine = xml;
                    xml.modelBlendentUuid = line.modelBlendentUuid;
                    xml.select = true;
                    selectedId = xml.id;
                }
            })
            $scope.selectItemValue = itemValue;
            if (!!selectedId) {
                setTimeout(function() {
                    document.getElementById(selectedId).scrollIntoView();
                }, 100);
            }
            search();
        }

        $scope.xmlHide = function () {
            vm.xmlShow = !vm.xmlShow;
            vm.searchQuery = "";
            vm.dynamic = "";
            vm.themeId = null;
            vm.addXml = false;
            vm.currentXmlLine = {};
            $scope.selectItemValue = {};
        }

        /**
         * 选中模板文件
         * @param xml
         */
        $scope.chooseOne = function (xml) {
            xml.select = !xml.select;
            if (!vm.addXml) {
                angular.forEach($scope.selectItemValue.productXmls, function (p) {
                    if (p.id != xml.id) {
                        p.select = false;
                    }
                })
            }
        }
        /**
         * 模板文件搜索
         * @param searchQuery
         */
        function search() {
            angular.forEach($scope.selectItemValue.productXmls, function(xml){
                xml.filter = false;
            });
            if (!!vm.searchQuery) {
                angular.forEach($scope.selectItemValue.productXmls, function(xml){
                    if (!xml.filter &&  xml.name.indexOf(vm.searchQuery)<0) {
                        xml.filter = true;
                    }
                })
            }
            // if (!!vm.product.productType) {
            //     angular.forEach($scope.selectItemValue.productXmls, function(xml){
            //         if (!xml.filter &&  xml.productType!= vm.product.productType) {
            //             xml.filter = true;
            //         }
            //     })
            // }
            if (!!vm.themeId) {
                angular.forEach($scope.selectItemValue.productXmls, function(xml){
                    if (!xml.filter) {
                        var _exist = false;
                        for(var i=0; i<xml.themeClassifies.length; i++){
                            if(xml.themeClassifies[i].id == vm.themeId){
                                _exist = true;
                                break
                            }
                        }
                        if(!_exist){
                            xml.filter = true;
                        }
                    }
                })
            }
            if (!!vm.dynamic) {
                var dynamic = (vm.dynamic == "true") ? true : (vm.dynamic == "false") ? false : null;
                angular.forEach($scope.selectItemValue.productXmls, function(xml){
                    if (!xml.filter && (xml.dynamic != dynamic) ) {
                        xml.filter = true;
                    }
                })
            }
        }

        $scope.xmlGener = function () {
            //编辑模板行
            vm.searchQuery= "";
            vm.dynamic = "";
            vm.themeId = null;
            if (!vm.addXml) {
                // 该行未选择则置为false
                if(vm.thisXmlLine&&!vm.thisXmlLine.select){
                    vm.thisXmlLine.choose = false;
                }
                vm.currentXmlLine.productXmlId = null;
                vm.currentXmlLine.productXmlName = null;
                angular.forEach($scope.selectItemValue.productXmls, function (p) {
                    if(p.select){
                        p.choose = true;
                        vm.currentXmlLine.name = p.name;
                        vm.currentXmlLine.productXmlId = p.id;
                        vm.currentXmlLine.productXmlName = p.name;
                        vm.currentXmlLine.productXmlNumber = p.number;
                        if (p.modelBlendents && p.modelBlendentUuid) {
                            for (var i = p.modelBlendents.length - 1; i >= 0; i--) {
                               var modelBlendent = p.modelBlendents[i];
                               if (modelBlendent.uuid == p.modelBlendentUuid) {
                                    vm.currentXmlLine.modelBlendentUuid = modelBlendent.uuid;
                                    vm.currentXmlLine.modelBlendentName = modelBlendent.name;
                                    break;
                               }
                            }
                        }else{
                            vm.currentXmlLine.modelBlendentUuid = null;
                            vm.currentXmlLine.modelBlendentName = null;
                        }
                        ProductXmls.get({id: p.id},function (item) {
                            if (item.status == 200 && item.data && item.data.documentPics.length) {
                                item.data.documentPics.sort(function(a, b){
                                    return a.seq - b.seq;
                                })
                                vm.currentXmlLine.coverImg = item.data.documentPics[0].identifier;
                            }
                        })
                    }
                })
            }else{
                //新增模板行
                if($scope.selectItemValue.productXmlLines==undefined){
                    $scope.selectItemValue.productXmlLines = [];
                }
                angular.forEach($scope.selectItemValue.productXmls, function (xml) {
                    if(xml.select){
                        xml.choose = true;
                        var xmlLine = {
                            name:xml.name,
                            seq:999,
                            productXmlId:xml.id,
                            productXmlName:xml.name,
                            uuid:UidService.get(),
                            paid:true,
                            productXmlNumber:xml.number
                        }
                        if (xml.modelBlendents && xml.modelBlendentUuid) {
                            for (var i = xml.modelBlendents.length - 1; i >= 0; i--) {
                               var modelBlendent = xml.modelBlendents[i];
                               if (modelBlendent.uuid == xml.modelBlendentUuid) {
                                    xmlLine.modelBlendentUuid = modelBlendent.uuid;
                                    xmlLine.modelBlendentName = modelBlendent.name;
                                    break;
                               }
                            }
                        }else{
                            xmlLine.modelBlendentUuid = null;
                            xmlLine.modelBlendentName = null;
                        }
                        ProductXmls.get({id: xml.id},function (item) {
                            if (item.status == 200 && item.data && item.data.documentPics.length) {
                                item.data.documentPics.sort(function(a, b){
                                    return a.seq - b.seq;
                                });
                                xmlLine.coverImg = item.data.documentPics[0].identifier;
                            }
                            $scope.selectItemValue.productXmlLines.push(xmlLine);
                        })
                    }
                })
            }
            vm.addXml = false;
            vm.xmlShow = false;
        }


        function doExchange(results, result, arr, depth, value) {
            for (var i = 0; i < arr[depth][value].length; i++) {
                result[depth] = arr[depth][value][i];
                if (depth != arr.length - 1) {
                    doExchange(results, result, arr, depth + 1, value);
                } else {
                    var t = angular.copy(result);
                    results.push(t);
                }
            }
        }

        $scope.propertyValueComfirm = function( defaultProperties) {
            var results = [];
            var result = [];
            var defaultPropertiesBack = angular.copy(defaultProperties);
            for (var i = defaultPropertiesBack.length - 1; i >= 0; i--) {
                var p =  defaultPropertiesBack[i];
               for (var j = p.propertyValues.length - 1; j >= 0; j--) {
                   var pValue = p.propertyValues[j];
                   if (!pValue.selected) {
                        p.propertyValues.splice(j,1);
                    }
               }
            }
            //确认将有多少行 ItemValue
            doExchange(results, result, defaultPropertiesBack, 0, "propertyValues");
            var itemValues = [];
            for (var i = results.length - 1; i >= 0; i--) {
                var objectvalues = results[i];
                var itemValue = {
                    objectValues: [],
                    productXmls:[]
                };
                var sku = "";
                var skuNumber = "";

                for (var j = objectvalues.length - 1; j >= 0; j--) {
                    var ob = objectvalues[j];
                    var uuid = UidService.get();
                    sku = sku + "," + ob.value;
                    skuNumber = skuNumber + "-" + ob.propertyId + "_" + ob.id;
                    var objValue = {
                        seq: uuid,
                        uuid: uuid,
                        propertyId: ob.propertyId,
                        propertyName: ob.propertyName,
                        propertyValueId: ob.id,
                        propertyValueValue: ob.value
                    }
                    itemValue.objectValues.push(objValue);
                }
                itemValue.skuNumber = skuNumber.substring(1);
                itemValue.uuid = UidService.get();
                itemValue.sku = sku.substring(1);
                itemValues.push(itemValue);
            }
            console.log(itemValues)
            results = [];
            result = [];

            //判断ItemValue  是否要加入product
            for (var i = itemValues.length - 1; i >= 0; i--) {
                var item = itemValues[i];
                var result = $scope.getItemFromProduct(item);
                if (result == null) {
                    if (vm.product.itemValues == null) {
                        vm.product.itemValues = [];
                    }
                    item.productXmlLines = [];
                    vm.product.itemValues.push(item);
                }else{
                    result.sku = item.sku;
                }
            }
        }

        $scope.getItemFromProduct = function(it){
            if (vm.product.itemValues == null || vm.product.itemValues.length == 0) {
                return null;
            }
            for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                var item =  vm.product.itemValues[i];
                if (item.cancelled) {
                    continue;
                }
                if (it.skuNumber == item.skuNumber) {
                   return item;
                }
            }
            return null;
        }

        $scope.addXml = function (itemValue) {
            vm.addXml = true;
            vm.xmlShow = !vm.xmlShow;
            vm.themeClassifies = [];
            vm.themeId = null;
            vm.searchProductType = null;
            angular.forEach(itemValue.productXmls, function (xml) {
                // 所有行置于未选择状态
                xml.select = false;
                xml.themeClassifies.forEach(function (themeClassifie) {
                    var theme = {id:themeClassifie.id, name:themeClassifie.name};
                    var result = ListService.inList(theme, vm.themeClassifies, ["id"]);
                    if (result == null) {
                        vm.themeClassifies.push(theme);
                    }
                })
            })
            $scope.selectItemValue = itemValue;
            search();
        }
        $scope.diyEditorSettingChange = function () {
            vm.product.diyEditorSettingName = "";
            vm.diyEditorSettings.forEach(function (diyEditorSetting) {
                if(diyEditorSetting.id == vm.product.diyEditorSettingId){
                    vm.product.diyEditorSettingName = diyEditorSetting.name;
                }
            })
        }
        //关联模型
        $scope.addGltf = function () {
            $uibModal.open({
                templateUrl: 'app/entities/scene/scene-modal.html',
                controller: 'SceneModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return vm.product.moulds
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.product.moulds = result;
                }
            });
        }
        $scope.deleteMould = function (index) {
            vm.product.moulds.splice(index,1);
        }

        //产品 coverImg更改
        window.updateProjectImg = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.product.projectImg = $scope.domain + data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };
        $scope.themeClassifie = function (xml) {
            var _return = '';
            xml.themeClassifies.forEach(function (item) {
                _return = _return + item.name + '；'
            })
            if(_return){
                _return = _return.substring(0, _return.length - 1);
            }
            return _return;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$state', '$q', 'entity', 'Product', 'ProductXmlLines', 'UidService', 'Category',
        'MessageService', 'Qinius', 'Property', '$uibModal', '$stateParams', 'PlatformSetting'
    ];


    function ProductDialogController($timeout, $scope, $state, $q, entity, Product, ProductXmlLines, UidService, Category,
                                     MessageService, Qinius, Property, $uibModal, $stateParams, PlatformSetting) {
        var vm = this;
        localStorage.setItem('Production', 'edit');
        $scope.status = localStorage.getItem('Production');
        vm.product = entity.data;
        vm.clear = clear;
        vm.save = save;
        $scope.colspanLen = 3;
        vm.pTicketCheck = pTicketCheck;
        vm.platformSetting = PlatformSetting.get();
        // vm.paidProductXmlLines = ProductXmlLines.getPaidProductXmlLine();
        vm.domains = Qinius.getDomain();
        vm.title = "编辑"
        if(!vm.product.id){
            vm.title = "新建"
        }else if(vm.product.bokehType!="None"){
            vm.product.bokeh = true;
        }

        vm.categoriesAll = Category.storeGetAllByCondition({items: [{key:"usable",op:"=",value:'true'}]})

        var createModal = function (url, controller, item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass:'modal-right',
                controllerAs: 'vm',
                resolve: {
                    entity: item,
                }
            });
        };

         $scope.itemvalueDefault =  function(itemValue){
            for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                var value = vm.product.itemValues[i];
                if (value.id == itemValue.id) {
                    continue;
                }
                value.default = false;
            }
        }


        $scope.itemvalueLineDefault =  function(itemValue, line){
            for (var i = itemValue.itemValueLines.length - 1; i >= 0; i--) {
                var valueLine = itemValue.itemValueLines[i];
                if (line.id == valueLine.id) {
                    continue;
                }
                valueLine.default = false;
            }
        }


        $scope.amountChange = function (itemValue, amount) {
            if (itemValue == null || itemValue[amount] == null) {
                return;
            }
            if (!(/^-?\d+\.?\d{0,2}$/.test(itemValue[amount]))) {
                MessageService.error("金额只能输入小数点后两位数");
                itemValue[amount] = Math.round(itemValue[amount] * 100) / 100;
                return;
            }
        };

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        vm.multilingual2 = multilingual2;
        function multilingual2(item){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:item.productXmlLineLanguages,
                            key:"name",
                            fieldValue:item.name,
                            fieldName:"模板展示名称"
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    item.productXmlLineLanguages=data;
                }
            });
        }

        $q.all([vm.domains.$promise, vm.product.$promise, vm.platformSetting.$promise, vm.categoriesAll.$promise]).then(function () {
            vm.platformSetting = vm.platformSetting.data;
            vm.categories = vm.categoriesAll.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if (vm.product.itemValues && vm.product.itemValues.length>0) {
                for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                    var itemValue = vm.product.itemValues[i];
                    if (itemValue.cancelled) {
                        continue;
                    }
                    if (itemValue.productXmlLines && itemValue.productXmlLines.length > 0) {
                        itemValue.productXmlLines.sort(function(a, b){
                            return a.seq - b.seq;
                        })
                    }
                }
            }

            if (vm.product.objectProperties != null) {
                vm.product.defaultObjectProperties = [];

                for (var i = vm.product.objectProperties.length - 1; i >= 0; i--) {
                    var ob = vm.product.objectProperties[i];
                    vm.product.defaultObjectProperties.push(ob);
                }
            }
        }).then(function () {
        });

        function pTicketCheck(b) {
            vm.product.pTicket = b;
        }

        $scope.removeFile2 = function (itemValue) {
            itemValue.coverImg = null;
        };

        $scope.removeFile = function (coverImg) {
            vm.product.coverImg = null;
        };


        //标准印品文件移除
        $scope.removeFile3 = function (line) {
            line.fileIdentifier = null;
        };

        window.xmlLineProductFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var uuid = $event.target.id
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get()+ ".pdf");
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                       for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.cancelled || item.deleted) {
                                continue;
                            }
                            if (item.productXmlLines && item.productXmlLines.length>0) {
                                for (var j = item.productXmlLines.length - 1; j >= 0; j--) {
                                    var line = item.productXmlLines[j];
                                    if (line.uuid == uuid) {
                                        line.fileIdentifier = $scope.domain + data.key;
                                        break;
                                    }
                                }
                            }

                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        window.xmlLineImgFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var uuid = $event.target.id
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                       for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.cancelled || item.deleted) {
                                continue;
                            }
                            if (item.productXmlLines && item.productXmlLines.length>0) {
                                for (var j = item.productXmlLines.length - 1; j >= 0; j--) {
                                    var line = item.productXmlLines[j];
                                    if (line.uuid == uuid) {
                                        line.coverImg = $scope.domain + data.key;
                                        break;
                                    }
                                }
                            }

                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        //产品 coverImg更改
        window.updateImgFile1 = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.product.coverImg = data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };


        // itemvalue封面图片修改
        window.itemvalueLineImgFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var uuid = $event.target.id
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.cancelled || item.deleted) {
                                continue;
                            }
                            if (item.uuid == uuid) {
                                item.coverImg = data.key;
                                break;
                            }
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.uploadFile = function (fileWatched, uuid) {
            $timeout(function () {
                var file = fileWatched;
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                            var item = vm.product.itemValues[i];
                            if (item.uuid == uuid) {
                                item.coverImg = data.key;
                                break;
                            }
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        $scope.buyXml = function (line) {
            console.log(line)
            // return
            ProductXmlLines.payProductXmlLine({id:line.id},function (res) {
                if(res.status == 200){
                    line.paid = true;
                    console.log(res.data);
                    // line = res.data;
                    MessageService.success(res.message);
                }else{
                    MessageService.error(res.message);
                }
            })
        }

        $scope.goToView = function (line) {
            console.log(line.productXmlIdentifier)
            if(!line.productXmlIdentifier){
                MessageService.error('请选择模板');
                return
            }
            if (!vm.product.bindingType) {
                MessageService.error('请设置翻页方式');
                return
            }
            createModal2('app/entities/product/product-view-article.html', 'ProductViewArticleController', line.productXmlIdentifier).result.then(
                function (data) {

                });
        };

        var createModal2 = function (url, controller,fileName) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: {
                        fileName: fileName,
                        bindingtype:vm.product.bindingType,
                        product:vm.product,
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }]
                }
            });
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('product', null, {reload: 'product'});
        }

        $scope.validate = function () {
            if (vm.product.name == null || vm.product.name == "") {
                MessageService.error("请输入名称");
                return false;
            }
            return true;
        };


        function save() {
            if (!$scope.validate()) {
                return;
            }
            if (vm.product.bokeh == null || vm.product.bokeh == false) {
                vm.product.bokehType = "None";
            }
            vm.isSaving = true;
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(res) {
            if(res.status==200){
                $scope.$emit('backApp:productUpdate', res.data);
                $state.go('product', null, {reload: 'product'});
                MessageService.success("保存成功");
                vm.isSaving = false;
            }else{
                MessageService.error(res.message)
            }

        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("保存失败");
        }

        $scope.goToReadImage = function (pic) {
            // 遮罩层下面内容不滚动
            $('body').css("overflow", "hidden");
            $(".origin-image-dialog").removeClass('hide1');
            $(".dialog-form").addClass('opacity-zero');
            $(".origin-image-dialog img").attr('src', pic);
            $(".modal-content,.modal-dialog").addClass('clear-model');
        }

        window.bbimg = function (o) {
            var pic = o.firstElementChild
            var zoom = parseInt(pic.style.zoom, 10) || 100;
            zoom += event.wheelDelta / 12;
            if (zoom > 0) pic.style.zoom = zoom + '%';
            return false;
        }

        $scope.clickToHide = function () {
            if ($scope.imageClick) {
                $scope.imageClick = false;
                return
            }
            $(".origin-image-dialog").addClass('hide1');
            $(".dialog-form").removeClass('opacity-zero');
            $(".modal-content,.modal-dialog").removeClass('clear-model');
            $('body').css("overflow", "auto");
        }


        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        window.moveImgStartDialog = function (ev) {
            fn(ev);
            $scope.imageClick = true;
            var oEvent = ev;
            dragBox.clientX = oEvent.clientX || 0;
            dragBox.clientY = oEvent.clientY || 0;
            drag = true;

            document.addEventListener("mousemove", moveImgOnDialog, true);
            document.addEventListener("mouseup", moveImgEndDialog, true);
        }

        //move事件
        function moveImgOnDialog(ev) {
            var oEvent = ev;
            var oDiv = document.getElementById('origin-pic');
            if (drag) {
                fn(ev);
                if (dragBox.coordX == undefined || dragBox.coordY == undefined) {
                    dragBox.coordX = 0;
                    dragBox.coordY = 0;
                }
                oDiv.style.marginLeft = (dragBox.coordX + oEvent.clientX - dragBox.clientX) + "px";
                oDiv.style.marginTop = (dragBox.coordY + oEvent.clientY - dragBox.clientY) + "px";
            }
            $scope.$digest();
            return false;
        }

        //鼠标松开事件
        function moveImgEndDialog() {
            drag = false;
            dragBox = {};
            var oDiv = document.getElementById('origin-pic');
            dragBox.coordX = parseFloat(oDiv.style.marginLeft);
            dragBox.coordY = parseFloat(oDiv.style.marginTop);
            document.removeEventListener("mousemove", moveImgOnDialog, true);
            document.removeEventListener("mouseup", moveImgEndDialog, true);
            $scope.$digest();
            return false;
        }


        //防止事件冒泡，默认事件
        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }
        //关联模型
        $scope.addGltf = function () {
            $uibModal.open({
                templateUrl: 'app/entities/scene/scene-modal.html',
                controller: 'SceneModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return vm.product.moulds
                    }
                }
            }).result.then(function(result){
                if(result){
                    vm.product.moulds = result;
                }
            });
        }
        $scope.deleteMould = function (index) {
            vm.product.moulds.splice(index,1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$q', '$rootScope', '$stateParams', '$state', 'entity', 'Qinius', 'MessageService', '$uibModal'];

    function ProductDetailController($scope, $q, $rootScope, $stateParams, $state, entity, Qinius, MessageService, $uibModal) {
        var vm = this;

        vm.product = entity.data;
        vm.clear = clear;
        vm.title = "编辑"
        if(!vm.product.id){
            vm.title = "新建"
        }else if(vm.product.bokehType!="None"){
            vm.product.bokeh = true;
        }


        vm.multilingual = multilingual;
        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDetail.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.product.productLanguages, 
                            key:"name",
                            fieldValue:vm.product.name,
                            fieldName:"商品名称"
                        };
                    }]
                }
            }).result.then(function(data) {
                
            });
        }

        vm.multilingual2 = multilingual2;
        function multilingual2(item){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDetail.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:item.productXmlLineLanguages, 
                            key:"name",
                            fieldValue:item.name,
                            fieldName:"模板展示名称"
                        };
                    }]
                }
            }).result.then(function(data) {
                
            });
        }


        var createModal2 = function (url, controller, item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity:item,
                }
            });
        };

        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise, vm.product.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if (vm.product.objectProperties !=null) {
                vm.product.defaultObjectProperties = [];

                for (var i = vm.product.objectProperties.length - 1; i >= 0; i--) {
                    var ob = vm.product.objectProperties[i];
                    vm.product.defaultObjectProperties.push(ob);

                }
            }

            if (vm.product.itemValues && vm.product.itemValues.length>0) {
                for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                    var itemValue = vm.product.itemValues[i];
                    if (itemValue.cancelled) {
                        continue;
                    }
                    if (itemValue.productXmlLines && itemValue.productXmlLines.length > 0) {
                        itemValue.productXmlLines.sort(function(a, b){
                            return a.seq - b.seq;
                        })
                    }
                }
            }

        })

        function clear () {
            $state.go('product', {}, {reload: false});
        }

        $scope.getItemValueStr = function(itemValue){
            var valueStr="";
            if (itemValue == null || itemValue.propertyValues == null) {
                return valueStr;
            };
            for (var i = 0; i< itemValue.propertyValues.length  ; i++) {
                var propertyValue = itemValue.propertyValues[i];
                valueStr = valueStr+" "+propertyValue.value;
            };
            return valueStr;
        }

        var unsubscribe = $rootScope.$on('backApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);

        $scope.goToView = function (line) {
            if (!vm.product.bindingType) {
                MessageService.error('请设置翻页方式');
                return
            }
            createModal('app/entities/product/product-view-article.html', 'ProductViewArticleController',line.productXmlIdentifier).result.then(
                function (data) {

                });
        };

        var createModal = function (url, controller,fileName) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',

                resolve: {
                    entity: {
                        fileName: fileName,
                        bindingtype:vm.product.bindingType
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }]
                }
            });
        };

        $scope.goToReadImage = function (pic) {
            // 遮罩层下面内容不滚动
            $('body').css("overflow", "hidden");
            $(".origin-image-dialog").removeClass('hide1');
            $(".listDetail").addClass('opacity-zero');
            $(".origin-image-dialog img").attr('src', pic);
            $(".modal-content,.modal-dialog").addClass('clear-model');
        }

        // 滚动放大
        window.bbimg = function (o) {
            var pic = o.firstElementChild
            var zoom = parseInt(pic.style.zoom, 10) || 100;
            zoom += event.wheelDelta / 12;
            if (zoom > 0) pic.style.zoom = zoom + '%';
            return false;
        }

        $scope.clickToHide = function () {
            if ($scope.imageClick) {
                $scope.imageClick = false;
                return
            }
            $(".origin-image-dialog").addClass('hide1');
            $(".listDetail").removeClass('opacity-zero');
            $(".modal-content,.modal-dialog").removeClass('clear-model');
            $('body').css("overflow","auto");
        }


        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        window.moveImgStartDialog = function (ev) {
            fn(ev);
            $scope.imageClick = true;
            var oEvent = ev;
            dragBox.clientX = oEvent.clientX || 0;
            dragBox.clientY = oEvent.clientY || 0;
            drag = true;

            document.addEventListener("mousemove", moveImgOnDialog, true);
            document.addEventListener("mouseup", moveImgEndDialog, true);
        }

        //move事件
        function moveImgOnDialog(ev) {
            var oEvent = ev;
            var oDiv = document.getElementById('origin-pic');
            if (drag) {
                fn(ev);
                if (dragBox.coordX == undefined || dragBox.coordY == undefined) {
                    dragBox.coordX = 0;
                    dragBox.coordY = 0;
                }
                oDiv.style.marginLeft = (dragBox.coordX + oEvent.clientX - dragBox.clientX) + "px";
                oDiv.style.marginTop = (dragBox.coordY + oEvent.clientY - dragBox.clientY) + "px";
            }
            $scope.$digest();
            return false;
        }

        //鼠标松开事件
        function moveImgEndDialog() {
            drag = false;
            dragBox = {};
            var oDiv = document.getElementById('origin-pic');
            dragBox.coordX = parseFloat(oDiv.style.marginLeft);
            dragBox.coordY = parseFloat(oDiv.style.marginTop);
            document.removeEventListener("mousemove", moveImgOnDialog, true);
            document.removeEventListener("mouseup", moveImgEndDialog, true);
            $scope.$digest();
            return false;
        }


        //防止事件冒泡，默认事件
        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('product', {
                parent: 'entity',
                url: '/product?page&sort&search',
                data: {
                    authorities: ['ROLE_PRODUCT'],
                    pageTitle: 'global.menu.entities.templateManagement2'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/products.html',
                        controller: 'ProductController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id, desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('product-detail', {
                parent: 'product',
                url: '/product/{id}',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/product-detail.html',
                        controller: 'ProductDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Product','$stateParams', function (Product,$stateParams) {
                        return Product.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


            .state('product.new', {
                parent: 'product',
                url: '/new',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/product-dialog-create.html',
                        controller: 'ProductDialogCreateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return {
                            data:{
                                name: null,
                                sku: null,
                                cancelled: null,
                                price: null,
                                jsonFile: null,
                                pTicket: false,
                                id: null,
                                expandedObjectProperties:[],
                                defaultObjectProperties:[],
                                prototype: "StoreSelf",
                                contourWidth:2
                            }
                        };
                    }
                }
            })
            .state('product.edit', {
                parent: 'product',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/product-dialog.html',
                        controller: 'ProductDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Product','$stateParams', function (Product,$stateParams) {
                        return Product.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('product.edit2', {
                parent: 'product',
                url: '/{id}/edit2',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/product-dialog-create.html',
                        controller: 'ProductDialogCreateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Product','$stateParams', function (Product,$stateParams) {
                        return Product.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
 
            .state('product-view-article', {
                parent: 'product.new',
                url: '/{fileName}/{bindingType}',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product/product-view-article.html',
                        controller: 'ProductViewArticleController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProductXmlFileServes', '$stateParams', function(ProductXmlFileServes, $stateParams) {

                            }]
                        }
                    });
                }]
            })
            .state('product-view-article2', {
                parent: 'product.edit',
                url: '/view/{fileName}',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product/product-view-article.html',
                        controller: 'ProductViewArticleController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProductXmlFileServes', '$stateParams', function(ProductXmlFileServes, $stateParams) {

                            }]
                        }
                    }).result.then(function() {
                        $state.go('product', null, {
                            reload: 'product'
                        });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('product-putaway', {
                parent: 'product',
                url: '/product-putaway',
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/product-putaway.html',
                        controller: 'ProductPutawayController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('FileService2', FileService2)
        .factory('Music', Music)
        .factory('ProductXmlFileServes', ProductXmlFileServes)
        .factory('ItemValue', ItemValue)
        .factory('ProductXmlLines', ProductXmlLines)
        .factory('Product', Product)
        .factory('Vert', Vert)
        .factory('CommodityPrice', CommodityPrice)
        .factory('Tariffs', Tariffs)
        .factory('PlatformSetting', PlatformSetting);

    Product.$inject = ['$resource', 'DateUtils'];
    ProductXmlFileServes.$inject = ['$resource'];
    ItemValue.$inject = ['$resource'];
    ProductXmlLines.$inject = ['$resource'];

    FileService2.$inject = ['$resource'];
    Music.$inject = ['$resource', 'DateUtils'];
    Vert.$inject = ['$resource'];
    CommodityPrice.$inject = ['$resource'];
    Tariffs.$inject = ['$resource'];
    PlatformSetting.$inject = ['$resource'];

    function Music($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/music/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'allByCondition': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                }
            },
            'get': {
                method: 'GET'
            }
        });
    }

    function ItemValue ($resource) {
        var resourceUrl =  'manager/' + 'api/item-values/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }


    function ProductXmlFileServes ($resource) {
        var resourceUrl =  'fileserves/' + 'api/product-xmls/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'updatePageSize': {
                method: 'GET',
                params: {
                    path: 'updatePageSize'
                }
            },
            "updateCountTip":{
                method:"POST",
                params:{
                    path:"updateCountTip"
                }
            },
            "batchUpdateCountTip":{
                method:"GET",
                params:{
                    path:"batchUpdateCountTip"
                }
            },
            'update': { method:'PUT' }
        });
    }

    function ProductXmlLines ($resource) {
        var resourceUrl =  'manager/' + 'api/product-xml-lines/:path';

        return $resource(resourceUrl, {}, {
            'payProductXmlLine': {
                method: 'GET',
                params: {
                    path: 'payProductXmlLine'
                }
            },
            'getPaidProductXmlLine' : {
                method: 'POST',
                params: {
                    path: 'getPaidProductXmlLine'
                }
            }
        });
    }

    function Vert ($resource) {
        var resourceUrl =  'fileserves/' + 'api/convert/:path/:storeId';

        return $resource(resourceUrl, {}, {
            "xmlToDocument":{
                method:"GET",
                params:{
                    path:"xmlToDocument"
                }
            },
            "imgFilter":{
                method: 'GET',
                params: {
                    path: "filter"
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function FileService2 ($resource) {
        var resourceUrl =  'fileserves/' + 'api/download/:path/:id';
        return $resource(resourceUrl, {}, {
            'downloadZipFileCheck': {
                method: 'GET',
                params: {
                    path: 'downloadZipFileCheck'
                }
            },
            'downloadZipFile3': {
                method: 'GET',
                params: {
                    path: 'downloadZipFile3'
                }
            },
        });
    }



    function Product ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/products/:path/:id';

        return $resource(resourceUrl, {}, {
             
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'byCondition2': {
                method: 'POST',
                params: {
                    path: 'byCondition2'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "updatePrice":{
                method:"GET",
                params:{
                    path:"updatePrice",
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "shareProducts":{
                method:"GET",
                params:{
                    path:"shareProducts"
                }
            },

            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            },
            "getSupplierProducts":{
                method:"GET",
                params:{
                    path:"getSupplierProducts",
                }
            },
            "grounding":{
                method:"GET",
                params:{
                    path:"grounding",
                }
            },
            "grounded":{
                method:"GET",
                params:{
                    path:"grounded",
                }
            }
        });
    }

    function CommodityPrice ($resource) {
        var resourceUrl =  'manager/' + 'api/commodity-prices/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getPriceByProductAndStore': {
                method: 'GET',
                params: {
                    path: 'getPriceByProductAndStore'
                }
            }
        })
    }

    function Tariffs ($resource) {
        var resourceUrl =  'manager/' + 'api/tariffs/:path/:id';

        return $resource(resourceUrl, {}, {
            'findByItemValueLineId': {
                method: 'GET',
                params: {
                    path: 'findByItemValueLineId'
                }
            }
        });
    }

    function PlatformSetting ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/platform-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'},
            'get': {
                method: 'GET'

            },
            'update': { method:'PUT' }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$scope', '$q', '$state', 'Product', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', 'DateUtils'];

    function ProductController($scope, $q, $state, Product, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.domains = Qinius.getDomain();

        $q.all([vm.domains.$promise]).then(function () {
            console.log(vm.domains)
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        $scope.delete = function (id) {
            MessageService.confirm("entity.action.deleteConfirm", function () {
                Product.delete({id: id}, function () {
                    loadAll();
                });
            }, function () {
            }, true);
        }

        function loadAll() {
            if (pagingParams.search) {
                Product.byCondition({
                    items: [{key: "name", op: "like", value: pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Product.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(res, headers) {
                if(res.status==200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.products = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message)
                }

            }

            function onError(error) {
                MessageService.error("产品获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.goToReadImage = function (pic) {
            // 遮罩层下面内容不滚动
            $('body').css("overflow", "hidden");
            $(".origin-image").removeClass('hide1');
            $(".modal-content").addClass('opacity-zero');
            $(".origin-image img").attr('src', pic);
        }

        $scope.backTo = function () {
            if ($scope.imageClick) {
                $scope.imageClick = false;
                return
            }
            $(".origin-image").addClass('hide1');
            $(".modal-content").removeClass('opacity-zero');
            $('body').css("overflow","auto");
        };

        // 滚动放大
        window.bbimg = function (o) {
            var pic = o.firstElementChild
            var zoom = parseInt(pic.style.zoom, 10) || 100;
            zoom += event.wheelDelta / 12;
            if (zoom > 0) pic.style.zoom = zoom + '%';
            return false;
        }

        $scope.clickToHide = function () {
            if ($scope.imageClick) {
                $scope.imageClick = false;
                return
            }
            $(".origin-image").addClass('hide1');
            $(".modal-content").removeClass('opacity-zero');
            $('body').css("overflow","auto");
        }


        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        window.moveImgStart = function (ev) {
            fn(ev);
            $scope.imageClick = true;
            var oEvent = ev;
            dragBox.clientX = oEvent.clientX || 0;
            dragBox.clientY = oEvent.clientY || 0;
            drag = true;

            document.addEventListener("mousemove", moveImgOn, true);
            document.addEventListener("mouseup", moveImgEnd, true);
        }

        //move事件
        function moveImgOn(ev) {
            var oEvent = ev;
            var oDiv = document.getElementById('origin-pic');
            if (drag) {
                fn(ev);
                if (dragBox.coordX == undefined || dragBox.coordY == undefined) {
                    dragBox.coordX = 0;
                    dragBox.coordY = 0;
                }
                oDiv.style.marginLeft = (dragBox.coordX + oEvent.clientX - dragBox.clientX) + "px";
                oDiv.style.marginTop = (dragBox.coordY + oEvent.clientY - dragBox.clientY) + "px";
            }
            $scope.$digest();
            return false;
        }

        //鼠标松开事件
        function moveImgEnd() {
            drag = false;
            dragBox = {};
            var oDiv = document.getElementById('origin-pic');
            dragBox.coordX = parseFloat(oDiv.style.marginLeft);
            dragBox.coordY = parseFloat(oDiv.style.marginTop);
            document.removeEventListener("mousemove", moveImgOn, true);
            document.removeEventListener("mouseup", moveImgEnd, true);
            $scope.$digest();
            return false;
        }


        //防止事件冒泡，默认事件
        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }

    }
})();

(function () {
    'use strict';

    var editorPreviewMini = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/product-ec/editor-preview-mini.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            fileName: '='
        },
        controller: ['$scope', '$stateParams', 'Qinius', '$http', '$q', 'Convert', 'FontManagement',
            'Article', 'Music', 'ItemValue', 'Store', 'MessageService', '$state', '$compile', '$timeout',
            function ($scope, $stateParams, Qinius, $http, $q, Convert, FontManagement,
                      Article, Music, ItemValue, Store, MessageService, $state, $compile, $timeout) {
                var vm = this;
                vm.aid = $stateParams.aid;
                vm.orderArticleId = $stateParams.orderArticleId;
                if (vm.aid) {
                    vm.article = Article.get({id: vm.aid});
                } else {
                    vm.article = Article.get({id: vm.orderArticleId});
                }
                $q.all([vm.article.$promise]).then(function() {
                    vm.article = vm.article.data;
                    Convert.xmlToDocument({
                        identifier: vm.fileName,
                        provider: 'qiniu'
                    }, function (res) {

                        vm.pages=[];
                        res.pages.page.forEach(function (page) {
                            if(!page.backup){
                                vm.pages.push(page)
                            }
                        })

                        vm.windowH = 500;
                        vm.windowW = document.documentElement.clientWidth / 2 - 30;
                        console.log(vm.windowW)
                        angular.forEach(vm.pages, function (page, index) {
                            (function (page, index) {
                                if (page.editbox == null) {
                                    page.editbox = page.trimbox;
                                }
                                page.editbox = {
                                    width: transitionPx(page.editbox.width),
                                    height: transitionPx(page.editbox.height),
                                    x: transitionPx(page.editbox.x),
                                    y: transitionPx(page.editbox.y)
                                };
                                page.mediabox = {
                                    width: transitionPx(page.mediabox.width),
                                    height: transitionPx(page.mediabox.height),
                                    x: transitionPx(page.mediabox.x),
                                    y: transitionPx(page.mediabox.y)
                                };
                                page.trimbox = {
                                    width: transitionPx(page.trimbox.width),
                                    height: transitionPx(page.trimbox.height),
                                    x: transitionPx(page.trimbox.x),
                                    y: transitionPx(page.trimbox.y)
                                };
                                page.custom = {};
                                if(vm.windowH / page.mediabox.height >= vm.windowW / page.mediabox.width ){
                                    page.custom.ratio = vm.windowW / page.mediabox.width;
                                }else {
                                    page.custom.ratio = vm.windowH / page.mediabox.height;
                                }
                                page.custom.width = page.mediabox.width;
                                page.custom.height = page.mediabox.height;
                                //条形码
                                if(page.barcode){
                                    page.barcode.geometry = {
                                        width: transitionPx(page.barcode.geometry.width),
                                        height: transitionPx(page.barcode.geometry.height),
                                        x: transitionPx(page.barcode.geometry.x),
                                        y: transitionPx(page.barcode.geometry.y)
                                    };
                                }

                                //背景
                                if(page.background && page.background.resource && page.background.resource.identifier){
                                    getBackgroundSource($http, page.background.resource,page.mediabox.width,page.mediabox.height,page.background.resource, $scope);
                                    page.background.offsetx = transitionPx(page.background.offsetx);
                                    page.background.offsety = transitionPx(page.background.offsety);
                                }
                                if(!page.levels.level){
                                    page.levels.level = [];
                                }
                                angular.forEach(page.levels.level, function (level, i) {
                                    if(level.imageart){
                                        level.imageart.lock = true;
                                        level.imageart.offsetx = transitionPx(level.imageart.offsetx);
                                        level.imageart.offsety = transitionPx(level.imageart.offsety);
                                        level.imageart.geometry = {
                                            width: transitionPx(level.imageart.geometry.width),
                                            height: transitionPx(level.imageart.geometry.height),
                                            x: transitionPx(level.imageart.geometry.x),
                                            y: transitionPx(level.imageart.geometry.y)
                                        };
                                        level.imageart.rotation.angle = -level.imageart.rotation.angle;
                                        if(level.imageart.resource.identifier){
                                            getBackgroundSource($http, level.imageart.resource,level.imageart.geometry.width,level.imageart.geometry.height,level.imageart.resource, $scope);
                                        }
                                    }
                                    if(level.imagebox){
                                        level.imagebox.lock = true;
                                        level.imagebox.geometry = {
                                            width: transitionPx(level.imagebox.geometry.width),
                                            height: transitionPx(level.imagebox.geometry.height),
                                            x: transitionPx(level.imagebox.geometry.x),
                                            y: transitionPx(level.imagebox.geometry.y)
                                        };
                                        level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                                        level.imagebox.useradded = true;
                                        level.imagebox.bokehtypes = level.imagebox.bokehtype;
                                        if(level.imagebox.image){
                                            level.imagebox.image.offsetx = transitionPx(level.imagebox.image.offsetx);
                                            level.imagebox.image.offsety = transitionPx(level.imagebox.image.offsety);
                                            if(level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                                getBackgroundSource1(level.imagebox.image.resource,level.imagebox.geometry.width,level.imagebox.geometry.height,level.imagebox.image, level.imagebox.bokehtypes, $scope)
                                            }
                                        }
                                        if(level.imagebox.blurredrectangle){
                                            level.imagebox.blurredrectangle = {
                                                width: transitionPx(level.imagebox.blurredrectangle.width),
                                                height: transitionPx(level.imagebox.blurredrectangle.height),
                                                x: transitionPx(level.imagebox.blurredrectangle.x),
                                                y: transitionPx(level.imagebox.blurredrectangle.y)
                                            };
                                        }
                                    }
                                    if(level.textbox){
                                        level.textbox.lock = true;
                                        level.textbox.geometry = {
                                            width: transitionPx(level.textbox.geometry.width),
                                            height: transitionPx(level.textbox.geometry.height),
                                            x: transitionPx(level.textbox.geometry.x),
                                            y: transitionPx(level.textbox.geometry.y)
                                        };
                                        level.textbox.rotation.angle = -level.textbox.rotation.angle;
                                        if(level.textbox.fontuuid){
                                            //下载字体
                                            getFontCSS(FontManagement, level.textbox, $scope);
                                        }
                                        if (level.textbox.style.bold && level.textbox.style.italic) {
                                            level.textbox.styles = 'BOLD_ITALIC';
                                        } else if (level.textbox.style.bold) {
                                            level.textbox.styles = 'BOLD';
                                        } else if (level.textbox.style.italic) {
                                            level.textbox.styles = 'ITALIC';
                                        } else {
                                            level.textbox.styles = 'NORMAL';
                                        }
                                    }
                                    if (level.textdocument && level.textdocument.geometry) {
                                        var textdocument = angular.copy(level.textdocument);
                                        level.textdocument = {
                                            background: textdocument.background,
                                            geometry: {
                                                width: transitionPx(textdocument.geometry.width),
                                                height: transitionPx(textdocument.geometry.height),
                                                x: transitionPx(textdocument.geometry.x),
                                                y: transitionPx(textdocument.geometry.y)
                                            },
                                            rotation: {
                                                angle:-textdocument.rotation.angle||0
                                            },
                                            current: 'textdocument',
                                            levels: angular.copy(textdocument.levels),
                                            lock: true,
                                            transparency: textdocument.transparency,
                                            movable: textdocument.movable,
                                            useradded: textdocument.useradded,
                                            editable: textdocument.editable,
                                            scale:textdocument.geometry.width/page.mediabox.width
                                        }

                                        var backg = textdocument.background;
                                        var pageW = textdocument.geometry.width,
                                            pageH = textdocument.geometry.height;
                                        if(backg.resource.identifier){
                                            getBackgroundSource($http, backg.resource,pageW,pageH,backg, $scope);
                                            backg.offsetx = transitionPx(backg.offsetx);
                                            backg.offsety = transitionPx(backg.offsety);
                                        }

                                        angular.forEach(textdocument.levels.level, function (lev, l) {
                                            if (lev.imageart && lev.imageart.geometry) {
                                                var art = lev.imageart;
                                                $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                                    level.textdocument.levels.level[l].imageart = {
                                                        geometry:{
                                                            width: transitionPx(art.geometry.width),
                                                            height: transitionPx(art.geometry.height),
                                                            x: transitionPx(art.geometry.x),
                                                            y: transitionPx(art.geometry.y)
                                                        },
                                                        rotation: angular.copy(art.rotation),
                                                        type: art.type,
                                                        resource: {
                                                            identifier:art.resource.identifier,
                                                            provider:art.resource.provider,
                                                            width:data.width,
                                                            height:data.height
                                                        },
                                                        scale:art.scale,
                                                        offsetx: transitionPx(art.offsetx),
                                                        offsety: transitionPx(art.offsety),
                                                        current: 'imageart',
                                                        lock: false,
                                                        transparency: art.transparency,
                                                        onlyshow: art.onlyshow,
                                                        movable: art.movable,
                                                        useradded: art.useradded,
                                                        editable: art.editable,
                                                    }
                                                }).error(function (error) {});
                                            }
                                            if (lev.textbox && lev.textbox.geometry) {
                                                var text = lev.textbox;
                                                level.textdocument.levels.level[l].textbox = {
                                                    geometry: {
                                                        width: transitionPx(text.geometry.width),
                                                        height: transitionPx(text.geometry.height),
                                                        x: transitionPx(text.geometry.x),
                                                        y: transitionPx(text.geometry.y)
                                                    },
                                                    identifier: text.identifier,
                                                    rotation: angular.copy(text.rotation),
                                                    angle: angular.copy(text.angle),
                                                    status: angular.copy(text.status),
                                                    style: angular.copy(text.style),
                                                    type: angular.copy(text.type),
                                                    text: angular.copy(text.text),
                                                    fontStyle: [{
                                                        style: '',
                                                        path: text.identifier
                                                    }],
                                                    current: 'textbox',
                                                    lock: false,
                                                    transparency: text.transparency,
                                                    fontuuid:text.fontuuid,
                                                    version:text.version
                                                }
                                                getFontCSS(FontManagement, text, $scope);
                                            }
                                        })
                                    }
                                })
                            })(page, index)
                        })
                        $timeout(function () {
                            console.log(vm.pages)
                            loadApp()
                            $scope.$digest();
                        },100)
                    })
                })
                function loadApp() {

                    var flipbook = $('.flipbook');

                    // Check if the CSS was already loaded

                    if (flipbook.width() == 0 || flipbook.height() == 0) {
                        setTimeout(loadApp, 10);
                        return;
                    }

                    $('.flipbook .flipbook-viewport-page').scissor();

                    // Create the flipbook

                    var _flipbook = $('.flipbook').turn({
                        width: vm.pages[0].custom.width * vm.pages[0].custom.ratio*2,
                        height: vm.pages[0].custom.height * vm.pages[0].custom.ratio,
                        accelerator: true,

                        // Enable gradients

                        gradients: true,

                        // Auto center this flipbook

                        autoCenter: true

                    });
                    $('.flipbook div').on("click", function (e) {
                        console.log(_flipbook.turn('page'))
                        // var _num = _flipbook.turn('page');
                        // var _num1 = "";
                        // if (_num % 2 === 0){
                        // 	_num1 = (_num-1) < 0 ? 0 : (_num-1);
                        //
                        // } else if (_num % 2 === 1){
                        // 	_num1 = _num+1;
                        // };
                        // console.log(_num1)
                        // _flipbook.turn('page', 2);
                        e.preventDefault()
                    })
                }
            }
        ]
    };

    angular
        .module('backApp')
        .component('editorPreviewMini', editorPreviewMini);
})();

(function () {
    'use strict';

    var articlePreviewWeb = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/product/article-preview-web.html',
        controllerAs: 'vm',
        bindings: {
            page: '=',
            previewArticle: '=',
            editorType: '=', //这里为什么传了editorType 和bindingtype 因为插件内没有去查article了 文档是直接从外面传进来的
            bindingtype :'='
        },

        controller: ['$scope', '$stateParams', '$q', 'Qinius', 'Store', '$http', '$rootScope', 'FontManagement', '$state',
            function ($scope, $stateParams, $q, Qinius, Store, $http, $rootScope, FontManagement, $state) {
                var vm = this;
                // $(".navbar").hide();
                vm.counts = 0;
                var itemsCount = 0;
                vm.storeId = $stateParams.storeId;
                vm.aid = $stateParams.aid;

                $scope.isRandomView = false;
                $scope.viewPage = false;
                $scope.viewTypes = ['默认', '斜插式', '横插式', '翻阅式', '下降式', '心跳式（快）', '心跳式（慢）', '摩天轮', '跳跃式', '旋转式', '下缩式', '缩放式', '上移式',
                    '翻转式', '顺滑式', '倒滑式', '滑行式', '轮播式', '扔除式', '左滑式', '右滑式', '左右滑式', '变换式', '挤兑式', '翻转式', '左右轮滑式',
                    '淡出式', '上推式', '下推式', '抖动式']

                var $li = $(".templateView-carousel");
                var returnurl = localStorage.getItem('returnurl');
                var $loading = $(".loading-page2");
                if (vm.page == 1) {
                    $(".save-page").hide();
                } else {
                    $loading.hide();
                }
                var unitTransform = function (mm) {
                    // mm换算成px  Math.ceil(mm / 25.4 * 300);
                    // return (mm * 3) - 0;
                    return mm / 25.4 * vm.windowDpiW;
                };
                var unitTransformPx = function (px) {
                    // px换算成mm  Math.floor(px / 300 * 25.4)
                    // return (px * 1 / 3).toFixed(2) - 0;
                    return px / vm.windowDpiW * 25.4;
                };


                js_getDPI()

                function js_getDPI() {
                    var arrDPI = new Array();
                    if (window.screen.deviceXDPI != undefined) {
                        arrDPI[0] = window.screen.deviceXDPI;
                        arrDPI[1] = window.screen.deviceYDPI;
                    } else {
                        var tmpNode = document.createElement("DIV");
                        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                        document.body.appendChild(tmpNode);
                        arrDPI[0] = parseInt(tmpNode.offsetWidth);
                        arrDPI[1] = parseInt(tmpNode.offsetHeight);
                        tmpNode.parentNode.removeChild(tmpNode);
                    }
                    vm.windowDpiW = arrDPI[0];
                    vm.windowDpiH = arrDPI[1];
                    vm.windowDpi = arrDPI[1];
                    console.log(arrDPI)
                    return arrDPI;
                }

                vm.fontuuids = [];
                $scope.k = 0;
                $scope.isText = false;

                var allWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                $scope.dHeight = vm.dHeight = ((window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)) / 1.5;
                $scope.dWidth = vm.dWidth = allWidth / 1.5;
                $scope.template = {
                    pages: {
                        page: [{}]
                    }
                };
                $scope.document = {
                    pages: [{}]
                };
                $scope.len = 0;

                $scope.domains = Qinius.getDomain();
                $(".modal-content").addClass('opacity0');
                vm.store = Store.get({id: vm.storeId});
                $scope.isPull = true;
                $q.all([$scope.domains.$promise,  vm.store.$promise]).then(function () {
                    vm.store = vm.store.data;
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    var doc = vm.previewArticle;
                    if (vm.editorType == "POSTER") {
                        vm.isPoster = true;
                        editorInit1(doc)
                    }else if(vm.editorType == "PICTURE" || vm.editorType == "PICTURE_PRO" || vm.editorType == "PICTURE_PRO_P"){
                        vm.modelType = 'PICTURE';
                        vm.page = doc.pages.page;
                        var windowRatio = 1;
                        vm.windowW1 = 140;
                        angular.forEach(vm.page, function (page) {
                            page.trimbox = {
                                height: transitionPx(page.trimbox.height),
                                width: transitionPx(page.trimbox.width),
                                x: transitionPx(page.trimbox.x),
                                y: transitionPx(page.trimbox.y)
                            }
                            page.ratio = vm.windowW1 / page.trimbox.width;
                            angular.forEach(page.levels.level, function (level) {
                                if(level.imagebox){
                                    level.imagebox.blurredrectangle={
                                        height: transitionPx(level.imagebox.blurredrectangle.height),
                                        width: transitionPx(level.imagebox.blurredrectangle.width),
                                        x: transitionPx(level.imagebox.blurredrectangle.x),
                                        y: transitionPx(level.imagebox.blurredrectangle.y)
                                    }
                                }
                            })
                        })
                        $(".save-page").hide();
                    } else {
                        vm.isPoster = false;
                        editorInit(doc)
                    }

                });

                function editorInit(doc) {
                    angular.forEach(doc.pages.page, function (page) {
                        if (page.backup) {
                            return
                        }
                        $scope.len++;
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                            }
                        })
                    });
                    //取得xml文档内容
                    if (vm.bindingtype == 'Left2') {
                        $scope.isPull = false;
                        vm.bindingtype = 'Left';
                    } else if(vm.bindingtype == 'LeftNew'){
                        vm.bindingtype = 'Left';
                    }else {
                        vm.bindingtype = vm.bindingtype;
                    }
                    // vm.bindingtype = 'None';
                    if (vm.bindingtype == 'Top') {
                        $scope.dHeight = vm.dHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 100;
                    }
                    localStorage.setItem('bindingtype', vm.bindingtype);
                    $scope.maxW = doc.pages.page[0].mediabox.width;
                    $scope.minW = doc.pages.page[0].mediabox.width;
                    $scope.maxH = doc.pages.page[0].mediabox.height;
                    $scope.minH = doc.pages.page[0].mediabox.height;
                    $(".modal-content").addClass('opacity0');
                    var arrUse = {
                        pages: {
                            page: []
                        }
                    };
                    angular.forEach(doc.pages.page, function (page) {
                        if (!page.backup) {
                            arrUse.pages.page.push(page);
                        }
                    });
                    $scope.getDetail(arrUse, 0);
                }

                function editorInit1(doc) {
                    vm.windowH = 960;
                    vm.windowW = 960;
                    $scope.template = angular.copy(doc);
                    angular.forEach($scope.template.pages.page, function (page, index) {

                        page.editbox = {
                            width: transitionPx(page.editbox.width),
                            height: transitionPx(page.editbox.height),
                            x: transitionPx(page.editbox.x),
                            y: transitionPx(page.editbox.y)
                        };
                        page.mediabox = {
                            width: transitionPx(page.mediabox.width),
                            height: transitionPx(page.mediabox.height),
                            x: transitionPx(page.mediabox.x),
                            y: transitionPx(page.mediabox.y)
                        };
                        page.trimbox = {
                            width: transitionPx(page.trimbox.width),
                            height: transitionPx(page.trimbox.height),
                            x: transitionPx(page.trimbox.x),
                            y: transitionPx(page.trimbox.y)
                        };
                        page.custom = {};
                        if (page.scene) {
                            page.scene.geometry = {
                                width: transitionPx(page.scene.geometry.width),
                                height: transitionPx(page.scene.geometry.height),
                                x: transitionPx(page.scene.geometry.x),
                                y: transitionPx(page.scene.geometry.y)
                            };
                            page.scene.imagebox.geometry = {
                                width: transitionPx(page.scene.imagebox.geometry.width),
                                height: transitionPx(page.scene.imagebox.geometry.height),
                                x: transitionPx(page.scene.imagebox.geometry.x),
                                y: transitionPx(page.scene.imagebox.geometry.y)
                            };
                            if (page.scene.resource) {
                                getBackgroundSource(page.scene.resource, page.scene.geometry.width, page.scene.geometry.height, page.scene.resource);
                            }

                            if (vm.windowH / page.scene.geometry.height >= vm.windowW / page.scene.geometry.width) {
                                page.custom.ratio = vm.windowW / page.scene.geometry.width * 0.8;
                            } else {
                                page.custom.ratio = vm.windowH / page.scene.geometry.height * 0.8;
                            }
                            page.custom.ratio1 = vm.windowW1 / page.scene.geometry.width * 0.8;
                            page.custom.width = page.scene.geometry.width;
                            page.custom.height = page.scene.geometry.height;
                        } else {
                            if (vm.windowH / page.mediabox.height >= vm.windowW / page.mediabox.width) {
                                page.custom.ratio = vm.windowW / page.mediabox.width * 0.8;
                            } else {
                                page.custom.ratio = vm.windowH / page.mediabox.height * 0.8;
                            }
                            page.custom.ratio1 = vm.windowW1 / page.mediabox.width * 0.8;
                            page.custom.width = page.mediabox.width;
                            page.custom.height = page.mediabox.height;
                        }
                        //条形码
                        if (page.barcode) {
                            page.barcode.geometry = {
                                width: transitionPx(page.barcode.geometry.width),
                                height: transitionPx(page.barcode.geometry.height),
                                x: transitionPx(page.barcode.geometry.x),
                                y: transitionPx(page.barcode.geometry.y)
                            };
                        }

                        //背景
                        if (page.background.resource.identifier) {
                            getBackgroundSource(page.background.resource, page.mediabox.width, page.mediabox.height, page.background.resource);
                            page.background.offsetx = transitionPx(page.background.offsetx);
                            page.background.offsety = transitionPx(page.background.offsety);
                        }
                        angular.forEach(page.levels.level, function (level, i) {
                            if (level.imageart) {
                                level.imageart.offsetx = transitionPx(level.imageart.offsetx);
                                level.imageart.offsety = transitionPx(level.imageart.offsety);
                                level.imageart.geometry = {
                                    width: transitionPx(level.imageart.geometry.width),
                                    height: transitionPx(level.imageart.geometry.height),
                                    x: transitionPx(level.imageart.geometry.x),
                                    y: transitionPx(level.imageart.geometry.y)
                                };
                                level.imageart.rotation.angle = -level.imageart.rotation.angle;
                                if (level.imageart.resource.identifier) {
                                    getBackgroundSource(level.imageart.resource, level.imageart.geometry.width, level.imageart.geometry.height, level.imageart.resource);
                                }
                            }
                            if (level.imagebox) {
                                level.imagebox.geometry = {
                                    width: transitionPx(level.imagebox.geometry.width),
                                    height: transitionPx(level.imagebox.geometry.height),
                                    x: transitionPx(level.imagebox.geometry.x),
                                    y: transitionPx(level.imagebox.geometry.y)
                                };
                                level.imagebox.rotation.angle = -level.imagebox.rotation.angle;

                                level.imagebox.bokehtypes = level.imagebox.bokehtype;
                                if (level.imagebox.image) {
                                    level.imagebox.image.offsetx = transitionPx(level.imagebox.image.offsetx);
                                    level.imagebox.image.offsety = transitionPx(level.imagebox.image.offsety);
                                    if (level.imagebox.image.resource.identifier) {
                                        getBackgroundSource2(level.imagebox.image.resource, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtypes)
                                    }
                                }
                                if (level.imagebox.blurredrectangle) {
                                    level.imagebox.blurredrectangle = {
                                        width: transitionPx(level.imagebox.blurredrectangle.width),
                                        height: transitionPx(level.imagebox.blurredrectangle.height),
                                        x: transitionPx(level.imagebox.blurredrectangle.x),
                                        y: transitionPx(level.imagebox.blurredrectangle.y)
                                    };
                                }
                            }
                            if (level.textbox) {
                                level.textbox.geometry = {
                                    width: transitionPx(level.textbox.geometry.width),
                                    height: transitionPx(level.textbox.geometry.height),
                                    x: transitionPx(level.textbox.geometry.x),
                                    y: transitionPx(level.textbox.geometry.y)
                                };
                                level.textbox.rotation.angle = -level.textbox.rotation.angle;
                                if (level.textbox.fontuuid) {
                                    //下载字体
                                    getFontCSS(level.textbox.fontuuid)
                                }
                                if (level.textbox.style.bold && level.textbox.style.italic) {
                                    level.textbox.styles = 'BOLD_ITALIC';
                                } else if (level.textbox.style.bold) {
                                    level.textbox.styles = 'BOLD';
                                } else if (level.textbox.style.italic) {
                                    level.textbox.styles = 'ITALIC';
                                } else {
                                    level.textbox.styles = 'NORMAL';
                                }
                            }
                            if (level.textdocument && level.textdocument.geometry) {
                                var textdocument = angular.copy(level.textdocument);
                                level.textdocument = {
                                    background: textdocument.background,
                                    geometry: {
                                        width: transitionPx(textdocument.geometry.width),
                                        height: transitionPx(textdocument.geometry.height),
                                        x: transitionPx(textdocument.geometry.x),
                                        y: transitionPx(textdocument.geometry.y)
                                    },
                                    rotation: {
                                        angle: -textdocument.rotation.angle || 0
                                    },
                                    current: 'textdocument',
                                    levels: angular.copy(textdocument.levels),
                                    lock: true,
                                    transparency: textdocument.transparency,
                                    movable: textdocument.movable,
                                    useradded: textdocument.useradded,
                                    editable: textdocument.editable,
                                    scale: textdocument.geometry.width / page.mediabox.width
                                }

                                var backg = textdocument.background;
                                var pageW = textdocument.geometry.width,
                                    pageH = textdocument.geometry.height;
                                if (backg.resource.identifier) {
                                    getBackgroundSource(backg.resource, pageW, pageH, backg);
                                    backg.offsetx = transitionPx(backg.offsetx);
                                    backg.offsety = transitionPx(backg.offsety);
                                }

                                angular.forEach(textdocument.levels.level, function (lev, l) {
                                    if (lev.imageart && lev.imageart.geometry) {
                                        var art = lev.imageart;
                                        $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                            level.textdocument.levels.level[l].imageart = {
                                                geometry: {
                                                    width: transitionPx(art.geometry.width),
                                                    height: transitionPx(art.geometry.height),
                                                    x: transitionPx(art.geometry.x),
                                                    y: transitionPx(art.geometry.y)
                                                },
                                                rotation: angular.copy(art.rotation),
                                                type: art.type,
                                                resource: {
                                                    identifier: art.resource.identifier,
                                                    provider: art.resource.provider,
                                                    width: data.width,
                                                    height: data.height
                                                },
                                                scale: art.scale,
                                                offsetx: transitionPx(art.offsetx),
                                                offsety: transitionPx(art.offsety),
                                                current: 'imageart',
                                                lock: false,
                                                transparency: art.transparency,
                                                onlyshow: art.onlyshow,
                                                movable: art.movable,
                                                useradded: art.useradded,
                                                editable: art.editable,
                                            }
                                        }).error(function (error) {
                                        });
                                    }
                                    if (lev.textbox && lev.textbox.geometry) {
                                        var text = lev.textbox;
                                        level.textdocument.levels.level[l].textbox = {
                                            geometry: {
                                                width: transitionPx(text.geometry.width),
                                                height: transitionPx(text.geometry.height),
                                                x: transitionPx(text.geometry.x),
                                                y: transitionPx(text.geometry.y)
                                            },
                                            identifier: text.identifier,
                                            rotation: angular.copy(text.rotation),
                                            angle: angular.copy(text.angle),
                                            status: angular.copy(text.status),
                                            style: angular.copy(text.style),
                                            type: angular.copy(text.type),
                                            text: angular.copy(text.text),
                                            fontStyle: [{
                                                style: '',
                                                path: text.identifier
                                            }],
                                            current: 'textbox',
                                            lock: true,
                                            transparency: text.transparency,
                                            fontuuid: text.fontuuid,
                                            version: text.version
                                        }
                                        getFontCSS(text.fontuuid)
                                    }
                                })
                            }
                        })
                    })
                    showPages();
                }

                function transitionPx(item) {
                    return item * vm.windowDpi / 25.4;
                }

                $scope.edit = function () {
                    if (vm.isPoster) {
                        $state.go('editorAllEdit', {storeId: vm.storeId, aid: vm.aid})
                    } else {
                        $state.go('page-my-suffix-remake', {storeId: vm.storeId, aid: vm.aid})
                    }
                }

                $scope.getDetail = function (document, index) {
                    var obj = document.pages.page[index];

                    $(".carousel-wrapper").height(document.pages.page[0].mediabox.height * (document.pages.page.length + 1.7));

                    $scope.template = document;
                    var bgIdentifier = null;
                    if (obj.background && obj.background.resource && obj.background.resource.identifier) {
                        bgIdentifier = obj.background.resource.identifier + '?imageMogr2/thumbnail/!40p';
                    }
                    var isMaxWidth = getScale($scope.dWidth, $scope.dHeight, obj.mediabox.width, obj.mediabox.height, index);

                    $scope.template.pages.page[index] = {
                        background: angular.copy(obj.background),
                        bgImg: bgIdentifier,
                        barcode: angular.copy(obj.barcode),
                        barcodeM: angular.copy(obj.barcode),
                        barcodeRotation: {
                            angle: obj.barcodeRotation ? obj.barcodeRotation.angle : 0
                        },
                        mediabox: angular.copy(obj.mediabox),
                        mediaboxPx: {},
                        levels: angular.copy(obj.levels),
                        isMaxWidth: isMaxWidth,
                        spread: obj.spread,
                        centerrotation: obj.centerrotation ? true : false,
                        'thumbnailH': isMaxWidth ? $scope.dWidth * 0.8 * unitTransform(obj.mediabox.height) / unitTransform(obj.mediabox.width) : $scope.dHeight * 0.7 * unitTransform(obj.mediabox.width) / unitTransform(obj.mediabox.height),
                        pageScaleH: 1,
                        pageScaleW: 1
                    };

                    // 无翻页效果
                    if (document.pages.page.length < 2 || vm.bindingtype == 'None') {
                        $scope.template.pages.page[index].styleScale = (vm.dWidth * 0.25 / (unitTransform(obj.mediabox.width)));
                    } else {
                        $scope.template.pages.page[index].styleScale = 1;
                    }


                    // 得到压缩比例后的最高page的高度
                    if ($scope.maxPageHeight < $scope.template.pages.page[index].thumbnailH) {
                        $scope.maxPageHeight = $scope.template.pages.page[index].thumbnailH;
                    }
                    if (obj.barcode) {
                        $scope.template.pages.page[index].barcode.geometry = getGeometry(obj.barcode.geometry, index);
                    }
                    $scope.template.pages.page[index].mediaboxPx = getGeometry(obj.mediabox, index)
                    $scope.template.pages.page[index].ratio = $scope.template.pages.page[index].mediaboxPx.width / ($scope.template.pages.page[index].mediabox.width / 25.4 * vm.windowDpiW)

                    var background = $scope.template.pages.page[index].background;
                    var w = $scope.template.pages.page[index].mediaboxPx.width,
                        h = $scope.template.pages.page[index].mediaboxPx.height;

                    if (background && background.resource) {
                        getBackgroundSource(background.resource, w, h, background)
                        background.offsetx = unitTransform(background.offsetx) * $scope.template.pages.page[index].styleScale
                        background.offsety = unitTransform(background.offsety) * $scope.template.pages.page[index].styleScale
                        background.offsetXM = angular.copy(background.offsetx);
                        background.offsetYM = angular.copy(background.offsety);
                    }

                    angular.forEach(obj.levels.level, function (level, l) {
                        var pageLevel = $scope.template.pages.page[index].levels.level[l];
                        if(pageLevel.code&&pageLevel.code.geometry){
                            var code = pageLevel.code;
                            code.geometry = getGeometry(code.geometry, index);
                        }
                        if (level.imageart && level.imageart.geometry) {
                            var art = level.imageart;
                            pageLevel.imageart = {
                                geometry: getGeometry(art.geometry, index),
                                rotation: {
                                    angle: -art.rotation.angle
                                },
                                type: art.type,
                                resource: {
                                    identifier: art.resource.identifier,
                                    provider: art.resource.provider
                                },
                                scale: art.scale,
                                widthM: art.geometry.width,
                                heightM: art.geometry.height,
                                XM: art.geometry.x,
                                YM: art.geometry.y,
                                offsetXM: angular.copy(art.offsetx),
                                offsetYM: angular.copy(art.offsety),
                                offsetx: unitTransform(art.offsetx) * $scope.template.pages.page[index].styleScale,
                                offsety: unitTransform(art.offsety) * $scope.template.pages.page[index].styleScale,
                                current: 'imageart',
                                levelI: l,
                                pageI: index,
                                transparency: art.transparency,
                                onlyshow: art.onlyshow,
                                movable: art.movable,
                                editable: art.editable,
                            }
                            $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                pageLevel.imageart.resource.width = data.width;
                                pageLevel.imageart.resource.height = data.height;
                            }).error(function (error) {
                            });
                        }
                        if (level.textbox && level.textbox.geometry) {
                            var text = level.textbox;
                            pageLevel.textbox = {
                                geometry: getGeometry(text.geometry, index),
                                identifier: text.identifier,
                                style: angular.copy(text.style),
                                rotation: {
                                    angle: -text.rotation.angle
                                },
                                text: text.text,
                                heightM: text.geometry.height,
                                widthM: text.geometry.width,
                                xM: text.geometry.x,
                                yM: text.geometry.y,
                                styles: 'NORMAL',
                                type: text.type,
                                status: text.status,
                                templateType: vm.edit ? text.type : '',
                                levelI: l,
                                transparency: text.transparency,
                                lineheight: text.style.lineheight,
                                letterspacing: text.style.letterspacing,
                                movable: text.movable,
                                editable: text.editable,
                                fontuuid: text.fontuuid,
                                version: text.version
                            };
                            if (text.fontuuid) {
                                //下载字体
                                if (vm.fontuuids.indexOf(text.fontuuid) == -1) {
                                    vm.fontuuids.push(text.fontuuid);
                                    getFontCSS(text.fontuuid)
                                }
                            }
                            var tempText = pageLevel.textbox;
                            if (tempText.style.bold && tempText.style.italic) {
                                tempText.styles = 'BOLD_ITALIC';
                            } else if (tempText.style.bold) {
                                tempText.styles = 'BOLD';
                            } else if (tempText.style.italic) {
                                tempText.styles = 'ITALIC';
                            } else {
                                tempText.styles = 'NORMAL';
                            }
                        }
                        if (level.imagebox && level.imagebox.geometry) {
                            var img = level.imagebox;
                            pageLevel.imagebox = {
                                geometry: getGeometry(img.geometry, index),
                                mask: angular.copy(img.mask),
                                imgUrl: 'content/images/mask_souce.png',
                                maskUrl: 'content/images/mask_souce.png',
                                rotation: {
                                    angle: -img.rotation.angle
                                },
                                scaleW: 1,
                                scaleH: 1,
                                bokehtype: img.bokehtype,
                                image: img.image
                            };

                            if (img.bokehtype != 'None' && img.blurredrectangle) {
                                pageLevel.imagebox.blurredrectangle = getGeometry(img.blurredrectangle, index)
                            }

                            if (img.mask.resource.identifier) {
                                pageLevel.imagebox.maskUrl = img.mask.resource.identifier + '?imageMogr2';
                            }


                            if (img.image && img.image.resource && img.image.resource.identifier) {       //qiniu
                                pageLevel.imagebox.image = {
                                    resource: {
                                        identifier: img.image.resource.identifier ? img.image.resource.identifier : '',
                                        provider: 'qiniu'
                                    },
                                    rotation: angular.copy(img.rotation),
                                    parameter: (!img.image) || img.image.parameter == null ? [] : angular.fromJson(img.image.parameter),
                                    filter: (!img.image) || img.image.filter == null ? '' : img.image.filter,
                                    offsetx: img.image.offsetx == 0 ? 0 : (unitTransform(img.image.offsetx) * $scope.template.pages.page[index].styleScale),
                                    offsety: img.image.offsety == 0 ? 0 : (unitTransform(img.image.offsety) * $scope.template.pages.page[index].styleScale),
                                    angle: img.image && img.image.angle ? img.image.angle : 0,
                                    scale: (!img.image) || img.image.scale == 1 ? 1 : img.image.scale
                                }
                                // level.imagebox.image.offsetx = unitTransform(img.image.offsetx) * $scope.template.pages.page[index].styleScale;
                                // level.imagebox.image.offsety = unitTransform(img.image.offsety) * $scope.template.pages.page[index].styleScale;
                                if (img.image.resource.identifier) {
                                    getBackgroundSource1(pageLevel.imagebox.image.resource, pageLevel.imagebox.geometry.width, pageLevel.imagebox.geometry.height, pageLevel.imagebox.image, img.bokehtype)
                                }
                            }
                        }
                        if (level.textdocument && level.textdocument.geometry) {
                            var textdocument = level.textdocument;
                            pageLevel.textdocument = {
                                background: textdocument.background,
                                geometry: getGeometry(textdocument.geometry, index),
                                widthM: textdocument.geometry.width,
                                heightM: textdocument.geometry.height,
                                offsetXM: textdocument.geometry.x,
                                offsetYM: textdocument.geometry.y,
                                rotation: {
                                    angle: textdocument.rotation.angle || 0
                                },
                                current: 'textdocument',
                                levels: angular.copy(textdocument.levels),
                                levelI: l,
                                pageI: index,
                                lock: true,
                                transparency: textdocument.transparency,
                                movable: textdocument.movable,
                                editable: textdocument.editable
                            }

                            var backg = pageLevel.textdocument.background;
                            var pageW = pageLevel.textdocument.geometry.width,
                                pageH = pageLevel.textdocument.geometry.height;
                            if (backg.resource.identifier) {
                                getBackgroundSource(backg.resource, pageW, pageH, backg)
                                backg.offsetx = unitTransform(backg.offsetx) * $scope.template.pages.page[index].styleScale
                                backg.offsety = unitTransform(backg.offsety) * $scope.template.pages.page[index].styleScale
                                backg.offsetXM = angular.copy(level.textdocument.background.offsetx);
                                backg.offsetYM = angular.copy(level.textdocument.background.offsety);
                            }

                            angular.forEach(textdocument.levels.level, function (lev, n) {
                                if (lev.imageart && lev.imageart.geometry) {
                                    var art = lev.imageart;
                                    pageLevel.textdocument.levels.level[n].imageart = {
                                        geometry: getGeometry(art.geometry, index),
                                        rotation: {
                                            angle: -art.rotation.angle
                                        },
                                        type: art.type,
                                        resource: {
                                            identifier: art.resource.identifier,
                                            provider: art.resource.provider
                                        },
                                        scale: art.scale,
                                        widthM: art.geometry.width,
                                        heightM: art.geometry.height,
                                        XM: art.geometry.x,
                                        YM: art.geometry.y,
                                        offsetXM: angular.copy(art.offsetx),
                                        offsetYM: angular.copy(art.offsety),
                                        offsetx: unitTransform(art.offsetx) * $scope.template.pages.page[index].styleScale,
                                        offsety: unitTransform(art.offsety) * $scope.template.pages.page[index].styleScale,
                                        current: 'imageart',
                                        levelI: l,
                                        pageI: index,
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        editable: art.editable,
                                    }
                                    $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                        pageLevel.textdocument.levels.level[n].imageart.resource.width = data.width;
                                        pageLevel.textdocument.levels.level[n].imageart.resource.height = data.height;
                                    }).error(function (error) {
                                    });
                                }
                                if (lev.textbox && lev.textbox.geometry) {
                                    var text = lev.textbox;
                                    pageLevel.textdocument.levels.level[n].textbox = {
                                        geometry: getGeometry(text.geometry, index),
                                        identifier: text.identifier,
                                        rotation: {
                                            angle: -text.rotation.angle
                                        },
                                        angle: angular.copy(text.angle),
                                        status: angular.copy(text.status),
                                        style: angular.copy(text.style),
                                        type: angular.copy(text.type),
                                        text: angular.copy(text.text),
                                        fontStyle: [{
                                            style: '',
                                            path: text.identifier
                                        }],
                                        widthM: text.geometry.width,
                                        heightM: text.geometry.height,
                                        offsetXM: text.geometry.x,
                                        offsetYM: text.geometry.y,
                                        current: 'textbox',
                                        levelI: n,
                                        pageI: index,
                                        lock: true,
                                        transparency: text.transparency,
                                        lineheight: text.style.lineheight,
                                        letterspacing: text.style.letterspacing,
                                        fontuuid: text.fontuuid,
                                        version: text.version
                                    }
                                    if (vm.fontuuids.indexOf(text.fontuuid) == -1) {
                                        vm.fontuuids.push(text.fontuuid);
                                        getFontCSS(text.fontuuid)
                                    }
                                }
                            })
                        }
                    });

                    if (index < document.pages.page.length - 1) {
                        $scope.getDetail(document, index + 1);
                    } else {
                        $scope.isLeftRotation = false;
                        if (vm.counts == 0) {
                            showPages();
                            $(".rightBtn").hide();
                        }
                        // 平铺
                        if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                            showPages();
                            $(".rightBtn").hide();
                        } else {
                            // 翻页
                            var arr = $scope.template;
                            angular.forEach(arr.pages.page, function (obj, index) {
                                getArr(arr, obj, index);
                            });
                        }

                        $scope.slide = $scope.template.pages.page[0];
                        itemsCount = $scope.len;
                    }
                    if (vm.counts == 0) {
                        var arr = angular.copy($scope.template);
                        angular.forEach(arr.pages.page, function (obj, index) {
                            getArr(arr, obj, index);
                        });
                    }

                };

                function getScale(screenW, screenH, pageW, pageH) {
                    var newH = angular.copy(screenH);
                    if (vm.bindingtype == 'Top' && screenW * 0.7 * pageH / pageW * 2 > screenH) {
                        newH = (newH - 100) / 2;
                    }

                    if (vm.bindingtype == 'Top') {
                        if (screenW / newH < pageW / pageH) {
                            //宽定，高不定
                            $scope.isMaxWidth = true;
                            return true;
                        } else {
                            //高定，宽不定
                            $scope.isMaxWidth = false;
                            return false;
                        }
                    } else {
                        if (screenW / newH > pageW / pageH) {
                            //宽定，高不定
                            $scope.isMaxWidth = true;
                            return true;
                        } else {
                            //高定，宽不定
                            $scope.isMaxWidth = false;
                            return false;
                        }
                    }
                }

                function getBackgroundSource(res, pageW, pageH, arr) {
                    $http({url: res.identifier + '?imageInfo'}).success(function (data) {
                        var bgW = data.width,
                            bgH = data.height;
                        // 高适配
                        var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                        // 宽适配
                        if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                            w = pageW;
                            h = pageW * bgH / bgW;
                            adaptation = 'Width';
                        }
                        arr.width = w;
                        arr.height = h;
                        arr.type = arr.type;
                        arr.adaptation = adaptation;
                    }).error(function (error) {
                    });
                }

                function getBackgroundSource1(res, pageW, pageH, item, bokehtypes) {
                    var newImg = new Image();
                    newImg.crossOrigin = "Anonymous";
                    newImg.src = res.identifier + '?imageMogr2/auto-orient/rotate/' + item.angle + '/thumbnail/!40p';
                    newImg.onload = function () {
                        var imgR = pageW / pageH;
                        var imgR1 = newImg.width / newImg.height;
                        if (bokehtypes == 'None') {
                            if (imgR >= imgR1) {
                                item.resource.adaptation = 'Height';
                                item.width = pageW;
                                item.height = pageW / newImg.width * newImg.height;
                            } else {
                                item.resource.adaptation = 'Width';
                                item.width = pageH / newImg.height * newImg.width;
                                item.height = pageH;
                            }
                        } else {
                            if (imgR >= imgR1) {
                                item.resource.adaptation = 'Height';
                                item.width = pageW;
                                item.height = pageW / newImg.width * newImg.height;
                                item.offsetx = 0;
                                item.offsety = (pageH - pageW / newImg.width * newImg.height) / 2;
                            } else {
                                item.resource.adaptation = 'Width';
                                item.width = pageH / newImg.height * newImg.width;
                                item.height = pageH;
                                item.offsetx = (pageW - pageH / newImg.height * newImg.width) / 2;
                                item.offsety = 0;
                            }
                        }
                        if (item.scale > 1) {
                            item.width *= item.scale;
                            item.height *= item.scale;
                            item.offsetx *= item.scale;
                            item.offsety *= item.scale;
                        }
                        $scope.$digest();
                    };
                }

                function getBackgroundSource2(res, pageW, pageH, item, bokehtypes) {
                    var newImg = new Image();
                    newImg.crossOrigin = "Anonymous";
                    newImg.src = res.identifier + '?imageMogr2/auto-orient/rotate/' + item.angle + '/thumbnail/!40p';
                    newImg.onload = function () {
                        var imgR = pageW / pageH;
                        var imgR1 = newImg.width / newImg.height;
                        if (bokehtypes == 'None') {
                            if (imgR >= imgR1) {
                                item.resource.adaptation = 'Height';
                                item.width = pageW;
                                item.height = pageW / newImg.width * newImg.height;
                            } else {
                                item.resource.adaptation = 'Width';
                                item.width = pageH / newImg.height * newImg.width;
                                item.height = pageH;
                            }
                        } else {
                            if (imgR >= imgR1) {
                                item.resource.adaptation = 'Height';
                                item.width = pageW;
                                item.height = pageW / newImg.width * newImg.height;
                                item.offsetx = 0;
                                item.offsety = (pageH - pageW / newImg.width * newImg.height) / 2;
                            } else {
                                item.resource.adaptation = 'Width';
                                item.width = pageH / newImg.height * newImg.width;
                                item.height = pageH;
                                item.offsetx = (pageW - pageH / newImg.height * newImg.width) / 2;
                                item.offsety = 0;
                            }
                        }
                        $scope.$digest();
                    };
                }

                function getFontCSS(item) {
                    FontManagement.getCss({uuid: item}, function (res) {
                        var style = document.createElement("style");
                        style.type = 'text/css';
                        try {
                            style.appendChild(document.createTextNode(res.data));
                        } catch (ex) {
                            style.stylesheet.cssText = res.message;
                        }
                        var Head = document.getElementsByTagName("head")[0];
                        Head.appendChild(style);
                    });
                }

                function getScale2(screenW, screenH, pageW, pageH) {
                    var newH = angular.copy(screenH);
                    if (vm.bindingtype == 'Top' && screenW * 0.7 * pageH / pageW * 2 > screenH) {
                        newH /= 2;
                    }

                    if (vm.bindingtype == 'Top') {
                        if (screenW / newH < pageW / pageH) {
                            //宽定，高不定
                            $scope.isMaxWidth = true;
                            // return true;
                        } else {
                            //高定，宽不定
                            $scope.isMaxWidth = false;
                            // return false;
                        }
                    } else {
                        if (screenW / newH > pageW / pageH) {
                            //宽定，高不定
                            $scope.isMaxWidth = true;
                            // return true;
                        } else {
                            //高定，宽不定
                            $scope.isMaxWidth = false;
                            // return false;
                        }
                    }
                }

                function getGeometry(obj, index) {
                    return {
                        height: unitTransform(obj.height) * $scope.template.pages.page[index].styleScale,
                        width: unitTransform(obj.width) * $scope.template.pages.page[index].styleScale,
                        x: unitTransform(obj.x) * $scope.template.pages.page[index].styleScale,
                        y: unitTransform(obj.y) * $scope.template.pages.page[index].styleScale
                    }
                }

                function getArr(arrs, obj, index) {
                    var w = obj.mediabox.width;
                    var h = obj.mediabox.height;
                    if (obj.spread) {
                        if (w / 2 > $scope.maxW) {
                            $scope.maxW = w / 2;
                        }
                        if (w / 2 < $scope.minW) {
                            $scope.minW = w / 2;
                        }
                    } else {
                        if (w > $scope.maxW) {
                            $scope.maxW = w;
                        }
                        if (w < $scope.minW) {
                            $scope.minW = w;
                        }
                    }

                    if (h > $scope.maxH) {
                        $scope.maxH = h;
                    }
                    if (w < $scope.minH) {
                        $scope.minH = h;
                    }
                    $scope.document.pages[index] = {
                        arr: obj,
                        arr2: '',
                        multiple: 0.45,
                        multiple2: 0.45,
                        width: w,
                        height: h,
                        spread: obj.spread,
                        'marginLeft': 0,
                        'thumbnail': 1,
                        'thumbnail2': 1,
                        id: obj.id,
                        mediabox: angular.copy(obj.mediabox)
                    };
                    setBgImg(index, arrs, obj);
                    if (index == $scope.len - 1 && vm.bindingtype != 'None') {
                        var page = $scope.document.pages;
                        getScale2($scope.dWidth, $scope.dHeight, page[0].mediabox.width, page[0].mediabox.height);

                        getPageThumbnail(page[0], page[0].spread);
                        var x = 1;
                        if (!$scope.isPull) {
                            x = 0;
                        }

                        for (var j = x; j < page.length; j++) {
                            page[j].halfWidth = ($scope.dWidth * page[j].multiple).toFixed(2);
                            //每个page宽度 和 最大page宽度 的比值
                            getPageThumbnail(page[j], page[0].spread);

                            if (j + 1 != page.length) {
                                getPageThumbnail(page[j + 1], page[j + 1].spread);
                            }
                            //跨页
                            if (page[j].spread == true) {
                                //左右翻页的清空
                                if (vm.bindingtype != 'Left') {
                                    if (!$scope.uadHeight) {
                                        $scope.uadHeight = page[j - 1].mediabox.height * 2
                                    }
                                    // page[j].marginTop = $scope.dWidth * 0.7 * ($scope.uadHeight - page[j].mediabox.height) * page[j].thumbnail / page[j].mediabox.width / 2;
                                    if ($scope.isMaxWidth) {
                                        var newW = $scope.dWidth * 0.7
                                    } else {
                                        var newW = ($scope.dHeight - 100) / 2 * page[j].mediabox.width / page[j].mediabox.height
                                    }
                                    page[j].marginTop = newW * ($scope.uadHeight - page[j].mediabox.height) * page[j].thumbnail / page[j].mediabox.width / 2;

                                }

                            } else if (page[j].spread == false && (page[j + 1] || []).spread == false && (!$scope.isPull || (j + 2) != page.length)) {
                                // console.log(j);
                                var arr = page[j + 1];
                                var arr0 = page[j];
                                page[j] = {
                                    id: arr0.id,
                                    width: arr0.mediabox.width,
                                    height: arr0.mediabox.height,
                                    arr: arr0.arr,
                                    spread: arr0.spread,
                                    multiple: arr0.multiple,
                                    thumbnail: arr0.thumbnail,
                                    marginLeft: arr0.halfWidth - $scope.dWidth * arr.multiple * arr.thumbnail,
                                    id2: arr.id,
                                    width2: arr.mediabox.width,
                                    height2: arr.mediabox.height,
                                    arr2: arr.arr,
                                    spread2: arr.spread,
                                    multiple2: arr.multiple,
                                    thumbnail2: arr.thumbnail
                                };
                                page.splice(j + 1, 1);
                                $scope.uadHeight = arr.mediabox.height + arr0.mediabox.height;
                            }
                            if (j == page.length - 1) {
                                $scope.document.pages = page;
                                showPages();

                                angular.forEach(page, function (paged) {
                                    if (vm.bindingtype == 'Top') {
                                        $scope.getPageWaHUad(paged, true);
                                        $scope.getPageWaHUad(paged, false);
                                    }
                                });

                                $scope.$watch('toggle.now', function () {
                                    if ($scope.toggle.now) {
                                        setTimeout(function () {
                                            Page.init();
                                        }, 600)

                                    }
                                });
                                $(".un-last:parent").css({width: '50%!important'})
                            }
                        }
                        $scope.document.pages = page;
                    }
                    if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                        showPages();
                        $(".rightBtn").hide();
                    }
                }

                function showPages() {
                    setTimeout(function () {
                        $(".save-page").hide();
                        $loading.hide();
                    })
                }

                function getPageThumbnail(page, spread) {
                    var pageW = page.mediabox.width;
                    if (spread) {
                        pageW /= 2;
                    }
                    if (pageW > 0) {
                        page.thumbnail = (pageW / $scope.maxW).toFixed(2)
                    }
                }

                function setBgImg(index, documents, obj) {
                    // if ((index - 1) > 0 && documents.pages[index].identifier && (index - 1) < (documents.pages.length - 2) && (obj.spread == false && documents.pages[index - 2].spread == false && (index - 2) != 0 && (documents.pages[index - 2].spread2) || (obj.spread == false && (documents.pages[index] || []).spread == false))) {
                    //     $scope.template.pages[index - 1].bgImg2 = $scope.domain + documents.pages[index].identifier;
                    // }
                    if (index <= 2) {
                        return
                    }
                    if (!documents.pages.page[index].identifier) {
                        return
                    }
                    if (index >= (documents.pages.page.length - 1)) {
                        return
                    }
                    if (obj.spread) {
                        return
                    }
                    if (!documents.pages.page[index - 2].spread && (documents.pages.page[index - 2].spread2)) {
                        $scope.document.pages[index - 1].arr2 = documents.pages.page[index];
                        return
                    }
                    if (!(documents.pages.page[index] || []).spread) {
                        $scope.document.pages[index - 1].arr2 = documents.pages.page[index];
                    }
                }

                $scope.getLiW = function (slide) {
                    if (vm.bindingtype == 'Top') {
                        if ($scope.isMaxWidth) {
                            return $scope.dWidth * 0.7
                        } else {
                            return ($scope.dHeight - 100) / 2 * slide.width / slide.height
                        }
                    } else {
                        if ($scope.isMaxWidth) {
                            return $scope.dWidth * 0.9
                            // return ''
                        } else {
                            return $scope.dWidth * 0.9
                        }

                    }
                };
                $scope.getUlW = function () {
                    if (vm.bindingtype == 'Top') {
                        if ($scope.isMaxWidth) {
                            return $scope.dWidth * 0.7
                        } else {
                            return ($scope.dHeight - 100) / 2 * $scope.document.pages[0].width / $scope.document.pages[0].height
                        }
                    } else {
                        return $scope.dWidth * 0.9
                    }
                };

                $scope.getPageWaHLar = function (slide, flag, marginFlag) {
                    if (vm.bindingtype != 'Left') {
                        return
                    }

                    if (!slide) {
                        return
                    }

                    if (!slide.arr) {
                        return
                    }

                    if (flag) {
                        var w = 0;
                        if (!marginFlag) {
                            if (!slide.arr2) {
                                return
                            }

                            w = $scope.dWidth * slide.multiple2 * slide.thumbnail2;
                            slide.arr2.pageScaleW = w / unitTransform(slide.width2);
                        } else {
                            w = $scope.dWidth * slide.multiple * slide.thumbnail;
                            slide.arr.pageScaleW = w / unitTransform(slide.width);

                        }
                        if (marginFlag && $scope.maxW != $scope.minW) {
                            if (slide.spread) {
                                slide.marginLeft = ($scope.dWidth * 0.9 - w) / 2;
                            } else {
                                slide.marginLeft = ($scope.dWidth * 0.45 - w);
                            }
                        }
                        return w;
                    } else {
                        var h = 0;
                        if (!marginFlag) {
                            if (!slide.arr2) {
                                return
                            }

                            h = $scope.dWidth * slide.multiple2 * slide.height2 * slide.thumbnail2 / slide.width2
                            slide.arr2.pageScaleH = h / unitTransform(slide.height2);
                        } else {
                            h = $scope.dWidth * slide.multiple * slide.height * slide.thumbnail / slide.width
                            slide.arr.pageScaleH = h / unitTransform(slide.height);
                        }
                        return h;
                    }
                };
                $scope.getPageWaHUad = function (slide, flag) {
                    if (vm.bindingtype != 'Top') {
                        return
                    }

                    if (!slide) {
                        return
                    }

                    if (!slide.arr) {
                        return
                    }

                    if (flag) {
                        var w1 = 0, w2 = 0;
                        if (slide.arr2) {
                            if ($scope.isMaxWidth) {
                                w2 = $scope.dWidth * 0.7 * slide.thumbnail2
                            } else {
                                w2 = ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2
                            }
                            slide.w2 = w2;
                            slide.arr2.w = w2;
                            slide.arr2.pageScaleW = w2 / unitTransform(slide.width2);

                        }
                        if ($scope.isMaxWidth) {
                            w1 = $scope.dWidth * 0.7 * slide.thumbnail
                        } else {
                            w1 = ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail
                        }
                        slide.w1 = w1;
                        slide.arr.w = w1;
                        slide.arr.pageScaleW = w1 / unitTransform(slide.width);
                    } else {
                        var h1 = 0, h2 = 0;
                        if (slide.arr2) {
                            if ($scope.isMaxWidth) {
                                h2 = $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2;
                            } else {
                                h2 = ($scope.dHeight - 100) / 2;
                            }
                            slide.h2 = h2;
                            slide.arr2.h = h2;
                            slide.arr2.pageScaleH = h2 / unitTransform(slide.height2);

                        }
                        if ($scope.isMaxWidth) {
                            h1 = $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                        } else {
                            h1 = ($scope.dHeight - 100) / 2;
                        }
                        slide.h1 = h1;
                        slide.arr.h = h1;
                        slide.arr.pageScaleH = h1 / unitTransform(slide.height);
                    }
                };

                $scope.getPageWaHUad1 = function (slide, flag) {
                    if (vm.bindingtype != 'Top') {
                        return
                    }

                    if (!slide) {
                        return
                    }

                    if (!slide.arr) {
                        return
                    }

                    if (flag) {
                        var w = 0;
                        if (slide.arr2) {
                            if ($scope.isMaxWidth) {
                                w = $scope.dWidth * 0.7 * slide.thumbnail2
                            } else {
                                w = ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2
                            }
                            slide.w2 = w;
                            slide.arr2.w = w;
                            slide.arr2.pageScaleW = w / unitTransform(slide.width2);

                        } else {
                            if ($scope.isMaxWidth) {
                                w = $scope.dWidth * 0.7 * slide.thumbnail
                            } else {
                                w = ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail
                            }
                            slide.w1 = w;
                            slide.arr.w = w;
                            slide.arr.pageScaleW = w / unitTransform(slide.width);
                        }
                        // var w = slide.bgImg2 ? !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 * slide.width2 / slide.height2 * slide.thumbnail2 : $scope.dWidth * 0.7 * slide.thumbnail2 : !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 * slide.width / slide.height * slide.thumbnail : $scope.dWidth * 0.7 * slide.thumbnail;
                        return w;
                    } else {
                        var h = 0;
                        if (slide.arr2) {
                            if ($scope.isMaxWidth) {
                                h = $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2;
                            } else {
                                h = ($scope.dHeight - 100) / 2;
                            }
                            slide.h2 = h;
                            slide.arr2.h = h;
                            slide.arr2.pageScaleH = h / unitTransform(slide.height2);

                        } else {
                            if ($scope.isMaxWidth) {
                                h = $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                            } else {
                                h = ($scope.dHeight - 100) / 2;
                            }
                            slide.h1 = h;
                            slide.arr.h = h;
                            slide.arr.pageScaleH = h / unitTransform(slide.height);

                        }
                        return h;
                    }
                };
                $scope.getPageScaleUad = function (slide, flag) {
                    if (vm.bindingtype != 'Top') {
                        return
                    }

                    if (!slide) {
                        return
                    }

                    if (!slide.arr) {
                        return
                    }

                    if (flag) {
                        var pageScaleW = 0;
                        if (slide.arr2) {
                            slide.arr2.pageScaleW = pageScaleW = slide.arr2.w / unitTransform(slide.width2);

                        } else {
                            slide.arr.pageScaleW = pageScaleW = slide.arr.w / unitTransform(slide.width);
                        }
                        return pageScaleW;
                    } else {
                        var pageScaleH = 0;
                        if (slide.arr2) {
                            slide.arr2.pageScaleH = pageScaleH = slide.arr2.h / unitTransform(slide.height2);

                        } else {
                            slide.arr.pageScaleH = pageScaleH = slide.arr.h / unitTransform(slide.height);

                        }
                        // var h = slide.bgImg2 ? !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 : $scope.dWidth * 0.7 * slide.height2 * slide.thumbnail2 / slide.width2 : !$scope.isMaxWidth ? ($scope.dHeight - 100) / 2 : $scope.dWidth * 0.7 * slide.height * slide.thumbnail / slide.width;
                        return pageScaleH;
                    }
                };

                $scope.toggle = {
                    now: false
                };
                var Page = (function () {
                    var pageI = 0;
                    var config = {
                            $bookBlock: $('#bb-bookblock'),
                            $navNext: $('#bb-nav-next'),
                            $navPrev: $('#bb-nav-prev'),
                            $slide1: $('#slide1'),
                            $slide2: $('#slide2')
                        },
                        init = function () {
                            config = {
                                $bookBlock: $('#bb-bookblock'),
                                $navNext: $('#bb-nav-next'),
                                $navPrev: $('#bb-nav-prev'),
                                $slide1: $('#slide1'),
                                $slide2: $('#slide2')
                            };
                            if (vm.bindingtype == 'Left') {
                                config.$bookBlock.bookblock({
                                    speed: 800,
                                    shadowSides: 0.8,
                                    shadowFlip: 0.7,
                                    len: $scope.document.pages.length
                                });
                            } else {
                                $(".bb-item").addClass('lar-noShadow');
                                config.$bookBlock.bookblock({
                                    orientation: 'horizontal',
                                    speed: 700
                                });
                            }
                            initEvents();
                        },
                        initEvents = function () {
                            var $slides = config.$bookBlock.children();

                            // add navigation events
                            config.$navNext.on('click touchstart', function () {
                                config.$bookBlock.bookblock('next');
                                pageI = localStorage.getItem('pageI');
                                nextShow(pageI - 1);
                                return false;
                            });

                            config.$navPrev.on('click touchstart', function () {
                                config.$bookBlock.bookblock('prev');
                                pageI = localStorage.getItem('pageI');
                                prevShow(pageI - 0 + 1);
                                return false;
                            });

                            // add swipe events
                            $slides.on({
                                'click': function (event) {
                                    fn(event);
                                    var index = event.currentTarget.dataset.index;
                                    var page = $scope.document.pages[index];

                                    // var mar = parseFloat($(".wrap").css("marginLeft")) + parseFloat($(".wrap").css("paddingLeft"))
                                    var mar = $(".view-article").offset().left;
                                    var w = $(".view-article").width() / 2 + mar;

                                    if (vm.bindingtype == 'Left') {
                                        if (event.clientX > (w)) {
                                            getPageWidth(index - 0 + 1, 'next', config);
                                            nextShow(index);
                                        } else {
                                            getPageWidth(index - 1, 'prev', config);
                                            prevShow(index);
                                        }
                                    } else if (vm.bindingtype == 'Top') {
                                        // 120px---->bb-bg 上方高度
                                        if (event.clientY > 30 + $(".bb-item").eq(index).height() / 2) {
                                            //最后一页的时候禁止点击
                                            if (index == $scope.document.pages.length - 1) {
                                                return
                                            }
                                            config.$bookBlock.bookblock('next');
                                            nextShow(index);
                                        } else {
                                            config.$bookBlock.bookblock('prev');
                                            prevShow(index);
                                        }

                                        if ($scope.document.pages[index].spread == true) {
                                            $(".bb-horizontal .bb-page").css({top: '50.1%'})
                                        }
                                    }
                                    return false;
                                }
                            });
                        };

                    return {init: init};

                })();

                function nextShow(index) {
                    var len = $scope.document.pages.length;
                    $(".leftBtn").show();
                    if (index - 0 + 1 == len - 1) {
                        $(".rightBtn").hide();
                    }
                }

                function prevShow(index) {
                    $(".rightBtn").show();
                    if (index - 1 == 0) {
                        $(".leftBtn").hide();
                    }
                }

                function getPageWidth(index, attr, config) {
                    if (!$scope.isMaxWidth) {
                        var page = $scope.document.pages[index];
                        var w = $scope.dWidth * page.multiple * page.thumbnail + $scope.dWidth * page.multiple2 * page.thumbnail2;
                        // console.log(w);
                        $li.width(w);
                        $("#bb-bookblock").width(w);
                    } else {
                        $li.width($("#bb-bookblock").width());
                    }
                    config.$bookBlock.bookblock(attr);
                }

                $scope.backTo = function () {
                    // $uibModalInstance.dismiss('cancel');

                    $(".listBGC").show();
                    $(".modal-content").show().removeClass('opacity0');
                };
                vm.qrcodeShow = false
                $scope.shareParents = function () {
                    vm.qrcodeShow = !vm.qrcodeShow;
                }

                $scope.reorder = function () {
                    window.location.href = returnurl;
                }

                //防止事件冒泡，默认事件
                function fn(e) {
                    e = e || event;
                    e.cancelBubble = true;
                    e.stopPropagation();
                    e.returnValue = false;
                    e.preventDefault();
                }


            }]
    };

    angular
        .module('backApp')
        .component('articlePreviewWeb', articlePreviewWeb);
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProcessSpotColorDialogController', ProcessSpotColorDialogController);

    ProcessSpotColorDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Process'];

    function ProcessSpotColorDialogController($scope, $uibModalInstance, entity, Process) {
        var vm = this;

        vm.process = entity;
        vm.operationValues = angular.copy(vm.process.operationValues || []);
        vm.clear = clear;
        vm.save = save;
        vm.addOperationValue = addOperationValue;
        vm.removeOperationValue = removeOperationValue;
        vm.quantityType = (vm.process.type == 'HOT_STAMP' || vm.process.type == 'UV' || vm.process.type == 'FLUORESCENT' ) ? 'MULTIPLE' : 'SINGLE'

        function addOperationValue() {
            vm.operationValues.push({
                alias: '',
                spotColor: '',
                color: '#000000',
                seq: vm.operationValues.length + 1,
                cancelled: false
            });
        }

        function removeOperationValue(index) {
            vm.operationValues.splice(index, 1);
            // angular.forEach(vm.operationValues, function (item, idx) {
            //     item.seq = idx + 1;
            // });
        }

        function save() {
            vm.isSaving = true;
            vm.process.operationValues = vm.operationValues;
            var data = {
                id: vm.process.id,
                name: vm.process.name,
                alias: vm.process.alias,
                type: vm.process.type,
                quantityType: vm.process.quantityType,
                spotColor: vm.process.spotColor,
                epitaxy: vm.process.epitaxy,
                epitaxyValue: vm.process.epitaxyValue,
                remark: vm.process.remark,
                unit: vm.process.unit,
                cancelled: vm.process.cancelled || false,
                origin: 'STORE',
                operationValues: vm.process.operationValues || []
            };
            if (data.id) {
                Process.update(data, onSaveSuccess, onSaveError);
            } else {
                Process.save(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:processUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProcessDialogController', ProcessDialogController);

    ProcessDialogController.$inject = ['$scope', '$uibModalInstance', '$uibModal', 'entity', 'Process',
        'MessageService', 'AlertService'
    ];

    function ProcessDialogController($scope, $uibModalInstance, $uibModal, entity, Process,
        MessageService, AlertService) {
        var vm = this;

        vm.process = entity ? entity : {};
        vm.quantityType = (vm.process.type == 'HOT_STAMP' || vm.process.type == 'UV' || vm.process.type === 'FLUORESCENT')? 'MULTIPLE' : 'SINGLE'
        if(!vm.process.unit){
            vm.process.unit = 'mm'
        }
        vm.clear = clear;
        vm.save = save;
        vm.onUnitChange = onUnitChange;
        vm.onEpitaxyValueChange = onEpitaxyValueChange;
        vm.onEpitaxyKeyDown = onEpitaxyKeyDown;
        vm.getEpitaxyMin = getEpitaxyMin;
        vm.getEpitaxyMax = getEpitaxyMax;
        vm.getEpitaxyStep = getEpitaxyStep;

        function onUnitChange() {
            vm.process.epitaxyValue = null;
        }

        function onEpitaxyKeyDown(e) {
            var key = e.key;
            if (key === '-' || key === '+' || key === 'e' || key === 'E') {
                e.preventDefault();
                return;
            }
            if (key === '.' && vm.process.unit === 'px') {
                e.preventDefault();
                return;
            }
            if (key === '.' && vm.process.unit === 'mm') {
                var current = String(vm.process.epitaxyValue || '');
                if (current.indexOf('.') !== -1) {
                    e.preventDefault();
                }
            }
        }

        function onEpitaxyValueChange() {
            var v = vm.process.epitaxyValue;
            if (v === null || v === undefined || v === '') {
                return;
            }
            var num = Number(v);
            if (isNaN(num)) {
                vm.process.epitaxyValue = null;
                return;
            }
            if (vm.process.unit === 'mm') {
                if (num < 0) num = 0;
                if (num > 10) num = 10;
                num = Math.floor(num * 10) / 10;
                vm.process.epitaxyValue = num;
            } else if (vm.process.unit === 'px') {
                if (num < 0) num = 0;
                if (num > 100) num = 100;
                num = Math.floor(num);
                vm.process.epitaxyValue = num;
            }
        }

        function getEpitaxyMin() {
            return 0;
        }

        function getEpitaxyMax() {
            return vm.process.unit === 'mm' ? 10 : (vm.process.unit === 'px' ? 100 : undefined);
        }

        function getEpitaxyStep() {
            return vm.process.unit === 'mm' ? 0.1 : (vm.process.unit === 'px' ? 1 : 'any');
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if(vm.process.epitaxy){
                if(vm.process.epitaxyValue === null || vm.process.epitaxyValue === undefined || vm.process.epitaxyValue === ''){
                    MessageService.error("请填写扩收参数");
                    return;
                }
                var value = Number(vm.process.epitaxyValue);
                if(vm.process.unit === 'mm'){
                    if(isNaN(value) || value < 0 || value > 10 || !/^\d+(\.\d)?$/.test(String(vm.process.epitaxyValue))){
                        MessageService.error("扩收参数必须为0-10且最多一位小数");
                        return;
                    }
                } else if(vm.process.unit === 'px'){
                    if(isNaN(value) || value < 0 || value > 100 || !/^\d+$/.test(String(vm.process.epitaxyValue))){
                        MessageService.error("扩收参数必须为0-100的整数");
                        return;
                    }
                } else {
                    MessageService.error("请选择单位");
                    return;
                }
            }else{
                vm.process.epitaxy = null;
                vm.process.epitaxyValue = 0;
            }
            vm.isSaving = true;
            var data = {
                id: vm.process.id,
                name: vm.process.name,
                alias: vm.process.alias,
                type: vm.process.type,
                quantityType: vm.process.quantityType,
                spotColor: vm.process.spotColor,
                epitaxy: vm.process.epitaxy,
                epitaxyValue: vm.process.epitaxyValue,
                remark: vm.process.remark,
                unit: vm.process.unit,
                cancelled: vm.process.cancelled || false,
                origin: vm.process.origin || 'STORE',
                operationValues: vm.process.operationValues || []
            };
            if (data.id) {
                Process.update(data, onSaveSuccess, onSaveError);
            } else {
                Process.save(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:processUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('process', {
                parent: 'entity',
                url: '/process?page&sort&search',
                data: {
                    authorities: ['ROLE_PROCESS_OPERATION'],
                    pageTitle: 'backApp.process.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/process/processes.html',
                        controller: 'ProcessController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('process');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('process.edit', {
                parent: 'process',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_PROCESS_OPERATION']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/process/process-dialog.html',
                        controller: 'ProcessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('process');
                                return $translate.refresh();
                            }],
                            entity: ['Process', function (Process) {
                                return Process.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('process', null, {reload: 'process'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('Process', Process);

    Process.$inject = ['$resource'];

    function Process($resource) {
        var resourceUrl = 'manager/api/process-operations/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {
                    // path: '',
                    origin: 'STORE'
                }
            },
            'get': {
                method: 'GET',
                params: {
                    path: ''
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                params: {
                    path: ''
                }
            },
            'save': {
                method: 'POST',
                params: {
                    path: ''
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProcessController', ProcessController);

    ProcessController.$inject = ['$uibModal', 'Process', 'AlertService'];

    function ProcessController($uibModal, Process, AlertService) {
        var vm = this;

        vm.processes = [];
        vm.page = 1;
        vm.openSpotColorDialog = openSpotColorDialog;

        loadAll();

        function loadAll() {
            Process.query({
                page: 0,
                size: 200,
                sort: ['id']
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.processes = data.data || [];
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function openSpotColorDialog(process) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/process/process-spot-color-dialog.html',
                controller: 'ProcessSpotColorDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: function () {
                        return process;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                // 保存成功后刷新列表
                loadAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PayOrderDialogController', PayOrderDialogController);

    PayOrderDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'PayOrder', 'MessageService',
    '$http', '$sce', '$state', 'PaidGiftSetting'];

    function PayOrderDialogController ($timeout, $scope, $stateParams,  entity, PayOrder, MessageService,
        $http, $sce, $state, PaidGiftSetting) {
        var vm = this;

        vm.store = entity.data;
        vm.prepare = false;
        vm.payMethod = "WeChat";
        vm.otherAmount = false;
        vm.amountId = "";
        PaidGiftSetting.getAllByCondition({},function (res) {
            if(res.status == 200){
                vm.payList = res.data;
            }else{
                MessageService.error(res.message);
            }
        });
        $scope.payCb = function(data){
            vm.otherAmount = false;
            vm.amount = data.amount;
            vm.amountId = data.id;
        };
        $scope.payCb1 = function(){
            vm.otherAmount = true;
            vm.amount = "";
            vm.amountId = "";
        };

        $scope.changePayMethod = function(method){
            if (method == null) {
                return;
            }
            vm.payMethod = method;
            console.log(vm.payMethod)
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.recharge = function() {
            if (vm.store.balance !=0 && vm.store.balance >= 100000000) {
                MessageService.error("当前账户余额较多，请消费后再充值");
                return;
            }
            if (vm.payMethod == null || vm.payMethod == "") {
                MessageService.error("请选择支付方式");
                return;
            }
            if (vm.amount == null || vm.amount == "") {
                MessageService.error("请输入充值金额");
                return;
            }
            vm.amount = Math.floor(vm.amount * 100) / 100;
            if (vm.amount<0.01) {
                MessageService.error("请输入有效充值金额");
                return;
            };
            clearInterval($scope.timer);
            var data = {
                type: vm.payMethod,
                amount: vm.amount,
                name: "商户充值"
            }
            PayOrder.createPayOrder2(data ,function(result){
                if(result.status==200){
                    vm.payOrderId = result.data.id;
                    if (result.data.type == "WeChat") {
                        $http({
                            url: '/manager/api/pay-orders/createQRCode/'+vm.payOrderId,
                            method: 'POST',
                            responseType: 'blob'
                        }).success(function(res) {
                            vm.prepare = true;
                            var blob = new Blob([res], {
                                type: "image/jpeg"
                            });
                            $scope.image = URL.createObjectURL(blob);
                            //启动一个定时器判断是否完成支付，完成则关闭页面 取消定时器
                            $scope.timer = setInterval(function() {
                                PayOrder.get({
                                    id: vm.payOrderId
                                }, function(val) {
                                    if(val.status==200){
                                        if (!!val.data && val.data.paid) {
                                            clearInterval($scope.timer);
                                            MessageService.success("支付完成");
                                            $state.go("pay-order",{reload:true});
                                        }
                                    }else{
                                        MessageService.error(val.message);
                                    }
                                }, function() {});
                            }, 2000);
                        })
                    }else{
                        PayOrder.aliPay({
                            id:result.data.id,
                            returnUrl:window.location.href
                        },function(data){
                            if(!!data && data.status == 200){
                                $scope.trustHtml = $sce.trustAsHtml(data.data);
                            }
                        },function(){
                        });
                    }
                }else{
                    MessageService.error(result.message);
                }

            },function(){
                MessageService.error("创建充值订单失败，请稍后再试");
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PayOrderDetail1Controller', PayOrderDetail1Controller);

    PayOrderDetail1Controller.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'CommodityPrice', 'Product', 'Store', '$state', 'PayOrder', '$http', 'MessageService', '$sce'];

    function PayOrderDetail1Controller ($timeout, $scope, $stateParams, $q, entity, CommodityPrice, Product, Store, $state, PayOrder, $http, MessageService, $sce) {
        var vm = this;
        Store.getCurrent({},function (res) {
            if(res.status == 200){
                vm.store = res.data;
            }else{
                MessageService.error(res.message);
            }
        });
        vm.pay = entity.data;
        vm.cancel = cancel;
        vm.isPay = false;
        vm.payOrderId = "";


        $scope.recharge = function() {
            if (vm.store.balance !=0 && vm.store.balance >= 100000000) {
                MessageService.error("当前账户余额较多，请消费后再充值");
                return;
            }
            clearInterval($scope.timer);
            PayOrder.get({id:vm.pay.id} ,function(res){
                if(res.status == 200){
                    vm.payOrderId = res.data.id;
                    if (res.data.type == "WeChat") {
                        $http({
                            url: '/back/manager/api/pay-orders/createQRCode/'+vm.payOrderId,
                            method: 'POST',
                            responseType: 'blob'
                        }).success(function(res) {
                            vm.isPay = true;
                            var blob = new Blob([res], {
                                type: "image/jpeg"
                            });
                            $scope.image = URL.createObjectURL(blob);
                            //启动一个定时器判断是否完成支付，完成则关闭页面 取消定时器
                            $scope.timer = setInterval(function() {
                                PayOrder.get({
                                    id: vm.payOrderId
                                }, function(val) {
                                    if (!!val && val.paid) {
                                        clearInterval($scope.timer);
                                        MessageService.success("支付完成");
                                        vm.isPay = false;
                                        loadAll();
                                    }
                                }, function() {});
                            }, 2000);
                        })
                    }else{
                        PayOrder.aliPay({
                            id:res.data.id,
                            returnUrl:window.location.href
                        },function(data){
                            if(!!data && data.status == 200){
                                $scope.trustHtml = $sce.trustAsHtml(data.data);
                            }
                        },function(){
                        });
                    }
                }else{
                    MessageService.error(res.message);
                }
            },function(){
                MessageService.error("创建充值订单失败，请稍后再试");
            })
        }

        $scope.savePay = function () {
            PayOrder.get({
                id: vm.payOrderId
            }, function(res) {
                clearInterval($scope.timer);
                vm.isPay = false;
                if(res.status == 200){
                    if (!!res.data && res.data.paid) {
                        $state.go('pay-order');
                        MessageService.success("支付完成");
                    }else {
                        MessageService.error("支付失败");
                    }
                }else{
                    MessageService.error(res.message);
                }
            }, function() {
                MessageService.error("支付失败");
            });
        }
        $scope.cancelPay = function () {
            clearInterval($scope.timer);
            vm.isPay = false;
        }

        $scope.delete = function () {
            MessageService.confirm("确认取消当前支付信息吗？",function(){
                PayOrder.delete({id: vm.pay.id},function (res) {
                    if(res.status == 200){
                        $state.go('pay-order')
                        MessageService.success('取消成功');
                    }else{
                        MessageService.error(res.message);
                    }
                });
            },function(){},true);
        }


        //返回
        function cancel() {
            $state.go('pay-order')
        }


        vm.type = type;
        function type(target) {
            switch (target) {
                case "WeChat":
                    return "微信";
                default:
                    return "";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pay-order', {
            parent: 'pay-orderNew',
            url: '/pay-order?page&sort&search&startTime&endTime&type&paid',
            data: {
                authorities: ["ROLE_RECHARGE_RECORD"],
                pageTitle: 'global.menu.entities.payOrder'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pay-order/pay-orders.html',
                    controller: 'PayOrderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        startTime: $stateParams.startTime,
                        endTime: $stateParams.endTime,
                        type: $stateParams.type,
                        paid: $stateParams.paid
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payOrder');
                    $translatePartialLoader.addPart('settlementMethod');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pay-order2', {
            parent: 'entity',
            url: '/pay-order2',
            data: {
                authorities: ["ROLE_INVOICE_SUBMIT"],
                pageTitle: 'global.menu.entities.invoiceApplication'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pay-order/pay-orders2.html',
                    controller: 'PayOrderController2',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payOrder');
                    $translatePartialLoader.addPart('settlementMethod');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice-new', {
            parent: 'pay-order',
            url: '/pay-order/invoice/{id}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-detail.html',
                    controller: 'InvoiceNewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('invoice');
                            return $translate.refresh();
                        }],
                        entity: ['PayOrder', function(PayOrder) {
                            return PayOrder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pay-order', null, { reload: 'pay-order' });
                }, function() {
                    $state.go('pay-order');
                });
            }]
        })
        .state('pay-order-detail', {
            parent: 'entity',
            url: '/pay-order/{id}',
            data: {
                authorities: [],
                pageTitle: 'backApp.payOrder.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pay-order/pay-order-detail.html',
                    controller: 'PayOrderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payOrder');
                    $translatePartialLoader.addPart('settlementMethod');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PayOrder', function($stateParams, PayOrder) {
                    return PayOrder.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pay-order',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pay-order-detail.edit', {
            parent: 'pay-order-detail',
            url: '/detail/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pay-order/pay-order-dialog.html',
                    controller: 'PayOrderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PayOrder', function(PayOrder) {
                            return PayOrder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pay-orderNew', {
            parent: 'entity',
            url: '/pay-orderNew',
            data: {
                authorities: ["ROLE_RECHARGE"],
                pageTitle: 'global.menu.entities.storeRecharge'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pay-order/pay-order-dialog.html',
                    controller: 'PayOrderDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('store');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Store', function(Store) {
                    return Store.getCurrent().$promise;
                }]
            }
        })
        .state('pay-order.edit', {
            parent: 'pay-order',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pay-order/pay-order-dialog.html',
                    controller: 'PayOrderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PayOrder', function(PayOrder) {
                            return PayOrder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pay-order', null, { reload: 'pay-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pay-order.detail1', {
            parent: 'pay-order',
            url: '/{id}/detail1',
            data: {
                authorities: ["ROLE_RECHARGE"],
                pageTitle: 'global.menu.entities.storeRecharge'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pay-order/pay-order-detail1.html',
                    controller: 'PayOrderDetail1Controller',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('store');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['PayOrder', '$stateParams', function(PayOrder, $stateParams) {
                    return PayOrder.get({id: $stateParams.id}).$promise;
                }]
            }
        })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('PayOrder', PayOrder)
        .factory('PaidGiftSetting', PaidGiftSetting);

    PayOrder.$inject = ['$resource'];
    PaidGiftSetting.$inject = ['$resource'];

    function PayOrder ($resource) {
        var resourceUrl =  'manager/' + 'api/pay-orders/:path/:id';

        return $resource(resourceUrl, {}, {

            'getAllByCondition': {
                params:{
                    path:"getAllByCondition"
                },
                method: 'POST'
            },
            'byCondition': {
                params:{
                    path:"byCondition"
                },
                method: 'POST'
            },
            "createPayOrder": {
                params:{
                    path:"createPayOrder"
                },
                method: 'GET'
            },
            "aliPay": {
                params:{
                    path:"aliPay"
                },
                method: 'GET'
            },
            "createPayOrder2": {
                params:{
                    path:"createPayOrder2"
                },
                method: 'POST'
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function PaidGiftSetting ($resource) {
        var resourceUrl =  'manager/' + 'api/paid-gift-settings/:path/:id';

        return $resource(resourceUrl, {}, {

            'getAllByCondition': {
                params:{
                    path:"getAllByCondition"
                },
                method: 'POST'
            },
            'byCondition': {
                params:{
                    path:"byCondition"
                },
                method: 'POST'
            },
            'query': { method: 'GET'},
            'delete': { method: 'DELETE'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PayOrderController2', PayOrderController2);

    PayOrderController2.$inject = ['$scope', '$state', 'PayOrder', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService',
    'DateUtils'];

    function PayOrderController2 ($scope, $state, PayOrder, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService,
        DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        vm.datePickerOpenStatus = {};
        vm.openCalendar =  openCalendar;
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.batchArr = [];
        $scope.selectOne = false;
        $scope.selectAll = false;
        vm.selectAmount = 0;

        $scope.chooseAll = function () {
            $scope.selectAll = !$scope.selectAll;
            $scope.batchArr = [];
            angular.forEach(vm.payOrders,function (order,i) {
                if($scope.selectAll){
                    vm.selectAmount += order.amount;
                    order.select = true;
                    $scope.batchArr.push(order.id);
                    $scope.selectOne = true;
                }else{
                    vm.selectAmount = 0;
                    order.select = false;
                    $scope.selectOne = false;
                }
            })
        }

        $scope.chooseOne = function (payOrder) {
            payOrder.select = !payOrder.select;
            // 选中
            if(payOrder.select){
                vm.selectAmount += payOrder.amount;
                $scope.batchArr.push(payOrder.id);
            }else{
                // 未选中
                 vm.selectAmount = vm.selectAmount - payOrder.amount;
                var ind = $scope.batchArr.indexOf(payOrder.id);
                if (ind >= 0) {
                    $scope.batchArr.splice(ind, 1);
                }
            }

            // 判断全选按钮
            var flag = true;
            angular.forEach(vm.payOrders,function (payOrder,i) {
                if(!payOrder.select){
                    $scope.selectAll = false;
                    flag = false;
                }
                // 全部选中
                if(i==vm.payOrders.length-1&&flag){
                    $scope.selectAll = true;
                }
            })

            // 批量按钮的显示
            if($scope.batchArr.length){
                $scope.selectOne = true;
            }else {
                $scope.selectOne = false;
            }
        }


        $scope.invoiceDetail = function(){
            if ($scope.batchArr == null || $scope.batchArr.length == 0) {
                MessageService.error("请先勾选想要开票的订单");
                return;
            }
            $state.go('invoice-detail', {ids: $scope.batchArr});
        }

        loadAll();

        function loadAll () {
            var items = [{key:"paid",op:"=",value:"true"},{key:"invoiced",op:"=",value:"false"}];
            if (vm.endTime != null) {
                items.push({"key":"createdDate", op:"<=", value:new Date(Date.parse(vm.endTime) + 32 * 60 * 60 * 1000-1000) });
            }
            if (vm.startTime != null) {
                items.push({"key":"createdDate", op:">=", value:new Date(Date.parse(vm.startTime) + 8 * 60 * 60 * 1000)});
            }

            PayOrder.byCondition({
                items:items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.payOrders = res.data;
                    vm.amount = 0 ;
                    for (var i = vm.payOrders.length - 1; i >= 0; i--) {
                        var order = vm.payOrders[i];
                        vm.amount += order.amount;
                    }
                    vm.count = vm.payOrders.length;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }

            }
            function onError(error) {
                MessageService.error("充值订单获取失败");
            }
        }


        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }


        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PayOrderController', PayOrderController);

    PayOrderController.$inject = ['$scope', '$state', 'PayOrder', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'Store', '$http', '$sce', '$timeout', 'DateUtils'];

    function PayOrderController ($scope, $state, PayOrder, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, Store, $http, $sce, $timeout, DateUtils) {
        var vm = this;
        Store.getCurrent({},function (res) {
            if(res.status == 200){
                vm.store = res.data;
            }else{
                MessageService.error(res.message);
            }
        });
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.isPay = false;
        vm.payTypeList = [
            {name: '全部',id:''},
            {name: '微信',id:'WeChat'},
            {name: '支付宝',id:'Alipay'}
        ]
        vm.statesList = [
            {name: '所有状态',id:''},
            {name: '已支付',id:'true'},
            {name: '待支付',id:'false'}
        ]
        vm.data = {
            startTime: pagingParams.startTime? new Date(pagingParams.startTime):null,
            endTime: pagingParams.endTime? new Date(pagingParams.endTime):null,
            type: pagingParams.type ? pagingParams.type : '',
            paid: pagingParams.paid ? pagingParams.paid : '',
            searchQuery: pagingParams.search
        }
        vm.datePickerOpenStatus = {
            startTime: false,
            endTime: false
        };
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        loadAll();

        function loadAll () {
            var items = [];
            if(vm.data.startTime){
                items.push({key:"createdDate",op:">=",value:new Date(Date.parse(vm.data.startTime) -8 * 60 * 60 * 1000)})
            }
            if(vm.data.endTime){
                items.push({key:"createdDate",op:"<=",value:new Date(Date.parse(vm.data.endTime) + 16 * 60 * 60 * 1000 - 1000)});
            }
            if(vm.data.type){
                items.push({key:"type",op:"=",value:vm.data.type})
            }
            if(vm.data.paid){
                items.push({key:"paid",op:"=",value:vm.data.paid})
            }
            if(vm.data.searchQuery){
                items.push({key:"number",op:"like",value:vm.data.searchQuery})
            }
            PayOrder.byCondition({
                items: items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(res, headers) {
                if(res.status==200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.payOrders = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message)
                }

            }
            function onError(error) {
                MessageService.error("充值订单获取失败");
            }
        }
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.data.searchQuery,
                startTime: vm.data.startTime?DateUtils.convertLocalDateToServer(vm.data.startTime):"",
                endTime: vm.data.endTime?DateUtils.convertLocalDateToServer(vm.data.endTime):"",
                type: vm.data.type,
                paid: vm.data.paid
            });
        }

        function search () {
            vm.links = null;
            vm.page = 1;
            loadAll();
        }
        function search () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }


        $scope.recharge = function(item) {
            if (vm.store.balance !=0 && vm.store.balance >= 100000000) {
                MessageService.error("当前账户余额较多，请消费后再充值");
                return;
            }
            clearInterval($scope.timer);
            PayOrder.get({id:item.id} ,function(res){
                if(res.status == 200){
                    vm.payOrderId = res.data.id;
                    if (res.data.type == "WeChat") {
                        $http({
                            url: '/back/manager/api/pay-orders/createQRCode/'+vm.payOrderId,
                            method: 'POST',
                            responseType: 'blob'
                        }).success(function(res) {
                            vm.isPay = true;
                            var blob = new Blob([res], {
                                type: "image/jpeg"
                            });
                            $scope.image = URL.createObjectURL(blob);
                            //启动一个定时器判断是否完成支付，完成则关闭页面 取消定时器
                            $scope.timer = setInterval(function() {
                                PayOrder.get({
                                    id: vm.payOrderId
                                }, function(val) {
                                    if (!!val && val.paid) {
                                        clearInterval($scope.timer);
                                        MessageService.success("支付完成");
                                        vm.isPay = false;
                                        loadAll();
                                    }
                                }, function() {});
                            }, 2000);
                        })
                    }else{
                        PayOrder.aliPay({
                            id:res.data.id,
                            returnUrl:window.location.href
                        },function(data){
                            if(!!data && data.status == 200){
                                $scope.trustHtml = $sce.trustAsHtml(data.data);
                            }
                        },function(){
                        });
                    }
                }else{
                    MessageService.error(res.message);
                }
            },function(){
                MessageService.error("创建充值订单失败，请稍后再试");
            })
        }

        $scope.savePay = function () {
            PayOrder.get({
                id: vm.payOrderId
            }, function(res) {
                clearInterval($scope.timer);
                vm.isPay = false;
                if(res.status == 200){
                    loadAll();
                    if (!!res.data && res.data.paid) {
                        MessageService.success("支付完成");
                    }else {
                        MessageService.error("支付失败");
                    }
                }else{
                    MessageService.error(res.message);
                }
                
            }, function() {
                MessageService.error("支付失败1");
            });
        }
        $scope.cancelPay = function () {
            clearInterval($scope.timer);
            vm.isPay = false;
        }
        $scope.cancel = function (data) {
            MessageService.confirm("确认取消当前支付信息吗？",function(){
                PayOrder.delete({id: data.id},function (res) {
                    if(res.status == 200){
                        loadAll();
                        MessageService.success('取消成功');
                    }else{
                        MessageService.error(res.message);
                    }
                    
                });
            },function(){},true);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('PageMySuffixSave2Controller', PageMySuffixSave2Controller);
    PageMySuffixSave2Controller.$inject = ['$scope', 'UidService', 'Category', '$uibModalInstance', 'MessageService', '$stateParams', 'ProductXmlFileServes',
    'ThemeClassify', 'ProductXmls', 'Store', 'xmlId', '$localStorage', 'pageIndex','Qinius','$q', 'StoreWorkEditConfig', '$uibModal'];

    function PageMySuffixSave2Controller( $scope, UidService, Category, $uibModalInstance, MessageService, $stateParams, ProductXmlFileServes,
        ThemeClassify, ProductXmls, Store, xmlId, $localStorage, pageIndex,Qinius,$q, StoreWorkEditConfig, $uibModal) {
        //编辑第三方的模板 弹出窗口

        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.id = null;
        vm.multilingual= multilingual
        vm.domains = Qinius.getDomain();
        vm.modelData = [];
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.storeWorkEditAll = StoreWorkEditConfig.storeId();
        $q.all([vm.domains.$promise, vm.storeWorkEditAll.$promise]).then(function () {
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            vm.storeWorkEdit = vm.storeWorkEditAll.data;
        });
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'XML'},{key: "storeId", op: "=", value: $localStorage.user.storeId}]},function (res) {
            if(res.status == 200){
                vm.themeClassifyList = res.data;
            }else {
                MessageService.error(res.message);
            }
        });
        Store.getCurrent(function (res) {
            if(res.status == 200){
                vm.store = res.data;
            }else {
                MessageService.error(res.message);
            }
        });

        vm.variableData = "";
        if(xmlId){
            console.log(xmlId)
            vm.id = xmlId;
            ProductXmlFileServes.get({id: vm.id}, function (resp) {
                if(resp.status == 200){
                    vm.customStore = resp.data.customStoreId;
                    vm.productXml = resp.data;
                    if(!vm.productXml.themeClassifies){
                        vm.productXml.themeClassifies = [];
                    }
                    if(vm.productXml.modelData){
                        vm.modelData = vm.productXml.modelData;
                        if(!vm.productXml.modelBlendent){
                            vm.productXml.modelBlendent = [];
                        }else{
                            vm.productXml.modelBlendent = vm.productXml.modelBlendent;
                        }
                    }
                    if (resp.data.document) {
                        vm.productXml.replace = resp.data.document.replace;
                    }
                    if (vm.productXml != null && vm.productXml.bindingType != null) {
                        if (vm.productXml.bindingType == 'Top') {
                            vm.repbindingTyperint = '上下滑动';
                        } else if (vm.productXml.bindingType == 'Left') {
                            vm.bindingType = '左右滑动（含封面）';
                        } else if (vm.productXml.bindingType == 'None') {
                            vm.bindingType = '单页展示';
                        }else{
                            vm.bindingType = '左右滑动（不含封面）';
                        }
                    }


                    vm.page = [];
                    for(var i=0; i<vm.productXml.document.pages.page.length; i++){
                        var _page = vm.productXml.document.pages.page[i];
                        vm.page.push({
                            index:i,
                            name: '第'+i+'页'
                        })
                        _page.levels.level.forEach(function (level) {
                            if(level.variable){
                                vm.variableData += level.name + "；";
                            }
                        })
                    }
                    console.log(vm.page)
                }else {
                    MessageService.error(resp.message);
                }

            });
        }

        Category.storeGetAllByCondition({items: [{key: "usable", op: "=", value: "true"}]},function (res) {
            if(res.status == 200){
                vm.categories = res.data;
            }else {
                MessageService.error(res.message);
            }
        });

        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data: vm.productXml.productXmlLanguages,
                            key: 'name',
                            fieldValue: vm.productXml.name,
                            fieldName: '模板名称'
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    vm.productXml.productXmlLanguages=data;
                }
            });
        }

        //配色管理
        $scope.modelBlendentAdd = function () {
            if(!vm.productXml.modelBlendent){
                vm.productXml.modelBlendent = [];
            }
            vm.productXml.modelBlendent.push({
                name:'',
                uuid:getUuid(16, 16),
                cancelled: false,
                modelData:angular.copy(vm.modelData)
            })
        }

        function getUuid(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [],
                i;
            radix = radix || chars.length;

            if (len) {
                // Compact form
                for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
            } else {
                // rfc4122, version 4 form
                var r;

                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                    }
                }
            }

            return uuid.join('');
        }
        $scope.modelBlendentSet = function (data) {
            vm.modelData.forEach(function (modelData2){
                data.modelData.forEach(function (modelData1){
                    if(modelData1.materialName == modelData2.materialName){
                        modelData1.page = modelData2.page;
                        if(modelData1.page>0 || modelData1.page === 0){
                            modelData1.color = null;
                        }
                    }
                })
            })
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/blendent-modal.html',
                controller: 'BlendentModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            modelData: data.modelData,
                            modelPath: vm.productXml.modelPath
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    data.modelData = res;
                }
            });
        }
        $scope.removeModelBlendent = function (index) {
            vm.productXml.modelBlendent.splice(index, 1)
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            if (vm.productXml.categoryId == null || vm.productXml.categoryId == "") {
                MessageService.error("请选择分类");
                return false;
            }

            if (vm.productXml.name == null || vm.productXml.name == "") {
                MessageService.error("请输入作品名称");
                return false;
            }
            if (!vm.productXml.themeClassifies || vm.productXml.themeClassifies.length == 0) {
                MessageService.error("请选择模板分类");
                return false;
            }
            if(vm.productXml.modelType == "THREE" && !vm.productXml.modelPath){
                MessageService.error("请上传3D模型");
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            var _data = angular.copy(vm.productXml);
            _data.document.replace = _data.replace;
            _data.modelData = vm.modelData;
            ProductXmlFileServes.update(_data, function(data){
                MessageService.success("保存成功");
                $uibModalInstance.close(data);
            },function(){
                MessageService.error("保存失败");
            });
        }

        $scope.save2 = function(){
            if (!$scope.validate()) {
                return;
            }
            var _data = angular.copy(vm.productXml);
            _data.document.replace = _data.replace;
            _data.modelData = vm.modelData;
            ProductXmlFileServes.update(_data,function(res){
                if(res.status == 200){
                    var url = vm.storeWorkEdit.productXmlUrl + '/#/page-my-suffix/'+res.data.identifier+'/'+vm.storeWorkEdit.productXmlKey+'/'+res.data.id+'/'+_data.pattern+'/'+_data.document.replace+'/'+ pageIndex;
                    if(_data.modelType=='THREE'){
                        url+='/'+_data.modelType+'/'+encodeURIComponent(JSON.stringify(_data.modelData))+'?modelPath='+encodeURIComponent(_data.modelPath) + '&xmlName=' + res.data.name
                    }else{
                        url+='?xmlName='+res.data.name
                    }
                    window.location.href = url;
                }else {
                    MessageService.error(res.message);
                }

            },function(){
                MessageService.error("保存失败");
            });
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        $scope.modelPathDelete = function(){
            vm.productXml.modelPath = "";
            vm.productXml.modelData = "";
            vm.productXml.modelBlendent = [];
            vm.modelData = [];
        }
        //上传3D模型
        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }

        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "product-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.productXml.modelPath = $scope.domain + data.key;
                    gltfInfo(vm.productXml.modelPath)
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        };

        function gltfInfo(path) {
            // 加载glTF格式的模型
            vm.modelData = [];
            vm.materialMap = [];
            var loader = new THREE.GLTFLoader();
            if (THREE.DRACOLoader) {
                var dracoLoader = new THREE.DRACOLoader();
                if (dracoLoader) {
                    loader.setDRACOLoader( dracoLoader );
                }
            }
            vm.modelLoad = true;
            loader.load(path, function (gltf) {
                gltf.scene.traverse(function(child){
                    if (child.isMesh) {
                        traverseMaterials(child, function(node,i){
                            if(vm.materialMap.indexOf(node.name) == -1){
                                var _modelData = {
                                    materialName:node.name,
                                    page:''
                                };
                                vm.modelData.push(_modelData);
                                vm.materialMap.push(node.name);
                            }
                        });
                    }
                });
                vm.modelLoad = false;
                $scope.$apply();
            }, function (xhr) {
                vm.schedule = (xhr.loaded / xhr.total * 100);
            }, function (error) {
                MessageService.error("3D模型上传失败，请稍后重试！")
                vm.modelLoad = false;
            })
        }

        function traverseMaterials(object, callback) {
            object.traverse(function(node){
                if (!node.isMesh) return;
                var materials = Array.isArray(node.material)
                    ? node.material
                    : [node.material];
                materials.forEach(callback);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('PageMySuffixSaveController', PageMySuffixSaveController);

    PageMySuffixSaveController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService', '$stateParams',
     'ProductXmlFileServes', 'ThemeClassify', 'Store', '$localStorage'];

    function PageMySuffixSaveController( $scope, Category, $uibModalInstance, MessageService, $stateParams, 
        ProductXmlFileServes, ThemeClassify, Store, $localStorage) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.id = null;
        vm.themeClassifyList = ThemeClassify.getAllByCondition({items:[{key: "storeId", op: "=", value: $localStorage.user.storeId}]});
        vm.stores = Store.getAllByCondition({items:[]});

        if($stateParams.id){
            vm.id = $stateParams.id;
            ProductXmlFileServes.get({id: $stateParams.id}, function (resp) {
                vm.themeClassify = resp.themeId;
                vm.customStore = resp.customStoreId;
                if (resp.document && resp.document.pages && resp.document.pages.page) {
                    var p = resp.document.pages.page[0];
                    vm.bleedTop = p.trimbox.y;
                    vm.bleedBottom= p.mediabox.height - p.trimbox.height -  p.trimbox.y;
                    vm.bleedLeft= p.trimbox.x;
                    vm.bleedRight= p.mediabox.width - p.trimbox.width -  p.trimbox.x;
                }
                vm.page = {
                    name: resp.name,
                    replace: resp.document.replace +"",
                    category: resp.categoryId,
                    themeClassify: '',
                    type:resp.type,
                    customStore:{
                        id:resp.customStoreId,
                        name:resp.customStoreName
                    },
                    bleedTop:vm.bleedTop ,
                    bleedBottom:vm.bleedBottom,
                    bleedLeft:vm.bleedLeft,
                    bleedRight:vm.bleedRight
                };
            });

        }else{
            vm.page = {
                name: '',
                category: '',
                themeClassify: '',
                replace: "true",
                bleedTop:3,
                bleedBottom:3,
                bleedLeft:3,
                bleedRight:3
            };
        }

        vm.categories = Category.getAllByCondition({items: []});

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.customStoreChange = function(){
            if (vm.customStore == null) {
                vm.page.customStore = null;
            }
            for (var i = vm.stores.length - 1; i >= 0; i--) {
                var s = vm.stores[i];
                if (s.id == vm.customStore) {
                    vm.page.customStore = s;
                }
            }
        }

        $scope.validate = function () {
            if (vm.page.category == null || vm.page.category == "") {
                MessageService.error("请选择分类");
                return false;
            }
            if (vm.page.name == null || vm.page.name == "") {
                MessageService.error("请输入作品名称");
                return false;
            }
            if (vm.themeClassify == null || vm.themeClassify == "") {
                MessageService.error("请选择模板分类");
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.page.themeClassify = vm.themeClassify;
            onSaveSuccess(vm.page);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('page-my-suffix', {
                parent: 'entity',
                url: '/page-my-suffix',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('page-my-suffix-edit', {
                parent: 'entity',
                url: '/page-my-suffix/{id}',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('page-my-suffix-copy', {
                parent: 'entity',
                url: '/page-my-suffix/{id}/copy',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    copy:true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    entity: ['ProductXmlFileServes','$stateParams', function(ProductXmlFileServes,$stateParams) {
                        return ProductXmlFileServes.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Page', Page)  
        .factory('Category', Category);

    Page.$inject = ['$resource'];  
    Category.$inject = ['$resource'];

    function Page ($resource) {
        var resourceUrl =  'api/pages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
     
    function Category ($resource) {
        var resourceUrl =  'manager/' + 'api/categories/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                },
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('PageMySuffixController', PageMySuffixController);

    PageMySuffixController.$inject = ['$state', '$scope', '$timeout', 'Qinius', '$uibModal', '$http', 'FontManagement', '$q',
        'pagingParams', 'paginationConstants', 'MessageService', 'ProductXmlFileServes', '$stateParams', 'ImageService', 'ClipArt', 'UidService'];

    function PageMySuffixController($state, $scope, $timeout, Qinius, $uibModal, $http, FontManagement, $q,
                                    pagingParams, paginationConstants, MessageService, ProductXmlFileServes, $stateParams, ImageService, ClipArt, UidService) {

        var vm = this;

        $(".navbar").hide();
        $(".nav-bg").show();
        $(".wrap").hide();
        vm.pages = [];
        vm.token = "";
        vm.url = null;
        $scope.visibleLeft = false;
        $scope.visibleRight = false;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.pid = $stateParams.id;
        vm.isCopy = $stateParams.copy;
        vm.bleedUp = null;
        vm.bleedBottom = null;
        vm.bleedLeft = null;
        vm.bleedRight = null;
        $scope.currentPage = [];
        localStorage.removeItem('ctrlKeyArray');

        //键盘操作array
        vm.CtrlKeyArray = {imageboxes: [], textboxes: []};
        // vm.clipArts = ClipArt.getAllByCondition({items:[]});
        //得到原始模板框中最大宽高比例
        var $con = $(".content-scroll");
        var originalScale = $con.width() * 0.8 / ($con.height() * 0.8);

        /**
         * 出血统一改成固定3mm
         * liu
         */
        var unitTransform = function (mm) {
            // return Math.ceil(mm / 25.4 * 300);         //mm换算成px
            // return Math.ceil(mm *3.78);         //mm换算成px
            return (mm * 3) - 0;         //mm换算成px
        };
        var unitTransformPx = function (px) {
            // return Math.floor(px / 300 * 25.4);        //px换算成mm
            // return Math.floor(px *50/189);        //px换算成mm
            return (px * 1 / 3).toFixed(2) - 0;        //px换算成mm
        };
        $scope.border = unitTransform(3);  //36px   出血值
        $scope.borderTop = unitTransform(3);
        $scope.borderBottom = unitTransform(3);
        $scope.borderLeft = unitTransform(3);
        $scope.borderRight = unitTransform(3);

        vm.page = {
            name: '',
            reprint: '',
            categoryId: ''
        };


        vm.fontNames = [];

        vm.dpiChoose = [{data: 'mm(毫米)', id: 0}, {data: 'px(像素)', id: 1}];
        $scope.dpi = vm.dpiChoose[0];

        var timer = null;
        $scope.bgImgs = {bgImg: []};
        $scope.masks = {mask: []};
        $scope.template = {
            pageI: 0,
            widthM: 420,
            heightM: 285,
            currentMenu: 'page',
            angle: 0,
            textAngle: 0,
            textFont: '',
            text: '',
            textColor: '#000000',
            textSize: 16,
            bgImgs: {
                bgImg: []
            },
            masks: {
                mask: []
            },
            pages: {
                page: [{
                    bgImg: '',
                    background: {
                        resource: {}
                    },
                    imageboxes: {
                        imagebox: []
                    },
                    textboxes: {
                        textbox: []
                    },
                    barcode: {},
                    hasBarCode: false,
                    widthM: 420,
                    heightM: 285,
                    scale: 1,
                    proportion: 1,
                    seq: 1,
                    spread: false,
                    backup: false
                }]
            }
        };

        $scope.updateOnlyShow = function(flag){
            var art = $scope.template.pages.page[$scope.template.pageI].imagearts.imageart[$scope.template.artI];
            art.onlyShow = flag;
            $scope.template.artOnlyShow = flag;
        }

        function getAll() {
            if ($stateParams.id) {
                ProductXmlFileServes.get({id: $stateParams.id}, function (resp) {
                    vm.page = {
                        name: resp.name,
                        categoryName: resp.categoryName,
                        categoryId: resp.categoryId,
                        reprint: resp.reprint,
                        provider: resp.provider,
                        identifier: resp.identifier,
                        type: resp.type,
                        customStoreId: resp.customStoreId,
                        customStoreName: resp.customStoreName
                    };

                    $scope.template.bgImgs = angular.copy(resp.document.bgImgs);
                    $scope.template.masks = angular.copy(resp.document.masks);
                    $scope.template.pages = angular.copy(resp.document.pages);

                    if ($scope.template.pages.page.length > 1) {
                        $scope.visibleRight = true;
                    }

                    angular.forEach(resp.document.bgImgs.bgImg, function (bgImg, i) {
                        var newImg = document.createElement('img');
                        newImg.crossOrigin = "Anonymous";
                        newImg.src = vm.url + bgImg.identifier;
                        $timeout(function () {
                            var w = newImg.width;
                            var h = newImg.height;
                            if (w < h) {
                                $scope.template.bgImgs.bgImg[i].width = 50;
                            } else {
                                $scope.template.bgImgs.bgImg[i].height = 50;
                            }
                            $scope.template.bgImgs.bgImg[i].isEdit = true;
                        });
                    });
                    angular.forEach(resp.document.masks.mask, function (mask, i) {
                        $scope.template.masks.mask[i] = {
                            resource: {
                                'identifier': mask.resource.identifier,
                                'provider': mask.resource.provider
                            },
                            // 'bgImg': imagecanvas.toDataURL(),
                            'height': 50,
                            'isEdit': true
                        };
                    });
                    angular.forEach(resp.document.pages.page, function (page, i) {
                        $scope.template.pages.page[i] = {
                            seq: i + 1,
                            widthM: page.trimbox.width,
                            heightM: page.trimbox.height,
                            width: unitTransform(page.trimbox.width),
                            height: unitTransform(page.trimbox.height),
                            spread: page.spread,
                            backup: page.backup,
                            scale: 1,
                            barcode: {},
                            uuid: page.uuid,
                            hasBarCode: page.barcode ? true : false,
                            barWidthM: page.barcode ? page.barcode.width : 0,
                            barHeightM: page.barcode ? page.barcode.height : 0,
                            barXM: page.barcode ? page.barcode.x : 0,
                            barYM: page.barcode ? page.barcode.y : 0,
                            background: angular.copy(page.background),
                            hasBgImg: page.background && page.background.resource.identifier ? true : false,
                            bgImg: page.background && page.background.resource.identifier ? vm.url + page.background.resource.identifier + '?imageMogr2/interlace/1' : '',
                            imageboxes: angular.copy(page.imageboxes),
                            textboxes: angular.copy(page.textboxes),
                            imagearts: angular.copy(page.imagearts),
                            unit: 'mm'
                        };
                        if ($scope.template.pages.page[i].uuid == null) {
                            $scope.template.pages.page[i].uuid = UidService.get();
                        }
                        if (page.barcode) {
                            $scope.template.pages.page[i].barcode = {
                                width: unitTransform(page.barcode.width),
                                height: unitTransform(page.barcode.height),
                                x: unitTransform(page.barcode.x),
                                y: unitTransform(page.barcode.y),
                                barWidthM: page.barcode.width,
                                barHeightM: page.barcode.height,
                                barXM: page.barcode.x,
                                barYM: page.barcode.y
                            }
                        }

                        if (page.imagearts) {
                            var tempPage = $scope.template.pages.page[i];
                            angular.forEach(page.imagearts.imageart, function (art, n) {
                                tempPage.imagearts.imageart[n] = {
                                    geometry: getGeometry(art.geometry),
                                    rotation: angular.copy(art.rotation),
                                    type: art.type,
                                    onlyShow:art.onlyShow,
                                    resource: angular.copy(art.resource),
                                    widthM: art.geometry.width,
                                    heightM: art.geometry.height,
                                    offsetXM: art.geometry.x,
                                    offsetYM: art.geometry.y,
                                    unit: 'mm'
                                }
                            });
                            console.log($scope.template.pages.page)
                        }

                        angular.forEach(page.imageboxes.imagebox, function (image, j) {
                            var imagecanvas = document.createElement('canvas');
                            var imagecontext = imagecanvas.getContext('2d');
                            var newImg = document.createElement('img');
                            newImg.crossOrigin = "Anonymous";
                            newImg.src = 'content/images/shattered.png';
                            newImg.onload = function () {
                                newImg.onload = null;
                                var width = newImg.width;
                                var height = newImg.height;
                                var masks = document.createElement('img');
                                masks.crossOrigin = "anonymous";
                                masks.onload = function () {
                                    masks.onload = null;
                                    imagecanvas.width = width;
                                    imagecanvas.height = height;
                                    imagecontext.drawImage(masks, 0, 0, width, height);
                                    imagecontext.globalCompositeOperation = 'source-atop';
                                    imagecontext.drawImage(newImg, 0, 0);
                                    $scope.template.pages.page[i].imageboxes.imagebox[j].bgImg = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                                    $scope.$apply();
                                };
                                masks.src = vm.url + image.mask.resource.identifier;
                            };
                            newImg.src = 'content/images/shattered.png';

                            var tempPage = $scope.template.pages.page[i];
                            tempPage.imageboxes.imagebox[j] = {
                                geometry: getGeometry(image.geometry),
                                rotation: angular.copy(image.rotation),
                                mask: angular.copy(image.mask),
                                image: angular.copy(image.image),
                                widthM: image.geometry.width,
                                heightM: image.geometry.height,
                                offsetXM: image.geometry.x,
                                offsetYM: image.geometry.y,
                                unit: 'mm'
                            }
                        });
                        angular.forEach(page.textboxes.textbox, function (text, k) {
                            $scope.template.pages.page[i].textboxes.textbox[k] = {
                                geometry: getGeometry(text.geometry),
                                identifier: text.identifier,
                                rotation: angular.copy(text.rotation),
                                angle: angular.copy(text.angle),
                                status: angular.copy(text.status),
                                style: angular.copy(text.style),
                                type: angular.copy(text.type),
                                text: angular.copy(text.text),
                                fontStyle: [{
                                    style: '',
                                    path: text.identifier
                                }],
                                unit: 'mm'
                            };

                            $scope.template.textWidthM = $scope.template.pages.page[i].textboxes.textbox[k].widthM = text.geometry.width;
                            $scope.template.textHeightM = $scope.template.pages.page[i].textboxes.textbox[k].heightM = text.geometry.height;
                            $scope.template.pages.page[i].textboxes.textbox[k].xM = $scope.template.pages.page[i].textboxes.textbox[k].textXM = text.geometry.x;
                            $scope.template.pages.page[i].textboxes.textbox[k].yM = $scope.template.pages.page[i].textboxes.textbox[k].textYM = text.geometry.y;

                            switch (text.style.bold + '' + text.style.italic) {
                                case 'falsefalse':
                                    text.styles = 'NORMAL';
                                    break;
                                case 'falsetrue':
                                    text.styles = 'ITALIC';
                                    break;
                                case 'truefalse':
                                    text.styles = 'BOLD';
                                    break;
                                default:
                                    text.styles = 'BOLD_ITALIC';
                                    break;
                            }
                            $http({
                                url: 'fileserves/api/convert/textToImg',
                                method: 'POST',
                                data: {
                                    identifier: text.identifier,
                                    text: text.text,
                                    fontSize: text.style.size,
                                    style: text.styles,
                                    width: $scope.template.pages.page[i].textboxes.textbox[k].geometry.width,
                                    height: $scope.template.pages.page[i].textboxes.textbox[k].geometry.height,
                                    color: text.style.color,
                                    family: text.style.font
                                },
                                responseType: 'blob'
                            }).success(function (data, status, headers, config) {
                                var createObjectURL = function (blob) {
                                    return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
                                };
                                var fileURL = URL.createObjectURL(data);
                                $scope.template.pages.page[i].textboxes.textbox[k].picCode = fileURL;
                            }).error(function () {
                                MessageService.error("文字生成失败，请重新选择字体");
                            });
                        });
                        setOriginalWaH(unitTransform(page.trimbox.width), unitTransform(page.trimbox.height), i);
                    });

                    $scope.template.widthM = resp.document.pages.page[0].trimbox.width;
                    $scope.template.width = unitTransform($scope.template.widthM);
                    $scope.template.heightM = resp.document.pages.page[0].trimbox.height;
                    $scope.template.height = unitTransform($scope.template.heightM);
                    $scope.currentPage = $scope.template.pages.page[0];
                    $scope.template.textI = 0;
                    setUlWidth();
                })
            } else {
                setOriginalWaH(unitTransform(420), unitTransform(285), 0);
                $scope.template.width = unitTransform(420);
                $scope.template.widthM = 420;
                $scope.template.height = unitTransform(285);
                $scope.template.heightM = 285;
                $scope.currentPage = angular.copy($scope.template.pages.page[0]);
            }
        }


        var data = new Date().getTime();

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        $scope.domains = Qinius.getDomain();

        $scope.files = new Array;

        $scope.history = [angular.copy($scope.template)];
        $scope.currentHistoryIndex = 0;
        $scope.pageHistory = [{
            history: [angular.copy($scope.template.pages.page[$scope.template.pageI])],
            currentHistoryIndex: 0
        }];
        $q.all([$scope.domains.$promise]).then(function () {
            vm.url = 'https://' + $scope.domains.domains[0] + '/';
            getAll();
            $scope.confirmName();
        });

        /**
         *
         * 自定义元素右键菜单样式  复制、粘贴、删除
         *
         */
        document.onkeydown = function (event) {
            if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 67) {
                $scope.copyimg();
                event.returnvalue = false;
            } else if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 86) {
                $scope.pasteimg();
                event.returnvalue = false;
            }
        };

        //复制
        $scope.copyimg = function () {
            console.log(vm.CtrlKeyArray);
            localStorage.setItem('ctrlKeyArray', JSON.stringify(vm.CtrlKeyArray));
        };
        //粘贴
        $scope.pasteimg = function () {
            var index = $scope.template.pageI;
            var temp = JSON.parse(localStorage.getItem('ctrlKeyArray'));

            if (temp != null) {
                if ($scope.template.pages.page[index].imageboxes == null) {
                    $scope.template.pages.page[index].imageboxes = {};
                }
                if ($scope.template.pages.page[index].imageboxes.imagebox == null) {
                    $scope.template.pages.page[index].imageboxes.imagebox = [];
                }
                if ($scope.template.pages.page[index].textboxes == null) {
                    $scope.template.pages.page[index].textboxes = {};
                }
                if ($scope.template.pages.page[index].textboxes.textbox == null) {
                    $scope.template.pages.page[index].textboxes.textbox = [];
                }
                angular.forEach(temp.imageboxes, function (item) {
                    item.offsetXM += 12;
                    item.offsetYM += 12;
                    item.geometry.x = unitTransform(item.offsetXM);
                    item.geometry.y = unitTransform(item.offsetYM);
                    $scope.template.pages.page[index].imageboxes.imagebox.push(item);
                    $scope.template.imgI = $scope.template.pages.page[index].imageboxes.imagebox.length - 1;
                });
                angular.forEach(temp.textboxes, function (item) {
                    item.xM += 20;
                    item.yM += 20;
                    item.geometry.x = unitTransform(item.xM);
                    item.geometry.y = unitTransform(item.yM);
                    $scope.template.pages.page[index].textboxes.textbox.push(item);
                });
            }
            $scope.digest;
            if ($scope.template.pages.page[index].textboxes && $scope.template.pages.page[index].textboxes.textbox) {
                angular.forEach($scope.template.pages.page[index].textboxes.textbox, function (item, index) {
                    var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[index];
                    toImg(text);
                    updateHistorys();
                })
            }
            $timeout(function () {
                $scope.selectPages(index);
            }, 200);

            localStorage.setItem('ctrlKeyArray', JSON.stringify(temp));
        };
        //删除
        $scope.deleteTemplate = function () {
            vm.CtrlKeyArray = {imageboxes: [], textboxes: []};
            $scope.rollback(1);
        };

        $scope.updateDpi = function (data, attr, flag) {
            $scope.dpi = data;

            var i = $scope.template.pageI;
            var page = $scope.template.pages.page[i];

            var arr = {};
            var arr2 = {};

            if (data.id == 1) {
                if (attr == 'page') {
                    $(".temp-px").removeClass('hide1');
                    $(".temp-mm").addClass('hide1');
                    page.unit = 'px';
                    arr = ThreeHundredDpi($scope.template.widthM, $scope.template.heightM);
                    $scope.template.widthPx = arr.px1;
                    $scope.template.heightPx = arr.px2;
                }
                if (attr == 'Img') {
                    var img = page.imageboxes.imagebox[$scope.template.imgI];
                    img.unit = 'px';
                    $(".img-wah-px").removeClass('hide1');
                    $(".img-wah-mm").addClass('hide1');
                    arr = ThreeHundredDpi($scope.template.imgWidthM, $scope.template.imgHeightM);
                    $scope.template.imgWidthPx = arr.px1;
                    $scope.template.imgHeightPx = arr.px2;

                    $(".img-xay-px").removeClass('hide1');
                    $(".img-xay-mm").addClass('hide1');
                    arr2 = ThreeHundredDpi($scope.template.offsetXM, $scope.template.offsetYM);

                    $scope.template.offsetXPx = arr2.px1;
                    $scope.template.offsetYPx = arr2.px2;
                }
                if (attr == 'text') {
                    var textbox = page.textboxes.textbox[$scope.template.textI];
                    textbox.unit = 'px';
                    $(".text-wah-px").removeClass('hide1');
                    $(".text-wah-mm").addClass('hide1');
                    arr = ThreeHundredDpi($scope.template.textWidthM, $scope.template.textHeightM);
                    $scope.template.textWidthPx = arr.px1;
                    $scope.template.textHeightPx = arr.px2;

                    $(".text-xay-px").removeClass('hide1');
                    $(".text-xay-mm").addClass('hide1');
                    arr2 = ThreeHundredDpi($scope.template.textXM, $scope.template.textYM);

                    $scope.template.textXPx = arr2.px1;
                    $scope.template.textYPx = arr2.px2;
                }
                if (attr == 'Art') {
                    var art = page.imagearts.imageart[$scope.template.artI];
                    art.unit = 'px';
                    $(".art-wah-px").removeClass('hide1');
                    $(".art-wah-mm").addClass('hide1');
                    arr = ThreeHundredDpi($scope.template.artWidthM, $scope.template.artHeightM);
                    $scope.template.artWidthPx = arr.px1;
                    $scope.template.artHeightPx = arr.px2;

                    $(".art-xay-px").removeClass('hide1');
                    $(".art-xay-mm").addClass('hide1');
                    arr2 = ThreeHundredDpi($scope.template.artXM, $scope.template.artYM);

                    $scope.template.artXPx = arr2.px1;
                    $scope.template.artYPx = arr2.px2;
                }
                if (attr == 'Barcode') {
                    var bar = page.barcode;
                    bar.unit = 'px';
                    $(".bar-wah-px").removeClass('hide1');
                    $(".bar-wah-mm").addClass('hide1');
                    arr = ThreeHundredDpi($scope.template.barWidthM, $scope.template.barHeightM);
                    $scope.template.barWidthPx = arr.px1;
                    $scope.template.barHeightPx = arr.px2;

                    $(".bar-xay-px").removeClass('hide1');
                    $(".bar-xay-mm").addClass('hide1');
                    arr2 = ThreeHundredDpi($scope.template.barXM, $scope.template.barYM);
                    $scope.template.barXPx = arr2.px1;
                    $scope.template.barYPx = arr2.px2;
                }
            } else {
                if (attr == 'page') {
                    $(".temp-px").addClass('hide1');
                    $(".temp-mm").removeClass('hide1');
                    page.unit = 'mm';
                    arr = ThreeHundredDpiToMm($scope.template.widthPx, $scope.template.heightPx);
                    $scope.template.widthM = arr.mm1;
                    $scope.template.heightM = arr.mm2
                }
                if (attr == 'Img') {
                    var img = page.imageboxes.imagebox[$scope.template.imgI];
                    $(".img-wah-px").addClass('hide1');
                    $(".img-wah-mm").removeClass('hide1');
                    img.unit = 'mm';
                    arr = ThreeHundredDpiToMm($scope.template.imgWidthPx, $scope.template.imgHeightPx);
                    $scope.template.imgWidthM = arr.mm1;
                    $scope.template.imgHeightM = arr.mm2

                    $(".img-xay-px").addClass('hide1');
                    $(".img-xay-mm").removeClass('hide1');
                    arr2 = ThreeHundredDpiToMm($scope.template.offsetXPx, $scope.template.offsetYPx);
                    $scope.template.offsetXM = arr2.mm1;
                    $scope.template.offsetYM = arr2.mm2;
                }
                if (attr == 'text') {
                    var textbox = page.textboxes.textbox[$scope.template.textI];
                    $(".text-wah-px").addClass('hide1');
                    $(".text-wah-mm").removeClass('hide1');
                    textbox.unit = 'mm';
                    arr = ThreeHundredDpiToMm($scope.template.textWidthPx, $scope.template.textHeightPx);
                    $scope.template.textWidthM = arr.mm1;
                    $scope.template.textHeightM = arr.mm2

                    $(".text-xay-px").addClass('hide1');
                    $(".text-xay-mm").removeClass('hide1');
                    arr2 = ThreeHundredDpiToMm($scope.template.textXPx, $scope.template.textYPx);
                    $scope.template.textXM = arr2.mm1;
                    $scope.template.textYM = arr2.mm2;
                }
                if (attr == 'Art') {
                    var art = page.imagearts.imageart[$scope.template.artI];
                    $(".art-wah-px").addClass('hide1');
                    $(".art-wah-mm").removeClass('hide1');
                    art.unit = 'mm';
                    arr = ThreeHundredDpiToMm($scope.template.artWidthPx, $scope.template.artHeightPx);
                    $scope.template.artWidthM = arr.mm1;
                    $scope.template.artHeightM = arr.mm2

                    $(".art-xay-px").addClass('hide1');
                    $(".art-xay-mm").removeClass('hide1');
                    arr2 = ThreeHundredDpiToMm($scope.template.artXPx, $scope.template.artYPx);
                    $scope.template.artXM = arr2.mm1;
                    $scope.template.artYM = arr2.mm2;
                }
                if (attr == 'Barcode') {
                    var bar = page.barcode;
                    bar.unit = 'mm';
                    $(".bar-wah-px").addClass('hide1');
                    $(".bar-wah-mm").removeClass('hide1');
                    arr = ThreeHundredDpiToMm($scope.template.barWidthPx, $scope.template.barHeightPx);
                    $scope.template.barWidthM = arr.mm1;
                    $scope.template.barHeightM = arr.mm2

                    $(".bar-xay-px").addClass('hide1');
                    $(".bar-xay-mm").removeClass('hide1');
                    arr2 = ThreeHundredDpiToMm($scope.template.barXPx, $scope.template.barYPx);
                    $scope.template.barXM = arr2.mm1;
                    $scope.template.barYM = arr2.mm2;
                }
            }
        }

        // mm---px
        function ThreeHundredDpi(attr1, attr2) {
            // Math.floor(px / 300 * 25.4)   (px--mm)
            // Math.ceil(mm / 25.4 * 300)   (mm---px)
            var px1 = parseFloat((attr1 / 25.4 * 300 - 0)).toFixed(2) - 0;
            var px2 = parseFloat((attr2 / 25.4 * 300 - 0)).toFixed(2) - 0;
            return {
                px1: px1,
                px2: px2
            }
        }

        // px---mm
        function ThreeHundredDpiToMm(attr1, attr2) {
            var mm1 = parseFloat((attr1 / 300 * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / 300 * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }

        }

        $scope.selectPageo = function (e, $index, page) {
            if (page.unit == 'mm') {
                $scope.dpi = vm.dpiChoose[0];
            } else {
                $scope.dpi = vm.dpiChoose[1];
            }
        };

        /**
         * 宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function getGeometry(obj) {
            return {
                height: unitTransform(obj.height),
                width: unitTransform(obj.width),
                x: unitTransform(obj.x),
                y: unitTransform(obj.y)
            }
        }

        var content = $(".content-container")[0];
        content.ondragenter = ignoreDrag;
        // 拖动文件的鼠标指针位置放置区之上时发生
        content.ondragover = ignoreDrag;
        content.ondrop = drop;

        function ignoreDrag(e) {
            // 确保其他元素不会取得该事件
            e.stopPropagation();
            e.preventDefault();
        }

        function drop(e) {
            ignoreDrag(e);

            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var data = e.dataTransfer.getData("Text");

            var s = $('#' + data)[0].src;
            var mask = $('#' + data)[0].getAttribute('data-mask');
            var dataIndex = $('#' + data)[0].getAttribute('data-index');
            var s1 = s.split(/\//)[3];
            var bgImgArr = $scope.template.bgImgs.bgImg[dataIndex];
            // 判读是否是占位框
            if (data.indexOf('dragtargetMask') != '-1') {
                s1 = $('#' + data).attr('data-mask');
                if (currentPage.imageboxes.imagebox.length) {
                    var index = e.target.dataset.index;

                    ImageService.convertImgToBase64(vm.url + s1, function (s) {
                        var imagecanvas = document.createElement('canvas');
                        var imagecontext = imagecanvas.getContext('2d');
                        var img = document.getElementsByClassName('page-item')[0].getElementsByClassName('mask')[index];
                        img.src = 'content/images/shattered.png';
                        var newImg = document.createElement('img');
                        newImg.crossOrigin = "Anonymous";
                        newImg.src = img.src;
                        newImg.onload = function () {
                            newImg.onload = null;
                            var width = newImg.width;
                            var height = newImg.height;
                            img.setAttribute('data-mask', s);
                            var masks = document.createElement('img');
                            masks.src = img.getAttribute('data-mask');
                            masks.crossOrigin = "anonymous";
                            masks.onload = function () {
                                masks.onload = null;
                                imagecanvas.width = width;
                                imagecanvas.height = height;
                                imagecontext.drawImage(masks, 0, 0, width, height);
                                imagecontext.globalCompositeOperation = 'source-atop';
                                imagecontext.drawImage(img, 0, 0);
                                img.src = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                                $scope.currentPage.imageboxes.imagebox[index].bgImg = img.src;
                                currentPage.imageboxes.imagebox[index].bgImg = img.src;
                                currentPage.imageboxes.imagebox[index].mask.resource.identifier = s1;
                                currentPage.imageboxes.imagebox[index].mask.resource.provider = "qiniu";
                                updateHistorys();
                                $scope.$digest();
                            };
                        };


                    });
                }
            } else if (data.indexOf('dragtargetClipArt') != '-1') {
                //判读是否是素材
                var identifier = e.dataTransfer.getData("Art");

                if (!currentPage.imagearts) {
                    currentPage.imagearts = {
                        imageart: []
                    };
                }
                var newImg = document.createElement('img');
                newImg.crossOrigin = "Anonymous";
                newImg.src = vm.url + identifier + '?imageView2';
                newImg.onload = function () {
                    newImg.onload = null;
                    var width = newImg.width;
                    var height = newImg.height;


                    $(".art-wah-px").addClass('hide1');
                    $(".art-wah-mm").removeClass('hide1');
                    $(".art-xay-px").addClass('hide1');
                    $(".art-xay-mm").removeClass('hide1');
                    var arr = ThreeHundredDpiToMm(width, height);
                    $scope.template.artWidthM = arr.mm1;
                    $scope.template.artHeightM = arr.mm2;

                    $scope.template.artXM = 12 + currentPage.imagearts.imageart.length * 2;
                    $scope.template.artYM = 12 + currentPage.imagearts.imageart.length * 2;

                    $scope.template.angle = 0;
                    currentPage.imagearts.imageart.push({
                        geometry: {
                            width: unitTransform($scope.template.artWidthM),
                            height: unitTransform($scope.template.artHeightM),
                            x: unitTransform($scope.template.artXM),
                            y: unitTransform($scope.template.artYM)
                        },
                        rotation: {
                            angle: 0
                        },
                        // 模板使用，微信端不可进行操作
                        type: 'static',
                        resource: {
                            identifier: identifier,
                            provider: 'qiniu'
                        },
                        bgImg: '',
                        widthM: $scope.template.artWidthM,
                        heightM: $scope.template.artHeightM,
                        offsetXM: $scope.template.artXM,
                        offsetYM: $scope.template.artYM,
                        zoom: 1,
                        unit: 'mm'
                    });

                    $scope.template.artI = currentPage.imagearts.imageart.length - 1;
                    updateHistorys();
                    $scope.template.currentMenu = 'Art';
                    $scope.$digest();
                };
            } else {
                currentPage.hasBgImg = true;

                if (!bgImgArr.isEdit) {
                    $("#bgImg" + $scope.template.pageI).attr('src', s);
                    currentPage.bgImg = s;
                    $scope.currentPage.bgImg = s;
                } else {
                    $("#bgImg" + $scope.template.pageI).attr('src', vm.url + bgImgArr.identifier);
                    currentPage.bgImg = vm.url + bgImgArr.identifier;
                    $scope.currentPage.bgImg = vm.url + bgImgArr.identifier;
                }

                if (timer) {
                    clearInterval(timer);
                }
                timer = setInterval(function () {
                    if (bgImgArr.identifier) {
                        clearInterval(timer);
                        timer = null;
                        currentPage.background.resource.identifier = bgImgArr.identifier;
                        currentPage.background.resource.provider = "qiniu";
                        updateHistorys();
                    }
                }, 600);
                $scope.$digest();
            }

            // 取得拖放进来的文件
            var datas = e.dataTransfer;
            var files = datas.files;
            // 将其传给真正的处理文件的函数
            var file = files[0];

            if (!file) {
                return
            }
            var reader = new FileReader();
            reader.onload = function (e) {
                currentPage.bgImg = e.target.result;
                $scope.currentPage.bgImg = e.target.result;

                var formData = new FormData();
                formData.append('file', file);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);

                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        currentPage.background.resource.identifier = data.key;
                        currentPage.background.resource.provider = "qiniu";
                    },
                    error: function (request) {
                        console.log("error");
                    }
                });
                updateHistorys();
                $scope.$digest();
            };
            reader.readAsDataURL(file);
        }

        window.dragStart = function (event) {
            var target = event.target;
            event.dataTransfer.setData("Text", target.id);
            if (target.id.indexOf('dragtargetClipArt') != '-1') {
                event.dataTransfer.setData("Art", target.dataset.clipart);
            }
        };

        //撤销，重做按钮事件
        $scope.rollback = function (forward) {
            var i = $scope.template.pageI;
            if ((!forward && !$scope.pageHistory[i].currentHistoryIndex)) {
                return;
            }

            if (forward) {
                $scope.template.pages.page[i] = {
                    bgImg: '',
                    background: {
                        resource: {}
                    },
                    imageboxes: {
                        imagebox: []
                    },
                    textboxes: {
                        textboxes: []
                    },
                    barcode: {},
                    hasBarCode: false,
                    scale: 1,
                    widthM: $scope.template.pages.page[i].widthM,
                    heightM: $scope.template.pages.page[i].heightM,
                    width: $scope.template.pages.page[i].width,
                    height: $scope.template.pages.page[i].height,
                    spread: $scope.template.pages.page[i].spread,
                    backup: $scope.template.pages.page[i].backup
                };
                $scope.template.currentMenu = 'page';
                $scope.currentPage = $scope.template.pages.page[i];
            } else {
                $scope.pageHistory[i].currentHistoryIndex = $scope.pageHistory[i].currentHistoryIndex - 1;
                $scope.pageHistory[i].history.pop();
                $scope.template.pages.page[i] = angular.copy($scope.pageHistory[i].history[$scope.pageHistory[i].currentHistoryIndex]);
                if (!$scope.template.pages.page[i].imageboxes.imagebox.length && $scope.template.currentMenu == 'Img') {
                    $scope.template.currentMenu = 'page';
                }
                if (!($scope.template.pages.page[i].textboxes.textbox && $scope.template.pages.page[i].textboxes.textbox.length) && $scope.template.currentMenu == 'text') {
                    $scope.template.currentMenu = 'page';
                }
            }
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.template.widthM = $scope.currentPage.widthM;
            $scope.template.heightM = $scope.currentPage.heightM;
            setOriginalWaH(unitTransform($scope.currentPage.widthM), unitTransform($scope.currentPage.heightM), $scope.template.pageI);
            setUlWidth();
            angular.forEach($scope.template.pages.page, function (item, index) {
                if (!item.bgImg) {
                    $('#bgImg' + index).attr('src', '');            //添加src
                }
            });
        };


        $scope.zoomIn = function () {
            changeImgOffset(true);
        };

        $scope.zoomOut = function () {
            changeImgOffset(false);
        };

        $scope.reduction = function () {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            currentPage.scale = 1;
            $(".page-item").css({'margin': 'auto'});
            updateHistorys();
        };

        $scope.pageIsSpread = function (flag) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (flag) {
                currentPage.spread = true;
            } else {
                currentPage.spread = false;
            }
            updateHistorys();
        };

        $scope.pageIsBackup = function (flag) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (flag) {
                currentPage.backup = true;
            } else {
                currentPage.backup = false;
            }
            updateHistorys();
        };

        $scope.exitPage = function () {
            restoreZindex();
            MessageService.confirm("确认要退出吗？", function () {
                $state.go('product-xml', {reload: true})
            }, function () {
            });
        };


        function setOriginalWaH(width, height, i) {
            var w = width;
            var h = height;

            if (originalScale < width / height) {
                // console.log("宽定，高不定");
                //宽定，高不定
                width = $con.width() * 0.8;
                height = $con.width() * 0.8 * h / w;
            } else {
                // console.log("高定，宽不动");
                //高定，宽不动
                height = $con.height() * 0.8;
                width = $con.height() * 0.8 * w / h
            }
            $scope.template.pages.page[i].width = width;
            $scope.template.pages.page[i].height = height;
            $scope.template.pages.page[i].proportion = (w / width);
            $scope.currentPage = $scope.template.pages.page[i];
        }

        window.onresize = function () {
            // console.log("resize");
            angular.forEach($scope.template.pages.page, function (page, i) {
                setOriginalWaH(unitTransform(page.widthM), unitTransform(page.heightM), i);
            });
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            // console.log($scope.template.pageI)
        };

        function restoreZindex() {
            angular.forEach($scope.currentPage.imageboxes.imagebox, function (imagebox, i) {
                $("#mask" + i).css({'z-index': i + 200});
            });
        }

        $scope.confirmName = function () {
            createModal('app/entities/page/pagesmySuffix-save.html', 'PageMySuffixSaveController').result.then(
                function (data) {
                    $scope.borderTop = unitTransform(data.bleedTop);
                    $scope.borderBottom = unitTransform(data.bleedBottom);
                    $scope.borderLeft = unitTransform(data.bleedLeft);
                    $scope.borderRight = unitTransform(data.bleedRight);

                    if (!vm.pid || vm.isCopy) {
                        vm.page = {
                            name: data.name,
                            reprint: data.reprint,
                            categoryId: data.category,
                            themeClassify: data.themeClassify,
                            type: data.type,
                            pattern:data.pattern,
                            replace:data.replace
                        };
                    } else {
                        vm.page.name = data.name;
                        vm.page.reprint = data.reprint;
                        vm.page.pattern = data.pattern;
                        vm.page.categoryId = data.category;
                        vm.page.themeClassify = data.themeClassify;
                        vm.page.type = data.type;
                        vm.page.replace = data.replace;

                    }
                    if (vm.page.type == "Custom") {
                        vm.page.customStoreId = data.customStore.id;
                        vm.page.customStoreName = data.customStore.name;
                    } else {
                        vm.page.customStoreId = null;
                        vm.page.customStoreName = null;
                    }

                    ClipArt.getAllByCondition({
                        items: [{
                            key: "themeClassify.id",
                            value: vm.page.themeClassify,
                            op: "="
                        }]
                    }, function (data) {
                        vm.clipArts = data;
                    }, function () {
                        MessageService.error("素材获取失败")
                    })

                });
        }

        $scope.savePage = function () {
            restoreZindex();
            generateJsonFile();
        };

        var createModal = function (url, controller) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                params: {
                    copy: vm.isCopy
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };
        /************************---模板---***************************---start---*******************/
        //增加模板
        $scope.addPage = function () {
            var seq = $scope.template.pages.page.length + 1;
            $scope.template.pages.page.push({
                bgImg: '',
                seq: seq,
                background: {
                    resource: {}
                },
                imageboxes: {imagebox: []},
                textboxes: {textbox: []},
                imagearts: {imageart: []},
                barcode: {},
                hasBarCode: false,
                scale: 1,
                uuid: UidService.get(),
                widthM: $scope.template.pages.page[$scope.template.pageI].widthM,
                heightM: $scope.template.pages.page[$scope.template.pageI].heightM,
                width: $scope.template.pages.page[$scope.template.pageI].width,
                height: $scope.template.pages.page[$scope.template.pageI].height,
                spread: false,
                backup: false
            });
            $scope.template.pageI = $scope.template.pages.page.length - 1;
            updateHistorys();
            $scope.template.currentMenu = 'page';
            $scope.visibleLeft = true;
            $scope.visibleRight = false;
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];

            $scope.template.width = unitTransform($scope.template.widthM);
            $scope.template.height = unitTransform($scope.template.heightM);
            setOriginalWaH($scope.template.width, $scope.template.height, $scope.template.pageI);
            setUlWidth();
        };

        var setUlWidth = function () {
            var w = 30, w1 = 70;
            angular.forEach($scope.template.pages.page, function (page) {
                w += page.width * 42 / page.height + 16;
                w1 += (page.width + $scope.borderLeft + $scope.borderRight) * 42 / (page.height + $scope.borderTop +$scope.borderBottom) + 16;
            });
            $(".sort-ul").width(w + 'px');
            $(".nav-ol").width(w1 + 'px');
        };

        $scope.sortableOptions = {
            // 数据有变化
            update: function (e, ui) {
                $timeout(function () {
                    var resArr = [];
                    for (var i = 0; i < $scope.template.pages.page.length; i++) {
                        resArr.push($scope.template.pages.page[i].imageboxes.imagebox.length);
                    }
                })
            },

            // 完成动作
            stop: function (e, ui) {
                //do nothing
                isCanLeftAndRightPage();
            },
            items: "li:not(.not-sortable)"
        };

        // var dataWatcher = $scope.$watchCollection("data", function(){
        //     console.log("watcher");
        //     $scope.data = orderByFilter($scope.data, ["age"]);
        //     //销毁监听器
        //     dataWatcher();
        // });

        //模板预览点击时
        $scope.selectPages = function (index) {
            if (index == null) {
                return;
            }
            if (index !== $scope.template.pageI) {
                $(".bg-image").attr('src', '');
            }
            $scope.template.pageI = index;
            $scope.template.currentMenu = 'page';
            isCanLeftAndRightPage();
        };

        /**
         * 上一张，下一张
         */
        $scope.pageLeft = function () {
            $scope.template.pageI = $scope.template.pageI - 1;
            $(".bg-image").attr('src', '');
            isCanLeftAndRightPage();
        };

        $scope.pageRight = function () {
            $scope.template.pageI = $scope.template.pageI + 1;
            $(".bg-image").attr('src', '');
            isCanLeftAndRightPage();
        };

        //点击页面显示左右方向
        function isCanLeftAndRightPage() {
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            // var bg = null;
            // if($scope.currentPage.bgImg){
            //     bg = $scope.currentPage.bgImg;
            // }else if($scope.currentPage.background.resource.identifier){
            //     bg = vm.url+$scope.currentPage.background.resource.identifier;
            // }else{
            //     bg = ''
            // }
            // console.log(bg);
            // $(".bg-image").attr('src',bg);
            if ($scope.currentPage.background && $scope.currentPage.background.resource) {
               $(".bg-image").attr('src', vm.url + $scope.currentPage.background.resource.identifier + '?imageslim');
            }
            $scope.template.widthM = $scope.currentPage.widthM;
            $scope.template.heightM = $scope.currentPage.heightM;
            if ($scope.template.pages.page.length == 1) {
                $scope.visibleLeft = false;
                $scope.visibleRight = false;
            } else if ($scope.template.pageI == 0) {
                $scope.visibleLeft = false;
                $scope.visibleRight = true;
            } else if ($scope.template.pageI == $scope.template.pages.page.length - 1) {
                $scope.visibleLeft = true;
                $scope.visibleRight = false;
            } else {
                $scope.visibleLeft = true;
                $scope.visibleRight = true;
            }

            if ($scope.currentPage.unit == 'mm') {
                $scope.dpi = vm.dpiChoose[0];
                $(".temp-px").addClass('hide1');
                $(".temp-mm").removeClass('hide1');
            } else {
                $scope.dpi = vm.dpiChoose[1];
                $(".temp-px").removeClass('hide1');
                $(".temp-mm").addClass('hide1');
                var arr = ThreeHundredDpi($scope.template.widthM, $scope.template.heightM);
                $scope.template.widthPx = arr.px1;
                $scope.template.heightPx = arr.px2;
            }
        }

        /**
         * 放大缩小及还原
         */
        function changeImgOffset(zoomIn) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            var number = 1.2;
            var marTop = 0;

            if (zoomIn) {
                //限制放大倍数
                if (currentPage.scale * number > 2) {
                    return
                }
                currentPage.scale = currentPage.scale * number;
                setTimeout(function () {
                    marTop = parseInt($(".page-item").css('margin-top'));
                    if (marTop < 0) {
                        $(".page-item").css({'margin': '0 auto'});
                    }
                }, 10);
            } else {
                if (currentPage.scale == 1) {
                    return;
                }
                currentPage.scale = currentPage.scale / number;
                setTimeout(function () {
                    marTop = parseInt($(".page-item").css('margin-top'));
                    if (marTop >= 0) {
                        $(".page-item").css({'margin': 'auto'});
                    } else {
                        $(".page-item").css({'margin': '0 auto'});
                    }
                }, 10);
            }
            updateHistorys();
        }

        //模板背景图更改
        window.updateImgFile = function ($event) {
            // SweetAlert.swal('', '初始化图片中...', 'info');
            $scope.$digest();
            $timeout(function () {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var file = $event.target.files[0];

                $scope.files[$scope.template.pageI] = file;

                //$scope.uploadMul($event.target.files);
                var getBase64 = function (file, callback) {
                    var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                    reader.onload = function () {       //	成功读取
                        $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                        callback(reader.result);
                    };
                    reader.onerror = function (error) {     //	出错
                        console.log('Error: ', error);
                        alert(error);
                    };
                };

                $event.target.value = null;
                // $event.target.files[0] = null;
                getBase64(file, function (result) {
                    currentPage.bgImg = result;
                    currentPage.hasBgImg = true;
                    updateHistorys();
                    $scope.$digest();

                });
                // var $inputFile = $('#imgSelect');
                // $inputFile.closest('#form1').submit();

                var formData = new FormData();
                formData.append('file', file);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);

                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        currentPage.background.resource.identifier = data.key;
                        currentPage.background.resource.provider = "qiniu";
                    },
                    error: function (request) {
                        console.log("error");
                    }
                });
            });
        };

        $scope.isShowBg = true;
        $scope.isShowMask = false;
        $scope.isClipArt = false;
        $scope.showBgbar = function () {
            $scope.isShowBg = true;
            $scope.isShowMask = false;
            $scope.isClipArt = false;
        };

        $scope.showMaskbar = function () {
            $scope.isShowBg = false;
            $scope.isShowMask = true;
            $scope.isClipArt = false;
        };

        $scope.showClipArtbar = function () {
            $scope.isShowBg = false;
            $scope.isShowMask = false;
            $scope.isClipArt = true;
        };

        window.updateBg = function ($event) {
            var len = $scope.template.bgImgs.bgImg.length;
            $scope.$digest();
            var files = $event.target.files;
            // console.log(files[0]);
            getBgImg(files, 0, len);
        };

        function getBgImg(files, i, len) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url

            img.crossOrigin = "Anonymous";
            img.onload = function () {
                img.onload = null;
                var w = img.width;
                var h = img.height;
                if (w < h) {
                    $scope.template.bgImgs.bgImg.push({
                        'identifier': '',
                        'provider': 'qiniu',
                        'bgImg': img.src,
                        'width': 50
                    });
                } else {
                    $scope.template.bgImgs.bgImg.push({
                        'identifier': '',
                        'provider': 'qiniu',
                        'bgImg': img.src,
                        'height': 50
                    });
                }
                $scope.$digest();
                var formData = new FormData();
                formData.append('file', files[i]);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        $scope.template.bgImgs.bgImg[parseInt(len + i)].identifier = data.key;
                        $("#dragtarget" + parseInt(len + i)).attr('data-mask', data.key);
                        $scope.$digest();
                        i++;
                        if (i < files.length) {
                            getBgImg(files, i, len);
                        }
                    },
                    error: function (request) {
                        console.log("error");
                    }
                });
            };
        }

        window.updateMask = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            angular.forEach(files, function (file, i) {
                var url = window.URL || window.webkitURL;

                var pic = url.createObjectURL(file);

                var formData = new FormData();
                formData.append('file', file);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        var imagecanvas = document.createElement('canvas');
                        var imagecontext = imagecanvas.getContext('2d');
                        var newImg = document.createElement('img');
                        newImg.crossOrigin = "Anonymous";
                        newImg.src = 'content/images/white.png';
                        newImg.onload = function () {
                            newImg.onload = null;
                            var width = newImg.width;
                            var height = newImg.height;
                            newImg.setAttribute('data-mask', pic);
                            var masks = document.createElement('img');
                            masks.src = newImg.getAttribute('data-mask');
                            masks.crossOrigin = "anonymous";
                            masks.onload = function () {
                                masks.onload = null;
                                imagecanvas.width = width;
                                imagecanvas.height = height;
                                imagecontext.drawImage(masks, 0, 0, width, height);
                                imagecontext.globalCompositeOperation = 'source-atop';
                                imagecontext.drawImage(newImg, 0, 0);
                                $scope.template.masks.mask.push({
                                    resource: {
                                        'identifier': data.key,
                                        'provider': 'qiniu'
                                    },
                                    'bgImg': ImageService.dataURLtoBlob(imagecanvas.toDataURL()),
                                    'height': 50,
                                    'isEdit': false
                                });
                                updatePageHistory();
                                $scope.$digest();
                            };
                        };

                    },
                    error: function (request) {
                        console.log("error");
                    }
                });
            });
        };


        //模板宽高onchange
        $scope.updateTemplateHeightAndWidth = function (attr) {
            console.log(attr);
            var i = $scope.template.pageI;
            var page = $scope.template.pages.page[i];
            if (page.unit == 'px') {
                var aa = unitTransform($scope.template.widthPx / 300 * 25.4)
                var bb = unitTransform($scope.template.heightPx / 300 * 25.4)
                $scope.template.pages.page[i].width = $scope.template.width = aa;
                $scope.template.pages.page[i].height = $scope.template.height = bb;
                $scope.template.pages.page[i].widthM = $scope.template.widthM = $scope.template.widthPx / 300 * 25.4;
                $scope.template.pages.page[i].heightM = $scope.template.widthM = $scope.template.heightPx / 300 * 25.4;
            } else {
                $scope.template.pages.page[i].width = $scope.template.width = unitTransform($scope.template.widthM);
                $scope.template.pages.page[i].height = $scope.template.height = unitTransform($scope.template.heightM);
                $scope.template.pages.page[i].widthM = $scope.template.widthM;
                $scope.template.pages.page[i].heightM = $scope.template.heightM;
            }
            // $scope.template.pages.page[i].width = $scope.template.width = unitTransform($scope.template.widthM);
            // $scope.template.pages.page[i].height = $scope.template.height = unitTransform($scope.template.heightM);
            setOriginalWaH($scope.template.width, $scope.template.height, i);
            setUlWidth();
            $timeout(updateHistorys, 600);
        };


        var updateHistorys = function () {
            updateHistory();
            updatePageHistory();
        };

        //删除模板
        $scope.deletePage = function (index) {
            if ($scope.template.pages.page.length == 1 || $scope.template.pageI == null || $scope.template.pageI < 0) {
                return;
            }
            if (index == null && ($scope.template.pageI == null || $scope.template.pageI < 0)) {
                return;
            }
            if (index == null) {
                index = $scope.template.pageI;
            }

            $scope.template.pages.page.splice(index, 1);
            $scope.template.pageI = index == 0 ? 0 : index - 1;
            var len = $scope.template.pages.page.length;
            if (len > 1) {
                $scope.template.pages.page[len - 1].spread = false;
            }
            setUlWidth();
            updateHistorys();
        };

        $scope.deleteBg = function (index) {
            $scope.template.bgImgs.bgImg.splice(index, 1);
            updateHistorys();
        };

        window.bgOver = function (e) {
            var targ = e.target ? e.target : e.srcElement;
            var i = targ.dataset.index;
            $(".bg-del" + i).show();
        };
        window.bgLeave = function (e) {
            var targ = e.target ? e.target : e.srcElement;
            var i = targ.dataset.index;
            $(".bg-del" + i).hide();
        };

        $scope.deleteMask = function (index) {
            $scope.template.masks.mask.splice(index, 1);
            updateHistorys();
        };

        window.maskOver = function (e) {
            var targ = e.target ? e.target : e.srcElement;
            var i = targ.dataset.index;
            $(".mask-del" + i).show();
        };
        window.maskLeave = function (e) {
            var targ = e.target ? e.target : e.srcElement;
            var i = targ.dataset.index;
            $(".mask-del" + i).hide();
        };
        //删除模板背景图片
        $scope.deleteBgImg = function () {
            if ($scope.template.pages.page[$scope.template.pageI].bgImg == '') {
                return;
            }
            $scope.template.pages.page[$scope.template.pageI].bgImg = '';
            $scope.template.pages.page[$scope.template.pageI].background.resource.identifier = '';
            $scope.template.pages.page[$scope.template.pageI].hasBgImg = false;
            updateHistorys();
        };
        /************************---模板---***************************--- end---*******************/


        /************************---素材---***************************---start---*******************/
        // 素材点击时
        $scope.selectArt = function (e, $index, art) {
            fn(e);
            $scope.template.artI = $index;
            $scope.template.currentMenu = 'Art';
            $scope.template.artOnlyShow = art.onlyShow;
            $scope.template.artWidthM = art.widthM;
            $scope.template.artHeightM = art.heightM;
            $scope.template.artXM = art.offsetXM;
            $scope.template.artYM = art.offsetYM;
            $scope.template.angle = art.rotation.angle;
        };

        $scope.updateArtParameter = function (p1, p2, p3, p4) {
            var art = $scope.template.pages.page[$scope.template.pageI].imagearts.imageart[$scope.template.artI];

            if (art.unit == 'px') {
                var aa = unitTransform($scope.template[p4] / 300 * 25.4);
                art.geometry[p1] = aa;
                art[p3] = $scope.template[p4] / 300 * 25.4;
            } else {
                art[p3] = $scope.template[p2];
                art.geometry[p1] = unitTransform($scope.template[p2]);
            }
            updateHistorys();
        };
        //图片占位框旋转角度
        $scope.updateArtRotate = function () {
            var art = $scope.template.pages.page[$scope.template.pageI].imagearts.imageart[$scope.template.artI];
            art.rotation.angle = $scope.template.angle;
            updateHistorys();
        };

        //删除素材
        $scope.deleteArtBox = function () {
            $scope.template.pages.page[$scope.template.pageI].imagearts.imageart.splice($scope.template.artI, 1);
            updateHistorys();
        };

        // 素材鼠标事件
        var dragArt = {};
        window.moveArtStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var imgIndex = targ.dataset.index || $scope.template.artI;
            $scope.template.artI = imgIndex;
            dragArt.clientX = e.clientX || 0;
            dragArt.clientY = e.clientY || 0;
            dragArt.coordX = targ.offsetParent.offsetLeft;
            dragArt.coordY = targ.offsetParent.offsetTop;
            drag = true;

            var art = $scope.template.pages.page[$scope.template.pageI].imagearts.imageart[$scope.template.artI];
            if (art.unit == 'mm') {
                $scope.dpi = vm.dpiChoose[0];

                $(".art-wah-px").addClass('hide1');
                $(".art-wah-mm").removeClass('hide1');

                $(".art-xay-px").addClass('hide1');
                $(".art-xay-mm").removeClass('hide1');
            } else {
                $(".art-wah-px").removeClass('hide1');
                $(".art-wah-mm").addClass('hide1');

                $(".art-xay-px").removeClass('hide1');
                $(".art-xay-mm").addClass('hide1');
                $scope.dpi = vm.dpiChoose[1];
                var arr = ThreeHundredDpi(art.widthM, art.heightM);
                $scope.template.artWidthPx = arr.px1;
                $scope.template.artHeightPx = arr.px2;

                var arr2 = ThreeHundredDpi(art.offsetXM, art.offsetYM);
                $scope.template.artXPx = arr2.px1;
                $scope.template.artYPx = arr2.px2;
            }

            document.addEventListener("mousemove", moveArtOn, true);
            document.addEventListener("mouseup", moveArtEnd, true);
        };

        //move事件
        function moveArtOn(e) {
            fn(e);
            $scope.$digest();
            setZindex($scope.template.artI);
            if (e.target.nodeName == 'SPAN') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var pressArt = currentPage.imagearts.imageart[$scope.template.artI];
                var angle = (pressArt.rotation.angle) * Math.PI / 180;
                // 0-90度的夹角
                var angle2 = (90 - pressArt.rotation.angle) * Math.PI / 180;
                // 100-180度的夹角
                var angle3 = (180 - pressArt.rotation.angle) * Math.PI / 180;
                var angle4 = (-90 + pressArt.rotation.angle) * Math.PI / 180;
                // 180-270
                var angle5 = (270 - pressArt.rotation.angle) * 2 * Math.PI / 360;
                // 280-360
                var angle6 = (360 - pressArt.rotation.angle) * 2 * Math.PI / 360;

                var imgOffsetX = (dragArt.coordX + e.clientX - dragArt.clientX);
                var imgOffsetY = (dragArt.coordY + e.clientY - dragArt.clientY);
                var imgWidth = pressArt.geometry.width * currentPage.scale / currentPage.proportion;
                var imgHeight = pressArt.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;

                var lar = ($scope.borderLeft+$scope.borderRight)* currentPage.scale/ currentPage.proportion;
                var tab = ($scope.borderTop+$scope.borderBottom)* currentPage.scale/ currentPage.proportion;

                // 斜边
                var r = Math.sqrt(imgWidth * imgWidth + imgHeight * imgHeight);
                // 斜边夹角度数
                var rAngle = (Math.asin(imgHeight / r) * 180 / Math.PI);
                // 斜边夹角弧度
                var yrtAngle = (rAngle + pressArt.rotation.angle) * Math.PI / 180;

                // 右上角坐标
                var nativeX = imgOffsetX + imgWidth;
                var y0 = imgOffsetY - imgHeight;
                var xrt = (nativeX - imgOffsetX) * Math.cos(angle) - (imgOffsetY - y0) * Math.sin(angle) + imgOffsetX;
                var yrt = imgOffsetY - r * Math.sin(yrtAngle) + imgHeight;

                // 右下角坐标
                var xrb = (imgOffsetX) + imgWidth * Math.cos(angle).toFixed(2);
                //100-180
                var yrb = imgHeight - imgWidth * Math.sin(angle3) + imgOffsetY;
                //270-360
                var yrb2 = imgWidth * Math.sin(angle6) + imgHeight + imgOffsetY;

                // 左上角坐标
                var xlt = imgOffsetX + imgHeight * Math.cos(angle5).toFixed(2);
                var ylt = imgOffsetY + imgHeight + imgHeight * Math.sin(angle4).toFixed(2);
                // 270-360
                var ylt2 = imgHeight - imgHeight * Math.cos(angle6).toFixed(2) + imgOffsetY;


                if (1) {
                    if (imgOffsetX <= 0) {
                        imgOffsetX = 0;
                    }

                    if (imgOffsetX >= (width + lar - imgWidth)) {
                        imgOffsetX = width + lar - imgWidth;
                    }
                    if (imgOffsetY <= 0) {
                        imgOffsetY = 0;
                    }

                    if (imgOffsetY >= (height + tab - imgHeight)) {
                        imgOffsetY = height + tab - imgHeight;
                    }

                    // var x0 = (imgWidth+1)/2+imgOffsetX;
                    // var y0 = (imgHeight+1)/2+imgOffsetY;
                    // var xx = (x0 - xcenter) cosθ - (y0 - ycenter)*sinθ + x0;
                    // var yy = (x0 - xcenter) sinθ + (y0 - ycenter)*cosθ + y0;
                }

                pressArt.geometry.x = imgOffsetX / currentPage.scale * currentPage.proportion;
                pressArt.geometry.y = imgOffsetY / currentPage.scale * currentPage.proportion;

                $scope.template.artXM = pressArt.offsetXM = (imgOffsetX / currentPage.scale * currentPage.proportion / 3).toFixed(2) - 0;//px-->mm
                $scope.template.artYM = pressArt.offsetYM = (imgOffsetY / currentPage.scale * currentPage.proportion / 3).toFixed(2) - 0;//px-->mm

                if (pressArt.unit == 'px') {
                    var arr2 = ThreeHundredDpi($scope.template.artXM, $scope.template.artYM);
                    $scope.template.artXPx = arr2.px1;
                    $scope.template.artYPx = arr2.px2;
                }
            }
            return false;
        }

        //鼠标松开事件
        function moveArtEnd() {
            drag = false;
            dragArt = {};
            document.removeEventListener("mousemove", moveArtOn, true);
            document.removeEventListener("mouseup", moveArtEnd, true);
            updateHistorys();
            $scope.$digest();
        }

        /**
         *放大素材
         * @param e
         */
        window.resizeArtStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            dragMask.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragMask.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragMask.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragMask.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离

            var imgIndex = targ.dataset.index || $scope.template.artI;
            $scope.template.artI = imgIndex;

            dragFlag = true;
            document.addEventListener("mousemove", resizeArtOn, true);
            document.addEventListener("mouseup", resizeArtEnd, true);
            setZindex(e.target.dataset.index);
        };
        function resizeArtOn(e) {
            if (dragFlag) {
                fn(e);
                $scope.template.currentMenu = 'Art';
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = targ.dataset.index || $scope.template.artI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var pressArt = $scope.template.pages.page[$scope.template.pageI].imagearts.imageart[$scope.template.artI];
                if (pressArt == null) {
                    return;
                }
                // 移动的时候该div的层级设置最高
                // $("#mask" + imgIndex).css({'z-index': 300});
                //20 小图标的宽高
                var w = (dragMask.coordX + 10 + e.clientX - dragMask.clientX - pressArt.geometry.x / pageIndex.proportion * pageIndex.scale) * pageIndex.proportion / pageIndex.scale;
                var h = (dragMask.coordY + 10 + e.clientY - dragMask.clientY - pressArt.geometry.y / pageIndex.proportion * pageIndex.scale) * pageIndex.proportion / pageIndex.scale;
                if (w < 20 || h < 20) {
                    return
                }
                pressArt.geometry.width = w;
                pressArt.geometry.height = h;
                pressArt.widthM = $scope.template.artWidthM = unitTransformPx(pressArt.geometry.width);
                pressArt.heightM = $scope.template.artHeightM = unitTransformPx(pressArt.geometry.height);

                if (pressArt.unit == 'px') {
                    var arr = ThreeHundredDpi($scope.template.artWidthM, $scope.template.artHeightM);
                    $scope.template.artWidthPx = arr.px1;
                    $scope.template.artHeightPx = arr.px2;
                }

            }
            $scope.$digest();
            return false;
        }

        function resizeArtEnd() {
            console.log("end");
            dragFlag = false;
            document.removeEventListener("mousemove", resizeArtOn, true);
            document.removeEventListener("mouseup", resizeArtEnd, true);
            updateHistorys();
            $scope.$digest();
        }


        /************************---素材---***************************--- end ---*******************/

        /************************---蒙版---***************************---start---*******************/
        //增加图片占位框
        $scope.addImg = function () {
            restoreZindex();
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (!currentPage.imageboxes.imagebox) {
                currentPage.imageboxes.imagebox = [];
            }
            $scope.template.imgWidthM = 50;
            $scope.template.imgHeightM = 45;

            $scope.template.offsetXM = 12 + currentPage.imageboxes.imagebox.length * 2;
            $scope.template.offsetYM = 12 + currentPage.imageboxes.imagebox.length * 2;

            $(".img-xay-px").addClass('hide1');
            $(".img-xay-mm").removeClass('hide1');
            $(".img-wah-px").addClass('hide1');
            $(".img-wah-mm").removeClass('hide1');


            $scope.template.angle = 0;

            var len = currentPage.imagearts ? currentPage.imagearts.imageart.length : 0;

            currentPage.imageboxes.imagebox.push({
                geometry: {
                    height: unitTransform($scope.template.imgHeightM),
                    width: unitTransform($scope.template.imgWidthM),
                    x: unitTransform($scope.template.offsetXM),
                    y: unitTransform($scope.template.offsetYM)
                },
                rotation: {
                    angle: 0
                },
                mask: {
                    resource: {
                        identifier: "",
                        provider: 'qiniu'
                    }
                },
                bgImg: '',
                widthM: $scope.template.imgWidthM,
                heightM: $scope.template.imgHeightM,
                offsetXM: $scope.template.offsetXM,
                offsetYM: $scope.template.offsetYM,
                zIndex: currentPage.imageboxes.imagebox.length + len + 200,
                zoom: 1,
                unit: 'mm'
            });

            $scope.template.imgI = currentPage.imageboxes.imagebox.length - 1;
            updateHistorys();
            $scope.template.currentMenu = 'Img';
            console.log($scope.template.pages.page);
        };
        //图片占位框点击时
        $scope.selectImg = function (e, $index, img) {
            $scope.template.imgI = $index;
            $scope.template.currentMenu = 'Img';
            $scope.template.imgHeightM = img.heightM;
            $scope.template.imgWidthM = img.widthM;
            $scope.template.offsetXM = img.offsetXM;
            $scope.template.offsetYM = img.offsetYM;
            $scope.template.angle = img.rotation.angle;
            setZindex($index);
            $("#maskSelect").val("");
            // console.log
            e.stopPropagation();
        };

        function setZindex(index) {
            angular.forEach($scope.currentPage.imageboxes.imagebox, function (imagebox, i) {
                $("#mask" + i).css({'z-index': i + 200});
                if (i == index) {
                    $("#mask" + index).css({'z-index': 300});
                }
            });
        }

        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        var dragMask = {};
        var pressImg;
        var pressText;
        $scope.buttonShows = false;
        window.moveImgStart = function (e) {
            fn(e);
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            var imgIndex = targ.dataset.index || $scope.template.imgI;
            console.log('imgIndex:' + imgIndex);
            $scope.template.imgI = imgIndex;
            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;
            dragBox.coordX = targ.offsetParent.offsetLeft;
            dragBox.coordY = targ.offsetParent.offsetTop;
            drag = true;
            var imgbox = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[imgIndex];

            if (imgbox.unit == 'mm') {
                $scope.dpi = vm.dpiChoose[0];

                $(".img-wah-px").addClass('hide1');
                $(".img-wah-mm").removeClass('hide1');

                $(".img-xay-px").addClass('hide1');
                $(".img-xay-mm").removeClass('hide1');
            } else {

                $(".img-wah-px").removeClass('hide1');
                $(".img-wah-mm").addClass('hide1');

                $(".img-xay-px").removeClass('hide1');
                $(".img-xay-mm").addClass('hide1');
                $scope.dpi = vm.dpiChoose[1];
                var arr = ThreeHundredDpi(imgbox.widthM, imgbox.heightM);
                $scope.template.imgWidthPx = arr.px1;
                $scope.template.imgHeightPx = arr.px2;
                var arr2 = ThreeHundredDpi(imgbox.offsetXM, imgbox.offsetYM);
                $scope.template.offsetXPx = arr2.px1;
                $scope.template.offsetYPx = arr2.px2;
            }


            document.addEventListener("mousemove", moveImgOn, true);
            document.addEventListener("mouseup", moveImgEnd, true);

            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                var mm = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[imgIndex];
                vm.CtrlKeyArray.imageboxes[imgIndex] = angular.copy(mm);
                console.log(vm.CtrlKeyArray)
            } else {
                vm.CtrlKeyArray.imageboxes = [];
                vm.CtrlKeyArray.textboxes = [];
                var cc = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[imgIndex];
                vm.CtrlKeyArray.imageboxes[0] = angular.copy(cc);
                console.log(vm.CtrlKeyArray);
            }
        };

        //图片占位框
        window.contextMenu = function (e) {
            e.preventDefault();
            //显示自定义菜单
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var imgIndex = targ.dataset.index || $scope.template.imgI;
            $scope.template.imgI = imgIndex;

            var menu = document.getElementById('menus');
            var mm = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[imgIndex];
            menu.style.display = 'block';
            menu.style.left = (mm.offsetXM + mm.widthM) + 'px';
            menu.style.top = (mm.offsetYM + 30) + 'px';
        };
        //文本框
        window.contextMenuText = function (e) {
            e.preventDefault();
            //显示自定义菜单
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var imgIndex = targ.dataset.index || $scope.template.imgI;
            $scope.template.imgI = imgIndex;
            var menu = document.getElementById('menus');
            var mm = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[imgIndex];
            menu.style.display = 'block';
            menu.style.left = mm.xM + 'px';
            menu.style.top = (mm.yM + 30) + 'px';
        };
        //关闭右键菜单
        window.onclick = function (e) {
            //用户触发click事件就可以关闭了，因为绑定在window上，按事件冒泡处理，不会影响菜单的功能
            document.getElementById('menus').style.display = 'none';
        };

        //move事件
        function moveImgOn(e) {
            fn(e);
            $scope.$digest();
            setZindex($scope.template.imgI);
            if (e.target.nodeName == 'SPAN') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var pressImg = currentPage.imageboxes.imagebox[$scope.template.imgI];
                var angle = (pressImg.rotation.angle) * Math.PI / 180;
                // 0-90度的夹角
                var angle2 = (90 - pressImg.rotation.angle) * Math.PI / 180;
                // 100-180度的夹角
                var angle3 = (180 - pressImg.rotation.angle) * Math.PI / 180;
                var angle4 = (-90 + pressImg.rotation.angle) * Math.PI / 180;
                // 180-270
                var angle5 = (270 - pressImg.rotation.angle) * 2 * Math.PI / 360;
                // 280-360
                var angle6 = (360 - pressImg.rotation.angle) * 2 * Math.PI / 360;

                var imgOffsetX = (dragBox.coordX + e.clientX - dragBox.clientX);
                var imgOffsetY = (dragBox.coordY + e.clientY - dragBox.clientY);
                var imgWidth = pressImg.geometry.width * currentPage.scale / currentPage.proportion;
                var imgHeight = pressImg.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;

                var lar = ($scope.borderLeft+$scope.borderRight)* currentPage.scale/ currentPage.proportion;
                var tab = ($scope.borderTop+$scope.borderBottom)* currentPage.scale/ currentPage.proportion;

                // 斜边
                var r = Math.sqrt(imgWidth * imgWidth + imgHeight * imgHeight);
                // 斜边夹角度数
                var rAngle = (Math.asin(imgHeight / r) * 180 / Math.PI);
                // 斜边夹角弧度
                var yrtAngle = (rAngle + pressImg.rotation.angle) * Math.PI / 180;

                // 右上角坐标
                var nativeX = imgOffsetX + imgWidth;
                var y0 = imgOffsetY - imgHeight;
                var xrt = (nativeX - imgOffsetX) * Math.cos(angle) - (imgOffsetY - y0) * Math.sin(angle) + imgOffsetX;
                var yrt = imgOffsetY - r * Math.sin(yrtAngle) + imgHeight;

                // 右下角坐标
                var xrb = (imgOffsetX) + imgWidth * Math.cos(angle).toFixed(2);
                //100-180
                var yrb = imgHeight - imgWidth * Math.sin(angle3) + imgOffsetY;
                //270-360
                var yrb2 = imgWidth * Math.sin(angle6) + imgHeight + imgOffsetY;

                // 左上角坐标
                var xlt = imgOffsetX + imgHeight * Math.cos(angle5).toFixed(2);
                var ylt = imgOffsetY + imgHeight + imgHeight * Math.sin(angle4).toFixed(2);
                // 270-360
                var ylt2 = imgHeight - imgHeight * Math.cos(angle6).toFixed(2) + imgOffsetY;

                if (angle == 0) {
                    if (imgOffsetX <= 0) {
                        imgOffsetX = 0;
                    }

                    if (imgOffsetX >= (width + lar - imgWidth)) {
                        imgOffsetX = width + lar - imgWidth;
                    }
                    if (imgOffsetY <= 0) {
                        imgOffsetY = 0;
                    }

                    if (imgOffsetY >= (height + tab - imgHeight)) {
                        imgOffsetY = height + tab - imgHeight;
                    }
                } else {

                    if (pressImg.rotation.angle <= 90) {
                        // 左
                        if (imgOffsetX <= imgHeight * Math.cos(angle2).toFixed(2)) {
                            imgOffsetX = imgHeight * Math.cos(angle2).toFixed(2);
                        }
                        // 右
                        if (xrb >= width + lar) {
                            imgOffsetX = width + lar - imgWidth * Math.cos(angle).toFixed(2)
                        }
                        // 上
                        if (yrt <= 0) {
                            imgOffsetY = r * Math.sin(yrtAngle) - imgHeight;
                        }
                        // 下
                        if (imgOffsetY >= (height + tab - imgHeight)) {
                            imgOffsetY = height + tab - imgHeight;
                        }
                    }

                    if (pressImg.rotation.angle > 90 && pressImg.rotation.angle <= 180) {

                        if (xrt <= 0) {
                            imgOffsetX = (imgOffsetY - y0) * Math.sin(angle) - (nativeX - imgOffsetX) * Math.cos(angle);
                        }
                        if (imgOffsetX >= width + lar) {
                            imgOffsetX = width + lar
                        }

                        if (yrb <= 0) {
                            imgOffsetY = imgWidth * Math.sin(angle3) - imgHeight;
                        }

                        if (ylt >= (height + tab)) {
                            imgOffsetY = height + tab - imgHeight * Math.sin(angle4).toFixed(2) - imgHeight;
                        }
                    }

                    if (pressImg.rotation.angle > 180 && pressImg.rotation.angle <= 270) {

                        if (xrb <= 0) {
                            imgOffsetX = -imgWidth * Math.cos(angle).toFixed(2);
                        }
                        if (xlt >= width + lar) {
                            imgOffsetX = width + lar - imgHeight * Math.cos(angle5).toFixed(2)
                        }

                        if (imgOffsetY <= -imgHeight) {
                            imgOffsetY = -imgHeight;
                        }

                        if (yrt >= (height + tab)) {
                            imgOffsetY = height + tab - imgHeight + r * Math.sin(yrtAngle);
                        }
                    }

                    if (pressImg.rotation.angle > 270 && pressImg.rotation.angle <= 360) {
                        if (imgOffsetX <= 0) {
                            imgOffsetX = 0;
                        }
                        if (xrt >= width + lar) {
                            imgOffsetX = width + lar + (imgOffsetY - y0) * Math.sin(angle) - (nativeX - imgOffsetX) * Math.cos(angle)
                        }

                        if (ylt2 <= 0) {
                            imgOffsetY = imgHeight * Math.cos(angle6).toFixed(2) - imgHeight;
                        }

                        if (yrb2 >= (height + tab)) {
                            imgOffsetY = height + tab - imgHeight - imgWidth * Math.sin(angle6);
                        }
                    }
                }

                pressImg.geometry.x = imgOffsetX / currentPage.scale * currentPage.proportion;
                pressImg.geometry.y = imgOffsetY / currentPage.scale * currentPage.proportion;

                $scope.template.offsetXM = pressImg.offsetXM = (pressImg.geometry.x / 3).toFixed(2) - 0;//px-->mm
                $scope.template.offsetYM = pressImg.offsetYM = (pressImg.geometry.y / 3).toFixed(2) - 0;//px-->mm

                if (pressImg.unit == 'px') {
                    var arr2 = ThreeHundredDpi($scope.template.offsetXM, $scope.template.offsetYM);
                    $scope.template.offsetXPx = arr2.px1;
                    $scope.template.offsetYPx = arr2.px2;
                }
            }
            return false;
        }

        //鼠标松开事件
        function moveImgEnd() {
            pressImg = null;
            drag = false;
            dragBox = {};
            dragFlag = false;
            dragMask = {};
            document.removeEventListener("mousemove", moveImgOn, true);
            document.removeEventListener("mouseup", moveImgEnd, true);
            updateHistorys();
            $scope.$digest();
        }

        /**
         *放大占位框
         * @param e
         */
        var dragFlag = false;
        window.resizeStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.imgI = targ.dataset.index;
            dragMask.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragMask.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragMask.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragMask.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
            dragFlag = true;
            $scope.template.currentMenu = 'Img';
            document.addEventListener("mousemove", resizeOn, true);
            document.addEventListener("mouseup", resizeEnd, true);
            setZindex(e.target.dataset.index);
        };
        function resizeOn(e) {
            if (dragFlag) {
                fn(e);
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = $scope.template.imgI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var pressImg = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[imgIndex];
                if (pressImg == null) {
                    return;
                }
                // 移动的时候该div的层级设置最高
                $("#mask" + imgIndex).css({'z-index': 300});
                //20 小图标的宽高
                pressImg.geometry.width = (dragMask.coordX + 10 + e.clientX - dragMask.clientX - pressImg.geometry.x / pageIndex.proportion * pageIndex.scale) * pageIndex.proportion / pageIndex.scale;
                pressImg.geometry.height = (dragMask.coordY + 10 + e.clientY - dragMask.clientY - pressImg.geometry.y / pageIndex.proportion * pageIndex.scale) * pageIndex.proportion / pageIndex.scale;
                pressImg.widthM = $scope.template.imgWidthM = unitTransformPx(pressImg.geometry.width);
                pressImg.heightM = $scope.template.imgHeightM = unitTransformPx(pressImg.geometry.height);

                if (pressImg.unit == 'px') {
                    var arr = ThreeHundredDpi($scope.template.imgWidthM, $scope.template.imgHeightM);
                    $scope.template.imgWidthPx = arr.px1;
                    $scope.template.imgHeightPx = arr.px2;
                }

            }
            $scope.$digest();
            return false;
        }

        function resizeEnd() {
            console.log("end");
            pressImg = null;
            dragFlag = false;
            dragMask = {};
            document.removeEventListener("mousemove", resizeOn, true);
            document.removeEventListener("mouseup", resizeEnd, true);
            $scope.template.currentMenu = 'Img';
            updateHistorys();
            $scope.$digest();
        }

        //防止事件冒泡，默认事件
        function fn(e) {
            // e = e || window.event;
            // e.cancelBubble = true;
            // e.stopPropagation();
            // e.returnValue = false;
            // e.preventDefault();

            if (e && e.stopPropagation) {

                // 因此它支持W3C的stopPropagation()方法

                e.stopPropagation();

            } else {

                // 否则，我们需要使用IE的方式来取消事件冒泡

                window.event.cancelBubble = true;

            }

            // 阻止默认浏览器动作(W3C)

            if (e && e.preventDefault) {

                e.preventDefault();

            } else {

                // IE中阻止函数器默认动作的方式

                window.event.returnValue = false;

            }
        }

        //蒙版图更改
        window.updateMaskFile = function ($event) {
            $timeout(function () {
                var currentImg = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[$scope.template.imgI];
                var file = $event.target.files[0];
                currentImg.masks = file;
                var getBase64 = function (file, callback) {
                    var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                    reader.onload = function () {       //	成功读取
                        $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                        callback(reader.result);
                    };
                    reader.onerror = function (error) {     //	出错
                        console.log('Error: ', error);
                        alert(error);
                    };
                };

                // $("#maskSelect")[0].value = $event.target.value;
                currentImg.fileName = $event.target.value;
                // $event.target.value = null;
                // $event.target.files[0] = null;
                getBase64(file, function (result) {
                    currentImg.masks = result;
                    updateHistorys();
                    $scope.$digest();
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('key', "product-" + UidService.get());
                formData.append('token', vm.token);

                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        currentImg.mask.resource.identifier = data.key;
                        currentImg.mask.resource.provider = "qiniu";
                        MessageService.success("蒙版上传成功");
                        // $("#commonLayout_appcreshi").parent().html(data);
                    },
                    error: function (request) {
                        MessageService.error("蒙版上传失败");
                        console.log("error");
                    }
                });

                var imagecanvas = document.createElement('canvas');
                var imagecontext = imagecanvas.getContext('2d');
                var img = document.getElementsByClassName('page-item')[$scope.template.pageI].getElementsByClassName('mask')[$scope.template.imgI];
                // img.src = 'content/images/otis_redding.png';
                img.src = 'content/images/shattered.png';
                var newImg = document.createElement('img');
                newImg.crossOrigin = "Anonymous";
                newImg.src = img.src;
                newImg.onload = function () {
                    newImg.onload = null;
                    var width = newImg.width;
                    var height = newImg.height;
                    img.setAttribute('data-mask', currentImg.masks);
                    var masks = document.createElement('img');
                    masks.src = img.getAttribute('data-mask');
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = width;
                        imagecanvas.height = height;
                        imagecontext.drawImage(masks, 0, 0, width, height);
                        imagecontext.globalCompositeOperation = 'source-atop';
                        imagecontext.drawImage(img, 0, 0);
                        img.src = imagecanvas.toDataURL();
                        updateHistorys();
                        $scope.$digest();
                    };
                };
            });
        };

        $scope.updateImgParameter = function (p1, p2, p3, p4) {
            var img = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[$scope.template.imgI];
            console.log(img.unit)
            if (img.unit == 'px') {
                $scope.dpi = vm.dpiChoose[1];
                var aa = unitTransform($scope.template[p4] / 300 * 25.4);
                img.geometry[p1] = aa;
                img[p3] = $scope.template[p4] / 300 * 25.4;

            } else {
                $scope.dpi = vm.dpiChoose[0];
                img[p3] = $scope.template[p2];
                img.geometry[p1] = unitTransform($scope.template[p2]);

            }
            updateHistorys();
            setUlWidth();
        };

        function ToggleClass(attr, flag) {
            if (flag) {
                $("." + attr + "-wah-px").addClass('hide1');
                $("." + attr + "-wah-mm").removeClass('hide1');
                $("." + attr + "-xay-px").addClass('hide1');
                $("." + attr + "-xay-mm").removeClass('hide1');
            } else {
                $("." + attr + "-wah-px").removeClass('hide1');
                $("." + attr + "-wah-mm").addClass('hide1');
                $("." + attr + "-xay-px").removeClass('hide1');
                $("." + attr + "-xay-mm").addClass('hide1');
            }

        }


        //图片占位框旋转角度
        $scope.updateImgRotate = function () {
            var img = $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox[$scope.template.imgI];
            img.rotation.angle = $scope.template.angle;
            updateHistorys();
        };

        //删除图片占位框
        $scope.deleteImgBox = function () {
            $scope.template.pages.page[$scope.template.pageI].imageboxes.imagebox.splice($scope.template.imgI, 1);
            updateHistorys();
        };

        /************************---蒙版---***************************---end ---*******************/

        /************************---文本---***************************---start---*******************/
        //增加文本框
        $scope.addText = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (!currentPage.textboxes.textbox) {
                currentPage.textboxes = {
                    textbox: []
                };
            }
            $(".text-xay-px").addClass('hide1');
            $(".text-wah-px").addClass('hide1');
            $(".text-xay-mm").removeClass('hide1');
            $(".text-wah-mm").removeClass('hide1');

            $scope.template.textWidthM = 40;
            $scope.template.textHeightM = 8;
            $scope.template.textXM = (20 + currentPage.textboxes.textbox.length * 2);
            $scope.template.textYM = (20 + currentPage.textboxes.textbox.length * 2);
            $scope.template.text = "";
            $scope.template.textAngle = 0;
            $scope.template.textSize = 16;
            var currentGeometry = {
                width: unitTransform($scope.template.textWidthM),
                height: unitTransform($scope.template.textHeightM),
                x: unitTransform($scope.template.textXM),
                y: unitTransform($scope.template.textYM)
            };
            currentPage.textboxes.textbox.push({
                geometry: currentGeometry,
                rotation: {
                    angle: 0
                },
                style: {
                    bold: $scope.template.bold ? true : false,
                    color: $scope.template.textColor,
                    font: $scope.template.textFont,
                    italic: $scope.template.italic ? true : false,
                    size: $scope.template.textSize
                },
                text: '',
                fontStyle: $scope.template.fontStyle,
                picCode: '',
                type: 'static',
                status: 'dynamic',
                xM: $scope.template.textXM,
                yM: $scope.template.textYM,
                widthM: $scope.template.textWidthM,
                heightM: $scope.template.textHeightM,
                unit: 'mm'
            });
            $scope.template.textI = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox.length - 1;
            $scope.template.currentMenu = 'text';
            // $scope.currentText = {width: currentGeometry.width, height: 24};
            $scope.updateTextFont(vm.fontNames[0]);
            updateHistorys();
            console.log($scope.template.pages.page)
        };

        //文本框点击时
        $scope.selectText = function (e, $index, text) {
            fn(e);
            $scope.template.textI = $index;
            $scope.template.currentMenu = 'text';
            $scope.template.textWidthM = text.widthM;
            $scope.template.textHeightM = text.heightM;
            $scope.template.textYM = text.yM;
            $scope.template.textXM = text.xM;
            $scope.template.text = text.text;
            $scope.template.textFont = text.style.font;
            $scope.template.textSize = text.style.size;
            $scope.template.textColor = text.style.color;
            $scope.template.textAngle = text.rotation.angle;
            chargeFontPath(text.identifier);
            console.log(text.unit);

            if (text.unit == 'mm') {
                $scope.dpi = vm.dpiChoose[0];

                $(".text-wah-px").addClass('hide1');
                $(".text-wah-mm").removeClass('hide1');

                $(".text-xay-px").addClass('hide1');
                $(".text-xay-mm").removeClass('hide1');
            } else {

                $(".text-wah-px").removeClass('hide1');
                $(".text-wah-mm").addClass('hide1');

                $(".text-xay-px").removeClass('hide1');
                $(".text-xay-mm").addClass('hide1');
                $scope.dpi = vm.dpiChoose[1];
                var arr = ThreeHundredDpi(text.widthM, text.heightM);
                $scope.template.textWidthPx = arr.px1;
                $scope.template.textHeightPx = arr.px2;

                var arr2 = ThreeHundredDpi(text.xM, text.yM);
                $scope.template.textXPx = arr2.px1;
                $scope.template.textYPx = arr2.px2;
            }

            // e.stopPropagation();
        };
        //文本框鼠标事件
        var dragText;
        var dragTextBox = {};
        window.moveTextStart = function (e) {
            fn(e);
            $scope.buttonShows = true;
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var imgIndex = targ.dataset.index || $scope.template.textI;
            $scope.template.textI = imgIndex;

            pressText = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[imgIndex];
            dragTextBox.clientX = e.clientX || 0;
            dragTextBox.clientY = e.clientY || 0;
            dragTextBox.coordX = targ.offsetLeft;
            dragTextBox.coordY = targ.offsetTop;
            dragText = true;

            document.addEventListener("mousemove", moveTextOn, true);
            document.addEventListener("mouseup", moveTextEnd, true);

            if (e.ctrlKey == true || e.metaKey == true) {
                var mm = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[imgIndex];
                vm.CtrlKeyArray.textboxes[imgIndex] = angular.copy(mm);
                console.log(vm.CtrlKeyArray);
            } else {
                vm.CtrlKeyArray.textboxes = [];
                vm.CtrlKeyArray.imageboxes = [];
                var cc = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[imgIndex];
                vm.CtrlKeyArray.textboxes[0] = angular.copy(cc);
                console.log(vm.CtrlKeyArray);
            }

        };

        //文本框move事件
        function moveTextOn(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();
            if (dragText) {

                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var pressText = currentPage.textboxes.textbox[$scope.template.textI];

                var $textStyle = $("#text" + $scope.template.pageI + $scope.template.textI);
                var $pageStyle = $(".content-container");


                var x = $scope.borderLeft * currentPage.scale/ currentPage.proportion;
                var y = $scope.borderTop * currentPage.scale/ currentPage.proportion;

                var lar = ($scope.borderLeft+$scope.borderRight)* currentPage.scale/ currentPage.proportion;
                var tab = ($scope.borderTop+$scope.borderBottom)* currentPage.scale/ currentPage.proportion;

                var offsetsX = (dragTextBox.coordX + e.clientX - dragTextBox.clientX);
                var offsetsY = (dragTextBox.coordY + e.clientY - dragTextBox.clientY);

                var w = pressText.picCode ? pressText.geometry.width * currentPage.scale / currentPage.proportion : 70;
                var h = pressText.picCode ? pressText.geometry.height * currentPage.scale / currentPage.proportion : 24;

                var width = $pageStyle.width();
                var height = $pageStyle.height();


                if (offsetsX <= x) {
                    offsetsX = x;
                }

                if (offsetsX >= (width - lar - w)) {
                    offsetsX = width - lar - w;
                }
                if (offsetsY <= y) {
                    offsetsY = y;
                }

                if (offsetsY >= (height - tab - h)) {
                    offsetsY = height - tab - h;
                }
                pressText.geometry.x = offsetsX / currentPage.scale * currentPage.proportion;
                pressText.geometry.y = offsetsY / currentPage.scale * currentPage.proportion;

                $scope.template.textXM = pressText.xM = (offsetsX / currentPage.scale * currentPage.proportion / 3).toFixed(2) - 0;
                $scope.template.textYM = pressText.yM = (offsetsY / currentPage.scale * currentPage.proportion / 3).toFixed(2) - 0;

                if (pressText.unit == 'px') {
                    var arr2 = ThreeHundredDpi($scope.template.textXM, $scope.template.textYM);
                    $scope.template.textXPx = arr2.px1;
                    $scope.template.textYPx = arr2.px2;
                }

            }
            return false;
        }

        //文本框鼠标松开
        function moveTextEnd() {
            updateHistorys();
            $scope.$digest();
            pressText = null;
            dragText = false;
            document.removeEventListener("mousemove", moveTextOn, true);
            document.removeEventListener("mouseup", moveTextEnd, true);
            dragTextBox = {};
        }

        $scope.updateTextParameter = function (p1, p2, p3, p4) {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];

            if (text.unit == 'px') {
                var aa = unitTransform($scope.template[p4] / 300 * 25.4);
                text.geometry[p1] = aa;
                text[p3] = $scope.template[p4] / 300 * 25.4;
            } else {
                text.geometry[p1] = unitTransform($scope.template[p2]);
                text[p3] = $scope.template[p2];
            }
            toImg(text);
            updateHistorys();
        };


        $scope.updateTextRotate = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.rotation.angle = $scope.template.textAngle;
            updateHistorys();
        };

        $scope.updateTextSize = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.style.size = $scope.template.textSize;
            toImg(text);
            updateHistorys();
        };

        $scope.updateTextColor = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.style.color = $scope.template.textColor;
            toImg(text);
            updateHistorys();
        };

        $scope.updateTextContent = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.text = $scope.template.text;

            toImg(text);
            updateHistorys();
        };
        function toImg(text) {
            switch (text.style.bold + '' + text.style.italic) {
                case 'falsefalse':
                    text.styles = 'NORMAL';
                    break;
                case 'falsetrue':
                    text.styles = 'ITALIC';
                    break;
                case 'truefalse':
                    text.styles = 'BOLD';
                    break;
                default:
                    text.styles = 'BOLD_ITALIC';
                    break;
            }
            //  1 inch = 72pt = 96px = 2.54cm =254mm   1pt =1.06px
            if (text.style.font == null) {
                MessageService.error("请先选择文字字体");
            }
            if (text.fontStyle == null) {
                MessageService.error("文字生成失败，请重新选择字体");
                return;
            }

            for (var i = text.fontStyle.length - 1; i >= 0; i--) {
                var st = text.fontStyle[i];
                if (st.style == text.styles) {
                    text.identifier = st.path;
                    break;
                }
            }

            $http({
                // url: '/manager/api/textToImg',
                url: 'fileserves/api/convert/textToImg',
                method: 'POST',
                data: {
                    identifier: text.identifier,
                    text: text.text,
                    fontSize: text.style.size,
                    style: text.styles,
                    width: text.geometry.width,
                    height: text.geometry.height,
                    color: text.style.color,
                    family: text.style.font
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var createObjectURL = function (blob) {
                    return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
                };
                var fileURL = URL.createObjectURL(data);
                console.log(data);
                console.log(fileURL);
                text.picCode = fileURL;
                console.log(text.geometry);
            }).error(function () {
                MessageService.error("文字生成失败，请重新选择字体");
            });
        }


        var $b = $("#textBold");
        var $i = $("#textItalic");
        $scope.updateTextFont = function (data) {
            if (data == undefined) {
                MessageService.error("文字添加失败，请上传字体!");
                return
            }
            $b.addClass("button-un");
            $i.addClass("button-un");
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.style.font = $scope.template.textFont = data.family;
            text.fontStyle = [];
            angular.forEach(data.fontStyles, function (fontStyle, i) {
                text.fontStyle[i] = {
                    style: fontStyle.style,
                    path: fontStyle.path
                };
            });
            angular.forEach(text.fontStyle, function (styles, j) {
                if (styles.style.indexOf('BOLD') >= 0) {
                    $b.removeClass("button-un");
                    $scope.template.bold = true;
                    text.style.bold = true;
                } else {
                    $scope.template.bold = false;
                    text.style.bold = false;
                }
                if (styles.style.indexOf('ITALIC') >= 0) {
                    $i.removeClass("button-un");
                    $scope.template.italic = true;
                    text.style.italic = true;
                } else {
                    $scope.template.italic = false;
                    text.style.italic = false;
                }
            });
            $scope.template.fontStyle = text.fontStyle;
            toImg(text);
            updateHistorys();
        };

        FontManagement.byCondition({
            page: pagingParams.page - 1,
            size: vm.itemsPerPage,
            sort: sort()
        }, function (msg) {
            angular.forEach(msg, function (msg, i) {
                vm.fontNames[i] = {
                    family: msg.family,
                    fontStyles: msg.fontStyles,
                    id: msg.id
                };
            });
            $scope.item = vm.fontNames[0];
        });
        function chargeFontPath(path) {
            angular.forEach(vm.fontNames, function (msg) {
                angular.forEach(msg.fontStyles, function (fontStyle) {
                    if (fontStyle.path == path) {
                        var numbers = $(".fontSel").find("option"); //获取select下拉框的所有值
                        for (var x = 0; x < vm.fontNames.length + 1; x++) {
                            if ($(numbers[x]).text() == msg.family) {
                                angular.forEach(vm.fontNames, function (num, i) {
                                    $(numbers[i]).removeAttr("selected");
                                });
                                $(numbers[x]).attr("selected", "selected");
                            }
                        }
                    }
                });
            })

        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        $scope.textStatic = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.status = 'dynamic' ? text.status = 'static' : text.status = 'dynamic';
        };

        $scope.textDynamic = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            text.status = 'static' ? text.status = 'dynamic' : text.status = 'static';
        };
        $scope.textBold = function () {
            if ($b.hasClass("button-un")) {
                return;
            }
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            if (text.fontStyle.length == 1) {

                return
            }
            text.style.bold ? text.style.bold = false : text.style.bold = true;
            $scope.template.bold = text.style.bold;
            toImg(text);
            updateHistorys();
        };

        $scope.textItalic = function () {
            if ($i.hasClass("button-un")) {
                return;
            }
            var text = $scope.template.pages.page[$scope.template.pageI].textboxes.textbox[$scope.template.textI];
            if (text.fontStyle.length == 1) {
                return
            }
            text.style.italic ? text.style.italic = false : text.style.italic = true;
            $scope.template.italic = text.style.italic;
            toImg(text);
            updateHistorys();
        };

        $scope.deleteTextBox = function () {
            $scope.template.pages.page[$scope.template.pageI].textboxes.textbox.splice($scope.template.textI, 1);
            updateHistorys();
        };
        /************************---文本---***************************--- end---*******************/


        /************************---条形码---***************************--- start---*******************/
        // 增加条形码
        $scope.addBarCode = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];

            $scope.template.barWidthM = 60;
            $scope.template.barHeightM = 30;
            $scope.template.barXM = 16;
            $scope.template.barYM = 16;
            $(".bar-xay-px").addClass('hide1');
            $(".bar-wah-px").addClass('hide1');
            $(".bar-xay-mm").removeClass('hide1');
            $(".bar-wah-mm").removeClass('hide1');

            currentPage.barcode = {
                height: unitTransform($scope.template.barHeightM),
                width: unitTransform($scope.template.barWidthM),
                x: unitTransform($scope.template.barXM),
                y: unitTransform($scope.template.barYM),
                barWidthM: $scope.template.barWidthM,
                barHeightM: $scope.template.barHeightM,
                barXM: $scope.template.barXM,
                barYM: $scope.template.barYM,
                zoom: 1,
                unit: 'mm'
            };
            currentPage.hasBarCode = true;
            updateHistorys();
            $scope.template.currentMenu = 'Barcode';
        };

        $scope.updateParameter = function (p, p1, p2, p4) {
            var arr = $scope.template.pages.page[$scope.template.pageI][p];

            if (arr.unit == 'px') {
                arr[p1] = unitTransform($scope.template[p4] / 300 * 25.4);
                arr[p2] = $scope.template[p4] / 300 * 25.4;
            } else {
                arr[p1] = unitTransform($scope.template[p2]);
                arr[p2] = $scope.template[p2];
            }
            updateHistorys();
        };


        //条形码点击时
        $scope.selectBar = function (e, currentPage) {
            fn(e);
            $scope.template.currentMenu = 'Barcode';
            $scope.template.barWidthM = currentPage.barcode.barWidthM;
            $scope.template.barHeightM = currentPage.barcode.barHeightM;
            $scope.template.barYM = currentPage.barcode.barYM;
            $scope.template.barXM = currentPage.barcode.barXM;
            // e.stopPropagation();
        };

        //条形码移动事件
        var dragBar;
        var dragBarBox = {};
        window.moveBarcodeStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragBarBox.clientX = e.clientX || 0;
            dragBarBox.clientY = e.clientY || 0;
            dragBarBox.coordX = targ.offsetLeft;
            dragBarBox.coordY = targ.offsetTop;
            dragBar = true;
            document.addEventListener("mousemove", moveBarcodeOn, true);
            document.addEventListener("mouseup", moveBarcodeOnEnd, true);
        };

        //条形码move事件
        function moveBarcodeOn(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragBar) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var barOffsetX = (dragBarBox.coordX + e.clientX - dragBarBox.clientX);
                var barOffsetY = (dragBarBox.coordY + e.clientY - dragBarBox.clientY);
                var barWidth = currentPage.barcode.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.barcode.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;

                var lar = ($scope.borderLeft+$scope.borderRight)* currentPage.scale/ currentPage.proportion;
                var tab = ($scope.borderTop+$scope.borderBottom)* currentPage.scale/ currentPage.proportion;

                if (barOffsetX <= 0) {
                    barOffsetX = 0;
                }

                if (barOffsetX >= (width + lar - barWidth)) {
                    barOffsetX = width + lar - barWidth;
                }
                if (barOffsetY <= 0) {
                    barOffsetY = 0;
                }

                if (barOffsetY >= (height + tab - barHeight)) {
                    barOffsetY = height + tab - barHeight;
                }

                currentPage.barcode.x = barOffsetX / currentPage.scale * currentPage.proportion;
                currentPage.barcode.y = barOffsetY / currentPage.scale * currentPage.proportion;

                $scope.template.barXM = currentPage.barcode.barXM = (barOffsetX / currentPage.scale * currentPage.proportion / 3).toFixed(2) - 0;//px-->mm
                $scope.template.barYM = currentPage.barcode.barYM = (barOffsetY / currentPage.scale * currentPage.proportion / 3).toFixed(2) - 0;//px-->mm
            }
            return false;
        }

        //条形码鼠标松开
        function moveBarcodeOnEnd() {
            updateHistorys();
            $scope.$digest();
            dragBar = false;
            document.removeEventListener("mousemove", moveBarcodeOn, true);
            document.removeEventListener("mouseup", moveBarcodeOnEnd, true);
            dragBarBox = {};
        }


        $scope.deleteBarCode = function () {
            $scope.template.pages.page[$scope.template.pageI].barcode = {};
            $scope.template.pages.page[$scope.template.pageI].hasBarCode = false;
            $scope.template.currentMenu = 'page';
            updateHistorys();
        };

        /************************---条形码---***************************--- end---*******************/


            //历史纪录
        var updateHistory = function () {
                $scope.history.push(angular.copy($scope.template));
                if ($scope.history.length > 20) {
                    $scope.history.splice($scope.history.length - 4, $scope.history.length - 5)
                }
                $scope.currentHistoryIndex = $scope.history.length - 1;
                $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            };

        //每一页的历史记录
        var updatePageHistory = function () {
            if (!$scope.pageHistory[$scope.template.pageI]) {
                $scope.pageHistory[$scope.template.pageI] = {
                    history: []
                }
            }
            $scope.pageHistory[$scope.template.pageI].history.push(angular.copy($scope.template.pages.page[$scope.template.pageI]));
            if ($scope.pageHistory[$scope.template.pageI].history.length > 20) {
                $scope.pageHistory[$scope.template.pageI].history.splice($scope.pageHistory[$scope.template.pageI].history.length - 4, $scope.pageHistory[$scope.template.pageI].history.length - 5)
            }
            $scope.pageHistory[$scope.template.pageI].currentHistoryIndex = $scope.pageHistory[$scope.template.pageI].history.length - 1;
        };


        //json下载文件中需要的内容
        var generateJsonFile = function () {
            $scope.isHasGeometry = true;
            var myTimer = setInterval(function () {
                if (timer == null) {
                    clearInterval(myTimer);
                    var template = angular.copy($scope.template);
                    template.reprint = vm.page.reprint;
                    template.pattern = vm.page.pattern;
                    template.replace = vm.page.replace;
                    angular.forEach(template.pages.page, function (item) {
                        item.centerRotation = true;
                        item.mediabox = {
                            height: item.heightM + unitTransformPx($scope.borderTop) + unitTransformPx($scope.borderBottom),
                            width: item.widthM + unitTransformPx($scope.borderLeft) + unitTransformPx($scope.borderRight),
                            x: 0,
                            y: 0
                        };
                        item.trimbox = {
                            height: item.heightM,
                            width: item.widthM,
                            x: unitTransformPx($scope.borderLeft),
                            y: unitTransformPx($scope.borderTop)
                        };
                        if (item.hasBarCode) {
                            item.barcode = {
                                height: item.barcode.barHeightM,
                                width: item.barcode.barWidthM,
                                x: item.barcode.barXM,
                                y: item.barcode.barYM
                            };
                        } else {
                            item.barcode = null;
                        }

                        if (item.imagearts) {
                            angular.forEach(item.imagearts.imageart, function (art, i) {
                                art.geometry = {
                                    height: art.heightM,
                                    width: art.widthM,
                                    x: art.offsetXM,
                                    y: art.offsetYM
                                };
                            });
                        }

                        angular.forEach(item.imageboxes.imagebox, function (img, i) {
                            delete img.bgImg;
                            if (img.heightM <= 1 || img.widthM <= 1) {
                                $scope.isHasGeometry = false;
                            }
                            img.geometry = {
                                height: img.heightM,
                                width: img.widthM,
                                x: img.offsetXM,
                                y: img.offsetYM
                            }
                        });

                        angular.forEach(item.textboxes.textbox, function (text, i) {
                            text.geometry = {
                                height: text.heightM,
                                width: text.widthM,
                                x: text.xM,
                                y: text.yM
                            }
                        });
                    });

                    if (!$scope.isHasGeometry) {
                        MessageService.error("请输入正确的占位框宽高！");
                        return
                    }

                    if ($stateParams.id && !$stateParams.copy) {
                        ProductXmlFileServes.update({
                            document: template,
                            reprint: vm.page.reprint,
                            pattern: vm.page.pattern,
                            replace : vm.page.replace,
                            name: vm.page.name,
                            categoryId: vm.page.categoryId,
                            id: $stateParams.id,
                            provider: vm.page.provider,
                            themeId: vm.page.themeClassify,
                            type: vm.page.type,
                            customStoreId: vm.page.customStoreId,
                            customStoreName: vm.page.customStoreName

                        }, success, error);
                    } else {
                        ProductXmlFileServes.save({
                            document: template,
                            reprint: vm.page.reprint,
                            pattern: vm.page.pattern,
                            replace:vm.page.replace,
                            name: vm.page.name,
                            categoryId: vm.page.categoryId,
                            themeId: vm.page.themeClassify,
                            type: vm.page.type,
                            customStoreId: vm.page.customStoreId,
                            customStoreName: vm.page.customStoreName
                        }, success, error);
                    }
                }
            }, 600);
        };

        function success(data) {
            MessageService.success("保存成功！");
            $state.go('product-xml', {reload: true})
        }

        function error() {
            MessageService.error("保存失败！");
        }


        $scope.getPageBgImg = function () {
            return $('#bgImg' + $scope.template.pageI).attr('src');
        };


        $scope.$watch('template.widthM', function (newValue, oldValue) {
        });

        $scope.toggleShowBorder = function () {
            updateHistory();
            updatePageHistory();
        };

        // ?imageMogr2/gravity/Center/crop/100x100
    }

})();

(function () {
    'use strict';

    var threePreviewModal = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/page/modal/three-preview-modal.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '=',
            width: '=',
            modelPath: '=',
            modelData: '<',
        },

        controller: ['$scope', '$stateParams', 'Qinius', '$http', '$q',
            'MessageService','$state', '$compile','$timeout', 'ThreeEnv',
            function ($scope, $stateParams, Qinius, $http, $q,
                       MessageService,$state, $compile,$timeout, ThreeEnv) {
                var vm = this;
                vm.loading = true;
                vm.error = false;
                vm.data = "";
                vm.viewWidth = vm.width;
                vm.viewHeight = vm.height;
                vm.$onChanges = function(data) {
                    console.log(data)
                    if (data.modelData) {
                        vm.modelData = data.modelData.currentValue;
                        initContent1();
                    }
                };
                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }
                $q.all().then(function () {
                    init();
                });

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, guiControls;
                // var stats = initStats();

                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                    // scene.background = new THREE.Color(0xB3CEFB);
                    // scene.fog = new THREE.Fog(scene.background, 0.1, 1);
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    // camera = new THREE.PerspectiveCamera(45, vm.viewWidth / vm.viewHeight, 0.1, 100000);
                    // camera.position.z = 15;
                    // camera.lookAt(new THREE.Vector3(0, 10, 0));


                    camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                    var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                    l1.name = 'a-light';
                    camera.add(l1);
                    var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
                    l2.position.set(6, 0, 6); // ~60º
                    l2.name = 'm-light';
                    l2.castShadow = true;
                    camera.add(l2);
                    var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                    l3.name = 'h-light';
                    camera.add(l3);
                    scene.add(camera);

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView").appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }

                /* 灯光 */
                function initLight() {
                    scene.add(new THREE.AmbientLight(0xdddddd));
                    var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
                    directionalLight.position.set(-4, 8, 4);
                    var dhelper = new THREE.DirectionalLightHelper(directionalLight, 5, 0xff0000);

                    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
                    hemisphereLight.position.set(0, 8, 0);
                    var hHelper = new THREE.HemisphereLightHelper(hemisphereLight, 5);

                    // directionalLight.castShadow = true;
                    // directionalLight.shadow.mapSize = new THREE.Vector2(100000, 100);
                    // directionalLight.shadow.bias = -0.1;
                    // scene.add(hemisphereLight);
                    scene.add(directionalLight);


                    // let floorGeometry = new THREE.PlaneGeometry(500, 500, 32);
                    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
                    // let floorMaterial = new THREE.MeshPhongMaterial({
                    //     color: 0xffff00,
                    //     shininess: 0,
                    //     // wireframe: true
                    // });
                    // let floor = new THREE.Mesh(floorGeometry, material);
                    // floor.rotation.x = -0.5 * Math.PI;
                    // floor.position.y = -120;
                    // floor.receiveShadow = true;
                    // scene.add(floor);
                }

                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    controls.autoRotate = true;
                    controls.autoRotateSpeed = -6;
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        // console.log(gltf);
                        var metalness = checkGltfMetalness(gltf);
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        // controls.reset();
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        camera.position.x += size / 1.0;
                        camera.position.y += size / 1.0;
                        camera.position.z += size / 1.0;
                        camera.lookAt(center);

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                // child.material.emissive =  child.material.color;
                                // child.material.emissiveMap = child.material.map;

                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }

                                            if(vm.modelData[i].color){
                                                node.color = new THREE.Color(vm.modelData[i].color);
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltfScene);
                        if (metalness > 0) {
                            console.log("metalness=" + metalness);
                            updateEnvironment();
                        }
                        // 判断当前的gltf问价中是否有动画
                        if (clips.length !== 0) {
                            var mixer = new THREE.AnimationMixer(gltfScene);
                            mixer.clipAction(gltf.animations[0]).play();
                        }
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }
                function initContent1() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }

                                            if(vm.modelData[i].color){
                                                node.color = new THREE.Color(vm.modelData[i].color);
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }

                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }

                /* 数据更新 */
                // function update() {
                //     stats.update();
                // }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView");
                    initScene();
                    initCamera(container.clientWidth, container.clientHeight);
                    initRender();
                    // initLight();
                    initControls();
                    // initGui();
                    /* 监听事件 */
                    window.addEventListener('resize', onWindowResize, false);
                    animate();
                }

                /* 循环渲染 */
                function animate() {
                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);

                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        renderer.render(scene, camera);
                        controls.update();
                    };
                    r();
                }

                $scope.onMouseOver = function () {
                    controls.autoRotate = false;
                }
                $scope.onMouseOut = function () {
                    controls.autoRotate = true;
                }

                function checkGltfMetalness(gltf) {
                    var metalness = 0;
                    if (gltf && gltf.scene) {
                        metalness = parseGroupMetalness(gltf.scene);
                    }
                    return metalness;
                }

                function parseGroupMetalness(group) {
                    var metalness = 0;
                    if (!group.children) {
                        return metalness;
                    }
                    for (var i = 0; i < group.children.length; i++) {
                        var child = group.children[i];
                        if (child.type == 'Mesh') {
                            if (child.material && child.material.metalness > metalness) {
                                metalness = child.material.metalness;
                            }
                        }
                        else if (child.type == 'Group') {
                            var val = parseGroupMetalness(child);
                            if (val > metalness) {
                                metalness = val;
                            }
                        }
                    }
                    return metalness;
                }

                function updateEnvironment () {
                    ThreeEnv.getEnvMap(renderer).then(
                        function (data) {
                            if (data && data.envMap) {
                                scene.environment = data.envMap;
                            }
                        }
                    );
                }
            }
        ]
    };

    angular
        .module('backApp')
        .component('threePreviewModal', threePreviewModal);
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('BlendentModalController', BlendentModalController);

    BlendentModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function BlendentModalController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.modelData = entity.modelData;
        vm.modelPath = entity.modelPath;
        vm.modelData1 = angular.copy(vm.modelData);

        $scope.colorChange = function () {
            vm.modelData1 = angular.copy(vm.modelData);
        }
        //保存
        function save() {
            $uibModalInstance.close(vm.modelData);
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('MultilingualDialogController', MultilingualDialogController);

    MultilingualDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'DiyEditorSetting', 'MessageService', 'JhiLanguageService'];

    function MultilingualDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, DiyEditorSetting, MessageService, JhiLanguageService) {
        /**
         * data 数据 (Object 必填)
         * key 多语言数据的key(String 必填)
         * fieldName 外部这段名(String 非必填)
         * fieldValue 外部字段值(String 非必填)
         */
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.multilingual = [];
        vm.data = entity.data || [];
        vm.key = entity.key;
        vm.fieldName = entity.fieldName;
        vm.fieldValue = entity.fieldValue;
        vm.allLanguages = JhiLanguageService.availableLanguages();
        // 弹窗中移除中文
        vm.languages = removeZhLanguage(vm.allLanguages);
        function removeZhLanguage(oldArr){
            var newArr = [];
            for (var i = 0; i < oldArr.length; i++) {
                var item = oldArr[i];
                if (item.value != 'zh-cn') {
                    newArr.push(item)
                }
            }
            return newArr
        }
        vm.languages.forEach(function (language) {
            var newLanguage = {
                key: language.key,
                language: language.value
            }
            newLanguage[vm.key] ='';
            vm.data.forEach(function (item) {
                if (item.language == language.value) {
                    newLanguage[vm.key] = item[vm.key];
                    newLanguage.id = item.id;
                }
            })
            vm.multilingual.push(newLanguage);
        })

        vm.multilingual.forEach(function(item){
            if (item.language == 'zh-cn' && vm.fieldValue && !item[vm.key]) {
                item[vm.key] = vm.fieldValue
            }
        })
        


        function cancel() {
            $uibModalInstance.dismiss();
        }


        function save() {
            // 检验是否为空
            for (var i = 0; i < vm.multilingual.length; i++) {
                var language = vm.multilingual[i];
                if (!language[vm.key]) {
                    MessageService.error('第' + (i + 1) + '项请输入内容');
                    return
                }
            }
            // 返回的数据处理
            var returnArray = [];
            for (var i = 0; i < vm.multilingual.length; i++) {
                var language = vm.multilingual[i];
                var obj = {
                    language: language.language,
                    id: language.id
                }
                obj[vm.key] =language[vm.key];
                returnArray.push(obj);
            }
            $uibModalInstance.close(returnArray);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('MouldDialogController', MouldDialogController);

    MouldDialogController.$inject = ['$timeout', '$scope', 'MessageService', '$state', 'entity', 'Mould', 'Category',
    'Property', '$q', 'ListService', 'UidService', '$localStorage'];

    function MouldDialogController($timeout, $scope, MessageService, $state, entity, Mould, Category, Property,
     $q, ListService, UidService, $localStorage) {
        var vm = this;

        vm.mould = entity.data;
        vm.clear = clear;
        vm.save = save;
        vm.categoriesAll = Category.storeGetAllByCondition({
            items: [{key: "usable", op: "=", value: "true"}]
        });

        vm.title = "编辑"
        if(!vm.mould.id){
            vm.title = "新建"
        }
        $scope.validate = function(){
            if (vm.mould.name == null || vm.mould.name == "") {
                MessageService.error("请输入名称")
                return false;
            }

            if (vm.mould.categoryId == null || vm.mould.categoryId == "") {
                MessageService.error("请选择分类")
                return false;
            }

            if (vm.mould.mouldProperties == null || vm.mould.mouldProperties.length == 0) {
                MessageService.error("请选择属性")
                return false;
            }

            var arr = [];
            angular.forEach(vm.mould.mouldProperties,function (mould) {
                if(!mould.cancelled){
                    arr.push(mould);
                }
            })

            if (arr.length) {
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i];
                    if(!item.propertyId){
                        MessageService.error("请选择规格属性");
                        return false;
                        // break;
                    }
                }

                //筛选出重复的  比较propertyId
                vm.arr1 = uniqeByKeys(arr, ['propertyId']);
                console.log(vm.arr1)
                if(vm.arr1.length!=arr.length){
                    MessageService.error("请删除重复规格")
                    return false;
                }
            }
            return true;
        }

        function obj2key(obj, keys) {
            var n = keys.length,
                key = [];
            while (n--) {
                key.push(obj[keys[n]]);
            }
            return key.join('|');
        }

        //去重操作
        function uniqeByKeys(array, keys) {
            var arr = [];
            var hash = {};
            for (var i = 0, j = array.length; i < j; i++) {
                if(!array[i].cancelled&&!array[i].deleted){
                    var k = obj2key(array[i], keys);
                    if (!(k in hash)) {
                        hash[k] = true;
                        arr.push(array[i]);
                    }
                }else{
                    arr.push(array[i]);
                }

            }
            return arr;
        }

        $q.all([vm.categoriesAll.$promise]).then(function () {
            vm.categories = vm.categoriesAll.data;
            Property.getAllByCondition({
                items: [{key: "storeId", op: "=", value: $localStorage.user.storeId}]
            },function (res) {
                if(res.status==200){
                    vm.properties = res.data;
                }else{
                    MessageService.error(res.message);
                }
            });

            console.log(vm.mould)
        })


        $scope.addItemValue = function () {
            var objectValue = {
                added: true,
                deleted: false,
                uuid: UidService.get()
            };
            if(!vm.mould.mouldProperties){
                vm.mould.mouldProperties = []
            }
            vm.mould.mouldProperties.push(objectValue)
        }

        $scope.deleteValue = function (value, properties) {
            if (value == null) {
                return;
            }

            if (!value.added) {
                value.deleted = true;
                value.cancelled = true;
            } else {
                var ind = properties.indexOf(value);
                if (ind >= 0) {
                    properties.splice(ind, 1);
                }
            }
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        })

        function clear() {
            $state.go('mould', null, {reload: 'mould'});
        }

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            if (vm.mould.id !== null) {
                Mould.update(vm.mould, onSaveSuccess, onSaveError);
            } else {
                Mould.save(vm.mould, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(res) {
            if(res.status==200){
                $scope.$emit('platformApp:mouldUpdate', res.data);
                $state.go('mould', null, {reload: 'mould'});
                vm.isSaving = false;
                MessageService.success("保存成功");
            }else{
                MessageService.error(res.message);
            }

        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("保存失败");
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mould', {
            parent: 'entity',
            url: '/mould?page&sort&search',
            data: {
                authorities: ['ROLE_PRODUCT_XML'],
                pageTitle: 'platformApp.mould.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mould/moulds.html',
                    controller: 'MouldController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mould');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mould-detail.edit', {
            parent: 'mould-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_PRODUCT_XML']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mould/mould-dialog.html',
                    controller: 'MouldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mould', function(Mould) {
                            return Mould.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mould.new', {
            parent: 'mould',
            url: '/new',
            data: {
                authorities: ['ROLE_PRODUCT_XML']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mould/mould-dialog.html',
                    controller: 'MouldDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        data:{
                            name: null,
                            number: null,
                            description: null,
                            enable: null,
                            cancelled: null,
                            id: null
                        }
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mould');
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mould.edit', {
            parent: 'mould',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_PRODUCT_XML']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mould/mould-dialog.html',
                    controller: 'MouldDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mould');
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Mould','$stateParams', function(Mould,$stateParams) {
                    return Mould.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Mould', Mould);

    Mould.$inject = ['$resource'];

    function Mould ($resource) {
        var resourceUrl =  'manager/' + 'api/moulds/:path/:id';

        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MouldController', MouldController);

    MouldController.$inject = ['$state', 'Mould', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$scope','MessageService', '$localStorage'];

    function MouldController($state, Mould, ParseLinks, AlertService, paginationConstants, pagingParams,$scope,MessageService, $localStorage) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                Mould.byCondition({
                    items: [{key: "name", op: "like", value: pagingParams.search},{key: "storeId", op: "=", value: $localStorage.user.storeId}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Mould.byCondition({
                    items: [{key: "storeId", op: "=", value: $localStorage.user.storeId}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status==200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.moulds = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message)
                }

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0  ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.delete = function (id) {
            MessageService.confirm("确认要删除该模板吗？", function () {
                Mould.delete({id: id}, function () {
                    loadAll();
                });
            }, function () {
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MessageNotificationDialogController', MessageNotificationDialogController);

    MessageNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'MessageNotification', 'MessageService',
     '$state', '$q', '$uibModal'];

    function MessageNotificationDialogController ($timeout, $scope, $stateParams, entity, MessageNotification, MessageService,
     $state, $q, $uibModal) {
        var vm = this;

        $q.all([entity.$promise]).then(function(data){
            vm.messageNotification = entity.data;
            if (vm.messageNotification.id) {
                vm.title = "编辑";
            }else{
                vm.title = "新建";
            }
        })
      
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.multilingual = multilingual;
        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.messageNotification.messageNotificationLanguages, 
                            key:"content",
                            fieldValue:vm.messageNotification.content,
                            fieldName:"消息内容"
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    vm.messageNotification.messageNotificationLanguages=data;
                }
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go("message-notification", {reload:true})
        }

        $scope.validata = function(){
            if (vm.messageNotification.content == null || vm.messageNotification.content == "") {
                MessageService.error("请输入通知内容")
                return false;
            }
            if (vm.messageNotification.seq == null || vm.messageNotification.seq == "") {
                MessageService.error("请输入排序")
                return false;
            }
            if (vm.messageNotification.pageType == null || vm.messageNotification.pageType == "") {
                MessageService.error("请选择展示页面")
                return false;
            }
            if (vm.messageNotification.validate == null || vm.messageNotification.validate == "") {
                MessageService.error("请选择有效日期")
                return false;
            }
            return true;
        }

        function save () {
            if (!$scope.validata()) {
                return;
            }
            vm.isSaving = true;
            vm.messageNotification.type = 'Store';
            if (vm.messageNotification.id) {
                MessageNotification.update(vm.messageNotification, onSaveSuccess, onSaveError);
            } else {
                MessageNotification.createByBack(vm.messageNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('platformApp:messageNotificationUpdate', result);
            $state.go("message-notification", {reload:true})
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.validate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
         .controller('MessageNotificationDetailController', MessageNotificationDetailController);

    MessageNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MessageNotification',
     '$state', '$uibModal'];

    function MessageNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, MessageNotification,
     $state, $uibModal) {
        var vm = this;

        vm.messageNotification = entity.data;
        vm.previousState = previousState.name;
        vm.clear = clear;

        var unsubscribe = $rootScope.$on('platformApp:messageNotificationUpdate', function(event, result) {
            vm.messageNotification = result;
        });

        vm.multilingual = multilingual;
        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDetail.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.messageNotification.messageNotificationLanguages, 
                            key:"content",
                            fieldValue:vm.messageNotification.content,
                            fieldName:"消息内容"
                        };
                    }]
                }
            }).result.then(function(data) {
                
            });
        }
        
        function clear () {
            $state.go("message-notification", {reload:true})
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('message-notification', {
            parent: 'logo-setting',
            url: '/message-notification?page&sort&search&pageType',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'backApp.messageNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/message-notification/message-notifications.html',
                    controller: 'MessageNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        pageType: $stateParams.pageType,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('messageNotification');
                    $translatePartialLoader.addPart('pageType');
                    $translatePartialLoader.addPart('messageType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('message-notification-detail', {
            parent: 'message-notification',
            url: '/message-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'backApp.messageNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/message-notification/message-notification-detail.html',
                    controller: 'MessageNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('messageNotification');
                    $translatePartialLoader.addPart('pageType');
                    $translatePartialLoader.addPart('messageType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MessageNotification', function($stateParams, MessageNotification) {
                    return MessageNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'message-notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
         .state('message-notification.new', {
                parent: 'message-notification',
                url: '/new',
                data: {
                    authorities: [],
                    pageTitle: 'backApp.messageNotification.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message-notification/message-notification-dialog.html',
                        controller: 'MessageNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('messageNotification');
                        $translatePartialLoader.addPart('pageType');
                        $translatePartialLoader.addPart('messageType');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            data:{
                                content: null,
                                validate: null,
                                top: null,
                                available: null,
                                seq: null,
                                protoId: null,
                                pageType: null,
                                type: null,
                                id: null
                            }
                        };
                    }
                }
            })
        .state('message-notification.edit', {
            parent: 'message-notification',
                url: '/{id}/edit',
                data: {
                    authorities: [],
                    pageTitle: 'backApp.messageNotification.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message-notification/message-notification-dialog.html',
                        controller: 'MessageNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('messageNotification');
                        $translatePartialLoader.addPart('pageType');
                        $translatePartialLoader.addPart('messageType');
                        return $translate.refresh();
                    }],
                    entity: ['MessageNotification', '$stateParams' , function(MessageNotification, $stateParams) {
                        return MessageNotification.get({id : $stateParams.id}).$promise;
                    }]
                }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('MessageNotification', MessageNotification);

    MessageNotification.$inject = ['$resource', 'DateUtils'];

    function MessageNotification ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/message-notifications/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition2': {
                method: 'POST',
                params: {
                    path: 'byCondition3'
                }
            },
            'getAllByCondition2': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition3'
                }
            },
            'createByBack': {
                method: 'POST',
                params: {
                    path: 'createByBack'
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data.validate = DateUtils.convertLocalDateFromServer(data.data.validate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validate = DateUtils.convertLocalDateToServer(copy.validate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validate = DateUtils.convertLocalDateToServer(copy.validate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MessageNotificationController', MessageNotificationController);

    MessageNotificationController.$inject = ['$scope', '$state', 'MessageNotification', 'ParseLinks', 'Principal', 'paginationConstants', 'pagingParams', 'MessageService'];

    function MessageNotificationController ($scope, $state, MessageNotification, ParseLinks, Principal, paginationConstants, pagingParams, MessageService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.jump = jump;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageType = pagingParams.pageType;
        console.log(vm.pageType)
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.time = null;
        vm.pages = ['请选择展示页面','图片库','预览页','编辑页','平铺页'];

        loadAll();

        $scope.delete = function(item){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                MessageNotification.delete({id: item.id},function () {
                    loadAll();
                    MessageService.success('删除成功');
                });
            },function(){},true)
        };

        function loadAll () {
            var items = [ ];
            if (pagingParams.search) {
                items.push({key:"content",op:"like",value:pagingParams.search});
            }
            if(vm.pageType){
                items.push({key:"pageType",op:"=",value:vm.pageType});
            }
            MessageNotification.byCondition2({
                items: items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.messageNotifications = res.data;
                    vm.messageNotifications.sort(function(a, b){return a.seq- b.seq})
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message)
                }

            }
            function onError(error) {
                MessageService.error("数据获取失败");
            }
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                pageType: vm.pageType,
            });
        }
        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function jump(){
            loadPage(vm.jumpText <= 0 ? 1 : vm.jumpText);
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        $scope.searchPageType = function () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MaterialDialogController', MaterialDialogController);

    MaterialDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Material', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', '$localStorage'];

    function MaterialDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Material, MessageService,
        Upload, UidService, ThemeClassify, $localStorage) {
        var vm = this;

        vm.type = entity.state;
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                type: entity.type || 'CLIPART',
                keys: []
            }
        }
        vm.attachments = [];
        vm.imgs = [];
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: entity.type || 'CLIPART'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                Material.getone({id: entity.data.id},function (res) {
                    if(res.status==200){
                        vm.data = res.data;
                    }else{
                        MessageService.error(res.message);
                        return
                    }
                });
            }

        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }
        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            vm.data.keys.splice(index,1);
        };

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(entity.state == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择图片");
                    return
                }
            }
            console.log(vm.data)
            vm.isSaving = true;
            if (vm.data.id != null) {
                Material.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Material.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                MessageService.success("素材保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            };

            function onSaveError () {
                MessageService.error("素材保存失败");
                vm.isSaving = false;
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('material', {
            parent: 'entity',
            url: '/material?page&sort&search&themeClassifyId&classType',
            data: {
                authorities: ["ROLE_CLIPART"],
                pageTitle: 'backApp.title.material'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material/material.html',
                    controller: 'MaterialController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        themeClassifyId: $stateParams.themeClassifyId,
                        classType: $stateParams.classType
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Material', Material);

    Material.$inject = ['$resource'];

    function Material ($resource) {
        var resourceUrl =  'manager/' + 'api/clipArt/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "getone":{
                method:"GET",
                params:{
                    path:"getone"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "batchCreate":{
                method:"GET",
                params:{
                    path:"batchCreate"
                }
            },
            "batchCreateByStore":{
                method:"GET",
                params:{
                    path:"batchCreateByStore"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "save":{
                method:"POST",
                params:{
                    path:"save"
                }
            },
            "delete":{
                method:"DELETE",
                params:{
                    path:"delete"
                }
            },
            "themeClassify":{
                method:"GET",
                params:{
                    path:"saveTheme"
                }
            },
            'update': {
                method:'PUT',
                params:{
                    path:"update"
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MaterialController', MaterialController);

    MaterialController.$inject = ['$scope', '$q', '$state', 'Material', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', '$uibModal', '$localStorage', 'ThemeClassify'];

    function MaterialController ($scope, $q, $state, Material, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, $uibModal, $localStorage, ThemeClassify) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 44;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.themeClassifyId = Number(pagingParams.themeClassifyId);
        vm.classType = pagingParams.classType || 'CLIPART';
        vm.jump = jump;
        vm.storeId = JSON.parse(localStorage.getItem('back-user')).storeId;
        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        vm.class =  ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: vm.classType}]});
        // {key: "storeId", op: "=", value: vm.storeId},
        $q.all([vm.domains.$promise , vm.class.$promise]).then(function(){
            vm.class = vm.class.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        function loadAll () {
            var items = [{key: "type", op: "like", value: vm.classType}];
            if (pagingParams.search) {
                items.push({key:"name,themeClassify.name",op:"like",value:pagingParams.search});
            }
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",op:"=",value:vm.themeClassifyId});
            }
            Material.byCondition2({
                items:items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.data = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("素材获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                themeClassifyId:vm.themeClassifyId,
                
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/material/material-dialog.html',
                controller: 'MaterialDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add',
                            type: vm.classType,
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.edit = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/material/material-dialog.html',
                controller: 'MaterialDialogController',
                controllerAs: 'vm',
                windowClass:'modal-right',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'edit',
                            data: data
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/material/material-dialog.html',
                controller: 'MaterialDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'look',
                            data: data
                        };
                    }]
                }
            });
        }
        $scope.delete = function(id){
            MessageService.confirm("确认删除该数据？",function(){
                Material.delete({id: id},function (res) {
                    if(res.status == 200){
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                });
            },function(){});
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MaskingDialogController', MaskingDialogController);

    MaskingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Masking', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', '$state'];

    function MaskingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Masking, MessageService,
        Upload, UidService, ThemeClassify, $state) {
        var vm = this;

        vm.type = entity.state;
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                type: 'MASK',
                keys: []
            }
        }
        vm.attachments = [];
        vm.imgs = [];
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'MASK'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                Masking.get({id: entity.data.id}, function (res) {
                    if(res.status == 200){
                        vm.data = res.data;
                    }else {
                        MessageService.error(res.message);
                    }
                });
            }

        })

       Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }
        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            vm.data.keys.splice(index,1);
        };
        $scope.typeSelect = function () {
            for(var i=0; i<vm.setting.length; i++){
                if(vm.setting[i].id == vm.data.themeClassifyId){
                    vm.data.themeClassifyName = vm.setting[i].name;
                }
            }
        }

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择蒙版分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(vm.type == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择图片");
                    return
                }
            }
            vm.isSaving = true;
            if (vm.data.id != null) {
                Masking.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Masking.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (res) {
                if(res.status == 200){
                    MessageService.success("蒙版保存成功");
                    $uibModalInstance.close(res.data);
                    vm.isSaving = false;
                    $state.go("masking", null, { reload: 'masking' });
                }else{
                    MessageService.error(res.message);
                    return
                }
            };

            function onSaveError () {
                MessageService.error("蒙版保存失败");
                vm.isSaving = false;
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('masking', {
            parent: 'entity',
            url: '/masking?page&sort&search&themeClassifyId',
            data: {
                authorities: ["ROLE_MASK"],
                pageTitle: 'backApp.title.masking'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/masking/masking.html',
                    controller: 'MaskingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        themeClassifyId: $stateParams.themeClassifyId,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Masking', Masking);

    Masking.$inject = ['$resource'];

    function Masking ($resource) {
        var resourceUrl =  'manager/' + 'api/materials/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "save":{
                method:"POST"
            },
            "delete":{
                method:"DELETE"
            },
            "themeClassify":{
                method:"GET",
                params:{
                    path:"saveTheme"
                }
            },
            "batchCreate":{
                method:"GET",
                params:{
                    path:"batchCreate"
                }
            },
            "batchCreateByStore":{
                method:"GET",
                params:{
                    path:"batchCreateByStore"
                }
            },
            'update': { method:'PUT' },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MaskingController', MaskingController);

    MaskingController.$inject = ['$scope', '$q', '$state', 'Masking', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', '$uibModal', '$localStorage', 'ThemeClassify'];

    function MaskingController ($scope, $q, $state, Masking, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, $uibModal, $localStorage, ThemeClassify) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 44;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.themeClassifyId = Number(pagingParams.themeClassifyId);
        vm.jump = jump;
        vm.storeId = JSON.parse(localStorage.getItem('back-user')).storeId;
        vm.class =  ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'MASK'}]});
        // {key: "storeId", op: "=", value: vm.storeId},
        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise , vm.class.$promise]).then(function(){
            vm.class = vm.class.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        function loadAll () {
            var items = [];
            if (pagingParams.search) {
                items.push({key:"name,themeClassify.name",op:"like",value:pagingParams.search});
            }
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",op:"=",value:vm.themeClassifyId});
            }
            Masking.byCondition2({
                items: items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.data = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("蒙版获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                themeClassifyId:vm.themeClassifyId,
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/masking/masking-dialog.html',
                controller: 'MaskingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add'
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
 
        $scope.edit = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/masking/masking-dialog.html',
                controller: 'MaskingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'edit',
                            data: data
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/masking/masking-dialog.html',
                controller: 'MaskingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-right',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'look',
                            data: data
                        };
                    }]
                }
            });
        }
        $scope.delete = function(id){
            MessageService.confirm("确认删除该数据？",function(){
                Masking.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('MapDepot1Controller', MapDepot1Controller)

    MapDepot1Controller.$inject = ['$scope', '$state', 'Store', 'MessageService', '$timeout', 'StoragePayOrders', '$q', '$uibModalInstance','StoreStorages','StoragePrices1','$http'];

    function MapDepot1Controller($scope, $state, Store, MessageService, $timeout, StoragePayOrders, $q, $uibModalInstance, StoreStorages,StoragePrices1,$http) {
        var vm = this;
        vm.payType = 'weChat';
        Store.getCurrent(function (res) {
            vm.store = res.data;
            StoragePrices1.byStoreId({id: vm.store.id},function (res1) {
                if(res1.status == 200){
                    vm.storages = res1.data;
                    if(vm.storages.storagePriceLines && vm.storages.storagePriceLines.length>0){
                        for(var i=0; i<vm.storages.storagePriceLines.length; i++){
                            var _storagePriceLines = vm.storages.storagePriceLines[i];
                            if(!_storagePriceLines.cancelled){
                                vm.data = _storagePriceLines;
                                createOrder();
                                break
                            }
                        }
                        swiperInit();
                    }
                }else{
                    MessageService.error(res.message || "获取图片存储失败");
                }
            });
        });
        function swiperInit(){
            $timeout(function () {
                new Swiper('.swiper-container', {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    slidesPerView: 3,
                    grid: {
                        fill: 'column',
                        rows: 2,
                    },
                });
            }, 300)
        }
        $scope.depotSelect = function (item) {
            vm.data = item;
            createOrder()
        };

        function createOrder(){
            clearInterval($scope.timer);
            vm.thisTime = currentDateLater(vm.data.periodOfValidity);
            StoragePayOrders.createOrder({storagePriceLineId: vm.data.id}, function (res) {
                payInit(res.data)
            })
        }

        function payInit(item){
            if(vm.payType == 'weChat'){
                $http({
                    url: '/manager/api/storage-pay-orders/wechatPay/'+item.id,
                    method: 'GET',
                    responseType: 'blob'
                }).success(function(res) {
                    // if(res.status == 400){
                    //     MessageService.error(res.message || "获取支付信息失败");
                    //     return
                    // }
                    $timeout(function () {
                        vm.prepare = true;
                        var blob = new Blob([res], {
                            type: "image/jpeg"
                        });
                        $scope.image = URL.createObjectURL(blob);
                        console.log($scope.image)
                        //启动一个定时器判断是否完成支付，完成则关闭页面 取消定时器
                        $scope.timer = setInterval(function() {
                            StoragePayOrders.get({
                                id: item.id
                            }, function(val) {
                                if (!!val.data && val.data.paid) {
                                    clearInterval($scope.timer);
                                    MessageService.success("支付完成");
                                    $uibModalInstance.close(true);
                                }
                            }, function() {});
                        }, 2000);
                    })
                });
            }
        }

        //返回
        $scope.cancel = function() {
            clearInterval($scope.timer);
            $uibModalInstance.close(false);
        }

        function currentDateLater(item) {
            var date = new Date();
            var y = date.getFullYear() + item;
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? ('1' + minute) : minute;
            second = second < 10 ? ('0' + second) : second;
            return y + '-' + m + '-' + d;
            // return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MapDepotRecordController', MapDepotRecordController);

    MapDepotRecordController.$inject = ['$scope', '$state', 'Store','MessageService', '$timeout', '$uibModal', 'paginationConstants','$q', 'StoragePayOrders', 'ParseLinks'];

    function MapDepotRecordController ($scope, $state, Store, MessageService, $timeout, $uibModal, paginationConstants,$q, StoragePayOrders, ParseLinks ) {
        var vm = this;

        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        init();
        function init(){
            var items = [{key: "paid", op: "=", value: "true"}];
            StoragePayOrders.byCondition({
                items: items,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tableData = res.data;
            }, function (error) {
                MessageService.error("数据加载出错");
            });
        }

        function transition() {
            init();
        }

        $scope.currentDateLater = function(item) {
            if(!item.paidDate){
                return ""
            }
            var date = new Date(item.paidDate);
            var y = date.getFullYear() + item.periodOfValidity;
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? ('1' + minute) : minute;
            second = second < 10 ? ('0' + second) : second;
            return y + '-' + m + '-' + d;
            // return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MapDepotClearRecordController', MapDepotClearRecordController);

        MapDepotClearRecordController.$inject = ['$scope', '$state', 'Store','MessageService', '$timeout', '$uibModal', 'paginationConstants','$q', 'StorageCleanSchedules', 'ParseLinks'];

    function MapDepotClearRecordController ($scope, $state, Store, MessageService, $timeout, $uibModal, paginationConstants,$q, StorageCleanSchedules, ParseLinks ) {
        var vm = this;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        init();
        function init(){
            var items = [];
            StorageCleanSchedules.byCondition({
                items: items,
                available: false,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, function (res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.tableData = res.data;
            }, function (error) {
                MessageService.error("数据加载出错");
            });

        }

        $scope.check = function(item){
            $uibModal.open({
                templateUrl: 'app/entities/map-depot/map-depot-clear-dialog.html',
                controller: 'MapDepotClearDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['StorageCleanSchedules', function (StorageCleanSchedules) {
                        return item;
                    }]
                }
            }).result.then(function (result) {
                check(result);
            });
        }

        function check(item){
            if (!item) {
                return;
            }
            StorageCleanSchedules.doClean({
                id:item.id
            } , function(res){
                if (res.status == 200) {
                    MessageService.success("操作成功");
                    init();
                }
            })
        }

        $scope.calculate = function(item){
            if (!item || !item.id) {
                return;
            }
            StorageCleanSchedules.doCalculateData({id:item.id}, function (res) {
                MessageService.success("操作成功");
                init();
            }, function (error) {
                MessageService.error("数据加载出错");
            });
        }

        $scope.cancel = function(item){
            if (!item || !item.id) {
                return;
            }
            MessageService.confirm("确认取消当前清理计划？",function(){
                StorageCleanSchedules.delete({id:item.id}, function (res) {
                    MessageService.success("取消成功");
                    init();
                }, function (error) {
                    MessageService.error("数据加载出错");
                });
            },function(){});
        }

        $scope.view = function(item){
            $uibModal.open({
                templateUrl: 'app/entities/map-depot/map-depot-clear-detail.html',
                controller: 'MapDepotClearDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['StorageCleanSchedules', function (StorageCleanSchedules) {
                        return item;
                    }]
                }
            }).result.then(function () {
            });
        }

        $scope.getStatus = function(item){
            if (!item || !item.status) {
                return;
            }
            if (item.cancelled) {
                return "已取消";
            }
            switch(item.status){
                case "Calculating":
                    return "统计中";
                    break;
                case "Calculated":
                    return "待执行";
                    break;
                case "Executing":
                    return "计划中";
                    break;
                case "Executed":
                    return "已完成";
                    break;
                default:
                    return "";
            }
        }


        function transition() {
            init();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('MapDepotClearDialogController', MapDepotClearDialogController)

        MapDepotClearDialogController.$inject = ['$scope', '$state', 'Store', 'MessageService', '$timeout', 'StoragePayOrders', '$q', '$uibModalInstance','entity','StoragePrices1','$http','handlePackage'];

    function MapDepotClearDialogController($scope, $state, Store, MessageService, $timeout, StoragePayOrders, $q, $uibModalInstance, entity,StoragePrices1,$http,handlePackage) {
        var vm = this;
        vm.data = entity;
        // $q.all([ vm.data.$promise]).then(function() {
        //     if (vm.data.status && vm.data.status != 200) {
        //         MessageService.error(vm.data.message);
        //         return;
        //     }
        //     vm.data = vm.data.message;
        // });
        vm.save = function(){
            $uibModalInstance.close();
        }
        vm.save2 = function(){
           $uibModalInstance.close(vm.data);
        }
        //返回
        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.getStatus = function(){
            if (!vm.data || !vm.data.status) {
                return;
            }
            if (vm.data.cancelled) {
                return "已取消";
            }
            switch(vm.data.status){
                case "Calculating":
                    return "统计中";
                    break;
                case "Calculated":
                    return "待执行";
                    break;
                case "Executing":
                    return "计划中";
                    break;
                case "Executed":
                    return "已完成";
                    break;
                default:
                    return "";
            }
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('MapDepotClearController', MapDepotClearController);

    MapDepotClearController.$inject = ['MessageService', "$scope" ,'$uibModal', 'StorageCleanSchedules'];

    function MapDepotClearController(MessageService, $scope , $uibModal , StorageCleanSchedules) {
        var vm = this;

        vm.data = {
            boundary : 12 ,//准备删除多久之前的  单位 月
            exemptOrdered : 90 ,//多久之前下过单的
            ordered:true,
        }

        $scope.creationClear = function () {
            if (!vm.data.boundary) {
                MessageService.error('请选择删除几个月之前的图片');
                return
            }
            if (vm.data.ordered && !vm.data.exemptOrdered) {
                MessageService.error('请输入下单后几天内的用户不清理');
                return
            }

            $uibModal.open({
                templateUrl: 'app/entities/map-depot/map-depot-clear-dialog.html',
                controller: 'MapDepotClearDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['StorageCleanSchedules', function (StorageCleanSchedules) {
                        return null;
                    }]
                }
            }).result.then(function (result) {
                create();
            });
        }

        function create(){
            StorageCleanSchedules.create(vm.data , function(res){
                if (res.status == 200) {
                    MessageService.success('创建清理任务成功')
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mapDepot', {
            parent: 'entity',
            url: '/mapDepot',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepot'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot.html',
                    controller: 'MapDepotController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapDepotRecord', {
            parent: 'mapDepot',
            url: '/mapDepotRecord',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepot'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-record.html',
                    controller: 'MapDepotRecordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapDepotSettle', {
            parent: 'mapDepot',
            url: '/{id}/mapDepotSettle',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepot'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-settle.html',
                    controller: 'MapDepotSettleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {

            }
        })
        .state('mapDepotStatistice', {
            parent: 'mapDepot',
            url: '/mapDepotStatistice',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepot'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-statistics.html',
                    controller: 'MapDepotStatisticeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {

            }
        })
        .state('mapDepotClear', {
            parent: 'mapDepot',
            url: '/mapDepotClear',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepotClear'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-clear.html',
                    controller: 'MapDepotClearController',
                    controllerAs: 'vm'
                }
            },
        })
        .state('mapDepotClearRecord', {
            parent: 'mapDepot',
            url: '/mapDepotClearRecord',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepotClearRecord'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-clear-record.html',
                    controller: 'MapDepotClearRecordController',
                    controllerAs: 'vm'
                }
            },
        })
        .state('customerPurchaseRecord', {
            parent: 'mapDepot',
            url: '/customerPurchaseRecord',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.customerPurchaseRecord'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/customer-purchase-record.html',
                    controller: 'CustomerPurchaseRecordController',
                    controllerAs: 'vm'
                }
            },
        })
        .state('mapDepotProtocol', {
            parent: 'mapDepot',
            url: '/mapDepotProtocol',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepotProtocol'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-protocol.html',
                    controller: 'MapDepotProtocolController',
                    controllerAs: 'vm'
                }
            },
        })
        .state('mapDepotProtocolEdit', {
            parent: 'mapDepot',
            url: '/mapDepotProtocolEdit',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.mapDepotProtocol'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-depot/map-depot-protocol-edit.html',
                    controller: 'MapDepotProtocolController',
                    controllerAs: 'vm'
                }
            },
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('backApp')
        .factory('StoragePrices', StoragePrices)
        .factory('StoragePrices1', StoragePrices1)
        .factory('StoragePayOrders', StoragePayOrders)
        .factory('CustomerStorages', CustomerStorages)
        .factory('StoreStorages', StoreStorages)
        .factory('StoreStorages1', StoreStorages1)
        .factory('handlePackage', handlePackage)
        .factory('CustomerStorageSnapshots', CustomerStorageSnapshots)
        .factory('CustomerStoragePayOrders', CustomerStoragePayOrders)
        .factory('StorageCleanSchedules', StorageCleanSchedules)
        .factory('CustomerClearRecords', CustomerClearRecords)

    StoragePrices.$inject = ['$resource'];
    StoragePrices1.$inject = ['$resource'];
    StoragePayOrders.$inject = ['$resource'];
    CustomerStorages.$inject = ['$resource'];
    StoreStorages.$inject = ['$resource'];
    StoreStorages1.$inject = ['$resource'];
    handlePackage.$inject = ['$resource'];
    CustomerStorageSnapshots.$inject = ['$resource'];
    CustomerStoragePayOrders.$inject = ['$resource'];
    StorageCleanSchedules.$inject = ['$resource'];
    CustomerClearRecords.$inject = ['$resource'];
    function handlePackage($resource) {
        var resourceUrl = 'manager/' + 'api/store-storage-prices/:path/:id';
        return $resource(resourceUrl, {}, {
            'CreatePackage': {
                method: "POST",
            },
            'updatePackage':{
                method: "POST",
            },
            'getAllByCondition1':{
                method: "POST",
                params: {
                    path: "getAllByCondition1"
                }
            },
            'deletePackage':{
                method: "DELETE",
            },
            'setDefault':{
                method: "GET",
                params: {
                    path: "setDefault"
                },
            }
        })
    }
    function StoragePrices($resource) {
        var resourceUrl = 'manager/' + 'api/storage-prices/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },

            "byStoreId": {
                method: "GET",
                params: {
                    path: "byStoreId"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                },
                isArray: true
            },
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                },
                isArray: true
            },
            "byCondition3": {
                method: "POST",
                params: {
                    path: "byCondition3"
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                },
                isArray: true
            },
            "getAllByCondition3": {
                method: "POST",
                params: {
                    path: "getAllByCondition3"
                },
                isArray: true
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "themeClassify": {
                method: "GET",
                params: {
                    path: "saveTheme"
                }
            },
            "batchCreate": {
                method: "GET",
                params: {
                    path: "batchCreate"
                }
            },
            "batchCreateByStore": {
                method: "GET",
                params: {
                    path: "batchCreateByStore"
                }
            },
            'update': { method: 'PUT' },
        });
    }
    function StoragePrices1($resource) {
        var resourceUrl = 'manager/' + 'api/storage-prices/:path';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byStoreId": {
                method: "GET",
                params: {
                    path: "byStoreId"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                },
                isArray: true
            },
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                },
                isArray: true
            },
            "byCondition3": {
                method: "POST",
                params: {
                    path: "byCondition3"
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                },
                isArray: true
            },
            "getAllByCondition3": {
                method: "POST",
                params: {
                    path: "getAllByCondition3"
                },
                isArray: true
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "themeClassify": {
                method: "GET",
                params: {
                    path: "saveTheme"
                }
            },
            "batchCreate": {
                method: "GET",
                params: {
                    path: "batchCreate"
                }
            },
            "batchCreateByStore": {
                method: "GET",
                params: {
                    path: "batchCreateByStore"
                }
            },
            'update': { method: 'PUT' },
        });
    }
    function StoragePayOrders($resource) {
        var resourceUrl = 'manager/' + 'api/storage-pay-orders/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "wechatPay": {
                method: "GET",
                params: {
                    path: "wechatPay"
                }
            },
            "createOrder": {
                method: "POST",
                params: {
                    path: "createOrder"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                }
            },
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                }
            },
            "byCondition3": {
                method: "POST",
                params: {
                    path: "byCondition3"
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                }
            },
            "getAllByCondition3": {
                method: "POST",
                params: {
                    path: "getAllByCondition3"
                }
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "themeClassify": {
                method: "GET",
                params: {
                    path: "saveTheme"
                }
            },
            "batchCreate": {
                method: "GET",
                params: {
                    path: "batchCreate"
                }
            },
            "batchCreateByStore": {
                method: "GET",
                params: {
                    path: "batchCreateByStore"
                }
            },
            'update': { method: 'PUT' },
        });
    }
    function CustomerStorages($resource) {
        var resourceUrl = 'manager/' + 'api/customer-storages/:path/:id';
        return $resource(resourceUrl, {}, {
            'byCondition1': {
                method: 'POST',
                params: {
                    path: 'byCondition1'
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byStoreId": {
                method: "get",
                params: {
                    path: "byStoreId"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                },
                isArray: true
            },
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                },
                isArray: true
            },
            "byCondition3": {
                method: "POST",
                params: {
                    path: "byCondition3"
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                },
                isArray: true
            },
            "getAllByCondition3": {
                method: "POST",
                params: {
                    path: "getAllByCondition3"
                },
                isArray: true
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "themeClassify": {
                method: "GET",
                params: {
                    path: "saveTheme"
                }
            },
            "batchCreate": {
                method: "GET",
                params: {
                    path: "batchCreate"
                }
            },
            "fixCustomerUsedSize": {
                method: "GET",
                params: {
                    path: "fixCustomerUsedSize"
                }
            },
            'update': { method: 'PUT' },
        });
    }
    function StoreStorages($resource) {
        var resourceUrl = 'manager/' + 'api/store-storages/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byStoreId": {
                method: "get",
                params: {
                    path: "byStoreId"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                },
                isArray: true
            },
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                },
                isArray: true
            },
            "byCondition3": {
                method: "POST",
                params: {
                    path: "byCondition3"
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                },
                isArray: true
            },
            "getAllByCondition3": {
                method: "POST",
                params: {
                    path: "getAllByCondition3"
                },
                isArray: true
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "themeClassify": {
                method: "GET",
                params: {
                    path: "saveTheme"
                }
            },
            "batchCreate": {
                method: "GET",
                params: {
                    path: "batchCreate"
                }
            },
            "batchCreateByStore": {
                method: "GET",
                params: {
                    path: "batchCreateByStore"
                }
            },
            'update': { method: 'PUT' },
        })
    }
    function StoreStorages1($resource) {
        var resourceUrl = 'manager/' + 'api/store-storages/:path';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byStoreId": {
                method: "get",
                params: {
                    path: "byStoreId"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                },
                isArray: true
            },
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                },
                isArray: true
            },
            "byCondition3": {
                method: "POST",
                params: {
                    path: "byCondition3"
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                },
                isArray: true
            },
            "getAllByCondition3": {
                method: "POST",
                params: {
                    path: "getAllByCondition3"
                },
                isArray: true
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "themeClassify": {
                method: "GET",
                params: {
                    path: "saveTheme"
                }
            },
            "batchCreate": {
                method: "GET",
                params: {
                    path: "batchCreate"
                }
            },
            "batchCreateByStore": {
                method: "GET",
                params: {
                    path: "batchCreateByStore"
                }
            },
            'update': { method: 'PUT' },
        })
    }
    function CustomerStorageSnapshots($resource) {
        var resourceUrl = 'manager/' + 'api/customer-storage-snapshots/:path/:id';
        return $resource(resourceUrl, {}, {
            'byCondition1': {
                method: 'POST',
                params: {
                    path: 'byCondition1'
                },
            },
            'byCondition2': {
                method: 'POST',
                params: {
                    path: 'byCondition2'
                },
            },
        });
    }
    function CustomerStoragePayOrders($resource) {
        var resourceUrl = 'manager/' + '/api/customer-storage-pay-orders/:path/:id';
        return $resource(resourceUrl, {}, {
            'byCondition1': {
                method: 'POST',
                params: {
                    path: 'byCondition1'
                },
            },
        });
    }
    function StorageCleanSchedules($resource) {
        var resourceUrl = 'service/' + 'api/storage-clean-schedules/:path/:id';
        return $resource(resourceUrl, {}, {
            'doCalculateData': {
                method: 'GET',
                params: {
                    path: 'doCalculateData'
                },
            },
            'doClean': {
                method: 'GET',
                params: {
                    path: 'doClean'
                },
            },
            'construct': {
                method: 'GET',
                params: {
                    path: 'construct'
                },
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
            },
            "calculating2":{
                method: 'Get',
                params: {
                    path: 'calculating2'
                },
            },
            "check":{
                method: 'Get',
                params: {
                    path: 'check'
                },
            },
            "delete": {
                method: "DELETE"
            },
            'create': {
                method: 'Get',
                params: {
                    path: 'create'
                },
            },

        });
    }
    function CustomerClearRecords($resource) {
        var resourceUrl = 'manager' + '/api/customer-clear-records/:path/:id';
        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            'clear': {
                method: 'GET',
                params: {
                    path: 'clear'
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('MapDepotController', MapDepotController)
        .filter('sizeTransition', function () {
            return function (size) {
                if (!size)
                    return 0;
                var num = 1000.00;
                if (size < num)
                    return size + "B";
                if (size < Math.pow(num, 2))
                    return (size / num).toFixed(2) + "KB"; //kb
                if (size < Math.pow(num, 3))
                    return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
                if (size < Math.pow(num, 4))
                    return (size / Math.pow(num, 3)).toFixed(2) + "GB"; //G
                return (size / Math.pow(num, 4)).toFixed(2) + "TB"; //T
            }
        });

    MapDepotController.$inject = ['$scope', '$state', 'handlePackage', 'Store', 'MessageService', '$timeout', '$uibModal', 'StoreStorages', '$q', 'StoreStorages1'];

    function MapDepotController($scope, $state, handlePackage, Store, MessageService, $timeout, $uibModal, StoreStorages, $q, StoreStorages1) {
        var vm = this;
        Store.getCurrent(function (res) {
            vm.store = res.data;
            init()
        });
        vm.sumSize = 0;
        vm.useSize = 0;
        vm.percentage = 0;
        vm.months = [];
        for (var i = 1; i < 25; i++) {
            vm.months.push({
                name: i,
                id: i
            })
        }
        function init() {
            StoreStorages1.byStoreId({ storeId: vm.store.id }, function (res) {
                vm.data = res.data;
                vm.sumSize = Number(res.data.initSize) + Number(res.data.buySize);
                vm.useSize = Number(res.data.usedSize);
                vm.percentage = vm.useSize / vm.sumSize;
            });
        }

        $scope.progressColor = function (size) {
            return progressColor(size)
        };
        function progressColor(size) {
            if(size <= 0.5){
                return '#2486FF'
            }
            if(size <= 0.75){
                return '#A13EFD'
            }
            if(size > 0.75){
                return '#F72E2A'
            }
        }

        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/map-depot/map-depot1.html',
                controller: 'MapDepot1Controller',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function (result) {
                if (result) {
                    init()
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('LogoSettingPageController', LogoSettingPageController);

    LogoSettingPageController.$inject = ['$q', '$timeout', '$scope', '$stateParams', '$state', '$uibModalInstance', 'entity', 'UidService', 'MessageService', 'Qinius', 'Store'];

    function LogoSettingPageController($q, $timeout, $scope, $stateParams, $state, $uibModalInstance, entity, UidService, MessageService, Qinius, Store) {
        var vm = this;

        vm.type = entity;
        vm.logisticsCompany = entity;
        vm.clear = clear;

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.domains = Qinius.getDomain();
        vm.store = Store.getCurrent();
        $q.all([vm.domains.$promise, vm.store.$promise]).then(function(){
            vm.store = vm.store.data;
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                    reader.onload = function () {       //  成功读取
                        $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) {     //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "logo-"+ UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        if (vm.type == 1) { //登录页LOGO
                            vm.store.loginLogo = data.key;
                        } else if (vm.type == 2) {  //菜单顶部LOGO
                            vm.store.menuLogo = data.key;
                        }

                        Store.update(vm.store, onSaveSuccess, onSaveError);
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            MessageService.success("保存成功");
        }

        function onSaveError () {
            MessageService.error("保存失败");
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('LogoSettingEditController', LogoSettingEditController);

    LogoSettingEditController.$inject = ['$scope', '$q', 'UidService', '$rootScope', '$state', 'MessageService', 'Store', 'Qinius', '$uibModal'];

    function LogoSettingEditController($scope, $q, UidService, $rootScope, $state, MessageService, Store, Qinius, $uibModal) {
        var vm = this;

        vm.save = save;

        vm.domains = Qinius.getDomain();
        vm.store = Store.getCurrent();
        $q.all([vm.domains.$promise, vm.store.$promise]).then(function(){
            vm.store = vm.store.data;
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        window.uploadPic = function ($event,attr) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0],attr);
            }
        }

        function qiniuUpload(file,attr) {
            vm.attr = attr;
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "setting-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    if(attr=='login'){
                        imgSrop($scope.domain + data.key, 600, 300)
                    }else if(attr=='register'){
                        imgSrop($scope.domain + data.key, 600, 300)
                    }else{
                        imgSrop($scope.domain + data.key, 300, 160)
                    }

                    $scope.$apply();
                    // Store.update(vm.store, onSaveSuccess, onSaveError);
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        function imgSrop(url, width, height){
            $uibModal.open({
                templateUrl: 'app/entities/initialization/modal/img-crop.html',
                controller: 'ImgCropController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            url: url,
                            width: width,
                            height: height
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    if(vm.attr=='login'){
                        vm.store.webLoginLogo = data;
                    }else if(vm.attr=='register'){
                        vm.store.webRegisterLogo = data;
                    }else{
                        vm.store.menuLogo = data;
                    }
                }
            });
        }

        function onSaveSuccess(result) {
            MessageService.success("信息更新成功");
            $state.go("logo-setting", null, { reload: 'logo-setting' });
            vm.isSaving = false;
        }

        function onSaveError(result) {
            MessageService.error("操作失败，请稍后再试！");
            vm.isSaving = false;
        }


        $scope.clear = function (){
            $state.go("logo-setting", null, { reload: 'logo-setting' });
        }

        function save() {
            Store.update(vm.store, onSaveSuccess, onSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logo-setting', {
                parent: 'entity',
                url: '/logo-setting',
                data: {
                    authorities: ["ROLE_LOGO_SETTING"],
                    pageTitle: 'global.menu.entities.LOGOsetting'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/logo-setting/logo-setting.html',
                        controller: 'LogoSettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('productType');
                        $translatePartialLoader.addPart('store');
                        return $translate.refresh();
                    }],
                    entity: ['Product' , '$stateParams' , function(Product, $stateParams) {
                        return null;
                    }]
                }
            })
        .state('logo-setting-edit', {
            parent: 'logo-setting',
            url: '/edit',
            data: {
                authorities: ["ROLE_LOGO_SETTING"],
                pageTitle: 'global.menu.entities.LOGOsetting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logo-setting/logo-setting-edit.html',
                    controller: 'LogoSettingEditController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('productType');
                    $translatePartialLoader.addPart('store');
                    return $translate.refresh();
                }],
                entity: ['Product' , '$stateParams' , function(Product, $stateParams) {
                    return null;
                }]
            }
        })
        .state('logo-setting-page', {
            parent: 'logo-setting',
            url: '/logo-setting/{type}',
            data: {
                authorities: ["ROLE_LOGO_SETTING"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logo-setting/logo-setting-page.html',
                    controller: 'LogoSettingPageController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return $stateParams.type;
                        }
                    }
                }).result.then(function() {
                    $state.go('logo-setting', null, { reload: true});
                }, function() {
                    $state.go('logo-setting');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('LogoSettingController', LogoSettingController);

    LogoSettingController.$inject = ['$scope', '$q', '$rootScope', '$stateParams', 'MessageService', 'Store', 'Qinius'];

    function LogoSettingController($scope, $q, $rootScope, $stateParams, MessageService, Store, Qinius) {
        var vm = this;

        vm.domains = Qinius.getDomain();
        vm.store = Store.getCurrent();
        $q.all([vm.domains.$promise, vm.store.$promise]).then(function(){
            vm.store = vm.store.data;
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-setting-list', {
            parent: 'entity',
            url: '/invoice-setting-list?page&sort&search',
            data: {
                authorities: ["ROLE_INVOICE_INFOMATION"],
                pageTitle: 'global.menu.entities.invoiceSetting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-setting/invoice-settings.html',
                    controller: 'InvoiceSettingListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        
        .state('invoice-setting-detail', {
            parent: 'invoice-setting-list',
            url: '/invoice-setting-detail/{id}',
            data: {
                authorities: ["ROLE_INVOICE_INFOMATION"],
                pageTitle: 'home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-setting/invoice-setting-detail.html',
                    controller: 'InvoiceSettingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('invoice');
                    return $translate.refresh();
                }],
                entity: ['InvoiceSetting', '$stateParams', function(InvoiceSetting, $stateParams) {
                    return InvoiceSetting.get({id: $stateParams.id}).$promise;
                }]
            }
        })
        .state('invoice-setting', {
            parent: 'invoice-setting-list',
            url: '/invoice-setting/{id}',
            data: {
                authorities: ["ROLE_INVOICE_INFOMATION"],
                pageTitle: 'home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-setting/invoice-setting.html',
                    controller: 'InvoiceSettingController',
                    controllerAs: 'vm'
                }
            },
            
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('invoice');
                    return $translate.refresh();
                }],
                entity: ['InvoiceSetting', '$stateParams',  function(InvoiceSetting, $stateParams) {
                    return InvoiceSetting.get({id: $stateParams.id}).$promise;
                }]
            }
        })
        .state('invoice-setting.new', {
            parent: 'invoice-setting-list',
            url: '/invoice-settingNew',
            data: {
                authorities: ["ROLE_INVOICE_INFOMATION"],
                pageTitle: 'home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-setting/invoice-setting.html',
                    controller: 'InvoiceSettingController',
                    controllerAs: 'vm'
                }
            },
            
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('invoice');
                    return $translate.refresh();
                }],
                entity: ['InvoiceSetting', '$stateParams',  function(InvoiceSetting, $stateParams) {
                    return {};
                }]
            }
        });
    }

})();
(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('InvoiceSetting', InvoiceSetting);

    InvoiceSetting.$inject = ['$resource', 'DateUtils'];

    function InvoiceSetting ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/invoice-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll': {
                method: 'GET'
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.submitTime = DateUtils.convertDateTimeFromServer(data.submitTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'del': {
                method: "DELETE"
            },
            'changeStatus': {
                method: 'GET',
                params: {
                    path: 'changeStatus'
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'byConditionForStore': {
                method: 'POST',
                params: {
                    path: 'byConditionForStore'
                }
            },
            "getAllByConditionForStore":{
                method:"POST",
                params:{
                    path:"getAllByConditionForStore"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceSettingListController', InvoiceSettingListController);

    InvoiceSettingListController.$inject =  ['$scope', '$q', '$state', 'InvoiceSetting', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService'];

    function InvoiceSettingListController ($scope, $q, $state, InvoiceSetting, ParseLinks, paginationConstants, pagingParams, MessageService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.del = del;

        loadAll();
        function loadAll () {
            if (pagingParams.search) {
                items.push({key:"title",op:"like",value:pagingParams.search});
                InvoiceSetting.byConditionForStore({
                    items: items,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                InvoiceSetting.byConditionForStore({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.invoiceSettings = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }

            }
            function onError(error) {
                MessageService.error("数据获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            loadPage(vm.jumpText <= 0 ? 1 : vm.jumpText);
        }

        function del (id) {
            InvoiceSetting.delete({id: id}, function(){
                loadAll();
                MessageService.success("删除成功");
            }, function (error) {
                MessageService.error("删除失败");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceSettingController', InvoiceSettingController);

    InvoiceSettingController.$inject = ['$state','$scope', 'MessageService', 'InvoiceSetting', "entity", "$q"];

    function InvoiceSettingController($state, $scope, MessageService, InvoiceSetting, entity, $q) {

        var vm = this;

        vm.save = save;
        vm.editor = editor;

        vm.back = back;

        function back(){
            $state.go("invoice-setting-list", {id:vm.invoiceSetting.id});
        }

        vm.clear = clear;

        function clear(){
            $state.go("invoice-setting-detail", {id:vm.invoiceSetting.id});
        }
        vm.openTypeChange = openTypeChange;

        function editor (){
            $state.go("invoice-setting", {id:vm.invoiceSetting.id});
        }
        vm.invoiceSetting = entity;

        $q.all([vm.invoiceSetting.$promise]).then(function(){
            vm.invoiceSetting = vm.invoiceSetting.data;
            vm.title2 = "个人";
            if (vm.invoiceSetting != undefined &&vm.invoiceSetting != null && vm.invoiceSetting.id != null) {
                if (vm.invoiceSetting.openType != null) {
                    vm.openType = vm.invoiceSetting.openType != 'Company';
                }
                if (vm.invoiceSetting.invoiceType != null) {
                    vm.invoiceType = vm.invoiceSetting.invoiceType == 'Ordinary';
                }
            } else {
                vm.invoiceSetting = {};
                vm.openType = true;
                vm.invoiceType = true;
            }
        });


        $scope.validate = function(data) {
            if (!vm.openType) {
                if (data.title == null || data.title == "") {
                    MessageService.error("请输入发票抬头");
                    vm.isSaving = false;
                    return false;
                };
            } else {
                vm.invoiceSetting.title = "个人";
                vm.invoiceType = true;
            }

            // 增值税专用发票--不可为空， 增值税普通发票可为空
            if (!vm.invoiceType) {
                if (data.taxRegistrationNumber == null || data.taxRegistrationNumber == "") {
                    MessageService.error("请输入税务登记证号");
                    vm.isSaving = false;
                    return false;
                };


            }
            return true;
        }

        function save() {
            if (vm.openType) {
                vm.invoiceSetting.openType = "Personal";
            } else {
                vm.invoiceSetting.openType = "Company";
            }

            if (vm.invoiceType) {
                vm.invoiceSetting.invoiceType = "Ordinary";
            } else {
                vm.invoiceSetting.invoiceType = "Special";
            }
            if (!$scope.validate(vm.invoiceSetting)) {
                return;
            };
            vm.isSaving = true;
            InvoiceSetting.update(vm.invoiceSetting, function(result){
                vm.isSaving = false;
                MessageService.success("操作成功");
                $state.go("invoice-setting-detail",{id:result.data.id});
            }, function(){
                vm.isSaving = false;
                MessageService.error("操作失败");
            })
        }

        function openTypeChange(int) {
            vm.invoiceSetting.title = '';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceLocationPageController', InvoiceLocationPageController);

    InvoiceLocationPageController.$inject = ['$scope', '$state', 'entity', 'InvoiceLocation',  'MessageService', '$q', 'LocationCity',
        'LocationDistrict', 'LocationProvice'
    ];

    function InvoiceLocationPageController($scope, $state, entity, InvoiceLocation,   MessageService, $q, LocationCity,
        LocationDistrict, LocationProvice) {
        var vm = this;

        vm.invoiceLocation = entity;
        vm.changeProvince = changeProvince;
        vm.changeCity = changeCity;
        vm.clear = clear;
        vm.save = save;

        function changeProvince() {
            LocationCity.findByProvince({
                provinceId: vm.province.id
            }, function(res) {
                if(res.status == 200){
                    vm.citys = res.data;
                }else{
                    MessageService.error(res.message);
                }
                vm.districts = [];
            });
        }

        function changeCity() {
            if (vm.city == null) {
                return;
            }
            LocationDistrict.findByCities({
                cityId: vm.city.id
            }, function(res) {
                if(res.status == 200){
                    vm.districts = res.data;
                }else{
                    MessageService.error(res.message);
                }
            });
        }

        $q.all([vm.invoiceLocation.$promise]).then(function() {
            vm.invoiceLocation = vm.invoiceLocation.data;
            console.log(vm.invoiceLocation)
            LocationProvice.query({}, function(res) {
                if(res.status == 200){
                    vm.provinces = res.data;
                    for (var i = vm.provinces.length - 1; i >= 0; i--) {
                        var p = vm.provinces[i];
                        if (p.name == vm.invoiceLocation.province) {
                            vm.province = p;
                            break;
                        }
                    }
                    if (!!vm.invoiceLocation.id) {
                        vm.districts = [];
                        LocationCity.findByProvince({
                            provinceId: vm.province.id
                        }, function(res) {
                            if(res.status == 200){
                                vm.citys = res.data;
                                for (var i = vm.citys.length - 1; i >= 0; i--) {
                                    var c = vm.citys[i];
                                    if (c.name == vm.invoiceLocation.city) {
                                        vm.city = c;
                                        break;
                                    }
                                }
                                if (vm.city != null) {
                                    LocationDistrict.findByCities({
                                        cityId: vm.city.id
                                    }, function(res) {
                                        if(res.status == 200){
                                            vm.districts = res.data;
                                            for (var i = vm.districts.length - 1; i >= 0; i--) {
                                                var di = vm.districts[i];
                                                if (di.name == vm.invoiceLocation.area) {
                                                    vm.district = di;
                                                }
                                            }
                                        }else{
                                            MessageService.error(res.message);
                                        }

                                    });
                                }
                            }else{
                                MessageService.error(res.message);
                            }
                        });
                    }
                }else{
                    MessageService.error(res.message);
                }

            });

        });

        // 关闭弹出
        function clear() {
            $state.go("invoice-location");
        }

        $scope.validate = function(data) {
            if (vm.invoiceLocation.name == null || vm.invoiceLocation.name == "") {
                MessageService.error("请输入收件人姓名");
                vm.isSaving = false;
                return false;
            };

            if (vm.invoiceLocation.province == null || vm.invoiceLocation.province == "") {
                MessageService.error("请选择省份");
                vm.isSaving = false;
                return false;
            };

            if (vm.invoiceLocation.city == null || vm.invoiceLocation.city == '') {
                MessageService.error('请选择城市');
                vm.isSaving = false;
                return false;
            }

            if (vm.invoiceLocation.area == null || vm.invoiceLocation.area == "") {
                MessageService.error("请选择区县");
                vm.isSaving = false;
                return false;
            };

            if (vm.invoiceLocation.address == null || vm.invoiceLocation.address == "") {
                MessageService.error("请输入街道地址");
                vm.isSaving = false;
                return false;
            };

            if (vm.invoiceLocation.postCode == null || vm.invoiceLocation.postCode == "") {
                MessageService.error("请输入邮编");
                vm.isSaving = false;
                return false;
            };

            if (vm.invoiceLocation.phone == null || vm.invoiceLocation.phone == "") {
                MessageService.error("请输入手机电话");
                vm.isSaving = false;
                return false;
            };

            if (!(/^(0|86|17951)?(13[0-9]|15[012356789]|17[3678]|18[0-9]|14[57]|166|198|199)[0-9]{8}$/.test(vm.invoiceLocation.phone))) {
                MessageService.error("手机号码非法");
                return false;
            }


            return true;
        }

        $scope.toPostData = function() {
            vm.invoiceLocation.province = vm.province == null ? '' : vm.province.name;
            vm.invoiceLocation.city = vm.city == null ? '' : vm.city.name;
            vm.invoiceLocation.area = vm.district == null ? '' : vm.district.name;
        }

        function save() {
            $scope.toPostData();
            if (!$scope.validate()) {
                return;
            };
            vm.isSaving = true;
            InvoiceLocation.update(vm.invoiceLocation, function(result) {
                MessageService.success("操作成功");
                $state.go("invoice-location");
            }, function(error) {
                vm.isSaving = false;
                MessageService.error("操作失败");
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('invoice-location', {
                parent: 'entity',
                url: '/invoice-location',
                data: {
                    authorities: ["ROLE_INVOICE_EXPRESS"],
                    pageTitle: 'global.menu.entities.ilocationManagement'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-location/invoice-location.html',
                        controller: 'InvoiceLocationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('invoiceLocation');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-location.new', {
                parent: 'invoice-location',
                url: '/new',
                data: {
                    authorities: ["ROLE_INVOICE_EXPRESS"]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-location/invoice-location-page.html',
                        controller: 'InvoiceLocationPageController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoiceLocation');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceLocation', function(InvoiceLocation) {
                        return {
                            data:{
                                title: null,
                                img: null,
                                status: null,
                                cancelled: null,
                                id: null
                            }
                        };
                    }]
                }
            })
            .state('invoice-location-detail', {
                parent: 'invoice-location',
                url: '/invoice-location/{id}',
                data: {
                    authorities: ["ROLE_INVOICE_EXPRESS"]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-location/invoice-location-page.html',
                        controller: 'InvoiceLocationPageController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoiceLocation');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceLocation', '$stateParams', function(InvoiceLocation, $stateParams) {
                        return InvoiceLocation.get({
                            id: $stateParams.id
                        }).$promise;
                    }]
                }
            })

    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('LocationProvice', LocationProvice)
        .factory('LocationCity', LocationCity)
        .factory('LocationDistrict', LocationDistrict)
        .factory('InvoiceLocation', InvoiceLocation);

     LocationProvice.$inject = ['$resource']

    LocationCity.$inject = ['$resource']

    LocationDistrict.$inject = ['$resource']

    InvoiceLocation.$inject = ['$resource', 'DateUtils'];

    function LocationProvice($resource) {
        var resourceUrl = 'manager/' + 'api/location-provinces/:path/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'},
            "findByName":{
                method:"GET",
                params:{
                    path:"findByName"
                },
            },
            "other":{
                method:"GET",
                params:{
                    path:"other"
                }
            }
        });
    }

    function LocationCity($resource) {
        var resourceUrl = 'manager/' + 'api/location-cities/:path/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'},
            "findByProvince":{
                method:"GET",
                params:{
                    path:"findByProvince"
                }
            },
            "findByName":{
                method:"GET",
                params:{
                    path:"findByName"
                }
            }
        });
    }

    function LocationDistrict($resource) {
        var resourceUrl = 'manager/' + 'api/location-districts/:path/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'},
            "findByCities":{
                method:"GET",
                params:{
                    path:"findByCities"
                }
            },
            "findByName":{
                method:"GET",
                params:{
                    path:"findByName"
                },
            }

        });
    }


    function InvoiceLocation ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/invoice-locations/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll': {
                method: 'GET',
                params: {
                    path: 'all'
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.submitTime = DateUtils.convertDateTimeFromServer(data.submitTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'del': {
                method: "DELETE"
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceLocationController', InvoiceLocationController);

    InvoiceLocationController.$inject = ['$q', '$scope', '$state','$stateParams', 'InvoiceLocation',  'MessageService'];

    function InvoiceLocationController($q, $scope, $state, $stateParams, InvoiceLocation,  MessageService) {
        var vm = this;

        vm.del = del;
        vm.changeStatue = changeStatue;

        function loadAll () {
            InvoiceLocation.getAll({}, function(data){
                vm.ilocations = data;
            });
        };

        vm.ilocationsAll = InvoiceLocation.getAll({});
        $q.all([vm.ilocationsAll.$promise]).then(function() {
            vm.ilocations = vm.ilocationsAll.data;
        });


        function changeStatue (obj){
            if (obj.enable) {
                obj.enable = false;
            } else {
                obj.enable = true;
            }
            console.log(obj);
            InvoiceLocation.update(obj, function(){
                $state.go('invoice-location', null, { reload: true});
            })
        };

        function del (id) {
            console.log(id);
            InvoiceLocation.del({id: id}, function(){
                loadAll();
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceShowController', InvoiceShowController);

    InvoiceShowController.$inject = ['$q', '$state','$scope',  'entity', 'MessageService', 'Invoice'];

    function InvoiceShowController($q, $state, $scope,   entity, MessageService, Invoice) {

        var vm = this;
        vm.invoice = entity;
        vm.clear = clear;
        $q.all([  vm.invoice.$promise]).then(function(){
            vm.invoice = vm.invoice.data;

        });
        function clear () {
            $state.go("invoice");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceNewController', InvoiceNewController);

    InvoiceNewController.$inject = ['$q', '$state','$scope', '$uibModalInstance', 'entity', 'MessageService', 'Invoice', 'InvoiceLocation', 'RegionService', 'InvoiceSetting'];

    function InvoiceNewController($q, $state, $scope, $uibModalInstance, entity, MessageService, Invoice, InvoiceLocation, RegionService, InvoiceSetting) {

        var vm = this;
        vm.save = save;
        vm.payOrder = entity;
        vm.clear = clear;
        vm.invoiceSetting = InvoiceSetting.getAllByConditionForStore({items:[]});

        vm.invoiceLocations = InvoiceLocation.getAll({});
        $q.all([vm.invoiceLocations.$promise, vm.invoiceSetting.$promise, vm.payOrder.$promise]).then(function(){
            vm.payOrder = vm.payOrder.data;
            vm.invoiceLocations = vm.invoiceLocations.data;
            vm.invoiceSetting = vm.invoiceSetting.data;
            if (vm.invoiceLocations && vm.invoiceLocations.length > 0) {
                for (var i = vm.invoiceLocations.length - 1; i >= 0; i--) {
                    var location = vm.invoiceLocations[i];
                    if (location.enable) {
                        vm.selectedLocation = location;
                        break;
                    }
                }
            }
            getData();
        });

        function getData() {
            vm.title2 = "个人";
            console.log(entity);
            if (vm.invoiceSetting != null && vm.invoiceSetting.id != null) {
                if (vm.invoiceSetting.openType != null) {
                    vm.openType = vm.invoiceSetting.openType != 'Company';
                }
                if (vm.invoiceSetting.invoiceType != null) {
                    vm.invoiceType = vm.invoiceSetting.invoiceType == 'Ordinary';
                }
            } else {
                vm.openType = true;
                vm.invoiceType = true;
            }

            vm.invoice = {  "id":null,
                            "openType": vm.invoiceSetting.openType,
                            "title": vm.invoiceSetting.title,
                            "invoiceType": vm.invoiceSetting.invoiceType,
                            "taxRegistrationNumber": vm.invoiceSetting.taxRegistrationNumber,
                            "basicAccount": vm.invoiceSetting.basicAccount,
                            "bankName": vm.invoiceSetting.bankName,
                            "registeredAddress": vm.invoiceSetting.registeredAddress,
                            "registeredPhone": vm.invoiceSetting.registeredPhone,
                            "invoiceLocation":null,
                            "payOrder":vm.payOrder,
                            "invoiceState":null}
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

         $scope.validate = function(data) {
            if (!vm.openType) {
                if (data.title == null || data.title == "") {
                    MessageService.error("请输入发票抬头");
                    vm.isSaving = false;
                    return false;
                };
            } else {
                vm.invoice.title = "个人";
                vm.invoiceType = true;
            }

            // 增值税专用发票--不可为空， 增值税普通发票可为空
            if (!vm.invoiceType) {
                if (data.taxRegistrationNumber == null || data.taxRegistrationNumber == "") {
                    MessageService.error("请输入税务登记证号");
                    vm.isSaving = false;
                    return false;
                };

                if (data.bankName == null || data.bankName == "") {
                    MessageService.error("请输入基本开户银行名称");
                    vm.isSaving = false;
                    return false;
                };

                if (data.basicAccount == null || data.basicAccount == "") {
                    MessageService.error("请输入基本开户账号");
                    vm.isSaving = false;
                    return false;
                };

                if (data.registeredAddress == null || data.registeredAddress == "") {
                    MessageService.error("请输入注册场所地址");
                    vm.isSaving = false;
                    return false;
                };

                if (data.registeredPhone == null || data.registeredPhone == "") {
                    MessageService.error("请输入注册固定电话");
                    vm.isSaving = false;
                    return false;
                };

                if(!(/^(0|86|17951)?(13[0-9]|15[012356789]|17[3678]|18[0-9]|14[57]|166|198|199)[0-9]{8}$/.test(data.registeredPhone))){
                    MessageService.error("手机号码非法");
                    return false;
                }
            }

            if (data.invoiceLocation == null || data.invoiceLocation.id == null) {
                MessageService.error("请选择发票寄送地址");
                vm.isSaving = false;
                return false;
            };
            return true;
         }

        function save() {

            if (vm.openType) {
                vm.invoice.openType = "Personal";
            } else {
                vm.invoice.openType = "Company";
            }

            if (vm.invoiceType) {
                vm.invoice.invoiceType = "Ordinary";
            } else {
                vm.invoice.invoiceType = "Special";
            }
            vm.invoice.invoiceLocation = vm.selectedLocation;
            if (!$scope.validate(vm.invoice)) {
                return;
            };
             vm.isSaving = true;
            vm.invoice.payOrder = vm.payOrder;
            Invoice.update(vm.invoice, function(res){
                if(res.status == 200){
                    MessageService.success("操作成功");
                    $uibModalInstance.close(res.data);
                }else {
                    vm.isSaving = false;
                    MessageService.error(res.message);
                }
            }, function(){
                vm.isSaving = false;
                MessageService.error("操作失败");
            })
        }
    }
})();




(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$q', '$state','$scope',  'entity', 'MessageService', 'Invoice', 'InvoiceLocation', 'InvoiceSetting', '$stateParams'];

    function InvoiceDetailController($q, $state, $scope, entity, MessageService, Invoice, InvoiceLocation, InvoiceSetting, $stateParams) {

        var vm = this;
        vm.save = save;
        vm.clear = clear;
        vm.invoice = entity;
        vm.addSetting = false;
        vm.invoiceSetting = {};
        vm.clear2 = clear2;
        vm.save2 = save2;

        $scope.addSetting = function(){
            vm.addSetting = true;
        }
        vm.invoiceLocations = InvoiceLocation.getAll({});
        vm.settings = InvoiceSetting.getAllByConditionForStore({});
        $q.all([vm.invoiceLocations.$promise,  vm.invoice.$promise, vm.settings.$promise]).then(function(){
            vm.invoice = vm.invoice.data;
            vm.invoiceLocations = vm.invoiceLocations.data;
            vm.settings = vm.settings.data;
            if (vm.invoiceLocations && vm.invoiceLocations.length>0) {
                for (var i = vm.invoiceLocations.length - 1; i >= 0; i--) {
                    var location = vm.invoiceLocations[i];
                    if (location.enable && vm.invoice.id == null) {
                        vm.selectedLocation = location.id;
                        break;
                    }
                }
            }
        });

        function clear2(){
            vm.addSetting = false;
        }

        $scope.validate2 = function(data) {
            if (!vm.openType) {
                if (data.title == null || data.title == "") {
                    MessageService.error("请输入发票抬头");
                    vm.isSaving = false;
                    return false;
                };
            } else {
                vm.invoiceSetting.title = "个人";
                vm.invoiceType = true;
            }

            // 增值税专用发票--不可为空， 增值税普通发票可为空
            if (!vm.invoiceType) {
                if (data.taxRegistrationNumber == null || data.taxRegistrationNumber == "") {
                    MessageService.error("请输入税务登记证号");
                    vm.isSaving = false;
                    return false;
                };

            }
            return true;
        }

        function save2() {
            if (vm.openType) {
                vm.invoiceSetting.openType = "Personal";
            } else {
                vm.invoiceSetting.openType = "Company";
            }

            if (vm.invoiceType) {
                vm.invoiceSetting.invoiceType = "Ordinary";
            } else {
                vm.invoiceSetting.invoiceType = "Special";
            }
            if (!$scope.validate2(vm.invoiceSetting)) {
                return;
            };
            vm.isSaving = true;
            InvoiceSetting.update(vm.invoiceSetting, function(res){
                if(res.status == 200){
                    vm.isSaving = false;
                    vm.addSetting = false;
                    vm.settings.push(res.data);
                    vm.selectedTitle = res.data.id;
                    MessageService.success("操作成功");
                }else {
                    MessageService.error(res.message);
                    vm.isSaving = false;
                }
            }, function(){
                vm.isSaving = false;
                MessageService.error("操作失败");
            })
        }

        function clear () {
            $state.go("pay-order2")
        }

         $scope.validate = function() {
            if (vm.selectedLocation == null) {
                MessageService.error("请选择发票寄送地址");
                return false;
            };

            if (vm.selectedTitle == null || vm.selectedTitle == "") {
                MessageService.error("请选择发票抬头");
                return false;
            };
            return true;
         }

        function save() {
            if (!$scope.validate()) {
                return;
            };

            vm.isSaving = true;
            var data = {
                ids:$stateParams.ids,
                locationId: vm.selectedLocation,
                settingId: vm.selectedTitle
            }
            Invoice.create(data, function(res){
                if(res.status == 200){
                    MessageService.success("操作成功");
                    $state.go("invoice");
                }else {
                    MessageService.error(res.message);
                    vm.isSaving = false;
                }
            }, function(){
                vm.isSaving = false;
                MessageService.error("操作失败");
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('invoice', {
                parent: 'entity',
                url: '/invoice',
                data: {
                    authorities: ["ROLE_INVOICE_LIST"],
                    pageTitle: 'global.menu.entities.invoices'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice/invoice.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    statue: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            statue: $stateParams.statue
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoice');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice.show', {
                parent: 'invoice',
                url: '/invoice/show/{id}',
                data: {
                    authorities: ["ROLE_INVOICE_LIST"]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice/invoice-show.html',
                        controller: 'InvoiceShowController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoice');
                        return $translate.refresh();
                    }],
                    entity: ['Invoice', '$stateParams', function(Invoice, $stateParams) {
                        return Invoice.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('invoice-detail', {
                parent: 'invoice',
                url: '/invoice/{ids}',
                data: {
                    authorities: ["ROLE_INVOICE_LIST"],
                    pageTitle: 'home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice/invoice-detail.html',
                        controller: 'InvoiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoice');
                        return $translate.refresh();
                    }],
                    entity: ['Invoice', '$stateParams', function(Invoice, $stateParams) {
                        return {};
                    }]
                }

            });
    }

})();
(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/invoice/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll': {
                method: 'GET'
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.submitTime = DateUtils.convertDateTimeFromServer(data.submitTime);
                    }
                    return data;
                }
            },
            "create":{
                method: 'GET',
                params: {
                    path: 'create'
                }
            },
            'update': { method:'PUT' },
            'del': {
                method: "DELETE"
            },
            'changeStatus': {
                method: 'GET',
                params: {
                    path: 'changeStatus'
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$state','$scope', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Invoice'];

    function InvoiceController($state, $scope, ParseLinks, paginationConstants, pagingParams, MessageService, Invoice) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.del = del;
        vm.changeStatus = changeStatus;

        loadAll();
        function loadAll () {
            var items=[{key:"invoiceState",op:"!=",value:"INVOICE_DELETED"}];
            if (pagingParams.search) {
                items.push({key:"title",op:"like",value:pagingParams.search});
                Invoice.byCondition({
                    items: items,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Invoice.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.invoices = res.data;
                    vm.page = pagingParams.page;
                }else{
                    MessageService.error(res.message);
                }

            }
            function onError(error) {
                MessageService.error("数据获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            loadPage(vm.jumpText <= 0 ? 1 : vm.jumpText);
        }

        function del (id) {
            Invoice.del({id: id}, function(){
                $state.go('invoice', null, {reload: 'invoice'});
                MessageService.success("删除成功");
            }, function (error) {
                MessageService.error("删除失败");
            });
        }

        function changeStatus (id) {
            Invoice.changeStatus({id: id, type: 0}, function (){
                MessageService.success("操作成功");
                $state.go('invoice', null, {reload: 'invoice'});
            }, function (error) {
                MessageService.error("操作失败");
            })

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ShopModalController', ShopModalController);

    ShopModalController.$inject = ['$timeout', '$state', '$uibModalInstance'];

    function ShopModalController ($timeout, $state, $uibModalInstance) {
        var vm = this;
        vm.save = save;

        function save() {
            $uibModalInstance.close();
            $state.go('store')
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ImgCropController', ImgCropController);

    ImgCropController.$inject = ['$timeout', '$scope', 'UidService', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService', 'Qinius'];

    function ImgCropController ($timeout, $scope, UidService, $stateParams, $uibModalInstance, entity, $state, MessageService, Qinius) {
        var vm = this;
        vm.cancel = cancel;

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.data = {
            url: entity.url,
            width: entity.width,
            height: entity.height
        }


        init();
        function init(){
            $timeout(function () {
                var el = document.getElementById('imgCrop');
                vm.resize = new Croppie(el, {
                    viewport: { width: vm.data.width, height: vm.data.height },
                    // boundary: { width: 700, height: 350 },
                    showZoomer: false,
                    enableOrientation: true
                });
                vm.resize.bind({
                    url: vm.data.url
                });
            })
        }
        $scope.cropRotate = function(){
            vm.resize.rotate(-90);
        }
        $scope.cropRemove = function(){
            $uibModalInstance.close();
        };
        $scope.cropSave = function(){
            vm.resize.result('base64').then(function(blob) {
                var formData = new FormData();
                formData.append('file', dataURLtoBlob(blob));
                formData.append('unique_names', false);
                formData.append('key', "crop-" + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        $uibModalInstance.close(data.key);
                        $scope.$apply();
                    },
                    error: function (request) {
                        MessageService.error("图片上传失败");
                    }
                });
            });
        }
        function dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('InitStepOneController', InitStepOneController);

    InitStepOneController.$inject = ['$scope', '$state', 'UidService', 'Store', 'Qinius', 'MessageService', '$q', '$timeout', '$uibModal'];

    function InitStepOneController ($scope, $state, UidService, Store, Qinius, MessageService, $q, $timeout, $uibModal) {
        var vm = this;

        vm.saveStep = saveStep;
        vm.domains = Qinius.getDomain();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.store = Store.getCurrent();
        $q.all([vm.domains.$promise, vm.store.$promise]).then(function () {
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            vm.store = vm.store.data;
            // 更新 初始化
            vm.store.initialized = true;
            Store.update(vm.store);
        });

        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }

        function qiniuUpload(file) {
            var formData = new FormData();
            if (!file.name.endsWith(".jpg")) {
                MessageService.error("图片格式不对，上传失败");
                return;
            }
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "logo-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    imgSrop($scope.domain + data.key, 300, 160)
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }

        function imgSrop(url, width, height){
            $uibModal.open({
                templateUrl: 'app/entities/initialization/modal/img-crop.html',
                controller: 'ImgCropController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            url: url,
                            width: width,
                            height: height
                        };
                    }]
                }
            }).result.then(function(data) {
                vm.store.menuLogo = data;
            });
        }

        $scope.removeFile = function() {
            vm.store.menuLogo = null;
        }

        function saveStep() {
            // if(vm.store.storeType2==null){
            //     MessageService.error("商户未设置商户类型");
            //     return
            // }

            if (vm.store.id !== null) {
                vm.isSaving = true;
                Store.update(vm.store, onSaveSuccess, onSaveError);
            } else {
                vm.isSaving = true;
                Store.save(vm.store, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:storeUpdate', result);
            vm.isSaving = false;
            $scope.jumpOver();
        }

        $scope.jumpOver = function () {
            $state.go('guide-commodity', null, { reload: true });
        }

        function onSaveError(result) {
            MessageService.error("操作失败，请稍后再试！");
            vm.isSaving = false;
        }

        window.showTip = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            $(".step-tip-text"+index).show();
        }

        $(".step-tip-text").hide();
        window.hideTip = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            $(".step-tip-text"+index).hide();
        }

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('step1', {
                parent: 'store',
                url: '/step1',
                data: {
                    authorities: ['ROLE_STORE'],
                    pageTitle: 'global.menu.entities.store'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/initialization/init-step1.html',
                        controller: 'InitStepOneController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('guide-commodity', {
                parent: 'app',
                url: '/guide-commodity',
                data: {
                    authorities: ["ROLE_PRODUCT"],
                    pageTitle: 'backApp.productPurchase.home.title'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/initialization/commodity.html',
                        controller: 'GideCommodityController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productPurchase');
                        $translatePartialLoader.addPart('purchaseStatus');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('GideCommodityController', GideCommodityController);

    GideCommodityController.$inject = ['$state', '$timeout', '$scope', '$stateParams', '$q', '$uibModal',
    'Product', 'MessageService', 'Store', 'DateUtils', 'CommodityPrice', 'Category', 'Qinius', '$localStorage', 'ParseLinks'];

    function GideCommodityController ($state, $timeout, $scope, $stateParams, $q, $uibModal,
        Product, MessageService, Store, DateUtils, CommodityPrice, Category, Qinius, $localStorage, ParseLinks) {
        var vm = this;

        vm.classifyList = [{name: '全部', id: ''}];
        vm.classify = {name: '全部', id: ''};
        vm.products = [];
        vm.itemValueLines = [];
        vm.item = [];
        vm.domains = Qinius.getDomain();
        vm.page = 1;

        $q.all([vm.domains.$promise]).then(function () {
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            //获取分类
            Category.getAllByCondition({}, function (res) {
                if(res.status == 200){
                    for(var i=0; i<res.data.length; i++){
                        if(!res.data[i].cancelled){
                            vm.classifyList.push(res.data[i]);
                        }
                    }
                    productInit()
                }else{
                    MessageService.error(res.message)
                }
            })
        });
        $scope.classifyCb = function (data) {
            vm.classify = data;
            vm.page = 1;
            productInit()
        }

        //获取商品
        function productInit(){
            vm.products = [];
            var items = [{key: "prototype", op: "=", value: 'Original'},
                {key: "custom", op: "=", value: "false"}];
            if(vm.classify.id){
                items.push({key:"category.id",op:"=",value: vm.classify.id})
            }
            Product.getAllByCondition2({items: items},function(data){
                if(data.status == 200){
                    for(var i=0; i<data.data.length; i++){
                        if(!data.data[i].cancelled){
                            vm.products.push(data.data[i])
                        }
                    }
                    Store.getCurrent({}, function (res) {
                        if(res.status == 200){
                            var _products = [];
                            for(var i1=0; i1<res.data.products.length; i1++){
                                if(!res.data.products[i1].cancelled){
                                    if((res.data.products[i1].categoryId == vm.classify.id || !vm.classify.id)){
                                        _products.push(res.data.products[i1])
                                    }
                                }
                            }

                            for(var i=0; i<_products.length; i++){
                                var _isResult = vm.products.some(function (item) {
                                    if(item.id == _products[i].id){
                                        return true
                                    }
                                })
                                if(!_isResult){
                                    vm.products.push(_products[i])
                                }
                            }
                            Product.grounded({storeId: $localStorage.user.storeId}, function (items) {
                                if(items.status == 200){
                                    for (var i2 = 0; i2 < items.data.length; i2++) {
                                        for (var i1 = vm.products.length - 1; i1 >= 0; i1--) {
                                            if (vm.products[i1].id == items.data[i2].id) {
                                                vm.products.splice(i1, 1)
                                            }
                                        }
                                    }
                                    for(var i=0; i<vm.products.length; i++){
                                        for(var j=0; j<vm.item.length; j++){
                                            if(vm.item[j].id == vm.products[i].id){
                                                vm.products[i].selected = true
                                            }
                                        }
                                    }

                                    var nums = 20; //每页出现的数量
                                    var pages = Math.ceil(vm.products.length/nums); //得到总页数
                                    var thisDate = function(curr){
                                        //此处只是演示，实际场景通常是返回已经当前页已经分组好的数据
                                        var str = [], last = curr*nums - 1;
                                        last = last >= vm.products.length ? (vm.products.length-1) : last;
                                        for(var i = (curr*nums - nums); i <= last; i++){
                                            str.push(vm.products[i]);
                                        }
                                        return str;
                                    };

                                    //调用分页
                                    laypage({
                                        cont: 'c-paging',
                                        curr: vm.page, //初始化当前页
                                        pages: pages,
                                        skip: true, //是否开启跳页
                                        first: false,
                                        last: false,
                                        jump: function(obj){
                                            $timeout(function () {
                                                vm.products1=thisDate(obj.curr);
                                                vm.page = obj.curr;
                                            })
                                        }
                                    });
                                }else{
                                    MessageService.error(items.message);
                                }
                            })
                        }else{
                            MessageService.error(res.message);
                        }
                    });
                }else{
                    MessageService.error(data.message);
                }

            })
        }
        //获取选中商品
        $scope.itemValueLinesCb = function (data) {
            data.selected = !data.selected ? true : false;
            if(!data.selected){
                for(var i=0; i<vm.item.length; i++){
                    if(vm.item[i].id == data.id){
                        vm.item.splice(i, 1);
                    }
                }
            }else {
                vm.item.push(data)
            }
        }

        //上一步
        $scope.back = function () {
            $state.go('step1')
        }


        var createModal = function (url, controller, item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity:item,
                }
            });
        };


        //保存，下一步
        $scope.save = function () {
            if(vm.item.length == 0){
                MessageService.error("请选择需要的商品！");
                return
            }
            var _ids = [];
            for(var i=0; i<vm.item.length; i++){
                _ids.push(vm.item[i].id)
            }
            var ground = {
                ids:_ids
            }
            createModal('app/entities/product/product-update-category.html', 'ProductUpdateCategoryController', ground).result.then(
            function (data) {
                if (!!data.categoryId) {
                    Product.grounding({ids: data.ids, categoryId: data.categoryId}, function (res) {
                        pop();
                    })

                }else{
                    Product.grounding({ids: data.ids}, function (res) {
                        pop();
                    })
                }
            });

            // console.log(vm.item)
            // var _ids = [];
            // for(var i=0; i<vm.item.length; i++){
            //     _ids.push(vm.item[i].id)
            // }
            // Product.grounding({ids: _ids}, function (res) {
            //     $state.go('shop')
            // })
        }

        function pop() {
            $uibModal.open({
                templateUrl: 'app/entities/initialization/modal/shop-modal.html',
                controller: 'ShopModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hue', {
                parent: 'entity',
                url: '/hue',
                data: {
                    authorities: ["ROLE_LOGO_SETTING"],
                    pageTitle: 'global.menu.entities.hue'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/hue/hue.html',
                        controller: 'HueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('ToneSettings', ToneSettings);

    ToneSettings.$inject = ['$resource'];

    function ToneSettings ($resource) {
        var resourceUrl =  'manager/' + 'api/tone-settings/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byStoreId': {
                method: 'GET',
                params:{
                    path:"byStoreId"
                }
            },
            "save":{
                method:"POST"
            },
            "delete":{
                method:"DELETE"
            },
            'update': { method:'PUT' },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('HueController', HueController);

    HueController.$inject = ['$scope', '$q', 'UidService', '$rootScope', '$stateParams', 'MessageService', 'Store', 'Qinius', 'ToneSettings'];

    function HueController($scope, $q, UidService, $rootScope, $stateParams, MessageService, Store, Qinius, ToneSettings) {
        var vm = this;

        vm.domains = Qinius.getDomain();
        vm.store = Store.getCurrent();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        // 导航栏默认色调
        vm.webNavbarBackColor = '#1e1f22';
        vm.webTitleColor = '#ffffff';
        vm.webMainButtonBackColor = '#ff5722';
        vm.webMainButtonTextColor = '#ffffff';
        vm.webSecondButtonBackColor = '#2e2e2e';
        vm.webSecondButtonTextColor = '#ffffff';

        // 侧边栏默认色调
        vm.sidebarBackColor = '#1e1f22';
        vm.sidebarUnselectButtonForeColor = '#999999';
        vm.sidebarSelectedButtonForeColor = '#ffffff';

        // 工具栏默认色调
        vm.toolbarBackColor = '#ffffff';
        vm.toolbarButtonBackColor = '#ededed';
        vm.toolbarButtonDefaultColor = '#000000';
        vm.toolbarFloatButtonBackColor = '#ff5722';
        vm.toolbarSelectedButtonBackColor = '#ff5722';

        // 通用颜色
        vm.genericColor = '#ff5722';


        vm.data={};
        $q.all([vm.domains.$promise, vm.store.$promise]).then(function(){
            vm.store = vm.store.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            init();
        })

        function init(){
            ToneSettings.byStoreId({id:vm.store.id}, function (res) {
                if(res.status == 200){
                    if(res.data){
                        vm.data = res.data;
                    }
                }else{
                    MessageService.error(res.message)
                }
            }, function (error) {});
        }

        window.uploadPic = function ($event, key) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0], key);
            }
        }

        function qiniuUpload(file, key) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "logo-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    if(key == 'previewBkWeb'){
                        vm.data.previewBkWeb = $scope.domain + data.key;
                    }else if(key == 'previewBkMobile'){
                        vm.data.previewBkMobile = $scope.domain + data.key;
                    }else {
                        vm.data.logo = $scope.domain + data.key;
                    }
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.removeFile = function(key) {
            if(key == 'previewBkWeb'){
                vm.data.previewBkWeb = null;
            }else if(key == 'previewBkMobile'){
                vm.data.previewBkMobile = null;
            }else {
                vm.data.logo = null;
            }
        }
        $scope.chooseTextColor = function () {
            console.log(vm.data.mobileTextSelectedColor)
            document.body.style.setProperty('--themeColor1', vm.data.mobileTextSelectedColor);
        }
        $scope.save = function () {
            if(vm.data.id){
                ToneSettings.update(vm.data, function (res) {
                    if(res.status == 200){
                        MessageService.success("更改成功")
                        init()
                    }else{
                        MessageService.error(res.message)
                    }
                }, function (error) {});
            }else {
                ToneSettings.save(vm.data, function (res) {
                    if(res.status == 200){
                        MessageService.success("更改成功")
                        init()
                    }else{
                        MessageService.error(res.message)
                    }
                }, function (error) {});
            }
        }

        // 重置颜色
        $scope.resetColor = function () {
            $('#resetIcon').addClass('rotation360')
            setTimeout(function () {
                $('#resetIcon').removeClass('rotation360')
            },1000)

            vm.data.webNavbarBackColor = vm.webNavbarBackColor;
            vm.data.webTitleColor = vm.webTitleColor;
            vm.data.webMainButtonBackColor = vm.webMainButtonBackColor;
            vm.data.webMainButtonTextColor = vm.webMainButtonTextColor;
            vm.data.webSecondButtonBackColor = vm.webSecondButtonBackColor;
            vm.data.webSecondButtonTextColor = vm.webSecondButtonTextColor;
    
            vm.data.sidebarBackColor = vm.sidebarBackColor;
            vm.data.sidebarUnselectButtonForeColor = vm.sidebarUnselectButtonForeColor;
            vm.data.sidebarSelectedButtonForeColor = vm.sidebarSelectedButtonForeColor;
    
            vm.data.toolbarBackColor = vm.toolbarBackColor;
            vm.data.toolbarButtonBackColor = vm.toolbarButtonBackColor;
            vm.data.toolbarButtonDefaultColor = vm.toolbarButtonDefaultColor;
            vm.data.toolbarFloatButtonBackColor = vm.toolbarFloatButtonBackColor;
            vm.data.toolbarSelectedButtonBackColor = vm.toolbarSelectedButtonBackColor;
    
            vm.data.genericColor =  vm.genericColor;
        }
    }

    // $scope.goToReadImage = function (pic) {
    //     // 遮罩层下面内容不滚动
    //     $('body').css("overflow", "hidden");
    //     $(".origin-image-dialog").removeClass('hide1');
    //     $(".dialog-form").addClass('opacity-zero');
    //     $(".origin-image-dialog img").attr('src', pic);
    //     $(".modal-content,.modal-dialog").addClass('clear-model');
    // }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FrameConfigLookController', FrameConfigLookController);

    FrameConfigLookController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function FrameConfigLookController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.cancel = cancel;
        vm.url = entity.url;
        vm.domain = entity.domain;

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FrameConfigApproveController', FrameConfigApproveController);

    FrameConfigApproveController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'MessageService', 
    'ThemeClassify', 'FrameConfig'];

    function FrameConfigApproveController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, MessageService,
     ThemeClassify, FrameConfig) {
        var vm = this;

        vm.textXml = entity;
        vm.clear = clear;
        vm.save = save;
        vm.name = "审核";
        if ($scope.toState.name == 'frame-config-approve') {
            vm.name = "审核";
        }else{
            vm.name = "编辑";
        }
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'BORDER'}]}, function (res) {
            if(res.status == 200){
                vm.themeClassifies = res.data;
            }else {
                MessageService.error(res.message);
            }
        });
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise,vm.textXml.$promise]).then(function(){
            vm.textXml = vm.textXml.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })



        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.validate = function(){
            if(vm.textXml.themeClassifyId == null || vm.textXml.themeClassifyId==""){
                MessageService.error("请选择分类");
                return false;
            }
            return true;
        };

        function save () {
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if ($scope.toState.name == 'frame-config-approve') {
                FrameConfig.approve({id:vm.textXml.id, name:vm.textXml.name, themeClassifyId: vm.textXml.themeClassifyId, seq:vm.textXml.seq},function(res){
                    MessageService.success("审核通过");
                    $uibModalInstance.close();
                    vm.isSaving = false;
                },function(){
                    MessageService.error("通过失败");
                    vm.isSaving = false;
                })
            }else{
                FrameConfig.update(vm.textXml,function(res){
                    MessageService.success("保存成功");
                    $uibModalInstance.close();
                    vm.isSaving = false;
                },function(){
                    MessageService.error("保存失败");
                    vm.isSaving = false;
                })
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frame-config', {
            parent: 'entity',
            url: '/frame-config?page&sort&search&themeClassifyId',
            data: {
                authorities: ["ROLE_FRAME_CONFIG"],
                pageTitle: 'global.menu.entities.frameConfig'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frame-config/frame-config.html',
                    controller: 'FrameConfigController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        themeClassifyId: $stateParams.themeClassifyId,
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frame-config-approve', {
            parent: 'frame-config',
            url: '/approve/{id}',
            data: {
                authorities: ["ROLE_FRAME_CONFIG"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frame-config/modal/frame-config-approve.html',
                    controller: 'FrameConfigApproveController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass:'modal-right',
                    size: 'lg',
                    resolve: {
                        entity: ['FrameConfig'  , function(FrameConfig) {
                            return FrameConfig.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frame-config', null, { reload: 'frame-config' });
                }, function() {
                    $state.go('frame-config');
                });
            }]
        })
        .state('frame-config-edit', {
            parent: 'frame-config',
            url: '/edit/{id}',
            data: {
                authorities: ["ROLE_FRAME_CONFIG"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frame-config/modal/frame-config-approve.html',
                    controller: 'FrameConfigApproveController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass:'modal-right',
                    size: 'lg',
                    resolve: {
                        entity: ['FrameConfig'  , function(FrameConfig) {
                            return FrameConfig.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frame-config', null, { reload: 'frame-config' });
                }, function() {
                    $state.go('frame-config');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('FrameConfig', FrameConfig);

    FrameConfig.$inject = ['$resource'];

    function FrameConfig ($resource) {
        var resourceUrl =  'manager/' + 'api/frame-configs/:path/:id';
        return $resource(resourceUrl, {}, {
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete': {
                method: 'DELETE'
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "approve":{
                method:"GET",
                params:{
                    path:"approve"
                }
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            "reject":{
                method:"GET",
                params:{
                    path:"reject"
                },
            },
            "receive":{
                method:"POST",
                params:{
                    path:"receive"
                },
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FrameConfigController', FrameConfigController);

    FrameConfigController.$inject = ['$scope', '$q', '$state', 'FrameConfig', 'ParseLinks', 'paginationConstants', 'pagingParams',
     'MessageService', 'Qinius', '$uibModal', 'ThemeClassify'];

    function FrameConfigController ($scope, $q, $state, FrameConfig, ParseLinks, paginationConstants, pagingParams, 
        MessageService, Qinius, $uibModal, ThemeClassify) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.themeClassifyId = Number(pagingParams.themeClassifyId);
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.status = status;

        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        vm.class =  ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'BORDER'}]});
        $q.all([vm.domains.$promise, vm.class.$promise]).then(function(){
            vm.class = vm.class.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        $scope.changeStatue = function (id,e) {
            FrameConfig.changeStatue({id: id}, function () {
                loadAll();
            });
        }
        
        function loadAll () {
            var items = [];
            if (pagingParams.search) {
                items.push({key:"name",op:"like",value:pagingParams.search});
            }
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",op:"=",value:vm.themeClassifyId});
            }
            FrameConfig.byCondition2({
                items:items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.textXmls = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("边框获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                themeClassifyId:vm.themeClassifyId,
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        $scope.approved = function(item){
            MessageService.confirm("确认要通过该边框", function(){
                FrameConfig.approve({id:item.id, status:"Approved", remarks:""},function(res){
                    if(res.status == 200){
                        MessageService.success("审核通过");
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                },function(){
                    MessageService.error("通过失败");
                })
            })
        }
        $scope.rejected = function(item){
            MessageService.confirm("确认要拒绝该边框么？", function(){
                FrameConfig.reject({id:item.id, status:"Rejected", remarks:""},function(res){
                    if(res.status == 200){
                        MessageService.success("拒绝成功");
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                },function(){
                    MessageService.error("拒绝失败");
                })
            })
        };
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/frame-config/modal/frame-config-look.html',
                controller: 'FrameConfigLookController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            url: data.cover,
                            domain: $scope.domain
                        };
                    }]
                }
            });
        }
        $scope.delete = function(id){
            MessageService.confirm("确认删除该边框？",function(){
                FrameConfig.delete({id: id},function (res) {
                    if(res.status == 200){
                        MessageService.success("删除成功");
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                });
            },function(){});
        };
        //Creating,  Created,  Approved,  Rejected,  Cancelled
        function status(item) {
            switch (item) {
                case 'Creating':
                    return '新建';
                    break;
                case 'Created':
                    return '已创建';
                    break;
                case 'Approved':
                    return '已通过';
                    break;
                case 'Rejected':
                    return '已拒绝';
                    break;
                case 'Cancelled':
                    return '已取消';
                    break;
                default:
                    return '暂无状态'
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FontManagementDialogController', FontManagementDialogController);

    FontManagementDialogController.$inject = ['$timeout', '$scope', 'UidService', '$stateParams', '$uibModalInstance', 'entity', 'FontManagement', 'Upload', 'MessageService', 'Qinius'];

    function FontManagementDialogController ($timeout, $scope, UidService, $stateParams, $uibModalInstance, entity, FontManagement, Upload, MessageService, Qinius) {
        var vm = this;

        vm.fontManagement = entity;
        vm.clear = clear;
        vm.save = save;

        vm.types =[{type:"wechat",name:'全部可用'},{type:"all",name:'模板可用'}];
        vm.fontManagement.type = vm.types[0].type;

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        vm.files = [];
        window.uploadFile = function ($event) {
            vm.files = $event.target.files;
            if (vm.files.length > 0) {
                qiniuUpload(0);
            }
        }
        function qiniuUpload(index) {
            var file = vm.files[index];
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', true);
            formData.append('key', "font-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                success: function(data) {
                    Upload.upload({
                        type: 'POST',
                        url: 'manager/api/font-managements/upload', //上传路径
                        data: {
                            file: file,
                            identifier: data.key,
                            name: file.name,
                            type: vm.fontManagement.type
                        }
                    }).then(function successCallback(res) {
                        if (res.status && res.status == 200) {
                            if(index < vm.files.length-1){
                                qiniuUpload(index+1);
                            }else{
                                MessageService.success("字体上传成功");
                                $uibModalInstance.close(res);
                            }
                        }else{
                            MessageService.error(file.name + "字体上传失败");
                            if(index < vm.files.length-1){
                                qiniuUpload(index+1);
                            }
                        }
                    }, function errorCallback(response) {
                        if(index < vm.files.length-1){
                            qiniuUpload(index+1);
                        }
                        MessageService.error(file.name + "字体上传失败");
                    });
                },
                error: function (request) {
                    if(index < vm.files.length-1){
                        qiniuUpload(index+1);
                    }
                    MessageService.error(file.name + "文件上传失败");
                }
            });
        };


        function save () {
            vm.isSaving = true;
            if (vm.fontManagement.id !== null) {
                FontManagement.update(vm.fontManagement, onSaveSuccess, onSaveError);
            } else {
                FontManagement.save(vm.fontManagement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('editorApp:fontManagementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FontManagementDetailController', FontManagementDetailController);

    FontManagementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'FontManagement'];

    function FontManagementDetailController($scope, $rootScope, $stateParams, $uibModalInstance, entity, FontManagement) {
        var vm = this;

        vm.fontManagement = entity.data; 
        console.log(entity);
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('platformApp:fontManagementUpdate', function(event, result) {
            vm.fontManagement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('font-management', {
            parent: 'entity',
            url: '/font-management?page&sort&search&style',
            data: {
                authorities: ["ROLE_FONT_MANAGEMENT"],
                pageTitle: 'editorApp.fontManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/font-management/font-managements.html',
                    controller: 'FontManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                style:'List'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        style:$stateParams.style
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('font-management-detail', {
            parent: 'font-management',
            url: '/font-management/{id}',
            data: {
                authorities: ["ROLE_FONT_MANAGEMENT"],
                pageTitle: 'editorApp.fontManagement.detail.title'
            },
            onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                $uibModal.open({
                    templateUrl: 'app/entities/font-management/font-management-detail.html',
                    controller: 'FontManagementDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass:'modal-right',
                    resolve: {
                        
                        entity: ['FontManagement', function(FontManagement) {
                            return FontManagement.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('fontManagement');
                            $translatePartialLoader.addPart('style');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('font-management', null, { reload: 'font-management' });
                }, function() {
                    $state.go('font-management');
                });
            }] 
        })
         
        .state('font-management.new', {
            parent: 'font-management',
            url: '/new',
            data: {
                authorities: ["ROLE_FONT_MANAGEMENT"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/font-management/font-management-dialog.html',
                    controller: 'FontManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass:'modal-right',
                    resolve: {
                        entity: function () {
                            return {
                                family: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('font-management', null, { reload: 'font-management' });
                }, function() {
                    $state.go('font-management');
                });
            }]
        })
        .state('font-management.edit', {
            parent: 'font-management',
            url: '/{id}/edit',
            data: {
                authorities: ["ROLE_FONT_MANAGEMENT"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/font-management/font-management-dialog.html',
                    controller: 'FontManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FontManagement', function(FontManagement) {
                            return FontManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('font-management', null, { reload: 'font-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('FontManagement', FontManagement);

    FontManagement.$inject = ['$resource'];

    function FontManagement ($resource) {
        var resourceUrl =  'manager/' + 'api/font-managements/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAll1": {
                method: "POST",
                params: {
                    path: "getAll1"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
            },
            "getCss": {
                method: "GET",
                params: {
                    path: "getCss"
                }
            },
            "upload": {
                method: "POST",
                params: {
                    path: "upload"
                }
            },
            "defaultShow":{
                method:"GET",
                params:{
                    path:"defaultShow"
                }
            },
            "getAll": {
                method: "POST",
                params: {
                    path: "getAll"
                }
            },
            "updateType": {
                method: "GET",
                params: {
                    path: "updateType"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'updateLanguage':{
                method: 'POST',
                params:{
                    path:"updateLanguage"
                },
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FontManagementController', FontManagementController);

    FontManagementController.$inject = ['$scope', '$state', 'FontManagement', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService',
    '$localStorage', 'Qinius', '$q','$uibModal'];

    function FontManagementController ($scope, $state, FontManagement, ParseLinks, paginationConstants, pagingParams, MessageService,
     $localStorage, Qinius, $q,$uibModal) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.multilingual= multilingual;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.account = $localStorage.user;
        vm.listStyle = pagingParams.style; //List
        loadAll();

        vm.domains = Qinius.getDomain();
        $q.all([ vm.domains.$promise]).then(function(){
            vm.domainQ = 'https://' + vm.domains.domains[0] + '/';
        })


        $scope.defaultShow = function(fontManagement){
            // MessageService.confirm("确认要设置为模板中默认展示？",function(){
            //     FontManagement.defaultShow({id: id},function (res) {
            //         if(res.status == 200){
            //             MessageService.success('设置默认字体成功');
            //             loadAll();
            //         }else {
            //             MessageService.error(res.message);
            //         }
            //     });
            // },function(){});
            if (!fontManagement.enable) {
                MessageService.error('当前字体不可设置为默认字体！');
                fontManagement.defaultShow = false
                return
            }
            FontManagement.defaultShow({id: fontManagement.id},function (res) {
                if(res.status == 200){
                    MessageService.success('设置默认字体成功');
                    loadAll();
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        $scope.delete = function(id){
            MessageService.confirm("确认要删除该数据？",function(){
                FontManagement.delete({id: id},function (res) {
                    if(res.status == 200){
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                });
            },function(){});
        };

        $scope.switchStyle = function(){
            if (vm.listStyle == 'Card') {
                vm.listStyle = 'List'
            }else{
                vm.listStyle = 'Card'
            }
            transition()
        }

        function loadAll () {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            if (pagingParams.search) {
                FontManagement.byCondition2({
                    items:[{key:"family",value:pagingParams.search, op:"like"}],
                    page: pagingParams.page - 1,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FontManagement.byCondition2({
                    page: pagingParams.page - 1,
                    size: 20,
                    sort: sort()
                },
                onSuccess, onError);

            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.fontManagements = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("字体获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                style:vm.listStyle
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function multilingual(fontManagement){
            var languages = fontManagement.fontFamilyLanguages;
            var id = fontManagement.id;
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:languages,
                            key: 'family',
                            fieldValue: fontManagement.family,
                            fieldName: '字体名称'
                        };
                    }]
                }
            }).result.then(function(data) {
                if (data) {
                    var familyLanguageVM ={}
                    familyLanguageVM.list = data;
                    familyLanguageVM.fontManagementId = id;
                }
                FontManagement.updateLanguage(familyLanguageVM,function (){
                    MessageService.success("保存成功");
                    loadAll()
                },function (){
                    MessageService.error("保存失败");
                });
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FeedbackDialogController', FeedbackDialogController);

    FeedbackDialogController.$inject = ['$timeout', '$q', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Feedback', 'MessageService', 'Qinius', 'UidService'];

    function FeedbackDialogController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, Feedback, MessageService, Qinius, UidService) {
        var vm = this;

        vm.feedback = entity;
        vm.clear = clear;
        vm.save = save;
        vm.attachments =[];
        vm.imgs =[];
        vm.status = vm.feedback.status;

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise, vm.feedback.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        });

        //上传附件
        window.updateImgFile = function ($event) {
            vm.imgs = [];
            $timeout(function () {
                console.log($event.target.files);
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file){
                    var getBase64 = function (file, callback) {
                        var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                        reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                        reader.onload = function () {       //  成功读取
                            $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                        };
                        reader.onerror = function (error) {     //  出错
                        };
                    };
                    getBase64(file, function (result) {
                    });
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);
                    formData.append('key', "feedback-"+ UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            console.log(data);
                            //vm.imgs.push(data.key);
                            vm.attachments.push({provider:"qiniu", identifier:data.key,fileName:vm.imgs[i]});
                            console.log(vm.attachments);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        };


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function(){
            if(vm.feedback.title == null || vm.feedback.title==""){
                MessageService.error("请输入标题");
                return false;
            }
            if(vm.feedback.description == null || vm.feedback.description==""){
                MessageService.error("请输入描述");
                return false;
            }
            //if(vm.imgs== null || vm.imgs==""){
            //    MessageService.error("请上传附件");
            //    return false;
            //}

            return true;
        };

        function save () {
            vm.feedback.status = vm.status;
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            var objLine={};
            objLine.description = vm.feedback.description;
            objLine.type = "Problem";
            objLine.attachments = vm.attachments;
            console.log(objLine);
            vm.feedback.feedbackLines = [];
            vm.feedback.feedbackLines.push(objLine);
            Feedback.save(vm.feedback, onSaveSuccess, onSaveError);
        }

        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            console.log(vm.attachments);
        };

        function onSaveSuccess (result) {
            $scope.$emit('backApp:feedbackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FeedbackDetailController', FeedbackDetailController);

    FeedbackDetailController.$inject = ['$scope','$q','$timeout', '$rootScope', '$stateParams','MessageService' ,'$uibModalInstance', 'entity', 'Feedback','Qinius','UidService'];

    function FeedbackDetailController($scope, $q,$timeout,$rootScope, $stateParams,MessageService,$uibModalInstance, entity, Feedback,Qinius,UidService) {
        var vm = this;
        vm.feedback = entity;
        vm.askProblem = false;
        vm.askSubmit = false;
        vm.attachments = [];
        vm.imgs =[];
        console.log(entity);

        vm.feedback.feedbackLines.sort(function(a, b){
            return new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime();
        });

        vm.clear = clear;
        vm.save = save;
        vm.unresolved = unresolved;
        vm.resolve = resolve;

        function resolve(id){
            Feedback.resolve({
               id:id
            }, onSuccess, onError);
        };

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise, vm.feedback.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        });

        //上传附件
        window.updateImgFile = function ($event) {
            vm.imgs = [];
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file){
                    var getBase64 = function (file, callback) {
                        var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                        reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                        reader.onload = function () {       //  成功读取
                            $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                        };
                        reader.onerror = function (error) {     //  出错
                        };
                    };
                    getBase64(file, function (result) {
                    });
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);
                    formData.append('key', "feedback-"+ UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            console.log(data);
                            vm.attachments.push({provider:"qiniu", identifier:data.key,fileName:vm.imgs[i]});
                            console.log(vm.attachments);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        };


        //文件下载
        $scope.downloadZipFile3 = function(attachment){
            var storeId = JSON.parse(localStorage.getItem('back-user')).storeId;
            window.open("fileserves/api/download/downloadZipFile3?key="+attachment.identifier+'&name='+attachment.fileName+'&storeId='+storeId);
        };

        $scope.validate = function(){
            if(vm.askContent == null || vm.askContent==""){
                MessageService.error("请输入追问内容");
                return false;
            }
            //if(vm.imgs== null || vm.imgs==""){
            //    MessageService.error("请上传附件");
            //    return false;
            //}
            return true;
        };

        $scope.removeFile = function(file,index) {
            vm.imgs.splice(index, 1);
            vm.attachments.splice(index,1);
            console.log(vm.imgs);
            console.log(vm.attachments);
        };

        function unresolved(){
            vm.askProblem = true;
            vm.askSubmit = true;
        };


        function save () {
            if(!$scope.validate()){
                return;
            }
            vm.line ={};
            vm.line.attachments = vm.attachments;
            vm.line.feedbackId = vm.feedback.id;
            vm.line.description = vm.askContent;
            vm.line.type = "Asking";
            console.log(vm.line);
            Feedback.unresolved(vm.line, onSuccess, onError);
        }
        function onSuccess (result) {
            $scope.$emit('backApp:feedbackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        function onError(error) {
            MessageService.error("状态修改失败");
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        var unsubscribe = $rootScope.$on('backApp:feedbackUpdate', function(event, result) {
            vm.feedback = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('feedback', {
                parent: 'entity',
                url: '/feedback',
                data: {
                    authorities: ['ROLE_FEEDBACK'],
                    pageTitle: 'global.menu.entities.feedbackManagement'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/feedback/feedback.html',
                        controller: 'FeedbackController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    status:null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            status: $stateParams.status
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('feedback');
                        return $translate.refresh();
                    }]
                }
            })
            .state('feedback.new', {
                parent: 'feedback',
                url: '/new',
                data: {
                    authorities: ['ROLE_FEEDBACK']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    img: null,
                                    status: null,
                                    cancelled: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('feedback', null, { reload: 'feedback' });
                    }, function() {
                        $state.go('feedback');
                    });
                }]
            })
            .state('feedback-detail', {
                parent: 'feedback',
                url: '/feedback/{id}',
                data: {
                    authorities: ['ROLE_FEEDBACK']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-detail.html',
                        controller: 'FeedbackDetailController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('feedback');
                                return $translate.refresh();
                            }],
                            entity: ['Feedback', function(Feedback) {
                                return Feedback.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('feedback', {}, {
                            reload: 'feedback'
                        });
                    }, function() {
                        $state.go('feedback');
                    });
                }]
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Feedback', Feedback);

    Feedback.$inject = ['$resource', 'DateUtils'];

    function Feedback ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/feedbacks/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                },
                isArray: true
            },
            "resolve":{
                method:"GET",
                params:{
                    path:"resolve"
                },
                isArray: false
            },
            "unresolved":{
                method:"POST",
                params:{
                    path:"unresolved"
                },
                isArray: false
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.submitTime = DateUtils.convertDateTimeFromServer(data.submitTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FeedbackController', FeedbackController);

    FeedbackController.$inject = ['$scope', 'Principal','$state', 'MessageService', 'ParseLinks', 'paginationConstants', 'pagingParams', 'Feedback'];

    function FeedbackController($scope, Principal,$state, MessageService, ParseLinks, paginationConstants, pagingParams, Feedback) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.jump = jump;
        vm.status = pagingParams.status;
        vm.time = pagingParams.time;
        vm.isAuthenticated = Principal.isAuthenticated;
        loadAll();
        function loadAll () {
            var items=[];
            if (vm.status !=null) {
                items.push({key:"status",op:"=",value:vm.status});
            };
            if (pagingParams.search) {
                items.push({key:"title",op:"like",value:pagingParams.search});
                Feedback.byCondition({
                    items:items,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Feedback.byCondition({
                    items:items,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feedbacks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                MessageService.error("反馈获取失败");
            }
        };

        $scope.byStatus =function(status){
            vm.status = status;
            loadAll();
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        };

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                time:vm.time,
                status:vm.status
            });
        };

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
            loadAll();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;

            vm.status = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', { abstract: true, parent: 'app'});
        $stateProvider.state('basicSettings', { abstract: true, parent: 'app'});
        $stateProvider.state('usersAuthority', { abstract: true, parent: 'app'});
        $stateProvider.state('templateManagement', { abstract: true, parent: 'app'});
        $stateProvider.state('salesManagement', { abstract: true, parent: 'app'});
        $stateProvider.state('shipManagement', { abstract: true, parent: 'app'});
        $stateProvider.state('bannerManagement', { abstract: true, parent: 'app'});
        $stateProvider.state('customerManagement', { abstract: true, parent: 'app'});
        $stateProvider.state('couponManagement', { abstract: true, parent: 'app'});
        $stateProvider.state('storeManagement', { abstract: true, parent: 'app'});
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('DiyEditorSettingDialogController', DiyEditorSettingDialogController);

    DiyEditorSettingDialogController.$inject = ['$q', '$timeout','UidService', '$scope', 'MessageService', 'entity', '$stateParams', '$state', 'Qinius' ,'Store',
    'ListService','FontManagement','DiyEditorSetting','$localStorage','$uibModal'];

    function DiyEditorSettingDialogController ($q, $timeout,UidService, $scope, MessageService, entity, $stateParams, $state, Qinius,Store,
        ListService,FontManagement,DiyEditorSetting,$localStorage, $uibModal) {
        var vm = this;
        vm.data = entity.data;
        vm.clear = clear;
        vm.save = save;

        // 选中tab(模板,文字,素材,图片)
        vm.pageBox = null;
        //右侧边栏展示名
        vm.rightIndex = null;
        /**
         * imgself  默认icon 不会改变
         * img      显示默认icon或者自定义icon
         * isShow   是否展示
         * seq      排序
         * seqValye 排序设置名称（保存时判断）
         * value    icon名称
         * value2   是否展示（icon名）
         * */
        vm.posterBox=[
            {name:'模板', img:'content/images/editor/mubanshape.svg',isShow:false,seq:0,value:'templateIcon',value2:'templateShow',seqValye:'templateSeq',imgself:'content/images/editor/mubanshape.svg'},
            {name:'文字', img:'content/images/editor/wenzishape.svg',isShow:false,seq:1,value:'wordIcon',value2:'wordShow',seqValye:'wordSeq',imgself:'content/images/editor/wenzishape.svg'},
            {name:'素材', img:'content/images/editor/sucaishape.svg',isShow:false,seq:2,value:'clipartIcon',value2:'clipartShow',seqValye:'clipartSeq',imgself:'content/images/editor/sucaishape.svg'},
            {name:'图片', img:'content/images/editor/tupianshape.svg',isShow:false,seq:3,value:'imgIcon',value2:'imgShow',seqValye:'imgSeq',imgself:'content/images/editor/tupianshape.svg'},
        ]

        vm.tokens = Qinius.get();
        vm.domains = Qinius.getDomain();

        FontManagement.getAll1({items: [], sort: ["id,asc"]}, function (res) {
            vm.fontList = angular.copy(res.data);
            vm.fontList1 = angular.copy(res.data);
            $scope.item = vm.fontList[0];
        });

        $q.all([vm.domains.$promise, vm.tokens.$promise]).then(function(){
            vm.token = vm.tokens.token;
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
            if(!vm.data.storeId){vm.data.storeId=$localStorage.user.storeId}
            if(!vm.data.mainColor){vm.data.mainColor = '#ff6e33';}
            if(!vm.data.delWordColor){vm.data.delWordColor = '#0a0a0a';}
            if(!vm.data.wordStyleColor){vm.data.wordStyleColor = '#0a0a0a';}
            if(!vm.data.editWordColor){vm.data.editWordColor = '#0a0a0a';}
            if(!vm.data.templateColor){vm.data.templateColor = '#333333';}
            if(!vm.data.clipartColor){vm.data.clipartColor = '#333333';}
            if(!vm.data.wordColor){vm.data.wordColor = '#333333';}
            if(!vm.data.imgColor){vm.data.imgColor = '#333333';}
            if(!vm.data.changeImgColor){vm.data.changeImgColor = '#0a0a0a';}
            if(!vm.data.filterColor){vm.data.filterColor = '#0a0a0a';}
            if(!vm.data.rotationColor){vm.data.rotationColor = '#0a0a0a';}
            if(!vm.data.upColor){vm.data.upColor = '#0a0a0a';}
            if(!vm.data.downColor){vm.data.downColor = '#0a0a0a';}
            if(!vm.data.flipColor){vm.data.flipColor = '#0a0a0a';}
            if(!vm.data.restoreColor){vm.data.restoreColor = '#0a0a0a';}
            if(!vm.data.spreadColor){vm.data.spreadColor = '#0a0a0a';}
            if(!vm.data.retractColor){vm.data.retractColor = '#0a0a0a';}
            if(!vm.data.wordText){vm.data.wordText="文字"}
            if(!vm.data.templateText){vm.data.templateText="模板"}
            if(!vm.data.clipartText){vm.data.clipartText="素材"}
            if(!vm.data.imgText){vm.data.imgText="图片"}
            if(vm.data.templateShow){
                vm.posterBox[0].isShow = true;
                vm.posterBox[0].seq = vm.data.templateSeq;
            }
            if(vm.data.wordShow){
                vm.posterBox[1].isShow = true;
                vm.posterBox[1].seq = vm.data.wordSeq;
            }
            if(vm.data.clipartShow){
                vm.posterBox[2].isShow = true;
                vm.posterBox[2].seq = vm.data.clipartSeq;
            }
            if(vm.data.imgShow){
                vm.posterBox[3].isShow = true;
                vm.posterBox[3].seq = vm.data.imgSeq;
            }
            vm.posterBox.sort(function (a, b) {
                return a.seq - b.seq;
            })
            if(vm.data.templateSelf && vm.data.templateIcon){ $scope.changeSelf('templateSelf',1); }
            if(vm.data.clipartSelf && vm.data.clipartIcon){ $scope.changeSelf('clipartSelf',1); }
            if(vm.data.wordIconSelf && vm.data.wordIcon){ $scope.changeSelf('wordIconSelf',1); }
            if(vm.data.imgSelf && vm.data.imgIcon){ $scope.changeSelf('imgSelf',1); }
        })

        window.dragStart = function (event) {
            var target = event.target;
            $(".diy-editor-poster-box").addClass('diy-drop-active')
        };

        var content = $(".diy-editor-poster-box")[0];
        content.ondragenter = ignoreDrag;
        // 拖动文件的鼠标指针位置放置区之上时发生
        content.ondragover = ignoreDrag;
        content.ondrop = drop;

        function ignoreDrag(e) {
            // 确保其他元素不会取得该事件
            e.stopPropagation();
            e.preventDefault();
            var dataset = e.target.dataset;
        }

        function drop(e) {
            ignoreDrag(e);
            var data = e.dataTransfer.getData("Text");
            // 如果Text类型获取不到，尝试text/plain
            if (!data) {
                data = e.dataTransfer.getData("text/plain");
            }
            
            // 如果还是获取不到，尝试从dataTransfer.types中获取
            if (!data && e.dataTransfer.types) {
                for (var i = 0; i < e.dataTransfer.types.length; i++) {
                    var type = e.dataTransfer.types[i];
                    if (type === "text/plain" || type === "text/html" || type === "text/uri-list" ) {
                        data = e.dataTransfer.getData(type);
                        if (data) break;
                    }
                }
            }
            if (data.indexOf('mubanshape') != '-1') {
                selectTab('templateIcon')
                vm.data.templateShow = true;
            }else if (data.indexOf('wenzishape') != '-1') {
                selectTab('wordIcon')
                vm.data.wordShow = true;
            }else if (data.indexOf('sucaishape') != '-1') {
                selectTab('clipartIcon')
                vm.data.clipartShow = true;
            }else if (data.indexOf('tupianshape') != '-1') {
                selectTab('imgIcon')
                vm.data.imgShow = true;
            }
            $(".diy-editor-poster-box").removeClass('diy-drop-active')
            $scope.$digest()
            console.log(vm.data)
        }

        function selectTab(attr){
            for (var i = 0; i < vm.posterBox.length; i++) {
                if(vm.posterBox[i].value == attr){
                    vm.posterBox[i].isShow = true;
                    break
                }
            }
        }

        $scope.editBox = function(box){
            vm.pageBox = box.value;
            vm.rightIndex = box.value;
            console.log(vm.rightIndex)
        }

        $scope.deleteTab = function(e,box){
            fn(e);
            box.isShow = false;
            vm.pageBox = null;
            vm.rightIndex = null;
        }

        $scope.changeSelf = function(attr,flag){
            if(flag){
                vm.data[attr] = true;
            }else{
                vm.data[attr] = false;
            }
            // 四个tab icon
            for (var i = 0; i < vm.posterBox.length; i++) {
                if(attr=='templateSelf'&&vm.posterBox[i].value=='templateIcon' || attr=='clipartSelf'&&vm.posterBox[i].value=='clipartIcon' ||
                    attr=='wordIconSelf'&&vm.posterBox[i].value=='wordIcon' || attr=='imgSelf'&&vm.posterBox[i].value=='imgIcon'){
                    if(flag && vm.data[vm.posterBox[i].value]){
                        vm.posterBox[i].img = vm.data[vm.posterBox[i].value];
                    }else{
                        vm.posterBox[i].img = angular.copy(vm.posterBox[i].imgself);
                    }
                    break
                }
            }
        }
        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }
        window.updateImgFile = function ($event) {
            console.log($event)
            console.log($event.target)
            $timeout(function () {
                var file = $event.target.files[0];
                updateImg(file,$event.target.dataset.flag)
            });
        };

        function updateImg(file,attr) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(file);//创建Image的对象的url
            img.onload = function () {
                // 建议尺寸40px*40px
                var w = Math.abs(this.width - 40);
                var h = Math.abs(this.height - 40);
                if (w > 11 || h > 11) {
                    MessageService.error("建议图片尺寸：40px*40px");
                    return
                }
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', 'diy-' + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        console.log(data);
                        vm.data[attr] = $scope.domain+data.key;
                        if(attr=='wordIcon'){
                            for (var i = 0; i < vm.posterBox.length; i++) {
                                if(vm.posterBox[i].value=='wordIcon'){vm.posterBox[i].img = $scope.domain+data.key;break;}
                            }
                        }
                        if(attr=='clipartIcon'){
                            for (var i = 0; i < vm.posterBox.length; i++) {
                                if(vm.posterBox[i].value=='clipartIcon'){vm.posterBox[i].img = $scope.domain+data.key;break;}
                            }
                        }
                        if(attr=='templateIcon'){
                            for (var i = 0; i < vm.pageBox.length; i++) {
                                if(vm.posterBox[i].value=='templateIcon'){vm.posterBox[i].img = $scope.domain+data.key;break;}
                            }
                        }
                        if(attr=='imgIcon'){
                            for (var i = 0; i < vm.posterBox.length; i++) {
                                if(vm.posterBox[i].value=='imgIcon'){vm.posterBox[i].img = $scope.domain+data.key;break;}
                            }
                        }
                        $scope.$digest();
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            }
        }

        $scope.removeFile = function(attr) {
            vm.data[attr] = null;
            if(attr=='wordIcon'){
                for (var i = 0; i < vm.posterBox.length; i++) {
                    if(vm.posterBox[i].value=='wordIcon'){vm.posterBox[i].img = angular.copy(vm.posterBox[i].imgself);break;}
                }
            }
            if(attr=='clipartIcon'){
                for (var i = 0; i < vm.posterBox.length; i++) {
                    if(vm.posterBox[i].value=='clipartIcon'){vm.posterBox[i].img = angular.copy(vm.posterBox[i].imgself);break;}
                }
            }
            if(attr=='templateIcon'){
                for (var i = 0; i < vm.posterBox.length; i++) {
                    if(vm.posterBox[i].value=='templateIcon'){vm.posterBox[i].img = angular.copy(vm.posterBox[i].imgself);break;}
                }
            }
            if(attr=='imgIcon'){
                for (var i = 0; i < vm.posterBox.length; i++) {
                    if(vm.posterBox[i].value=='imgIcon'){vm.posterBox[i].img = angular.copy(vm.posterBox[i].imgself);break;}
                }
            }
        }

        $scope.addTextFont = function(){
            if(!vm.data.supportFonts){
                vm.data.supportFonts = [];
            }
            vm.data.supportFonts.push({fontManagement:null})
            console.log(vm.data.supportFonts)
        }

        $scope.delFont = function(index){
            vm.data.supportFonts.splice(index,1)
        }

        $scope.addColor = function(){
            if(!vm.data.supportFontColors){
                vm.data.supportFontColors = [];
            }
            vm.data.supportFontColors.push({color:'#333333'})
            console.log(vm.data.supportFonts)
        }

        $scope.delColor = function(index){
            vm.data.supportFontColors.splice(index,1)
        }

        $scope.chooseFont = function () {
            console.log(vm.data)
        }

        var sort = null;
        var sortArray = [];
        setTimeout(function () {
            sort = new Sortable(document.getElementById('my-ui-list1'), {
                swap: true,
                filter: '.filtered',
                animation: 150,
                onEnd: function (/**Event*/evt) {
                    console.log('onEnd.foo:', [evt.item, evt.from]);
                }
            });
        },500)

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go('diy-editor-setting', null, { reload: 'diy-editor-setting' });
        }

        function save () {
            sortArray = [];
            angular.forEach($('#my-ui-list1').find('.slide-content1'), function (item, index) {
                var seq = item.getAttribute("data-sort-tag");
                var value = angular.copy(vm.posterBox[seq]);
                value.seq = index;
                sortArray.push(value)
            });
            vm.posterBox = angular.copy(sortArray);
            console.log(vm.posterBox)
            angular.forEach(vm.posterBox,function (box) {
                if(box.isShow){
                    vm.data[box.value2] = true;
                    vm.data[box.seqValye] = box.seq;
                }else{
                    vm.data[box.value2] = false;
                }
            })
            console.log(vm.data)
            // sort.destroy();
            // return
            vm.isSaving = true;
            DiyEditorSetting.update(vm.data, onSaveSuccess, onSaveError);
            // return
        }

        function onSaveSuccess (result) {
            $scope.$emit('backApp:navigationSettingUpdate', result);
            $state.go('diy-editor-setting', null, { reload: 'diy-editor-setting' });
            // $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        vm.multilingual = function (title, name, key, data){
            if(!vm.data[data]){
                vm.data[data] = [];
            }
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.data[data],
                            key: key,
                            fieldValue: name,
                            fieldName: title
                        };
                    }]
                }
            }).result.then(function(res) {
                if (res) {
                    vm.data[data] = res;
                    console.log(vm.data)
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('DiyEditorSettingCreateController', DiyEditorSettingCreateController);

    DiyEditorSettingCreateController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'DiyEditorSetting', 'MessageService','$uibModal'];

    function DiyEditorSettingCreateController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, DiyEditorSetting, MessageService,$uibModal) {
        var vm = this;
        vm.data = {};
        vm.cancel = cancel;
        vm.save = save;
        vm.multilingual= multilingual;

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.editorType){
                MessageService.error("请选择适用编辑器");
                return
            }

            if(!vm.data.name){
                MessageService.error("请输入编辑器名称");
                return
            }
            console.log(vm.data)
            vm.isSaving = true;
            DiyEditorSetting.save(vm.data, onSaveSuccess, onSaveError);

            function onSaveSuccess (result) {
                MessageService.success("保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }

            function onSaveError () {
                MessageService.error("保存失败");
                vm.isSaving = false;
            }
        }

        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.data.diyEditorSettingLanguages,
                            key: 'name',
                            fieldValue: vm.data.name,
                            fieldName: 'DIY编辑器名称'
                        };
                    }]
                }
            }).result.then(function(data) {
                if (data) {
                    vm.data.diyEditorSettingLanguages =data;
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('diy-editor-setting', {
                parent: 'entity',
                url: '/diy-editor-setting',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.entities.editorDiy'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/diyEditorSetting/diy-editor-setting.html',
                        controller: 'DiyEditorSettingController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('diyEditorSetting');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
        .state('diy-editor-setting.edit', {
            parent: 'diy-editor-setting',
            url: '/{id}/edit',
            data: {
                authorities: [],
                pageTitle: 'global.menu.entities.editorDiy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/diyEditorSetting/diy-editor-setting-dialog.html',
                    controller: 'DiyEditorSettingDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diyEditorSetting');
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['DiyEditorSetting','$stateParams', function(DiyEditorSetting,$stateParams) {
                    return DiyEditorSetting.get({id:$stateParams.id}).$promise;
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('DiyEditorSetting', DiyEditorSetting);

    DiyEditorSetting.$inject = ['$resource'];

    function DiyEditorSetting ($resource) {
        var resourceUrl =  'manager/' + 'api/diy-editor-settings/:path/:id';
        return $resource(resourceUrl, {}, {
            'getOne4Platform': {
                method: 'GET',
                params: {
                    path: 'getOne4Platform'
                }
            },
            'byCondition1': {
                method: 'POST',
                params: {
                    path: 'byCondition1'
                }
            },
            "getAllByCondition1":{
                method:"POST",
                params:{
                    path:"getAllByCondition1"
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' },
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            },
            'enable':{
                method: 'GET',
                params: {
                    path: 'enable'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('DiyEditorSettingController', DiyEditorSettingController);

    DiyEditorSettingController.$inject = ['$scope', '$q', '$state', 'DiyEditorSetting', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius', 'Principal', '$uibModal'];

    function DiyEditorSettingController ($scope, $q, $state, DiyEditorSetting, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius, Principal, $uibModal) {
        var vm = this;
        // Principal.hasAuthority('ROLE_STORE_DIANPU').then(function (data) {
        //     if (!data) {
        //         MessageService.error("不好意思，你不具有访问权限！");
        //         $state.go("home");
        //     }
        // });

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.multilingual = multilingual;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.tabFlag =1;
        vm.isSort = false;

        vm.jump = jump

        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            $scope.domain = 'http://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        $scope.delete = function(item){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                DiyEditorSetting.delete({id: item.id},function () {
                    loadAll();
                });
            },function(){},true);
        };

        function loadAll () {
            if (pagingParams.search) {
                DiyEditorSetting.byCondition({
                    items: [{key:"theme",op:"=",value:pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DiyEditorSetting.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.items = res.data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                MessageService.error("编辑器获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.deleteBatch = function () {
            MessageService.confirm("entity.action.deleteConfirm",function(){
                DialogConfig.deleteBatch({ids: $scope.batchArr},function () {
                    MessageService.success("删除成功");
                    $scope.selectOne = false;
                    $scope.selectAll = false;
                    loadAll();
                },function () {
                    MessageService.error("删除失败");
                })
            },function(){},true);

        }


        $scope.createEditor = function () {
            $uibModal.open({
                templateUrl: 'app/entities/diyEditorSetting/diy-editor-setting-create.html',
                controller: 'DiyEditorSettingCreateController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            state: 'add'
                        };
                    }]
                }
            }).result.then(function(item) {
                if(item){
                    loadAll()
                }
            });
        }

        function multilingual(setting){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:setting.diyEditorSettingLanguages,
                            key: 'name',
                            fieldValue: setting.name,
                            fieldName: 'DIY编辑器名称'
                        };
                    }]
                }
            }).result.then(function(data) {
                if (data) {
                    setting.diyEditorSettingLanguages = data
                }
                DiyEditorSetting.save(setting,function (){
                    MessageService.success("保存成功");
                    loadAll()
                },function (){
                    MessageService.error("保存失败");
                });
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('UserAnalysisController', UserAnalysisController);

    UserAnalysisController.$inject = ['$scope', '$state', 'MessageService', 'WechatUserAnalysis', 'DateUtils', 'XlsxService'];

    function UserAnalysisController($scope, $state, MessageService, WechatUserAnalysis, DateUtils, XlsxService) {
        var vm = this;
        vm.openCalendar = openCalendar; 
        vm.changeTime = changeTime;
        vm.changeTopType = changeTopType; 
        vm.begin_date = null;
        vm.end_date = null; 
        vm.pageType = 0;  
        var ref_date_datas = [];
        var cancel_user_datas = [];
        var cumulate_user_datas = [];
        var new_user_datas = []; 
        vm.downLoadFile = downLoadFile;
        vm.sheetName = "新关注人数";
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false; 
        vm.times = {
            time1: {
                key: 1,
                value: '最近7日'
            },
            time2: {
                key: 2,
                value: '最近15日'
            },
            time3: {
                key: 3,
                value: '最近30日'
            }
        };
        vm.time = vm.times.time1; 

        function downLoadFile(){
            var dates = []; 
            if (vm.pageType == 0) { 
                for (var i = ref_date_datas.length - 1; i >= 0; i--) {
                    dates.push({
                        "日期":ref_date_datas[i],
                        "人数":new_user_datas[i] 
                    }) 
                };  
            }else if (vm.pageType == 1) { 
                for (var i = ref_date_datas.length - 1; i >= 0; i--) {
                    dates.push({
                        "日期":ref_date_datas[i],
                        "人数":cancel_user_datas[i] 
                    }) 
                }; 
            }else if (vm.pageType == 2) { 
                for (var i = ref_date_datas.length - 1; i >= 0; i--) {
                    dates.push({
                        "日期":ref_date_datas[i],
                        "人数":cumulate_user_datas[i] 
                    }) 
                };  
            };
            XlsxService.xlsxOut(dates, vm.sheetName , "用户分析");
            
        }

        $scope.searchDate = function(){ 
            if (((new Date()) - vm.endTime)/1000/3600/24 < 1) {
                MessageService.error("结束时间最早只能选择昨天");
                return;
            };
            if (vm.endTime - vm.startTime<0) {
                MessageService.error("开始时间不能晚于结束时间");
                return;
            };
            if ((vm.endTime-vm.startTime)/1000/3600/24>30) {
                MessageService.error("查询时间不能超过31天");
                return; 
            };
            vm.begin_date = DateUtils.convertLocalDateToServer(vm.startTime);
            vm.end_date =  DateUtils.convertLocalDateToServer(vm.endTime); 
            WechatUserAnalysis.getUserSummaryDate({begin_date: vm.begin_date, end_date:vm.end_date}, function (data) { 
                if (data && data.list ) { 
                    ref_date_datas = [];
                    cancel_user_datas = [];
                    cumulate_user_datas = [];
                    new_user_datas = [];

                    for (var i = 0; i< data.list.length ; i++) {
                        var d = data.list[i]; 
                        ref_date_datas.push(d.ref_date);
                        cancel_user_datas.push(d.cancel_user);
                        cumulate_user_datas.push(d.cumulate_user);
                        new_user_datas.push(d.new_user);
                    };
                    if (vm.pageType == 0) {
                        vm.sheetName = "新关注人数";
                        echarts_init(ref_date_datas, vm.sheetName, new_user_datas);
                    }else if (vm.pageType == 1) {
                        vm.sheetName = "取消关注人数";
                        echarts_init(ref_date_datas, vm.sheetName, cancel_user_datas);
                    }else if (vm.pageType == 2) {
                        vm.sheetName = "累积关注人数";
                        echarts_init(ref_date_datas, vm.sheetName, cumulate_user_datas);
                    };
                };
            },function(){
                MessageService.error("服务器异常，请稍后重试");
            });
        } 

        function initData() {
            // 昨日的订单数和销售额
            WechatUserAnalysis.getYesterdayDate({}, function(data) {
                if (data && data.list && data.list.length > 0) {
                    vm.yesterday = data.list[0];
                };
            });
            //初始的时候  最近七日
            vm.endTime= new Date();
            vm.startTime = new Date(); 
            vm.endTime.setDate(vm.endTime.getDate() - 1); 
            vm.startTime.setDate(vm.startTime.getDate() - 7);   
            $scope.searchDate();
        } 

        function changeTopType(num) {
            //选择显示数据
            vm.pageType = num;  
            if (vm.pageType == 0) {
                vm.sheetName = "新关注人数";
                echarts_init(ref_date_datas, vm.sheetName, new_user_datas);
            }else if (vm.pageType == 1) {
                vm.sheetName = "取消关注人数";
                echarts_init(ref_date_datas, vm.sheetName, cancel_user_datas);
            }else if (vm.pageType == 2) {
                vm.sheetName = "累积关注人数";
                echarts_init(ref_date_datas, vm.sheetName, cumulate_user_datas);
            };
        }  
        
        // 画图部分
        function echarts_init(ref_dates, name, datas) {
            var myChart = echarts.init(document.getElementById("main-userAnalysis"));
            // 指定图表的配置项和数据
            var option = {
                xAxis: {
                    type: 'category',
                    data: ref_dates,

                },
                yAxis: {
                    minInterval : 1,
                    type: 'value'
                },
                tooltip: {
                        trigger: 'axis'
                    },
                series: [{ 
                    name: name,
                    data: datas,
                    type: 'line',
                    areaStyle: {normal: {}},
                }]
            }; 
            // 使用刚指定的配置项和数据显示图表。  
            myChart.setOption(option);
        }

        // 选择时间下拉框
        function changeTime() {
            vm.endTime= new Date();
            vm.startTime = new Date(); 
            vm.endTime.setDate(vm.endTime.getDate() - 1); 
            if (vm.time.key == 1) {
                vm.startTime.setDate(vm.startTime.getDate() - 7); 
            } else if (vm.time.key == 2) { 
                vm.startTime.setDate(vm.startTime.getDate() - 15); 
            } else if (vm.time.key == 3) { 
                vm.startTime.setDate(vm.startTime.getDate() - 30); 
            }  
            $scope.searchDate();
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        // 初始化页面数据
        initData();
    }
})();
(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SalesAnalysisController', SalesAnalysisController);

    SalesAnalysisController.$inject = ['$scope', '$state', 'ParseLinks', 'MessageService', 'Da', 'SalesOrder', 'XlsxService'];

    function SalesAnalysisController ($scope, $state, ParseLinks, MessageService, Da, SalesOrder, XlsxService) {
        var vm = this;
        vm.openCalendar = openCalendar;
        vm.changeType = changeType;
        vm.changeTime = changeTime;
        vm.changeTopType = changeTopType;
        vm.fondByTime = fondByTime;
        vm.downLoadFile = downLoadFile;

        // 当前日期
        var today = new Date();
        today.setDate(today.getDate() - 1);
        var afterDay = today.getFullYear() + "-" + ((today.getMonth() + 1) > 9 ? (today.getMonth() + 1) : "0" + (today.getMonth() + 1)) + "-" + today.getDate();

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;

        // 初始化页面数据
        initData();
        function initData() {
            // 昨日的订单数和销售额
            SalesOrder.getOrderNumAndSalesNum({}, function (data) {
                if (data.message == null) {
                    vm.orderSize = 0;
                    vm.salesMoney = 0.0;
                } else {
                    var str = data.message.split(",");
                    vm.orderSize = str[0];
                    vm.salesMoney = str[1];
                }
            });
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.pageType = 0;
        function changeTopType(num) {
            vm.pageType = num;
            changeTime();
        }

        //获得区间内所有日期  
        function getMonthBetween(start, end){  
            var result = [];  
            var s = start.split("-");  
            var e = end.split("-");  
            var min = new Date();  
            var max = new Date();  
            min.setFullYear(s[0],s[1]);  
            max.setFullYear(e[0],e[1]);  
              
            var curr = min;  
            while(curr <= max){  
                var month = curr.getMonth();
                if (month == 0) {
                    result.push((curr.getFullYear() - 1) + "-12");
                } else {
                    result.push(curr.getFullYear() + "-" + (month < 10 ? ("0"+month) : month));  
                }
                curr.setMonth(month + 1);  
            }  
            return result;  
        }

        // 时间部分默认数据
        vm.dataType = 'day';
        vm.times = {time1 : {key: 1, value: '最近7日'}, time2 : {key: 2, value: '最近15日'}, time3 : {key: 3, value: '最近30日'}};
        vm.time = vm.times.time1;
        function seriesData(startTime, endTime) {
            if (endTime == '' || endTime == null) {
                endTime = vm.endTime;
            }
            if (vm.dataType == 'quarter') {
                // 季度
                var td = new Date();
                if (vm.timeKey == 1) {
                    startTime = td.getFullYear() + '-01-01';
                    endTime = td.getFullYear() + '-03-31';
                } else if (vm.timeKey == 2) {
                    startTime = td.getFullYear() + '-04-01';
                    endTime = td.getFullYear() + '-06-30';
                } else if (vm.timeKey == 3) {
                    startTime = td.getFullYear() + '-07-01';
                    endTime = td.getFullYear() + '-09-30';
                } else if (vm.timeKey == 4) {
                    startTime = td.getFullYear() + '-10-01';
                    endTime = td.getFullYear() + '-12-30';
                }
                vm.startTime = startTime;
                vm.endTime = endTime;
            }
            
            var bd = new Date(startTime),be = new Date(vm.endTime);
            var bd_time = bd.getTime(), be_time = be.getTime(),time_diff = be_time - bd_time;  
            vm.date_arr = [];
            if (vm.dataType == 'day') {
                for (var i = 0; i <= time_diff; i += 86400000) {  
                        var ds = new Date (bd_time + i);

                        vm.date_arr.push(ds.getFullYear() + "-" + ((ds.getMonth() + 1) > 9 ? (ds.getMonth() + 1) : "0"+(ds.getMonth() + 1)) + '-' 
                            + (ds.getDate() > 9 ? ds.getDate() : "0" + ds.getDate()))  
                }
            } else if (vm.dataType == 'month' || vm.dataType == 'quarter') {
                    vm.date_arr = getMonthBetween(startTime, endTime);
                    if (vm.dataType == 'quarter') {
                        var endTime0 = new Date();
                        endTime0 = new Date(endTime0.setDate(endTime0.getDate() - 1));
                        vm.startTime = startTime;
                        vm.endTime = endTime;
                    }
                }

            vm.datas = [];
            if (vm.pageType == 0) {
                // 获取订单数ju
                SalesOrder.getOrderNums({
                    startTime: startTime,
                    endTime: vm.endTime,
                    type: vm.dataType
                }, function (data) {
                    if (data.message != null) {
                        vm.datas = data.message.data;
                        echarts_init(vm.date_arr, vm.datas);
                    }
                });
            } else if (vm.pageType == 1) {
                // 获取销售额数据
                SalesOrder.getSalesNums({
                    startTime: startTime,
                    endTime: vm.endTime,
                    type: vm.dataType
                }, function (data) {
                    vm.datas = data.message.data;
                    echarts_init(vm.date_arr, vm.datas);
                });
            }
        }

        // 画图部分
        function echarts_init(date_arr, datas) {
            var myChart = echarts.init(document.getElementById("main"));
                // 指定图表的配置项和数据
                var option = {
                    xAxis: {
                        type: 'category',
                        data: date_arr
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: datas,
                        type: 'line',
                        lineStyle:{
                            normal: {
                                color: '#ff6c5f'
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: '#ff6c5f'
                            }
                        },
                    }]
                };

                // 使用刚指定的配置项和数据显示图表。  
                myChart.setOption(option);
        }

        // 时间部分选择联动处理
        changeType('day');
        function changeType (type) {
            vm.dataType = type;

            if (type == 'month') {
                vm.times = {
                    time1 : {key: 1, value: '3个月'},
                    time2 : {key: 2, value: '6个月'},
                    time3 : {key: 3, value: '9个月'},
                    time4 : {key: 4, value: '12个月'}
                };
                vm.time = vm.times.time1;

            } else if (type == 'day') {
                vm.times = {
                    time1 : {key: 1, value: '最近7日'},
                    time2 : {key: 2, value: '最近15日'},
                    time3 : {key: 3, value: '最近30日'}
                };
                vm.time = vm.times.time1;
            } else if (type == 'quarter') {
                vm.times = {
                    time1 : {key: 1, value: '第一季度'},
                    time2 : {key: 2, value: '第二季度'},
                    time3 : {key: 3, value: '第三季度'},
                    time4 : {key: 4, value: '第四季度'}
                };
                vm.time = vm.times.time1;
            }
            changeTime();
        }

        // 选择时间下拉框
        function changeTime () {
            /** 日统计情况：需要计算开始和结束的时间
                月统计情况：需要计算开始和结束的月份
                季度统计下：不要计算开始和结束的时间，但是要传是第几季度 **/

            // 今天
            var today = new Date();
            // 结束时间
            var endTime = "";
            // 开始时间
            var startTime = new Date();
            // 上个月底
            var td = new Date();
            td = new Date(td.setDate(1));
            var lastMonth = new Date(td.setDate(td.getDate() - 1));

            // 解释为什么要加10天，因为每个月总会差别2~4天 ，就索性加10天
            if (vm.time.key == 1) {
                if (vm.dataType == 'month') {
                    // 最近三个月，上个月月底为结束时间，往前推三个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 3));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    startTime.setDate(new Date().getDate() - 7);
                } else if (vm.dataType == 'quarter') {
                    // 第一季度： 当年的季度
                    vm.timeKey = 1;
                }
            } else if (vm.time.key == 2) {
                if (vm.dataType == 'month') {
                    // 最近六个月，上个月月底为结束时间，往前推六个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 6));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    startTime.setDate(new Date().getDate() - 15);
                } else if (vm.dataType == 'quarter') {
                    // 第二季度： 当年的季度
                    vm.timeKey = 2;
                }
            } else if (vm.time.key == 3) {
                if (vm.dataType == 'month') {
                    // 最近九个月，上个月月底为结束时间，往前推九个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 9));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    startTime.setDate(new Date().getDate() - 30);
                } else if (vm.dataType == 'quarter') {
                    // 第三季度： 当年的季度
                    vm.timeKey = 3;
                }
            } else if (vm.time.key == 4) {
                if (vm.dataType == 'month') {
                    // 最近十二个月，上个月月底为结束时间，往前推十二个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 12));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    // 不存在
                } else if (vm.dataType == 'quarter') {
                    // 第四季度： 当年的季度
                    vm.timeKey = 4;
                }
            }
            if (vm.dataType != 'month') {
                // 日统计的结束时间是年月日---季统计的最后时间也显示为昨天
                endTime = today;
                endTime = new Date(endTime.setDate(endTime.getDate() - 1));
            } else {
                endTime = lastMonth;
            }
            vm.endTime = endTime;
            endTime = lastMonth.getFullYear() + "-" + ((lastMonth.getMonth() + 1) > 9 ? (lastMonth.getMonth() + 1) : "0" + 
                (lastMonth.getMonth() + 1)) + "-" + lastMonth.getDate();

            vm.startTime = startTime;
            startTime = startTime.getFullYear() + "-" + ((startTime.getMonth() + 1) > 9 ? (startTime.getMonth() + 1) : "0" + (startTime.getMonth() + 1)) 
                        + "-" + (startTime.getDate() > 9 ? startTime.getDate() : ("0" + startTime.getDate()));

            seriesData(startTime, endTime);
        }

        // 点击查询
        function fondByTime () {
            if (vm.startTime == '' || vm.startTime == undefined || vm.startTime == null) {
                MessageService.error('请选择开始日期');
                return;
            }
            if (vm.endTime == '' || vm.endTime == undefined || vm.endTime == null) {
                MessageService.error('请选择结束日期');
                return;
            }

            // 时间区间判断
            // 日统计最长时间周期31天；月统计时间周期不超过24个月；季统计时间周期不超过8季度
            if (vm.dataType == 'month') {
                var date3 = vm.endTime.getMonth() - vm.startTime.getMonth();
                if (date3 > 24) {
                    MessageService.error("月统计时间周期不超过24个月");
                    return;
                }
            } else if (vm.dataType == 'day') {
                var date3 = vm.endTime.getTime() - vm.startTime.getTime();
                var days = Math.floor(date3 / (24 * 3600 * 1000));
                if (days >= 31) {
                    MessageService.error("日统计最长时间周期31天");
                    return;
                }
            } else if (vm.dataType == 'quarter') {
                var date3 = vm.endTime.getMonth() - vm.startTime.getMonth();
                if (date3 > 24) {
                    MessageService.error("季统计时间周期不超过8季度");
                    return;
                }
            }

            var startTime = vm.startTime;
            var endTime = new Date(vm.endTime);
            startTime = startTime.getFullYear() + "-" + ((startTime.getMonth() + 1) > 9 ? (startTime.getMonth() + 1) : "0" + (startTime.getMonth() + 1)) 
                        + "-" + (startTime.getDate() > 9 ? startTime.getDate() : ("0" + startTime.getDate()));
            if (endTime == null) {
                endTime = new Date(vm.endTime);
            }
            if (endTime != '' && endTime != null) {
                endTime = endTime.getFullYear() + "-" + ((endTime.getMonth() + 1) > 9 ? (endTime.getMonth() + 1) : "0" + (endTime.getMonth() + 1)) + "-" + endTime.getDate();
            }
            seriesData(startTime, endTime);
        }

        // 下载文件
        function downLoadFile() {
            var tabData = [];
            var sheetName = '';
            if (vm.pageType == 0) {
                sheetName = "订单数";
            } else {
                sheetName = "销售额";
            }

            for (var i = 0; i < vm.date_arr.length; i++) {
                tabData.push({"日期": vm.date_arr[i], "数量": vm.datas[i]});
            }
            XlsxService.xlsxOut(tabData, sheetName, "销售分析");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dataAnalysis', {
            parent: 'entity',
            url: '/da',
            data: {
                authorities: ['ROLE_STATISTICS'],
                pageTitle: 'global.menu.entities.da'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/da/da.html',
                    controller: 'DaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sendRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('salesAnalysis', {
            parent: 'entity',
            url: '/salesAnalysis',
            data: {
                authorities: ['ROLE_STATISTICS'],
                pageTitle: 'global.menu.entities.da'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/da/salesAnalysis.html',
                    controller: 'SalesAnalysisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sendRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('userAnalysis', {
            parent: 'entity',
            url: '/userAnalysis',
            data: {
                authorities: ['ROLE_STATISTICS'],
                pageTitle: 'global.menu.entities.da'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/da/userAnalysis.html',
                    controller: 'UserAnalysisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {  
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('WechatUserAnalysis', WechatUserAnalysis)
        .factory('Da', Da);

    Da.$inject = ['$resource', 'DateUtils'];

    WechatUserAnalysis.$inject = ['$resource', 'DateUtils'];

    function WechatUserAnalysis($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/store-wechat-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'getYesterdayDate': {
                method: 'GET',
                params: {
                    path: 'getYesterdayDate'
                }
            },
            'getUserSummaryDate': {
                method: 'GET',
                params: {
                    path: 'getUserSummaryDate'
                }
            }
        })
    }

    function Da($resource, DateUtils) {
        var resourceUrl = 'service/' + 'api/sales-orders/:path/:id';

        return $resource(resourceUrl, {}, {
            'getData4Chart': {
                method: 'GET',
                params: {
                    path: 'getData4Chart'
                }
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('DaController', DaController);

    DaController.$inject = ['$scope', '$state', 'ParseLinks', 'MessageService', 'Da', 'XlsxService'];

    function DaController ($scope, $state, ParseLinks, MessageService, Da, XlsxService) {
        var vm = this;
        vm.openCalendar = openCalendar;
        vm.changeType = changeType;
        vm.changeTime = changeTime;
        vm.downLoadFile = downLoadFile;
        vm.fondByTime = fondByTime;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        //获得区间内所有日期  
        function getMonthBetween(start, end){  
            var result = [];  
            var s = start.split("-");  
            var e = end.split("-");  
            var min = new Date();  
            var max = new Date();  
            min.setFullYear(s[0],s[1]);  
            max.setFullYear(e[0],e[1]);  
              
            var curr = min;  
            while(curr <= max){  
                var month = curr.getMonth();  
                if (month == 0) {
                    result.push((curr.getFullYear() - 1) + "-12");
                } else {
                    result.push(curr.getFullYear() + "-" + (month < 10 ? ("0"+month) : month));  
                }
                curr.setMonth(month+1);  
            }  
            return result;  
        } 

        // 时间部分默认数据
        vm.dataType = 'day';
        vm.times = {time1 : {key: 1, value: '最近7日'}, time2 : {key: 2, value: '最近15日'}, time3 : {key: 3, value: '最近30日'}};
        vm.time = vm.times.time1;
        function seriesData(startTime, endTime) {
            vm.res = [];
            if (vm.dataType == 'quarter') {
                // 季度
                var td = new Date();
                if (vm.timeKey == 1) {
                    startTime = td.getFullYear() + '-01-01';
                    endTime = td.getFullYear() + '-03-31';
                } else if (vm.timeKey == 2) {
                    startTime = td.getFullYear() + '-04-01';
                    endTime = td.getFullYear() + '-06-30';
                } else if (vm.timeKey == 3) {
                    startTime = td.getFullYear() + '-07-01';
                    endTime = td.getFullYear() + '-09-30';
                } else if (vm.timeKey == 4) {
                    startTime = td.getFullYear() + '-10-01';
                    endTime = td.getFullYear() + '-12-30';
                }
                vm.startTime = startTime;
                vm.endTime = endTime;
            }
            Da.getData4Chart({
                startTime: vm.startTime,
                endTime: vm.endTime,
                type: vm.dataType,
                timeKey: vm.timeKey
            }, function (data) {
                vm.res = [];
                vm.res = data.data;
                // 处理类型
                var legendData = [];
                if (vm.res.length > 0) {
                    for (var i = 0; i < vm.res.length; i++) {
                        legendData.push(vm.res[i].name);
                    }
                }

                // 日期段内所有日期的处理
                var bd = new Date(startTime),be = new Date(vm.endTime);  
                var bd_time = bd.getTime(), be_time = be.getTime(),time_diff = be_time - bd_time;  
                vm.date_arr = [];
                if (vm.dataType == 'day') {
                    for (var i = 0; i <= time_diff; i += 86400000) {  
                            var ds = new Date (bd_time + i);  
                            vm.date_arr.push(ds.getFullYear() + "-" + ((ds.getMonth() + 1) > 9 ? (ds.getMonth() + 1) : "0"+(ds.getMonth() + 1)) + '-' 
                                + (ds.getDate() > 9 ? ds.getDate() : "0" + ds.getDate()))  
                    }
                } else if (vm.dataType == 'month' || vm.dataType == 'quarter') {
                    vm.date_arr = getMonthBetween(startTime, endTime);
                    if (vm.dataType == 'quarter') {
                        var endTime0 = new Date();
                        endTime0 = new Date(endTime0.setDate(endTime0.getDate() - 1));
                        vm.startTime = startTime;
                        vm.endTime = endTime;
                    }
                }

                var myChart = echarts.init(document.getElementById("main-da"));
                myChart.clear();    // 清空图表，防止缓存
                // 指定图表的配置项和数据
                var option = {
                    title: {
                        text: "",
                        textStyle: {
                            color: "#436EEE",
                            fontSize: 17
                        }
                    },
                    //鼠标触发提示数量
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        data: legendData,
                        left: '150px',
                        top: '20px'
                    },
                    //x轴显示   时间--格式：["2017-01-01", "2017-01-02", "2017-01-03", "2017-01-04"]
                    xAxis: {
                        data: vm.date_arr,
                        splitLine: {
                        　　show: false
                        }
                    },
                    //y轴显示
                    yAxis: {
                        splitLine:{
                        　　show:false
                        }
                    },
                    series: vm.res 
                };  

                // 使用刚指定的配置项和数据显示图表。  
                myChart.setOption(option);
            }, function (error) {
                MessageService.error("服务器异常，请稍后重试");
            });
        }        

        // 刷新图表
        function refreshData(){
            var myChart = echarts.init(document.getElementById("main-da"));
            if(!myChart){
                return;
            }
            var option = myChart.getOption();
            option.series = "";
            myChart.setOption(option);    
        }

        // 时间部分选择联动处理
        changeType('day');
        function changeType (type) {
            vm.dataType = type;
            if (type == 'month') {
                vm.times = {
                    time1 : {key: 1, value: '3个月'},
                    time2 : {key: 2, value: '6个月'},
                    time3 : {key: 3, value: '9个月'},
                    time4 : {key: 4, value: '12个月'}
                };
                vm.time = vm.times.time1;

            } else if (type == 'day') {
                vm.times = {
                    time1 : {key: 1, value: '最近7日'},
                    time2 : {key: 2, value: '最近15日'},
                    time3 : {key: 3, value: '最近30日'}
                };
                vm.time = vm.times.time1;
            } else if (type == 'quarter') {
                vm.times = {
                    time1 : {key: 1, value: '第一季度'},
                    time2 : {key: 2, value: '第二季度'},
                    time3 : {key: 3, value: '第三季度'},
                    time4 : {key: 4, value: '第四季度'}
                };
                vm.time = vm.times.time1;
            }
            changeTime();
        }

        // 选择时间下拉框
        function changeTime () {
            /** 日统计情况：需要计算开始和结束的时间
                月统计情况：需要计算开始和结束的月份
                季度统计下：不要计算开始和结束的时间，但是要传是第几季度 **/

            // 今天
            var today = new Date();
            // 结束时间
            var endTime = "";
            // 开始时间
            var startTime = new Date();
            // 上个月底
            var td = new Date();
            td = new Date(td.setDate(1));
            var lastMonth = new Date(td.setDate(td.getDate() - 1));

            // 解释为什么要加10天，因为每个月总会差别2~4天 ，就索性加10天
            if (vm.time.key == 1) {
                if (vm.dataType == 'month') {
                    // 最近三个月，上个月月底为结束时间，往前推三个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 3));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    startTime.setDate(new Date().getDate() - 7);
                } else if (vm.dataType == 'quarter') {
                    // 第一季度： 当年的季度
                    vm.timeKey = 1;
                }
            } else if (vm.time.key == 2) {
                if (vm.dataType == 'month') {
                    // 最近六个月，上个月月底为结束时间，往前推六个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 6));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    startTime.setDate(new Date().getDate() - 15);
                } else if (vm.dataType == 'quarter') {
                    // 第二季度： 当年的季度
                    vm.timeKey = 2;
                }
            } else if (vm.time.key == 3) {
                if (vm.dataType == 'month') {
                    // 最近九个月，上个月月底为结束时间，往前推九个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 9));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    startTime.setDate(new Date().getDate() - 30);
                } else if (vm.dataType == 'quarter') {
                    // 第三季度： 当年的季度
                    vm.timeKey = 3;
                }
            } else if (vm.time.key == 4) {
                if (vm.dataType == 'month') {
                    // 最近十二个月，上个月月底为结束时间，往前推十二个月
                    startTime = new Date(startTime.setMonth(lastMonth.getMonth() - 12));
                    startTime = new Date(startTime.setDate(lastMonth.getDate() + 10));
                } else if (vm.dataType == 'day') {
                    // 不存在
                } else if (vm.dataType == 'quarter') {
                    // 第四季度： 当年的季度
                    vm.timeKey = 4;
                }
            }
            if (vm.dataType != 'month') {
                // 日统计的结束时间是年月日---季统计的最后时间也显示为昨天
                endTime = today;
                endTime = new Date(endTime.setDate(endTime.getDate() - 1));
            } else {
                endTime = lastMonth;
            }
            vm.endTime = endTime;
            endTime = lastMonth.getFullYear() + "-" + ((lastMonth.getMonth() + 1) > 9 ? (lastMonth.getMonth() + 1) : "0" + 
                (lastMonth.getMonth() + 1)) + "-" + lastMonth.getDate();

            vm.startTime = startTime;
            startTime = startTime.getFullYear() + "-" + ((startTime.getMonth() + 1) > 9 ? (startTime.getMonth() + 1) : "0" + (startTime.getMonth() + 1)) 
                        + "-" + (startTime.getDate() > 9 ? startTime.getDate() : ("0" + startTime.getDate()));

            seriesData(startTime, endTime);
        }

        function fondByTime() {
            if (vm.dataType == 'quarter') {
                return;
            }
            if (vm.startTime == '' || vm.startTime == undefined || vm.startTime == null) {
                MessageService.error('请选择开始日期');
                return;
            }
            if (vm.endTime == '' || vm.endTime == undefined || vm.endTime == null) {
                MessageService.error('请选择结束日期');
                return;
            }

            // 时间区间判断
            // 日统计最长时间周期31天；月统计时间周期不超过24个月；季统计时间周期不超过8季度
            if (vm.dataType == 'month') {
                var date3 = vm.endTime.getMonth() - vm.startTime.getMonth();
                if (date3 > 24) {
                    MessageService.error("月统计时间周期不超过24个月");
                    return;
                }
            } else if (vm.dataType == 'day') {
                var date3 = vm.endTime.getTime() - vm.startTime.getTime();
                var days = Math.floor(date3 / (24 * 3600 * 1000));
                if (days >= 31) {
                    MessageService.error("日统计最长时间周期31天");
                    return;
                }
            } else if (vm.dataType == 'quarter') {
                var date3 = vm.endTime.getMonth() - vm.startTime.getMonth();
                if (date3 > 24) {
                    MessageService.error("季统计时间周期不超过8季度");
                    return;
                }
            }

            var startTime = vm.startTime;
            var endTime = new Date(vm.endTime);
            startTime = startTime.getFullYear() + "-" + ((startTime.getMonth() + 1) > 9 ? (startTime.getMonth() + 1) : "0" + (startTime.getMonth() + 1)) 
                        + "-" + (startTime.getDate() > 9 ? startTime.getDate() : ("0" + startTime.getDate()));
            if (endTime == null) {
                endTime = new Date(vm.endTime);
            }
            if (endTime != '' && endTime != null) {
                endTime = endTime.getFullYear() + "-" + ((endTime.getMonth() + 1) > 9 ? (endTime.getMonth() + 1) : "0" + (endTime.getMonth() + 1)) + "-" + endTime.getDate();
            }
            if (vm.dataType == 'month') {
                startTime = startTime.substr(0, startTime.length - 3);
                endTime = endTime.substr(0, endTime.length - 3);
            }
            seriesData(startTime, endTime);
        }

        // 下载文件
        function downLoadFile() {
            var tabData = [];
            var sheetName = '分类分析';
            for (var i = 0; i < vm.date_arr.length; i ++) {
                var jsonObj = {"日期": vm.date_arr[i]};
                for (var j = 0; j < vm.res.length; j ++) {
                    jsonObj[vm.res[j].name] = vm.res[j].data[i];
                }
                tabData.push(jsonObj);
            }
            XlsxService.xlsxOut(tabData, sheetName, "分类分析");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer', {
            parent: 'entity',
            url: '/customer?page&sort&search',
            data: {
                authorities: ['ROLE_CUSTOMER'],
                pageTitle: 'backApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customers.html',
                    controller: 'CustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        vip: '0'
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-detail', {
            parent: 'entity',
            url: '/customer/{id}',
            data: {
                authorities: ['ROLE_CUSTOMER'],
                pageTitle: 'backApp.customer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-detail.html',
                    controller: 'CustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Customer', function($stateParams, Customer) {
                    return Customer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
         
        .state('customer.new', {
            parent: 'customer',
            url: '/new',
            data: {
                authorities: ['ROLE_CUSTOMER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                openId: null,
                                name: null,
                                sex: null,
                                langKey: null,
                                headImgUrl: null,
                                lastLogin: null,
                                cancelled: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: 'customer' });
                }, function() {
                    $state.go('customer');
                });
            }]
        })
        .state('customer.edit', {
            parent: 'customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_CUSTOMER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: 'customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'DateUtils'];

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/customers/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            "todayNum":{
                method:"GET",
                params:{
                    path:"todayNum"
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['$scope', '$state', 'Customer', 'ParseLinks', 'MessageService', 'paginationConstants', 'pagingParams'];

    function CustomerController ($scope, $state, Customer, ParseLinks, MessageService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.vip = pagingParams.vip;

        console.log(vm.vip);

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                Customer.byCondition({
                    items:[{key:"name",op:"like",value:pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Customer.byCondition({
                    items:[],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.customers = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("客户获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            loadPage(vm.jumpText<=0?1:vm.jumpText);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('creditExtension', {
                parent: 'entity',
                url: '/creditExtension?page&sort&search&startTime&endTime',
                data: {
                    authorities: ["ROLE_PROPERTY"],
                    pageTitle: 'global.menu.entities.commoditySpecification'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/creditExtension/creditExtension.html',
                        controller: 'CreditExtensionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    endTime: null,
                    startTime: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            endTime: $stateParams.endTime,
                            startTime: $stateParams.startTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('backApp')
        .factory('CreditRecords', CreditRecords);

    CreditRecords.$inject = ['$resource'];

    function CreditRecords($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/credit-records/:path/:id';

        return $resource(resourceUrl, {}, {
            'save': {
                method: 'POST'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                }
            },
            "delete": {
                method: "DELETE"
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('CreditExtensionController', CreditExtensionController);

    CreditExtensionController.$inject = ['$scope', '$state', 'CreditRecords', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Store','DateUtils','$localStorage'];

    function CreditExtensionController ($scope, $state, CreditRecords, ParseLinks, paginationConstants, pagingParams, MessageService, Store,DateUtils,$localStorage) {
        var vm = this;
        vm.search = search;
        vm.transition = transition;
        vm.datePickerOpenStatus = {};
        vm.openCalendar =  openCalendar;
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.startTime = pagingParams.startTime ? new Date(pagingParams.startTime):null;
        vm.endTime = pagingParams.endTime? new Date(pagingParams.endTime):null;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        vm.tableData = {
            page:1,
            size:20
        }
        init();
        function init() {
            var _items = [{"key":"storeId", op:"=", value:$localStorage.user.storeId}];
            if (vm.endTime != null) {
                _items.push({"key":"createdDate", op:"<=", value:DateUtils.convertLocalDateToServer(vm.endTime)});
            }
            if (vm.startTime != null) {
                _items.push({"key":"createdDate", op:">=", value:DateUtils.convertLocalDateToServer(vm.startTime)});
            }
            CreditRecords.byCondition({
                items:_items,
                page: vm.tableData.page-1,
                size: vm.tableData.size,
                sort: ["id,desc"]
            },function (res,headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.creditData = res.data;
                }else {
                    MessageService.error(res.message);
                }
            })
        }

        function search() {
            vm.transition();
        }
        function transition() {
           $state.transitionTo($state.$current, {
                page: vm.page,
                startTime: vm.startTime?DateUtils.convertLocalDateToServer(vm.startTime):"",
                endTime: vm.endTime?DateUtils.convertLocalDateToServer(vm.endTime):""

            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('consumption', {
            parent: 'pay-orderNew',
            url: '/consumption?page&sort&startTime&endTime&classType',
            data: {
                authorities: ["ROLE_BILLING_DETAIL"],
                pageTitle: 'global.menu.entities.consumptionList'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/consumption/consumption.html',
                    controller: 'ConsumptionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,
                startTime: null,
                endTime: null,
                classType: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        startTime: $stateParams.startTime,
                        endTime: $stateParams.endTime,
                        classType: $stateParams.classType,
                        
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productPurchase');
                     $translatePartialLoader.addPart('purchaseStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Consumption', Consumption);

    Consumption.$inject = ['$resource'];

    function Consumption ($resource) {
        var resourceUrl =  'manager/' + 'api/consumption-lists/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'getPriceByProductAndStore': {
                method: 'GET',
                params: {
                    path: 'getPriceByProductAndStore'
                }
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ConsumptionController', ConsumptionController);

    ConsumptionController.$inject = ['$state', 'Consumption', 'ParseLinks',  'paginationConstants', 'pagingParams', 'MessageService', '$scope', 'DateUtils'];

    function ConsumptionController($state, Consumption, ParseLinks,   paginationConstants, pagingParams, MessageService, $scope, DateUtils) {
        var vm = this;
        vm.data={};
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search; 
        vm.data.classType = pagingParams.classType;
        vm.data.startTime = pagingParams.startTime ? new Date(pagingParams.startTime):null;
        vm.data.endTime = pagingParams.endTime? new Date(pagingParams.endTime):null;
        vm.transition = transition;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.type = type;
        vm.openCalendar = openCalendar;
        vm.search = search;
        vm.clear = clear;

        vm.datePickerOpenStatus = {
            startTime: false,
            endTime: false
        };
        vm.mannerList = [
            {name: '订单流量',id:'SALESORDER'},
            {name: '购买模板',id:'PRODUCTXMLLINE'},
        ];

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        loadAll();
        function loadAll () {
            var items = [];
            if(vm.data.startTime){
                items.push({key:"classDate",op:">=",value:new Date(Date.parse(vm.data.startTime) -8 * 60 * 60 * 1000)})
            }
            if(vm.data.endTime){
                items.push({key:"classDate",op:"<=",value:new Date(Date.parse(vm.data.endTime) + 16 * 60 * 60 * 1000 - 1000)});
            }
            if(vm.data.classType){
                items.push({key:"classType",op:"=",value:vm.data.classType})
            }else{
                items.push({key:"classType",op:"in",value:'SALESORDER;PRODUCTXMLLINE'})
            }
            if(vm.data.searchQuery){
                items.push({key:"classNumber",op:"like",value:vm.data.searchQuery})
            }

            Consumption.byCondition({
                items: items,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status==200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.consumption = res.data;
                }else{
                    MessageService.error(res.message)
                }

            }
            function onError(error) {
                MessageService.error("数据获取失败");
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.data.currentSearch,
                startTime: vm.data.startTime?DateUtils.convertLocalDateToServer(vm.data.startTime):"",
                endTime: vm.data.endTime?DateUtils.convertLocalDateToServer(vm.data.endTime):"",
                classType: vm.data.classType,

            });
        }
        function search (searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
            // loadAll()
        }

        function clear() {
            vm.data = {
                startTime: '',
                endTime: '',
                classType: '',
                searchQuery: ''
            }
            loadAll()
        }

        function type(target) {
            switch (target) {
                case "SALESORDER":
                    return "订单流量";
                case "PRODUCTXMLLINE":
                    return "购买模板";
                default:
                    return "";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ConfigurationDialogController', ConfigurationDialogController);

    ConfigurationDialogController.$inject = ['$scope', '$q', '$state', 'ECommerceSetting','Store','MessageService', 'entity'];

    function ConfigurationDialogController ($scope, $q, $state, ECommerceSetting,Store,MessageService, entity) {
        var vm = this;
        vm.data = entity.data;
        $scope.save = function () {
            ECommerceSetting.edit(vm.data,function (res) {
                if(res.status == 200){
                    MessageService.success("修改成功");
                    $state.go("configuration2");
                }else {
                    MessageService.error(resp.message);
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('configuration2', {
                parent: 'entity',
                url: '/configuration2',
                data: {
                    authorities: ["ROLE_STORE"],
                    pageTitle: 'global.menu.entities.configuration'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/configuration/configuration.html',
                        controller: 'ConfigurationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('configuration2.new', {
                parent: 'configuration2',
                url: '/add',
                data: {
                    authorities: ["ROLE_STORE"],
                    pageTitle: 'global.menu.entities.configuration'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/configuration/configuration-dialog.html',
                        controller: 'ConfigurationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            data:{
                                appId: null,
                                appSecret: null,
                                domain:null,
                                combinationNotifyUrl: "/api/sales-orders/combinationNotify",
                                articleStatusNotifyUrl:"/api/articles/updateStatus",
                                wechatInfoUrl:"/api/wechat-settings/getOne",
                                enable:true,
                                id: null
                            }
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('configuration2-dialog', {
                parent: 'configuration2',
                url: '/{id}/edit',
                data: {
                    authorities: ["ROLE_STORE"],
                    pageTitle: 'global.menu.entities.configuration'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/configuration/configuration-dialog.html',
                        controller: 'ConfigurationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: { 
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['ECommerceSetting', '$stateParams', function(ECommerceSetting, $stateParams) {
                        return ECommerceSetting.get({
                            id: $stateParams.id
                        }).$promise;
                    }]
                }
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('backApp')
        .factory('ECommerceSetting', ECommerceSetting);

    ECommerceSetting.$inject = ['$resource'];

    function ECommerceSetting($resource) {
        var resourceUrl = 'manager/' + 'api/e-commerce-settings/:path/:id';
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST'
            },
            'edit': {
                method: 'PUT'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            "getECommerceSettingByStoreId": {
                method: "GET",
                params: {
                    path: "getECommerceSettingByStoreId"
                }
            },
            "getECommerceSettingByAppId": {
                method: "GET",
                params: {
                    path: "getECommerceSettingByAppId"
                }
            },
        });
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ConfigurationController', ConfigurationController);

    ConfigurationController.$inject = ['$scope', '$q', '$state', 'ECommerceSetting','Store','MessageService'];

    function ConfigurationController ($scope, $q, $state, ECommerceSetting,Store,MessageService) {
        var vm = this;
        Store.getCurrent({}, function (res) {
            if(res.status == 200){
                vm.store = res.data;
                ECommerceSetting.getECommerceSettingByStoreId({storeId:vm.store.id},function (resp) {
                    if(resp.status == 200){
                        vm.data = resp.data;
                    }else {
                        MessageService.error(resp.message);
                    }
                });
            }else {
                MessageService.error(res.message);
            }
        });
    }
})();

(function () {
    'use strict';

    var SelectMultipleControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/select-multiple.html',
        controllerAs: 'vm',
        bindings: {
            options: '<', //下拉选项数据
            model: '=', //选中的数据
            multiple: '<', //是否多选
            key: '<',
            value: '<',
        },

        controller: ['$scope','MessageService',
            function ($scope,MessageService) {
            var vm = this;
            $scope.checked = function (item) {
                if(vm.multiple){
                    if(vm.model && vm.model.length>0){
                        for(var j=0; j<vm.model.length; j++){
                            var _model = vm.model[j];
                            if(item[vm.key] == _model[vm.key]){
                                return true
                            }
                        }
                    }
                }else{
                    if(item[vm.key] == vm.model[vm.key]){
                        return true
                    }
                }
                return false
            }
            $scope.optionSave = function (item) {
                var _index = -1;
                if(vm.model && vm.model.length>0 && vm.multiple){
                    for(var j=0; j<vm.model.length; j++){
                        var _model = vm.model[j];
                        if(item[vm.key] == _model[vm.key]){
                            _index = j;
                            break
                        }
                    }
                }
                if(_index>-1){
                    if(vm.multiple){
                        vm.model.splice(_index, 1);
                    }else{
                        vm.model=null;
                    }
                }else{
                    if(vm.multiple){
                        vm.model.push(item);
                    }else{
                        vm.model = item;
                    }
                }
            }
        }]
    };

    angular.module('backApp')
    	.component('selectMultiple', SelectMultipleControl);

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ClipArtDialogController', ClipArtDialogController);

    ClipArtDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'ClipArt', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', 'Convert'];

    function ClipArtDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, ClipArt, MessageService,
        Upload, UidService, ThemeClassify, Convert) {
        var vm = this;

        vm.clipArt = entity.data;
        vm.clear = clear;
        vm.save = save;
        vm.token = "";
        vm.attachments =[];
        vm.imgs =[];
        vm.keys =[];
        vm.themeClassifies = ThemeClassify.getAllByCondition({items:[]});
        vm.domains = Qinius.getDomain();
        $q.all([vm.themeClassifies.$promise,vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.validate = function(){

            if(vm.clipArt.themeClassifyId == null || vm.clipArt.themeClassifyId==""){
                MessageService.error("请选择模板分类");
                return false;
            }
            if(vm.clipArt.id == null && vm.attachments.length ==0){
                MessageService.error("请上传素材");
                return false;
            }
            return true;
        };

        function save () {
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if (vm.clipArt.type == null || vm.clipArt.type == "" ) {
                vm.clipArt.type = "wechat";
            }
            vm.clipArt.provider = "qiniu";
            vm.clipArt.keys = vm.keys;
            if (vm.clipArt.id != null) {
               ClipArt.update(vm.clipArt, onSaveSuccess, onSaveError);
            } else {
                ClipArt.batchCreate(vm.clipArt, onSaveSuccess, onSaveError);
            }
        };

        function onSaveSuccess (result) {
            if(result.status == 200){
                MessageService.success("素材保存成功");
                $scope.$emit('editorApp:productUpdate', result.data);
                $uibModalInstance.close(result.data);
                vm.isSaving = false;
            }else {
                MessageService.error(result.message);
                vm.isSaving = false;
                return
            }
        };

        function onSaveError () {
            MessageService.error("素材保存失败");
            vm.isSaving = false;
        };

        //模板背景图更改
        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            // Convert.imageFormat({key:data.key},function(value){
                            //     vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            //     vm.keys.push(data.key);
                            // },function(data){

                            // })
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        };
        //remove背景图
        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            console.log(vm.attachments);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ClipArtDetailController', ClipArtDetailController);

    ClipArtDetailController.$inject = ['$scope', '$rootScope', '$q', '$stateParams', '$uibModalInstance', 'entity', 'Qinius'];

    function ClipArtDetailController($scope, $rootScope, $q, $stateParams, $uibModalInstance, entity, Qinius) {
        var vm = this;
        vm.clipArt = entity.data;

        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        vm.clear = clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('platformApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clipArt', {
            parent: 'entity',
            url: '/clipArt?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'backApp.title.masking'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clip-art/clip-art.html',
                    controller: 'ClipArtController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('clipArt.detail', {
            parent: 'clipArt',
            url: '/clipArt/{id}',
            data: {
                authorities: ["ROLE_CLIPART"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clip-art/clip-art-detail.html',
                    controller: 'ClipArtDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('clipArt');
                            return $translate.refresh();
                        }],
                        entity: ['ClipArt', function(ClipArt) {
                            return ClipArt.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('clipArt', {}, {
                        reload: false
                    });
                }, function() {
                    $state.go('clipArt');
                });
            }]
        })
        .state('clipArt.new', {
            parent: 'clipArt',
            url: '/new',
            data: {
                authorities: ["ROLE_CLIPART"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clip-art/clip-art-dialog.html',
                    controller: 'ClipArtDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {name: null, identifier: null, cancelled: null, provider: null, id: null,type:null};
                        }
                    }
                }).result.then(function() {
                    $state.go('clipArt', null, { reload: 'clipArt' });
                }, function() {
                    $state.go('clipArt');
                });
            }]
        })
        .state('clipArt.edit', {
            parent: 'clipArt',
            url: '/edit/{id}',
            data: {
                authorities: ["ROLE_CLIPART"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clip-art/clip-art-dialog.html',
                    controller: 'ClipArtDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('clipArt');
                            return $translate.refresh();
                        }],
                        entity: ['ClipArt', function(ClipArt) {
                            return ClipArt.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('clipArt', null, { reload: 'clipArt' });
                }, function() {
                    $state.go('clipArt');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('ClipArt', ClipArt);

    ClipArt.$inject = ['$resource', 'DateUtils'];

    function ClipArt($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/clipArt/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "updateType": {
                method: "GET",
                params: {
                    path: "updateType"
                }
            },
            'get': {
                method: 'GET',
                params: {
                    path: 'getone'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                params: {
                    path: 'update'
                },
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.startTime = DateUtils.convertLocalDateToServer(copy.startTime);
                    copy.endTime = DateUtils.convertLocalDateToServer(copy.endTime);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                params: {
                    path: 'save'
                },
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.startTime = DateUtils.convertLocalDateToServer(copy.startTime);
                    copy.endTime = DateUtils.convertLocalDateToServer(copy.endTime);
                    return angular.toJson(copy);
                }
            },
            'batchCreate':{
                method: 'GET',
                params: {
                    path: 'batchCreate'
                }
            },
            'delete': {
                method: 'DELETE',
                params: {
                    path: 'delete'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ClipArtController', ClipArtController);

    ClipArtController.$inject = ['$scope', '$q', '$state', 'ClipArt', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', 'Qinius'];

    function ClipArtController ($scope, $q, $state, ClipArt, ParseLinks, paginationConstants, pagingParams, MessageService, Qinius) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        // 获取qiniu服务器
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })

        $scope.changeType = function(clipArt){
            if (clipArt == null) {
                return;
            }
            MessageService.confirm("确认要修改该数据的类型？", function(){
                var type = "";
                if (clipArt.type = null || clipArt.type == "" || clipArt.type == "all") {
                    type = "wechat";
                }else{
                    type = "all";
                }
                ClipArt.updateType({id:clipArt.id, type:type},function(res){
                    if(res.status == 200){
                        MessageService.success("类型修改成功");
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                }, function(){
                        MessageService.error("类型修改失败，请稍后再试");
                })
            },function(){})
        }


        $scope.delete = function(id){
            MessageService.confirm("确认删除该素材？",function(){
                ClipArt.delete({id: id},function (res) {
                    if(res.status == 200){
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                    }
                });
            },function(){});
        };

        function loadAll () {
            if (pagingParams.search) {
                ClipArt.byCondition({
                    items: [{key:"name,themeClassify.name",op:"like",value:pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ClipArt.byCondition({
                    items:[],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.clipArts = res.data;
                    vm.page = pagingParams.page;
                }else {
                    MessageService.error(res.message);
                }
            }
            function onError(error) {
                MessageService.error("素材获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('CategoryDialogController', CategoryDialogController);

    CategoryDialogController.$inject = ['$timeout', '$q', '$scope', '$state', 'entity', 'Qinius', 'Category',  'MessageService',
     'UidService', '$uibModal'];

    function CategoryDialogController ($timeout, $q, $scope, $state, entity, Qinius, Category,  MessageService,
     UidService, $uibModal) {
        var vm = this;

        vm.category = entity.data;
        vm.clear = clear;
        vm.save = save;
        vm.title = "编辑";
        if(!vm.category.id){
            vm.title = "新建"
        }

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })
        
        vm.multilingual = multilingual;
        function multilingual(){
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:vm.category.categoryLanguages, 
                            key:"name",
                            fieldValue:vm.category.name,
                            fieldName:"分类名称"
                        };
                    }]
                }
            }).result.then(function(data) {
                if(data){
                    vm.category.categoryLanguages=data;
                }
            });
        }

        //模板背景图更改
        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                    reader.onload = function () {       //  成功读取
                        $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) {     //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', "category-"+ UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.category.imgUrl = data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $state.go('category', null, { reload: 'category' });
        }

        $scope.validate = function(){
            if(vm.category.name == null || vm.category.name==""){
                MessageService.error("请输入分类名称");
                return false;
            }

            if(vm.category.seq == null || vm.category.seq < 0){
                MessageService.error("优先值不能小于零");
                return false;
            }

            if (vm.category.imgUrl == null || vm.category.imgUrl=="") {
                MessageService.error("请上传展示图片");
                return false;
            };
            if(vm.category.usable == null || vm.category.usable==""){
                vm.category.usable = false;
            }
            return true;
        }
        function save () {
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if (vm.category.id !== null) {
                Category.update(vm.category, onSaveSuccess, onSaveError);
            } else {
                Category.categoryStoreCreate(vm.category, onSaveSuccess, onSaveError);
            }
        }


        $scope.removeFile = function(file) {
            vm.category.imgUrl = null;
        }


        function onSaveSuccess (result) {
            if(result.status == 200){
                $scope.$emit('backApp:categoryUpdate', result.data);
                $state.go('category', null, { reload: 'category' });
                vm.isSaving = false;
                MessageService.success("保存成功");
            }else {
                MessageService.error(result.message);
                return
            }
        }

        function onSaveError () {
            MessageService.error("保存失败");
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('CategoryDetailController', CategoryDetailController);

    CategoryDetailController.$inject = ['$scope', '$q', '$rootScope', '$stateParams', 'entity', 'Category','$uibModalInstance', 'Qinius'];

    function CategoryDetailController($scope, $q, $rootScope, $stateParams, entity, Category, $uibModalInstance, Qinius) {
        var vm = this;

        vm.category = entity.data;
        vm.clear = clear;
        vm.domains = Qinius.getDomain();
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('backApp:categoryUpdate', function(event, result) {
            vm.category = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('category', {
                parent: 'entity',
                url: '/category?page&sort&search',
                data: {
                    authorities: ["ROLE_CATEGORY"],
                    pageTitle: 'global.menu.entities.commodityClassification'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/category/categories.html',
                        controller: 'CategoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('category');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('category-detail', {
                parent: 'category',
                url: '/category/{id}',
                data: {
                    authorities: ["ROLE_CATEGORY"]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/category/category-detail.html',
                        controller: 'CategoryDetailController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('category');
                                return $translate.refresh();
                            }],
                            entity: ['Category', function(Category) {
                                return Category.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('category', {}, {
                            reload: false
                        });
                    }, function() {
                        $state.go('category');
                    });
                }]
            })
            .state('category-detail.edit', {
                parent: 'category-detail',
                url: '/detail/edit',
                data: {
                    authorities: ["ROLE_CATEGORY"]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/category/category-dialog.html',
                        controller: 'CategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Category', function(Category) {
                                return Category.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, {
                            reload: false
                        });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('category.new', {
                parent: 'category',
                url: '/new',
                data: {
                    authorities: ["ROLE_CATEGORY"]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/category/category-dialog.html',
                        controller: 'CategoryDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            data:{
                                name: null,
                                number: null,
                                cancelled: null,
                                id: null,
                                usable:null
                            }
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('category');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('category.edit', {
                parent: 'category',
                url: '/{id}/edit',
                data: {
                    authorities: ["ROLE_CATEGORY"]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/category/category-dialog.html',
                        controller: 'CategoryDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('category');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Category','$stateParams', function(Category,$stateParams) {
                        return Category.get({id : $stateParams.id}).$promise;
                    }]
                }
            });

    }

})();

(function () {
    'use strict';
    angular
        .module('backApp')
        .factory('Qinius', Qinius)
        .factory("Convert", Convert)
        .factory('Category', Category);

    Category.$inject = ['$resource'];
    Convert.$inject = ['$resource'];
    Qinius.$inject = ['$resource'];

    function Qinius($resource) {
        var resourceUrl = 'manager/' + 'api/qiniu/:path/:storeId';
        var service = $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'upload-token'
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getDomain': {
                method: 'GET',
                params: {
                    path: 'bucket-domains'
                }
            },
        });
        return service;
    }

    function Convert ($resource) {
        var resourceUrl =  'fileserves/' + 'api/convert/:path/:storeId';

        return $resource(resourceUrl, {}, {
            "xmlToDocument":{
                method:"GET",
                params:{
                    path:"xmlToDocument"
                }
            },
            "imageFormat":{
                method:"GET",
                params:{
                    path:"imageFormat"
                }
            },
            "imgFilter":{
                method: 'GET',
                params: {
                    path: "filter"
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'documentToImg': {
                method: 'POST',
                params: {
                    path: 'documentToImg'
                },
                isArray: true
            },
        });
    }

    function Category($resource) {
        var resourceUrl = 'manager/' + 'api/categories/:store/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "categoryStoreCreate": {
                method: "POST",
                params: {
                    path: "store"
                }
            },
            'storeByCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition',
                    store:"store"
                }
            },
            "storeGetAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition",
                    store:"store"
                }
            },
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('CategoryController', CategoryController);

    CategoryController.$inject = ['$scope', '$q', '$state', 'ParseLinks', 'pagingParams', 'paginationConstants', 'Category','Product', 'MessageService', 'Qinius'];

    function CategoryController ($scope, $q, $state, ParseLinks, pagingParams, paginationConstants, Category,Product, MessageService, Qinius) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;

        vm.domains = Qinius.getDomain();

        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            loadAll();
        })
        function loadAll () {
            if (pagingParams.search) {
                Category.storeByCondition({
                    items: [{key:"name",op:"like",value:pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Category.storeByCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(res, headers) {
                if(res.status == 200){
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.categories = res.data;
                    vm.page = pagingParams.page;
                    console.log(vm.categories);
                }else if(res.status == 404){
                    MessageService.error("分类获取失败");
                    return
                }else {
                    MessageService.error(res.message);
                    return
                }
            }
            function onError(error) {
                MessageService.error("分类获取失败");
            }
        }

        $scope.delete = function(id){
            MessageService.confirm("entity.action.deleteConfirm",function(){
                Category.delete({id: id},function (res) {
                    if(res.status == 200){
                        MessageService.success("删除成功");
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                        return
                    }
                });
            },function(){},true);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText <= 0 ?  1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.batchArr = [];
        $scope.selectOne = false;
        $scope.selectAll = false;

        $scope.chooseAll = function () {
            $scope.selectAll = !$scope.selectAll;
            $scope.batchArr = [];
            angular.forEach(vm.categories,function (category,i) {
                if($scope.selectAll){
                    category.select = true;
                    $scope.batchArr.push(category.id);
                    $scope.selectOne = true;
                }else{
                    category.select = false;
                    $scope.selectOne = false;
                }
            })
        }

        $scope.chooseOne = function (category) {
            category.select = !category.select;
            // 选中
            if(category.select){
                $scope.batchArr.push(category.id);
            }else{
                // 未选中
                var ind = $scope.batchArr.indexOf(category.id);
                if (ind >= 0) {
                    $scope.batchArr.splice(ind, 1);
                }
            }

            // 判断全选按钮
            var flag = true;
            angular.forEach(vm.categories,function (category,i) {
                if(!category.select){
                    $scope.selectAll = false;
                    flag = false;
                }
                // 全部选中
                if(i==vm.categories.length-1&&flag){
                    $scope.selectAll = true;
                }
            })

            // 批量按钮的显示
            if($scope.batchArr.length){
                $scope.selectOne = true;
            }else {
                $scope.selectOne = false;
            }
        }

        $scope.deleteBatch = function () {
            MessageService.confirm("entity.action.deleteConfirm",function(){
                Category.deleteBatch({ids: $scope.batchArr},function (res) {
                    if(res.status == 200){
                        MessageService.success("删除成功");
                        loadAll();
                    }else {
                        MessageService.error(res.message);
                        return
                    }
                },function () {
                    MessageService.error("删除失败");
                })
            },function(){},true);
        }
    }
})();

(function() {
	'use strict';
	angular
		.module('backApp')
		.factory('XlsxService', XlsxService);

	XlsxService.$inject = [];

	function XlsxService() {
		var service = {
			xlsxOut: xlsxOut
		}
		return service;
	}

	function xlsxOut(datas, sheetName, fileName) {

		var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
        var wb = {
			SheetNames: [sheetName],
			Sheets: {},
			Props: {}
		};
		wb.Sheets[sheetName] = XLSX.utils.json_to_sheet(datas); 
		saveAs(new Blob([s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" }), fileName + '.' + (wopts.bookType=="biff2"?"xls":wopts.bookType));
	}

	function s2ab(s) {
        if (typeof ArrayBuffer !== 'undefined') {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        } else {
            var buf = new Array(s.length);
            for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
    }

	 function saveAs(obj, fileName) {//当然可以自定义简单的下载文件实现方式 
            var tmpa = document.createElement("a");
            tmpa.download = fileName || "下载";
            tmpa.href = URL.createObjectURL(obj); //绑定a标签
            tmpa.click(); //模拟点击实现下载
            setTimeout(function () { //延时释放
                URL.revokeObjectURL(obj); //用URL.revokeObjectURL()来释放这个object URL
            }, 100);
        }

})();

(function(){
	'use strict';
	angular
	.module('backApp')
	.factory('UidService',UidService);

	UidService.$inject = [];
	
	function UidService(){
		var service={
			get:get
		}
		return service;
	}
	function get(){
		var d = new Date().getTime();
		var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
		});
		return uid;
	}

})();
(function() {
    'use strict';

    angular
        .module('backApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

/**
 * Swiper 5.4.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 16, 2020
 */

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self).Swiper=t()}(this,(function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(i,s){void 0===i&&(i={}),void 0===s&&(s={}),Object.keys(s).forEach((function(a){void 0===i[a]?i[a]=s[a]:e(s[a])&&e(i[a])&&Object.keys(s[a]).length>0&&t(i[a],s[a])}))}var i="undefined"!=typeof document?document:{},s={body:{},addEventListener:function(){},removeEventListener:function(){},activeElement:{blur:function(){},nodeName:""},querySelector:function(){return null},querySelectorAll:function(){return[]},getElementById:function(){return null},createEvent:function(){return{initEvent:function(){}}},createElement:function(){return{children:[],childNodes:[],style:{},setAttribute:function(){},getElementsByTagName:function(){return[]}}},createElementNS:function(){return{}},importNode:function(){return null},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};t(i,s);var a="undefined"!=typeof window?window:{};t(a,{document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState:function(){},pushState:function(){},go:function(){},back:function(){}},CustomEvent:function(){return this},addEventListener:function(){},removeEventListener:function(){},getComputedStyle:function(){return{getPropertyValue:function(){return""}}},Image:function(){},Date:function(){},screen:{},setTimeout:function(){},clearTimeout:function(){},matchMedia:function(){return{}}});var r=function(e){for(var t=0;t<e.length;t+=1)this[t]=e[t];return this.length=e.length,this};function n(e,t){var s=[],n=0;if(e&&!t&&e instanceof r)return e;if(e)if("string"==typeof e){var o,l,d=e.trim();if(d.indexOf("<")>=0&&d.indexOf(">")>=0){var h="div";for(0===d.indexOf("<li")&&(h="ul"),0===d.indexOf("<tr")&&(h="tbody"),0!==d.indexOf("<td")&&0!==d.indexOf("<th")||(h="tr"),0===d.indexOf("<tbody")&&(h="table"),0===d.indexOf("<option")&&(h="select"),(l=i.createElement(h)).innerHTML=d,n=0;n<l.childNodes.length;n+=1)s.push(l.childNodes[n])}else for(o=t||"#"!==e[0]||e.match(/[ .<>:~]/)?(t||i).querySelectorAll(e.trim()):[i.getElementById(e.trim().split("#")[1])],n=0;n<o.length;n+=1)o[n]&&s.push(o[n])}else if(e.nodeType||e===a||e===i)s.push(e);else if(e.length>0&&e[0].nodeType)for(n=0;n<e.length;n+=1)s.push(e[n]);return new r(s)}function o(e){for(var t=[],i=0;i<e.length;i+=1)-1===t.indexOf(e[i])&&t.push(e[i]);return t}n.fn=r.prototype,n.Class=r,n.Dom7=r;var l={addClass:function(e){if(void 0===e)return this;for(var t=e.split(" "),i=0;i<t.length;i+=1)for(var s=0;s<this.length;s+=1)void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.add(t[i]);return this},removeClass:function(e){for(var t=e.split(" "),i=0;i<t.length;i+=1)for(var s=0;s<this.length;s+=1)void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.remove(t[i]);return this},hasClass:function(e){return!!this[0]&&this[0].classList.contains(e)},toggleClass:function(e){for(var t=e.split(" "),i=0;i<t.length;i+=1)for(var s=0;s<this.length;s+=1)void 0!==this[s]&&void 0!==this[s].classList&&this[s].classList.toggle(t[i]);return this},attr:function(e,t){var i=arguments;if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var s=0;s<this.length;s+=1)if(2===i.length)this[s].setAttribute(e,t);else for(var a in e)this[s][a]=e[a],this[s].setAttribute(a,e[a]);return this},removeAttr:function(e){for(var t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},data:function(e,t){var i;if(void 0!==t){for(var s=0;s<this.length;s+=1)(i=this[s]).dom7ElementDataStorage||(i.dom7ElementDataStorage={}),i.dom7ElementDataStorage[e]=t;return this}if(i=this[0]){if(i.dom7ElementDataStorage&&e in i.dom7ElementDataStorage)return i.dom7ElementDataStorage[e];var a=i.getAttribute("data-"+e);return a||void 0}},transform:function(e){for(var t=0;t<this.length;t+=1){var i=this[t].style;i.webkitTransform=e,i.transform=e}return this},transition:function(e){"string"!=typeof e&&(e+="ms");for(var t=0;t<this.length;t+=1){var i=this[t].style;i.webkitTransitionDuration=e,i.transitionDuration=e}return this},on:function(){for(var e,t=[],i=arguments.length;i--;)t[i]=arguments[i];var s=t[0],a=t[1],r=t[2],o=t[3];function l(e){var t=e.target;if(t){var i=e.target.dom7EventData||[];if(i.indexOf(e)<0&&i.unshift(e),n(t).is(a))r.apply(t,i);else for(var s=n(t).parents(),o=0;o<s.length;o+=1)n(s[o]).is(a)&&r.apply(s[o],i)}}function d(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),r.apply(this,t)}"function"==typeof t[1]&&(s=(e=t)[0],r=e[1],o=e[2],a=void 0),o||(o=!1);for(var h,p=s.split(" "),c=0;c<this.length;c+=1){var u=this[c];if(a)for(h=0;h<p.length;h+=1){var v=p[h];u.dom7LiveListeners||(u.dom7LiveListeners={}),u.dom7LiveListeners[v]||(u.dom7LiveListeners[v]=[]),u.dom7LiveListeners[v].push({listener:r,proxyListener:l}),u.addEventListener(v,l,o)}else for(h=0;h<p.length;h+=1){var f=p[h];u.dom7Listeners||(u.dom7Listeners={}),u.dom7Listeners[f]||(u.dom7Listeners[f]=[]),u.dom7Listeners[f].push({listener:r,proxyListener:d}),u.addEventListener(f,d,o)}}return this},off:function(){for(var e,t=[],i=arguments.length;i--;)t[i]=arguments[i];var s=t[0],a=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(s=(e=t)[0],r=e[1],n=e[2],a=void 0),n||(n=!1);for(var o=s.split(" "),l=0;l<o.length;l+=1)for(var d=o[l],h=0;h<this.length;h+=1){var p=this[h],c=void 0;if(!a&&p.dom7Listeners?c=p.dom7Listeners[d]:a&&p.dom7LiveListeners&&(c=p.dom7LiveListeners[d]),c&&c.length)for(var u=c.length-1;u>=0;u-=1){var v=c[u];r&&v.listener===r||r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1)):r||(p.removeEventListener(d,v.proxyListener,n),c.splice(u,1))}}return this},trigger:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];for(var s=e[0].split(" "),r=e[1],n=0;n<s.length;n+=1)for(var o=s[n],l=0;l<this.length;l+=1){var d=this[l],h=void 0;try{h=new a.CustomEvent(o,{detail:r,bubbles:!0,cancelable:!0})}catch(e){(h=i.createEvent("Event")).initEvent(o,!0,!0),h.detail=r}d.dom7EventData=e.filter((function(e,t){return t>0})),d.dispatchEvent(h),d.dom7EventData=[],delete d.dom7EventData}return this},transitionEnd:function(e){var t,i=["webkitTransitionEnd","transitionend"],s=this;function a(r){if(r.target===this)for(e.call(this,r),t=0;t<i.length;t+=1)s.off(i[t],a)}if(e)for(t=0;t<i.length;t+=1)s.on(i[t],a);return this},outerWidth:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},offset:function(){if(this.length>0){var e=this[0],t=e.getBoundingClientRect(),s=i.body,r=e.clientTop||s.clientTop||0,n=e.clientLeft||s.clientLeft||0,o=e===a?a.scrollY:e.scrollTop,l=e===a?a.scrollX:e.scrollLeft;return{top:t.top+o-r,left:t.left+l-n}}return null},css:function(e,t){var i;if(1===arguments.length){if("string"!=typeof e){for(i=0;i<this.length;i+=1)for(var s in e)this[i].style[s]=e[s];return this}if(this[0])return a.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(i=0;i<this.length;i+=1)this[i].style[e]=t;return this}return this},each:function(e){if(!e)return this;for(var t=0;t<this.length;t+=1)if(!1===e.call(this[t],t,this[t]))return this;return this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:void 0;for(var t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){var t,s,o=this[0];if(!o||void 0===e)return!1;if("string"==typeof e){if(o.matches)return o.matches(e);if(o.webkitMatchesSelector)return o.webkitMatchesSelector(e);if(o.msMatchesSelector)return o.msMatchesSelector(e);for(t=n(e),s=0;s<t.length;s+=1)if(t[s]===o)return!0;return!1}if(e===i)return o===i;if(e===a)return o===a;if(e.nodeType||e instanceof r){for(t=e.nodeType?[e]:e,s=0;s<t.length;s+=1)if(t[s]===o)return!0;return!1}return!1},index:function(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;var t,i=this.length;return new r(e>i-1?[]:e<0?(t=i+e)<0?[]:[this[t]]:[this[e]])},append:function(){for(var e,t=[],s=arguments.length;s--;)t[s]=arguments[s];for(var a=0;a<t.length;a+=1){e=t[a];for(var n=0;n<this.length;n+=1)if("string"==typeof e){var o=i.createElement("div");for(o.innerHTML=e;o.firstChild;)this[n].appendChild(o.firstChild)}else if(e instanceof r)for(var l=0;l<e.length;l+=1)this[n].appendChild(e[l]);else this[n].appendChild(e)}return this},prepend:function(e){var t,s;for(t=0;t<this.length;t+=1)if("string"==typeof e){var a=i.createElement("div");for(a.innerHTML=e,s=a.childNodes.length-1;s>=0;s-=1)this[t].insertBefore(a.childNodes[s],this[t].childNodes[0])}else if(e instanceof r)for(s=0;s<e.length;s+=1)this[t].insertBefore(e[s],this[t].childNodes[0]);else this[t].insertBefore(e,this[t].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&n(this[0].nextElementSibling).is(e)?new r([this[0].nextElementSibling]):new r([]):this[0].nextElementSibling?new r([this[0].nextElementSibling]):new r([]):new r([])},nextAll:function(e){var t=[],i=this[0];if(!i)return new r([]);for(;i.nextElementSibling;){var s=i.nextElementSibling;e?n(s).is(e)&&t.push(s):t.push(s),i=s}return new r(t)},prev:function(e){if(this.length>0){var t=this[0];return e?t.previousElementSibling&&n(t.previousElementSibling).is(e)?new r([t.previousElementSibling]):new r([]):t.previousElementSibling?new r([t.previousElementSibling]):new r([])}return new r([])},prevAll:function(e){var t=[],i=this[0];if(!i)return new r([]);for(;i.previousElementSibling;){var s=i.previousElementSibling;e?n(s).is(e)&&t.push(s):t.push(s),i=s}return new r(t)},parent:function(e){for(var t=[],i=0;i<this.length;i+=1)null!==this[i].parentNode&&(e?n(this[i].parentNode).is(e)&&t.push(this[i].parentNode):t.push(this[i].parentNode));return n(o(t))},parents:function(e){for(var t=[],i=0;i<this.length;i+=1)for(var s=this[i].parentNode;s;)e?n(s).is(e)&&t.push(s):t.push(s),s=s.parentNode;return n(o(t))},closest:function(e){var t=this;return void 0===e?new r([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){for(var t=[],i=0;i<this.length;i+=1)for(var s=this[i].querySelectorAll(e),a=0;a<s.length;a+=1)t.push(s[a]);return new r(t)},children:function(e){for(var t=[],i=0;i<this.length;i+=1)for(var s=this[i].childNodes,a=0;a<s.length;a+=1)e?1===s[a].nodeType&&n(s[a]).is(e)&&t.push(s[a]):1===s[a].nodeType&&t.push(s[a]);return new r(o(t))},filter:function(e){for(var t=[],i=0;i<this.length;i+=1)e.call(this[i],i,this[i])&&t.push(this[i]);return new r(t)},remove:function(){for(var e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this},add:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var i,s,a=this;for(i=0;i<e.length;i+=1){var r=n(e[i]);for(s=0;s<r.length;s+=1)a[a.length]=r[s],a.length+=1}return a},styles:function(){return this[0]?a.getComputedStyle(this[0],null):{}}};Object.keys(l).forEach((function(e){n.fn[e]=n.fn[e]||l[e]}));var d={deleteProps:function(e){var t=e;Object.keys(t).forEach((function(e){try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))},nextTick:function(e,t){return void 0===t&&(t=0),setTimeout(e,t)},now:function(){return Date.now()},getTranslate:function(e,t){var i,s,r;void 0===t&&(t="x");var n=a.getComputedStyle(e,null);return a.WebKitCSSMatrix?((s=n.transform||n.webkitTransform).split(",").length>6&&(s=s.split(", ").map((function(e){return e.replace(",",".")})).join(", ")),r=new a.WebKitCSSMatrix("none"===s?"":s)):i=(r=n.MozTransform||n.OTransform||n.MsTransform||n.msTransform||n.transform||n.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===t&&(s=a.WebKitCSSMatrix?r.m41:16===i.length?parseFloat(i[12]):parseFloat(i[4])),"y"===t&&(s=a.WebKitCSSMatrix?r.m42:16===i.length?parseFloat(i[13]):parseFloat(i[5])),s||0},parseUrlQuery:function(e){var t,i,s,r,n={},o=e||a.location.href;if("string"==typeof o&&o.length)for(r=(i=(o=o.indexOf("?")>-1?o.replace(/\S*\?/,""):"").split("&").filter((function(e){return""!==e}))).length,t=0;t<r;t+=1)s=i[t].replace(/#\S+/g,"").split("="),n[decodeURIComponent(s[0])]=void 0===s[1]?void 0:decodeURIComponent(s[1])||"";return n},isObject:function(e){return"object"==typeof e&&null!==e&&e.constructor&&e.constructor===Object},extend:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];for(var i=Object(e[0]),s=1;s<e.length;s+=1){var a=e[s];if(null!=a)for(var r=Object.keys(Object(a)),n=0,o=r.length;n<o;n+=1){var l=r[n],h=Object.getOwnPropertyDescriptor(a,l);void 0!==h&&h.enumerable&&(d.isObject(i[l])&&d.isObject(a[l])?d.extend(i[l],a[l]):!d.isObject(i[l])&&d.isObject(a[l])?(i[l]={},d.extend(i[l],a[l])):i[l]=a[l])}}return i}},h={touch:!!("ontouchstart"in a||a.DocumentTouch&&i instanceof a.DocumentTouch),pointerEvents:!!a.PointerEvent&&"maxTouchPoints"in a.navigator&&a.navigator.maxTouchPoints>=0,observer:"MutationObserver"in a||"WebkitMutationObserver"in a,passiveListener:function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});a.addEventListener("testPassiveListener",null,t)}catch(e){}return e}(),gestures:"ongesturestart"in a},p=function(e){void 0===e&&(e={});var t=this;t.params=e,t.eventsListeners={},t.params&&t.params.on&&Object.keys(t.params.on).forEach((function(e){t.on(e,t.params.on[e])}))},c={components:{configurable:!0}};p.prototype.on=function(e,t,i){var s=this;if("function"!=typeof t)return s;var a=i?"unshift":"push";return e.split(" ").forEach((function(e){s.eventsListeners[e]||(s.eventsListeners[e]=[]),s.eventsListeners[e][a](t)})),s},p.prototype.once=function(e,t,i){var s=this;if("function"!=typeof t)return s;function a(){for(var i=[],r=arguments.length;r--;)i[r]=arguments[r];s.off(e,a),a.f7proxy&&delete a.f7proxy,t.apply(s,i)}return a.f7proxy=t,s.on(e,a,i)},p.prototype.off=function(e,t){var i=this;return i.eventsListeners?(e.split(" ").forEach((function(e){void 0===t?i.eventsListeners[e]=[]:i.eventsListeners[e]&&i.eventsListeners[e].length&&i.eventsListeners[e].forEach((function(s,a){(s===t||s.f7proxy&&s.f7proxy===t)&&i.eventsListeners[e].splice(a,1)}))})),i):i},p.prototype.emit=function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var i,s,a,r=this;if(!r.eventsListeners)return r;"string"==typeof e[0]||Array.isArray(e[0])?(i=e[0],s=e.slice(1,e.length),a=r):(i=e[0].events,s=e[0].data,a=e[0].context||r);var n=Array.isArray(i)?i:i.split(" ");return n.forEach((function(e){if(r.eventsListeners&&r.eventsListeners[e]){var t=[];r.eventsListeners[e].forEach((function(e){t.push(e)})),t.forEach((function(e){e.apply(a,s)}))}})),r},p.prototype.useModulesParams=function(e){var t=this;t.modules&&Object.keys(t.modules).forEach((function(i){var s=t.modules[i];s.params&&d.extend(e,s.params)}))},p.prototype.useModules=function(e){void 0===e&&(e={});var t=this;t.modules&&Object.keys(t.modules).forEach((function(i){var s=t.modules[i],a=e[i]||{};s.instance&&Object.keys(s.instance).forEach((function(e){var i=s.instance[e];t[e]="function"==typeof i?i.bind(t):i})),s.on&&t.on&&Object.keys(s.on).forEach((function(e){t.on(e,s.on[e])})),s.create&&s.create.bind(t)(a)}))},c.components.set=function(e){this.use&&this.use(e)},p.installModule=function(e){for(var t=[],i=arguments.length-1;i-- >0;)t[i]=arguments[i+1];var s=this;s.prototype.modules||(s.prototype.modules={});var a=e.name||Object.keys(s.prototype.modules).length+"_"+d.now();return s.prototype.modules[a]=e,e.proto&&Object.keys(e.proto).forEach((function(t){s.prototype[t]=e.proto[t]})),e.static&&Object.keys(e.static).forEach((function(t){s[t]=e.static[t]})),e.install&&e.install.apply(s,t),s},p.use=function(e){for(var t=[],i=arguments.length-1;i-- >0;)t[i]=arguments[i+1];var s=this;return Array.isArray(e)?(e.forEach((function(e){return s.installModule(e)})),s):s.installModule.apply(s,[e].concat(t))},Object.defineProperties(p,c);var u={updateSize:function(){var e,t,i=this.$el;e=void 0!==this.params.width?this.params.width:i[0].clientWidth,t=void 0!==this.params.height?this.params.height:i[0].clientHeight,0===e&&this.isHorizontal()||0===t&&this.isVertical()||(e=e-parseInt(i.css("padding-left"),10)-parseInt(i.css("padding-right"),10),t=t-parseInt(i.css("padding-top"),10)-parseInt(i.css("padding-bottom"),10),d.extend(this,{width:e,height:t,size:this.isHorizontal()?e:t}))},updateSlides:function(){var e=this.params,t=this.$wrapperEl,i=this.size,s=this.rtlTranslate,r=this.wrongRTL,n=this.virtual&&e.virtual.enabled,o=n?this.virtual.slides.length:this.slides.length,l=t.children("."+this.params.slideClass),h=n?this.virtual.slides.length:l.length,p=[],c=[],u=[];function v(t){return!e.cssMode||t!==l.length-1}var f=e.slidesOffsetBefore;"function"==typeof f&&(f=e.slidesOffsetBefore.call(this));var m=e.slidesOffsetAfter;"function"==typeof m&&(m=e.slidesOffsetAfter.call(this));var g=this.snapGrid.length,b=this.snapGrid.length,w=e.spaceBetween,y=-f,x=0,E=0;if(void 0!==i){var T,S;"string"==typeof w&&w.indexOf("%")>=0&&(w=parseFloat(w.replace("%",""))/100*i),this.virtualSize=-w,s?l.css({marginLeft:"",marginTop:""}):l.css({marginRight:"",marginBottom:""}),e.slidesPerColumn>1&&(T=Math.floor(h/e.slidesPerColumn)===h/this.params.slidesPerColumn?h:Math.ceil(h/e.slidesPerColumn)*e.slidesPerColumn,"auto"!==e.slidesPerView&&"row"===e.slidesPerColumnFill&&(T=Math.max(T,e.slidesPerView*e.slidesPerColumn)));for(var C,M=e.slidesPerColumn,P=T/M,z=Math.floor(h/e.slidesPerColumn),k=0;k<h;k+=1){S=0;var $=l.eq(k);if(e.slidesPerColumn>1){var L=void 0,I=void 0,D=void 0;if("row"===e.slidesPerColumnFill&&e.slidesPerGroup>1){var O=Math.floor(k/(e.slidesPerGroup*e.slidesPerColumn)),A=k-e.slidesPerColumn*e.slidesPerGroup*O,G=0===O?e.slidesPerGroup:Math.min(Math.ceil((h-O*M*e.slidesPerGroup)/M),e.slidesPerGroup);L=(I=A-(D=Math.floor(A/G))*G+O*e.slidesPerGroup)+D*T/M,$.css({"-webkit-box-ordinal-group":L,"-moz-box-ordinal-group":L,"-ms-flex-order":L,"-webkit-order":L,order:L})}else"column"===e.slidesPerColumnFill?(D=k-(I=Math.floor(k/M))*M,(I>z||I===z&&D===M-1)&&(D+=1)>=M&&(D=0,I+=1)):I=k-(D=Math.floor(k/P))*P;$.css("margin-"+(this.isHorizontal()?"top":"left"),0!==D&&e.spaceBetween&&e.spaceBetween+"px")}if("none"!==$.css("display")){if("auto"===e.slidesPerView){var H=a.getComputedStyle($[0],null),B=$[0].style.transform,N=$[0].style.webkitTransform;if(B&&($[0].style.transform="none"),N&&($[0].style.webkitTransform="none"),e.roundLengths)S=this.isHorizontal()?$.outerWidth(!0):$.outerHeight(!0);else if(this.isHorizontal()){var X=parseFloat(H.getPropertyValue("width")),V=parseFloat(H.getPropertyValue("padding-left")),Y=parseFloat(H.getPropertyValue("padding-right")),F=parseFloat(H.getPropertyValue("margin-left")),W=parseFloat(H.getPropertyValue("margin-right")),R=H.getPropertyValue("box-sizing");S=R&&"border-box"===R?X+F+W:X+V+Y+F+W}else{var q=parseFloat(H.getPropertyValue("height")),j=parseFloat(H.getPropertyValue("padding-top")),K=parseFloat(H.getPropertyValue("padding-bottom")),U=parseFloat(H.getPropertyValue("margin-top")),_=parseFloat(H.getPropertyValue("margin-bottom")),Z=H.getPropertyValue("box-sizing");S=Z&&"border-box"===Z?q+U+_:q+j+K+U+_}B&&($[0].style.transform=B),N&&($[0].style.webkitTransform=N),e.roundLengths&&(S=Math.floor(S))}else S=(i-(e.slidesPerView-1)*w)/e.slidesPerView,e.roundLengths&&(S=Math.floor(S)),l[k]&&(this.isHorizontal()?l[k].style.width=S+"px":l[k].style.height=S+"px");l[k]&&(l[k].swiperSlideSize=S),u.push(S),e.centeredSlides?(y=y+S/2+x/2+w,0===x&&0!==k&&(y=y-i/2-w),0===k&&(y=y-i/2-w),Math.abs(y)<.001&&(y=0),e.roundLengths&&(y=Math.floor(y)),E%e.slidesPerGroup==0&&p.push(y),c.push(y)):(e.roundLengths&&(y=Math.floor(y)),(E-Math.min(this.params.slidesPerGroupSkip,E))%this.params.slidesPerGroup==0&&p.push(y),c.push(y),y=y+S+w),this.virtualSize+=S+w,x=S,E+=1}}if(this.virtualSize=Math.max(this.virtualSize,i)+m,s&&r&&("slide"===e.effect||"coverflow"===e.effect)&&t.css({width:this.virtualSize+e.spaceBetween+"px"}),e.setWrapperSize&&(this.isHorizontal()?t.css({width:this.virtualSize+e.spaceBetween+"px"}):t.css({height:this.virtualSize+e.spaceBetween+"px"})),e.slidesPerColumn>1&&(this.virtualSize=(S+e.spaceBetween)*T,this.virtualSize=Math.ceil(this.virtualSize/e.slidesPerColumn)-e.spaceBetween,this.isHorizontal()?t.css({width:this.virtualSize+e.spaceBetween+"px"}):t.css({height:this.virtualSize+e.spaceBetween+"px"}),e.centeredSlides)){C=[];for(var Q=0;Q<p.length;Q+=1){var J=p[Q];e.roundLengths&&(J=Math.floor(J)),p[Q]<this.virtualSize+p[0]&&C.push(J)}p=C}if(!e.centeredSlides){C=[];for(var ee=0;ee<p.length;ee+=1){var te=p[ee];e.roundLengths&&(te=Math.floor(te)),p[ee]<=this.virtualSize-i&&C.push(te)}p=C,Math.floor(this.virtualSize-i)-Math.floor(p[p.length-1])>1&&p.push(this.virtualSize-i)}if(0===p.length&&(p=[0]),0!==e.spaceBetween&&(this.isHorizontal()?s?l.filter(v).css({marginLeft:w+"px"}):l.filter(v).css({marginRight:w+"px"}):l.filter(v).css({marginBottom:w+"px"})),e.centeredSlides&&e.centeredSlidesBounds){var ie=0;u.forEach((function(t){ie+=t+(e.spaceBetween?e.spaceBetween:0)}));var se=(ie-=e.spaceBetween)-i;p=p.map((function(e){return e<0?-f:e>se?se+m:e}))}if(e.centerInsufficientSlides){var ae=0;if(u.forEach((function(t){ae+=t+(e.spaceBetween?e.spaceBetween:0)})),(ae-=e.spaceBetween)<i){var re=(i-ae)/2;p.forEach((function(e,t){p[t]=e-re})),c.forEach((function(e,t){c[t]=e+re}))}}d.extend(this,{slides:l,snapGrid:p,slidesGrid:c,slidesSizesGrid:u}),h!==o&&this.emit("slidesLengthChange"),p.length!==g&&(this.params.watchOverflow&&this.checkOverflow(),this.emit("snapGridLengthChange")),c.length!==b&&this.emit("slidesGridLengthChange"),(e.watchSlidesProgress||e.watchSlidesVisibility)&&this.updateSlidesOffset()}},updateAutoHeight:function(e){var t,i=[],s=0;if("number"==typeof e?this.setTransition(e):!0===e&&this.setTransition(this.params.speed),"auto"!==this.params.slidesPerView&&this.params.slidesPerView>1)if(this.params.centeredSlides)this.visibleSlides.each((function(e,t){i.push(t)}));else for(t=0;t<Math.ceil(this.params.slidesPerView);t+=1){var a=this.activeIndex+t;if(a>this.slides.length)break;i.push(this.slides.eq(a)[0])}else i.push(this.slides.eq(this.activeIndex)[0]);for(t=0;t<i.length;t+=1)if(void 0!==i[t]){var r=i[t].offsetHeight;s=r>s?r:s}s&&this.$wrapperEl.css("height",s+"px")},updateSlidesOffset:function(){for(var e=this.slides,t=0;t<e.length;t+=1)e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);var t=this.params,i=this.slides,s=this.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&this.updateSlidesOffset();var a=-e;s&&(a=e),i.removeClass(t.slideVisibleClass),this.visibleSlidesIndexes=[],this.visibleSlides=[];for(var r=0;r<i.length;r+=1){var o=i[r],l=(a+(t.centeredSlides?this.minTranslate():0)-o.swiperSlideOffset)/(o.swiperSlideSize+t.spaceBetween);if(t.watchSlidesVisibility||t.centeredSlides&&t.autoHeight){var d=-(a-o.swiperSlideOffset),h=d+this.slidesSizesGrid[r];(d>=0&&d<this.size-1||h>1&&h<=this.size||d<=0&&h>=this.size)&&(this.visibleSlides.push(o),this.visibleSlidesIndexes.push(r),i.eq(r).addClass(t.slideVisibleClass))}o.progress=s?-l:l}this.visibleSlides=n(this.visibleSlides)}},updateProgress:function(e){if(void 0===e){var t=this.rtlTranslate?-1:1;e=this&&this.translate&&this.translate*t||0}var i=this.params,s=this.maxTranslate()-this.minTranslate(),a=this.progress,r=this.isBeginning,n=this.isEnd,o=r,l=n;0===s?(a=0,r=!0,n=!0):(r=(a=(e-this.minTranslate())/s)<=0,n=a>=1),d.extend(this,{progress:a,isBeginning:r,isEnd:n}),(i.watchSlidesProgress||i.watchSlidesVisibility||i.centeredSlides&&i.autoHeight)&&this.updateSlidesProgress(e),r&&!o&&this.emit("reachBeginning toEdge"),n&&!l&&this.emit("reachEnd toEdge"),(o&&!r||l&&!n)&&this.emit("fromEdge"),this.emit("progress",a)},updateSlidesClasses:function(){var e,t=this.slides,i=this.params,s=this.$wrapperEl,a=this.activeIndex,r=this.realIndex,n=this.virtual&&i.virtual.enabled;t.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=n?this.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+a+'"]'):t.eq(a)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+r+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+r+'"]').addClass(i.slideDuplicateActiveClass));var o=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===o.length&&(o=t.eq(0)).addClass(i.slideNextClass);var l=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===l.length&&(l=t.eq(-1)).addClass(i.slidePrevClass),i.loop&&(o.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),l.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+l.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass))},updateActiveIndex:function(e){var t,i=this.rtlTranslate?this.translate:-this.translate,s=this.slidesGrid,a=this.snapGrid,r=this.params,n=this.activeIndex,o=this.realIndex,l=this.snapIndex,h=e;if(void 0===h){for(var p=0;p<s.length;p+=1)void 0!==s[p+1]?i>=s[p]&&i<s[p+1]-(s[p+1]-s[p])/2?h=p:i>=s[p]&&i<s[p+1]&&(h=p+1):i>=s[p]&&(h=p);r.normalizeSlideIndex&&(h<0||void 0===h)&&(h=0)}if(a.indexOf(i)>=0)t=a.indexOf(i);else{var c=Math.min(r.slidesPerGroupSkip,h);t=c+Math.floor((h-c)/r.slidesPerGroup)}if(t>=a.length&&(t=a.length-1),h!==n){var u=parseInt(this.slides.eq(h).attr("data-swiper-slide-index")||h,10);d.extend(this,{snapIndex:t,realIndex:u,previousIndex:n,activeIndex:h}),this.emit("activeIndexChange"),this.emit("snapIndexChange"),o!==u&&this.emit("realIndexChange"),(this.initialized||this.params.runCallbacksOnInit)&&this.emit("slideChange")}else t!==l&&(this.snapIndex=t,this.emit("snapIndexChange"))},updateClickedSlide:function(e){var t=this.params,i=n(e.target).closest("."+t.slideClass)[0],s=!1;if(i)for(var a=0;a<this.slides.length;a+=1)this.slides[a]===i&&(s=!0);if(!i||!s)return this.clickedSlide=void 0,void(this.clickedIndex=void 0);this.clickedSlide=i,this.virtual&&this.params.virtual.enabled?this.clickedIndex=parseInt(n(i).attr("data-swiper-slide-index"),10):this.clickedIndex=n(i).index(),t.slideToClickedSlide&&void 0!==this.clickedIndex&&this.clickedIndex!==this.activeIndex&&this.slideToClickedSlide()}};var v={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this.params,i=this.rtlTranslate,s=this.translate,a=this.$wrapperEl;if(t.virtualTranslate)return i?-s:s;if(t.cssMode)return s;var r=d.getTranslate(a[0],e);return i&&(r=-r),r||0},setTranslate:function(e,t){var i=this.rtlTranslate,s=this.params,a=this.$wrapperEl,r=this.wrapperEl,n=this.progress,o=0,l=0;this.isHorizontal()?o=i?-e:e:l=e,s.roundLengths&&(o=Math.floor(o),l=Math.floor(l)),s.cssMode?r[this.isHorizontal()?"scrollLeft":"scrollTop"]=this.isHorizontal()?-o:-l:s.virtualTranslate||a.transform("translate3d("+o+"px, "+l+"px, 0px)"),this.previousTranslate=this.translate,this.translate=this.isHorizontal()?o:l;var d=this.maxTranslate()-this.minTranslate();(0===d?0:(e-this.minTranslate())/d)!==n&&this.updateProgress(e),this.emit("setTranslate",this.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,i,s,a){var r;void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0),void 0===s&&(s=!0);var n=this,o=n.params,l=n.wrapperEl;if(n.animating&&o.preventInteractionOnTransition)return!1;var d,h=n.minTranslate(),p=n.maxTranslate();if(d=s&&e>h?h:s&&e<p?p:e,n.updateProgress(d),o.cssMode){var c=n.isHorizontal();return 0===t?l[c?"scrollLeft":"scrollTop"]=-d:l.scrollTo?l.scrollTo(((r={})[c?"left":"top"]=-d,r.behavior="smooth",r)):l[c?"scrollLeft":"scrollTop"]=-d,!0}return 0===t?(n.setTransition(0),n.setTranslate(d),i&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionEnd"))):(n.setTransition(t),n.setTranslate(d),i&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionStart")),n.animating||(n.animating=!0,n.onTranslateToWrapperTransitionEnd||(n.onTranslateToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd),n.onTranslateToWrapperTransitionEnd=null,delete n.onTranslateToWrapperTransitionEnd,i&&n.emit("transitionEnd"))}),n.$wrapperEl[0].addEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd))),!0}};var f={setTransition:function(e,t){this.params.cssMode||this.$wrapperEl.transition(e),this.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);var i=this.activeIndex,s=this.params,a=this.previousIndex;if(!s.cssMode){s.autoHeight&&this.updateAutoHeight();var r=t;if(r||(r=i>a?"next":i<a?"prev":"reset"),this.emit("transitionStart"),e&&i!==a){if("reset"===r)return void this.emit("slideResetTransitionStart");this.emit("slideChangeTransitionStart"),"next"===r?this.emit("slideNextTransitionStart"):this.emit("slidePrevTransitionStart")}}},transitionEnd:function(e,t){void 0===e&&(e=!0);var i=this.activeIndex,s=this.previousIndex,a=this.params;if(this.animating=!1,!a.cssMode){this.setTransition(0);var r=t;if(r||(r=i>s?"next":i<s?"prev":"reset"),this.emit("transitionEnd"),e&&i!==s){if("reset"===r)return void this.emit("slideResetTransitionEnd");this.emit("slideChangeTransitionEnd"),"next"===r?this.emit("slideNextTransitionEnd"):this.emit("slidePrevTransitionEnd")}}}};var m={slideTo:function(e,t,i,s){var a;void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0);var r=this,n=e;n<0&&(n=0);var o=r.params,l=r.snapGrid,d=r.slidesGrid,h=r.previousIndex,p=r.activeIndex,c=r.rtlTranslate,u=r.wrapperEl;if(r.animating&&o.preventInteractionOnTransition)return!1;var v=Math.min(r.params.slidesPerGroupSkip,n),f=v+Math.floor((n-v)/r.params.slidesPerGroup);f>=l.length&&(f=l.length-1),(p||o.initialSlide||0)===(h||0)&&i&&r.emit("beforeSlideChangeStart");var m,g=-l[f];if(r.updateProgress(g),o.normalizeSlideIndex)for(var b=0;b<d.length;b+=1)-Math.floor(100*g)>=Math.floor(100*d[b])&&(n=b);if(r.initialized&&n!==p){if(!r.allowSlideNext&&g<r.translate&&g<r.minTranslate())return!1;if(!r.allowSlidePrev&&g>r.translate&&g>r.maxTranslate()&&(p||0)!==n)return!1}if(m=n>p?"next":n<p?"prev":"reset",c&&-g===r.translate||!c&&g===r.translate)return r.updateActiveIndex(n),o.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==o.effect&&r.setTranslate(g),"reset"!==m&&(r.transitionStart(i,m),r.transitionEnd(i,m)),!1;if(o.cssMode){var w=r.isHorizontal(),y=-g;return c&&(y=u.scrollWidth-u.offsetWidth-y),0===t?u[w?"scrollLeft":"scrollTop"]=y:u.scrollTo?u.scrollTo(((a={})[w?"left":"top"]=y,a.behavior="smooth",a)):u[w?"scrollLeft":"scrollTop"]=y,!0}return 0===t?(r.setTransition(0),r.setTranslate(g),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,s),r.transitionStart(i,m),r.transitionEnd(i,m)):(r.setTransition(t),r.setTranslate(g),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,s),r.transitionStart(i,m),r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(i,m))}),r.$wrapperEl[0].addEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onSlideToWrapperTransitionEnd))),!0},slideToLoop:function(e,t,i,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===i&&(i=!0);var a=e;return this.params.loop&&(a+=this.loopedSlides),this.slideTo(a,t,i,s)},slideNext:function(e,t,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var s=this.params,a=this.animating,r=this.activeIndex<s.slidesPerGroupSkip?1:s.slidesPerGroup;if(s.loop){if(a)return!1;this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft}return this.slideTo(this.activeIndex+r,e,t,i)},slidePrev:function(e,t,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var s=this.params,a=this.animating,r=this.snapGrid,n=this.slidesGrid,o=this.rtlTranslate;if(s.loop){if(a)return!1;this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft}function l(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}var d,h=l(o?this.translate:-this.translate),p=r.map((function(e){return l(e)})),c=(n.map((function(e){return l(e)})),r[p.indexOf(h)],r[p.indexOf(h)-1]);return void 0===c&&s.cssMode&&r.forEach((function(e){!c&&h>=e&&(c=e)})),void 0!==c&&(d=n.indexOf(c))<0&&(d=this.activeIndex-1),this.slideTo(d,e,t,i)},slideReset:function(e,t,i){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,i)},slideToClosest:function(e,t,i,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===s&&(s=.5);var a=this.activeIndex,r=Math.min(this.params.slidesPerGroupSkip,a),n=r+Math.floor((a-r)/this.params.slidesPerGroup),o=this.rtlTranslate?this.translate:-this.translate;if(o>=this.snapGrid[n]){var l=this.snapGrid[n];o-l>(this.snapGrid[n+1]-l)*s&&(a+=this.params.slidesPerGroup)}else{var d=this.snapGrid[n-1];o-d<=(this.snapGrid[n]-d)*s&&(a-=this.params.slidesPerGroup)}return a=Math.max(a,0),a=Math.min(a,this.slidesGrid.length-1),this.slideTo(a,e,t,i)},slideToClickedSlide:function(){var e,t=this,i=t.params,s=t.$wrapperEl,a="auto"===i.slidesPerView?t.slidesPerViewDynamic():i.slidesPerView,r=t.clickedIndex;if(i.loop){if(t.animating)return;e=parseInt(n(t.clickedSlide).attr("data-swiper-slide-index"),10),i.centeredSlides?r<t.loopedSlides-a/2||r>t.slides.length-t.loopedSlides+a/2?(t.loopFix(),r=s.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+i.slideDuplicateClass+")").eq(0).index(),d.nextTick((function(){t.slideTo(r)}))):t.slideTo(r):r>t.slides.length-a?(t.loopFix(),r=s.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+i.slideDuplicateClass+")").eq(0).index(),d.nextTick((function(){t.slideTo(r)}))):t.slideTo(r)}else t.slideTo(r)}};var g={loopCreate:function(){var e=this,t=e.params,s=e.$wrapperEl;s.children("."+t.slideClass+"."+t.slideDuplicateClass).remove();var a=s.children("."+t.slideClass);if(t.loopFillGroupWithBlank){var r=t.slidesPerGroup-a.length%t.slidesPerGroup;if(r!==t.slidesPerGroup){for(var o=0;o<r;o+=1){var l=n(i.createElement("div")).addClass(t.slideClass+" "+t.slideBlankClass);s.append(l)}a=s.children("."+t.slideClass)}}"auto"!==t.slidesPerView||t.loopedSlides||(t.loopedSlides=a.length),e.loopedSlides=Math.ceil(parseFloat(t.loopedSlides||t.slidesPerView,10)),e.loopedSlides+=t.loopAdditionalSlides,e.loopedSlides>a.length&&(e.loopedSlides=a.length);var d=[],h=[];a.each((function(t,i){var s=n(i);t<e.loopedSlides&&h.push(i),t<a.length&&t>=a.length-e.loopedSlides&&d.push(i),s.attr("data-swiper-slide-index",t)}));for(var p=0;p<h.length;p+=1)s.append(n(h[p].cloneNode(!0)).addClass(t.slideDuplicateClass));for(var c=d.length-1;c>=0;c-=1)s.prepend(n(d[c].cloneNode(!0)).addClass(t.slideDuplicateClass))},loopFix:function(){this.emit("beforeLoopFix");var e,t=this.activeIndex,i=this.slides,s=this.loopedSlides,a=this.allowSlidePrev,r=this.allowSlideNext,n=this.snapGrid,o=this.rtlTranslate;this.allowSlidePrev=!0,this.allowSlideNext=!0;var l=-n[t]-this.getTranslate();if(t<s)e=i.length-3*s+t,e+=s,this.slideTo(e,0,!1,!0)&&0!==l&&this.setTranslate((o?-this.translate:this.translate)-l);else if(t>=i.length-s){e=-i.length+t+s,e+=s,this.slideTo(e,0,!1,!0)&&0!==l&&this.setTranslate((o?-this.translate:this.translate)-l)}this.allowSlidePrev=a,this.allowSlideNext=r,this.emit("loopFix")},loopDestroy:function(){var e=this.$wrapperEl,t=this.params,i=this.slides;e.children("."+t.slideClass+"."+t.slideDuplicateClass+",."+t.slideClass+"."+t.slideBlankClass).remove(),i.removeAttr("data-swiper-slide-index")}};var b={setGrabCursor:function(e){if(!(h.touch||!this.params.simulateTouch||this.params.watchOverflow&&this.isLocked||this.params.cssMode)){var t=this.el;t.style.cursor="move",t.style.cursor=e?"-webkit-grabbing":"-webkit-grab",t.style.cursor=e?"-moz-grabbin":"-moz-grab",t.style.cursor=e?"grabbing":"grab"}},unsetGrabCursor:function(){h.touch||this.params.watchOverflow&&this.isLocked||this.params.cssMode||(this.el.style.cursor="")}};var w,y,x,E,T,S,C,M,P,z,k,$,L,I,D,O={appendSlide:function(e){var t=this.$wrapperEl,i=this.params;if(i.loop&&this.loopDestroy(),"object"==typeof e&&"length"in e)for(var s=0;s<e.length;s+=1)e[s]&&t.append(e[s]);else t.append(e);i.loop&&this.loopCreate(),i.observer&&h.observer||this.update()},prependSlide:function(e){var t=this.params,i=this.$wrapperEl,s=this.activeIndex;t.loop&&this.loopDestroy();var a=s+1;if("object"==typeof e&&"length"in e){for(var r=0;r<e.length;r+=1)e[r]&&i.prepend(e[r]);a=s+e.length}else i.prepend(e);t.loop&&this.loopCreate(),t.observer&&h.observer||this.update(),this.slideTo(a,0,!1)},addSlide:function(e,t){var i=this.$wrapperEl,s=this.params,a=this.activeIndex;s.loop&&(a-=this.loopedSlides,this.loopDestroy(),this.slides=i.children("."+s.slideClass));var r=this.slides.length;if(e<=0)this.prependSlide(t);else if(e>=r)this.appendSlide(t);else{for(var n=a>e?a+1:a,o=[],l=r-1;l>=e;l-=1){var d=this.slides.eq(l);d.remove(),o.unshift(d)}if("object"==typeof t&&"length"in t){for(var p=0;p<t.length;p+=1)t[p]&&i.append(t[p]);n=a>e?a+t.length:a}else i.append(t);for(var c=0;c<o.length;c+=1)i.append(o[c]);s.loop&&this.loopCreate(),s.observer&&h.observer||this.update(),s.loop?this.slideTo(n+this.loopedSlides,0,!1):this.slideTo(n,0,!1)}},removeSlide:function(e){var t=this.params,i=this.$wrapperEl,s=this.activeIndex;t.loop&&(s-=this.loopedSlides,this.loopDestroy(),this.slides=i.children("."+t.slideClass));var a,r=s;if("object"==typeof e&&"length"in e){for(var n=0;n<e.length;n+=1)a=e[n],this.slides[a]&&this.slides.eq(a).remove(),a<r&&(r-=1);r=Math.max(r,0)}else a=e,this.slides[a]&&this.slides.eq(a).remove(),a<r&&(r-=1),r=Math.max(r,0);t.loop&&this.loopCreate(),t.observer&&h.observer||this.update(),t.loop?this.slideTo(r+this.loopedSlides,0,!1):this.slideTo(r,0,!1)},removeAllSlides:function(){for(var e=[],t=0;t<this.slides.length;t+=1)e.push(t);this.removeSlide(e)}},A=(w=a.navigator.platform,y=a.navigator.userAgent,x={ios:!1,android:!1,androidChrome:!1,desktop:!1,iphone:!1,ipod:!1,ipad:!1,edge:!1,ie:!1,firefox:!1,macos:!1,windows:!1,cordova:!(!a.cordova&&!a.phonegap),phonegap:!(!a.cordova&&!a.phonegap),electron:!1},E=a.screen.width,T=a.screen.height,S=y.match(/(Android);?[\s\/]+([\d.]+)?/),C=y.match(/(iPad).*OS\s([\d_]+)/),M=y.match(/(iPod)(.*OS\s([\d_]+))?/),P=!C&&y.match(/(iPhone\sOS|iOS)\s([\d_]+)/),z=y.indexOf("MSIE ")>=0||y.indexOf("Trident/")>=0,k=y.indexOf("Edge/")>=0,$=y.indexOf("Gecko/")>=0&&y.indexOf("Firefox/")>=0,L="Win32"===w,I=y.toLowerCase().indexOf("electron")>=0,D="MacIntel"===w,!C&&D&&h.touch&&(1024===E&&1366===T||834===E&&1194===T||834===E&&1112===T||768===E&&1024===T)&&(C=y.match(/(Version)\/([\d.]+)/),D=!1),x.ie=z,x.edge=k,x.firefox=$,S&&!L&&(x.os="android",x.osVersion=S[2],x.android=!0,x.androidChrome=y.toLowerCase().indexOf("chrome")>=0),(C||P||M)&&(x.os="ios",x.ios=!0),P&&!M&&(x.osVersion=P[2].replace(/_/g,"."),x.iphone=!0),C&&(x.osVersion=C[2].replace(/_/g,"."),x.ipad=!0),M&&(x.osVersion=M[3]?M[3].replace(/_/g,"."):null,x.ipod=!0),x.ios&&x.osVersion&&y.indexOf("Version/")>=0&&"10"===x.osVersion.split(".")[0]&&(x.osVersion=y.toLowerCase().split("version/")[1].split(" ")[0]),x.webView=!(!(P||C||M)||!y.match(/.*AppleWebKit(?!.*Safari)/i)&&!a.navigator.standalone)||a.matchMedia&&a.matchMedia("(display-mode: standalone)").matches,x.webview=x.webView,x.standalone=x.webView,x.desktop=!(x.ios||x.android)||I,x.desktop&&(x.electron=I,x.macos=D,x.windows=L,x.macos&&(x.os="macos"),x.windows&&(x.os="windows")),x.pixelRatio=a.devicePixelRatio||1,x);function G(e){var t=this.touchEventsData,s=this.params,r=this.touches;if(!this.animating||!s.preventInteractionOnTransition){var o=e;o.originalEvent&&(o=o.originalEvent);var l=n(o.target);if(("wrapper"!==s.touchEventsTarget||l.closest(this.wrapperEl).length)&&(t.isTouchEvent="touchstart"===o.type,(t.isTouchEvent||!("which"in o)||3!==o.which)&&!(!t.isTouchEvent&&"button"in o&&o.button>0||t.isTouched&&t.isMoved)))if(s.noSwiping&&l.closest(s.noSwipingSelector?s.noSwipingSelector:"."+s.noSwipingClass)[0])this.allowClick=!0;else if(!s.swipeHandler||l.closest(s.swipeHandler)[0]){r.currentX="touchstart"===o.type?o.targetTouches[0].pageX:o.pageX,r.currentY="touchstart"===o.type?o.targetTouches[0].pageY:o.pageY;var h=r.currentX,p=r.currentY,c=s.edgeSwipeDetection||s.iOSEdgeSwipeDetection,u=s.edgeSwipeThreshold||s.iOSEdgeSwipeThreshold;if(!c||!(h<=u||h>=a.screen.width-u)){if(d.extend(t,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),r.startX=h,r.startY=p,t.touchStartTime=d.now(),this.allowClick=!0,this.updateSize(),this.swipeDirection=void 0,s.threshold>0&&(t.allowThresholdMove=!1),"touchstart"!==o.type){var v=!0;l.is(t.formElements)&&(v=!1),i.activeElement&&n(i.activeElement).is(t.formElements)&&i.activeElement!==l[0]&&i.activeElement.blur();var f=v&&this.allowTouchMove&&s.touchStartPreventDefault;(s.touchStartForcePreventDefault||f)&&o.preventDefault()}this.emit("touchStart",o)}}}}function H(e){var t=this.touchEventsData,s=this.params,a=this.touches,r=this.rtlTranslate,o=e;if(o.originalEvent&&(o=o.originalEvent),t.isTouched){if(!t.isTouchEvent||"touchmove"===o.type){var l="touchmove"===o.type&&o.targetTouches&&(o.targetTouches[0]||o.changedTouches[0]),h="touchmove"===o.type?l.pageX:o.pageX,p="touchmove"===o.type?l.pageY:o.pageY;if(o.preventedByNestedSwiper)return a.startX=h,void(a.startY=p);if(!this.allowTouchMove)return this.allowClick=!1,void(t.isTouched&&(d.extend(a,{startX:h,startY:p,currentX:h,currentY:p}),t.touchStartTime=d.now()));if(t.isTouchEvent&&s.touchReleaseOnEdges&&!s.loop)if(this.isVertical()){if(p<a.startY&&this.translate<=this.maxTranslate()||p>a.startY&&this.translate>=this.minTranslate())return t.isTouched=!1,void(t.isMoved=!1)}else if(h<a.startX&&this.translate<=this.maxTranslate()||h>a.startX&&this.translate>=this.minTranslate())return;if(t.isTouchEvent&&i.activeElement&&o.target===i.activeElement&&n(o.target).is(t.formElements))return t.isMoved=!0,void(this.allowClick=!1);if(t.allowTouchCallbacks&&this.emit("touchMove",o),!(o.targetTouches&&o.targetTouches.length>1)){a.currentX=h,a.currentY=p;var c=a.currentX-a.startX,u=a.currentY-a.startY;if(!(this.params.threshold&&Math.sqrt(Math.pow(c,2)+Math.pow(u,2))<this.params.threshold)){var v;if(void 0===t.isScrolling)this.isHorizontal()&&a.currentY===a.startY||this.isVertical()&&a.currentX===a.startX?t.isScrolling=!1:c*c+u*u>=25&&(v=180*Math.atan2(Math.abs(u),Math.abs(c))/Math.PI,t.isScrolling=this.isHorizontal()?v>s.touchAngle:90-v>s.touchAngle);if(t.isScrolling&&this.emit("touchMoveOpposite",o),void 0===t.startMoving&&(a.currentX===a.startX&&a.currentY===a.startY||(t.startMoving=!0)),t.isScrolling)t.isTouched=!1;else if(t.startMoving){this.allowClick=!1,!s.cssMode&&o.cancelable&&o.preventDefault(),s.touchMoveStopPropagation&&!s.nested&&o.stopPropagation(),t.isMoved||(s.loop&&this.loopFix(),t.startTranslate=this.getTranslate(),this.setTransition(0),this.animating&&this.$wrapperEl.trigger("webkitTransitionEnd transitionend"),t.allowMomentumBounce=!1,!s.grabCursor||!0!==this.allowSlideNext&&!0!==this.allowSlidePrev||this.setGrabCursor(!0),this.emit("sliderFirstMove",o)),this.emit("sliderMove",o),t.isMoved=!0;var f=this.isHorizontal()?c:u;a.diff=f,f*=s.touchRatio,r&&(f=-f),this.swipeDirection=f>0?"prev":"next",t.currentTranslate=f+t.startTranslate;var m=!0,g=s.resistanceRatio;if(s.touchReleaseOnEdges&&(g=0),f>0&&t.currentTranslate>this.minTranslate()?(m=!1,s.resistance&&(t.currentTranslate=this.minTranslate()-1+Math.pow(-this.minTranslate()+t.startTranslate+f,g))):f<0&&t.currentTranslate<this.maxTranslate()&&(m=!1,s.resistance&&(t.currentTranslate=this.maxTranslate()+1-Math.pow(this.maxTranslate()-t.startTranslate-f,g))),m&&(o.preventedByNestedSwiper=!0),!this.allowSlideNext&&"next"===this.swipeDirection&&t.currentTranslate<t.startTranslate&&(t.currentTranslate=t.startTranslate),!this.allowSlidePrev&&"prev"===this.swipeDirection&&t.currentTranslate>t.startTranslate&&(t.currentTranslate=t.startTranslate),s.threshold>0){if(!(Math.abs(f)>s.threshold||t.allowThresholdMove))return void(t.currentTranslate=t.startTranslate);if(!t.allowThresholdMove)return t.allowThresholdMove=!0,a.startX=a.currentX,a.startY=a.currentY,t.currentTranslate=t.startTranslate,void(a.diff=this.isHorizontal()?a.currentX-a.startX:a.currentY-a.startY)}s.followFinger&&!s.cssMode&&((s.freeMode||s.watchSlidesProgress||s.watchSlidesVisibility)&&(this.updateActiveIndex(),this.updateSlidesClasses()),s.freeMode&&(0===t.velocities.length&&t.velocities.push({position:a[this.isHorizontal()?"startX":"startY"],time:t.touchStartTime}),t.velocities.push({position:a[this.isHorizontal()?"currentX":"currentY"],time:d.now()})),this.updateProgress(t.currentTranslate),this.setTranslate(t.currentTranslate))}}}}}else t.startMoving&&t.isScrolling&&this.emit("touchMoveOpposite",o)}function B(e){var t=this,i=t.touchEventsData,s=t.params,a=t.touches,r=t.rtlTranslate,n=t.$wrapperEl,o=t.slidesGrid,l=t.snapGrid,h=e;if(h.originalEvent&&(h=h.originalEvent),i.allowTouchCallbacks&&t.emit("touchEnd",h),i.allowTouchCallbacks=!1,!i.isTouched)return i.isMoved&&s.grabCursor&&t.setGrabCursor(!1),i.isMoved=!1,void(i.startMoving=!1);s.grabCursor&&i.isMoved&&i.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,c=d.now(),u=c-i.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(h),t.emit("tap click",h),u<300&&c-i.lastClickTime<300&&t.emit("doubleTap doubleClick",h)),i.lastClickTime=d.now(),d.nextTick((function(){t.destroyed||(t.allowClick=!0)})),!i.isTouched||!i.isMoved||!t.swipeDirection||0===a.diff||i.currentTranslate===i.startTranslate)return i.isTouched=!1,i.isMoved=!1,void(i.startMoving=!1);if(i.isTouched=!1,i.isMoved=!1,i.startMoving=!1,p=s.followFinger?r?t.translate:-t.translate:-i.currentTranslate,!s.cssMode)if(s.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<l.length?t.slideTo(l.length-1):t.slideTo(t.slides.length-1));if(s.freeModeMomentum){if(i.velocities.length>1){var v=i.velocities.pop(),f=i.velocities.pop(),m=v.position-f.position,g=v.time-f.time;t.velocity=m/g,t.velocity/=2,Math.abs(t.velocity)<s.freeModeMinimumVelocity&&(t.velocity=0),(g>150||d.now()-v.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=s.freeModeMomentumVelocityRatio,i.velocities.length=0;var b=1e3*s.freeModeMomentumRatio,w=t.velocity*b,y=t.translate+w;r&&(y=-y);var x,E,T=!1,S=20*Math.abs(t.velocity)*s.freeModeMomentumBounceRatio;if(y<t.maxTranslate())s.freeModeMomentumBounce?(y+t.maxTranslate()<-S&&(y=t.maxTranslate()-S),x=t.maxTranslate(),T=!0,i.allowMomentumBounce=!0):y=t.maxTranslate(),s.loop&&s.centeredSlides&&(E=!0);else if(y>t.minTranslate())s.freeModeMomentumBounce?(y-t.minTranslate()>S&&(y=t.minTranslate()+S),x=t.minTranslate(),T=!0,i.allowMomentumBounce=!0):y=t.minTranslate(),s.loop&&s.centeredSlides&&(E=!0);else if(s.freeModeSticky){for(var C,M=0;M<l.length;M+=1)if(l[M]>-y){C=M;break}y=-(y=Math.abs(l[C]-y)<Math.abs(l[C-1]-y)||"next"===t.swipeDirection?l[C]:l[C-1])}if(E&&t.once("transitionEnd",(function(){t.loopFix()})),0!==t.velocity){if(b=r?Math.abs((-y-t.translate)/t.velocity):Math.abs((y-t.translate)/t.velocity),s.freeModeSticky){var P=Math.abs((r?-y:y)-t.translate),z=t.slidesSizesGrid[t.activeIndex];b=P<z?s.speed:P<2*z?1.5*s.speed:2.5*s.speed}}else if(s.freeModeSticky)return void t.slideToClosest();s.freeModeMomentumBounce&&T?(t.updateProgress(x),t.setTransition(b),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&i.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(s.speed),setTimeout((function(){t.setTranslate(x),n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(t.updateProgress(y),t.setTransition(b),t.setTranslate(y),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(y),t.updateActiveIndex(),t.updateSlidesClasses()}else if(s.freeModeSticky)return void t.slideToClosest();(!s.freeModeMomentum||u>=s.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}else{for(var k=0,$=t.slidesSizesGrid[0],L=0;L<o.length;L+=L<s.slidesPerGroupSkip?1:s.slidesPerGroup){var I=L<s.slidesPerGroupSkip-1?1:s.slidesPerGroup;void 0!==o[L+I]?p>=o[L]&&p<o[L+I]&&(k=L,$=o[L+I]-o[L]):p>=o[L]&&(k=L,$=o[o.length-1]-o[o.length-2])}var D=(p-o[k])/$,O=k<s.slidesPerGroupSkip-1?1:s.slidesPerGroup;if(u>s.longSwipesMs){if(!s.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(D>=s.longSwipesRatio?t.slideTo(k+O):t.slideTo(k)),"prev"===t.swipeDirection&&(D>1-s.longSwipesRatio?t.slideTo(k+O):t.slideTo(k))}else{if(!s.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(h.target===t.navigation.nextEl||h.target===t.navigation.prevEl)?h.target===t.navigation.nextEl?t.slideTo(k+O):t.slideTo(k):("next"===t.swipeDirection&&t.slideTo(k+O),"prev"===t.swipeDirection&&t.slideTo(k))}}}function N(){var e=this.params,t=this.el;if(!t||0!==t.offsetWidth){e.breakpoints&&this.setBreakpoint();var i=this.allowSlideNext,s=this.allowSlidePrev,a=this.snapGrid;this.allowSlideNext=!0,this.allowSlidePrev=!0,this.updateSize(),this.updateSlides(),this.updateSlidesClasses(),("auto"===e.slidesPerView||e.slidesPerView>1)&&this.isEnd&&!this.isBeginning&&!this.params.centeredSlides?this.slideTo(this.slides.length-1,0,!1,!0):this.slideTo(this.activeIndex,0,!1,!0),this.autoplay&&this.autoplay.running&&this.autoplay.paused&&this.autoplay.run(),this.allowSlidePrev=s,this.allowSlideNext=i,this.params.watchOverflow&&a!==this.snapGrid&&this.checkOverflow()}}function X(e){this.allowClick||(this.params.preventClicks&&e.preventDefault(),this.params.preventClicksPropagation&&this.animating&&(e.stopPropagation(),e.stopImmediatePropagation()))}function V(){var e=this.wrapperEl,t=this.rtlTranslate;this.previousTranslate=this.translate,this.isHorizontal()?this.translate=t?e.scrollWidth-e.offsetWidth-e.scrollLeft:-e.scrollLeft:this.translate=-e.scrollTop,-0===this.translate&&(this.translate=0),this.updateActiveIndex(),this.updateSlidesClasses();var i=this.maxTranslate()-this.minTranslate();(0===i?0:(this.translate-this.minTranslate())/i)!==this.progress&&this.updateProgress(t?-this.translate:this.translate),this.emit("setTranslate",this.translate,!1)}var Y=!1;function F(){}var W={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,preventInteractionOnTransition:!1,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,slidesPerGroupSkip:0,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0},R={update:u,translate:v,transition:f,slide:m,loop:g,grabCursor:b,manipulation:O,events:{attachEvents:function(){var e=this.params,t=this.touchEvents,s=this.el,a=this.wrapperEl;this.onTouchStart=G.bind(this),this.onTouchMove=H.bind(this),this.onTouchEnd=B.bind(this),e.cssMode&&(this.onScroll=V.bind(this)),this.onClick=X.bind(this);var r=!!e.nested;if(!h.touch&&h.pointerEvents)s.addEventListener(t.start,this.onTouchStart,!1),i.addEventListener(t.move,this.onTouchMove,r),i.addEventListener(t.end,this.onTouchEnd,!1);else{if(h.touch){var n=!("touchstart"!==t.start||!h.passiveListener||!e.passiveListeners)&&{passive:!0,capture:!1};s.addEventListener(t.start,this.onTouchStart,n),s.addEventListener(t.move,this.onTouchMove,h.passiveListener?{passive:!1,capture:r}:r),s.addEventListener(t.end,this.onTouchEnd,n),t.cancel&&s.addEventListener(t.cancel,this.onTouchEnd,n),Y||(i.addEventListener("touchstart",F),Y=!0)}(e.simulateTouch&&!A.ios&&!A.android||e.simulateTouch&&!h.touch&&A.ios)&&(s.addEventListener("mousedown",this.onTouchStart,!1),i.addEventListener("mousemove",this.onTouchMove,r),i.addEventListener("mouseup",this.onTouchEnd,!1))}(e.preventClicks||e.preventClicksPropagation)&&s.addEventListener("click",this.onClick,!0),e.cssMode&&a.addEventListener("scroll",this.onScroll),e.updateOnWindowResize?this.on(A.ios||A.android?"resize orientationchange observerUpdate":"resize observerUpdate",N,!0):this.on("observerUpdate",N,!0)},detachEvents:function(){var e=this.params,t=this.touchEvents,s=this.el,a=this.wrapperEl,r=!!e.nested;if(!h.touch&&h.pointerEvents)s.removeEventListener(t.start,this.onTouchStart,!1),i.removeEventListener(t.move,this.onTouchMove,r),i.removeEventListener(t.end,this.onTouchEnd,!1);else{if(h.touch){var n=!("onTouchStart"!==t.start||!h.passiveListener||!e.passiveListeners)&&{passive:!0,capture:!1};s.removeEventListener(t.start,this.onTouchStart,n),s.removeEventListener(t.move,this.onTouchMove,r),s.removeEventListener(t.end,this.onTouchEnd,n),t.cancel&&s.removeEventListener(t.cancel,this.onTouchEnd,n)}(e.simulateTouch&&!A.ios&&!A.android||e.simulateTouch&&!h.touch&&A.ios)&&(s.removeEventListener("mousedown",this.onTouchStart,!1),i.removeEventListener("mousemove",this.onTouchMove,r),i.removeEventListener("mouseup",this.onTouchEnd,!1))}(e.preventClicks||e.preventClicksPropagation)&&s.removeEventListener("click",this.onClick,!0),e.cssMode&&a.removeEventListener("scroll",this.onScroll),this.off(A.ios||A.android?"resize orientationchange observerUpdate":"resize observerUpdate",N)}},breakpoints:{setBreakpoint:function(){var e=this.activeIndex,t=this.initialized,i=this.loopedSlides;void 0===i&&(i=0);var s=this.params,a=this.$el,r=s.breakpoints;if(r&&(!r||0!==Object.keys(r).length)){var n=this.getBreakpoint(r);if(n&&this.currentBreakpoint!==n){var o=n in r?r[n]:void 0;o&&["slidesPerView","spaceBetween","slidesPerGroup","slidesPerGroupSkip","slidesPerColumn"].forEach((function(e){var t=o[e];void 0!==t&&(o[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto")}));var l=o||this.originalParams,h=s.slidesPerColumn>1,p=l.slidesPerColumn>1;h&&!p?a.removeClass(s.containerModifierClass+"multirow "+s.containerModifierClass+"multirow-column"):!h&&p&&(a.addClass(s.containerModifierClass+"multirow"),"column"===l.slidesPerColumnFill&&a.addClass(s.containerModifierClass+"multirow-column"));var c=l.direction&&l.direction!==s.direction,u=s.loop&&(l.slidesPerView!==s.slidesPerView||c);c&&t&&this.changeDirection(),d.extend(this.params,l),d.extend(this,{allowTouchMove:this.params.allowTouchMove,allowSlideNext:this.params.allowSlideNext,allowSlidePrev:this.params.allowSlidePrev}),this.currentBreakpoint=n,u&&t&&(this.loopDestroy(),this.loopCreate(),this.updateSlides(),this.slideTo(e-i+this.loopedSlides,0,!1)),this.emit("breakpoint",l)}}},getBreakpoint:function(e){if(e){var t=!1,i=Object.keys(e).map((function(e){if("string"==typeof e&&0===e.indexOf("@")){var t=parseFloat(e.substr(1));return{value:a.innerHeight*t,point:e}}return{value:e,point:e}}));i.sort((function(e,t){return parseInt(e.value,10)-parseInt(t.value,10)}));for(var s=0;s<i.length;s+=1){var r=i[s],n=r.point;r.value<=a.innerWidth&&(t=n)}return t||"max"}}},checkOverflow:{checkOverflow:function(){var e=this.params,t=this.isLocked,i=this.slides.length>0&&e.slidesOffsetBefore+e.spaceBetween*(this.slides.length-1)+this.slides[0].offsetWidth*this.slides.length;e.slidesOffsetBefore&&e.slidesOffsetAfter&&i?this.isLocked=i<=this.size:this.isLocked=1===this.snapGrid.length,this.allowSlideNext=!this.isLocked,this.allowSlidePrev=!this.isLocked,t!==this.isLocked&&this.emit(this.isLocked?"lock":"unlock"),t&&t!==this.isLocked&&(this.isEnd=!1,this.navigation&&this.navigation.update())}},classes:{addClasses:function(){var e=this.classNames,t=this.params,i=this.rtl,s=this.$el,a=[];a.push("initialized"),a.push(t.direction),t.freeMode&&a.push("free-mode"),t.autoHeight&&a.push("autoheight"),i&&a.push("rtl"),t.slidesPerColumn>1&&(a.push("multirow"),"column"===t.slidesPerColumnFill&&a.push("multirow-column")),A.android&&a.push("android"),A.ios&&a.push("ios"),t.cssMode&&a.push("css-mode"),a.forEach((function(i){e.push(t.containerModifierClass+i)})),s.addClass(e.join(" "))},removeClasses:function(){var e=this.$el,t=this.classNames;e.removeClass(t.join(" "))}},images:{loadImage:function(e,t,i,s,r,o){var l;function d(){o&&o()}n(e).parent("picture")[0]||e.complete&&r?d():t?((l=new a.Image).onload=d,l.onerror=d,s&&(l.sizes=s),i&&(l.srcset=i),t&&(l.src=t)):d()},preloadImages:function(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(var i=0;i<e.imagesToLoad.length;i+=1){var s=e.imagesToLoad[i];e.loadImage(s,s.currentSrc||s.getAttribute("src"),s.srcset||s.getAttribute("srcset"),s.sizes||s.getAttribute("sizes"),!0,t)}}}},q={},j=function(e){function t(){for(var i,s,a,r=[],o=arguments.length;o--;)r[o]=arguments[o];1===r.length&&r[0].constructor&&r[0].constructor===Object?a=r[0]:(s=(i=r)[0],a=i[1]),a||(a={}),a=d.extend({},a),s&&!a.el&&(a.el=s),e.call(this,a),Object.keys(R).forEach((function(e){Object.keys(R[e]).forEach((function(i){t.prototype[i]||(t.prototype[i]=R[e][i])}))}));var l=this;void 0===l.modules&&(l.modules={}),Object.keys(l.modules).forEach((function(e){var t=l.modules[e];if(t.params){var i=Object.keys(t.params)[0],s=t.params[i];if("object"!=typeof s||null===s)return;if(!(i in a)||!("enabled"in s))return;!0===a[i]&&(a[i]={enabled:!0}),"object"!=typeof a[i]||"enabled"in a[i]||(a[i].enabled=!0),a[i]||(a[i]={enabled:!1})}}));var p=d.extend({},W);l.useModulesParams(p),l.params=d.extend({},p,q,a),l.originalParams=d.extend({},l.params),l.passedParams=d.extend({},a),l.$=n;var c=n(l.params.el);if(s=c[0]){if(c.length>1){var u=[];return c.each((function(e,i){var s=d.extend({},a,{el:i});u.push(new t(s))})),u}var v,f,m;return s.swiper=l,c.data("swiper",l),s&&s.shadowRoot&&s.shadowRoot.querySelector?(v=n(s.shadowRoot.querySelector("."+l.params.wrapperClass))).children=function(e){return c.children(e)}:v=c.children("."+l.params.wrapperClass),d.extend(l,{$el:c,el:s,$wrapperEl:v,wrapperEl:v[0],classNames:[],slides:n(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function(){return"horizontal"===l.params.direction},isVertical:function(){return"vertical"===l.params.direction},rtl:"rtl"===s.dir.toLowerCase()||"rtl"===c.css("direction"),rtlTranslate:"horizontal"===l.params.direction&&("rtl"===s.dir.toLowerCase()||"rtl"===c.css("direction")),wrongRTL:"-webkit-box"===v.css("display"),activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEvents:(f=["touchstart","touchmove","touchend","touchcancel"],m=["mousedown","mousemove","mouseup"],h.pointerEvents&&(m=["pointerdown","pointermove","pointerup"]),l.touchEventsTouch={start:f[0],move:f[1],end:f[2],cancel:f[3]},l.touchEventsDesktop={start:m[0],move:m[1],end:m[2]},h.touch||!l.params.simulateTouch?l.touchEventsTouch:l.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,formElements:"input, select, option, textarea, button, video, label",lastClickTime:d.now(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.useModules(),l.params.init&&l.init(),l}}e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t;var i={extendedDefaults:{configurable:!0},defaults:{configurable:!0},Class:{configurable:!0},$:{configurable:!0}};return t.prototype.slidesPerViewDynamic=function(){var e=this.params,t=this.slides,i=this.slidesGrid,s=this.size,a=this.activeIndex,r=1;if(e.centeredSlides){for(var n,o=t[a].swiperSlideSize,l=a+1;l<t.length;l+=1)t[l]&&!n&&(r+=1,(o+=t[l].swiperSlideSize)>s&&(n=!0));for(var d=a-1;d>=0;d-=1)t[d]&&!n&&(r+=1,(o+=t[d].swiperSlideSize)>s&&(n=!0))}else for(var h=a+1;h<t.length;h+=1)i[h]-i[a]<s&&(r+=1);return r},t.prototype.update=function(){var e=this;if(e&&!e.destroyed){var t=e.snapGrid,i=e.params;i.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode?(s(),e.params.autoHeight&&e.updateAutoHeight()):(("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0))||s(),i.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}function s(){var t=e.rtlTranslate?-1*e.translate:e.translate,i=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(i),e.updateActiveIndex(),e.updateSlidesClasses()}},t.prototype.changeDirection=function(e,t){void 0===t&&(t=!0);var i=this.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e||(this.$el.removeClass(""+this.params.containerModifierClass+i).addClass(""+this.params.containerModifierClass+e),this.params.direction=e,this.slides.each((function(t,i){"vertical"===e?i.style.width="":i.style.height=""})),this.emit("changeDirection"),t&&this.update()),this},t.prototype.init=function(){this.initialized||(this.emit("beforeInit"),this.params.breakpoints&&this.setBreakpoint(),this.addClasses(),this.params.loop&&this.loopCreate(),this.updateSize(),this.updateSlides(),this.params.watchOverflow&&this.checkOverflow(),this.params.grabCursor&&this.setGrabCursor(),this.params.preloadImages&&this.preloadImages(),this.params.loop?this.slideTo(this.params.initialSlide+this.loopedSlides,0,this.params.runCallbacksOnInit):this.slideTo(this.params.initialSlide,0,this.params.runCallbacksOnInit),this.attachEvents(),this.initialized=!0,this.emit("init"))},t.prototype.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var i=this,s=i.params,a=i.$el,r=i.$wrapperEl,n=i.slides;return void 0===i.params||i.destroyed||(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),s.loop&&i.loopDestroy(),t&&(i.removeClasses(),a.removeAttr("style"),r.removeAttr("style"),n&&n.length&&n.removeClass([s.slideVisibleClass,s.slideActiveClass,s.slideNextClass,s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),i.emit("destroy"),Object.keys(i.eventsListeners).forEach((function(e){i.off(e)})),!1!==e&&(i.$el[0].swiper=null,i.$el.data("swiper",null),d.deleteProps(i)),i.destroyed=!0),null},t.extendDefaults=function(e){d.extend(q,e)},i.extendedDefaults.get=function(){return q},i.defaults.get=function(){return W},i.Class.get=function(){return e},i.$.get=function(){return n},Object.defineProperties(t,i),t}(p),K={name:"device",proto:{device:A},static:{device:A}},U={name:"support",proto:{support:h},static:{support:h}},_={isEdge:!!a.navigator.userAgent.match(/Edge/g),isSafari:function(){var e=a.navigator.userAgent.toLowerCase();return e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0}(),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(a.navigator.userAgent)},Z={name:"browser",proto:{browser:_},static:{browser:_}},Q={name:"resize",create:function(){var e=this;d.extend(e,{resize:{resizeHandler:function(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"))},orientationChangeHandler:function(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange")}}})},on:{init:function(){a.addEventListener("resize",this.resize.resizeHandler),a.addEventListener("orientationchange",this.resize.orientationChangeHandler)},destroy:function(){a.removeEventListener("resize",this.resize.resizeHandler),a.removeEventListener("orientationchange",this.resize.orientationChangeHandler)}}},J={func:a.MutationObserver||a.WebkitMutationObserver,attach:function(e,t){void 0===t&&(t={});var i=this,s=new(0,J.func)((function(e){if(1!==e.length){var t=function(){i.emit("observerUpdate",e[0])};a.requestAnimationFrame?a.requestAnimationFrame(t):a.setTimeout(t,0)}else i.emit("observerUpdate",e[0])}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),i.observer.observers.push(s)},init:function(){if(h.observer&&this.params.observer){if(this.params.observeParents)for(var e=this.$el.parents(),t=0;t<e.length;t+=1)this.observer.attach(e[t]);this.observer.attach(this.$el[0],{childList:this.params.observeSlideChildren}),this.observer.attach(this.$wrapperEl[0],{attributes:!1})}},destroy:function(){this.observer.observers.forEach((function(e){e.disconnect()})),this.observer.observers=[]}},ee={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function(){d.extend(this,{observer:{init:J.init.bind(this),attach:J.attach.bind(this),destroy:J.destroy.bind(this),observers:[]}})},on:{init:function(){this.observer.init()},destroy:function(){this.observer.destroy()}}},te={update:function(e){var t=this,i=t.params,s=i.slidesPerView,a=i.slidesPerGroup,r=i.centeredSlides,n=t.params.virtual,o=n.addSlidesBefore,l=n.addSlidesAfter,h=t.virtual,p=h.from,c=h.to,u=h.slides,v=h.slidesGrid,f=h.renderSlide,m=h.offset;t.updateActiveIndex();var g,b,w,y=t.activeIndex||0;g=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",r?(b=Math.floor(s/2)+a+o,w=Math.floor(s/2)+a+l):(b=s+(a-1)+o,w=a+l);var x=Math.max((y||0)-w,0),E=Math.min((y||0)+b,u.length-1),T=(t.slidesGrid[x]||0)-(t.slidesGrid[0]||0);function S(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load()}if(d.extend(t.virtual,{from:x,to:E,offset:T,slidesGrid:t.slidesGrid}),p===x&&c===E&&!e)return t.slidesGrid!==v&&T!==m&&t.slides.css(g,T+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:T,from:x,to:E,slides:function(){for(var e=[],t=x;t<=E;t+=1)e.push(u[t]);return e}()}),void S();var C=[],M=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var P=p;P<=c;P+=1)(P<x||P>E)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+P+'"]').remove();for(var z=0;z<u.length;z+=1)z>=x&&z<=E&&(void 0===c||e?M.push(z):(z>c&&M.push(z),z<p&&C.push(z)));M.forEach((function(e){t.$wrapperEl.append(f(u[e],e))})),C.sort((function(e,t){return t-e})).forEach((function(e){t.$wrapperEl.prepend(f(u[e],e))})),t.$wrapperEl.children(".swiper-slide").css(g,T+"px"),S()},renderSlide:function(e,t){var i=this.params.virtual;if(i.cache&&this.virtual.cache[t])return this.virtual.cache[t];var s=i.renderSlide?n(i.renderSlide.call(this,e,t)):n('<div class="'+this.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return s.attr("data-swiper-slide-index")||s.attr("data-swiper-slide-index",t),i.cache&&(this.virtual.cache[t]=s),s},appendSlide:function(e){if("object"==typeof e&&"length"in e)for(var t=0;t<e.length;t+=1)e[t]&&this.virtual.slides.push(e[t]);else this.virtual.slides.push(e);this.virtual.update(!0)},prependSlide:function(e){var t=this.activeIndex,i=t+1,s=1;if(Array.isArray(e)){for(var a=0;a<e.length;a+=1)e[a]&&this.virtual.slides.unshift(e[a]);i=t+e.length,s=e.length}else this.virtual.slides.unshift(e);if(this.params.virtual.cache){var r=this.virtual.cache,n={};Object.keys(r).forEach((function(e){var t=r[e],i=t.attr("data-swiper-slide-index");i&&t.attr("data-swiper-slide-index",parseInt(i,10)+1),n[parseInt(e,10)+s]=t})),this.virtual.cache=n}this.virtual.update(!0),this.slideTo(i,0)},removeSlide:function(e){if(null!=e){var t=this.activeIndex;if(Array.isArray(e))for(var i=e.length-1;i>=0;i-=1)this.virtual.slides.splice(e[i],1),this.params.virtual.cache&&delete this.virtual.cache[e[i]],e[i]<t&&(t-=1),t=Math.max(t,0);else this.virtual.slides.splice(e,1),this.params.virtual.cache&&delete this.virtual.cache[e],e<t&&(t-=1),t=Math.max(t,0);this.virtual.update(!0),this.slideTo(t,0)}},removeAllSlides:function(){this.virtual.slides=[],this.params.virtual.cache&&(this.virtual.cache={}),this.virtual.update(!0),this.slideTo(0,0)}},ie={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,addSlidesBefore:0,addSlidesAfter:0}},create:function(){d.extend(this,{virtual:{update:te.update.bind(this),appendSlide:te.appendSlide.bind(this),prependSlide:te.prependSlide.bind(this),removeSlide:te.removeSlide.bind(this),removeAllSlides:te.removeAllSlides.bind(this),renderSlide:te.renderSlide.bind(this),slides:this.params.virtual.slides,cache:{}}})},on:{beforeInit:function(){if(this.params.virtual.enabled){this.classNames.push(this.params.containerModifierClass+"virtual");var e={watchSlidesProgress:!0};d.extend(this.params,e),d.extend(this.originalParams,e),this.params.initialSlide||this.virtual.update()}},setTranslate:function(){this.params.virtual.enabled&&this.virtual.update()}}},se={handle:function(e){var t=this.rtlTranslate,s=e;s.originalEvent&&(s=s.originalEvent);var r=s.keyCode||s.charCode,n=this.params.keyboard.pageUpDown,o=n&&33===r,l=n&&34===r,d=37===r,h=39===r,p=38===r,c=40===r;if(!this.allowSlideNext&&(this.isHorizontal()&&h||this.isVertical()&&c||l))return!1;if(!this.allowSlidePrev&&(this.isHorizontal()&&d||this.isVertical()&&p||o))return!1;if(!(s.shiftKey||s.altKey||s.ctrlKey||s.metaKey||i.activeElement&&i.activeElement.nodeName&&("input"===i.activeElement.nodeName.toLowerCase()||"textarea"===i.activeElement.nodeName.toLowerCase()))){if(this.params.keyboard.onlyInViewport&&(o||l||d||h||p||c)){var u=!1;if(this.$el.parents("."+this.params.slideClass).length>0&&0===this.$el.parents("."+this.params.slideActiveClass).length)return;var v=a.innerWidth,f=a.innerHeight,m=this.$el.offset();t&&(m.left-=this.$el[0].scrollLeft);for(var g=[[m.left,m.top],[m.left+this.width,m.top],[m.left,m.top+this.height],[m.left+this.width,m.top+this.height]],b=0;b<g.length;b+=1){var w=g[b];w[0]>=0&&w[0]<=v&&w[1]>=0&&w[1]<=f&&(u=!0)}if(!u)return}this.isHorizontal()?((o||l||d||h)&&(s.preventDefault?s.preventDefault():s.returnValue=!1),((l||h)&&!t||(o||d)&&t)&&this.slideNext(),((o||d)&&!t||(l||h)&&t)&&this.slidePrev()):((o||l||p||c)&&(s.preventDefault?s.preventDefault():s.returnValue=!1),(l||c)&&this.slideNext(),(o||p)&&this.slidePrev()),this.emit("keyPress",r)}},enable:function(){this.keyboard.enabled||(n(i).on("keydown",this.keyboard.handle),this.keyboard.enabled=!0)},disable:function(){this.keyboard.enabled&&(n(i).off("keydown",this.keyboard.handle),this.keyboard.enabled=!1)}},ae={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}},create:function(){d.extend(this,{keyboard:{enabled:!1,enable:se.enable.bind(this),disable:se.disable.bind(this),handle:se.handle.bind(this)}})},on:{init:function(){this.params.keyboard.enabled&&this.keyboard.enable()},destroy:function(){this.keyboard.enabled&&this.keyboard.disable()}}};var re={lastScrollTime:d.now(),lastEventBeforeSnap:void 0,recentWheelEvents:[],event:function(){return a.navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var e="onwheel"in i;if(!e){var t=i.createElement("div");t.setAttribute("onwheel","return;"),e="function"==typeof t.onwheel}return!e&&i.implementation&&i.implementation.hasFeature&&!0!==i.implementation.hasFeature("","")&&(e=i.implementation.hasFeature("Events.wheel","3.0")),e}()?"wheel":"mousewheel"},normalize:function(e){var t=0,i=0,s=0,a=0;return"detail"in e&&(i=e.detail),"wheelDelta"in e&&(i=-e.wheelDelta/120),"wheelDeltaY"in e&&(i=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=i,i=0),s=10*t,a=10*i,"deltaY"in e&&(a=e.deltaY),"deltaX"in e&&(s=e.deltaX),e.shiftKey&&!s&&(s=a,a=0),(s||a)&&e.deltaMode&&(1===e.deltaMode?(s*=40,a*=40):(s*=800,a*=800)),s&&!t&&(t=s<1?-1:1),a&&!i&&(i=a<1?-1:1),{spinX:t,spinY:i,pixelX:s,pixelY:a}},handleMouseEnter:function(){this.mouseEntered=!0},handleMouseLeave:function(){this.mouseEntered=!1},handle:function(e){var t=e,i=this,s=i.params.mousewheel;i.params.cssMode&&t.preventDefault();var a=i.$el;if("container"!==i.params.mousewheel.eventsTarged&&(a=n(i.params.mousewheel.eventsTarged)),!i.mouseEntered&&!a[0].contains(t.target)&&!s.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var r=0,o=i.rtlTranslate?-1:1,l=re.normalize(t);if(s.forceToAxis)if(i.isHorizontal()){if(!(Math.abs(l.pixelX)>Math.abs(l.pixelY)))return!0;r=-l.pixelX*o}else{if(!(Math.abs(l.pixelY)>Math.abs(l.pixelX)))return!0;r=-l.pixelY}else r=Math.abs(l.pixelX)>Math.abs(l.pixelY)?-l.pixelX*o:-l.pixelY;if(0===r)return!0;if(s.invert&&(r=-r),i.params.freeMode){var h={time:d.now(),delta:Math.abs(r),direction:Math.sign(r)},p=i.mousewheel.lastEventBeforeSnap,c=p&&h.time<p.time+500&&h.delta<=p.delta&&h.direction===p.direction;if(!c){i.mousewheel.lastEventBeforeSnap=void 0,i.params.loop&&i.loopFix();var u=i.getTranslate()+r*s.sensitivity,v=i.isBeginning,f=i.isEnd;if(u>=i.minTranslate()&&(u=i.minTranslate()),u<=i.maxTranslate()&&(u=i.maxTranslate()),i.setTransition(0),i.setTranslate(u),i.updateProgress(),i.updateActiveIndex(),i.updateSlidesClasses(),(!v&&i.isBeginning||!f&&i.isEnd)&&i.updateSlidesClasses(),i.params.freeModeSticky){clearTimeout(i.mousewheel.timeout),i.mousewheel.timeout=void 0;var m=i.mousewheel.recentWheelEvents;m.length>=15&&m.shift();var g=m.length?m[m.length-1]:void 0,b=m[0];if(m.push(h),g&&(h.delta>g.delta||h.direction!==g.direction))m.splice(0);else if(m.length>=15&&h.time-b.time<500&&b.delta-h.delta>=1&&h.delta<=6){var w=r>0?.8:.2;i.mousewheel.lastEventBeforeSnap=h,m.splice(0),i.mousewheel.timeout=d.nextTick((function(){i.slideToClosest(i.params.speed,!0,void 0,w)}),0)}i.mousewheel.timeout||(i.mousewheel.timeout=d.nextTick((function(){i.mousewheel.lastEventBeforeSnap=h,m.splice(0),i.slideToClosest(i.params.speed,!0,void 0,.5)}),500))}if(c||i.emit("scroll",t),i.params.autoplay&&i.params.autoplayDisableOnInteraction&&i.autoplay.stop(),u===i.minTranslate()||u===i.maxTranslate())return!0}}else{var y={time:d.now(),delta:Math.abs(r),direction:Math.sign(r),raw:e},x=i.mousewheel.recentWheelEvents;x.length>=2&&x.shift();var E=x.length?x[x.length-1]:void 0;if(x.push(y),E?(y.direction!==E.direction||y.delta>E.delta||y.time>E.time+150)&&i.mousewheel.animateSlider(y):i.mousewheel.animateSlider(y),i.mousewheel.releaseScroll(y))return!0}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1},animateSlider:function(e){return e.delta>=6&&d.now()-this.mousewheel.lastScrollTime<60||(e.direction<0?this.isEnd&&!this.params.loop||this.animating||(this.slideNext(),this.emit("scroll",e.raw)):this.isBeginning&&!this.params.loop||this.animating||(this.slidePrev(),this.emit("scroll",e.raw)),this.mousewheel.lastScrollTime=(new a.Date).getTime(),!1)},releaseScroll:function(e){var t=this.params.mousewheel;if(e.direction<0){if(this.isEnd&&!this.params.loop&&t.releaseOnEdges)return!0}else if(this.isBeginning&&!this.params.loop&&t.releaseOnEdges)return!0;return!1},enable:function(){var e=re.event();if(this.params.cssMode)return this.wrapperEl.removeEventListener(e,this.mousewheel.handle),!0;if(!e)return!1;if(this.mousewheel.enabled)return!1;var t=this.$el;return"container"!==this.params.mousewheel.eventsTarged&&(t=n(this.params.mousewheel.eventsTarged)),t.on("mouseenter",this.mousewheel.handleMouseEnter),t.on("mouseleave",this.mousewheel.handleMouseLeave),t.on(e,this.mousewheel.handle),this.mousewheel.enabled=!0,!0},disable:function(){var e=re.event();if(this.params.cssMode)return this.wrapperEl.addEventListener(e,this.mousewheel.handle),!0;if(!e)return!1;if(!this.mousewheel.enabled)return!1;var t=this.$el;return"container"!==this.params.mousewheel.eventsTarged&&(t=n(this.params.mousewheel.eventsTarged)),t.off(e,this.mousewheel.handle),this.mousewheel.enabled=!1,!0}},ne={update:function(){var e=this.params.navigation;if(!this.params.loop){var t=this.navigation,i=t.$nextEl,s=t.$prevEl;s&&s.length>0&&(this.isBeginning?s.addClass(e.disabledClass):s.removeClass(e.disabledClass),s[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](e.lockClass)),i&&i.length>0&&(this.isEnd?i.addClass(e.disabledClass):i.removeClass(e.disabledClass),i[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](e.lockClass))}},onPrevClick:function(e){e.preventDefault(),this.isBeginning&&!this.params.loop||this.slidePrev()},onNextClick:function(e){e.preventDefault(),this.isEnd&&!this.params.loop||this.slideNext()},init:function(){var e,t,i=this.params.navigation;(i.nextEl||i.prevEl)&&(i.nextEl&&(e=n(i.nextEl),this.params.uniqueNavElements&&"string"==typeof i.nextEl&&e.length>1&&1===this.$el.find(i.nextEl).length&&(e=this.$el.find(i.nextEl))),i.prevEl&&(t=n(i.prevEl),this.params.uniqueNavElements&&"string"==typeof i.prevEl&&t.length>1&&1===this.$el.find(i.prevEl).length&&(t=this.$el.find(i.prevEl))),e&&e.length>0&&e.on("click",this.navigation.onNextClick),t&&t.length>0&&t.on("click",this.navigation.onPrevClick),d.extend(this.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}))},destroy:function(){var e=this.navigation,t=e.$nextEl,i=e.$prevEl;t&&t.length&&(t.off("click",this.navigation.onNextClick),t.removeClass(this.params.navigation.disabledClass)),i&&i.length&&(i.off("click",this.navigation.onPrevClick),i.removeClass(this.params.navigation.disabledClass))}},oe={update:function(){var e=this.rtl,t=this.params.pagination;if(t.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var i,s=this.virtual&&this.params.virtual.enabled?this.virtual.slides.length:this.slides.length,a=this.pagination.$el,r=this.params.loop?Math.ceil((s-2*this.loopedSlides)/this.params.slidesPerGroup):this.snapGrid.length;if(this.params.loop?((i=Math.ceil((this.activeIndex-this.loopedSlides)/this.params.slidesPerGroup))>s-1-2*this.loopedSlides&&(i-=s-2*this.loopedSlides),i>r-1&&(i-=r),i<0&&"bullets"!==this.params.paginationType&&(i=r+i)):i=void 0!==this.snapIndex?this.snapIndex:this.activeIndex||0,"bullets"===t.type&&this.pagination.bullets&&this.pagination.bullets.length>0){var o,l,d,h=this.pagination.bullets;if(t.dynamicBullets&&(this.pagination.bulletSize=h.eq(0)[this.isHorizontal()?"outerWidth":"outerHeight"](!0),a.css(this.isHorizontal()?"width":"height",this.pagination.bulletSize*(t.dynamicMainBullets+4)+"px"),t.dynamicMainBullets>1&&void 0!==this.previousIndex&&(this.pagination.dynamicBulletIndex+=i-this.previousIndex,this.pagination.dynamicBulletIndex>t.dynamicMainBullets-1?this.pagination.dynamicBulletIndex=t.dynamicMainBullets-1:this.pagination.dynamicBulletIndex<0&&(this.pagination.dynamicBulletIndex=0)),o=i-this.pagination.dynamicBulletIndex,d=((l=o+(Math.min(h.length,t.dynamicMainBullets)-1))+o)/2),h.removeClass(t.bulletActiveClass+" "+t.bulletActiveClass+"-next "+t.bulletActiveClass+"-next-next "+t.bulletActiveClass+"-prev "+t.bulletActiveClass+"-prev-prev "+t.bulletActiveClass+"-main"),a.length>1)h.each((function(e,s){var a=n(s),r=a.index();r===i&&a.addClass(t.bulletActiveClass),t.dynamicBullets&&(r>=o&&r<=l&&a.addClass(t.bulletActiveClass+"-main"),r===o&&a.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),r===l&&a.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next"))}));else{var p=h.eq(i),c=p.index();if(p.addClass(t.bulletActiveClass),t.dynamicBullets){for(var u=h.eq(o),v=h.eq(l),f=o;f<=l;f+=1)h.eq(f).addClass(t.bulletActiveClass+"-main");if(this.params.loop)if(c>=h.length-t.dynamicMainBullets){for(var m=t.dynamicMainBullets;m>=0;m-=1)h.eq(h.length-m).addClass(t.bulletActiveClass+"-main");h.eq(h.length-t.dynamicMainBullets-1).addClass(t.bulletActiveClass+"-prev")}else u.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),v.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next");else u.prev().addClass(t.bulletActiveClass+"-prev").prev().addClass(t.bulletActiveClass+"-prev-prev"),v.next().addClass(t.bulletActiveClass+"-next").next().addClass(t.bulletActiveClass+"-next-next")}}if(t.dynamicBullets){var g=Math.min(h.length,t.dynamicMainBullets+4),b=(this.pagination.bulletSize*g-this.pagination.bulletSize)/2-d*this.pagination.bulletSize,w=e?"right":"left";h.css(this.isHorizontal()?w:"top",b+"px")}}if("fraction"===t.type&&(a.find("."+t.currentClass).text(t.formatFractionCurrent(i+1)),a.find("."+t.totalClass).text(t.formatFractionTotal(r))),"progressbar"===t.type){var y;y=t.progressbarOpposite?this.isHorizontal()?"vertical":"horizontal":this.isHorizontal()?"horizontal":"vertical";var x=(i+1)/r,E=1,T=1;"horizontal"===y?E=x:T=x,a.find("."+t.progressbarFillClass).transform("translate3d(0,0,0) scaleX("+E+") scaleY("+T+")").transition(this.params.speed)}"custom"===t.type&&t.renderCustom?(a.html(t.renderCustom(this,i+1,r)),this.emit("paginationRender",this,a[0])):this.emit("paginationUpdate",this,a[0]),a[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](t.lockClass)}},render:function(){var e=this.params.pagination;if(e.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var t=this.virtual&&this.params.virtual.enabled?this.virtual.slides.length:this.slides.length,i=this.pagination.$el,s="";if("bullets"===e.type){for(var a=this.params.loop?Math.ceil((t-2*this.loopedSlides)/this.params.slidesPerGroup):this.snapGrid.length,r=0;r<a;r+=1)e.renderBullet?s+=e.renderBullet.call(this,r,e.bulletClass):s+="<"+e.bulletElement+' class="'+e.bulletClass+'"></'+e.bulletElement+">";i.html(s),this.pagination.bullets=i.find("."+e.bulletClass)}"fraction"===e.type&&(s=e.renderFraction?e.renderFraction.call(this,e.currentClass,e.totalClass):'<span class="'+e.currentClass+'"></span> / <span class="'+e.totalClass+'"></span>',i.html(s)),"progressbar"===e.type&&(s=e.renderProgressbar?e.renderProgressbar.call(this,e.progressbarFillClass):'<span class="'+e.progressbarFillClass+'"></span>',i.html(s)),"custom"!==e.type&&this.emit("paginationRender",this.pagination.$el[0])}},init:function(){var e=this,t=e.params.pagination;if(t.el){var i=n(t.el);0!==i.length&&(e.params.uniqueNavElements&&"string"==typeof t.el&&i.length>1&&(i=e.$el.find(t.el)),"bullets"===t.type&&t.clickable&&i.addClass(t.clickableClass),i.addClass(t.modifierClass+t.type),"bullets"===t.type&&t.dynamicBullets&&(i.addClass(""+t.modifierClass+t.type+"-dynamic"),e.pagination.dynamicBulletIndex=0,t.dynamicMainBullets<1&&(t.dynamicMainBullets=1)),"progressbar"===t.type&&t.progressbarOpposite&&i.addClass(t.progressbarOppositeClass),t.clickable&&i.on("click","."+t.bulletClass,(function(t){t.preventDefault();var i=n(this).index()*e.params.slidesPerGroup;e.params.loop&&(i+=e.loopedSlides),e.slideTo(i)})),d.extend(e.pagination,{$el:i,el:i[0]}))}},destroy:function(){var e=this.params.pagination;if(e.el&&this.pagination.el&&this.pagination.$el&&0!==this.pagination.$el.length){var t=this.pagination.$el;t.removeClass(e.hiddenClass),t.removeClass(e.modifierClass+e.type),this.pagination.bullets&&this.pagination.bullets.removeClass(e.bulletActiveClass),e.clickable&&t.off("click","."+e.bulletClass)}}},le={setTranslate:function(){if(this.params.scrollbar.el&&this.scrollbar.el){var e=this.scrollbar,t=this.rtlTranslate,i=this.progress,s=e.dragSize,a=e.trackSize,r=e.$dragEl,n=e.$el,o=this.params.scrollbar,l=s,d=(a-s)*i;t?(d=-d)>0?(l=s-d,d=0):-d+s>a&&(l=a+d):d<0?(l=s+d,d=0):d+s>a&&(l=a-d),this.isHorizontal()?(r.transform("translate3d("+d+"px, 0, 0)"),r[0].style.width=l+"px"):(r.transform("translate3d(0px, "+d+"px, 0)"),r[0].style.height=l+"px"),o.hide&&(clearTimeout(this.scrollbar.timeout),n[0].style.opacity=1,this.scrollbar.timeout=setTimeout((function(){n[0].style.opacity=0,n.transition(400)}),1e3))}},setTransition:function(e){this.params.scrollbar.el&&this.scrollbar.el&&this.scrollbar.$dragEl.transition(e)},updateSize:function(){if(this.params.scrollbar.el&&this.scrollbar.el){var e=this.scrollbar,t=e.$dragEl,i=e.$el;t[0].style.width="",t[0].style.height="";var s,a=this.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,r=this.size/this.virtualSize,n=r*(a/this.size);s="auto"===this.params.scrollbar.dragSize?a*r:parseInt(this.params.scrollbar.dragSize,10),this.isHorizontal()?t[0].style.width=s+"px":t[0].style.height=s+"px",i[0].style.display=r>=1?"none":"",this.params.scrollbar.hide&&(i[0].style.opacity=0),d.extend(e,{trackSize:a,divider:r,moveDivider:n,dragSize:s}),e.$el[this.params.watchOverflow&&this.isLocked?"addClass":"removeClass"](this.params.scrollbar.lockClass)}},getPointerPosition:function(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY},setDragPosition:function(e){var t,i=this.scrollbar,s=this.rtlTranslate,a=i.$el,r=i.dragSize,n=i.trackSize,o=i.dragStartPos;t=(i.getPointerPosition(e)-a.offset()[this.isHorizontal()?"left":"top"]-(null!==o?o:r/2))/(n-r),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var l=this.minTranslate()+(this.maxTranslate()-this.minTranslate())*t;this.updateProgress(l),this.setTranslate(l),this.updateActiveIndex(),this.updateSlidesClasses()},onDragStart:function(e){var t=this.params.scrollbar,i=this.scrollbar,s=this.$wrapperEl,a=i.$el,r=i.$dragEl;this.scrollbar.isTouched=!0,this.scrollbar.dragStartPos=e.target===r[0]||e.target===r?i.getPointerPosition(e)-e.target.getBoundingClientRect()[this.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),r.transition(100),i.setDragPosition(e),clearTimeout(this.scrollbar.dragTimeout),a.transition(0),t.hide&&a.css("opacity",1),this.params.cssMode&&this.$wrapperEl.css("scroll-snap-type","none"),this.emit("scrollbarDragStart",e)},onDragMove:function(e){var t=this.scrollbar,i=this.$wrapperEl,s=t.$el,a=t.$dragEl;this.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,t.setDragPosition(e),i.transition(0),s.transition(0),a.transition(0),this.emit("scrollbarDragMove",e))},onDragEnd:function(e){var t=this.params.scrollbar,i=this.scrollbar,s=this.$wrapperEl,a=i.$el;this.scrollbar.isTouched&&(this.scrollbar.isTouched=!1,this.params.cssMode&&(this.$wrapperEl.css("scroll-snap-type",""),s.transition("")),t.hide&&(clearTimeout(this.scrollbar.dragTimeout),this.scrollbar.dragTimeout=d.nextTick((function(){a.css("opacity",0),a.transition(400)}),1e3)),this.emit("scrollbarDragEnd",e),t.snapOnRelease&&this.slideToClosest())},enableDraggable:function(){if(this.params.scrollbar.el){var e=this.scrollbar,t=this.touchEventsTouch,s=this.touchEventsDesktop,a=this.params,r=e.$el[0],n=!(!h.passiveListener||!a.passiveListeners)&&{passive:!1,capture:!1},o=!(!h.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};h.touch?(r.addEventListener(t.start,this.scrollbar.onDragStart,n),r.addEventListener(t.move,this.scrollbar.onDragMove,n),r.addEventListener(t.end,this.scrollbar.onDragEnd,o)):(r.addEventListener(s.start,this.scrollbar.onDragStart,n),i.addEventListener(s.move,this.scrollbar.onDragMove,n),i.addEventListener(s.end,this.scrollbar.onDragEnd,o))}},disableDraggable:function(){if(this.params.scrollbar.el){var e=this.scrollbar,t=this.touchEventsTouch,s=this.touchEventsDesktop,a=this.params,r=e.$el[0],n=!(!h.passiveListener||!a.passiveListeners)&&{passive:!1,capture:!1},o=!(!h.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};h.touch?(r.removeEventListener(t.start,this.scrollbar.onDragStart,n),r.removeEventListener(t.move,this.scrollbar.onDragMove,n),r.removeEventListener(t.end,this.scrollbar.onDragEnd,o)):(r.removeEventListener(s.start,this.scrollbar.onDragStart,n),i.removeEventListener(s.move,this.scrollbar.onDragMove,n),i.removeEventListener(s.end,this.scrollbar.onDragEnd,o))}},init:function(){if(this.params.scrollbar.el){var e=this.scrollbar,t=this.$el,i=this.params.scrollbar,s=n(i.el);this.params.uniqueNavElements&&"string"==typeof i.el&&s.length>1&&1===t.find(i.el).length&&(s=t.find(i.el));var a=s.find("."+this.params.scrollbar.dragClass);0===a.length&&(a=n('<div class="'+this.params.scrollbar.dragClass+'"></div>'),s.append(a)),d.extend(e,{$el:s,el:s[0],$dragEl:a,dragEl:a[0]}),i.draggable&&e.enableDraggable()}},destroy:function(){this.scrollbar.disableDraggable()}},de={setTransform:function(e,t){var i=this.rtl,s=n(e),a=i?-1:1,r=s.attr("data-swiper-parallax")||"0",o=s.attr("data-swiper-parallax-x"),l=s.attr("data-swiper-parallax-y"),d=s.attr("data-swiper-parallax-scale"),h=s.attr("data-swiper-parallax-opacity");if(o||l?(o=o||"0",l=l||"0"):this.isHorizontal()?(o=r,l="0"):(l=r,o="0"),o=o.indexOf("%")>=0?parseInt(o,10)*t*a+"%":o*t*a+"px",l=l.indexOf("%")>=0?parseInt(l,10)*t+"%":l*t+"px",null!=h){var p=h-(h-1)*(1-Math.abs(t));s[0].style.opacity=p}if(null==d)s.transform("translate3d("+o+", "+l+", 0px)");else{var c=d-(d-1)*(1-Math.abs(t));s.transform("translate3d("+o+", "+l+", 0px) scale("+c+")")}},setTranslate:function(){var e=this,t=e.$el,i=e.slides,s=e.progress,a=e.snapGrid;t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t,i){e.parallax.setTransform(i,s)})),i.each((function(t,i){var r=i.progress;e.params.slidesPerGroup>1&&"auto"!==e.params.slidesPerView&&(r+=Math.ceil(t/2)-s*(a.length-1)),r=Math.min(Math.max(r,-1),1),n(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t,i){e.parallax.setTransform(i,r)}))}))},setTransition:function(e){void 0===e&&(e=this.params.speed);this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t,i){var s=n(i),a=parseInt(s.attr("data-swiper-parallax-duration"),10)||e;0===e&&(a=0),s.transition(a)}))}},he={getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,i=e.targetTouches[0].pageY,s=e.targetTouches[1].pageX,a=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(s-t,2)+Math.pow(a-i,2))},onGestureStart:function(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(i.fakeGestureTouched=!1,i.fakeGestureMoved=!1,!h.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;i.fakeGestureTouched=!0,s.scaleStart=he.getDistanceBetweenTouches(e)}s.$slideEl&&s.$slideEl.length||(s.$slideEl=n(e.target).closest("."+this.params.slideClass),0===s.$slideEl.length&&(s.$slideEl=this.slides.eq(this.activeIndex)),s.$imageEl=s.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),s.$imageWrapEl=s.$imageEl.parent("."+t.containerClass),s.maxRatio=s.$imageWrapEl.attr("data-swiper-zoom")||t.maxRatio,0!==s.$imageWrapEl.length)?(s.$imageEl&&s.$imageEl.transition(0),this.zoom.isScaling=!0):s.$imageEl=void 0},onGestureChange:function(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(!h.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;i.fakeGestureMoved=!0,s.scaleMove=he.getDistanceBetweenTouches(e)}s.$imageEl&&0!==s.$imageEl.length&&(i.scale=h.gestures?e.scale*i.currentScale:s.scaleMove/s.scaleStart*i.currentScale,i.scale>s.maxRatio&&(i.scale=s.maxRatio-1+Math.pow(i.scale-s.maxRatio+1,.5)),i.scale<t.minRatio&&(i.scale=t.minRatio+1-Math.pow(t.minRatio-i.scale+1,.5)),s.$imageEl.transform("translate3d(0,0,0) scale("+i.scale+")"))},onGestureEnd:function(e){var t=this.params.zoom,i=this.zoom,s=i.gesture;if(!h.gestures){if(!i.fakeGestureTouched||!i.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!A.android)return;i.fakeGestureTouched=!1,i.fakeGestureMoved=!1}s.$imageEl&&0!==s.$imageEl.length&&(i.scale=Math.max(Math.min(i.scale,s.maxRatio),t.minRatio),s.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale("+i.scale+")"),i.currentScale=i.scale,i.isScaling=!1,1===i.scale&&(s.$slideEl=void 0))},onTouchStart:function(e){var t=this.zoom,i=t.gesture,s=t.image;i.$imageEl&&0!==i.$imageEl.length&&(s.isTouched||(A.android&&e.cancelable&&e.preventDefault(),s.isTouched=!0,s.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))},onTouchMove:function(e){var t=this.zoom,i=t.gesture,s=t.image,a=t.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(this.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=d.getTranslate(i.$imageWrapEl[0],"x")||0,s.startY=d.getTranslate(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0),this.rtl&&(s.startX=-s.startX,s.startY=-s.startY));var r=s.width*t.scale,n=s.height*t.scale;if(!(r<i.slideWidth&&n<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-r/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-n/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!t.isScaling){if(this.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!this.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),a.prevPositionX||(a.prevPositionX=s.touchesCurrent.x),a.prevPositionY||(a.prevPositionY=s.touchesCurrent.y),a.prevTime||(a.prevTime=Date.now()),a.x=(s.touchesCurrent.x-a.prevPositionX)/(Date.now()-a.prevTime)/2,a.y=(s.touchesCurrent.y-a.prevPositionY)/(Date.now()-a.prevTime)/2,Math.abs(s.touchesCurrent.x-a.prevPositionX)<2&&(a.x=0),Math.abs(s.touchesCurrent.y-a.prevPositionY)<2&&(a.y=0),a.prevPositionX=s.touchesCurrent.x,a.prevPositionY=s.touchesCurrent.y,a.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)")}}},onTouchEnd:function(){var e=this.zoom,t=e.gesture,i=e.image,s=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!i.isTouched||!i.isMoved)return i.isTouched=!1,void(i.isMoved=!1);i.isTouched=!1,i.isMoved=!1;var a=300,r=300,n=s.x*a,o=i.currentX+n,l=s.y*r,d=i.currentY+l;0!==s.x&&(a=Math.abs((o-i.currentX)/s.x)),0!==s.y&&(r=Math.abs((d-i.currentY)/s.y));var h=Math.max(a,r);i.currentX=o,i.currentY=d;var p=i.width*e.scale,c=i.height*e.scale;i.minX=Math.min(t.slideWidth/2-p/2,0),i.maxX=-i.minX,i.minY=Math.min(t.slideHeight/2-c/2,0),i.maxY=-i.minY,i.currentX=Math.max(Math.min(i.currentX,i.maxX),i.minX),i.currentY=Math.max(Math.min(i.currentY,i.maxY),i.minY),t.$imageWrapEl.transition(h).transform("translate3d("+i.currentX+"px, "+i.currentY+"px,0)")}},onTransitionEnd:function(){var e=this.zoom,t=e.gesture;t.$slideEl&&this.previousIndex!==this.activeIndex&&(t.$imageEl&&t.$imageEl.transform("translate3d(0,0,0) scale(1)"),t.$imageWrapEl&&t.$imageWrapEl.transform("translate3d(0,0,0)"),e.scale=1,e.currentScale=1,t.$slideEl=void 0,t.$imageEl=void 0,t.$imageWrapEl=void 0)},toggle:function(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e)},in:function(e){var t,i,s,a,r,n,o,l,d,h,p,c,u,v,f,m,g=this.zoom,b=this.params.zoom,w=g.gesture,y=g.image;(w.$slideEl||(this.params.virtual&&this.params.virtual.enabled&&this.virtual?w.$slideEl=this.$wrapperEl.children("."+this.params.slideActiveClass):w.$slideEl=this.slides.eq(this.activeIndex),w.$imageEl=w.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),w.$imageWrapEl=w.$imageEl.parent("."+b.containerClass)),w.$imageEl&&0!==w.$imageEl.length)&&(w.$slideEl.addClass(""+b.zoomedSlideClass),void 0===y.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,i="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=y.touchesStart.x,i=y.touchesStart.y),g.scale=w.$imageWrapEl.attr("data-swiper-zoom")||b.maxRatio,g.currentScale=w.$imageWrapEl.attr("data-swiper-zoom")||b.maxRatio,e?(f=w.$slideEl[0].offsetWidth,m=w.$slideEl[0].offsetHeight,s=w.$slideEl.offset().left+f/2-t,a=w.$slideEl.offset().top+m/2-i,o=w.$imageEl[0].offsetWidth,l=w.$imageEl[0].offsetHeight,d=o*g.scale,h=l*g.scale,u=-(p=Math.min(f/2-d/2,0)),v=-(c=Math.min(m/2-h/2,0)),(r=s*g.scale)<p&&(r=p),r>u&&(r=u),(n=a*g.scale)<c&&(n=c),n>v&&(n=v)):(r=0,n=0),w.$imageWrapEl.transition(300).transform("translate3d("+r+"px, "+n+"px,0)"),w.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+g.scale+")"))},out:function(){var e=this.zoom,t=this.params.zoom,i=e.gesture;i.$slideEl||(this.params.virtual&&this.params.virtual.enabled&&this.virtual?i.$slideEl=this.$wrapperEl.children("."+this.params.slideActiveClass):i.$slideEl=this.slides.eq(this.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),i.$imageWrapEl=i.$imageEl.parent("."+t.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&(e.scale=1,e.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+t.zoomedSlideClass),i.$slideEl=void 0)},enable:function(){var e=this.zoom;if(!e.enabled){e.enabled=!0;var t=!("touchstart"!==this.touchEvents.start||!h.passiveListener||!this.params.passiveListeners)&&{passive:!0,capture:!1},i=!h.passiveListener||{passive:!1,capture:!0},s="."+this.params.slideClass;h.gestures?(this.$wrapperEl.on("gesturestart",s,e.onGestureStart,t),this.$wrapperEl.on("gesturechange",s,e.onGestureChange,t),this.$wrapperEl.on("gestureend",s,e.onGestureEnd,t)):"touchstart"===this.touchEvents.start&&(this.$wrapperEl.on(this.touchEvents.start,s,e.onGestureStart,t),this.$wrapperEl.on(this.touchEvents.move,s,e.onGestureChange,i),this.$wrapperEl.on(this.touchEvents.end,s,e.onGestureEnd,t),this.touchEvents.cancel&&this.$wrapperEl.on(this.touchEvents.cancel,s,e.onGestureEnd,t)),this.$wrapperEl.on(this.touchEvents.move,"."+this.params.zoom.containerClass,e.onTouchMove,i)}},disable:function(){var e=this.zoom;if(e.enabled){this.zoom.enabled=!1;var t=!("touchstart"!==this.touchEvents.start||!h.passiveListener||!this.params.passiveListeners)&&{passive:!0,capture:!1},i=!h.passiveListener||{passive:!1,capture:!0},s="."+this.params.slideClass;h.gestures?(this.$wrapperEl.off("gesturestart",s,e.onGestureStart,t),this.$wrapperEl.off("gesturechange",s,e.onGestureChange,t),this.$wrapperEl.off("gestureend",s,e.onGestureEnd,t)):"touchstart"===this.touchEvents.start&&(this.$wrapperEl.off(this.touchEvents.start,s,e.onGestureStart,t),this.$wrapperEl.off(this.touchEvents.move,s,e.onGestureChange,i),this.$wrapperEl.off(this.touchEvents.end,s,e.onGestureEnd,t),this.touchEvents.cancel&&this.$wrapperEl.off(this.touchEvents.cancel,s,e.onGestureEnd,t)),this.$wrapperEl.off(this.touchEvents.move,"."+this.params.zoom.containerClass,e.onTouchMove,i)}}},pe={loadInSlide:function(e,t){void 0===t&&(t=!0);var i=this,s=i.params.lazy;if(void 0!==e&&0!==i.slides.length){var a=i.virtual&&i.params.virtual.enabled?i.$wrapperEl.children("."+i.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):i.slides.eq(e),r=a.find("."+s.elementClass+":not(."+s.loadedClass+"):not(."+s.loadingClass+")");!a.hasClass(s.elementClass)||a.hasClass(s.loadedClass)||a.hasClass(s.loadingClass)||(r=r.add(a[0])),0!==r.length&&r.each((function(e,r){var o=n(r);o.addClass(s.loadingClass);var l=o.attr("data-background"),d=o.attr("data-src"),h=o.attr("data-srcset"),p=o.attr("data-sizes"),c=o.parent("picture");i.loadImage(o[0],d||l,h,p,!1,(function(){if(null!=i&&i&&(!i||i.params)&&!i.destroyed){if(l?(o.css("background-image",'url("'+l+'")'),o.removeAttr("data-background")):(h&&(o.attr("srcset",h),o.removeAttr("data-srcset")),p&&(o.attr("sizes",p),o.removeAttr("data-sizes")),c.length&&c.children("source").each((function(e,t){var i=n(t);i.attr("data-srcset")&&(i.attr("srcset",i.attr("data-srcset")),i.removeAttr("data-srcset"))})),d&&(o.attr("src",d),o.removeAttr("data-src"))),o.addClass(s.loadedClass).removeClass(s.loadingClass),a.find("."+s.preloaderClass).remove(),i.params.loop&&t){var e=a.attr("data-swiper-slide-index");if(a.hasClass(i.params.slideDuplicateClass)){var r=i.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+i.params.slideDuplicateClass+")");i.lazy.loadInSlide(r.index(),!1)}else{var u=i.$wrapperEl.children("."+i.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');i.lazy.loadInSlide(u.index(),!1)}}i.emit("lazyImageReady",a[0],o[0]),i.params.autoHeight&&i.updateAutoHeight()}})),i.emit("lazyImageLoad",a[0],o[0])}))}},load:function(){var e=this,t=e.$wrapperEl,i=e.params,s=e.slides,a=e.activeIndex,r=e.virtual&&i.virtual.enabled,o=i.lazy,l=i.slidesPerView;function d(e){if(r){if(t.children("."+i.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0}else if(s[e])return!0;return!1}function h(e){return r?n(e).attr("data-swiper-slide-index"):n(e).index()}if("auto"===l&&(l=0),e.lazy.initialImageLoaded||(e.lazy.initialImageLoaded=!0),e.params.watchSlidesVisibility)t.children("."+i.slideVisibleClass).each((function(t,i){var s=r?n(i).attr("data-swiper-slide-index"):n(i).index();e.lazy.loadInSlide(s)}));else if(l>1)for(var p=a;p<a+l;p+=1)d(p)&&e.lazy.loadInSlide(p);else e.lazy.loadInSlide(a);if(o.loadPrevNext)if(l>1||o.loadPrevNextAmount&&o.loadPrevNextAmount>1){for(var c=o.loadPrevNextAmount,u=l,v=Math.min(a+u+Math.max(c,u),s.length),f=Math.max(a-Math.max(u,c),0),m=a+l;m<v;m+=1)d(m)&&e.lazy.loadInSlide(m);for(var g=f;g<a;g+=1)d(g)&&e.lazy.loadInSlide(g)}else{var b=t.children("."+i.slideNextClass);b.length>0&&e.lazy.loadInSlide(h(b));var w=t.children("."+i.slidePrevClass);w.length>0&&e.lazy.loadInSlide(h(w))}}},ce={LinearSpline:function(e,t){var i,s,a,r,n,o=function(e,t){for(s=-1,i=e.length;i-s>1;)e[a=i+s>>1]<=t?s=a:i=a;return i};return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=o(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0},this},getInterpolateFunction:function(e){this.controller.spline||(this.controller.spline=this.params.loop?new ce.LinearSpline(this.slidesGrid,e.slidesGrid):new ce.LinearSpline(this.snapGrid,e.snapGrid))},setTranslate:function(e,t){var i,s,a=this,r=a.controller.control;function n(e){var t=a.rtlTranslate?-a.translate:a.translate;"slide"===a.params.controller.by&&(a.controller.getInterpolateFunction(e),s=-a.controller.spline.interpolate(-t)),s&&"container"!==a.params.controller.by||(i=(e.maxTranslate()-e.minTranslate())/(a.maxTranslate()-a.minTranslate()),s=(t-a.minTranslate())*i+e.minTranslate()),a.params.controller.inverse&&(s=e.maxTranslate()-s),e.updateProgress(s),e.setTranslate(s,a),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(var o=0;o<r.length;o+=1)r[o]!==t&&r[o]instanceof j&&n(r[o]);else r instanceof j&&t!==r&&n(r)},setTransition:function(e,t){var i,s=this,a=s.controller.control;function r(t){t.setTransition(e,s),0!==e&&(t.transitionStart(),t.params.autoHeight&&d.nextTick((function(){t.updateAutoHeight()})),t.$wrapperEl.transitionEnd((function(){a&&(t.params.loop&&"slide"===s.params.controller.by&&t.loopFix(),t.transitionEnd())})))}if(Array.isArray(a))for(i=0;i<a.length;i+=1)a[i]!==t&&a[i]instanceof j&&r(a[i]);else a instanceof j&&t!==a&&r(a)}},ue={makeElFocusable:function(e){return e.attr("tabIndex","0"),e},makeElNotFocusable:function(e){return e.attr("tabIndex","-1"),e},addElRole:function(e,t){return e.attr("role",t),e},addElLabel:function(e,t){return e.attr("aria-label",t),e},disableEl:function(e){return e.attr("aria-disabled",!0),e},enableEl:function(e){return e.attr("aria-disabled",!1),e},onEnterKey:function(e){var t=this.params.a11y;if(13===e.keyCode){var i=n(e.target);this.navigation&&this.navigation.$nextEl&&i.is(this.navigation.$nextEl)&&(this.isEnd&&!this.params.loop||this.slideNext(),this.isEnd?this.a11y.notify(t.lastSlideMessage):this.a11y.notify(t.nextSlideMessage)),this.navigation&&this.navigation.$prevEl&&i.is(this.navigation.$prevEl)&&(this.isBeginning&&!this.params.loop||this.slidePrev(),this.isBeginning?this.a11y.notify(t.firstSlideMessage):this.a11y.notify(t.prevSlideMessage)),this.pagination&&i.is("."+this.params.pagination.bulletClass)&&i[0].click()}},notify:function(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e))},updateNavigation:function(){if(!this.params.loop&&this.navigation){var e=this.navigation,t=e.$nextEl,i=e.$prevEl;i&&i.length>0&&(this.isBeginning?(this.a11y.disableEl(i),this.a11y.makeElNotFocusable(i)):(this.a11y.enableEl(i),this.a11y.makeElFocusable(i))),t&&t.length>0&&(this.isEnd?(this.a11y.disableEl(t),this.a11y.makeElNotFocusable(t)):(this.a11y.enableEl(t),this.a11y.makeElFocusable(t)))}},updatePagination:function(){var e=this,t=e.params.a11y;e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.bullets.each((function(i,s){var a=n(s);e.a11y.makeElFocusable(a),e.a11y.addElRole(a,"button"),e.a11y.addElLabel(a,t.paginationBulletMessage.replace(/\{\{index\}\}/,a.index()+1))}))},init:function(){this.$el.append(this.a11y.liveRegion);var e,t,i=this.params.a11y;this.navigation&&this.navigation.$nextEl&&(e=this.navigation.$nextEl),this.navigation&&this.navigation.$prevEl&&(t=this.navigation.$prevEl),e&&(this.a11y.makeElFocusable(e),this.a11y.addElRole(e,"button"),this.a11y.addElLabel(e,i.nextSlideMessage),e.on("keydown",this.a11y.onEnterKey)),t&&(this.a11y.makeElFocusable(t),this.a11y.addElRole(t,"button"),this.a11y.addElLabel(t,i.prevSlideMessage),t.on("keydown",this.a11y.onEnterKey)),this.pagination&&this.params.pagination.clickable&&this.pagination.bullets&&this.pagination.bullets.length&&this.pagination.$el.on("keydown","."+this.params.pagination.bulletClass,this.a11y.onEnterKey)},destroy:function(){var e,t;this.a11y.liveRegion&&this.a11y.liveRegion.length>0&&this.a11y.liveRegion.remove(),this.navigation&&this.navigation.$nextEl&&(e=this.navigation.$nextEl),this.navigation&&this.navigation.$prevEl&&(t=this.navigation.$prevEl),e&&e.off("keydown",this.a11y.onEnterKey),t&&t.off("keydown",this.a11y.onEnterKey),this.pagination&&this.params.pagination.clickable&&this.pagination.bullets&&this.pagination.bullets.length&&this.pagination.$el.off("keydown","."+this.params.pagination.bulletClass,this.a11y.onEnterKey)}},ve={init:function(){if(this.params.history){if(!a.history||!a.history.pushState)return this.params.history.enabled=!1,void(this.params.hashNavigation.enabled=!0);var e=this.history;e.initialized=!0,e.paths=ve.getPathValues(),(e.paths.key||e.paths.value)&&(e.scrollToSlide(0,e.paths.value,this.params.runCallbacksOnInit),this.params.history.replaceState||a.addEventListener("popstate",this.history.setHistoryPopState))}},destroy:function(){this.params.history.replaceState||a.removeEventListener("popstate",this.history.setHistoryPopState)},setHistoryPopState:function(){this.history.paths=ve.getPathValues(),this.history.scrollToSlide(this.params.speed,this.history.paths.value,!1)},getPathValues:function(){var e=a.location.pathname.slice(1).split("/").filter((function(e){return""!==e})),t=e.length;return{key:e[t-2],value:e[t-1]}},setHistory:function(e,t){if(this.history.initialized&&this.params.history.enabled){var i=this.slides.eq(t),s=ve.slugify(i.attr("data-history"));a.location.pathname.includes(e)||(s=e+"/"+s);var r=a.history.state;r&&r.value===s||(this.params.history.replaceState?a.history.replaceState({value:s},null,s):a.history.pushState({value:s},null,s))}},slugify:function(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,t,i){if(t)for(var s=0,a=this.slides.length;s<a;s+=1){var r=this.slides.eq(s);if(ve.slugify(r.attr("data-history"))===t&&!r.hasClass(this.params.slideDuplicateClass)){var n=r.index();this.slideTo(n,e,i)}}else this.slideTo(0,e,i)}},fe={onHashCange:function(){this.emit("hashChange");var e=i.location.hash.replace("#","");if(e!==this.slides.eq(this.activeIndex).attr("data-hash")){var t=this.$wrapperEl.children("."+this.params.slideClass+'[data-hash="'+e+'"]').index();if(void 0===t)return;this.slideTo(t)}},setHash:function(){if(this.hashNavigation.initialized&&this.params.hashNavigation.enabled)if(this.params.hashNavigation.replaceState&&a.history&&a.history.replaceState)a.history.replaceState(null,null,"#"+this.slides.eq(this.activeIndex).attr("data-hash")||""),this.emit("hashSet");else{var e=this.slides.eq(this.activeIndex),t=e.attr("data-hash")||e.attr("data-history");i.location.hash=t||"",this.emit("hashSet")}},init:function(){if(!(!this.params.hashNavigation.enabled||this.params.history&&this.params.history.enabled)){this.hashNavigation.initialized=!0;var e=i.location.hash.replace("#","");if(e)for(var t=0,s=this.slides.length;t<s;t+=1){var r=this.slides.eq(t);if((r.attr("data-hash")||r.attr("data-history"))===e&&!r.hasClass(this.params.slideDuplicateClass)){var o=r.index();this.slideTo(o,0,this.params.runCallbacksOnInit,!0)}}this.params.hashNavigation.watchState&&n(a).on("hashchange",this.hashNavigation.onHashCange)}},destroy:function(){this.params.hashNavigation.watchState&&n(a).off("hashchange",this.hashNavigation.onHashCange)}},me={run:function(){var e=this,t=e.slides.eq(e.activeIndex),i=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(i=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=d.nextTick((function(){e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")),e.params.cssMode&&e.autoplay.running&&e.autoplay.run()}),i)},start:function(){return void 0===this.autoplay.timeout&&(!this.autoplay.running&&(this.autoplay.running=!0,this.emit("autoplayStart"),this.autoplay.run(),!0))},stop:function(){return!!this.autoplay.running&&(void 0!==this.autoplay.timeout&&(this.autoplay.timeout&&(clearTimeout(this.autoplay.timeout),this.autoplay.timeout=void 0),this.autoplay.running=!1,this.emit("autoplayStop"),!0))},pause:function(e){this.autoplay.running&&(this.autoplay.paused||(this.autoplay.timeout&&clearTimeout(this.autoplay.timeout),this.autoplay.paused=!0,0!==e&&this.params.autoplay.waitForTransition?(this.$wrapperEl[0].addEventListener("transitionend",this.autoplay.onTransitionEnd),this.$wrapperEl[0].addEventListener("webkitTransitionEnd",this.autoplay.onTransitionEnd)):(this.autoplay.paused=!1,this.autoplay.run())))}},ge={setTranslate:function(){for(var e=this.slides,t=0;t<e.length;t+=1){var i=this.slides.eq(t),s=-i[0].swiperSlideOffset;this.params.virtualTranslate||(s-=this.translate);var a=0;this.isHorizontal()||(a=s,s=0);var r=this.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:r}).transform("translate3d("+s+"px, "+a+"px, 0px)")}},setTransition:function(e){var t=this,i=t.slides,s=t.$wrapperEl;if(i.transition(e),t.params.virtualTranslate&&0!==e){var a=!1;i.transitionEnd((function(){if(!a&&t&&!t.destroyed){a=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],i=0;i<e.length;i+=1)s.trigger(e[i])}}))}}},be={setTranslate:function(){var e,t=this.$el,i=this.$wrapperEl,s=this.slides,a=this.width,r=this.height,o=this.rtlTranslate,l=this.size,d=this.params.cubeEffect,h=this.isHorizontal(),p=this.virtual&&this.params.virtual.enabled,c=0;d.shadow&&(h?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=n('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:a+"px"})):0===(e=t.find(".swiper-cube-shadow")).length&&(e=n('<div class="swiper-cube-shadow"></div>'),t.append(e)));for(var u=0;u<s.length;u+=1){var v=s.eq(u),f=u;p&&(f=parseInt(v.attr("data-swiper-slide-index"),10));var m=90*f,g=Math.floor(m/360);o&&(m=-m,g=Math.floor(-m/360));var b=Math.max(Math.min(v[0].progress,1),-1),w=0,y=0,x=0;f%4==0?(w=4*-g*l,x=0):(f-1)%4==0?(w=0,x=4*-g*l):(f-2)%4==0?(w=l+4*g*l,x=l):(f-3)%4==0&&(w=-l,x=3*l+4*l*g),o&&(w=-w),h||(y=w,w=0);var E="rotateX("+(h?0:-m)+"deg) rotateY("+(h?m:0)+"deg) translate3d("+w+"px, "+y+"px, "+x+"px)";if(b<=1&&b>-1&&(c=90*f+90*b,o&&(c=90*-f-90*b)),v.transform(E),d.slideShadows){var T=h?v.find(".swiper-slide-shadow-left"):v.find(".swiper-slide-shadow-top"),S=h?v.find(".swiper-slide-shadow-right"):v.find(".swiper-slide-shadow-bottom");0===T.length&&(T=n('<div class="swiper-slide-shadow-'+(h?"left":"top")+'"></div>'),v.append(T)),0===S.length&&(S=n('<div class="swiper-slide-shadow-'+(h?"right":"bottom")+'"></div>'),v.append(S)),T.length&&(T[0].style.opacity=Math.max(-b,0)),S.length&&(S[0].style.opacity=Math.max(b,0))}}if(i.css({"-webkit-transform-origin":"50% 50% -"+l/2+"px","-moz-transform-origin":"50% 50% -"+l/2+"px","-ms-transform-origin":"50% 50% -"+l/2+"px","transform-origin":"50% 50% -"+l/2+"px"}),d.shadow)if(h)e.transform("translate3d(0px, "+(a/2+d.shadowOffset)+"px, "+-a/2+"px) rotateX(90deg) rotateZ(0deg) scale("+d.shadowScale+")");else{var C=Math.abs(c)-90*Math.floor(Math.abs(c)/90),M=1.5-(Math.sin(2*C*Math.PI/360)/2+Math.cos(2*C*Math.PI/360)/2),P=d.shadowScale,z=d.shadowScale/M,k=d.shadowOffset;e.transform("scale3d("+P+", 1, "+z+") translate3d(0px, "+(r/2+k)+"px, "+-r/2/z+"px) rotateX(-90deg)")}var $=_.isSafari||_.isWebView?-l/2:0;i.transform("translate3d(0px,0,"+$+"px) rotateX("+(this.isHorizontal()?0:c)+"deg) rotateY("+(this.isHorizontal()?-c:0)+"deg)")},setTransition:function(e){var t=this.$el;this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),this.params.cubeEffect.shadow&&!this.isHorizontal()&&t.find(".swiper-cube-shadow").transition(e)}},we={setTranslate:function(){for(var e=this.slides,t=this.rtlTranslate,i=0;i<e.length;i+=1){var s=e.eq(i),a=s[0].progress;this.params.flipEffect.limitRotation&&(a=Math.max(Math.min(s[0].progress,1),-1));var r=-180*a,o=0,l=-s[0].swiperSlideOffset,d=0;if(this.isHorizontal()?t&&(r=-r):(d=l,l=0,o=-r,r=0),s[0].style.zIndex=-Math.abs(Math.round(a))+e.length,this.params.flipEffect.slideShadows){var h=this.isHorizontal()?s.find(".swiper-slide-shadow-left"):s.find(".swiper-slide-shadow-top"),p=this.isHorizontal()?s.find(".swiper-slide-shadow-right"):s.find(".swiper-slide-shadow-bottom");0===h.length&&(h=n('<div class="swiper-slide-shadow-'+(this.isHorizontal()?"left":"top")+'"></div>'),s.append(h)),0===p.length&&(p=n('<div class="swiper-slide-shadow-'+(this.isHorizontal()?"right":"bottom")+'"></div>'),s.append(p)),h.length&&(h[0].style.opacity=Math.max(-a,0)),p.length&&(p[0].style.opacity=Math.max(a,0))}s.transform("translate3d("+l+"px, "+d+"px, 0px) rotateX("+o+"deg) rotateY("+r+"deg)")}},setTransition:function(e){var t=this,i=t.slides,s=t.activeIndex,a=t.$wrapperEl;if(i.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.virtualTranslate&&0!==e){var r=!1;i.eq(s).transitionEnd((function(){if(!r&&t&&!t.destroyed){r=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],i=0;i<e.length;i+=1)a.trigger(e[i])}}))}}},ye={setTranslate:function(){for(var e=this.width,t=this.height,i=this.slides,s=this.$wrapperEl,a=this.slidesSizesGrid,r=this.params.coverflowEffect,o=this.isHorizontal(),l=this.translate,d=o?e/2-l:t/2-l,p=o?r.rotate:-r.rotate,c=r.depth,u=0,v=i.length;u<v;u+=1){var f=i.eq(u),m=a[u],g=(d-f[0].swiperSlideOffset-m/2)/m*r.modifier,b=o?p*g:0,w=o?0:p*g,y=-c*Math.abs(g),x=r.stretch;"string"==typeof x&&-1!==x.indexOf("%")&&(x=parseFloat(r.stretch)/100*m);var E=o?0:x*g,T=o?x*g:0,S=1-(1-r.scale)*Math.abs(g);Math.abs(T)<.001&&(T=0),Math.abs(E)<.001&&(E=0),Math.abs(y)<.001&&(y=0),Math.abs(b)<.001&&(b=0),Math.abs(w)<.001&&(w=0),Math.abs(S)<.001&&(S=0);var C="translate3d("+T+"px,"+E+"px,"+y+"px)  rotateX("+w+"deg) rotateY("+b+"deg) scale("+S+")";if(f.transform(C),f[0].style.zIndex=1-Math.abs(Math.round(g)),r.slideShadows){var M=o?f.find(".swiper-slide-shadow-left"):f.find(".swiper-slide-shadow-top"),P=o?f.find(".swiper-slide-shadow-right"):f.find(".swiper-slide-shadow-bottom");0===M.length&&(M=n('<div class="swiper-slide-shadow-'+(o?"left":"top")+'"></div>'),f.append(M)),0===P.length&&(P=n('<div class="swiper-slide-shadow-'+(o?"right":"bottom")+'"></div>'),f.append(P)),M.length&&(M[0].style.opacity=g>0?g:0),P.length&&(P[0].style.opacity=-g>0?-g:0)}}(h.pointerEvents||h.prefixedPointerEvents)&&(s[0].style.perspectiveOrigin=d+"px 50%")},setTransition:function(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}},xe={init:function(){var e=this.params.thumbs,t=this.constructor;e.swiper instanceof t?(this.thumbs.swiper=e.swiper,d.extend(this.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),d.extend(this.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):d.isObject(e.swiper)&&(this.thumbs.swiper=new t(d.extend({},e.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),this.thumbs.swiperCreated=!0),this.thumbs.swiper.$el.addClass(this.params.thumbs.thumbsContainerClass),this.thumbs.swiper.on("tap",this.thumbs.onThumbClick)},onThumbClick:function(){var e=this.thumbs.swiper;if(e){var t=e.clickedIndex,i=e.clickedSlide;if(!(i&&n(i).hasClass(this.params.thumbs.slideThumbActiveClass)||null==t)){var s;if(s=e.params.loop?parseInt(n(e.clickedSlide).attr("data-swiper-slide-index"),10):t,this.params.loop){var a=this.activeIndex;this.slides.eq(a).hasClass(this.params.slideDuplicateClass)&&(this.loopFix(),this._clientLeft=this.$wrapperEl[0].clientLeft,a=this.activeIndex);var r=this.slides.eq(a).prevAll('[data-swiper-slide-index="'+s+'"]').eq(0).index(),o=this.slides.eq(a).nextAll('[data-swiper-slide-index="'+s+'"]').eq(0).index();s=void 0===r?o:void 0===o?r:o-a<a-r?o:r}this.slideTo(s)}}},update:function(e){var t=this.thumbs.swiper;if(t){var i="auto"===t.params.slidesPerView?t.slidesPerViewDynamic():t.params.slidesPerView,s=this.params.thumbs.autoScrollOffset,a=s&&!t.params.loop;if(this.realIndex!==t.realIndex||a){var r,n,o=t.activeIndex;if(t.params.loop){t.slides.eq(o).hasClass(t.params.slideDuplicateClass)&&(t.loopFix(),t._clientLeft=t.$wrapperEl[0].clientLeft,o=t.activeIndex);var l=t.slides.eq(o).prevAll('[data-swiper-slide-index="'+this.realIndex+'"]').eq(0).index(),d=t.slides.eq(o).nextAll('[data-swiper-slide-index="'+this.realIndex+'"]').eq(0).index();r=void 0===l?d:void 0===d?l:d-o==o-l?o:d-o<o-l?d:l,n=this.activeIndex>this.previousIndex?"next":"prev"}else n=(r=this.realIndex)>this.previousIndex?"next":"prev";a&&(r+="next"===n?s:-1*s),t.visibleSlidesIndexes&&t.visibleSlidesIndexes.indexOf(r)<0&&(t.params.centeredSlides?r=r>o?r-Math.floor(i/2)+1:r+Math.floor(i/2)-1:r>o&&(r=r-i+1),t.slideTo(r,e?0:void 0))}var h=1,p=this.params.thumbs.slideThumbActiveClass;if(this.params.slidesPerView>1&&!this.params.centeredSlides&&(h=this.params.slidesPerView),this.params.thumbs.multipleActiveThumbs||(h=1),h=Math.floor(h),t.slides.removeClass(p),t.params.loop||t.params.virtual&&t.params.virtual.enabled)for(var c=0;c<h;c+=1)t.$wrapperEl.children('[data-swiper-slide-index="'+(this.realIndex+c)+'"]').addClass(p);else for(var u=0;u<h;u+=1)t.slides.eq(this.realIndex+u).addClass(p)}}},Ee=[K,U,Z,Q,ee,ie,ae,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarged:"container"}},create:function(){d.extend(this,{mousewheel:{enabled:!1,enable:re.enable.bind(this),disable:re.disable.bind(this),handle:re.handle.bind(this),handleMouseEnter:re.handleMouseEnter.bind(this),handleMouseLeave:re.handleMouseLeave.bind(this),animateSlider:re.animateSlider.bind(this),releaseScroll:re.releaseScroll.bind(this),lastScrollTime:d.now(),lastEventBeforeSnap:void 0,recentWheelEvents:[]}})},on:{init:function(){!this.params.mousewheel.enabled&&this.params.cssMode&&this.mousewheel.disable(),this.params.mousewheel.enabled&&this.mousewheel.enable()},destroy:function(){this.params.cssMode&&this.mousewheel.enable(),this.mousewheel.enabled&&this.mousewheel.disable()}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function(){d.extend(this,{navigation:{init:ne.init.bind(this),update:ne.update.bind(this),destroy:ne.destroy.bind(this),onNextClick:ne.onNextClick.bind(this),onPrevClick:ne.onPrevClick.bind(this)}})},on:{init:function(){this.navigation.init(),this.navigation.update()},toEdge:function(){this.navigation.update()},fromEdge:function(){this.navigation.update()},destroy:function(){this.navigation.destroy()},click:function(e){var t,i=this.navigation,s=i.$nextEl,a=i.$prevEl;!this.params.navigation.hideOnClick||n(e.target).is(a)||n(e.target).is(s)||(s?t=s.hasClass(this.params.navigation.hiddenClass):a&&(t=a.hasClass(this.params.navigation.hiddenClass)),!0===t?this.emit("navigationShow",this):this.emit("navigationHide",this),s&&s.toggleClass(this.params.navigation.hiddenClass),a&&a.toggleClass(this.params.navigation.hiddenClass))}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function(e){return e},formatFractionTotal:function(e){return e},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function(){d.extend(this,{pagination:{init:oe.init.bind(this),render:oe.render.bind(this),update:oe.update.bind(this),destroy:oe.destroy.bind(this),dynamicBulletIndex:0}})},on:{init:function(){this.pagination.init(),this.pagination.render(),this.pagination.update()},activeIndexChange:function(){(this.params.loop||void 0===this.snapIndex)&&this.pagination.update()},snapIndexChange:function(){this.params.loop||this.pagination.update()},slidesLengthChange:function(){this.params.loop&&(this.pagination.render(),this.pagination.update())},snapGridLengthChange:function(){this.params.loop||(this.pagination.render(),this.pagination.update())},destroy:function(){this.pagination.destroy()},click:function(e){this.params.pagination.el&&this.params.pagination.hideOnClick&&this.pagination.$el.length>0&&!n(e.target).hasClass(this.params.pagination.bulletClass)&&(!0===this.pagination.$el.hasClass(this.params.pagination.hiddenClass)?this.emit("paginationShow",this):this.emit("paginationHide",this),this.pagination.$el.toggleClass(this.params.pagination.hiddenClass))}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function(){d.extend(this,{scrollbar:{init:le.init.bind(this),destroy:le.destroy.bind(this),updateSize:le.updateSize.bind(this),setTranslate:le.setTranslate.bind(this),setTransition:le.setTransition.bind(this),enableDraggable:le.enableDraggable.bind(this),disableDraggable:le.disableDraggable.bind(this),setDragPosition:le.setDragPosition.bind(this),getPointerPosition:le.getPointerPosition.bind(this),onDragStart:le.onDragStart.bind(this),onDragMove:le.onDragMove.bind(this),onDragEnd:le.onDragEnd.bind(this),isTouched:!1,timeout:null,dragTimeout:null}})},on:{init:function(){this.scrollbar.init(),this.scrollbar.updateSize(),this.scrollbar.setTranslate()},update:function(){this.scrollbar.updateSize()},resize:function(){this.scrollbar.updateSize()},observerUpdate:function(){this.scrollbar.updateSize()},setTranslate:function(){this.scrollbar.setTranslate()},setTransition:function(e){this.scrollbar.setTransition(e)},destroy:function(){this.scrollbar.destroy()}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function(){d.extend(this,{parallax:{setTransform:de.setTransform.bind(this),setTranslate:de.setTranslate.bind(this),setTransition:de.setTransition.bind(this)}})},on:{beforeInit:function(){this.params.parallax.enabled&&(this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0)},init:function(){this.params.parallax.enabled&&this.parallax.setTranslate()},setTranslate:function(){this.params.parallax.enabled&&this.parallax.setTranslate()},setTransition:function(e){this.params.parallax.enabled&&this.parallax.setTransition(e)}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function(){var e=this,t={enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}};"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach((function(i){t[i]=he[i].bind(e)})),d.extend(e,{zoom:t});var i=1;Object.defineProperty(e.zoom,"scale",{get:function(){return i},set:function(t){if(i!==t){var s=e.zoom.gesture.$imageEl?e.zoom.gesture.$imageEl[0]:void 0,a=e.zoom.gesture.$slideEl?e.zoom.gesture.$slideEl[0]:void 0;e.emit("zoomChange",t,s,a)}i=t}})},on:{init:function(){this.params.zoom.enabled&&this.zoom.enable()},destroy:function(){this.zoom.disable()},touchStart:function(e){this.zoom.enabled&&this.zoom.onTouchStart(e)},touchEnd:function(e){this.zoom.enabled&&this.zoom.onTouchEnd(e)},doubleTap:function(e){this.params.zoom.enabled&&this.zoom.enabled&&this.params.zoom.toggle&&this.zoom.toggle(e)},transitionEnd:function(){this.zoom.enabled&&this.params.zoom.enabled&&this.zoom.onTransitionEnd()},slideChange:function(){this.zoom.enabled&&this.params.zoom.enabled&&this.params.cssMode&&this.zoom.onTransitionEnd()}}},{name:"lazy",params:{lazy:{enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function(){d.extend(this,{lazy:{initialImageLoaded:!1,load:pe.load.bind(this),loadInSlide:pe.loadInSlide.bind(this)}})},on:{beforeInit:function(){this.params.lazy.enabled&&this.params.preloadImages&&(this.params.preloadImages=!1)},init:function(){this.params.lazy.enabled&&!this.params.loop&&0===this.params.initialSlide&&this.lazy.load()},scroll:function(){this.params.freeMode&&!this.params.freeModeSticky&&this.lazy.load()},resize:function(){this.params.lazy.enabled&&this.lazy.load()},scrollbarDragMove:function(){this.params.lazy.enabled&&this.lazy.load()},transitionStart:function(){this.params.lazy.enabled&&(this.params.lazy.loadOnTransitionStart||!this.params.lazy.loadOnTransitionStart&&!this.lazy.initialImageLoaded)&&this.lazy.load()},transitionEnd:function(){this.params.lazy.enabled&&!this.params.lazy.loadOnTransitionStart&&this.lazy.load()},slideChange:function(){this.params.lazy.enabled&&this.params.cssMode&&this.lazy.load()}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function(){d.extend(this,{controller:{control:this.params.controller.control,getInterpolateFunction:ce.getInterpolateFunction.bind(this),setTranslate:ce.setTranslate.bind(this),setTransition:ce.setTransition.bind(this)}})},on:{update:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},resize:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},observerUpdate:function(){this.controller.control&&this.controller.spline&&(this.controller.spline=void 0,delete this.controller.spline)},setTranslate:function(e,t){this.controller.control&&this.controller.setTranslate(e,t)},setTransition:function(e,t){this.controller.control&&this.controller.setTransition(e,t)}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}"}},create:function(){var e=this;d.extend(e,{a11y:{liveRegion:n('<span class="'+e.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')}}),Object.keys(ue).forEach((function(t){e.a11y[t]=ue[t].bind(e)}))},on:{init:function(){this.params.a11y.enabled&&(this.a11y.init(),this.a11y.updateNavigation())},toEdge:function(){this.params.a11y.enabled&&this.a11y.updateNavigation()},fromEdge:function(){this.params.a11y.enabled&&this.a11y.updateNavigation()},paginationUpdate:function(){this.params.a11y.enabled&&this.a11y.updatePagination()},destroy:function(){this.params.a11y.enabled&&this.a11y.destroy()}}},{name:"history",params:{history:{enabled:!1,replaceState:!1,key:"slides"}},create:function(){d.extend(this,{history:{init:ve.init.bind(this),setHistory:ve.setHistory.bind(this),setHistoryPopState:ve.setHistoryPopState.bind(this),scrollToSlide:ve.scrollToSlide.bind(this),destroy:ve.destroy.bind(this)}})},on:{init:function(){this.params.history.enabled&&this.history.init()},destroy:function(){this.params.history.enabled&&this.history.destroy()},transitionEnd:function(){this.history.initialized&&this.history.setHistory(this.params.history.key,this.activeIndex)},slideChange:function(){this.history.initialized&&this.params.cssMode&&this.history.setHistory(this.params.history.key,this.activeIndex)}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function(){d.extend(this,{hashNavigation:{initialized:!1,init:fe.init.bind(this),destroy:fe.destroy.bind(this),setHash:fe.setHash.bind(this),onHashCange:fe.onHashCange.bind(this)}})},on:{init:function(){this.params.hashNavigation.enabled&&this.hashNavigation.init()},destroy:function(){this.params.hashNavigation.enabled&&this.hashNavigation.destroy()},transitionEnd:function(){this.hashNavigation.initialized&&this.hashNavigation.setHash()},slideChange:function(){this.hashNavigation.initialized&&this.params.cssMode&&this.hashNavigation.setHash()}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1}},create:function(){var e=this;d.extend(e,{autoplay:{running:!1,paused:!1,run:me.run.bind(e),start:me.start.bind(e),stop:me.stop.bind(e),pause:me.pause.bind(e),onVisibilityChange:function(){"hidden"===document.visibilityState&&e.autoplay.running&&e.autoplay.pause(),"visible"===document.visibilityState&&e.autoplay.paused&&(e.autoplay.run(),e.autoplay.paused=!1)},onTransitionEnd:function(t){e&&!e.destroyed&&e.$wrapperEl&&t.target===this&&(e.$wrapperEl[0].removeEventListener("transitionend",e.autoplay.onTransitionEnd),e.$wrapperEl[0].removeEventListener("webkitTransitionEnd",e.autoplay.onTransitionEnd),e.autoplay.paused=!1,e.autoplay.running?e.autoplay.run():e.autoplay.stop())}}})},on:{init:function(){this.params.autoplay.enabled&&(this.autoplay.start(),document.addEventListener("visibilitychange",this.autoplay.onVisibilityChange))},beforeTransitionStart:function(e,t){this.autoplay.running&&(t||!this.params.autoplay.disableOnInteraction?this.autoplay.pause(e):this.autoplay.stop())},sliderFirstMove:function(){this.autoplay.running&&(this.params.autoplay.disableOnInteraction?this.autoplay.stop():this.autoplay.pause())},touchEnd:function(){this.params.cssMode&&this.autoplay.paused&&!this.params.autoplay.disableOnInteraction&&this.autoplay.run()},destroy:function(){this.autoplay.running&&this.autoplay.stop(),document.removeEventListener("visibilitychange",this.autoplay.onVisibilityChange)}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function(){d.extend(this,{fadeEffect:{setTranslate:ge.setTranslate.bind(this),setTransition:ge.setTransition.bind(this)}})},on:{beforeInit:function(){if("fade"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"fade");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};d.extend(this.params,e),d.extend(this.originalParams,e)}},setTranslate:function(){"fade"===this.params.effect&&this.fadeEffect.setTranslate()},setTransition:function(e){"fade"===this.params.effect&&this.fadeEffect.setTransition(e)}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function(){d.extend(this,{cubeEffect:{setTranslate:be.setTranslate.bind(this),setTransition:be.setTransition.bind(this)}})},on:{beforeInit:function(){if("cube"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"cube"),this.classNames.push(this.params.containerModifierClass+"3d");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};d.extend(this.params,e),d.extend(this.originalParams,e)}},setTranslate:function(){"cube"===this.params.effect&&this.cubeEffect.setTranslate()},setTransition:function(e){"cube"===this.params.effect&&this.cubeEffect.setTransition(e)}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function(){d.extend(this,{flipEffect:{setTranslate:we.setTranslate.bind(this),setTransition:we.setTransition.bind(this)}})},on:{beforeInit:function(){if("flip"===this.params.effect){this.classNames.push(this.params.containerModifierClass+"flip"),this.classNames.push(this.params.containerModifierClass+"3d");var e={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};d.extend(this.params,e),d.extend(this.originalParams,e)}},setTranslate:function(){"flip"===this.params.effect&&this.flipEffect.setTranslate()},setTransition:function(e){"flip"===this.params.effect&&this.flipEffect.setTransition(e)}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}},create:function(){d.extend(this,{coverflowEffect:{setTranslate:ye.setTranslate.bind(this),setTransition:ye.setTransition.bind(this)}})},on:{beforeInit:function(){"coverflow"===this.params.effect&&(this.classNames.push(this.params.containerModifierClass+"coverflow"),this.classNames.push(this.params.containerModifierClass+"3d"),this.params.watchSlidesProgress=!0,this.originalParams.watchSlidesProgress=!0)},setTranslate:function(){"coverflow"===this.params.effect&&this.coverflowEffect.setTranslate()},setTransition:function(e){"coverflow"===this.params.effect&&this.coverflowEffect.setTransition(e)}}},{name:"thumbs",params:{thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function(){d.extend(this,{thumbs:{swiper:null,init:xe.init.bind(this),update:xe.update.bind(this),onThumbClick:xe.onThumbClick.bind(this)}})},on:{beforeInit:function(){var e=this.params.thumbs;e&&e.swiper&&(this.thumbs.init(),this.thumbs.update(!0))},slideChange:function(){this.thumbs.swiper&&this.thumbs.update()},update:function(){this.thumbs.swiper&&this.thumbs.update()},resize:function(){this.thumbs.swiper&&this.thumbs.update()},observerUpdate:function(){this.thumbs.swiper&&this.thumbs.update()},setTransition:function(e){var t=this.thumbs.swiper;t&&t.setTransition(e)},beforeDestroy:function(){var e=this.thumbs.swiper;e&&this.thumbs.swiperCreated&&e&&e.destroy()}}}];return void 0===j.use&&(j.use=j.Class.use,j.installModule=j.Class.installModule),j.use(Ee),j}));

// stats.js - http://github.com/mrdoob/stats.js
var Stats = function() {
    function h(a) {
        c.appendChild(a.dom);
        return a
    }
    function k(a) {
        for (var d = 0; d < c.children.length; d++)
            c.children[d].style.display = d === a ? "block" : "none";
        l = a
    }
    var l = 0
        , c = document.createElement("div");
    c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
    c.addEventListener("click", function(a) {
        a.preventDefault();
        k(++l % c.children.length)
    }, !1);
    var g = (performance || Date).now()
        , e = g
        , a = 0
        , r = h(new Stats.Panel("FPS","#0ff","#002"))
        , f = h(new Stats.Panel("MS","#0f0","#020"));
    if (self.performance && self.performance.memory)
        var t = h(new Stats.Panel("MB","#f08","#201"));
    k(0);
    return {
        REVISION: 16,
        dom: c,
        addPanel: h,
        showPanel: k,
        begin: function() {
            g = (performance || Date).now()
        },
        end: function() {
            a++;
            var c = (performance || Date).now();
            f.update(c - g, 200);
            if (c > e + 1E3 && (r.update(1E3 * a / (c - e), 100),
                e = c,
                a = 0,
                t)) {
                var d = performance.memory;
                t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576)
            }
            return c
        },
        update: function() {
            g = this.end()
        },
        domElement: c,
        setMode: k
    }
};
Stats.Panel = function(h, k, l) {
    var c = Infinity
        , g = 0
        , e = Math.round
        , a = e(window.devicePixelRatio || 1)
        , r = 80 * a
        , f = 48 * a
        , t = 3 * a
        , u = 2 * a
        , d = 3 * a
        , m = 15 * a
        , n = 74 * a
        , p = 30 * a
        , q = document.createElement("canvas");
    q.width = r;
    q.height = f;
    q.style.cssText = "width:80px;height:48px";
    var b = q.getContext("2d");
    b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
    b.textBaseline = "top";
    b.fillStyle = l;
    b.fillRect(0, 0, r, f);
    b.fillStyle = k;
    b.fillText(h, t, u);
    b.fillRect(d, m, n, p);
    b.fillStyle = l;
    b.globalAlpha = .9;
    b.fillRect(d, m, n, p);
    return {
        dom: q,
        update: function(f, v) {
            c = Math.min(c, f);
            g = Math.max(g, f);
            b.fillStyle = l;
            b.globalAlpha = 1;
            b.fillRect(0, 0, r, m);
            b.fillStyle = k;
            b.fillText(e(f) + " " + h + " (" + e(c) + "-" + e(g) + ")", t, u);
            b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
            b.fillRect(d + n - a, m, a, p);
            b.fillStyle = l;
            b.globalAlpha = .9;
            b.fillRect(d + n - a, m, a, e((1 - f / v) * p))
        }
    }
}
;
"object" === typeof module && (module.exports = Stats);

/**!
 * Sortable 1.10.1
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.Sortable = factory());
}(this, function () { 'use strict';

    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function (obj) {
                return typeof obj;
            };
        } else {
            _typeof = function (obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
        }

        return _typeof(obj);
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    function _extends() {
        _extends = Object.assign || function (target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];

                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }

                return target;
            };

        return _extends.apply(this, arguments);
    }

    function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);

            if (typeof Object.getOwnPropertySymbols === 'function') {
                ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }));
            }

            ownKeys.forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        }

        return target;
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;

        for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }

        return target;
    }

    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};

        var target = _objectWithoutPropertiesLoose(source, excluded);

        var key, i;

        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

            for (i = 0; i < sourceSymbolKeys.length; i++) {
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }

        return target;
    }

    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }

    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

            return arr2;
        }
    }

    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }

    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    var version = "1.10.1";

    function userAgent(pattern) {
        if (typeof window !== 'undefined' && window.navigator) {
            return !!
                /*@__PURE__*/
                navigator.userAgent.match(pattern);
        }
    }

    var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
    var Edge = userAgent(/Edge/i);
    var FireFox = userAgent(/firefox/i);
    var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
    var IOS = userAgent(/iP(ad|od|hone)/i);
    var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

    var captureMode = {
        capture: false,
        passive: false
    };

    function on(el, event, fn) {
        el.addEventListener(event, fn, !IE11OrLess && captureMode);
    }

    function off(el, event, fn) {
        el.removeEventListener(event, fn, !IE11OrLess && captureMode);
    }

    function matches(
        /**HTMLElement*/
        el,
        /**String*/
        selector) {
        if (!selector) return;
        selector[0] === '>' && (selector = selector.substring(1));

        if (el) {
            try {
                if (el.matches) {
                    return el.matches(selector);
                } else if (el.msMatchesSelector) {
                    return el.msMatchesSelector(selector);
                } else if (el.webkitMatchesSelector) {
                    return el.webkitMatchesSelector(selector);
                }
            } catch (_) {
                return false;
            }
        }

        return false;
    }

    function getParentOrHost(el) {
        return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
    }

    function closest(
        /**HTMLElement*/
        el,
        /**String*/
        selector,
        /**HTMLElement*/
        ctx, includeCTX) {
        if (el) {
            ctx = ctx || document;

            do {
                if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
                    return el;
                }

                if (el === ctx) break;
                /* jshint boss:true */
            } while (el = getParentOrHost(el));
        }

        return null;
    }

    var R_SPACE = /\s+/g;

    function toggleClass(el, name, state) {
        if (el && name) {
            if (el.classList) {
                el.classList[state ? 'add' : 'remove'](name);
            } else {
                var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
                el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
            }
        }
    }

    function css(el, prop, val) {
        var style = el && el.style;

        if (style) {
            if (val === void 0) {
                if (document.defaultView && document.defaultView.getComputedStyle) {
                    val = document.defaultView.getComputedStyle(el, '');
                } else if (el.currentStyle) {
                    val = el.currentStyle;
                }

                return prop === void 0 ? val : val[prop];
            } else {
                if (!(prop in style) && prop.indexOf('webkit') === -1) {
                    prop = '-webkit-' + prop;
                }

                style[prop] = val + (typeof val === 'string' ? '' : 'px');
            }
        }
    }

    function matrix(el, selfOnly) {
        var appliedTransforms = '';

        if (typeof el === 'string') {
            appliedTransforms = el;
        } else {
            do {
                var transform = css(el, 'transform');

                if (transform && transform !== 'none') {
                    appliedTransforms = transform + ' ' + appliedTransforms;
                }
                /* jshint boss:true */

            } while (!selfOnly && (el = el.parentNode));
        }

        var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix;
        /*jshint -W056 */

        return matrixFn && new matrixFn(appliedTransforms);
    }

    function find(ctx, tagName, iterator) {
        if (ctx) {
            var list = ctx.getElementsByTagName(tagName),
                i = 0,
                n = list.length;

            if (iterator) {
                for (; i < n; i++) {
                    iterator(list[i], i);
                }
            }

            return list;
        }

        return [];
    }

    function getWindowScrollingElement() {
        if (IE11OrLess) {
            return document.documentElement;
        } else {
            return document.scrollingElement;
        }
    }
    /**
     * Returns the "bounding client rect" of given element
     * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
     * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
     * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
     * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
     * @param  {[HTMLElement]} container              The parent the element will be placed in
     * @return {Object}                               The boundingClientRect of el, with specified adjustments
     */


    function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
        if (!el.getBoundingClientRect && el !== window) return;
        var elRect, top, left, bottom, right, height, width;

        if (el !== window && el !== getWindowScrollingElement()) {
            elRect = el.getBoundingClientRect();
            top = elRect.top;
            left = elRect.left;
            bottom = elRect.bottom;
            right = elRect.right;
            height = elRect.height;
            width = elRect.width;
        } else {
            top = 0;
            left = 0;
            bottom = window.innerHeight;
            right = window.innerWidth;
            height = window.innerHeight;
            width = window.innerWidth;
        }

        if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
            // Adjust for translate()
            container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
            // Not needed on <= IE11

            if (!IE11OrLess) {
                do {
                    if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
                        var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

                        top -= containerRect.top + parseInt(css(container, 'border-top-width'));
                        left -= containerRect.left + parseInt(css(container, 'border-left-width'));
                        bottom = top + elRect.height;
                        right = left + elRect.width;
                        break;
                    }
                    /* jshint boss:true */

                } while (container = container.parentNode);
            }
        }

        if (undoScale && el !== window) {
            // Adjust for scale()
            var elMatrix = matrix(container || el),
                scaleX = elMatrix && elMatrix.a,
                scaleY = elMatrix && elMatrix.d;

            if (elMatrix) {
                top /= scaleY;
                left /= scaleX;
                width /= scaleX;
                height /= scaleY;
                bottom = top + height;
                right = left + width;
            }
        }

        return {
            top: top,
            left: left,
            bottom: bottom,
            right: right,
            width: width,
            height: height
        };
    }
    /**
     * Checks if a side of an element is scrolled past a side of its parents
     * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
     * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
     * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
     * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
     */


    function isScrolledPast(el, elSide, parentSide) {
        var parent = getParentAutoScrollElement(el, true),
            elSideVal = getRect(el)[elSide];
        /* jshint boss:true */

        while (parent) {
            var parentSideVal = getRect(parent)[parentSide],
                visible = void 0;

            if (parentSide === 'top' || parentSide === 'left') {
                visible = elSideVal >= parentSideVal;
            } else {
                visible = elSideVal <= parentSideVal;
            }

            if (!visible) return parent;
            if (parent === getWindowScrollingElement()) break;
            parent = getParentAutoScrollElement(parent, false);
        }

        return false;
    }
    /**
     * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
     * and non-draggable elements
     * @param  {HTMLElement} el       The parent element
     * @param  {Number} childNum      The index of the child
     * @param  {Object} options       Parent Sortable's options
     * @return {HTMLElement}          The child at index childNum, or null if not found
     */


    function getChild(el, childNum, options) {
        var currentChild = 0,
            i = 0,
            children = el.children;

        while (i < children.length) {
            if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
                if (currentChild === childNum) {
                    return children[i];
                }

                currentChild++;
            }

            i++;
        }

        return null;
    }
    /**
     * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
     * @param  {HTMLElement} el       Parent element
     * @param  {selector} selector    Any other elements that should be ignored
     * @return {HTMLElement}          The last child, ignoring ghostEl
     */


    function lastChild(el, selector) {
        var last = el.lastElementChild;

        while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
            last = last.previousElementSibling;
        }

        return last || null;
    }
    /**
     * Returns the index of an element within its parent for a selected set of
     * elements
     * @param  {HTMLElement} el
     * @param  {selector} selector
     * @return {number}
     */


    function index(el, selector) {
        var index = 0;

        if (!el || !el.parentNode) {
            return -1;
        }
        /* jshint boss:true */


        while (el = el.previousElementSibling) {
            if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
                index++;
            }
        }

        return index;
    }
    /**
     * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
     * The value is returned in real pixels.
     * @param  {HTMLElement} el
     * @return {Array}             Offsets in the format of [left, top]
     */


    function getRelativeScrollOffset(el) {
        var offsetLeft = 0,
            offsetTop = 0,
            winScroller = getWindowScrollingElement();

        if (el) {
            do {
                var elMatrix = matrix(el),
                    scaleX = elMatrix.a,
                    scaleY = elMatrix.d;
                offsetLeft += el.scrollLeft * scaleX;
                offsetTop += el.scrollTop * scaleY;
            } while (el !== winScroller && (el = el.parentNode));
        }

        return [offsetLeft, offsetTop];
    }
    /**
     * Returns the index of the object within the given array
     * @param  {Array} arr   Array that may or may not hold the object
     * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
     * @return {Number}      The index of the object in the array, or -1
     */


    function indexOfObject(arr, obj) {
        for (var i in arr) {
            if (!arr.hasOwnProperty(i)) continue;

            for (var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
            }
        }

        return -1;
    }

    function getParentAutoScrollElement(el, includeSelf) {
        // skip to window
        if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
        var elem = el;
        var gotSelf = false;

        do {
            // we don't need to get elem css if it isn't even overflowing in the first place (performance)
            if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
                var elemCSS = css(elem);

                if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
                    if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
                    if (gotSelf || includeSelf) return elem;
                    gotSelf = true;
                }
            }
            /* jshint boss:true */

        } while (elem = elem.parentNode);

        return getWindowScrollingElement();
    }

    function extend(dst, src) {
        if (dst && src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) {
                    dst[key] = src[key];
                }
            }
        }

        return dst;
    }

    function isRectEqual(rect1, rect2) {
        return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
    }

    var _throttleTimeout;

    function throttle(callback, ms) {
        return function () {
            if (!_throttleTimeout) {
                var args = arguments,
                    _this = this;

                if (args.length === 1) {
                    callback.call(_this, args[0]);
                } else {
                    callback.apply(_this, args);
                }

                _throttleTimeout = setTimeout(function () {
                    _throttleTimeout = void 0;
                }, ms);
            }
        };
    }

    function cancelThrottle() {
        clearTimeout(_throttleTimeout);
        _throttleTimeout = void 0;
    }

    function scrollBy(el, x, y) {
        el.scrollLeft += x;
        el.scrollTop += y;
    }

    function clone(el) {
        var Polymer = window.Polymer;
        var $ = window.jQuery || window.Zepto;

        if (Polymer && Polymer.dom) {
            return Polymer.dom(el).cloneNode(true);
        } else if ($) {
            return $(el).clone(true)[0];
        } else {
            return el.cloneNode(true);
        }
    }

    function setRect(el, rect) {
        css(el, 'position', 'absolute');
        css(el, 'top', rect.top);
        css(el, 'left', rect.left);
        css(el, 'width', rect.width);
        css(el, 'height', rect.height);
    }

    function unsetRect(el) {
        css(el, 'position', '');
        css(el, 'top', '');
        css(el, 'left', '');
        css(el, 'width', '');
        css(el, 'height', '');
    }

    var expando = 'Sortable' + new Date().getTime();

    function AnimationStateManager() {
        var animationStates = [],
            animationCallbackId;
        return {
            captureAnimationState: function captureAnimationState() {
                animationStates = [];
                if (!this.options.animation) return;
                var children = [].slice.call(this.el.children);
                children.forEach(function (child) {
                    if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
                    animationStates.push({
                        target: child,
                        rect: getRect(child)
                    });

                    var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


                    if (child.thisAnimationDuration) {
                        var childMatrix = matrix(child, true);

                        if (childMatrix) {
                            fromRect.top -= childMatrix.f;
                            fromRect.left -= childMatrix.e;
                        }
                    }

                    child.fromRect = fromRect;
                });
            },
            addAnimationState: function addAnimationState(state) {
                animationStates.push(state);
            },
            removeAnimationState: function removeAnimationState(target) {
                animationStates.splice(indexOfObject(animationStates, {
                    target: target
                }), 1);
            },
            animateAll: function animateAll(callback) {
                var _this = this;

                if (!this.options.animation) {
                    clearTimeout(animationCallbackId);
                    if (typeof callback === 'function') callback();
                    return;
                }

                var animating = false,
                    animationTime = 0;
                animationStates.forEach(function (state) {
                    var time = 0,
                        target = state.target,
                        fromRect = target.fromRect,
                        toRect = getRect(target),
                        prevFromRect = target.prevFromRect,
                        prevToRect = target.prevToRect,
                        animatingRect = state.rect,
                        targetMatrix = matrix(target, true);

                    if (targetMatrix) {
                        // Compensate for current animation
                        toRect.top -= targetMatrix.f;
                        toRect.left -= targetMatrix.e;
                    }

                    target.toRect = toRect;

                    if (target.thisAnimationDuration) {
                        // Could also check if animatingRect is between fromRect and toRect
                        if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
                            // If returning to same place as started from animation and on same axis
                            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                        }
                    } // if fromRect != toRect: animate


                    if (!isRectEqual(toRect, fromRect)) {
                        target.prevFromRect = fromRect;
                        target.prevToRect = toRect;

                        if (!time) {
                            time = _this.options.animation;
                        }

                        _this.animate(target, animatingRect, toRect, time);
                    }

                    if (time) {
                        animating = true;
                        animationTime = Math.max(animationTime, time);
                        clearTimeout(target.animationResetTimer);
                        target.animationResetTimer = setTimeout(function () {
                            target.animationTime = 0;
                            target.prevFromRect = null;
                            target.fromRect = null;
                            target.prevToRect = null;
                            target.thisAnimationDuration = null;
                        }, time);
                        target.thisAnimationDuration = time;
                    }
                });
                clearTimeout(animationCallbackId);

                if (!animating) {
                    if (typeof callback === 'function') callback();
                } else {
                    animationCallbackId = setTimeout(function () {
                        if (typeof callback === 'function') callback();
                    }, animationTime);
                }

                animationStates = [];
            },
            animate: function animate(target, currentRect, toRect, duration) {
                if (duration) {
                    css(target, 'transition', '');
                    css(target, 'transform', '');
                    var elMatrix = matrix(this.el),
                        scaleX = elMatrix && elMatrix.a,
                        scaleY = elMatrix && elMatrix.d,
                        translateX = (currentRect.left - toRect.left) / (scaleX || 1),
                        translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                    target.animatingX = !!translateX;
                    target.animatingY = !!translateY;
                    css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                    repaint(target); // repaint

                    css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                    css(target, 'transform', 'translate3d(0,0,0)');
                    typeof target.animated === 'number' && clearTimeout(target.animated);
                    target.animated = setTimeout(function () {
                        css(target, 'transition', '');
                        css(target, 'transform', '');
                        target.animated = false;
                        target.animatingX = false;
                        target.animatingY = false;
                    }, duration);
                }
            }
        };
    }

    function repaint(target) {
        return target.offsetWidth;
    }

    function calculateRealTime(animatingRect, fromRect, toRect, options) {
        return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
    }

    var plugins = [];
    var defaults = {
        initializeByDefault: true
    };
    var PluginManager = {
        mount: function mount(plugin) {
            // Set default static properties
            for (var option in defaults) {
                if (defaults.hasOwnProperty(option) && !(option in plugin)) {
                    plugin[option] = defaults[option];
                }
            }

            plugins.push(plugin);
        },
        pluginEvent: function pluginEvent(eventName, sortable, evt) {
            var _this = this;

            this.eventCanceled = false;

            evt.cancel = function () {
                _this.eventCanceled = true;
            };

            var eventNameGlobal = eventName + 'Global';
            plugins.forEach(function (plugin) {
                if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

                if (sortable[plugin.pluginName][eventNameGlobal]) {
                    sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
                        sortable: sortable
                    }, evt));
                } // Only fire plugin event if plugin is enabled in this sortable,
                // and plugin has event defined


                if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
                    sortable[plugin.pluginName][eventName](_objectSpread({
                        sortable: sortable
                    }, evt));
                }
            });
        },
        initializePlugins: function initializePlugins(sortable, el, defaults, options) {
            plugins.forEach(function (plugin) {
                var pluginName = plugin.pluginName;
                if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
                var initialized = new plugin(sortable, el, sortable.options);
                initialized.sortable = sortable;
                initialized.options = sortable.options;
                sortable[pluginName] = initialized; // Add default options from plugin

                _extends(defaults, initialized.defaults);
            });

            for (var option in sortable.options) {
                if (!sortable.options.hasOwnProperty(option)) continue;
                var modified = this.modifyOption(sortable, option, sortable.options[option]);

                if (typeof modified !== 'undefined') {
                    sortable.options[option] = modified;
                }
            }
        },
        getEventProperties: function getEventProperties(name, sortable) {
            var eventProperties = {};
            plugins.forEach(function (plugin) {
                if (typeof plugin.eventProperties !== 'function') return;

                _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
            });
            return eventProperties;
        },
        modifyOption: function modifyOption(sortable, name, value) {
            var modifiedValue;
            plugins.forEach(function (plugin) {
                // Plugin must exist on the Sortable
                if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

                if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
                    modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
                }
            });
            return modifiedValue;
        }
    };

    function dispatchEvent(_ref) {
        var sortable = _ref.sortable,
            rootEl = _ref.rootEl,
            name = _ref.name,
            targetEl = _ref.targetEl,
            cloneEl = _ref.cloneEl,
            toEl = _ref.toEl,
            fromEl = _ref.fromEl,
            oldIndex = _ref.oldIndex,
            newIndex = _ref.newIndex,
            oldDraggableIndex = _ref.oldDraggableIndex,
            newDraggableIndex = _ref.newDraggableIndex,
            originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            extraEventProperties = _ref.extraEventProperties;
        sortable = sortable || rootEl && rootEl[expando];
        if (!sortable) return;
        var evt,
            options = sortable.options,
            onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

        if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent(name, {
                bubbles: true,
                cancelable: true
            });
        } else {
            evt = document.createEvent('Event');
            evt.initEvent(name, true, true);
        }

        evt.to = toEl || rootEl;
        evt.from = fromEl || rootEl;
        evt.item = targetEl || rootEl;
        evt.clone = cloneEl;
        evt.oldIndex = oldIndex;
        evt.newIndex = newIndex;
        evt.oldDraggableIndex = oldDraggableIndex;
        evt.newDraggableIndex = newDraggableIndex;
        evt.originalEvent = originalEvent;
        evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

        var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

        for (var option in allEventProperties) {
            evt[option] = allEventProperties[option];
        }

        if (rootEl) {
            rootEl.dispatchEvent(evt);
        }

        if (options[onName]) {
            options[onName].call(sortable, evt);
        }
    }

    var pluginEvent = function pluginEvent(eventName, sortable) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            originalEvent = _ref.evt,
            data = _objectWithoutProperties(_ref, ["evt"]);

        PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
            dragEl: dragEl,
            parentEl: parentEl,
            ghostEl: ghostEl,
            rootEl: rootEl,
            nextEl: nextEl,
            lastDownEl: lastDownEl,
            cloneEl: cloneEl,
            cloneHidden: cloneHidden,
            dragStarted: moved,
            putSortable: putSortable,
            activeSortable: Sortable.active,
            originalEvent: originalEvent,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex,
            hideGhostForTarget: _hideGhostForTarget,
            unhideGhostForTarget: _unhideGhostForTarget,
            cloneNowHidden: function cloneNowHidden() {
                cloneHidden = true;
            },
            cloneNowShown: function cloneNowShown() {
                cloneHidden = false;
            },
            dispatchSortableEvent: function dispatchSortableEvent(name) {
                _dispatchEvent({
                    sortable: sortable,
                    name: name,
                    originalEvent: originalEvent
                });
            }
        }, data));
    };

    function _dispatchEvent(info) {
        dispatchEvent(_objectSpread({
            putSortable: putSortable,
            cloneEl: cloneEl,
            targetEl: dragEl,
            rootEl: rootEl,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex
        }, info));
    }

    var dragEl,
        parentEl,
        ghostEl,
        rootEl,
        nextEl,
        lastDownEl,
        cloneEl,
        cloneHidden,
        oldIndex,
        newIndex,
        oldDraggableIndex,
        newDraggableIndex,
        activeGroup,
        putSortable,
        awaitingDragStarted = false,
        ignoreNextClick = false,
        sortables = [],
        tapEvt,
        touchEvt,
        lastDx,
        lastDy,
        tapDistanceLeft,
        tapDistanceTop,
        moved,
        lastTarget,
        lastDirection,
        pastFirstInvertThresh = false,
        isCircumstantialInvert = false,
        targetMoveDistance,
    // For positioning ghost absolutely
        ghostRelativeParent,
        ghostRelativeParentInitialScroll = [],
    // (left, top)
        _silent = false,
        savedInputChecked = [];
    /** @const */

    var documentExists = typeof document !== 'undefined',
        PositionGhostAbsolutely = IOS,
        CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
        supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
        supportCssPointerEvents = function () {
            if (!documentExists) return; // false when <= IE11

            if (IE11OrLess) {
                return false;
            }

            var el = document.createElement('x');
            el.style.cssText = 'pointer-events:auto';
            return el.style.pointerEvents === 'auto';
        }(),
        _detectDirection = function _detectDirection(el, options) {
            var elCSS = css(el),
                elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
                child1 = getChild(el, 0, options),
                child2 = getChild(el, 1, options),
                firstChildCSS = child1 && css(child1),
                secondChildCSS = child2 && css(child2),
                firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
                secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

            if (elCSS.display === 'flex') {
                return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
            }

            if (elCSS.display === 'grid') {
                return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
            }

            if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
                var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
                return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
            }

            return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
        },
        _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
            var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
                dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
                dragElOppLength = vertical ? dragRect.width : dragRect.height,
                targetS1Opp = vertical ? targetRect.left : targetRect.top,
                targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
                targetOppLength = vertical ? targetRect.width : targetRect.height;
            return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
        },

        /**
         * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
         * @param  {Number} x      X position
         * @param  {Number} y      Y position
         * @return {HTMLElement}   Element of the first found nearest Sortable
         */
        _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
            var ret;
            sortables.some(function (sortable) {
                if (lastChild(sortable)) return;
                var rect = getRect(sortable),
                    threshold = sortable[expando].options.emptyInsertThreshold,
                    insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
                    insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

                if (threshold && insideHorizontally && insideVertically) {
                    return ret = sortable;
                }
            });
            return ret;
        },
        _prepareGroup = function _prepareGroup(options) {
            function toFn(value, pull) {
                return function (to, from, dragEl, evt) {
                    var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

                    if (value == null && (pull || sameGroup)) {
                        // Default pull value
                        // Default pull and put value if same group
                        return true;
                    } else if (value == null || value === false) {
                        return false;
                    } else if (pull && value === 'clone') {
                        return value;
                    } else if (typeof value === 'function') {
                        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
                    } else {
                        var otherGroup = (pull ? to : from).options.group.name;
                        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
                    }
                };
            }

            var group = {};
            var originalGroup = options.group;

            if (!originalGroup || _typeof(originalGroup) != 'object') {
                originalGroup = {
                    name: originalGroup
                };
            }

            group.name = originalGroup.name;
            group.checkPull = toFn(originalGroup.pull, true);
            group.checkPut = toFn(originalGroup.put);
            group.revertClone = originalGroup.revertClone;
            options.group = group;
        },
        _hideGhostForTarget = function _hideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
                css(ghostEl, 'display', 'none');
            }
        },
        _unhideGhostForTarget = function _unhideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
                css(ghostEl, 'display', '');
            }
        }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


    if (documentExists) {
        document.addEventListener('click', function (evt) {
            if (ignoreNextClick) {
                evt.preventDefault();
                evt.stopPropagation && evt.stopPropagation();
                evt.stopImmediatePropagation && evt.stopImmediatePropagation();
                ignoreNextClick = false;
                return false;
            }
        }, true);
    }

    var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
        if (dragEl) {
            evt = evt.touches ? evt.touches[0] : evt;

            var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

            if (nearest) {
                // Create imitation event
                var event = {};

                for (var i in evt) {
                    if (evt.hasOwnProperty(i)) {
                        event[i] = evt[i];
                    }
                }

                event.target = event.rootEl = nearest;
                event.preventDefault = void 0;
                event.stopPropagation = void 0;

                nearest[expando]._onDragOver(event);
            }
        }
    };

    var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
        if (dragEl) {
            dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        }
    };
    /**
     * @class  Sortable
     * @param  {HTMLElement}  el
     * @param  {Object}       [options]
     */


    function Sortable(el, options) {
        if (!(el && el.nodeType && el.nodeType === 1)) {
            throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
        }

        this.el = el; // root element

        this.options = options = _extends({}, options); // Export instance

        el[expando] = this;
        var defaults = {
            group: null,
            sort: true,
            disabled: false,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
            swapThreshold: 1,
            // percentage; 0 <= x <= 1
            invertSwap: false,
            // invert always
            invertedSwapThreshold: null,
            // will be set to same as swapThreshold if default
            removeCloneOnHide: true,
            direction: function direction() {
                return _detectDirection(el, this.options);
            },
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            ignore: 'a, img',
            filter: null,
            preventOnFilter: true,
            animation: 0,
            easing: null,
            setData: function setData(dataTransfer, dragEl) {
                dataTransfer.setData('Text', dragEl.textContent);
            },
            dropBubble: false,
            dragoverBubble: false,
            dataIdAttr: 'data-id',
            delay: 0,
            delayOnTouchOnly: false,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: false,
            fallbackClass: 'sortable-fallback',
            fallbackOnBody: false,
            fallbackTolerance: 0,
            fallbackOffset: {
                x: 0,
                y: 0
            },
            supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
            emptyInsertThreshold: 5
        };
        PluginManager.initializePlugins(this, el, defaults); // Set default options

        for (var name in defaults) {
            !(name in options) && (options[name] = defaults[name]);
        }

        _prepareGroup(options); // Bind all private methods


        for (var fn in this) {
            if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                this[fn] = this[fn].bind(this);
            }
        } // Setup drag mode


        this.nativeDraggable = options.forceFallback ? false : supportDraggable;

        if (this.nativeDraggable) {
            // Touch start threshold cannot be greater than the native dragstart threshold
            this.options.touchStartThreshold = 1;
        } // Bind events


        if (options.supportPointer) {
            on(el, 'pointerdown', this._onTapStart);
        } else {
            on(el, 'mousedown', this._onTapStart);
            on(el, 'touchstart', this._onTapStart);
        }

        if (this.nativeDraggable) {
            on(el, 'dragover', this);
            on(el, 'dragenter', this);
        }

        sortables.push(this.el); // Restore sorting

        options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

        _extends(this, AnimationStateManager());
    }

    Sortable.prototype =
        /** @lends Sortable.prototype */
    {
        constructor: Sortable,
        _isOutsideThisEl: function _isOutsideThisEl(target) {
            if (!this.el.contains(target) && target !== this.el) {
                lastTarget = null;
            }
        },
        _getDirection: function _getDirection(evt, target) {
            return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
        },
        _onTapStart: function _onTapStart(
            /** Event|TouchEvent */
            evt) {
            if (!evt.cancelable) return;

            var _this = this,
                el = this.el,
                options = this.options,
                preventOnFilter = options.preventOnFilter,
                type = evt.type,
                touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
                target = (touch || evt).target,
                originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
                filter = options.filter;

            _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


            if (dragEl) {
                return;
            }

            if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
                return; // only left button and enabled
            } // cancel dnd if original target is content editable


            if (originalTarget.isContentEditable) {
                return;
            }

            target = closest(target, options.draggable, el, false);

            if (target && target.animated) {
                return;
            }

            if (lastDownEl === target) {
                // Ignoring duplicate `down`
                return;
            } // Get the index of the dragged element within its parent


            oldIndex = index(target);
            oldDraggableIndex = index(target, options.draggable); // Check filter

            if (typeof filter === 'function') {
                if (filter.call(this, evt, target, this)) {
                    _dispatchEvent({
                        sortable: _this,
                        rootEl: originalTarget,
                        name: 'filter',
                        targetEl: target,
                        toEl: el,
                        fromEl: el
                    });

                    pluginEvent('filter', _this, {
                        evt: evt
                    });
                    preventOnFilter && evt.cancelable && evt.preventDefault();
                    return; // cancel dnd
                }
            } else if (filter) {
                filter = filter.split(',').some(function (criteria) {
                    criteria = closest(originalTarget, criteria.trim(), el, false);

                    if (criteria) {
                        _dispatchEvent({
                            sortable: _this,
                            rootEl: criteria,
                            name: 'filter',
                            targetEl: target,
                            fromEl: el,
                            toEl: el
                        });

                        pluginEvent('filter', _this, {
                            evt: evt
                        });
                        return true;
                    }
                });

                if (filter) {
                    preventOnFilter && evt.cancelable && evt.preventDefault();
                    return; // cancel dnd
                }
            }

            if (options.handle && !closest(originalTarget, options.handle, el, false)) {
                return;
            } // Prepare `dragstart`


            this._prepareDragStart(evt, touch, target);
        },
        _prepareDragStart: function _prepareDragStart(
            /** Event */
            evt,
            /** Touch */
            touch,
            /** HTMLElement */
            target) {
            var _this = this,
                el = _this.el,
                options = _this.options,
                ownerDocument = el.ownerDocument,
                dragStartFn;

            if (target && !dragEl && target.parentNode === el) {
                var dragRect = getRect(target);
                rootEl = el;
                dragEl = target;
                parentEl = dragEl.parentNode;
                nextEl = dragEl.nextSibling;
                lastDownEl = target;
                activeGroup = options.group;
                Sortable.dragged = dragEl;
                tapEvt = {
                    target: dragEl,
                    clientX: (touch || evt).clientX,
                    clientY: (touch || evt).clientY
                };
                tapDistanceLeft = tapEvt.clientX - dragRect.left;
                tapDistanceTop = tapEvt.clientY - dragRect.top;
                this._lastX = (touch || evt).clientX;
                this._lastY = (touch || evt).clientY;
                dragEl.style['will-change'] = 'all';

                dragStartFn = function dragStartFn() {
                    pluginEvent('delayEnded', _this, {
                        evt: evt
                    });

                    if (Sortable.eventCanceled) {
                        _this._onDrop();

                        return;
                    } // Delayed drag has been triggered
                    // we can re-enable the events: touchmove/mousemove


                    _this._disableDelayedDragEvents();

                    if (!FireFox && _this.nativeDraggable) {
                        dragEl.draggable = true;
                    } // Bind the events: dragstart/dragend


                    _this._triggerDragStart(evt, touch); // Drag start event


                    _dispatchEvent({
                        sortable: _this,
                        name: 'choose',
                        originalEvent: evt
                    }); // Chosen item


                    toggleClass(dragEl, options.chosenClass, true);
                }; // Disable "draggable"


                options.ignore.split(',').forEach(function (criteria) {
                    find(dragEl, criteria.trim(), _disableDraggable);
                });
                on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'mouseup', _this._onDrop);
                on(ownerDocument, 'touchend', _this._onDrop);
                on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

                if (FireFox && this.nativeDraggable) {
                    this.options.touchStartThreshold = 4;
                    dragEl.draggable = true;
                }

                pluginEvent('delayStart', this, {
                    evt: evt
                }); // Delay is impossible for native DnD in Edge or IE

                if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                    if (Sortable.eventCanceled) {
                        this._onDrop();

                        return;
                    } // If the user moves the pointer or let go the click or touch
                    // before the delay has been reached:
                    // disable the delayed drag


                    on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                    on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                    on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                    options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                    _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
                } else {
                    dragStartFn();
                }
            }
        },
        _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
            /** TouchEvent|PointerEvent **/
            e) {
            var touch = e.touches ? e.touches[0] : e;

            if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
                this._disableDelayedDrag();
            }
        },
        _disableDelayedDrag: function _disableDelayedDrag() {
            dragEl && _disableDraggable(dragEl);
            clearTimeout(this._dragStartTimer);

            this._disableDelayedDragEvents();
        },
        _disableDelayedDragEvents: function _disableDelayedDragEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._disableDelayedDrag);
            off(ownerDocument, 'touchend', this._disableDelayedDrag);
            off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
            off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
        },
        _triggerDragStart: function _triggerDragStart(
            /** Event */
            evt,
            /** Touch */
            touch) {
            touch = touch || evt.pointerType == 'touch' && evt;

            if (!this.nativeDraggable || touch) {
                if (this.options.supportPointer) {
                    on(document, 'pointermove', this._onTouchMove);
                } else if (touch) {
                    on(document, 'touchmove', this._onTouchMove);
                } else {
                    on(document, 'mousemove', this._onTouchMove);
                }
            } else {
                on(dragEl, 'dragend', this);
                on(rootEl, 'dragstart', this._onDragStart);
            }

            try {
                if (document.selection) {
                    // Timeout neccessary for IE9
                    _nextTick(function () {
                        document.selection.empty();
                    });
                } else {
                    window.getSelection().removeAllRanges();
                }
            } catch (err) {}
        },
        _dragStarted: function _dragStarted(fallback, evt) {

            awaitingDragStarted = false;

            if (rootEl && dragEl) {
                pluginEvent('dragStarted', this, {
                    evt: evt
                });

                if (this.nativeDraggable) {
                    on(document, 'dragover', _checkOutsideTargetEl);
                }

                var options = this.options; // Apply effect

                !fallback && toggleClass(dragEl, options.dragClass, false);
                toggleClass(dragEl, options.ghostClass, true);
                Sortable.active = this;
                fallback && this._appendGhost(); // Drag start event

                _dispatchEvent({
                    sortable: this,
                    name: 'start',
                    originalEvent: evt
                });
            } else {
                this._nulling();
            }
        },
        _emulateDragOver: function _emulateDragOver() {
            if (touchEvt) {
                this._lastX = touchEvt.clientX;
                this._lastY = touchEvt.clientY;

                _hideGhostForTarget();

                var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                var parent = target;

                while (target && target.shadowRoot) {
                    target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                    if (target === parent) break;
                    parent = target;
                }

                dragEl.parentNode[expando]._isOutsideThisEl(target);

                if (parent) {
                    do {
                        if (parent[expando]) {
                            var inserted = void 0;
                            inserted = parent[expando]._onDragOver({
                                clientX: touchEvt.clientX,
                                clientY: touchEvt.clientY,
                                target: target,
                                rootEl: parent
                            });

                            if (inserted && !this.options.dragoverBubble) {
                                break;
                            }
                        }

                        target = parent; // store last element
                    }
                        /* jshint boss:true */
                    while (parent = parent.parentNode);
                }

                _unhideGhostForTarget();
            }
        },
        _onTouchMove: function _onTouchMove(
            /**TouchEvent*/
            evt) {
            if (tapEvt) {
                var options = this.options,
                    fallbackTolerance = options.fallbackTolerance,
                    fallbackOffset = options.fallbackOffset,
                    touch = evt.touches ? evt.touches[0] : evt,
                    ghostMatrix = ghostEl && matrix(ghostEl),
                    scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
                    scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
                    relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
                    dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
                    dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

                if (!Sortable.active && !awaitingDragStarted) {
                    if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
                        return;
                    }

                    this._onDragStart(evt, true);
                }

                if (ghostEl) {
                    if (ghostMatrix) {
                        ghostMatrix.e += dx - (lastDx || 0);
                        ghostMatrix.f += dy - (lastDy || 0);
                    } else {
                        ghostMatrix = {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            e: dx,
                            f: dy
                        };
                    }

                    var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                    css(ghostEl, 'webkitTransform', cssMatrix);
                    css(ghostEl, 'mozTransform', cssMatrix);
                    css(ghostEl, 'msTransform', cssMatrix);
                    css(ghostEl, 'transform', cssMatrix);
                    lastDx = dx;
                    lastDy = dy;
                    touchEvt = touch;
                }

                evt.cancelable && evt.preventDefault();
            }
        },
        _appendGhost: function _appendGhost() {
            // Bug if using scale(): https://stackoverflow.com/questions/2637058
            // Not being adjusted for
            if (!ghostEl) {
                var container = this.options.fallbackOnBody ? document.body : rootEl,
                    rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
                    options = this.options; // Position absolutely

                if (PositionGhostAbsolutely) {
                    // Get relatively positioned parent
                    ghostRelativeParent = container;

                    while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
                        ghostRelativeParent = ghostRelativeParent.parentNode;
                    }

                    if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                        if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                        rect.top += ghostRelativeParent.scrollTop;
                        rect.left += ghostRelativeParent.scrollLeft;
                    } else {
                        ghostRelativeParent = getWindowScrollingElement();
                    }

                    ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
                }

                ghostEl = dragEl.cloneNode(true);
                toggleClass(ghostEl, options.ghostClass, false);
                toggleClass(ghostEl, options.fallbackClass, true);
                toggleClass(ghostEl, options.dragClass, true);
                css(ghostEl, 'transition', '');
                css(ghostEl, 'transform', '');
                css(ghostEl, 'box-sizing', 'border-box');
                css(ghostEl, 'margin', 0);
                css(ghostEl, 'top', rect.top);
                css(ghostEl, 'left', rect.left);
                css(ghostEl, 'width', rect.width);
                css(ghostEl, 'height', rect.height);
                css(ghostEl, 'opacity', '0.8');
                css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
                css(ghostEl, 'zIndex', '100000');
                css(ghostEl, 'pointerEvents', 'none');
                Sortable.ghost = ghostEl;
                container.appendChild(ghostEl); // Set transform-origin

                css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
            }
        },
        _onDragStart: function _onDragStart(
            /**Event*/
            evt,
            /**boolean*/
            fallback) {
            var _this = this;

            var dataTransfer = evt.dataTransfer;
            var options = _this.options;
            pluginEvent('dragStart', this, {
                evt: evt
            });

            if (Sortable.eventCanceled) {
                this._onDrop();

                return;
            }

            pluginEvent('setupClone', this);

            if (!Sortable.eventCanceled) {
                cloneEl = clone(dragEl);
                cloneEl.draggable = false;
                cloneEl.style['will-change'] = '';

                this._hideClone();

                toggleClass(cloneEl, this.options.chosenClass, false);
                Sortable.clone = cloneEl;
            } // #1143: IFrame support workaround


            _this.cloneId = _nextTick(function () {
                pluginEvent('clone', _this);
                if (Sortable.eventCanceled) return;

                if (!_this.options.removeCloneOnHide) {
                    rootEl.insertBefore(cloneEl, dragEl);
                }

                _this._hideClone();

                _dispatchEvent({
                    sortable: _this,
                    name: 'clone'
                });
            });
            !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

            if (fallback) {
                ignoreNextClick = true;
                _this._loopId = setInterval(_this._emulateDragOver, 50);
            } else {
                // Undo what was set in _prepareDragStart before drag started
                off(document, 'mouseup', _this._onDrop);
                off(document, 'touchend', _this._onDrop);
                off(document, 'touchcancel', _this._onDrop);

                if (dataTransfer) {
                    dataTransfer.effectAllowed = 'move';
                    options.setData && options.setData.call(_this, dataTransfer, dragEl);
                }

                on(document, 'drop', _this); // #1276 fix:

                css(dragEl, 'transform', 'translateZ(0)');
            }

            awaitingDragStarted = true;
            _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
            on(document, 'selectstart', _this);
            moved = true;

            if (Safari) {
                css(document.body, 'user-select', 'none');
            }
        },
        // Returns true - if no further action is needed (either inserted or another condition)
        _onDragOver: function _onDragOver(
            /**Event*/
            evt) {
            var el = this.el,
                target = evt.target,
                dragRect,
                targetRect,
                revert,
                options = this.options,
                group = options.group,
                activeSortable = Sortable.active,
                isOwner = activeGroup === group,
                canSort = options.sort,
                fromSortable = putSortable || activeSortable,
                vertical,
                _this = this,
                completedFired = false;

            if (_silent) return;

            function dragOverEvent(name, extra) {
                pluginEvent(name, _this, _objectSpread({
                    evt: evt,
                    isOwner: isOwner,
                    axis: vertical ? 'vertical' : 'horizontal',
                    revert: revert,
                    dragRect: dragRect,
                    targetRect: targetRect,
                    canSort: canSort,
                    fromSortable: fromSortable,
                    target: target,
                    completed: completed,
                    onMove: function onMove(target, after) {
                        return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
                    },
                    changed: changed
                }, extra));
            } // Capture animation state


            function capture() {
                dragOverEvent('dragOverAnimationCapture');

                _this.captureAnimationState();

                if (_this !== fromSortable) {
                    fromSortable.captureAnimationState();
                }
            } // Return invocation when dragEl is inserted (or completed)


            function completed(insertion) {
                dragOverEvent('dragOverCompleted', {
                    insertion: insertion
                });

                if (insertion) {
                    // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                    if (isOwner) {
                        activeSortable._hideClone();
                    } else {
                        activeSortable._showClone(_this);
                    }

                    if (_this !== fromSortable) {
                        // Set ghost class to new sortable's ghost class
                        toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                        toggleClass(dragEl, options.ghostClass, true);
                    }

                    if (putSortable !== _this && _this !== Sortable.active) {
                        putSortable = _this;
                    } else if (_this === Sortable.active && putSortable) {
                        putSortable = null;
                    } // Animation


                    if (fromSortable === _this) {
                        _this._ignoreWhileAnimating = target;
                    }

                    _this.animateAll(function () {
                        dragOverEvent('dragOverAnimationComplete');
                        _this._ignoreWhileAnimating = null;
                    });

                    if (_this !== fromSortable) {
                        fromSortable.animateAll();
                        fromSortable._ignoreWhileAnimating = null;
                    }
                } // Null lastTarget if it is not inside a previously swapped element


                if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
                    lastTarget = null;
                } // no bubbling and not fallback


                if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                    dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


                    !insertion && nearestEmptyInsertDetectEvent(evt);
                }

                !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
                return completedFired = true;
            } // Call when dragEl has been inserted


            function changed() {
                newIndex = index(dragEl);
                newDraggableIndex = index(dragEl, options.draggable);

                _dispatchEvent({
                    sortable: _this,
                    name: 'change',
                    toEl: el,
                    newIndex: newIndex,
                    newDraggableIndex: newDraggableIndex,
                    originalEvent: evt
                });
            }

            if (evt.preventDefault !== void 0) {
                evt.cancelable && evt.preventDefault();
            }

            target = closest(target, options.draggable, el, true);
            dragOverEvent('dragOver');
            if (Sortable.eventCanceled) return completedFired;

            if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
                return completed(false);
            }

            ignoreNextClick = false;

            if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
                    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
                vertical = this._getDirection(evt, target) === 'vertical';
                dragRect = getRect(dragEl);
                dragOverEvent('dragOverValid');
                if (Sortable.eventCanceled) return completedFired;

                if (revert) {
                    parentEl = rootEl; // actualization

                    capture();

                    this._hideClone();

                    dragOverEvent('revert');

                    if (!Sortable.eventCanceled) {
                        if (nextEl) {
                            rootEl.insertBefore(dragEl, nextEl);
                        } else {
                            rootEl.appendChild(dragEl);
                        }
                    }

                    return completed(true);
                }

                var elLastChild = lastChild(el, options.draggable);

                if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                    // If already at end of list: Do not insert
                    if (elLastChild === dragEl) {
                        return completed(false);
                    } // assign target only if condition is true


                    if (elLastChild && el === evt.target) {
                        target = elLastChild;
                    }

                    if (target) {
                        targetRect = getRect(target);
                    }

                    if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                        capture();
                        el.appendChild(dragEl);
                        parentEl = el; // actualization

                        changed();
                        return completed(true);
                    }
                } else if (target.parentNode === el) {
                    targetRect = getRect(target);
                    var direction = 0,
                        targetBeforeFirstSwap,
                        differentLevel = dragEl.parentNode !== el,
                        differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
                        side1 = vertical ? 'top' : 'left',
                        scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
                        scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

                    if (lastTarget !== target) {
                        targetBeforeFirstSwap = targetRect[side1];
                        pastFirstInvertThresh = false;
                        isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                    }

                    direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                    var sibling;

                    if (direction !== 0) {
                        // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                        var dragIndex = index(dragEl);

                        do {
                            dragIndex -= direction;
                            sibling = parentEl.children[dragIndex];
                        } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
                    } // If dragEl is already beside target: Do not insert


                    if (direction === 0 || sibling === target) {
                        return completed(false);
                    }

                    lastTarget = target;
                    lastDirection = direction;
                    var nextSibling = target.nextElementSibling,
                        after = false;
                    after = direction === 1;

                    var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

                    if (moveVector !== false) {
                        if (moveVector === 1 || moveVector === -1) {
                            after = moveVector === 1;
                        }

                        _silent = true;
                        setTimeout(_unsilent, 30);
                        capture();

                        if (after && !nextSibling) {
                            el.appendChild(dragEl);
                        } else {
                            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                        } // Undo chrome's scroll adjustment (has no effect on other browsers)


                        if (scrolledPastTop) {
                            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                        }

                        parentEl = dragEl.parentNode; // actualization
                        // must be done before animation

                        if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
                            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                        }

                        changed();
                        return completed(true);
                    }
                }

                if (el.contains(dragEl)) {
                    return completed(false);
                }
            }

            return false;
        },
        _ignoreWhileAnimating: null,
        _offMoveEvents: function _offMoveEvents() {
            off(document, 'mousemove', this._onTouchMove);
            off(document, 'touchmove', this._onTouchMove);
            off(document, 'pointermove', this._onTouchMove);
            off(document, 'dragover', nearestEmptyInsertDetectEvent);
            off(document, 'mousemove', nearestEmptyInsertDetectEvent);
            off(document, 'touchmove', nearestEmptyInsertDetectEvent);
        },
        _offUpEvents: function _offUpEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._onDrop);
            off(ownerDocument, 'touchend', this._onDrop);
            off(ownerDocument, 'pointerup', this._onDrop);
            off(ownerDocument, 'touchcancel', this._onDrop);
            off(document, 'selectstart', this);
        },
        _onDrop: function _onDrop(
            /**Event*/
            evt) {
            var el = this.el,
                options = this.options; // Get the index of the dragged element within its parent

            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            pluginEvent('drop', this, {
                evt: evt
            });
            parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);

            if (Sortable.eventCanceled) {
                this._nulling();

                return;
            }

            awaitingDragStarted = false;
            isCircumstantialInvert = false;
            pastFirstInvertThresh = false;
            clearInterval(this._loopId);
            clearTimeout(this._dragStartTimer);

            _cancelNextTick(this.cloneId);

            _cancelNextTick(this._dragStartId); // Unbind events


            if (this.nativeDraggable) {
                off(document, 'drop', this);
                off(el, 'dragstart', this._onDragStart);
            }

            this._offMoveEvents();

            this._offUpEvents();

            if (Safari) {
                css(document.body, 'user-select', '');
            }

            if (evt) {
                if (moved) {
                    evt.cancelable && evt.preventDefault();
                    !options.dropBubble && evt.stopPropagation();
                }

                ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

                if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                    // Remove clone(s)
                    cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
                }

                if (dragEl) {
                    if (this.nativeDraggable) {
                        off(dragEl, 'dragend', this);
                    }

                    _disableDraggable(dragEl);

                    dragEl.style['will-change'] = ''; // Remove classes
                    // ghostClass is added in dragStarted

                    if (moved && !awaitingDragStarted) {
                        toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                    }

                    toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

                    _dispatchEvent({
                        sortable: this,
                        name: 'unchoose',
                        toEl: parentEl,
                        newIndex: null,
                        newDraggableIndex: null,
                        originalEvent: evt
                    });

                    if (rootEl !== parentEl) {
                        if (newIndex >= 0) {
                            // Add event
                            _dispatchEvent({
                                rootEl: parentEl,
                                name: 'add',
                                toEl: parentEl,
                                fromEl: rootEl,
                                originalEvent: evt
                            }); // Remove event


                            _dispatchEvent({
                                sortable: this,
                                name: 'remove',
                                toEl: parentEl,
                                originalEvent: evt
                            }); // drag from one list and drop into another


                            _dispatchEvent({
                                rootEl: parentEl,
                                name: 'sort',
                                toEl: parentEl,
                                fromEl: rootEl,
                                originalEvent: evt
                            });

                            _dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                        }

                        putSortable && putSortable.save();
                    } else {
                        if (newIndex !== oldIndex) {
                            if (newIndex >= 0) {
                                // drag & drop within the same list
                                _dispatchEvent({
                                    sortable: this,
                                    name: 'update',
                                    toEl: parentEl,
                                    originalEvent: evt
                                });

                                _dispatchEvent({
                                    sortable: this,
                                    name: 'sort',
                                    toEl: parentEl,
                                    originalEvent: evt
                                });
                            }
                        }
                    }

                    if (Sortable.active) {
                        /* jshint eqnull:true */
                        if (newIndex == null || newIndex === -1) {
                            newIndex = oldIndex;
                            newDraggableIndex = oldDraggableIndex;
                        }

                        _dispatchEvent({
                            sortable: this,
                            name: 'end',
                            toEl: parentEl,
                            originalEvent: evt
                        }); // Save sorting


                        this.save();
                    }
                }
            }

            this._nulling();
        },
        _nulling: function _nulling() {
            pluginEvent('nulling', this);
            rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
            savedInputChecked.forEach(function (el) {
                el.checked = true;
            });
            savedInputChecked.length = lastDx = lastDy = 0;
        },
        handleEvent: function handleEvent(
            /**Event*/
            evt) {
            switch (evt.type) {
                case 'drop':
                case 'dragend':
                    this._onDrop(evt);

                    break;

                case 'dragenter':
                case 'dragover':
                    if (dragEl) {
                        this._onDragOver(evt);

                        _globalDragOver(evt);
                    }

                    break;

                case 'selectstart':
                    evt.preventDefault();
                    break;
            }
        },

        /**
         * Serializes the item into an array of string.
         * @returns {String[]}
         */
        toArray: function toArray() {
            var order = [],
                el,
                children = this.el.children,
                i = 0,
                n = children.length,
                options = this.options;

            for (; i < n; i++) {
                el = children[i];

                if (closest(el, options.draggable, this.el, false)) {
                    order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
                }
            }

            return order;
        },

        /**
         * Sorts the elements according to the array.
         * @param  {String[]}  order  order of the items
         */
        sort: function sort(order) {
            var items = {},
                rootEl = this.el;
            this.toArray().forEach(function (id, i) {
                var el = rootEl.children[i];

                if (closest(el, this.options.draggable, rootEl, false)) {
                    items[id] = el;
                }
            }, this);
            order.forEach(function (id) {
                if (items[id]) {
                    rootEl.removeChild(items[id]);
                    rootEl.appendChild(items[id]);
                }
            });
        },

        /**
         * Save the current sorting
         */
        save: function save() {
            var store = this.options.store;
            store && store.set && store.set(this);
        },

        /**
         * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
         * @param   {HTMLElement}  el
         * @param   {String}       [selector]  default: `options.draggable`
         * @returns {HTMLElement|null}
         */
        closest: function closest$1(el, selector) {
            return closest(el, selector || this.options.draggable, this.el, false);
        },

        /**
         * Set/get option
         * @param   {string} name
         * @param   {*}      [value]
         * @returns {*}
         */
        option: function option(name, value) {
            var options = this.options;

            if (value === void 0) {
                return options[name];
            } else {
                var modifiedValue = PluginManager.modifyOption(this, name, value);

                if (typeof modifiedValue !== 'undefined') {
                    options[name] = modifiedValue;
                } else {
                    options[name] = value;
                }

                if (name === 'group') {
                    _prepareGroup(options);
                }
            }
        },

        /**
         * Destroy
         */
        destroy: function destroy() {
            pluginEvent('destroy', this);
            var el = this.el;
            el[expando] = null;
            off(el, 'mousedown', this._onTapStart);
            off(el, 'touchstart', this._onTapStart);
            off(el, 'pointerdown', this._onTapStart);

            if (this.nativeDraggable) {
                off(el, 'dragover', this);
                off(el, 'dragenter', this);
            } // Remove draggable attributes


            Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
                el.removeAttribute('draggable');
            });

            this._onDrop();

            sortables.splice(sortables.indexOf(this.el), 1);
            this.el = el = null;
        },
        _hideClone: function _hideClone() {
            if (!cloneHidden) {
                pluginEvent('hideClone', this);
                if (Sortable.eventCanceled) return;
                css(cloneEl, 'display', 'none');

                if (this.options.removeCloneOnHide && cloneEl.parentNode) {
                    cloneEl.parentNode.removeChild(cloneEl);
                }

                cloneHidden = true;
            }
        },
        _showClone: function _showClone(putSortable) {
            if (putSortable.lastPutMode !== 'clone') {
                this._hideClone();

                return;
            }

            if (cloneHidden) {
                pluginEvent('showClone', this);
                if (Sortable.eventCanceled) return; // show clone at dragEl or original position

                if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
                    rootEl.insertBefore(cloneEl, dragEl);
                } else if (nextEl) {
                    rootEl.insertBefore(cloneEl, nextEl);
                } else {
                    rootEl.appendChild(cloneEl);
                }

                if (this.options.group.revertClone) {
                    this.animate(dragEl, cloneEl);
                }

                css(cloneEl, 'display', '');
                cloneHidden = false;
            }
        }
    };

    function _globalDragOver(
        /**Event*/
        evt) {
        if (evt.dataTransfer) {
            evt.dataTransfer.dropEffect = 'move';
        }

        evt.cancelable && evt.preventDefault();
    }

    function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
        var evt,
            sortable = fromEl[expando],
            onMoveFn = sortable.options.onMove,
            retVal; // Support for new CustomEvent feature

        if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent('move', {
                bubbles: true,
                cancelable: true
            });
        } else {
            evt = document.createEvent('Event');
            evt.initEvent('move', true, true);
        }

        evt.to = toEl;
        evt.from = fromEl;
        evt.dragged = dragEl;
        evt.draggedRect = dragRect;
        evt.related = targetEl || toEl;
        evt.relatedRect = targetRect || getRect(toEl);
        evt.willInsertAfter = willInsertAfter;
        evt.originalEvent = originalEvent;
        fromEl.dispatchEvent(evt);

        if (onMoveFn) {
            retVal = onMoveFn.call(sortable, evt, originalEvent);
        }

        return retVal;
    }

    function _disableDraggable(el) {
        el.draggable = false;
    }

    function _unsilent() {
        _silent = false;
    }

    function _ghostIsLast(evt, vertical, sortable) {
        var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
        var spacer = 10;
        return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
    }

    function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
        var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
            targetLength = vertical ? targetRect.height : targetRect.width,
            targetS1 = vertical ? targetRect.top : targetRect.left,
            targetS2 = vertical ? targetRect.bottom : targetRect.right,
            invert = false;

        if (!invertSwap) {
            // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
            if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
                // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
                // check if past first invert threshold on side opposite of lastDirection
                if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
                    // past first invert threshold, do not restrict inverted threshold to dragEl shadow
                    pastFirstInvertThresh = true;
                }

                if (!pastFirstInvertThresh) {
                    // dragEl shadow (target move distance shadow)
                    if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
                            : mouseOnAxis > targetS2 - targetMoveDistance) {
                        return -lastDirection;
                    }
                } else {
                    invert = true;
                }
            } else {
                // Regular
                if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
                    return _getInsertDirection(target);
                }
            }
        }

        invert = invert || invertSwap;

        if (invert) {
            // Invert of regular
            if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
                return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
            }
        }

        return 0;
    }
    /**
     * Gets the direction dragEl must be swapped relative to target in order to make it
     * seem that dragEl has been "inserted" into that element's position
     * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
     * @return {Number}                   Direction dragEl must be swapped
     */


    function _getInsertDirection(target) {
        if (index(dragEl) < index(target)) {
            return 1;
        } else {
            return -1;
        }
    }
    /**
     * Generate id
     * @param   {HTMLElement} el
     * @returns {String}
     * @private
     */


    function _generateId(el) {
        var str = el.tagName + el.className + el.src + el.href + el.textContent,
            i = str.length,
            sum = 0;

        while (i--) {
            sum += str.charCodeAt(i);
        }

        return sum.toString(36);
    }

    function _saveInputCheckedState(root) {
        savedInputChecked.length = 0;
        var inputs = root.getElementsByTagName('input');
        var idx = inputs.length;

        while (idx--) {
            var el = inputs[idx];
            el.checked && savedInputChecked.push(el);
        }
    }

    function _nextTick(fn) {
        return setTimeout(fn, 0);
    }

    function _cancelNextTick(id) {
        return clearTimeout(id);
    } // Fixed #973:


    if (documentExists) {
        on(document, 'touchmove', function (evt) {
            if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
                evt.preventDefault();
            }
        });
    } // Export utils


    Sortable.utils = {
        on: on,
        off: off,
        css: css,
        find: find,
        is: function is(el, selector) {
            return !!closest(el, selector, el, false);
        },
        extend: extend,
        throttle: throttle,
        closest: closest,
        toggleClass: toggleClass,
        clone: clone,
        index: index,
        nextTick: _nextTick,
        cancelNextTick: _cancelNextTick,
        detectDirection: _detectDirection,
        getChild: getChild
    };
    /**
     * Get the Sortable instance of an element
     * @param  {HTMLElement} element The element
     * @return {Sortable|undefined}         The instance of Sortable
     */

    Sortable.get = function (element) {
        return element[expando];
    };
    /**
     * Mount a plugin to Sortable
     * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
     */


    Sortable.mount = function () {
        for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
            plugins[_key] = arguments[_key];
        }

        if (plugins[0].constructor === Array) plugins = plugins[0];
        plugins.forEach(function (plugin) {
            if (!plugin.prototype || !plugin.prototype.constructor) {
                throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
            }

            if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
            PluginManager.mount(plugin);
        });
    };
    /**
     * Create sortable instance
     * @param {HTMLElement}  el
     * @param {Object}      [options]
     */


    Sortable.create = function (el, options) {
        return new Sortable(el, options);
    }; // Export


    Sortable.version = version;

    var autoScrolls = [],
        scrollEl,
        scrollRootEl,
        scrolling = false,
        lastAutoScrollX,
        lastAutoScrollY,
        touchEvt$1,
        pointerElemChangedInterval;

    function AutoScrollPlugin() {
        function AutoScroll() {
            this.defaults = {
                scroll: true,
                scrollSensitivity: 30,
                scrollSpeed: 10,
                bubbleScroll: true
            }; // Bind all private methods

            for (var fn in this) {
                if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                    this[fn] = this[fn].bind(this);
                }
            }
        }

        AutoScroll.prototype = {
            dragStarted: function dragStarted(_ref) {
                var originalEvent = _ref.originalEvent;

                if (this.sortable.nativeDraggable) {
                    on(document, 'dragover', this._handleAutoScroll);
                } else {
                    if (this.options.supportPointer) {
                        on(document, 'pointermove', this._handleFallbackAutoScroll);
                    } else if (originalEvent.touches) {
                        on(document, 'touchmove', this._handleFallbackAutoScroll);
                    } else {
                        on(document, 'mousemove', this._handleFallbackAutoScroll);
                    }
                }
            },
            dragOverCompleted: function dragOverCompleted(_ref2) {
                var originalEvent = _ref2.originalEvent;

                // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
                if (!this.options.dragOverBubble && !originalEvent.rootEl) {
                    this._handleAutoScroll(originalEvent);
                }
            },
            drop: function drop() {
                if (this.sortable.nativeDraggable) {
                    off(document, 'dragover', this._handleAutoScroll);
                } else {
                    off(document, 'pointermove', this._handleFallbackAutoScroll);
                    off(document, 'touchmove', this._handleFallbackAutoScroll);
                    off(document, 'mousemove', this._handleFallbackAutoScroll);
                }

                clearPointerElemChangedInterval();
                clearAutoScrolls();
                cancelThrottle();
            },
            nulling: function nulling() {
                touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
                autoScrolls.length = 0;
            },
            _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
                this._handleAutoScroll(evt, true);
            },
            _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
                var _this = this;

                var x = (evt.touches ? evt.touches[0] : evt).clientX,
                    y = (evt.touches ? evt.touches[0] : evt).clientY,
                    elem = document.elementFromPoint(x, y);
                touchEvt$1 = evt; // IE does not seem to have native autoscroll,
                // Edge's autoscroll seems too conditional,
                // MACOS Safari does not have autoscroll,
                // Firefox and Chrome are good

                if (fallback || Edge || IE11OrLess || Safari) {
                    autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

                    var ogElemScroller = getParentAutoScrollElement(elem, true);

                    if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                        pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

                        pointerElemChangedInterval = setInterval(function () {
                            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

                            if (newElem !== ogElemScroller) {
                                ogElemScroller = newElem;
                                clearAutoScrolls();
                            }

                            autoScroll(evt, _this.options, newElem, fallback);
                        }, 10);
                        lastAutoScrollX = x;
                        lastAutoScrollY = y;
                    }
                } else {
                    // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                    if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                        clearAutoScrolls();
                        return;
                    }

                    autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
                }
            }
        };
        return _extends(AutoScroll, {
            pluginName: 'scroll',
            initializeByDefault: true
        });
    }

    function clearAutoScrolls() {
        autoScrolls.forEach(function (autoScroll) {
            clearInterval(autoScroll.pid);
        });
        autoScrolls = [];
    }

    function clearPointerElemChangedInterval() {
        clearInterval(pointerElemChangedInterval);
    }

    var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
        // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
        if (!options.scroll) return;
        var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            sens = options.scrollSensitivity,
            speed = options.scrollSpeed,
            winScroller = getWindowScrollingElement();
        var scrollThisInstance = false,
            scrollCustomFn; // New scroll root, set scrollEl

        if (scrollRootEl !== rootEl) {
            scrollRootEl = rootEl;
            clearAutoScrolls();
            scrollEl = options.scroll;
            scrollCustomFn = options.scrollFn;

            if (scrollEl === true) {
                scrollEl = getParentAutoScrollElement(rootEl, true);
            }
        }

        var layersOut = 0;
        var currentParent = scrollEl;

        do {
            var el = currentParent,
                rect = getRect(el),
                top = rect.top,
                bottom = rect.bottom,
                left = rect.left,
                right = rect.right,
                width = rect.width,
                height = rect.height,
                canScrollX = void 0,
                canScrollY = void 0,
                scrollWidth = el.scrollWidth,
                scrollHeight = el.scrollHeight,
                elCSS = css(el),
                scrollPosX = el.scrollLeft,
                scrollPosY = el.scrollTop;

            if (el === winScroller) {
                canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
                canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
            } else {
                canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
                canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
            }

            var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
            var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

            if (!autoScrolls[layersOut]) {
                for (var i = 0; i <= layersOut; i++) {
                    if (!autoScrolls[i]) {
                        autoScrolls[i] = {};
                    }
                }
            }

            if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
                autoScrolls[layersOut].el = el;
                autoScrolls[layersOut].vx = vx;
                autoScrolls[layersOut].vy = vy;
                clearInterval(autoScrolls[layersOut].pid);

                if (vx != 0 || vy != 0) {
                    scrollThisInstance = true;
                    /* jshint loopfunc:true */

                    autoScrolls[layersOut].pid = setInterval(function () {
                        // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                        if (isFallback && this.layer === 0) {
                            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

                        }

                        var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                        var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

                        if (typeof scrollCustomFn === 'function') {
                            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                                return;
                            }
                        }

                        scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                    }.bind({
                        layer: layersOut
                    }), 24);
                }
            }

            layersOut++;
        } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

        scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
    }, 30);

    var drop = function drop(_ref) {
        var originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            dragEl = _ref.dragEl,
            activeSortable = _ref.activeSortable,
            dispatchSortableEvent = _ref.dispatchSortableEvent,
            hideGhostForTarget = _ref.hideGhostForTarget,
            unhideGhostForTarget = _ref.unhideGhostForTarget;
        if (!originalEvent) return;
        var toSortable = putSortable || activeSortable;
        hideGhostForTarget();
        var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
        var target = document.elementFromPoint(touch.clientX, touch.clientY);
        unhideGhostForTarget();

        if (toSortable && !toSortable.el.contains(target)) {
            dispatchSortableEvent('spill');
            this.onSpill({
                dragEl: dragEl,
                putSortable: putSortable
            });
        }
    };

    function Revert() {}

    Revert.prototype = {
        startIndex: null,
        dragStart: function dragStart(_ref2) {
            var oldDraggableIndex = _ref2.oldDraggableIndex;
            this.startIndex = oldDraggableIndex;
        },
        onSpill: function onSpill(_ref3) {
            var dragEl = _ref3.dragEl,
                putSortable = _ref3.putSortable;
            this.sortable.captureAnimationState();

            if (putSortable) {
                putSortable.captureAnimationState();
            }

            var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

            if (nextSibling) {
                this.sortable.el.insertBefore(dragEl, nextSibling);
            } else {
                this.sortable.el.appendChild(dragEl);
            }

            this.sortable.animateAll();

            if (putSortable) {
                putSortable.animateAll();
            }
        },
        drop: drop
    };

    _extends(Revert, {
        pluginName: 'revertOnSpill'
    });

    function Remove() {}

    Remove.prototype = {
        onSpill: function onSpill(_ref4) {
            var dragEl = _ref4.dragEl,
                putSortable = _ref4.putSortable;
            var parentSortable = putSortable || this.sortable;
            parentSortable.captureAnimationState();
            dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
            parentSortable.animateAll();
        },
        drop: drop
    };

    _extends(Remove, {
        pluginName: 'removeOnSpill'
    });

    var lastSwapEl;

    function SwapPlugin() {
        function Swap() {
            this.defaults = {
                swapClass: 'sortable-swap-highlight'
            };
        }

        Swap.prototype = {
            dragStart: function dragStart(_ref) {
                var dragEl = _ref.dragEl;
                lastSwapEl = dragEl;
            },
            dragOverValid: function dragOverValid(_ref2) {
                var completed = _ref2.completed,
                    target = _ref2.target,
                    onMove = _ref2.onMove,
                    activeSortable = _ref2.activeSortable,
                    changed = _ref2.changed,
                    cancel = _ref2.cancel;
                if (!activeSortable.options.swap) return;
                var el = this.sortable.el,
                    options = this.options;

                if (target && target !== el) {
                    var prevSwapEl = lastSwapEl;

                    if (onMove(target) !== false) {
                        toggleClass(target, options.swapClass, true);
                        lastSwapEl = target;
                    } else {
                        lastSwapEl = null;
                    }

                    if (prevSwapEl && prevSwapEl !== lastSwapEl) {
                        toggleClass(prevSwapEl, options.swapClass, false);
                    }
                }

                changed();
                completed(true);
                cancel();
            },
            drop: function drop(_ref3) {
                var activeSortable = _ref3.activeSortable,
                    putSortable = _ref3.putSortable,
                    dragEl = _ref3.dragEl;
                var toSortable = putSortable || this.sortable;
                var options = this.options;
                lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

                if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                    if (dragEl !== lastSwapEl) {
                        toSortable.captureAnimationState();
                        if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                        swapNodes(dragEl, lastSwapEl);
                        toSortable.animateAll();
                        if (toSortable !== activeSortable) activeSortable.animateAll();
                    }
                }
            },
            nulling: function nulling() {
                lastSwapEl = null;
            }
        };
        return _extends(Swap, {
            pluginName: 'swap',
            eventProperties: function eventProperties() {
                return {
                    swapItem: lastSwapEl
                };
            }
        });
    }

    function swapNodes(n1, n2) {
        var p1 = n1.parentNode,
            p2 = n2.parentNode,
            i1,
            i2;
        if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
        i1 = index(n1);
        i2 = index(n2);

        if (p1.isEqualNode(p2) && i1 < i2) {
            i2++;
        }

        p1.insertBefore(n2, p1.children[i1]);
        p2.insertBefore(n1, p2.children[i2]);
    }

    var multiDragElements = [],
        multiDragClones = [],
        lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
        multiDragSortable,
        initialFolding = false,
    // Initial multi-drag fold when drag started
        folding = false,
    // Folding any other time
        dragStarted = false,
        dragEl$1,
        clonesFromRect,
        clonesHidden;

    function MultiDragPlugin() {
        function MultiDrag(sortable) {
            // Bind all private methods
            for (var fn in this) {
                if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                    this[fn] = this[fn].bind(this);
                }
            }

            if (sortable.options.supportPointer) {
                on(document, 'pointerup', this._deselectMultiDrag);
            } else {
                on(document, 'mouseup', this._deselectMultiDrag);
                on(document, 'touchend', this._deselectMultiDrag);
            }

            on(document, 'keydown', this._checkKeyDown);
            on(document, 'keyup', this._checkKeyUp);
            this.defaults = {
                selectedClass: 'sortable-selected',
                multiDragKey: null,
                setData: function setData(dataTransfer, dragEl) {
                    var data = '';

                    if (multiDragElements.length && multiDragSortable === sortable) {
                        multiDragElements.forEach(function (multiDragElement, i) {
                            data += (!i ? '' : ', ') + multiDragElement.textContent;
                        });
                    } else {
                        data = dragEl.textContent;
                    }

                    dataTransfer.setData('Text', data);
                }
            };
        }

        MultiDrag.prototype = {
            multiDragKeyDown: false,
            isMultiDrag: false,
            delayStartGlobal: function delayStartGlobal(_ref) {
                var dragged = _ref.dragEl;
                dragEl$1 = dragged;
            },
            delayEnded: function delayEnded() {
                this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
            },
            setupClone: function setupClone(_ref2) {
                var sortable = _ref2.sortable,
                    cancel = _ref2.cancel;
                if (!this.isMultiDrag) return;

                for (var i = 0; i < multiDragElements.length; i++) {
                    multiDragClones.push(clone(multiDragElements[i]));
                    multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
                    multiDragClones[i].draggable = false;
                    multiDragClones[i].style['will-change'] = '';
                    toggleClass(multiDragClones[i], this.options.selectedClass, false);
                    multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
                }

                sortable._hideClone();

                cancel();
            },
            clone: function clone(_ref3) {
                var sortable = _ref3.sortable,
                    rootEl = _ref3.rootEl,
                    dispatchSortableEvent = _ref3.dispatchSortableEvent,
                    cancel = _ref3.cancel;
                if (!this.isMultiDrag) return;

                if (!this.options.removeCloneOnHide) {
                    if (multiDragElements.length && multiDragSortable === sortable) {
                        insertMultiDragClones(true, rootEl);
                        dispatchSortableEvent('clone');
                        cancel();
                    }
                }
            },
            showClone: function showClone(_ref4) {
                var cloneNowShown = _ref4.cloneNowShown,
                    rootEl = _ref4.rootEl,
                    cancel = _ref4.cancel;
                if (!this.isMultiDrag) return;
                insertMultiDragClones(false, rootEl);
                multiDragClones.forEach(function (clone) {
                    css(clone, 'display', '');
                });
                cloneNowShown();
                clonesHidden = false;
                cancel();
            },
            hideClone: function hideClone(_ref5) {
                var _this = this;

                var sortable = _ref5.sortable,
                    cloneNowHidden = _ref5.cloneNowHidden,
                    cancel = _ref5.cancel;
                if (!this.isMultiDrag) return;
                multiDragClones.forEach(function (clone) {
                    css(clone, 'display', 'none');

                    if (_this.options.removeCloneOnHide && clone.parentNode) {
                        clone.parentNode.removeChild(clone);
                    }
                });
                cloneNowHidden();
                clonesHidden = true;
                cancel();
            },
            dragStartGlobal: function dragStartGlobal(_ref6) {
                var sortable = _ref6.sortable;

                if (!this.isMultiDrag && multiDragSortable) {
                    multiDragSortable.multiDrag._deselectMultiDrag();
                }

                multiDragElements.forEach(function (multiDragElement) {
                    multiDragElement.sortableIndex = index(multiDragElement);
                }); // Sort multi-drag elements

                multiDragElements = multiDragElements.sort(function (a, b) {
                    return a.sortableIndex - b.sortableIndex;
                });
                dragStarted = true;
            },
            dragStarted: function dragStarted(_ref7) {
                var _this2 = this;

                var sortable = _ref7.sortable;
                if (!this.isMultiDrag) return;

                if (this.options.sort) {
                    // Capture rects,
                    // hide multi drag elements (by positioning them absolute),
                    // set multi drag elements rects to dragRect,
                    // show multi drag elements,
                    // animate to rects,
                    // unset rects & remove from DOM
                    sortable.captureAnimationState();

                    if (this.options.animation) {
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            css(multiDragElement, 'position', 'absolute');
                        });
                        var dragRect = getRect(dragEl$1, false, true, true);
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            setRect(multiDragElement, dragRect);
                        });
                        folding = true;
                        initialFolding = true;
                    }
                }

                sortable.animateAll(function () {
                    folding = false;
                    initialFolding = false;

                    if (_this2.options.animation) {
                        multiDragElements.forEach(function (multiDragElement) {
                            unsetRect(multiDragElement);
                        });
                    } // Remove all auxiliary multidrag items from el, if sorting enabled


                    if (_this2.options.sort) {
                        removeMultiDragElements();
                    }
                });
            },
            dragOver: function dragOver(_ref8) {
                var target = _ref8.target,
                    completed = _ref8.completed,
                    cancel = _ref8.cancel;

                if (folding && ~multiDragElements.indexOf(target)) {
                    completed(false);
                    cancel();
                }
            },
            revert: function revert(_ref9) {
                var fromSortable = _ref9.fromSortable,
                    rootEl = _ref9.rootEl,
                    sortable = _ref9.sortable,
                    dragRect = _ref9.dragRect;

                if (multiDragElements.length > 1) {
                    // Setup unfold animation
                    multiDragElements.forEach(function (multiDragElement) {
                        sortable.addAnimationState({
                            target: multiDragElement,
                            rect: folding ? getRect(multiDragElement) : dragRect
                        });
                        unsetRect(multiDragElement);
                        multiDragElement.fromRect = dragRect;
                        fromSortable.removeAnimationState(multiDragElement);
                    });
                    folding = false;
                    insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
                }
            },
            dragOverCompleted: function dragOverCompleted(_ref10) {
                var sortable = _ref10.sortable,
                    isOwner = _ref10.isOwner,
                    insertion = _ref10.insertion,
                    activeSortable = _ref10.activeSortable,
                    parentEl = _ref10.parentEl,
                    putSortable = _ref10.putSortable;
                var options = this.options;

                if (insertion) {
                    // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                    if (isOwner) {
                        activeSortable._hideClone();
                    }

                    initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

                    if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                        // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                        var dragRectAbsolute = getRect(dragEl$1, false, true, true);
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

                            parentEl.appendChild(multiDragElement);
                        });
                        folding = true;
                    } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


                    if (!isOwner) {
                        // Only remove if not folding (folding will remove them anyways)
                        if (!folding) {
                            removeMultiDragElements();
                        }

                        if (multiDragElements.length > 1) {
                            var clonesHiddenBefore = clonesHidden;

                            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


                            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                                multiDragClones.forEach(function (clone) {
                                    activeSortable.addAnimationState({
                                        target: clone,
                                        rect: clonesFromRect
                                    });
                                    clone.fromRect = clonesFromRect;
                                    clone.thisAnimationDuration = null;
                                });
                            }
                        } else {
                            activeSortable._showClone(sortable);
                        }
                    }
                }
            },
            dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
                var dragRect = _ref11.dragRect,
                    isOwner = _ref11.isOwner,
                    activeSortable = _ref11.activeSortable;
                multiDragElements.forEach(function (multiDragElement) {
                    multiDragElement.thisAnimationDuration = null;
                });

                if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                    clonesFromRect = _extends({}, dragRect);
                    var dragMatrix = matrix(dragEl$1, true);
                    clonesFromRect.top -= dragMatrix.f;
                    clonesFromRect.left -= dragMatrix.e;
                }
            },
            dragOverAnimationComplete: function dragOverAnimationComplete() {
                if (folding) {
                    folding = false;
                    removeMultiDragElements();
                }
            },
            drop: function drop(_ref12) {
                var evt = _ref12.originalEvent,
                    rootEl = _ref12.rootEl,
                    parentEl = _ref12.parentEl,
                    sortable = _ref12.sortable,
                    dispatchSortableEvent = _ref12.dispatchSortableEvent,
                    oldIndex = _ref12.oldIndex,
                    putSortable = _ref12.putSortable;
                var toSortable = putSortable || this.sortable;
                if (!evt) return;
                var options = this.options,
                    children = parentEl.children; // Multi-drag selection

                if (!dragStarted) {
                    if (options.multiDragKey && !this.multiDragKeyDown) {
                        this._deselectMultiDrag();
                    }

                    toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

                    if (!~multiDragElements.indexOf(dragEl$1)) {
                        multiDragElements.push(dragEl$1);
                        dispatchEvent({
                            sortable: sortable,
                            rootEl: rootEl,
                            name: 'select',
                            targetEl: dragEl$1,
                            originalEvt: evt
                        }); // Modifier activated, select from last to dragEl

                        if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
                            var lastIndex = index(lastMultiDragSelect),
                                currentIndex = index(dragEl$1);

                            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                                // (but previous selection existed)
                                var n, i;

                                if (currentIndex > lastIndex) {
                                    i = lastIndex;
                                    n = currentIndex;
                                } else {
                                    i = currentIndex;
                                    n = lastIndex + 1;
                                }

                                for (; i < n; i++) {
                                    if (~multiDragElements.indexOf(children[i])) continue;
                                    toggleClass(children[i], options.selectedClass, true);
                                    multiDragElements.push(children[i]);
                                    dispatchEvent({
                                        sortable: sortable,
                                        rootEl: rootEl,
                                        name: 'select',
                                        targetEl: children[i],
                                        originalEvt: evt
                                    });
                                }
                            }
                        } else {
                            lastMultiDragSelect = dragEl$1;
                        }

                        multiDragSortable = toSortable;
                    } else {
                        multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
                        lastMultiDragSelect = null;
                        dispatchEvent({
                            sortable: sortable,
                            rootEl: rootEl,
                            name: 'deselect',
                            targetEl: dragEl$1,
                            originalEvt: evt
                        });
                    }
                } // Multi-drag drop


                if (dragStarted && this.isMultiDrag) {
                    // Do not "unfold" after around dragEl if reverted
                    if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
                        var dragRect = getRect(dragEl$1),
                            multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
                        if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
                        toSortable.captureAnimationState();

                        if (!initialFolding) {
                            if (options.animation) {
                                dragEl$1.fromRect = dragRect;
                                multiDragElements.forEach(function (multiDragElement) {
                                    multiDragElement.thisAnimationDuration = null;

                                    if (multiDragElement !== dragEl$1) {
                                        var rect = folding ? getRect(multiDragElement) : dragRect;
                                        multiDragElement.fromRect = rect; // Prepare unfold animation

                                        toSortable.addAnimationState({
                                            target: multiDragElement,
                                            rect: rect
                                        });
                                    }
                                });
                            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                            // properly they must all be removed


                            removeMultiDragElements();
                            multiDragElements.forEach(function (multiDragElement) {
                                if (children[multiDragIndex]) {
                                    parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                                } else {
                                    parentEl.appendChild(multiDragElement);
                                }

                                multiDragIndex++;
                            }); // If initial folding is done, the elements may have changed position because they are now
                            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                            // must be fired here as Sortable will not.

                            if (oldIndex === index(dragEl$1)) {
                                var update = false;
                                multiDragElements.forEach(function (multiDragElement) {
                                    if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                                        update = true;
                                        return;
                                    }
                                });

                                if (update) {
                                    dispatchSortableEvent('update');
                                }
                            }
                        } // Must be done after capturing individual rects (scroll bar)


                        multiDragElements.forEach(function (multiDragElement) {
                            unsetRect(multiDragElement);
                        });
                        toSortable.animateAll();
                    }

                    multiDragSortable = toSortable;
                } // Remove clones if necessary


                if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                    multiDragClones.forEach(function (clone) {
                        clone.parentNode && clone.parentNode.removeChild(clone);
                    });
                }
            },
            nullingGlobal: function nullingGlobal() {
                this.isMultiDrag = dragStarted = false;
                multiDragClones.length = 0;
            },
            destroyGlobal: function destroyGlobal() {
                this._deselectMultiDrag();

                off(document, 'pointerup', this._deselectMultiDrag);
                off(document, 'mouseup', this._deselectMultiDrag);
                off(document, 'touchend', this._deselectMultiDrag);
                off(document, 'keydown', this._checkKeyDown);
                off(document, 'keyup', this._checkKeyUp);
            },
            _deselectMultiDrag: function _deselectMultiDrag(evt) {
                if (dragStarted) return; // Only deselect if selection is in this sortable

                if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

                if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

                if (evt && evt.button !== 0) return;

                while (multiDragElements.length) {
                    var el = multiDragElements[0];
                    toggleClass(el, this.options.selectedClass, false);
                    multiDragElements.shift();
                    dispatchEvent({
                        sortable: this.sortable,
                        rootEl: this.sortable.el,
                        name: 'deselect',
                        targetEl: el,
                        originalEvt: evt
                    });
                }
            },
            _checkKeyDown: function _checkKeyDown(evt) {
                if (evt.key === this.options.multiDragKey) {
                    this.multiDragKeyDown = true;
                }
            },
            _checkKeyUp: function _checkKeyUp(evt) {
                if (evt.key === this.options.multiDragKey) {
                    this.multiDragKeyDown = false;
                }
            }
        };
        return _extends(MultiDrag, {
            // Static methods & properties
            pluginName: 'multiDrag',
            utils: {
                /**
                 * Selects the provided multi-drag item
                 * @param  {HTMLElement} el    The element to be selected
                 */
                select: function select(el) {
                    var sortable = el.parentNode[expando];
                    if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

                    if (multiDragSortable && multiDragSortable !== sortable) {
                        multiDragSortable.multiDrag._deselectMultiDrag();

                        multiDragSortable = sortable;
                    }

                    toggleClass(el, sortable.options.selectedClass, true);
                    multiDragElements.push(el);
                },

                /**
                 * Deselects the provided multi-drag item
                 * @param  {HTMLElement} el    The element to be deselected
                 */
                deselect: function deselect(el) {
                    var sortable = el.parentNode[expando],
                        index = multiDragElements.indexOf(el);
                    if (!sortable || !sortable.options.multiDrag || !~index) return;
                    toggleClass(el, sortable.options.selectedClass, false);
                    multiDragElements.splice(index, 1);
                }
            },
            eventProperties: function eventProperties() {
                var _this3 = this;

                var oldIndicies = [],
                    newIndicies = [];
                multiDragElements.forEach(function (multiDragElement) {
                    oldIndicies.push({
                        multiDragElement: multiDragElement,
                        index: multiDragElement.sortableIndex
                    }); // multiDragElements will already be sorted if folding

                    var newIndex;

                    if (folding && multiDragElement !== dragEl$1) {
                        newIndex = -1;
                    } else if (folding) {
                        newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                    } else {
                        newIndex = index(multiDragElement);
                    }

                    newIndicies.push({
                        multiDragElement: multiDragElement,
                        index: newIndex
                    });
                });
                return {
                    items: _toConsumableArray(multiDragElements),
                    clones: [].concat(multiDragClones),
                    oldIndicies: oldIndicies,
                    newIndicies: newIndicies
                };
            },
            optionListeners: {
                multiDragKey: function multiDragKey(key) {
                    key = key.toLowerCase();

                    if (key === 'ctrl') {
                        key = 'Control';
                    } else if (key.length > 1) {
                        key = key.charAt(0).toUpperCase() + key.substr(1);
                    }

                    return key;
                }
            }
        });
    }

    function insertMultiDragElements(clonesInserted, rootEl) {
        multiDragElements.forEach(function (multiDragElement, i) {
            var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

            if (target) {
                rootEl.insertBefore(multiDragElement, target);
            } else {
                rootEl.appendChild(multiDragElement);
            }
        });
    }
    /**
     * Insert multi-drag clones
     * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
     * @param  {HTMLElement} rootEl
     */


    function insertMultiDragClones(elementsInserted, rootEl) {
        multiDragClones.forEach(function (clone, i) {
            var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

            if (target) {
                rootEl.insertBefore(clone, target);
            } else {
                rootEl.appendChild(clone);
            }
        });
    }

    function removeMultiDragElements() {
        multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
        });
    }

    Sortable.mount(new AutoScrollPlugin());
    Sortable.mount(Remove, Revert);

    Sortable.mount(new SwapPlugin());
    Sortable.mount(new MultiDragPlugin());

    return Sortable;

}));

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.qiniu=e():t.qiniu=e()}("undefined"!=typeof self?self:this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=58)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:"2.6.9"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(31)("wks"),o=n(22),i=n(0).Symbol,a="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))}).store=r},function(t,e,n){var r=n(8);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){t.exports=!n(10)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(0),o=n(1),i=n(19),a=n(6),s=n(9),u=function(t,e,n){var c,f,l,h=t&u.F,p=t&u.G,d=t&u.S,g=t&u.P,m=t&u.B,v=t&u.W,y=p?o:o[e]||(o[e]={}),b=y.prototype,w=p?r:d?r[e]:(r[e]||{}).prototype;for(c in p&&(n=e),n)(f=!h&&w&&void 0!==w[c])&&s(y,c)||(l=f?w[c]:n[c],y[c]=p&&"function"!=typeof w[c]?n[c]:m&&f?i(l,r):v&&w[c]==l?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(l):g&&"function"==typeof l?i(Function.call,l):l,g&&((y.virtual||(y.virtual={}))[c]=l,t&u.R&&b&&!b[c]&&a(b,c,l)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,t.exports=u},function(t,e,n){var r=n(7),o=n(21);t.exports=n(4)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(3),o=n(43),i=n(29),a=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(47),o=n(27);t.exports=function(t){return r(o(t))}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){var e=t+864e5;return(new Date).getTime()>e}function i(t){return(0,m.default)(t).filter(function(t){return t.startsWith("x:")}).map(function(e){return[e,t[e].toString()]})}function a(t){return"qiniu_js_sdk_upload_file_"+t.name+"_size_"+t.size}function s(t){try{return JSON.parse(localStorage.getItem(a(t)))||[]}catch(t){return window.console&&window.console.warn&&console.warn("getLocalFileInfo failed"),[]}}function u(t){return{Authorization:"UpToken "+t}}function c(){return window.XMLHttpRequest?new XMLHttpRequest:new window.ActiveXObject("Microsoft.XMLHTTP")}function f(t){return new p.default(function(e,n){var r=new FileReader;r.readAsArrayBuffer(t),r.onload=function(t){var n=t.target.result;e(n)},r.onerror=function(){n(new Error("fileReader 读取错误"))}})}function l(t,e){return new p.default(function(n,r){var o=c();o.open(e.method,t),e.onCreate&&e.onCreate(o),e.headers&&(0,m.default)(e.headers).forEach(function(t){return o.setRequestHeader(t,e.headers[t])}),o.upload.addEventListener("progress",function(t){t.lengthComputable&&e.onProgress&&e.onProgress({loaded:t.loaded,total:t.total})}),o.onreadystatechange=function(){var t=o.responseText;if(4===o.readyState){var e=o.getResponseHeader("x-reqId")||"";if(200!==o.status){var i="xhr request failed, code: "+o.status+";";return t&&(i=i+" response: "+t),void r({code:o.status,message:i,reqId:e,isRequestError:!0})}try{n({data:JSON.parse(t),reqId:e})}catch(t){r(t)}}},o.send(e.body)})}function h(){return"http:"===window.location.protocol?"http:":"https:"}e.__esModule=!0;var p=r(n(18)),d=r(n(34)),g=r(n(86)),m=r(n(36));e.isChunkExpired=o,e.getChunks=function(t,e){for(var n=[],r=Math.ceil(t.size/e),o=0;o<r;o++){var i=t.slice(e*o,o===r-1?t.size:e*(o+1));n.push(i)}return n},e.filterParams=i,e.sum=function(t){return t.reduce(function(t,e){return t+e},0)},e.setLocalFileInfo=function(t,e){try{localStorage.setItem(a(t),(0,g.default)(e))}catch(t){window.console&&window.console.warn&&console.warn("setLocalFileInfo failed")}},e.removeLocalFileInfo=function(t){try{localStorage.removeItem(a(t))}catch(t){window.console&&window.console.warn&&console.warn("removeLocalFileInfo failed")}},e.getLocalFileInfo=s,e.getResumeUploadedSize=function(t){return s(t).filter(function(t){return t&&!o(t.time)}).reduce(function(t,e){return t+e.size},0)},e.createMkFileUrl=function(t,e,n,r){var o=t+"/mkfile/"+e.size;null!=n&&(o+="/key/"+(0,v.urlSafeBase64Encode)(n)),r.mimeType&&(o+="/mimeType/"+(0,v.urlSafeBase64Encode)(e.type));var a=r.fname;return a&&(o+="/fname/"+(0,v.urlSafeBase64Encode)(a)),r.params&&i(r.params).forEach(function(t){return o+="/"+encodeURIComponent(t[0])+"/"+(0,v.urlSafeBase64Encode)(t[1])}),o},e.getHeadersForChunkUpload=function(t){var e=u(t);return(0,d.default)({"content-type":"application/octet-stream"},e)},e.getHeadersForMkFile=function(t){var e=u(t);return(0,d.default)({"content-type":"text/plain"},e)},e.createXHR=c,e.computeMd5=function(t){return f(t).then(function(t){var e=new b.default.ArrayBuffer;return e.append(t),e.end()})},e.readAsArrayBuffer=f,e.request=l,e.getPortFromUrl=function(t){if(t&&t.match){var e=t.match(/(^https?)/);if(!e)return"";var n=e[1];return(e=t.match(/^https?:\/\/([^:^\/]*):(\d*)/))?e[2]:"http"===n?"80":"443"}return""},e.getDomainFromUrl=function(t){if(t&&t.match){var e=t.match(/^https?:\/\/([^:^\/]*)/);return e?e[1]:""}return""},e.getUploadUrl=function(t,e){var n=h();if(null!=t.uphost)return p.default.resolve(n+"//"+t.uphost);if(null!=t.region){var r=y.regionUphostMap[t.region],o=t.useCdnDomain?r.cdnUphost:r.srcUphost;return p.default.resolve(n+"//"+o)}return function(t){try{var e=function(t){var e=t.split(":"),n=e[0],r=JSON.parse((0,v.urlSafeBase64Decode)(e[2]));return r.ak=n,r.bucket=r.scope.split(":")[0],r}(t);return l(h()+"//api.qiniu.com/v2/query?ak="+e.ak+"&bucket="+e.bucket,{method:"GET"})}catch(t){return p.default.reject(t)}}(e).then(function(t){var e=t.data.up.acc.main;return n+"//"+e[0]})},e.isContainFileMimeType=function(t,e){return e.indexOf(t)>-1},e.createObjectURL=function(t){return(window.URL||window.webkitURL||window.mozURL).createObjectURL(t)},e.getTransform=function(t,e){var n=t.width,r=t.height;switch(e){case 1:return{width:n,height:r,matrix:[1,0,0,1,0,0]};case 2:return{width:n,height:r,matrix:[-1,0,0,1,n,0]};case 3:return{width:n,height:r,matrix:[-1,0,0,-1,n,r]};case 4:return{width:n,height:r,matrix:[1,0,0,-1,0,r]};case 5:return{width:r,height:n,matrix:[0,1,1,0,0,0]};case 6:return{width:r,height:n,matrix:[0,1,-1,0,r,0]};case 7:return{width:r,height:n,matrix:[0,-1,-1,0,r,n]};case 8:return{width:r,height:n,matrix:[0,-1,1,0,0,n]}}};var v=n(56),y=n(39),b=r(n(91))},function(t,e){t.exports=!0},function(t,e){t.exports={}},function(t,e,n){var r=n(46),o=n(32);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){t.exports={default:n(59),__esModule:!0}},function(t,e,n){var r=n(20);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){var r=n(7).f,o=n(9),i=n(2)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(27);t.exports=function(t){return Object(r(t))}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(8),o=n(0).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(8);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(31)("keys"),o=n(22);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(1),o=n(0),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(13)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){"use strict";var r=n(20);t.exports.f=function(t){return new function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=r(e),this.reject=r(n)}(t)}},function(t,e,n){t.exports={default:n(83),__esModule:!0}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){t.exports={default:n(88),__esModule:!0}},function(t,e,n){e.f=n(2)},function(t,e,n){var r=n(0),o=n(1),i=n(13),a=n(37),s=n(7).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:a.f(t)})}},function(t,e,n){"use strict";e.__esModule=!0,e.regionUphostMap={z0:{srcUphost:"up.qiniup.com",cdnUphost:"upload.qiniup.com"},z1:{srcUphost:"up-z1.qiniup.com",cdnUphost:"upload-z1.qiniup.com"},z2:{srcUphost:"up-z2.qiniup.com",cdnUphost:"upload-z2.qiniup.com"},na0:{srcUphost:"up-na0.qiniup.com",cdnUphost:"upload-na0.qiniup.com"},as0:{srcUphost:"up-as0.qiniup.com",cdnUphost:"upload-as0.qiniup.com"}},e.region={z0:"z0",z1:"z1",z2:"z2",na0:"na0",as0:"as0"}},function(t,e){},function(t,e,n){"use strict";var r=n(60)(!0);n(42)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var r=n(13),o=n(5),i=n(44),a=n(6),s=n(14),u=n(61),c=n(23),f=n(65),l=n(2)("iterator"),h=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,n,d,g,m,v){u(n,e,d);var y,b,w,x=function(t){if(!h&&t in C)return C[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},S=e+" Iterator",P="values"==g,_=!1,C=t.prototype,U=C[l]||C["@@iterator"]||g&&C[g],F=U||x(g),I=g?P?x("entries"):F:void 0,k="Array"==e&&C.entries||U;if(k&&(w=f(k.call(new t)))!==Object.prototype&&w.next&&(c(w,S,!0),r||"function"==typeof w[l]||a(w,l,p)),P&&U&&"values"!==U.name&&(_=!0,F=function(){return U.call(this)}),r&&!v||!h&&!_&&C[l]||a(C,l,F),s[e]=F,s[S]=p,g)if(y={values:P?F:x("values"),keys:m?F:x("keys"),entries:I},v)for(b in y)b in C||i(C,b,y[b]);else o(o.P+o.F*(h||_),e,y);return y}},function(t,e,n){t.exports=!n(4)&&!n(10)(function(){return 7!=Object.defineProperty(n(28)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){t.exports=n(6)},function(t,e,n){var r=n(3),o=n(62),i=n(32),a=n(30)("IE_PROTO"),s=function(){},u=function(){var t,e=n(28)("iframe"),r=i.length;for(e.style.display="none",n(49).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),u=t.F;r--;)delete u.prototype[i[r]];return u()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=r(t),n=new s,s.prototype=null,n[a]=t):n=u(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(9),o=n(11),i=n(63)(!1),a=n(30)("IE_PROTO");t.exports=function(t,e){var n,s=o(t),u=0,c=[];for(n in s)n!=a&&r(s,n)&&c.push(n);for(;e.length>u;)r(s,n=e[u++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){var r=n(16);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(26),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(0).document;t.exports=r&&r.documentElement},function(t,e,n){n(66);for(var r=n(0),o=n(6),i=n(14),a=n(2)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),u=0;u<s.length;u++){var c=s[u],f=r[c],l=f&&f.prototype;l&&!l[a]&&o(l,a,c),i[c]=i.Array}},function(t,e,n){var r=n(16),o=n(2)("toStringTag"),i="Arguments"==r(function(){return arguments}());t.exports=function(t){var e,n,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:i?r(e):"Object"==(a=r(e))&&"function"==typeof e.callee?"Arguments":a}},function(t,e,n){var r=n(3),o=n(20),i=n(2)("species");t.exports=function(t,e){var n,a=r(t).constructor;return void 0===a||void 0==(n=r(a)[i])?e:o(n)}},function(t,e,n){var r,o,i,a=n(19),s=n(75),u=n(49),c=n(28),f=n(0),l=f.process,h=f.setImmediate,p=f.clearImmediate,d=f.MessageChannel,g=f.Dispatch,m=0,v={},y=function(){var t=+this;if(v.hasOwnProperty(t)){var e=v[t];delete v[t],e()}},b=function(t){y.call(t.data)};h&&p||(h=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return v[++m]=function(){s("function"==typeof t?t:Function(t),e)},r(m),m},p=function(t){delete v[t]},"process"==n(16)(l)?r=function(t){l.nextTick(a(y,t,1))}:g&&g.now?r=function(t){g.now(a(y,t,1))}:d?(i=(o=new d).port2,o.port1.onmessage=b,r=a(i.postMessage,i,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",b,!1)):r="onreadystatechange"in c("script")?function(t){u.appendChild(c("script")).onreadystatechange=function(){u.removeChild(this),y.call(t)}}:function(t){setTimeout(a(y,t,1),0)}),t.exports={set:h,clear:p}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r=n(3),o=n(8),i=n(33);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){"use strict";e.__esModule=!0,e.urlSafeBase64Encode=function(t){return(t=function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=void 0,r=void 0,o=void 0,i=void 0,a=void 0,s=void 0,u=void 0,c=void 0,f=0,l=0,h="",p=[];if(!t)return t;t=function(t){if(null===t||void 0===t)return"";var e=t+"",n="",r=void 0,o=void 0,i=0;r=o=0,i=e.length;for(var a=0;a<i;a++){var s=e.charCodeAt(a),u=null;if(s<128)o++;else if(s>127&&s<2048)u=String.fromCharCode(s>>6|192,63&s|128);else if(63488&s^!0)u=String.fromCharCode(s>>12|224,s>>6&63|128,63&s|128);else{if(64512&s^!0)throw new RangeError("Unmatched trail surrogate at "+a);var c=e.charCodeAt(++a);if(64512&c^!0)throw new RangeError("Unmatched lead surrogate at "+(a-1));s=((1023&s)<<10)+(1023&c)+65536,u=String.fromCharCode(s>>18|240,s>>12&63|128,s>>6&63|128,63&s|128)}null!==u&&(o>r&&(n+=e.slice(r,o)),n+=u,r=o=a+1)}return o>r&&(n+=e.slice(r,i)),n}(t+"");do{n=t.charCodeAt(f++),r=t.charCodeAt(f++),o=t.charCodeAt(f++),i=(c=n<<16|r<<8|o)>>18&63,a=c>>12&63,s=c>>6&63,u=63&c,p[l++]=e.charAt(i)+e.charAt(a)+e.charAt(s)+e.charAt(u)}while(f<t.length);switch(h=p.join(""),t.length%3){case 1:h=h.slice(0,-2)+"==";break;case 2:h=h.slice(0,-1)+"="}return h}(t)).replace(/\//g,"_").replace(/\+/g,"-")},e.urlSafeBase64Decode=function(t){return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=void 0,r=void 0,o=void 0,i=void 0,a=void 0,s=void 0,u=void 0,c=void 0,f=0,l=0,h=[];if(!t)return t;t+="";do{i=e.indexOf(t.charAt(f++)),a=e.indexOf(t.charAt(f++)),s=e.indexOf(t.charAt(f++)),u=e.indexOf(t.charAt(f++)),n=(c=i<<18|a<<12|s<<6|u)>>16&255,r=c>>8&255,o=255&c,h[l++]=64===s?String.fromCharCode(n):64===u?String.fromCharCode(n,r):String.fromCharCode(n,r,o)}while(f<t.length);return h.join("")}(t=t.replace(/_/g,"/").replace(/-/g,"+"))}},function(t,e,n){var r=n(46),o=n(32).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){"use strict";e.__esModule=!0,e.pipeline=e.compressImage=e.exif=e.imageInfo=e.watermark=e.imageMogr2=e.getUploadUrl=e.filterParams=e.getHeadersForMkFile=e.getResumeUploadedSize=e.getHeadersForChunkUpload=e.createMkFileUrl=e.region=e.upload=void 0;var r=n(39),o=n(12),i=n(92),a=n(94),s=n(95),u=n(109),c=function(t){return t&&t.__esModule?t:{default:t}}(n(110)),f=new u.StatisticsLogger;e.upload=function(t,e,n,r,o){var a={file:t,key:e,token:n,putExtra:r,config:o};return new s.Observable(function(t){var e=new i.UploadManager(a,{onData:function(e){return t.next(e)},onError:function(e){return t.error(e)},onComplete:function(e){return t.complete(e)}},f);return e.putFile(),e.stop.bind(e)})},e.region=r.region,e.createMkFileUrl=o.createMkFileUrl,e.getHeadersForChunkUpload=o.getHeadersForChunkUpload,e.getResumeUploadedSize=o.getResumeUploadedSize,e.getHeadersForMkFile=o.getHeadersForMkFile,e.filterParams=o.filterParams,e.getUploadUrl=o.getUploadUrl,e.imageMogr2=a.imageMogr2,e.watermark=a.watermark,e.imageInfo=a.imageInfo,e.exif=a.exif,e.compressImage=c.default,e.pipeline=a.pipeline},function(t,e,n){n(40),n(41),n(50),n(69),n(81),n(82),t.exports=n(1).Promise},function(t,e,n){var r=n(26),o=n(27);t.exports=function(t){return function(e,n){var i,a,s=String(o(e)),u=r(n),c=s.length;return u<0||u>=c?t?"":void 0:(i=s.charCodeAt(u))<55296||i>56319||u+1===c||(a=s.charCodeAt(u+1))<56320||a>57343?t?s.charAt(u):i:t?s.slice(u,u+2):a-56320+(i-55296<<10)+65536}}},function(t,e,n){"use strict";var r=n(45),o=n(21),i=n(23),a={};n(6)(a,n(2)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){var r=n(7),o=n(3),i=n(15);t.exports=n(4)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),s=a.length,u=0;s>u;)r.f(t,n=a[u++],e[n]);return t}},function(t,e,n){var r=n(11),o=n(48),i=n(64);t.exports=function(t){return function(e,n,a){var s,u=r(e),c=o(u.length),f=i(a,c);if(t&&n!=n){for(;c>f;)if((s=u[f++])!=s)return!0}else for(;c>f;f++)if((t||f in u)&&u[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(26),o=Math.max,i=Math.min;t.exports=function(t,e){return(t=r(t))<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(9),o=n(24),i=n(30)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){"use strict";var r=n(67),o=n(68),i=n(14),a=n(11);t.exports=n(42)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";var r,o,i,a,s=n(13),u=n(0),c=n(19),f=n(51),l=n(5),h=n(8),p=n(20),d=n(70),g=n(71),m=n(52),v=n(53).set,y=n(76)(),b=n(33),w=n(54),x=n(77),S=n(55),P=u.TypeError,_=u.process,C=_&&_.versions,U=C&&C.v8||"",F=u.Promise,I="process"==f(_),k=function(){},E=o=b.f,M=!!function(){try{var t=F.resolve(1),e=(t.constructor={})[n(2)("species")]=function(t){t(k,k)};return(I||"function"==typeof PromiseRejectionEvent)&&t.then(k)instanceof e&&0!==U.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),O=function(t){var e;return!(!h(t)||"function"!=typeof(e=t.then))&&e},T=function(t,e){if(!t._n){t._n=!0;var n=t._c;y(function(){for(var r=t._v,o=1==t._s,i=0;n.length>i;)!function(e){var n,i,a,s=o?e.ok:e.fail,u=e.resolve,c=e.reject,f=e.domain;try{s?(o||(2==t._h&&L(t),t._h=1),!0===s?n=r:(f&&f.enter(),n=s(r),f&&(f.exit(),a=!0)),n===e.promise?c(P("Promise-chain cycle")):(i=O(n))?i.call(n,u,c):u(n)):c(r)}catch(t){f&&!a&&f.exit(),c(t)}}(n[i++]);t._c=[],t._n=!1,e&&!t._h&&R(t)})}},R=function(t){v.call(u,function(){var e,n,r,o=t._v,i=A(t);if(i&&(e=w(function(){I?_.emit("unhandledRejection",o,t):(n=u.onunhandledrejection)?n({promise:t,reason:o}):(r=u.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=I||A(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},A=function(t){return 1!==t._h&&0===(t._a||t._c).length},L=function(t){v.call(u,function(){var e;I?_.emit("rejectionHandled",t):(e=u.onrejectionhandled)&&e({promise:t,reason:t._v})})},D=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),T(e,!0))},j=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw P("Promise can't be resolved itself");(e=O(t))?y(function(){var r={_w:n,_d:!1};try{e.call(t,c(j,r,1),c(D,r,1))}catch(t){D.call(r,t)}}):(n._v=t,n._s=1,T(n,!1))}catch(t){D.call({_w:n,_d:!1},t)}}};M||(F=function(t){d(this,F,"Promise","_h"),p(t),r.call(this);try{t(c(j,this,1),c(D,this,1))}catch(t){D.call(this,t)}},(r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n(78)(F.prototype,{then:function(t,e){var n=E(m(this,F));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=I?_.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&T(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=c(j,t,1),this.reject=c(D,t,1)},b.f=E=function(t){return t===F||t===a?new i(t):o(t)}),l(l.G+l.W+l.F*!M,{Promise:F}),n(23)(F,"Promise"),n(79)("Promise"),a=n(1).Promise,l(l.S+l.F*!M,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),l(l.S+l.F*(s||!M),"Promise",{resolve:function(t){return S(s&&this===a?F:this,t)}}),l(l.S+l.F*!(M&&n(80)(function(t){F.all(t).catch(k)})),"Promise",{all:function(t){var e=this,n=E(e),r=n.resolve,o=n.reject,i=w(function(){var n=[],i=0,a=1;g(t,!1,function(t){var s=i++,u=!1;n.push(void 0),a++,e.resolve(t).then(function(t){u||(u=!0,n[s]=t,--a||r(n))},o)}),--a||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=E(e),r=n.reject,o=w(function(){g(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(19),o=n(72),i=n(73),a=n(3),s=n(48),u=n(74),c={},f={};(e=t.exports=function(t,e,n,l,h){var p,d,g,m,v=h?function(){return t}:u(t),y=r(n,l,e?2:1),b=0;if("function"!=typeof v)throw TypeError(t+" is not iterable!");if(i(v)){for(p=s(t.length);p>b;b++)if((m=e?y(a(d=t[b])[0],d[1]):y(t[b]))===c||m===f)return m}else for(g=v.call(t);!(d=g.next()).done;)if((m=o(g,y,d.value,e))===c||m===f)return m}).BREAK=c,e.RETURN=f},function(t,e,n){var r=n(3);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(14),o=n(2)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(51),o=n(2)("iterator"),i=n(14);t.exports=n(1).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(0),o=n(53).set,i=r.MutationObserver||r.WebKitMutationObserver,a=r.process,s=r.Promise,u="process"==n(16)(a);t.exports=function(){var t,e,n,c=function(){var r,o;for(u&&(r=a.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(u)n=function(){a.nextTick(c)};else if(!i||r.navigator&&r.navigator.standalone)if(s&&s.resolve){var f=s.resolve(void 0);n=function(){f.then(c)}}else n=function(){o.call(r,c)};else{var l=!0,h=document.createTextNode("");new i(c).observe(h,{characterData:!0}),n=function(){h.data=l=!l}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e,n){var r=n(0).navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var r=n(6);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){"use strict";var r=n(0),o=n(1),i=n(7),a=n(4),s=n(2)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:r[t];a&&e&&!e[s]&&i.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(2)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},t(i)}catch(t){}return n}},function(t,e,n){"use strict";var r=n(5),o=n(1),i=n(0),a=n(52),s=n(55);r(r.P+r.R,"Promise",{finally:function(t){var e=a(this,o.Promise||i.Promise),n="function"==typeof t;return this.then(n?function(n){return s(e,t()).then(function(){return n})}:t,n?function(n){return s(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";var r=n(5),o=n(33),i=n(54);r(r.S,"Promise",{try:function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){n(84),t.exports=n(1).Object.assign},function(t,e,n){var r=n(5);r(r.S+r.F,"Object",{assign:n(85)})},function(t,e,n){"use strict";var r=n(4),o=n(15),i=n(35),a=n(25),s=n(24),u=n(47),c=Object.assign;t.exports=!c||n(10)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=c({},t)[n]||Object.keys(c({},e)).join("")!=r})?function(t,e){for(var n=s(t),c=arguments.length,f=1,l=i.f,h=a.f;c>f;)for(var p,d=u(arguments[f++]),g=l?o(d).concat(l(d)):o(d),m=g.length,v=0;m>v;)p=g[v++],r&&!h.call(d,p)||(n[p]=d[p]);return n}:c},function(t,e,n){t.exports={default:n(87),__esModule:!0}},function(t,e,n){var r=n(1),o=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,e,n){n(89),t.exports=n(1).Object.keys},function(t,e,n){var r=n(24),o=n(15);n(90)("keys",function(){return function(t){return o(r(t))}})},function(t,e,n){var r=n(5),o=n(1),i=n(10);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],a={};a[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(t,e,n){!function(e){t.exports=function(t){"use strict";function e(t,e){var n=t[0],r=t[1],o=t[2],i=t[3];r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[0]-680876936|0)<<7|n>>>25)+r|0)&r|~n&o)+e[1]-389564586|0)<<12|i>>>20)+n|0)&n|~i&r)+e[2]+606105819|0)<<17|o>>>15)+i|0)&i|~o&n)+e[3]-1044525330|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[4]-176418897|0)<<7|n>>>25)+r|0)&r|~n&o)+e[5]+1200080426|0)<<12|i>>>20)+n|0)&n|~i&r)+e[6]-1473231341|0)<<17|o>>>15)+i|0)&i|~o&n)+e[7]-45705983|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[8]+1770035416|0)<<7|n>>>25)+r|0)&r|~n&o)+e[9]-1958414417|0)<<12|i>>>20)+n|0)&n|~i&r)+e[10]-42063|0)<<17|o>>>15)+i|0)&i|~o&n)+e[11]-1990404162|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[12]+1804603682|0)<<7|n>>>25)+r|0)&r|~n&o)+e[13]-40341101|0)<<12|i>>>20)+n|0)&n|~i&r)+e[14]-1502002290|0)<<17|o>>>15)+i|0)&i|~o&n)+e[15]+1236535329|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[1]-165796510|0)<<5|n>>>27)+r|0)&o|r&~o)+e[6]-1069501632|0)<<9|i>>>23)+n|0)&r|n&~r)+e[11]+643717713|0)<<14|o>>>18)+i|0)&n|i&~n)+e[0]-373897302|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[5]-701558691|0)<<5|n>>>27)+r|0)&o|r&~o)+e[10]+38016083|0)<<9|i>>>23)+n|0)&r|n&~r)+e[15]-660478335|0)<<14|o>>>18)+i|0)&n|i&~n)+e[4]-405537848|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[9]+568446438|0)<<5|n>>>27)+r|0)&o|r&~o)+e[14]-1019803690|0)<<9|i>>>23)+n|0)&r|n&~r)+e[3]-187363961|0)<<14|o>>>18)+i|0)&n|i&~n)+e[8]+1163531501|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[13]-1444681467|0)<<5|n>>>27)+r|0)&o|r&~o)+e[2]-51403784|0)<<9|i>>>23)+n|0)&r|n&~r)+e[7]+1735328473|0)<<14|o>>>18)+i|0)&n|i&~n)+e[12]-1926607734|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[5]-378558|0)<<4|n>>>28)+r|0)^r^o)+e[8]-2022574463|0)<<11|i>>>21)+n|0)^n^r)+e[11]+1839030562|0)<<16|o>>>16)+i|0)^i^n)+e[14]-35309556|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[1]-1530992060|0)<<4|n>>>28)+r|0)^r^o)+e[4]+1272893353|0)<<11|i>>>21)+n|0)^n^r)+e[7]-155497632|0)<<16|o>>>16)+i|0)^i^n)+e[10]-1094730640|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[13]+681279174|0)<<4|n>>>28)+r|0)^r^o)+e[0]-358537222|0)<<11|i>>>21)+n|0)^n^r)+e[3]-722521979|0)<<16|o>>>16)+i|0)^i^n)+e[6]+76029189|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[9]-640364487|0)<<4|n>>>28)+r|0)^r^o)+e[12]-421815835|0)<<11|i>>>21)+n|0)^n^r)+e[15]+530742520|0)<<16|o>>>16)+i|0)^i^n)+e[2]-995338651|0)<<23|r>>>9)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[0]-198630844|0)<<6|n>>>26)+r|0)|~o))+e[7]+1126891415|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[14]-1416354905|0)<<15|o>>>17)+i|0)|~n))+e[5]-57434055|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[12]+1700485571|0)<<6|n>>>26)+r|0)|~o))+e[3]-1894986606|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[10]-1051523|0)<<15|o>>>17)+i|0)|~n))+e[1]-2054922799|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[8]+1873313359|0)<<6|n>>>26)+r|0)|~o))+e[15]-30611744|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[6]-1560198380|0)<<15|o>>>17)+i|0)|~n))+e[13]+1309151649|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[4]-145523070|0)<<6|n>>>26)+r|0)|~o))+e[11]-1120210379|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[2]+718787259|0)<<15|o>>>17)+i|0)|~n))+e[9]-343485551|0)<<21|r>>>11)+o|0,t[0]=n+t[0]|0,t[1]=r+t[1]|0,t[2]=o+t[2]|0,t[3]=i+t[3]|0}function n(t){var e,n=[];for(e=0;e<64;e+=4)n[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return n}function r(t){var e,n=[];for(e=0;e<64;e+=4)n[e>>2]=t[e]+(t[e+1]<<8)+(t[e+2]<<16)+(t[e+3]<<24);return n}function o(t){var r,o,i,a,s,u,c=t.length,f=[1732584193,-271733879,-1732584194,271733878];for(r=64;r<=c;r+=64)e(f,n(t.substring(r-64,r)));for(o=(t=t.substring(r-64)).length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],r=0;r<o;r+=1)i[r>>2]|=t.charCodeAt(r)<<(r%4<<3);if(i[r>>2]|=128<<(r%4<<3),r>55)for(e(f,i),r=0;r<16;r+=1)i[r]=0;return a=(a=8*c).toString(16).match(/(.*?)(.{0,8})$/),s=parseInt(a[2],16),u=parseInt(a[1],16)||0,i[14]=s,i[15]=u,e(f,i),f}function i(t){var e,n="";for(e=0;e<4;e+=1)n+=f[t>>8*e+4&15]+f[t>>8*e&15];return n}function a(t){var e;for(e=0;e<t.length;e+=1)t[e]=i(t[e]);return t.join("")}function s(t){return/[\u0080-\uFFFF]/.test(t)&&(t=unescape(encodeURIComponent(t))),t}function u(t){var e,n=[],r=t.length;for(e=0;e<r-1;e+=2)n.push(parseInt(t.substr(e,2),16));return String.fromCharCode.apply(String,n)}function c(){this.reset()}var f=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"];return a(o("hello")),"undefined"==typeof ArrayBuffer||ArrayBuffer.prototype.slice||function(){function e(t,e){return(t=0|t||0)<0?Math.max(t+e,0):Math.min(t,e)}ArrayBuffer.prototype.slice=function(n,r){var o,i,a,s,u=this.byteLength,c=e(n,u),f=u;return r!==t&&(f=e(r,u)),c>f?new ArrayBuffer(0):(o=f-c,i=new ArrayBuffer(o),a=new Uint8Array(i),s=new Uint8Array(this,c,o),a.set(s),i)}}(),c.prototype.append=function(t){return this.appendBinary(s(t)),this},c.prototype.appendBinary=function(t){this._buff+=t,this._length+=t.length;var r,o=this._buff.length;for(r=64;r<=o;r+=64)e(this._hash,n(this._buff.substring(r-64,r)));return this._buff=this._buff.substring(r-64),this},c.prototype.end=function(t){var e,n,r=this._buff,o=r.length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<o;e+=1)i[e>>2]|=r.charCodeAt(e)<<(e%4<<3);return this._finish(i,o),n=a(this._hash),t&&(n=u(n)),this.reset(),n},c.prototype.reset=function(){return this._buff="",this._length=0,this._hash=[1732584193,-271733879,-1732584194,271733878],this},c.prototype.getState=function(){return{buff:this._buff,length:this._length,hash:this._hash}},c.prototype.setState=function(t){return this._buff=t.buff,this._length=t.length,this._hash=t.hash,this},c.prototype.destroy=function(){delete this._hash,delete this._buff,delete this._length},c.prototype._finish=function(t,n){var r,o,i,a=n;if(t[a>>2]|=128<<(a%4<<3),a>55)for(e(this._hash,t),a=0;a<16;a+=1)t[a]=0;r=(r=8*this._length).toString(16).match(/(.*?)(.{0,8})$/),o=parseInt(r[2],16),i=parseInt(r[1],16)||0,t[14]=o,t[15]=i,e(this._hash,t)},c.hash=function(t,e){return c.hashBinary(s(t),e)},c.hashBinary=function(t,e){var n=a(o(t));return e?u(n):n},c.ArrayBuffer=function(){this.reset()},c.ArrayBuffer.prototype.append=function(t){var n,o=function(t,e,n){var r=new Uint8Array(t.byteLength+e.byteLength);return r.set(new Uint8Array(t)),r.set(new Uint8Array(e),t.byteLength),r}(this._buff.buffer,t),i=o.length;for(this._length+=t.byteLength,n=64;n<=i;n+=64)e(this._hash,r(o.subarray(n-64,n)));return this._buff=n-64<i?new Uint8Array(o.buffer.slice(n-64)):new Uint8Array(0),this},c.ArrayBuffer.prototype.end=function(t){var e,n,r=this._buff,o=r.length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<o;e+=1)i[e>>2]|=r[e]<<(e%4<<3);return this._finish(i,o),n=a(this._hash),t&&(n=u(n)),this.reset(),n},c.ArrayBuffer.prototype.reset=function(){return this._buff=new Uint8Array(0),this._length=0,this._hash=[1732584193,-271733879,-1732584194,271733878],this},c.ArrayBuffer.prototype.getState=function(){var t=c.prototype.getState.call(this);return t.buff=function(t){return String.fromCharCode.apply(null,new Uint8Array(t))}(t.buff),t},c.ArrayBuffer.prototype.setState=function(t){return t.buff=function(t,e){var n,r=t.length,o=new ArrayBuffer(r),i=new Uint8Array(o);for(n=0;n<r;n+=1)i[n]=t.charCodeAt(n);return i}(t.buff),c.prototype.setState.call(this,t)},c.ArrayBuffer.prototype.destroy=c.prototype.destroy,c.ArrayBuffer.prototype._finish=c.prototype._finish,c.ArrayBuffer.hash=function(t,n){var o=a(function(t){var n,o,i,a,s,u,c=t.length,f=[1732584193,-271733879,-1732584194,271733878];for(n=64;n<=c;n+=64)e(f,r(t.subarray(n-64,n)));for(o=(t=n-64<c?t.subarray(n-64):new Uint8Array(0)).length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],n=0;n<o;n+=1)i[n>>2]|=t[n]<<(n%4<<3);if(i[n>>2]|=128<<(n%4<<3),n>55)for(e(f,i),n=0;n<16;n+=1)i[n]=0;return a=(a=8*c).toString(16).match(/(.*?)(.{0,8})$/),s=parseInt(a[2],16),u=parseInt(a[1],16)||0,i[14]=s,i[15]=u,e(f,i),f}(new Uint8Array(t)));return n?u(o):o},c}()}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.UploadManager=void 0;var o=r(n(18)),i=r(n(34)),a=r(n(17)),s=n(12),u=n(93);e.UploadManager=function(){function t(e,n,r){var o=this;(0,a.default)(this,t),this.config=(0,i.default)({useCdnDomain:!0,disableStatisticsReport:!1,retryCount:3,checkByMD5:!1,uphost:null,forceDirect:!1,concurrentRequestLimit:3,region:null},e.config),this.putExtra=(0,i.default)({fname:"",params:{},mimeType:null},e.putExtra),this.statisticsLogger=r,this.progress=null,this.xhrList=[],this.xhrHandler=function(t){return o.xhrList.push(t)},this.aborted=!1,this.file=e.file,this.key=e.key,this.token=e.token,this.onData=function(){},this.onError=function(){},this.onComplete=function(){},this.retryCount=0,(0,i.default)(this,n)}return t.prototype.putFile=function(){var t=this;if(this.aborted=!1,this.putExtra.fname||(this.putExtra.fname=this.file.name),!this.putExtra.mimeType||!this.putExtra.mimeType.length||(0,s.isContainFileMimeType)(this.file.type,this.putExtra.mimeType)){var e=(0,s.getUploadUrl)(this.config,this.token).then(function(e){return t.uploadUrl=e,t.uploadAt=(new Date).getTime(),t.config.forceDirect?t.directUpload():t.file.size>4194304?t.resumeUpload():t.directUpload()});return e.then(function(e){t.onComplete(e.data),t.config.disableStatisticsReport||t.sendLog(e.reqId,200)},function(e){if(t.clear(),e.isRequestError&&!t.config.disableStatisticsReport){var n=t.aborted?"":e.reqId,r=t.aborted?-2:e.code;t.sendLog(n,r)}var o=e.isRequestError&&0===e.code&&!t.aborted,i=++t.retryCount<=t.config.retryCount;o&&i?t.putFile():t.onError(e)}),e}var n=new Error("file type doesn't match with what you specify");this.onError(n)},t.prototype.clear=function(){this.xhrList.forEach(function(t){return t.abort()}),this.xhrList=[]},t.prototype.stop=function(){this.clear(),this.aborted=!0},t.prototype.sendLog=function(t,e){this.statisticsLogger.log({code:e,reqId:t,host:(0,s.getDomainFromUrl)(this.uploadUrl),remoteIp:"",port:(0,s.getPortFromUrl)(this.uploadUrl),duration:((new Date).getTime()-this.uploadAt)/1e3,time:Math.floor(this.uploadAt/1e3),bytesSent:this.progress?this.progress.total.loaded:0,upType:"jssdk-h5",size:this.file.size},this.token)},t.prototype.directUpload=function(){var t=this,e=new FormData;return e.append("file",this.file),e.append("token",this.token),null!=this.key&&e.append("key",this.key),e.append("fname",this.putExtra.fname),(0,s.filterParams)(this.putExtra.params).forEach(function(t){return e.append(t[0],t[1])}),(0,s.request)(this.uploadUrl,{method:"POST",body:e,onProgress:function(e){t.updateDirectProgress(e.loaded,e.total)},onCreate:this.xhrHandler}).then(function(e){return t.finishDirectProgress(),e})},t.prototype.resumeUpload=function(){var t=this;this.loaded={mkFileProgress:0,chunks:null},this.ctxList=[],this.localInfo=(0,s.getLocalFileInfo)(this.file),this.chunks=(0,s.getChunks)(this.file,4194304),this.initChunksProgress();var e=new u.Pool(function(e){return t.uploadChunk(e)},this.config.concurrentRequestLimit),n=this.chunks.map(function(t,n){return e.enqueue({chunk:t,index:n})}),r=o.default.all(n).then(function(){return t.mkFileReq()});return r.then(function(e){(0,s.removeLocalFileInfo)(t.file)},function(e){701!==e.code||(0,s.removeLocalFileInfo)(t.file)}),r},t.prototype.uploadChunk=function(t){var e=this,n=t.index,r=t.chunk,i=this.localInfo[n],a=this.uploadUrl+"/mkblk/"+r.size,u=i&&!(0,s.isChunkExpired)(i.time),c=this.config.checkByMD5,f=function(){return e.updateChunkProgress(r.size,n),e.ctxList[n]={ctx:i.ctx,size:i.size,time:i.time,md5:i.md5},o.default.resolve(null)};return u&&!c?f():(0,s.computeMd5)(r).then(function(t){if(u&&t===i.md5)return f();var o=(0,s.getHeadersForChunkUpload)(e.token),c=function(t){e.updateChunkProgress(t.loaded,n)},l=e.xhrHandler;return(0,s.request)(a,{method:"POST",headers:o,body:r,onProgress:c,onCreate:l}).then(function(o){c({loaded:r.size}),e.ctxList[n]={time:(new Date).getTime(),ctx:o.data.ctx,size:r.size,md5:t},(0,s.setLocalFileInfo)(e.file,e.ctxList)})})},t.prototype.mkFileReq=function(){var t=this,e=(0,i.default)({mimeType:"application/octet-stream"},this.putExtra),n=(0,s.createMkFileUrl)(this.uploadUrl,this.file,this.key,e),r=this.ctxList.map(function(t){return t.ctx}).join(","),a=(0,s.getHeadersForMkFile)(this.token),u=this.xhrHandler;return(0,s.request)(n,{method:"POST",body:r,headers:a,onCreate:u}).then(function(e){return t.updateMkFileProgress(1),o.default.resolve(e)})},t.prototype.updateDirectProgress=function(t,e){this.progress={total:this.getProgressInfoItem(t,e+1)},this.onData(this.progress)},t.prototype.finishDirectProgress=function(){if(!this.progress)return this.progress={total:this.getProgressInfoItem(this.file.size,this.file.size)},void this.onData(this.progress);var t=this.progress.total;this.progress={total:this.getProgressInfoItem(t.loaded+1,t.size)},this.onData(this.progress)},t.prototype.initChunksProgress=function(){this.loaded.chunks=this.chunks.map(function(t){return 0}),this.notifyResumeProgress()},t.prototype.updateChunkProgress=function(t,e){this.loaded.chunks[e]=t,this.notifyResumeProgress()},t.prototype.updateMkFileProgress=function(t){this.loaded.mkFileProgress=t,this.notifyResumeProgress()},t.prototype.notifyResumeProgress=function(){var t=this;this.progress={total:this.getProgressInfoItem((0,s.sum)(this.loaded.chunks)+this.loaded.mkFileProgress,this.file.size+1),chunks:this.chunks.map(function(e,n){return t.getProgressInfoItem(t.loaded.chunks[n],e.size)})},this.onData(this.progress)},t.prototype.getProgressInfoItem=function(t,e){return{loaded:t,size:e,percent:t/e*100}},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.Pool=void 0;var o=r(n(18)),i=r(n(17));e.Pool=function(){function t(e,n){(0,i.default)(this,t),this.runTask=e,this.queue=[],this.processing=[],this.limit=n}return t.prototype.enqueue=function(t){var e=this;return new o.default(function(n,r){e.queue.push({task:t,resolve:n,reject:r}),e.check()})},t.prototype.run=function(t){var e=this;this.queue=this.queue.filter(function(e){return e!==t}),this.processing.push(t),this.runTask(t.task).then(function(){e.processing=e.processing.filter(function(e){return e!==t}),t.resolve(),e.check()},function(e){return t.reject(e)})},t.prototype.check=function(){var t=this,e=this.processing.length,n=this.limit-e;this.queue.slice(0,n).forEach(function(e,n){t.run(e)})},t}()},function(t,e,n){"use strict";function r(t,e){return t=encodeURIComponent(t),"/"!==e.slice(e.length-1)&&(e+="/"),e+t}function o(t,e,n){if(!/^\d$/.test(t.mode))throw"mode should be number in imageView2";var o=t.mode,i=t.w,a=t.h,s=t.q,u=t.format;if(!i&&!a)throw"param w and h is empty in imageView2";var c="imageView2/"+encodeURIComponent(o);return c+=i?"/w/"+encodeURIComponent(i):"",c+=a?"/h/"+encodeURIComponent(a):"",c+=s?"/q/"+encodeURIComponent(s):"",c+=u?"/format/"+encodeURIComponent(u):"",e&&(c=r(e,n)+"?"+c),c}function i(t,e,n){var o=t["auto-orient"],i=t.thumbnail,a=t.strip,s=t.gravity,u=t.crop,c=t.quality,f=t.rotate,l=t.format,h=t.blur,p="imageMogr2";return p+=o?"/auto-orient":"",p+=i?"/thumbnail/"+encodeURIComponent(i):"",p+=a?"/strip":"",p+=s?"/gravity/"+encodeURIComponent(s):"",p+=c?"/quality/"+encodeURIComponent(c):"",p+=u?"/crop/"+encodeURIComponent(u):"",p+=f?"/rotate/"+encodeURIComponent(f):"",p+=l?"/format/"+encodeURIComponent(l):"",p+=h?"/blur/"+encodeURIComponent(h):"",e&&(p=r(e,n)+"?"+p),p}function a(t,e,n){var o=t.mode;if(!o)throw"mode can't be empty in watermark";var i="watermark/"+o;if(1!==o&&2!==o)throw"mode is wrong";if(1===o){var a=t.image;if(!a)throw"image can't be empty in watermark";i+=a?"/image/"+(0,u.urlSafeBase64Encode)(a):""}if(2===o){var s=t.text,c=t.font,f=t.fontsize,l=t.fill;if(!s)throw"text can't be empty in watermark";i+=s?"/text/"+(0,u.urlSafeBase64Encode)(s):"",i+=c?"/font/"+(0,u.urlSafeBase64Encode)(c):"",i+=f?"/fontsize/"+f:"",i+=l?"/fill/"+(0,u.urlSafeBase64Encode)(l):""}var h=t.dissolve,p=t.gravity,d=t.dx,g=t.dy;return i+=h?"/dissolve/"+encodeURIComponent(h):"",i+=p?"/gravity/"+encodeURIComponent(p):"",i+=d?"/dx/"+encodeURIComponent(d):"",i+=g?"/dy/"+encodeURIComponent(g):"",e&&(i=r(e,n)+"?"+i),i}e.__esModule=!0,e.imageView2=o,e.imageMogr2=i,e.watermark=a,e.imageInfo=function(t,e){var n=r(t,e)+"?imageInfo";return(0,s.request)(n,{method:"GET"})},e.exif=function(t,e){var n=r(t,e)+"?exif";return(0,s.request)(n,{method:"GET"})},e.pipeline=function(t,e,n){var s=void 0,u=void 0,c="";if("[object Array]"===Object.prototype.toString.call(t)){for(var f=0,l=t.length;f<l;f++){if(!(s=t[f]).fop)throw"fop can't be empty in pipeline";switch(s.fop){case"watermark":c+=a(s)+"|";break;case"imageView2":c+=o(s)+"|";break;case"imageMogr2":c+=i(s)+"|";break;default:u=!0}if(u)throw"fop is wrong in pipeline"}if(e){var h=(c=r(e,n)+"?"+c).length;"|"===c.slice(h-1)&&(c=c.slice(0,h-1))}return c}throw"pipeline's first param should be array"};var s=n(12),u=n(56)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.Observable=void 0;var o=r(n(96)),i=r(n(17));e.Observable=function(){function t(e){(0,i.default)(this,t),this.subscribeAction=e}return t.prototype.subscribe=function(t,e,n){var r=new a(t,e,n),o=this.subscribeAction(r);return new s(r,o)},t}();var a=function(){function t(e,n,r){(0,i.default)(this,t),this.isStopped=!1,"object"===(void 0===e?"undefined":(0,o.default)(e))?(this._onNext=e.next,this._onError=e.error,this._onCompleted=e.complete):(this._onNext=e,this._onError=n,this._onCompleted=r)}return t.prototype.next=function(t){!this.isStopped&&this._onNext&&this._onNext(t)},t.prototype.error=function(t){!this.isStopped&&this._onError&&(this.isStopped=!0,this._onError(t))},t.prototype.complete=function(t){!this.isStopped&&this._onCompleted&&(this.isStopped=!0,this._onCompleted(t))},t}(),s=function(){function t(e,n){(0,i.default)(this,t),this.observer=e,this.result=n}return t.prototype.unsubscribe=function(){this.observer.isStopped=!0,this.result()},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=r(n(97)),i=r(n(99)),a="function"==typeof i.default&&"symbol"==typeof o.default?function(t){return typeof t}:function(t){return t&&"function"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?"symbol":typeof t};e.default="function"==typeof i.default&&"symbol"===a(o.default)?function(t){return void 0===t?"undefined":a(t)}:function(t){return t&&"function"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?"symbol":void 0===t?"undefined":a(t)}},function(t,e,n){t.exports={default:n(98),__esModule:!0}},function(t,e,n){n(41),n(50),t.exports=n(37).f("iterator")},function(t,e,n){t.exports={default:n(100),__esModule:!0}},function(t,e,n){n(101),n(40),n(107),n(108),t.exports=n(1).Symbol},function(t,e,n){"use strict";var r=n(0),o=n(9),i=n(4),a=n(5),s=n(44),u=n(102).KEY,c=n(10),f=n(31),l=n(23),h=n(22),p=n(2),d=n(37),g=n(38),m=n(103),v=n(104),y=n(3),b=n(8),w=n(24),x=n(11),S=n(29),P=n(21),_=n(45),C=n(105),U=n(106),F=n(35),I=n(7),k=n(15),E=U.f,M=I.f,O=C.f,T=r.Symbol,R=r.JSON,A=R&&R.stringify,L=p("_hidden"),D=p("toPrimitive"),j={}.propertyIsEnumerable,B=f("symbol-registry"),G=f("symbols"),q=f("op-symbols"),N=Object.prototype,z="function"==typeof T&&!!F.f,H=r.QObject,V=!H||!H.prototype||!H.prototype.findChild,W=i&&c(function(){return 7!=_(M({},"a",{get:function(){return M(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=E(N,e);r&&delete N[e],M(t,e,n),r&&t!==N&&M(N,e,r)}:M,J=function(t){var e=G[t]=_(T.prototype);return e._k=t,e},X=z&&"symbol"==typeof T.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof T},Y=function(t,e,n){return t===N&&Y(q,e,n),y(t),e=S(e,!0),y(n),o(G,e)?(n.enumerable?(o(t,L)&&t[L][e]&&(t[L][e]=!1),n=_(n,{enumerable:P(0,!1)})):(o(t,L)||M(t,L,P(1,{})),t[L][e]=!0),W(t,e,n)):M(t,e,n)},K=function(t,e){y(t);for(var n,r=m(e=x(e)),o=0,i=r.length;i>o;)Y(t,n=r[o++],e[n]);return t},$=function(t){var e=j.call(this,t=S(t,!0));return!(this===N&&o(G,t)&&!o(q,t))&&(!(e||!o(this,t)||!o(G,t)||o(this,L)&&this[L][t])||e)},Q=function(t,e){if(t=x(t),e=S(e,!0),t!==N||!o(G,e)||o(q,e)){var n=E(t,e);return!n||!o(G,e)||o(t,L)&&t[L][e]||(n.enumerable=!0),n}},Z=function(t){for(var e,n=O(x(t)),r=[],i=0;n.length>i;)o(G,e=n[i++])||e==L||e==u||r.push(e);return r},tt=function(t){for(var e,n=t===N,r=O(n?q:x(t)),i=[],a=0;r.length>a;)!o(G,e=r[a++])||n&&!o(N,e)||i.push(G[e]);return i};z||(s((T=function(){if(this instanceof T)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),e=function(n){this===N&&e.call(q,n),o(this,L)&&o(this[L],t)&&(this[L][t]=!1),W(this,t,P(1,n))};return i&&V&&W(N,t,{configurable:!0,set:e}),J(t)}).prototype,"toString",function(){return this._k}),U.f=Q,I.f=Y,n(57).f=C.f=Z,n(25).f=$,F.f=tt,i&&!n(13)&&s(N,"propertyIsEnumerable",$,!0),d.f=function(t){return J(p(t))}),a(a.G+a.W+a.F*!z,{Symbol:T});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)p(et[nt++]);for(var rt=k(p.store),ot=0;rt.length>ot;)g(rt[ot++]);a(a.S+a.F*!z,"Symbol",{for:function(t){return o(B,t+="")?B[t]:B[t]=T(t)},keyFor:function(t){if(!X(t))throw TypeError(t+" is not a symbol!");for(var e in B)if(B[e]===t)return e},useSetter:function(){V=!0},useSimple:function(){V=!1}}),a(a.S+a.F*!z,"Object",{create:function(t,e){return void 0===e?_(t):K(_(t),e)},defineProperty:Y,defineProperties:K,getOwnPropertyDescriptor:Q,getOwnPropertyNames:Z,getOwnPropertySymbols:tt});var it=c(function(){F.f(1)});a(a.S+a.F*it,"Object",{getOwnPropertySymbols:function(t){return F.f(w(t))}}),R&&a(a.S+a.F*(!z||c(function(){var t=T();return"[null]"!=A([t])||"{}"!=A({a:t})||"{}"!=A(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(b(e)||void 0!==t)&&!X(t))return v(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!X(e))return e}),r[1]=e,A.apply(R,r)}}),T.prototype[D]||n(6)(T.prototype,D,T.prototype.valueOf),l(T,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,e,n){var r=n(22)("meta"),o=n(8),i=n(9),a=n(7).f,s=0,u=Object.isExtensible||function(){return!0},c=!n(10)(function(){return u(Object.preventExtensions({}))}),f=function(t){a(t,r,{value:{i:"O"+ ++s,w:{}}})},l=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!u(t))return"F";if(!e)return"E";f(t)}return t[r].i},getWeak:function(t,e){if(!i(t,r)){if(!u(t))return!0;if(!e)return!1;f(t)}return t[r].w},onFreeze:function(t){return c&&l.NEED&&u(t)&&!i(t,r)&&f(t),t}}},function(t,e,n){var r=n(15),o=n(35),i=n(25);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,s=n(t),u=i.f,c=0;s.length>c;)u.call(t,a=s[c++])&&e.push(a);return e}},function(t,e,n){var r=n(16);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(11),o=n(57).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?function(t){try{return o(t)}catch(t){return a.slice()}}(t):o(r(t))}},function(t,e,n){var r=n(25),o=n(21),i=n(11),a=n(29),s=n(9),u=n(43),c=Object.getOwnPropertyDescriptor;e.f=n(4)?c:function(t,e){if(t=i(t),e=a(e,!0),u)try{return c(t,e)}catch(t){}if(s(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){n(38)("asyncIterator")},function(t,e,n){n(38)("observable")},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.StatisticsLogger=void 0;var o=r(n(36)),i=r(n(17)),a=n(12);e.StatisticsLogger=function(){function t(){(0,i.default)(this,t)}return t.prototype.log=function(t,e){var n="";(0,o.default)(t).forEach(function(e){return n+=t[e]+","}),this.send(n,e,0)},t.prototype.send=function(t,e,n){var r=(0,a.createXHR)(),o=this;r.open("POST","https://uplog.qbox.me/log/3"),r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.setRequestHeader("Authorization","UpToken "+e),r.onreadystatechange=function(){4===r.readyState&&200!==r.status&&++n<=3&&o.send(t,e,n)},r.send(t)},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=r(n(18)),i=r(n(34)),a=r(n(17)),s=r(n(36)),u=n(111),c=n(12),f={PNG:"image/png",JPEG:"image/jpeg",WEBP:"image/webp",BMP:"image/bmp"},l=Math.log(2),h=(0,s.default)(f).map(function(t){return f[t]}),p=f.JPEG,d=function(){function t(e,n){(0,a.default)(this,t),this.config=(0,i.default)({quality:.92,noCompressIfLarger:!1},n),this.file=e}return t.prototype.process=function(){var t=this;this.outputType=this.file.type;var e={};return function(t){return h.includes(t)}(this.file.type)?this.getOriginImage().then(function(e){return t.getCanvas(e)}).then(function(n){var r=1;return t.config.maxWidth&&(r=Math.min(1,t.config.maxWidth/n.width)),t.config.maxHeight&&(r=Math.min(1,r,t.config.maxHeight/n.height)),e.width=n.width,e.height=n.height,t.doScale(n,r)}).then(function(n){var r=t.toBlob(n);return r.size>t.file.size&&t.config.noCompressIfLarger?{dist:t.file,width:e.width,height:e.height}:{dist:r,width:n.width,height:n.height}}):o.default.reject(new Error("unsupported file type: "+this.file.type))},t.prototype.clear=function(t,e,n){this.outputType===p?(t.fillStyle="#fff",t.fillRect(0,0,e,n)):t.clearRect(0,0,e,n)},t.prototype.getOriginImage=function(){var t=this;return new o.default(function(e,n){var r=(0,c.createObjectURL)(t.file),o=new Image;o.onload=function(){e(o)},o.onerror=function(){n("image load error")},o.src=r})},t.prototype.getCanvas=function(t){var e=this;return new o.default(function(n,r){u.EXIF.getData(t,function(){var r=u.EXIF.getTag(t,"Orientation")||1,o=(0,c.getTransform)(t,r),i=o.width,a=o.height,s=o.matrix,f=document.createElement("canvas"),l=f.getContext("2d");f.width=i,f.height=a,e.clear(l,i,a),l.transform.apply(l,s),l.drawImage(t,0,0),n(f)})})},t.prototype.doScale=function(t,e){if(1===e)return o.default.resolve(t);var n=t.getContext("2d"),r=Math.min(4,Math.ceil(1/e/l)),i=Math.pow(e,1/r),a=document.createElement("canvas"),s=a.getContext("2d"),u=t.width,c=t.height,f=u,h=c;a.width=u,a.height=c;for(var p=void 0,d=void 0,g=0;g<r;g++){var m=u*i|0,v=c*i|0;g===r-1&&(m=f*e,v=h*e),g%2==0?(p=t,d=s):(p=a,d=n),this.clear(d,u,c),d.drawImage(p,0,0,u,c,0,0,m,v),u=m,c=v}var y=p===t?a:t,b=d.getImageData(0,0,u,c);return y.width=u,y.height=c,d.putImageData(b,0,0),o.default.resolve(y)},t.prototype.toBlob=function(t){var e=t.toDataURL(this.outputType,this.config.quality),n=atob(e.split(",")[1]).split("").map(function(t){return t.charCodeAt(0)});return new Blob([new Uint8Array(n)],{type:this.outputType})},t}();e.default=function(t,e){return new d(t,e).process()}},function(t,e,r){var o;(function(){function r(t){return!!t.exifdata}function i(t,e){function n(n){var r=a(n);t.exifdata=r||{};var o=function(t){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n=2,r=t.byteLength;n<r;){if(function(t,e){return 56===t.getUint8(e)&&66===t.getUint8(e+1)&&73===t.getUint8(e+2)&&77===t.getUint8(e+3)&&4===t.getUint8(e+4)&&4===t.getUint8(e+5)}(e,n)){var o=e.getUint8(n+7);o%2!=0&&(o+=1),0===o&&(o=4);return s(t,n+8+o,e.getUint16(n+6+o))}n++}}(n);if(t.iptcdata=o||{},g.isXmpEnabled){var i=function(t){if("DOMParser"in self){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n=2,r=t.byteLength,o=new DOMParser;n<r-4;){if("http"==f(e,n,4)){var i=n-1,a=e.getUint16(n-2)-1,s=f(e,i,a),u=s.indexOf("xmpmeta>")+8,c=(s=s.substring(s.indexOf("<x:xmpmeta"),u)).indexOf("x:xmpmeta")+10;s=s.slice(0,c)+'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:tiff="http://ns.adobe.com/tiff/1.0/" xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" xmlns:exif="http://ns.adobe.com/exif/1.0/" xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '+s.slice(c);return p(o.parseFromString(s,"text/xml"))}n++}}}(n);t.xmpdata=i||{}}e&&e.call(t)}if(t.src)if(/^data\:/i.test(t.src))n(function(t,e){e=e||t.match(/^data\:([^\;]+)\;base64,/im)[1]||"",t=t.replace(/^data\:([^\;]+)\;base64,/gim,"");for(var n=atob(t),r=n.length,o=new ArrayBuffer(r),i=new Uint8Array(o),a=0;a<r;a++)i[a]=n.charCodeAt(a);return o}(t.src));else if(/^blob\:/i.test(t.src))(o=new FileReader).onload=function(t){n(t.target.result)},function(t,e){var n=new XMLHttpRequest;n.open("GET",t,!0),n.responseType="blob",n.onload=function(t){200!=this.status&&0!==this.status||e(this.response)},n.send()}(t.src,function(t){o.readAsArrayBuffer(t)});else{var r=new XMLHttpRequest;r.onload=function(){if(200!=this.status&&0!==this.status)throw"Could not load image";n(r.response),r=null},r.open("GET",t.src,!0),r.responseType="arraybuffer",r.send(null)}else if(self.FileReader&&(t instanceof self.Blob||t instanceof self.File)){var o;(o=new FileReader).onload=function(t){d&&console.log("Got file of length "+t.target.result.byteLength),n(t.target.result)},o.readAsArrayBuffer(t)}}function a(t){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n,r=2,o=t.byteLength;r<o;){if(255!=e.getUint8(r))return d&&console.log("Not a valid marker at offset "+r+", found: "+e.getUint8(r)),!1;if(n=e.getUint8(r+1),d&&console.log(n),225==n)return d&&console.log("Found 0xFFE1 marker"),l(e,r+4,e.getUint16(r+2));r+=2+e.getUint16(r+2)}}function s(t,e,n){for(var r,o,i,a,s=new DataView(t),u={},c=e;c<e+n;)28===s.getUint8(c)&&2===s.getUint8(c+1)&&(a=s.getUint8(c+2))in x&&(i=s.getInt16(c+3),o=x[a],r=f(s,c+5,i),u.hasOwnProperty(o)?u[o]instanceof Array?u[o].push(r):u[o]=[u[o],r]:u[o]=r),c++;return u}function u(t,e,n,r,o){var i,a,s,u=t.getUint16(n,!o),f={};for(s=0;s<u;s++)i=n+12*s+2,!(a=r[t.getUint16(i,!o)])&&d&&console.log("Unknown tag: "+t.getUint16(i,!o)),f[a]=c(t,i,e,n,o);return f}function c(t,e,n,r,o){var i,a,s,u,c,l,h=t.getUint16(e+2,!o),p=t.getUint32(e+4,!o),d=t.getUint32(e+8,!o)+n;switch(h){case 1:case 7:if(1==p)return t.getUint8(e+8,!o);for(i=p>4?d:e+8,a=[],u=0;u<p;u++)a[u]=t.getUint8(i+u);return a;case 2:return f(t,i=p>4?d:e+8,p-1);case 3:if(1==p)return t.getUint16(e+8,!o);for(i=p>2?d:e+8,a=[],u=0;u<p;u++)a[u]=t.getUint16(i+2*u,!o);return a;case 4:if(1==p)return t.getUint32(e+8,!o);for(a=[],u=0;u<p;u++)a[u]=t.getUint32(d+4*u,!o);return a;case 5:if(1==p)return c=t.getUint32(d,!o),l=t.getUint32(d+4,!o),(s=new Number(c/l)).numerator=c,s.denominator=l,s;for(a=[],u=0;u<p;u++)c=t.getUint32(d+8*u,!o),l=t.getUint32(d+4+8*u,!o),a[u]=new Number(c/l),a[u].numerator=c,a[u].denominator=l;return a;case 9:if(1==p)return t.getInt32(e+8,!o);for(a=[],u=0;u<p;u++)a[u]=t.getInt32(d+4*u,!o);return a;case 10:if(1==p)return t.getInt32(d,!o)/t.getInt32(d+4,!o);for(a=[],u=0;u<p;u++)a[u]=t.getInt32(d+8*u,!o)/t.getInt32(d+4+8*u,!o);return a}}function f(t,e,r){var o="";for(n=e;n<e+r;n++)o+=String.fromCharCode(t.getUint8(n));return o}function l(t,e){if("Exif"!=f(t,e,4))return d&&console.log("Not valid EXIF data! "+f(t,e,4)),!1;var n,r,o,i,a,s=e+6;if(18761==t.getUint16(s))n=!1;else{if(19789!=t.getUint16(s))return d&&console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"),!1;n=!0}if(42!=t.getUint16(s+2,!n))return d&&console.log("Not valid TIFF data! (no 0x002A)"),!1;var c=t.getUint32(s+4,!n);if(c<8)return d&&console.log("Not valid TIFF data! (First offset less than 8)",t.getUint32(s+4,!n)),!1;if((r=u(t,s,s+c,v,n)).ExifIFDPointer)for(o in i=u(t,s,s+r.ExifIFDPointer,m,n)){switch(o){case"LightSource":case"Flash":case"MeteringMode":case"ExposureProgram":case"SensingMethod":case"SceneCaptureType":case"SceneType":case"CustomRendered":case"WhiteBalance":case"GainControl":case"Contrast":case"Saturation":case"Sharpness":case"SubjectDistanceRange":case"FileSource":i[o]=w[o][i[o]];break;case"ExifVersion":case"FlashpixVersion":i[o]=String.fromCharCode(i[o][0],i[o][1],i[o][2],i[o][3]);break;case"ComponentsConfiguration":i[o]=w.Components[i[o][0]]+w.Components[i[o][1]]+w.Components[i[o][2]]+w.Components[i[o][3]]}r[o]=i[o]}if(r.GPSInfoIFDPointer)for(o in a=u(t,s,s+r.GPSInfoIFDPointer,y,n)){switch(o){case"GPSVersionID":a[o]=a[o][0]+"."+a[o][1]+"."+a[o][2]+"."+a[o][3]}r[o]=a[o]}return r.thumbnail=function(t,e,n,r){var o=function(t,e,n){var r=t.getUint16(e,!n);return t.getUint32(e+2+12*r,!n)}(t,e+n,r);if(!o)return{};if(o>t.byteLength)return{};var i=u(t,e,e+o,b,r);if(i.Compression)switch(i.Compression){case 6:if(i.JpegIFOffset&&i.JpegIFByteCount){var a=e+i.JpegIFOffset,s=i.JpegIFByteCount;i.blob=new Blob([new Uint8Array(t.buffer,a,s)],{type:"image/jpeg"})}break;case 1:console.log("Thumbnail image format is TIFF, which is not implemented.");break;default:console.log("Unknown thumbnail image format '%s'",i.Compression)}else 2==i.PhotometricInterpretation&&console.log("Thumbnail image format is RGB, which is not implemented.");return i}(t,s,c,n),r}function h(t){var e={};if(1==t.nodeType){if(t.attributes.length>0){e["@attributes"]={};for(var n=0;n<t.attributes.length;n++){var r=t.attributes.item(n);e["@attributes"][r.nodeName]=r.nodeValue}}}else if(3==t.nodeType)return t.nodeValue;if(t.hasChildNodes())for(var o=0;o<t.childNodes.length;o++){var i=t.childNodes.item(o),a=i.nodeName;if(null==e[a])e[a]=h(i);else{if(null==e[a].push){var s=e[a];e[a]=[],e[a].push(s)}e[a].push(h(i))}}return e}function p(t){try{var e={};if(t.children.length>0)for(var n=0;n<t.children.length;n++){var r=t.children.item(n),o=r.attributes;for(var i in o){var a=o[i],s=a.nodeName,u=a.nodeValue;void 0!==s&&(e[s]=u)}var c=r.nodeName;if(void 0===e[c])e[c]=h(r);else{if(void 0===e[c].push){var f=e[c];e[c]=[],e[c].push(f)}e[c].push(h(r))}}else e=t.textContent;return e}catch(t){console.log(t.message)}}var d=!1,g=function(t){return t instanceof g?t:this instanceof g?void(this.EXIFwrapped=t):new g(t)};void 0!==t&&t.exports&&(e=t.exports=g),e.EXIF=g;var m=g.Tags={36864:"ExifVersion",40960:"FlashpixVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",37121:"ComponentsConfiguration",37122:"CompressedBitsPerPixel",37500:"MakerNote",37510:"UserComment",40964:"RelatedSoundFile",36867:"DateTimeOriginal",36868:"DateTimeDigitized",37520:"SubsecTime",37521:"SubsecTimeOriginal",37522:"SubsecTimeDigitized",33434:"ExposureTime",33437:"FNumber",34850:"ExposureProgram",34852:"SpectralSensitivity",34855:"ISOSpeedRatings",34856:"OECF",37377:"ShutterSpeedValue",37378:"ApertureValue",37379:"BrightnessValue",37380:"ExposureBias",37381:"MaxApertureValue",37382:"SubjectDistance",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37396:"SubjectArea",37386:"FocalLength",41483:"FlashEnergy",41484:"SpatialFrequencyResponse",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41492:"SubjectLocation",41493:"ExposureIndex",41495:"SensingMethod",41728:"FileSource",41729:"SceneType",41730:"CFAPattern",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41988:"DigitalZoomRation",41989:"FocalLengthIn35mmFilm",41990:"SceneCaptureType",41991:"GainControl",41992:"Contrast",41993:"Saturation",41994:"Sharpness",41995:"DeviceSettingDescription",41996:"SubjectDistanceRange",40965:"InteroperabilityIFDPointer",42016:"ImageUniqueID"},v=g.TiffTags={256:"ImageWidth",257:"ImageHeight",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer",40965:"InteroperabilityIFDPointer",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",274:"Orientation",277:"SamplesPerPixel",284:"PlanarConfiguration",530:"YCbCrSubSampling",531:"YCbCrPositioning",282:"XResolution",283:"YResolution",296:"ResolutionUnit",273:"StripOffsets",278:"RowsPerStrip",279:"StripByteCounts",513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength",301:"TransferFunction",318:"WhitePoint",319:"PrimaryChromaticities",529:"YCbCrCoefficients",532:"ReferenceBlackWhite",306:"DateTime",270:"ImageDescription",271:"Make",272:"Model",305:"Software",315:"Artist",33432:"Copyright"},y=g.GPSTags={0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude",5:"GPSAltitudeRef",6:"GPSAltitude",7:"GPSTimeStamp",8:"GPSSatellites",9:"GPSStatus",10:"GPSMeasureMode",11:"GPSDOP",12:"GPSSpeedRef",13:"GPSSpeed",14:"GPSTrackRef",15:"GPSTrack",16:"GPSImgDirectionRef",17:"GPSImgDirection",18:"GPSMapDatum",19:"GPSDestLatitudeRef",20:"GPSDestLatitude",21:"GPSDestLongitudeRef",22:"GPSDestLongitude",23:"GPSDestBearingRef",24:"GPSDestBearing",25:"GPSDestDistanceRef",26:"GPSDestDistance",27:"GPSProcessingMethod",28:"GPSAreaInformation",29:"GPSDateStamp",30:"GPSDifferential"},b=g.IFD1Tags={256:"ImageWidth",257:"ImageHeight",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",273:"StripOffsets",274:"Orientation",277:"SamplesPerPixel",278:"RowsPerStrip",279:"StripByteCounts",282:"XResolution",283:"YResolution",284:"PlanarConfiguration",296:"ResolutionUnit",513:"JpegIFOffset",514:"JpegIFByteCount",529:"YCbCrCoefficients",530:"YCbCrSubSampling",531:"YCbCrPositioning",532:"ReferenceBlackWhite"},w=g.StringValues={ExposureProgram:{0:"Not defined",1:"Manual",2:"Normal program",3:"Aperture priority",4:"Shutter priority",5:"Creative program",6:"Action program",7:"Portrait mode",8:"Landscape mode"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{0:"Unknown",1:"Daylight",2:"Fluorescent",3:"Tungsten (incandescent light)",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 - 5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},SensingMethod:{1:"Not defined",2:"One-chip color area sensor",3:"Two-chip color area sensor",4:"Three-chip color area sensor",5:"Color sequential area sensor",7:"Trilinear sensor",8:"Color sequential linear sensor"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},SceneType:{1:"Directly photographed"},CustomRendered:{0:"Normal process",1:"Custom process"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},GainControl:{0:"None",1:"Low gain up",2:"High gain up",3:"Low gain down",4:"High gain down"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},SubjectDistanceRange:{0:"Unknown",1:"Macro",2:"Close view",3:"Distant view"},FileSource:{3:"DSC"},Components:{0:"",1:"Y",2:"Cb",3:"Cr",4:"R",5:"G",6:"B"}},x={120:"caption",110:"credit",25:"keywords",55:"dateCreated",80:"byline",85:"bylineTitle",122:"captionWriter",105:"headline",116:"copyright",15:"category"};g.enableXmp=function(){g.isXmpEnabled=!0},g.disableXmp=function(){g.isXmpEnabled=!1},g.getData=function(t,e){return!((self.Image&&t instanceof self.Image||self.HTMLImageElement&&t instanceof self.HTMLImageElement)&&!t.complete||(r(t)?e&&e.call(t):i(t,e),0))},g.getTag=function(t,e){if(r(t))return t.exifdata[e]},g.getIptcTag=function(t,e){if(r(t))return t.iptcdata[e]},g.getAllTags=function(t){if(!r(t))return{};var e,n=t.exifdata,o={};for(e in n)n.hasOwnProperty(e)&&(o[e]=n[e]);return o},g.getAllIptcTags=function(t){if(!r(t))return{};var e,n=t.iptcdata,o={};for(e in n)n.hasOwnProperty(e)&&(o[e]=n[e]);return o},g.pretty=function(t){if(!r(t))return"";var e,n=t.exifdata,o="";for(e in n)n.hasOwnProperty(e)&&("object"==typeof n[e]?n[e]instanceof Number?o+=e+" : "+n[e]+" ["+n[e].numerator+"/"+n[e].denominator+"]\r\n":o+=e+" : ["+n[e].length+" values]\r\n":o+=e+" : "+n[e]+"\r\n");return o},g.readFromBinaryFile=function(t){return a(t)},void 0===(o=function(){return g}.apply(e,[]))||(t.exports=o)}).call(this)}])});

(function(){
    'use strict';

    angular
        .module('backApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransforms3d-csstransitions-shiv-cssclasses-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes-load
 */
;window.Modernizr = function (a, b, c) {
    function z(a) {
        j.cssText = a
    }

    function A(a, b) {
        return z(m.join(a + ";") + (b || ""))
    }

    function B(a, b) {
        return typeof a === b
    }

    function C(a, b) {
        return !!~("" + a).indexOf(b)
    }

    function D(a, b) {
        for (var d in a) {
            var e = a[d];
            if (!C(e, "-") && j[e] !== c)return b == "pfx" ? e : !0
        }
        return !1
    }

    function E(a, b, d) {
        for (var e in a) {
            var f = b[a[e]];
            if (f !== c)return d === !1 ? a[e] : B(f, "function") ? f.bind(d || b) : f
        }
        return !1
    }

    function F(a, b, c) {
        var d = a.charAt(0).toUpperCase() + a.slice(1), e = (a + " " + o.join(d + " ") + d).split(" ");
        return B(b, "string") || B(b, "undefined") ? D(e, b) : (e = (a + " " + p.join(d + " ") + d).split(" "), E(e, b, c))
    }

    var d = "2.6.2", e = {}, f = !0, g = b.documentElement, h = "modernizr", i = b.createElement(h), j = i.style, k, l = {}.toString, m = " -webkit- -moz- -o- -ms- ".split(" "), n = "Webkit Moz O ms", o = n.split(" "), p = n.toLowerCase().split(" "), q = {}, r = {}, s = {}, t = [], u = t.slice, v, w = function (a, c, d, e) {
        var f, i, j, k, l = b.createElement("div"), m = b.body, n = m || b.createElement("body");
        if (parseInt(d, 10))while (d--)j = b.createElement("div"), j.id = e ? e[d] : h + (d + 1), l.appendChild(j);
        return f = ["&#173;", '<style id="s', h, '">', a, "</style>"].join(""), l.id = h, (m ? l : n).innerHTML += f, n.appendChild(l), m || (n.style.background = "", n.style.overflow = "hidden", k = g.style.overflow, g.style.overflow = "hidden", g.appendChild(n)), i = c(l, a), m ? l.parentNode.removeChild(l) : (n.parentNode.removeChild(n), g.style.overflow = k), !!i
    }, x = {}.hasOwnProperty, y;
    !B(x, "undefined") && !B(x.call, "undefined") ? y = function (a, b) {
            return x.call(a, b)
        } : y = function (a, b) {
            return b in a && B(a.constructor.prototype[b], "undefined")
        }, Function.prototype.bind || (Function.prototype.bind = function (b) {
        var c = this;
        if (typeof c != "function")throw new TypeError;
        var d = u.call(arguments, 1), e = function () {
            if (this instanceof e) {
                var a = function () {
                };
                a.prototype = c.prototype;
                var f = new a, g = c.apply(f, d.concat(u.call(arguments)));
                return Object(g) === g ? g : f
            }
            return c.apply(b, d.concat(u.call(arguments)))
        };
        return e
    }), q.csstransforms3d = function () {
        var a = !!F("perspective");
        return a && "webkitPerspective" in g.style && w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function (b, c) {
            a = b.offsetLeft === 9 && b.offsetHeight === 3
        }), a
    }, q.csstransitions = function () {
        return F("transition")
    };
    for (var G in q)y(q, G) && (v = G.toLowerCase(), e[v] = q[G](), t.push((e[v] ? "" : "no-") + v));
    return e.addTest = function (a, b) {
        if (typeof a == "object")for (var d in a)y(a, d) && e.addTest(d, a[d]); else {
            a = a.toLowerCase();
            if (e[a] !== c)return e;
            b = typeof b == "function" ? b() : b, typeof f != "undefined" && f && (g.className += " " + (b ? "" : "no-") + a), e[a] = b
        }
        return e
    }, z(""), i = k = null, function (a, b) {
        function k(a, b) {
            var c = a.createElement("p"), d = a.getElementsByTagName("head")[0] || a.documentElement;
            return c.innerHTML = "x<style>" + b + "</style>", d.insertBefore(c.lastChild, d.firstChild)
        }

        function l() {
            var a = r.elements;
            return typeof a == "string" ? a.split(" ") : a
        }

        function m(a) {
            var b = i[a[g]];
            return b || (b = {}, h++, a[g] = h, i[h] = b), b
        }

        function n(a, c, f) {
            c || (c = b);
            if (j)return c.createElement(a);
            f || (f = m(c));
            var g;
            return f.cache[a] ? g = f.cache[a].cloneNode() : e.test(a) ? g = (f.cache[a] = f.createElem(a)).cloneNode() : g = f.createElem(a), g.canHaveChildren && !d.test(a) ? f.frag.appendChild(g) : g
        }

        function o(a, c) {
            a || (a = b);
            if (j)return a.createDocumentFragment();
            c = c || m(a);
            var d = c.frag.cloneNode(), e = 0, f = l(), g = f.length;
            for (; e < g; e++)d.createElement(f[e]);
            return d
        }

        function p(a, b) {
            b.cache || (b.cache = {}, b.createElem = a.createElement, b.createFrag = a.createDocumentFragment, b.frag = b.createFrag()), a.createElement = function (c) {
                return r.shivMethods ? n(c, a, b) : b.createElem(c)
            }, a.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + l().join().replace(/\w+/g, function (a) {
                    return b.createElem(a), b.frag.createElement(a), 'c("' + a + '")'
                }) + ");return n}")(r, b.frag)
        }

        function q(a) {
            a || (a = b);
            var c = m(a);
            return r.shivCSS && !f && !c.hasCSS && (c.hasCSS = !!k(a, "article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")), j || p(a, c), a
        }

        var c = a.html5 || {}, d = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i, e = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i, f, g = "_html5shiv", h = 0, i = {}, j;
        (function () {
            try {
                var a = b.createElement("a");
                a.innerHTML = "<xyz></xyz>", f = "hidden" in a, j = a.childNodes.length == 1 || function () {
                        b.createElement("a");
                        var a = b.createDocumentFragment();
                        return typeof a.cloneNode == "undefined" || typeof a.createDocumentFragment == "undefined" || typeof a.createElement == "undefined"
                    }()
            } catch (c) {
                f = !0, j = !0
            }
        })();
        var r = {
            elements: c.elements || "abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",
            shivCSS: c.shivCSS !== !1,
            supportsUnknownElements: j,
            shivMethods: c.shivMethods !== !1,
            type: "default",
            shivDocument: q,
            createElement: n,
            createDocumentFragment: o
        };
        a.html5 = r, q(b)
    }(this, b), e._version = d, e._prefixes = m, e._domPrefixes = p, e._cssomPrefixes = o, e.testProp = function (a) {
        return D([a])
    }, e.testAllProps = F, e.testStyles = w, e.prefixed = function (a, b, c) {
        return b ? F(a, b, c) : F(a, "pfx")
    }, g.className = g.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (f ? " js " + t.join(" ") : ""), e
}(this, this.document), function (a, b, c) {
    function d(a) {
        return "[object Function]" == o.call(a)
    }

    function e(a) {
        return "string" == typeof a
    }

    function f() {
    }

    function g(a) {
        return !a || "loaded" == a || "complete" == a || "uninitialized" == a
    }

    function h() {
        var a = p.shift();
        q = 1, a ? a.t ? m(function () {
                    ("c" == a.t ? B.injectCss : B.injectJs)(a.s, 0, a.a, a.x, a.e, 1)
                }, 0) : (a(), h()) : q = 0
    }

    function i(a, c, d, e, f, i, j) {
        function k(b) {
            if (!o && g(l.readyState) && (u.r = o = 1, !q && h(), l.onload = l.onreadystatechange = null, b)) {
                "img" != a && m(function () {
                    t.removeChild(l)
                }, 50);
                for (var d in y[c])y[c].hasOwnProperty(d) && y[c][d].onload()
            }
        }

        var j = j || B.errorTimeout, l = b.createElement(a), o = 0, r = 0, u = {t: d, s: c, e: f, a: i, x: j};
        1 === y[c] && (r = 1, y[c] = []), "object" == a ? l.data = c : (l.src = c, l.type = a), l.width = l.height = "0", l.onerror = l.onload = l.onreadystatechange = function () {
            k.call(this, r)
        }, p.splice(e, 0, u), "img" != a && (r || 2 === y[c] ? (t.insertBefore(l, s ? null : n), m(k, j)) : y[c].push(l))
    }

    function j(a, b, c, d, f) {
        return q = 0, b = b || "j", e(a) ? i("c" == b ? v : u, a, b, this.i++, c, d, f) : (p.splice(this.i++, 0, a), 1 == p.length && h()), this
    }

    function k() {
        var a = B;
        return a.loader = {load: j, i: 0}, a
    }

    var l = b.documentElement, m = a.setTimeout, n = b.getElementsByTagName("script")[0], o = {}.toString, p = [], q = 0, r = "MozAppearance" in l.style, s = r && !!b.createRange().compareNode, t = s ? l : n.parentNode, l = a.opera && "[object Opera]" == o.call(a.opera), l = !!b.attachEvent && !l, u = r ? "object" : l ? "script" : "img", v = l ? "script" : u, w = Array.isArray || function (a) {
            return "[object Array]" == o.call(a)
        }, x = [], y = {}, z = {
        timeout: function (a, b) {
            return b.length && (a.timeout = b[0]), a
        }
    }, A, B;
    B = function (a) {
        function b(a) {
            var a = a.split("!"), b = x.length, c = a.pop(), d = a.length, c = {
                url: c,
                origUrl: c,
                prefixes: a
            }, e, f, g;
            for (f = 0; f < d; f++)g = a[f].split("="), (e = z[g.shift()]) && (c = e(c, g));
            for (f = 0; f < b; f++)c = x[f](c);
            return c
        }

        function g(a, e, f, g, h) {
            var i = b(a), j = i.autoCallback;
            i.url.split(".").pop().split("?").shift(), i.bypass || (e && (e = d(e) ? e : e[a] || e[g] || e[a.split("/").pop().split("?")[0]]), i.instead ? i.instead(a, e, f, g, h) : (y[i.url] ? i.noexec = !0 : y[i.url] = 1, f.load(i.url, i.forceCSS || !i.forceJS && "css" == i.url.split(".").pop().split("?").shift() ? "c" : c, i.noexec, i.attrs, i.timeout), (d(e) || d(j)) && f.load(function () {
                    k(), e && e(i.origUrl, h, g), j && j(i.origUrl, h, g), y[i.url] = 2
                })))
        }

        function h(a, b) {
            function c(a, c) {
                if (a) {
                    if (e(a)) c || (j = function () {
                        var a = [].slice.call(arguments);
                        k.apply(this, a), l()
                    }), g(a, j, b, 0, h); else if (Object(a) === a)for (n in m = function () {
                        var b = 0, c;
                        for (c in a)a.hasOwnProperty(c) && b++;
                        return b
                    }(), a)a.hasOwnProperty(n) && (!c && !--m && (d(j) ? j = function () {
                            var a = [].slice.call(arguments);
                            k.apply(this, a), l()
                        } : j[n] = function (a) {
                            return function () {
                                var b = [].slice.call(arguments);
                                a && a.apply(this, b), l()
                            }
                        }(k[n])), g(a[n], j, b, n, h))
                } else!c && l()
            }

            var h = !!a.test, i = a.load || a.both, j = a.callback || f, k = j, l = a.complete || f, m, n;
            c(h ? a.yep : a.nope, !!i), i && c(i)
        }

        var i, j, l = this.yepnope.loader;
        if (e(a)) g(a, 0, l, 0); else if (w(a))for (i = 0; i < a.length; i++)j = a[i], e(j) ? g(j, 0, l, 0) : w(j) ? B(j) : Object(j) === j && h(j, l); else Object(a) === a && h(a, l)
    }, B.addPrefix = function (a, b) {
        z[a] = b
    }, B.addFilter = function (a) {
        x.push(a)
    }, B.errorTimeout = 1e4, null == b.readyState && b.addEventListener && (b.readyState = "loading", b.addEventListener("DOMContentLoaded", A = function () {
        b.removeEventListener("DOMContentLoaded", A, 0), b.readyState = "complete"
    }, 0)), a.yepnope = k(), a.yepnope.executeStack = h, a.yepnope.injectJs = function (a, c, d, e, i, j) {
        var k = b.createElement("script"), l, o, e = e || B.errorTimeout;
        k.src = a;
        for (o in d)k.setAttribute(o, d[o]);
        c = j ? h : c || f, k.onreadystatechange = k.onload = function () {
            !l && g(k.readyState) && (l = 1, c(), k.onload = k.onreadystatechange = null)
        }, m(function () {
            l || (l = 1, c(1))
        }, e), i ? k.onload() : n.parentNode.insertBefore(k, n)
    }, a.yepnope.injectCss = function (a, c, d, e, g, i) {
        var e = b.createElement("link"), j, c = i ? h : c || f;
        e.href = a, e.rel = "stylesheet", e.type = "text/css";
        for (j in d)e.setAttribute(j, d[j]);
        g || (n.parentNode.insertBefore(e, n), m(c, 0))
    }
}(this, document), Modernizr.load = function () {
    yepnope.apply(window, [].slice.call(arguments, 0))
};
(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('MessageService', MessageService);

    MessageService.$inject = ['$uibModal'];

    function MessageService($uibModal) {
        var service = {
            confirm: confirm,
            successConfirm: successConfirm,
            comment:comment,
            loading:loading,
            error:error,
            notice:notice,
            info:info,
            success:success, 
            notify:notify


        };

        var settings = {
            title: 'The notice title.', // The notice's title.
            title_escape: false, // Whether to escape the content of the title. (Not allow HTML.)
            // text: 'The notice text.', // The notice's text.
            text_escape: false, // Whether to escape the content of the text. (Not allow HTML.)
            styling: "bootstrap3", // What styling classes to use. (Can be either jqueryui or bootstrap or bootstrap3.)
            // addclass: "", // Additional classes to be added to the notice. (For custom styling.)
            // cornerclass: "", // Class to be added to the notice for corner styling.
            // nonblock: false, // Create a non-blocking notice. It lets the user click elements underneath it.
            // nonblock_opacity: .2, // The opacity of the notice (if it's non-blocking) when the mouse is over it.
            history: false, // Display a pull down menu to redisplay previous notices, and place the notice in the history.
            // width: "300px", // Width of the notice.
            // min_height: "16px", // Minimum height of the notice. It will expand to fit content.
            type: "notice", // Type of the notice. "notice", "info", "success", or "error".
            icon: true, // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
            // animation: "fade", // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
            // animate_speed: "slow", // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
            // opacity: 1, // Opacity of the notice.
            // shadow: true, // Display a drop shadow.
            // closer: true, // Provide a button for the user to manually close the notice.
            // closer_hover: true, // Only show the closer button on hover.
            // sticker: true, // Provide a button for the user to manually stick the notice.
            // sticker_hover: true, // Only show the sticker button on hover.
            // hide: true, // After a delay, remove the notice.
            delay: 5000 // Delay in milliseconds before the notice is removed.
                // mouse_reset: true, // Reset the hide timer if the mouse moves over the notice.
                // remove: true, // Remove the notice's elements from the DOM after it is removed.
                // insert_brs: true, // Change new lines to br tags.
                // stack: {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25}
        };
        var current;

        function notice(content) {
            var hash = angular.copy(settings);
            hash.type = 'notice';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function info(content) {
            var hash = angular.copy(settings);
            hash.type = 'info';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function success(content) {
            var hash = angular.copy(settings);
            hash.type = 'success';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function error(content) {
            var hash = angular.copy(settings);
            hash.type = 'error';
            hash.title = content;
            return this.notify(hash);
        };

        function notify(hash) {
            if (current) {
                current.remove();
            }
            current = new PNotify(hash);
            return current; 

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + hash.title + '</h3>' + //
                    '</div>' + // 
                    '</div>', 
            });
        };

        function loading() {
            return $uibModal.open({
                template: '<i class="fa fa-5x fa-spinner fa-spin fa-white"></i>',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'loading-window'
            });
        };

        function confirm(msg, confirmCallback, cancelCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            ];
            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div  style="position: relative;">' + //
                        '<div class="modal-top">操作</div>'+
                        '<div class="modal-row">' + //
                        '<span><label translate='+msg+'></label></span>' + //
                        '</div>' + //
                        '<div class="modal-foot2">' + //
                        '<button class="btn btn-warning2 mar-right-10" translate="entity.action.cancel" ng-click="cancel()"></button>' + //
                        '<button class="btn btn-primary width-80"  translate="entity.action.ok" ng-click="ok()"></button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl,windowClass:'modal-center',
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div style="position: relative;">' + //
                        '<div class="modal-top">操作</div>'+
                        '<div class="modal-row">' + //
                        '<span>'+msg+'</span>' + //
                        '</div>' + //
                        '<div class="modal-foot2">' + //
                        '<button class="btn btn-warning2 mar-right-10"  ng-click="cancel()">取消</button>' + //
                        '<button class="btn btn-primary width-80" ng-click="ok()">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl,windowClass:'modal-center',
                });
            }
            

            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });

        };

        function successConfirm(msg, confirmCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                }
            ];

            if(!!translate){
                 var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()"><label translate='+msg+'></label></h3>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()">' + msg + '</h3>',
                    controller: ModalInstanceCtrl
                });
            }
            

           
            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            });
        };

        function comment(msg, confirmCallback, cancelCallback, commentMust, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance', '$timeout',
                function($scope, $uibModalInstance, $timeout) {
                    $scope.ok = function(comment) {
                        if (commentMust && !comment) {
                            // return self.error('评论必填');
                            $scope.error = true;
                            return;
                        }
                        $scope.error = false;
                        $uibModalInstance.close(comment);
                    };
                    if (commentMust) {
                        $scope.placeholderMsg = "请输入评论(必填)";
                    } else {
                        $scope.placeholderMsg = "请输入评论(可空)";
                    }

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $timeout(function() {
                        $scope.$apply();
                    });
                }
            ];

            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3><label translate='+msg+'></label></h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3>' + msg + '</h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }

            modalInstance.result.then(function(comment) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(comment);
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });
        };
        return service;
    }

})();

(function() {
	'use strict';
	angular
		.module('backApp')
		.factory('ListService', ListService);

	ListService.$inject = [];

	function ListService() {
		var service = {
			inList: inList,
			inList2 :inList2,
			removeEmptyInList: removeEmptyInList
		};
		return service;

		function inList2(value, list, valueAttr , listAttr) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (valueAttr && listAttr) {
						if (v && value[valueAttr] == v[listAttr]) { 
							return v; 
						}; 
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function inList(value, list, attrList) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (attrList) {
						if (v) {
							var match = 0;
							for (var j = 0; attrList && j < attrList.length; j++) {
								var attr = attrList[j];
								if (attr) {
									if (v[attr] == value[attr]) {
										match++;
									} else {
										break;
									}
								}
							}
							if (match == attrList.length) {
								return v;
							}
						}
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function removeEmptyInList(list, key) {
			if (!list) return;
			for (var i = 0; i < list.length; i++) {
				var item = list[i];
				if (item && !item[key]) {
					list.splice(i, 1);
					i--;
				}
			}
		}
	}



})();
/*! layPage-v1.3.0 分页组件 License MIT  http://laypage.layui.com/ By 贤心 */
;!function () {
    "use strict";

    function a(d) {
        var e = "laypagecss";
        a.dir = "dir" in a ? a.dir : f.getpath + "/skin/laypages.css", new f(d), a.dir && !b[c](e) && f.use(a.dir, e)
    }

    a.v = "1.3";
    var b = document, c = "getElementById", d = "getElementsByTagName", e = 0, f = function (a) {
        var b = this, c = b.config = a || {};
        c.item = e++, b.render(!0)
    };
    f.on = function (a, b, c) {
        return a.attachEvent ? a.attachEvent("on" + b, function () {
            c.call(a, window.even)
        }) : a.addEventListener(b, c, !1), f
    }, f.getpath = function () {
        var a = document.scripts, b = a[a.length - 1].src;
        return b.substring(0, b.lastIndexOf("/") + 1)
    }(), f.use = function (c, e) {
        // var f = b.createElement("link");
        // f.type = "text/css", f.rel = "stylesheet", f.href = a.dir, e && (f.id = e), b[d]("head")[0].appendChild(f), f = null
    }, f.prototype.type = function () {
        var a = this.config;
        return "object" == typeof a.cont ? void 0 === a.cont.length ? 2 : 3 : void 0
    }, f.prototype.view = function () {
        var b = this, c = b.config, d = [], e = {};
        if (c.pages = 0 | c.pages, c.curr = 0 | c.curr || 1, c.groups = "groups" in c ? 0 | c.groups : 5, c.first = "first" in c ? c.first : "&#x9996;&#x9875;", c.last = "last" in c ? c.last : "&#x5C3E;&#x9875;", c.prev = "prev" in c ? c.prev : "&#x4E0A;&#x4E00;&#x9875;", c.next = "next" in c ? c.next : "&#x4E0B;&#x4E00;&#x9875;", c.pages <= 1) return "";
        for (c.groups > c.pages && (c.groups = c.pages), e.index = Math.ceil((c.curr + (c.groups > 1 && c.groups !== c.pages ? 1 : 0)) / (0 === c.groups ? 1 : c.groups)), c.curr > 1 && c.prev && d.push('<a href="javascript:;" class="laypage_prev" data-page="' + (c.curr - 1) + '">' + c.prev + "</a>"), e.index > 1 && c.first && 0 !== c.groups && d.push('<a href="javascript:;" class="laypage_first" data-page="1"  title="&#x9996;&#x9875;">' + c.first + "</a><span>&#x2026;</span>"), e.poor = Math.floor((c.groups - 1) / 2), e.start = e.index > 1 ? c.curr - e.poor : 1, e.end = e.index > 1 ? function () {
            var a = c.curr + (c.groups - e.poor - 1);
            return a > c.pages ? c.pages : a
        }() : c.groups, e.end - e.start < c.groups - 1 && (e.start = e.end - c.groups + 1); e.start <= e.end; e.start++) e.start === c.curr ? d.push('<span class="laypage_curr" ' + (/^#/.test(c.skin) ? 'style="background-color:' + c.skin + '"' : "") + ">" + e.start + "</span>") : d.push('<a href="javascript:;" data-page="' + e.start + '">' + e.start + "</a>");
        return c.pages > c.groups && e.end < c.pages && c.last && 0 !== c.groups && d.push('<span>&#x2026;</span><a href="javascript:;" class="laypage_last" title="&#x5C3E;&#x9875;"  data-page="' + c.pages + '">' + c.last + "</a>"), e.flow = !c.prev && 0 === c.groups, (c.curr !== c.pages && c.next || e.flow) && d.push(function () {
            return e.flow && c.curr === c.pages ? '<span class="page_nomore" title="&#x5DF2;&#x6CA1;&#x6709;&#x66F4;&#x591A;">' + c.next + "</span>" : '<a href="javascript:;" class="laypage_next" data-page="' + (c.curr + 1) + '">' + c.next + "</a>"
        }()), '<div name="laypage' + a.v + '" class="laypage_main laypageskin_' + (c.skin ? function (a) {
            return /^#/.test(a) ? "molv" : a
        }(c.skin) : "default") + '" id="laypage_' + b.config.item + '">' + d.join("") + function () {
            return c.skip ? '<span class="laypage_total"><label>&#x5230;&#x7B2C;</label><input type="number" min="1" onkeyup="this.value=this.value.replace(/\\D/, \'\');" class="laypage_skip"><label>&#x9875;</label><button type="button" class="laypage_btn">&#x786e;&#x5b9a</button></span>' : ""
        }() + "</div>"
    }, f.prototype.jump = function (a) {
        if (a) {
            for (var b = this, c = b.config, e = a.children, g = a[d]("button")[0], h = a[d]("input")[0], i = 0, j = e.length; j > i; i++) "a" === e[i].nodeName.toLowerCase() && f.on(e[i], "click", function () {
                var a = 0 | this.getAttribute("data-page");
                c.curr = a, b.render()
            });
            g && f.on(g, "click", function () {
                var a = 0 | h.value.replace(/\s|\D/g, "");
                a && a <= c.pages && (c.curr = a, b.render())
            })
        }
    }, f.prototype.render = function (a) {
        var d = this, e = d.config, f = d.type(), g = d.view();
        2 === f ? e.cont.innerHTML = g : 3 === f ? e.cont.html(g) : b[c](e.cont).innerHTML = g, e.jump && e.jump(e, a), d.jump(b[c]("laypage_" + e.item)), e.hash && !a && (location.hash = "!" + e.hash + "=" + e.curr)
    }, "function" == typeof define ? define(function () {
        return a
    }) : "undefined" != typeof exports ? module.exports = a : window.laypage = a
}();

/**
 * jquery.bookblock.min.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
(function(f,g,d){var c=f(g),e=g.Modernizr;e.addTest("csstransformspreserve3d",function(){var l=e.prefixed("transformStyle");var k="preserve-3d";var j;if(!l){return false}l=l.replace(/([A-Z])/g,function(n,m){return"-"+m.toLowerCase()}).replace(/^ms-/,"-ms-");e.testStyles("#modernizr{"+l+":"+k+";}",function(m,n){j=g.getComputedStyle?getComputedStyle(m,null).getPropertyValue(l):""});return(j===k)});var a=f.event,b,i;b=a.special.debouncedresize={setup:function(){f(this).on("resize",b.handler)},teardown:function(){f(this).off("resize",b.handler)},handler:function(n,j){var m=this,l=arguments,k=function(){n.type="debouncedresize";a.dispatch.apply(m,l)};if(i){clearTimeout(i)}j?k():i=setTimeout(k,b.threshold)},threshold:150};f.BookBlock=function(j,k){this.$el=f(k);this._init(j)};f.BookBlock.defaults={orientation:"vertical",direction:"ltr",speed:1000,easing:"ease-in-out",shadows:true,shadowSides:0.2,shadowFlip:0.1,circular:false,nextEl:"",prevEl:"",autoplay:false,interval:3000,onEndFlip:function(j,l,k){return false},onBeforeFlip:function(j){return false}};f.BookBlock.prototype={_init:function(j){this.options=f.extend(true,{},f.BookBlock.defaults,j);this.$el.addClass("bb-"+this.options.orientation);this.$items=this.$el.children(".bb-item").hide();this.itemsCount=this.$items.length;this.current=0;this.previous=-1;this.$current=this.$items.eq(this.current).show();this.elWidth=this.$el.width();var k={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",msTransition:"MSTransitionEnd",transition:"transitionend"};this.transEndEventName=k[e.prefixed("transition")]+".bookblock";this.support=e.csstransitions&&e.csstransforms3d&&e.csstransformspreserve3d;this._initEvents();if(this.options.autoplay){this.options.circular=true;this._startSlideshow()}},_initEvents:function(){var j=this;if(this.options.nextEl!==""){f(this.options.nextEl).on("click.bookblock touchstart.bookblock",function(){j._action("next");return false})}if(this.options.prevEl!==""){f(this.options.prevEl).on("click.bookblock touchstart.bookblock",function(){j._action("prev");return false})}c.on("debouncedresize",function(){j.elWidth=j.$el.width()})},_action:function(j,k){this._stopSlideshow();this._navigate(j,k)},_navigate:function(j,k){if(this.isAnimating){return false}this.options.onBeforeFlip(this.current);this.isAnimating=true;this.$current=this.$items.eq(this.current);if(k!==d){this.current=k}else{if(j==="next"&&this.options.direction==="ltr"||j==="prev"&&this.options.direction==="rtl"){if(!this.options.circular&&this.current===this.itemsCount-1){this.end=true}else{this.previous=this.current;this.current=this.current<this.itemsCount-1?this.current+1:0}}else{if(j==="prev"&&this.options.direction==="ltr"||j==="next"&&this.options.direction==="rtl"){if(!this.options.circular&&this.current===0){this.end=true}else{this.previous=this.current;this.current=this.current>0?this.current-1:this.itemsCount-1}}}}this.$nextItem=!this.options.circular&&this.end?this.$current:this.$items.eq(this.current);if(!this.support){this._layoutNoSupport(j)}else{this._layout(j)}},_layoutNoSupport:function(k){this.$items.hide();this.$nextItem.show();this.end=false;this.isAnimating=false;var j=k==="next"&&this.current===this.itemsCount-1||k==="prev"&&this.current===0;this.options.onEndFlip(this.previous,this.current,j)},_layout:function(l){var v=this,u=this._addSide("left",l),o=this._addSide("middle",l),j=this._addSide("right",l),r=u.find("div.bb-overlay"),t=o.find("div.bb-flipoverlay:first"),w=o.find("div.bb-flipoverlay:last"),s=j.find("div.bb-overlay"),k=this.end?400:this.options.speed;this.$items.hide();this.$el.prepend(u,o,j);o.css({transitionDuration:k+"ms",transitionTimingFunction:this.options.easing}).on(this.transEndEventName,function(y){if(f(y.target).hasClass("bb-page")){v.$el.children(".bb-page").remove();v.$nextItem.show();v.end=false;v.isAnimating=false;var x=l==="next"&&v.current===v.itemsCount-1||l==="prev"&&v.current===0;v.options.onEndFlip(v.previous,v.current,x)}});if(l==="prev"){o.addClass("bb-flip-initial")}if(this.options.shadows&&!this.end){var n=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms"}:{transition:"opacity "+this.options.speed/2+"ms linear",opacity:this.options.shadowSides},q=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear"}:{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms",opacity:this.options.shadowFlip},m=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms",opacity:this.options.shadowFlip}:{transition:"opacity "+this.options.speed/2+"ms linear"},p=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear",opacity:this.options.shadowSides}:{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms"};t.css(q);w.css(m);r.css(n);s.css(p)}setTimeout(function(){o.addClass(v.end?"bb-flip-"+l+"-end":"bb-flip-"+l);if(v.options.shadows&&!v.end){t.css({opacity:l==="next"?v.options.shadowFlip:0});w.css({opacity:l==="next"?0:v.options.shadowFlip});r.css({opacity:l==="next"?v.options.shadowSides:0});s.css({opacity:l==="next"?0:v.options.shadowSides})}},25)},_addSide:function(l,k){var j;switch(l){case"left":j=f('<div class="bb-page"><div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+(k==="next"?this.$current.html():this.$nextItem.html())+'</div></div><div class="bb-overlay"></div></div></div></div>').css("z-index",102);break;case"middle":j=f('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+(k==="next"?this.$current.html():this.$nextItem.html())+'</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:'+this.elWidth+'px"><div class="bb-inner">'+(k==="next"?this.$nextItem.html():this.$current.html())+'</div></div><div class="bb-flipoverlay"></div></div></div></div>').css("z-index",103);break;case"right":j=f('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+(k==="next"?this.$nextItem.html():this.$current.html())+'</div></div><div class="bb-overlay"></div></div></div></div>').css("z-index",101);break}return j},_startSlideshow:function(){var j=this;this.slideshow=setTimeout(function(){j._navigate("next");if(j.options.autoplay){j._startSlideshow()}},this.options.interval)},_stopSlideshow:function(){if(this.options.autoplay){clearTimeout(this.slideshow);this.options.autoplay=false}},next:function(){this._action(this.options.direction==="ltr"?"next":"prev")},prev:function(){this._action(this.options.direction==="ltr"?"prev":"next")},jump:function(k){k-=1;if(k===this.current||k>=this.itemsCount||k<0){return false}var j;if(this.options.direction==="ltr"){j=k>this.current?"next":"prev"}else{j=k>this.current?"prev":"next"}this._action(j,k)},last:function(){this.jump(this.itemsCount)},first:function(){this.jump(1)},isActive:function(){return this.isAnimating},update:function(){var j=this.$items.eq(this.current);this.$items=this.$el.children(".bb-item");this.itemsCount=this.$items.length;this.current=j.index()},destroy:function(){if(this.options.autoplay){this._stopSlideshow()}this.$el.removeClass("bb-"+this.options.orientation);this.$items.show();if(this.options.nextEl!==""){f(this.options.nextEl).off(".bookblock")}if(this.options.prevEl!==""){f(this.options.prevEl).off(".bookblock")}c.off("debouncedresize")}};var h=function(j){if(g.console){g.console.error(j)}};f.fn.bookblock=function(k){if(typeof k==="string"){var j=Array.prototype.slice.call(arguments,1);this.each(function(){var l=f.data(this,"bookblock");if(!l){h("cannot call methods on bookblock prior to initialization; attempted to call method '"+k+"'");return}if(!f.isFunction(l[k])||k.charAt(0)==="_"){h("no such method '"+k+"' for bookblock instance");return}l[k].apply(l,j)})}else{this.each(function(){var l=f.data(this,"bookblock");if(l){l._init()}else{l=f.data(this,"bookblock",new f.BookBlock(k,this))}})}return this}})(jQuery,window);

;(function ($, window, undefined) {

    'use strict';

    // global
    var $window = $(window),
        Modernizr = window.Modernizr;

    // https://gist.github.com/edankwan/4389601
    Modernizr.addTest('csstransformspreserve3d', function () {
        var prop = Modernizr.prefixed('transformStyle');
        var val = 'preserve-3d';
        var computedStyle;
        if (!prop) return false;

        prop = prop.replace(/([A-Z])/g, function (str, m1) {
            return '-' + m1.toLowerCase();
        }).replace(/^ms-/, '-ms-');


        Modernizr.testStyles('#modernizr{' + prop + ':' + val + ';}', function (el, rule) {
            computedStyle = window.getComputedStyle ? getComputedStyle(el, null).getPropertyValue(prop) : '';
        });

        return (computedStyle === val);
    });

    var $event = $.event,
        $special,
        resizeTimeout;

    $special = $event.special.debouncedresize = {
        setup: function () {
            $(this).on("resize", $special.handler);
        },
        teardown: function () {
            $(this).off("resize", $special.handler);
        },
        handler: function (event, execAsap) {
            // Save the context
            var context = this,
                args = arguments,
                dispatch = function () {
                    // set correct event type
                    event.type = "debouncedresize";
                    $event.dispatch.apply(context, args);
                };

            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }

            execAsap ?
                dispatch() :
                resizeTimeout = setTimeout(dispatch, $special.threshold);
        },
        threshold: 150
    };

    $.BookBlock = function (options, element) {
        this.$el = $(element);
        this._init(options);
    };

    // the options
    $.BookBlock.defaults = {
        // vertical or horizontal flip
        orientation: 'vertical',
        // ltr (left to right) or rtl (right to left)
        direction: 'ltr',
        // speed for the flip transition in ms
        speed: 800,
        // easing for the flip transition
        easing: 'ease-in-out',
        // if set to true, both the flipping page and the sides will have an overlay to simulate shadows
        shadows: true,
        // opacity value for the "shadow" on both sides (when the flipping page is over it)
        // value : 0.1 - 1
        shadowSides: 0.2,
        // opacity value for the "shadow" on the flipping page (while it is flipping)
        // value : 0.1 - 1
        shadowFlip: 0.1,
        // if we should show the first item after reaching the end
        circular: false,
        // if we want to specify a selector that triggers the next() function. example: ´#bb-nav-next´
        nextEl: '',
        // if we want to specify a selector that triggers the prev() function
        prevEl: '',
        // autoplay. If true it overwrites the circular option to true
        autoplay: false,
        // time (ms) between page switch, if autoplay is true
        interval: 3000,
        // callback after the flip transition
        // old is the index of the previous item
        // page is the current item´s index
        // isLimit is true if the current page is the last one (or the first one)
        onEndFlip: function (old, page, isLimit) {
            return false;
        },
        // callback before the flip transition
        // page is the current item´s index
        onBeforeFlip: function (page) {
            return false;
        }
    };

    $.BookBlock.prototype = {
        _init: function (options) {
            var bindingtype = localStorage.getItem('bindingtype');
            // options
            this.options = $.extend(true, {}, $.BookBlock.defaults, options);
            // orientation class
            if(bindingtype=='Top'){
                this.$el.addClass('bb-horizontal');
            }else {
                this.$el.addClass('bb-vertical');
            }
            // items
            this.$items = this.$el.children('.bb-item').hide();
            //当前item
            this.$nowItems = this.$el.children('.bb-item:eq(0)');
            this.$firstItem = this.$el.children('.bb-item:eq(0)');
            this.$secItem = this.$el.children('.bb-item:eq(1)');
            // total items
            this.itemsCount = $(".bb-item").length;
            // current item´s index
            this.current = 0;
            // previous item´s index
            this.previous = -1;
            // show first item
            this.$current = this.$items.eq(this.current).show();
            // console.log(this.$current);
            // get width of this.$el
            // this will be necessary to create the flipping layout
            this.elWidth = this.$el.width();
            var transEndEventNames = {
                'WebkitTransition': 'webkitTransitionEnd',
                'MozTransition': 'transitionend',
                'OTransition': 'oTransitionEnd',
                'msTransition': 'MSTransitionEnd',
                'transition': 'transitionend'
            };
            this.transEndEventName = transEndEventNames[Modernizr.prefixed('transition')] + '.bookblock';

            // support css 3d transforms && css transitions && Modernizr.csstransformspreserve3d
            this.support = Modernizr.csstransitions && Modernizr.csstransforms3d && Modernizr.csstransformspreserve3d;
            // initialize/bind some events
            this._initEvents();
            // start slideshow
            if (this.options.autoplay) {
                this.options.circular = true;
                this._startSlideshow();
            }
        },
        _initEvents: function () {
            var self = this;

            if (this.options.nextEl !== '') {
                $(this.options.nextEl).on('click.bookblock touchstart.bookblock', function () {
                    self._action('next');
                    return false;
                });
            }

            if (this.options.prevEl !== '') {
                $(this.options.prevEl).on('click.bookblock touchstart.bookblock', function () {
                    self._action('prev');
                    return false;
                });
            }

            $window.on('debouncedresize', function () {
                // update width value
                self.elWidth = self.$el.width();
            });

        },
        _action: function (dir, page) {
            this._stopSlideshow();
            this._navigate(dir, page);
        },
        _navigate: function (dir, page) {
            if (this.isAnimating) {
                return false;
            }

            // callback trigger
            this.options.onBeforeFlip(this.current);

            this.isAnimating = true;
            // update current value
            this.$current = this.$items.eq(this.current);
            if (page !== undefined) {
                this.current = page;
            }
            else if (dir === 'next' && this.options.direction === 'ltr' || dir === 'prev' && this.options.direction === 'rtl') {

                if (!this.options.circular && this.current === this.itemsCount - 1) {
                    this.end = true;
                }
                else {
                    this.previous = this.current;
                    this.current = this.current < this.itemsCount - 1 ? this.current + 1 : 0;
                }
            }
            else if (dir === 'prev' && this.options.direction === 'ltr' || dir === 'next' && this.options.direction === 'rtl') {
                if (!this.options.circular && this.current === 0) {
                    this.end = true;
                }
                else {
                    this.previous = this.current;
                    this.current = this.current > 0 ? this.current - 1 : this.itemsCount - 1;
                }
            }

            this.$nextItem = this.$items.eq(this.current);

            if (!this.support) {
                this._layoutNoSupport(dir);
            } else {
                this._layout(dir);
            }

        },
        _layoutNoSupport: function (dir) {
            this.$items.hide();
            this.$nextItem.show();
            this.end = false;
            this.isAnimating = false;
            var isLimit = dir === 'next' && this.current === this.itemsCount - 1 || dir === 'prev' && this.current === 0;
            // callback trigger
            this.options.onEndFlip(this.previous, this.current, isLimit);
        },
        // creates the necessary layout for the 3d structure
        _layout: function (dir) {
            this.$nowItems = this.$items.eq(this.current + 1);
            var self = this,
                // basic structure: 1 element for the left side.
                $s_left = this._addSide('left', dir),
                // 1 element for the flipping/middle page
                $s_middle = this._addSide('middle', dir),
                // 1 element for the right side
                $s_right = this._addSide('right', dir),
                // overlays
                $o_left = $s_left.find('div.bb-overlay'),
                $o_middle_f = $s_middle.find('div.bb-flipoverlay:first'),
                $o_middle_b = $s_middle.find('div.bb-flipoverlay:last'),
                $o_right = $s_right.find('div.bb-overlay'),
                speed = this.end ? 400 : this.options.speed;

            // console.log(this);
            // console.log(dir === 'next' && self.current === self.itemsCount - 1 || dir === 'prev' && self.current === 0);
            this.$items.hide();
            if (dir == 'next' && self.current !== self.itemsCount - 1) {
                // console.log(1);
                self.$current.show();
            } else if ((dir == 'next' && self.current === self.itemsCount - 1)) {        //最后一页
                // self.$current.hide();
                self.$nextItem.show();
            } else if (dir == 'prev' && self.current > 0) {
                // console.log(3);
                self.$nowItems.show();
            } else if (dir == 'prev' && self.current === 0) {         //第一页
                // console.log(4);
                self.$nowItems.show();
            }


            localStorage.setItem('pageI',self.current);
            this.$el.prepend($s_left, $s_middle, $s_right);
            var bindingtype = localStorage.getItem('bindingtype');
            if($(".bb-item").length>=2){
                $(".bb-item:eq(1)").removeClass('bb-white').find('.slide1').addClass('opacity-zero');
            }

            if(this.current == 0&&dir=='prev'||(this.current == 1&&dir=='next')&& bindingtype== 'Top'){
                $(".bb-item:eq(1)").addClass('opacity-zero');
            }else{
                $(".bb-item:eq(1)").removeClass('opacity-zero');
            }
            $s_middle.css({
                transitionDuration: speed + 'ms',
                transitionTimingFunction: this.options.easing
            }).on(this.transEndEventName, function (event) {
                if ($(event.target).hasClass('bb-page')) {
                    self.$el.children('.bb-page').remove();
                    if($(".bb-item").length>=2&&bindingtype=='Top'){
                        $(".bb-item:eq(1)").addClass('bb-white').removeClass('opacity-zero').find('.slide1').removeClass('opacity-zero');
                    }else if($(".bb-item").length>=2&&bindingtype=='Left'){
                        $(".bb-item:eq(1)").addClass('bb-white').removeClass('opacity-zero').find('.slide1').removeClass('opacity-zero');
                    }

                    self.$nextItem.show();
                    if (dir == 'prev') {
                        self.$nowItems.hide();
                    }
                    if (dir == 'next' && self.current !== self.itemsCount - 1) {
                        self.$current.hide();
                    }
                    self.end = false;
                    self.isAnimating = false;
                    var isLimit = dir === 'next' && self.current === self.itemsCount - 1 || dir === 'prev' && self.current === 0;
                    // callback trigger
                    self.options.onEndFlip(self.previous, self.current, isLimit);
                }
            });

            if (dir === 'prev') {
                $s_middle.addClass('bb-flip-initial');
            }

            // overlays
            if (this.options.shadows && !this.end) {

                var o_left_style = (dir === 'next') ? {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms'
                        } : {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-ms-filter': 'alpha(opacity='+this.options.shadowSides*100+')',
                            filter:'alpha(opacity='+this.options.shadowSides*100+')',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            opacity: this.options.shadowSides
                        },
                    o_middle_f_style = (dir === 'next') ? {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear'
                        } : {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-ms-filter': 'alpha(opacity='+this.options.shadowFlip*100+')',
                            filter:'alpha(opacity='+this.options.shadowFlip*100+')',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            opacity: this.options.shadowFlip
                        },
                    o_middle_b_style = (dir === 'next') ? {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-ms-filter': 'alpha(opacity='+this.options.shadowFlip*100+')',
                            filter:'alpha(opacity='+this.options.shadowFlip*100+')',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            opacity: this.options.shadowFlip
                        } : {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear'
                        },
                    o_right_style = (dir === 'next') ? {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            '-ms-filter': 'alpha(opacity='+this.options.shadowSides*100+')',
                            filter:'alpha(opacity='+this.options.shadowSides*100+')',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                            opacity: this.options.shadowSides
                        } : {
                            '-webkit-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-moz-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            '-o-transition': 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                            transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms'
                        };

                $o_middle_f.css(o_middle_f_style);
                $o_middle_b.css(o_middle_b_style);
                $o_left.css(o_left_style);
                $o_right.css(o_right_style);

            }

            setTimeout(function () {
                // first && last pages lift slightly up when we can't go further
                $s_middle.addClass(self.end ? 'bb-flip-' + dir + '-end' : 'bb-flip-' + dir);

                // overlays
                if (self.options.shadows && !self.end) {

                    $o_middle_f.css({
                        opacity: dir === 'next' ? self.options.shadowFlip : 0,
                        '-ms-filter': 'alpha(opacity='+dir === 'next' ? self.options.shadowFlip*100 : 0+')',
                        filter: 'alpha(opacity='+dir === 'next' ? self.options.shadowFlip*100 : 0+')'
                    });

                    $o_middle_b.css({
                        opacity: dir === 'next' ? 0 : self.options.shadowFlip,
                        '-ms-filter': 'alpha(opacity='+dir === 'next' ? 0 : self.options.shadowFlip*100+')',
                        filter: 'alpha(opacity='+dir === 'next' ? 0 : self.options.shadowFlip*100+')'
                    });

                    $o_left.css({
                        opacity: dir === 'next' ? self.options.shadowSides : 0,
                        '-ms-filter': 'alpha(opacity='+dir === 'next' ? self.options.shadowSides*100 : 0+')',
                        filter: 'alpha(opacity='+dir === 'next' ? self.options.shadowSides*100 : 0+')'
                    });

                    $o_right.css({
                        opacity: dir === 'next' ? 0 : self.options.shadowSides,
                        '-ms-filter': 'alpha(opacity='+dir === 'next' ? 0 : self.options.shadowSides*100+')',
                        filter: 'alpha(opacity='+dir === 'next' ? 0 : self.options.shadowSides*100+')'
                    });

                }
            }, 25);
        },
        // adds the necessary sides (bb-page) to the layout
        _addSide: function (side, dir) {
            var $side;
            var pageL = '', pageR = '', pageF = '';
            var mar = 0;
            var bindingtype = localStorage.getItem('bindingtype');
            if (dir == 'next' && this.current == 1) {
                mar = this.$firstItem.width();
                pageL = this.$firstItem.html();
                // pageF = bindingtype == 'Top' ? "" : $(".show-flag").html();
            } else if (dir == 'next' && this.current > 1) {
                mar = 0;
                pageL = this.$current.html();
                pageF = this.$current.html();
            } else if (dir == 'prev' && this.current == 0) {
                mar = this.$firstItem.width();
                // pageR = bindingtype == 'Top' ? "" : $(".show-flag").html();
            } else if (dir == 'prev' && this.current != 0) {
                mar = 0;
                pageR = this.$nextItem.html();
            }
            if (!((dir == 'next' && this.current == this.itemsCount - 1) || (dir == 'prev' && this.current == this.itemsCount - 2))) {
                // $(".bb-content").css({background: '#fff!important'});
            }

            // console.log(dir);
            // console.log(this);
            // console.log(this.current);
            if (bindingtype == 'Top') {
                mar = 0;
            }

            if(this.current == 0&&dir=='prev'&&bindingtype == 'Top'){
                $(".bb-item").addClass('lar-noShadow');
            }else{
                $(".bb-item").removeClass('lar-noShadow');
            }
            if(dir == 'next' && this.current == this.itemsCount - 1&&bindingtype == 'Top'){
                // console.log("aaaaa");
                $(".bb-item").addClass('uad-noShadow');
            }else {
                $(".bb-item").removeClass('uad-noShadow');
            }
            switch (side) {
                case 'left':
                    /*
                     <div class="bb-page" style="z-index:102;">
                     <div class="bb-back">
                     <div class="bb-outer">
                     <div class="bb-content">
                     <div class="bb-inner">
                     dir==='next' ? [content of current page] : [content of next page]
                     </div>
                     </div>
                     <div class="bb-overlay"></div>
                     </div>
                     </div>
                     </div>
                     */
                    if (this.current == 1&&dir=='next'||(this.current == 0&&dir=='prev')) {
                        $side = $('<div class="bb-page opacity-zero"><div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'
                            + '</div></div><div class="bb-overlay"></div></div></div></div>').css({'z-index': 997});
                    } else {
                        $side = $('<div class="bb-page"><div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'
                            + ( dir === 'next' ? pageF : pageR )
                            + '</div></div><div class="bb-overlay"></div></div></div></div>').css({'z-index': 997});
                    }

                    break;
                case 'middle':
                    /*
                     <div class="bb-page" style="z-index:103;">
                     <div class="bb-front">
                     <div class="bb-outer">
                     <div class="bb-content">
                     <div class="bb-inner">
                     dir==='next' ? [content of current page] : [content of next page]
                     </div>
                     </div>
                     <div class="bb-flipoverlay"></div>
                     </div>
                     </div>
                     <div class="bb-back">
                     <div class="bb-outer">
                     <div class="bb-content">
                     <div class="bb-inner">
                     dir==='next' ? [content of next page] : [content of current page]
                     </div>
                     </div>
                     <div class="bb-flipoverlay"></div>
                     </div>
                     </div>
                     </div>
                     */
                    $side = $('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner" style="margin-left:' + mar + 'px">'
                        + (dir === 'next' ? pageL : this.$nextItem.html())
                        + '</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:'
                        + this.elWidth + 'px"><div class="bb-inner">' + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() )
                        + '</div></div><div class="bb-flipoverlay"></div></div></div></div>').css({'z-index': 998});
                    break;
                case 'right':
                    /*
                     <div class="bb-page" style="z-index:101;">
                     <div class="bb-front">
                     <div class="bb-outer">
                     <div class="bb-content">
                     <div class="bb-inner">
                     dir==='next' ? [content of next page] : [content of current page]
                     </div>
                     </div>
                     <div class="bb-overlay"></div>
                     </div>
                     </div>
                     </div>
                     */
                    if (this.current == this.$items.length-1||(this.previous == this.$items.length-1&&dir=='prev')){
                        $side = $('<div class="bb-page opacity-zero"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'
                            + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() )
                            + '</div></div><div class="bb-overlay"></div></div></div></div>').css({'z-index': 996});
                    }else {
                        $side = $('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'
                            + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() )
                            + '</div></div><div class="bb-overlay"></div></div></div></div>').css({'z-index': 996});
                    }
                    break;
            }

            return $side;
        },
        _startSlideshow: function () {
            var self = this;
            this.slideshow = setTimeout(function () {
                self._navigate('next');
                if (self.options.autoplay) {
                    self._startSlideshow();
                }
            }, this.options.interval);
        },
        _stopSlideshow: function () {
            if (this.options.autoplay) {
                clearTimeout(this.slideshow);
                this.options.autoplay = false;
            }
        },
        // public method: flips next
        next: function () {
            this._action(this.options.direction === 'ltr' ? 'next' : 'prev');
        },
        // public method: flips back
        prev: function () {
            this._action(this.options.direction === 'ltr' ? 'prev' : 'next');
        },
        // public method: goes to a specific page
        jump: function (page) {

            page -= 1;

            if (page === this.current || page >= this.itemsCount || page < 0) {
                return false;
            }

            var dir;
            if (this.options.direction === 'ltr') {
                dir = page > this.current ? 'next' : 'prev';
            }
            else {
                dir = page > this.current ? 'prev' : 'next';
            }
            this._action(dir, page);

        },
        // public method: goes to the last page
        last: function () {
            this.jump(this.itemsCount);
        },
        // public method: goes to the first page
        first: function () {
            this.jump(1);
        },
        // public method: check if isAnimating is true
        isActive: function () {
            return this.isAnimating;
        },
        // public method: dynamically adds new elements
        // call this method after inserting new "bb-item" elements inside the BookBlock
        update: function () {
            var $currentItem = this.$items.eq(this.current);
            this.$items = this.$el.children('.bb-item');
            this.itemsCount = this.$items.length;
            this.current = $currentItem.index();
        },
        destroy: function () {
            if (this.options.autoplay) {
                this._stopSlideshow();
            }
            this.$el.removeClass('bb-' + this.options.orientation);
            this.$items.show();

            if (this.options.nextEl !== '') {
                $(this.options.nextEl).off('.bookblock');
            }

            if (this.options.prevEl !== '') {
                $(this.options.prevEl).off('.bookblock');
            }

            $window.off('debouncedresize');
        }
    };

    var logError = function (message) {
        if (window.console) {
            window.console.error(message);
        }
    };

    $.fn.bookblock = function (options) {
        if (typeof options === 'string') {
            var args = Array.prototype.slice.call(arguments, 1);
            this.each(function () {
                var instance = $.data(this, 'bookblock');
                if (!instance) {
                    logError("cannot call methods on bookblock prior to initialization; " +
                        "attempted to call method '" + options + "'");
                    return;
                }
                if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
                    logError("no such method '" + options + "' for bookblock instance");
                    return;
                }
                instance[options].apply(instance, args);
            });
        }
        else {
            this.each(function () {
                var instance = $.data(this, 'bookblock');
                if (instance) {
                    instance._init();
                }
                else {
                    instance = $.data(this, 'bookblock', new $.BookBlock(options, this));
                }
            });
        }
        return this;
    };

})(jQuery, window);

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '第 {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    '条，共 {{$ctrl.queryCount}} 条' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('backApp')
        .component('jhiItemCount', jhiItemCount);
})();

/**
 * Created by rae on 3/26/2018.
 */
window.angular.module('image.service', []).
factory('ImageService', ['$location', '$http', '$timeout', '$rootScope', '$state',
    function ($location, $http, $timeout, $rootScope, $state) {

        /**
         * png,jpg等图片格式转base64
         * @param url
         * @param callback
         * @param outputFormat
         */
        this.convertImgToBase64 = function (url, callback, outputFormat) {
            var canvas = document.createElement('CANVAS'),
                ctx = canvas.getContext('2d'),
                img = new Image;
            img.crossOrigin = 'Anonymous';
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.imageSmoothingEnabled = true;
                ctx.mozImageSmoothingEnabled = true;
                ctx.webkitImageSmoothingEnabled = true;
                ctx.msImageSmoothingEnabled = true;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL(outputFormat || 'image/png');
                // callback.call(this, dataURL);
                callback.call(this, dataURLtoBlobs(dataURL));
                canvas = null;
            };
            img.src = url;
        };

        /**
         * base64转Blob
         * @param dataurl
         * @returns {*}
         */
        this.dataURLtoBlob=function(dataurl) {
            return dataURLtoBlobs(dataurl);
        };
        function dataURLtoBlobs(dataurl) {
            var arr = dataurl.split(','),
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var createObjectURL = function (blob) {
                return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
            };
            var fileURL = URL.createObjectURL(new Blob([u8arr], {type: 'image/*'}));
            return fileURL;
        }

        return this;

    }]);

(function(){
    'user strict';
    angular.module('backApp')
    .directive('fileread', fileread);

    function fileread() {
        var directive = {
            restrict: 'A',
            scope: false,
            link: linkFunc
        };
        return directive;
        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind("change", function(changeEvent) {
                scope.$parent.upLoading = true;
                scope.uploadFile(changeEvent.target.files[0], changeEvent.target.id);
            });
        }
    }
})();



/**
 * @author alteredq / http://alteredqualia.com/
 * @author mr.doob / http://mrdoob.com/
 */

var Detector = {

  canvas: !! window.CanvasRenderingContext2D,
  webgl: ( function () {

    try {

      var canvas = document.createElement( 'canvas' ); return !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );

    } catch ( e ) {

      return false;

    }

  } )(),
  workers: !! window.Worker,
  fileapi: window.File && window.FileReader && window.FileList && window.Blob,

  getWebGLErrorMessage: function () {

    var element = document.createElement( 'div' );
    element.id = 'webgl-error-message';
    element.style.fontFamily = 'monospace';
    element.style.fontSize = '13px';
    element.style.fontWeight = 'normal';
    element.style.textAlign = 'center';
    element.style.background = '#fff';
    element.style.color = '#000';
    element.style.padding = '1.5em';
    element.style.width = '400px';
    element.style.margin = '5em auto 0';

    if ( ! this.webgl ) {

      element.innerHTML = window.WebGLRenderingContext ? [
        'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />',
        'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join( '\n' ) : [
        'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>',
        'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join( '\n' );

    }

    return element;

  },

  addGetWebGLMessage: function ( parameters ) {

    var parent, id, element;

    parameters = parameters || {};

    parent = parameters.parent !== undefined ? parameters.parent : document.body;
    id = parameters.id !== undefined ? parameters.id : 'oldie';

    element = Detector.getWebGLErrorMessage();
    element.id = id;

    parent.appendChild( element );

  }

};

// browserify support
if ( typeof module === 'object' ) {

  module.exports = Detector;

}

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

/**
 * dat-gui JavaScript Controller Library
 * https://github.com/dataarts/dat.gui
 *
 * Copyright 2016 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */
!function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.dat = t() : e.dat = t()
}(this, function() {
    return function(e) {
        function t(o) {
            if (n[o])
                return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t),
                i.loaded = !0,
                i.exports
        }
        var n = {};
        return t.m = e,
            t.c = n,
            t.p = "",
            t(0)
    }([function(e, t, n) {
        "use strict";
        function o(e) {
            return e && e.__esModule ? e : {
                "default": e
            }
        }
        var i = n(1)
            , r = o(i);
        e.exports = r["default"]
    }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(2)
                , r = o(i)
                , a = n(6)
                , l = o(a)
                , s = n(3)
                , u = o(s)
                , d = n(7)
                , c = o(d)
                , f = n(8)
                , _ = o(f)
                , p = n(10)
                , h = o(p)
                , m = n(11)
                , b = o(m)
                , g = n(12)
                , v = o(g)
                , y = n(13)
                , w = o(y)
                , x = n(14)
                , E = o(x)
                , C = n(15)
                , A = o(C)
                , S = n(16)
                , k = o(S)
                , O = n(9)
                , T = o(O)
                , R = n(17)
                , L = o(R);
            t["default"] = {
                color: {
                    Color: r["default"],
                    math: l["default"],
                    interpret: u["default"]
                },
                controllers: {
                    Controller: c["default"],
                    BooleanController: _["default"],
                    OptionController: h["default"],
                    StringController: b["default"],
                    NumberController: v["default"],
                    NumberControllerBox: w["default"],
                    NumberControllerSlider: E["default"],
                    FunctionController: A["default"],
                    ColorController: k["default"]
                },
                dom: {
                    dom: T["default"]
                },
                gui: {
                    GUI: L["default"]
                },
                GUI: L["default"]
            }
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t, n) {
                Object.defineProperty(e, t, {
                    get: function() {
                        return "RGB" === this.__state.space ? this.__state[t] : (h.recalculateRGB(this, t, n),
                            this.__state[t])
                    },
                    set: function(e) {
                        "RGB" !== this.__state.space && (h.recalculateRGB(this, t, n),
                            this.__state.space = "RGB"),
                            this.__state[t] = e
                    }
                })
            }
            function a(e, t) {
                Object.defineProperty(e, t, {
                    get: function() {
                        return "HSV" === this.__state.space ? this.__state[t] : (h.recalculateHSV(this),
                            this.__state[t])
                    },
                    set: function(e) {
                        "HSV" !== this.__state.space && (h.recalculateHSV(this),
                            this.__state.space = "HSV"),
                            this.__state[t] = e
                    }
                })
            }
            t.__esModule = !0;
            var l = n(3)
                , s = o(l)
                , u = n(6)
                , d = o(u)
                , c = n(4)
                , f = o(c)
                , _ = n(5)
                , p = o(_)
                , h = function() {
                function e() {
                    if (i(this, e),
                        this.__state = s["default"].apply(this, arguments),
                    this.__state === !1)
                        throw new Error("Failed to interpret color arguments");
                    this.__state.a = this.__state.a || 1
                }
                return e.prototype.toString = function() {
                    return (0,
                        f["default"])(this)
                }
                    ,
                    e.prototype.toHexString = function() {
                        return (0,
                            f["default"])(this, !0)
                    }
                    ,
                    e.prototype.toOriginal = function() {
                        return this.__state.conversion.write(this)
                    }
                    ,
                    e
            }();
            h.recalculateRGB = function(e, t, n) {
                if ("HEX" === e.__state.space)
                    e.__state[t] = d["default"].component_from_hex(e.__state.hex, n);
                else {
                    if ("HSV" !== e.__state.space)
                        throw new Error("Corrupted color state");
                    p["default"].extend(e.__state, d["default"].hsv_to_rgb(e.__state.h, e.__state.s, e.__state.v))
                }
            }
                ,
                h.recalculateHSV = function(e) {
                    var t = d["default"].rgb_to_hsv(e.r, e.g, e.b);
                    p["default"].extend(e.__state, {
                        s: t.s,
                        v: t.v
                    }),
                        p["default"].isNaN(t.h) ? p["default"].isUndefined(e.__state.h) && (e.__state.h = 0) : e.__state.h = t.h
                }
                ,
                h.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"],
                r(h.prototype, "r", 2),
                r(h.prototype, "g", 1),
                r(h.prototype, "b", 0),
                a(h.prototype, "h"),
                a(h.prototype, "s"),
                a(h.prototype, "v"),
                Object.defineProperty(h.prototype, "a", {
                    get: function() {
                        return this.__state.a
                    },
                    set: function(e) {
                        this.__state.a = e
                    }
                }),
                Object.defineProperty(h.prototype, "hex", {
                    get: function() {
                        return "HEX" !== !this.__state.space && (this.__state.hex = d["default"].rgb_to_hex(this.r, this.g, this.b)),
                            this.__state.hex
                    },
                    set: function(e) {
                        this.__state.space = "HEX",
                            this.__state.hex = e
                    }
                }),
                t["default"] = h
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(4)
                , r = o(i)
                , a = n(5)
                , l = o(a)
                , s = [{
                litmus: l["default"].isString,
                conversions: {
                    THREE_CHAR_HEX: {
                        read: function(e) {
                            var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
                            return null !== t && {
                                space: "HEX",
                                hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
                            }
                        },
                        write: r["default"]
                    },
                    SIX_CHAR_HEX: {
                        read: function(e) {
                            var t = e.match(/^#([A-F0-9]{6})$/i);
                            return null !== t && {
                                space: "HEX",
                                hex: parseInt("0x" + t[1].toString(), 0)
                            }
                        },
                        write: r["default"]
                    },
                    CSS_RGB: {
                        read: function(e) {
                            var t = e.match(/^rgb\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
                            return null !== t && {
                                space: "RGB",
                                r: parseFloat(t[1]),
                                g: parseFloat(t[2]),
                                b: parseFloat(t[3])
                            }
                        },
                        write: r["default"]
                    },
                    CSS_RGBA: {
                        read: function(e) {
                            var t = e.match(/^rgba\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
                            return null !== t && {
                                space: "RGB",
                                r: parseFloat(t[1]),
                                g: parseFloat(t[2]),
                                b: parseFloat(t[3]),
                                a: parseFloat(t[4])
                            }
                        },
                        write: r["default"]
                    }
                }
            }, {
                litmus: l["default"].isNumber,
                conversions: {
                    HEX: {
                        read: function(e) {
                            return {
                                space: "HEX",
                                hex: e,
                                conversionName: "HEX"
                            }
                        },
                        write: function(e) {
                            return e.hex
                        }
                    }
                }
            }, {
                litmus: l["default"].isArray,
                conversions: {
                    RGB_ARRAY: {
                        read: function(e) {
                            return 3 === e.length && {
                                space: "RGB",
                                r: e[0],
                                g: e[1],
                                b: e[2]
                            }
                        },
                        write: function(e) {
                            return [e.r, e.g, e.b]
                        }
                    },
                    RGBA_ARRAY: {
                        read: function(e) {
                            return 4 === e.length && {
                                space: "RGB",
                                r: e[0],
                                g: e[1],
                                b: e[2],
                                a: e[3]
                            }
                        },
                        write: function(e) {
                            return [e.r, e.g, e.b, e.a]
                        }
                    }
                }
            }, {
                litmus: l["default"].isObject,
                conversions: {
                    RGBA_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.r) && l["default"].isNumber(e.g) && l["default"].isNumber(e.b) && l["default"].isNumber(e.a)) && {
                                space: "RGB",
                                r: e.r,
                                g: e.g,
                                b: e.b,
                                a: e.a
                            }
                        },
                        write: function(e) {
                            return {
                                r: e.r,
                                g: e.g,
                                b: e.b,
                                a: e.a
                            }
                        }
                    },
                    RGB_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.r) && l["default"].isNumber(e.g) && l["default"].isNumber(e.b)) && {
                                space: "RGB",
                                r: e.r,
                                g: e.g,
                                b: e.b
                            }
                        },
                        write: function(e) {
                            return {
                                r: e.r,
                                g: e.g,
                                b: e.b
                            }
                        }
                    },
                    HSVA_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.h) && l["default"].isNumber(e.s) && l["default"].isNumber(e.v) && l["default"].isNumber(e.a)) && {
                                space: "HSV",
                                h: e.h,
                                s: e.s,
                                v: e.v,
                                a: e.a
                            }
                        },
                        write: function(e) {
                            return {
                                h: e.h,
                                s: e.s,
                                v: e.v,
                                a: e.a
                            }
                        }
                    },
                    HSV_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.h) && l["default"].isNumber(e.s) && l["default"].isNumber(e.v)) && {
                                space: "HSV",
                                h: e.h,
                                s: e.s,
                                v: e.v
                            }
                        },
                        write: function(e) {
                            return {
                                h: e.h,
                                s: e.s,
                                v: e.v
                            }
                        }
                    }
                }
            }]
                , u = void 0
                , d = void 0
                , c = function() {
                d = !1;
                var e = arguments.length > 1 ? l["default"].toArray(arguments) : arguments[0];
                return l["default"].each(s, function(t) {
                    if (t.litmus(e))
                        return l["default"].each(t.conversions, function(t, n) {
                            if (u = t.read(e),
                            d === !1 && u !== !1)
                                return d = u,
                                    u.conversionName = n,
                                    u.conversion = t,
                                    l["default"].BREAK
                        }),
                            l["default"].BREAK
                }),
                    d
            };
            t["default"] = c
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0,
                t["default"] = function(e, t) {
                    var n = e.__state.conversionName.toString()
                        , o = Math.round(e.r)
                        , i = Math.round(e.g)
                        , r = Math.round(e.b)
                        , a = e.a
                        , l = Math.round(e.h)
                        , s = e.s.toFixed(1)
                        , u = e.v.toFixed(1);
                    if (t || "THREE_CHAR_HEX" === n || "SIX_CHAR_HEX" === n) {
                        for (var d = e.hex.toString(16); d.length < 6; )
                            d = "0" + d;
                        return "#" + d
                    }
                    return "CSS_RGB" === n ? "rgb(" + o + "," + i + "," + r + ")" : "CSS_RGBA" === n ? "rgba(" + o + "," + i + "," + r + "," + a + ")" : "HEX" === n ? "0x" + e.hex.toString(16) : "RGB_ARRAY" === n ? "[" + o + "," + i + "," + r + "]" : "RGBA_ARRAY" === n ? "[" + o + "," + i + "," + r + "," + a + "]" : "RGB_OBJ" === n ? "{r:" + o + ",g:" + i + ",b:" + r + "}" : "RGBA_OBJ" === n ? "{r:" + o + ",g:" + i + ",b:" + r + ",a:" + a + "}" : "HSV_OBJ" === n ? "{h:" + l + ",s:" + s + ",v:" + u + "}" : "HSVA_OBJ" === n ? "{h:" + l + ",s:" + s + ",v:" + u + ",a:" + a + "}" : "unknown format"
                }
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0;
            var n = Array.prototype.forEach
                , o = Array.prototype.slice
                , i = {
                BREAK: {},
                extend: function(e) {
                    return this.each(o.call(arguments, 1), function(t) {
                        var n = this.isObject(t) ? Object.keys(t) : [];
                        n.forEach(function(n) {
                            this.isUndefined(t[n]) || (e[n] = t[n])
                        }
                            .bind(this))
                    }, this),
                        e
                },
                defaults: function(e) {
                    return this.each(o.call(arguments, 1), function(t) {
                        var n = this.isObject(t) ? Object.keys(t) : [];
                        n.forEach(function(n) {
                            this.isUndefined(e[n]) && (e[n] = t[n])
                        }
                            .bind(this))
                    }, this),
                        e
                },
                compose: function() {
                    var e = o.call(arguments);
                    return function() {
                        for (var t = o.call(arguments), n = e.length - 1; n >= 0; n--)
                            t = [e[n].apply(this, t)];
                        return t[0]
                    }
                },
                each: function(e, t, o) {
                    if (e)
                        if (n && e.forEach && e.forEach === n)
                            e.forEach(t, o);
                        else if (e.length === e.length + 0) {
                            var i = void 0
                                , r = void 0;
                            for (i = 0,
                                     r = e.length; i < r; i++)
                                if (i in e && t.call(o, e[i], i) === this.BREAK)
                                    return
                        } else
                            for (var a in e)
                                if (t.call(o, e[a], a) === this.BREAK)
                                    return
                },
                defer: function(e) {
                    setTimeout(e, 0)
                },
                debounce: function(e, t) {
                    var n = void 0;
                    return function() {
                        function o() {
                            n = null
                        }
                        var i = this
                            , r = arguments
                            , a = !n;
                        clearTimeout(n),
                            n = setTimeout(o, t),
                        a && e.apply(i, r)
                    }
                },
                toArray: function(e) {
                    return e.toArray ? e.toArray() : o.call(e)
                },
                isUndefined: function(e) {
                    return void 0 === e
                },
                isNull: function(e) {
                    return null === e
                },
                isNaN: function(e) {
                    function t(t) {
                        return e.apply(this, arguments)
                    }
                    return t.toString = function() {
                        return e.toString()
                    }
                        ,
                        t
                }(function(e) {
                    return isNaN(e)
                }),
                isArray: Array.isArray || function(e) {
                    return e.constructor === Array
                }
                ,
                isObject: function(e) {
                    return e === Object(e)
                },
                isNumber: function(e) {
                    return e === e + 0
                },
                isString: function(e) {
                    return e === e + ""
                },
                isBoolean: function(e) {
                    return e === !1 || e === !0
                },
                isFunction: function(e) {
                    return "[object Function]" === Object.prototype.toString.call(e)
                }
            };
            t["default"] = i
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0;
            var n = void 0
                , o = {
                hsv_to_rgb: function(e, t, n) {
                    var o = Math.floor(e / 60) % 6
                        , i = e / 60 - Math.floor(e / 60)
                        , r = n * (1 - t)
                        , a = n * (1 - i * t)
                        , l = n * (1 - (1 - i) * t)
                        , s = [[n, l, r], [a, n, r], [r, n, l], [r, a, n], [l, r, n], [n, r, a]][o];
                    return {
                        r: 255 * s[0],
                        g: 255 * s[1],
                        b: 255 * s[2]
                    }
                },
                rgb_to_hsv: function(e, t, n) {
                    var o = Math.min(e, t, n)
                        , i = Math.max(e, t, n)
                        , r = i - o
                        , a = void 0
                        , l = void 0;
                    return 0 === i ? {
                        h: NaN,
                        s: 0,
                        v: 0
                    } : (l = r / i,
                        a = e === i ? (t - n) / r : t === i ? 2 + (n - e) / r : 4 + (e - t) / r,
                        a /= 6,
                    a < 0 && (a += 1),
                        {
                            h: 360 * a,
                            s: l,
                            v: i / 255
                        })
                },
                rgb_to_hex: function(e, t, n) {
                    var o = this.hex_with_component(0, 2, e);
                    return o = this.hex_with_component(o, 1, t),
                        o = this.hex_with_component(o, 0, n)
                },
                component_from_hex: function(e, t) {
                    return e >> 8 * t & 255
                },
                hex_with_component: function(e, t, o) {
                    return o << (n = 8 * t) | e & ~(255 << n)
                }
            };
            t["default"] = o
        }
        , function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            t.__esModule = !0;
            var o = function() {
                function e(t, o) {
                    n(this, e),
                        this.initialValue = t[o],
                        this.domElement = document.createElement("div"),
                        this.object = t,
                        this.property = o,
                        this.__onChange = void 0,
                        this.__onFinishChange = void 0
                }
                return e.prototype.onChange = function(e) {
                    return this.__onChange = e,
                        this
                }
                    ,
                    e.prototype.onFinishChange = function(e) {
                        return this.__onFinishChange = e,
                            this
                    }
                    ,
                    e.prototype.setValue = function(e) {
                        return this.object[this.property] = e,
                        this.__onChange && this.__onChange.call(this, e),
                            this.updateDisplay(),
                            this
                    }
                    ,
                    e.prototype.getValue = function() {
                        return this.object[this.property]
                    }
                    ,
                    e.prototype.updateDisplay = function() {
                        return this
                    }
                    ,
                    e.prototype.isModified = function() {
                        return this.initialValue !== this.getValue()
                    }
                    ,
                    e
            }();
            t["default"] = o
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o) {
                    function a() {
                        s.setValue(!s.__prev)
                    }
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = l;
                    return l.__prev = l.getValue(),
                        l.__checkbox = document.createElement("input"),
                        l.__checkbox.setAttribute("type", "checkbox"),
                        d["default"].bind(l.__checkbox, "change", a, !1),
                        l.domElement.appendChild(l.__checkbox),
                        l.updateDisplay(),
                        l
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = e.prototype.setValue.call(this, t);
                        return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()),
                            this.__prev = this.getValue(),
                            n
                    }
                    ,
                    t.prototype.updateDisplay = function() {
                        return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"),
                            this.__checkbox.checked = !0) : this.__checkbox.checked = !1,
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e) {
                if ("0" === e || a["default"].isUndefined(e))
                    return 0;
                var t = e.match(u);
                return a["default"].isNull(t) ? 0 : parseFloat(t[1])
            }
            t.__esModule = !0;
            var r = n(5)
                , a = o(r)
                , l = {
                HTMLEvents: ["change"],
                MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
                KeyboardEvents: ["keydown"]
            }
                , s = {};
            a["default"].each(l, function(e, t) {
                a["default"].each(e, function(e) {
                    s[e] = t
                })
            });
            var u = /(\d+(\.\d+)?)px/
                , d = {
                makeSelectable: function(e, t) {
                    void 0 !== e && void 0 !== e.style && (e.onselectstart = t ? function() {
                            return !1
                        }
                        : function() {}
                        ,
                        e.style.MozUserSelect = t ? "auto" : "none",
                        e.style.KhtmlUserSelect = t ? "auto" : "none",
                        e.unselectable = t ? "on" : "off")
                },
                makeFullscreen: function(e, t, n) {
                    var o = n
                        , i = t;
                    a["default"].isUndefined(i) && (i = !0),
                    a["default"].isUndefined(o) && (o = !0),
                        e.style.position = "absolute",
                    i && (e.style.left = 0,
                        e.style.right = 0),
                    o && (e.style.top = 0,
                        e.style.bottom = 0)
                },
                fakeEvent: function(e, t, n, o) {
                    var i = n || {}
                        , r = s[t];
                    if (!r)
                        throw new Error("Event type " + t + " not supported.");
                    var l = document.createEvent(r);
                    switch (r) {
                        case "MouseEvents":
                            var u = i.x || i.clientX || 0
                                , d = i.y || i.clientY || 0;
                            l.initMouseEvent(t, i.bubbles || !1, i.cancelable || !0, window, i.clickCount || 1, 0, 0, u, d, !1, !1, !1, !1, 0, null);
                            break;
                        case "KeyboardEvents":
                            var c = l.initKeyboardEvent || l.initKeyEvent;
                            a["default"].defaults(i, {
                                cancelable: !0,
                                ctrlKey: !1,
                                altKey: !1,
                                shiftKey: !1,
                                metaKey: !1,
                                keyCode: void 0,
                                charCode: void 0
                            }),
                                c(t, i.bubbles || !1, i.cancelable, window, i.ctrlKey, i.altKey, i.shiftKey, i.metaKey, i.keyCode, i.charCode);
                            break;
                        default:
                            l.initEvent(t, i.bubbles || !1, i.cancelable || !0)
                    }
                    a["default"].defaults(l, o),
                        e.dispatchEvent(l)
                },
                bind: function(e, t, n, o) {
                    var i = o || !1;
                    return e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent && e.attachEvent("on" + t, n),
                        d
                },
                unbind: function(e, t, n, o) {
                    var i = o || !1;
                    return e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent && e.detachEvent("on" + t, n),
                        d
                },
                addClass: function(e, t) {
                    if (void 0 === e.className)
                        e.className = t;
                    else if (e.className !== t) {
                        var n = e.className.split(/ +/);
                        n.indexOf(t) === -1 && (n.push(t),
                            e.className = n.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""))
                    }
                    return d
                },
                removeClass: function(e, t) {
                    if (t)
                        if (e.className === t)
                            e.removeAttribute("class");
                        else {
                            var n = e.className.split(/ +/)
                                , o = n.indexOf(t);
                            o !== -1 && (n.splice(o, 1),
                                e.className = n.join(" "))
                        }
                    else
                        e.className = void 0;
                    return d
                },
                hasClass: function(e, t) {
                    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1
                },
                getWidth: function(e) {
                    var t = getComputedStyle(e);
                    return i(t["border-left-width"]) + i(t["border-right-width"]) + i(t["padding-left"]) + i(t["padding-right"]) + i(t.width)
                },
                getHeight: function(e) {
                    var t = getComputedStyle(e);
                    return i(t["border-top-width"]) + i(t["border-bottom-width"]) + i(t["padding-top"]) + i(t["padding-bottom"]) + i(t.height)
                },
                getOffset: function(e) {
                    var t = e
                        , n = {
                        left: 0,
                        top: 0
                    };
                    if (t.offsetParent)
                        do
                            n.left += t.offsetLeft,
                                n.top += t.offsetTop,
                                t = t.offsetParent;
                        while (t);return n
                },
                isActive: function(e) {
                    return e === document.activeElement && (e.type || e.href)
                }
            };
            t["default"] = d
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = n(5)
                , f = o(c)
                , _ = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = a
                        , u = l;
                    return l.__select = document.createElement("select"),
                    f["default"].isArray(s) && !function() {
                        var e = {};
                        f["default"].each(s, function(t) {
                            e[t] = t
                        }),
                            s = e
                    }(),
                        f["default"].each(s, function(e, t) {
                            var n = document.createElement("option");
                            n.innerHTML = t,
                                n.setAttribute("value", e),
                                u.__select.appendChild(n)
                        }),
                        l.updateDisplay(),
                        d["default"].bind(l.__select, "change", function() {
                            var e = this.options[this.selectedIndex].value;
                            u.setValue(e)
                        }),
                        l.domElement.appendChild(l.__select),
                        l
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = e.prototype.setValue.call(this, t);
                        return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()),
                            n
                    }
                    ,
                    t.prototype.updateDisplay = function() {
                        return d["default"].isActive(this.__select) ? this : (this.__select.value = this.getValue(),
                            e.prototype.updateDisplay.call(this))
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = _
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o) {
                    function a() {
                        u.setValue(u.__input.value)
                    }
                    function l() {
                        u.__onFinishChange && u.__onFinishChange.call(u, u.getValue())
                    }
                    i(this, t);
                    var s = r(this, e.call(this, n, o))
                        , u = s;
                    return s.__input = document.createElement("input"),
                        s.__input.setAttribute("type", "text"),
                        d["default"].bind(s.__input, "keyup", a),
                        d["default"].bind(s.__input, "change", a),
                        d["default"].bind(s.__input, "blur", l),
                        d["default"].bind(s.__input, "keydown", function(e) {
                            13 === e.keyCode && this.blur()
                        }),
                        s.updateDisplay(),
                        s.domElement.appendChild(s.__input),
                        s
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        return d["default"].isActive(this.__input) || (this.__input.value = this.getValue()),
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e) {
                var t = e.toString();
                return t.indexOf(".") > -1 ? t.length - t.indexOf(".") - 1 : 0
            }
            t.__esModule = !0;
            var s = n(7)
                , u = o(s)
                , d = n(5)
                , c = o(d)
                , f = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var s = r(this, e.call(this, n, o))
                        , u = a || {};
                    return s.__min = u.min,
                        s.__max = u.max,
                        s.__step = u.step,
                        c["default"].isUndefined(s.__step) ? 0 === s.initialValue ? s.__impliedStep = 1 : s.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(s.initialValue)) / Math.LN10)) / 10 : s.__impliedStep = s.__step,
                        s.__precision = l(s.__impliedStep),
                        s
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = t;
                        return void 0 !== this.__min && n < this.__min ? n = this.__min : void 0 !== this.__max && n > this.__max && (n = this.__max),
                        void 0 !== this.__step && n % this.__step !== 0 && (n = Math.round(n / this.__step) * this.__step),
                            e.prototype.setValue.call(this, n)
                    }
                    ,
                    t.prototype.min = function(e) {
                        return this.__min = e,
                            this
                    }
                    ,
                    t.prototype.max = function(e) {
                        return this.__max = e,
                            this
                    }
                    ,
                    t.prototype.step = function(e) {
                        return this.__step = e,
                            this.__impliedStep = e,
                            this.__precision = l(e),
                            this
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = f
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t) {
                var n = Math.pow(10, t);
                return Math.round(e * n) / n
            }
            t.__esModule = !0;
            var s = n(12)
                , u = o(s)
                , d = n(9)
                , c = o(d)
                , f = n(5)
                , _ = o(f)
                , p = function(e) {
                function t(n, o, a) {
                    function l() {
                        var e = parseFloat(m.__input.value);
                        _["default"].isNaN(e) || m.setValue(e)
                    }
                    function s() {
                        m.__onFinishChange && m.__onFinishChange.call(m, m.getValue())
                    }
                    function u() {
                        s()
                    }
                    function d(e) {
                        var t = b - e.clientY;
                        m.setValue(m.getValue() + t * m.__impliedStep),
                            b = e.clientY
                    }
                    function f() {
                        c["default"].unbind(window, "mousemove", d),
                            c["default"].unbind(window, "mouseup", f),
                            s()
                    }
                    function p(e) {
                        c["default"].bind(window, "mousemove", d),
                            c["default"].bind(window, "mouseup", f),
                            b = e.clientY
                    }
                    i(this, t);
                    var h = r(this, e.call(this, n, o, a));
                    h.__truncationSuspended = !1;
                    var m = h
                        , b = void 0;
                    return h.__input = document.createElement("input"),
                        h.__input.setAttribute("type", "text"),
                        c["default"].bind(h.__input, "change", l),
                        c["default"].bind(h.__input, "blur", u),
                        c["default"].bind(h.__input, "mousedown", p),
                        c["default"].bind(h.__input, "keydown", function(e) {
                            13 === e.keyCode && (m.__truncationSuspended = !0,
                                this.blur(),
                                m.__truncationSuspended = !1,
                                s())
                        }),
                        h.updateDisplay(),
                        h.domElement.appendChild(h.__input),
                        h
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        return this.__input.value = this.__truncationSuspended ? this.getValue() : l(this.getValue(), this.__precision),
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = p
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t, n, o, i) {
                return o + (i - o) * ((e - t) / (n - t))
            }
            t.__esModule = !0;
            var s = n(12)
                , u = o(s)
                , d = n(9)
                , c = o(d)
                , f = function(e) {
                function t(n, o, a, s, u) {
                    function d(e) {
                        document.activeElement.blur(),
                            c["default"].bind(window, "mousemove", f),
                            c["default"].bind(window, "mouseup", _),
                            f(e)
                    }
                    function f(e) {
                        e.preventDefault();
                        var t = h.__background.getBoundingClientRect();
                        return h.setValue(l(e.clientX, t.left, t.right, h.__min, h.__max)),
                            !1
                    }
                    function _() {
                        c["default"].unbind(window, "mousemove", f),
                            c["default"].unbind(window, "mouseup", _),
                        h.__onFinishChange && h.__onFinishChange.call(h, h.getValue())
                    }
                    i(this, t);
                    var p = r(this, e.call(this, n, o, {
                        min: a,
                        max: s,
                        step: u
                    }))
                        , h = p;
                    return p.__background = document.createElement("div"),
                        p.__foreground = document.createElement("div"),
                        c["default"].bind(p.__background, "mousedown", d),
                        c["default"].addClass(p.__background, "slider"),
                        c["default"].addClass(p.__foreground, "slider-fg"),
                        p.updateDisplay(),
                        p.__background.appendChild(p.__foreground),
                        p.domElement.appendChild(p.__background),
                        p
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        var t = (this.getValue() - this.__min) / (this.__max - this.__min);
                        return this.__foreground.style.width = 100 * t + "%",
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = f
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = l;
                    return l.__button = document.createElement("div"),
                        l.__button.innerHTML = void 0 === a ? "Fire" : a,
                        d["default"].bind(l.__button, "click", function(e) {
                            return e.preventDefault(),
                                s.fire(),
                                !1
                        }),
                        d["default"].addClass(l.__button, "button"),
                        l.domElement.appendChild(l.__button),
                        l
                }
                return a(t, e),
                    t.prototype.fire = function() {
                        this.__onChange && this.__onChange.call(this),
                            this.getValue().call(this.object),
                        this.__onFinishChange && this.__onFinishChange.call(this, this.getValue())
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t, n, o) {
                e.style.background = "",
                    g["default"].each(y, function(i) {
                        e.style.cssText += "background: " + i + "linear-gradient(" + t + ", " + n + " 0%, " + o + " 100%); "
                    })
            }
            function s(e) {
                e.style.background = "",
                    e.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);",
                    e.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);"
            }
            t.__esModule = !0;
            var u = n(7)
                , d = o(u)
                , c = n(9)
                , f = o(c)
                , _ = n(2)
                , p = o(_)
                , h = n(3)
                , m = o(h)
                , b = n(5)
                , g = o(b)
                , v = function(e) {
                function t(n, o) {
                    function a(e) {
                        h(e),
                            f["default"].bind(window, "mousemove", h),
                            f["default"].bind(window, "mouseup", u)
                    }
                    function u() {
                        f["default"].unbind(window, "mousemove", h),
                            f["default"].unbind(window, "mouseup", u),
                            _()
                    }
                    function d() {
                        var e = (0,
                            m["default"])(this.value);
                        e !== !1 ? (y.__color.__state = e,
                            y.setValue(y.__color.toOriginal())) : this.value = y.__color.toString()
                    }
                    function c() {
                        f["default"].unbind(window, "mousemove", b),
                            f["default"].unbind(window, "mouseup", c),
                            _()
                    }
                    function _() {
                        y.__onFinishChange && y.__onFinishChange.call(y, y.__color.toOriginal())
                    }
                    function h(e) {
                        e.preventDefault();
                        var t = y.__saturation_field.getBoundingClientRect()
                            , n = (e.clientX - t.left) / (t.right - t.left)
                            , o = 1 - (e.clientY - t.top) / (t.bottom - t.top);
                        return o > 1 ? o = 1 : o < 0 && (o = 0),
                            n > 1 ? n = 1 : n < 0 && (n = 0),
                            y.__color.v = o,
                            y.__color.s = n,
                            y.setValue(y.__color.toOriginal()),
                            !1
                    }
                    function b(e) {
                        e.preventDefault();
                        var t = y.__hue_field.getBoundingClientRect()
                            , n = 1 - (e.clientY - t.top) / (t.bottom - t.top);
                        return n > 1 ? n = 1 : n < 0 && (n = 0),
                            y.__color.h = 360 * n,
                            y.setValue(y.__color.toOriginal()),
                            !1
                    }
                    i(this, t);
                    var v = r(this, e.call(this, n, o));
                    v.__color = new p["default"](v.getValue()),
                        v.__temp = new p["default"](0);
                    var y = v;
                    v.domElement = document.createElement("div"),
                        f["default"].makeSelectable(v.domElement, !1),
                        v.__selector = document.createElement("div"),
                        v.__selector.className = "selector",
                        v.__saturation_field = document.createElement("div"),
                        v.__saturation_field.className = "saturation-field",
                        v.__field_knob = document.createElement("div"),
                        v.__field_knob.className = "field-knob",
                        v.__field_knob_border = "2px solid ",
                        v.__hue_knob = document.createElement("div"),
                        v.__hue_knob.className = "hue-knob",
                        v.__hue_field = document.createElement("div"),
                        v.__hue_field.className = "hue-field",
                        v.__input = document.createElement("input"),
                        v.__input.type = "text",
                        v.__input_textShadow = "0 1px 1px ",
                        f["default"].bind(v.__input, "keydown", function(e) {
                            13 === e.keyCode && d.call(this)
                        }),
                        f["default"].bind(v.__input, "blur", d),
                        f["default"].bind(v.__selector, "mousedown", function() {
                            f["default"].addClass(this, "drag").bind(window, "mouseup", function() {
                                f["default"].removeClass(y.__selector, "drag")
                            })
                        });
                    var w = document.createElement("div");
                    return g["default"].extend(v.__selector.style, {
                        width: "122px",
                        height: "102px",
                        padding: "3px",
                        backgroundColor: "#222",
                        boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
                    }),
                        g["default"].extend(v.__field_knob.style, {
                            position: "absolute",
                            width: "12px",
                            height: "12px",
                            border: v.__field_knob_border + (v.__color.v < .5 ? "#fff" : "#000"),
                            boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
                            borderRadius: "12px",
                            zIndex: 1
                        }),
                        g["default"].extend(v.__hue_knob.style, {
                            position: "absolute",
                            width: "15px",
                            height: "2px",
                            borderRight: "4px solid #fff",
                            zIndex: 1
                        }),
                        g["default"].extend(v.__saturation_field.style, {
                            width: "100px",
                            height: "100px",
                            border: "1px solid #555",
                            marginRight: "3px",
                            display: "inline-block",
                            cursor: "pointer"
                        }),
                        g["default"].extend(w.style, {
                            width: "100%",
                            height: "100%",
                            background: "none"
                        }),
                        l(w, "top", "rgba(0,0,0,0)", "#000"),
                        g["default"].extend(v.__hue_field.style, {
                            width: "15px",
                            height: "100px",
                            border: "1px solid #555",
                            cursor: "ns-resize",
                            position: "absolute",
                            top: "3px",
                            right: "3px"
                        }),
                        s(v.__hue_field),
                        g["default"].extend(v.__input.style, {
                            outline: "none",
                            textAlign: "center",
                            color: "#fff",
                            border: 0,
                            fontWeight: "bold",
                            textShadow: v.__input_textShadow + "rgba(0,0,0,0.7)"
                        }),
                        f["default"].bind(v.__saturation_field, "mousedown", a),
                        f["default"].bind(v.__field_knob, "mousedown", a),
                        f["default"].bind(v.__hue_field, "mousedown", function(e) {
                            b(e),
                                f["default"].bind(window, "mousemove", b),
                                f["default"].bind(window, "mouseup", c)
                        }),
                        v.__saturation_field.appendChild(w),
                        v.__selector.appendChild(v.__field_knob),
                        v.__selector.appendChild(v.__saturation_field),
                        v.__selector.appendChild(v.__hue_field),
                        v.__hue_field.appendChild(v.__hue_knob),
                        v.domElement.appendChild(v.__input),
                        v.domElement.appendChild(v.__selector),
                        v.updateDisplay(),
                        v
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        var e = (0,
                            m["default"])(this.getValue());
                        if (e !== !1) {
                            var t = !1;
                            g["default"].each(p["default"].COMPONENTS, function(n) {
                                if (!g["default"].isUndefined(e[n]) && !g["default"].isUndefined(this.__color.__state[n]) && e[n] !== this.__color.__state[n])
                                    return t = !0,
                                        {}
                            }, this),
                            t && g["default"].extend(this.__color.__state, e)
                        }
                        g["default"].extend(this.__temp.__state, this.__color.__state),
                            this.__temp.a = 1;
                        var n = this.__color.v < .5 || this.__color.s > .5 ? 255 : 0
                            , o = 255 - n;
                        g["default"].extend(this.__field_knob.style, {
                            marginLeft: 100 * this.__color.s - 7 + "px",
                            marginTop: 100 * (1 - this.__color.v) - 7 + "px",
                            backgroundColor: this.__temp.toHexString(),
                            border: this.__field_knob_border + "rgb(" + n + "," + n + "," + n + ")"
                        }),
                            this.__hue_knob.style.marginTop = 100 * (1 - this.__color.h / 360) + "px",
                            this.__temp.s = 1,
                            this.__temp.v = 1,
                            l(this.__saturation_field, "left", "#fff", this.__temp.toHexString()),
                            this.__input.value = this.__color.toString(),
                            g["default"].extend(this.__input.style, {
                                backgroundColor: this.__color.toHexString(),
                                color: "rgb(" + n + "," + n + "," + n + ")",
                                textShadow: this.__input_textShadow + "rgba(" + o + "," + o + "," + o + ",.7)"
                            })
                    }
                    ,
                    t
            }(d["default"])
                , y = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
            t["default"] = v
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t, n) {
                var o = document.createElement("li");
                return t && o.appendChild(t),
                    n ? e.__ul.insertBefore(o, n) : e.__ul.appendChild(o),
                    e.onResize(),
                    o
            }
            function r(e, t) {
                var n = e.__preset_select[e.__preset_select.selectedIndex];
                t ? n.innerHTML = n.value + "*" : n.innerHTML = n.value
            }
            function a(e, t, n) {
                if (n.__li = t,
                    n.__gui = e,
                    U["default"].extend(n, {
                        options: function(t) {
                            if (arguments.length > 1) {
                                var o = n.__li.nextElementSibling;
                                return n.remove(),
                                    s(e, n.object, n.property, {
                                        before: o,
                                        factoryArgs: [U["default"].toArray(arguments)]
                                    })
                            }
                            if (U["default"].isArray(t) || U["default"].isObject(t)) {
                                var i = n.__li.nextElementSibling;
                                return n.remove(),
                                    s(e, n.object, n.property, {
                                        before: i,
                                        factoryArgs: [t]
                                    })
                            }
                        },
                        name: function(e) {
                            return n.__li.firstElementChild.firstElementChild.innerHTML = e,
                                n
                        },
                        listen: function() {
                            return n.__gui.listen(n),
                                n
                        },
                        remove: function() {
                            return n.__gui.remove(n),
                                n
                        }
                    }),
                n instanceof B["default"])
                    !function() {
                        var e = new N["default"](n.object,n.property,{
                            min: n.__min,
                            max: n.__max,
                            step: n.__step
                        });
                        U["default"].each(["updateDisplay", "onChange", "onFinishChange", "step"], function(t) {
                            var o = n[t]
                                , i = e[t];
                            n[t] = e[t] = function() {
                                var t = Array.prototype.slice.call(arguments);
                                return i.apply(e, t),
                                    o.apply(n, t)
                            }
                        }),
                            z["default"].addClass(t, "has-slider"),
                            n.domElement.insertBefore(e.domElement, n.domElement.firstElementChild)
                    }();
                else if (n instanceof N["default"]) {
                    var o = function(t) {
                        if (U["default"].isNumber(n.__min) && U["default"].isNumber(n.__max)) {
                            var o = n.__li.firstElementChild.firstElementChild.innerHTML
                                , i = n.__gui.__listening.indexOf(n) > -1;
                            n.remove();
                            var r = s(e, n.object, n.property, {
                                before: n.__li.nextElementSibling,
                                factoryArgs: [n.__min, n.__max, n.__step]
                            });
                            return r.name(o),
                            i && r.listen(),
                                r
                        }
                        return t
                    };
                    n.min = U["default"].compose(o, n.min),
                        n.max = U["default"].compose(o, n.max)
                } else
                    n instanceof O["default"] ? (z["default"].bind(t, "click", function() {
                        z["default"].fakeEvent(n.__checkbox, "click")
                    }),
                        z["default"].bind(n.__checkbox, "click", function(e) {
                            e.stopPropagation()
                        })) : n instanceof R["default"] ? (z["default"].bind(t, "click", function() {
                        z["default"].fakeEvent(n.__button, "click")
                    }),
                        z["default"].bind(t, "mouseover", function() {
                            z["default"].addClass(n.__button, "hover")
                        }),
                        z["default"].bind(t, "mouseout", function() {
                            z["default"].removeClass(n.__button, "hover")
                        })) : n instanceof j["default"] && (z["default"].addClass(t, "color"),
                        n.updateDisplay = U["default"].compose(function(e) {
                            return t.style.borderLeftColor = n.__color.toString(),
                                e
                        }, n.updateDisplay),
                        n.updateDisplay());
                n.setValue = U["default"].compose(function(t) {
                    return e.getRoot().__preset_select && n.isModified() && r(e.getRoot(), !0),
                        t
                }, n.setValue)
            }
            function l(e, t) {
                var n = e.getRoot()
                    , o = n.__rememberedObjects.indexOf(t.object);
                if (o !== -1) {
                    var i = n.__rememberedObjectIndecesToControllers[o];
                    if (void 0 === i && (i = {},
                        n.__rememberedObjectIndecesToControllers[o] = i),
                        i[t.property] = t,
                    n.load && n.load.remembered) {
                        var r = n.load.remembered
                            , a = void 0;
                        if (r[e.preset])
                            a = r[e.preset];
                        else {
                            if (!r[Q])
                                return;
                            a = r[Q]
                        }
                        if (a[o] && void 0 !== a[o][t.property]) {
                            var l = a[o][t.property];
                            t.initialValue = l,
                                t.setValue(l)
                        }
                    }
                }
            }
            function s(e, t, n, o) {
                if (void 0 === t[n])
                    throw new Error('Object "' + t + '" has no property "' + n + '"');
                var r = void 0;
                if (o.color)
                    r = new j["default"](t,n);
                else {
                    var s = [t, n].concat(o.factoryArgs);
                    r = C["default"].apply(e, s)
                }
                o.before instanceof S["default"] && (o.before = o.before.__li),
                    l(e, r),
                    z["default"].addClass(r.domElement, "c");
                var u = document.createElement("span");
                z["default"].addClass(u, "property-name"),
                    u.innerHTML = r.property;
                var d = document.createElement("div");
                d.appendChild(u),
                    d.appendChild(r.domElement);
                var c = i(e, d, o.before);
                return z["default"].addClass(c, oe.CLASS_CONTROLLER_ROW),
                    r instanceof j["default"] ? z["default"].addClass(c, "color") : z["default"].addClass(c, g(r.getValue())),
                    a(e, c, r),
                    e.__controllers.push(r),
                    r
            }
            function u(e, t) {
                return document.location.href + "." + t
            }
            function d(e, t, n) {
                var o = document.createElement("option");
                o.innerHTML = t,
                    o.value = t,
                    e.__preset_select.appendChild(o),
                n && (e.__preset_select.selectedIndex = e.__preset_select.length - 1)
            }
            function c(e, t) {
                t.style.display = e.useLocalStorage ? "block" : "none"
            }
            function f(e) {
                var t = e.__save_row = document.createElement("li");
                z["default"].addClass(e.domElement, "has-save"),
                    e.__ul.insertBefore(t, e.__ul.firstChild),
                    z["default"].addClass(t, "save-row");
                var n = document.createElement("span");
                n.innerHTML = "&nbsp;",
                    z["default"].addClass(n, "button gears");
                var o = document.createElement("span");
                o.innerHTML = "Save",
                    z["default"].addClass(o, "button"),
                    z["default"].addClass(o, "save");
                var i = document.createElement("span");
                i.innerHTML = "New",
                    z["default"].addClass(i, "button"),
                    z["default"].addClass(i, "save-as");
                var r = document.createElement("span");
                r.innerHTML = "Revert",
                    z["default"].addClass(r, "button"),
                    z["default"].addClass(r, "revert");
                var a = e.__preset_select = document.createElement("select");
                e.load && e.load.remembered ? U["default"].each(e.load.remembered, function(t, n) {
                    d(e, n, n === e.preset)
                }) : d(e, Q, !1),
                    z["default"].bind(a, "change", function() {
                        for (var t = 0; t < e.__preset_select.length; t++)
                            e.__preset_select[t].innerHTML = e.__preset_select[t].value;
                        e.preset = this.value
                    }),
                    t.appendChild(a),
                    t.appendChild(n),
                    t.appendChild(o),
                    t.appendChild(i),
                    t.appendChild(r),
                q && !function() {
                    var t = document.getElementById("dg-local-explain")
                        , n = document.getElementById("dg-local-storage")
                        , o = document.getElementById("dg-save-locally");
                    o.style.display = "block",
                    "true" === localStorage.getItem(u(e, "isLocal")) && n.setAttribute("checked", "checked"),
                        c(e, t),
                        z["default"].bind(n, "change", function() {
                            e.useLocalStorage = !e.useLocalStorage,
                                c(e, t)
                        })
                }();
                var l = document.getElementById("dg-new-constructor");
                z["default"].bind(l, "keydown", function(e) {
                    !e.metaKey || 67 !== e.which && 67 !== e.keyCode || Z.hide()
                }),
                    z["default"].bind(n, "click", function() {
                        l.innerHTML = JSON.stringify(e.getSaveObject(), void 0, 2),
                            Z.show(),
                            l.focus(),
                            l.select()
                    }),
                    z["default"].bind(o, "click", function() {
                        e.save()
                    }),
                    z["default"].bind(i, "click", function() {
                        var t = prompt("Enter a new preset name.");
                        t && e.saveAs(t)
                    }),
                    z["default"].bind(r, "click", function() {
                        e.revert()
                    })
            }
            function _(e) {
                function t(t) {
                    return t.preventDefault(),
                        e.width += i - t.clientX,
                        e.onResize(),
                        i = t.clientX,
                        !1
                }
                function n() {
                    z["default"].removeClass(e.__closeButton, oe.CLASS_DRAG),
                        z["default"].unbind(window, "mousemove", t),
                        z["default"].unbind(window, "mouseup", n)
                }
                function o(o) {
                    return o.preventDefault(),
                        i = o.clientX,
                        z["default"].addClass(e.__closeButton, oe.CLASS_DRAG),
                        z["default"].bind(window, "mousemove", t),
                        z["default"].bind(window, "mouseup", n),
                        !1
                }
                var i = void 0;
                e.__resize_handle = document.createElement("div"),
                    U["default"].extend(e.__resize_handle.style, {
                        width: "6px",
                        marginLeft: "-3px",
                        height: "200px",
                        cursor: "ew-resize",
                        position: "absolute"
                    }),
                    z["default"].bind(e.__resize_handle, "mousedown", o),
                    z["default"].bind(e.__closeButton, "mousedown", o),
                    e.domElement.insertBefore(e.__resize_handle, e.domElement.firstElementChild)
            }
            function p(e, t) {
                e.domElement.style.width = t + "px",
                e.__save_row && e.autoPlace && (e.__save_row.style.width = t + "px"),
                e.__closeButton && (e.__closeButton.style.width = t + "px")
            }
            function h(e, t) {
                var n = {};
                return U["default"].each(e.__rememberedObjects, function(o, i) {
                    var r = {}
                        , a = e.__rememberedObjectIndecesToControllers[i];
                    U["default"].each(a, function(e, n) {
                        r[n] = t ? e.initialValue : e.getValue()
                    }),
                        n[i] = r
                }),
                    n
            }
            function m(e) {
                for (var t = 0; t < e.__preset_select.length; t++)
                    e.__preset_select[t].value === e.preset && (e.__preset_select.selectedIndex = t)
            }
            function b(e) {
                0 !== e.length && D["default"].call(window, function() {
                    b(e)
                }),
                    U["default"].each(e, function(e) {
                        e.updateDisplay()
                    })
            }
            var g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                }
                : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e
                }
                , v = n(18)
                , y = o(v)
                , w = n(19)
                , x = o(w)
                , E = n(20)
                , C = o(E)
                , A = n(7)
                , S = o(A)
                , k = n(8)
                , O = o(k)
                , T = n(15)
                , R = o(T)
                , L = n(13)
                , N = o(L)
                , M = n(14)
                , B = o(M)
                , H = n(16)
                , j = o(H)
                , P = n(21)
                , D = o(P)
                , V = n(22)
                , F = o(V)
                , I = n(9)
                , z = o(I)
                , G = n(5)
                , U = o(G)
                , X = n(23)
                , K = o(X);
            y["default"].inject(K["default"]);
            var Y = "dg"
                , J = 72
                , W = 20
                , Q = "Default"
                , q = function() {
                try {
                    return "localStorage"in window && null !== window.localStorage
                } catch (e) {
                    return !1
                }
            }()
                , Z = void 0
                , $ = !0
                , ee = void 0
                , te = !1
                , ne = []
                , oe = function ie(e) {
                function t() {
                    var e = n.getRoot();
                    e.width += 1,
                        U["default"].defer(function() {
                            e.width -= 1
                        })
                }
                var n = this
                    , o = e || {};
                this.domElement = document.createElement("div"),
                    this.__ul = document.createElement("ul"),
                    this.domElement.appendChild(this.__ul),
                    z["default"].addClass(this.domElement, Y),
                    this.__folders = {},
                    this.__controllers = [],
                    this.__rememberedObjects = [],
                    this.__rememberedObjectIndecesToControllers = [],
                    this.__listening = [],
                    o = U["default"].defaults(o, {
                        autoPlace: !0,
                        width: ie.DEFAULT_WIDTH
                    }),
                    o = U["default"].defaults(o, {
                        resizable: o.autoPlace,
                        hideable: o.autoPlace
                    }),
                    U["default"].isUndefined(o.load) ? o.load = {
                        preset: Q
                    } : o.preset && (o.load.preset = o.preset),
                U["default"].isUndefined(o.parent) && o.hideable && ne.push(this),
                    o.resizable = U["default"].isUndefined(o.parent) && o.resizable,
                o.autoPlace && U["default"].isUndefined(o.scrollable) && (o.scrollable = !0);
                var r = q && "true" === localStorage.getItem(u(this, "isLocal"))
                    , a = void 0;
                if (Object.defineProperties(this, {
                    parent: {
                        get: function() {
                            return o.parent
                        }
                    },
                    scrollable: {
                        get: function() {
                            return o.scrollable
                        }
                    },
                    autoPlace: {
                        get: function() {
                            return o.autoPlace
                        }
                    },
                    preset: {
                        get: function() {
                            return n.parent ? n.getRoot().preset : o.load.preset
                        },
                        set: function(e) {
                            n.parent ? n.getRoot().preset = e : o.load.preset = e,
                                m(this),
                                n.revert()
                        }
                    },
                    width: {
                        get: function() {
                            return o.width
                        },
                        set: function(e) {
                            o.width = e,
                                p(n, e)
                        }
                    },
                    name: {
                        get: function() {
                            return o.name
                        },
                        set: function(e) {
                            o.name = e,
                            titleRowName && (titleRowName.innerHTML = o.name)
                        }
                    },
                    closed: {
                        get: function() {
                            return o.closed
                        },
                        set: function(e) {
                            o.closed = e,
                                o.closed ? z["default"].addClass(n.__ul, ie.CLASS_CLOSED) : z["default"].removeClass(n.__ul, ie.CLASS_CLOSED),
                                this.onResize(),
                            n.__closeButton && (n.__closeButton.innerHTML = e ? ie.TEXT_OPEN : ie.TEXT_CLOSED)
                        }
                    },
                    load: {
                        get: function() {
                            return o.load
                        }
                    },
                    useLocalStorage: {
                        get: function() {
                            return r
                        },
                        set: function(e) {
                            q && (r = e,
                                e ? z["default"].bind(window, "unload", a) : z["default"].unbind(window, "unload", a),
                                localStorage.setItem(u(n, "isLocal"), e))
                        }
                    }
                }),
                    U["default"].isUndefined(o.parent)) {
                    if (o.closed = !1,
                        z["default"].addClass(this.domElement, ie.CLASS_MAIN),
                        z["default"].makeSelectable(this.domElement, !1),
                    q && r) {
                        n.useLocalStorage = !0;
                        var l = localStorage.getItem(u(this, "gui"));
                        l && (o.load = JSON.parse(l))
                    }
                    this.__closeButton = document.createElement("div"),
                        this.__closeButton.innerHTML = ie.TEXT_CLOSED,
                        z["default"].addClass(this.__closeButton, ie.CLASS_CLOSE_BUTTON),
                        this.domElement.appendChild(this.__closeButton),
                        z["default"].bind(this.__closeButton, "click", function() {
                            n.closed = !n.closed
                        })
                } else {
                    void 0 === o.closed && (o.closed = !0);
                    var s = document.createTextNode(o.name);
                    z["default"].addClass(s, "controller-name");
                    var d = i(n, s)
                        , c = function(e) {
                        return e.preventDefault(),
                            n.closed = !n.closed,
                            !1
                    };
                    z["default"].addClass(this.__ul, ie.CLASS_CLOSED),
                        z["default"].addClass(d, "title"),
                        z["default"].bind(d, "click", c),
                    o.closed || (this.closed = !1)
                }
                o.autoPlace && (U["default"].isUndefined(o.parent) && ($ && (ee = document.createElement("div"),
                    z["default"].addClass(ee, Y),
                    z["default"].addClass(ee, ie.CLASS_AUTO_PLACE_CONTAINER),
                    document.body.appendChild(ee),
                    $ = !1),
                    ee.appendChild(this.domElement),
                    z["default"].addClass(this.domElement, ie.CLASS_AUTO_PLACE)),
                this.parent || p(n, o.width)),
                    this.__resizeHandler = function() {
                        n.onResizeDebounced()
                    }
                    ,
                    z["default"].bind(window, "resize", this.__resizeHandler),
                    z["default"].bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler),
                    z["default"].bind(this.__ul, "transitionend", this.__resizeHandler),
                    z["default"].bind(this.__ul, "oTransitionEnd", this.__resizeHandler),
                    this.onResize(),
                o.resizable && _(this),
                    a = function() {
                        q && "true" === localStorage.getItem(u(n, "isLocal")) && localStorage.setItem(u(n, "gui"), JSON.stringify(n.getSaveObject()))
                    }
                    ,
                    this.saveToLocalStorageIfPossible = a,
                o.parent || t()
            };
            oe.toggleHide = function() {
                te = !te,
                    U["default"].each(ne, function(e) {
                        e.domElement.style.display = te ? "none" : ""
                    })
            }
                ,
                oe.CLASS_AUTO_PLACE = "a",
                oe.CLASS_AUTO_PLACE_CONTAINER = "ac",
                oe.CLASS_MAIN = "main",
                oe.CLASS_CONTROLLER_ROW = "cr",
                oe.CLASS_TOO_TALL = "taller-than-window",
                oe.CLASS_CLOSED = "closed",
                oe.CLASS_CLOSE_BUTTON = "close-button",
                oe.CLASS_DRAG = "drag",
                oe.DEFAULT_WIDTH = 245,
                oe.TEXT_CLOSED = "Close Controls",
                oe.TEXT_OPEN = "Open Controls",
                oe._keydownHandler = function(e) {
                    "text" === document.activeElement.type || e.which !== J && e.keyCode !== J || oe.toggleHide()
                }
                ,
                z["default"].bind(window, "keydown", oe._keydownHandler, !1),
                U["default"].extend(oe.prototype, {
                    add: function(e, t) {
                        return s(this, e, t, {
                            factoryArgs: Array.prototype.slice.call(arguments, 2)
                        })
                    },
                    addColor: function(e, t) {
                        return s(this, e, t, {
                            color: !0
                        })
                    },
                    remove: function(e) {
                        this.__ul.removeChild(e.__li),
                            this.__controllers.splice(this.__controllers.indexOf(e), 1);
                        var t = this;
                        U["default"].defer(function() {
                            t.onResize()
                        })
                    },
                    destroy: function() {
                        this.autoPlace && ee.removeChild(this.domElement),
                            z["default"].unbind(window, "keydown", oe._keydownHandler, !1),
                            z["default"].unbind(window, "resize", this.__resizeHandler),
                        this.saveToLocalStorageIfPossible && z["default"].unbind(window, "unload", this.saveToLocalStorageIfPossible)
                    },
                    addFolder: function(e) {
                        if (void 0 !== this.__folders[e])
                            throw new Error('You already have a folder in this GUI by the name "' + e + '"');
                        var t = {
                            name: e,
                            parent: this
                        };
                        t.autoPlace = this.autoPlace,
                        this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed,
                            t.load = this.load.folders[e]);
                        var n = new oe(t);
                        this.__folders[e] = n;
                        var o = i(this, n.domElement);
                        return z["default"].addClass(o, "folder"),
                            n
                    },
                    open: function() {
                        this.closed = !1
                    },
                    close: function() {
                        this.closed = !0
                    },
                    onResize: function() {
                        var e = this.getRoot();
                        if (e.scrollable) {
                            var t = z["default"].getOffset(e.__ul).top
                                , n = 0;
                            U["default"].each(e.__ul.childNodes, function(t) {
                                e.autoPlace && t === e.__save_row || (n += z["default"].getHeight(t))
                            }),
                                window.innerHeight - t - W < n ? (z["default"].addClass(e.domElement, oe.CLASS_TOO_TALL),
                                    e.__ul.style.height = window.innerHeight - t - W + "px") : (z["default"].removeClass(e.domElement, oe.CLASS_TOO_TALL),
                                    e.__ul.style.height = "auto")
                        }
                        e.__resize_handle && U["default"].defer(function() {
                            e.__resize_handle.style.height = e.__ul.offsetHeight + "px"
                        }),
                        e.__closeButton && (e.__closeButton.style.width = e.width + "px")
                    },
                    onResizeDebounced: U["default"].debounce(function() {
                        this.onResize()
                    }, 200),
                    remember: function() {
                        if (U["default"].isUndefined(Z) && (Z = new F["default"],
                            Z.domElement.innerHTML = x["default"]),
                            this.parent)
                            throw new Error("You can only call remember on a top level GUI.");
                        var e = this;
                        U["default"].each(Array.prototype.slice.call(arguments), function(t) {
                            0 === e.__rememberedObjects.length && f(e),
                            e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t)
                        }),
                        this.autoPlace && p(this, this.width)
                    },
                    getRoot: function() {
                        for (var e = this; e.parent; )
                            e = e.parent;
                        return e
                    },
                    getSaveObject: function() {
                        var e = this.load;
                        return e.closed = this.closed,
                        this.__rememberedObjects.length > 0 && (e.preset = this.preset,
                        e.remembered || (e.remembered = {}),
                            e.remembered[this.preset] = h(this)),
                            e.folders = {},
                            U["default"].each(this.__folders, function(t, n) {
                                e.folders[n] = t.getSaveObject()
                            }),
                            e
                    },
                    save: function() {
                        this.load.remembered || (this.load.remembered = {}),
                            this.load.remembered[this.preset] = h(this),
                            r(this, !1),
                            this.saveToLocalStorageIfPossible()
                    },
                    saveAs: function(e) {
                        this.load.remembered || (this.load.remembered = {},
                            this.load.remembered[Q] = h(this, !0)),
                            this.load.remembered[e] = h(this),
                            this.preset = e,
                            d(this, e, !0),
                            this.saveToLocalStorageIfPossible()
                    },
                    revert: function(e) {
                        U["default"].each(this.__controllers, function(t) {
                            this.getRoot().load.remembered ? l(e || this.getRoot(), t) : t.setValue(t.initialValue),
                            t.__onFinishChange && t.__onFinishChange.call(t, t.getValue())
                        }, this),
                            U["default"].each(this.__folders, function(e) {
                                e.revert(e)
                            }),
                        e || r(this.getRoot(), !1)
                    },
                    listen: function(e) {
                        var t = 0 === this.__listening.length;
                        this.__listening.push(e),
                        t && b(this.__listening)
                    },
                    updateDisplay: function() {
                        U["default"].each(this.__controllers, function(e) {
                            e.updateDisplay()
                        }),
                            U["default"].each(this.__folders, function(e) {
                                e.updateDisplay()
                            })
                    }
                }),
                e.exports = oe
        }
        , function(e, t) {
            "use strict";
            e.exports = {
                load: function(e, t) {
                    var n = t || document
                        , o = n.createElement("link");
                    o.type = "text/css",
                        o.rel = "stylesheet",
                        o.href = e,
                        n.getElementsByTagName("head")[0].appendChild(o)
                },
                inject: function(e, t) {
                    var n = t || document
                        , o = document.createElement("style");
                    o.type = "text/css",
                        o.innerHTML = e;
                    var i = n.getElementsByTagName("head")[0];
                    try {
                        i.appendChild(o)
                    } catch (r) {}
                }
            }
        }
        , function(e, t) {
            e.exports = "<div id=dg-save class=\"dg dialogue\"> Here's the new load parameter for your <code>GUI</code>'s constructor: <textarea id=dg-new-constructor></textarea> <div id=dg-save-locally> <input id=dg-local-storage type=checkbox /> Automatically save values to <code>localStorage</code> on exit. <div id=dg-local-explain>The values saved to <code>localStorage</code> will override those passed to <code>dat.GUI</code>'s constructor. This makes it easier to work incrementally, but <code>localStorage</code> is fragile, and your friends may not see the same values you do. </div> </div> </div>"
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(10)
                , r = o(i)
                , a = n(13)
                , l = o(a)
                , s = n(14)
                , u = o(s)
                , d = n(11)
                , c = o(d)
                , f = n(15)
                , _ = o(f)
                , p = n(8)
                , h = o(p)
                , m = n(5)
                , b = o(m)
                , g = function(e, t) {
                var n = e[t];
                return b["default"].isArray(arguments[2]) || b["default"].isObject(arguments[2]) ? new r["default"](e,t,arguments[2]) : b["default"].isNumber(n) ? b["default"].isNumber(arguments[2]) && b["default"].isNumber(arguments[3]) ? b["default"].isNumber(arguments[4]) ? new u["default"](e,t,arguments[2],arguments[3],arguments[4]) : new u["default"](e,t,arguments[2],arguments[3]) : b["default"].isNumber(arguments[4]) ? new l["default"](e,t,{
                    min: arguments[2],
                    max: arguments[3],
                    step: arguments[4]
                }) : new l["default"](e,t,{
                    min: arguments[2],
                    max: arguments[3]
                }) : b["default"].isString(n) ? new c["default"](e,t) : b["default"].isFunction(n) ? new _["default"](e,t,"") : b["default"].isBoolean(n) ? new h["default"](e,t) : null
            };
            t["default"] = g
        }
        , function(e, t) {
            "use strict";
            function n(e) {
                setTimeout(e, 1e3 / 60)
            }
            t.__esModule = !0,
                t["default"] = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || n
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            t.__esModule = !0;
            var r = n(9)
                , a = o(r)
                , l = n(5)
                , s = o(l)
                , u = function() {
                function e() {
                    i(this, e),
                        this.backgroundElement = document.createElement("div"),
                        s["default"].extend(this.backgroundElement.style, {
                            backgroundColor: "rgba(0,0,0,0.8)",
                            top: 0,
                            left: 0,
                            display: "none",
                            zIndex: "1000",
                            opacity: 0,
                            WebkitTransition: "opacity 0.2s linear",
                            transition: "opacity 0.2s linear"
                        }),
                        a["default"].makeFullscreen(this.backgroundElement),
                        this.backgroundElement.style.position = "fixed",
                        this.domElement = document.createElement("div"),
                        s["default"].extend(this.domElement.style, {
                            position: "fixed",
                            display: "none",
                            zIndex: "1001",
                            opacity: 0,
                            WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
                            transition: "transform 0.2s ease-out, opacity 0.2s linear"
                        }),
                        document.body.appendChild(this.backgroundElement),
                        document.body.appendChild(this.domElement);
                    var t = this;
                    a["default"].bind(this.backgroundElement, "click", function() {
                        t.hide()
                    })
                }
                return e.prototype.show = function() {
                    var e = this;
                    this.backgroundElement.style.display = "block",
                        this.domElement.style.display = "block",
                        this.domElement.style.opacity = 0,
                        this.domElement.style.webkitTransform = "scale(1.1)",
                        this.layout(),
                        s["default"].defer(function() {
                            e.backgroundElement.style.opacity = 1,
                                e.domElement.style.opacity = 1,
                                e.domElement.style.webkitTransform = "scale(1)"
                        })
                }
                    ,
                    e.prototype.hide = function t() {
                        var e = this
                            , t = function n() {
                            e.domElement.style.display = "none",
                                e.backgroundElement.style.display = "none",
                                a["default"].unbind(e.domElement, "webkitTransitionEnd", n),
                                a["default"].unbind(e.domElement, "transitionend", n),
                                a["default"].unbind(e.domElement, "oTransitionEnd", n)
                        };
                        a["default"].bind(this.domElement, "webkitTransitionEnd", t),
                            a["default"].bind(this.domElement, "transitionend", t),
                            a["default"].bind(this.domElement, "oTransitionEnd", t),
                            this.backgroundElement.style.opacity = 0,
                            this.domElement.style.opacity = 0,
                            this.domElement.style.webkitTransform = "scale(1.1)"
                    }
                    ,
                    e.prototype.layout = function() {
                        this.domElement.style.left = window.innerWidth / 2 - a["default"].getWidth(this.domElement) / 2 + "px",
                            this.domElement.style.top = window.innerHeight / 2 - a["default"].getHeight(this.domElement) / 2 + "px"
                    }
                    ,
                    e
            }();
            t["default"] = u
        }
        , function(e, t, n) {
            t = e.exports = n(24)(),
                t.push([e.id, ".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1!important}.dg.main .close-button.drag,.dg.main:hover .close-button{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;transition:opacity .1s linear;border:0;position:absolute;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-x:hidden}.dg.a.has-save>ul{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{position:fixed;top:0;z-index:1002}.dg li{-webkit-transition:height .1s ease-out;transition:height .1s ease-out}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;overflow:hidden;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid transparent}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .c{float:left;width:60%}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:9px}.dg .c select{margin-top:5px}.dg .cr.boolean,.dg .cr.boolean *,.dg .cr.function,.dg .cr.function *,.dg .cr.function .property-name{cursor:pointer}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco,monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px Lucida Grande,sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid hsla(0,0%,100%,.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2fa1d6}.dg .cr.number input[type=text]{color:#2fa1d6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.boolean:hover,.dg .cr.function:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2fa1d6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}", ""])
        }
        , function(e, t) {
            e.exports = function() {
                var e = [];
                return e.toString = function() {
                    for (var e = [], t = 0; t < this.length; t++) {
                        var n = this[t];
                        n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1])
                    }
                    return e.join("")
                }
                    ,
                    e.i = function(t, n) {
                        "string" == typeof t && (t = [[null, t, ""]]);
                        for (var o = {}, i = 0; i < this.length; i++) {
                            var r = this[i][0];
                            "number" == typeof r && (o[r] = !0)
                        }
                        for (i = 0; i < t.length; i++) {
                            var a = t[i];
                            "number" == typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"),
                                e.push(a))
                        }
                    }
                    ,
                    e
            }
        }
    ])
});

/*************************
 * Croppie
 * Copyright 2019
 * Foliotek
 * Version: 2.6.4
 *************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        module.exports = factory();
    } else {
        // Browser globals
        root.Croppie = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {

    /* Polyfills */
    if (typeof Promise !== 'function') {
        /*! promise-polyfill 3.1.0 */
        !function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!==typeof this)throw new TypeError("Promises must be constructed via new");if("function"!==typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"===typeof a||"function"===typeof a)){var c=a.then;if("function"===typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"===typeof a?a:null,this.onRejected="function"===typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=setTimeout,k="function"===typeof setImmediate&&setImmediate||function(a){j(a,1)},l=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"===typeof g||"function"===typeof g)){var h=g.then;if("function"===typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"===typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){k=a},"undefined"!==typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);
    }

    if ( typeof window.CustomEvent !== "function" ) {
        (function(){
            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                var evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }
            CustomEvent.prototype = window.Event.prototype;
            window.CustomEvent = CustomEvent;
        }());
    }

    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
                var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                    len = binStr.length,
                    arr = new Uint8Array(len);

                for (var i=0; i<len; i++ ) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback( new Blob( [arr], {type: type || 'image/png'} ) );
            }
        });
    }
    /* End Polyfills */

    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
        emptyStyles = document.createElement('div').style,
        EXIF_NORM = [1,8,3,6],
        EXIF_FLIP = [2,7,4,5],
        CSS_TRANS_ORG,
        CSS_TRANSFORM,
        CSS_USERSELECT;

    function vendorPrefix(prop) {
        if (prop in emptyStyles) {
            return prop;
        }

        var capProp = prop[0].toUpperCase() + prop.slice(1),
            i = cssPrefixes.length;

        while (i--) {
            prop = cssPrefixes[i] + capProp;
            if (prop in emptyStyles) {
                return prop;
            }
        }
    }

    CSS_TRANSFORM = vendorPrefix('transform');
    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
    CSS_USERSELECT = vendorPrefix('userSelect');

    function getExifOffset(ornt, rotate) {
        var arr = EXIF_NORM.indexOf(ornt) > -1 ? EXIF_NORM : EXIF_FLIP,
            index = arr.indexOf(ornt),
            offset = (rotate / 90) % arr.length;// 180 = 2%4 = 2 shift exif by 2 indexes

        return arr[(arr.length + index + (offset % arr.length)) % arr.length];
    }

    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
    function deepExtend(destination, source) {
        destination = destination || {};
        for (var property in source) {
            if (source[property] && source[property].constructor && source[property].constructor === Object) {
                destination[property] = destination[property] || {};
                deepExtend(destination[property], source[property]);
            } else {
                destination[property] = source[property];
            }
        }
        return destination;
    }

    function clone(object) {
        return deepExtend({}, object);
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function dispatchChange(element) {
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            element.dispatchEvent(evt);
        }
        else {
            element.fireEvent("onchange");
        }
    }

    //http://jsperf.com/vanilla-css
    function css(el, styles, val) {
        if (typeof (styles) === 'string') {
            var tmp = styles;
            styles = {};
            styles[tmp] = val;
        }

        for (var prop in styles) {
            el.style[prop] = styles[prop];
        }
    }

    function addClass(el, c) {
        if (el.classList) {
            el.classList.add(c);
        }
        else {
            el.className += ' ' + c;
        }
    }

    function removeClass(el, c) {
        if (el.classList) {
            el.classList.remove(c);
        }
        else {
            el.className = el.className.replace(c, '');
        }
    }

    function setAttributes(el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    function num(v) {
        return parseInt(v, 10);
    }

    /* Utilities */
    function loadImage(src, doExif) {
        var img = new Image();
        img.style.opacity = '0';
        return new Promise(function (resolve, reject) {
            function _resolve() {
                img.style.opacity = '1';
                setTimeout(function () {
                    resolve(img);
                }, 1);
            }

            img.removeAttribute('crossOrigin');
            if (src.match(/^https?:\/\/|^\/\//)) {
                img.setAttribute('crossOrigin', 'anonymous');
            }

            img.onload = function () {
                if (doExif) {
                    EXIF.getData(img, function () {
                        _resolve();
                    });
                }
                else {
                    _resolve();
                }
            };
            img.onerror = function (ev) {
                img.style.opacity = 1;
                setTimeout(function () {
                    reject(ev);
                }, 1);
            };
            img.src = src;
        });
    }

    function naturalImageDimensions(img, ornt) {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var orient = ornt || getExifOrientation(img);
        if (orient && orient >= 5) {
            var x= w;
            w = h;
            h = x;
        }
        return { width: w, height: h };
    }

    /* CSS Transform Prototype */
    var TRANSLATE_OPTS = {
        'translate3d': {
            suffix: ', 0px'
        },
        'translate': {
            suffix: ''
        }
    };
    var Transform = function (x, y, scale) {
        this.x = parseFloat(x);
        this.y = parseFloat(y);
        this.scale = parseFloat(scale);
    };

    Transform.parse = function (v) {
        if (v.style) {
            return Transform.parse(v.style[CSS_TRANSFORM]);
        }
        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
            return Transform.fromMatrix(v);
        }
        else {
            return Transform.fromString(v);
        }
    };

    Transform.fromMatrix = function (v) {
        var vals = v.substring(7).split(',');
        if (!vals.length || v === 'none') {
            vals = [1, 0, 0, 1, 0, 0];
        }

        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
    };

    Transform.fromString = function (v) {
        var values = v.split(') '),
            translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
            scale = values.length > 1 ? values[1].substring(6) : 1,
            x = translate.length > 1 ? translate[0] : 0,
            y = translate.length > 1 ? translate[1] : 0;

        return new Transform(x, y, scale);
    };

    Transform.prototype.toString = function () {
        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
    };

    var TransformOrigin = function (el) {
        if (!el || !el.style[CSS_TRANS_ORG]) {
            this.x = 0;
            this.y = 0;
            return;
        }
        var css = el.style[CSS_TRANS_ORG].split(' ');
        this.x = parseFloat(css[0]);
        this.y = parseFloat(css[1]);
    };

    TransformOrigin.prototype.toString = function () {
        return this.x + 'px ' + this.y + 'px';
    };

    function getExifOrientation (img) {
        return img.exifdata && img.exifdata.Orientation ? num(img.exifdata.Orientation) : 1;
    }

    function drawCanvas(canvas, img, orientation) {
        var width = img.width,
            height = img.height,
            ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.save();
        switch (orientation) {
            case 2:
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;

            case 3:
                ctx.translate(width, height);
                ctx.rotate(180*Math.PI/180);
                break;

            case 4:
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;

            case 5:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90*Math.PI/180);
                ctx.scale(1, -1);
                break;

            case 6:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90*Math.PI/180);
                ctx.translate(0, -height);
                break;

            case 7:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(-90*Math.PI/180);
                ctx.translate(-width, height);
                ctx.scale(1, -1);
                break;

            case 8:
                canvas.width = height;
                canvas.height = width;
                ctx.translate(0, width);
                ctx.rotate(-90*Math.PI/180);
                break;
        }
        ctx.drawImage(img, 0,0, width, height);
        ctx.restore();
    }

    /* Private Methods */
    function _create() {
        var self = this,
            contClass = 'croppie-container',
            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
            boundary, img, viewport, overlay, bw, bh;

        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
        // Properties on class
        self.data = {};
        self.elements = {};

        boundary = self.elements.boundary = document.createElement('div');
        viewport = self.elements.viewport = document.createElement('div');
        img = self.elements.img = document.createElement('img');
        overlay = self.elements.overlay = document.createElement('div');

        if (self.options.useCanvas) {
            self.elements.canvas = document.createElement('canvas');
            self.elements.preview = self.elements.canvas;
        }
        else {
            self.elements.preview = img;
        }

        addClass(boundary, 'cr-boundary');
        boundary.setAttribute('aria-dropeffect', 'none');
        bw = self.options.boundary.width;
        bh = self.options.boundary.height;
        css(boundary, {
            width: (bw + (isNaN(bw) ? '' : 'px')),
            height: (bh + (isNaN(bh) ? '' : 'px'))
        });

        addClass(viewport, 'cr-viewport');
        if (customViewportClass) {
            addClass(viewport, customViewportClass);
        }
        css(viewport, {
            width: self.options.viewport.width + 'px',
            height: self.options.viewport.height + 'px'
        });
        viewport.setAttribute('tabindex', 0);

        addClass(self.elements.preview, 'cr-image');
        setAttributes(self.elements.preview, { 'alt': 'preview', 'aria-grabbed': 'false' });
        addClass(overlay, 'cr-overlay');

        self.element.appendChild(boundary);
        boundary.appendChild(self.elements.preview);
        boundary.appendChild(viewport);
        boundary.appendChild(overlay);

        addClass(self.element, contClass);
        if (self.options.customClass) {
            addClass(self.element, self.options.customClass);
        }

        _initDraggable.call(this);

        if (self.options.enableZoom) {
            _initializeZoom.call(self);
        }

        // if (self.options.enableOrientation) {
        //     _initRotationControls.call(self);
        // }

        if (self.options.enableResize) {
            _initializeResize.call(self);
        }
    }

    // function _initRotationControls () {
    //     var self = this,
    //         wrap, btnLeft, btnRight, iLeft, iRight;

    //     wrap = document.createElement('div');
    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');

    //     wrap.appendChild(btnLeft);
    //     wrap.appendChild(btnRight);

    //     iLeft = document.createElement('i');
    //     iRight = document.createElement('i');
    //     btnLeft.appendChild(iLeft);
    //     btnRight.appendChild(iRight);

    //     addClass(wrap, 'cr-rotate-controls');
    //     addClass(btnLeft, 'cr-rotate-l');
    //     addClass(btnRight, 'cr-rotate-r');

    //     self.elements.boundary.appendChild(wrap);

    //     btnLeft.addEventListener('click', function () {
    //         self.rotate(-90);
    //     });
    //     btnRight.addEventListener('click', function () {
    //         self.rotate(90);
    //     });
    // }

    function _hasExif() {
        return this.options.enableExif && window.EXIF;
    }

    function _initializeResize () {
        var self = this;
        var wrap = document.createElement('div');
        var isDragging = false;
        var direction;
        var originalX;
        var originalY;
        var minSize = 50;
        var maxWidth;
        var maxHeight;
        var vr;
        var hr;

        addClass(wrap, 'cr-resizer');
        css(wrap, {
            width: this.options.viewport.width + 'px',
            height: this.options.viewport.height + 'px'
        });

        if (this.options.resizeControls.height) {
            vr = document.createElement('div');
            addClass(vr, 'cr-resizer-vertical');
            wrap.appendChild(vr);
        }

        if (this.options.resizeControls.width) {
            hr = document.createElement('div');
            addClass(hr, 'cr-resizer-horisontal');
            wrap.appendChild(hr);
        }

        function mouseDown(ev) {
            if (ev.button !== undefined && ev.button !== 0) return;

            ev.preventDefault();
            if (isDragging) {
                return;
            }

            var overlayRect = self.elements.overlay.getBoundingClientRect();

            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;
            direction = ev.currentTarget.className.indexOf('vertical') !== -1 ? 'v' : 'h';
            maxWidth = overlayRect.width;
            maxHeight = overlayRect.height;

            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }

            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
        }

        function mouseMove(ev) {
            var pageX = ev.pageX;
            var pageY = ev.pageY;

            ev.preventDefault();

            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }

            var deltaX = pageX - originalX;
            var deltaY = pageY - originalY;
            var newHeight = self.options.viewport.height + deltaY;
            var newWidth = self.options.viewport.width + deltaX;

            if (direction === 'v' && newHeight >= minSize && newHeight <= maxHeight) {
                css(wrap, {
                    height: newHeight + 'px'
                });

                self.options.boundary.height += deltaY;
                css(self.elements.boundary, {
                    height: self.options.boundary.height + 'px'
                });

                self.options.viewport.height += deltaY;
                css(self.elements.viewport, {
                    height: self.options.viewport.height + 'px'
                });
            }
            else if (direction === 'h' && newWidth >= minSize && newWidth <= maxWidth) {
                css(wrap, {
                    width: newWidth + 'px'
                });

                self.options.boundary.width += deltaX;
                css(self.elements.boundary, {
                    width: self.options.boundary.width + 'px'
                });

                self.options.viewport.width += deltaX;
                css(self.elements.viewport, {
                    width: self.options.viewport.width + 'px'
                });
            }

            _updateOverlay.call(self);
            _updateZoomLimits.call(self);
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalY = pageY;
            originalX = pageX;
        }

        function mouseUp() {
            isDragging = false;
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
        }

        if (vr) {
            vr.addEventListener('mousedown', mouseDown);
            vr.addEventListener('touchstart', mouseDown);
        }

        if (hr) {
            hr.addEventListener('mousedown', mouseDown);
            hr.addEventListener('touchstart', mouseDown);
        }

        this.elements.boundary.appendChild(wrap);
    }

    function _setZoomerVal(v) {
        if (this.options.enableZoom) {
            var z = this.elements.zoomer,
                val = fix(v, 4);

            z.value = Math.max(parseFloat(z.min), Math.min(parseFloat(z.max), val)).toString();
        }
    }

    function _initializeZoom() {
        var self = this,
            wrap = self.elements.zoomerWrap = document.createElement('div'),
            zoomer = self.elements.zoomer = document.createElement('input');

        addClass(wrap, 'cr-slider-wrap');
        addClass(zoomer, 'cr-slider');
        zoomer.type = 'range';
        zoomer.step = '0.0001';
        zoomer.value = '1';
        zoomer.style.display = self.options.showZoomer ? '' : 'none';
        zoomer.setAttribute('aria-label', 'zoom');

        self.element.appendChild(wrap);
        wrap.appendChild(zoomer);

        self._currentZoom = 1;

        function change() {
            _onZoom.call(self, {
                value: parseFloat(zoomer.value),
                origin: new TransformOrigin(self.elements.preview),
                viewportRect: self.elements.viewport.getBoundingClientRect(),
                transform: Transform.parse(self.elements.preview)
            });
        }

        function scroll(ev) {
            var delta, targetZoom;

            if(self.options.mouseWheelZoom === 'ctrl' && ev.ctrlKey !== true){
                return 0;
            } else if (ev.wheelDelta) {
                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
            } else if (ev.deltaY) {
                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
            } else if (ev.detail) {
                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
            } else {
                delta = 0;
            }

            targetZoom = self._currentZoom + (delta * self._currentZoom);

            ev.preventDefault();
            _setZoomerVal.call(self, targetZoom);
            change.call(self);
        }

        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
        self.elements.zoomer.addEventListener('change', change);

        if (self.options.mouseWheelZoom) {
            self.elements.boundary.addEventListener('mousewheel', scroll);
            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
        }
    }

    function _onZoom(ui) {
        var self = this,
            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview);

        function applyCss() {
            var transCss = {};
            transCss[CSS_TRANSFORM] = transform.toString();
            transCss[CSS_TRANS_ORG] = origin.toString();
            css(self.elements.preview, transCss);
        }

        self._currentZoom = ui ? ui.value : self._currentZoom;
        transform.scale = self._currentZoom;
        self.elements.zoomer.setAttribute('aria-valuenow', self._currentZoom);
        applyCss();

        if (self.options.enforceBoundary) {
            var boundaries = _getVirtualBoundaries.call(self, vpRect),
                transBoundaries = boundaries.translate,
                oBoundaries = boundaries.origin;

            if (transform.x >= transBoundaries.maxX) {
                origin.x = oBoundaries.minX;
                transform.x = transBoundaries.maxX;
            }

            if (transform.x <= transBoundaries.minX) {
                origin.x = oBoundaries.maxX;
                transform.x = transBoundaries.minX;
            }

            if (transform.y >= transBoundaries.maxY) {
                origin.y = oBoundaries.minY;
                transform.y = transBoundaries.maxY;
            }

            if (transform.y <= transBoundaries.minY) {
                origin.y = oBoundaries.maxY;
                transform.y = transBoundaries.minY;
            }
        }
        applyCss();
        _debouncedOverlay.call(self);
        _triggerUpdate.call(self);
    }

    function _getVirtualBoundaries(viewport) {
        var self = this,
            scale = self._currentZoom,
            vpWidth = viewport.width,
            vpHeight = viewport.height,
            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
            imgRect = self.elements.preview.getBoundingClientRect(),
            curImgWidth = imgRect.width,
            curImgHeight = imgRect.height,
            halfWidth = vpWidth / 2,
            halfHeight = vpHeight / 2;

        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));

        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));

        var originMinX = (1 / scale) * halfWidth;
        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;

        var originMinY = (1 / scale) * halfHeight;
        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;

        return {
            translate: {
                maxX: maxX,
                minX: minX,
                maxY: maxY,
                minY: minY
            },
            origin: {
                maxX: originMaxX,
                minX: originMinX,
                maxY: originMaxY,
                minY: originMinY
            }
        };
    }

    function _updateCenterPoint(rotate) {
        var self = this,
            scale = self._currentZoom,
            data = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
            pc = new TransformOrigin(self.elements.preview),
            top = (vpData.top - data.top) + (vpData.height / 2),
            left = (vpData.left - data.left) + (vpData.width / 2),
            center = {},
            adj = {};

        if (rotate) {
            var cx = pc.x;
            var cy = pc.y;
            var tx = transform.x;
            var ty = transform.y;

            center.y = cx;
            center.x = cy;
            transform.y = tx;
            transform.x = ty;
        }
        else {
            center.y = top / scale;
            center.x = left / scale;

            adj.y = (center.y - pc.y) * (1 - scale);
            adj.x = (center.x - pc.x) * (1 - scale);

            transform.x -= adj.x;
            transform.y -= adj.y;
        }

        var newCss = {};
        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
        newCss[CSS_TRANSFORM] = transform.toString();
        css(self.elements.preview, newCss);
    }

    function _initDraggable() {
        var self = this,
            isDragging = false,
            originalX,
            originalY,
            originalDistance,
            vpRect,
            transform;

        function assignTransformCoordinates(deltaX, deltaY) {
            var imgRect = self.elements.preview.getBoundingClientRect(),
                top = transform.y + deltaY,
                left = transform.x + deltaX;

            if (self.options.enforceBoundary) {
                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
                    transform.y = top;
                }

                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
                    transform.x = left;
                }
            }
            else {
                transform.y = top;
                transform.x = left;
            }
        }

        function toggleGrabState(isDragging) {
            self.elements.preview.setAttribute('aria-grabbed', isDragging);
            self.elements.boundary.setAttribute('aria-dropeffect', isDragging? 'move': 'none');
        }

        function keyDown(ev) {
            var LEFT_ARROW  = 37,
                UP_ARROW    = 38,
                RIGHT_ARROW = 39,
                DOWN_ARROW  = 40;

            if (ev.shiftKey && (ev.keyCode === UP_ARROW || ev.keyCode === DOWN_ARROW)) {
                var zoom;
                if (ev.keyCode === UP_ARROW) {
                    zoom = parseFloat(self.elements.zoomer.value) + parseFloat(self.elements.zoomer.step)
                }
                else {
                    zoom = parseFloat(self.elements.zoomer.value) - parseFloat(self.elements.zoomer.step)
                }
                self.setZoom(zoom);
            }
            else if (self.options.enableKeyMovement && (ev.keyCode >= 37 && ev.keyCode <= 40)) {
                ev.preventDefault();
                var movement = parseKeyDown(ev.keyCode);

                transform = Transform.parse(self.elements.preview);
                document.body.style[CSS_USERSELECT] = 'none';
                vpRect = self.elements.viewport.getBoundingClientRect();
                keyMove(movement);
            }

            function parseKeyDown(key) {
                switch (key) {
                    case LEFT_ARROW:
                        return [1, 0];
                    case UP_ARROW:
                        return [0, 1];
                    case RIGHT_ARROW:
                        return [-1, 0];
                    case DOWN_ARROW:
                        return [0, -1];
                }
            }
        }

        function keyMove(movement) {
            var deltaX = movement[0],
                deltaY = movement[1],
                newCss = {};

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        function mouseDown(ev) {
            if (ev.button !== undefined && ev.button !== 0) return;

            ev.preventDefault();
            if (isDragging) return;
            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }
            toggleGrabState(isDragging);
            transform = Transform.parse(self.elements.preview);
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
            vpRect = self.elements.viewport.getBoundingClientRect();
        }

        function mouseMove(ev) {
            ev.preventDefault();
            var pageX = ev.pageX,
                pageY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }

            var deltaX = pageX - originalX,
                deltaY = pageY - originalY,
                newCss = {};

            if (ev.type === 'touchmove') {
                if (ev.touches.length > 1) {
                    var touch1 = ev.touches[0];
                    var touch2 = ev.touches[1];
                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));

                    if (!originalDistance) {
                        originalDistance = dist / self._currentZoom;
                    }

                    var scale = dist / originalDistance;

                    _setZoomerVal.call(self, scale);
                    dispatchChange(self.elements.zoomer);
                    return;
                }
            }

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            originalY = pageY;
            originalX = pageX;
        }

        function mouseUp() {
            isDragging = false;
            toggleGrabState(isDragging);
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        self.elements.overlay.addEventListener('mousedown', mouseDown);
        self.elements.viewport.addEventListener('keydown', keyDown);
        self.elements.overlay.addEventListener('touchstart', mouseDown);
    }

    function _updateOverlay() {
        if (!this.elements) return; // since this is debounced, it can be fired after destroy
        var self = this,
            boundRect = self.elements.boundary.getBoundingClientRect(),
            imgData = self.elements.preview.getBoundingClientRect();

        css(self.elements.overlay, {
            width: imgData.width + 'px',
            height: imgData.height + 'px',
            top: (imgData.top - boundRect.top) + 'px',
            left: (imgData.left - boundRect.left) + 'px'
        });
    }
    var _debouncedOverlay = debounce(_updateOverlay, 500);

    function _triggerUpdate() {
        var self = this,
            data = self.get();

        if (!_isVisible.call(self)) {
            return;
        }

        self.options.update.call(self, data);
        if (self.$ && typeof Prototype === 'undefined') {
            self.$(self.element).trigger('update.croppie', data);
        }
        else {
            var ev;
            if (window.CustomEvent) {
                ev = new CustomEvent('update', { detail: data });
            } else {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('update', true, true, data);
            }

            self.element.dispatchEvent(ev);
        }
    }

    function _isVisible() {
        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
    }

    function _updatePropertiesFromImage() {
        var self = this,
            initialZoom = 1,
            cssReset = {},
            img = self.elements.preview,
            imgData,
            transformReset = new Transform(0, 0, initialZoom),
            originReset = new TransformOrigin(),
            isVisible = _isVisible.call(self);

        if (!isVisible || self.data.bound) {// if the croppie isn't visible or it doesn't need binding
            return;
        }

        self.data.bound = true;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        cssReset[CSS_TRANS_ORG] = originReset.toString();
        cssReset['opacity'] = 1;
        css(img, cssReset);

        imgData = self.elements.preview.getBoundingClientRect();

        self._originalImageWidth = imgData.width;
        self._originalImageHeight = imgData.height;
        self.data.orientation = getExifOrientation(self.elements.img);

        if (self.options.enableZoom) {
            _updateZoomLimits.call(self, true);
        }
        else {
            self._currentZoom = initialZoom;
        }

        transformReset.scale = self._currentZoom;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        css(img, cssReset);

        if (self.data.points.length) {
            _bindPoints.call(self, self.data.points);
        }
        else {
            _centerImage.call(self);
        }

        _updateCenterPoint.call(self);
        _updateOverlay.call(self);
    }

    function _updateZoomLimits (initial) {
        var self = this,
            minZoom = Math.max(self.options.minZoom, 0) || 0,
            maxZoom = self.options.maxZoom || 1.5,
            initialZoom,
            defaultInitialZoom,
            zoomer = self.elements.zoomer,
            scale = parseFloat(zoomer.value),
            boundaryData = self.elements.boundary.getBoundingClientRect(),
            imgData = naturalImageDimensions(self.elements.img, self.data.orientation),
            vpData = self.elements.viewport.getBoundingClientRect(),
            minW,
            minH;
        if (self.options.enforceBoundary) {
            minW = vpData.width / imgData.width;
            minH = vpData.height / imgData.height;
            minZoom = Math.max(minW, minH);
        }

        if (minZoom >= maxZoom) {
            maxZoom = minZoom + 1;
        }

        zoomer.min = fix(minZoom, 4);
        zoomer.max = fix(maxZoom, 4);

        if (!initial && (scale < zoomer.min || scale > zoomer.max)) {
            _setZoomerVal.call(self, scale < zoomer.min ? zoomer.min : zoomer.max);
        }
        else if (initial) {
            defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
            _setZoomerVal.call(self, initialZoom);
        }

        dispatchChange(zoomer);
    }

    function _bindPoints(points) {
        if (points.length !== 4) {
            throw "Croppie - Invalid number of points supplied: " + points;
        }
        var self = this,
            pointsWidth = points[2] - points[0],
            // pointsHeight = points[3] - points[1],
            vpData = self.elements.viewport.getBoundingClientRect(),
            boundRect = self.elements.boundary.getBoundingClientRect(),
            vpOffset = {
                left: vpData.left - boundRect.left,
                top: vpData.top - boundRect.top
            },
            scale = vpData.width / pointsWidth,
            originTop = points[1],
            originLeft = points[0],
            transformTop = (-1 * points[1]) + vpOffset.top,
            transformLeft = (-1 * points[0]) + vpOffset.left,
            newCss = {};

        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
        css(self.elements.preview, newCss);

        _setZoomerVal.call(self, scale);
        self._currentZoom = scale;
    }

    function _centerImage() {
        var self = this,
            imgDim = self.elements.preview.getBoundingClientRect(),
            vpDim = self.elements.viewport.getBoundingClientRect(),
            boundDim = self.elements.boundary.getBoundingClientRect(),
            vpLeft = vpDim.left - boundDim.left,
            vpTop = vpDim.top - boundDim.top,
            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
            h = vpTop - ((imgDim.height - vpDim.height) / 2),
            transform = new Transform(w, h, self._currentZoom);

        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
    }

    function _transferImageToCanvas(customOrientation) {
        var self = this,
            canvas = self.elements.canvas,
            img = self.elements.img,
            ctx = canvas.getContext('2d');

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = img.width;
        canvas.height = img.height;

        var orientation = self.options.enableOrientation && customOrientation || getExifOrientation(img);
        drawCanvas(canvas, img, orientation);
    }

    function _getCanvas(data) {
        var self = this,
            points = data.points,
            left = num(points[0]),
            top = num(points[1]),
            right = num(points[2]),
            bottom = num(points[3]),
            width = right-left,
            height = bottom-top,
            circle = data.circle,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            startX = 0,
            startY = 0,
            canvasWidth = data.outputWidth || width,
            canvasHeight = data.outputHeight || height;

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        if (data.backgroundColor) {
            ctx.fillStyle = data.backgroundColor;
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        }

        // By default assume we're going to draw the entire
        // source image onto the destination canvas.
        var sx = left,
            sy = top,
            sWidth = width,
            sHeight = height,
            dx = 0,
            dy = 0,
            dWidth = canvasWidth,
            dHeight = canvasHeight;

        //
        // Do not go outside of the original image's bounds along the x-axis.
        // Handle translations when projecting onto the destination canvas.
        //

        // The smallest possible source x-position is 0.
        if (left < 0) {
            sx = 0;
            dx = (Math.abs(left) / width) * canvasWidth;
        }

        // The largest possible source width is the original image's width.
        if (sWidth + sx > self._originalImageWidth) {
            sWidth = self._originalImageWidth - sx;
            dWidth =  (sWidth / width) * canvasWidth;
        }

        //
        // Do not go outside of the original image's bounds along the y-axis.
        //

        // The smallest possible source y-position is 0.
        if (top < 0) {
            sy = 0;
            dy = (Math.abs(top) / height) * canvasHeight;
        }

        // The largest possible source height is the original image's height.
        if (sHeight + sy > self._originalImageHeight) {
            sHeight = self._originalImageHeight - sy;
            dHeight = (sHeight / height) * canvasHeight;
        }

        // console.table({ left, right, top, bottom, canvasWidth, canvasHeight, width, height, startX, startY, circle, sx, sy, dx, dy, sWidth, sHeight, dWidth, dHeight });

        ctx.drawImage(this.elements.preview, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        if (circle) {
            ctx.fillStyle = '#fff';
            ctx.globalCompositeOperation = 'destination-in';
            ctx.beginPath();
            ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
        }
        return canvas;
    }

    function _getHtmlResult(data) {
        var points = data.points,
            div = document.createElement('div'),
            img = document.createElement('img'),
            width = points[2] - points[0],
            height = points[3] - points[1];

        addClass(div, 'croppie-result');
        div.appendChild(img);
        css(img, {
            left: (-1 * points[0]) + 'px',
            top: (-1 * points[1]) + 'px'
        });
        img.src = data.url;
        css(div, {
            width: width + 'px',
            height: height + 'px'
        });

        return div;
    }

    function _getBase64Result(data) {
        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
    }

    function _getBlobResult(data) {
        var self = this;
        return new Promise(function (resolve) {
            _getCanvas.call(self, data).toBlob(function (blob) {
                resolve(blob);
            }, data.format, data.quality);
        });
    }

    function _replaceImage(img) {
        if (this.elements.img.parentNode) {
            Array.prototype.forEach.call(this.elements.img.classList, function(c) { img.classList.add(c); });
            this.elements.img.parentNode.replaceChild(img, this.elements.img);
            this.elements.preview = img; // if the img is attached to the DOM, they're not using the canvas
        }
        this.elements.img = img;
    }

    function _bind(options, cb) {
        var self = this,
            url,
            points = [],
            zoom = null,
            hasExif = _hasExif.call(self);

        if (typeof (options) === 'string') {
            url = options;
            options = {};
        }
        else if (Array.isArray(options)) {
            points = options.slice();
        }
        else if (typeof (options) === 'undefined' && self.data.url) { //refreshing
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            return null;
        }
        else {
            url = options.url;
            points = options.points || [];
            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
        }

        self.data.bound = false;
        self.data.url = url || self.data.url;
        self.data.boundZoom = zoom;

        return loadImage(url, hasExif).then(function (img) {
            _replaceImage.call(self, img);
            if (!points.length) {
                var natDim = naturalImageDimensions(img);
                var rect = self.elements.viewport.getBoundingClientRect();
                var aspectRatio = rect.width / rect.height;
                var imgAspectRatio = natDim.width / natDim.height;
                var width, height;

                if (imgAspectRatio > aspectRatio) {
                    height = natDim.height;
                    width = height * aspectRatio;
                }
                else {
                    width = natDim.width;
                    height = natDim.height / aspectRatio;
                }

                var x0 = (natDim.width - width) / 2;
                var y0 = (natDim.height - height) / 2;
                var x1 = x0 + width;
                var y1 = y0 + height;
                self.data.points = [x0, y0, x1, y1];
            }
            else if (self.options.relative) {
                points = [
                    points[0] * img.naturalWidth / 100,
                    points[1] * img.naturalHeight / 100,
                    points[2] * img.naturalWidth / 100,
                    points[3] * img.naturalHeight / 100
                ];
            }

            self.data.points = points.map(function (p) {
                return parseFloat(p);
            });
            if (self.options.useCanvas) {
                _transferImageToCanvas.call(self, options.orientation);
            }
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            cb && cb();
        });
    }

    function fix(v, decimalPoints) {
        return parseFloat(v).toFixed(decimalPoints || 0);
    }

    function _get() {
        var self = this,
            imgData = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            x1 = vpData.left - imgData.left,
            y1 = vpData.top - imgData.top,
            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2, //border
            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
            scale = self._currentZoom;

        if (scale === Infinity || isNaN(scale)) {
            scale = 1;
        }

        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
        x1 = Math.max(max, x1 / scale);
        y1 = Math.max(max, y1 / scale);
        x2 = Math.max(max, x2 / scale);
        y2 = Math.max(max, y2 / scale);

        return {
            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
            zoom: scale,
            orientation: self.data.orientation
        };
    }

    var RESULT_DEFAULTS = {
            type: 'canvas',
            format: 'png',
            quality: 1
        },
        RESULT_FORMATS = ['jpeg', 'webp', 'png'];

    function _result(options) {
        var self = this,
            data = _get.call(self),
            opts = deepExtend(clone(RESULT_DEFAULTS), clone(options)),
            resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
            size = opts.size || 'viewport',
            format = opts.format,
            quality = opts.quality,
            backgroundColor = opts.backgroundColor,
            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
            vpRect = self.elements.viewport.getBoundingClientRect(),
            ratio = vpRect.width / vpRect.height,
            prom;

        if (size === 'viewport') {
            data.outputWidth = vpRect.width;
            data.outputHeight = vpRect.height;
        } else if (typeof size === 'object') {
            if (size.width && size.height) {
                data.outputWidth = size.width;
                data.outputHeight = size.height;
            } else if (size.width) {
                data.outputWidth = size.width;
                data.outputHeight = size.width / ratio;
            } else if (size.height) {
                data.outputWidth = size.height * ratio;
                data.outputHeight = size.height;
            }
        }

        if (RESULT_FORMATS.indexOf(format) > -1) {
            data.format = 'image/' + format;
            data.quality = quality;
        }

        data.circle = circle;
        data.url = self.data.url;
        data.backgroundColor = backgroundColor;

        prom = new Promise(function (resolve) {
            switch(resultType.toLowerCase())
            {
                case 'rawcanvas':
                    resolve(_getCanvas.call(self, data));
                    break;
                case 'canvas':
                case 'base64':
                    resolve(_getBase64Result.call(self, data));
                    break;
                case 'blob':
                    _getBlobResult.call(self, data).then(resolve);
                    break;
                default:
                    resolve(_getHtmlResult.call(self, data));
                    break;
            }
        });
        return prom;
    }

    function _refresh() {
        _updatePropertiesFromImage.call(this);
    }

    function _rotate(deg) {
        if (!this.options.useCanvas || !this.options.enableOrientation) {
            throw 'Croppie: Cannot rotate without enableOrientation && EXIF.js included';
        }

        var self = this,
            canvas = self.elements.canvas;

        self.data.orientation = getExifOffset(self.data.orientation, deg);
        drawCanvas(canvas, self.elements.img, self.data.orientation);
        _updateCenterPoint.call(self, true);
        _updateZoomLimits.call(self);
    }

    function _destroy() {
        var self = this;
        self.element.removeChild(self.elements.boundary);
        removeClass(self.element, 'croppie-container');
        if (self.options.enableZoom) {
            self.element.removeChild(self.elements.zoomerWrap);
        }
        delete self.elements;
    }

    if (window.jQuery) {
        var $ = window.jQuery;
        $.fn.croppie = function (opts) {
            var ot = typeof opts;

            if (ot === 'string') {
                var args = Array.prototype.slice.call(arguments, 1);
                var singleInst = $(this).data('croppie');

                if (opts === 'get') {
                    return singleInst.get();
                }
                else if (opts === 'result') {
                    return singleInst.result.apply(singleInst, args);
                }
                else if (opts === 'bind') {
                    return singleInst.bind.apply(singleInst, args);
                }

                return this.each(function () {
                    var i = $(this).data('croppie');
                    if (!i) return;

                    var method = i[opts];
                    if ($.isFunction(method)) {
                        method.apply(i, args);
                        if (opts === 'destroy') {
                            $(this).removeData('croppie');
                        }
                    }
                    else {
                        throw 'Croppie ' + opts + ' method not found';
                    }
                });
            }
            else {
                return this.each(function () {
                    var i = new Croppie(this, opts);
                    i.$ = $;
                    $(this).data('croppie', i);
                });
            }
        };
    }

    function Croppie(element, opts) {
        if (element.className.indexOf('croppie-container') > -1) {
            throw new Error("Croppie: Can't initialize croppie more than once");
        }
        this.element = element;
        this.options = deepExtend(clone(Croppie.defaults), opts);

        if (this.element.tagName.toLowerCase() === 'img') {
            var origImage = this.element;
            addClass(origImage, 'cr-original-image');
            setAttributes(origImage, {'aria-hidden' : 'true', 'alt' : '' });
            var replacementDiv = document.createElement('div');
            this.element.parentNode.appendChild(replacementDiv);
            replacementDiv.appendChild(origImage);
            this.element = replacementDiv;
            this.options.url = this.options.url || origImage.src;
        }

        _create.call(this);
        if (this.options.url) {
            var bindOpts = {
                url: this.options.url,
                points: this.options.points
            };
            delete this.options['url'];
            delete this.options['points'];
            _bind.call(this, bindOpts);
        }
    }

    Croppie.defaults = {
        viewport: {
            width: 100,
            height: 100,
            type: 'square'
        },
        boundary: { },
        orientationControls: {
            enabled: true,
            leftClass: '',
            rightClass: ''
        },
        resizeControls: {
            width: true,
            height: true
        },
        customClass: '',
        showZoomer: true,
        enableZoom: true,
        enableResize: false,
        mouseWheelZoom: true,
        enableExif: false,
        enforceBoundary: true,
        enableOrientation: false,
        enableKeyMovement: true,
        update: function () { }
    };

    Croppie.globals = {
        translate: 'translate3d'
    };

    deepExtend(Croppie.prototype, {
        bind: function (options, cb) {
            return _bind.call(this, options, cb);
        },
        get: function () {
            var data = _get.call(this);
            var points = data.points;
            if (this.options.relative) {
                points[0] /= this.elements.img.naturalWidth / 100;
                points[1] /= this.elements.img.naturalHeight / 100;
                points[2] /= this.elements.img.naturalWidth / 100;
                points[3] /= this.elements.img.naturalHeight / 100;
            }
            return data;
        },
        result: function (type) {
            return _result.call(this, type);
        },
        refresh: function () {
            return _refresh.call(this);
        },
        setZoom: function (v) {
            _setZoomerVal.call(this, v);
            dispatchChange(this.elements.zoomer);
        },
        rotate: function (deg) {
            _rotate.call(this, deg);
        },
        destroy: function () {
            return _destroy.call(this);
        }
    });
    return Croppie;
}));

(function() {
    'use strict';

    angular
        .module('backApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('backApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function(){
    'user strict';
    angular.module('backApp')
    .directive('perm', perm);

    perm.$inject = ['Principal', '$q']
    function perm(Principal, $q) {
        var directive = {
            restrict: 'A',
            scope: false, 
            link: linkFunc
        };
        return directive;
        function linkFunc(scope, element, attrs) {
            var auth = attrs.perm; 
            if(auth.indexOf(",") <= 0){
                var result = Principal.hasAuthority(auth);
                $q.all([result.$promise]).then(function(){
                    if(!result.$$state.value){
                        element.hide();
                    }
                })
            }else{
                var authorities = auth.split(",");
                if(authorities !=null && authorities.length > 0){ 
                    var result = Principal.hasAnyAuthority(authorities);
                    if(!result){
                        element.hide();
                    }
                } else{
                    element.hide(); 
                }
            }
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('backApp')
		.factory('RegionService', RegionService);
 
	 RegionService.$inject = ['regions'];

	function RegionService(regions) {
		var $regions = {};
		var root = {};
		$regions['root'] = root;
		for (var i = 0; i < regions.length; i++) {
			var region = regions[i];
			$regions[region.c] = region;
			if (region.pc && $regions[region.pc]) {
				$regions[region.pc].children = $regions[region.pc].children || [];
				if ($regions[region.pc].children.indexOf(region) === -1) {
					$regions[region.pc].children.push(region);
					region.parent = $regions[region.pc];
				}
			}
			if (!region.pc) {
				region.parent = root;
				root.children = root.children || [];
				root.children.push(region);
			}
		}

		return {
			get: function(key) {
				return $regions[key];
			},
			getCountries: function() {
				return $regions['root'].children;
			}
		};
	}
})();

(function() {
		'use strict';
		angular
			.module('backApp')
			.factory('regions', regions);

		function regions() {
			var regions = [{
				"c": "86",
				"n": "中国"
			}, {
				"c": "110000",
				"n": "北京市",
				"pc": "86"
			}, {
				"c": "110100",
				"n": "北京市",
				"pc": "110000"
			}, {
				"c": "110101",
				"n": "东城区",
				"pc": "110100"
			}, {
				"c": "110102",
				"n": "西城区",
				"pc": "110100"
			}, {
				"c": "110105",
				"n": "朝阳区",
				"pc": "110100"
			}, {
				"c": "110106",
				"n": "丰台区",
				"pc": "110100"
			}, {
				"c": "110107",
				"n": "石景山区",
				"pc": "110100"
			}, {
				"c": "110108",
				"n": "海淀区",
				"pc": "110100"
			}, {
				"c": "110109",
				"n": "门头沟区",
				"pc": "110100"
			}, {
				"c": "110111",
				"n": "房山区",
				"pc": "110100"
			}, {
				"c": "110112",
				"n": "通州区",
				"pc": "110100"
			}, {
				"c": "110113",
				"n": "顺义区",
				"pc": "110100"
			}, {
				"c": "110114",
				"n": "昌平区",
				"pc": "110100"
			}, {
				"c": "110115",
				"n": "大兴区",
				"pc": "110100"
			}, {
				"c": "110116",
				"n": "怀柔区",
				"pc": "110100"
			}, {
				"c": "110117",
				"n": "平谷区",
				"pc": "110100"
			}, {
				"c": "110228",
				"n": "密云县",
				"pc": "110100"
			}, {
				"c": "110229",
				"n": "延庆县",
				"pc": "110100"
			}, {
				"c": "120000",
				"n": "天津市",
				"pc": "86"
			}, {
				"c": "120100",
				"n": "天津市",
				"pc": "120000"
			}, {
				"c": "120101",
				"n": "和平区",
				"pc": "120100"
			}, {
				"c": "120102",
				"n": "河东区",
				"pc": "120100"
			}, {
				"c": "120103",
				"n": "河西区",
				"pc": "120100"
			}, {
				"c": "120104",
				"n": "南开区",
				"pc": "120100"
			}, {
				"c": "120105",
				"n": "河北区",
				"pc": "120100"
			}, {
				"c": "120106",
				"n": "红桥区",
				"pc": "120100"
			}, {
				"c": "120110",
				"n": "东丽区",
				"pc": "120100"
			}, {
				"c": "120111",
				"n": "西青区",
				"pc": "120100"
			}, {
				"c": "120112",
				"n": "津南区",
				"pc": "120100"
			}, {
				"c": "120113",
				"n": "北辰区",
				"pc": "120100"
			}, {
				"c": "120114",
				"n": "武清区",
				"pc": "120100"
			}, {
				"c": "120115",
				"n": "宝坻区",
				"pc": "120100"
			}, {
				"c": "120116",
				"n": "滨海新区",
				"pc": "120100"
			}, {
				"c": "120221",
				"n": "宁河县",
				"pc": "120100"
			}, {
				"c": "120223",
				"n": "静海县",
				"pc": "120100"
			}, {
				"c": "120225",
				"n": "蓟县",
				"pc": "120100"
			}, {
				"c": "130000",
				"n": "河北省",
				"pc": "86"
			}, {
				"c": "130100",
				"n": "石家庄市",
				"pc": "130000"
			}, {
				"c": "130101",
				"n": "市辖区",
				"pc": "130100"
			}, {
				"c": "130102",
				"n": "长安区",
				"pc": "130100"
			}, {
				"c": "130103",
				"n": "桥东区",
				"pc": "130100"
			}, {
				"c": "130104",
				"n": "桥西区",
				"pc": "130100"
			}, {
				"c": "130105",
				"n": "新华区",
				"pc": "130100"
			}, {
				"c": "130107",
				"n": "井陉矿区",
				"pc": "130100"
			}, {
				"c": "130108",
				"n": "裕华区",
				"pc": "130100"
			}, {
				"c": "130121",
				"n": "井陉县",
				"pc": "130100"
			}, {
				"c": "130123",
				"n": "正定县",
				"pc": "130100"
			}, {
				"c": "130124",
				"n": "栾城县",
				"pc": "130100"
			}, {
				"c": "130125",
				"n": "行唐县",
				"pc": "130100"
			}, {
				"c": "130126",
				"n": "灵寿县",
				"pc": "130100"
			}, {
				"c": "130127",
				"n": "高邑县",
				"pc": "130100"
			}, {
				"c": "130128",
				"n": "深泽县",
				"pc": "130100"
			}, {
				"c": "130129",
				"n": "赞皇县",
				"pc": "130100"
			}, {
				"c": "130130",
				"n": "无极县",
				"pc": "130100"
			}, {
				"c": "130131",
				"n": "平山县",
				"pc": "130100"
			}, {
				"c": "130132",
				"n": "元氏县",
				"pc": "130100"
			}, {
				"c": "130133",
				"n": "赵县",
				"pc": "130100"
			}, {
				"c": "130181",
				"n": "辛集市",
				"pc": "130100"
			}, {
				"c": "130182",
				"n": "藁城市",
				"pc": "130100"
			}, {
				"c": "130183",
				"n": "晋州市",
				"pc": "130100"
			}, {
				"c": "130184",
				"n": "新乐市",
				"pc": "130100"
			}, {
				"c": "130185",
				"n": "鹿泉市",
				"pc": "130100"
			}, {
				"c": "130200",
				"n": "唐山市",
				"pc": "130000"
			}, {
				"c": "130201",
				"n": "市辖区",
				"pc": "130200"
			}, {
				"c": "130202",
				"n": "路南区",
				"pc": "130200"
			}, {
				"c": "130203",
				"n": "路北区",
				"pc": "130200"
			}, {
				"c": "130204",
				"n": "古冶区",
				"pc": "130200"
			}, {
				"c": "130205",
				"n": "开平区",
				"pc": "130200"
			}, {
				"c": "130207",
				"n": "丰南区",
				"pc": "130200"
			}, {
				"c": "130208",
				"n": "丰润区",
				"pc": "130200"
			}, {
				"c": "130209",
				"n": "曹妃甸区",
				"pc": "130200"
			}, {
				"c": "130223",
				"n": "滦县",
				"pc": "130200"
			}, {
				"c": "130224",
				"n": "滦南县",
				"pc": "130200"
			}, {
				"c": "130225",
				"n": "乐亭县",
				"pc": "130200"
			}, {
				"c": "130227",
				"n": "迁西县",
				"pc": "130200"
			}, {
				"c": "130229",
				"n": "玉田县",
				"pc": "130200"
			}, {
				"c": "130281",
				"n": "遵化市",
				"pc": "130200"
			}, {
				"c": "130283",
				"n": "迁安市",
				"pc": "130200"
			}, {
				"c": "130300",
				"n": "秦皇岛市",
				"pc": "130000"
			}, {
				"c": "130301",
				"n": "市辖区",
				"pc": "130300"
			}, {
				"c": "130302",
				"n": "海港区",
				"pc": "130300"
			}, {
				"c": "130303",
				"n": "山海关区",
				"pc": "130300"
			}, {
				"c": "130304",
				"n": "北戴河区",
				"pc": "130300"
			}, {
				"c": "130321",
				"n": "青龙满族自治县",
				"pc": "130300"
			}, {
				"c": "130322",
				"n": "昌黎县",
				"pc": "130300"
			}, {
				"c": "130323",
				"n": "抚宁县",
				"pc": "130300"
			}, {
				"c": "130324",
				"n": "卢龙县",
				"pc": "130300"
			}, {
				"c": "130400",
				"n": "邯郸市",
				"pc": "130000"
			}, {
				"c": "130401",
				"n": "市辖区",
				"pc": "130400"
			}, {
				"c": "130402",
				"n": "邯山区",
				"pc": "130400"
			}, {
				"c": "130403",
				"n": "丛台区",
				"pc": "130400"
			}, {
				"c": "130404",
				"n": "复兴区",
				"pc": "130400"
			}, {
				"c": "130406",
				"n": "峰峰矿区",
				"pc": "130400"
			}, {
				"c": "130421",
				"n": "邯郸县",
				"pc": "130400"
			}, {
				"c": "130423",
				"n": "临漳县",
				"pc": "130400"
			}, {
				"c": "130424",
				"n": "成安县",
				"pc": "130400"
			}, {
				"c": "130425",
				"n": "大名县",
				"pc": "130400"
			}, {
				"c": "130426",
				"n": "涉县",
				"pc": "130400"
			}, {
				"c": "130427",
				"n": "磁县",
				"pc": "130400"
			}, {
				"c": "130428",
				"n": "肥乡县",
				"pc": "130400"
			}, {
				"c": "130429",
				"n": "永年县",
				"pc": "130400"
			}, {
				"c": "130430",
				"n": "邱县",
				"pc": "130400"
			}, {
				"c": "130431",
				"n": "鸡泽县",
				"pc": "130400"
			}, {
				"c": "130432",
				"n": "广平县",
				"pc": "130400"
			}, {
				"c": "130433",
				"n": "馆陶县",
				"pc": "130400"
			}, {
				"c": "130434",
				"n": "魏县",
				"pc": "130400"
			}, {
				"c": "130435",
				"n": "曲周县",
				"pc": "130400"
			}, {
				"c": "130481",
				"n": "武安市",
				"pc": "130400"
			}, {
				"c": "130500",
				"n": "邢台市",
				"pc": "130000"
			}, {
				"c": "130501",
				"n": "市辖区",
				"pc": "130500"
			}, {
				"c": "130502",
				"n": "桥东区",
				"pc": "130500"
			}, {
				"c": "130503",
				"n": "桥西区",
				"pc": "130500"
			}, {
				"c": "130521",
				"n": "邢台县",
				"pc": "130500"
			}, {
				"c": "130522",
				"n": "临城县",
				"pc": "130500"
			}, {
				"c": "130523",
				"n": "内丘县",
				"pc": "130500"
			}, {
				"c": "130524",
				"n": "柏乡县",
				"pc": "130500"
			}, {
				"c": "130525",
				"n": "隆尧县",
				"pc": "130500"
			}, {
				"c": "130526",
				"n": "任县",
				"pc": "130500"
			}, {
				"c": "130527",
				"n": "南和县",
				"pc": "130500"
			}, {
				"c": "130528",
				"n": "宁晋县",
				"pc": "130500"
			}, {
				"c": "130529",
				"n": "巨鹿县",
				"pc": "130500"
			}, {
				"c": "130530",
				"n": "新河县",
				"pc": "130500"
			}, {
				"c": "130531",
				"n": "广宗县",
				"pc": "130500"
			}, {
				"c": "130532",
				"n": "平乡县",
				"pc": "130500"
			}, {
				"c": "130533",
				"n": "威县",
				"pc": "130500"
			}, {
				"c": "130534",
				"n": "清河县",
				"pc": "130500"
			}, {
				"c": "130535",
				"n": "临西县",
				"pc": "130500"
			}, {
				"c": "130581",
				"n": "南宫市",
				"pc": "130500"
			}, {
				"c": "130582",
				"n": "沙河市",
				"pc": "130500"
			}, {
				"c": "130600",
				"n": "保定市",
				"pc": "130000"
			}, {
				"c": "130601",
				"n": "市辖区",
				"pc": "130600"
			}, {
				"c": "130602",
				"n": "新市区",
				"pc": "130600"
			}, {
				"c": "130603",
				"n": "北市区",
				"pc": "130600"
			}, {
				"c": "130604",
				"n": "南市区",
				"pc": "130600"
			}, {
				"c": "130621",
				"n": "满城县",
				"pc": "130600"
			}, {
				"c": "130622",
				"n": "清苑县",
				"pc": "130600"
			}, {
				"c": "130623",
				"n": "涞水县",
				"pc": "130600"
			}, {
				"c": "130624",
				"n": "阜平县",
				"pc": "130600"
			}, {
				"c": "130625",
				"n": "徐水县",
				"pc": "130600"
			}, {
				"c": "130626",
				"n": "定兴县",
				"pc": "130600"
			}, {
				"c": "130627",
				"n": "唐县",
				"pc": "130600"
			}, {
				"c": "130628",
				"n": "高阳县",
				"pc": "130600"
			}, {
				"c": "130629",
				"n": "容城县",
				"pc": "130600"
			}, {
				"c": "130630",
				"n": "涞源县",
				"pc": "130600"
			}, {
				"c": "130631",
				"n": "望都县",
				"pc": "130600"
			}, {
				"c": "130632",
				"n": "安新县",
				"pc": "130600"
			}, {
				"c": "130633",
				"n": "易县",
				"pc": "130600"
			}, {
				"c": "130634",
				"n": "曲阳县",
				"pc": "130600"
			}, {
				"c": "130635",
				"n": "蠡县",
				"pc": "130600"
			}, {
				"c": "130636",
				"n": "顺平县",
				"pc": "130600"
			}, {
				"c": "130637",
				"n": "博野县",
				"pc": "130600"
			}, {
				"c": "130638",
				"n": "雄县",
				"pc": "130600"
			}, {
				"c": "130681",
				"n": "涿州市",
				"pc": "130600"
			}, {
				"c": "130682",
				"n": "定州市",
				"pc": "130600"
			}, {
				"c": "130683",
				"n": "安国市",
				"pc": "130600"
			}, {
				"c": "130684",
				"n": "高碑店市",
				"pc": "130600"
			}, {
				"c": "130700",
				"n": "张家口市",
				"pc": "130000"
			}, {
				"c": "130701",
				"n": "市辖区",
				"pc": "130700"
			}, {
				"c": "130702",
				"n": "桥东区",
				"pc": "130700"
			}, {
				"c": "130703",
				"n": "桥西区",
				"pc": "130700"
			}, {
				"c": "130705",
				"n": "宣化区",
				"pc": "130700"
			}, {
				"c": "130706",
				"n": "下花园区",
				"pc": "130700"
			}, {
				"c": "130721",
				"n": "宣化县",
				"pc": "130700"
			}, {
				"c": "130722",
				"n": "张北县",
				"pc": "130700"
			}, {
				"c": "130723",
				"n": "康保县",
				"pc": "130700"
			}, {
				"c": "130724",
				"n": "沽源县",
				"pc": "130700"
			}, {
				"c": "130725",
				"n": "尚义县",
				"pc": "130700"
			}, {
				"c": "130726",
				"n": "蔚县",
				"pc": "130700"
			}, {
				"c": "130727",
				"n": "阳原县",
				"pc": "130700"
			}, {
				"c": "130728",
				"n": "怀安县",
				"pc": "130700"
			}, {
				"c": "130729",
				"n": "万全县",
				"pc": "130700"
			}, {
				"c": "130730",
				"n": "怀来县",
				"pc": "130700"
			}, {
				"c": "130731",
				"n": "涿鹿县",
				"pc": "130700"
			}, {
				"c": "130732",
				"n": "赤城县",
				"pc": "130700"
			}, {
				"c": "130733",
				"n": "崇礼县",
				"pc": "130700"
			}, {
				"c": "130800",
				"n": "承德市",
				"pc": "130000"
			}, {
				"c": "130801",
				"n": "市辖区",
				"pc": "130800"
			}, {
				"c": "130802",
				"n": "双桥区",
				"pc": "130800"
			}, {
				"c": "130803",
				"n": "双滦区",
				"pc": "130800"
			}, {
				"c": "130804",
				"n": "鹰手营子矿区",
				"pc": "130800"
			}, {
				"c": "130821",
				"n": "承德县",
				"pc": "130800"
			}, {
				"c": "130822",
				"n": "兴隆县",
				"pc": "130800"
			}, {
				"c": "130823",
				"n": "平泉县",
				"pc": "130800"
			}, {
				"c": "130824",
				"n": "滦平县",
				"pc": "130800"
			}, {
				"c": "130825",
				"n": "隆化县",
				"pc": "130800"
			}, {
				"c": "130826",
				"n": "丰宁满族自治县",
				"pc": "130800"
			}, {
				"c": "130827",
				"n": "宽城满族自治县",
				"pc": "130800"
			}, {
				"c": "130828",
				"n": "围场满族蒙古族自治县",
				"pc": "130800"
			}, {
				"c": "130900",
				"n": "沧州市",
				"pc": "130000"
			}, {
				"c": "130901",
				"n": "市辖区",
				"pc": "130900"
			}, {
				"c": "130902",
				"n": "新华区",
				"pc": "130900"
			}, {
				"c": "130903",
				"n": "运河区",
				"pc": "130900"
			}, {
				"c": "130921",
				"n": "沧县",
				"pc": "130900"
			}, {
				"c": "130922",
				"n": "青县",
				"pc": "130900"
			}, {
				"c": "130923",
				"n": "东光县",
				"pc": "130900"
			}, {
				"c": "130924",
				"n": "海兴县",
				"pc": "130900"
			}, {
				"c": "130925",
				"n": "盐山县",
				"pc": "130900"
			}, {
				"c": "130926",
				"n": "肃宁县",
				"pc": "130900"
			}, {
				"c": "130927",
				"n": "南皮县",
				"pc": "130900"
			}, {
				"c": "130928",
				"n": "吴桥县",
				"pc": "130900"
			}, {
				"c": "130929",
				"n": "献县",
				"pc": "130900"
			}, {
				"c": "130930",
				"n": "孟村回族自治县",
				"pc": "130900"
			}, {
				"c": "130981",
				"n": "泊头市",
				"pc": "130900"
			}, {
				"c": "130982",
				"n": "任丘市",
				"pc": "130900"
			}, {
				"c": "130983",
				"n": "黄骅市",
				"pc": "130900"
			}, {
				"c": "130984",
				"n": "河间市",
				"pc": "130900"
			}, {
				"c": "131000",
				"n": "廊坊市",
				"pc": "130000"
			}, {
				"c": "131001",
				"n": "市辖区",
				"pc": "131000"
			}, {
				"c": "131002",
				"n": "安次区",
				"pc": "131000"
			}, {
				"c": "131003",
				"n": "广阳区",
				"pc": "131000"
			}, {
				"c": "131022",
				"n": "固安县",
				"pc": "131000"
			}, {
				"c": "131023",
				"n": "永清县",
				"pc": "131000"
			}, {
				"c": "131024",
				"n": "香河县",
				"pc": "131000"
			}, {
				"c": "131025",
				"n": "大城县",
				"pc": "131000"
			}, {
				"c": "131026",
				"n": "文安县",
				"pc": "131000"
			}, {
				"c": "131028",
				"n": "大厂回族自治县",
				"pc": "131000"
			}, {
				"c": "131081",
				"n": "霸州市",
				"pc": "131000"
			}, {
				"c": "131082",
				"n": "三河市",
				"pc": "131000"
			}, {
				"c": "131100",
				"n": "衡水市",
				"pc": "130000"
			}, {
				"c": "131101",
				"n": "市辖区",
				"pc": "131100"
			}, {
				"c": "131102",
				"n": "桃城区",
				"pc": "131100"
			}, {
				"c": "131121",
				"n": "枣强县",
				"pc": "131100"
			}, {
				"c": "131122",
				"n": "武邑县",
				"pc": "131100"
			}, {
				"c": "131123",
				"n": "武强县",
				"pc": "131100"
			}, {
				"c": "131124",
				"n": "饶阳县",
				"pc": "131100"
			}, {
				"c": "131125",
				"n": "安平县",
				"pc": "131100"
			}, {
				"c": "131126",
				"n": "故城县",
				"pc": "131100"
			}, {
				"c": "131127",
				"n": "景县",
				"pc": "131100"
			}, {
				"c": "131128",
				"n": "阜城县",
				"pc": "131100"
			}, {
				"c": "131181",
				"n": "冀州市",
				"pc": "131100"
			}, {
				"c": "131182",
				"n": "深州市",
				"pc": "131100"
			}, {
				"c": "140000",
				"n": "山西省",
				"pc": "86"
			}, {
				"c": "140100",
				"n": "太原市",
				"pc": "140000"
			}, {
				"c": "140101",
				"n": "市辖区",
				"pc": "140100"
			}, {
				"c": "140105",
				"n": "小店区",
				"pc": "140100"
			}, {
				"c": "140106",
				"n": "迎泽区",
				"pc": "140100"
			}, {
				"c": "140107",
				"n": "杏花岭区",
				"pc": "140100"
			}, {
				"c": "140108",
				"n": "尖草坪区",
				"pc": "140100"
			}, {
				"c": "140109",
				"n": "万柏林区",
				"pc": "140100"
			}, {
				"c": "140110",
				"n": "晋源区",
				"pc": "140100"
			}, {
				"c": "140121",
				"n": "清徐县",
				"pc": "140100"
			}, {
				"c": "140122",
				"n": "阳曲县",
				"pc": "140100"
			}, {
				"c": "140123",
				"n": "娄烦县",
				"pc": "140100"
			}, {
				"c": "140181",
				"n": "古交市",
				"pc": "140100"
			}, {
				"c": "140200",
				"n": "大同市",
				"pc": "140000"
			}, {
				"c": "140201",
				"n": "市辖区",
				"pc": "140200"
			}, {
				"c": "140202",
				"n": "城区",
				"pc": "140200"
			}, {
				"c": "140203",
				"n": "矿区",
				"pc": "140200"
			}, {
				"c": "140211",
				"n": "南郊区",
				"pc": "140200"
			}, {
				"c": "140212",
				"n": "新荣区",
				"pc": "140200"
			}, {
				"c": "140221",
				"n": "阳高县",
				"pc": "140200"
			}, {
				"c": "140222",
				"n": "天镇县",
				"pc": "140200"
			}, {
				"c": "140223",
				"n": "广灵县",
				"pc": "140200"
			}, {
				"c": "140224",
				"n": "灵丘县",
				"pc": "140200"
			}, {
				"c": "140225",
				"n": "浑源县",
				"pc": "140200"
			}, {
				"c": "140226",
				"n": "左云县",
				"pc": "140200"
			}, {
				"c": "140227",
				"n": "大同县",
				"pc": "140200"
			}, {
				"c": "140300",
				"n": "阳泉市",
				"pc": "140000"
			}, {
				"c": "140301",
				"n": "市辖区",
				"pc": "140300"
			}, {
				"c": "140302",
				"n": "城区",
				"pc": "140300"
			}, {
				"c": "140303",
				"n": "矿区",
				"pc": "140300"
			}, {
				"c": "140311",
				"n": "郊区",
				"pc": "140300"
			}, {
				"c": "140321",
				"n": "平定县",
				"pc": "140300"
			}, {
				"c": "140322",
				"n": "盂县",
				"pc": "140300"
			}, {
				"c": "140400",
				"n": "长治市",
				"pc": "140000"
			}, {
				"c": "140401",
				"n": "市辖区",
				"pc": "140400"
			}, {
				"c": "140402",
				"n": "城区",
				"pc": "140400"
			}, {
				"c": "140411",
				"n": "郊区",
				"pc": "140400"
			}, {
				"c": "140421",
				"n": "长治县",
				"pc": "140400"
			}, {
				"c": "140423",
				"n": "襄垣县",
				"pc": "140400"
			}, {
				"c": "140424",
				"n": "屯留县",
				"pc": "140400"
			}, {
				"c": "140425",
				"n": "平顺县",
				"pc": "140400"
			}, {
				"c": "140426",
				"n": "黎城县",
				"pc": "140400"
			}, {
				"c": "140427",
				"n": "壶关县",
				"pc": "140400"
			}, {
				"c": "140428",
				"n": "长子县",
				"pc": "140400"
			}, {
				"c": "140429",
				"n": "武乡县",
				"pc": "140400"
			}, {
				"c": "140430",
				"n": "沁县",
				"pc": "140400"
			}, {
				"c": "140431",
				"n": "沁源县",
				"pc": "140400"
			}, {
				"c": "140481",
				"n": "潞城市",
				"pc": "140400"
			}, {
				"c": "140500",
				"n": "晋城市",
				"pc": "140000"
			}, {
				"c": "140501",
				"n": "晋城市市辖区",
				"pc": "140500"
			}, {
				"c": "140502",
				"n": "城区",
				"pc": "140500"
			}, {
				"c": "140521",
				"n": "沁水县",
				"pc": "140500"
			}, {
				"c": "140522",
				"n": "阳城县",
				"pc": "140500"
			}, {
				"c": "140524",
				"n": "陵川县",
				"pc": "140500"
			}, {
				"c": "140525",
				"n": "泽州县",
				"pc": "140500"
			}, {
				"c": "140581",
				"n": "高平市",
				"pc": "140500"
			}, {
				"c": "140600",
				"n": "朔州市",
				"pc": "140000"
			}, {
				"c": "140601",
				"n": "市辖区",
				"pc": "140600"
			}, {
				"c": "140602",
				"n": "朔城区",
				"pc": "140600"
			}, {
				"c": "140603",
				"n": "平鲁区",
				"pc": "140600"
			}, {
				"c": "140621",
				"n": "山阴县",
				"pc": "140600"
			}, {
				"c": "140622",
				"n": "应县",
				"pc": "140600"
			}, {
				"c": "140623",
				"n": "右玉县",
				"pc": "140600"
			}, {
				"c": "140624",
				"n": "怀仁县",
				"pc": "140600"
			}, {
				"c": "140700",
				"n": "晋中市",
				"pc": "140000"
			}, {
				"c": "140701",
				"n": "市辖区",
				"pc": "140700"
			}, {
				"c": "140702",
				"n": "榆次区",
				"pc": "140700"
			}, {
				"c": "140721",
				"n": "榆社县",
				"pc": "140700"
			}, {
				"c": "140722",
				"n": "左权县",
				"pc": "140700"
			}, {
				"c": "140723",
				"n": "和顺县",
				"pc": "140700"
			}, {
				"c": "140724",
				"n": "昔阳县",
				"pc": "140700"
			}, {
				"c": "140725",
				"n": "寿阳县",
				"pc": "140700"
			}, {
				"c": "140726",
				"n": "太谷县",
				"pc": "140700"
			}, {
				"c": "140727",
				"n": "祁县",
				"pc": "140700"
			}, {
				"c": "140728",
				"n": "平遥县",
				"pc": "140700"
			}, {
				"c": "140729",
				"n": "灵石县",
				"pc": "140700"
			}, {
				"c": "140781",
				"n": "介休市",
				"pc": "140700"
			}, {
				"c": "140800",
				"n": "运城市",
				"pc": "140000"
			}, {
				"c": "140801",
				"n": "市辖区",
				"pc": "140800"
			}, {
				"c": "140802",
				"n": "盐湖区",
				"pc": "140800"
			}, {
				"c": "140821",
				"n": "临猗县",
				"pc": "140800"
			}, {
				"c": "140822",
				"n": "万荣县",
				"pc": "140800"
			}, {
				"c": "140823",
				"n": "闻喜县",
				"pc": "140800"
			}, {
				"c": "140824",
				"n": "稷山县",
				"pc": "140800"
			}, {
				"c": "140825",
				"n": "新绛县",
				"pc": "140800"
			}, {
				"c": "140826",
				"n": "绛县",
				"pc": "140800"
			}, {
				"c": "140827",
				"n": "垣曲县",
				"pc": "140800"
			}, {
				"c": "140828",
				"n": "夏县",
				"pc": "140800"
			}, {
				"c": "140829",
				"n": "平陆县",
				"pc": "140800"
			}, {
				"c": "140830",
				"n": "芮城县",
				"pc": "140800"
			}, {
				"c": "140881",
				"n": "永济市",
				"pc": "140800"
			}, {
				"c": "140882",
				"n": "河津市",
				"pc": "140800"
			}, {
				"c": "140900",
				"n": "忻州市",
				"pc": "140000"
			}, {
				"c": "140901",
				"n": "市辖区",
				"pc": "140900"
			}, {
				"c": "140902",
				"n": "忻府区",
				"pc": "140900"
			}, {
				"c": "140921",
				"n": "定襄县",
				"pc": "140900"
			}, {
				"c": "140922",
				"n": "五台县",
				"pc": "140900"
			}, {
				"c": "140923",
				"n": "代县",
				"pc": "140900"
			}, {
				"c": "140924",
				"n": "繁峙县",
				"pc": "140900"
			}, {
				"c": "140925",
				"n": "宁武县",
				"pc": "140900"
			}, {
				"c": "140926",
				"n": "静乐县",
				"pc": "140900"
			}, {
				"c": "140927",
				"n": "神池县",
				"pc": "140900"
			}, {
				"c": "140928",
				"n": "五寨县",
				"pc": "140900"
			}, {
				"c": "140929",
				"n": "岢岚县",
				"pc": "140900"
			}, {
				"c": "140930",
				"n": "河曲县",
				"pc": "140900"
			}, {
				"c": "140931",
				"n": "保德县",
				"pc": "140900"
			}, {
				"c": "140932",
				"n": "偏关县",
				"pc": "140900"
			}, {
				"c": "140981",
				"n": "原平市",
				"pc": "140900"
			}, {
				"c": "141000",
				"n": "临汾市",
				"pc": "140000"
			}, {
				"c": "141001",
				"n": "市辖区",
				"pc": "141000"
			}, {
				"c": "141002",
				"n": "尧都区",
				"pc": "141000"
			}, {
				"c": "141021",
				"n": "曲沃县",
				"pc": "141000"
			}, {
				"c": "141022",
				"n": "翼城县",
				"pc": "141000"
			}, {
				"c": "141023",
				"n": "襄汾县",
				"pc": "141000"
			}, {
				"c": "141024",
				"n": "洪洞县",
				"pc": "141000"
			}, {
				"c": "141025",
				"n": "古县",
				"pc": "141000"
			}, {
				"c": "141026",
				"n": "安泽县",
				"pc": "141000"
			}, {
				"c": "141027",
				"n": "浮山县",
				"pc": "141000"
			}, {
				"c": "141028",
				"n": "吉县",
				"pc": "141000"
			}, {
				"c": "141029",
				"n": "乡宁县",
				"pc": "141000"
			}, {
				"c": "141030",
				"n": "大宁县",
				"pc": "141000"
			}, {
				"c": "141031",
				"n": "隰县",
				"pc": "141000"
			}, {
				"c": "141032",
				"n": "永和县",
				"pc": "141000"
			}, {
				"c": "141033",
				"n": "蒲县",
				"pc": "141000"
			}, {
				"c": "141034",
				"n": "汾西县",
				"pc": "141000"
			}, {
				"c": "141081",
				"n": "侯马市",
				"pc": "141000"
			}, {
				"c": "141082",
				"n": "霍州市",
				"pc": "141000"
			}, {
				"c": "141100",
				"n": "吕梁市",
				"pc": "140000"
			}, {
				"c": "141101",
				"n": "市辖区",
				"pc": "141100"
			}, {
				"c": "141102",
				"n": "离石区",
				"pc": "141100"
			}, {
				"c": "141121",
				"n": "文水县",
				"pc": "141100"
			}, {
				"c": "141122",
				"n": "交城县",
				"pc": "141100"
			}, {
				"c": "141123",
				"n": "兴县",
				"pc": "141100"
			}, {
				"c": "141124",
				"n": "临县",
				"pc": "141100"
			}, {
				"c": "141125",
				"n": "柳林县",
				"pc": "141100"
			}, {
				"c": "141126",
				"n": "石楼县",
				"pc": "141100"
			}, {
				"c": "141127",
				"n": "岚县",
				"pc": "141100"
			}, {
				"c": "141128",
				"n": "方山县",
				"pc": "141100"
			}, {
				"c": "141129",
				"n": "中阳县",
				"pc": "141100"
			}, {
				"c": "141130",
				"n": "交口县",
				"pc": "141100"
			}, {
				"c": "141181",
				"n": "孝义市",
				"pc": "141100"
			}, {
				"c": "141182",
				"n": "汾阳市",
				"pc": "141100"
			}, {
				"c": "150000",
				"n": "内蒙古自治区",
				"pc": "86"
			}, {
				"c": "150100",
				"n": "呼和浩特市",
				"pc": "150000"
			}, {
				"c": "150101",
				"n": "市辖区",
				"pc": "150100"
			}, {
				"c": "150102",
				"n": "新城区",
				"pc": "150100"
			}, {
				"c": "150103",
				"n": "回民区",
				"pc": "150100"
			}, {
				"c": "150104",
				"n": "玉泉区",
				"pc": "150100"
			}, {
				"c": "150105",
				"n": "赛罕区",
				"pc": "150100"
			}, {
				"c": "150121",
				"n": "土默特左旗",
				"pc": "150100"
			}, {
				"c": "150122",
				"n": "托克托县",
				"pc": "150100"
			}, {
				"c": "150123",
				"n": "和林格尔县",
				"pc": "150100"
			}, {
				"c": "150124",
				"n": "清水河县",
				"pc": "150100"
			}, {
				"c": "150125",
				"n": "武川县",
				"pc": "150100"
			}, {
				"c": "150200",
				"n": "包头市",
				"pc": "150000"
			}, {
				"c": "150201",
				"n": "市辖区",
				"pc": "150200"
			}, {
				"c": "150202",
				"n": "东河区",
				"pc": "150200"
			}, {
				"c": "150203",
				"n": "昆都仑区",
				"pc": "150200"
			}, {
				"c": "150204",
				"n": "青山区",
				"pc": "150200"
			}, {
				"c": "150205",
				"n": "石拐区",
				"pc": "150200"
			}, {
				"c": "150206",
				"n": "白云鄂博矿区",
				"pc": "150200"
			}, {
				"c": "150207",
				"n": "九原区",
				"pc": "150200"
			}, {
				"c": "150221",
				"n": "土默特右旗",
				"pc": "150200"
			}, {
				"c": "150222",
				"n": "固阳县",
				"pc": "150200"
			}, {
				"c": "150223",
				"n": "达尔罕茂明安联合旗",
				"pc": "150200"
			}, {
				"c": "150300",
				"n": "乌海市",
				"pc": "150000"
			}, {
				"c": "150301",
				"n": "市辖区",
				"pc": "150300"
			}, {
				"c": "150302",
				"n": "海勃湾区",
				"pc": "150300"
			}, {
				"c": "150303",
				"n": "海南区",
				"pc": "150300"
			}, {
				"c": "150304",
				"n": "乌达区",
				"pc": "150300"
			}, {
				"c": "150400",
				"n": "赤峰市",
				"pc": "150000"
			}, {
				"c": "150401",
				"n": "市辖区",
				"pc": "150400"
			}, {
				"c": "150402",
				"n": "红山区",
				"pc": "150400"
			}, {
				"c": "150403",
				"n": "元宝山区",
				"pc": "150400"
			}, {
				"c": "150404",
				"n": "松山区",
				"pc": "150400"
			}, {
				"c": "150421",
				"n": "阿鲁科尔沁旗",
				"pc": "150400"
			}, {
				"c": "150422",
				"n": "巴林左旗",
				"pc": "150400"
			}, {
				"c": "150423",
				"n": "巴林右旗",
				"pc": "150400"
			}, {
				"c": "150424",
				"n": "林西县",
				"pc": "150400"
			}, {
				"c": "150425",
				"n": "克什克腾旗",
				"pc": "150400"
			}, {
				"c": "150426",
				"n": "翁牛特旗",
				"pc": "150400"
			}, {
				"c": "150428",
				"n": "喀喇沁旗",
				"pc": "150400"
			}, {
				"c": "150429",
				"n": "宁城县",
				"pc": "150400"
			}, {
				"c": "150430",
				"n": "敖汉旗",
				"pc": "150400"
			}, {
				"c": "150500",
				"n": "通辽市",
				"pc": "150000"
			}, {
				"c": "150501",
				"n": "市辖区",
				"pc": "150500"
			}, {
				"c": "150502",
				"n": "科尔沁区",
				"pc": "150500"
			}, {
				"c": "150521",
				"n": "科尔沁左翼中旗",
				"pc": "150500"
			}, {
				"c": "150522",
				"n": "科尔沁左翼后旗",
				"pc": "150500"
			}, {
				"c": "150523",
				"n": "开鲁县",
				"pc": "150500"
			}, {
				"c": "150524",
				"n": "库伦旗",
				"pc": "150500"
			}, {
				"c": "150525",
				"n": "奈曼旗",
				"pc": "150500"
			}, {
				"c": "150526",
				"n": "扎鲁特旗",
				"pc": "150500"
			}, {
				"c": "150581",
				"n": "霍林郭勒市",
				"pc": "150500"
			}, {
				"c": "150600",
				"n": "鄂尔多斯市",
				"pc": "150000"
			}, {
				"c": "150601",
				"n": "市辖区",
				"pc": "150600"
			}, {
				"c": "150602",
				"n": "东胜区",
				"pc": "150600"
			}, {
				"c": "150621",
				"n": "达拉特旗",
				"pc": "150600"
			}, {
				"c": "150622",
				"n": "准格尔旗",
				"pc": "150600"
			}, {
				"c": "150623",
				"n": "鄂托克前旗",
				"pc": "150600"
			}, {
				"c": "150624",
				"n": "鄂托克旗",
				"pc": "150600"
			}, {
				"c": "150625",
				"n": "杭锦旗",
				"pc": "150600"
			}, {
				"c": "150626",
				"n": "乌审旗",
				"pc": "150600"
			}, {
				"c": "150627",
				"n": "伊金霍洛旗",
				"pc": "150600"
			}, {
				"c": "150700",
				"n": "呼伦贝尔市",
				"pc": "150000"
			}, {
				"c": "150701",
				"n": "市辖区",
				"pc": "150700"
			}, {
				"c": "150702",
				"n": "海拉尔区",
				"pc": "150700"
			}, {
				"c": "150721",
				"n": "阿荣旗",
				"pc": "150700"
			}, {
				"c": "150722",
				"n": "莫力达瓦达斡尔族自治旗",
				"pc": "150700"
			}, {
				"c": "150723",
				"n": "鄂伦春自治旗",
				"pc": "150700"
			}, {
				"c": "150724",
				"n": "鄂温克族自治旗",
				"pc": "150700"
			}, {
				"c": "150725",
				"n": "陈巴尔虎旗",
				"pc": "150700"
			}, {
				"c": "150726",
				"n": "新巴尔虎左旗",
				"pc": "150700"
			}, {
				"c": "150727",
				"n": "新巴尔虎右旗",
				"pc": "150700"
			}, {
				"c": "150781",
				"n": "满洲里市",
				"pc": "150700"
			}, {
				"c": "150782",
				"n": "牙克石市",
				"pc": "150700"
			}, {
				"c": "150783",
				"n": "扎兰屯市",
				"pc": "150700"
			}, {
				"c": "150784",
				"n": "额尔古纳市",
				"pc": "150700"
			}, {
				"c": "150785",
				"n": "根河市",
				"pc": "150700"
			}, {
				"c": "150800",
				"n": "巴彦淖尔市",
				"pc": "150000"
			}, {
				"c": "150801",
				"n": "市辖区",
				"pc": "150800"
			}, {
				"c": "150802",
				"n": "临河区",
				"pc": "150800"
			}, {
				"c": "150821",
				"n": "五原县",
				"pc": "150800"
			}, {
				"c": "150822",
				"n": "磴口县",
				"pc": "150800"
			}, {
				"c": "150823",
				"n": "乌拉特前旗",
				"pc": "150800"
			}, {
				"c": "150824",
				"n": "乌拉特中旗",
				"pc": "150800"
			}, {
				"c": "150825",
				"n": "乌拉特后旗",
				"pc": "150800"
			}, {
				"c": "150826",
				"n": "杭锦后旗",
				"pc": "150800"
			}, {
				"c": "150900",
				"n": "乌兰察布市",
				"pc": "150000"
			}, {
				"c": "150901",
				"n": "市辖区",
				"pc": "150900"
			}, {
				"c": "150902",
				"n": "集宁区",
				"pc": "150900"
			}, {
				"c": "150921",
				"n": "卓资县",
				"pc": "150900"
			}, {
				"c": "150922",
				"n": "化德县",
				"pc": "150900"
			}, {
				"c": "150923",
				"n": "商都县",
				"pc": "150900"
			}, {
				"c": "150924",
				"n": "兴和县",
				"pc": "150900"
			}, {
				"c": "150925",
				"n": "凉城县",
				"pc": "150900"
			}, {
				"c": "150926",
				"n": "察哈尔右翼前旗",
				"pc": "150900"
			}, {
				"c": "150927",
				"n": "察哈尔右翼中旗",
				"pc": "150900"
			}, {
				"c": "150928",
				"n": "察哈尔右翼后旗",
				"pc": "150900"
			}, {
				"c": "150929",
				"n": "四子王旗",
				"pc": "150900"
			}, {
				"c": "150981",
				"n": "丰镇市",
				"pc": "150900"
			}, {
				"c": "152200",
				"n": "兴安盟",
				"pc": "150000"
			}, {
				"c": "152201",
				"n": "乌兰浩特市",
				"pc": "152200"
			}, {
				"c": "152202",
				"n": "阿尔山市",
				"pc": "152200"
			}, {
				"c": "152221",
				"n": "科尔沁右翼前旗",
				"pc": "152200"
			}, {
				"c": "152222",
				"n": "科尔沁右翼中旗",
				"pc": "152200"
			}, {
				"c": "152223",
				"n": "扎赉特旗",
				"pc": "152200"
			}, {
				"c": "152224",
				"n": "突泉县",
				"pc": "152200"
			}, {
				"c": "152500",
				"n": "锡林郭勒盟",
				"pc": "150000"
			}, {
				"c": "152501",
				"n": "二连浩特市",
				"pc": "152500"
			}, {
				"c": "152502",
				"n": "锡林浩特市",
				"pc": "152500"
			}, {
				"c": "152522",
				"n": "阿巴嘎旗",
				"pc": "152500"
			}, {
				"c": "152523",
				"n": "苏尼特左旗",
				"pc": "152500"
			}, {
				"c": "152524",
				"n": "苏尼特右旗",
				"pc": "152500"
			}, {
				"c": "152525",
				"n": "东乌珠穆沁旗",
				"pc": "152500"
			}, {
				"c": "152526",
				"n": "西乌珠穆沁旗",
				"pc": "152500"
			}, {
				"c": "152527",
				"n": "太仆寺旗",
				"pc": "152500"
			}, {
				"c": "152528",
				"n": "镶黄旗",
				"pc": "152500"
			}, {
				"c": "152529",
				"n": "正镶白旗",
				"pc": "152500"
			}, {
				"c": "152530",
				"n": "正蓝旗",
				"pc": "152500"
			}, {
				"c": "152531",
				"n": "多伦县",
				"pc": "152500"
			}, {
				"c": "152900",
				"n": "阿拉善盟",
				"pc": "150000"
			}, {
				"c": "152921",
				"n": "阿拉善左旗",
				"pc": "152900"
			}, {
				"c": "152922",
				"n": "阿拉善右旗",
				"pc": "152900"
			}, {
				"c": "152923",
				"n": "额济纳旗",
				"pc": "152900"
			}, {
				"c": "210000",
				"n": "辽宁省",
				"pc": "86"
			}, {
				"c": "210100",
				"n": "沈阳市",
				"pc": "210000"
			}, {
				"c": "210101",
				"n": "市辖区",
				"pc": "210100"
			}, {
				"c": "210102",
				"n": "和平区",
				"pc": "210100"
			}, {
				"c": "210103",
				"n": "沈河区",
				"pc": "210100"
			}, {
				"c": "210104",
				"n": "大东区",
				"pc": "210100"
			}, {
				"c": "210105",
				"n": "皇姑区",
				"pc": "210100"
			}, {
				"c": "210106",
				"n": "铁西区",
				"pc": "210100"
			}, {
				"c": "210111",
				"n": "苏家屯区",
				"pc": "210100"
			}, {
				"c": "210112",
				"n": "东陵区",
				"pc": "210100"
			}, {
				"c": "210113",
				"n": "沈北新区",
				"pc": "210100"
			}, {
				"c": "210114",
				"n": "于洪区",
				"pc": "210100"
			}, {
				"c": "210122",
				"n": "辽中县",
				"pc": "210100"
			}, {
				"c": "210123",
				"n": "康平县",
				"pc": "210100"
			}, {
				"c": "210124",
				"n": "法库县",
				"pc": "210100"
			}, {
				"c": "210181",
				"n": "新民市",
				"pc": "210100"
			}, {
				"c": "210200",
				"n": "大连市",
				"pc": "210000"
			}, {
				"c": "210201",
				"n": "市辖区",
				"pc": "210200"
			}, {
				"c": "210202",
				"n": "中山区",
				"pc": "210200"
			}, {
				"c": "210203",
				"n": "西岗区",
				"pc": "210200"
			}, {
				"c": "210204",
				"n": "沙河口区",
				"pc": "210200"
			}, {
				"c": "210211",
				"n": "甘井子区",
				"pc": "210200"
			}, {
				"c": "210212",
				"n": "旅顺口区",
				"pc": "210200"
			}, {
				"c": "210213",
				"n": "金州区",
				"pc": "210200"
			}, {
				"c": "210224",
				"n": "长海县",
				"pc": "210200"
			}, {
				"c": "210281",
				"n": "瓦房店市",
				"pc": "210200"
			}, {
				"c": "210282",
				"n": "普兰店市",
				"pc": "210200"
			}, {
				"c": "210283",
				"n": "庄河市",
				"pc": "210200"
			}, {
				"c": "210300",
				"n": "鞍山市",
				"pc": "210000"
			}, {
				"c": "210301",
				"n": "市辖区",
				"pc": "210300"
			}, {
				"c": "210302",
				"n": "铁东区",
				"pc": "210300"
			}, {
				"c": "210303",
				"n": "铁西区",
				"pc": "210300"
			}, {
				"c": "210304",
				"n": "立山区",
				"pc": "210300"
			}, {
				"c": "210311",
				"n": "千山区",
				"pc": "210300"
			}, {
				"c": "210321",
				"n": "台安县",
				"pc": "210300"
			}, {
				"c": "210323",
				"n": "岫岩满族自治县",
				"pc": "210300"
			}, {
				"c": "210381",
				"n": "海城市",
				"pc": "210300"
			}, {
				"c": "210400",
				"n": "抚顺市",
				"pc": "210000"
			}, {
				"c": "210401",
				"n": "市辖区",
				"pc": "210400"
			}, {
				"c": "210402",
				"n": "新抚区",
				"pc": "210400"
			}, {
				"c": "210403",
				"n": "东洲区",
				"pc": "210400"
			}, {
				"c": "210404",
				"n": "望花区",
				"pc": "210400"
			}, {
				"c": "210411",
				"n": "顺城区",
				"pc": "210400"
			}, {
				"c": "210421",
				"n": "抚顺县",
				"pc": "210400"
			}, {
				"c": "210422",
				"n": "新宾满族自治县",
				"pc": "210400"
			}, {
				"c": "210423",
				"n": "清原满族自治县",
				"pc": "210400"
			}, {
				"c": "210500",
				"n": "本溪市",
				"pc": "210000"
			}, {
				"c": "210501",
				"n": "市辖区",
				"pc": "210500"
			}, {
				"c": "210502",
				"n": "平山区",
				"pc": "210500"
			}, {
				"c": "210503",
				"n": "溪湖区",
				"pc": "210500"
			}, {
				"c": "210504",
				"n": "明山区",
				"pc": "210500"
			}, {
				"c": "210505",
				"n": "南芬区",
				"pc": "210500"
			}, {
				"c": "210521",
				"n": "本溪满族自治县",
				"pc": "210500"
			}, {
				"c": "210522",
				"n": "桓仁满族自治县",
				"pc": "210500"
			}, {
				"c": "210600",
				"n": "丹东市",
				"pc": "210000"
			}, {
				"c": "210601",
				"n": "市辖区",
				"pc": "210600"
			}, {
				"c": "210602",
				"n": "元宝区",
				"pc": "210600"
			}, {
				"c": "210603",
				"n": "振兴区",
				"pc": "210600"
			}, {
				"c": "210604",
				"n": "振安区",
				"pc": "210600"
			}, {
				"c": "210624",
				"n": "宽甸满族自治县",
				"pc": "210600"
			}, {
				"c": "210681",
				"n": "东港市",
				"pc": "210600"
			}, {
				"c": "210682",
				"n": "凤城市",
				"pc": "210600"
			}, {
				"c": "210700",
				"n": "锦州市",
				"pc": "210000"
			}, {
				"c": "210701",
				"n": "市辖区",
				"pc": "210700"
			}, {
				"c": "210702",
				"n": "古塔区",
				"pc": "210700"
			}, {
				"c": "210703",
				"n": "凌河区",
				"pc": "210700"
			}, {
				"c": "210711",
				"n": "太和区",
				"pc": "210700"
			}, {
				"c": "210726",
				"n": "黑山县",
				"pc": "210700"
			}, {
				"c": "210727",
				"n": "义县",
				"pc": "210700"
			}, {
				"c": "210781",
				"n": "凌海市",
				"pc": "210700"
			}, {
				"c": "210782",
				"n": "北镇市",
				"pc": "210700"
			}, {
				"c": "210800",
				"n": "营口市",
				"pc": "210000"
			}, {
				"c": "210801",
				"n": "市辖区",
				"pc": "210800"
			}, {
				"c": "210802",
				"n": "站前区",
				"pc": "210800"
			}, {
				"c": "210803",
				"n": "西市区",
				"pc": "210800"
			}, {
				"c": "210804",
				"n": "鲅鱼圈区",
				"pc": "210800"
			}, {
				"c": "210811",
				"n": "老边区",
				"pc": "210800"
			}, {
				"c": "210881",
				"n": "盖州市",
				"pc": "210800"
			}, {
				"c": "210882",
				"n": "大石桥市",
				"pc": "210800"
			}, {
				"c": "210900",
				"n": "阜新市",
				"pc": "210000"
			}, {
				"c": "210901",
				"n": "市辖区",
				"pc": "210900"
			}, {
				"c": "210902",
				"n": "海州区",
				"pc": "210900"
			}, {
				"c": "210903",
				"n": "新邱区",
				"pc": "210900"
			}, {
				"c": "210904",
				"n": "太平区",
				"pc": "210900"
			}, {
				"c": "210905",
				"n": "清河门区",
				"pc": "210900"
			}, {
				"c": "210911",
				"n": "细河区",
				"pc": "210900"
			}, {
				"c": "210921",
				"n": "阜新蒙古族自治县",
				"pc": "210900"
			}, {
				"c": "210922",
				"n": "彰武县",
				"pc": "210900"
			}, {
				"c": "211000",
				"n": "辽阳市",
				"pc": "210000"
			}, {
				"c": "211001",
				"n": "市辖区",
				"pc": "211000"
			}, {
				"c": "211002",
				"n": "白塔区",
				"pc": "211000"
			}, {
				"c": "211003",
				"n": "文圣区",
				"pc": "211000"
			}, {
				"c": "211004",
				"n": "宏伟区",
				"pc": "211000"
			}, {
				"c": "211005",
				"n": "弓长岭区",
				"pc": "211000"
			}, {
				"c": "211011",
				"n": "太子河区",
				"pc": "211000"
			}, {
				"c": "211021",
				"n": "辽阳县",
				"pc": "211000"
			}, {
				"c": "211081",
				"n": "灯塔市",
				"pc": "211000"
			}, {
				"c": "211100",
				"n": "盘锦市",
				"pc": "210000"
			}, {
				"c": "211101",
				"n": "市辖区",
				"pc": "211100"
			}, {
				"c": "211102",
				"n": "双台子区",
				"pc": "211100"
			}, {
				"c": "211103",
				"n": "兴隆台区",
				"pc": "211100"
			}, {
				"c": "211121",
				"n": "大洼县",
				"pc": "211100"
			}, {
				"c": "211122",
				"n": "盘山县",
				"pc": "211100"
			}, {
				"c": "211200",
				"n": "铁岭市",
				"pc": "210000"
			}, {
				"c": "211201",
				"n": "市辖区",
				"pc": "211200"
			}, {
				"c": "211202",
				"n": "银州区",
				"pc": "211200"
			}, {
				"c": "211204",
				"n": "清河区",
				"pc": "211200"
			}, {
				"c": "211221",
				"n": "铁岭县",
				"pc": "211200"
			}, {
				"c": "211223",
				"n": "西丰县",
				"pc": "211200"
			}, {
				"c": "211224",
				"n": "昌图县",
				"pc": "211200"
			}, {
				"c": "211281",
				"n": "调兵山市",
				"pc": "211200"
			}, {
				"c": "211282",
				"n": "开原市",
				"pc": "211200"
			}, {
				"c": "211300",
				"n": "朝阳市",
				"pc": "210000"
			}, {
				"c": "211301",
				"n": "市辖区",
				"pc": "211300"
			}, {
				"c": "211302",
				"n": "双塔区",
				"pc": "211300"
			}, {
				"c": "211303",
				"n": "龙城区",
				"pc": "211300"
			}, {
				"c": "211321",
				"n": "朝阳县",
				"pc": "211300"
			}, {
				"c": "211322",
				"n": "建平县",
				"pc": "211300"
			}, {
				"c": "211324",
				"n": "喀喇沁左翼蒙古族自治县",
				"pc": "211300"
			}, {
				"c": "211381",
				"n": "北票市",
				"pc": "211300"
			}, {
				"c": "211382",
				"n": "凌源市",
				"pc": "211300"
			}, {
				"c": "211400",
				"n": "葫芦岛市",
				"pc": "210000"
			}, {
				"c": "211401",
				"n": "市辖区",
				"pc": "211400"
			}, {
				"c": "211402",
				"n": "连山区",
				"pc": "211400"
			}, {
				"c": "211403",
				"n": "龙港区",
				"pc": "211400"
			}, {
				"c": "211404",
				"n": "南票区",
				"pc": "211400"
			}, {
				"c": "211421",
				"n": "绥中县",
				"pc": "211400"
			}, {
				"c": "211422",
				"n": "建昌县",
				"pc": "211400"
			}, {
				"c": "211481",
				"n": "兴城市",
				"pc": "211400"
			}, {
				"c": "220000",
				"n": "吉林省",
				"pc": "86"
			}, {
				"c": "220100",
				"n": "长春市",
				"pc": "220000"
			}, {
				"c": "220101",
				"n": "市辖区",
				"pc": "220100"
			}, {
				"c": "220102",
				"n": "南关区",
				"pc": "220100"
			}, {
				"c": "220103",
				"n": "宽城区",
				"pc": "220100"
			}, {
				"c": "220104",
				"n": "朝阳区",
				"pc": "220100"
			}, {
				"c": "220105",
				"n": "二道区",
				"pc": "220100"
			}, {
				"c": "220106",
				"n": "绿园区",
				"pc": "220100"
			}, {
				"c": "220112",
				"n": "双阳区",
				"pc": "220100"
			}, {
				"c": "220122",
				"n": "农安县",
				"pc": "220100"
			}, {
				"c": "220181",
				"n": "九台市",
				"pc": "220100"
			}, {
				"c": "220182",
				"n": "榆树市",
				"pc": "220100"
			}, {
				"c": "220183",
				"n": "德惠市",
				"pc": "220100"
			}, {
				"c": "220200",
				"n": "吉林市",
				"pc": "220000"
			}, {
				"c": "220201",
				"n": "市辖区",
				"pc": "220200"
			}, {
				"c": "220202",
				"n": "昌邑区",
				"pc": "220200"
			}, {
				"c": "220203",
				"n": "龙潭区",
				"pc": "220200"
			}, {
				"c": "220204",
				"n": "船营区",
				"pc": "220200"
			}, {
				"c": "220211",
				"n": "丰满区",
				"pc": "220200"
			}, {
				"c": "220221",
				"n": "永吉县",
				"pc": "220200"
			}, {
				"c": "220281",
				"n": "蛟河市",
				"pc": "220200"
			}, {
				"c": "220282",
				"n": "桦甸市",
				"pc": "220200"
			}, {
				"c": "220283",
				"n": "舒兰市",
				"pc": "220200"
			}, {
				"c": "220284",
				"n": "磐石市",
				"pc": "220200"
			}, {
				"c": "220300",
				"n": "四平市",
				"pc": "220000"
			}, {
				"c": "220301",
				"n": "市辖区",
				"pc": "220300"
			}, {
				"c": "220302",
				"n": "铁西区",
				"pc": "220300"
			}, {
				"c": "220303",
				"n": "铁东区",
				"pc": "220300"
			}, {
				"c": "220322",
				"n": "梨树县",
				"pc": "220300"
			}, {
				"c": "220323",
				"n": "伊通满族自治县",
				"pc": "220300"
			}, {
				"c": "220381",
				"n": "公主岭市",
				"pc": "220300"
			}, {
				"c": "220382",
				"n": "双辽市",
				"pc": "220300"
			}, {
				"c": "220400",
				"n": "辽源市",
				"pc": "220000"
			}, {
				"c": "220401",
				"n": "市辖区",
				"pc": "220400"
			}, {
				"c": "220402",
				"n": "龙山区",
				"pc": "220400"
			}, {
				"c": "220403",
				"n": "西安区",
				"pc": "220400"
			}, {
				"c": "220421",
				"n": "东丰县",
				"pc": "220400"
			}, {
				"c": "220422",
				"n": "东辽县",
				"pc": "220400"
			}, {
				"c": "220500",
				"n": "通化市",
				"pc": "220000"
			}, {
				"c": "220501",
				"n": "市辖区",
				"pc": "220500"
			}, {
				"c": "220502",
				"n": "东昌区",
				"pc": "220500"
			}, {
				"c": "220503",
				"n": "二道江区",
				"pc": "220500"
			}, {
				"c": "220521",
				"n": "通化县",
				"pc": "220500"
			}, {
				"c": "220523",
				"n": "辉南县",
				"pc": "220500"
			}, {
				"c": "220524",
				"n": "柳河县",
				"pc": "220500"
			}, {
				"c": "220581",
				"n": "梅河口市",
				"pc": "220500"
			}, {
				"c": "220582",
				"n": "集安市",
				"pc": "220500"
			}, {
				"c": "220600",
				"n": "白山市",
				"pc": "220000"
			}, {
				"c": "220601",
				"n": "市辖区",
				"pc": "220600"
			}, {
				"c": "220602",
				"n": "浑江区",
				"pc": "220600"
			}, {
				"c": "220605",
				"n": "江源区",
				"pc": "220600"
			}, {
				"c": "220621",
				"n": "抚松县",
				"pc": "220600"
			}, {
				"c": "220622",
				"n": "靖宇县",
				"pc": "220600"
			}, {
				"c": "220623",
				"n": "长白朝鲜族自治县",
				"pc": "220600"
			}, {
				"c": "220681",
				"n": "临江市",
				"pc": "220600"
			}, {
				"c": "220700",
				"n": "松原市",
				"pc": "220000"
			}, {
				"c": "220701",
				"n": "市辖区",
				"pc": "220700"
			}, {
				"c": "220702",
				"n": "宁江区",
				"pc": "220700"
			}, {
				"c": "220721",
				"n": "前郭尔罗斯蒙古族自治县",
				"pc": "220700"
			}, {
				"c": "220722",
				"n": "长岭县",
				"pc": "220700"
			}, {
				"c": "220723",
				"n": "乾安县",
				"pc": "220700"
			}, {
				"c": "220724",
				"n": "扶余县",
				"pc": "220700"
			}, {
				"c": "220800",
				"n": "白城市",
				"pc": "220000"
			}, {
				"c": "220801",
				"n": "市辖区",
				"pc": "220800"
			}, {
				"c": "220802",
				"n": "洮北区",
				"pc": "220800"
			}, {
				"c": "220821",
				"n": "镇赉县",
				"pc": "220800"
			}, {
				"c": "220822",
				"n": "通榆县",
				"pc": "220800"
			}, {
				"c": "220881",
				"n": "洮南市",
				"pc": "220800"
			}, {
				"c": "220882",
				"n": "大安市",
				"pc": "220800"
			}, {
				"c": "222400",
				"n": "延边朝鲜族自治州",
				"pc": "220000"
			}, {
				"c": "222401",
				"n": "延吉市",
				"pc": "222400"
			}, {
				"c": "222402",
				"n": "图们市",
				"pc": "222400"
			}, {
				"c": "222403",
				"n": "敦化市",
				"pc": "222400"
			}, {
				"c": "222404",
				"n": "珲春市",
				"pc": "222400"
			}, {
				"c": "222405",
				"n": "龙井市",
				"pc": "222400"
			}, {
				"c": "222406",
				"n": "和龙市",
				"pc": "222400"
			}, {
				"c": "222424",
				"n": "汪清县",
				"pc": "222400"
			}, {
				"c": "222426",
				"n": "安图县",
				"pc": "222400"
			}, {
				"c": "230000",
				"n": "黑龙江省",
				"pc": "86"
			}, {
				"c": "230100",
				"n": "哈尔滨市",
				"pc": "230000"
			}, {
				"c": "230101",
				"n": "市辖区",
				"pc": "230100"
			}, {
				"c": "230102",
				"n": "道里区",
				"pc": "230100"
			}, {
				"c": "230103",
				"n": "南岗区",
				"pc": "230100"
			}, {
				"c": "230104",
				"n": "道外区",
				"pc": "230100"
			}, {
				"c": "230108",
				"n": "平房区",
				"pc": "230100"
			}, {
				"c": "230109",
				"n": "松北区",
				"pc": "230100"
			}, {
				"c": "230110",
				"n": "香坊区",
				"pc": "230100"
			}, {
				"c": "230111",
				"n": "呼兰区",
				"pc": "230100"
			}, {
				"c": "230112",
				"n": "阿城区",
				"pc": "230100"
			}, {
				"c": "230123",
				"n": "依兰县",
				"pc": "230100"
			}, {
				"c": "230124",
				"n": "方正县",
				"pc": "230100"
			}, {
				"c": "230125",
				"n": "宾县",
				"pc": "230100"
			}, {
				"c": "230126",
				"n": "巴彦县",
				"pc": "230100"
			}, {
				"c": "230127",
				"n": "木兰县",
				"pc": "230100"
			}, {
				"c": "230128",
				"n": "通河县",
				"pc": "230100"
			}, {
				"c": "230129",
				"n": "延寿县",
				"pc": "230100"
			}, {
				"c": "230182",
				"n": "双城市",
				"pc": "230100"
			}, {
				"c": "230183",
				"n": "尚志市",
				"pc": "230100"
			}, {
				"c": "230184",
				"n": "五常市",
				"pc": "230100"
			}, {
				"c": "230200",
				"n": "齐齐哈尔市",
				"pc": "230000"
			}, {
				"c": "230201",
				"n": "市辖区",
				"pc": "230200"
			}, {
				"c": "230202",
				"n": "龙沙区",
				"pc": "230200"
			}, {
				"c": "230203",
				"n": "建华区",
				"pc": "230200"
			}, {
				"c": "230204",
				"n": "铁锋区",
				"pc": "230200"
			}, {
				"c": "230205",
				"n": "昂昂溪区",
				"pc": "230200"
			}, {
				"c": "230206",
				"n": "富拉尔基区",
				"pc": "230200"
			}, {
				"c": "230207",
				"n": "碾子山区",
				"pc": "230200"
			}, {
				"c": "230208",
				"n": "梅里斯达斡尔族区",
				"pc": "230200"
			}, {
				"c": "230221",
				"n": "龙江县",
				"pc": "230200"
			}, {
				"c": "230223",
				"n": "依安县",
				"pc": "230200"
			}, {
				"c": "230224",
				"n": "泰来县",
				"pc": "230200"
			}, {
				"c": "230225",
				"n": "甘南县",
				"pc": "230200"
			}, {
				"c": "230227",
				"n": "富裕县",
				"pc": "230200"
			}, {
				"c": "230229",
				"n": "克山县",
				"pc": "230200"
			}, {
				"c": "230230",
				"n": "克东县",
				"pc": "230200"
			}, {
				"c": "230231",
				"n": "拜泉县",
				"pc": "230200"
			}, {
				"c": "230281",
				"n": "讷河市",
				"pc": "230200"
			}, {
				"c": "230300",
				"n": "鸡西市",
				"pc": "230000"
			}, {
				"c": "230301",
				"n": "市辖区",
				"pc": "230300"
			}, {
				"c": "230302",
				"n": "鸡冠区",
				"pc": "230300"
			}, {
				"c": "230303",
				"n": "恒山区",
				"pc": "230300"
			}, {
				"c": "230304",
				"n": "滴道区",
				"pc": "230300"
			}, {
				"c": "230305",
				"n": "梨树区",
				"pc": "230300"
			}, {
				"c": "230306",
				"n": "城子河区",
				"pc": "230300"
			}, {
				"c": "230307",
				"n": "麻山区",
				"pc": "230300"
			}, {
				"c": "230321",
				"n": "鸡东县",
				"pc": "230300"
			}, {
				"c": "230381",
				"n": "虎林市",
				"pc": "230300"
			}, {
				"c": "230382",
				"n": "密山市",
				"pc": "230300"
			}, {
				"c": "230400",
				"n": "鹤岗市",
				"pc": "230000"
			}, {
				"c": "230401",
				"n": "市辖区",
				"pc": "230400"
			}, {
				"c": "230402",
				"n": "向阳区",
				"pc": "230400"
			}, {
				"c": "230403",
				"n": "工农区",
				"pc": "230400"
			}, {
				"c": "230404",
				"n": "南山区",
				"pc": "230400"
			}, {
				"c": "230405",
				"n": "兴安区",
				"pc": "230400"
			}, {
				"c": "230406",
				"n": "东山区",
				"pc": "230400"
			}, {
				"c": "230407",
				"n": "兴山区",
				"pc": "230400"
			}, {
				"c": "230421",
				"n": "萝北县",
				"pc": "230400"
			}, {
				"c": "230422",
				"n": "绥滨县",
				"pc": "230400"
			}, {
				"c": "230500",
				"n": "双鸭山市",
				"pc": "230000"
			}, {
				"c": "230501",
				"n": "市辖区",
				"pc": "230500"
			}, {
				"c": "230502",
				"n": "尖山区",
				"pc": "230500"
			}, {
				"c": "230503",
				"n": "岭东区",
				"pc": "230500"
			}, {
				"c": "230505",
				"n": "四方台区",
				"pc": "230500"
			}, {
				"c": "230506",
				"n": "宝山区",
				"pc": "230500"
			}, {
				"c": "230521",
				"n": "集贤县",
				"pc": "230500"
			}, {
				"c": "230522",
				"n": "友谊县",
				"pc": "230500"
			}, {
				"c": "230523",
				"n": "宝清县",
				"pc": "230500"
			}, {
				"c": "230524",
				"n": "饶河县",
				"pc": "230500"
			}, {
				"c": "230600",
				"n": "大庆市",
				"pc": "230000"
			}, {
				"c": "230601",
				"n": "市辖区",
				"pc": "230600"
			}, {
				"c": "230602",
				"n": "萨尔图区",
				"pc": "230600"
			}, {
				"c": "230603",
				"n": "龙凤区",
				"pc": "230600"
			}, {
				"c": "230604",
				"n": "让胡路区",
				"pc": "230600"
			}, {
				"c": "230605",
				"n": "红岗区",
				"pc": "230600"
			}, {
				"c": "230606",
				"n": "大同区",
				"pc": "230600"
			}, {
				"c": "230621",
				"n": "肇州县",
				"pc": "230600"
			}, {
				"c": "230622",
				"n": "肇源县",
				"pc": "230600"
			}, {
				"c": "230623",
				"n": "林甸县",
				"pc": "230600"
			}, {
				"c": "230624",
				"n": "杜尔伯特蒙古族自治县",
				"pc": "230600"
			}, {
				"c": "230700",
				"n": "伊春市",
				"pc": "230000"
			}, {
				"c": "230701",
				"n": "市辖区",
				"pc": "230700"
			}, {
				"c": "230702",
				"n": "伊春区",
				"pc": "230700"
			}, {
				"c": "230703",
				"n": "南岔区",
				"pc": "230700"
			}, {
				"c": "230704",
				"n": "友好区",
				"pc": "230700"
			}, {
				"c": "230705",
				"n": "西林区",
				"pc": "230700"
			}, {
				"c": "230706",
				"n": "翠峦区",
				"pc": "230700"
			}, {
				"c": "230707",
				"n": "新青区",
				"pc": "230700"
			}, {
				"c": "230708",
				"n": "美溪区",
				"pc": "230700"
			}, {
				"c": "230709",
				"n": "金山屯区",
				"pc": "230700"
			}, {
				"c": "230710",
				"n": "五营区",
				"pc": "230700"
			}, {
				"c": "230711",
				"n": "乌马河区",
				"pc": "230700"
			}, {
				"c": "230712",
				"n": "汤旺河区",
				"pc": "230700"
			}, {
				"c": "230713",
				"n": "带岭区",
				"pc": "230700"
			}, {
				"c": "230714",
				"n": "乌伊岭区",
				"pc": "230700"
			}, {
				"c": "230715",
				"n": "红星区",
				"pc": "230700"
			}, {
				"c": "230716",
				"n": "上甘岭区",
				"pc": "230700"
			}, {
				"c": "230722",
				"n": "嘉荫县",
				"pc": "230700"
			}, {
				"c": "230781",
				"n": "铁力市",
				"pc": "230700"
			}, {
				"c": "230800",
				"n": "佳木斯市",
				"pc": "230000"
			}, {
				"c": "230801",
				"n": "市辖区",
				"pc": "230800"
			}, {
				"c": "230803",
				"n": "向阳区",
				"pc": "230800"
			}, {
				"c": "230804",
				"n": "前进区",
				"pc": "230800"
			}, {
				"c": "230805",
				"n": "东风区",
				"pc": "230800"
			}, {
				"c": "230811",
				"n": "郊区",
				"pc": "230800"
			}, {
				"c": "230822",
				"n": "桦南县",
				"pc": "230800"
			}, {
				"c": "230826",
				"n": "桦川县",
				"pc": "230800"
			}, {
				"c": "230828",
				"n": "汤原县",
				"pc": "230800"
			}, {
				"c": "230833",
				"n": "抚远县",
				"pc": "230800"
			}, {
				"c": "230881",
				"n": "同江市",
				"pc": "230800"
			}, {
				"c": "230882",
				"n": "富锦市",
				"pc": "230800"
			}, {
				"c": "230900",
				"n": "七台河市",
				"pc": "230000"
			}, {
				"c": "230901",
				"n": "市辖区",
				"pc": "230900"
			}, {
				"c": "230902",
				"n": "新兴区",
				"pc": "230900"
			}, {
				"c": "230903",
				"n": "桃山区",
				"pc": "230900"
			}, {
				"c": "230904",
				"n": "茄子河区",
				"pc": "230900"
			}, {
				"c": "230921",
				"n": "勃利县",
				"pc": "230900"
			}, {
				"c": "231000",
				"n": "牡丹江市",
				"pc": "230000"
			}, {
				"c": "231001",
				"n": "市辖区",
				"pc": "231000"
			}, {
				"c": "231002",
				"n": "东安区",
				"pc": "231000"
			}, {
				"c": "231003",
				"n": "阳明区",
				"pc": "231000"
			}, {
				"c": "231004",
				"n": "爱民区",
				"pc": "231000"
			}, {
				"c": "231005",
				"n": "西安区",
				"pc": "231000"
			}, {
				"c": "231024",
				"n": "东宁县",
				"pc": "231000"
			}, {
				"c": "231025",
				"n": "林口县",
				"pc": "231000"
			}, {
				"c": "231081",
				"n": "绥芬河市",
				"pc": "231000"
			}, {
				"c": "231083",
				"n": "海林市",
				"pc": "231000"
			}, {
				"c": "231084",
				"n": "宁安市",
				"pc": "231000"
			}, {
				"c": "231085",
				"n": "穆棱市",
				"pc": "231000"
			}, {
				"c": "231100",
				"n": "黑河市",
				"pc": "230000"
			}, {
				"c": "231101",
				"n": "市辖区",
				"pc": "231100"
			}, {
				"c": "231102",
				"n": "爱辉区",
				"pc": "231100"
			}, {
				"c": "231121",
				"n": "嫩江县",
				"pc": "231100"
			}, {
				"c": "231123",
				"n": "逊克县",
				"pc": "231100"
			}, {
				"c": "231124",
				"n": "孙吴县",
				"pc": "231100"
			}, {
				"c": "231181",
				"n": "北安市",
				"pc": "231100"
			}, {
				"c": "231182",
				"n": "五大连池市",
				"pc": "231100"
			}, {
				"c": "231200",
				"n": "绥化市",
				"pc": "230000"
			}, {
				"c": "231201",
				"n": "市辖区",
				"pc": "231200"
			}, {
				"c": "231202",
				"n": "北林区",
				"pc": "231200"
			}, {
				"c": "231221",
				"n": "望奎县",
				"pc": "231200"
			}, {
				"c": "231222",
				"n": "兰西县",
				"pc": "231200"
			}, {
				"c": "231223",
				"n": "青冈县",
				"pc": "231200"
			}, {
				"c": "231224",
				"n": "庆安县",
				"pc": "231200"
			}, {
				"c": "231225",
				"n": "明水县",
				"pc": "231200"
			}, {
				"c": "231226",
				"n": "绥棱县",
				"pc": "231200"
			}, {
				"c": "231281",
				"n": "安达市",
				"pc": "231200"
			}, {
				"c": "231282",
				"n": "肇东市",
				"pc": "231200"
			}, {
				"c": "231283",
				"n": "海伦市",
				"pc": "231200"
			}, {
				"c": "232700",
				"n": "大兴安岭地区",
				"pc": "230000"
			}, {
				"c": "232721",
				"n": "呼玛县",
				"pc": "232700"
			}, {
				"c": "232722",
				"n": "塔河县",
				"pc": "232700"
			}, {
				"c": "232723",
				"n": "漠河县",
				"pc": "232700"
			}, {
				"c": "310000",
				"n": "上海市",
				"pc": "86"
			}, {
				"c": "310100",
				"n": "上海市",
				"pc": "310000"
			}, {
				"c": "310101",
				"n": "黄浦区",
				"pc": "310100"
			}, {
				"c": "310104",
				"n": "徐汇区",
				"pc": "310100"
			}, {
				"c": "310105",
				"n": "长宁区",
				"pc": "310100"
			}, {
				"c": "310106",
				"n": "静安区",
				"pc": "310100"
			}, {
				"c": "310107",
				"n": "普陀区",
				"pc": "310100"
			}, {
				"c": "310108",
				"n": "闸北区",
				"pc": "310100"
			}, {
				"c": "310109",
				"n": "虹口区",
				"pc": "310100"
			}, {
				"c": "310110",
				"n": "杨浦区",
				"pc": "310100"
			}, {
				"c": "310112",
				"n": "闵行区",
				"pc": "310100"
			}, {
				"c": "310113",
				"n": "宝山区",
				"pc": "310100"
			}, {
				"c": "310114",
				"n": "嘉定区",
				"pc": "310100"
			}, {
				"c": "310115",
				"n": "浦东新区",
				"pc": "310100"
			}, {
				"c": "310116",
				"n": "金山区",
				"pc": "310100"
			}, {
				"c": "310117",
				"n": "松江区",
				"pc": "310100"
			}, {
				"c": "310118",
				"n": "青浦区",
				"pc": "310100"
			}, {
				"c": "310120",
				"n": "奉贤区",
				"pc": "310100"
			}, {
				"c": "310230",
				"n": "崇明县",
				"pc": "310100"
			}, {
				"c": "320000",
				"n": "江苏省",
				"pc": "86"
			}, {
				"c": "320100",
				"n": "南京市",
				"pc": "320000"
			}, {
				"c": "320101",
				"n": "市辖区",
				"pc": "320100"
			}, {
				"c": "320102",
				"n": "玄武区",
				"pc": "320100"
			}, {
				"c": "320103",
				"n": "白下区",
				"pc": "320100"
			}, {
				"c": "320104",
				"n": "秦淮区",
				"pc": "320100"
			}, {
				"c": "320105",
				"n": "建邺区",
				"pc": "320100"
			}, {
				"c": "320106",
				"n": "鼓楼区",
				"pc": "320100"
			}, {
				"c": "320107",
				"n": "下关区",
				"pc": "320100"
			}, {
				"c": "320111",
				"n": "浦口区",
				"pc": "320100"
			}, {
				"c": "320113",
				"n": "栖霞区",
				"pc": "320100"
			}, {
				"c": "320114",
				"n": "雨花台区",
				"pc": "320100"
			}, {
				"c": "320115",
				"n": "江宁区",
				"pc": "320100"
			}, {
				"c": "320116",
				"n": "六合区",
				"pc": "320100"
			}, {
				"c": "320124",
				"n": "溧水县",
				"pc": "320100"
			}, {
				"c": "320125",
				"n": "高淳县",
				"pc": "320100"
			}, {
				"c": "320200",
				"n": "无锡市",
				"pc": "320000"
			}, {
				"c": "320201",
				"n": "市辖区",
				"pc": "320200"
			}, {
				"c": "320202",
				"n": "崇安区",
				"pc": "320200"
			}, {
				"c": "320203",
				"n": "南长区",
				"pc": "320200"
			}, {
				"c": "320204",
				"n": "北塘区",
				"pc": "320200"
			}, {
				"c": "320205",
				"n": "锡山区",
				"pc": "320200"
			}, {
				"c": "320206",
				"n": "惠山区",
				"pc": "320200"
			}, {
				"c": "320211",
				"n": "滨湖区",
				"pc": "320200"
			}, {
				"c": "320281",
				"n": "江阴市",
				"pc": "320200"
			}, {
				"c": "320282",
				"n": "宜兴市",
				"pc": "320200"
			}, {
				"c": "320300",
				"n": "徐州市",
				"pc": "320000"
			}, {
				"c": "320301",
				"n": "市辖区",
				"pc": "320300"
			}, {
				"c": "320302",
				"n": "鼓楼区",
				"pc": "320300"
			}, {
				"c": "320303",
				"n": "云龙区",
				"pc": "320300"
			}, {
				"c": "320305",
				"n": "贾汪区",
				"pc": "320300"
			}, {
				"c": "320311",
				"n": "泉山区",
				"pc": "320300"
			}, {
				"c": "320312",
				"n": "铜山区",
				"pc": "320300"
			}, {
				"c": "320321",
				"n": "丰县",
				"pc": "320300"
			}, {
				"c": "320322",
				"n": "沛县",
				"pc": "320300"
			}, {
				"c": "320324",
				"n": "睢宁县",
				"pc": "320300"
			}, {
				"c": "320381",
				"n": "新沂市",
				"pc": "320300"
			}, {
				"c": "320382",
				"n": "邳州市",
				"pc": "320300"
			}, {
				"c": "320400",
				"n": "常州市",
				"pc": "320000"
			}, {
				"c": "320401",
				"n": "市辖区",
				"pc": "320400"
			}, {
				"c": "320402",
				"n": "天宁区",
				"pc": "320400"
			}, {
				"c": "320404",
				"n": "钟楼区",
				"pc": "320400"
			}, {
				"c": "320405",
				"n": "戚墅堰区",
				"pc": "320400"
			}, {
				"c": "320411",
				"n": "新北区",
				"pc": "320400"
			}, {
				"c": "320412",
				"n": "武进区",
				"pc": "320400"
			}, {
				"c": "320481",
				"n": "溧阳市",
				"pc": "320400"
			}, {
				"c": "320482",
				"n": "金坛市",
				"pc": "320400"
			}, {
				"c": "320500",
				"n": "苏州市",
				"pc": "320000"
			}, {
				"c": "320501",
				"n": "市辖区",
				"pc": "320500"
			}, {
				"c": "320505",
				"n": "虎丘区",
				"pc": "320500"
			}, {
				"c": "320506",
				"n": "吴中区",
				"pc": "320500"
			}, {
				"c": "320507",
				"n": "相城区",
				"pc": "320500"
			}, {
				"c": "320508",
				"n": "姑苏区",
				"pc": "320500"
			}, {
				"c": "320509",
				"n": "吴江区",
				"pc": "320500"
			}, {
				"c": "320581",
				"n": "常熟市",
				"pc": "320500"
			}, {
				"c": "320582",
				"n": "张家港市",
				"pc": "320500"
			}, {
				"c": "320583",
				"n": "昆山市",
				"pc": "320500"
			}, {
				"c": "320585",
				"n": "太仓市",
				"pc": "320500"
			}, {
				"c": "320600",
				"n": "南通市",
				"pc": "320000"
			}, {
				"c": "320601",
				"n": "市辖区",
				"pc": "320600"
			}, {
				"c": "320602",
				"n": "崇川区",
				"pc": "320600"
			}, {
				"c": "320611",
				"n": "港闸区",
				"pc": "320600"
			}, {
				"c": "320612",
				"n": "通州区",
				"pc": "320600"
			}, {
				"c": "320621",
				"n": "海安县",
				"pc": "320600"
			}, {
				"c": "320623",
				"n": "如东县",
				"pc": "320600"
			}, {
				"c": "320681",
				"n": "启东市",
				"pc": "320600"
			}, {
				"c": "320682",
				"n": "如皋市",
				"pc": "320600"
			}, {
				"c": "320684",
				"n": "海门市",
				"pc": "320600"
			}, {
				"c": "320700",
				"n": "连云港市",
				"pc": "320000"
			}, {
				"c": "320701",
				"n": "市辖区",
				"pc": "320700"
			}, {
				"c": "320703",
				"n": "连云区",
				"pc": "320700"
			}, {
				"c": "320705",
				"n": "新浦区",
				"pc": "320700"
			}, {
				"c": "320706",
				"n": "海州区",
				"pc": "320700"
			}, {
				"c": "320721",
				"n": "赣榆县",
				"pc": "320700"
			}, {
				"c": "320722",
				"n": "东海县",
				"pc": "320700"
			}, {
				"c": "320723",
				"n": "灌云县",
				"pc": "320700"
			}, {
				"c": "320724",
				"n": "灌南县",
				"pc": "320700"
			}, {
				"c": "320800",
				"n": "淮安市",
				"pc": "320000"
			}, {
				"c": "320801",
				"n": "市辖区",
				"pc": "320800"
			}, {
				"c": "320802",
				"n": "清河区",
				"pc": "320800"
			}, {
				"c": "320803",
				"n": "淮安区",
				"pc": "320800"
			}, {
				"c": "320804",
				"n": "淮阴区",
				"pc": "320800"
			}, {
				"c": "320811",
				"n": "清浦区",
				"pc": "320800"
			}, {
				"c": "320826",
				"n": "涟水县",
				"pc": "320800"
			}, {
				"c": "320829",
				"n": "洪泽县",
				"pc": "320800"
			}, {
				"c": "320830",
				"n": "盱眙县",
				"pc": "320800"
			}, {
				"c": "320831",
				"n": "金湖县",
				"pc": "320800"
			}, {
				"c": "320900",
				"n": "盐城市",
				"pc": "320000"
			}, {
				"c": "320901",
				"n": "市辖区",
				"pc": "320900"
			}, {
				"c": "320902",
				"n": "亭湖区",
				"pc": "320900"
			}, {
				"c": "320903",
				"n": "盐都区",
				"pc": "320900"
			}, {
				"c": "320921",
				"n": "响水县",
				"pc": "320900"
			}, {
				"c": "320922",
				"n": "滨海县",
				"pc": "320900"
			}, {
				"c": "320923",
				"n": "阜宁县",
				"pc": "320900"
			}, {
				"c": "320924",
				"n": "射阳县",
				"pc": "320900"
			}, {
				"c": "320925",
				"n": "建湖县",
				"pc": "320900"
			}, {
				"c": "320981",
				"n": "东台市",
				"pc": "320900"
			}, {
				"c": "320982",
				"n": "大丰市",
				"pc": "320900"
			}, {
				"c": "321000",
				"n": "扬州市",
				"pc": "320000"
			}, {
				"c": "321001",
				"n": "市辖区",
				"pc": "321000"
			}, {
				"c": "321002",
				"n": "广陵区",
				"pc": "321000"
			}, {
				"c": "321003",
				"n": "邗江区",
				"pc": "321000"
			}, {
				"c": "321012",
				"n": "江都区",
				"pc": "321000"
			}, {
				"c": "321023",
				"n": "宝应县",
				"pc": "321000"
			}, {
				"c": "321081",
				"n": "仪征市",
				"pc": "321000"
			}, {
				"c": "321084",
				"n": "高邮市",
				"pc": "321000"
			}, {
				"c": "321100",
				"n": "镇江市",
				"pc": "320000"
			}, {
				"c": "321101",
				"n": "市辖区",
				"pc": "321100"
			}, {
				"c": "321102",
				"n": "京口区",
				"pc": "321100"
			}, {
				"c": "321111",
				"n": "润州区",
				"pc": "321100"
			}, {
				"c": "321112",
				"n": "丹徒区",
				"pc": "321100"
			}, {
				"c": "321181",
				"n": "丹阳市",
				"pc": "321100"
			}, {
				"c": "321182",
				"n": "扬中市",
				"pc": "321100"
			}, {
				"c": "321183",
				"n": "句容市",
				"pc": "321100"
			}, {
				"c": "321200",
				"n": "泰州市",
				"pc": "320000"
			}, {
				"c": "321201",
				"n": "市辖区",
				"pc": "321200"
			}, {
				"c": "321202",
				"n": "海陵区",
				"pc": "321200"
			}, {
				"c": "321203",
				"n": "高港区",
				"pc": "321200"
			}, {
				"c": "321281",
				"n": "兴化市",
				"pc": "321200"
			}, {
				"c": "321282",
				"n": "靖江市",
				"pc": "321200"
			}, {
				"c": "321283",
				"n": "泰兴市",
				"pc": "321200"
			}, {
				"c": "321284",
				"n": "姜堰市",
				"pc": "321200"
			}, {
				"c": "321300",
				"n": "宿迁市",
				"pc": "320000"
			}, {
				"c": "321301",
				"n": "市辖区",
				"pc": "321300"
			}, {
				"c": "321302",
				"n": "宿城区",
				"pc": "321300"
			}, {
				"c": "321311",
				"n": "宿豫区",
				"pc": "321300"
			}, {
				"c": "321322",
				"n": "沭阳县",
				"pc": "321300"
			}, {
				"c": "321323",
				"n": "泗阳县",
				"pc": "321300"
			}, {
				"c": "321324",
				"n": "泗洪县",
				"pc": "321300"
			}, {
				"c": "330000",
				"n": "浙江省",
				"pc": "86"
			}, {
				"c": "330100",
				"n": "杭州市",
				"pc": "330000"
			}, {
				"c": "330101",
				"n": "市辖区",
				"pc": "330100"
			}, {
				"c": "330102",
				"n": "上城区",
				"pc": "330100"
			}, {
				"c": "330103",
				"n": "下城区",
				"pc": "330100"
			}, {
				"c": "330104",
				"n": "江干区",
				"pc": "330100"
			}, {
				"c": "330105",
				"n": "拱墅区",
				"pc": "330100"
			}, {
				"c": "330106",
				"n": "西湖区",
				"pc": "330100"
			}, {
				"c": "330108",
				"n": "滨江区",
				"pc": "330100"
			}, {
				"c": "330109",
				"n": "萧山区",
				"pc": "330100"
			}, {
				"c": "330110",
				"n": "余杭区",
				"pc": "330100"
			}, {
				"c": "330122",
				"n": "桐庐县",
				"pc": "330100"
			}, {
				"c": "330127",
				"n": "淳安县",
				"pc": "330100"
			}, {
				"c": "330182",
				"n": "建德市",
				"pc": "330100"
			}, {
				"c": "330183",
				"n": "富阳市",
				"pc": "330100"
			}, {
				"c": "330185",
				"n": "临安市",
				"pc": "330100"
			}, {
				"c": "330200",
				"n": "宁波市",
				"pc": "330000"
			}, {
				"c": "330201",
				"n": "市辖区",
				"pc": "330200"
			}, {
				"c": "330203",
				"n": "海曙区",
				"pc": "330200"
			}, {
				"c": "330204",
				"n": "江东区",
				"pc": "330200"
			}, {
				"c": "330205",
				"n": "江北区",
				"pc": "330200"
			}, {
				"c": "330206",
				"n": "北仑区",
				"pc": "330200"
			}, {
				"c": "330211",
				"n": "镇海区",
				"pc": "330200"
			}, {
				"c": "330212",
				"n": "鄞州区",
				"pc": "330200"
			}, {
				"c": "330225",
				"n": "象山县",
				"pc": "330200"
			}, {
				"c": "330226",
				"n": "宁海县",
				"pc": "330200"
			}, {
				"c": "330281",
				"n": "余姚市",
				"pc": "330200"
			}, {
				"c": "330282",
				"n": "慈溪市",
				"pc": "330200"
			}, {
				"c": "330283",
				"n": "奉化市",
				"pc": "330200"
			}, {
				"c": "330300",
				"n": "温州市",
				"pc": "330000"
			}, {
				"c": "330301",
				"n": "市辖区",
				"pc": "330300"
			}, {
				"c": "330302",
				"n": "鹿城区",
				"pc": "330300"
			}, {
				"c": "330303",
				"n": "龙湾区",
				"pc": "330300"
			}, {
				"c": "330304",
				"n": "瓯海区",
				"pc": "330300"
			}, {
				"c": "330322",
				"n": "洞头县",
				"pc": "330300"
			}, {
				"c": "330324",
				"n": "永嘉县",
				"pc": "330300"
			}, {
				"c": "330326",
				"n": "平阳县",
				"pc": "330300"
			}, {
				"c": "330327",
				"n": "苍南县",
				"pc": "330300"
			}, {
				"c": "330328",
				"n": "文成县",
				"pc": "330300"
			}, {
				"c": "330329",
				"n": "泰顺县",
				"pc": "330300"
			}, {
				"c": "330381",
				"n": "瑞安市",
				"pc": "330300"
			}, {
				"c": "330382",
				"n": "乐清市",
				"pc": "330300"
			}, {
				"c": "330400",
				"n": "嘉兴市",
				"pc": "330000"
			}, {
				"c": "330401",
				"n": "市辖区",
				"pc": "330400"
			}, {
				"c": "330402",
				"n": "南湖区",
				"pc": "330400"
			}, {
				"c": "330411",
				"n": "秀洲区",
				"pc": "330400"
			}, {
				"c": "330421",
				"n": "嘉善县",
				"pc": "330400"
			}, {
				"c": "330424",
				"n": "海盐县",
				"pc": "330400"
			}, {
				"c": "330481",
				"n": "海宁市",
				"pc": "330400"
			}, {
				"c": "330482",
				"n": "平湖市",
				"pc": "330400"
			}, {
				"c": "330483",
				"n": "桐乡市",
				"pc": "330400"
			}, {
				"c": "330500",
				"n": "湖州市",
				"pc": "330000"
			}, {
				"c": "330501",
				"n": "市辖区",
				"pc": "330500"
			}, {
				"c": "330502",
				"n": "吴兴区",
				"pc": "330500"
			}, {
				"c": "330503",
				"n": "南浔区",
				"pc": "330500"
			}, {
				"c": "330521",
				"n": "德清县",
				"pc": "330500"
			}, {
				"c": "330522",
				"n": "长兴县",
				"pc": "330500"
			}, {
				"c": "330523",
				"n": "安吉县",
				"pc": "330500"
			}, {
				"c": "330600",
				"n": "绍兴市",
				"pc": "330000"
			}, {
				"c": "330601",
				"n": "市辖区",
				"pc": "330600"
			}, {
				"c": "330602",
				"n": "越城区",
				"pc": "330600"
			}, {
				"c": "330621",
				"n": "绍兴县",
				"pc": "330600"
			}, {
				"c": "330624",
				"n": "新昌县",
				"pc": "330600"
			}, {
				"c": "330681",
				"n": "诸暨市",
				"pc": "330600"
			}, {
				"c": "330682",
				"n": "上虞市",
				"pc": "330600"
			}, {
				"c": "330683",
				"n": "嵊州市",
				"pc": "330600"
			}, {
				"c": "330700",
				"n": "金华市",
				"pc": "330000"
			}, {
				"c": "330701",
				"n": "市辖区",
				"pc": "330700"
			}, {
				"c": "330702",
				"n": "婺城区",
				"pc": "330700"
			}, {
				"c": "330703",
				"n": "金东区",
				"pc": "330700"
			}, {
				"c": "330723",
				"n": "武义县",
				"pc": "330700"
			}, {
				"c": "330726",
				"n": "浦江县",
				"pc": "330700"
			}, {
				"c": "330727",
				"n": "磐安县",
				"pc": "330700"
			}, {
				"c": "330781",
				"n": "兰溪市",
				"pc": "330700"
			}, {
				"c": "330782",
				"n": "义乌市",
				"pc": "330700"
			}, {
				"c": "330783",
				"n": "东阳市",
				"pc": "330700"
			}, {
				"c": "330784",
				"n": "永康市",
				"pc": "330700"
			}, {
				"c": "330800",
				"n": "衢州市",
				"pc": "330000"
			}, {
				"c": "330801",
				"n": "市辖区",
				"pc": "330800"
			}, {
				"c": "330802",
				"n": "柯城区",
				"pc": "330800"
			}, {
				"c": "330803",
				"n": "衢江区",
				"pc": "330800"
			}, {
				"c": "330822",
				"n": "常山县",
				"pc": "330800"
			}, {
				"c": "330824",
				"n": "开化县",
				"pc": "330800"
			}, {
				"c": "330825",
				"n": "龙游县",
				"pc": "330800"
			}, {
				"c": "330881",
				"n": "江山市",
				"pc": "330800"
			}, {
				"c": "330900",
				"n": "舟山市",
				"pc": "330000"
			}, {
				"c": "330901",
				"n": "市辖区",
				"pc": "330900"
			}, {
				"c": "330902",
				"n": "定海区",
				"pc": "330900"
			}, {
				"c": "330903",
				"n": "普陀区",
				"pc": "330900"
			}, {
				"c": "330921",
				"n": "岱山县",
				"pc": "330900"
			}, {
				"c": "330922",
				"n": "嵊泗县",
				"pc": "330900"
			}, {
				"c": "331000",
				"n": "台州市",
				"pc": "330000"
			}, {
				"c": "331001",
				"n": "市辖区",
				"pc": "331000"
			}, {
				"c": "331002",
				"n": "椒江区",
				"pc": "331000"
			}, {
				"c": "331003",
				"n": "黄岩区",
				"pc": "331000"
			}, {
				"c": "331004",
				"n": "路桥区",
				"pc": "331000"
			}, {
				"c": "331021",
				"n": "玉环县",
				"pc": "331000"
			}, {
				"c": "331022",
				"n": "三门县",
				"pc": "331000"
			}, {
				"c": "331023",
				"n": "天台县",
				"pc": "331000"
			}, {
				"c": "331024",
				"n": "仙居县",
				"pc": "331000"
			}, {
				"c": "331081",
				"n": "温岭市",
				"pc": "331000"
			}, {
				"c": "331082",
				"n": "临海市",
				"pc": "331000"
			}, {
				"c": "331100",
				"n": "丽水市",
				"pc": "330000"
			}, {
				"c": "331101",
				"n": "市辖区",
				"pc": "331100"
			}, {
				"c": "331102",
				"n": "莲都区",
				"pc": "331100"
			}, {
				"c": "331121",
				"n": "青田县",
				"pc": "331100"
			}, {
				"c": "331122",
				"n": "缙云县",
				"pc": "331100"
			}, {
				"c": "331123",
				"n": "遂昌县",
				"pc": "331100"
			}, {
				"c": "331124",
				"n": "松阳县",
				"pc": "331100"
			}, {
				"c": "331125",
				"n": "云和县",
				"pc": "331100"
			}, {
				"c": "331126",
				"n": "庆元县",
				"pc": "331100"
			}, {
				"c": "331127",
				"n": "景宁畲族自治县",
				"pc": "331100"
			}, {
				"c": "331181",
				"n": "龙泉市",
				"pc": "331100"
			}, {
				"c": "340000",
				"n": "安徽省",
				"pc": "86"
			}, {
				"c": "340100",
				"n": "合肥市",
				"pc": "340000"
			}, {
				"c": "340101",
				"n": "市辖区",
				"pc": "340100"
			}, {
				"c": "340102",
				"n": "瑶海区",
				"pc": "340100"
			}, {
				"c": "340103",
				"n": "庐阳区",
				"pc": "340100"
			}, {
				"c": "340104",
				"n": "蜀山区",
				"pc": "340100"
			}, {
				"c": "340111",
				"n": "包河区",
				"pc": "340100"
			}, {
				"c": "340121",
				"n": "长丰县",
				"pc": "340100"
			}, {
				"c": "340122",
				"n": "肥东县",
				"pc": "340100"
			}, {
				"c": "340123",
				"n": "肥西县",
				"pc": "340100"
			}, {
				"c": "340124",
				"n": "庐江县",
				"pc": "340100"
			}, {
				"c": "340181",
				"n": "巢湖市",
				"pc": "340100"
			}, {
				"c": "340200",
				"n": "芜湖市",
				"pc": "340000"
			}, {
				"c": "340201",
				"n": "市辖区",
				"pc": "340200"
			}, {
				"c": "340202",
				"n": "镜湖区",
				"pc": "340200"
			}, {
				"c": "340203",
				"n": "弋江区",
				"pc": "340200"
			}, {
				"c": "340207",
				"n": "鸠江区",
				"pc": "340200"
			}, {
				"c": "340208",
				"n": "三山区",
				"pc": "340200"
			}, {
				"c": "340221",
				"n": "芜湖县",
				"pc": "340200"
			}, {
				"c": "340222",
				"n": "繁昌县",
				"pc": "340200"
			}, {
				"c": "340223",
				"n": "南陵县",
				"pc": "340200"
			}, {
				"c": "340225",
				"n": "无为县",
				"pc": "340200"
			}, {
				"c": "340300",
				"n": "蚌埠市",
				"pc": "340000"
			}, {
				"c": "340301",
				"n": "市辖区",
				"pc": "340300"
			}, {
				"c": "340302",
				"n": "龙子湖区",
				"pc": "340300"
			}, {
				"c": "340303",
				"n": "蚌山区",
				"pc": "340300"
			}, {
				"c": "340304",
				"n": "禹会区",
				"pc": "340300"
			}, {
				"c": "340311",
				"n": "淮上区",
				"pc": "340300"
			}, {
				"c": "340321",
				"n": "怀远县",
				"pc": "340300"
			}, {
				"c": "340322",
				"n": "五河县",
				"pc": "340300"
			}, {
				"c": "340323",
				"n": "固镇县",
				"pc": "340300"
			}, {
				"c": "340400",
				"n": "淮南市",
				"pc": "340000"
			}, {
				"c": "340401",
				"n": "市辖区",
				"pc": "340400"
			}, {
				"c": "340402",
				"n": "大通区",
				"pc": "340400"
			}, {
				"c": "340403",
				"n": "田家庵区",
				"pc": "340400"
			}, {
				"c": "340404",
				"n": "谢家集区",
				"pc": "340400"
			}, {
				"c": "340405",
				"n": "八公山区",
				"pc": "340400"
			}, {
				"c": "340406",
				"n": "潘集区",
				"pc": "340400"
			}, {
				"c": "340421",
				"n": "凤台县",
				"pc": "340400"
			}, {
				"c": "340500",
				"n": "马鞍山市",
				"pc": "340000"
			}, {
				"c": "340501",
				"n": "市辖区",
				"pc": "340500"
			}, {
				"c": "340503",
				"n": "花山区",
				"pc": "340500"
			}, {
				"c": "340504",
				"n": "雨山区",
				"pc": "340500"
			}, {
				"c": "340506",
				"n": "博望区",
				"pc": "340500"
			}, {
				"c": "340521",
				"n": "当涂县",
				"pc": "340500"
			}, {
				"c": "340522",
				"n": "含山县",
				"pc": "340500"
			}, {
				"c": "340523",
				"n": "和县",
				"pc": "340500"
			}, {
				"c": "340600",
				"n": "淮北市",
				"pc": "340000"
			}, {
				"c": "340601",
				"n": "市辖区",
				"pc": "340600"
			}, {
				"c": "340602",
				"n": "杜集区",
				"pc": "340600"
			}, {
				"c": "340603",
				"n": "相山区",
				"pc": "340600"
			}, {
				"c": "340604",
				"n": "烈山区",
				"pc": "340600"
			}, {
				"c": "340621",
				"n": "濉溪县",
				"pc": "340600"
			}, {
				"c": "340700",
				"n": "铜陵市",
				"pc": "340000"
			}, {
				"c": "340701",
				"n": "市辖区",
				"pc": "340700"
			}, {
				"c": "340702",
				"n": "铜官山区",
				"pc": "340700"
			}, {
				"c": "340703",
				"n": "狮子山区",
				"pc": "340700"
			}, {
				"c": "340711",
				"n": "郊区",
				"pc": "340700"
			}, {
				"c": "340721",
				"n": "铜陵县",
				"pc": "340700"
			}, {
				"c": "340800",
				"n": "安庆市",
				"pc": "340000"
			}, {
				"c": "340801",
				"n": "市辖区",
				"pc": "340800"
			}, {
				"c": "340802",
				"n": "迎江区",
				"pc": "340800"
			}, {
				"c": "340803",
				"n": "大观区",
				"pc": "340800"
			}, {
				"c": "340811",
				"n": "宜秀区",
				"pc": "340800"
			}, {
				"c": "340822",
				"n": "怀宁县",
				"pc": "340800"
			}, {
				"c": "340823",
				"n": "枞阳县",
				"pc": "340800"
			}, {
				"c": "340824",
				"n": "潜山县",
				"pc": "340800"
			}, {
				"c": "340825",
				"n": "太湖县",
				"pc": "340800"
			}, {
				"c": "340826",
				"n": "宿松县",
				"pc": "340800"
			}, {
				"c": "340827",
				"n": "望江县",
				"pc": "340800"
			}, {
				"c": "340828",
				"n": "岳西县",
				"pc": "340800"
			}, {
				"c": "340881",
				"n": "桐城市",
				"pc": "340800"
			}, {
				"c": "341000",
				"n": "黄山市",
				"pc": "340000"
			}, {
				"c": "341001",
				"n": "市辖区",
				"pc": "341000"
			}, {
				"c": "341002",
				"n": "屯溪区",
				"pc": "341000"
			}, {
				"c": "341003",
				"n": "黄山区o:p>",
				"pc": "341000"
			}, {
				"c": "341004",
				"n": "徽州区",
				"pc": "341000"
			}, {
				"c": "341021",
				"n": "歙县",
				"pc": "341000"
			}, {
				"c": "341022",
				"n": "休宁县",
				"pc": "341000"
			}, {
				"c": "341023",
				"n": "黟县",
				"pc": "341000"
			}, {
				"c": "341024",
				"n": "祁门县",
				"pc": "341000"
			}, {
				"c": "341100",
				"n": "滁州市",
				"pc": "340000"
			}, {
				"c": "341101",
				"n": "市辖区",
				"pc": "341100"
			}, {
				"c": "341102",
				"n": "琅琊区",
				"pc": "341100"
			}, {
				"c": "341103",
				"n": "南谯区",
				"pc": "341100"
			}, {
				"c": "341122",
				"n": "来安县",
				"pc": "341100"
			}, {
				"c": "341124",
				"n": "全椒县",
				"pc": "341100"
			}, {
				"c": "341125",
				"n": "定远县",
				"pc": "341100"
			}, {
				"c": "341126",
				"n": "凤阳县",
				"pc": "341100"
			}, {
				"c": "341181",
				"n": "天长市",
				"pc": "341100"
			}, {
				"c": "341182",
				"n": "明光市",
				"pc": "341100"
			}, {
				"c": "341200",
				"n": "阜阳市",
				"pc": "340000"
			}, {
				"c": "341201",
				"n": "市辖区",
				"pc": "341200"
			}, {
				"c": "341202",
				"n": "颍州区",
				"pc": "341200"
			}, {
				"c": "341203",
				"n": "颍东区",
				"pc": "341200"
			}, {
				"c": "341204",
				"n": "颍泉区",
				"pc": "341200"
			}, {
				"c": "341221",
				"n": "临泉县",
				"pc": "341200"
			}, {
				"c": "341222",
				"n": "太和县",
				"pc": "341200"
			}, {
				"c": "341225",
				"n": "阜南县",
				"pc": "341200"
			}, {
				"c": "341226",
				"n": "颍上县",
				"pc": "341200"
			}, {
				"c": "341282",
				"n": "界首市",
				"pc": "341200"
			}, {
				"c": "341300",
				"n": "宿州市",
				"pc": "340000"
			}, {
				"c": "341301",
				"n": "市辖区",
				"pc": "341300"
			}, {
				"c": "341302",
				"n": "埇桥区",
				"pc": "341300"
			}, {
				"c": "341321",
				"n": "砀山县",
				"pc": "341300"
			}, {
				"c": "341322",
				"n": "萧县",
				"pc": "341300"
			}, {
				"c": "341323",
				"n": "灵璧县",
				"pc": "341300"
			}, {
				"c": "341324",
				"n": "泗县",
				"pc": "341300"
			}, {
				"c": "341500",
				"n": "六安市",
				"pc": "340000"
			}, {
				"c": "341501",
				"n": "市辖区",
				"pc": "341500"
			}, {
				"c": "341502",
				"n": "金安区",
				"pc": "341500"
			}, {
				"c": "341503",
				"n": "裕安区",
				"pc": "341500"
			}, {
				"c": "341521",
				"n": "寿县",
				"pc": "341500"
			}, {
				"c": "341522",
				"n": "霍邱县",
				"pc": "341500"
			}, {
				"c": "341523",
				"n": "舒城县",
				"pc": "341500"
			}, {
				"c": "341524",
				"n": "金寨县",
				"pc": "341500"
			}, {
				"c": "341525",
				"n": "霍山县",
				"pc": "341500"
			}, {
				"c": "341600",
				"n": "亳州市",
				"pc": "340000"
			}, {
				"c": "341601",
				"n": "市辖区",
				"pc": "341600"
			}, {
				"c": "341602",
				"n": "谯城区",
				"pc": "341600"
			}, {
				"c": "341621",
				"n": "涡阳县",
				"pc": "341600"
			}, {
				"c": "341622",
				"n": "蒙城县",
				"pc": "341600"
			}, {
				"c": "341623",
				"n": "利辛县",
				"pc": "341600"
			}, {
				"c": "341700",
				"n": "池州市",
				"pc": "340000"
			}, {
				"c": "341701",
				"n": "市辖区",
				"pc": "341700"
			}, {
				"c": "341702",
				"n": "贵池区",
				"pc": "341700"
			}, {
				"c": "341721",
				"n": "东至县",
				"pc": "341700"
			}, {
				"c": "341722",
				"n": "石台县",
				"pc": "341700"
			}, {
				"c": "341723",
				"n": "青阳县",
				"pc": "341700"
			}, {
				"c": "341800",
				"n": "宣城市",
				"pc": "340000"
			}, {
				"c": "341801",
				"n": "市辖区",
				"pc": "341800"
			}, {
				"c": "341802",
				"n": "宣州区",
				"pc": "341800"
			}, {
				"c": "341821",
				"n": "郎溪县",
				"pc": "341800"
			}, {
				"c": "341822",
				"n": "广德县",
				"pc": "341800"
			}, {
				"c": "341823",
				"n": "泾县",
				"pc": "341800"
			}, {
				"c": "341824",
				"n": "绩溪县",
				"pc": "341800"
			}, {
				"c": "341825",
				"n": "旌德县",
				"pc": "341800"
			}, {
				"c": "341881",
				"n": "宁国市",
				"pc": "341800"
			}, {
				"c": "350000",
				"n": "福建省",
				"pc": "86"
			}, {
				"c": "350100",
				"n": "福州市",
				"pc": "350000"
			}, {
				"c": "350101",
				"n": "市辖区",
				"pc": "350100"
			}, {
				"c": "350102",
				"n": "鼓楼区",
				"pc": "350100"
			}, {
				"c": "350103",
				"n": "台江区",
				"pc": "350100"
			}, {
				"c": "350104",
				"n": "仓山区",
				"pc": "350100"
			}, {
				"c": "350105",
				"n": "马尾区",
				"pc": "350100"
			}, {
				"c": "350111",
				"n": "晋安区",
				"pc": "350100"
			}, {
				"c": "350121",
				"n": "闽侯县",
				"pc": "350100"
			}, {
				"c": "350122",
				"n": "连江县",
				"pc": "350100"
			}, {
				"c": "350123",
				"n": "罗源县",
				"pc": "350100"
			}, {
				"c": "350124",
				"n": "闽清县",
				"pc": "350100"
			}, {
				"c": "350125",
				"n": "永泰县",
				"pc": "350100"
			}, {
				"c": "350128",
				"n": "平潭县",
				"pc": "350100"
			}, {
				"c": "350181",
				"n": "福清市",
				"pc": "350100"
			}, {
				"c": "350182",
				"n": "长乐市",
				"pc": "350100"
			}, {
				"c": "350200",
				"n": "厦门市",
				"pc": "350000"
			}, {
				"c": "350201",
				"n": "市辖区",
				"pc": "350200"
			}, {
				"c": "350203",
				"n": "思明区",
				"pc": "350200"
			}, {
				"c": "350205",
				"n": "海沧区",
				"pc": "350200"
			}, {
				"c": "350206",
				"n": "湖里区",
				"pc": "350200"
			}, {
				"c": "350211",
				"n": "集美区",
				"pc": "350200"
			}, {
				"c": "350212",
				"n": "同安区",
				"pc": "350200"
			}, {
				"c": "350213",
				"n": "翔安区",
				"pc": "350200"
			}, {
				"c": "350300",
				"n": "莆田市",
				"pc": "350000"
			}, {
				"c": "350301",
				"n": "市辖区",
				"pc": "350300"
			}, {
				"c": "350302",
				"n": "城厢区",
				"pc": "350300"
			}, {
				"c": "350303",
				"n": "涵江区",
				"pc": "350300"
			}, {
				"c": "350304",
				"n": "荔城区",
				"pc": "350300"
			}, {
				"c": "350305",
				"n": "秀屿区",
				"pc": "350300"
			}, {
				"c": "350322",
				"n": "仙游县",
				"pc": "350300"
			}, {
				"c": "350400",
				"n": "三明市",
				"pc": "350000"
			}, {
				"c": "350401",
				"n": "市辖区",
				"pc": "350400"
			}, {
				"c": "350402",
				"n": "梅列区",
				"pc": "350400"
			}, {
				"c": "350403",
				"n": "三元区",
				"pc": "350400"
			}, {
				"c": "350421",
				"n": "明溪县",
				"pc": "350400"
			}, {
				"c": "350423",
				"n": "清流县",
				"pc": "350400"
			}, {
				"c": "350424",
				"n": "宁化县",
				"pc": "350400"
			}, {
				"c": "350425",
				"n": "大田县",
				"pc": "350400"
			}, {
				"c": "350426",
				"n": "尤溪县",
				"pc": "350400"
			}, {
				"c": "350427",
				"n": "沙县",
				"pc": "350400"
			}, {
				"c": "350428",
				"n": "将乐县",
				"pc": "350400"
			}, {
				"c": "350429",
				"n": "泰宁县",
				"pc": "350400"
			}, {
				"c": "350430",
				"n": "建宁县",
				"pc": "350400"
			}, {
				"c": "350481",
				"n": "永安市",
				"pc": "350400"
			}, {
				"c": "350500",
				"n": "泉州市",
				"pc": "350000"
			}, {
				"c": "350501",
				"n": "市辖区",
				"pc": "350500"
			}, {
				"c": "350502",
				"n": "鲤城区",
				"pc": "350500"
			}, {
				"c": "350503",
				"n": "丰泽区",
				"pc": "350500"
			}, {
				"c": "350504",
				"n": "洛江区",
				"pc": "350500"
			}, {
				"c": "350505",
				"n": "泉港区",
				"pc": "350500"
			}, {
				"c": "350521",
				"n": "惠安县",
				"pc": "350500"
			}, {
				"c": "350524",
				"n": "安溪县",
				"pc": "350500"
			}, {
				"c": "350525",
				"n": "永春县",
				"pc": "350500"
			}, {
				"c": "350526",
				"n": "德化县",
				"pc": "350500"
			}, {
				"c": "350527",
				"n": "金门县",
				"pc": "350500"
			}, {
				"c": "350581",
				"n": "石狮市",
				"pc": "350500"
			}, {
				"c": "350582",
				"n": "晋江市",
				"pc": "350500"
			}, {
				"c": "350583",
				"n": "南安市",
				"pc": "350500"
			}, {
				"c": "350600",
				"n": "漳州市",
				"pc": "350000"
			}, {
				"c": "350601",
				"n": "市辖区",
				"pc": "350600"
			}, {
				"c": "350602",
				"n": "芗城区",
				"pc": "350600"
			}, {
				"c": "350603",
				"n": "龙文区",
				"pc": "350600"
			}, {
				"c": "350622",
				"n": "云霄县",
				"pc": "350600"
			}, {
				"c": "350623",
				"n": "漳浦县",
				"pc": "350600"
			}, {
				"c": "350624",
				"n": "诏安县",
				"pc": "350600"
			}, {
				"c": "350625",
				"n": "长泰县",
				"pc": "350600"
			}, {
				"c": "350626",
				"n": "东山县",
				"pc": "350600"
			}, {
				"c": "350627",
				"n": "南靖县",
				"pc": "350600"
			}, {
				"c": "350628",
				"n": "平和县",
				"pc": "350600"
			}, {
				"c": "350629",
				"n": "华安县",
				"pc": "350600"
			}, {
				"c": "350681",
				"n": "龙海市",
				"pc": "350600"
			}, {
				"c": "350700",
				"n": "南平市",
				"pc": "350000"
			}, {
				"c": "350701",
				"n": "市辖区",
				"pc": "350700"
			}, {
				"c": "350702",
				"n": "延平区",
				"pc": "350700"
			}, {
				"c": "350721",
				"n": "顺昌县",
				"pc": "350700"
			}, {
				"c": "350722",
				"n": "浦城县",
				"pc": "350700"
			}, {
				"c": "350723",
				"n": "光泽县",
				"pc": "350700"
			}, {
				"c": "350724",
				"n": "松溪县",
				"pc": "350700"
			}, {
				"c": "350725",
				"n": "政和县",
				"pc": "350700"
			}, {
				"c": "350781",
				"n": "邵武市",
				"pc": "350700"
			}, {
				"c": "350782",
				"n": "武夷山市",
				"pc": "350700"
			}, {
				"c": "350783",
				"n": "建瓯市",
				"pc": "350700"
			}, {
				"c": "350784",
				"n": "建阳市",
				"pc": "350700"
			}, {
				"c": "350800",
				"n": "龙岩市",
				"pc": "350000"
			}, {
				"c": "350801",
				"n": "市辖区",
				"pc": "350800"
			}, {
				"c": "350802",
				"n": "新罗区",
				"pc": "350800"
			}, {
				"c": "350821",
				"n": "长汀县",
				"pc": "350800"
			}, {
				"c": "350822",
				"n": "永定县",
				"pc": "350800"
			}, {
				"c": "350823",
				"n": "上杭县",
				"pc": "350800"
			}, {
				"c": "350824",
				"n": "武平县",
				"pc": "350800"
			}, {
				"c": "350825",
				"n": "连城县",
				"pc": "350800"
			}, {
				"c": "350881",
				"n": "漳平市",
				"pc": "350800"
			}, {
				"c": "350900",
				"n": "宁德市",
				"pc": "350000"
			}, {
				"c": "350901",
				"n": "市辖区",
				"pc": "350900"
			}, {
				"c": "350902",
				"n": "蕉城区",
				"pc": "350900"
			}, {
				"c": "350921",
				"n": "霞浦县",
				"pc": "350900"
			}, {
				"c": "350922",
				"n": "古田县",
				"pc": "350900"
			}, {
				"c": "350923",
				"n": "屏南县",
				"pc": "350900"
			}, {
				"c": "350924",
				"n": "寿宁县",
				"pc": "350900"
			}, {
				"c": "350925",
				"n": "周宁县",
				"pc": "350900"
			}, {
				"c": "350926",
				"n": "柘荣县",
				"pc": "350900"
			}, {
				"c": "350981",
				"n": "福安市",
				"pc": "350900"
			}, {
				"c": "350982",
				"n": "福鼎市",
				"pc": "350900"
			}, {
				"c": "360000",
				"n": "江西省",
				"pc": "86"
			}, {
				"c": "360100",
				"n": "南昌市",
				"pc": "360000"
			}, {
				"c": "360101",
				"n": "市辖区",
				"pc": "360100"
			}, {
				"c": "360102",
				"n": "东湖区",
				"pc": "360100"
			}, {
				"c": "360103",
				"n": "西湖区",
				"pc": "360100"
			}, {
				"c": "360104",
				"n": "青云谱区",
				"pc": "360100"
			}, {
				"c": "360105",
				"n": "湾里区",
				"pc": "360100"
			}, {
				"c": "360111",
				"n": "青山湖区",
				"pc": "360100"
			}, {
				"c": "360121",
				"n": "南昌县",
				"pc": "360100"
			}, {
				"c": "360122",
				"n": "新建县",
				"pc": "360100"
			}, {
				"c": "360123",
				"n": "安义县",
				"pc": "360100"
			}, {
				"c": "360124",
				"n": "进贤县",
				"pc": "360100"
			}, {
				"c": "360200",
				"n": "景德镇市",
				"pc": "360000"
			}, {
				"c": "360201",
				"n": "市辖区",
				"pc": "360200"
			}, {
				"c": "360202",
				"n": "昌江区",
				"pc": "360200"
			}, {
				"c": "360203",
				"n": "珠山区",
				"pc": "360200"
			}, {
				"c": "360222",
				"n": "浮梁县",
				"pc": "360200"
			}, {
				"c": "360281",
				"n": "乐平市",
				"pc": "360200"
			}, {
				"c": "360300",
				"n": "萍乡市",
				"pc": "360000"
			}, {
				"c": "360301",
				"n": "市辖区",
				"pc": "360300"
			}, {
				"c": "360302",
				"n": "安源区",
				"pc": "360300"
			}, {
				"c": "360313",
				"n": "湘东区",
				"pc": "360300"
			}, {
				"c": "360321",
				"n": "莲花县",
				"pc": "360300"
			}, {
				"c": "360322",
				"n": "上栗县",
				"pc": "360300"
			}, {
				"c": "360323",
				"n": "芦溪县",
				"pc": "360300"
			}, {
				"c": "360400",
				"n": "九江市",
				"pc": "360000"
			}, {
				"c": "360401",
				"n": "市辖区",
				"pc": "360400"
			}, {
				"c": "360402",
				"n": "庐山区",
				"pc": "360400"
			}, {
				"c": "360403",
				"n": "浔阳区",
				"pc": "360400"
			}, {
				"c": "360421",
				"n": "九江县",
				"pc": "360400"
			}, {
				"c": "360423",
				"n": "武宁县",
				"pc": "360400"
			}, {
				"c": "360424",
				"n": "修水县",
				"pc": "360400"
			}, {
				"c": "360425",
				"n": "永修县",
				"pc": "360400"
			}, {
				"c": "360426",
				"n": "德安县",
				"pc": "360400"
			}, {
				"c": "360427",
				"n": "星子县",
				"pc": "360400"
			}, {
				"c": "360428",
				"n": "都昌县",
				"pc": "360400"
			}, {
				"c": "360429",
				"n": "湖口县",
				"pc": "360400"
			}, {
				"c": "360430",
				"n": "彭泽县",
				"pc": "360400"
			}, {
				"c": "360481",
				"n": "瑞昌市",
				"pc": "360400"
			}, {
				"c": "360482",
				"n": "共青城市",
				"pc": "360400"
			}, {
				"c": "360500",
				"n": "新余市",
				"pc": "360000"
			}, {
				"c": "360501",
				"n": "市辖区",
				"pc": "360500"
			}, {
				"c": "360502",
				"n": "渝水区",
				"pc": "360500"
			}, {
				"c": "360521",
				"n": "分宜县",
				"pc": "360500"
			}, {
				"c": "360600",
				"n": "鹰潭市",
				"pc": "360000"
			}, {
				"c": "360601",
				"n": "市辖区",
				"pc": "360600"
			}, {
				"c": "360602",
				"n": "月湖区",
				"pc": "360600"
			}, {
				"c": "360622",
				"n": "余江县",
				"pc": "360600"
			}, {
				"c": "360681",
				"n": "贵溪市",
				"pc": "360600"
			}, {
				"c": "360700",
				"n": "赣州市",
				"pc": "360000"
			}, {
				"c": "360701",
				"n": "市辖区",
				"pc": "360700"
			}, {
				"c": "360702",
				"n": "章贡区",
				"pc": "360700"
			}, {
				"c": "360721",
				"n": "赣县",
				"pc": "360700"
			}, {
				"c": "360722",
				"n": "信丰县",
				"pc": "360700"
			}, {
				"c": "360723",
				"n": "大余县",
				"pc": "360700"
			}, {
				"c": "360724",
				"n": "上犹县",
				"pc": "360700"
			}, {
				"c": "360725",
				"n": "崇义县",
				"pc": "360700"
			}, {
				"c": "360726",
				"n": "安远县",
				"pc": "360700"
			}, {
				"c": "360727",
				"n": "龙南县",
				"pc": "360700"
			}, {
				"c": "360728",
				"n": "定南县",
				"pc": "360700"
			}, {
				"c": "360729",
				"n": "全南县",
				"pc": "360700"
			}, {
				"c": "360730",
				"n": "宁都县",
				"pc": "360700"
			}, {
				"c": "360731",
				"n": "于都县",
				"pc": "360700"
			}, {
				"c": "360732",
				"n": "兴国县",
				"pc": "360700"
			}, {
				"c": "360733",
				"n": "会昌县",
				"pc": "360700"
			}, {
				"c": "360734",
				"n": "寻乌县",
				"pc": "360700"
			}, {
				"c": "360735",
				"n": "石城县",
				"pc": "360700"
			}, {
				"c": "360781",
				"n": "瑞金市",
				"pc": "360700"
			}, {
				"c": "360782",
				"n": "南康市",
				"pc": "360700"
			}, {
				"c": "360800",
				"n": "吉安市",
				"pc": "360000"
			}, {
				"c": "360801",
				"n": "市辖区",
				"pc": "360800"
			}, {
				"c": "360802",
				"n": "吉州区",
				"pc": "360800"
			}, {
				"c": "360803",
				"n": "青原区",
				"pc": "360800"
			}, {
				"c": "360821",
				"n": "吉安县",
				"pc": "360800"
			}, {
				"c": "360822",
				"n": "吉水县",
				"pc": "360800"
			}, {
				"c": "360823",
				"n": "峡江县",
				"pc": "360800"
			}, {
				"c": "360824",
				"n": "新干县",
				"pc": "360800"
			}, {
				"c": "360825",
				"n": "永丰县",
				"pc": "360800"
			}, {
				"c": "360826",
				"n": "泰和县",
				"pc": "360800"
			}, {
				"c": "360827",
				"n": "遂川县",
				"pc": "360800"
			}, {
				"c": "360828",
				"n": "万安县",
				"pc": "360800"
			}, {
				"c": "360829",
				"n": "安福县",
				"pc": "360800"
			}, {
				"c": "360830",
				"n": "永新县",
				"pc": "360800"
			}, {
				"c": "360881",
				"n": "井冈山市",
				"pc": "360800"
			}, {
				"c": "360900",
				"n": "宜春市",
				"pc": "360000"
			}, {
				"c": "360901",
				"n": "市辖区",
				"pc": "360900"
			}, {
				"c": "360902",
				"n": "袁州区",
				"pc": "360900"
			}, {
				"c": "360921",
				"n": "奉新县",
				"pc": "360900"
			}, {
				"c": "360922",
				"n": "万载县",
				"pc": "360900"
			}, {
				"c": "360923",
				"n": "上高县",
				"pc": "360900"
			}, {
				"c": "360924",
				"n": "宜丰县",
				"pc": "360900"
			}, {
				"c": "360925",
				"n": "靖安县",
				"pc": "360900"
			}, {
				"c": "360926",
				"n": "铜鼓县",
				"pc": "360900"
			}, {
				"c": "360981",
				"n": "丰城市",
				"pc": "360900"
			}, {
				"c": "360982",
				"n": "樟树市",
				"pc": "360900"
			}, {
				"c": "360983",
				"n": "高安市",
				"pc": "360900"
			}, {
				"c": "361000",
				"n": "抚州市",
				"pc": "360000"
			}, {
				"c": "361001",
				"n": "市辖区",
				"pc": "361000"
			}, {
				"c": "361002",
				"n": "临川区",
				"pc": "361000"
			}, {
				"c": "361021",
				"n": "南城县",
				"pc": "361000"
			}, {
				"c": "361022",
				"n": "黎川县",
				"pc": "361000"
			}, {
				"c": "361023",
				"n": "南丰县",
				"pc": "361000"
			}, {
				"c": "361024",
				"n": "崇仁县",
				"pc": "361000"
			}, {
				"c": "361025",
				"n": "乐安县",
				"pc": "361000"
			}, {
				"c": "361026",
				"n": "宜黄县",
				"pc": "361000"
			}, {
				"c": "361027",
				"n": "金溪县",
				"pc": "361000"
			}, {
				"c": "361028",
				"n": "资溪县",
				"pc": "361000"
			}, {
				"c": "361029",
				"n": "东乡县",
				"pc": "361000"
			}, {
				"c": "361030",
				"n": "广昌县",
				"pc": "361000"
			}, {
				"c": "361100",
				"n": "上饶市",
				"pc": "360000"
			}, {
				"c": "361101",
				"n": "市辖区",
				"pc": "361100"
			}, {
				"c": "361102",
				"n": "信州区",
				"pc": "361100"
			}, {
				"c": "361121",
				"n": "上饶县",
				"pc": "361100"
			}, {
				"c": "361122",
				"n": "广丰县",
				"pc": "361100"
			}, {
				"c": "361123",
				"n": "玉山县",
				"pc": "361100"
			}, {
				"c": "361124",
				"n": "铅山县",
				"pc": "361100"
			}, {
				"c": "361125",
				"n": "横峰县",
				"pc": "361100"
			}, {
				"c": "361126",
				"n": "弋阳县",
				"pc": "361100"
			}, {
				"c": "361127",
				"n": "余干县",
				"pc": "361100"
			}, {
				"c": "361128",
				"n": "鄱阳县",
				"pc": "361100"
			}, {
				"c": "361129",
				"n": "万年县",
				"pc": "361100"
			}, {
				"c": "361130",
				"n": "婺源县",
				"pc": "361100"
			}, {
				"c": "361181",
				"n": "德兴市",
				"pc": "361100"
			}, {
				"c": "370000",
				"n": "山东省",
				"pc": "86"
			}, {
				"c": "370100",
				"n": "济南市",
				"pc": "370000"
			}, {
				"c": "370101",
				"n": "市辖区",
				"pc": "370100"
			}, {
				"c": "370102",
				"n": "历下区",
				"pc": "370100"
			}, {
				"c": "370103",
				"n": "市中区",
				"pc": "370100"
			}, {
				"c": "370104",
				"n": "槐荫区",
				"pc": "370100"
			}, {
				"c": "370105",
				"n": "天桥区",
				"pc": "370100"
			}, {
				"c": "370112",
				"n": "历城区",
				"pc": "370100"
			}, {
				"c": "370113",
				"n": "长清区",
				"pc": "370100"
			}, {
				"c": "370124",
				"n": "平阴县",
				"pc": "370100"
			}, {
				"c": "370125",
				"n": "济阳县",
				"pc": "370100"
			}, {
				"c": "370126",
				"n": "商河县",
				"pc": "370100"
			}, {
				"c": "370181",
				"n": "章丘市",
				"pc": "370100"
			}, {
				"c": "370200",
				"n": "青岛市",
				"pc": "370000"
			}, {
				"c": "370201",
				"n": "市辖区",
				"pc": "370200"
			}, {
				"c": "370202",
				"n": "市南区",
				"pc": "370200"
			}, {
				"c": "370203",
				"n": "市北区",
				"pc": "370200"
			}, {
				"c": "370205",
				"n": "四方区",
				"pc": "370200"
			}, {
				"c": "370211",
				"n": "黄岛区",
				"pc": "370200"
			}, {
				"c": "370212",
				"n": "崂山区",
				"pc": "370200"
			}, {
				"c": "370213",
				"n": "李沧区",
				"pc": "370200"
			}, {
				"c": "370214",
				"n": "城阳区",
				"pc": "370200"
			}, {
				"c": "370281",
				"n": "胶州市",
				"pc": "370200"
			}, {
				"c": "370282",
				"n": "即墨市",
				"pc": "370200"
			}, {
				"c": "370283",
				"n": "平度市",
				"pc": "370200"
			}, {
				"c": "370284",
				"n": "胶南市",
				"pc": "370200"
			}, {
				"c": "370285",
				"n": "莱西市",
				"pc": "370200"
			}, {
				"c": "370300",
				"n": "淄博市",
				"pc": "370000"
			}, {
				"c": "370301",
				"n": "市辖区",
				"pc": "370300"
			}, {
				"c": "370302",
				"n": "淄川区",
				"pc": "370300"
			}, {
				"c": "370303",
				"n": "张店区",
				"pc": "370300"
			}, {
				"c": "370304",
				"n": "博山区",
				"pc": "370300"
			}, {
				"c": "370305",
				"n": "临淄区",
				"pc": "370300"
			}, {
				"c": "370306",
				"n": "周村区",
				"pc": "370300"
			}, {
				"c": "370321",
				"n": "桓台县",
				"pc": "370300"
			}, {
				"c": "370322",
				"n": "高青县",
				"pc": "370300"
			}, {
				"c": "370323",
				"n": "沂源县",
				"pc": "370300"
			}, {
				"c": "370400",
				"n": "枣庄市",
				"pc": "370000"
			}, {
				"c": "370401",
				"n": "市辖区",
				"pc": "370400"
			}, {
				"c": "370402",
				"n": "市中区",
				"pc": "370400"
			}, {
				"c": "370403",
				"n": "薛城区",
				"pc": "370400"
			}, {
				"c": "370404",
				"n": "峄城区",
				"pc": "370400"
			}, {
				"c": "370405",
				"n": "台儿庄区",
				"pc": "370400"
			}, {
				"c": "370406",
				"n": "山亭区",
				"pc": "370400"
			}, {
				"c": "370481",
				"n": "滕州市",
				"pc": "370400"
			}, {
				"c": "370500",
				"n": "东营市",
				"pc": "370000"
			}, {
				"c": "370501",
				"n": "市辖区",
				"pc": "370500"
			}, {
				"c": "370502",
				"n": "东营区",
				"pc": "370500"
			}, {
				"c": "370503",
				"n": "河口区",
				"pc": "370500"
			}, {
				"c": "370521",
				"n": "垦利县",
				"pc": "370500"
			}, {
				"c": "370522",
				"n": "利津县",
				"pc": "370500"
			}, {
				"c": "370523",
				"n": "广饶县",
				"pc": "370500"
			}, {
				"c": "370600",
				"n": "烟台市",
				"pc": "370000"
			}, {
				"c": "370601",
				"n": "市辖区",
				"pc": "370600"
			}, {
				"c": "370602",
				"n": "芝罘区",
				"pc": "370600"
			}, {
				"c": "370611",
				"n": "福山区",
				"pc": "370600"
			}, {
				"c": "370612",
				"n": "牟平区",
				"pc": "370600"
			}, {
				"c": "370613",
				"n": "莱山区",
				"pc": "370600"
			}, {
				"c": "370634",
				"n": "长岛县",
				"pc": "370600"
			}, {
				"c": "370681",
				"n": "龙口市",
				"pc": "370600"
			}, {
				"c": "370682",
				"n": "莱阳市",
				"pc": "370600"
			}, {
				"c": "370683",
				"n": "莱州市",
				"pc": "370600"
			}, {
				"c": "370684",
				"n": "蓬莱市",
				"pc": "370600"
			}, {
				"c": "370685",
				"n": "招远市",
				"pc": "370600"
			}, {
				"c": "3706",
				"n": "栖霞市",
				"pc": "370600"
			}, {
				"c": "370687",
				"n": "海阳市",
				"pc": "370600"
			}, {
				"c": "370700",
				"n": "潍坊市",
				"pc": "370000"
			}, {
				"c": "370701",
				"n": "市辖区",
				"pc": "370700"
			}, {
				"c": "370702",
				"n": "潍城区",
				"pc": "370700"
			}, {
				"c": "370703",
				"n": "寒亭区",
				"pc": "370700"
			}, {
				"c": "370704",
				"n": "坊子区",
				"pc": "370700"
			}, {
				"c": "370705",
				"n": "奎文区",
				"pc": "370700"
			}, {
				"c": "370724",
				"n": "临朐县",
				"pc": "370700"
			}, {
				"c": "370725",
				"n": "昌乐县",
				"pc": "370700"
			}, {
				"c": "370781",
				"n": "青州市",
				"pc": "370700"
			}, {
				"c": "370782",
				"n": "诸城市",
				"pc": "370700"
			}, {
				"c": "370783",
				"n": "寿光市",
				"pc": "370700"
			}, {
				"c": "370784",
				"n": "安丘市",
				"pc": "370700"
			}, {
				"c": "370785",
				"n": "高密市",
				"pc": "370700"
			}, {
				"c": "3707",
				"n": "昌邑市",
				"pc": "370700"
			}, {
				"c": "370800",
				"n": "济宁市",
				"pc": "370000"
			}, {
				"c": "370801",
				"n": "市辖区",
				"pc": "370800"
			}, {
				"c": "370802",
				"n": "市中区",
				"pc": "370800"
			}, {
				"c": "370811",
				"n": "任城区",
				"pc": "370800"
			}, {
				"c": "370826",
				"n": "微山县",
				"pc": "370800"
			}, {
				"c": "370827",
				"n": "鱼台县",
				"pc": "370800"
			}, {
				"c": "370828",
				"n": "金乡县",
				"pc": "370800"
			}, {
				"c": "370829",
				"n": "嘉祥县",
				"pc": "370800"
			}, {
				"c": "370830",
				"n": "汶上县",
				"pc": "370800"
			}, {
				"c": "370831",
				"n": "泗水县",
				"pc": "370800"
			}, {
				"c": "370832",
				"n": "梁山县",
				"pc": "370800"
			}, {
				"c": "370881",
				"n": "曲阜市",
				"pc": "370800"
			}, {
				"c": "370882",
				"n": "兖州市",
				"pc": "370800"
			}, {
				"c": "370883",
				"n": "邹城市",
				"pc": "370800"
			}, {
				"c": "370900",
				"n": "泰安市",
				"pc": "370000"
			}, {
				"c": "370901",
				"n": "市辖区",
				"pc": "370900"
			}, {
				"c": "370902",
				"n": "泰山区",
				"pc": "370900"
			}, {
				"c": "370911",
				"n": "岱岳区",
				"pc": "370900"
			}, {
				"c": "370921",
				"n": "宁阳县",
				"pc": "370900"
			}, {
				"c": "370923",
				"n": "东平县",
				"pc": "370900"
			}, {
				"c": "370982",
				"n": "新泰市",
				"pc": "370900"
			}, {
				"c": "370983",
				"n": "肥城市",
				"pc": "370900"
			}, {
				"c": "371000",
				"n": "威海市",
				"pc": "370000"
			}, {
				"c": "371001",
				"n": "市辖区",
				"pc": "371000"
			}, {
				"c": "371002",
				"n": "环翠区",
				"pc": "371000"
			}, {
				"c": "371081",
				"n": "文登市",
				"pc": "371000"
			}, {
				"c": "371082",
				"n": "荣成市",
				"pc": "371000"
			}, {
				"c": "371083",
				"n": "乳山市",
				"pc": "371000"
			}, {
				"c": "371100",
				"n": "日照市",
				"pc": "370000"
			}, {
				"c": "371101",
				"n": "市辖区",
				"pc": "371100"
			}, {
				"c": "371102",
				"n": "东港区",
				"pc": "371100"
			}, {
				"c": "371103",
				"n": "岚山区",
				"pc": "371100"
			}, {
				"c": "371121",
				"n": "五莲县",
				"pc": "371100"
			}, {
				"c": "371122",
				"n": "莒县",
				"pc": "371100"
			}, {
				"c": "371200",
				"n": "莱芜市",
				"pc": "370000"
			}, {
				"c": "371201",
				"n": "市辖区",
				"pc": "371200"
			}, {
				"c": "371202",
				"n": "莱城区",
				"pc": "371200"
			}, {
				"c": "371203",
				"n": "钢城区",
				"pc": "371200"
			}, {
				"c": "371300",
				"n": "临沂市",
				"pc": "370000"
			}, {
				"c": "371301",
				"n": "市辖区",
				"pc": "371300"
			}, {
				"c": "371302",
				"n": "兰山区",
				"pc": "371300"
			}, {
				"c": "371311",
				"n": "罗庄区",
				"pc": "371300"
			}, {
				"c": "371312",
				"n": "河东区",
				"pc": "371300"
			}, {
				"c": "371321",
				"n": "沂南县",
				"pc": "371300"
			}, {
				"c": "371322",
				"n": "郯城县",
				"pc": "371300"
			}, {
				"c": "371323",
				"n": "沂水县",
				"pc": "371300"
			}, {
				"c": "371324",
				"n": "苍山县",
				"pc": "371300"
			}, {
				"c": "371325",
				"n": "费县",
				"pc": "371300"
			}, {
				"c": "371326",
				"n": "平邑县",
				"pc": "371300"
			}, {
				"c": "371327",
				"n": "莒南县",
				"pc": "371300"
			}, {
				"c": "371328",
				"n": "蒙阴县",
				"pc": "371300"
			}, {
				"c": "371329",
				"n": "临沭县",
				"pc": "371300"
			}, {
				"c": "371400",
				"n": "德州市",
				"pc": "370000"
			}, {
				"c": "371401",
				"n": "市辖区",
				"pc": "371400"
			}, {
				"c": "371402",
				"n": "德城区",
				"pc": "371400"
			}, {
				"c": "371421",
				"n": "陵县",
				"pc": "371400"
			}, {
				"c": "371422",
				"n": "宁津县",
				"pc": "371400"
			}, {
				"c": "371423",
				"n": "庆云县",
				"pc": "371400"
			}, {
				"c": "371424",
				"n": "临邑县",
				"pc": "371400"
			}, {
				"c": "371425",
				"n": "齐河县",
				"pc": "371400"
			}, {
				"c": "371426",
				"n": "平原县",
				"pc": "371400"
			}, {
				"c": "371427",
				"n": "夏津县",
				"pc": "371400"
			}, {
				"c": "371428",
				"n": "武城县",
				"pc": "371400"
			}, {
				"c": "371481",
				"n": "乐陵市",
				"pc": "371400"
			}, {
				"c": "371482",
				"n": "禹城市",
				"pc": "371400"
			}, {
				"c": "371500",
				"n": "聊城市",
				"pc": "370000"
			}, {
				"c": "371501",
				"n": "市辖区",
				"pc": "371500"
			}, {
				"c": "371502",
				"n": "东昌府区",
				"pc": "371500"
			}, {
				"c": "371521",
				"n": "阳谷县",
				"pc": "371500"
			}, {
				"c": "371522",
				"n": "莘县",
				"pc": "371500"
			}, {
				"c": "371523",
				"n": "茌平县",
				"pc": "371500"
			}, {
				"c": "371524",
				"n": "东阿县",
				"pc": "371500"
			}, {
				"c": "371525",
				"n": "冠县",
				"pc": "371500"
			}, {
				"c": "371526",
				"n": "高唐县",
				"pc": "371500"
			}, {
				"c": "371581",
				"n": "临清市",
				"pc": "371500"
			}, {
				"c": "371600",
				"n": "滨州市",
				"pc": "370000"
			}, {
				"c": "371601",
				"n": "市辖区",
				"pc": "371600"
			}, {
				"c": "371602",
				"n": "滨城区",
				"pc": "371600"
			}, {
				"c": "371621",
				"n": "惠民县",
				"pc": "371600"
			}, {
				"c": "371622",
				"n": "阳信县",
				"pc": "371600"
			}, {
				"c": "371623",
				"n": "无棣县",
				"pc": "371600"
			}, {
				"c": "371624",
				"n": "沾化县",
				"pc": "371600"
			}, {
				"c": "371625",
				"n": "博兴县",
				"pc": "371600"
			}, {
				"c": "371626",
				"n": "邹平县",
				"pc": "371600"
			}, {
				"c": "371700",
				"n": "菏泽市",
				"pc": "370000"
			}, {
				"c": "371701",
				"n": "市辖区",
				"pc": "371700"
			}, {
				"c": "371702",
				"n": "牡丹区",
				"pc": "371700"
			}, {
				"c": "371721",
				"n": "曹县",
				"pc": "371700"
			}, {
				"c": "371722",
				"n": "单县",
				"pc": "371700"
			}, {
				"c": "371723",
				"n": "成武县",
				"pc": "371700"
			}, {
				"c": "371724",
				"n": "巨野县",
				"pc": "371700"
			}, {
				"c": "371725",
				"n": "郓城县",
				"pc": "371700"
			}, {
				"c": "371726",
				"n": "鄄城县",
				"pc": "371700"
			}, {
				"c": "371727",
				"n": "定陶县",
				"pc": "371700"
			}, {
				"c": "371728",
				"n": "东明县",
				"pc": "371700"
			}, {
				"c": "410000",
				"n": "河南省",
				"pc": "86"
			}, {
				"c": "410100",
				"n": "郑州市",
				"pc": "410000"
			}, {
				"c": "410101",
				"n": "市辖区",
				"pc": "410100"
			}, {
				"c": "410102",
				"n": "中原区",
				"pc": "410100"
			}, {
				"c": "410103",
				"n": "二七区",
				"pc": "410100"
			}, {
				"c": "410104",
				"n": "管城回族区",
				"pc": "410100"
			}, {
				"c": "410105",
				"n": "金水区",
				"pc": "410100"
			}, {
				"c": "410106",
				"n": "上街区",
				"pc": "410100"
			}, {
				"c": "410108",
				"n": "惠济区",
				"pc": "410100"
			}, {
				"c": "410122",
				"n": "中牟县",
				"pc": "410100"
			}, {
				"c": "410181",
				"n": "巩义市",
				"pc": "410100"
			}, {
				"c": "410182",
				"n": "荥阳市",
				"pc": "410100"
			}, {
				"c": "410183",
				"n": "新密市",
				"pc": "410100"
			}, {
				"c": "410184",
				"n": "新郑市",
				"pc": "410100"
			}, {
				"c": "410185",
				"n": "登封市",
				"pc": "410100"
			}, {
				"c": "410200",
				"n": "开封市",
				"pc": "410000"
			}, {
				"c": "410201",
				"n": "市辖区",
				"pc": "410200"
			}, {
				"c": "410202",
				"n": "龙亭区",
				"pc": "410200"
			}, {
				"c": "410203",
				"n": "顺河回族区",
				"pc": "410200"
			}, {
				"c": "410204",
				"n": "鼓楼区",
				"pc": "410200"
			}, {
				"c": "410205",
				"n": "禹王台区",
				"pc": "410200"
			}, {
				"c": "410211",
				"n": "金明区",
				"pc": "410200"
			}, {
				"c": "410221",
				"n": "杞县",
				"pc": "410200"
			}, {
				"c": "410222",
				"n": "通许县",
				"pc": "410200"
			}, {
				"c": "410223",
				"n": "尉氏县",
				"pc": "410200"
			}, {
				"c": "410224",
				"n": "开封县",
				"pc": "410200"
			}, {
				"c": "410225",
				"n": "兰考县",
				"pc": "410200"
			}, {
				"c": "410300",
				"n": "洛阳市",
				"pc": "410000"
			}, {
				"c": "410301",
				"n": "市辖区",
				"pc": "410300"
			}, {
				"c": "410302",
				"n": "老城区",
				"pc": "410300"
			}, {
				"c": "410303",
				"n": "西工区",
				"pc": "410300"
			}, {
				"c": "410304",
				"n": "瀍河回族区",
				"pc": "410300"
			}, {
				"c": "410305",
				"n": "涧西区",
				"pc": "410300"
			}, {
				"c": "410306",
				"n": "吉利区",
				"pc": "410300"
			}, {
				"c": "410311",
				"n": "洛龙区",
				"pc": "410300"
			}, {
				"c": "410322",
				"n": "孟津县",
				"pc": "410300"
			}, {
				"c": "410323",
				"n": "新安县",
				"pc": "410300"
			}, {
				"c": "410324",
				"n": "栾川县",
				"pc": "410300"
			}, {
				"c": "410325",
				"n": "嵩县",
				"pc": "410300"
			}, {
				"c": "410326",
				"n": "汝阳县",
				"pc": "410300"
			}, {
				"c": "410327",
				"n": "宜阳县",
				"pc": "410300"
			}, {
				"c": "410328",
				"n": "洛宁县",
				"pc": "410300"
			}, {
				"c": "410329",
				"n": "伊川县",
				"pc": "410300"
			}, {
				"c": "410381",
				"n": "偃师市",
				"pc": "410300"
			}, {
				"c": "410400",
				"n": "平顶山市",
				"pc": "410000"
			}, {
				"c": "410401",
				"n": "市辖区",
				"pc": "410400"
			}, {
				"c": "410402",
				"n": "新华区",
				"pc": "410400"
			}, {
				"c": "410403",
				"n": "卫东区",
				"pc": "410400"
			}, {
				"c": "410404",
				"n": "石龙区",
				"pc": "410400"
			}, {
				"c": "410411",
				"n": "湛河区",
				"pc": "410400"
			}, {
				"c": "410421",
				"n": "宝丰县",
				"pc": "410400"
			}, {
				"c": "410422",
				"n": "叶县",
				"pc": "410400"
			}, {
				"c": "410423",
				"n": "鲁山县",
				"pc": "410400"
			}, {
				"c": "410425",
				"n": "郏县",
				"pc": "410400"
			}, {
				"c": "410481",
				"n": "舞钢市",
				"pc": "410400"
			}, {
				"c": "410482",
				"n": "汝州市",
				"pc": "410400"
			}, {
				"c": "410500",
				"n": "安阳市",
				"pc": "410000"
			}, {
				"c": "410501",
				"n": "市辖区",
				"pc": "410500"
			}, {
				"c": "410502",
				"n": "文峰区",
				"pc": "410500"
			}, {
				"c": "410503",
				"n": "北关区",
				"pc": "410500"
			}, {
				"c": "410505",
				"n": "殷都区",
				"pc": "410500"
			}, {
				"c": "410506",
				"n": "龙安区",
				"pc": "410500"
			}, {
				"c": "410522",
				"n": "安阳县",
				"pc": "410500"
			}, {
				"c": "410523",
				"n": "汤阴县",
				"pc": "410500"
			}, {
				"c": "410526",
				"n": "滑县",
				"pc": "410500"
			}, {
				"c": "410527",
				"n": "内黄县",
				"pc": "410500"
			}, {
				"c": "410581",
				"n": "林州市",
				"pc": "410500"
			}, {
				"c": "410600",
				"n": "鹤壁市",
				"pc": "410000"
			}, {
				"c": "410601",
				"n": "市辖区",
				"pc": "410600"
			}, {
				"c": "410602",
				"n": "鹤山区",
				"pc": "410600"
			}, {
				"c": "410603",
				"n": "山城区",
				"pc": "410600"
			}, {
				"c": "410611",
				"n": "淇滨区",
				"pc": "410600"
			}, {
				"c": "410621",
				"n": "浚县",
				"pc": "410600"
			}, {
				"c": "410622",
				"n": "淇县",
				"pc": "410600"
			}, {
				"c": "410700",
				"n": "新乡市",
				"pc": "410000"
			}, {
				"c": "410701",
				"n": "市辖区",
				"pc": "410700"
			}, {
				"c": "410702",
				"n": "红旗区",
				"pc": "410700"
			}, {
				"c": "410703",
				"n": "卫滨区",
				"pc": "410700"
			}, {
				"c": "410704",
				"n": "凤泉区",
				"pc": "410700"
			}, {
				"c": "410711",
				"n": "牧野区",
				"pc": "410700"
			}, {
				"c": "410721",
				"n": "新乡县",
				"pc": "410700"
			}, {
				"c": "410724",
				"n": "获嘉县",
				"pc": "410700"
			}, {
				"c": "410725",
				"n": "原阳县",
				"pc": "410700"
			}, {
				"c": "410726",
				"n": "延津县",
				"pc": "410700"
			}, {
				"c": "410727",
				"n": "封丘县",
				"pc": "410700"
			}, {
				"c": "410728",
				"n": "长垣县",
				"pc": "410700"
			}, {
				"c": "410781",
				"n": "卫辉市",
				"pc": "410700"
			}, {
				"c": "410782",
				"n": "辉县市",
				"pc": "410700"
			}, {
				"c": "410800",
				"n": "焦作市",
				"pc": "410000"
			}, {
				"c": "410801",
				"n": "市辖区",
				"pc": "410800"
			}, {
				"c": "410802",
				"n": "解放区",
				"pc": "410800"
			}, {
				"c": "410803",
				"n": "中站区",
				"pc": "410800"
			}, {
				"c": "410804",
				"n": "马村区",
				"pc": "410800"
			}, {
				"c": "410811",
				"n": "山阳区",
				"pc": "410800"
			}, {
				"c": "410821",
				"n": "修武县",
				"pc": "410800"
			}, {
				"c": "410822",
				"n": "博爱县",
				"pc": "410800"
			}, {
				"c": "410823",
				"n": "武陟县",
				"pc": "410800"
			}, {
				"c": "410825",
				"n": "温县",
				"pc": "410800"
			}, {
				"c": "410882",
				"n": "沁阳市",
				"pc": "410800"
			}, {
				"c": "410883",
				"n": "孟州市",
				"pc": "410800"
			}, {
				"c": "410900",
				"n": "濮阳市",
				"pc": "410000"
			}, {
				"c": "410901",
				"n": "市辖区",
				"pc": "410900"
			}, {
				"c": "410902",
				"n": "华龙区",
				"pc": "410900"
			}, {
				"c": "410922",
				"n": "清丰县",
				"pc": "410900"
			}, {
				"c": "410923",
				"n": "南乐县",
				"pc": "410900"
			}, {
				"c": "410926",
				"n": "范县",
				"pc": "410900"
			}, {
				"c": "410927",
				"n": "台前县",
				"pc": "410900"
			}, {
				"c": "410928",
				"n": "濮阳县",
				"pc": "410900"
			}, {
				"c": "411000",
				"n": "许昌市",
				"pc": "410000"
			}, {
				"c": "411001",
				"n": "市辖区",
				"pc": "411000"
			}, {
				"c": "411002",
				"n": "魏都区",
				"pc": "411000"
			}, {
				"c": "411023",
				"n": "许昌县",
				"pc": "411000"
			}, {
				"c": "411024",
				"n": "鄢陵县",
				"pc": "411000"
			}, {
				"c": "411025",
				"n": "襄城县",
				"pc": "411000"
			}, {
				"c": "411081",
				"n": "禹州市",
				"pc": "411000"
			}, {
				"c": "411082",
				"n": "长葛市",
				"pc": "411000"
			}, {
				"c": "411100",
				"n": "漯河市",
				"pc": "410000"
			}, {
				"c": "411101",
				"n": "市辖区",
				"pc": "411100"
			}, {
				"c": "411102",
				"n": "源汇区",
				"pc": "411100"
			}, {
				"c": "411103",
				"n": "郾城区",
				"pc": "411100"
			}, {
				"c": "411104",
				"n": "召陵区",
				"pc": "411100"
			}, {
				"c": "411121",
				"n": "舞阳县",
				"pc": "411100"
			}, {
				"c": "411122",
				"n": "临颍县",
				"pc": "411100"
			}, {
				"c": "411200",
				"n": "三门峡市",
				"pc": "410000"
			}, {
				"c": "411201",
				"n": "市辖区",
				"pc": "411200"
			}, {
				"c": "411202",
				"n": "湖滨区",
				"pc": "411200"
			}, {
				"c": "411221",
				"n": "渑池县",
				"pc": "411200"
			}, {
				"c": "411222",
				"n": "陕县",
				"pc": "411200"
			}, {
				"c": "411224",
				"n": "卢氏县",
				"pc": "411200"
			}, {
				"c": "411281",
				"n": "义马市",
				"pc": "411200"
			}, {
				"c": "411282",
				"n": "灵宝市",
				"pc": "411200"
			}, {
				"c": "411300",
				"n": "南阳市",
				"pc": "410000"
			}, {
				"c": "411301",
				"n": "市辖区",
				"pc": "411300"
			}, {
				"c": "411302",
				"n": "宛城区",
				"pc": "411300"
			}, {
				"c": "411303",
				"n": "卧龙区",
				"pc": "411300"
			}, {
				"c": "411321",
				"n": "南召县",
				"pc": "411300"
			}, {
				"c": "411322",
				"n": "方城县",
				"pc": "411300"
			}, {
				"c": "411323",
				"n": "西峡县",
				"pc": "411300"
			}, {
				"c": "411324",
				"n": "镇平县",
				"pc": "411300"
			}, {
				"c": "411325",
				"n": "内乡县",
				"pc": "411300"
			}, {
				"c": "411326",
				"n": "淅川县",
				"pc": "411300"
			}, {
				"c": "411327",
				"n": "社旗县",
				"pc": "411300"
			}, {
				"c": "411328",
				"n": "唐河县",
				"pc": "411300"
			}, {
				"c": "411329",
				"n": "新野县",
				"pc": "411300"
			}, {
				"c": "411330",
				"n": "桐柏县",
				"pc": "411300"
			}, {
				"c": "411381",
				"n": "邓州市",
				"pc": "411300"
			}, {
				"c": "411400",
				"n": "商丘市",
				"pc": "410000"
			}, {
				"c": "411401",
				"n": "市辖区",
				"pc": "411400"
			}, {
				"c": "411402",
				"n": "梁园区",
				"pc": "411400"
			}, {
				"c": "411403",
				"n": "睢阳区",
				"pc": "411400"
			}, {
				"c": "411421",
				"n": "民权县",
				"pc": "411400"
			}, {
				"c": "411422",
				"n": "睢县",
				"pc": "411400"
			}, {
				"c": "411423",
				"n": "宁陵县",
				"pc": "411400"
			}, {
				"c": "411424",
				"n": "柘城县",
				"pc": "411400"
			}, {
				"c": "411425",
				"n": "虞城县",
				"pc": "411400"
			}, {
				"c": "411426",
				"n": "夏邑县",
				"pc": "411400"
			}, {
				"c": "411481",
				"n": "永城市",
				"pc": "411400"
			}, {
				"c": "411500",
				"n": "信阳市",
				"pc": "410000"
			}, {
				"c": "411501",
				"n": "市辖区",
				"pc": "411500"
			}, {
				"c": "411502",
				"n": "浉河区",
				"pc": "411500"
			}, {
				"c": "411503",
				"n": "平桥区",
				"pc": "411500"
			}, {
				"c": "411521",
				"n": "罗山县",
				"pc": "411500"
			}, {
				"c": "411522",
				"n": "光山县",
				"pc": "411500"
			}, {
				"c": "411523",
				"n": "新县",
				"pc": "411500"
			}, {
				"c": "411524",
				"n": "商城县",
				"pc": "411500"
			}, {
				"c": "411525",
				"n": "固始县",
				"pc": "411500"
			}, {
				"c": "411526",
				"n": "潢川县",
				"pc": "411500"
			}, {
				"c": "411527",
				"n": "淮滨县",
				"pc": "411500"
			}, {
				"c": "411528",
				"n": "息县",
				"pc": "411500"
			}, {
				"c": "411600",
				"n": "周口市",
				"pc": "410000"
			}, {
				"c": "411601",
				"n": "市辖区",
				"pc": "411600"
			}, {
				"c": "411602",
				"n": "川汇区",
				"pc": "411600"
			}, {
				"c": "411621",
				"n": "扶沟县",
				"pc": "411600"
			}, {
				"c": "411622",
				"n": "西华县",
				"pc": "411600"
			}, {
				"c": "411623",
				"n": "商水县",
				"pc": "411600"
			}, {
				"c": "411624",
				"n": "沈丘县",
				"pc": "411600"
			}, {
				"c": "411625",
				"n": "郸城县",
				"pc": "411600"
			}, {
				"c": "411626",
				"n": "淮阳县",
				"pc": "411600"
			}, {
				"c": "411627",
				"n": "太康县",
				"pc": "411600"
			}, {
				"c": "411628",
				"n": "鹿邑县",
				"pc": "411600"
			}, {
				"c": "411681",
				"n": "项城市",
				"pc": "411600"
			}, {
				"c": "411700",
				"n": "驻马店市",
				"pc": "410000"
			}, {
				"c": "411701",
				"n": "市辖区",
				"pc": "411700"
			}, {
				"c": "411702",
				"n": "驿城区",
				"pc": "411700"
			}, {
				"c": "411721",
				"n": "西平县",
				"pc": "411700"
			}, {
				"c": "411722",
				"n": "上蔡县",
				"pc": "411700"
			}, {
				"c": "411723",
				"n": "平舆县",
				"pc": "411700"
			}, {
				"c": "411724",
				"n": "正阳县",
				"pc": "411700"
			}, {
				"c": "411725",
				"n": "确山县",
				"pc": "411700"
			}, {
				"c": "411726",
				"n": "泌阳县",
				"pc": "411700"
			}, {
				"c": "411727",
				"n": "汝南县",
				"pc": "411700"
			}, {
				"c": "411728",
				"n": "遂平县",
				"pc": "411700"
			}, {
				"c": "411729",
				"n": "新蔡县",
				"pc": "411700"
			}, {
				"c": "419000",
				"n": "省直辖县级行政区划",
				"pc": "410000"
			}, {
				"c": "419001",
				"n": "济源市",
				"pc": "419000"
			}, {
				"c": "420000",
				"n": "湖北省",
				"pc": "86"
			}, {
				"c": "420100",
				"n": "武汉市",
				"pc": "420000"
			}, {
				"c": "420101",
				"n": "市辖区",
				"pc": "420100"
			}, {
				"c": "420102",
				"n": "江岸区",
				"pc": "420100"
			}, {
				"c": "420103",
				"n": "江汉区",
				"pc": "420100"
			}, {
				"c": "420104",
				"n": "硚口区",
				"pc": "420100"
			}, {
				"c": "420105",
				"n": "汉阳区",
				"pc": "420100"
			}, {
				"c": "420106",
				"n": "武昌区",
				"pc": "420100"
			}, {
				"c": "420107",
				"n": "青山区",
				"pc": "420100"
			}, {
				"c": "420111",
				"n": "洪山区",
				"pc": "420100"
			}, {
				"c": "420112",
				"n": "东西湖区",
				"pc": "420100"
			}, {
				"c": "420113",
				"n": "汉南区",
				"pc": "420100"
			}, {
				"c": "420114",
				"n": "蔡甸区",
				"pc": "420100"
			}, {
				"c": "420115",
				"n": "江夏区",
				"pc": "420100"
			}, {
				"c": "420116",
				"n": "黄陂区",
				"pc": "420100"
			}, {
				"c": "420117",
				"n": "新洲区",
				"pc": "420100"
			}, {
				"c": "420200",
				"n": "黄石市",
				"pc": "420000"
			}, {
				"c": "420201",
				"n": "市辖区",
				"pc": "420200"
			}, {
				"c": "420202",
				"n": "黄石港区",
				"pc": "420200"
			}, {
				"c": "420203",
				"n": "西塞山区",
				"pc": "420200"
			}, {
				"c": "420204",
				"n": "下陆区",
				"pc": "420200"
			}, {
				"c": "420205",
				"n": "铁山区",
				"pc": "420200"
			}, {
				"c": "420222",
				"n": "阳新县",
				"pc": "420200"
			}, {
				"c": "420281",
				"n": "大冶市",
				"pc": "420200"
			}, {
				"c": "420300",
				"n": "十堰市",
				"pc": "420000"
			}, {
				"c": "420301",
				"n": "市辖区",
				"pc": "420300"
			}, {
				"c": "420302",
				"n": "茅箭区",
				"pc": "420300"
			}, {
				"c": "420303",
				"n": "张湾区",
				"pc": "420300"
			}, {
				"c": "420321",
				"n": "郧县",
				"pc": "420300"
			}, {
				"c": "420322",
				"n": "郧西县",
				"pc": "420300"
			}, {
				"c": "420323",
				"n": "竹山县",
				"pc": "420300"
			}, {
				"c": "420324",
				"n": "竹溪县",
				"pc": "420300"
			}, {
				"c": "420325",
				"n": "房县",
				"pc": "420300"
			}, {
				"c": "420381",
				"n": "丹江口市",
				"pc": "420300"
			}, {
				"c": "420500",
				"n": "宜昌市",
				"pc": "420000"
			}, {
				"c": "420501",
				"n": "市辖区",
				"pc": "420500"
			}, {
				"c": "420502",
				"n": "西陵区",
				"pc": "420500"
			}, {
				"c": "420503",
				"n": "伍家岗区",
				"pc": "420500"
			}, {
				"c": "420504",
				"n": "点军区",
				"pc": "420500"
			}, {
				"c": "420505",
				"n": "猇亭区",
				"pc": "420500"
			}, {
				"c": "420506",
				"n": "夷陵区",
				"pc": "420500"
			}, {
				"c": "420525",
				"n": "远安县",
				"pc": "420500"
			}, {
				"c": "420526",
				"n": "兴山县",
				"pc": "420500"
			}, {
				"c": "420527",
				"n": "秭归县",
				"pc": "420500"
			}, {
				"c": "420528",
				"n": "长阳土家族自治县",
				"pc": "420500"
			}, {
				"c": "420529",
				"n": "五峰土家族自治县",
				"pc": "420500"
			}, {
				"c": "420581",
				"n": "宜都市",
				"pc": "420500"
			}, {
				"c": "420582",
				"n": "当阳市",
				"pc": "420500"
			}, {
				"c": "420583",
				"n": "枝江市",
				"pc": "420500"
			}, {
				"c": "420600",
				"n": "襄阳市",
				"pc": "420000"
			}, {
				"c": "420601",
				"n": "市辖区",
				"pc": "420600"
			}, {
				"c": "420602",
				"n": "襄城区",
				"pc": "420600"
			}, {
				"c": "420606",
				"n": "樊城区",
				"pc": "420600"
			}, {
				"c": "420607",
				"n": "襄州区",
				"pc": "420600"
			}, {
				"c": "420624",
				"n": "南漳县",
				"pc": "420600"
			}, {
				"c": "420625",
				"n": "谷城县",
				"pc": "420600"
			}, {
				"c": "420626",
				"n": "保康县",
				"pc": "420600"
			}, {
				"c": "420682",
				"n": "老河口市",
				"pc": "420600"
			}, {
				"c": "420683",
				"n": "枣阳市",
				"pc": "420600"
			}, {
				"c": "420684",
				"n": "宜城市",
				"pc": "420600"
			}, {
				"c": "420700",
				"n": "鄂州市",
				"pc": "420000"
			}, {
				"c": "420701",
				"n": "市辖区",
				"pc": "420700"
			}, {
				"c": "420702",
				"n": "梁子湖区",
				"pc": "420700"
			}, {
				"c": "420703",
				"n": "华容区",
				"pc": "420700"
			}, {
				"c": "420704",
				"n": "鄂城区",
				"pc": "420700"
			}, {
				"c": "420800",
				"n": "荆门市",
				"pc": "420000"
			}, {
				"c": "420801",
				"n": "市辖区",
				"pc": "420800"
			}, {
				"c": "420802",
				"n": "东宝区",
				"pc": "420800"
			}, {
				"c": "420804",
				"n": "掇刀区",
				"pc": "420800"
			}, {
				"c": "420821",
				"n": "京山县",
				"pc": "420800"
			}, {
				"c": "420822",
				"n": "沙洋县",
				"pc": "420800"
			}, {
				"c": "420881",
				"n": "钟祥市",
				"pc": "420800"
			}, {
				"c": "420900",
				"n": "孝感市",
				"pc": "420000"
			}, {
				"c": "420901",
				"n": "市辖区",
				"pc": "420900"
			}, {
				"c": "420902",
				"n": "孝南区",
				"pc": "420900"
			}, {
				"c": "420921",
				"n": "孝昌县",
				"pc": "420900"
			}, {
				"c": "420922",
				"n": "大悟县",
				"pc": "420900"
			}, {
				"c": "420923",
				"n": "云梦县",
				"pc": "420900"
			}, {
				"c": "420981",
				"n": "应城市",
				"pc": "420900"
			}, {
				"c": "420982",
				"n": "安陆市",
				"pc": "420900"
			}, {
				"c": "420984",
				"n": "汉川市",
				"pc": "420900"
			}, {
				"c": "421000",
				"n": "荆州市",
				"pc": "420000"
			}, {
				"c": "421001",
				"n": "市辖区",
				"pc": "421000"
			}, {
				"c": "421002",
				"n": "沙市区",
				"pc": "421000"
			}, {
				"c": "421003",
				"n": "荆州区",
				"pc": "421000"
			}, {
				"c": "421022",
				"n": "公安县",
				"pc": "421000"
			}, {
				"c": "421023",
				"n": "监利县",
				"pc": "421000"
			}, {
				"c": "421024",
				"n": "江陵县",
				"pc": "421000"
			}, {
				"c": "421081",
				"n": "石首市",
				"pc": "421000"
			}, {
				"c": "421083",
				"n": "洪湖市",
				"pc": "421000"
			}, {
				"c": "421087",
				"n": "松滋市",
				"pc": "421000"
			}, {
				"c": "421100",
				"n": "黄冈市",
				"pc": "420000"
			}, {
				"c": "421101",
				"n": "市辖区",
				"pc": "421100"
			}, {
				"c": "421102",
				"n": "黄州区",
				"pc": "421100"
			}, {
				"c": "421121",
				"n": "团风县",
				"pc": "421100"
			}, {
				"c": "421122",
				"n": "红安县",
				"pc": "421100"
			}, {
				"c": "421123",
				"n": "罗田县",
				"pc": "421100"
			}, {
				"c": "421124",
				"n": "英山县",
				"pc": "421100"
			}, {
				"c": "421125",
				"n": "浠水县",
				"pc": "421100"
			}, {
				"c": "421126",
				"n": "蕲春县",
				"pc": "421100"
			}, {
				"c": "421127",
				"n": "黄梅县",
				"pc": "421100"
			}, {
				"c": "421181",
				"n": "麻城市",
				"pc": "421100"
			}, {
				"c": "421182",
				"n": "武穴市",
				"pc": "421100"
			}, {
				"c": "421200",
				"n": "咸宁市",
				"pc": "420000"
			}, {
				"c": "421201",
				"n": "市辖区",
				"pc": "421200"
			}, {
				"c": "421202",
				"n": "咸安区",
				"pc": "421200"
			}, {
				"c": "421221",
				"n": "嘉鱼县",
				"pc": "421200"
			}, {
				"c": "421222",
				"n": "通城县",
				"pc": "421200"
			}, {
				"c": "421223",
				"n": "崇阳县",
				"pc": "421200"
			}, {
				"c": "421224",
				"n": "通山县",
				"pc": "421200"
			}, {
				"c": "421281",
				"n": "赤壁市",
				"pc": "421200"
			}, {
				"c": "421300",
				"n": "随州市",
				"pc": "420000"
			}, {
				"c": "421301",
				"n": "市辖区",
				"pc": "421300"
			}, {
				"c": "421303",
				"n": "曾都区",
				"pc": "421300"
			}, {
				"c": "421321",
				"n": "随县",
				"pc": "421300"
			}, {
				"c": "421381",
				"n": "广水市",
				"pc": "421300"
			}, {
				"c": "422800",
				"n": "恩施土家族苗族自治州",
				"pc": "420000"
			}, {
				"c": "422801",
				"n": "恩施市",
				"pc": "422800"
			}, {
				"c": "422802",
				"n": "利川市",
				"pc": "422800"
			}, {
				"c": "422822",
				"n": "建始县",
				"pc": "422800"
			}, {
				"c": "422823",
				"n": "巴东县",
				"pc": "422800"
			}, {
				"c": "422825",
				"n": "宣恩县",
				"pc": "422800"
			}, {
				"c": "422826",
				"n": "咸丰县",
				"pc": "422800"
			}, {
				"c": "422827",
				"n": "来凤县",
				"pc": "422800"
			}, {
				"c": "422828",
				"n": "鹤峰县",
				"pc": "422800"
			}, {
				"c": "429000",
				"n": "省直辖县级行政区划",
				"pc": "420000"
			}, {
				"c": "429004",
				"n": "仙桃市",
				"pc": "429000"
			}, {
				"c": "429005",
				"n": "潜江市",
				"pc": "429000"
			}, {
				"c": "429006",
				"n": "天门市",
				"pc": "429000"
			}, {
				"c": "429021",
				"n": "神农架林区",
				"pc": "429000"
			}, {
				"c": "430000",
				"n": "湖南省",
				"pc": "86"
			}, {
				"c": "430100",
				"n": "长沙市",
				"pc": "430000"
			}, {
				"c": "430101",
				"n": "市辖区",
				"pc": "430100"
			}, {
				"c": "430102",
				"n": "芙蓉区",
				"pc": "430100"
			}, {
				"c": "430103",
				"n": "天心区",
				"pc": "430100"
			}, {
				"c": "430104",
				"n": "岳麓区",
				"pc": "430100"
			}, {
				"c": "430105",
				"n": "开福区",
				"pc": "430100"
			}, {
				"c": "430111",
				"n": "雨花区",
				"pc": "430100"
			}, {
				"c": "430112",
				"n": "望城区",
				"pc": "430100"
			}, {
				"c": "430121",
				"n": "长沙县",
				"pc": "430100"
			}, {
				"c": "430124",
				"n": "宁乡县",
				"pc": "430100"
			}, {
				"c": "430181",
				"n": "浏阳市",
				"pc": "430100"
			}, {
				"c": "430200",
				"n": "株洲市",
				"pc": "430000"
			}, {
				"c": "430201",
				"n": "市辖区",
				"pc": "430200"
			}, {
				"c": "430202",
				"n": "荷塘区",
				"pc": "430200"
			}, {
				"c": "430203",
				"n": "芦淞区",
				"pc": "430200"
			}, {
				"c": "430204",
				"n": "石峰区",
				"pc": "430200"
			}, {
				"c": "430211",
				"n": "天元区",
				"pc": "430200"
			}, {
				"c": "430221",
				"n": "株洲县",
				"pc": "430200"
			}, {
				"c": "430223",
				"n": "攸县",
				"pc": "430200"
			}, {
				"c": "430224",
				"n": "茶陵县",
				"pc": "430200"
			}, {
				"c": "430225",
				"n": "炎陵县",
				"pc": "430200"
			}, {
				"c": "430281",
				"n": "醴陵市",
				"pc": "430200"
			}, {
				"c": "430300",
				"n": "湘潭市",
				"pc": "430000"
			}, {
				"c": "430301",
				"n": "市辖区",
				"pc": "430300"
			}, {
				"c": "430302",
				"n": "雨湖区",
				"pc": "430300"
			}, {
				"c": "430304",
				"n": "岳塘区",
				"pc": "430300"
			}, {
				"c": "430321",
				"n": "湘潭县",
				"pc": "430300"
			}, {
				"c": "430381",
				"n": "湘乡市",
				"pc": "430300"
			}, {
				"c": "430382",
				"n": "韶山市",
				"pc": "430300"
			}, {
				"c": "430400",
				"n": "衡阳市",
				"pc": "430000"
			}, {
				"c": "430401",
				"n": "市辖区",
				"pc": "430400"
			}, {
				"c": "430405",
				"n": "珠晖区",
				"pc": "430400"
			}, {
				"c": "430406",
				"n": "雁峰区",
				"pc": "430400"
			}, {
				"c": "430407",
				"n": "石鼓区",
				"pc": "430400"
			}, {
				"c": "430408",
				"n": "蒸湘区",
				"pc": "430400"
			}, {
				"c": "430412",
				"n": "南岳区",
				"pc": "430400"
			}, {
				"c": "430421",
				"n": "衡阳县",
				"pc": "430400"
			}, {
				"c": "430422",
				"n": "衡南县",
				"pc": "430400"
			}, {
				"c": "430423",
				"n": "衡山县",
				"pc": "430400"
			}, {
				"c": "430424",
				"n": "衡东县",
				"pc": "430400"
			}, {
				"c": "430426",
				"n": "祁东县",
				"pc": "430400"
			}, {
				"c": "430481",
				"n": "耒阳市",
				"pc": "430400"
			}, {
				"c": "430482",
				"n": "常宁市",
				"pc": "430400"
			}, {
				"c": "430500",
				"n": "邵阳市",
				"pc": "430000"
			}, {
				"c": "430501",
				"n": "市辖区",
				"pc": "430500"
			}, {
				"c": "430502",
				"n": "双清区",
				"pc": "430500"
			}, {
				"c": "430503",
				"n": "大祥区",
				"pc": "430500"
			}, {
				"c": "430511",
				"n": "北塔区",
				"pc": "430500"
			}, {
				"c": "430521",
				"n": "邵东县",
				"pc": "430500"
			}, {
				"c": "430522",
				"n": "新邵县",
				"pc": "430500"
			}, {
				"c": "430523",
				"n": "邵阳县",
				"pc": "430500"
			}, {
				"c": "430524",
				"n": "隆回县",
				"pc": "430500"
			}, {
				"c": "430525",
				"n": "洞口县",
				"pc": "430500"
			}, {
				"c": "430527",
				"n": "绥宁县",
				"pc": "430500"
			}, {
				"c": "430528",
				"n": "新宁县",
				"pc": "430500"
			}, {
				"c": "430529",
				"n": "城步苗族自治县",
				"pc": "430500"
			}, {
				"c": "430581",
				"n": "武冈市",
				"pc": "430500"
			}, {
				"c": "430600",
				"n": "岳阳市",
				"pc": "430000"
			}, {
				"c": "430601",
				"n": "市辖区",
				"pc": "430600"
			}, {
				"c": "430602",
				"n": "岳阳楼区",
				"pc": "430600"
			}, {
				"c": "430603",
				"n": "云溪区",
				"pc": "430600"
			}, {
				"c": "430611",
				"n": "君山区",
				"pc": "430600"
			}, {
				"c": "430621",
				"n": "岳阳县",
				"pc": "430600"
			}, {
				"c": "430623",
				"n": "华容县",
				"pc": "430600"
			}, {
				"c": "430624",
				"n": "湘阴县",
				"pc": "430600"
			}, {
				"c": "430626",
				"n": "平江县",
				"pc": "430600"
			}, {
				"c": "430681",
				"n": "汨罗市",
				"pc": "430600"
			}, {
				"c": "430682",
				"n": "临湘市",
				"pc": "430600"
			}, {
				"c": "430700",
				"n": "常德市",
				"pc": "430000"
			}, {
				"c": "430701",
				"n": "市辖区",
				"pc": "430700"
			}, {
				"c": "430702",
				"n": "武陵区",
				"pc": "430700"
			}, {
				"c": "430703",
				"n": "鼎城区",
				"pc": "430700"
			}, {
				"c": "430721",
				"n": "安乡县",
				"pc": "430700"
			}, {
				"c": "430722",
				"n": "汉寿县",
				"pc": "430700"
			}, {
				"c": "430723",
				"n": "澧县",
				"pc": "430700"
			}, {
				"c": "430724",
				"n": "临澧县",
				"pc": "430700"
			}, {
				"c": "430725",
				"n": "桃源县",
				"pc": "430700"
			}, {
				"c": "430726",
				"n": "石门县",
				"pc": "430700"
			}, {
				"c": "430781",
				"n": "津市市",
				"pc": "430700"
			}, {
				"c": "430800",
				"n": "张家界市",
				"pc": "430000"
			}, {
				"c": "430801",
				"n": "市辖区",
				"pc": "430800"
			}, {
				"c": "430802",
				"n": "永定区",
				"pc": "430800"
			}, {
				"c": "430811",
				"n": "武陵源区",
				"pc": "430800"
			}, {
				"c": "430821",
				"n": "慈利县",
				"pc": "430800"
			}, {
				"c": "430822",
				"n": "桑植县",
				"pc": "430800"
			}, {
				"c": "430900",
				"n": "益阳市",
				"pc": "430000"
			}, {
				"c": "430901",
				"n": "市辖区",
				"pc": "430900"
			}, {
				"c": "430902",
				"n": "资阳区",
				"pc": "430900"
			}, {
				"c": "430903",
				"n": "赫山区",
				"pc": "430900"
			}, {
				"c": "430921",
				"n": "南县",
				"pc": "430900"
			}, {
				"c": "430922",
				"n": "桃江县",
				"pc": "430900"
			}, {
				"c": "430923",
				"n": "安化县",
				"pc": "430900"
			}, {
				"c": "430981",
				"n": "沅江市",
				"pc": "430900"
			}, {
				"c": "431000",
				"n": "郴州市",
				"pc": "430000"
			}, {
				"c": "431001",
				"n": "市辖区",
				"pc": "431000"
			}, {
				"c": "431002",
				"n": "北湖区",
				"pc": "431000"
			}, {
				"c": "431003",
				"n": "苏仙区",
				"pc": "431000"
			}, {
				"c": "431021",
				"n": "桂阳县",
				"pc": "431000"
			}, {
				"c": "431022",
				"n": "宜章县",
				"pc": "431000"
			}, {
				"c": "431023",
				"n": "永兴县",
				"pc": "431000"
			}, {
				"c": "431024",
				"n": "嘉禾县",
				"pc": "431000"
			}, {
				"c": "431025",
				"n": "临武县",
				"pc": "431000"
			}, {
				"c": "431026",
				"n": "汝城县",
				"pc": "431000"
			}, {
				"c": "431027",
				"n": "桂东县",
				"pc": "431000"
			}, {
				"c": "431028",
				"n": "安仁县",
				"pc": "431000"
			}, {
				"c": "431081",
				"n": "资兴市",
				"pc": "431000"
			}, {
				"c": "431100",
				"n": "永州市",
				"pc": "430000"
			}, {
				"c": "431101",
				"n": "市辖区",
				"pc": "431100"
			}, {
				"c": "431102",
				"n": "零陵区",
				"pc": "431100"
			}, {
				"c": "431103",
				"n": "冷水滩区",
				"pc": "431100"
			}, {
				"c": "431121",
				"n": "祁阳县",
				"pc": "431100"
			}, {
				"c": "431122",
				"n": "东安县",
				"pc": "431100"
			}, {
				"c": "431123",
				"n": "双牌县",
				"pc": "431100"
			}, {
				"c": "431124",
				"n": "道县",
				"pc": "431100"
			}, {
				"c": "431125",
				"n": "江永县",
				"pc": "431100"
			}, {
				"c": "431126",
				"n": "宁远县",
				"pc": "431100"
			}, {
				"c": "431127",
				"n": "蓝山县",
				"pc": "431100"
			}, {
				"c": "431128",
				"n": "新田县",
				"pc": "431100"
			}, {
				"c": "431129",
				"n": "江华瑶族自治县",
				"pc": "431100"
			}, {
				"c": "431200",
				"n": "怀化市",
				"pc": "430000"
			}, {
				"c": "431201",
				"n": "市辖区",
				"pc": "431200"
			}, {
				"c": "431202",
				"n": "鹤城区",
				"pc": "431200"
			}, {
				"c": "431221",
				"n": "中方县",
				"pc": "431200"
			}, {
				"c": "431222",
				"n": "沅陵县",
				"pc": "431200"
			}, {
				"c": "431223",
				"n": "辰溪县",
				"pc": "431200"
			}, {
				"c": "431224",
				"n": "溆浦县",
				"pc": "431200"
			}, {
				"c": "431225",
				"n": "会同县",
				"pc": "431200"
			}, {
				"c": "431226",
				"n": "麻阳苗族自治县",
				"pc": "431200"
			}, {
				"c": "431227",
				"n": "新晃侗族自治县",
				"pc": "431200"
			}, {
				"c": "431228",
				"n": "芷江侗族自治县",
				"pc": "431200"
			}, {
				"c": "431229",
				"n": "靖州苗族侗族自治县",
				"pc": "431200"
			}, {
				"c": "431230",
				"n": "通道侗族自治县",
				"pc": "431200"
			}, {
				"c": "431281",
				"n": "洪江市",
				"pc": "431200"
			}, {
				"c": "431300",
				"n": "娄底市",
				"pc": "430000"
			}, {
				"c": "431301",
				"n": "市辖区",
				"pc": "431300"
			}, {
				"c": "431302",
				"n": "娄星区",
				"pc": "431300"
			}, {
				"c": "431321",
				"n": "双峰县",
				"pc": "431300"
			}, {
				"c": "431322",
				"n": "新化县",
				"pc": "431300"
			}, {
				"c": "431381",
				"n": "冷水江市",
				"pc": "431300"
			}, {
				"c": "431382",
				"n": "涟源市",
				"pc": "431300"
			}, {
				"c": "433100",
				"n": "湘西土家族苗族自治州",
				"pc": "430000"
			}, {
				"c": "433101",
				"n": "吉首市",
				"pc": "433100"
			}, {
				"c": "433122",
				"n": "泸溪县",
				"pc": "433100"
			}, {
				"c": "433123",
				"n": "凤凰县",
				"pc": "433100"
			}, {
				"c": "433124",
				"n": "花垣县",
				"pc": "433100"
			}, {
				"c": "433125",
				"n": "保靖县",
				"pc": "433100"
			}, {
				"c": "433126",
				"n": "古丈县",
				"pc": "433100"
			}, {
				"c": "433127",
				"n": "永顺县",
				"pc": "433100"
			}, {
				"c": "433130",
				"n": "龙山县",
				"pc": "433100"
			}, {
				"c": "440000",
				"n": "广东省",
				"pc": "86"
			}, {
				"c": "440100",
				"n": "广州市",
				"pc": "440000"
			}, {
				"c": "440101",
				"n": "市辖区",
				"pc": "440100"
			}, {
				"c": "440103",
				"n": "荔湾区",
				"pc": "440100"
			}, {
				"c": "440104",
				"n": "越秀区",
				"pc": "440100"
			}, {
				"c": "440105",
				"n": "海珠区",
				"pc": "440100"
			}, {
				"c": "440106",
				"n": "天河区",
				"pc": "440100"
			}, {
				"c": "440111",
				"n": "白云区",
				"pc": "440100"
			}, {
				"c": "440112",
				"n": "黄埔区",
				"pc": "440100"
			}, {
				"c": "440113",
				"n": "番禺区",
				"pc": "440100"
			}, {
				"c": "440114",
				"n": "花都区",
				"pc": "440100"
			}, {
				"c": "440115",
				"n": "南沙区",
				"pc": "440100"
			}, {
				"c": "440116",
				"n": "萝岗区",
				"pc": "440100"
			}, {
				"c": "440183",
				"n": "增城市",
				"pc": "440100"
			}, {
				"c": "440184",
				"n": "从化市",
				"pc": "440100"
			}, {
				"c": "440200",
				"n": "韶关市",
				"pc": "440000"
			}, {
				"c": "440201",
				"n": "市辖区",
				"pc": "440200"
			}, {
				"c": "440203",
				"n": "武江区",
				"pc": "440200"
			}, {
				"c": "440204",
				"n": "浈江区",
				"pc": "440200"
			}, {
				"c": "440205",
				"n": "曲江区",
				"pc": "440200"
			}, {
				"c": "440222",
				"n": "始兴县",
				"pc": "440200"
			}, {
				"c": "440224",
				"n": "仁化县",
				"pc": "440200"
			}, {
				"c": "440229",
				"n": "翁源县",
				"pc": "440200"
			}, {
				"c": "440232",
				"n": "乳源瑶族自治县",
				"pc": "440200"
			}, {
				"c": "440233",
				"n": "新丰县",
				"pc": "440200"
			}, {
				"c": "440281",
				"n": "乐昌市",
				"pc": "440200"
			}, {
				"c": "440282",
				"n": "南雄市",
				"pc": "440200"
			}, {
				"c": "440300",
				"n": "深圳市",
				"pc": "440000"
			}, {
				"c": "440301",
				"n": "市辖区",
				"pc": "440300"
			}, {
				"c": "440303",
				"n": "罗湖区",
				"pc": "440300"
			}, {
				"c": "440304",
				"n": "福田区",
				"pc": "440300"
			}, {
				"c": "440305",
				"n": "南山区",
				"pc": "440300"
			}, {
				"c": "440306",
				"n": "宝安区",
				"pc": "440300"
			}, {
				"c": "440307",
				"n": "龙岗区",
				"pc": "440300"
			}, {
				"c": "440308",
				"n": "盐田区",
				"pc": "440300"
			}, {
				"c": "440400",
				"n": "珠海市",
				"pc": "440000"
			}, {
				"c": "440401",
				"n": "市辖区",
				"pc": "440400"
			}, {
				"c": "440402",
				"n": "香洲区",
				"pc": "440400"
			}, {
				"c": "440403",
				"n": "斗门区",
				"pc": "440400"
			}, {
				"c": "440404",
				"n": "金湾区",
				"pc": "440400"
			}, {
				"c": "440500",
				"n": "汕头市",
				"pc": "440000"
			}, {
				"c": "440501",
				"n": "市辖区",
				"pc": "440500"
			}, {
				"c": "440507",
				"n": "龙湖区",
				"pc": "440500"
			}, {
				"c": "440511",
				"n": "金平区",
				"pc": "440500"
			}, {
				"c": "440512",
				"n": "濠江区",
				"pc": "440500"
			}, {
				"c": "440513",
				"n": "潮阳区",
				"pc": "440500"
			}, {
				"c": "440514",
				"n": "潮南区",
				"pc": "440500"
			}, {
				"c": "440515",
				"n": "澄海区",
				"pc": "440500"
			}, {
				"c": "440523",
				"n": "南澳县",
				"pc": "440500"
			}, {
				"c": "440600",
				"n": "佛山市",
				"pc": "440000"
			}, {
				"c": "440601",
				"n": "市辖区",
				"pc": "440600"
			}, {
				"c": "440604",
				"n": "禅城区",
				"pc": "440600"
			}, {
				"c": "440605",
				"n": "南海区",
				"pc": "440600"
			}, {
				"c": "440606",
				"n": "顺德区",
				"pc": "440600"
			}, {
				"c": "440607",
				"n": "三水区",
				"pc": "440600"
			}, {
				"c": "440608",
				"n": "高明区",
				"pc": "440600"
			}, {
				"c": "440700",
				"n": "江门市",
				"pc": "440000"
			}, {
				"c": "440701",
				"n": "市辖区",
				"pc": "440700"
			}, {
				"c": "440703",
				"n": "蓬江区",
				"pc": "440700"
			}, {
				"c": "440704",
				"n": "江海区",
				"pc": "440700"
			}, {
				"c": "440705",
				"n": "新会区",
				"pc": "440700"
			}, {
				"c": "440781",
				"n": "台山市",
				"pc": "440700"
			}, {
				"c": "440783",
				"n": "开平市",
				"pc": "440700"
			}, {
				"c": "440784",
				"n": "鹤山市",
				"pc": "440700"
			}, {
				"c": "440785",
				"n": "恩平市",
				"pc": "440700"
			}, {
				"c": "440800",
				"n": "湛江市",
				"pc": "440000"
			}, {
				"c": "440801",
				"n": "市辖区",
				"pc": "440800"
			}, {
				"c": "440802",
				"n": "赤坎区",
				"pc": "440800"
			}, {
				"c": "440803",
				"n": "霞山区",
				"pc": "440800"
			}, {
				"c": "440804",
				"n": "坡头区",
				"pc": "440800"
			}, {
				"c": "440811",
				"n": "麻章区",
				"pc": "440800"
			}, {
				"c": "440823",
				"n": "遂溪县",
				"pc": "440800"
			}, {
				"c": "440825",
				"n": "徐闻县",
				"pc": "440800"
			}, {
				"c": "440881",
				"n": "廉江市",
				"pc": "440800"
			}, {
				"c": "440882",
				"n": "雷州市",
				"pc": "440800"
			}, {
				"c": "440883",
				"n": "吴川市",
				"pc": "440800"
			}, {
				"c": "440900",
				"n": "茂名市",
				"pc": "440000"
			}, {
				"c": "440901",
				"n": "市辖区",
				"pc": "440900"
			}, {
				"c": "440902",
				"n": "茂南区",
				"pc": "440900"
			}, {
				"c": "440903",
				"n": "茂港区",
				"pc": "440900"
			}, {
				"c": "440923",
				"n": "电白县",
				"pc": "440900"
			}, {
				"c": "440981",
				"n": "高州市",
				"pc": "440900"
			}, {
				"c": "440982",
				"n": "化州市",
				"pc": "440900"
			}, {
				"c": "440983",
				"n": "信宜市",
				"pc": "440900"
			}, {
				"c": "441200",
				"n": "肇庆市",
				"pc": "440000"
			}, {
				"c": "441201",
				"n": "市辖区",
				"pc": "441200"
			}, {
				"c": "441202",
				"n": "端州区",
				"pc": "441200"
			}, {
				"c": "441203",
				"n": "鼎湖区",
				"pc": "441200"
			}, {
				"c": "441223",
				"n": "广宁县",
				"pc": "441200"
			}, {
				"c": "441224",
				"n": "怀集县",
				"pc": "441200"
			}, {
				"c": "441225",
				"n": "封开县",
				"pc": "441200"
			}, {
				"c": "441226",
				"n": "德庆县",
				"pc": "441200"
			}, {
				"c": "441283",
				"n": "高要市",
				"pc": "441200"
			}, {
				"c": "441284",
				"n": "四会市",
				"pc": "441200"
			}, {
				"c": "441300",
				"n": "惠州市",
				"pc": "440000"
			}, {
				"c": "441301",
				"n": "市辖区",
				"pc": "441300"
			}, {
				"c": "441302",
				"n": "惠城区",
				"pc": "441300"
			}, {
				"c": "441303",
				"n": "惠阳区",
				"pc": "441300"
			}, {
				"c": "441322",
				"n": "博罗县",
				"pc": "441300"
			}, {
				"c": "441323",
				"n": "惠东县",
				"pc": "441300"
			}, {
				"c": "441324",
				"n": "龙门县",
				"pc": "441300"
			}, {
				"c": "441400",
				"n": "梅州市",
				"pc": "440000"
			}, {
				"c": "441401",
				"n": "市辖区",
				"pc": "441400"
			}, {
				"c": "441402",
				"n": "梅江区",
				"pc": "441400"
			}, {
				"c": "441421",
				"n": "梅县",
				"pc": "441400"
			}, {
				"c": "441422",
				"n": "大埔县",
				"pc": "441400"
			}, {
				"c": "441423",
				"n": "丰顺县",
				"pc": "441400"
			}, {
				"c": "441424",
				"n": "五华县",
				"pc": "441400"
			}, {
				"c": "441426",
				"n": "平远县",
				"pc": "441400"
			}, {
				"c": "441427",
				"n": "蕉岭县",
				"pc": "441400"
			}, {
				"c": "441481",
				"n": "兴宁市",
				"pc": "441400"
			}, {
				"c": "441500",
				"n": "汕尾市",
				"pc": "440000"
			}, {
				"c": "441501",
				"n": "市辖区",
				"pc": "441500"
			}, {
				"c": "441502",
				"n": "城区",
				"pc": "441500"
			}, {
				"c": "441521",
				"n": "海丰县",
				"pc": "441500"
			}, {
				"c": "441523",
				"n": "陆河县",
				"pc": "441500"
			}, {
				"c": "441581",
				"n": "陆丰市",
				"pc": "441500"
			}, {
				"c": "441600",
				"n": "河源市",
				"pc": "440000"
			}, {
				"c": "441601",
				"n": "市辖区",
				"pc": "441600"
			}, {
				"c": "441602",
				"n": "源城区",
				"pc": "441600"
			}, {
				"c": "441621",
				"n": "紫金县",
				"pc": "441600"
			}, {
				"c": "441622",
				"n": "龙川县",
				"pc": "441600"
			}, {
				"c": "441623",
				"n": "连平县",
				"pc": "441600"
			}, {
				"c": "441624",
				"n": "和平县",
				"pc": "441600"
			}, {
				"c": "441625",
				"n": "东源县",
				"pc": "441600"
			}, {
				"c": "441700",
				"n": "阳江市",
				"pc": "440000"
			}, {
				"c": "441701",
				"n": "市辖区",
				"pc": "441700"
			}, {
				"c": "441702",
				"n": "江城区",
				"pc": "441700"
			}, {
				"c": "441721",
				"n": "阳西县",
				"pc": "441700"
			}, {
				"c": "441723",
				"n": "阳东县",
				"pc": "441700"
			}, {
				"c": "441781",
				"n": "阳春市",
				"pc": "441700"
			}, {
				"c": "441800",
				"n": "清远市",
				"pc": "440000"
			}, {
				"c": "441801",
				"n": "市辖区",
				"pc": "441800"
			}, {
				"c": "441802",
				"n": "清城区",
				"pc": "441800"
			}, {
				"c": "441821",
				"n": "佛冈县",
				"pc": "441800"
			}, {
				"c": "441823",
				"n": "阳山县",
				"pc": "441800"
			}, {
				"c": "441825",
				"n": "连山壮族瑶族自治县",
				"pc": "441800"
			}, {
				"c": "441826",
				"n": "连南瑶族自治县",
				"pc": "441800"
			}, {
				"c": "441827",
				"n": "清新县",
				"pc": "441800"
			}, {
				"c": "441881",
				"n": "英德市",
				"pc": "441800"
			}, {
				"c": "441882",
				"n": "连州市",
				"pc": "441800"
			}, {
				"c": "441900",
				"n": "东莞市",
				"pc": "440000"
			}, {
				"c": "442000",
				"n": "中山市",
				"pc": "440000"
			}, {
				"c": "445100",
				"n": "潮州市",
				"pc": "440000"
			}, {
				"c": "445101",
				"n": "市辖区",
				"pc": "445100"
			}, {
				"c": "445102",
				"n": "湘桥区",
				"pc": "445100"
			}, {
				"c": "445121",
				"n": "潮安县",
				"pc": "445100"
			}, {
				"c": "445122",
				"n": "饶平县",
				"pc": "445100"
			}, {
				"c": "445200",
				"n": "揭阳市",
				"pc": "440000"
			}, {
				"c": "445201",
				"n": "市辖区",
				"pc": "445200"
			}, {
				"c": "445202",
				"n": "榕城区",
				"pc": "445200"
			}, {
				"c": "445221",
				"n": "揭东县",
				"pc": "445200"
			}, {
				"c": "445222",
				"n": "揭西县",
				"pc": "445200"
			}, {
				"c": "445224",
				"n": "惠来县",
				"pc": "445200"
			}, {
				"c": "445281",
				"n": "普宁市",
				"pc": "445200"
			}, {
				"c": "445300",
				"n": "云浮市",
				"pc": "440000"
			}, {
				"c": "445301",
				"n": "市辖区",
				"pc": "445300"
			}, {
				"c": "445302",
				"n": "云城区",
				"pc": "445300"
			}, {
				"c": "445321",
				"n": "新兴县",
				"pc": "445300"
			}, {
				"c": "445322",
				"n": "郁南县",
				"pc": "445300"
			}, {
				"c": "445323",
				"n": "云安县",
				"pc": "445300"
			}, {
				"c": "445381",
				"n": "罗定市",
				"pc": "445300"
			}, {
				"c": "450000",
				"n": "广西壮族自治区",
				"pc": "86"
			}, {
				"c": "450100",
				"n": "南宁市",
				"pc": "450000"
			}, {
				"c": "450101",
				"n": "市辖区",
				"pc": "450100"
			}, {
				"c": "450102",
				"n": "兴宁区",
				"pc": "450100"
			}, {
				"c": "450103",
				"n": "青秀区",
				"pc": "450100"
			}, {
				"c": "450105",
				"n": "江南区",
				"pc": "450100"
			}, {
				"c": "450107",
				"n": "西乡塘区",
				"pc": "450100"
			}, {
				"c": "450108",
				"n": "良庆区",
				"pc": "450100"
			}, {
				"c": "450109",
				"n": "邕宁区",
				"pc": "450100"
			}, {
				"c": "450122",
				"n": "武鸣县",
				"pc": "450100"
			}, {
				"c": "450123",
				"n": "隆安县",
				"pc": "450100"
			}, {
				"c": "450124",
				"n": "马山县",
				"pc": "450100"
			}, {
				"c": "450125",
				"n": "上林县",
				"pc": "450100"
			}, {
				"c": "450126",
				"n": "宾阳县",
				"pc": "450100"
			}, {
				"c": "450127",
				"n": "横县",
				"pc": "450100"
			}, {
				"c": "450200",
				"n": "柳州市",
				"pc": "450000"
			}, {
				"c": "450201",
				"n": "市辖区",
				"pc": "450200"
			}, {
				"c": "450202",
				"n": "城中区",
				"pc": "450200"
			}, {
				"c": "450203",
				"n": "鱼峰区",
				"pc": "450200"
			}, {
				"c": "450204",
				"n": "柳南区",
				"pc": "450200"
			}, {
				"c": "450205",
				"n": "柳北区",
				"pc": "450200"
			}, {
				"c": "450221",
				"n": "柳江县",
				"pc": "450200"
			}, {
				"c": "450222",
				"n": "柳城县",
				"pc": "450200"
			}, {
				"c": "450223",
				"n": "鹿寨县",
				"pc": "450200"
			}, {
				"c": "450224",
				"n": "融安县",
				"pc": "450200"
			}, {
				"c": "450225",
				"n": "融水苗族自治县",
				"pc": "450200"
			}, {
				"c": "450226",
				"n": "三江侗族自治县",
				"pc": "450200"
			}, {
				"c": "450300",
				"n": "桂林市",
				"pc": "450000"
			}, {
				"c": "450301",
				"n": "市辖区",
				"pc": "450300"
			}, {
				"c": "450302",
				"n": "秀峰区",
				"pc": "450300"
			}, {
				"c": "450303",
				"n": "叠彩区",
				"pc": "450300"
			}, {
				"c": "450304",
				"n": "象山区",
				"pc": "450300"
			}, {
				"c": "450305",
				"n": "七星区",
				"pc": "450300"
			}, {
				"c": "450311",
				"n": "雁山区",
				"pc": "450300"
			}, {
				"c": "450321",
				"n": "阳朔县",
				"pc": "450300"
			}, {
				"c": "450322",
				"n": "临桂县",
				"pc": "450300"
			}, {
				"c": "450323",
				"n": "灵川县",
				"pc": "450300"
			}, {
				"c": "450324",
				"n": "全州县",
				"pc": "450300"
			}, {
				"c": "450325",
				"n": "兴安县",
				"pc": "450300"
			}, {
				"c": "450326",
				"n": "永福县",
				"pc": "450300"
			}, {
				"c": "450327",
				"n": "灌阳县",
				"pc": "450300"
			}, {
				"c": "450328",
				"n": "龙胜各族自治县",
				"pc": "450300"
			}, {
				"c": "450329",
				"n": "资源县",
				"pc": "450300"
			}, {
				"c": "450330",
				"n": "平乐县",
				"pc": "450300"
			}, {
				"c": "450331",
				"n": "荔浦县",
				"pc": "450300"
			}, {
				"c": "450332",
				"n": "恭城瑶族自治县",
				"pc": "450300"
			}, {
				"c": "450400",
				"n": "梧州市",
				"pc": "450000"
			}, {
				"c": "450401",
				"n": "市辖区",
				"pc": "450400"
			}, {
				"c": "450403",
				"n": "万秀区",
				"pc": "450400"
			}, {
				"c": "450404",
				"n": "蝶山区",
				"pc": "450400"
			}, {
				"c": "450405",
				"n": "长洲区",
				"pc": "450400"
			}, {
				"c": "450421",
				"n": "苍梧县",
				"pc": "450400"
			}, {
				"c": "450422",
				"n": "藤县",
				"pc": "450400"
			}, {
				"c": "450423",
				"n": "蒙山县",
				"pc": "450400"
			}, {
				"c": "450481",
				"n": "岑溪市",
				"pc": "450400"
			}, {
				"c": "450500",
				"n": "北海市",
				"pc": "450000"
			}, {
				"c": "450501",
				"n": "市辖区",
				"pc": "450500"
			}, {
				"c": "450502",
				"n": "海城区",
				"pc": "450500"
			}, {
				"c": "450503",
				"n": "银海区",
				"pc": "450500"
			}, {
				"c": "450512",
				"n": "铁山港区",
				"pc": "450500"
			}, {
				"c": "450521",
				"n": "合浦县",
				"pc": "450500"
			}, {
				"c": "450600",
				"n": "防城港市",
				"pc": "450000"
			}, {
				"c": "450601",
				"n": "市辖区",
				"pc": "450600"
			}, {
				"c": "450602",
				"n": "港口区",
				"pc": "450600"
			}, {
				"c": "450603",
				"n": "防城区",
				"pc": "450600"
			}, {
				"c": "450621",
				"n": "上思县",
				"pc": "450600"
			}, {
				"c": "450681",
				"n": "东兴市",
				"pc": "450600"
			}, {
				"c": "450700",
				"n": "钦州市",
				"pc": "450000"
			}, {
				"c": "450701",
				"n": "市辖区",
				"pc": "450700"
			}, {
				"c": "450702",
				"n": "钦南区",
				"pc": "450700"
			}, {
				"c": "450703",
				"n": "钦北区",
				"pc": "450700"
			}, {
				"c": "450721",
				"n": "灵山县",
				"pc": "450700"
			}, {
				"c": "450722",
				"n": "浦北县",
				"pc": "450700"
			}, {
				"c": "450800",
				"n": "贵港市",
				"pc": "450000"
			}, {
				"c": "450801",
				"n": "市辖区",
				"pc": "450800"
			}, {
				"c": "450802",
				"n": "港北区",
				"pc": "450800"
			}, {
				"c": "450803",
				"n": "港南区",
				"pc": "450800"
			}, {
				"c": "450804",
				"n": "覃塘区",
				"pc": "450800"
			}, {
				"c": "450821",
				"n": "平南县",
				"pc": "450800"
			}, {
				"c": "450881",
				"n": "桂平市",
				"pc": "450800"
			}, {
				"c": "450900",
				"n": "玉林市",
				"pc": "450000"
			}, {
				"c": "450901",
				"n": "市辖区",
				"pc": "450900"
			}, {
				"c": "450902",
				"n": "玉州区",
				"pc": "450900"
			}, {
				"c": "450921",
				"n": "容县",
				"pc": "450900"
			}, {
				"c": "450922",
				"n": "陆川县",
				"pc": "450900"
			}, {
				"c": "450923",
				"n": "博白县",
				"pc": "450900"
			}, {
				"c": "450924",
				"n": "兴业县",
				"pc": "450900"
			}, {
				"c": "450981",
				"n": "北流市",
				"pc": "450900"
			}, {
				"c": "451000",
				"n": "百色市",
				"pc": "450000"
			}, {
				"c": "451001",
				"n": "市辖区",
				"pc": "451000"
			}, {
				"c": "451002",
				"n": "右江区",
				"pc": "451000"
			}, {
				"c": "451021",
				"n": "田阳县",
				"pc": "451000"
			}, {
				"c": "451022",
				"n": "田东县",
				"pc": "451000"
			}, {
				"c": "451023",
				"n": "平果县",
				"pc": "451000"
			}, {
				"c": "451024",
				"n": "德保县",
				"pc": "451000"
			}, {
				"c": "451025",
				"n": "靖西县",
				"pc": "451000"
			}, {
				"c": "451026",
				"n": "那坡县",
				"pc": "451000"
			}, {
				"c": "451027",
				"n": "凌云县",
				"pc": "451000"
			}, {
				"c": "451028",
				"n": "乐业县",
				"pc": "451000"
			}, {
				"c": "451029",
				"n": "田林县",
				"pc": "451000"
			}, {
				"c": "451030",
				"n": "西林县",
				"pc": "451000"
			}, {
				"c": "451031",
				"n": "隆林各族自治县",
				"pc": "451000"
			}, {
				"c": "451100",
				"n": "贺州市",
				"pc": "450000"
			}, {
				"c": "451101",
				"n": "市辖区",
				"pc": "451100"
			}, {
				"c": "451102",
				"n": "八步区",
				"pc": "451100"
			}, {
				"c": "451121",
				"n": "昭平县",
				"pc": "451100"
			}, {
				"c": "451122",
				"n": "钟山县",
				"pc": "451100"
			}, {
				"c": "451123",
				"n": "富川瑶族自治县",
				"pc": "451100"
			}, {
				"c": "451200",
				"n": "河池市",
				"pc": "450000"
			}, {
				"c": "451201",
				"n": "市辖区",
				"pc": "451200"
			}, {
				"c": "451202",
				"n": "金城江区",
				"pc": "451200"
			}, {
				"c": "451221",
				"n": "南丹县",
				"pc": "451200"
			}, {
				"c": "451222",
				"n": "天峨县",
				"pc": "451200"
			}, {
				"c": "451223",
				"n": "凤山县",
				"pc": "451200"
			}, {
				"c": "451224",
				"n": "东兰县",
				"pc": "451200"
			}, {
				"c": "451225",
				"n": "罗城仫佬族自治县",
				"pc": "451200"
			}, {
				"c": "451226",
				"n": "环江毛南族自治县",
				"pc": "451200"
			}, {
				"c": "451227",
				"n": "巴马瑶族自治县",
				"pc": "451200"
			}, {
				"c": "451228",
				"n": "都安瑶族自治县",
				"pc": "451200"
			}, {
				"c": "451229",
				"n": "大化瑶族自治县",
				"pc": "451200"
			}, {
				"c": "451281",
				"n": "宜州市",
				"pc": "451200"
			}, {
				"c": "451300",
				"n": "来宾市",
				"pc": "450000"
			}, {
				"c": "451301",
				"n": "市辖区",
				"pc": "451300"
			}, {
				"c": "451302",
				"n": "兴宾区",
				"pc": "451300"
			}, {
				"c": "451321",
				"n": "忻城县",
				"pc": "451300"
			}, {
				"c": "451322",
				"n": "象州县",
				"pc": "451300"
			}, {
				"c": "451323",
				"n": "武宣县",
				"pc": "451300"
			}, {
				"c": "451324",
				"n": "金秀瑶族自治县",
				"pc": "451300"
			}, {
				"c": "451381",
				"n": "合山市",
				"pc": "451300"
			}, {
				"c": "451400",
				"n": "崇左市",
				"pc": "450000"
			}, {
				"c": "451401",
				"n": "市辖区",
				"pc": "451400"
			}, {
				"c": "451402",
				"n": "江洲区",
				"pc": "451400"
			}, {
				"c": "451421",
				"n": "扶绥县",
				"pc": "451400"
			}, {
				"c": "451422",
				"n": "宁明县",
				"pc": "451400"
			}, {
				"c": "451423",
				"n": "龙州县",
				"pc": "451400"
			}, {
				"c": "451424",
				"n": "大新县",
				"pc": "451400"
			}, {
				"c": "451425",
				"n": "天等县",
				"pc": "451400"
			}, {
				"c": "451481",
				"n": "凭祥市",
				"pc": "451400"
			}, {
				"c": "460000",
				"n": "海南省",
				"pc": "86"
			}, {
				"c": "460100",
				"n": "海口市",
				"pc": "460000"
			}, {
				"c": "460101",
				"n": "市辖区",
				"pc": "460100"
			}, {
				"c": "460105",
				"n": "秀英区",
				"pc": "460100"
			}, {
				"c": "460106",
				"n": "龙华区",
				"pc": "460100"
			}, {
				"c": "460107",
				"n": "琼山区",
				"pc": "460100"
			}, {
				"c": "460108",
				"n": "美兰区",
				"pc": "460100"
			}, {
				"c": "460200",
				"n": "三亚市",
				"pc": "460000"
			}, {
				"c": "460201",
				"n": "市辖区",
				"pc": "460200"
			}, {
				"c": "460300",
				"n": "三沙市",
				"pc": "460000"
			}, {
				"c": "460321",
				"n": "西沙群岛",
				"pc": "460300"
			}, {
				"c": "460322",
				"n": "南沙群岛",
				"pc": "460300"
			}, {
				"c": "460323",
				"n": "中沙群岛的岛礁及其海域",
				"pc": "460300"
			}, {
				"c": "469000",
				"n": "省直辖县级行政区划",
				"pc": "460000"
			}, {
				"c": "469001",
				"n": "五指山市",
				"pc": "469000"
			}, {
				"c": "469002",
				"n": "琼海市",
				"pc": "469000"
			}, {
				"c": "469003",
				"n": "儋州市",
				"pc": "469000"
			}, {
				"c": "469005",
				"n": "文昌市",
				"pc": "469000"
			}, {
				"c": "469006",
				"n": "万宁市",
				"pc": "469000"
			}, {
				"c": "469007",
				"n": "东方市",
				"pc": "469000"
			}, {
				"c": "469021",
				"n": "定安县",
				"pc": "469000"
			}, {
				"c": "469022",
				"n": "屯昌县",
				"pc": "469000"
			}, {
				"c": "469023",
				"n": "澄迈县",
				"pc": "469000"
			}, {
				"c": "469024",
				"n": "临高县",
				"pc": "469000"
			}, {
				"c": "469025",
				"n": "白沙黎族自治县",
				"pc": "469000"
			}, {
				"c": "469026",
				"n": "昌江黎族自治县",
				"pc": "469000"
			}, {
				"c": "469027",
				"n": "乐东黎族自治县",
				"pc": "469000"
			}, {
				"c": "469028",
				"n": "陵水黎族自治县",
				"pc": "469000"
			}, {
				"c": "469029",
				"n": "保亭黎族苗族自治县",
				"pc": "469000"
			}, {
				"c": "469030",
				"n": "琼中黎族苗族自治县",
				"pc": "469000"
			}, {
				"c": "500000",
				"n": "重庆市",
				"pc": "86"
			}, {
				"c": "500100",
				"n": "重庆市",
				"pc": "500000"
			}, {
				"c": "500101",
				"n": "万州区",
				"pc": "500100"
			}, {
				"c": "500102",
				"n": "涪陵区",
				"pc": "500100"
			}, {
				"c": "500103",
				"n": "渝中区",
				"pc": "500100"
			}, {
				"c": "500104",
				"n": "大渡口区",
				"pc": "500100"
			}, {
				"c": "500105",
				"n": "江北区",
				"pc": "500100"
			}, {
				"c": "500106",
				"n": "沙坪坝区",
				"pc": "500100"
			}, {
				"c": "500107",
				"n": "九龙坡区",
				"pc": "500100"
			}, {
				"c": "500108",
				"n": "南岸区",
				"pc": "500100"
			}, {
				"c": "500109",
				"n": "北碚区",
				"pc": "500100"
			}, {
				"c": "500110",
				"n": "綦江区",
				"pc": "500100"
			}, {
				"c": "500111",
				"n": "大足区",
				"pc": "500100"
			}, {
				"c": "500112",
				"n": "渝北区",
				"pc": "500100"
			}, {
				"c": "500113",
				"n": "巴南区",
				"pc": "500100"
			}, {
				"c": "500114",
				"n": "黔江区",
				"pc": "500100"
			}, {
				"c": "500115",
				"n": "长寿区",
				"pc": "500100"
			}, {
				"c": "500116",
				"n": "江津区",
				"pc": "500100"
			}, {
				"c": "500117",
				"n": "合川区",
				"pc": "500100"
			}, {
				"c": "500118",
				"n": "永川区",
				"pc": "500100"
			}, {
				"c": "500119",
				"n": "南川区",
				"pc": "500100"
			}, {
				"c": "500100",
				"n": "县",
				"pc": "500000"
			}, {
				"c": "500223",
				"n": "潼南县",
				"pc": "500100"
			}, {
				"c": "500224",
				"n": "铜梁县",
				"pc": "500100"
			}, {
				"c": "500226",
				"n": "荣昌县",
				"pc": "500100"
			}, {
				"c": "500227",
				"n": "璧山县",
				"pc": "500100"
			}, {
				"c": "500228",
				"n": "梁平县",
				"pc": "500100"
			}, {
				"c": "500229",
				"n": "城口县",
				"pc": "500100"
			}, {
				"c": "500230",
				"n": "丰都县",
				"pc": "500100"
			}, {
				"c": "500231",
				"n": "垫江县",
				"pc": "500100"
			}, {
				"c": "500232",
				"n": "武隆县",
				"pc": "500100"
			}, {
				"c": "500233",
				"n": "忠县",
				"pc": "500100"
			}, {
				"c": "500234",
				"n": "开县",
				"pc": "500100"
			}, {
				"c": "500235",
				"n": "云阳县",
				"pc": "500100"
			}, {
				"c": "500236",
				"n": "奉节县",
				"pc": "500100"
			}, {
				"c": "500237",
				"n": "巫山县",
				"pc": "500100"
			}, {
				"c": "500238",
				"n": "巫溪县",
				"pc": "500100"
			}, {
				"c": "500240",
				"n": "石柱土家族自治县",
				"pc": "500100"
			}, {
				"c": "500241",
				"n": "秀山土家族苗族自治县",
				"pc": "500100"
			}, {
				"c": "500242",
				"n": "酉阳土家族苗族自治县",
				"pc": "500100"
			}, {
				"c": "500243",
				"n": "彭水苗族土家族自治县",
				"pc": "500100"
			}, {
				"c": "510000",
				"n": "四川省",
				"pc": "86"
			}, {
				"c": "510100",
				"n": "成都市",
				"pc": "510000"
			}, {
				"c": "510101",
				"n": "市辖区",
				"pc": "510100"
			}, {
				"c": "510104",
				"n": "锦江区",
				"pc": "510100"
			}, {
				"c": "510105",
				"n": "青羊区",
				"pc": "510100"
			}, {
				"c": "510106",
				"n": "金牛区",
				"pc": "510100"
			}, {
				"c": "510107",
				"n": "武侯区",
				"pc": "510100"
			}, {
				"c": "510108",
				"n": "成华区",
				"pc": "510100"
			}, {
				"c": "510112",
				"n": "龙泉驿区",
				"pc": "510100"
			}, {
				"c": "510113",
				"n": "青白江区",
				"pc": "510100"
			}, {
				"c": "510114",
				"n": "新都区",
				"pc": "510100"
			}, {
				"c": "510115",
				"n": "温江区",
				"pc": "510100"
			}, {
				"c": "510121",
				"n": "金堂县",
				"pc": "510100"
			}, {
				"c": "510122",
				"n": "双流县",
				"pc": "510100"
			}, {
				"c": "510124",
				"n": "郫县",
				"pc": "510100"
			}, {
				"c": "510129",
				"n": "大邑县",
				"pc": "510100"
			}, {
				"c": "510131",
				"n": "蒲江县",
				"pc": "510100"
			}, {
				"c": "510132",
				"n": "新津县",
				"pc": "510100"
			}, {
				"c": "510181",
				"n": "都江堰市",
				"pc": "510100"
			}, {
				"c": "510182",
				"n": "彭州市",
				"pc": "510100"
			}, {
				"c": "510183",
				"n": "邛崃市",
				"pc": "510100"
			}, {
				"c": "510184",
				"n": "崇州市",
				"pc": "510100"
			}, {
				"c": "510300",
				"n": "自贡市",
				"pc": "510000"
			}, {
				"c": "510301",
				"n": "市辖区",
				"pc": "510300"
			}, {
				"c": "510302",
				"n": "自流井区",
				"pc": "510300"
			}, {
				"c": "510303",
				"n": "贡井区",
				"pc": "510300"
			}, {
				"c": "510304",
				"n": "大安区",
				"pc": "510300"
			}, {
				"c": "510311",
				"n": "沿滩区",
				"pc": "510300"
			}, {
				"c": "510321",
				"n": "荣县",
				"pc": "510300"
			}, {
				"c": "510322",
				"n": "富顺县",
				"pc": "510300"
			}, {
				"c": "510400",
				"n": "攀枝花市",
				"pc": "510000"
			}, {
				"c": "510401",
				"n": "市辖区",
				"pc": "510400"
			}, {
				"c": "510402",
				"n": "东区",
				"pc": "510400"
			}, {
				"c": "510403",
				"n": "西区",
				"pc": "510400"
			}, {
				"c": "510411",
				"n": "仁和区",
				"pc": "510400"
			}, {
				"c": "510421",
				"n": "米易县",
				"pc": "510400"
			}, {
				"c": "510422",
				"n": "盐边县",
				"pc": "510400"
			}, {
				"c": "510500",
				"n": "泸州市",
				"pc": "510000"
			}, {
				"c": "510501",
				"n": "市辖区",
				"pc": "510500"
			}, {
				"c": "510502",
				"n": "江阳区",
				"pc": "510500"
			}, {
				"c": "510503",
				"n": "纳溪区",
				"pc": "510500"
			}, {
				"c": "510504",
				"n": "龙马潭区",
				"pc": "510500"
			}, {
				"c": "510521",
				"n": "泸县",
				"pc": "510500"
			}, {
				"c": "510522",
				"n": "合江县",
				"pc": "510500"
			}, {
				"c": "510524",
				"n": "叙永县",
				"pc": "510500"
			}, {
				"c": "510525",
				"n": "古蔺县",
				"pc": "510500"
			}, {
				"c": "510600",
				"n": "德阳市",
				"pc": "510000"
			}, {
				"c": "510601",
				"n": "市辖区",
				"pc": "510600"
			}, {
				"c": "510603",
				"n": "旌阳区",
				"pc": "510600"
			}, {
				"c": "510623",
				"n": "中江县",
				"pc": "510600"
			}, {
				"c": "510626",
				"n": "罗江县",
				"pc": "510600"
			}, {
				"c": "510681",
				"n": "广汉市",
				"pc": "510600"
			}, {
				"c": "510682",
				"n": "什邡市",
				"pc": "510600"
			}, {
				"c": "510683",
				"n": "绵竹市",
				"pc": "510600"
			}, {
				"c": "510700",
				"n": "绵阳市",
				"pc": "510000"
			}, {
				"c": "510701",
				"n": "市辖区",
				"pc": "510700"
			}, {
				"c": "510703",
				"n": "涪城区",
				"pc": "510700"
			}, {
				"c": "510704",
				"n": "游仙区",
				"pc": "510700"
			}, {
				"c": "510722",
				"n": "三台县",
				"pc": "510700"
			}, {
				"c": "510723",
				"n": "盐亭县",
				"pc": "510700"
			}, {
				"c": "510724",
				"n": "安县",
				"pc": "510700"
			}, {
				"c": "510725",
				"n": "梓潼县",
				"pc": "510700"
			}, {
				"c": "510726",
				"n": "北川羌族自治县",
				"pc": "510700"
			}, {
				"c": "510727",
				"n": "平武县",
				"pc": "510700"
			}, {
				"c": "510781",
				"n": "江油市",
				"pc": "510700"
			}, {
				"c": "510800",
				"n": "广元市",
				"pc": "510000"
			}, {
				"c": "510801",
				"n": "市辖区",
				"pc": "510800"
			}, {
				"c": "510802",
				"n": "利州区",
				"pc": "510800"
			}, {
				"c": "510811",
				"n": "元坝区",
				"pc": "510800"
			}, {
				"c": "510812",
				"n": "朝天区",
				"pc": "510800"
			}, {
				"c": "510821",
				"n": "旺苍县",
				"pc": "510800"
			}, {
				"c": "510822",
				"n": "青川县",
				"pc": "510800"
			}, {
				"c": "510823",
				"n": "剑阁县",
				"pc": "510800"
			}, {
				"c": "510824",
				"n": "苍溪县",
				"pc": "510800"
			}, {
				"c": "510900",
				"n": "遂宁市",
				"pc": "510000"
			}, {
				"c": "510901",
				"n": "市辖区",
				"pc": "510900"
			}, {
				"c": "510903",
				"n": "船山区",
				"pc": "510900"
			}, {
				"c": "510904",
				"n": "安居区",
				"pc": "510900"
			}, {
				"c": "510921",
				"n": "蓬溪县",
				"pc": "510900"
			}, {
				"c": "510922",
				"n": "射洪县",
				"pc": "510900"
			}, {
				"c": "510923",
				"n": "大英县",
				"pc": "510900"
			}, {
				"c": "511000",
				"n": "内江市",
				"pc": "510000"
			}, {
				"c": "511001",
				"n": "市辖区",
				"pc": "511000"
			}, {
				"c": "511002",
				"n": "市中区",
				"pc": "511000"
			}, {
				"c": "511011",
				"n": "东兴区",
				"pc": "511000"
			}, {
				"c": "511024",
				"n": "威远县",
				"pc": "511000"
			}, {
				"c": "511025",
				"n": "资中县",
				"pc": "511000"
			}, {
				"c": "511028",
				"n": "隆昌县",
				"pc": "511000"
			}, {
				"c": "511100",
				"n": "乐山市",
				"pc": "510000"
			}, {
				"c": "511101",
				"n": "市辖区",
				"pc": "511100"
			}, {
				"c": "511102",
				"n": "市中区",
				"pc": "511100"
			}, {
				"c": "511111",
				"n": "沙湾区",
				"pc": "511100"
			}, {
				"c": "511112",
				"n": "五通桥区",
				"pc": "511100"
			}, {
				"c": "511113",
				"n": "金口河区",
				"pc": "511100"
			}, {
				"c": "511123",
				"n": "犍为县",
				"pc": "511100"
			}, {
				"c": "511124",
				"n": "井研县",
				"pc": "511100"
			}, {
				"c": "511126",
				"n": "夹江县",
				"pc": "511100"
			}, {
				"c": "511129",
				"n": "沐川县",
				"pc": "511100"
			}, {
				"c": "511132",
				"n": "峨边彝族自治县",
				"pc": "511100"
			}, {
				"c": "511133",
				"n": "马边彝族自治县",
				"pc": "511100"
			}, {
				"c": "511181",
				"n": "峨眉山市",
				"pc": "511100"
			}, {
				"c": "511300",
				"n": "南充市",
				"pc": "510000"
			}, {
				"c": "511301",
				"n": "市辖区",
				"pc": "511300"
			}, {
				"c": "511302",
				"n": "顺庆区",
				"pc": "511300"
			}, {
				"c": "511303",
				"n": "高坪区",
				"pc": "511300"
			}, {
				"c": "511304",
				"n": "嘉陵区",
				"pc": "511300"
			}, {
				"c": "511321",
				"n": "南部县",
				"pc": "511300"
			}, {
				"c": "511322",
				"n": "营山县",
				"pc": "511300"
			}, {
				"c": "511323",
				"n": "蓬安县",
				"pc": "511300"
			}, {
				"c": "511324",
				"n": "仪陇县",
				"pc": "511300"
			}, {
				"c": "511325",
				"n": "西充县",
				"pc": "511300"
			}, {
				"c": "511381",
				"n": "阆中市",
				"pc": "511300"
			}, {
				"c": "511400",
				"n": "眉山市",
				"pc": "510000"
			}, {
				"c": "511401",
				"n": "市辖区",
				"pc": "511400"
			}, {
				"c": "511402",
				"n": "东坡区",
				"pc": "511400"
			}, {
				"c": "511421",
				"n": "仁寿县",
				"pc": "511400"
			}, {
				"c": "511422",
				"n": "彭山县",
				"pc": "511400"
			}, {
				"c": "511423",
				"n": "洪雅县",
				"pc": "511400"
			}, {
				"c": "511424",
				"n": "丹棱县",
				"pc": "511400"
			}, {
				"c": "511425",
				"n": "青神县",
				"pc": "511400"
			}, {
				"c": "511500",
				"n": "宜宾市",
				"pc": "510000"
			}, {
				"c": "511501",
				"n": "市辖区",
				"pc": "511500"
			}, {
				"c": "511502",
				"n": "翠屏区",
				"pc": "511500"
			}, {
				"c": "511503",
				"n": "南溪区",
				"pc": "511500"
			}, {
				"c": "511521",
				"n": "宜宾县",
				"pc": "511500"
			}, {
				"c": "511523",
				"n": "江安县",
				"pc": "511500"
			}, {
				"c": "511524",
				"n": "长宁县",
				"pc": "511500"
			}, {
				"c": "511525",
				"n": "高县",
				"pc": "511500"
			}, {
				"c": "511526",
				"n": "珙县",
				"pc": "511500"
			}, {
				"c": "511527",
				"n": "筠连县",
				"pc": "511500"
			}, {
				"c": "511528",
				"n": "兴文县",
				"pc": "511500"
			}, {
				"c": "511529",
				"n": "屏山县",
				"pc": "511500"
			}, {
				"c": "511600",
				"n": "广安市",
				"pc": "510000"
			}, {
				"c": "511601",
				"n": "市辖区",
				"pc": "511600"
			}, {
				"c": "511602",
				"n": "广安区",
				"pc": "511600"
			}, {
				"c": "511621",
				"n": "岳池县",
				"pc": "511600"
			}, {
				"c": "511622",
				"n": "武胜县",
				"pc": "511600"
			}, {
				"c": "511623",
				"n": "邻水县",
				"pc": "511600"
			}, {
				"c": "511681",
				"n": "华蓥市",
				"pc": "511600"
			}, {
				"c": "511700",
				"n": "达州市",
				"pc": "510000"
			}, {
				"c": "511701",
				"n": "市辖区",
				"pc": "511700"
			}, {
				"c": "511702",
				"n": "通川区",
				"pc": "511700"
			}, {
				"c": "511721",
				"n": "达县",
				"pc": "511700"
			}, {
				"c": "511722",
				"n": "宣汉县",
				"pc": "511700"
			}, {
				"c": "511723",
				"n": "开江县",
				"pc": "511700"
			}, {
				"c": "511724",
				"n": "大竹县",
				"pc": "511700"
			}, {
				"c": "511725",
				"n": "渠县",
				"pc": "511700"
			}, {
				"c": "511781",
				"n": "万源市",
				"pc": "511700"
			}, {
				"c": "511800",
				"n": "雅安市",
				"pc": "510000"
			}, {
				"c": "511801",
				"n": "市辖区",
				"pc": "511800"
			}, {
				"c": "511802",
				"n": "雨城区",
				"pc": "511800"
			}, {
				"c": "511803",
				"n": "名山区",
				"pc": "511800"
			}, {
				"c": "511822",
				"n": "荥经县",
				"pc": "511800"
			}, {
				"c": "511823",
				"n": "汉源县",
				"pc": "511800"
			}, {
				"c": "511824",
				"n": "石棉县",
				"pc": "511800"
			}, {
				"c": "511825",
				"n": "天全县",
				"pc": "511800"
			}, {
				"c": "511826",
				"n": "芦山县",
				"pc": "511800"
			}, {
				"c": "511827",
				"n": "宝兴县",
				"pc": "511800"
			}, {
				"c": "511900",
				"n": "巴中市",
				"pc": "510000"
			}, {
				"c": "511901",
				"n": "市辖区",
				"pc": "511900"
			}, {
				"c": "511902",
				"n": "巴州区",
				"pc": "511900"
			}, {
				"c": "511921",
				"n": "通江县",
				"pc": "511900"
			}, {
				"c": "511922",
				"n": "南江县",
				"pc": "511900"
			}, {
				"c": "511923",
				"n": "平昌县",
				"pc": "511900"
			}, {
				"c": "512000",
				"n": "资阳市",
				"pc": "510000"
			}, {
				"c": "512001",
				"n": "市辖区",
				"pc": "512000"
			}, {
				"c": "512002",
				"n": "雁江区",
				"pc": "512000"
			}, {
				"c": "512021",
				"n": "安岳县",
				"pc": "512000"
			}, {
				"c": "512022",
				"n": "乐至县",
				"pc": "512000"
			}, {
				"c": "512081",
				"n": "简阳市",
				"pc": "512000"
			}, {
				"c": "513200",
				"n": "阿坝藏族羌族自治州",
				"pc": "510000"
			}, {
				"c": "513221",
				"n": "汶川县",
				"pc": "513200"
			}, {
				"c": "513222",
				"n": "理县",
				"pc": "513200"
			}, {
				"c": "513223",
				"n": "茂县",
				"pc": "513200"
			}, {
				"c": "513224",
				"n": "松潘县",
				"pc": "513200"
			}, {
				"c": "513225",
				"n": "九寨沟县",
				"pc": "513200"
			}, {
				"c": "513226",
				"n": "金川县",
				"pc": "513200"
			}, {
				"c": "513227",
				"n": "小金县",
				"pc": "513200"
			}, {
				"c": "513228",
				"n": "黑水县",
				"pc": "513200"
			}, {
				"c": "513229",
				"n": "马尔康县",
				"pc": "513200"
			}, {
				"c": "513230",
				"n": "壤塘县",
				"pc": "513200"
			}, {
				"c": "513231",
				"n": "阿坝县",
				"pc": "513200"
			}, {
				"c": "513232",
				"n": "若尔盖县",
				"pc": "513200"
			}, {
				"c": "513233",
				"n": "红原县",
				"pc": "513200"
			}, {
				"c": "513300",
				"n": "甘孜藏族自治州",
				"pc": "510000"
			}, {
				"c": "513321",
				"n": "康定县",
				"pc": "513300"
			}, {
				"c": "513322",
				"n": "泸定县",
				"pc": "513300"
			}, {
				"c": "513323",
				"n": "丹巴县",
				"pc": "513300"
			}, {
				"c": "513324",
				"n": "九龙县",
				"pc": "513300"
			}, {
				"c": "513325",
				"n": "雅江县",
				"pc": "513300"
			}, {
				"c": "513326",
				"n": "道孚县",
				"pc": "513300"
			}, {
				"c": "513327",
				"n": "炉霍县",
				"pc": "513300"
			}, {
				"c": "513328",
				"n": "甘孜县",
				"pc": "513300"
			}, {
				"c": "513329",
				"n": "新龙县",
				"pc": "513300"
			}, {
				"c": "513330",
				"n": "德格县",
				"pc": "513300"
			}, {
				"c": "513331",
				"n": "白玉县",
				"pc": "513300"
			}, {
				"c": "513332",
				"n": "石渠县",
				"pc": "513300"
			}, {
				"c": "513333",
				"n": "色达县",
				"pc": "513300"
			}, {
				"c": "513334",
				"n": "理塘县",
				"pc": "513300"
			}, {
				"c": "513335",
				"n": "巴塘县",
				"pc": "513300"
			}, {
				"c": "513336",
				"n": "乡城县",
				"pc": "513300"
			}, {
				"c": "513337",
				"n": "稻城县",
				"pc": "513300"
			}, {
				"c": "513338",
				"n": "得荣县",
				"pc": "513300"
			}, {
				"c": "513400",
				"n": "凉山彝族自治州",
				"pc": "510000"
			}, {
				"c": "513401",
				"n": "西昌市",
				"pc": "513400"
			}, {
				"c": "513422",
				"n": "木里藏族自治县",
				"pc": "513400"
			}, {
				"c": "513423",
				"n": "盐源县",
				"pc": "513400"
			}, {
				"c": "513424",
				"n": "德昌县",
				"pc": "513400"
			}, {
				"c": "513425",
				"n": "会理县",
				"pc": "513400"
			}, {
				"c": "513426",
				"n": "会东县",
				"pc": "513400"
			}, {
				"c": "513427",
				"n": "宁南县",
				"pc": "513400"
			}, {
				"c": "513428",
				"n": "普格县",
				"pc": "513400"
			}, {
				"c": "513429",
				"n": "布拖县",
				"pc": "513400"
			}, {
				"c": "513430",
				"n": "金阳县",
				"pc": "513400"
			}, {
				"c": "513431",
				"n": "昭觉县",
				"pc": "513400"
			}, {
				"c": "513432",
				"n": "喜德县",
				"pc": "513400"
			}, {
				"c": "513433",
				"n": "冕宁县",
				"pc": "513400"
			}, {
				"c": "513434",
				"n": "越西县",
				"pc": "513400"
			}, {
				"c": "513435",
				"n": "甘洛县",
				"pc": "513400"
			}, {
				"c": "513436",
				"n": "美姑县",
				"pc": "513400"
			}, {
				"c": "513437",
				"n": "雷波县",
				"pc": "513400"
			}, {
				"c": "520000",
				"n": "贵州省",
				"pc": "86"
			}, {
				"c": "520100",
				"n": "贵阳市",
				"pc": "520000"
			}, {
				"c": "520101",
				"n": "市辖区",
				"pc": "520100"
			}, {
				"c": "520102",
				"n": "南明区",
				"pc": "520100"
			}, {
				"c": "520103",
				"n": "云岩区",
				"pc": "520100"
			}, {
				"c": "520111",
				"n": "花溪区",
				"pc": "520100"
			}, {
				"c": "520112",
				"n": "乌当区",
				"pc": "520100"
			}, {
				"c": "520113",
				"n": "白云区",
				"pc": "520100"
			}, {
				"c": "520114",
				"n": "小河区",
				"pc": "520100"
			}, {
				"c": "520121",
				"n": "开阳县",
				"pc": "520100"
			}, {
				"c": "520122",
				"n": "息烽县",
				"pc": "520100"
			}, {
				"c": "520123",
				"n": "修文县",
				"pc": "520100"
			}, {
				"c": "520181",
				"n": "清镇市",
				"pc": "520100"
			}, {
				"c": "520200",
				"n": "六盘水市",
				"pc": "520000"
			}, {
				"c": "520201",
				"n": "钟山区",
				"pc": "520200"
			}, {
				"c": "520203",
				"n": "六枝特区",
				"pc": "520200"
			}, {
				"c": "520221",
				"n": "水城县",
				"pc": "520200"
			}, {
				"c": "520222",
				"n": "盘县",
				"pc": "520200"
			}, {
				"c": "520300",
				"n": "遵义市",
				"pc": "520000"
			}, {
				"c": "520301",
				"n": "市辖区",
				"pc": "520300"
			}, {
				"c": "520302",
				"n": "红花岗区",
				"pc": "520300"
			}, {
				"c": "520303",
				"n": "汇川区",
				"pc": "520300"
			}, {
				"c": "520321",
				"n": "遵义县",
				"pc": "520300"
			}, {
				"c": "520322",
				"n": "桐梓县",
				"pc": "520300"
			}, {
				"c": "520323",
				"n": "绥阳县",
				"pc": "520300"
			}, {
				"c": "520324",
				"n": "正安县",
				"pc": "520300"
			}, {
				"c": "520325",
				"n": "道真仡佬族苗族自治县",
				"pc": "520300"
			}, {
				"c": "520326",
				"n": "务川仡佬族苗族自治县",
				"pc": "520300"
			}, {
				"c": "520327",
				"n": "凤冈县",
				"pc": "520300"
			}, {
				"c": "520328",
				"n": "湄潭县",
				"pc": "520300"
			}, {
				"c": "520329",
				"n": "余庆县",
				"pc": "520300"
			}, {
				"c": "520330",
				"n": "习水县",
				"pc": "520300"
			}, {
				"c": "520381",
				"n": "赤水市",
				"pc": "520300"
			}, {
				"c": "520382",
				"n": "仁怀市",
				"pc": "520300"
			}, {
				"c": "520400",
				"n": "安顺市",
				"pc": "520000"
			}, {
				"c": "520401",
				"n": "市辖区",
				"pc": "520400"
			}, {
				"c": "520402",
				"n": "西秀区",
				"pc": "520400"
			}, {
				"c": "520421",
				"n": "平坝县",
				"pc": "520400"
			}, {
				"c": "520422",
				"n": "普定县",
				"pc": "520400"
			}, {
				"c": "520423",
				"n": "镇宁布依族苗族自治县",
				"pc": "520400"
			}, {
				"c": "520424",
				"n": "关岭布依族苗族自治县",
				"pc": "520400"
			}, {
				"c": "520425",
				"n": "紫云苗族布依族自治县",
				"pc": "520400"
			}, {
				"c": "520500",
				"n": "毕节市",
				"pc": "520000"
			}, {
				"c": "520502",
				"n": "七星关区",
				"pc": "520500"
			}, {
				"c": "520521",
				"n": "大方县",
				"pc": "520500"
			}, {
				"c": "520522",
				"n": "黔西县",
				"pc": "520500"
			}, {
				"c": "520523",
				"n": "金沙县",
				"pc": "520500"
			}, {
				"c": "520524",
				"n": "织金县",
				"pc": "520500"
			}, {
				"c": "520525",
				"n": "纳雍县",
				"pc": "520500"
			}, {
				"c": "520526",
				"n": "威宁彝族回族苗族自治县",
				"pc": "520500"
			}, {
				"c": "520527",
				"n": "赫章县",
				"pc": "520500"
			}, {
				"c": "520600",
				"n": "铜仁市",
				"pc": "520000"
			}, {
				"c": "520602",
				"n": "碧江区",
				"pc": "520600"
			}, {
				"c": "520603",
				"n": "万山区",
				"pc": "520600"
			}, {
				"c": "520621",
				"n": "江口县",
				"pc": "520600"
			}, {
				"c": "520622",
				"n": "玉屏侗族自治县",
				"pc": "520600"
			}, {
				"c": "520623",
				"n": "石阡县",
				"pc": "520600"
			}, {
				"c": "520624",
				"n": "思南县",
				"pc": "520600"
			}, {
				"c": "520625",
				"n": "印江土家族苗族自治县",
				"pc": "520600"
			}, {
				"c": "520626",
				"n": "德江县",
				"pc": "520600"
			}, {
				"c": "520627",
				"n": "沿河土家族自治县",
				"pc": "520600"
			}, {
				"c": "520628",
				"n": "松桃苗族自治县",
				"pc": "520600"
			}, {
				"c": "522300",
				"n": "黔西南布依族苗族自治州",
				"pc": "520000"
			}, {
				"c": "522301",
				"n": "兴义市",
				"pc": "522300"
			}, {
				"c": "522322",
				"n": "兴仁县",
				"pc": "522300"
			}, {
				"c": "522323",
				"n": "普安县",
				"pc": "522300"
			}, {
				"c": "522324",
				"n": "晴隆县",
				"pc": "522300"
			}, {
				"c": "522325",
				"n": "贞丰县",
				"pc": "522300"
			}, {
				"c": "522326",
				"n": "望谟县",
				"pc": "522300"
			}, {
				"c": "522327",
				"n": "册亨县",
				"pc": "522300"
			}, {
				"c": "522328",
				"n": "安龙县",
				"pc": "522300"
			}, {
				"c": "522600",
				"n": "黔东南苗族侗族自治州",
				"pc": "520000"
			}, {
				"c": "522601",
				"n": "凯里市",
				"pc": "522600"
			}, {
				"c": "522622",
				"n": "黄平县",
				"pc": "522600"
			}, {
				"c": "522623",
				"n": "施秉县",
				"pc": "522600"
			}, {
				"c": "522624",
				"n": "三穗县",
				"pc": "522600"
			}, {
				"c": "522625",
				"n": "镇远县",
				"pc": "522600"
			}, {
				"c": "522626",
				"n": "岑巩县",
				"pc": "522600"
			}, {
				"c": "522627",
				"n": "天柱县",
				"pc": "522600"
			}, {
				"c": "522628",
				"n": "锦屏县",
				"pc": "522600"
			}, {
				"c": "522629",
				"n": "剑河县",
				"pc": "522600"
			}, {
				"c": "522630",
				"n": "台江县",
				"pc": "522600"
			}, {
				"c": "522631",
				"n": "黎平县",
				"pc": "522600"
			}, {
				"c": "522632",
				"n": "榕江县",
				"pc": "522600"
			}, {
				"c": "522633",
				"n": "从江县",
				"pc": "522600"
			}, {
				"c": "522634",
				"n": "雷山县",
				"pc": "522600"
			}, {
				"c": "522635",
				"n": "麻江县",
				"pc": "522600"
			}, {
				"c": "522636",
				"n": "丹寨县",
				"pc": "522600"
			}, {
				"c": "522700",
				"n": "黔南布依族苗族自治州",
				"pc": "520000"
			}, {
				"c": "522701",
				"n": "都匀市",
				"pc": "522700"
			}, {
				"c": "522702",
				"n": "福泉市",
				"pc": "522700"
			}, {
				"c": "522722",
				"n": "荔波县",
				"pc": "522700"
			}, {
				"c": "522723",
				"n": "贵定县",
				"pc": "522700"
			}, {
				"c": "522725",
				"n": "瓮安县",
				"pc": "522700"
			}, {
				"c": "522726",
				"n": "独山县",
				"pc": "522700"
			}, {
				"c": "522727",
				"n": "平塘县",
				"pc": "522700"
			}, {
				"c": "522728",
				"n": "罗甸县",
				"pc": "522700"
			}, {
				"c": "522729",
				"n": "长顺县",
				"pc": "522700"
			}, {
				"c": "522730",
				"n": "龙里县",
				"pc": "522700"
			}, {
				"c": "522731",
				"n": "惠水县",
				"pc": "522700"
			}, {
				"c": "522732",
				"n": "三都水族自治县",
				"pc": "522700"
			}, {
				"c": "530000",
				"n": "云南省",
				"pc": "86"
			}, {
				"c": "530100",
				"n": "昆明市",
				"pc": "530000"
			}, {
				"c": "530101",
				"n": "市辖区",
				"pc": "530100"
			}, {
				"c": "530102",
				"n": "五华区",
				"pc": "530100"
			}, {
				"c": "530103",
				"n": "盘龙区",
				"pc": "530100"
			}, {
				"c": "530111",
				"n": "官渡区",
				"pc": "530100"
			}, {
				"c": "530112",
				"n": "西山区",
				"pc": "530100"
			}, {
				"c": "530113",
				"n": "东川区",
				"pc": "530100"
			}, {
				"c": "530114",
				"n": "呈贡区",
				"pc": "530100"
			}, {
				"c": "530122",
				"n": "晋宁县",
				"pc": "530100"
			}, {
				"c": "530124",
				"n": "富民县",
				"pc": "530100"
			}, {
				"c": "530125",
				"n": "宜良县",
				"pc": "530100"
			}, {
				"c": "530126",
				"n": "石林彝族自治县",
				"pc": "530100"
			}, {
				"c": "530127",
				"n": "嵩明县",
				"pc": "530100"
			}, {
				"c": "530128",
				"n": "禄劝彝族苗族自治县",
				"pc": "530100"
			}, {
				"c": "530129",
				"n": "寻甸回族彝族自治县",
				"pc": "530100"
			}, {
				"c": "530181",
				"n": "安宁市",
				"pc": "530100"
			}, {
				"c": "530300",
				"n": "曲靖市",
				"pc": "530000"
			}, {
				"c": "530301",
				"n": "市辖区",
				"pc": "530300"
			}, {
				"c": "530302",
				"n": "麒麟区",
				"pc": "530300"
			}, {
				"c": "530321",
				"n": "马龙县",
				"pc": "530300"
			}, {
				"c": "530322",
				"n": "陆良县",
				"pc": "530300"
			}, {
				"c": "530323",
				"n": "师宗县",
				"pc": "530300"
			}, {
				"c": "530324",
				"n": "罗平县",
				"pc": "530300"
			}, {
				"c": "530325",
				"n": "富源县",
				"pc": "530300"
			}, {
				"c": "530326",
				"n": "会泽县",
				"pc": "530300"
			}, {
				"c": "530328",
				"n": "沾益县",
				"pc": "530300"
			}, {
				"c": "530381",
				"n": "宣威市",
				"pc": "530300"
			}, {
				"c": "530400",
				"n": "玉溪市",
				"pc": "530000"
			}, {
				"c": "530402",
				"n": "红塔区",
				"pc": "530400"
			}, {
				"c": "530421",
				"n": "江川县",
				"pc": "530400"
			}, {
				"c": "530422",
				"n": "澄江县",
				"pc": "530400"
			}, {
				"c": "530423",
				"n": "通海县",
				"pc": "530400"
			}, {
				"c": "530424",
				"n": "华宁县",
				"pc": "530400"
			}, {
				"c": "530425",
				"n": "易门县",
				"pc": "530400"
			}, {
				"c": "530426",
				"n": "峨山彝族自治县",
				"pc": "530400"
			}, {
				"c": "530427",
				"n": "新平彝族傣族自治县",
				"pc": "530400"
			}, {
				"c": "530428",
				"n": "元江哈尼族彝族傣族自治县",
				"pc": "530400"
			}, {
				"c": "530500",
				"n": "保山市",
				"pc": "530000"
			}, {
				"c": "530501",
				"n": "市辖区",
				"pc": "530500"
			}, {
				"c": "530502",
				"n": "隆阳区",
				"pc": "530500"
			}, {
				"c": "530521",
				"n": "施甸县",
				"pc": "530500"
			}, {
				"c": "530522",
				"n": "腾冲县",
				"pc": "530500"
			}, {
				"c": "530523",
				"n": "龙陵县",
				"pc": "530500"
			}, {
				"c": "530524",
				"n": "昌宁县",
				"pc": "530500"
			}, {
				"c": "530600",
				"n": "昭通市",
				"pc": "530000"
			}, {
				"c": "530601",
				"n": "市辖区",
				"pc": "530600"
			}, {
				"c": "530602",
				"n": "昭阳区",
				"pc": "530600"
			}, {
				"c": "530621",
				"n": "鲁甸县",
				"pc": "530600"
			}, {
				"c": "530622",
				"n": "巧家县",
				"pc": "530600"
			}, {
				"c": "530623",
				"n": "盐津县",
				"pc": "530600"
			}, {
				"c": "530624",
				"n": "大关县",
				"pc": "530600"
			}, {
				"c": "530625",
				"n": "永善县",
				"pc": "530600"
			}, {
				"c": "530626",
				"n": "绥江县",
				"pc": "530600"
			}, {
				"c": "530627",
				"n": "镇雄县",
				"pc": "530600"
			}, {
				"c": "530628",
				"n": "彝良县",
				"pc": "530600"
			}, {
				"c": "530629",
				"n": "威信县",
				"pc": "530600"
			}, {
				"c": "530630",
				"n": "水富县",
				"pc": "530600"
			}, {
				"c": "530700",
				"n": "丽江市",
				"pc": "530000"
			}, {
				"c": "530701",
				"n": "市辖区",
				"pc": "530700"
			}, {
				"c": "530702",
				"n": "古城区",
				"pc": "530700"
			}, {
				"c": "530721",
				"n": "玉龙纳西族自治县",
				"pc": "530700"
			}, {
				"c": "530722",
				"n": "永胜县",
				"pc": "530700"
			}, {
				"c": "530723",
				"n": "华坪县",
				"pc": "530700"
			}, {
				"c": "530724",
				"n": "宁蒗彝族自治县",
				"pc": "530700"
			}, {
				"c": "530800",
				"n": "普洱市",
				"pc": "530000"
			}, {
				"c": "530801",
				"n": "市辖区",
				"pc": "530800"
			}, {
				"c": "530802",
				"n": "思茅区",
				"pc": "530800"
			}, {
				"c": "530821",
				"n": "宁洱哈尼族彝族自治县",
				"pc": "530800"
			}, {
				"c": "530822",
				"n": "墨江哈尼族自治县",
				"pc": "530800"
			}, {
				"c": "530823",
				"n": "景东彝族自治县",
				"pc": "530800"
			}, {
				"c": "530824",
				"n": "景谷傣族彝族自治县",
				"pc": "530800"
			}, {
				"c": "530825",
				"n": "镇沅彝族哈尼族拉祜族自治县",
				"pc": "530800"
			}, {
				"c": "530826",
				"n": "江城哈尼族彝族自治县",
				"pc": "530800"
			}, {
				"c": "530827",
				"n": "孟连傣族拉祜族佤族自治县",
				"pc": "530800"
			}, {
				"c": "530828",
				"n": "澜沧拉祜族自治县",
				"pc": "530800"
			}, {
				"c": "530829",
				"n": "西盟佤族自治县",
				"pc": "530800"
			}, {
				"c": "530900",
				"n": "临沧市",
				"pc": "530000"
			}, {
				"c": "530901",
				"n": "市辖区",
				"pc": "530900"
			}, {
				"c": "530902",
				"n": "临翔区",
				"pc": "530900"
			}, {
				"c": "530921",
				"n": "凤庆县",
				"pc": "530900"
			}, {
				"c": "530922",
				"n": "云县",
				"pc": "530900"
			}, {
				"c": "530923",
				"n": "永德县",
				"pc": "530900"
			}, {
				"c": "530924",
				"n": "镇康县",
				"pc": "530900"
			}, {
				"c": "530925",
				"n": "双江拉祜族佤族布朗族傣族自治县",
				"pc": "530900"
			}, {
				"c": "530926",
				"n": "耿马傣族佤族自治县",
				"pc": "530900"
			}, {
				"c": "530927",
				"n": "沧源佤族自治县",
				"pc": "530900"
			}, {
				"c": "532300",
				"n": "楚雄彝族自治州",
				"pc": "530000"
			}, {
				"c": "532301",
				"n": "楚雄市",
				"pc": "532300"
			}, {
				"c": "532322",
				"n": "双柏县",
				"pc": "532300"
			}, {
				"c": "532323",
				"n": "牟定县",
				"pc": "532300"
			}, {
				"c": "532324",
				"n": "南华县",
				"pc": "532300"
			}, {
				"c": "532325",
				"n": "姚安县",
				"pc": "532300"
			}, {
				"c": "532326",
				"n": "大姚县",
				"pc": "532300"
			}, {
				"c": "532327",
				"n": "永仁县",
				"pc": "532300"
			}, {
				"c": "532328",
				"n": "元谋县",
				"pc": "532300"
			}, {
				"c": "532329",
				"n": "武定县",
				"pc": "532300"
			}, {
				"c": "532331",
				"n": "禄丰县",
				"pc": "532300"
			}, {
				"c": "532500",
				"n": "红河哈尼族彝族自治州",
				"pc": "530000"
			}, {
				"c": "532501",
				"n": "个旧市",
				"pc": "532500"
			}, {
				"c": "532502",
				"n": "开远市",
				"pc": "532500"
			}, {
				"c": "532503",
				"n": "蒙自市",
				"pc": "532500"
			}, {
				"c": "532523",
				"n": "屏边苗族自治县",
				"pc": "532500"
			}, {
				"c": "532524",
				"n": "建水县",
				"pc": "532500"
			}, {
				"c": "532525",
				"n": "石屏县",
				"pc": "532500"
			}, {
				"c": "532526",
				"n": "弥勒县",
				"pc": "532500"
			}, {
				"c": "532527",
				"n": "泸西县",
				"pc": "532500"
			}, {
				"c": "532528",
				"n": "元阳县",
				"pc": "532500"
			}, {
				"c": "532529",
				"n": "红河县",
				"pc": "532500"
			}, {
				"c": "532530",
				"n": "金平苗族瑶族傣族自治县",
				"pc": "532500"
			}, {
				"c": "532531",
				"n": "绿春县",
				"pc": "532500"
			}, {
				"c": "532532",
				"n": "河口瑶族自治县",
				"pc": "532500"
			}, {
				"c": "532600",
				"n": "文山壮族苗族自治州",
				"pc": "530000"
			}, {
				"c": "532601",
				"n": "文山市",
				"pc": "532600"
			}, {
				"c": "532622",
				"n": "砚山县",
				"pc": "532600"
			}, {
				"c": "532623",
				"n": "西畴县",
				"pc": "532600"
			}, {
				"c": "532624",
				"n": "麻栗坡县",
				"pc": "532600"
			}, {
				"c": "532625",
				"n": "马关县",
				"pc": "532600"
			}, {
				"c": "532626",
				"n": "丘北县",
				"pc": "532600"
			}, {
				"c": "532627",
				"n": "广南县",
				"pc": "532600"
			}, {
				"c": "532628",
				"n": "富宁县",
				"pc": "532600"
			}, {
				"c": "532800",
				"n": "西双版纳傣族自治州",
				"pc": "530000"
			}, {
				"c": "532801",
				"n": "景洪市",
				"pc": "532800"
			}, {
				"c": "532822",
				"n": "勐海县",
				"pc": "532800"
			}, {
				"c": "532823",
				"n": "勐腊县",
				"pc": "532800"
			}, {
				"c": "532900",
				"n": "大理白族自治州",
				"pc": "530000"
			}, {
				"c": "532901",
				"n": "大理市",
				"pc": "532900"
			}, {
				"c": "532922",
				"n": "漾濞彝族自治县",
				"pc": "532900"
			}, {
				"c": "532923",
				"n": "祥云县",
				"pc": "532900"
			}, {
				"c": "532924",
				"n": "宾川县",
				"pc": "532900"
			}, {
				"c": "532925",
				"n": "弥渡县",
				"pc": "532900"
			}, {
				"c": "532926",
				"n": "南涧彝族自治县",
				"pc": "532900"
			}, {
				"c": "532927",
				"n": "巍山彝族回族自治县",
				"pc": "532900"
			}, {
				"c": "532928",
				"n": "永平县",
				"pc": "532900"
			}, {
				"c": "532929",
				"n": "云龙县",
				"pc": "532900"
			}, {
				"c": "532930",
				"n": "洱源县",
				"pc": "532900"
			}, {
				"c": "532931",
				"n": "剑川县",
				"pc": "532900"
			}, {
				"c": "532932",
				"n": "鹤庆县",
				"pc": "532900"
			}, {
				"c": "533100",
				"n": "德宏傣族景颇族自治州",
				"pc": "530000"
			}, {
				"c": "533102",
				"n": "瑞丽市",
				"pc": "533100"
			}, {
				"c": "533103",
				"n": "芒市",
				"pc": "533100"
			}, {
				"c": "533122",
				"n": "梁河县",
				"pc": "533100"
			}, {
				"c": "533123",
				"n": "盈江县",
				"pc": "533100"
			}, {
				"c": "533124",
				"n": "陇川县",
				"pc": "533100"
			}, {
				"c": "533300",
				"n": "怒江傈僳族自治州",
				"pc": "530000"
			}, {
				"c": "533321",
				"n": "泸水县",
				"pc": "533300"
			}, {
				"c": "533323",
				"n": "福贡县",
				"pc": "533300"
			}, {
				"c": "533324",
				"n": "贡山独龙族怒族自治县",
				"pc": "533300"
			}, {
				"c": "533325",
				"n": "兰坪白族普米族自治县",
				"pc": "533300"
			}, {
				"c": "533400",
				"n": "迪庆藏族自治州",
				"pc": "530000"
			}, {
				"c": "533421",
				"n": "香格里拉县",
				"pc": "533400"
			}, {
				"c": "533422",
				"n": "德钦县",
				"pc": "533400"
			}, {
				"c": "533423",
				"n": "维西傈僳族自治县",
				"pc": "533400"
			}, {
				"c": "540000",
				"n": "西藏自治区",
				"pc": "86"
			}, {
				"c": "540100",
				"n": "拉萨市",
				"pc": "540000"
			}, {
				"c": "540101",
				"n": "市辖区",
				"pc": "540100"
			}, {
				"c": "540102",
				"n": "城关区",
				"pc": "540100"
			}, {
				"c": "540121",
				"n": "林周县",
				"pc": "540100"
			}, {
				"c": "540122",
				"n": "当雄县",
				"pc": "540100"
			}, {
				"c": "540123",
				"n": "尼木县",
				"pc": "540100"
			}, {
				"c": "540124",
				"n": "曲水县",
				"pc": "540100"
			}, {
				"c": "540125",
				"n": "堆龙德庆县",
				"pc": "540100"
			}, {
				"c": "540126",
				"n": "达孜县",
				"pc": "540100"
			}, {
				"c": "540127",
				"n": "墨竹工卡县",
				"pc": "540100"
			}, {
				"c": "542100",
				"n": "昌都地区",
				"pc": "540000"
			}, {
				"c": "542121",
				"n": "昌都县",
				"pc": "542100"
			}, {
				"c": "542122",
				"n": "江达县",
				"pc": "542100"
			}, {
				"c": "542123",
				"n": "贡觉县",
				"pc": "542100"
			}, {
				"c": "542124",
				"n": "类乌齐县",
				"pc": "542100"
			}, {
				"c": "542125",
				"n": "丁青县",
				"pc": "542100"
			}, {
				"c": "542126",
				"n": "察雅县",
				"pc": "542100"
			}, {
				"c": "542127",
				"n": "八宿县",
				"pc": "542100"
			}, {
				"c": "542128",
				"n": "左贡县",
				"pc": "542100"
			}, {
				"c": "542129",
				"n": "芒康县",
				"pc": "542100"
			}, {
				"c": "542132",
				"n": "洛隆县",
				"pc": "542100"
			}, {
				"c": "542133",
				"n": "边坝县",
				"pc": "542100"
			}, {
				"c": "542200",
				"n": "山南地区",
				"pc": "540000"
			}, {
				"c": "542221",
				"n": "乃东县",
				"pc": "542200"
			}, {
				"c": "542222",
				"n": "扎囊县",
				"pc": "542200"
			}, {
				"c": "542223",
				"n": "贡嘎县",
				"pc": "542200"
			}, {
				"c": "542224",
				"n": "桑日县",
				"pc": "542200"
			}, {
				"c": "542225",
				"n": "琼结县",
				"pc": "542200"
			}, {
				"c": "542226",
				"n": "曲松县",
				"pc": "542200"
			}, {
				"c": "542227",
				"n": "措美县",
				"pc": "542200"
			}, {
				"c": "542228",
				"n": "洛扎县",
				"pc": "542200"
			}, {
				"c": "542229",
				"n": "加查县",
				"pc": "542200"
			}, {
				"c": "542231",
				"n": "隆子县",
				"pc": "542200"
			}, {
				"c": "542232",
				"n": "错那县",
				"pc": "542200"
			}, {
				"c": "542233",
				"n": "浪卡子县",
				"pc": "542200"
			}, {
				"c": "542300",
				"n": "日喀则地区",
				"pc": "540000"
			}, {
				"c": "542301",
				"n": "日喀则市",
				"pc": "542300"
			}, {
				"c": "542322",
				"n": "南木林县",
				"pc": "542300"
			}, {
				"c": "542323",
				"n": "江孜县",
				"pc": "542300"
			}, {
				"c": "542324",
				"n": "定日县",
				"pc": "542300"
			}, {
				"c": "542325",
				"n": "萨迦县",
				"pc": "542300"
			}, {
				"c": "542326",
				"n": "拉孜县",
				"pc": "542300"
			}, {
				"c": "542327",
				"n": "昂仁县",
				"pc": "542300"
			}, {
				"c": "542328",
				"n": "谢通门县",
				"pc": "542300"
			}, {
				"c": "542329",
				"n": "白朗县",
				"pc": "542300"
			}, {
				"c": "542330",
				"n": "仁布县",
				"pc": "542300"
			}, {
				"c": "542331",
				"n": "康马县",
				"pc": "542300"
			}, {
				"c": "542332",
				"n": "定结县",
				"pc": "542300"
			}, {
				"c": "542333",
				"n": "仲巴县",
				"pc": "542300"
			}, {
				"c": "542334",
				"n": "亚东县",
				"pc": "542300"
			}, {
				"c": "542335",
				"n": "吉隆县",
				"pc": "542300"
			}, {
				"c": "542336",
				"n": "聂拉木县",
				"pc": "542300"
			}, {
				"c": "542337",
				"n": "萨嘎县",
				"pc": "542300"
			}, {
				"c": "542338",
				"n": "岗巴县",
				"pc": "542300"
			}, {
				"c": "542400",
				"n": "那曲地区",
				"pc": "540000"
			}, {
				"c": "542421",
				"n": "那曲县",
				"pc": "542400"
			}, {
				"c": "542422",
				"n": "嘉黎县",
				"pc": "542400"
			}, {
				"c": "542423",
				"n": "比如县",
				"pc": "542400"
			}, {
				"c": "542424",
				"n": "聂荣县",
				"pc": "542400"
			}, {
				"c": "542425",
				"n": "安多县",
				"pc": "542400"
			}, {
				"c": "542426",
				"n": "申扎县",
				"pc": "542400"
			}, {
				"c": "542427",
				"n": "索县",
				"pc": "542400"
			}, {
				"c": "542428",
				"n": "班戈县",
				"pc": "542400"
			}, {
				"c": "542429",
				"n": "巴青县",
				"pc": "542400"
			}, {
				"c": "542430",
				"n": "尼玛县",
				"pc": "542400"
			}, {
				"c": "542500",
				"n": "阿里地区",
				"pc": "540000"
			}, {
				"c": "542521",
				"n": "普兰县",
				"pc": "542500"
			}, {
				"c": "542522",
				"n": "札达县",
				"pc": "542500"
			}, {
				"c": "542523",
				"n": "噶尔县",
				"pc": "542500"
			}, {
				"c": "542524",
				"n": "日土县",
				"pc": "542500"
			}, {
				"c": "542525",
				"n": "革吉县",
				"pc": "542500"
			}, {
				"c": "542526",
				"n": "改则县",
				"pc": "542500"
			}, {
				"c": "542527",
				"n": "措勤县",
				"pc": "542500"
			}, {
				"c": "542600",
				"n": "林芝地区",
				"pc": "540000"
			}, {
				"c": "542621",
				"n": "林芝县",
				"pc": "542600"
			}, {
				"c": "542622",
				"n": "工布江达县",
				"pc": "542600"
			}, {
				"c": "542623",
				"n": "米林县",
				"pc": "542600"
			}, {
				"c": "542624",
				"n": "墨脱县",
				"pc": "542600"
			}, {
				"c": "542625",
				"n": "波密县",
				"pc": "542600"
			}, {
				"c": "542626",
				"n": "察隅县",
				"pc": "542600"
			}, {
				"c": "542627",
				"n": "朗县",
				"pc": "542600"
			}, {
				"c": "610000",
				"n": "陕西省",
				"pc": "86"
			}, {
				"c": "610100",
				"n": "西安市",
				"pc": "610000"
			}, {
				"c": "610101",
				"n": "市辖区",
				"pc": "610100"
			}, {
				"c": "610102",
				"n": "新城区",
				"pc": "610100"
			}, {
				"c": "610103",
				"n": "碑林区",
				"pc": "610100"
			}, {
				"c": "610104",
				"n": "莲湖区",
				"pc": "610100"
			}, {
				"c": "610111",
				"n": "灞桥区",
				"pc": "610100"
			}, {
				"c": "610112",
				"n": "未央区",
				"pc": "610100"
			}, {
				"c": "610113",
				"n": "雁塔区",
				"pc": "610100"
			}, {
				"c": "610114",
				"n": "阎良区",
				"pc": "610100"
			}, {
				"c": "610115",
				"n": "临潼区",
				"pc": "610100"
			}, {
				"c": "610116",
				"n": "长安区",
				"pc": "610100"
			}, {
				"c": "610122",
				"n": "蓝田县",
				"pc": "610100"
			}, {
				"c": "610124",
				"n": "周至县",
				"pc": "610100"
			}, {
				"c": "610125",
				"n": "户县",
				"pc": "610100"
			}, {
				"c": "610126",
				"n": "高陵县",
				"pc": "610100"
			}, {
				"c": "610200",
				"n": "铜川市",
				"pc": "610000"
			}, {
				"c": "610201",
				"n": "市辖区",
				"pc": "610200"
			}, {
				"c": "610202",
				"n": "王益区",
				"pc": "610200"
			}, {
				"c": "610203",
				"n": "印台区",
				"pc": "610200"
			}, {
				"c": "610204",
				"n": "耀州区",
				"pc": "610200"
			}, {
				"c": "610222",
				"n": "宜君县",
				"pc": "610200"
			}, {
				"c": "610300",
				"n": "宝鸡市",
				"pc": "610000"
			}, {
				"c": "610301",
				"n": "市辖区",
				"pc": "610300"
			}, {
				"c": "610302",
				"n": "渭滨区",
				"pc": "610300"
			}, {
				"c": "610303",
				"n": "金台区",
				"pc": "610300"
			}, {
				"c": "610304",
				"n": "陈仓区",
				"pc": "610300"
			}, {
				"c": "610322",
				"n": "凤翔县",
				"pc": "610300"
			}, {
				"c": "610323",
				"n": "岐山县",
				"pc": "610300"
			}, {
				"c": "610324",
				"n": "扶风县",
				"pc": "610300"
			}, {
				"c": "610326",
				"n": "眉县",
				"pc": "610300"
			}, {
				"c": "610327",
				"n": "陇县",
				"pc": "610300"
			}, {
				"c": "610328",
				"n": "千阳县",
				"pc": "610300"
			}, {
				"c": "610329",
				"n": "麟游县",
				"pc": "610300"
			}, {
				"c": "610330",
				"n": "凤县",
				"pc": "610300"
			}, {
				"c": "610331",
				"n": "太白县",
				"pc": "610300"
			}, {
				"c": "610400",
				"n": "咸阳市",
				"pc": "610000"
			}, {
				"c": "610401",
				"n": "市辖区",
				"pc": "610400"
			}, {
				"c": "610402",
				"n": "秦都区",
				"pc": "610400"
			}, {
				"c": "610403",
				"n": "杨陵区",
				"pc": "610400"
			}, {
				"c": "610404",
				"n": "渭城区",
				"pc": "610400"
			}, {
				"c": "610422",
				"n": "三原县",
				"pc": "610400"
			}, {
				"c": "610423",
				"n": "泾阳县",
				"pc": "610400"
			}, {
				"c": "610424",
				"n": "乾县",
				"pc": "610400"
			}, {
				"c": "610425",
				"n": "礼泉县",
				"pc": "610400"
			}, {
				"c": "610426",
				"n": "永寿县",
				"pc": "610400"
			}, {
				"c": "610427",
				"n": "彬县",
				"pc": "610400"
			}, {
				"c": "610428",
				"n": "长武县",
				"pc": "610400"
			}, {
				"c": "610429",
				"n": "旬邑县",
				"pc": "610400"
			}, {
				"c": "610430",
				"n": "淳化县",
				"pc": "610400"
			}, {
				"c": "610431",
				"n": "武功县",
				"pc": "610400"
			}, {
				"c": "610481",
				"n": "兴平市",
				"pc": "610400"
			}, {
				"c": "610500",
				"n": "渭南市",
				"pc": "610000"
			}, {
				"c": "610501",
				"n": "市辖区",
				"pc": "610500"
			}, {
				"c": "610502",
				"n": "临渭区",
				"pc": "610500"
			}, {
				"c": "610521",
				"n": "华县",
				"pc": "610500"
			}, {
				"c": "610522",
				"n": "潼关县",
				"pc": "610500"
			}, {
				"c": "610523",
				"n": "大荔县",
				"pc": "610500"
			}, {
				"c": "610524",
				"n": "合阳县",
				"pc": "610500"
			}, {
				"c": "610525",
				"n": "澄城县",
				"pc": "610500"
			}, {
				"c": "610526",
				"n": "蒲城县",
				"pc": "610500"
			}, {
				"c": "610527",
				"n": "白水县",
				"pc": "610500"
			}, {
				"c": "610528",
				"n": "富平县",
				"pc": "610500"
			}, {
				"c": "610581",
				"n": "韩城市",
				"pc": "610500"
			}, {
				"c": "610582",
				"n": "华阴市",
				"pc": "610500"
			}, {
				"c": "610600",
				"n": "延安市",
				"pc": "610000"
			}, {
				"c": "610601",
				"n": "市辖区",
				"pc": "610600"
			}, {
				"c": "610602",
				"n": "宝塔区",
				"pc": "610600"
			}, {
				"c": "610621",
				"n": "延长县",
				"pc": "610600"
			}, {
				"c": "610622",
				"n": "延川县",
				"pc": "610600"
			}, {
				"c": "610623",
				"n": "子长县",
				"pc": "610600"
			}, {
				"c": "610624",
				"n": "安塞县",
				"pc": "610600"
			}, {
				"c": "610625",
				"n": "志丹县",
				"pc": "610600"
			}, {
				"c": "610626",
				"n": "吴起县",
				"pc": "610600"
			}, {
				"c": "610627",
				"n": "甘泉县",
				"pc": "610600"
			}, {
				"c": "610628",
				"n": "富县",
				"pc": "610600"
			}, {
				"c": "610629",
				"n": "洛川县",
				"pc": "610600"
			}, {
				"c": "610630",
				"n": "宜川县",
				"pc": "610600"
			}, {
				"c": "610631",
				"n": "黄龙县",
				"pc": "610600"
			}, {
				"c": "610632",
				"n": "黄陵县",
				"pc": "610600"
			}, {
				"c": "610700",
				"n": "汉中市",
				"pc": "610000"
			}, {
				"c": "610701",
				"n": "市辖区",
				"pc": "610700"
			}, {
				"c": "610702",
				"n": "汉台区",
				"pc": "610700"
			}, {
				"c": "610721",
				"n": "南郑县",
				"pc": "610700"
			}, {
				"c": "610722",
				"n": "城固县",
				"pc": "610700"
			}, {
				"c": "610723",
				"n": "洋县",
				"pc": "610700"
			}, {
				"c": "610724",
				"n": "西乡县",
				"pc": "610700"
			}, {
				"c": "610725",
				"n": "勉县",
				"pc": "610700"
			}, {
				"c": "610726",
				"n": "宁强县",
				"pc": "610700"
			}, {
				"c": "610727",
				"n": "略阳县",
				"pc": "610700"
			}, {
				"c": "610728",
				"n": "镇巴县",
				"pc": "610700"
			}, {
				"c": "610729",
				"n": "留坝县",
				"pc": "610700"
			}, {
				"c": "610730",
				"n": "佛坪县",
				"pc": "610700"
			}, {
				"c": "610800",
				"n": "榆林市",
				"pc": "610000"
			}, {
				"c": "610801",
				"n": "市辖区",
				"pc": "610800"
			}, {
				"c": "610802",
				"n": "榆阳区",
				"pc": "610800"
			}, {
				"c": "610821",
				"n": "神木县",
				"pc": "610800"
			}, {
				"c": "610822",
				"n": "府谷县",
				"pc": "610800"
			}, {
				"c": "610823",
				"n": "横山县",
				"pc": "610800"
			}, {
				"c": "610824",
				"n": "靖边县",
				"pc": "610800"
			}, {
				"c": "610825",
				"n": "定边县",
				"pc": "610800"
			}, {
				"c": "610826",
				"n": "绥德县",
				"pc": "610800"
			}, {
				"c": "610827",
				"n": "米脂县",
				"pc": "610800"
			}, {
				"c": "610828",
				"n": "佳县",
				"pc": "610800"
			}, {
				"c": "610829",
				"n": "吴堡县",
				"pc": "610800"
			}, {
				"c": "610830",
				"n": "清涧县",
				"pc": "610800"
			}, {
				"c": "610831",
				"n": "子洲县",
				"pc": "610800"
			}, {
				"c": "610900",
				"n": "安康市",
				"pc": "610000"
			}, {
				"c": "610901",
				"n": "市辖区",
				"pc": "610900"
			}, {
				"c": "610902",
				"n": "汉滨区",
				"pc": "610900"
			}, {
				"c": "610921",
				"n": "汉阴县",
				"pc": "610900"
			}, {
				"c": "610922",
				"n": "石泉县",
				"pc": "610900"
			}, {
				"c": "610923",
				"n": "宁陕县",
				"pc": "610900"
			}, {
				"c": "610924",
				"n": "紫阳县",
				"pc": "610900"
			}, {
				"c": "610925",
				"n": "岚皋县",
				"pc": "610900"
			}, {
				"c": "610926",
				"n": "平利县",
				"pc": "610900"
			}, {
				"c": "610927",
				"n": "镇坪县",
				"pc": "610900"
			}, {
				"c": "610928",
				"n": "旬阳县",
				"pc": "610900"
			}, {
				"c": "610929",
				"n": "白河县",
				"pc": "610900"
			}, {
				"c": "611000",
				"n": "商洛市",
				"pc": "610000"
			}, {
				"c": "611001",
				"n": "市辖区",
				"pc": "611000"
			}, {
				"c": "611002",
				"n": "商州区",
				"pc": "611000"
			}, {
				"c": "611021",
				"n": "洛南县",
				"pc": "611000"
			}, {
				"c": "611022",
				"n": "丹凤县",
				"pc": "611000"
			}, {
				"c": "611023",
				"n": "商南县",
				"pc": "611000"
			}, {
				"c": "611024",
				"n": "山阳县",
				"pc": "611000"
			}, {
				"c": "611025",
				"n": "镇安县",
				"pc": "611000"
			}, {
				"c": "611026",
				"n": "柞水县",
				"pc": "611000"
			}, {
				"c": "620000",
				"n": "甘肃省",
				"pc": "86"
			}, {
				"c": "620100",
				"n": "兰州市",
				"pc": "620000"
			}, {
				"c": "620101",
				"n": "市辖区",
				"pc": "620100"
			}, {
				"c": "620102",
				"n": "城关区",
				"pc": "620100"
			}, {
				"c": "620103",
				"n": "七里河区",
				"pc": "620100"
			}, {
				"c": "620104",
				"n": "西固区",
				"pc": "620100"
			}, {
				"c": "620105",
				"n": "安宁区",
				"pc": "620100"
			}, {
				"c": "620111",
				"n": "红古区",
				"pc": "620100"
			}, {
				"c": "620121",
				"n": "永登县",
				"pc": "620100"
			}, {
				"c": "620122",
				"n": "皋兰县",
				"pc": "620100"
			}, {
				"c": "620123",
				"n": "榆中县",
				"pc": "620100"
			}, {
				"c": "620200",
				"n": "嘉峪关市",
				"pc": "620000"
			}, {
				"c": "620201",
				"n": "市辖区",
				"pc": "620200"
			}, {
				"c": "620300",
				"n": "金昌市",
				"pc": "620000"
			}, {
				"c": "620301",
				"n": "市辖区",
				"pc": "620300"
			}, {
				"c": "620302",
				"n": "金川区",
				"pc": "620300"
			}, {
				"c": "620321",
				"n": "永昌县",
				"pc": "620300"
			}, {
				"c": "620400",
				"n": "白银市",
				"pc": "620000"
			}, {
				"c": "620401",
				"n": "市辖区",
				"pc": "620400"
			}, {
				"c": "620402",
				"n": "白银区",
				"pc": "620400"
			}, {
				"c": "620403",
				"n": "平川区",
				"pc": "620400"
			}, {
				"c": "620421",
				"n": "靖远县",
				"pc": "620400"
			}, {
				"c": "620422",
				"n": "会宁县",
				"pc": "620400"
			}, {
				"c": "620423",
				"n": "景泰县",
				"pc": "620400"
			}, {
				"c": "620500",
				"n": "天水市",
				"pc": "620000"
			}, {
				"c": "620501",
				"n": "市辖区",
				"pc": "620500"
			}, {
				"c": "620502",
				"n": "秦州区",
				"pc": "620500"
			}, {
				"c": "620503",
				"n": "麦积区",
				"pc": "620500"
			}, {
				"c": "620521",
				"n": "清水县",
				"pc": "620500"
			}, {
				"c": "620522",
				"n": "秦安县",
				"pc": "620500"
			}, {
				"c": "620523",
				"n": "甘谷县",
				"pc": "620500"
			}, {
				"c": "620524",
				"n": "武山县",
				"pc": "620500"
			}, {
				"c": "620525",
				"n": "张家川回族自治县",
				"pc": "620500"
			}, {
				"c": "620600",
				"n": "武威市",
				"pc": "620000"
			}, {
				"c": "620601",
				"n": "市辖区",
				"pc": "620600"
			}, {
				"c": "620602",
				"n": "凉州区",
				"pc": "620600"
			}, {
				"c": "620621",
				"n": "民勤县",
				"pc": "620600"
			}, {
				"c": "620622",
				"n": "古浪县",
				"pc": "620600"
			}, {
				"c": "620623",
				"n": "天祝藏族自治县",
				"pc": "620600"
			}, {
				"c": "620700",
				"n": "张掖市",
				"pc": "620000"
			}, {
				"c": "620701",
				"n": "市辖区",
				"pc": "620700"
			}, {
				"c": "620702",
				"n": "甘州区",
				"pc": "620700"
			}, {
				"c": "620721",
				"n": "肃南裕固族自治县",
				"pc": "620700"
			}, {
				"c": "620722",
				"n": "民乐县",
				"pc": "620700"
			}, {
				"c": "620723",
				"n": "临泽县",
				"pc": "620700"
			}, {
				"c": "620724",
				"n": "高台县",
				"pc": "620700"
			}, {
				"c": "620725",
				"n": "山丹县",
				"pc": "620700"
			}, {
				"c": "620800",
				"n": "平凉市",
				"pc": "620000"
			}, {
				"c": "620801",
				"n": "市辖区",
				"pc": "620800"
			}, {
				"c": "620802",
				"n": "崆峒区",
				"pc": "620800"
			}, {
				"c": "620821",
				"n": "泾川县",
				"pc": "620800"
			}, {
				"c": "620822",
				"n": "灵台县",
				"pc": "620800"
			}, {
				"c": "620823",
				"n": "崇信县",
				"pc": "620800"
			}, {
				"c": "620824",
				"n": "华亭县",
				"pc": "620800"
			}, {
				"c": "620825",
				"n": "庄浪县",
				"pc": "620800"
			}, {
				"c": "620826",
				"n": "静宁县",
				"pc": "620800"
			}, {
				"c": "620900",
				"n": "酒泉市",
				"pc": "620000"
			}, {
				"c": "620901",
				"n": "市辖区",
				"pc": "620900"
			}, {
				"c": "620902",
				"n": "肃州区",
				"pc": "620900"
			}, {
				"c": "620921",
				"n": "金塔县",
				"pc": "620900"
			}, {
				"c": "620922",
				"n": "瓜州县",
				"pc": "620900"
			}, {
				"c": "620923",
				"n": "肃北蒙古族自治县",
				"pc": "620900"
			}, {
				"c": "620924",
				"n": "阿克塞哈萨克族自治县",
				"pc": "620900"
			}, {
				"c": "620981",
				"n": "玉门市",
				"pc": "620900"
			}, {
				"c": "620982",
				"n": "敦煌市",
				"pc": "620900"
			}, {
				"c": "621000",
				"n": "庆阳市",
				"pc": "620000"
			}, {
				"c": "621001",
				"n": "市辖区",
				"pc": "621000"
			}, {
				"c": "621002",
				"n": "西峰区",
				"pc": "621000"
			}, {
				"c": "621021",
				"n": "庆城县",
				"pc": "621000"
			}, {
				"c": "621022",
				"n": "环县",
				"pc": "621000"
			}, {
				"c": "621023",
				"n": "华池县",
				"pc": "621000"
			}, {
				"c": "621024",
				"n": "合水县",
				"pc": "621000"
			}, {
				"c": "621025",
				"n": "正宁县",
				"pc": "621000"
			}, {
				"c": "621026",
				"n": "宁县",
				"pc": "621000"
			}, {
				"c": "621027",
				"n": "镇原县",
				"pc": "621000"
			}, {
				"c": "621100",
				"n": "定西市",
				"pc": "620000"
			}, {
				"c": "621101",
				"n": "市辖区",
				"pc": "621100"
			}, {
				"c": "621102",
				"n": "安定区",
				"pc": "621100"
			}, {
				"c": "621121",
				"n": "通渭县",
				"pc": "621100"
			}, {
				"c": "621122",
				"n": "陇西县",
				"pc": "621100"
			}, {
				"c": "621123",
				"n": "渭源县",
				"pc": "621100"
			}, {
				"c": "621124",
				"n": "临洮县",
				"pc": "621100"
			}, {
				"c": "621125",
				"n": "漳县",
				"pc": "621100"
			}, {
				"c": "621126",
				"n": "岷县",
				"pc": "621100"
			}, {
				"c": "621200",
				"n": "陇南市",
				"pc": "620000"
			}, {
				"c": "621201",
				"n": "市辖区",
				"pc": "621200"
			}, {
				"c": "621202",
				"n": "武都区",
				"pc": "621200"
			}, {
				"c": "621221",
				"n": "成县",
				"pc": "621200"
			}, {
				"c": "621222",
				"n": "文县",
				"pc": "621200"
			}, {
				"c": "621223",
				"n": "宕昌县",
				"pc": "621200"
			}, {
				"c": "621224",
				"n": "康县",
				"pc": "621200"
			}, {
				"c": "621225",
				"n": "西和县",
				"pc": "621200"
			}, {
				"c": "621226",
				"n": "礼县",
				"pc": "621200"
			}, {
				"c": "621227",
				"n": "徽县",
				"pc": "621200"
			}, {
				"c": "621228",
				"n": "两当县",
				"pc": "621200"
			}, {
				"c": "622900",
				"n": "临夏回族自治州",
				"pc": "620000"
			}, {
				"c": "622901",
				"n": "临夏市",
				"pc": "622900"
			}, {
				"c": "622921",
				"n": "临夏县",
				"pc": "622900"
			}, {
				"c": "622922",
				"n": "康乐县",
				"pc": "622900"
			}, {
				"c": "622923",
				"n": "永靖县",
				"pc": "622900"
			}, {
				"c": "622924",
				"n": "广河县",
				"pc": "622900"
			}, {
				"c": "622925",
				"n": "和政县",
				"pc": "622900"
			}, {
				"c": "622926",
				"n": "东乡族自治县",
				"pc": "622900"
			}, {
				"c": "622927",
				"n": "积石山保安族东乡族撒拉族自治县",
				"pc": "622900"
			}, {
				"c": "623000",
				"n": "甘南藏族自治州",
				"pc": "620000"
			}, {
				"c": "623001",
				"n": "合作市",
				"pc": "623000"
			}, {
				"c": "623021",
				"n": "临潭县",
				"pc": "623000"
			}, {
				"c": "623022",
				"n": "卓尼县",
				"pc": "623000"
			}, {
				"c": "623023",
				"n": "舟曲县",
				"pc": "623000"
			}, {
				"c": "623024",
				"n": "迭部县",
				"pc": "623000"
			}, {
				"c": "623025",
				"n": "玛曲县",
				"pc": "623000"
			}, {
				"c": "623026",
				"n": "碌曲县",
				"pc": "623000"
			}, {
				"c": "623027",
				"n": "夏河县",
				"pc": "623000"
			}, {
				"c": "630000",
				"n": "青海省",
				"pc": "86"
			}, {
				"c": "630100",
				"n": "西宁市",
				"pc": "630000"
			}, {
				"c": "630101",
				"n": "市辖区",
				"pc": "630100"
			}, {
				"c": "630102",
				"n": "城东区",
				"pc": "630100"
			}, {
				"c": "630103",
				"n": "城中区",
				"pc": "630100"
			}, {
				"c": "630104",
				"n": "城西区",
				"pc": "630100"
			}, {
				"c": "630105",
				"n": "城北区",
				"pc": "630100"
			}, {
				"c": "630121",
				"n": "大通回族土族自治县",
				"pc": "630100"
			}, {
				"c": "630122",
				"n": "湟中县",
				"pc": "630100"
			}, {
				"c": "630123",
				"n": "湟源县",
				"pc": "630100"
			}, {
				"c": "632100",
				"n": "海东地区",
				"pc": "630000"
			}, {
				"c": "632121",
				"n": "平安县",
				"pc": "632100"
			}, {
				"c": "632122",
				"n": "民和回族土族自治县",
				"pc": "632100"
			}, {
				"c": "632123",
				"n": "乐都县",
				"pc": "632100"
			}, {
				"c": "632126",
				"n": "互助土族自治县",
				"pc": "632100"
			}, {
				"c": "632127",
				"n": "化隆回族自治县",
				"pc": "632100"
			}, {
				"c": "632128",
				"n": "循化撒拉族自治县",
				"pc": "632100"
			}, {
				"c": "632200",
				"n": "海北藏族自治州",
				"pc": "630000"
			}, {
				"c": "632221",
				"n": "门源回族自治县",
				"pc": "632200"
			}, {
				"c": "632222",
				"n": "祁连县",
				"pc": "632200"
			}, {
				"c": "632223",
				"n": "海晏县",
				"pc": "632200"
			}, {
				"c": "632224",
				"n": "刚察县",
				"pc": "632200"
			}, {
				"c": "632300",
				"n": "黄南藏族自治州",
				"pc": "630000"
			}, {
				"c": "632321",
				"n": "同仁县",
				"pc": "632300"
			}, {
				"c": "632322",
				"n": "尖扎县",
				"pc": "632300"
			}, {
				"c": "632323",
				"n": "泽库县",
				"pc": "632300"
			}, {
				"c": "632324",
				"n": "河南蒙古族自治县",
				"pc": "632300"
			}, {
				"c": "632500",
				"n": "海南藏族自治州",
				"pc": "630000"
			}, {
				"c": "632521",
				"n": "共和县",
				"pc": "632500"
			}, {
				"c": "632522",
				"n": "同德县",
				"pc": "632500"
			}, {
				"c": "632523",
				"n": "贵德县",
				"pc": "632500"
			}, {
				"c": "632524",
				"n": "兴海县",
				"pc": "632500"
			}, {
				"c": "632525",
				"n": "贵南县",
				"pc": "632500"
			}, {
				"c": "632600",
				"n": "果洛藏族自治州",
				"pc": "630000"
			}, {
				"c": "632621",
				"n": "玛沁县",
				"pc": "632600"
			}, {
				"c": "632622",
				"n": "班玛县",
				"pc": "632600"
			}, {
				"c": "632623",
				"n": "甘德县",
				"pc": "632600"
			}, {
				"c": "632624",
				"n": "达日县",
				"pc": "632600"
			}, {
				"c": "632625",
				"n": "久治县",
				"pc": "632600"
			}, {
				"c": "632626",
				"n": "玛多县",
				"pc": "632600"
			}, {
				"c": "632700",
				"n": "玉树藏族自治州",
				"pc": "630000"
			}, {
				"c": "632721",
				"n": "玉树县",
				"pc": "632700"
			}, {
				"c": "632722",
				"n": "杂多县",
				"pc": "632700"
			}, {
				"c": "632723",
				"n": "称多县",
				"pc": "632700"
			}, {
				"c": "632724",
				"n": "治多县",
				"pc": "632700"
			}, {
				"c": "632725",
				"n": "囊谦县",
				"pc": "632700"
			}, {
				"c": "632726",
				"n": "曲麻莱县",
				"pc": "632700"
			}, {
				"c": "632800",
				"n": "海西蒙古族藏族自治州",
				"pc": "630000"
			}, {
				"c": "632801",
				"n": "格尔木市",
				"pc": "632800"
			}, {
				"c": "632802",
				"n": "德令哈市",
				"pc": "632800"
			}, {
				"c": "632821",
				"n": "乌兰县",
				"pc": "632800"
			}, {
				"c": "632822",
				"n": "都兰县",
				"pc": "632800"
			}, {
				"c": "632823",
				"n": "天峻县",
				"pc": "632800"
			}, {
				"c": "640000",
				"n": "宁夏回族自治区",
				"pc": "86"
			}, {
				"c": "640100",
				"n": "银川市",
				"pc": "640000"
			}, {
				"c": "640101",
				"n": "市辖区",
				"pc": "640100"
			}, {
				"c": "640104",
				"n": "兴庆区",
				"pc": "640100"
			}, {
				"c": "640105",
				"n": "西夏区",
				"pc": "640100"
			}, {
				"c": "640106",
				"n": "金凤区",
				"pc": "640100"
			}, {
				"c": "640121",
				"n": "永宁县",
				"pc": "640100"
			}, {
				"c": "640122",
				"n": "贺兰县",
				"pc": "640100"
			}, {
				"c": "640181",
				"n": "灵武市",
				"pc": "640100"
			}, {
				"c": "640200",
				"n": "石嘴山市",
				"pc": "640000"
			}, {
				"c": "640201",
				"n": "市辖区",
				"pc": "640200"
			}, {
				"c": "640202",
				"n": "大武口区",
				"pc": "640200"
			}, {
				"c": "640205",
				"n": "惠农区",
				"pc": "640200"
			}, {
				"c": "640221",
				"n": "平罗县",
				"pc": "640200"
			}, {
				"c": "640300",
				"n": "吴忠市",
				"pc": "640000"
			}, {
				"c": "640301",
				"n": "市辖区",
				"pc": "640300"
			}, {
				"c": "640302",
				"n": "利通区",
				"pc": "640300"
			}, {
				"c": "640303",
				"n": "红寺堡区",
				"pc": "640300"
			}, {
				"c": "640323",
				"n": "盐池县",
				"pc": "640300"
			}, {
				"c": "640324",
				"n": "同心县",
				"pc": "640300"
			}, {
				"c": "640381",
				"n": "青铜峡市",
				"pc": "640300"
			}, {
				"c": "640400",
				"n": "固原市",
				"pc": "640000"
			}, {
				"c": "640401",
				"n": "市辖区",
				"pc": "640400"
			}, {
				"c": "640402",
				"n": "原州区",
				"pc": "640400"
			}, {
				"c": "640422",
				"n": "西吉县",
				"pc": "640400"
			}, {
				"c": "640423",
				"n": "隆德县",
				"pc": "640400"
			}, {
				"c": "640424",
				"n": "泾源县",
				"pc": "640400"
			}, {
				"c": "640425",
				"n": "彭阳县",
				"pc": "640400"
			}, {
				"c": "640500",
				"n": "中卫市",
				"pc": "640000"
			}, {
				"c": "640501",
				"n": "市辖区",
				"pc": "640500"
			}, {
				"c": "640502",
				"n": "沙坡头区",
				"pc": "640500"
			}, {
				"c": "640521",
				"n": "中宁县",
				"pc": "640500"
			}, {
				"c": "640522",
				"n": "海原县",
				"pc": "640500"
			}, {
				"c": "650000",
				"n": "新疆维吾尔自治区",
				"pc": "86"
			}, {
				"c": "650100",
				"n": "乌鲁木齐市",
				"pc": "650000"
			}, {
				"c": "650101",
				"n": "市辖区",
				"pc": "650100"
			}, {
				"c": "650102",
				"n": "天山区",
				"pc": "650100"
			}, {
				"c": "650103",
				"n": "沙依巴克区",
				"pc": "650100"
			}, {
				"c": "650104",
				"n": "新市区",
				"pc": "650100"
			}, {
				"c": "650105",
				"n": "水磨沟区",
				"pc": "650100"
			}, {
				"c": "650106",
				"n": "头屯河区",
				"pc": "650100"
			}, {
				"c": "650107",
				"n": "达坂城区",
				"pc": "650100"
			}, {
				"c": "650109",
				"n": "米东区",
				"pc": "650100"
			}, {
				"c": "650121",
				"n": "乌鲁木齐县",
				"pc": "650100"
			}, {
				"c": "650200",
				"n": "克拉玛依市",
				"pc": "650000"
			}, {
				"c": "650201",
				"n": "市辖区",
				"pc": "650200"
			}, {
				"c": "650202",
				"n": "独山子区",
				"pc": "650200"
			}, {
				"c": "650203",
				"n": "克拉玛依区",
				"pc": "650200"
			}, {
				"c": "650204",
				"n": "白碱滩区",
				"pc": "650200"
			}, {
				"c": "650205",
				"n": "乌尔禾区",
				"pc": "650200"
			}, {
				"c": "652100",
				"n": "吐鲁番地区",
				"pc": "650000"
			}, {
				"c": "652101",
				"n": "吐鲁番市",
				"pc": "652100"
			}, {
				"c": "652122",
				"n": "鄯善县",
				"pc": "652100"
			}, {
				"c": "652123",
				"n": "托克逊县",
				"pc": "652100"
			}, {
				"c": "652200",
				"n": "哈密地区",
				"pc": "650000"
			}, {
				"c": "652201",
				"n": "哈密市",
				"pc": "652200"
			}, {
				"c": "652222",
				"n": "巴里坤哈萨克自治县",
				"pc": "652200"
			}, {
				"c": "652223",
				"n": "伊吾县",
				"pc": "652200"
			}, {
				"c": "652300",
				"n": "昌吉回族自治州",
				"pc": "650000"
			}, {
				"c": "652301",
				"n": "昌吉市",
				"pc": "652300"
			}, {
				"c": "652302",
				"n": "阜康市",
				"pc": "652300"
			}, {
				"c": "652323",
				"n": "呼图壁县",
				"pc": "652300"
			}, {
				"c": "652324",
				"n": "玛纳斯县",
				"pc": "652300"
			}, {
				"c": "652325",
				"n": "奇台县",
				"pc": "652300"
			}, {
				"c": "652327",
				"n": "吉木萨尔县",
				"pc": "652300"
			}, {
				"c": "652328",
				"n": "木垒哈萨克自治县",
				"pc": "652300"
			}, {
				"c": "652700",
				"n": "博尔塔拉蒙古自治州",
				"pc": "650000"
			}, {
				"c": "652701",
				"n": "博乐市",
				"pc": "652700"
			}, {
				"c": "652722",
				"n": "精河县",
				"pc": "652700"
			}, {
				"c": "652723",
				"n": "温泉县",
				"pc": "652700"
			}, {
				"c": "652800",
				"n": "巴音郭楞蒙古自治州",
				"pc": "650000"
			}, {
				"c": "652801",
				"n": "库尔勒市",
				"pc": "652800"
			}, {
				"c": "652822",
				"n": "轮台县",
				"pc": "652800"
			}, {
				"c": "652823",
				"n": "尉犁县",
				"pc": "652800"
			}, {
				"c": "652824",
				"n": "若羌县",
				"pc": "652800"
			}, {
				"c": "652825",
				"n": "且末县",
				"pc": "652800"
			}, {
				"c": "652826",
				"n": "焉耆回族自治县",
				"pc": "652800"
			}, {
				"c": "652827",
				"n": "和静县",
				"pc": "652800"
			}, {
				"c": "652828",
				"n": "和硕县",
				"pc": "652800"
			}, {
				"c": "652829",
				"n": "博湖县",
				"pc": "652800"
			}, {
				"c": "652900",
				"n": "阿克苏地区",
				"pc": "650000"
			}, {
				"c": "652901",
				"n": "阿克苏市",
				"pc": "652900"
			}, {
				"c": "652922",
				"n": "温宿县",
				"pc": "652900"
			}, {
				"c": "652923",
				"n": "库车县",
				"pc": "652900"
			}, {
				"c": "652924",
				"n": "沙雅县",
				"pc": "652900"
			}, {
				"c": "652925",
				"n": "新和县",
				"pc": "652900"
			}, {
				"c": "652926",
				"n": "拜城县",
				"pc": "652900"
			}, {
				"c": "652927",
				"n": "乌什县",
				"pc": "652900"
			}, {
				"c": "652928",
				"n": "阿瓦提县",
				"pc": "652900"
			}, {
				"c": "652929",
				"n": "柯坪县",
				"pc": "652900"
			}, {
				"c": "653000",
				"n": "克孜勒苏柯尔克孜自治州",
				"pc": "650000"
			}, {
				"c": "653001",
				"n": "阿图什市",
				"pc": "653000"
			}, {
				"c": "653022",
				"n": "阿克陶县",
				"pc": "653000"
			}, {
				"c": "653023",
				"n": "阿合奇县",
				"pc": "653000"
			}, {
				"c": "653024",
				"n": "乌恰县",
				"pc": "653000"
			}, {
				"c": "653100",
				"n": "喀什地区",
				"pc": "650000"
			}, {
				"c": "653101",
				"n": "喀什市",
				"pc": "653100"
			}, {
				"c": "653121",
				"n": "疏附县",
				"pc": "653100"
			}, {
				"c": "653122",
				"n": "疏勒县",
				"pc": "653100"
			}, {
				"c": "653123",
				"n": "英吉沙县",
				"pc": "653100"
			}, {
				"c": "653124",
				"n": "泽普县",
				"pc": "653100"
			}, {
				"c": "653125",
				"n": "莎车县",
				"pc": "653100"
			}, {
				"c": "653126",
				"n": "叶城县",
				"pc": "653100"
			}, {
				"c": "653127",
				"n": "麦盖提县",
				"pc": "653100"
			}, {
				"c": "653128",
				"n": "岳普湖县",
				"pc": "653100"
			}, {
				"c": "653129",
				"n": "伽师县",
				"pc": "653100"
			}, {
				"c": "653130",
				"n": "巴楚县",
				"pc": "653100"
			}, {
				"c": "653131",
				"n": "塔什库尔干塔吉克自治县",
				"pc": "653100"
			}, {
				"c": "653200",
				"n": "和田地区",
				"pc": "650000"
			}, {
				"c": "653201",
				"n": "和田市",
				"pc": "653200"
			}, {
				"c": "653221",
				"n": "和田县",
				"pc": "653200"
			}, {
				"c": "653222",
				"n": "墨玉县",
				"pc": "653200"
			}, {
				"c": "653223",
				"n": "皮山县",
				"pc": "653200"
			}, {
				"c": "653224",
				"n": "洛浦县",
				"pc": "653200"
			}, {
				"c": "653225",
				"n": "策勒县",
				"pc": "653200"
			}, {
				"c": "653226",
				"n": "于田县",
				"pc": "653200"
			}, {
				"c": "653227",
				"n": "民丰县",
				"pc": "653200"
			}, {
				"c": "654000",
				"n": "伊犁哈萨克自治州",
				"pc": "650000"
			}, {
				"c": "654002",
				"n": "伊宁市",
				"pc": "654000"
			}, {
				"c": "654003",
				"n": "奎屯市",
				"pc": "654000"
			}, {
				"c": "654021",
				"n": "伊宁县",
				"pc": "654000"
			}, {
				"c": "654022",
				"n": "察布查尔锡伯自治县",
				"pc": "654000"
			}, {
				"c": "654023",
				"n": "霍城县",
				"pc": "654000"
			}, {
				"c": "654024",
				"n": "巩留县",
				"pc": "654000"
			}, {
				"c": "654025",
				"n": "新源县",
				"pc": "654000"
			}, {
				"c": "654026",
				"n": "昭苏县",
				"pc": "654000"
			}, {
				"c": "654027",
				"n": "特克斯县",
				"pc": "654000"
			}, {
				"c": "654028",
				"n": "尼勒克县",
				"pc": "654000"
			}, {
				"c": "654200",
				"n": "塔城地区",
				"pc": "650000"
			}, {
				"c": "654201",
				"n": "塔城市",
				"pc": "654200"
			}, {
				"c": "654202",
				"n": "乌苏市",
				"pc": "654200"
			}, {
				"c": "654221",
				"n": "额敏县",
				"pc": "654200"
			}, {
				"c": "654223",
				"n": "沙湾县",
				"pc": "654200"
			}, {
				"c": "654224",
				"n": "托里县",
				"pc": "654200"
			}, {
				"c": "654225",
				"n": "裕民县",
				"pc": "654200"
			}, {
				"c": "654226",
				"n": "和布克赛尔蒙古自治县",
				"pc": "654200"
			}, {
				"c": "654300",
				"n": "阿勒泰地区",
				"pc": "650000"
			}, {
				"c": "654301",
				"n": "阿勒泰市",
				"pc": "654300"
			}, {
				"c": "654321",
				"n": "布尔津县",
				"pc": "654300"
			}, {
				"c": "654322",
				"n": "富蕴县",
				"pc": "654300"
			}, {
				"c": "654323",
				"n": "福海县",
				"pc": "654300"
			}, {
				"c": "654324",
				"n": "哈巴河县",
				"pc": "654300"
			}, {
				"c": "654325",
				"n": "青河县",
				"pc": "654300"
			}, {
				"c": "654326",
				"n": "吉木乃县",
				"pc": "654300"
			}, {
				"c": "659000",
				"n": "自治区直辖县级行政区划",
				"pc": "650000"
			}, {
				"c": "659001",
				"n": "石河子市",
				"pc": "659000"
			}, {
				"c": "659002",
				"n": "阿拉尔市",
				"pc": "659000"
			}, {
				"c": "659003",
				"n": "图木舒克市",
				"pc": "659000"
			}, {
				"c": "659004",
				"n": "五家渠市",
				"pc": "659000"
			}, {
				"c": "710000",
				"n": "台湾省",
				"pc": "86"
			}, {
				"c": "810000",
				"n": "香港特别行政区",
				"pc": "86"
			}, {
				"c": "820000",
				"n": "澳门特别行政区",
				"pc": "86"
			}];
			return regions;
		};
	})();
(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('regionBt', regionBt); 

    regionBt.$inject = ['RegionService'];
    function regionBt(RegionService) {
        var directive = {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                depends: '='
            },
            replace: true,
            template: '<select class="form-control" ng-options="o.c as o.n for o in options">' + //
            '            <option value="">请选择...</option>' + //
            '          </select>',
            link: function(scope, element, attrs, modelCtrl) {
                scope.$watch('depends', function(newVal, oldVal) {
                    if ('depends' in attrs) {
                        var parent = RegionService.get(scope.depends);
                        scope.options = [];
                        if (parent) {
                            scope.options = parent.children;
                        }
                        var oldModelValue = modelCtrl.$modelValue;
                        modelCtrl.$setViewValue();
                        for (var i = 0; i < scope.options.length; i++) {
                            var option = scope.options[i];
                            if (option.c === oldModelValue) {
                                modelCtrl.$setViewValue(oldModelValue);
                            }
                        }
                    } else {
                        scope.options = RegionService.getCountries();
                    }
                });
            }
        };
        return directive;
    }
})();
(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            // open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'MessageService'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, MessageService) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close(); 
                $state.go('store-user');

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent,
            availableLanguages:availableLanguages
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            // var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
            var language = "zh-cn";

            deferred.resolve(language);

            return deferred.promise;
        }

        function availableLanguages(){
            var languages = [
                {key: "简体中文", value: "zh-cn"},
                {key: "英文", value: "en"},
                // {key: "日文", value: "ja"},
                // {key: "韩文", value: "ko"},
                // {key: "德语", value: "Deutsch"},
            ];
            return languages
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'zh-cn'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('backApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('backApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('backApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('backApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('backApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $localStorage.user;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'zh-cn');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('zh-cn');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('back-');
        $sessionStorageProvider.setKeyPrefix('back-');
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        })
        .state('app2', {
            abstract: true,
            views: {
                'navbar2@': {
                    templateUrl: 'app/layouts/navbar/navbar_login.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('backApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1793867956143)
;
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance',  'User', 'JhiLanguageService', "Role"];

    function UserManagementDialogController ($stateParams, $uibModalInstance,  User, JhiLanguageService, Role) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = {};
        vm.roles = Role.query();
		vm.load = load;
		vm.load($stateParams.id);

        function load (id) {
            User.get({id: id,scope:'back'}, function(result) {
                vm.user = result;
            });
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User','$uibModalInstance'];

    function UserManagementDetailController ($stateParams, User, $uibModalInstance) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.clear = clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.load($stateParams.id);

        function load (id) {
            User.get({id: id,scope:'back'}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management?page&sort',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }]
                }
            }) 
            .state('user-management-detail', {
                parent: 'user-management',
                url: '/user/:id',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('user-management');
                                return $translate.refresh();
                            }]
                            // entity: ['AreaConfig', function(AreaConfig) {
                            //     return AreaConfig.get({id : $stateParams.id}).$promise;
                            // }]
                        }
                    }).result.then(function() {
                        $state.go('user-management', {}, { reload: false });
                    }, function() {
                        $state.go('user-management');
                    });
                }]
            })
            .state('user-management.new', {
                parent: 'user-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    id: null,
                                    login: null,
                                    firstName: null,
                                    lastName: null,
                                    email: null,
                                    activated: true,
                                    langKey: null,
                                    createdBy: null,
                                    createdDate: null,
                                    lastModifiedBy: null,
                                    lastModifiedDate: null,
                                    resetDate: null,
                                    resetKey: null,
                                    authorities: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('user-management', null, {
                            reload: true
                        });
                    }, function() {
                        $state.go('user-management');
                    });
                }]
            })
            .state('user-management.edit', {
                parent: 'user-management',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        /*resolve: {
                            entity: ['User', function(User) {
                                return User.get({
                                    id: $stateParams.id
                                });
                            }]
                        }*/
                    }).result.then(function() {
                        $state.go('user-management', null, {
                            reload: true
                        });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('user-management.delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function(User) {
                                return User.get({
                                    login: $stateParams.login
                                });
                            }]
                        }
                    }).result.then(function() {
                        $state.go('user-management', null, {
                            reload: true
                        });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }); 
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', '$scope', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'MessageService', 'Accounts'];

    function UserManagementController(Principal, $scope, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, MessageService, Accounts) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.shrink = shrink;
        vm.titleNavbar = titleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;


        loadAll();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });


        $scope.resetPasswords = function (id) {
            MessageService.confirm("global.action.reset", function () {
                Accounts.get({id: id}, function (msg) {
                    AlertService.success("password.messages.resetSuccess");
                })
            }, function () {
            }, true);

        };

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function shrink() {
            vm.isNavbarCollapsed = true;
        }

        function titleNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function loadAll() {
            if (pagingParams.search) {
                User.byCondition({
                    items: [{
                        key: "login",
                        op: "like",
                        value: pagingParams.search
                    }, {
                        key: "scope",
                        op: "=",
                        value: "back"
                    }],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                User.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    items: [{
                        key: "scope",
                        op: "=",
                        value: "back"
                    }],
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $scope.delete = function (id) {
            MessageService.confirm("global.action.delete", function () {
                User.delete({
                    id: id
                }, function () {
                    loadAll();
                });
            }, function () {
            }, true);
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('backApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/gateway',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', '$uibModalInstance'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate, $uibModalInstance) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('RegisterInfoController', RegisterInfoController);


    RegisterInfoController.$inject = ['$uibModalInstance'];

    function RegisterInfoController($uibModalInstance) {
        var vm = this;

        vm.save = save;
        vm.clear = clear;

        function save() {
            $uibModalInstance.close(true);
        }

        function clear() {
            $uibModalInstance.close(false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('register', {
                parent: 'app2',
                url: '/register',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/account/register/register.html',
                        controller: 'RegisterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('register_info', {
                parent: 'register',
                url: '/register_info',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/account/register/register_info.html',
                        controller: 'RegisterInfoController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('register');
                                $translatePartialLoader.addPart('store');
                                $translatePartialLoader.addPart('storeType');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('register', {}, { reload: false });
                    }, function() {
                        $state.go('register');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'UidService', 'StoreUser', 'Qinius', 'Store', '$scope', '$state', 'MessageService', 'VerifyCode',
        '$q', '$interval', '$uibModal'];

    function RegisterController($translate, $timeout, UidService, StoreUser, Qinius, Store, $scope, $state, MessageService, VerifyCode,
                                $q, $interval, $uibModal) {
        var vm = this;

        vm.domains = Qinius.getDomain();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.doNotMatch = null;
        vm.register = register;
        vm.save = save;
        vm.store = {};
        vm.store.storeType = "Company";
        vm.store.incident = "新用户注册";
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        $(".wrap").hide();
        vm.step = 1;
        vm.agree = false;
        vm.eye = true;

        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        })

        vm.datePickerOpenStatus.durationOfOperationTo = false;

        $scope.selectType = function (type) {
            vm.store.storeType = type;
        }

        $timeout(function () {
            angular.element('#name').focus();
        });

        var createModal = function (url, controller) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };

        //用户协议
        $scope.tempInfo = function (temp) {
            createModal('app/account/register/register_info.html', 'RegisterInfoController').result.then(
                function (data) {
                    if(data){
                        vm.agree = true;
                    }else {
                        vm.agree = false;
                    }
                });
        };

        $scope.toPostStoreData = function () {
            var data = {};
            data.storeName = vm.store.name;
            data.storeType = vm.store.storeType;
            data.idCard = vm.store.idCard;
            data.companyName = vm.store.companyName;
            data.companyCode = vm.store.companyCode;
            data.corporation = vm.store.corporation;
            data.contact = vm.store.contact;
            data.phone = vm.store.phone;
            data.email = vm.store.email;
            data.address = vm.store.address;
            data.userName = vm.store.userName;
            data.password = vm.store.password;
            data.roleId = '2';
            data.activated = 0;
            data.langKey = vm.store.langKey;
            return data;
        }

        $scope.toPostStoreUserData = function () {
            var data = {};
            data.name = vm.store.userName;
            data.password = vm.store.password;
            data.roleId = '2';
            data.activated = 0;
            data.langKey = vm.store.langKey;
            return data;
        }

        $scope.validate = function () {
            if (vm.store.name == null || vm.store.name == "") {
                MessageService.error("请输入商店名称");
                return false;
            }
            ;

            if (vm.store.storeType == null || vm.store.storeType == "") {
                MessageService.error("请选择注册者主体类型");
            }
            ;
            return true;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function register() {
            if (vm.store.phone == null || vm.store.phone == '') {
                MessageService.error("请输入正确的手机号码");
                return
            }
            if (vm.store.verifyCode == null || vm.store.verifyCode == '') {
                MessageService.error("请输入正确的验证码");
                return
            }

            if (vm.store.password !== vm.confirmPassword) {
                MessageService.error("两次密码输入不一致。");
                return
            }

            VerifyCode.check({
                phone: vm.store.phone,
                code: vm.store.verifyCode,
            }, function (msg) {
                if (msg.status == 200 && msg.data == true) {
                    vm.store.langKey = $translate.use();
                    vm.doNotMatch = null;
                    StoreUser.checkUser({
                        items: [{key: "name", op: "=", value: vm.store.userName}]
                    }, function (data) {
                        if (data.length > 0) {
                            MessageService.error("该账号已经存在，请选择其他用户名");
                        } else {
                            // 进入实名认证
                            vm.step = 2;
                        }
                    }, function () {
                        MessageService.error("校验用户名时出错");
                    });
                } else {
                    MessageService.error("验证码输入有误");
                }
            }, function () {
                MessageService.error("验证码输入有误");
            });
        }


        $scope.paracont = "获取验证码";
        vm.disabled = false;
        //验证码的定时器
        var timer = null;
        $scope.getVerifyCode = function () {
            if (vm.store.phone == null || vm.store.phone == "") {
                MessageService.error("请先输入手机号码");
                return;
            }
            if (vm.disabled) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            VerifyCode.getVerifyCode2({
                phone: vm.store.phone,
                incident: "新用户注册"
            }, function (res) {
                if(res.status ==200){
                    clearInterval(timer);
                    timer = $interval(function () {
                        if (vm.countdown > 0) {
                            vm.disabled = true;
                            vm.countdown--;
                            $scope.paracont = "重新发送(" + vm.countdown + ")";
                        } else {
                            vm.disabled = false;
                            $interval.cancel(timer);
                            $scope.paracont = "重发验证码";
                        }
                    }, 1000);
                }else{
                    MessageService.error(res.messages);
                }
            });
        };

        $scope.validatePerson = function () {
            if (vm.store.corporation == null || vm.store.corporation == "") {
                MessageService.error("请输入注册姓名");
                return false;
            }

            if (vm.store.idCard == null || vm.store.idCard == "") {
                MessageService.error("请输入证件号码");
                return false;
            }
            if (vm.store.corporationCardFront == null || vm.store.corporationCardFront == "") {
                MessageService.error("请上传证件正面照");
                return false;
            }
            if (vm.store.corporationCardBack == null || vm.store.corporationCardBack == "") {
                MessageService.error("证件反面照");
                return false;
            }

            return true;
        };

        $scope.validateCompany = function () {
            console.log(vm.store)
            if (vm.store.companyName == null || vm.store.companyName == "") {
                MessageService.error("请输入公司名称");
                return false;
            }

            if (vm.store.contact == null || vm.store.contact == "") {
                MessageService.error("请输入联系人信息");
                return false;
            }

            if (vm.store.contact.length==1) {
                MessageService.error("请输入正确的联系人信息");
                return false;
            }

            if (vm.store.address == null || vm.store.address == "") {
                MessageService.error("请输入地址信息");
                return false;
            }

            if (vm.store.corporation == null || vm.store.corporation == "") {
                MessageService.error("请输入法人代表姓名");
                return false;
            }

            if (vm.store.corporation.length==1) {
                MessageService.error("请输入正确的法人代表姓名");
                return false;
            }

            if (vm.store.corporationCardFront == null || vm.store.corporationCardFront == "") {
                MessageService.error("请上传证件正面照");
                return false;
            }
            if (vm.store.corporationCardBack == null || vm.store.corporationCardBack == "") {
                MessageService.error("证件反面照");
                return false;
            }

            if (vm.store.companyCode == null || vm.store.companyCode == "") {
                MessageService.error("请输入企业营业执照编号");
                return false;
            }

            if (vm.store.businessLicenseImg == null || vm.store.businessLicenseImg == "") {
                MessageService.error("请上传营业执照");
                return false;
            }

            return true;
        };

        function save() {
            if (vm.store.storeType == 'Company') {
                if (!$scope.validateCompany()) {
                    return;
                }
                vm.store.idCard = null;
            } else {
                if (!$scope.validatePerson()) {
                    return;
                }
                vm.store.companyName = null;
                vm.store.contact = null;
                vm.store.address = null;
                vm.store.companyCode = null;
                vm.store.businessLicenseImg = null;
            }
            vm.store.roleId = '2';
            vm.store.activated = 0;
            // $scope.toPostStoreData()
            Store.create(vm.store, function (response) {
                console.log(response)
                MessageService.success("注册成功，请在审核通过后登录。");
                $state.go('home');
            }, function (response) {
                MessageService.error(response.data.message);
            });

        }

        window.updateImgFile = function ($event,attr) {
            console.log(attr);
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0],attr);
            }
        }

        function qiniuUpload(file,attr) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "register-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.store[attr] = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }

        //remove背景图
        $scope.removeFile = function(attr) {
            vm.store[attr] = null;
        };

        $scope.agreeRegister = function () {
            vm.agree=!vm.agree;
        }


        $scope.showOrHidePassword = function () {
            vm.eye=!vm.eye;
            if(!vm.eye){
                $(".input-password").attr("type", "text");
            }else{
                $(".input-password").attr("type", "password");
            }

        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('backApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
         
    }
})();

(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$uibModalInstance', 'AccountP', '$scope', 'MessageService', '$timeout', '$state'];

    function PasswordController(Auth, Principal, $uibModalInstance, AccountP, $scope, MessageService, $timeout, $state) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.clear = clear;
        vm.check = {};
        vm.check.old = 0;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        $scope.checkOldPassword = function () {
            AccountP.checkPassword({id: vm.account.id, password: vm.oldPassword}, function (msg) {
                if (msg.status == 200 && msg.data) {
                    vm.check.old = 1;
                    return
                }
                vm.check.old = 0;
                $(".yzmStatus i:eq(1)").show();
            })
        };

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                var user = {
                    name: vm.account.name,
                    password: vm.password,
                    oldPassword:vm.oldPassword
                };
                vm.doNotMatch = null;
                Auth.changePassword(user).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    $timeout(function () {
                        $uibModalInstance.close();
                        $state.go('home');
                    }, 1000);
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
            var t1 = setInterval(function () {
                $uibModalInstance.close(true);
                window.clearTimeout(t1);
            }, 2000);

        } 
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('backApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div class="login_bgi login_bgi2 text-center1" style="top:0"><div><div class="login-logo"><img src="content/images/login_logo_text.png" style="width: 100%"></div><div class="login_div"><div class="col-md-12 login-title" style="margin-bottom: 30px">\u767B\u5F55</div><div class="login_div_xz" style="margin-bottom: 30px"><span class="c-login-form-view-span">\u8BF7\u9009\u62E9\u767B\u5F55\u65B9\u5F0F\uFF1A</span><ul class="c-login-form-view-tab"><li ng-class="{onleft:tab==true}" class="tab-left" ng-click="func(1)">\u7528\u6237\u540D</li><li ng-class="{onright:tab==false}" class="tab-right" ng-click="func(2)">\u624B\u673A\u53F7</li></ul></div><div class="col-md-12 pad-lr-80"><form class="form" role="form" ng-submit="vm.login($event)"><div ng-show="tab"><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label">\u8D26\u53F7</label><div class="login-input"><input type="text" id="username" name="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div></div></div><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label">\u5BC6\u7801</label><div class="login-input"><input type="password" id="password" name="password" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-model="vm.password"></div></div></div></div><div ng-show="!tab"><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label">\u624B\u673A\u53F7</label><div class="login-input"><input type="text" id="phoneNumber" name="phoneNumber" placeholder="\u60A8\u7684\u624B\u673A\u53F7" ng-model="vm.phoneNumber"></div></div></div><div class="col-lg-12 col-sm-12 form-group pad-0" style="margin-bottom:0"><div class="form-group text-left"><label class="login-label">\u5BC6\u7801</label><div class="login-input"><input type="password" id="password2" name="password2" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-model="vm.password2"></div></div></div></div><div class="col-lg-12 col-sm-12 form-group mar-top-30 pad-0"><div class="form-group"><div class="col-md-12 col-sm-12 col-xs-12 pad-0"><button type="submit" class="col-md-12 col-sm-12 col-xs-12 big-btn-normal pad-0" translate="global.form.button">Sign in</button></div></div></div><div class="col-lg-12 col-sm-12 form-group current-menu mar-top-6"><div class="form-group"><a ui-sref="register" class="login-label font-14">\u7ACB\u5373\u6CE8\u518C</a></div></div><div class="col-lg-12 col-sm-12 col-xm-12 form-group current-menu" style="margin-top:0px"><span class="login-label"><a href="https://beian.miit.gov.cn" target="_blank">\u6CAAICP\u590718030315\u53F7-9</a></span><br><span class="login-label">Powered By MomentsGo</span></div><div class="col-lg-12 col-sm-12 col-xm-12 form-group current-menu font-12"><span></span></div></form></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row row-registers"><div class="registers"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h2 data-translate="password.title" class="register-title"></h2></div><div class="col-md-8 col-md-offset-2 register-body" style="margin-top: 10px"><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group" style="position: relative"><label class="control-label" for="oldPassword" data-translate="global.form.oldPassword">old password</label><input type="password" class="form-control" id="oldPassword" name="oldPassword" placeholder="{{\'global.form.oldPassword.placeholder\' | translate}}" ng-model="vm.oldPassword" required ng-keyup="checkOldPassword()"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p></div><div class="yzmStatus"><i ng-show="vm.check.old==1"></i> <i ng-show="vm.check.old==0"></i></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="5" ng-maxlength="50" required ng-disabled="vm.check.old!=1" ng-style="{cursor:(vm.check.old!=1)?\'not-allowed\':\'text\'}"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="5" ng-maxlength="50" required ng-disabled="vm.check.old!=1" ng-style="{cursor:(vm.check.old!=1)?\'not-allowed\':\'text\'}"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div style="padding-bottom: 20px"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-save" data-translate="password.form.button">Save</button></div></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div class="login_bgi text-center1"><div class="login-logo"><img src="content/images/login_logo_text.png" style="width: 100%"></div><h4 class="register-head">\u65B0\u7528\u6237\u6CE8\u518C</h4><div class=""><img src="content/images/registrationActive.png" ng-show="vm.step==1" height="41px"> <img src="content/images/autonym.png" ng-show="vm.step==1" height="41px"> <img src="content/images/registration.png" ng-show="vm.step==2" height="41px"> <img src="content/images/autonym-active.png" ng-show="vm.step==2" height="41px"></div><div class="register-body"><!--        <img src="content/images/login_bg2.png" class="register-bg-fixed">--><div class="col-lg-12 col-md-12 col-sm-12 pad-0"><div class="register-body-con" ng-style="{\'padding\':vm.step==1?\'30px 80px\':\'30px 20px\'}"><!--\u6CE8\u518C\u8D26\u53F7--><div class="col-lg-12 col-sm-12 col-xm-12 text-center" ng-if="vm.step==1"><!--\u624B\u673A\u53F7\u7801--><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.phone">phone</label><div class="login-input"><input type="text" name="phone" id="phone" placeholder="{{\'global.form.phone.placeholder\' | translate}}" ng-model="vm.store.phone" ng-pattern="/^1[345789]\\d{9}$/" required><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required" data-translate="global.messages.validate.phone.required">Your phone is required.</p><p class="help-block" ng-show="form.phone.$error.pattern" data-translate="global.messages.validate.phone.invalid">Your phone is invalid.</p></div></div></div></div><!--\u9A8C\u8BC1\u7801--><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.verifyCode">verifyCode</label><div class="login-input position-relative"><input type="text" name="verifyCode" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801" ng-model="vm.store.verifyCode" required> <button class="login-input-btn" ng-disabled="vm.disabled" ng-click="getVerifyCode()" ng-bind="paracont">\u83B7\u53D6\u9A8C\u8BC1\u7801</button></div></div></div><!--\u7528\u6237\u540D--><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label" translate="global.form.username2">username</label><div class="login-input"><input type="text" id="userName" name="userName" placeholder="\u8BF7\u8F93\u5165\u7528\u6237\u540D" ng-model="vm.store.userName" ng-minlength="1" maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.username.$dirty && form.username.$invalid"><p class="help-block" ng-show="form.username.$error.required" data-translate="register.messages.validate.username.required">Your username is required.</p><p class="help-block" ng-show="form.username.$error.minlength" data-translate="register.messages.validate.username.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.username.$error.maxlength" data-translate="register.messages.validate.username.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.username.$error.pattern" data-translate="register.messages.validate.username.pattern">Your username can only contain lower-case letters and digits.</p></div></div></div></div><!--\u5BC6\u7801--><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label">\u5BC6\u7801</label><div class="login-input"><input type="password" id="password" name="password" placeholder="\u8BF7\u8F93\u5165\u5BC6\u7801" class="input-password" ng-model="vm.store.password" ng-minlength="5" maxlength="50" required> <img src="content/images/zk.png" ng-click="showOrHidePassword()" class="password-eye" ng-if="vm.eye"> <img src="content/images/zb.png" ng-click="showOrHidePassword()" class="password-eye-close" ng-if="!vm.eye"> <i class="fa fa-eye-slash"></i><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div></div></div><!--\u91CD\u590D\u5BC6\u7801--><div class="col-lg-12 col-sm-12 form-group pad-0"><div class="form-group text-left"><label class="login-label">\u518D\u6B21\u8F93\u5165\u5BC6\u7801</label><div class="login-input"><input type="password" id="confirmPassword" name="confirmPassword" placeholder="\u8BF7\u518D\u6B21\u8F93\u5165\u5BC6\u7801" class="input-password" ng-model="vm.confirmPassword" ng-minlength="5" maxlength="50" required> <img src="content/images/zk.png" ng-click="showOrHidePassword()" class="password-eye" ng-if="vm.eye"> <img src="content/images/zb.png" ng-click="showOrHidePassword()" class="password-eye-close" ng-if="!vm.eye"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div></div><!--\u7528\u6237\u534F\u8BAE--><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><span class="cursor-pointer" ng-click="agreeRegister()"><img src="content/images/select.png" width="15" ng-if="!vm.agree"> <img src="content/images/selected.png" width="15" ng-if="vm.agree"> </span><span class="register-temp">\u6211\u540C\u610F\u5E76\u9075\u5FAA<span class="register-protocol" ng-click="tempInfo()">\u300A\u7528\u6237\u534F\u8BAE\u300B</span></span></div></div><!--\u4E0B\u4E00\u6B65\uFF0C\u5B9E\u540D\u8BA4\u8BC1\u6309\u94AE--><div class="col-lg-12 col-sm-12 form-group current-menu mar-top-6"><div class="form-group"><button type="submit" class="col-md-12 col-sm-12 col-xs-12 big-btn-normal pad-0" ng-disabled="!vm.agree" ng-class="{\'opacity-half\':!vm.agree}" ng-click="vm.register()">\u4E0B\u4E00\u6B65\uFF0C\u5B9E\u540D\u8BA4\u8BC1</button></div></div></div><!--\u5B9E\u540D\u8BA4\u8BC1--><div class="col-lg-12 col-sm-12 col-xs-12 text-center" ng-if="vm.step==2"><!--\u8BA4\u8BC1\u7C7B\u578B--><div class="col-lg-6 col-sm-6 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.storeType">storeType</label><div><button ng-class="{\'border-style1\':vm.store.storeType == \'Company\',\'border-style2\':vm.store.storeType != \'Company\'}" ng-click="selectType(\'Company\')" class="width-80">\u4F01\u4E1A</button></div></div></div><!--\u4F01\u4E1A \u8BA4\u8BC1--><!--                    <div ng-if="vm.store.storeType == \'Company\' ">--><!--\u516C\u53F8\u540D\u79F0--><div class="col-lg-6 col-sm-6 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.companyName" for="companyName">companyName</label><div class="login-input mar-top-10"><input type="text" name="companyName" id="companyName" placeholder="{{\'global.form.companyName.placeholder\' | translate}}" ng-model="vm.store.companyName" required maxlength="18/"><div ng-show="form.companyName.$dirty && form.companyName.$invalid"><p class="help-block" ng-show="form.companyName.$error.required" data-translate="global.messages.validate.companyName.required">Your companyName is required.</p><p class="help-block" ng-show="form.companyName.$error.maxlength" data-translate="global.messages.validate.maxlength18">this cannot be longer than 18 characters.</p></div></div></div></div><!--\u8054\u7CFB\u4EBA--><div class="col-lg-6 col-sm-6 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.contact">contact</label><div class="login-input mar-top-10"><input type="text" name="contact" id="contact" placeholder="{{\'global.form.contact.placeholder\' | translate}}" ng-model="vm.store.contact" ng-minlength="1" maxlength="100" required><div ng-show="form.contact.$dirty && form.contact.$invalid"><p class="help-block" ng-show="form.contact.$error.required" data-translate="global.messages.validate.contact.required">Your contact is required.</p><p class="help-block" ng-show="form.contact.$error.minlength" data-translate="global.messages.validate.minlength2">this is required to be at least 4 characters.</p><p class="help-block" ng-show="form.contact.$error.maxlength" data-translate="global.messages.validate.maxlength16">this cannot be longer than 18 characters.</p></div></div></div></div><!--\u6CD5\u4EBA\u4EE3\u8868\u59D3\u540D--><div class="col-lg-6 col-sm-6 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.idName">idName</label><div class="login-input mar-top-10"><input type="text" name="corporation" id="corporation" placeholder="\u8BF7\u8F93\u5165\u6CD5\u4EBA\u4EE3\u8868\u59D3\u540D" ng-model="vm.store.corporation" minlength="1" maxlength="100" required><div ng-show="form.corporation.$dirty && form.corporation.$invalid"><p class="help-block" ng-show="form.corporation.$error.required" data-translate="global.messages.validate.name.required">Your name is required.</p><p class="help-block" ng-show="form.name.$error.minlength" data-translate="global.messages.validate.name.minlength">Your name is required to be at least 2 characters.</p><p class="help-block" ng-show="form.name.$error.maxlength" data-translate="global.messages.validate.name.maxlength">Your name cannot be longer than 100 characters.</p></div></div></div></div><!--\u516C\u53F8\u5730\u5740--><div class="col-lg-12 col-sm-12 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.address">address</label><div class="login-input"><input type="text" name="address" id="address" placeholder="{{\'global.form.address.placeholder\' | translate}}" ng-model="vm.store.address" required maxlength="100/"><div ng-show="form.address.$dirty && form.address.$invalid"><p class="help-block" ng-show="form.address.$error.required" data-translate="global.messages.validate.address.required">Your address is required.</p><p class="help-block" ng-show="form.address.$error.maxlength" data-translate="global.messages.validate.maxlength100">this cannot be longer than 18 characters.</p></div></div></div></div><div class="col-lg-6 col-sm-6 form-group pad-left-0"><!--\u6CD5\u4EBA\u8BC1\u4EF6\u6B63\u9762\u7167--><div class="col-lg-6 col-sm-6 pad-left-0"><div class="form-group text-left"><label class="login-label" data-translate="backApp.store.frontPhoto">frontPhoto</label><div class="login-input mar-top-10"><div class="cursorPointer position-relative" ng-if="!vm.store.corporationCardFront"><input type="file" name="file" style="width: 100%;height: 100%" class="filePrew" accept=".jpg" onchange="updateImgFile(event,\'corporationCardFront\')" ng-model-options="{debounce : 500}"> <img src="content/images/front.png"></div><span ng-if="vm.store.corporationCardFront"><img class="picture-border" ng-src="{{domain + vm.store.corporationCardFront}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'corporationCardFront\')" style="color: red"></i></span></div></div></div><!--\u6CD5\u4EBA\u8BC1\u4EF6\u53CD\u9762\u7167--><div class="col-lg-6 col-sm-6 pad-left-0"><div class="form-group text-left"><label class="login-label" data-translate="backApp.store.backPhoto">backPhoto</label><div class="login-input mar-top-10"><div class="cursorPointer position-relative" ng-if="!vm.store.corporationCardBack"><input type="file" name="file" style="width: 100%;height: 100%" class="filePrew" accept=".jpg" onchange="updateImgFile(event,\'corporationCardBack\')" ng-model-options="{debounce : 500}"> <img src="content/images/opposite.png"></div><span ng-if="vm.store.corporationCardBack"><img class="picture-border" ng-src="{{domain + vm.store.corporationCardBack}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'corporationCardBack\')" style="color: red"></i></span></div></div></div></div><div class="col-lg-6 col-sm-6 form-group pad-left-0" style="height: 130px"></div><!--\u4F01\u4E1A\u8425\u4E1A\u6267\u7167\u7F16\u53F7--><div class="col-lg-6 col-sm-6 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.businessLicenseiD">businessLicenseiD</label><div class="login-input mar-top-10"><input type="text" id="businessLicenseiD" name="businessLicenseiD" placeholder="\u8BF7\u8F93\u5165\u4F01\u4E1A\u8425\u4E1A\u6267\u7167\u7F16\u53F7" ng-model="vm.store.companyCode" ng-minlength="5" maxlength="50" required></div></div></div><!--\u4F01\u4E1A\u8425\u4E1A\u6267\u7167--><div class="col-lg-6 col-sm-6 form-group pad-left-0"><div class="form-group text-left"><label class="login-label" translate="backApp.store.businessLicense">businessLicense</label><div class="login-input mar-top-10"><div ng-if="!vm.store.businessLicenseImg" class="position-relative"><input type="file" name="file" class="filePrew" accept=".jpg" onchange="updateImgFile(event,\'businessLicenseImg\')" ng-model-options="{debounce : 500}"> <img src="content/images/zc.png"><a class="register-body-con-upload">\u70B9\u51FB\u4E0A\u4F20</a></div><span ng-if="vm.store.businessLicenseImg"><img class="picture-border" ng-src="{{domain + vm.store.businessLicenseImg}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'businessLicenseImg\')" style="color: red"></i></span></div></div></div><!--                    </div>--><!--\u63D0\u4EA4\u6CE8\u518C\u6309\u94AE--><div class="col-lg-12 col-sm-12 form-group mar-top-30 pad-0"><div class="form-group"><div class="col-md-12 col-sm-12 col-xs-12 pad-0"><button type="submit" class="col-md-12 col-sm-12 col-xs-12 big-btn-normal pad-0" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()">\u63D0\u4EA4\u6CE8\u518C</button></div></div></div><!--                    <div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 mar-top-30">--><!--                        <div class="form-group">--><!--                            <span class="col-lg-4 col-sm-4 col-xs-4 text-right pad-0"--><!--                                  style="height: 38px;line-height: 38px;"></span>--><!--                            <div class="col-lg-6 col-sm-6 col-xs-6">--><!--                                <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving"--><!--                                        ng-click="vm.save()"--><!--                                        class="register-save1">--><!--                                    <span>\u63D0\u4EA4\u6CE8\u518C</span>--><!--                                </button>--><!--                            </div>--><!--                        </div>--><!--                    </div>--></div></div></div></div><div class="register-foot col-lg-12 col-sm-12">\u5DF2\u6709\u8D26\u53F7\uFF0C<span ui-sref="home">\u53BB\u767B\u5F55</span></div></div>');
$templateCache.put('app/account/register/register_info.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listCreate pad-0" style="margin-top: -120px"><div class="scrollbar register-info"><div class="register-info-title"><button type="button" class="pad-5 close mar-top-15" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div>\u7528\u6237\u534F\u8BAE</div></div><div class="modal-body" style="margin: 30px 0 100px"><div class="help-main"><div class="help-box"><h2>\u6749\u5353\u79D1\u6280\u7528\u6237\u6CE8\u518C\u534F\u8BAE</h2><div class="help-time">\u66F4\u65B0\u65F6\u95F4 : 2019-08-08 00:00:00</div><div class="help-text">\u4E3A\u4F7F\u7528\u6749\u5353\u79D1\u6280\u8F6F\u4EF6\u670D\u52A1\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u670D\u52A1\u201D\uFF09\uFF0C\u60A8\u5E94\u5F53\u9605\u8BFB\u5E76\u9075\u5B88\u300A\u6749\u5353\u79D1\u6280\u8F6F\u4EF6\u6CE8\u518C\u534F\u8BAE\u300B\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u534F\u8BAE\u201D\uFF09\u4EE5\u53CA\u4E13\u9879\u89C4\u5219\u7B49\u3002\u8BF7\u60A8\u52A1\u5FC5\u5BA1\u614E\u9605\u8BFB\u3001\u5145\u5206\u7406\u89E3\u5404\u6761\u6B3E\u5185\u5BB9\uFF0C\u7279\u522B\u662F\u514D\u9664\u6216\u9650\u5236\u8D23\u4EFB\u7684\u76F8\u5E94\u6761\u6B3E\uFF0C\u4EE5\u53CA\u5F00\u901A\u6216\u4F7F\u7528\u67D0\u9879\u670D\u52A1\u7684\u5355\u72EC\u534F\u8BAE\uFF0C\u5E76\u9009\u62E9\u63A5\u53D7\u6216\u4E0D\u63A5\u53D7\u3002\u9650\u5236\u3001\u514D\u8D23\u6761\u6B3E\u53EF\u80FD\u4EE5\u52A0\u7C97\u5F62\u5F0F\u63D0\u793A\u60A8\u6CE8\u610F\u3002</div><div class="help-text">\u9664\u975E\u60A8\u5DF2\u9605\u8BFB\u5E76\u63A5\u53D7\u672C\u534F\u8BAE\u6240\u6709\u6761\u6B3E\uFF0C\u5426\u5219\u60A8\u65E0\u6743\u4F7F\u7528\u6749\u5353\u79D1\u6280\u8F6F\u4EF6\u670D\u52A1\u3002\u60A8\u5BF9\u672C\u670D\u52A1\u7684\u767B\u5F55\u3001\u67E5\u770B\u3001\u7ED1\u5B9A\u516C\u4F17\u53F7\u3001\u586B\u5199\u4FE1\u606F\u7B49\u884C\u4E3A\u5373\u89C6\u4E3A\u60A8\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u672C\u534F\u8BAE\u7684\u7EA6\u675F\u3002</div><div class="help-text">\u5982\u679C\u60A8\u672A\u6EE118\u5468\u5C81\uFF0C\u8BF7\u5728\u6CD5\u5B9A\u76D1\u62A4\u4EBA\u7684\u966A\u540C\u4E0B\u9605\u8BFB\u672C\u534F\u8BAE\u53CA\u5176\u4ED6\u4E0A\u8FF0\u534F\u8BAE\u3002</div><div class="help-text">\u672C\u534F\u8BAE\u53EF\u6749\u5353\u79D1\u6280\u968F\u65F6\u66F4\u65B0\uFF0C\u66F4\u65B0\u540E\u7684\u534F\u8BAE\u6761\u6B3E\u4E00\u65E6\u516C\u5E03\u5373\u4EE3\u66FF\u539F\u6765\u7684\u534F\u8BAE\u6761\u6B3E\uFF0C\u6055\u4E0D\u518D\u53E6\u884C\u901A\u77E5\uFF0C\u60A8\u53EF\u5728\u672C\u7F51\u7AD9\u4E2D\u67E5\u9605\u6700\u65B0\u7248\u534F\u8BAE\u6761\u6B3E\u3002\u5728\u4FEE\u6539\u534F\u8BAE\u6761\u6B3E\u540E\uFF0C\u5982\u679C\u60A8\u4E0D\u63A5\u53D7\u4FEE\u6539\u540E\u7684\u6761\u6B3E\uFF0C\u8BF7\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6749\u5353\u79D1\u6280\u63D0\u4F9B\u7684\u670D\u52A1\uFF0C\u60A8\u7EE7\u7EED\u4F7F\u7528\u6749\u5353\u79D1\u6280\u63D0\u4F9B\u7684\u670D\u52A1\u5C06\u88AB\u89C6\u4E3A\u63A5\u53D7\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u3002</div><h3 class="help-tit01">\u4E00\u3001\u534F\u8BAE\u7684\u8303\u56F4</h3><div class="help-listq"><h4 class="help-tit02">1. \u672C\u534F\u8BAE\u662F\u60A8\u4E0E\u6749\u5353\u79D1\u6280\u4E4B\u95F4\u5173\u4E8E\u60A8\u4F7F\u7528\u6749\u5353\u79D1\u6280\u8F6F\u4EF6\u670D\u52A1\u6240\u8BA2\u7ACB\u7684\u534F\u8BAE\u3002\u201C\u6749\u5353\u79D1\u6280\u201D\u662F\u6307\u4E0A\u6D77\u6749\u5353\u79D1\u6280\u4F01\u4E1A\u53D1\u5C55\u6709\u9650\u516C\u53F8\u53CA\u5176\u76F8\u5173\u670D\u52A1\u53EF\u80FD\u5B58\u5728\u7684\u8FD0\u8425\u5173\u8054\u5355\u4F4D\u3002\u201C\u7528\u6237\u201D\u662F\u6307\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u6749\u5353\u79D1\u6280\u8F6F\u4EF6\u7684\u4E2A\u4EBA\u6216\u7EC4\u7EC7\uFF0C\u5728\u672C\u534F\u8BAE\u4E2D\u66F4\u591A\u5730\u79F0\u4E3A\u201C\u60A8\u201D\u3002</h4><h4 class="help-tit02">2. \u672C\u534F\u8BAE\u7684\u5185\u5BB9\u5305\u62EC\u4EE5\u4E0B\u6761\u6B3E\u53CA\u6749\u5353\u79D1\u6280\u5DF2\u7ECF\u53D1\u5E03\u7684\u6216\u5C06\u6765\u53EF\u80FD\u53D1\u5E03\u7684\u5404\u9879\u89C4\u5219\uFF0C\u6240\u6709\u89C4\u5219\u4E3A\u672C\u534F\u8BAE\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u4E0E\u534F\u8BAE\u6B63\u6587\u5177\u6709\u540C\u7B49\u6CD5\u5F8B\u6548\u529B\u3002\u672C\u534F\u8BAE\u662F\u60A8\u4E0E\u6749\u5353\u79D1\u6280\u5171\u540C\u7B7E\u8BA2\u7684\uFF0C\u9002\u7528\u4E8E\u60A8\u5728\u6749\u5353\u79D1\u6280\u7684\u5168\u90E8\u6D3B\u52A8\u3002\u5728\u60A8\u6CE8\u518C\u6210\u4E3A\u7528\u6237\u65F6\uFF0C\u60A8\u5DF2\u7ECF\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u63A5\u53D7\u672C\u534F\u8BAE\u7684\u5168\u90E8\u6761\u6B3E\u53CA\u5404\u9879\u89C4\u5219\uFF0C\u5E76\u627F\u8BFA\u9075\u5B88\u4E2D\u56FD\u7684\u5404\u7C7B\u6CD5\u5F8B\u3001\u6CD5\u89C4\u3001\u653F\u7B56\u7684\u89C4\u5B9A\uFF0C\u5982\u6709\u8FDD\u53CD\u800C\u5BFC\u81F4\u4EFB\u4F55\u6CD5\u5F8B\u540E\u679C\u7684\u53D1\u751F\uFF0C\u60A8\u5C06\u4EE5\u81EA\u5DF1\u7684\u540D\u4E49\u72EC\u7ACB\u627F\u62C5\u6240\u6709\u76F8\u5E94\u7684\u6CD5\u5F8B\u8D23\u4EFB\u3002</h4><h4 class="help-tit02">3. \u6749\u5353\u79D1\u6280\u6709\u6743\u6839\u636E\u76F8\u5173\u6CD5\u5F8B\u3001\u6CD5\u89C4\u3001\u653F\u7B56\u7684\u8981\u6C42\u53CA\u63D0\u4F9B\u670D\u52A1\u7684\u9700\u8981\u4E0D\u65F6\u5730\u4FEE\u6539\u672C\u534F\u8BAE\u6216\u6839\u636E\u672C\u534F\u8BAE\u5236\u5B9A\u3001\u4FEE\u6539\u5404\u7C7B\u5177\u4F53\u89C4\u5219\u5E76\u5728\u6749\u5353\u79D1\u6280\u76F8\u5173\u7CFB\u7EDF\u7248\u5757\u53D1\u5E03\uFF0C\u8BF7\u60A8\u9002\u65F6\u6CE8\u610F\u672C\u534F\u8BAE\u53CA\u5177\u4F53\u89C4\u5219\u7684\u53D8\u66F4\u3002\u82E5\u60A8\u5728\u672C\u534F\u8BAE\u53CA\u5177\u4F53\u89C4\u5219\u5185\u5BB9\u516C\u544A\u53D8\u66F4\u540E\u7EE7\u7EED\u4F7F\u7528\u672C\u670D\u52A1\u7684\uFF0C\u8868\u793A\u60A8\u5DF2\u7ECF\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u63A5\u53D7\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u548C\u5177\u4F53\u89C4\u5219\u5185\u5BB9\uFF0C\u4E5F\u5C06\u9075\u5FAA\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u548C\u5177\u4F53\u89C4\u5219\u4F7F\u7528\u6749\u5353\u79D1\u6280\u7684\u670D\u52A1\uFF1B\u540C\u65F6\u5C31\u60A8\u5728\u534F\u8BAE\u548C\u5177\u4F53\u89C4\u5219\u4FEE\u8BA2\u524D\u901A\u8FC7\u6749\u5353\u79D1\u6280\u8FDB\u884C\u7684\u4EA4\u6613\u53CA\u5176\u6548\u529B\uFF0C\u89C6\u4E3A\u60A8\u5DF2\u540C\u610F\u5E76\u5DF2\u6309\u7167\u672C\u534F\u8BAE\u53CA\u6709\u5173\u89C4\u5219\u8FDB\u884C\u4E86\u76F8\u5E94\u7684\u6388\u6743\u548C\u8FFD\u8BA4\u3002\u82E5\u60A8\u4E0D\u540C\u610F\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u5185\u5BB9\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6749\u5353\u79D1\u6280\u76F8\u5173\u7684\u670D\u52A1\u3002</h4><h4 class="help-tit02">4. \u60A8\u901A\u8FC7\u81EA\u884C\u6216\u6388\u6743\u6709\u5173\u65B9\u6839\u636E\u672C\u534F\u8BAE\u53CA\u6749\u5353\u79D1\u6280\u6709\u5173\u89C4\u5219\u3001\u8BF4\u660E\u64CD\u4F5C\u786E\u8BA4\u672C\u534F\u8BAE\u540E\uFF0C\u672C\u534F\u8BAE\u5373\u5728\u60A8\u548C\u6749\u5353\u79D1\u6280\u4E4B\u95F4\u4EA7\u751F\u6CD5\u5F8B\u6548\u529B\u3002\u672C\u534F\u8BAE\u4E0D\u6D89\u53CA\u60A8\u4E0E\u6749\u5353\u79D1\u6280\u7684\u5176\u4ED6\u7528\u6237\u4E4B\u95F4\u56E0\u7F51\u4E0A\u4EA4\u6613\u800C\u4EA7\u751F\u7684\u6CD5\u5F8B\u5173\u7CFB\u6216\u6CD5\u5F8B\u7EA0\u7EB7\u3002</h4></div><h3 class="help-tit01">\u4E8C\u3001\u6CE8\u518C</h3><div class="help-listq"><h4 class="help-tit02">1. \u5728\u60A8\u6309\u7167\u6CE8\u518C\u9875\u9762\u63D0\u793A\u586B\u5199\u4FE1\u606F\u3001\u9605\u8BFB\u5E76\u540C\u610F\u672C\u534F\u8BAE\u4E14\u5B8C\u6210\u5168\u90E8\u6CE8\u518C\u7A0B\u5E8F\u540E\uFF0C\u6216\u60A8\u4EE5\u5176\u4ED6\u6749\u5353\u79D1\u6280\u5141\u8BB8\u7684\u65B9\u5F0F\u5B9E\u9645\u4F7F\u7528\u6749\u5353\u79D1\u6280\u670D\u52A1\u65F6\uFF0C\u60A8\u5373\u53D7\u672C\u534F\u8BAE\u7684\u7EA6\u675F\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u60A8\u63D0\u4F9B\u6216\u786E\u8BA4\u7684\u90AE\u7BB1\u3001\u624B\u673A\u53F7\u7801\u6216\u8005\u6749\u5353\u79D1\u6280\u5141\u8BB8\u7684\u5176\u5B83\u65B9\u5F0F\u4F5C\u4E3A\u767B\u5F55\u624B\u6BB5\u8FDB\u5165\u6749\u5353\u79D1\u6280\u3002</h4><h4 class="help-tit02">2. \u60A8\u4E86\u89E3\u5E76\u540C\u610F\uFF0C\u5982\u60A8\u7CFB\u5728\u6749\u5353\u79D1\u6280\u5B98\u7F51\u5B8C\u6210\u7684\u6CE8\u518C\u7A0B\u5E8F\uFF0C\u53EA\u8981\u60A8\u6CE8\u518C\u6210\u529F\uFF0C\u60A8\u5373\u53EF\u4EE5\u83B7\u5F97\u60A8\u7684\u767B\u5F55\u540D\u3002\u60A8\u5728\u6B64\u660E\u786E\u6388\u6743\uFF0C\u60A8\u7684\u8D26\u6237\u4FE1\u606F\u5728\u60A8\u6CE8\u518C\u6210\u529F\u65F6\uFF0C\u5DF2\u6388\u6743\u7ED9\u6749\u5353\u79D1\u6280\u4F7F\u7528\uFF0C\u4EE5\u4F7F\u60A8\u66F4\u4FBF\u6377\u5730\u4F7F\u7528\u6749\u5353\u79D1\u6280\u670D\u52A1\u3002</h4><h4 class="help-tit02">3. \u60A8\u4E86\u89E3\u5E76\u540C\u610F\uFF0C\u4E3A\u4E86\u5E2E\u52A9\u60A8\u66F4\u597D\u5730\u4F7F\u7528\u6749\u5353\u79D1\u6280\u65D7\u4E0B\u6240\u6709\u8F6F\u4EF6\u4EA7\u54C1\u7684\u670D\u52A1\uFF0C\u6749\u5353\u79D1\u6280\u6709\u6743\u83B7\u53D6\u60A8\u53CA\u60A8\u7684\u7528\u6237\u65B9\u5982\u4E0B\u4FE1\u606F\uFF1A\u60A8\u548C\u60A8\u7684\u7528\u6237\u63D0\u4F9B\u7684\u8054\u7CFB\u4EBA\u59D3\u540D\u3001\u624B\u673A\u53F7\u3001\u5730\u5740\u4EE5\u53CA\u60A8\u548C\u60A8\u7684\u7528\u6237\u5728\u4EAB\u53D7\u8F6F\u4EF6\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EA7\u751F\u7684\u5176\u4ED6\u7C7B\u4FE1\u606F\u3002\u60A8\u540C\u610F\u6749\u5353\u79D1\u6280\u53CA\u6749\u5353\u79D1\u6280\u7684\u5408\u4F5C\u65B9\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0A\u4FE1\u606F\u8FDB\u884C\u76F8\u5173\u5206\u6790\u3001\u6539\u5584\u6749\u5353\u79D1\u6280\u65D7\u4E0B\u6240\u6709\u8F6F\u4EF6\u4EA7\u54C1\u7684\u5185\u5BB9\uFF0C\u5E76\u4F7F\u76F8\u5173\u8F6F\u4EF6\u4EA7\u54C1\u7684\u5185\u5BB9\u3001\u8BBE\u8BA1\u548C\u670D\u52A1\u66F4\u80FD\u7B26\u5408\u7528\u6237\u7684\u9700\u6C42\u3002</h4><h4 class="help-tit02">4. \u60A8\u53EF\u4EE5\u5BF9\u8D26\u6237\u8BBE\u7F6E\u6635\u79F0\uFF0C\u4F46\u60A8\u8BBE\u7F6E\u7684\u6635\u79F0\u4E0D\u5F97\u4FB5\u72AF\u6216\u6D89\u5ACC\u4FB5\u72AF\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u3002\u5982\u60A8\u8BBE\u7F6E\u7684\u6635\u79F0\u6D89\u5ACC\u4FB5\u72AF\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\uFF0C\u6749\u5353\u79D1\u6280\u6709\u6743\u7EC8\u6B62\u5411\u60A8\u63D0\u4F9B\u670D\u52A1\uFF0C\u5E76\u6CE8\u9500\u60A8\u7684\u8D26\u6237\u3002\u8D26\u6237\u6CE8\u9500\u540E\uFF0C\u76F8\u5E94\u7684\u6635\u79F0\u5C06\u5F00\u653E\u7ED9\u5176\u4ED6\u6709\u6743\u7528\u6237\u767B\u8BB0\u4F7F\u7528\u3002</h4><h4 class="help-tit02">5. \u60A8\u5E94\u5F53\u59A5\u5584\u4FDD\u7BA1\u7528\u6237\u540D\u548C\u5BC6\u7801\uFF0C\u4E14\u9700\u5BF9\u7528\u6237\u540D\u548C\u5BC6\u7801\u7684\u5B89\u5168\u8D1F\u5168\u90E8\u8D23\u4EFB\uFF0C\u540C\u65F6\u5BF9\u4EE5\u7528\u6237\u540D\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u5168\u8D23\u3002</h4></div><h3 class="help-tit01">\u4E09\u3001\u7528\u6237\u4F7F\u7528\u89C4\u8303</h3><div>\u60A8\u7406\u89E3\u5E76\u540C\u610F\uFF0C\u60A8\u4E0D\u5F97\u5229\u7528\u6749\u5353\u79D1\u6280\u5E10\u53F7\u5236\u4F5C\u3001\u590D\u5236\u3001\u53D1\u5E03\u3001\u4F20\u64AD\u3001\u5982\u4E0B\u5E72\u6270\u6749\u5353\u79D1\u6280\u6B63\u5E38\u8FD0\u8425\uFF0C\u4EE5\u53CA\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u5185\u5BB9\uFF1A</div><div class="help-listq"><h4 class="help-tit02">1. \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u6CD5\u89C4\u7981\u6B62\u7684\u5185\u5BB9\uFF1A</h4><ul class="help-listq01"><li>\uFF081\uFF09\u8FDD\u53CD\u5BAA\u6CD5\u786E\u5B9A\u7684\u57FA\u672C\u539F\u5219\u7684\uFF1B</li><li>\uFF082\uFF09\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\uFF0C\u6CC4\u9732\u56FD\u5BB6\u79D8\u5BC6\uFF0C\u98A0\u8986\u56FD\u5BB6\u653F\u6743\uFF0C\u7834\u574F\u56FD\u5BB6\u7EDF\u4E00\u7684\uFF1B</li><li>\uFF083\uFF09\u635F\u5BB3\u56FD\u5BB6\u8363\u8A89\u548C\u5229\u76CA\u7684\uFF1B</li><li>\uFF084\uFF09\u717D\u52A8\u6C11\u65CF\u4EC7\u6068\u3001\u6C11\u65CF\u6B67\u89C6\uFF0C\u7834\u574F\u6C11\u65CF\u56E2\u7ED3\u7684\uFF1B</li><li>\uFF085\uFF09\u7834\u574F\u56FD\u5BB6\u5B97\u6559\u653F\u7B56\uFF0C\u5BA3\u626C\u90AA\u6559\u548C\u5C01\u5EFA\u8FF7\u4FE1\u7684\uFF1B</li><li>\uFF086\uFF09\u6563\u5E03\u8C23\u8A00\uFF0C\u6270\u4E71\u793E\u4F1A\u79E9\u5E8F\uFF0C\u7834\u574F\u793E\u4F1A\u7A33\u5B9A\u7684\uFF1B</li><li>\uFF087\uFF09\u6563\u5E03\u6DEB\u79FD\u3001\u8272\u60C5\u3001\u8D4C\u535A\u3001\u66B4\u529B\u3001\u6050\u6016\u6216\u8005\u6559\u5506\u72AF\u7F6A\u7684\uFF1B</li><li>\uFF088\uFF09\u4FAE\u8FB1\u6216\u8005\u8BFD\u8C24\u4ED6\u4EBA\uFF0C\u4FB5\u5BB3\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u7684\uFF1B</li><li>\uFF089\uFF09\u717D\u52A8\u975E\u6CD5\u96C6\u4F1A\u3001\u7ED3\u793E\u3001\u6E38\u884C\u3001\u793A\u5A01\u3001\u805A\u4F17\u6270\u4E71\u793E\u4F1A\u79E9\u5E8F\uFF1B</li><li>\uFF0810\uFF09\u4EE5\u975E\u6CD5\u6C11\u95F4\u7EC4\u7EC7\u540D\u4E49\u6D3B\u52A8\u7684\uFF1B</li><li>\uFF0811\uFF09\u542B\u6709\u6CD5\u5F8B\u3001\u884C\u653F\u6CD5\u89C4\u7981\u6B62\u7684\u5176\u4ED6\u5185\u5BB9\u7684\u3002</li></ul><h4 class="help-tit02">2. \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\u3002</h4><h4 class="help-tit02">3. \u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\u5185\u5BB9\u3002</h4><h4 class="help-tit02">4. \u53D1\u8868\u3001\u4F20\u9001\u3001\u4F20\u64AD\u9A9A\u6270\u4FE1\u606F\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u5185\u5BB9\u3002</h4><h4 class="help-tit02">5. \u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u6749\u5353\u79D1\u6280\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002</h4></div><h3 class="help-tit01">\u56DB\u3001\u6749\u5353\u79D1\u6280\u670D\u52A1\u5185\u5BB9</h3><div class="help-listq"><h4 class="help-tit02">1. \u6749\u5353\u79D1\u6280\u4E3A\u60A8\u63D0\u4F9B\u76F8\u5173\u7F51\u7EDC\u73AF\u5883\u548C\u6280\u672F\u652F\u6301\u3002</h4><h4 class="help-tit02">2. \u6749\u5353\u79D1\u6280\u6709\u6743\u5BF9\u60A8\u7684\u6CE8\u518C\u6570\u636E\u53CA\u4EA4\u6613\u884C\u4E3A\u8FDB\u884C\u67E5\u9605\uFF0C\u53D1\u73B0\u6CE8\u518C\u6570\u636E\u6216\u4EA4\u6613\u884C\u4E3A\u4E2D\u5B58\u5728\u4EFB\u4F55\u95EE\u9898\uFF0C\u5747\u6709\u6743\u5411\u60A8\u53D1\u51FA\u8BE2\u95EE\u6216\u8981\u6C42\u6539\u6B63\u7684\u901A\u77E5\uFF0C\u6216\u8005\u76F4\u63A5\u4F5C\u51FA\u5220\u9664\u7B49\u5904\u7406\u3002</h4><h4 class="help-tit02">3. \u5BF9\u4E8E\u60A8\u901A\u8FC7\u6749\u5353\u79D1\u6280\u540E\u53F0\u53D1\u5E03\u7684\u8FDD\u6CD5\u8FDD\u89C4\u4FE1\u606F\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u672C\u534F\u8BAE\u7B2C3.1\u6761\uFF0C\u6749\u5353\u79D1\u6280\u6709\u6743\u5728\u4E0D\u901A\u77E5\u60A8\u7684\u524D\u63D0\u4E0B\u8FDB\u884C\u5220\u9664\u6216\u91C7\u53D6\u5176\u5B83\u9650\u5236\u6027\u63AA\u65BD\u3002</h4></div><h3 class="help-tit01">\u4E94\u3001\u77E5\u8BC6\u4EA7\u6743</h3><div class="help-listq"><h4 class="help-tit02">1. \u6749\u5353\u79D1\u6280\u5728\u672C\u670D\u52A1\u4E2D\u63D0\u4F9B\u7684\u5185\u5BB9\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7F51\u9875\u3001\u6587\u5B57\u3001\u56FE\u7247\u3001\u97F3\u9891\u3001\u89C6\u9891\u3001\u56FE\u8868\u7B49\uFF09\u7684\u77E5\u8BC6\u4EA7\u6743\u5F52\u6749\u5353\u79D1\u6280\u6240\u6709\uFF0C\u7528\u6237\u5728\u4F7F\u7528\u672C\u670D\u52A1\u4E2D\u6240\u4EA7\u751F\u7684\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u5F52\u7528\u6237\u6216\u76F8\u5173\u6743\u5229\u4EBA\u6240\u6709\u3002</h4><h4 class="help-tit02">2. \u9664\u53E6\u6709\u7279\u522B\u58F0\u660E\u5916\uFF0C\u6749\u5353\u79D1\u6280\u63D0\u4F9B\u672C\u670D\u52A1\u65F6\u6240\u4F9D\u6258\u8F6F\u4EF6\u7684\u8457\u4F5C\u6743\u3001\u4E13\u5229\u6743\u53CA\u5176\u4ED6\u77E5\u8BC6\u4EA7\u6743\u5747\u5F52\u6749\u5353\u79D1\u6280\u6240\u6709\u3002</h4><h4 class="help-tit02">3. \u6749\u5353\u79D1\u6280\u5728\u672C\u670D\u52A1\u4E2D\u6240\u4F7F\u7528\u7684\u201C\u6749\u5353\u79D1\u6280\u201D\u3001\u201CMomentsgo\u201D\u56FE\u6807\u53CALOGO\u3001\u6749\u5353\u79D1\u6280\u76F8\u5173\u529F\u80FD\u7684\u56FE\u6807\u53CALOGO\u7B49\u5546\u4E1A\u6807\u8BC6\uFF0C\u5176\u8457\u4F5C\u6743\u6216\u5546\u6807\u6743\u5F52\u6749\u5353\u79D1\u6280\u6240\u6709\u3002</h4><h4 class="help-tit02">3. \u4E0A\u8FF0\u53CA\u5176\u4ED6\u4EFB\u4F55\u672C\u670D\u52A1\u5305\u542B\u7684\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u5747\u53D7\u5230\u6CD5\u5F8B\u4FDD\u62A4\uFF0C\u5176\u4ED6\u672A\u7ECF\u6749\u5353\u79D1\u6280\u3001\u7528\u6237\u6216\u76F8\u5173\u6743\u5229\u4EBA\u8BB8\u53EF\u7684\u7B2C\u4E09\u4EBA\uFF0C\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u8FDB\u884C\u4F7F\u7528\u6216\u521B\u9020\u76F8\u5173\u884D\u751F\u4F5C\u54C1\u3002</h4><h4 class="help-tit02">3. \u4EFB\u4F55\u672A\u7ECF\u6749\u5353\u79D1\u6280\u4E66\u9762\u540C\u610F\u53CA\u6743\u5229\u4EBA\u8BB8\u53EF\u7684\u975E\u6CD5\u83B7\u53D6\u884C\u4E3A\uFF0C\u5747\u5C5E\u8FDD\u6CD5\u4FB5\u6743\u884C\u4E3A\u3002\u60A8\u786E\u8BA4\u5E76\u540C\u610F\uFF0C\u4E3A\u53CA\u65F6\u3001\u6709\u6548\u5730\u4FDD\u969C\u60A8\u57FA\u4E8E\u672C\u670D\u52A1\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u6388\u6743\u6749\u5353\u79D1\u6280\u5728\u53D1\u73B0\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4FE1\u606F\u7F51\u7EDC\u4F20\u64AD\u6743\u3001\u8457\u4F5C\u6743\u7B49\uFF09\u53EF\u80FD\u53D7\u5230\u4FB5\u5BB3\u65F6\uFF0C\u6709\u6743\u4EE3\u4E3A\u5411\u6D89\u5ACC\u4FB5\u6743\u7684\u7B2C\u4E09\u4EBA\u91C7\u53D6\u6CD5\u5F8B\u624B\u6BB5\u8FDB\u884C\u7EF4\u6743\uFF0C\u6388\u6743\u91C7\u53D6\u7684\u6CD5\u5F8B\u624B\u6BB5\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u53D1\u51FD\u8B66\u544A\u3001\u63D0\u8D77\u8BC9\u8BBC\u3001\u7533\u8BF7\u4EF2\u88C1\u3001\u79FB\u9001\u4FA6\u67E5\u673A\u5173\u5904\u7406\u7B49\u3002</h4></div><h3 class="help-tit01">\u516D\u3001\u8D23\u4EFB\u9650\u5236\u548C\u514D\u8D23</h3><div class="help-listq"><h4 class="help-tit02">1. \u9274\u4E8E\u7F51\u7EDC\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u60A8\u540C\u610F\u6749\u5353\u79D1\u6280\u4F1A\u53D8\u66F4\u3001\u4E2D\u65AD\u90E8\u5206\u6216\u5168\u90E8\u7684\u7F51\u7EDC\u670D\u52A1\uFF0C\u5E76\u6309\u672C\u534F\u8BAE\u89C4\u5B9A\u5220\u9664\u60A8\u5728\u4F7F\u7528\u670D\u52A1\u4E2D\u63D0\u4EA4\u7684\u4EFB\u4F55\u8D44\u6599\uFF0C\u800C\u65E0\u9700\u901A\u77E5\u60A8\uFF0C\u4E5F\u65E0\u9700\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</h4><h4 class="help-tit02">2. \u60A8\u627F\u8BFA\u5411\u6749\u5353\u79D1\u6280\u53CA\u6749\u5353\u79D1\u6280\u5408\u4F5C\u65B9\u63D0\u4F9B\u7684\u60A8\u65B9\u53CA\u60A8\u65B9\u7528\u6237\u8D44\u6599\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A\u59D3\u540D\u3001\u5730\u5740\u3001\u624B\u673A\u53F7\u7B49\uFF09\u771F\u5B9E\u3001\u51C6\u786E\u3001\u5B8C\u6574\u53CA\u6709\u6548\uFF0C\u7B26\u5408\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6709\u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u89C4\u5B9A\uFF0C\u83B7\u5F97\u5B8C\u5168\u6388\u6743\u4E14\u4E0D\u5B58\u5728\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u884C\u4E3A\u3002\u82E5\u60A8\u5192\u7528\u3001\u76D7\u7528\u4ED6\u4EBA\u4FE1\u606F\u6240\u5BFC\u81F4\u7684\u4E00\u5207\u540E\u679C\uFF0C\u7531\u60A8\u4E2A\u4EBA\u627F\u62C5\u3002\u82E5\u56E0\u60A8\u7684\u8FDD\u6CD5\u8FDD\u89C4\u884C\u4E3A\uFF0C\u5BFC\u81F4\u6749\u5353\u79D1\u6280\u6216\u6749\u5353\u79D1\u6280\u7684\u5408\u4F5C\u65B9\u9677\u5165\u4E89\u8BAE\u6216\u8BC9\u8BBC\u7EA0\u7EB7\uFF0C\u60A8\u5E94\u5411\u6749\u5353\u79D1\u6280\u6216\u6749\u5353\u79D1\u6280\u7684\u5408\u4F5C\u65B9\u8D54\u507F\u4E00\u5207\u5B9E\u9645\u635F\u5931\u3002</h4><h4 class="help-tit02">3. \u7528\u6237\u660E\u786E\u540C\u610F\u5176\u5C06\u6587\u5B57\u3001\u8D44\u8BAF\u3001\u8D44\u6599\u3001\u97F3\u4E50\u3001\u7167\u7247\u3001\u56FE\u5F62\u3001\u89C6\u8BAF\u3001\u4FE1\u606F\u6216\u5176\u5B83\u4E2A\u4EBA\u8D44\u6599\u4E0A\u4F20\u5230\u4E92\u8054\u7F51\u4E0A\uFF0C\u6709\u53EF\u80FD\u88AB\u5176\u4ED6\u7EC4\u7EC7\u6216\u4E2A\u4EBA\u590D\u5236\u3001\u8F6C\u8F7D\u3001\u6216\u505A\u5176\u5B83\u7528\u9014\u7684\u98CE\u9669\u5B8C\u5168\u7531\u5176\u81EA\u5DF1\u627F\u62C5\uFF1B\u56E0\u5176\u4F7F\u7528\u6749\u5353\u79D1\u6280\u670D\u52A1\u800C\u4EA7\u751F\u7684\u4E00\u5207\u540E\u679C\u4E5F\u7531\u5176\u81EA\u5DF1\u627F\u62C5\uFF0C\u6211\u4EEC\u5BF9\u7528\u6237\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</h4><h4 class="help-tit02">4. \u60A8\u7406\u89E3\u5E76\u540C\u610F\uFF0C\u56E0\u4E1A\u52A1\u53D1\u5C55\u9700\u8981\uFF0C\u6749\u5353\u79D1\u6280\u4FDD\u7559\u5355\u65B9\u9762\u5BF9\u672C\u670D\u52A1\u7684\u5168\u90E8\u6216\u90E8\u5206\u670D\u52A1\u5185\u5BB9\u5728\u4EFB\u4F55\u65F6\u5019\u4E0D\u7ECF\u4EFB\u4F55\u901A\u77E5\u7684\u60C5\u51B5\u4E0B\u53D8\u66F4\u3001\u6682\u505C\u3001\u9650\u5236\u3001\u7EC8\u6B62\u6216\u64A4\u9500\u7684\u6743\u5229\uFF0C\u7528\u6237\u9700\u627F\u62C5\u6B64\u98CE\u9669\u3002</h4><h4 class="help-tit02">5. \u7528\u6237\u5728\u4F7F\u7528\u672C\u670D\u52A1\u65F6\uFF0C\u987B\u81EA\u884C\u627F\u62C5\u5982\u4E0B\u6749\u5353\u79D1\u6280\u4E0D\u53EF\u638C\u63A7\u7684\u98CE\u9669\u5185\u5BB9\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A</h4><ul class="help-listq01"><li>\uFF081\uFF09\u7531\u4E8E\u53D7\u5230\u8BA1\u7B97\u673A\u75C5\u6BD2\u3001\u6728\u9A6C\u6216\u5176\u4ED6\u6076\u610F\u7A0B\u5E8F\u3001\u9ED1\u5BA2\u653B\u51FB\u7684\u7834\u574F\u7B49\u4E0D\u53EF\u6297\u62D2\u56E0\u7D20\u53EF\u80FD\u5F15\u8D77\u7684\u4FE1\u606F\u4E22\u5931\u3001\u6CC4\u6F0F\u7B49\u98CE\u9669\uFF1B</li><li>\uFF082\uFF09\u7528\u6237\u6216\u6749\u5353\u79D1\u6280\u7684\u7535\u8111\u8F6F\u4EF6\u3001\u7CFB\u7EDF\u3001\u786C\u4EF6\u548C\u901A\u4FE1\u7EBF\u8DEF\u51FA\u73B0\u6545\u969C\uFF1B</li><li>\uFF083\uFF09\u7528\u6237\u64CD\u4F5C\u4E0D\u5F53\u4F7F\u7528\u672C\u670D\u52A1\uFF1B</li><li>\uFF084\uFF09\u5176\u4ED6\u6749\u5353\u79D1\u6280\u65E0\u6CD5\u63A7\u5236\u6216\u5408\u7406\u9884\u89C1\u7684\u60C5\u5F62\uFF1B</li></ul><h4 class="help-tit02">6. \u6749\u5353\u79D1\u6280\u4F9D\u636E\u672C\u534F\u8BAE\u7EA6\u5B9A\u83B7\u5F97\u5904\u7406\u8FDD\u6CD5\u8FDD\u89C4\u5185\u5BB9\u6216\u884C\u4E3A\u7684\u6743\u5229\uFF0C\u8BE5\u6743\u5229\u4E0D\u6784\u6210\u6749\u5353\u79D1\u6280\u7684\u4E49\u52A1\u6216\u627F\u8BFA\uFF0C\u6749\u5353\u79D1\u6280\u4E0D\u80FD\u4FDD\u8BC1\u53CA\u65F6\u53D1\u73B0\u8FDD\u6CD5\u8FDD\u89C4\u60C5\u5F62\u6216\u8FDB\u884C\u76F8\u5E94\u5904\u7406\u3002</h4><h4 class="help-tit02">7. \u82E5\u6749\u5353\u79D1\u6280\u53D1\u73B0\u60A8\u56E0\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7EC4\u7EC7\u673A\u6784\u89E3\u6563\u3001\u6CE8\u9500\u3001\u88AB\u540A\u9500\u7B49\u4EFB\u4F55\u539F\u56E0\u5BFC\u81F4\u6C11\u4E8B\u884C\u4E3A\u80FD\u529B\u3001\u6C11\u4E8B\u6743\u5229\u80FD\u529B\u7EC8\u6B62\u7684\u60C5\u51B5\uFF0C\u4E3A\u4FDD\u969C\u7528\u6237\u548C\u5176\u4ED6\u4E3B\u4F53\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u5C06\u6709\u6743\u51B3\u5B9A\u7ACB\u5373\u7EC8\u6B62\u672C\u670D\u52A1\uFF0C\u4E14\u65E0\u9700\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</h4></div><h3 class="help-tit01">\u4E03\u3001\u901A\u77E5</h3><div class="help-listq"><h4 class="help-tit02">1. \u60A8\u5E94\u5F53\u51C6\u786E\u586B\u5199\u5E76\u53CA\u65F6\u66F4\u65B0\u60A8\u63D0\u4F9B\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u8054\u7CFB\u5730\u5740\u3001\u90AE\u653F\u7F16\u7801\u7B49\u8054\u7CFB\u65B9\u5F0F\uFF0C\u4EE5\u4FBF\u6749\u5353\u79D1\u6280\u6216\u5176\u4ED6\u7528\u6237\u4E0E\u60A8\u8FDB\u884C\u6709\u6548\u8054\u7CFB\uFF0C\u56E0\u901A\u8FC7\u8FD9\u4E9B\u8054\u7CFB\u65B9\u5F0F\u65E0\u6CD5\u4E0E\u60A8\u53D6\u5F97\u8054\u7CFB\uFF0C\u5BFC\u81F4\u60A8\u5728\u4F7F\u7528\u6749\u5353\u79D1\u6280\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EA7\u751F\u4EFB\u4F55\u635F\u5931\u6216\u589E\u52A0\u8D39\u7528\u7684\uFF0C\u5E94\u7531\u60A8\u5B8C\u5168\u72EC\u81EA\u627F\u62C5\u3002</h4><h4 class="help-tit02">2. \u60A8\u4E86\u89E3\u5E76\u540C\u610F\uFF0C\u60A8\u6709\u4E49\u52A1\u4FDD\u6301\u60A8\u63D0\u4F9B\u7684\u8054\u7CFB\u65B9\u5F0F\u7684\u6709\u6548\u6027\uFF0C\u5982\u6709\u53D8\u66F4\u9700\u8981\u66F4\u65B0\u7684\uFF0C\u60A8\u5E94\u6309\u6749\u5353\u79D1\u6280\u7684\u8981\u6C42\u8FDB\u884C\u64CD\u4F5C\u3002</h4></div><h3 class="help-tit01">\u516B\u3001\u6CD5\u5F8B\u9002\u7528\u3001\u7BA1\u8F96\u53CA\u5176\u4ED6</h3><div class="help-listq"><h4 class="help-tit02">1. \u672C\u534F\u8BAE\u4E4B\u6548\u529B\u3001\u89E3\u91CA\u3001\u53D8\u66F4\u3001\u6267\u884C\u4E0E\u4E89\u8BAE\u89E3\u51B3\u5747\u9002\u7528\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u6CD5\u5F8B\uFF0C\u5982\u65E0\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u7684\uFF0C\u5219\u5E94\u53C2\u7167\u901A\u7528\u56FD\u9645\u5546\u4E1A\u60EF\u4F8B\u548C\uFF08\u6216\uFF09\u884C\u4E1A\u60EF\u4F8B\u3002</h4><h4 class="help-tit02">2. \u672C\u534F\u8BAE\u65E0\u610F\u7ED3\u6210\u6216\u521B\u8BBE\u4EFB\u4F55\u4EE3\u7406\u3001\u5408\u4F19\u3001\u5408\u8425\u3001\u96C7\u4F63\u4E0E\u88AB\u96C7\u4F63\u6216\u7279\u6027\u6388\u6743\u4E0E\u88AB\u6388\u6743\u5173\u7CFB\u3002</h4><h4 class="help-tit02">3. \u60A8\u540C\u610F\u6749\u5353\u79D1\u6280\u56E0\u7ECF\u8425\u4E1A\u52A1\u9700\u8981\u6709\u6743\u5C06\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u6743\u5229\u4E49\u52A1\u5C31\u90E8\u5206\u6216\u5168\u90E8\u8FDB\u884C\u8F6C\u8BA9\uFF0C\u800C\u65E0\u987B\u518D\u901A\u77E5\u4E88\u60A8\u5E76\u53D6\u5F97\u60A8\u7684\u540C\u610F\u3002</h4><h4 class="help-tit02">4. \u56E0\u672C\u534F\u8BAE\u6216\u6749\u5353\u79D1\u6280\u670D\u52A1\u6240\u5F15\u8D77\u6216\u4E0E\u5176\u6709\u5173\u7684\u4EFB\u4F55\u4E89\u8BAE\u5E94\u5411\u6749\u5353\u79D1\u6280\u6240\u5728\u5730\u4EBA\u6C11\u6CD5\u9662\u63D0\u8D77\u8BC9\u8BBC\u3002</h4><h4 class="help-tit02">5. \u672C\u534F\u8BAE\u53D6\u4EE3\u60A8\u548C\u6749\u5353\u79D1\u6280\u5148\u524D\u5C31\u76F8\u540C\u4E8B\u9879\u8BA2\u7ACB\u7684\u4EFB\u4F55\u4E66\u9762\u6216\u53E3\u5934\u534F\u8BAE\u3002\u5018\u82E5\u672C\u534F\u8BAE\u4EFB\u4F55\u6761\u6B3E\u88AB\u88C1\u5B9A\u4E3A\u65E0\u6548\u6216\u4E0D\u53EF\u5F3A\u5236\u6267\u884C\uFF0C\u8BE5\u9879\u6761\u6B3E\u5E94\u88AB\u64A4\u9500\uFF0C\u800C\u5176\u4F59\u6761\u6B3E\u5E94\u4E88\u9075\u5B88\u548C\u6267\u884C\u3002\u6761\u6B3E\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u53C2\u9605\u800C\u8BBE\uFF0C\u5E76\u4E0D\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u754C\u5B9A\u3001\u9650\u5236\u3001\u89E3\u91CA\u6216\u63CF\u8FF0\u8BE5\u6761\u6B3E\u7684\u8303\u56F4\u6216\u9650\u5EA6\u3002\u6749\u5353\u79D1\u6280\u672A\u5C31\u60A8\u6216\u5176\u4ED6\u4EBA\u58EB\u7684\u67D0\u9879\u8FDD\u7EA6\u884C\u4E3A\u91C7\u53D6\u884C\u52A8\uFF0C\u5E76\u4E0D\u8868\u660E\u6749\u5353\u79D1\u6280\u64A4\u56DE\u5C31\u4EFB\u4F55\u7EE7\u540E\u6216\u7C7B\u4F3C\u7684\u8FDD\u7EA6\u4E8B\u4EF6\u91C7\u53D6\u884C\u52A8\u7684\u6743\u5229\u3002</h4></div></div></div></div><div class="modal-footer text-align-center"><button type="button" class="btn btn-info width-120" data-dismiss="modal" ng-click="vm.save()">\u540C\u610F\u5E76\u7EE7\u7EED</button></div></div></form>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row row-registers"><div class="registers"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h2 data-translate="settings.title" class="register-title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div></div><jhi-alert-error></jhi-alert-error><div class="col-md-8 col-md-offset-2 register-body" style="margin-top: 10px"><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><div class="modal-footer"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-save" data-translate="settings.form.button">Save</button></div></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gateway/gateway.html','<div><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes == false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length == 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status == \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status == \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="userManagement.detail.title">User</span>{{vm.user.name}}</div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="userManagement.login">Login</label><div class="col-md-9 col-sm-9 col-xs-9"><span>{{vm.user.name}}</span></div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="userManagement.role">role</label><div class="col-md-9 col-sm-9 col-xs-9"><span>{{vm.user.roleName}}</span></div></div></div><!-- <div class="col-lg-6 col-sm-6 form-group">\n                    <div class="form-group">\n                        <label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel"\n                               translate="userManagement.lastName">Last Name</label>\n                        <div class="col-md-9 col-sm-9 col-xs-9">\n                            <span>{{vm.user.lastName}}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class="col-lg-6 col-sm-6 form-group">\n                    <div class="form-group">\n                        <label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel"\n                               translate="userManagement.email">Email</label>\n                        <div class="col-md-9 col-sm-9 col-xs-9">\n                            <span>{{vm.user.email}}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class="col-lg-6 col-sm-6 form-group">\n                    <div class="form-group">\n                        <label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel"\n                               translate="userManagement.activated">Activated</label>\n                        <div class="col-md-9 col-sm-9 col-xs-9">\n                            <span>{{vm.user.activated}}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class="col-lg-6 col-sm-6 form-group">\n                    <div class="form-group">\n                        <label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel"  translate="userManagement.langKey" >Lang Key</label>\n                        <div class="col-md-9 col-sm-9 col-xs-9">\n                            <span>{{vm.user.langKey}}</span>\n                        </div>\n                    </div>\n                </div>  --><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="userManagement.createdBy">C reated By</label><div class="col-md-9 col-sm-9 col-xs-9"><span>{{vm.user.createdBy}}</span></div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="userManagement.createdDate">Created Date</label><div class="col-md-9 col-sm-9 col-xs-9"><span>{{vm.user.createdDate| date:\'dd/MM/yy HH:mm\' }}</span></div></div></div><!-- <div class="col-lg-6 col-sm-6 form-group">\n                    <div class="form-group">\n                        <label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel"\n                               translate="userManagement.lastModifiedBy">Last Modeified By</label>\n                        <div class="col-md-9 col-sm-9 col-xs-9">\n                            <span>{{vm.user.lastModifiedBy}}</span>\n                        </div>\n                    </div>\n                </div> --><!-- <div class="col-lg-6 col-sm-6 form-group">\n                    <div class="form-group">\n                        <label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel"\n                               translate="userManagement.lastModifiedDate">Last Modeified Date</label>\n                        <div class="col-md-9 col-sm-9 col-xs-9">\n                            <span>{{vm.user.lastModifiedDate| date:\'dd/MM/yy HH:mm\' }}</span>\n                        </div>\n                    </div>\n                </div> --></div></div><div class="modal-footer"><button type="submit" class="btn btn-default btn-cancel" ng-click="vm.clear()"><!--<button type="button" class="btn btn-default btn-cancel" data-dismiss="modal" ng-click="vm.clear()">--> <span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><jhi-alert-error></jhi-alert-error><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="userManagement.login" for="field_login">Login</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control" name="field_login" id="field_login" ng-model="vm.user.name" readonly="readonly"></div></div></div><!-- <div class="col-lg-6 col-sm-6 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="userManagement.firstName"  for="field_firstName">First Name</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input type="text" class="form-control" name="field_firstName" id="field_firstName" ng-model="vm.user.firstName" />\n                    </div>\n                </div>\n            </div>\n            <div class="col-lg-6 col-sm-6 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="userManagement.lastName"  for="field_lastName">Last Name</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input type="text" class="form-control" name="field_lastName" id="field_lastName" ng-model="vm.user.lastName" />\n\n                    </div>\n                </div>\n            </div>\n            <div class="col-lg-6 col-sm-6 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="userManagement.telephone"  for="field_telephone">telephone</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input type="text" class="form-control" name="field_telephone" id="field_telephone" ng-model="vm.user.telephone" require />\n                    </div>\n                </div>\n            </div>\n            <div class="col-lg-6 col-sm-6 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="userManagement.email"  for="field_email">Email</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input type="text" class="form-control" name="field_email" id="field_email" ng-model="vm.user.email" />\n                    </div>\n                </div>\n            </div> --><!-- <div class="col-lg-6 col-sm-6 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="userManagement.langKey">Lang Key</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input type="text" class="form-control" name="field_langKey" id="field_langKey" ng-model="vm.user.langKey" />\n                    </div>\n                </div>\n            </div>  --><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="userManagement.role" for="field_role">Role</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_role" name="role" ng-model="vm.user.roleId" ng-options="role.id as role.name for role in vm.roles | orderBy:\'id\'"><option value=""></option></select></div></div></div><!-- <div class="col-lg-6 col-sm-6 form-group" style = "height:48.99px">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="userManagement.activated">Activated</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated" class="checkbox-outline">\n                    </div>\n                </div>\n            </div> --></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-save"><span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="listBGC"><jhi-alert></jhi-alert><div class="container-fluid pad-left-15 pad-right-15"><div class="row moduleNameBGC"><!--<div class="col-xs-5">--><!--<span class="moduleName" translate="userManagement.home.title1">Users</h2>--><!--</div>--><!-- <div class="col-xs-5  ">\n                <form name="searchForm" class="form-search form-inline">\n                    <div class="input-group pull-right" >14\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'userManagement.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div> --><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'userManagement.home.search\' | translate }}"> <span class="input-group-btn width-min btn-searched"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span translate="global.form.search"></span></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span translate="global.form.clear"></span></button></span></div></form></div><div class="createBar"><button class="btn btn-primary pull-right" ui-sref="register" ng-click="vm.collapseNavbar()" perm="ROLE_USER_CREATE"><span class="hidden-xs" translate="userManagement.home.createLabel">Create a new User</span></button></div></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="telephone"><span translate="userManagement.telephone">telephone</span> <span class="glyphicon glyphicon-sort"></span></th> --><!-- <th jh-sort-by="email"><span translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th> --><!--<th><span translate="global.field.status">Status</span></th>--><!-- <th  jh-sort-by="langKey"><span translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="role"><span translate="userManagement.role">Role</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.name}}</td><!-- <td>{{user.telephone}}</td> --><!-- <td>{{user.email}}</td> --><!--<td>\n                    <span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated"translate="userManagement.deactivated" style="cursor: pointer;">Deactivated</span>\n                    <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated"translate="userManagement.activated" style="cursor: pointer;">Activated</span>\n                </td>--><!-- <td>{{user.langKey}}</td> --><td>{{user.roleName}}</td><!--<td class="text-right">--><td class="text-right"><div><button type="submit" class="btn-sub" perm="ROLE_USER_CREATE" title="\u5BC6\u7801\u91CD\u7F6E"><span class="glyphicon glyphicon-transfer btn-password" ng-click="resetPasswords(user.id)"></span></button> <button type="submit" ui-sref="user-management-detail({id:user.id})" class="btn-sub" perm="ROLE_USER_VIEW" title="\u67E5\u770B\u8BE6\u60C5"><span class="glyphicon glyphicon-eye-open btn-check"></span></button> <button type="submit" ui-sref="user-management.edit({id:user.id})" class="btn-sub" perm="ROLE_USER_CREATE" title="\u7F16\u8F91"><span class="btn-edit"></span></button><!--<button type="submit"--><!--ui-sref="user-management.delete({id:user.id})"--><!--class="btn-sub" ng-disabled="vm.currentAccount.login==user.login" perm="ROLE_USER_DELETE">--><!--<span class="btn-del"></span>--><!--</button>--> <button type="submit" class="btn-sub" ng-click="delete(user.id)" perm="ROLE_USER_DELETE" title="\u5220\u9664\u8BB0\u5F55"><span class="btn-del"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/category/categories.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u54C1 / <span translate="global.menu.entities.category">category</span></div><div class="con"><div class="overflow-h"><div class="float-left"><button class="oval-btn-normal" ui-sref="category.new"><i class="icon iconfont webadd"></i> <span translate="platformApp.category.home.createLabel">Create new Property</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'platformApp.category.home.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button></span></div></form></div></div><div class="table-responsive pad-left-15 pad-right-15 mar-top-20"><table class="za-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span translate="platformApp.category.name">Name</span></th><th><span translate="platformApp.category.seq">seq</span></th><th><span translate="platformApp.category.imgUrl">imgUrl</span></th><th><span translate="platformApp.category.usable">usable</span></th><th style="width: 200px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="category in vm.categories track by category.id"><td style="display: table-cell; vertical-align: middle">{{category.name}}</td><td>{{category.seq}}</td><td><img class="picture-border" alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{domain + category.imgUrl}}"></td><td><!-- <button type="submit" class="small-btn-normal" ng-if="category.usable">\u542F\u7528</button>\n                        <button type="submit" class="small-btn-disabled" ng-if="!category.usable">\u672A\u542F\u7528</button> --> <span ng-if="category.usable">\u542F\u7528</span> <span ng-if="!category.usable">\u672A\u542F\u7528</span></td><td><button class="status-btn" type="submit" ui-sref="category.edit({id:category.id})"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91<!--                            <span class="hover-span">\u7F16\u8F91</span>--></button> <button class="status-btn" type="submit" ng-click="delete(category.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664<!--                            <span class="hover-span">\u5220\u9664</span>--></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/category/category-detail.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="platformApp.category.detail.title">Category</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="platformApp.category.name">Name</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.category.name}}</div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="platformApp.category.seq">seq</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.category.seq}}</div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="platformApp.category.imgUrl">imgUrl</label><div class="col-md-9 col-sm-9 col-xs-9"><img class="picture-border" alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{domain + vm.category.imgUrl}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-cancel" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/category/category-dialog.html','<div class="listBGC"><div class="breadcrumb-normal">\u5206\u7C7B\u7BA1\u7406 / <span>\u5206\u7C7B{{vm.title}}</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="platformApp.category.name">name\uFF1A</div><div class="c-form-div"><input type="text" class="c-input1" style="width: 90%" ng-model="vm.category.name" placeholder="\u8BF7\u8F93\u5165\u5206\u7C7B\u540D\u79F0" maxlength="20"> <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.category.seq">seq\uFF1A</div><div class="c-form-div"><input type="number" class="c-input1" ng-model="vm.category.seq" placeholder="\u8BF7\u8F93\u5165\u6570\u503C" maxlength="20"></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.category.usable">usable\uFF1A</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px; margin-top: -3px" ng-show="vm.category.usable">\u542F\u7528</div><div style="margin-left: 20px; margin-top: -3px" ng-show="!vm.category.usable">\u505C\u7528</div><input type="checkbox" ng-model="vm.category.usable" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.category.imgUrl">imgUrl</div><div class="c-form-div" style="position: relative"><input ng-if="!vm.category.imgUrl" type="file" name="file" class="form-control border-radius input-upload" accept=" image/jpeg, image/png" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"><div class="pic-upload" ng-if="!vm.category.imgUrl"><img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.category.imgUrl"><img class="picture-border" ng-src="{{domain + vm.category.imgUrl}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(vm.category.imgUrl)" style="color: red"></i></span></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/clip-art/clip-art-detail.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="editorApp.clipArt.detail.title">clipArt</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="editorApp.clipArt.show-pic">show-pic</label><div class="col-md-9 col-sm-9 col-xs-9"><!--<span ng-if="vm.attachments.length >0 && attach" ng-repeat="attach in vm.attachments track by $index">--> <img style="width: 100px; height: 100px; border: 1px dashed red" ng-src="{{domain + vm.clipArt.identifier +\'?imageView2\'}}"><!--</span>--></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="editorApp.clipArt.themeClassify">themeClassify</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.clipArt.themeClassifyName}}</div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-cancel" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/clip-art/clip-art-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" translate="editorApp.clipArt.home.createOrEditLabel">Create or edit a clipArt</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.clipArt.themeClassify" for="themeClassify">themeClassify</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.clipArt.themeClassifyId" ng-options="theme.id as theme.name for theme in vm.themeClassifies | orderBy:\'id\'"><option value=""></option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group" ng-if="!vm.clipArt.id"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.clipArt.show-pic">showPic</label><div class="col-md-9 col-sm-9 col-xs-9"><input ng-if="vm.attachments.length ==0" type="file" name="file" class="form-control" accept="image/jpeg, image/png" multiple="multiple" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <span ng-if="vm.attachments.length >0 && attach" ng-repeat="attach in vm.attachments track by $index" style="float:left;word-break: break-all;display: inline-block;margin-top: 10px;margin-right: 10px"><span>{{attach.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(attach,$index)" style="color: red"></i></span></div></div></div><div class="col-lg-10 col-sm-10 form-group" ng-if="!!vm.clipArt.id"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="editorApp.clipArt.show-pic">show-pic</label><div class="col-md-9 col-sm-9 col-xs-9"><img style="width: 100px; height: 100px; border: 1px dashed red" ng-src="{{domain + vm.clipArt.identifier +\'?imageView2\'}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></form>');
$templateCache.put('app/entities/clip-art/clip-art.html','<div class="listBGC"><div style="width: 100%; height: 50px; background-color: #fff"><div class="col-lg-12 col-sm-12 form-group" style="padding-left: 22px"><div class="multimedia-group-topspan" style="margin-left: 20px; border-bottom: 3px #fe5454 solid"><span style="color: #fe5454">\u7D20\u6750\u7BA1\u7406</span></div></div></div><div class="con" style="margin-top: 20px; min-height: 530px"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'editorApp.clipArt.home.search\' | translate }}"> <span class="input-group-btn width-min btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)"><span style="color: #fff">\u641C\u7D22</span></button></span></div></form></div><span class="input-group-btn width-min btn-clear" ui-sref="clipArt.new"><button class="btn btn-info"><span translate="editorApp.clipArt.home.createLabel">Create new clipArt</span></button></span></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="fw8"><span data-translate="editorApp.clipArt.show-pic">show-pic</span></th><th class="fw8" jh-sort-by="themeClassify"><span data-translate="editorApp.clipArt.themeClassify">themeClassify</span> <span class="glyphicon glyphicon-sort"></span></th><th class="fw8"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="clipArt in vm.clipArts track by clipArt.id"><td><img style="width: 100px; height: 100px" ng-src="{{domain + clipArt.identifier+\'?imageView2\'}}"></td><td style="line-height: 100px">{{clipArt.themeClassifyName}}</td><td class="text-right"><a ui-sref="clipArt.detail({id : clipArt.id})">\u67E5\u770B</a> <span style="color: #e9e9e9; margin-left: 4px; margin-right: 4px">|</span> <a ui-sref="clipArt.edit({id : clipArt.id})">\u7F16\u8F91</a> <span style="color: #e9e9e9; margin-left: 4px; margin-right: 4px">|</span> <a ng-click="delete(clipArt.id)">\u5220\u9664</a></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/components/select-multiple.html','<div class="select-multiple"><div class="select-multiple-title slh"><span ng-repeat="item in vm.model">{{item[vm.value]}}</span> <i class="iconfont icon-jiantouxia"></i></div><div class="select-multiple-ul"><div class="select-multiple-li slh" ng-repeat="item in vm.options" ng-class="{\'select-multiple-li-on\' : checked(item)}" ng-click="optionSave(item)">{{item[vm.value]}}</div></div></div><style>.select-multiple{\n        width: 100%;\n        position: relative;\n        z-index: 999;\n    }\n    .select-multiple-title{\n        position: relative;\n        width: 100%;\n        height: 35px;\n        line-height: 35px;\n        background: #fff;\n        border-radius: 4px;\n        border: 1px solid #ddd;\n        padding: 0 16px 0 8px;\n        color: #0a0a0a;\n    }\n    .select-multiple-title span{\n        margin: 0 5px;\n    }\n    .select-multiple-title .iconfont{\n        position: absolute;\n        right: 4px;\n        top: 0;\n        font-size: 12px;\n    }\n    .select-multiple-ul{\n        display: none;\n        width: 100%;\n        position: absolute;\n        top: 34px;\n        left: 0;\n        background: #fff;\n        border: 1px solid #ddd;\n        border-radius: 0 0 4px 4px;\n        max-height: 200px;\n        overflow: auto;\n    }\n    .select-multiple:hover .select-multiple-ul{\n        display: block;\n    }\n    .select-multiple-li{\n        width: 100%;\n        padding: 0 8px;\n        cursor: pointer;\n        height: 35px;\n        line-height: 35px;\n        color: #0A0A0A;\n        transition: all 0.1s;\n    }\n    .select-multiple-li:hover{\n        color: #f9a64c;\n    }\n    .select-multiple-li-on{\n        color: #FC5002 !important;\n    }</style>');
$templateCache.put('app/entities/configuration/configuration-dialog.html','<div class="listBGC" style="min-width: 700px"><div class="mar-top-24 mar-bottom-10"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A <span translate="global.menu.entities.configuration">configuration</span></span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">appId</label><div class="col-md-4 col-sm-4 col-xs-4"><span>{{vm.data.appId}}</span></div></div><div class="col-lg-12 col-sm-12 form-group no-padding"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">appSecret</label><div class="col-md-4 col-sm-4 col-xs-4" style="padding: 3px 16px"><span>{{vm.data.appSecret}}</span></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-lg-2 col-md-2 col-sm-2 col-xs-2 control-label" for="field_activated">\u57DF\u540D\uFF1A</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="c-input1" ng-model="vm.data.domain"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-lg-2 col-md-2 col-sm-2 col-xs-2 control-label" for="field_activated">\u7EC4\u7248\u5B8C\u6210\u901A\u77E5\u63A5\u53E3</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="c-input1" ng-model="vm.data.combinationNotifyUrl"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-lg-2 col-md-2 col-sm-2 col-xs-2 control-label" for="field_activated">\u7EC4\u7248\u5F02\u5E38\u901A\u77E5\u63A5\u53E3</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="c-input1" ng-model="vm.data.combinationErrorNotifyUrl"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-lg-2 col-md-2 col-sm-2 col-xs-2 control-label" for="field_activated">\u4F5C\u54C1\u72B6\u6001\u901A\u77E5\u63A5\u53E3</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="c-input1" ng-model="vm.data.articleStatusNotifyUrl"></div></div></div><!-- <div class="col-lg-12 col-sm-12 col-xs-12 pad-0" >\n                <div class="form-group">\n                    <label class="col-lg-2 col-md-2 col-sm-2 col-xs-2 control-label" for="field_activated">\u5FAE\u4FE1\u914D\u7F6E\u63A5\u53E3</label>\n                    <div class="col-md-4 col-sm-4 col-xs-4">\n                        <input type="text" class="c-input1" ng-model="vm.data.wechatInfoUrl">\n                    </div>\n                </div>\n            </div> --><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-lg-2 col-md-2 col-sm-2 col-xs-2 control-label" for="field_activated">\u4F5C\u54C1\u5931\u6548\u63A5\u53E3</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="c-input1" ng-model="vm.data.articleInvalidNotifyUrl"></div></div></div></div></div><div class="mar-top-10"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ui-sref="configuration2"><span>\u53D6\u6D88</span></button></div></div>');
$templateCache.put('app/entities/configuration/configuration.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u6237 / <span translate="global.menu.entities.configuration">\u7535\u5546\u914D\u7F6E</span></div><div class="con"><div class="overflow-h"><div class="float-left"><button class="oval-btn-normal" ui-sref="configuration2.new" ng-show="vm.data.length <  vm.store.apiQuantity"><i class="icon iconfont webadd"></i> <span>\u65B0\u5EFA</span></button></div></div><div class="table-responsive pad-left-15 pad-right-15 mar-top-20"><table class="za-table table"><thead><tr><th><span>appId</span></th><th><span>appSecret</span></th><th><span>\u57DF\u540D</span></th><th><span>\u4F5C\u54C1\u72B6\u6001\u901A\u77E5\u63A5\u53E3</span></th><th><span>\u7EC4\u7248\u5B8C\u6210\u901A\u77E5\u63A5\u53E3</span></th><th style="width: 200px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="d in vm.data track by d.id"><td style="display: table-cell; vertical-align: middle">{{d.appId}}</td><td>{{d.appSecret}}</td><td>{{d.domain}}</td><td>{{d.articleStatusNotifyUrl}}</td><td>{{d.combinationNotifyUrl}}</td><td><button class="status-btn" type="submit" ui-sref="configuration2-dialog({id:d.id})"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/consumption/consumption.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u8D22\u52A1 /<span class="breadcrumb-normal-step"> \u6D88\u8D39\u8BB0\u5F55</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"><div style="margin-right: 20px;width: 325px;float: left"><span class="filter-text">\u6D88\u8D39\u65F6\u95F4\uFF1A</span><div><div class="c-form-div clearfix" style="width: 450px"><input class="c-input1" type="text" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.data.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" style="width: 150px; float: left" placeholder="\u5F00\u59CB\u65F6\u95F4"> <span style="display: inline-block; width: 20px; text-align: center; float: left; line-height: 35px">\u81F3</span> <input class="c-input1" type="text" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.data.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" style="width: 150px; float: left" placeholder="\u7ED3\u675F\u65F6\u95F4"></div></div></div><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u6D88\u8D39\u65B9\u5F0F\uFF1A</span><div><select style="width: 85%" class="form-control border-radius" ng-model="vm.data.classType" ng-options="category.id as category.name for category in vm.mannerList"><option value="" class="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></div><div class="c-form pull-left" style="clear: none"><div class="float-left" style="padding-top: 17px"><button class="oval-btn-normal" ng-click="vm.search(vm.searchQuery)"><span>\u641C\u7D22</span></button></div></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr><th><span>\u6D88\u8D39\u65F6\u95F4</span></th><th><span>\u6D88\u8D39\u65B9\u5F0F</span></th><th><span>\u7F16\u53F7</span></th><th><span>\u5916\u90E8\u6765\u6E90\u5355\u53F7</span></th><th><span>\u6D88\u8D39\u91D1\u989D</span></th></tr></thead><tbody><tr ng-repeat="consumption in vm.consumption track by consumption.id"><td style="display: table-cell; vertical-align: middle">{{consumption.classDate | date:\'yyyy-MM-dd hh:mm:ss\'}}</td><td style="display: table-cell; vertical-align: middle">{{vm.type(consumption.classType)}}</td><td style="display: table-cell; vertical-align: middle">{{consumption.classNumber}}</td><td style="display: table-cell; vertical-align: middle">{{consumption.sourceNumber}}</td><td style="display: table-cell; vertical-align: middle">{{consumption.amount||0|currency}}</td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/creditExtension/creditExtension.html','<div class="listBGC"><span class="breadcrumb-normal">\u8D22\u52A1 /<span class="breadcrumb-normal-step"> \u6388\u4FE1\u8BB0\u5F55</span></span><div class="con"><div class="container-fluid mar-bottom-20"><div class="row"><div class="overflow-h"><div style="margin-right: 20px;width: 325px;float: left"><span class="filter-text">\u6388\u4FE1\u65F6\u95F4\uFF1A</span><div><div class="c-form-div clearfix" style="width: 450px"><input class="c-input1" type="text" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" style="width: 150px; float: left" placeholder="\u5F00\u59CB\u65F6\u95F4"> <span style="display: inline-block; width: 20px; text-align: center; float: left; line-height: 35px">\u81F3</span> <input class="c-input1" type="text" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" style="width: 150px; float: left" placeholder="\u7ED3\u675F\u65F6\u95F4"></div></div></div><div class="c-form pull-left" style="clear: none"><div class="float-left" style="padding-top: 17px"><button class="oval-btn-normal" ng-click="vm.search(vm.searchQuery)"><span>\u641C\u7D22</span></button></div></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr><th style="width: 100px"><span>\u5E8F\u53F7</span></th><th><span>\u5546\u6237\u540D\u79F0</span></th><th><span>\u6388\u4FE1\u53D8\u5316</span></th><th><span>\u6388\u4FE1\u989D\u5EA6</span></th><th><span>\u64CD\u4F5C\u524D\u989D\u5EA6</span></th><th><span>\u5269\u4F59\u989D\u5EA6</span></th><th><span>\u64CD\u4F5C\u65F6\u95F4</span></th></tr></thead><tbody><tr ng-repeat="item in vm.creditData track by item.id"><td>{{$index+1}}</td><td>{{item.storeName}}</td><td>{{item.action == \'ADD\' ? \'\u589E\u52A0\' : \'\u51CF\u5C11\'}}</td><td>{{item.creditAfter-item.creditBefore}}</td><td>{{item.creditBefore}}</td><td>{{item.creditAfter}}</td><td>{{item.createdDate| date:\'mediumDate\'}}</td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/customer/customers.html','<div class="listBGC" style="min-width: 1300px"><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A<span translate="global.menu.entities.customer">customer</span></span><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="backApp.customer.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="openId"><span data-translate="backApp.customer.openId">Open Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sex"><span data-translate="backApp.customer.sex">Sex</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id"><td>{{customer.name}}</td><td>{{customer.openId}}</td><td>{{customer.sex==1?"\u7537":customer.sex==2?"\u5973":"\u672A\u77E5"}}</td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/da/da.html','<!--\n         DA \u662F Data Analysis\uFF08\u6570\u636E\u5206\u6790\uFF09\u7684\u7B80\u5199\n\n         \u6B64\u9875\u9762\u662F\u5206\u7C7B\u5206\u6790\n--><div class="listBGC"><div class="current-location"><div><span translate="global.menu.current-location">\u5F53\u524D\u4F4D\u7F6E:</span> <span translate="global.menu.entities.daManagement2" class="current-menu">daManagement</span></div></div><div class="con"><table class="width-100p wrap-mar-0-12"><!-- \u7B2C\u4E00\u884C --><tr class="bgc-f4f5fa da-solid-border height-35"><td><div class="width-50p" style="text-align: center"><div ng-class="vm.dataType == \'day\' ? \'bgcolor-FF6C5F text-color\':\'\'" class="pad-top-10 float-left height-35 width-100 outline" ng-click="vm.changeType(\'day\')"><span>\u65E5\u7EDF\u8BA1</span></div><div ng-class="vm.dataType == \'month\' ? \'bgcolor-FF6C5F text-color\':\'\'" class="pad-top-10 float-left height-35 width-100 da-solid-border-left outline" ng-click="vm.changeType(\'month\')"><span>\u6708\u7EDF\u8BA1</span></div><div ng-class="vm.dataType == \'quarter\' ? \'bgcolor-FF6C5F text-color\':\'\'" class="pad-top-10 float-left height-35 width-100 da-solid-border-left da-solid-border-right outline" ng-click="vm.changeType(\'quarter\')"><span>\u5B63\u7EDF\u8BA1</span></div></div><!--\u4E0B\u8F7D\u64CD\u4F5C--><div class="float-right width-50" style="padding-top: 10px; outline-style: none" ng-click="vm.downLoadFile()"><span class="glyphicon glyphicon-save" style="color: #ff6c5f"></span></div></td></tr><!-- \u7B2C\u4E8C\u884C \u65F6\u95F4\u63A7\u4EF6--><tr class="bgc-f4f5fa da-solid-border" style="height: 50px"><td><div style="margin-left: 20px" class="float-left width-150"><select ng-model="vm.time" ng-options="x.value for x in vm.times" class="form-control" style="width: 110px; height: 100%" ng-change="vm.changeTime()"></select></div><div style="width: 180px" class="float-left"><input id="field_startTime" type="text" style="width: 116px; margin-left: -40px" class="form-control float-left" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType!=\'month\'"> <input id="field_startTime" type="month" style="width: 156px; margin-left: -40px" class="form-control float-left" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType==\'month\'"></div><div class="float-left height-35 da-solid-border bgcolor-fff" style="width: 35px; margin-left: -110px; padding-top: 5px; padding-left: 10px" ng-if="vm.dataType!=\'month\'">\u81F3</div><div class="float-left height-35 da-solid-border bgcolor-fff" style="width: 35px; margin-left: -80px; padding-top: 5px; padding-left: 10px" ng-if="vm.dataType==\'month\'">\u81F3</div><div><input id="field_endTime" type="text" style="width: 116px; margin-left: -75px" class="form-control float-left" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType!=\'month\'"> <input id="field_endTime" type="month" style="width: 156px; margin-left: -45px" class="form-control float-left" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType==\'month\'"></div><div class="float-left bgcolor-FF6C5F text-center1 salesAnalysis-btn2" ng-click="vm.fondByTime()">\u67E5\u8BE2</div><br></td></tr><!-- \u7B2C\u4E09\u884C \u5185\u5BB9\u663E\u793A--><tr class="da-solid-border height-500"><td><div id="main-da" class="height-500"></div></td></tr></table></div></div>');
$templateCache.put('app/entities/da/salesAnalysis.html','<!--\n         DA \u662F Data Analysis\uFF08\u6570\u636E\u5206\u6790\uFF09\u7684\u7B80\u5199\n\n         \u6B64\u9875\u9762\u662F\u5206\u7C7B\u5206\u6790\n--><div class="listBGC"><div class="current-location"><div><span translate="global.menu.current-location">\u5F53\u524D\u4F4D\u7F6E:</span> <span translate="global.menu.entities.salesManagement3" class="current-menu">salesManagement</span></div></div><div class="con"><div><table class="width-100p wrap-mar-0-12"><tr class="bgc-f4f5fa da-solid-border height-35"><td><span class="font-15 mar-left-15">\u6628\u65E5\u5173\u952E\u6307\u6570</span></td></tr><tr class="da-solid-border height-125"><td><div class="height-80" style="text-align: center"><div class="float-left height-100p width-50p"><span class="font-15">\u8BA2\u5355\u6570</span><br><span class="font-30 color-242424">{{vm.orderSize}}</span></div><div class="float-left height-100p da-solid-border-left width-50p"><span class="font-15">\u9500\u552E\u989D</span><br><span class="font-30 color-242424">{{vm.salesMoney}}</span></div></div></td></tr></table></div><div style="margin-top: 20px"><div class="col-lg-12 col-sm-12 col-xs-12 no-padding text-center1" style="margin-bottom: 20px; margin-left: -12px"><div ng-class="vm.pageType == 0 ? \'bgcolor-FF6C5F text-color\':\'\'" style="border-left: 1px solid #ddd;border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; min-width: 110px; line-height: 38px" class="col-lg-1 col-sm-2 col-xs-3 no-padding" ng-click="vm.changeTopType(0)"><span>\u8BA2\u5355\u6570</span></div><div ng-class="vm.pageType != 0 ? \'bgcolor-FF6C5F text-color\':\'\'" style="min-width: 110px; line-height: 38px" class="col-lg-1 col-sm-2 col-xs-3 da-solid-border no-padding" ng-click="vm.changeTopType(1)"><span>\u9500\u552E\u989D</span></div></div></div><div style="margin-top: 20px"><table class="width-100p wrap-mar-0-12"><!-- \u7B2C\u4E00\u884C --><tr class="bgc-f4f5fa da-solid-border height-35"><td><div class="width-30p" style="text-align: center"><div ng-class="vm.dataType == \'day\' ? \'bgcolor-FF6C5F text-color\':\'\'" class="pad-top-10 float-left height-35 width-100 outline" ng-click="vm.changeType(\'day\')"><span>\u65E5\u7EDF\u8BA1</span></div><div ng-class="vm.dataType == \'month\' ? \'bgcolor-FF6C5F text-color\':\'\'" class="pad-top-10 da-solid-border-left float-left height-35 width-100 outline" ng-click="vm.changeType(\'month\')"><span>\u6708\u7EDF\u8BA1</span></div><div ng-class="vm.dataType == \'quarter\' ? \'bgcolor-FF6C5F text-color\':\'\'" class="pad-top-10 da-solid-border-left da-solid-border-right float-left height-35 width-100 outline" ng-click="vm.changeType(\'quarter\')"><span>\u5B63\u7EDF\u8BA1</span></div></div><!--\u4E0B\u8F7D\u64CD\u4F5C--><div class="float-right width-50" style="padding-top: 10px; outline-style: none" ng-click="vm.downLoadFile()"><span class="glyphicon glyphicon-save" style="color: #ff6c5f"></span></div></td></tr><!-- \u7B2C\u4E8C\u884C \u65F6\u95F4\u63A7\u4EF6--><tr class="bgc-f4f5fa da-solid-border height-56"><td><div style="margin-left: 20px" class="float-left width-150 height-35"><select ng-model="vm.time" ng-options="x.value for x in vm.times" class="form-control" style="width: 110px; height: 100%" ng-change="vm.changeTime()"></select></div><div class="float-left width-180 height-35"><input id="field_startTime" type="text" style="width: 116px; margin-left: -40px" class="form-control float-left" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType!=\'month\'"> <input id="field_startTime" type="month" style="width: 156px; margin-left: -40px" class="form-control float-left" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType==\'month\'"></div><div class="float-left height-35 da-solid-border bgcolor-fff" style="width: 35px; margin-left: -110px; padding-top: 5px; padding-left: 10px" ng-if="vm.dataType!=\'month\'">\u81F3</div><div class="float-left height-35 da-solid-border bgcolor-fff" style="width: 35px; margin-left: -80px; padding-top: 5px; padding-left: 10px" ng-if="vm.dataType==\'month\'">\u81F3</div><div class="float-left width-180 height-35"><input id="field_endTime" type="text" style="width: 116px; margin-left: -75px" class="form-control float-left" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType!=\'month\'"> <input id="field_endTime" type="month" style="width: 156px; margin-left: -45px" class="form-control float-left" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" ng-disabled="vm.dataType==\'quarter\'" ng-if="vm.dataType==\'month\'"></div><div class="float-left bgcolor-FF6C5F text-center1 salesAnalysis-btn outline" ng-click="vm.fondByTime()">\u67E5\u8BE2</div><br></td></tr><!-- \u7B2C\u4E09\u884C \u5185\u5BB9\u663E\u793A--><tr class="da-solid-border height-500"><td><div id="main" class="height-500"></div></td></tr></table></div></div></div>');
$templateCache.put('app/entities/da/userAnalysis.html','<div class="listBGC font-14"><div class="current-location"><span translate="global.menu.current-location">\u5F53\u524D\u4F4D\u7F6E:</span> <span translate="global.menu.entities.userAnalysis" class="current-menu">userAnalysis</span></div><div style="background-color: white"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 da-solid-border bgc-f4f5fa"><div class="col-lg-12 col-sm-12 col-xs-12 pad-top-10 pad-bottom-10">\u6628\u65E5\u5173\u952E\u6307\u6570</div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-top-10 pad-bottom-10 text-center1" style="border-right: 1px solid #ddd;border-left: 1px solid #ddd; border-bottom: 1px solid #ddd"><div class="col-lg-4 col-sm-4 col-xs-4" style="min-height: 60px"><span>\u65B0\u5173\u6CE8\u4EBA\u6570</span><br><span class="font-30">{{vm.yesterday.new_user }}</span></div><div class="col-lg-4 col-sm-4 col-xs-4" style="border-left: 1px solid #ddd;min-height: 60px"><span>\u53D6\u6D88\u5173\u6CE8\u4EBA\u6570</span><br><span class="font-30">{{vm.yesterday.cancel_user }}</span></div><div class="col-lg-4 col-sm-4 col-xs-4" style="border-left: 1px solid #ddd;min-height: 60px"><span>\u7D2F\u79EF\u5173\u6CE8\u4EBA\u6570</span><br><span class="font-30">{{vm.yesterday.cumulate_user }}</span></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-top-10 pad-bottom-10"></div><div class="col-lg-12 col-sm-12 col-xs-12 no-padding text-center1"><div ng-class="vm.pageType == 0 ? \'bgcolor-FF6C5F text-color\':\'\'" style="border-left: 1px solid #ddd;border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; min-width: 110px; line-height: 38px" class="col-lg-1 col-sm-2 col-xs-3 no-padding" ng-click="vm.changeTopType(0)"><span>\u65B0\u5173\u6CE8\u4EBA\u6570</span></div><div ng-class="vm.pageType == 1 ? \'bgcolor-FF6C5F text-color\':\'\'" style="min-width: 110px; line-height: 38px" class="col-lg-1 col-sm-2 col-xs-3 da-solid-border no-padding" ng-click="vm.changeTopType(1)"><span>\u53D6\u6D88\u5173\u6CE8\u4EBA\u6570</span></div><div ng-class="vm.pageType == 2 ? \'bgcolor-FF6C5F text-color\':\'\'" style="border-right: 1px solid #ddd;border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; min-width: 110px; line-height: 38px" class="col-lg-1 col-sm-2 col-xs-3 no-padding" ng-click="vm.changeTopType(2)"><span>\u7D2F\u79EF\u5173\u6CE8\u4EBA\u6570</span></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-top-10 pad-bottom-10"></div><div class="da-solid-border col-lg-12 col-sm-12 col-xs-12 no-padding text-center1 bgc-f4f5fa"><div class="col-lg-1 col-sm-2 col-xs-3 bgcolor-FF6C5F text-color" style="min-width: 110px;line-height: 35px"><span>\u7EDF\u8BA1</span></div><div class="col-lg-1 col-sm-2 col-xs-3 pad-5 col-lg-offset-9 col-sm-offset-7 col-xs-offset-5" ng-click="vm.downLoadFile()"><span class="glyphicon glyphicon-save" style="color: #ff6c5f"></span></div></div><div class="col-lg-12 col-sm-12 col-xs-12 no-padding bgc-f4f5fa" style="border-right: 1px solid #ddd;border-left: 1px solid #ddd; border-bottom: 1px solid #ddd"><div class="col-lg-1 col-sm-3 col-xs-3 pad-5" style="min-width: 120px"><select ng-model="vm.time" ng-options="x.value for x in vm.times" class="form-control" ng-change="vm.changeTime()"></select></div><div class="col-lg-1 col-sm-3 col-xs-3 pad-5" style="min-width: 110px"><input id="field_startTime" type="text" class="form-control" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')"></div><div class="col-lg-1 col-sm-1 col-xs-1 pad-top-10 pad-left-0 pad-right-0" style="max-width: 27px"><label class="control-label readLabel">\u81F3</label></div><div class="col-lg-1 col-sm-3 col-xs-3 pad-5" style="min-width: 110px"><input id="field_endTime" type="text" class="form-control" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')"></div><div class="col-lg-1 col-sm-2 col-xs-2 pad-5" style="max-width: 70px" ng-click="searchDate()"><div class="bgcolor-FF6C5F text-color pad-5 text-center1" style="border-radius: 4px">\u67E5\u8BE2</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 no-padding" style="border-right: 1px solid #ddd;border-left: 1px solid #ddd; border-bottom: 1px solid #ddd"><div id="main-userAnalysis" class="height-500"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-top-10 mar-top-15 text-center1">{{vm.sheetName}}</div></div></div>');
$templateCache.put('app/entities/diyEditorSetting/diy-editor-setting-create.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u65B0\u589E</div><button aria-label="Close" data-dismiss="modal" class="close lh35" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding: 20px"><div class="c-form"><label class="c-form-label">\u9002\u7528\u7F16\u8F91\u5668\uFF1A</label><div class="c-form-div lh35"><select class="form-control border-radius" ng-model="vm.data.editorType"><!--                    <option value="BOOK_JUNIOR" data-translate="backApp.EditorType.BOOK_JUNIOR">BOOK_JUNIOR</option>--><!--                    <option value="BOOK_SENIOR" data-translate="backApp.EditorType.BOOK_SENIOR">BOOK_SENIOR</option>--><option value="POSTER" data-translate="backApp.EditorType.POSTER">POSTER</option><!--                    <option value="PICTURE" data-translate="backApp.EditorType.PICTURE">PICTURE</option>--><!--                    <option value="NEW_EDITOR" data-translate="backApp.EditorType.NEW_EDITOR">NEW_EDITOR</option>--><!--                    <option value="SIMPLEST" data-translate="backApp.EditorType.SIMPLEST">SIMPLEST</option>--></select></div></div><div class="c-form"><label class="c-form-label">\u7F16\u8F91\u5668\u540D\u79F0\uFF1A</label><div class="c-form-div lh35" style="display: flex"><input type="text" class="form-control border-radius" id="field_name" name="field_name" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual()"></span></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="oval-btn-normal" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/diyEditorSetting/diy-editor-setting-dialog.html','<div class="listBGC" style="min-height: 800px" novalidate><div class="con pad-0"><div class="pad-0"><div class="diy-editor-head"><button type="button" class="diy-editor-head-cancel" data-dismiss="modal" ng-click="vm.clear()">\u8FD4\u56DE\u5217\u8868</button> <button type="button" class="diy-editor-head-save" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving"><span>\u4FDD\u5B58</span></button></div><div class="pad-top-50 clearfix"><div class="diy-editor-head-left"><div class="diy-editor-head-left-title"><img src="content/images/editor/expansion.png" width="10px" class="mar-right-10">\u7EC4\u4EF6</div><ul class="diy-editor-head-left-ul"><li><div class="slide-content"><img src="content/images/editor/mubanshape.svg" draggable="true" ondragstart="dragStart(event)" id="mubanshape"><div>\u6A21\u677F</div></div></li><li><div class="slide-content"><img src="content/images/editor/wenzishape.svg" draggable="true" ondragstart="dragStart(event)" id="wenzishape"><div>\u6587\u5B57</div></div></li><li><div class="slide-content"><img src="content/images/editor/sucaishape.svg" draggable="true" ondragstart="dragStart(event)" id="sucaishape"><div>\u7D20\u6750</div></div></li><li><div class="slide-content"><img src="content/images/editor/tupianshape.svg" draggable="true" ondragstart="dragStart(event)" id="tupianshape"><div>\u56FE\u7247</div></div></li></ul></div><div class="diy-editor-head-center"><div class="diy-editor-poster"><div class="diy-editor-poster-top"></div><div class="diy-editor-poster-top2"><img src="content/images/editor/upButtonIcon.svg" ng-click="vm.rightIndex=\'zoomIn\'" ng-hide="vm.data.upButtonSelf&&vm.data.upButtonIcon"> <img ng-src="{{vm.data.upButtonIcon}}" ng-click="vm.rightIndex=\'zoomIn\'" ng-if="vm.data.upButtonSelf&&vm.data.upButtonIcon"> <button type="button" class="c-productThree-btn2" ng-click="vm.rightIndex=\'themeColor\'" ng-style="{\'background\':vm.data.mainColor}">\u5168\u90E8\u4FDD\u5B58</button></div><div class="diy-editor-poster-pic">\u7528\u6237\u7F16\u8F91\u533A\u57DF</div><div class="text-center"><div class="diy-editor-poster-box flex-btn-group-container" id="my-ui-list1"><div class="flex-1 slide-content1" ng-repeat="box in vm.posterBox" ng-show="box.isShow" ng-click="editBox(box)" data-sort-tag="{{$index}}"><div class="diy-editor-poster-box-edit" ng-class="{\'diy-editor-poster-box-edit-active\':vm.pageBox==box.value}"><img ng-src="{{box.img}}" width="16px" height="16px"><div ng-style="{color:box.value==\'wordIcon\'?vm.data.wordColor:box.value==\'templateIcon\'?vm.data.templateColor:box.value==\'clipartIcon\'?vm.data.clipartColor:box.value==\'imgIcon\'?vm.data.imgColor:\'#333\'}">{{box.value==\'wordIcon\'?vm.data.wordText:box.value==\'templateIcon\'?vm.data.templateText:box.value==\'clipartIcon\'?vm.data.clipartText:box.value==\'imgIcon\'?vm.data.imgText:box.name}}</div><img src="content/images/editor/close.png" class="diy-editor-poster-box-edit-del" ng-if="vm.pageBox==box.value" ng-click="deleteTab(event,box)"></div></div></div><div class="diy-editor-poster-edit"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pad-left-0" ng-if="vm.pageBox==\'imgIcon\'"><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'changeImg\'"><img src="content/images/editor/changeImgIcon.svg" width="16px" height="16px" ng-if="!vm.data.changeImgSelf"> <img ng-src="{{vm.data.changeImgIcon||\'content/images/editor/changeImgIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.changeImgSelf"><div ng-style="{color:vm.data.changeImgColor}">{{vm.data.changeImgText||\'\u6362\u56FE\'}}</div></div></div><!--                                    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10">--><!--                                        <div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'filter\'">--><!--                                            <img src="content/images/editor/filterIcon.svg" width="16px" height="16px" ng-if="!vm.data.filterSelf">--><!--                                            <img ng-src="{{vm.data.filterIcon||\'content/images/editor/filterIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.filterSelf">--><!--                                            <div ng-style="{color:vm.data.filterColor}">{{vm.data.filterText||\'\u6EE4\u955C\'}}</div>--><!--                                        </div>--><!--                                    </div>--><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'rotation\'"><img src="content/images/editor/rotationIcon.svg" width="16px" height="16px" ng-if="!vm.data.rotationSelf"> <img ng-src="{{vm.data.rotationIcon||\'content/images/editor/rotationIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.rotationSelf"><div ng-style="{color:vm.data.rotationColor}">{{vm.data.rotationText||\'\u65CB\u8F6C\'}}</div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'up\'"><img src="content/images/editor/upIcon.svg" width="16px" height="16px" ng-if="!vm.data.upSelf"> <img ng-src="{{vm.data.upIcon||\'content/images/editor/upIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.upSelf"><div ng-style="{color:vm.data.upColor}">{{vm.data.upText||\'\u653E\u5927\'}}</div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'down\'"><img src="content/images/editor/downIcon.svg" width="16px" height="16px" ng-if="!vm.data.downSelf"> <img ng-src="{{vm.data.downIcon||\'content/images/editor/downIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.downSelf"><div ng-style="{color:vm.data.downColor}">{{vm.data.downText||\'\u7F29\u5C0F\'}}</div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'flip\'"><img src="content/images/editor/flipIcon.svg" width="16px" height="16px" ng-if="!vm.data.flipSelf"> <img ng-src="{{vm.data.flipIcon||\'content/images/editor/flipIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.flipSelf"><div ng-style="{color:vm.data.flipColor}">{{vm.data.flipText||\'\u7FFB\u8F6C\'}}</div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'restore\'"><img src="content/images/editor/restoreIcon.svg" width="16px" height="16px" ng-if="!vm.data.restoreSelf"> <img ng-src="{{vm.data.restoreIcon||\'content/images/editor/restoreIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.restoreSelf"><div ng-style="{color:vm.data.restoreColor}">{{vm.data.restoreText||\'\u8FD8\u539F\'}}</div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'spread\'"><img src="content/images/editor/spreadIcon.svg" width="16px" height="16px" ng-if="!vm.data.spreadSelf"> <img ng-src="{{vm.data.spreadIcon||\'content/images/editor/spreadIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.spreadSelf"><div ng-style="{color:vm.data.spreadColor}">{{vm.data.spreadText||\'\u5C55\u5F00\'}}</div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'retract\'"><img src="content/images/editor/retractIcon.svg" width="16px" height="16px" ng-if="!vm.data.retractSelf"> <img ng-src="{{vm.data.retractIcon||\'content/images/editor/retractIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.retractSelf"><div ng-style="{color:vm.data.retractColor}">{{vm.data.retractText||\'\u7F29\u56DE\'}}</div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pad-lr-70" ng-if="vm.pageBox==\'wordIcon\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'editWord\'"><img src="content/images/editor/editWordIcon.svg" width="16px" height="16px" ng-if="!vm.data.editWordIconSelf"> <img ng-src="{{vm.data.editWordIcon||\'content/images/editor/editWordIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.editWordIconSelf"><div ng-style="{color:vm.data.editWordColor}">{{vm.data.editWordText||\'\u7F16\u8F91\u6587\u5B57\'}}</div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'wordStyle\'"><img src="content/images/editor/wordStyleIcon.svg" width="16px" height="16px" ng-if="!vm.data.wordStyleIconSelf"> <img ng-src="{{vm.data.wordStyleIcon||\'content/images/editor/wordStyleIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.wordStyleIconSelf"><div ng-style="{color:vm.data.wordStyleColor}">{{vm.data.wordStyleText||\'\u6587\u5B57\u6837\u5F0F\'}}</div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pad-right-0 mar-bottom-10"><div class="diy-editor-poster-box-edit2" ng-click="vm.rightIndex=\'delWord\'"><img src="content/images/editor/delWordIcon.svg" width="16px" height="16px" ng-if="!vm.data.delWordIconSelf"> <img ng-src="{{vm.data.delWordIcon||\'content/images/editor/delWordIcon.svg\'}}" width="16px" height="16px" ng-if="vm.data.delWordIconSelf"><div ng-style="{color:vm.data.delWordColor}">{{vm.data.delWordText||\'\u5220\u9664\u6587\u5B57\'}}</div></div></div></div></div></div></div></div><div class="diy-editor-head-right"><h4 class="diy-editor-head-right-title"><img src="content/images/editor/expansion.png" width="10px" class="mar-right-10">\u7EC4\u4EF6\u8BBE\u7F6E</h4><!--                    \u6A21\u677F--><div ng-if="vm.rightIndex==\'templateIcon\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u6A21\u677F</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.templateSelf}" ng-click="changeSelf(\'templateSelf\',0)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.templateSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.templateSelf}" ng-click="changeSelf(\'templateSelf\',1)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.templateSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.templateSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="templateIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.templateIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.templateIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'templateIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.templateText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u6A21\u677F\u540D\u79F0\', vm.data.templateText, \'name\', \'templateTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.templateColor"><div ng-style="{background:vm.data.templateColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.templateColor}}</span></div></div></div><!--                    \u7D20\u6750--><div ng-if="vm.rightIndex==\'clipartIcon\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u7D20\u6750</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.clipartSelf}" ng-click="changeSelf(\'clipartSelf\',0)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.clipartSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.clipartSelf}" ng-click="changeSelf(\'clipartSelf\',1)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.clipartSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.clipartSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="clipartIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.clipartIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.clipartIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'clipartIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.clipartText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u7D20\u6750\', vm.data.clipartText, \'name\', \'clipartTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.clipartColor"><div ng-style="{background:vm.data.clipartColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.clipartColor}}</span></div></div></div><!--                    \u6587\u5B57--><div ng-if="vm.rightIndex==\'wordIcon\'"><h4 class="diy-editor-head-right-title2">\u6587\u5B57\u8BBE\u7F6E</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.wordIconSelf}" ng-click="changeSelf(\'wordIconSelf\',0)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.wordIconSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.wordIconSelf}" ng-click="changeSelf(\'wordIconSelf\',1)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.wordIconSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.wordIconSelf"><div class="btn_addPic"><input type="file" name="file" data-flag="wordIcon" class="filePrew" accept=" image/*" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.wordIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.wordIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'wordIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.wordText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u6587\u5B57\', vm.data.wordText, \'name\', \'wordTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.wordColor"><div ng-style="{background:vm.data.wordColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.wordColor}}</span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u5B57\u4F53\u9009\u62E9</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.fontSupportSelf}" ng-click="vm.data.fontSupportSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.fontSupportSelf">\u7CFB\u7EDF\u9009\u62E9</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.fontSupportSelf}" ng-click="vm.data.fontSupportSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.fontSupportSelf">\u5355\u72EC\u9009\u62E9</button></div><div class="mar-top-24" ng-if="vm.data.fontSupportSelf"><div ng-repeat="font in vm.data.supportFonts" class="position-relative"><select class="form-control border-radius diy-editor-head-right-sel" ng-model="font.fontManagement.id" ng-options="fo.id as fo.family for fo in vm.fontList" ng-change="chooseFont()"></select><i class="glyphicon glyphicon-remove diy-editor-head-right-del" ng-click="delFont($index)"></i></div><div class="diy-editor-head-right-add" ng-click="addTextFont()"><img src="content/images/editor/add.svg">\u6DFB\u52A0\u5B57\u4F53</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u5B57\u4F53\u989C\u8272</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.fontColorSupportSelf}" ng-click="vm.data.fontColorSupportSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.fontColorSupportSelf">\u7CFB\u7EDF\u9009\u62E9</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.fontColorSupportSelf}" ng-click="vm.data.fontColorSupportSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.fontColorSupportSelf">\u5355\u72EC\u9009\u62E9</button></div><div class="mar-top-24" ng-if="vm.data.fontColorSupportSelf"><div class="position-relative" ng-repeat="fontColor in vm.data.supportFontColors"><input class="leftPanel-bg-choose-color" type="color" ng-model="fontColor.color"><div ng-style="{background:fontColor.color}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2" style="width: 170px">{{fontColor.color}}</span> <i class="glyphicon glyphicon-remove diy-editor-head-right-del" ng-click="delColor($index)"></i></div><div class="diy-editor-head-right-add" ng-click="addColor()"><img src="content/images/editor/add.svg">\u6DFB\u52A0\u5B57\u4F53\u989C\u8272</div></div></div><!--                        <div class="mar-top-20">--><!--                            <h4 class="diy-editor-head-right-title3">\u5B57\u53F7\u5927\u5C0F</h4>--><!--                            <div class="c-form-div">--><!--                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 no-padding">--><!--                                    <input type="text" class="form-control-edit" ng-model="vm.data.fontSizeStart"/>--><!--                                </div>--><!--                                <label class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fontStyle no-padding"--><!--                                       style="text-align: center">\u81F3</label>--><!--                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 no-padding">--><!--                                    <input type="text" class="form-control-edit" ng-model="vm.data.fontSizeEnd"/>--><!--                                </div>--><!--                            </div>--><!--                        </div>--></div><!--                    \u7F16\u8F91\u6587\u5B57--><div ng-if="vm.rightIndex==\'editWord\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u6587\u5B57</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.editWordIconSelf}" ng-click="vm.data.editWordIconSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.editWordIconSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.editWordIconSelf}" ng-click="vm.data.editWordIconSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.editWordIconSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.editWordIconSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="editWordIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.editWordIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.editWordIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'editWordIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.editWordText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u7F16\u8F91\u6587\u5B57\', vm.data.editWordText, \'name\', \'editWordTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.editWordColor"><div ng-style="{background:vm.data.editWordColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.editWordColor}}</span></div></div></div><!--                    \u6587\u5B57\u6837\u5F0F--><div ng-if="vm.rightIndex==\'wordStyle\'"><h4 class="diy-editor-head-right-title2">\u6587\u5B57\u6837\u5F0F</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.wordStyleIconSelf}" ng-click="vm.data.wordStyleIconSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.wordStyleIconSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.wordStyleIconSelf}" ng-click="vm.data.wordStyleIconSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.wordStyleIconSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.wordStyleIconSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="wordStyleIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.wordStyleIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.wordStyleIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'wordStyleIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.wordStyleText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u6587\u5B57\u6837\u5F0F\', vm.data.wordStyleText, \'name\', \'wordStyleTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.wordStyleColor"><div ng-style="{background:vm.data.wordStyleColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.wordStyleColor}}</span></div></div></div><!--                    \u5220\u9664\u6587\u5B57--><div ng-if="vm.rightIndex==\'delWord\'"><h4 class="diy-editor-head-right-title2">\u5220\u9664\u6587\u5B57</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.delWordIconSelf}" ng-click="vm.data.delWordIconSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.delWordIconSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.delWordIconSelf}" ng-click="vm.data.delWordIconSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.delWordIconSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.delWordIconSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="delWordIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.delWordIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.delWordIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'delWordIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.delWordText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u5220\u9664\u6587\u5B57\', vm.data.delWordText, \'name\', \'delWordTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.delWordColor"><div ng-style="{background:vm.data.delWordColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.delWordColor}}</span></div></div></div><!--                    \u4E3B\u8272\u8C03--><div ng-if="vm.rightIndex==\'themeColor\'"><h4 class="diy-editor-head-right-title2">\u4E3B\u9898\u8272\u8C03\u989C\u8272</h4><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u80CC\u666F\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.mainColor"><div ng-style="{background:vm.data.mainColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.mainColor}}</span></div></div></div><!--                    \u653E\u5927\u7F29\u5C0F\u6309\u94AE--><div ng-if="vm.rightIndex==\'zoomIn\'"><h4 class="diy-editor-head-right-title2">\u653E\u5927\u7F29\u5C0F\u6309\u94AE</h4><div><h4 class="diy-editor-head-right-title3">\u653E\u5927ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.upButtonSelf}" ng-click="vm.data.upButtonSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.upButtonSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.upButtonSelf}" ng-click="vm.data.upButtonSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.upButtonSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.upButtonSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="upButtonIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.upButtonIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.upButtonIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'upButtonIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-30"><h4 class="diy-editor-head-right-title3">\u7F29\u5C0FICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.downButtonSelf}" ng-click="vm.data.downButtonSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.downButtonSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.downButtonSelf}" ng-click="vm.data.downButtonSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.downButtonSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.downButtonSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="downButtonIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.downButtonIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.downButtonIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'downButtonIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div></div><!--                    \u56FE\u7247--><div ng-if="vm.rightIndex==\'imgIcon\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.imgSelf}" ng-click="changeSelf(\'imgSelf\',0)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.imgSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.imgSelf}" ng-click="changeSelf(\'imgSelf\',1)"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.imgSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.imgSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="imgIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.imgIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.imgIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'imgIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.imgText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u56FE\u7247\', vm.data.imgText, \'name\', \'imgTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.imgColor"><div ng-style="{background:vm.data.imgColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.imgColor}}</span></div></div></div><!--                    \u6362\u56FE--><div ng-if="vm.rightIndex==\'changeImg\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u6362\u56FE\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.changeImgSelf}" ng-click="vm.data.changeImgSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.changeImgSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.changeImgSelf}" ng-click="vm.data.changeImgSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.changeImgSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.changeImgSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="changeImgIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.changeImgIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.changeImgIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'changeImgIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.changeImgText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u6362\u56FE\', vm.data.changeImgText, \'name\', \'changeImgTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.changeImgColor"><div ng-style="{background:vm.data.changeImgColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.changeImgColor}}</span></div></div></div><!--                    \u6EE4\u955C--><div ng-if="vm.rightIndex==\'filter\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u6EE4\u955C\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.filterSelf}" ng-click="vm.data.filterSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.filterSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.filterSelf}" ng-click="vm.data.filterSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.filterSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.filterSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="filterIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.filterIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.filterIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'filterIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.filterText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u6EE4\u955C\', vm.data.filterText, \'name\', \'filterTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.filterColor"><div ng-style="{background:vm.data.filterColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.filterColor}}</span></div></div></div><!--                    \u65CB\u8F6C--><div ng-if="vm.rightIndex==\'rotation\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u65CB\u8F6C\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.rotationSelf}" ng-click="vm.data.rotationSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.rotationSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.rotationSelf}" ng-click="vm.data.rotationSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.rotationSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.rotationSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="rotationIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.rotationIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.rotationIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'rotationIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.rotationText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u65CB\u8F6C\', vm.data.rotationText, \'name\', \'rotationTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.rotationColor"><div ng-style="{background:vm.data.rotationColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.rotationColor}}</span></div></div></div><!--                    \u653E\u5927--><div ng-if="vm.rightIndex==\'up\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u653E\u5927\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.upSelf}" ng-click="vm.data.upSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.upSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.upSelf}" ng-click="vm.data.upSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.upSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.upSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="upIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.upIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.upIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'upIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.upText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u653E\u5927\', vm.data.upText, \'name\', \'upTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.upColor"><div ng-style="{background:vm.data.upColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.upColor}}</span></div></div></div><!--                    \u7F29\u5C0F--><div ng-if="vm.rightIndex==\'down\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u7F29\u5C0F\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.downSelf}" ng-click="vm.data.downSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.downSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.downSelf}" ng-click="vm.data.downSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.downSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.downSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="downIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.downIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.downIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'downIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.downText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u7F29\u5C0F\', vm.data.downText, \'name\', \'downTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.downColor"><div ng-style="{background:vm.data.downColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.downColor}}</span></div></div></div><!--                    \u7FFB\u8F6C--><div ng-if="vm.rightIndex==\'flip\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u7FFB\u8F6C\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.flipSelf}" ng-click="vm.data.flipSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.flipSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.flipSelf}" ng-click="vm.data.flipSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.flipSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.flipSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="flipIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.flipIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.flipIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'flipIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.flipText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u7FFB\u8F6C\', vm.data.flipText, \'name\', \'flipTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.flipColor"><div ng-style="{background:vm.data.flipColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.flipColor}}</span></div></div></div><!--                    \u8FD8\u539F--><div ng-if="vm.rightIndex==\'restore\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u8FD8\u539F\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.restoreSelf}" ng-click="vm.data.restoreSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.restoreSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.restoreSelf}" ng-click="vm.data.restoreSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.restoreSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.restoreSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="restoreIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.restoreIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.restoreIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'restoreIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.restoreText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u8FD8\u539F\', vm.data.restoreText, \'name\', \'restoreTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.restoreColor"><div ng-style="{background:vm.data.restoreColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.restoreColor}}</span></div></div></div><!--                    \u5C55\u5F00--><div ng-if="vm.rightIndex==\'spread\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u5C55\u5F00\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.spreadSelf}" ng-click="vm.data.spreadSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.spreadSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.spreadSelf}" ng-click="vm.data.spreadSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.spreadSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.spreadSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="spreadIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.spreadIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.spreadIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'spreadIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.spreadText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u5C55\u5F00\', vm.data.spreadText, \'name\', \'spreadTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.spreadColor"><div ng-style="{background:vm.data.spreadColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.spreadColor}}</span></div></div></div><!--                    \u7F29\u56DE--><div ng-if="vm.rightIndex==\'retract\'"><h4 class="diy-editor-head-right-title2">\u7F16\u8F91\u56FE\u7247\uFF08\u7F29\u56DE\uFF09</h4><div><h4 class="diy-editor-head-right-title3">ICON</h4><div class="c-form-div"><button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':!vm.data.retractSelf}" ng-click="vm.data.retractSelf=false"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="!vm.data.retractSelf">\u9ED8\u8BA4</button> <button type="button" class="diy-editor-head-right-btn-gray" ng-class="{\'diy-editor-head-right-btn-active\':vm.data.retractSelf}" ng-click="vm.data.retractSelf=true"><img src="content/images/editor/choose_sel.png" class="diy-editor-choose" ng-if="vm.data.retractSelf">\u81EA\u5B9A\u4E49</button></div><div class="mar-top-30" ng-if="vm.data.retractSelf"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept=" image/*" data-flag="retractIcon" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.data.retractIcon" class="vertical-align-top"><img class="picture-border" ng-src="{{vm.data.retractIcon}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'retractIcon\')" style="color: red"></i></span><div class="register-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A40x40px</div></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u6848</h4><div class="c-form-div"><input type="text" class="diy-editor-right-input" ng-model="vm.data.retractText" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="4"> <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(\'\u7F29\u56DE\', vm.data.retractText, \'name\', \'retractTextLanguages\')"></span></div></div><div class="mar-top-20"><h4 class="diy-editor-head-right-title3">\u6587\u5B57\u989C\u8272</h4><div class="c-form-div position-relative"><input class="leftPanel-bg-choose-color" type="color" ng-model="vm.data.retractColor"><div ng-style="{background:vm.data.retractColor}" style="width: 65px;height: 32px;display: inline-block"></div><span class="diy-editor-right-input2">{{vm.data.retractColor}}</span></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/diyEditorSetting/diy-editor-setting.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u6237 / <span>DIY\u7F16\u8F91\u5668</span></div><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><button class="oval-btn-normal" ng-click="createEditor()"><i class="icon iconfont webadd"></i>\u65B0\u5EFA\u7F16\u8F91\u5668</button></div></div><div class="table-responsive white pad-left-15 pad-linksright-15" style="min-height: 480px"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="backApp.diyEditorSetting.lastCreateData">lastCreateData</span></th><th><span data-translate="backApp.diyEditorSetting.name">name</span></th><th><span data-translate="backApp.diyEditorSetting.dialgTarget">dialgTarget</span></th><th style="width: 150px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="item in vm.items track by item.id"><td>{{item.lastModifiedDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td style="display: flex;align-items: center;justify-content: center">{{item.name}} <span class="iconfont webduoyuyan mar-left-10" ng-click="vm.multilingual(item)"></span></td><td data-translate="{{\'backApp.EditorType.\' + item.editorType}}">{{item.editorType}}</td><td class="text-right"><div><button type="submit" ui-sref="diy-editor-setting.edit({id:item.id})" class="btn-text" style="border-right: 1px solid #e9e9e9;padding-right: 10px">\u7F16\u8F91</button> <button type="submit" ng-click="delete(item)" class="btn-text">\u5220\u9664</button></div></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/feedback/feedback-detail.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" id="myBannerLabel" translate="backApp.feedback.home.show">Create or edit a Banner</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.title" for="number">title</label><div class="col-md-9 col-sm-9 col-xs-9"><span class="form-control border-radius" name="title" id="title">{{vm.feedback.title}}</span></div></div></div><div class="col-lg-12 col-sm-12 form-group" ng-repeat="line in vm.feedback.feedbackLines track by $index" ng-class="line.type == \'Reply\' || line.type == \'Asking\' ? \'borderLine-top\' :\'\'"><div class="form-group"><label ng-if="line.type == \'Problem\'" class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.description">description</label><label ng-if="line.type == \'Reply\'" class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.reply">reply</label><label ng-if="line.type == \'Asking\'" class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.ask">ask</label><div class="col-md-9 col-sm-9 col-xs-9"><span class="form-control border-radius" name="description" id="description" style="width:100%;word-break: break-all;height: auto">{{line.description}}</span></div><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" style="margin-top: 10px" ng-if="line.attachments && line.attachments.length>0" translate="backApp.feedback.img">img</label><div class="col-md-9 col-sm-9 col-xs-9" ng-if="line.attachments && line.attachments.length>0" style="margin-top: 10px"><span ng-repeat="attachment in line.attachments track by $index" style="width:100%;word-break: break-all;margin-right: 20px;text-decoration: underline" ng-click="downloadZipFile3(attachment)">{{attachment.fileName}}</span></div></div><div class="col-md-9 col-sm-9 col-xs-9 col-md-offset-3 col-sm-offset-3 col-xs-offset-3" ng-if="line.type == \'Reply\'" style="color: #c7c7c7;font-size: 12px"><span translate="backApp.feedback.replyTime" style="margin-right: 10px">replyTime</span>{{ line.createdDate | date:\'mediumDate\'}} <span class="solve" ng-if="vm.feedback.status!=\'Resolve\'" translate="backApp.feedback.unresolved" ng-click="vm.unresolved(vm.feedback)">unresolved</span> <span class="solve" ng-if="vm.feedback.status!=\'Unresolved\'" translate="backApp.feedback.resolve" ng-click="vm.resolve(vm.feedback.id)">resolved</span></div></div></div><!--\u8FFD\u52A0\u90E8\u5206--><div class="panel-body form-horizontal" ng-if="vm.askProblem" style="background: #F7F7F7"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.ask">ask</label><div class="col-md-9 col-sm-9 col-xs-9"><textarea type="ask" class="form-control border-radius" name="ask" id="ask" required ng-minlength="2" ng-model="vm.askContent" style="resize: none"></textarea></div><div ng-show="editForm.ask.$dirty && editForm.ask.$invalid" class="col-md-offset-3 col-sm-offset-3 col-xs-offset-3"><p class="help-block" ng-show="editForm.ask.$error.required" data-translate="global.messages.validate.ask.required">Your ask is required.</p><p class="help-block" ng-show="editForm.ask.$error.minlength" data-translate="global.messages.validate.minlength2">Your ask is required to be at least 2 characters.</p></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.img" for="file">img</label><div class="col-md-9 col-sm-9 col-xs-9"><input ng-if="vm.attachments.length ==0" type="file" name="file" id="file" multiple="multiple" style="border: none;background: #F7F7F7" class="form-control border-radius" type="file" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <span ng-if="vm.attachments.length >0 && attach" ng-repeat="attach in vm.attachments track by $index" style="float:left;word-break: break-all;display: inline-block;margin-top: 10px;margin-right: 10px"><span>{{attach.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(attach,$index)" style="color: red"></i></span></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info" ng-show="vm.askSubmit"><span translate="entity.action.submit">submit</span></button> <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></form>');
$templateCache.put('app/entities/feedback/feedback-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" id="myBannerLabel" translate="backApp.feedback.home.createLabel">Create or edit a Banner</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.title" for="title">title</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control border-radius" name="title" id="title" ng-minlength="2" required ng-maxlength="20" ng-model="vm.feedback.title"></div><div ng-show="editForm.title.$dirty && editForm.title.$invalid" class="col-md-offset-3 col-sm-offset-3 col-xs-offset-3" style="padding-left: 15px"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="global.messages.validate.title.required">Your title is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="global.messages.validate.minlength2">Your title is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="global.messages.validate.maxlength20">Your title cannot be longer than 20 characters.</p></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.description">description</label><div class="col-md-9 col-sm-9 col-xs-9"><textarea type="description" class="form-control border-radius" name="description" id="description" required ng-minlength="2" ng-maxlength="200" ng-model="vm.feedback.description"></textarea></div><div ng-show="editForm.description.$dirty && editForm.description.$invalid" class="col-md-offset-3 col-sm-offset-3 col-xs-offset-3"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="global.messages.validate.description.required">Your description is required.</p><p class="help-block" ng-show="editForm.description.$error.minlength" data-translate="global.messages.validate.minlength2">Your description is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="global.messages.validate.maxlength200">Your description cannot be longer than 200 characters.</p></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.feedback.img" for="file">img</label><div class="col-md-9 col-sm-9 col-xs-9 clearfix"><input ng-if="vm.attachments.length ==0" type="file" name="file" id="file" multiple="multiple" style="border: none" class="form-control border-radius" type="file" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <span ng-if="vm.attachments.length >0 && attach" ng-repeat="attach in vm.attachments track by $index" style="float:left;word-break: break-all;display: inline-block;margin-top: 10px;margin-right: 10px"><span>{{attach.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(attach,$index)" style="color: red"></i></span></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span translate="entity.action.submit">submit</span></button> <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></form>');
$templateCache.put('app/entities/feedback/feedback.html','<div class="listBGC"><div class="current-location"><div><span translate="global.menu.current-location">\u5F53\u524D\u4F4D\u7F6E:</span> <span translate="backApp.feedback.home.all feedbacks" class="current-menu">all feedbacks</span></div></div><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22"> <span class="input-group-btn width-min btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.currentSearch"><button class="btn btn-info btn-new-padding" ng-click="vm.clear()"><span translate="global.form.clear"></span></button></span></div><div class="input-group pull-right"><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><div uib-dropdown class="dropdown pointer"><p class="dropdown-toggle moduleNavbarColor arrowHover" uib-dropdown-toggle id="account-menu2"><span class="users-a">{{vm.status == null?\'\u5904\u7406\u72B6\u6001\':vm.status== \'Untreated\'?\'\u672A\u5904\u7406\':vm.status== \'Treated\'?\'\u5DF2\u5904\u7406\':vm.status== \'Resolve\'?\'\u5DF2\u89E3\u51B3\':vm.status== \'Unresolved\'?\'\u672A\u89E3\u51B3\':\'\u5904\u7406\u72B6\u6001\'}} </span><b style="color:#ff6c5f" class="arrows-icon"></b></p><ul class="dropdown-menu" uib-dropdown-menu style="width:100px; min-width: 100px"><li ui-sref-active="active" ng-switch-when="true"><a ng-click="byStatus()"><span>\u5904\u7406\u72B6\u6001</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ng-click="byStatus(\'Untreated\')"><span>\u672A\u5904\u7406</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ng-click="byStatus(\'Treated\')"><span>\u5DF2\u5904\u7406</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ng-click="byStatus(\'Resolve\')"><span>\u5DF2\u89E3\u51B3</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ng-click="byStatus(\'Unresolved\')"><span>\u672A\u89E3\u51B3</span></a></li></ul></div></div></div></form></div><span class="input-group-btn width-min btn-clear" ui-sref="feedback.new" style="margin: 0 30px 0 -10px!important"><button class="btn btn-info btn-new-padding"><span translate="backApp.feedback.home.createLabel">Create new banner</span></button></span></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="backApp.feedback.index">index</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="backApp.feedback.title">title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdBy"><span data-translate="backApp.feedback.submitter">submitter</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span data-translate="backApp.feedback.createTime">createTime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="submitTime"><span data-translate="backApp.feedback.submitTime">submitTime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="backApp.feedback.status">status</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="feedback in vm.feedbacks track by feedback.id"><td style="display: table-cell; vertical-align: middle">{{feedback.id}}</td><td style="display: table-cell; vertical-align: middle">{{feedback.title}}</td><td style="display: table-cell; vertical-align: middle">{{feedback.createdBy}}</td><td style="display: table-cell; vertical-align: middle">{{feedback.createdDate | date:\'mediumDate\'}}</td><td style="display: table-cell; vertical-align: middle">{{feedback.submitTime | date:\'mediumDate\'}}</td><td style="display: table-cell; vertical-align: middle"><span style="color:red">{{feedback.status== \'Untreated\'?\'\u672A\u5904\u7406\':feedback.status== \'Treated\'?\'\u5DF2\u5904\u7406\':feedback.status== \'Resolve\'?\'\u5DF2\u89E3\u51B3\':feedback.status== \'Unresolved\'?\'\u672A\u89E3\u51B3\':\'\u5904\u7406\u72B6\u6001\'}}</span></td><td class="text-right"><div class="right-btn"><button type="submit" ui-sref="feedback-detail({id:feedback.id})" class="btn-sub btn1"><span class="glyphicon btn-check"></span><p class="hover-box">\u67E5\u770B</p></button></div></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/font-management/font-management-detail.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u67E5\u770B/\u5B57\u4F53\u7D20\u6750</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.fontManagement.family">fontStyle</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.fontManagement.family}}</div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.fontManagement.fontStyle">fontStyle</label><div class="col-md-9 col-sm-9 col-xs-9" ng-repeat="fontStyle in vm.fontManagement.fontStyles track by $index"><span translate="{{\'backApp.style.\'+fontStyle.style}}">{{fontStyle.style}}</span></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/font-management/font-management-dialog.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u65B0\u589E/\u5B57\u4F53\u7D20\u6750</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" data-translate="editorApp.fontManagement.family">Family</label><div class="col-md-9 col-sm-9 col-xs-9"><input style="outline: none" type="file" accept=".ttf, .otf, .fon" class="upload-input" onchange="uploadFile(event)" multiple="multiple"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/font-management/font-managements.html','<div class="listBGC"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u5B57\u4F53\u7BA1\u7406</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ui-sref="font-management.new"><i class="icon iconfont webadd"></i> <span>\u65B0\u589E\u5B57\u4F53</span></button></div><span style="float: right;margin-top: 4px" class="transition" ng-class="vm.listStyle == \'Card\' ? \'\' : \'rotate180\'" ng-click="switchStyle()"><img style="width: 25px" src="content/images/icon/CardOrList.svg" alt=""></span><div class="searchBar" style="margin-right: 10px"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15" ng-show="vm.listStyle == \'Card\'"><div class="pic-geometry" style="position:relative" ng-repeat="fontManagement in vm.fontManagements track by fontManagement.id"><div class="pic-model" style="height: 85px"><div ng-repeat="fontStyle in fontManagement.fontStyles"><img ng-src="{{vm.domainQ + fontStyle.identifier}}" style="width: 100%" ng-if="fontStyle.identifier"> <img src="content/images/icon/TTF.png" style="width: 70%" ng-if="!fontStyle.identifier"></div></div><div style="padding-top: 7px" class="fontName">{{fontManagement.family}}</div><div class="pic-edit2"><button ui-sref="font-management-detail({id:fontManagement.id})" style="color: #ffffff;font-size: 16px" class="status-btn" type="submit"><i class="icon iconfont webchakan" style="font-size:12px !important"></i>\u67E5\u770B</button> <button ng-click="defaultShow(fontManagement)" style="color: #ffffff;font-size: 16px" class="status-btn" type="submit"><i class="icon iconfont webxiugai"></i>\u9ED8\u8BA4</button> <button ng-click="delete(fontManagement.id)" style="color: #ffffff;font-size: 16px" class="status-btn" type="submit"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></div><span ng-if="fontManagement.defaultShow" class="el-tage l-tag--warning" style="position:absolute;left: -1px;top: -1px">\u9ED8\u8BA4</span></div></div><div class="table-responsive pad-left-15 pad-right-15" ng-show="vm.listStyle == \'List\'"><table class="za-table table table-striped"><thead><tr style="font-weight: bold" jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" class="fw10"><span class="glyphicon glyphicon-sort"></span><span>ID</span></th><th class="fw10"><span>\u540D\u79F0</span></th><th class="fw10"><span>\u5B57\u4F53\u5C55\u793A</span></th><th class="fw8"><span>\u8BBE\u4E3A\u9ED8\u8BA4</span></th><th class="fw8"><span>\u662F\u5426\u6709\u6548</span></th><th class="fw8"><span>\u652F\u6301\u4E2D\u6587</span></th><th class="fw8"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="fontManagement in vm.fontManagements track by fontManagement.id"><td class="vertical-middle">{{fontManagement.id}}</td><td class="vertical-middle">{{fontManagement.family}} <span class="iconfont webduoyuyan" ng-click="vm.multilingual(fontManagement)"></span></td><td class="vertical-middle"><div ng-repeat="fontStyle in fontManagement.fontStyles"><img ng-src="{{vm.domainQ + fontStyle.identifier}}" style="width: 100px" ng-if="fontStyle.identifier"> <img src="content/images/icon/TTF.png" style="width: 50px" ng-if="!fontStyle.identifier"></div></td><td class="vertical-middle"><label class="i-switch"><div style="margin-left: 7px" ng-show="fontManagement.defaultShow">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!fontManagement.defaultShow">\u505C\u7528</div><input type="checkbox" ng-model="fontManagement.defaultShow" ng-change="defaultShow(fontManagement)" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></td><td>{{fontManagement.enable ? \'\u662F\' : \'\u5426\'}}</td><td>{{fontManagement.chineseSupport ? \'\u662F\' : \'\u5426\'}}</td><td style="width: 200px; max-width: 200px; min-width: 200px"><button class="status-btn" type="submit" ui-sref="font-management-detail({id:fontManagement.id})"><i class="icon iconfont webchakan"></i> <span class="hover-span">\u67E5\u770B</span></button> <button class="status-btn" type="submit" ng-click="delete(fontManagement.id)"><i class="icon iconfont webshanchu"></i> <span class="hover-span">\u5220\u9664</span></button></td></tr></tbody></table></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div></div><style>.el-tage.l-tag--warning {\n    background-color: #ffffff;\n    border-color: #7541e9;\n    color: #7541e9;\n}\n.el-tage {\n    background-color: #ecf5ff;\n    display: inline-block;\n    padding:1px 7px;\n    font-size: 12px;\n    color: #409eff;\n    border: 1px solid #d9ecff;\n    border-radius:0 0 4px 0;\n    box-sizing: border-box;\n    white-space: nowrap;\n}</style>');
$templateCache.put('app/entities/frame-config/frame-config.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u8FB9\u6846</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h mar-top-20" style="min-height: 35px"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="c-form pull-left" style="position: relative;left: -20px"><label class="c-form-label">\u5206\u7C7B</label><div class="c-form-div" style="width: 120px"><select ng-model="vm.themeClassifyId" class="c-select1" ng-options="c.id as c.name for c in vm.class"><option value="">\u5168\u90E8\u5206\u7C7B</option></select></div></div><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr style="font-weight: bold"><th class="fw8"><span>\u540D\u79F0</span></th><th class="fw8"><span>\u5206\u7C7B</span></th><th class="fw8"><span>\u6392\u5E8F</span></th><th class="fw8"><span>\u5C55\u793A\u56FE</span></th><th class="fw8"><span>\u72B6\u6001</span></th><th class="fw8"><span>\u542F\u7528</span></th><th class="fw8"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="frame in vm.textXmls track by frame.id"><td class="vertical-middle">{{frame.name}}</td><td style="line-height: 100px">{{frame.themeClassifyName}}</td><td class="vertical-middle">{{frame.seq}}</td><td class="vertical-middle"><img style="width: 100px; height: 100px; border: 1px dashed red" ng-src="{{frame.cover}}"></td><td style="line-height: 100px">{{vm.status(frame.status)}}</td><td class="vertical-middle"><label class="i-switch" ng-click="changeStatue(frame.id,$event)"><div style="margin-left: 7px" ng-show="frame.enable">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!frame.enable">\u505C\u7528</div><input type="checkbox" ng-model="frame.enable" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></td><td style="width: 260px; max-width: 260px; min-width: 200px"><button class="status-btn" type="submit" ui-sref="frame-config-edit({id:frame.id})"><i class="icon iconfont webxiugai"></i> <span class="hover-span">\u7F16\u8F91</span></button> <button class="status-btn" type="submit" ng-if="frame.status == \'Created\' || frame.status == null" ui-sref="frame-config-approve({id:frame.id})"><i class="icon iconfont webai53"></i> <span class="hover-span">\u901A\u8FC7</span></button> <button class="status-btn" type="submit" ng-if="frame.status == \'Created\' || frame.status == null" ng-click="rejected(frame)"><i class="icon iconfont webRectangleCopy"></i> <span class="hover-span">\u62D2\u7EDD</span></button> <button class="status-btn" type="submit" ng-click="delete(frame.id)"><i class="icon iconfont webshanchu"></i> <span class="hover-span">\u5220\u9664</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/hue/hue.html','<div class="listBGC"><span class="breadcrumb-normal">\u5546\u6237 / <span class="breadcrumb-normal-step">\u81EA\u5B9A\u4E49\u8272\u8C03</span></span><div class="list-title"><label class="colorText">\u6587\u5B57\u9009\u4E2D\uFF1A</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.mobileTextSelectedColor" ng-change="chooseTextColor()" ng-style="{\n                       \'background-color\' : vm.data.mobileTextSelectedColor}"> {{vm.data.mobileTextSelectedColor}}</div><label class="mar-left-106" content="colorText">\u6309\u94AE\u80CC\u666F\u8272\uFF1A</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.mobileButtonBackColor" ng-change="chooseTextColor()" ng-style="{\n                       \'background-color\' : vm.data.mobileButtonBackColor}"> {{vm.data.mobileButtonBackColor}}</div></div><div style="display:flex;justify-content: end;margin: 10px 0"><button class="oval-btn-normal" ng-click="resetColor()"><img src="content/images/icon/reset.png" id="resetIcon" style="width:18px;margin-right: 5px" alt=""> <span>\u91CD\u7F6E\u8272\u8C03</span></button></div><div class="col-lg-4 col-sm-4 form-group pad-0 store-body"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-4 col-sm-4">\u5BFC\u822A\u680F</div><div class="col-lg-8 col-sm-8 store-body-head-btn"></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div class="mar-bottom-20"><label class="colorText width-100">\u5BFC\u822A\u80CC\u666F\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.webNavbarBackColor" ng-style="{\'background-color\' : vm.data.webNavbarBackColor}"> {{vm.data.webNavbarBackColor}}</div></div><div class="mar-bottom-20"><label class="colorText width-100">\u6807\u9898\u989C\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.webTitleColor" ng-style="{\'background-color\' : vm.data.webTitleColor}"> {{vm.data.webTitleColor}}</div></div><div class="mar-bottom-20"><label class="colorText width-100">\u4E3B\u6309\u94AE\u80CC\u666F\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.webMainButtonBackColor" ng-style="{\'background-color\' : vm.data.webMainButtonBackColor}"> {{vm.data.webMainButtonBackColor}}</div></div><div class="mar-bottom-20"><label class="colorText width-100">\u4E3B\u6309\u94AE\u6587\u5B57</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.webMainButtonTextColor" ng-style="{\'background-color\' : vm.data.webMainButtonTextColor}"> {{vm.data.webMainButtonTextColor}}</div></div><div class="mar-bottom-20"><label class="colorText width-100">\u6B21\u6309\u94AE\u80CC\u666F\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.webSecondButtonBackColor" ng-style="{\'background-color\' : vm.data.webSecondButtonBackColor}"> {{vm.data.webSecondButtonBackColor}}</div></div><div class="mar-bottom-20"><label class="colorText width-100">\u6B21\u6309\u94AE\u6587\u5B57</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.webSecondButtonTextColor" ng-style="{\'background-color\' : vm.data.webSecondButtonTextColor}"> {{vm.data.webSecondButtonTextColor}}</div></div><!-- <div class="mar-bottom-20">\n                <label class="colorText width-100">\u6B21\u6309\u94AE\u5DE6\u8FB9\u6846</label>\n                <div class="colorDiv">\n                    <input class="colorBtn" type="color" ng-model="vm.data.webSecondButtonLeftBorderColor" ng-style="{\'background-color\' : vm.data.webSecondButtonLeftBorderColor}" />\n                    {{vm.data.webSecondButtonLeftBorderColor}}\n                </div>\n            </div> --></div></div><div class="col-lg-4 col-sm-4 form-group"><div class="col-lg-12 col-sm-12 pad-0 store-body"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-4 col-sm-4">\u4FA7\u8FB9\u680F</div><div class="col-lg-8 col-sm-8 store-body-head-btn"></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div class="mar-bottom-20"><label class="colorText width-130">\u80CC\u666F\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.sidebarBackColor" ng-style="{\'background-color\' : vm.data.sidebarBackColor}"> {{vm.data.sidebarBackColor}}</div></div><!-- <div class="mar-bottom-20">\n                    <label class="colorText width-130">\u9009\u4E2D\u524D\u6309\u94AE\u80CC\u666F\u8272</label>\n                    <div class="colorDiv">\n                        <input class="colorBtn" type="color" ng-model="vm.data.sidebarUnselectButtonBackColor" ng-style="{\'background-color\' : vm.data.sidebarUnselectButtonBackColor}" />\n                        {{vm.data.sidebarUnselectButtonBackColor}}\n                    </div>\n                </div> --><div class="mar-bottom-20"><label class="colorText width-130">\u9009\u4E2D\u524D\u6309\u94AE\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.sidebarUnselectButtonForeColor" ng-style="{\'background-color\' : vm.data.sidebarUnselectButtonForeColor}"> {{vm.data.sidebarUnselectButtonForeColor}}</div></div><!-- <div class="mar-bottom-20">\n                    <label class="colorText width-130">\u9009\u4E2D\u540E\u6309\u94AE\u80CC\u666F\u8272</label>\n                    <div class="colorDiv">\n                        <input class="colorBtn" type="color" ng-model="vm.data.sidebarSelectedButtonBackColor" ng-style="{\'background-color\' : vm.data.sidebarSelectedButtonBackColor}" />\n                        {{vm.data.sidebarSelectedButtonBackColor}}\n                    </div>\n                </div> --><div class="mar-bottom-20"><label class="colorText width-130">\u9009\u4E2D\u540E\u6309\u94AE\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.sidebarSelectedButtonForeColor" ng-style="{\'background-color\' : vm.data.sidebarSelectedButtonForeColor}"> {{vm.data.sidebarSelectedButtonForeColor}}</div></div><!-- <div class="mar-bottom-20">\n                    <label class="colorText width-130">\u6309\u94AE\u60AC\u6D6E\u80CC\u666F\u8272</label>\n                    <div class="colorDiv">\n                        <input class="colorBtn" type="color" ng-model="vm.data.sidebarFloatButtonBackColor" ng-style="{\'background-color\' : vm.data.sidebarFloatButtonBackColor}" />\n                        {{vm.data.sidebarFloatButtonBackColor}}\n                    </div>\n                </div> --></div></div><div class="col-lg-12 col-sm-12 pad-0 store-body mar-top-10" style="min-height: 100px"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-4 col-sm-4">\u901A\u7528\u989C\u8272\u8BBE\u7F6E</div><div class="col-lg-8 col-sm-8 store-body-head-btn"></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div class="mar-bottom-20"><label class="colorText width-100">\u901A\u7528\u989C\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.genericColor" ng-style="{\'background-color\' : vm.data.genericColor}"> {{vm.data.genericColor}}</div></div></div></div></div><div class="col-lg-4 col-sm-4 form-group pad-0"><div class="col-lg-12 col-sm-12 pad-0 store-body"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-4 col-sm-4">\u5DE5\u5177\u680F</div><div class="col-lg-8 col-sm-8 store-body-head-btn"></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div class="mar-bottom-20"><label class="colorText width-130">\u80CC\u666F\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.toolbarBackColor" ng-style="{\'background-color\' : vm.data.toolbarBackColor}"> {{vm.data.toolbarBackColor}}</div></div><!-- <div class="mar-bottom-20">\n                    <label class="colorText width-130">\u6309\u94AE\u80CC\u666F\u8272</label>\n                    <div class="colorDiv">\n                        <input class="colorBtn" type="color" ng-model="vm.data.toolbarButtonBackColor" ng-style="{\'background-color\' : vm.data.toolbarButtonBackColor}" />\n                        {{vm.data.toolbarButtonBackColor}}\n                    </div>\n                </div> --><div class="mar-bottom-20"><label class="colorText width-130">\u6309\u94AE\u9ED8\u8BA4\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.toolbarButtonDefaultColor" ng-style="{\'background-color\' : vm.data.toolbarButtonDefaultColor}"> {{vm.data.toolbarButtonDefaultColor}}</div></div><!-- <div class="mar-bottom-20">\n                    <label class="colorText width-130">\u6309\u94AE\u60AC\u6D6E\u8272</label>\n                    <div class="colorDiv">\n                        <input class="colorBtn" type="color" ng-model="vm.data.toolbarFloatButtonBackColor" ng-style="{\'background-color\' : vm.data.toolbarFloatButtonBackColor}" />\n                        {{vm.data.toolbarFloatButtonBackColor}}\n                    </div>\n                </div> --><div class="mar-bottom-20"><label class="colorText width-130">\u6309\u94AE\u9009\u4E2D\u8272</label><div class="colorDiv"><input class="colorBtn" type="color" ng-model="vm.data.toolbarSelectedButtonBackColor" ng-style="{\'background-color\' : vm.data.toolbarSelectedButtonBackColor}"> {{vm.data.toolbarSelectedButtonBackColor}}</div></div></div></div></div><div class="col-lg-12 col-sm-12 list-title"><div class="col-lg-12 col-sm-12"><label class="colorText">\u7F51\u9875\u7AEF-\u9884\u89C8\u9875\u80CC\u666F\uFF1A</label><div class="c-form"><div class="c-form-div"><input ng-if="!vm.data.previewBkWeb" type="file" name="file" class="form-control border-radius input-upload" type="file" accept="image/jpeg, image/png" onchange="uploadPic(event, \'previewBkWeb\')" ng-model-options="{debounce : 500}"><div class="pic-upload" ng-if="!vm.data.previewBkWeb"><img src="content/images/icon/upload_img.svg"></div><div ng-if="vm.data.previewBkWeb"><img class="picture-border" style="height: 164px; width: 294px" ng-src="{{vm.data.previewBkWeb}}?imageMogr2/auto-orient"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'previewBkWeb\')" style="color: red"></i></div><div class="" style="color:#b3a8a8; font-size: 12px">\u5EFA\u8BAE\u5C3A\u5BF8\uFF1A1470px*820px</div></div></div></div><div class="col-lg-12 col-sm-12"><label class="colorText">\u79FB\u52A8\u7AEF-\u9884\u89C8\u9875\u80CC\u666F\uFF1A</label><div class="c-form"><div class="c-form-div"><input ng-if="!vm.data.previewBkMobile" type="file" name="file" class="form-control border-radius input-upload" type="file" accept="image/jpeg, image/png" onchange="uploadPic(event, \'previewBkMobile\')" ng-model-options="{debounce : 500}"><div class="pic-upload" ng-if="!vm.data.previewBkMobile"><img src="content/images/icon/upload_img.svg"></div><div ng-if="vm.data.previewBkMobile"><img class="picture-border" style="height: 180px; width: 150px" ng-src="{{vm.data.previewBkMobile}}?imageMogr2/auto-orient"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'previewBkMobile\')" style="color: red"></i></div><div class="" style="color:#b3a8a8; font-size: 12px">\u5EFA\u8BAE\u5C3A\u5BF8\uFF1A750px*900px</div></div></div></div><!--        <label class="colorText">\u9884\u89C8\u80CC\u666F(\u7F51\u9875\u7AEF)\uFF1A</label>--><!--        <div class="colorDiv">--><!--            <input class="colorBtn" type="color" ng-model="vm.data.mobileTextSelectedColor" ng-change="chooseTextColor()" ng-style="{--><!--                   \'background-color\' : vm.data.mobileTextSelectedColor}" />--><!--            {{vm.data.mobileTextSelectedColor}}--><!--        </div>--><!--        <label class="mar-left-106" content="colorText">\u9884\u89C8\u80CC\u666F(\u79FB\u52A8\u7AEF)\uFF1A</label>--><!--        <div class="colorDiv">--><!--            <input class="colorBtn" type="color" ng-model="vm.data.mobileButtonBackColor" ng-change="chooseTextColor()" ng-style="{--><!--                   \'background-color\' : vm.data.mobileButtonBackColor}" />--><!--            {{vm.data.mobileButtonBackColor}}--><!--        </div>--></div><div class="col-lg-12 col-sm-12 colorSave"><button type="submit" class="small-btn-disabled" ng-click="save()"><span>\u4FDD\u5B58</span></button></div></div><style>.c-form-label {\n    width: 150px !important;\n}\n\n.c-form-div {\n    margin-left: 150px !important;\n    width: auto !important;\n}</style>');
$templateCache.put('app/entities/initialization/commodity.html','<div class="listBGC" style="min-width: 1300px"><div class="c-book" style="padding: 0 20px 20px"><div class="init-head"><h2>\u611F\u8C22\u60A8\u52A0\u5165MOMENTSGO\uFF0C\u8BF7\u5148\u8BBE\u7F6E\u60A8\u7684\u5546\u5E97</h2></div><div class="c-book-body" style="border: 1px solid #ddd"><div class="c-book-body-nav1"><ul class="clearfix"><li ng-repeat="item in vm.classifyList track by $index" ng-class="{\'bookNavOn\': item.id == vm.classify.id}" ng-click="classifyCb(item)" ng-if="vm.classifyList.length > 0"><span>{{item.name}}</span></li></ul><span ng-if="vm.classifyList.length == 0" style="color: #999; display: inline-block; line-height: 40px; text-align: center; width: 100%">\u6682\u65E0\u5546\u54C1\u5206\u7C7B</span></div><div class="c-book-body-content1"><div class="c-book-body-content-top"><ul class="clearfix" ng-if="vm.products1.length > 0"><li class="c-book-sku" ng-repeat="item in vm.products1 track by $index" ng-click="itemValueLinesCb(item)"><div class="c-book-sku-img"><img ng-src="{{domain + item.coverImg}}?imageMogr2/auto-orient" alt=""></div><div class="c-book-sku-text"><span class="checkbox-icon checkbox-0" style="display: inline-block;margin-top: 0" ng-if="!item.selected"></span> <span class="checkbox-icon checkbox-1" style="display: inline-block;margin-top: 0" ng-if="item.selected"></span> <span title="{{item.name}}">{{item.name}}</span></div></li></ul><div class="c-book-skuNo" ng-if="vm.products1.length == 0"><span>\u6682\u65E0\u6570\u636E</span></div></div><div class="c-book-paging" ng-show="vm.products1.length > 0"><div id="c-paging" style="display: inline-block"></div><span style="color: #999" ng-if="vm.products.length > vm.products1.length && vm.page == 1">\u603B\u5171{{vm.products.length}}\u6761\u6570\u636E</span></div></div><div class="c-book-body-item"><div class="c-book-body-item-title">\u5DF2\u9009\u5546\u54C1</div><ul class="clearfix"><li ng-repeat="item in vm.item track by $index">{{item.name}}</li></ul></div></div><div style="text-align: center; margin-top: 20px"><button class="oval-btn-normal-empty" ng-click="back()"><span>\u4E0A\u4E00\u6B65\uFF0C\u914D\u7F6E\u5546\u5E97</span></button> <button class="oval-btn-normal" ng-click="save()"><span>\u4FDD\u5B58\uFF0C\u4E0B\u4E00\u6B65</span></button></div></div></div>');
$templateCache.put('app/entities/initialization/init-step1.html','<div class="listBGC"><div class="modal-body pad-0" style="min-height: 630px"><div class="init-head"><h2>\u611F\u8C22\u60A8\u52A0\u5165MOMENTSGO,\u8BF7\u5148\u8BBE\u7F6E\u60A8\u7684\u5546\u5E97</h2><div>\u914D\u7F6E\u5546\u5E97</div></div><div class="init-body col-lg-12 col-sm-12 col-xs-12"><div class="col-lg-12 col-sm-12 col-xs-12 form-group mar-bottom-30"><div class="col-lg-3 col-md-3 col-sm-3"></div><label class="col-lg-2 col-md-2 col-sm-3 col-xs-3 text-right" for="name">\u5546\u5E97\u540D\u79F0\uFF1A</label><div class="col-md-3 col-sm-3 col-xs-3"><input type="text" class="form-control radius-5" name="name" id="name" ng-model="vm.store.name" ng-minlength="2" ng-maxlength="100" required></div><div class="col-lg-3 col-md-3 col-sm-3 text-left pad-0 position-relative"><img src="content/images/notes.png" class="step-tip-icon" data-index="1" onmouseover="showTip(event)" onmouseout="hideTip(event)"> <span class="step-tip border-style2-height-auto step-tip-text step-tip-text1">\u9996\u9875\u5C55\u793A\u7684\u5546\u5E97\u540D\u79F0</span></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><div class="col-lg-3 col-md-3 col-sm-3"></div><label class="col-lg-2 col-md-2 col-sm-3 col-xs-3 text-right" for="name">\u5546\u6237logo\u66FF\u6362\uFF1A</label><div class="col-md-3 col-sm-3 col-xs-3 text-left"><div class="btn_addPic" ng-if="!vm.store.menuLogo"><input type="file" name="file" class="filePrew" accept=".jpg" onchange="uploadPic(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><span ng-if="vm.store.menuLogo"><img class="picture-border" id="my-image" ng-src="{{domain + vm.store.menuLogo}}" style="width: 75px; height: 40px"> <i class="glyphicon glyphicon-remove" ng-click="removeFile()" style="color: red"></i></span><div class="register-tip">\u53EA\u652F\u6301.jpg\u683C\u5F0F</div></div><div class="col-lg-3 col-md-3 col-sm-3"></div></div></div><div class="init-footer col-lg-12 col-sm-12 col-xs-12"><button class="oval-btn-normal-empty" ng-click="jumpOver()"><span>\u8DF3\u8FC7</span></button> <button class="oval-btn-normal" ng-click="vm.saveStep()"><span>\u4FDD\u5B58\uFF0C\u4E0B\u4E00\u6B65</span></button></div></div></div>');
$templateCache.put('app/entities/invoice/invoice-detail.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="breadcrumb-normal">\u53D1\u7968 / <span>\u53D1\u7968\u7533\u8BF7 / \u786E\u8BA4\u53D1\u7968\u4FE1\u606F</span></div><div class="con"><div ng-if="!vm.addSetting"><div class="c-form"><div class="c-form-label">\u9009\u62E9\u62AC\u5934</div><div class="c-form-div"><select class="form-control border-radius" ng-model="vm.selectedTitle" ng-options="setting.id as setting.title for setting in vm.settings"></select><span class="outline" style="color: var(--btnBgBasicColor); padding: 10px 15px" ng-click="addSetting()">\u65B0\u5EFA\u62AC\u5934</span></div></div><div class="c-form"><div class="c-form-label">\u9009\u62E9\u5730\u5740</div><div class="c-form-div"><select class="form-control border-radius" ng-model="vm.selectedLocation" ng-options=" location.id as location.province+\'-\'+location.city+\'-\'+location.area+\'-\'+location.address for location in vm.invoiceLocations"></select></div></div></div><div ng-if="!!vm.addSetting"><div class="c-form"><div class="c-form-label" translate="backApp.invoice.openType">openType</div><div class="c-form-div"><input type="radio" name="openType" ng-value="true" ng-click="vm.openTypeChange(0)" ng-model="vm.openType" style="width: 15px; height: 15px"> \u4E2A\u4EBA <input type="radio" name="openType" ng-value="false" ng-click="vm.openTypeChange(1)" ng-model="vm.openType" style="width: 15px; height: 15px; margin-left: 20px"> \u4F01\u4E1A</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.title">title</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u53D1\u7968\u62AC\u5934" ng-if="!vm.openType" name="title" id="title" ng-minlength="1" required ng-maxlength="20" ng-model="vm.invoiceSetting.title"> <input type="text" class="form-control border-radius" ng-if="vm.openType" disabled="disabled" ng-model="vm.title2"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.invoiceType">invoiceType</div><div class="c-form-div" ng-if="!vm.openType"><input type="radio" name="invoiceType" ng-value="true" ng-model="vm.invoiceType" style="width: 15px; height: 15px"> \u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968 <input type="radio" name="invoiceType" ng-value="false" ng-model="vm.invoiceType" style="width: 15px; height: 15px; margin-left: 20px"> \u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968</div><div class="c-form-div" ng-if="vm.openType"><span>\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968</span></div></div><div ng-if="!vm.openType"><div class="c-form"><div class="c-form-label" translate="backApp.invoice.taxRegistrationNumber">taxRegistrationNumber</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u7A0E\u52A1\u767B\u8BB0\u8BC1\u53F7" name="taxRegistrationNumber" id="taxRegistrationNumber" ng-maxlength="20" ng-model="vm.invoiceSetting.taxRegistrationNumber"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.bankName">bankName</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u57FA\u672C\u5F00\u6237\u94F6\u884C\u540D\u79F0" name="bankName" id="bankName" ng-maxlength="20" ng-model="vm.invoiceSetting.bankName"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.basicAccount">basicAccount</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u57FA\u672C\u5F00\u6237\u8D26\u53F7" name="basicAccount" id="basicAccount" ng-maxlength="20" ng-model="vm.invoiceSetting.basicAccount"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.registeredAddress">registeredAddress</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6CE8\u518C\u573A\u6240\u5730\u5740" name="registeredAddress" id="registeredAddress" ng-maxlength="20" ng-model="vm.invoiceSetting.registeredAddress"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.registeredPhone">registeredPhone</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6CE8\u518C\u56FA\u5B9A\u7535\u8BDD" name="registeredPhone" id="registeredPhone" ng-maxlength="20" ng-model="vm.invoiceSetting.registeredPhone"></div></div></div></div><div class="c-form" ng-if="!!vm.addSetting"><div class="c-form-label"></div><div class="c-form-div"><button class="small-btn-normal" ng-click="vm.save2()"><span>\u6DFB\u52A0\u5E76\u4F7F\u7528</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear2()"><span>\u8FD4\u56DE</span></button></div></div><div class="c-form" ng-if="!vm.addSetting"><div class="c-form-label"></div><div class="c-form-div"><button class="small-btn-normal" ng-click="vm.save()"><span>\u786E\u8BA4\u5F00\u7968</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/invoice/invoice-show.html','<div class="listBGC"><div class="con"><span class="breadcrumb-normal">\u53D1\u7968 /<span class="breadcrumb-normal-step"> \u53D1\u7968\u5217\u8868 / \u5F00\u7968\u8BE6\u60C5</span></span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 form-group">\u53D1\u7968\u4FE1\u606F</div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u53D1\u7968\u53F7</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.id}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.amount">amount</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.amount}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.openType">openType</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.openType?"\u4E2A\u4EBA":"\u4F01\u4E1A"}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.invoiceState">invoiceState</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.invoiceState == \'INVOICE_UNCOMMIT\' ? \'\u672A\u63D0\u4EA4\' : vm.invoice.invoiceState == \'INVOICE_COMMIT\' ? \'\u5DF2\u63D0\u4EA4\' : vm.invoice.invoiceState == \'INVOICE_UNAUDITED\' ? \'\u672A\u5904\u7406\' : vm.invoice.invoiceState == \'INVOICE_AUDITED\' ? \'\u5DF2\u5904\u7406\' : \'\'}}</div></div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.title">title</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.title}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u7533\u8BF7\u65F6\u95F4</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.createdDate|date:\'medium\'}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group">\u6536\u8D27\u4FE1\u606F</div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u6536\u4EF6\u4EBA</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.invoiceLocation.name}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u8054\u7CFB\u7535\u8BDD</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.invoiceLocation.phone}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u90AE\u7F16</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.invoiceLocation.postCode}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u6536\u7968\u5730\u5740</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.invoiceLocation.province}}- {{vm.invoice.invoiceLocation.city}}- {{vm.invoice.invoiceLocation.area}}- {{vm.invoice.invoiceLocation.address}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u7269\u6D41\u516C\u53F8</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.delivery}}</div></div></div><div class="col-lg-4 col-sm-6 col-xs-12"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u7269\u6D41\u5355\u53F7</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px">{{vm.invoice.deliveryNumber}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group">\u8BA2\u5355\u4FE1\u606F</div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr><th><span>\u8BA2\u5355\u53F7</span></th><th><span>\u652F\u4ED8\u65B9\u5F0F</span></th><th><span>\u652F\u4ED8\u65F6\u95F4</span></th><th><span>\u91D1\u989D</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="order in vm.invoice.payOrders track by order.id"><td style="display: table-cell; vertical-align: middle">{{order.uuid}}</td><td style="display: table-cell; vertical-align: middle">{{order.type=="WeChat"?"\u5FAE\u4FE1":"\u652F\u4ED8\u5B9D"}}</td><td style="display: table-cell; vertical-align: middle">{{order.createdDate |date:\'medium\'}}</td><td style="display: table-cell; vertical-align: middle">{{order.amount}}</td></tr></tbody></table></div></div></div></div><div class="mar-top-10"><button type="button" class="small-btn-normal" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div><!-- <form name="editForm" role="form" novalidate class="listBGC listCreate pad-0">\n    <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button>\n\n    <div class="modal-detail">\n        <h4 class="modal-title" id="myBannerLabel" translate="backApp.invoice.home.title2">title2</h4>\n    </div>\n\n    <div class="modal-body">\n        <div  class="panel-body form-horizontal">\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="backApp.invoice.openType">openType</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span ng-if="vm.openType">\u4E2A\u4EBA</span>\n                        <span ng-if="!vm.openType">\u4F01\u4E1A</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.title" for="title">title</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.title}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="backApp.invoice.invoiceType">invoiceType</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" ng-if="!vm.openType" style="padding-top: 8px;">\n                        <span ng-if="vm.invoiceType">\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968</span>\n                        <span ng-if="!vm.invoiceType">\u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968</span>\n                    </div>\n                    <div class="col-md-9 col-sm-9 col-xs-9" ng-if="vm.openType" style="padding-top: 8px;">\n                        <span>\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968</span>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-if="!vm.openType">\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.taxRegistrationNumber">taxRegistrationNumber</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.taxRegistrationNumber}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.basicAccount">basicAccount</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.basicAccount}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.bankName">bankName</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.bankName}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.registeredAddress">registeredAddress</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.registeredAddress}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.registeredPhone">registeredPhone</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.registeredPhone}}</span>\n                    </div>\n                </div>\n            </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.invoiceLocation">invoiceLocation</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span ng-if="!!vm.selectedLocation">{{vm.selectedLocation.province+\'-\'+vm.selectedLocation.city+\'-\'+vm.selectedLocation.area+\'-\'+vm.selectedLocation.address}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.invoice.orderAccount">orderAccount</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9" style="padding-top: 8px;">\n                        <span>{{vm.invoice.payOrder.amount}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="col-lg-12 col-sm-12 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3  control-label"  translate="backApp.invoice.invoiceState">invoiceState</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <input type="text" class="form-control border-radius" ng-value="vm.invoice.invoiceState == \'INVOICE_UNCOMMIT\' ? \'\u672A\u63D0\u4EA4\' : (vm.invoice.invoiceState == \'INVOICE_COMMIT\' ? \'\u5DF2\u63D0\u4EA4\' : (vm.invoice.invoiceState == \'INVOICE_UNAUDITED\' ? \'\u672A\u5904\u7406\' : (vm.invoice.invoiceState == \'INVOICE_AUDITED\' ? \'\u5DF2\u5904\u7406\' : \'\')))" disabled="disabled" />\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">\n            <span translate="entity.action.back">back</span>\n        </button>\n    </div>\n</form> -->');
$templateCache.put('app/entities/invoice/invoice.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u53D1\u7968 /<span class="breadcrumb-normal-step"> \u53D1\u7968\u5217\u8868</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr jh-sort="vm.reverse" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="backApp.invoice.openType">openType</span></th><th><span data-translate="backApp.invoice.title">title</span></th><th><span data-translate="backApp.invoice.invoiceType">invoiceType</span></th><th><span data-translate="backApp.invoice.orderAccount">orderAccount</span></th><th><span data-translate="backApp.invoice.taxRegistrationNumber">taxRegistrationNumber</span></th><th><span data-translate="backApp.invoice.invoiceState">invoiceState</span></th><th><span data-translate="backApp.invoice.function">Send Rule</span></th></tr></thead><tbody><tr ng-repeat="invoice in vm.invoices track by invoice.id"><td style="display: table-cell; vertical-align: middle">{{invoice.openType == \'Company\' ? \'\u4F01\u4E1A\' : \'\u4E2A\u4EBA\'}}</td><td style="display: table-cell; vertical-align: middle">{{invoice.title}}</td><td style="display: table-cell; vertical-align: middle">{{invoice.invoiceType == \'Special\' ? \'\u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968\' : \'\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968\'}}</td><td style="display: table-cell; vertical-align: middle">{{invoice.amount}}</td><td style="display: table-cell; vertical-align: middle">{{invoice.taxRegistrationNumber}}</td><td style="display: table-cell; vertical-align: middle">{{invoice.invoiceState == \'INVOICE_UNCOMMIT\' ? \'\u672A\u63D0\u4EA4\' : (invoice.invoiceState == \'INVOICE_COMMIT\' ? \'\u5DF2\u63D0\u4EA4\' : (invoice.invoiceState == \'INVOICE_UNAUDITED\' ? \'\u672A\u5904\u7406\' : (invoice.invoiceState == \'INVOICE_AUDITED\' ? \'\u5DF2\u5904\u7406\' : \'\')))}}</td><td class="text-right"><div class="right-btn"><button class="status-btn" type="submit" ui-sref="invoice.show({id:invoice.id})"><i class="icon iconfont webchakan"></i>\u67E5\u770B <span class="hover-span">\u67E5\u770B</span></button> <button class="status-btn" type="submit" ng-if="invoice.invoiceState == \'INVOICE_UNCOMMIT\'" ng-click="vm.changeStatus(invoice.id)"><i class="icon iconfont webtijiao"></i>\u63D0\u4EA4 <span class="hover-span">\u63D0\u4EA4</span></button> <button class="status-btn" type="submit" ng-if="invoice.invoiceState == \'INVOICE_COMMIT\'" ng-click="vm.changeStatus(invoice.id)"><i class="icon iconfont webzhongzhi"></i>\u64A4\u9500 <span class="hover-span">\u64A4\u9500</span></button> <button class="status-btn" type="submit" ng-if="invoice.invoiceState == \'INVOICE_UNCOMMIT\'" ng-click="vm.del(invoice.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664 <span class="hover-span">\u5220\u9664</span></button></div></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/invoice-location/invoice-location-page.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="breadcrumb-normal">\u53D1\u7968 / <span>\u53D1\u7968\u5BC4\u9001 / \u786E\u8BA4\u53D1\u7968\u4FE1\u606F</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="backApp.ilocation.name">name</div><div class="c-form-div"><input type="text" class="form-control border-radius" name="name" id="name" required ng-model="vm.invoiceLocation.name"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.ilocation.area">area</div><div class="c-form-div"><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched mar-right-10" style="width: 30%; height: 100%; float: left" ng-model="vm.province" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince()"><option value="">\u8BF7\u9009\u62E9\u7701\u4EFD</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched mar-right-10" style="width: 30%; height: 100%; float: left" ng-model="vm.city" ng-options="city.name for city in vm.citys" ng-change="vm.changeCity()"><option value="">\u8BF7\u9009\u62E9\u57CE\u5E02</option></select><select class="form-control ng-pristine ng-valid ng-not-empty ng-touched" style="width: 30%; height: 100%; float: left" ng-model="vm.district" ng-options="district.name for district in vm.districts"><option value="">\u8BF7\u9009\u62E9\u533A\u53BF</option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.ilocation.address2">address2</div><div class="c-form-div"><input type="text" class="form-control border-radius" name="address" id="address" required ng-model="vm.invoiceLocation.address"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.ilocation.postCode">postCode</div><div class="c-form-div"><input type="text" class="form-control border-radius" name="postCode" id="postCode" required ng-model="vm.invoiceLocation.postCode"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.ilocation.phone">phone</div><div class="c-form-div"><input type="text" class="form-control border-radius" name="phone" id="phone" required ng-model="vm.invoiceLocation.phone"></div></div><div class="c-form"><div class="c-form-label mar-top--6" translate="backApp.ilocation.default">default</div><div><label class="i-switch"><div style="margin-left: 7px" ng-show="vm.invoiceLocation.enable">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!vm.invoiceLocation.enable">\u505C\u7528</div><input type="checkbox" ng-model="vm.invoiceLocation.enable" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/invoice-location/invoice-location.html','<div class="listBGC"><span class="breadcrumb-normal">\u53D1\u7968 /<span class="breadcrumb-normal-step"> \u53D1\u7968\u5BC4\u9001</span></span><div class="con"><div><span class="breadcrumb-normal">\u5171\u6709 {{vm.ilocations != null ? vm.ilocations.length : 0}} \u4E2A\u5730\u5740\uFF0C\u6700\u591A\u4FDD\u5B58 5 \u4E2A</span></div><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ui-sref="invoice-location.new" ng-if="vm.ilocations.length < 5"><i class="icon iconfont webadd"></i><span translate="backApp.ilocation.add">add</span></button></div></div></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="backApp.ilocation.name">name</span></th><th><span data-translate="backApp.ilocation.phone">phone</span></th><th><span data-translate="backApp.ilocation.address">address</span></th><th><span data-translate="backApp.ilocation.postCode">postCode</span></th><th><span data-translate="backApp.ilocation.enable">enable</span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="ilocation in vm.ilocations track by ilocation.id"><td style="display: table-cell; vertical-align: middle">{{ilocation.name}}</td><td style="display: table-cell; vertical-align: middle">{{ilocation.phone}}</td><td style="display: table-cell; vertical-align: middle">{{ilocation.province +\'-\'+ ilocation.city +\'-\'+ ilocation.area +\'-\'+ ilocation.address}}</td><td style="display: table-cell; vertical-align: middle">{{ilocation.postCode}}</td><td style="display: table-cell; vertical-align: middle">{{ilocation.enable ? \'\u662F\' : \'\u5426\'}}</td><td class="text-right"><div class="right-btn"><button class="status-btn" type="submit" ui-sref="invoice-location-detail({id:ilocation.id})"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91 <span class="hover-span">\u7F16\u8F91</span></button> <button class="status-btn" type="submit" ng-if="!ilocation.enable" ng-click="vm.changeStatue(ilocation)"><i class="icon iconfont webmoren"></i>\u9ED8\u8BA4 <span class="hover-span">\u9ED8\u8BA4</span></button> <button class="status-btn" type="submit" ng-click="vm.del(ilocation.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664 <span class="hover-span">\u5220\u9664</span></button></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/invoice-setting/invoice-setting-detail.html','<div class="listBGC" style="min-width: 700px"><div class="breadcrumb-normal">\u53D1\u7968 / <span>\u5F00\u7968\u4FE1\u606F / \u5F00\u7968\u8BBE\u7F6E</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="backApp.invoice.openType">openType</div><div class="c-form-div">{{vm.invoiceSetting.openType == \'Personal\'?"\u4E2A\u4EBA":"\u4F01\u4E1A"}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.title">title</div><div class="c-form-div">{{vm.invoiceSetting.title}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.invoiceType">invoiceType</div><div class="c-form-div"><span ng-if="!vm.openType">{{vm.invoiceType?"\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968":"\u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968"}}</span> <span ng-if="vm.openType">\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968</span></div></div><div ng-if="!vm.openType"><div class="c-form"><div class="c-form-label" translate="backApp.invoice.taxRegistrationNumber">taxRegistrationNumber</div><div class="c-form-div">{{vm.invoiceSetting.taxRegistrationNumber}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.bankName">bankName</div><div class="c-form-div">{{vm.invoiceSetting.bankName}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.basicAccount">basicAccount</div><div class="c-form-div">{{vm.invoiceSetting.basicAccount}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.registeredAddress">registeredAddress</div><div class="c-form-div">{{vm.invoiceSetting.registeredAddress}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.registeredPhone">registeredPhone</div><div class="c-form-div">{{vm.invoiceSetting.registeredPhone}}</div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button class="small-btn-normal" ng-click="vm.editor()"><span>\u7F16\u8F91</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.back()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/invoice-setting/invoice-setting.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><span class="breadcrumb-normal">\u53D1\u7968 /<span class="breadcrumb-normal-step"> \u5F00\u7968\u4FE1\u606F / \u5F00\u7968\u8BBE\u7F6E</span></span><div class="con"><div class="c-form"><div class="c-form-label" translate="backApp.invoice.openType">openType</div><div class="c-form-div"><input type="radio" name="openType" ng-value="true" ng-click="vm.openTypeChange(0)" ng-model="vm.openType" style="width: 15px; height: 15px"> \u4E2A\u4EBA <input type="radio" name="openType" ng-value="false" ng-click="vm.openTypeChange(1)" ng-model="vm.openType" style="width: 15px; height: 15px; margin-left: 20px"> \u4F01\u4E1A</div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.title">title</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u53D1\u7968\u62AC\u5934" ng-if="!vm.openType" name="title" id="title" ng-minlength="1" required ng-maxlength="20" ng-model="vm.invoiceSetting.title"> <input type="text" class="form-control border-radius" ng-if="vm.openType" disabled="disabled" ng-model="vm.title2"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.invoiceType">invoiceType</div><div class="c-form-div" ng-if="!vm.openType"><input type="radio" name="invoiceType" ng-value="true" ng-model="vm.invoiceType" style="width: 15px; height: 15px"> \u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968 <input type="radio" name="invoiceType" ng-value="false" ng-model="vm.invoiceType" style="width: 15px; height: 15px; margin-left: 20px"> \u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968</div><div class="c-form-div" ng-if="vm.openType"><span>\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968</span></div></div><div ng-if="!vm.openType"><div class="c-form"><div class="c-form-label" translate="backApp.invoice.taxRegistrationNumber">taxRegistrationNumber</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u7A0E\u52A1\u767B\u8BB0\u8BC1\u53F7" name="taxRegistrationNumber" id="taxRegistrationNumber" ng-maxlength="20" ng-model="vm.invoiceSetting.taxRegistrationNumber"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.bankName">bankName</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u57FA\u672C\u5F00\u6237\u94F6\u884C\u540D\u79F0" name="bankName" id="bankName" ng-maxlength="20" ng-model="vm.invoiceSetting.bankName"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.basicAccount">basicAccount</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u57FA\u672C\u5F00\u6237\u8D26\u53F7" name="basicAccount" id="basicAccount" ng-maxlength="20" ng-model="vm.invoiceSetting.basicAccount"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.registeredAddress">registeredAddress</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6CE8\u518C\u573A\u6240\u5730\u5740" name="registeredAddress" id="registeredAddress" ng-model="vm.invoiceSetting.registeredAddress"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.invoice.registeredPhone">registeredPhone</div><div class="c-form-div"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6CE8\u518C\u56FA\u5B9A\u7535\u8BDD" name="registeredPhone" id="registeredPhone" ng-maxlength="20" ng-model="vm.invoiceSetting.registeredPhone"></div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/invoice-setting/invoice-settings.html','<div class="listBGC"><span class="breadcrumb-normal">\u53D1\u7968 /<span class="breadcrumb-normal-step"> \u5F00\u7968\u4FE1\u606F</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ui-sref="invoice-setting.new"><i class="icon iconfont webadd"></i><span>\u65B0\u5EFA\u62AC\u5934</span></button></div></div></div></div><div class="table-responsive white pad-left-15 pad-right-15" style="min-height: 480px"><table class="za-table table table-striped"><thead><tr><th><span>\u5F00\u5177\u7C7B\u578B</span></th><th><span>\u62AC\u5934</span></th><th><span>\u53D1\u7968\u7C7B\u578B</span></th><th><span>\u7A0E\u52A1\u767B\u8BB0\u53F7</span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="setting in vm.invoiceSettings track by setting.id"><td style="display: table-cell; vertical-align: middle">{{setting.openType!=\'Personal\'?"\u4F01\u4E1A":"\u4E2A\u4EBA"}}</td><td style="display: table-cell; vertical-align: middle">{{setting.title}}</td><td style="display: table-cell; vertical-align: middle"><span>{{setting.invoiceType!=\'Special\'?"\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968":"\u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968"}}</span></td><td style="display: table-cell; vertical-align: middle">{{setting.taxRegistrationNumber}}</td><td class="text-right"><div class="right-btn"><button ui-sref="invoice-setting-detail({id:setting.id})" class="status-btn" type="submit"><i class="icon iconfont webchakan"></i>\u67E5\u770B <span class="hover-span">\u67E5\u770B</span></button> <button ui-sref="invoice-setting({id:setting.id})" class="status-btn" type="submit"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91 <span class="hover-span">\u7F16\u8F91</span></button> <button ng-click="vm.del(setting.id)" class="status-btn" type="submit"><i class="icon iconfont webshanchu"></i>\u5220\u9664 <span class="hover-span">\u5220\u9664</span></button></div></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/logo-setting/logo-setting-edit.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="mar-top-24 mar-bottom-10"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A<a ui-sref="logo-setting">\u5E97\u94FA\u88C5\u4FEE</a>/\u5E97\u94FA\u88C5\u4FEE\u7F16\u8F91</span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 float-left control-label readLabel" for="name">\u5546\u6237\u540D\u79F0</label><div class="col-md-8 col-sm-8 col-xs-8 float-left mar-left-10"><input type="text" class="form-control radius-5" name="name" id="name" ng-model="vm.store.name" ng-minlength="2" ng-maxlength="100" required><div ng-show="form.name.$dirty && form.name.$invalid"><p class="help-block" ng-show="form.name.$error.required" data-translate="global.messages.validate.required">this is required.</p><p class="help-block" ng-show="form.name.$error.minlength" data-translate="global.messages.validate.minlength2">this is required to be at least 2 characters.</p><p class="help-block" ng-show="form.name.$error.maxlength" data-translate="global.messages.validate.maxlength100">this cannot be longer than 100 characters.</p></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group" style="margin-bottom: 4px; height: 100px"><label class="col-md-2 col-sm-2 col-xs-2 float-left control-label readLabel" style="height: 60px; line-height: 60px">\u83DC\u5355\u9876\u90E8LOGO</label><div class="col-md-2 col-sm-2 col-xs-2 float-left logo-pic" style="margin-left: 25px"><img src="content/images/leftbar_logo_unfold.png" ng-if="!vm.store.menuLogo" style="width: 75px; height: 40px"> <img alt="\u56FE\u7247\u7F3A\u5931" ng-if="!!vm.store.menuLogo" ng-src="{{domain + vm.store.menuLogo}}" style="width: 75px; height: 40px"><div class="logo-tip">\u63A8\u8350\u5C3A\u5BF8\uFF1A75 * 40\u50CF\u7D20</div></div><div class="col-md-4 col-sm-4 col-xs-4 float-left mar-left-10" style="height: 49px;position: relative"><input type="file" name="file" class="form-control pad-0 input-upload" accept=" image/jpeg, image/png" onchange="uploadPic(event,\'menuLogo\')" ng-model-options="{debounce : 500}"><div class="pic-upload pad-top-20" style="color: var(--btnBgBasicColor);font-size: 12px">\u66F4\u6362</div></div></div></div></div><div class="mar-top-10"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button></div></div>');
$templateCache.put('app/entities/logo-setting/logo-setting-page.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span>\u4E0A\u4F20LOGO\u6587\u4EF6</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel">LOGO\u6587\u4EF6</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="file" id="fileId" name="file" class="form-control border-radius" type="file" accept=" image/jpeg, image/png" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-cancel" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/logo-setting/logo-setting.html','<div class="listBGC"><div class="con"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A\u5E97\u94FA\u88C5\u4FEE</span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u5546\u6237\u540D\u79F0</label><div class="col-md-8 col-sm-8 col-xs-8"><span>{{vm.store.name}}</span></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u83DC\u5355\u9876\u90E8LOGO</label><div class="col-md-8 col-sm-8 col-xs-8"><img style="width: 75px; height: 40px" alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{domain + vm.store.menuLogo + \'?imageMogr2\'}}" ng-if="vm.store.menuLogo"> <span ng-if="!vm.store.menuLogo">\u672A\u8BBE\u7F6E</span></div></div></div></div><div class="mar-top-10"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ui-sref="logo-setting-edit"><span>\u7F16\u8F91</span></button></div></div>');
$templateCache.put('app/entities/map-depot/map-depot-clear-detail.html','<div class="c-model"><div class="c-model-head" style="overflow: hidden"><div class="c-model-head-title">\u6E05\u7406\u8BA1\u5212\u8BE6\u60C5</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding-top: 15px"><div style="font-size: 16px">\u72B6\u6001</div><div style="color: #6D6D6D; padding: 5px 10px 10px 10px">{{getStatus()}}</div><div style="font-size: 16px">\u6E05\u7406\u63CF\u8FF0</div><div style="color: #6D6D6D; padding: 5px 10px 10px 10px"><span ng-if="vm.data.status == \'Calculated\' || vm.data.status == \'Executing\'">\u6B64\u6B21\u6E05\u7406\u5C06\u4F1A\u91CA\u653E <span class="map-clear-title2">{{vm.data.scheduleCleanSize | sizeTransition}} </span>\u5B58\u50A8\u7A7A\u95F4 </span><span ng-if="vm.data.status == \'Executed\'">\u91CA\u653E\u4E86 <span class="map-clear-title2">{{vm.data.cleanSize | sizeTransition}} </span>\u5B58\u50A8\u7A7A\u95F4 </span><span ng-if="vm.data.status == \'Calculating\'">\u7EDF\u8BA1\u4E2D\uFF0C\u6682\u65E0\u6570\u636E</span></div><div style="font-size: 16px">\u6E05\u9664\u8303\u56F4</div><div style="color: #6D6D6D; padding: 5px 10px 10px 10px">{{vm.data.boundary}}\u4E2A\u6708\u524D\u6570\u636E</div><div style="font-size: 16px">\u4E0D\u6E05\u7406</div><div style="color: #6D6D6D; padding: 5px 10px 10px 10px"><div style="display: list-item; margin-left: 15px" ng-show="vm.data.ordered">{{vm.data.exemptOrdered}}\u5929\u5185\u4E0B\u8FC7\u5355</div></div><div style="font-size: 16px">\u6E05\u7406\u65F6\u95F4</div><div style="color: #6D6D6D; padding: 5px 10px 10px 10px">{{vm.data.executedTime | date:\'mediumDate\'}}</div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" style="border-radius: 6px" ng-click="cancel()">\u5173\u95ED</button></div></div>');
$templateCache.put('app/entities/map-depot/map-depot-clear-dialog.html','<div class="c-model" ng-show="!vm.data.id"><div class="c-model-head" style="overflow: hidden"><div class="c-model-head-title">\u521B\u5EFA\u6E05\u7406\u8BA1\u5212</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding:10px 100px">\u5F00\u59CB\u7EDF\u8BA1\u6E05\u7406\u5185\u5B58\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\uFF0C\u7A0D\u540E\u53EF\u81F3\u6E05\u7406\u8BB0\u5F55\u4E2D\u624B\u52A8\u6267\u884C\u6E05\u7406\u4EFB\u52A1\u3002</div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-default" style="border-radius: 6px" ng-click="cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" style="border-radius: 6px" ng-click="vm.save()">\u786E\u5B9A</button></div></div><div class="c-model" ng-show="!!vm.data.id"><div class="c-model-head" style="overflow: hidden"><div class="c-model-head-title">\u6E05\u7406</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding:10px 50px"><div class="clear-dialog-con">\u6B64\u6B21\u6E05\u7406\u9884\u8BA1\u91CA\u653E <span class="clear-dialog-con-number">{{vm.data.scheduleCleanSize | sizeTransition}}</span> \u7A7A\u95F4\uFF0C \u662F\u5426\u6E05\u7406\uFF1F</div><!--    <div class="map-clear-div map-clear-operation" style="display: revert;">--><!--      <label class="map-clear-operation">--><!--        <input type="radio" ng-value="false" ng-model="vm.data.noticed" style="width: 16px;height: 16px; margin: 0 3px 0 0;" ng-click="vm.data.delay = 0">--><!--        <span>\u7ACB\u5373\u6E05\u7406</span>--><!--      </label>--><!--      <label  class="map-clear-operation">--><!--        <input type="radio" ng-value="true" ng-model="vm.data.noticed" style="width: 16px;height: 16px; margin: 0 3px 0 0;">--><!--        <span>\u53D1\u9001\u4FE1\u606F\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u4E8E</span>--><!--        <input class="c-input1" style="width: 60px; margin: 0 3px;" type="number" ng-disabled="!vm.data.noticed" ng-model="vm.data.delay" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<0)value=null">--><!--        <span>\u5929\u540E\u6E05\u7406</span>--><!--      </label>--><!--      <div class="map-clear-operation" ng-click="vm.data.cleanedNoticed = !vm.data.cleanedNoticed">--><!--        <span class="choose-li" ng-show="!vm.data.cleanedNoticed" style="padding: 0; width: 16px; height: 16px; margin-right: 3px;"></span>--><!--        <span class="choose-sel" ng-show="vm.data.cleanedNoticed" style="padding: 0; width: 16px; height: 16px; margin-right: 3px;"></span>--><!--        <span>\u6E05\u7406\u540E\u901A\u77E5\u7528\u6237\u56FE\u5E93\u5DF2\u88AB\u6E05\u7406</span>--><!--      </div>--><!--    </div>--></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-default" style="border-radius: 6px" ng-click="cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" style="border-radius: 6px" ng-click="vm.save2()">\u786E\u5B9A</button></div></div><style>.clear-dialog-con{\n        text-align: center;\n        font-size: 14px;\n        font-weight: 400;\n        color: #000000;\n        line-height: 36px;\n    }\n    .clear-dialog-con-number{\n        font-size: 20px;\n        color: #FF4600;\n    }\n    .map-clear-operation{\n        margin: 14px;\n        display: flex;\n        align-items: center;\n        line-height: 13px;\n    }</style>');
$templateCache.put('app/entities/map-depot/map-depot-clear-record.html','<div class="listBGC" style="min-width: 1200px;margin-top: 20px"><span class="breadcrumb-normal">\u5546\u6237 /<span class="breadcrumb-normal-step"> \u56FE\u5E93\u6E05\u7406</span></span><div style="width: 100%;height: auto"><div class="con map-clear-con"><div class="current-location"><div class="screening-order"><div class="screening-title" ui-sref="mapDepot"><span>\u5B58\u50A8\u7A7A\u95F4</span></div><div class="screening-title" ui-sref="mapDepotRecord"><span>\u8D2D\u4E70\u8BB0\u5F55</span></div><div class="screening-title colorSelect"><span>\u56FE\u5E93\u6E05\u7406</span></div></div></div><div class="map-clear-tab"><span class="content" style="cursor: pointer" ui-sref="mapDepotClear">\u6E05\u7406\u8BA1\u5212</span> <span class="content active-clear-tab">\u6E05\u7406\u8BB0\u5F55</span></div><hr><div class="white mar-top-20"><table class="za-table table"><thead><tr><th><span>\u72B6\u6001</span></th><th><span>\u63CF\u8FF0</span></th><th><span>\u6E05\u7406\u65F6\u95F4</span></th><!--                        <th><span>\u63D0\u4EA4\u8BA1\u5212\u6E05\u7406\u65F6\u95F4</span></th>--><th><span>\u64CD\u4F5C</span></th></tr></thead><tbody><tr ng-repeat="item in vm.tableData track by item.id"><td style="display: table-cell; vertical-align: middle">{{getStatus(item)}}</td><td style="display: table-cell; vertical-align: middle"><span ng-if="!item.executed">{{item.scheduleTime | date:\'mediumDate\'}}\u9884\u8BA1\u6E05\u7406{{item.scheduleCleanSize | sizeTransition}}\u5B58\u50A8\u7A7A\u95F4</span> <span ng-if="item.executed">\u6E05\u7406\u4E86{{item.cleanSize | sizeTransition}}\u5B58\u50A8\u7A7A\u95F4</span></td><td style="display: table-cell; vertical-align: middle">{{item.executedTime | date:\'mediumDate\'}}</td><!--                        <td style="display: table-cell; vertical-align: middle;">{{item.checkTime | date:\'mediumDate\'}}</td>--><td style="display: table-cell; vertical-align: middle"><span ng-click="view(item)">\u67E5\u770B</span> <span ng-click="calculate(item)" ng-show="!item.cancelled &&item.status == \'Calculated1\'">\u7EDF\u8BA1</span> <span ng-click="calculate(item)" ng-show="!item.cancelled &&item.status == \'Calculating2\' && item.error">\u7EDF\u8BA1(\u4FEE\u6B63)</span> <span ng-click="check(item)" ng-show="!item.cancelled &&item.status == \'Calculated\'">\u6267\u884C</span> <span ng-click="check(item)" ng-show="!item.cancelled &&item.status == \'Checked\' && item.error">\u6267\u884C(\u4FEE\u6B63)</span> <span ng-click="cancel(item)" ng-show="!item.cancelled &&item.status == \'Calculated\'">\u53D6\u6D88</span></td></tr></tbody></table></div></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left !important" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><!--        <div class="text-jump" style="display: block;">--><!--            <span translate="global.page.goto">Go to</span>--><!--            <input type="number" class="page-text page" max="100000" ng-model="vm.jumpText" onKeyUp="value=value.replace(/[^\\d]/g,\'\')" style="width: 55px;"/>--><!--            <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span>--><!--        </div>--></div></div>');
$templateCache.put('app/entities/map-depot/map-depot-clear.html','<div class="listBGC" style="min-width: 1200px;margin-top: 20px"><span class="breadcrumb-normal">\u5546\u6237 /<span class="breadcrumb-normal-step"> \u56FE\u5E93\u6E05\u7406</span></span><div style="width: 100%;height: auto"><div class="con"><div class="current-location"><div class="screening-order"><div class="screening-title" ui-sref="mapDepot"><span>\u5B58\u50A8\u7A7A\u95F4</span></div><div class="screening-title" ui-sref="mapDepotRecord"><span>\u8D2D\u4E70\u8BB0\u5F55</span></div><div class="screening-title colorSelect"><span>\u56FE\u5E93\u6E05\u7406</span></div></div></div><div class="map-clear-tab"><span class="content active-clear-tab">\u6E05\u7406\u8BA1\u5212</span> <span class="content" style="cursor: pointer" ui-sref="mapDepotClearRecord">\u6E05\u7406\u8BB0\u5F55</span></div><hr><div style="padding: 20px"><div class="lh35"><span class="c-color1">\u6E05\u7406\u65F6\u95F4</span> <span class="c-color2 font-12">\u5C06\u6E05\u9664\u4EE5\u4E0B\u65F6\u95F4\u5185\u7684\u975E\u6D3B\u8DC3\u4F5C\u54C1\u3002</span></div><div class="c-color1 lh35 mar-top-20"><span>\u6E05\u9664</span> <input class="c-input1" style="width: 100px" type="number" ng-model="vm.data.boundary" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<0)value=null;if(value>12)value=12"> <span>\u4E2A\u6708\u5185\u672A\u66F4\u65B0\u4F5C\u54C1\u7684\u56FE\u7247\u4FE1\u606F\uFF0C\u6E05\u7406\u540E\u4F5C\u54C1\u5931\u6548\u3002</span></div><hr class="mar-top-20"><div class="lh35 mar-top-20"><span class="c-color1">\u4E0D\u6E05\u7406\u4F5C\u54C1</span> <span class="c-color2 font-12">\u6EE1\u8DB3\u4EE5\u4E0B\u6761\u4EF6\u7684\u4F5C\u54C1\u5373\u4F7F\u5728\u6E05\u7406\u65F6\u95F4\u8303\u56F4\u5185\uFF0C\u4E5F\u4E0D\u4F1A\u88AB\u6E05\u7406\u3002</span></div><div class="c-color1 lh35 mar-top-20"><i class="choose-li" ng-click="vm.data.ordered = true" ng-show="!vm.data.ordered"></i> <i class="choose-sel" ng-click="vm.data.ordered = false" ng-show="vm.data.ordered"></i> <input class="c-input1" style="width: 100px" type="number" ng-model="vm.data.exemptOrdered" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<0)value=null"> <span>\u5929\u5185\u4E0B\u8FC7\u5355</span></div><hr class="mar-top-20"><button class="oval-btn-normal mar-top-20" ng-click="creationClear()">\u521B\u5EFA\u6E05\u7406\u8BA1\u5212</button><div class="c-color2 font-12 mar-top-20">*\u5FEB\u901F\u6E05\u9664\u4E91\u76F8\u518C\u56FE\u7247\u4FE1\u606F\uFF01\u5305\u62EC\u6587\u4EF6\u5939\u4E2D\u7684\u56FE\u7247\uFF0C\u8BF7\u8C28\u614E\u6E05\u7406\uFF0C\u4E00\u65E6\u6E05\u7406\u4E0D\u53EF\u6062\u590D\u3002</div></div></div></div></div><style>.c-color1{\n        color: #333;\n        font-size: 16px;\n    }\n    .c-color2{\n        color: #FF5926;\n    }</style>');
$templateCache.put('app/entities/map-depot/map-depot-record.html','<div class="listBGC" style="min-width: 1200px;margin-top: 20px"><span class="breadcrumb-normal">\u5546\u6237 /<span class="breadcrumb-normal-step"> \u5B58\u50A8\u7A7A\u95F4</span></span><div style="width: 100%;height: auto"><div class="con"><div class="screening-order"><div class="screening-title" ui-sref="mapDepot"><span>\u5B58\u50A8\u7A7A\u95F4</span></div><div class="screening-title colorSelect"><span>\u8D2D\u4E70\u8BB0\u5F55</span></div><div class="screening-title" ui-sref="mapDepotClear"><span>\u56FE\u5E93\u6E05\u7406</span></div></div><div class="white"><table class="za-table table"><thead><tr><th><span>\u5BB9\u91CF\u5927\u5C0F</span></th><th><span>\u8D2D\u4E70\u65E5\u671F</span></th><th><span>\u6709\u6548\u65F6\u95F4</span></th><th><span>\u4EF7\u683C</span></th><th><span>\u6709\u6548\u671F</span></th></tr></thead><tbody><tr ng-repeat="item in vm.tableData track by item.id"><td style="display: table-cell; vertical-align: middle">{{item.space | sizeTransition}}</td><td style="display: table-cell; vertical-align: middle; width: 200px;max-width: 200px">{{item.paidDate | date:\'mediumDate\'}}</td><td style="display: table-cell; vertical-align: middle">{{item.periodOfValidity}}\u5E74</td><td style="display: table-cell; vertical-align: middle">{{item.amount | currency}}</td><td style="display: table-cell; vertical-align: middle">{{currentDateLater(item)}}</td></tr></tbody></table></div></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/map-depot/map-depot.html','<div class="listBGC" style="min-width: 1200px;margin-top: 20px"><span class="breadcrumb-normal">\u5546\u6237 /<span class="breadcrumb-normal-step"> \u5B58\u50A8\u7A7A\u95F4</span></span><div style="width: 100%;height: auto"><div class="con"><div class="screening-order"><div class="screening-title colorSelect"><span>\u5B58\u50A8\u7A7A\u95F4</span></div><div class="screening-title" ui-sref="mapDepotRecord"><span>\u8D2D\u4E70\u8BB0\u5F55</span></div><div class="screening-title" ui-sref="mapDepotClear"><span>\u56FE\u5E93\u6E05\u7406</span></div></div><div class="c-view"><div class="c-mapDepot-view"><div class="c-mapDepot-view1">\u5F53\u524D\u5B58\u50A8\u7A7A\u95F4\uFF1A<span>{{vm.sumSize | sizeTransition}}</span></div><div class="c-mapDepot-plan"><div class="c-mapDepot-plan1">\u5DF2\u4F7F\u7528\uFF1A{{vm.useSize | sizeTransition}} / {{vm.sumSize | sizeTransition}}\uFF08{{vm.percentage*100 | number:2}}%\uFF09</div><div class="c-progress"><div class="c-progress-span" ng-style="{\n                        width: vm.percentage*100 + \'%\',\n                        background: progressColor(vm.percentage)\n                    }"></div></div><div class="c-mapDepot-plan2"><div class="c-mapDepot-plan2-div"><span class="c-mapDepot-plan2-span1" ng-if="vm.data.buySize && vm.data.buySize>0">{{vm.sumSize | sizeTransition}}\u5BB9\u91CF = {{vm.data.initSize | sizeTransition}}\u514D\u8D39\u5BB9\u91CF {{vm.data.buySize && vm.data.buySize>0 ? (\'+\' + (vm.data.buySize | sizeTransition) + \'\u8D2D\u4E70\u5BB9\u91CF\') : ""}}</span> <span class="c-mapDepot-plan2-btn1" ui-sref="mapDepotRecord" ng-if="vm.data.buySize && vm.data.buySize>0">\u67E5\u770B\u8BE6\u60C5</span></div><span class="c-mapDepot-plan2-span2" ng-click="add()">\u53BB\u6269\u5BB9</span></div></div></div><div class="c-mapDepot-view2" style="margin-top: 50px"><span class="c-mapDepot-view2-title1">\u56FE\u5E93\u8BF4\u660E\uFF1A</span> <span class="c-mapDepot-view2-title2">\u5B58\u50A8\u5728\u4E91\u670D\u52A1\u5668\u7684\u56FE\u7247\u90FD\u4F1A\u4EA7\u751F\u5B58\u50A8\u8D39\u7528\uFF01\u4E3A\u4E86\u964D\u4F4E\u5B58\u50A8\u6210\u672C\uFF0C\u5E73\u53F0\u4F1A\u63D0\u4F9B\u7ED9\u5BA2\u6237\u3001\u5546\u6237\u4E00\u5B9A\u7684\u514D\u8D39\u5BB9\u91CF\uFF0C\u5546\u6237\u53EF\u8BA2\u8D2D\u5E73\u53F0\u56FE\u5E93\u5BB9\u91CF\u5957\u9910\u6269\u5BB9\uFF0C\u8BBE\u7F6E\u5BB9\u91CF\u8D2D\u4E70\uFF0C\u4EE5\u6B64\u624D\u63D0\u9AD8\u7528\u6237\u7684\u7167\u7247\u5BB9\u91CF\uFF01\u5F53\u5BB9\u91CF\u8FBE\u5230\u4E0A\u9650\u5219\u5BA2\u6237\u4E0D\u53EF\u518D\u4E0A\u4F20\u56FE\u7247\uFF0C\u8BF7\u5546\u6237\u53CA\u65F6\u5173\u6CE8\u5E76\u6269\u5BB9/\u6E05\u7406\u3002</span></div></div></div></div></div><style>.c-mapDepot-view {\n        width: 100%;\n        height: 200px;\n        background: url("content/images/mapDepot-bg.png") no-repeat left top;\n        background-size: 100% 100%;\n        box-shadow: 0px 11px 18px 0px rgba(174, 204, 238, 0.46);\n        border-radius: 8px;\n        padding: 20px;\n    }\n\n    .c-mapDepot-view1 {\n        width: 100%;\n        height: 35px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #232323;\n        font-size: 16px;\n    }\n\n    .c-mapDepot-view1 span {\n        font-weight: bold;\n        color: #232323;\n        font-size: 24px;\n    }\n\n    .c-mapDepot-plan {\n        width: 90%;\n        margin: 20px auto;\n    }\n\n    .c-mapDepot-plan1 {\n        font-size: 14px;\n        color: #232323;\n        margin-bottom: 10px;\n        padding: 0 10px;\n    }\n\n    .c-progress {\n        position: relative;\n        width: 100%;\n        height: 30px;\n        background: #fff;\n        border-radius: 10px;\n        overflow: hidden;\n    }\n\n    .c-progress-span {\n        position: absolute;\n        left: 0;\n        top: 0;\n        height: 30px;\n        transition: all 1s;\n        width: 0;\n        background: #2486FF;\n        border-radius: 10px;\n    }\n\n    .c-mapDepot-plan2 {\n        margin-top: 10px;\n        font-size: 14px;\n        display: flex;\n        justify-content: space-between;\n        padding: 0 10px;\n    }\n\n    .c-mapDepot-plan2-span1 {\n        color: #3B6098;\n    }\n\n    .c-mapDepot-plan2-btn1 {\n        display: inline-block;\n        color: #717171;\n        border: 1px solid #717171;\n        height: 25px;\n        width: 90px;\n        font-size: 12px;\n        text-align: center;\n        line-height: 25px;\n        border-radius: 25px;\n        margin-left: 20px;\n        cursor: pointer;\n    }\n\n    .c-mapDepot-plan2-span2 {\n        font-size: 14px;\n        font-weight: 400;\n        text-decoration: underline;\n        color: #8A24EA;\n        cursor: pointer;\n    }\n\n    .c-mapDepot-view2 {\n        margin-top: 20px;\n    }\n\n    .c-mapDepot-view2-title1 {\n        font-size: 16px;\n        font-weight: 600;\n        color: #333333;\n    }\n\n    .c-mapDepot-view2-title2 {\n        font-size: 14px;\n        color: #6D6D6D;\n    }</style>');
$templateCache.put('app/entities/map-depot/map-depot1.html','<div class="c-model1"><div class="c-model-head1"><img src="content/images/icon/icon-depot-title.png" alt=""> <button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body1"><div class="c-login-banner1"><div class="swiper-container"><div class="swiper-wrapper"><div class="swiper-slide swiper-slide1" ng-repeat="item in vm.storages.storagePriceLines" ng-if="!item.cancelled" ng-click="depotSelect(item)"><div class="swiper-slide-content" ng-class="{\'swiper-slide-content-selected\' : item.id == vm.data.id}"><div class="c-mapDepot-text1">{{item.space | sizeTransition}}</div><div class="c-mapDepot-text2">{{item.periodOfValidity}}\u5E74</div><div class="c-mapDepot-text3"><span class="c-mapDepot-text3-1">\uFFE5{{item.price}}</span> <span class="c-mapDepot-text3-2">\uFFE5{{item.originalPrice}}</span></div><div class="c-mapDepot-text4">\u9650\u65F6\u62A2\u8D2D</div></div></div></div><!-- Add Arrows --><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div></div><div class="c-model-body1-bottom"><div class="c-model-body1-bottom-left"><img ng-src="{{image}}"></div><div class="c-model-body1-bottom-right"><div class="c-mapDepot-text5">\u5B9E\u4ED8\uFF1A<span>{{vm.data.price}}</span></div><div class="c-mapDepot-text6"><img src="content/images/wechatPaySelect.svg" alt=""></div><div class="c-mapDepot-text7">\u672C\u7AD9\u6682\u4E14\u652F\u6301\u5FAE\u4FE1\u652F\u4ED8\uFF0C\u626B\u63CF\u5DE6\u4FA7\u4E8C\u7EF4\u7801\u8FDB\u884C\u652F\u4ED8</div><div class="c-mapDepot-text8">\u8D2D\u4E70\u540E\u5230\u671F\u65F6\u95F4\uFF1A{{vm.thisTime}}</div></div></div><div style="text-align: center;margin-top: 10px"><button type="button" class="btn btn-cancel" ng-click="cancel()">\u8FD4\u56DE</button></div></div></div><style>.c-model1 {\n        width: 100%;\n        height: 500px;\n        background: #FFFFFF;\n        box-shadow: 5px 5px 34px 1px rgba(0, 0, 0, 0.28);\n        border-radius: 10px;\n    }\n    .c-model-head1 {\n        position: relative;\n        height: 78px;\n        background-color: #2d2d2d;\n        color: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .c-model-head1 .close {\n        position: absolute;\n        right: 5px;\n        top: 5px;\n        color: #fff;\n        opacity: 1;\n    }\n\n    .c-model-body1 {\n        height: 422px;\n    }\n    .c-login-banner1 {\n        margin-top: 31px;\n        height: 140px;\n        width: 100%;\n    }\n    .swiper-slide1 {\n        background: #fff;\n\n        /* Center slide text vertically */\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        -webkit-justify-content: center;\n        justify-content: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -webkit-align-items: center;\n        align-items: center;\n    }\n    .swiper-slide img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n\n    .swiper-slide-content {\n        position: relative;\n        width: 243px;\n        height: 140px;\n        border: 1px solid #fff;\n        box-shadow: 1px 1px 13px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 4px;\n        text-align: center;\n        background: #FFFFFF;\n        cursor: pointer;\n        -webkit-transition: all .1s ease;\n        -moz-transition: all .1s ease;\n        -o-transition: all .1s ease;\n        transition: all .1s ease;\n    }\n\n    .swiper-slide-content-selected {\n        background: #FFF9EC;\n        border: 1px solid #E9A42A;\n    }\n\n    .swiper-slide-content {\n        position: relative;\n        width: 243px;\n        height: 140px;\n        border: 1px solid #fff;\n        box-shadow: 1px 1px 13px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 4px;\n        text-align: center;\n        background: #FFFFFF;\n        cursor: pointer;\n        -webkit-transition: all .1s ease;\n        -moz-transition: all .1s ease;\n        -o-transition: all .1s ease;\n        transition: all .1s ease;\n    }\n\n    .swiper-slide-content-selected {\n        background: #FFF9EC;\n        border: 1px solid #E9A42A;\n    }\n\n    .c-mapDepot-text1 {\n        font-weight: 600;\n        color: #222222;\n        font-size: 18px;\n        line-height: 36px;\n    }\n\n    .c-mapDepot-text2 {\n        font-weight: 400;\n        color: #9E9D9D;\n        font-size: 14px;\n    }\n\n    .c-mapDepot-text3 {\n        margin-top: 15px;\n    }\n\n    .c-mapDepot-text4 {\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        color: #DF9B23;\n        font-size: 12px;\n        height: 25px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #FFE1A6;\n        border-radius: 0px 0px 4px 4px;\n        width: 100%;\n    }\n\n    .c-mapDepot-text3-1 {\n        font-size: 24px;\n        font-weight: 600;\n        color: #FF4600;\n    }\n\n    .c-mapDepot-text3-2 {\n        font-size: 14px;\n        font-weight: 400;\n        text-decoration: line-through;\n        color: #F3CABB;\n    }\n\n    .c-mapDepot-text5 {\n        font-size: 14px;\n        color: #000000;\n    }\n\n    .c-mapDepot-text5 span {\n        font-size: 24px;\n        font-weight: 600;\n        color: #FF4600;\n    }\n\n    .c-mapDepot-text6 {\n        margin-top: 15px;\n    }\n\n    .c-mapDepot-text7 {\n        font-size: 12px;\n        color: #B4B4B4;\n        margin-top: 20px;\n    }\n\n    .c-mapDepot-text8 {\n        font-size: 12px;\n        color: #998053;\n        margin-top: 15px;\n    }\n    .c-model-body1-bottom {\n        margin: 40px 10px 0 30px;\n        display: flex;\n    }\n\n    .c-model-body1-bottom-left {\n        width: 160px;\n        height: 160px;\n        background: #FFFFFF;\n        box-shadow: 1px 1px 13px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 4px;\n        overflow: hidden;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .c-model-body1-bottom-left img {\n        max-width: 100%;\n        max-height: 100%;\n    }\n\n    .c-model-body1-bottom-right {\n        margin-left: 15px;\n    }</style>');
$templateCache.put('app/entities/masking/masking-dialog.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u65B0\u589E/\u7F16\u8F91\u8499\u7248</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u8499\u7248\u5206\u7C7B</label><div class=""><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.data.themeClassifyId" ng-options="item.id as item.name for item in vm.setting | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9\u8499\u7248\u5206\u7C7B</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u6392\u5E8F</label><div class=""><input type="number" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F" ng-model="vm.data.seq" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<=0)value=null"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u56FE\u7247</label><div class="" ng-if="!vm.data.id" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start"><div class="btn_addPic" ng-if="!vm.data.identifier"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" multiple="multiple" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><div ng-repeat="item in vm.attachments track by $index" style="position: relative; display: inline-block; text-align: center"><img style="width: 100px; height: 100px; object-fit: cover; border: 1px dashed #ccc; display: block" ng-src="{{domain + item.identifier +\'?imageView2/0/w/100/h/100\'}}"> <span style="display: block; font-size: 12px; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top: 4px">{{item.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(item,$index)" style="position: absolute; top: -8px; right: -8px; color: red; cursor: pointer; background: #fff; border-radius: 50%; padding: 2px"></i></div></div><div class="" ng-if="!!vm.data.id"><img style="width: 100px;   background-color: powderblue; border: 1px dashed red" ng-src="{{domain + vm.data.identifier +\'?imageView2/0/w/100/h/100\'}}"></div></div><label class="control-label2" style="color: red" for="themeClassify">\u4E0A\u4F20\u56FE\u7247\u4EC5\u652F\u6301PNG\u683C\u5F0F</label></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.cancel()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/masking/masking.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u8499\u7248\u7BA1\u7406</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"></div><div class="mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ng-click="add()"><i class="icon iconfont webadd"></i> <span>\u65B0\u589E\u8499\u7248</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="c-form pull-left" style="position: relative;left: -20px"><label class="c-form-label">\u5206\u7C7B</label><div class="c-form-div" style="width: 120px"><select ng-model="vm.themeClassifyId" ng-change="vm.transition()" class="c-select1" ng-options="c.id as c.name for c in vm.class"><option value="">\u5168\u90E8\u5206\u7C7B</option></select></div></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><div class="pic-geometry" ng-repeat="data in vm.data track by data.id"><div class="pic-model"><div><img style="background-color: powderblue; border: 1px dashed red" ng-src="{{domain + data.identifier+\'?imageView2/0/w/100/h/100\'}}"></div></div><div style="padding-top:7px">{{data.themeClassifyName}}</div><div class="pic-edit"><button ng-click="edit(data)" style="color: #ffffff; top: 20%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button ng-click="delete(data.id)" style="color: #ffffff; top: 40%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></div></div></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/material/material-dialog.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u65B0\u589E/\u7F16\u8F91\u7D20\u6750</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">{{vm.data.type === \'TECHNIQUE\' ? \'\u5DE5\u827A\' : \'\u7D20\u6750\'}}\u5206\u7C7B</label><div class=""><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.data.themeClassifyId" ng-options="item.id as item.name for item in vm.setting | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9{{vm.data.type === \'TECHNIQUE\' ? \'\u5DE5\u827A\' : \'\u7D20\u6750\'}}\u5206\u7C7B</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u6392\u5E8F</label><div class=""><input type="number" class="form-control border-radius5" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F" ng-model="vm.data.seq" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<=0)value=null"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u56FE\u7247</label><div class="" ng-if="!vm.data.id" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" multiple="multiple" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><div ng-repeat="item in vm.attachments track by $index" style="position: relative; display: inline-block; text-align: center"><img style="width: 100px; height: 100px; object-fit: cover; border: 1px dashed #ccc; display: block" ng-src="{{domain + item.identifier +\'?imageView2/0/w/100/h/100\'}}"> <span style="display: block; font-size: 12px; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top: 4px">{{item.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(item,$index)" style="position: absolute; top: -8px; right: -8px; color: red; cursor: pointer; background: #fff; border-radius: 50%; padding: 2px"></i></div></div><div class="" ng-if="!!vm.data.id"><img style="width: 100px;  border: 1px dashed red" ng-src="{{domain + vm.data.identifier +\'?imageView2/0/w/100/h/100\'}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.cancel()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/material/material.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span>{{vm.classType === \'TECHNIQUE\' ? \'\u5DE5\u827A\u7BA1\u7406\' : \'\u7D20\u6750\u7BA1\u7406\'}}</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ng-click="add()"><i class="icon iconfont webadd"></i> <span>\u65B0\u589E{{vm.classType === \'TECHNIQUE\' ? \'\u5DE5\u827A\' : \'\u7D20\u6750\'}}</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="c-form pull-left" style="position: relative;left: -20px"><label class="c-form-label">\u5206\u7C7B</label><div class="c-form-div" style="width: 120px"><select ng-model="vm.themeClassifyId" ng-change="vm.transition()" class="c-select1" ng-options="c.id as c.name for c in vm.class"><option value="">\u5168\u90E8\u5206\u7C7B</option></select></div></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><div class="pic-geometry" ng-repeat="data in vm.data track by data.id"><div class="pic-model"><div><img ng-src="{{domain + data.identifier+\'?imageView2/0/w/100/h/100\'}}"></div></div><div style="padding-top:7px">{{data.themeClassifyName}}</div><div class="pic-edit"><button ng-click="edit(data)" style="color: #ffffff; top: 20%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button ng-click="delete(data.id)" style="color: #ffffff; top: 40%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></div></div></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/message-notification/message-notification-detail.html','<div class="listBGC" style="min-width: 700px"><div class="breadcrumb-normal">\u5546\u6237 / <span>\u7AD9\u5185\u5E7F\u64AD</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.content">content</div><div class="c-form-div">{{vm.messageNotification.content}} <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.available">available</div><div class="c-form-div">{{vm.messageNotification.available?"\u662F":"\u5426"}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.seq">seq</div><div class="c-form-div"><span>{{vm.messageNotification.seq == 0? 1: vm.messageNotification.seq}}</span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.pageType">pageType</div><div class="c-form-div"><span data-translate="{{\'backApp.PageType.\' + vm.messageNotification.pageType}}">{{vm.messageNotification.pageType}}</span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.type">type</div><div class="c-form-div"><span data-translate="{{\'backApp.MessageType.\' + vm.messageNotification.type}}">{{vm.messageNotification.type}}</span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.validate">validate</div><div class="c-form-div">{{vm.messageNotification.validate| date:\'mediumDate\'}}</div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/message-notification/message-notification-dialog.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="breadcrumb-normal">\u5546\u6237 / <span>\u7AD9\u5185\u5E7F\u64AD</span></div><div class="con"><div ng-if="vm.messageNotification.protoId == null || vm.messageNotification.type == \'Store\'"><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.content">content</div><div class="c-form-div"><input type="text" class="c-input1" style="width: 90%" ng-model="vm.messageNotification.content" placeholder="\u8BF7\u8F93\u5165\u901A\u77E5\u5185\u5BB9"> <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span></div></div><div class="c-form"><div class="c-form-label mar-top--6" translate="backApp.messageNotification.available">available</div><div><label class="i-switch"><div style="margin-left: 7px" ng-show="vm.messageNotification.available">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!vm.messageNotification.available">\u505C\u7528</div><input type="checkbox" ng-model="vm.messageNotification.available" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.seq">seq</div><div class="c-form-div"><input type="number" class="c-input1" min="2" ng-model="vm.messageNotification.seq" placeholder="\u8F93\u5165\u5927\u4E8E1\u7684\u6392\u5E8F\u503C"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.pageType">pageType</div><div class="c-form-div"><select class="c-select1" name="pageType" ng-model="vm.messageNotification.pageType"><option value="Gallery" data-translate="backApp.PageType.Gallery">Gallery</option><option value="View" data-translate="backApp.PageType.View">View</option><option value="Edit" data-translate="backApp.PageType.Edit">Edit</option><option value="Tile" data-translate="backApp.PageType.Tile">Tile</option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.validate">validate</div><div class="c-form-div"><div class="input-group"><input type="text" class="c-input1" uib-datepicker-popup="{{dateformat}}" ng-model="vm.messageNotification.validate" is-open="vm.datePickerOpenStatus.validate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div ng-if="vm.messageNotification.protoId != null && vm.messageNotification.type == \'Platform\'"><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.content">content</div><div class="c-form-div">{{vm.messageNotification.content}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.available">available</div><div class="c-form-div">{{vm.messageNotification.available?"\u662F":"\u5426"}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.seq">seq</div><div class="c-form-div"><input type="number" class="c-input1" ng-if="vm.messageNotification.top == false" ng-model="vm.messageNotification.seq" placeholder="\u8F93\u5165\u6392\u5E8F"> <span ng-if="vm.messageNotification.top">{{vm.messageNotification.seq}}</span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.pageType">pageType</div><div class="c-form-div"><span data-translate="{{\'backApp.PageType.\' + vm.messageNotification.pageType}}">{{vm.messageNotification.pageType}}</span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.type">type</div><div class="c-form-div"><span data-translate="{{\'backApp.MessageType.\' + vm.messageNotification.type}}">{{vm.messageNotification.type}}</span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.messageNotification.validate">validate</div><div class="c-form-div">{{vm.messageNotification.validate| date:\'mediumDate\'}}</div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/message-notification/message-notifications.html','<div class="listBGC"><span class="breadcrumb-normal">\u5546\u6237 /<span class="breadcrumb-normal-step"> \u7AD9\u5185\u5E7F\u64AD</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"><div style="margin-right: 20px;width: 200px"><span class="filter-text">\u7B5B\u9009\uFF1A</span><div><select class="form-control border-radius" name="pageType" ng-model="vm.pageType" ng-change="searchPageType()"><option value="" data-translate="backApp.PageType.none">\u8BF7\u9009\u62E9\u5C55\u793A\u9875\u9762</option><option value="Gallery" data-translate="backApp.PageType.Gallery">Gallery</option><option value="View" data-translate="backApp.PageType.View">View</option><option value="Edit" data-translate="backApp.PageType.Edit">Edit</option><option value="Tile" data-translate="backApp.PageType.Tile">Tile</option></select></div></div></div><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ui-sref="message-notification.new"><i class="icon iconfont webadd"></i><span>\u65B0\u5EFA\u6D88\u606F</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr style="font-weight: bold"><th class="fw18"><span data-translate="backApp.messageNotification.content">Content</span></th><th><span data-translate="backApp.messageNotification.top">Top</span></th><th><span data-translate="backApp.messageNotification.available">Available</span></th><th><span data-translate="backApp.messageNotification.initial">initial</span></th><th><span data-translate="backApp.messageNotification.seq">seq</span></th><th><span data-translate="backApp.messageNotification.pageType">Page Type</span></th><th><span data-translate="backApp.messageNotification.type">Type</span></th><th><span data-translate="backApp.messageNotification.validate">Validate</span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="messageNotification in vm.messageNotifications "><td>{{messageNotification.content}}</td><td>{{messageNotification.top?\'\u662F\':"\u5426"}}</td><td>{{messageNotification.available?\'\u662F\':"\u5426"}}</td><td>{{messageNotification.initial?\'\u662F\':"\u5426"}}</td><td>{{messageNotification.seq== 0 ? 1:messageNotification.seq}}</td><td data-translate="{{\'backApp.PageType.\' + messageNotification.pageType}}">{{messageNotification.pageType}}</td><td data-translate="{{\'backApp.MessageType.\' + messageNotification.type}}">{{messageNotification.type}}</td><td>{{messageNotification.validate | date:\'mediumDate\'}}</td><td><button class="status-btn" type="submit" ui-sref="message-notification-detail({id: messageNotification.id})"><i class="icon iconfont webchakan"></i>\u67E5\u770B</button> <button class="status-btn" type="submit" ng-if="!messageNotification.initial" ui-sref="message-notification.edit({id: messageNotification.id})"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button class="status-btn" type="submit" ng-if="!messageNotification.initial" ng-click="delete(messageNotification)"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/mould/mould-dialog.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u54C1\u6A21\u677F / <span>\u6A21\u677F{{vm.title}}</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="platformApp.mould.name">name\uFF1A</div><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.mould.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div><div class="c-form"><div class="c-form-label">\u5206\u7C7B</div><div class="c-form-div"><select class="c-select1" ng-model="vm.mould.categoryId" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option style="color: #b3a8a8" disabled="disabled" label="{{category.name}}"></option></select></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.mould.enable"></div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px; margin-top: -3px" ng-show="vm.mould.enable">\u542F\u7528</div><div style="margin-left: 20px; margin-top: -3px" ng-show="!vm.mould.enable">\u505C\u7528</div><input type="checkbox" ng-model="vm.mould.enable" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.mould.description">description</div><div class="c-form-div"><textarea type="description" class="c-textarea1" ng-model="vm.mould.description" placeholder="\u8BF7\u8F93\u5165\u63CF\u8FF0"></textarea></div></div><div class="c-form"><div class="c-form-label">\u89C4\u683C</div><div class="c-form-div" style="width: auto"><table class="za-table table"><thead><!-- <th class="fw2">\u5E8F\u53F7</th> --><th class="fw4">\u89C4\u683C\u540D\u79F0</th><th class="fw2">\u64CD\u4F5C</th></thead><tbody><tr ng-repeat="obj in vm.mould.mouldProperties" ng-if="!obj.deleted && !obj.cancelled"><!-- <td>{{$index+1}}</td> --><td><div class="col-lg-12 col-sm-12"><select style="padding: 2px" class="c-select1" ng-model="obj.propertyId" ng-options="value.id as value.name for value in vm.properties|filter:{cancelled:false}"><option style="color: #b3a8a8" disabled="disabled" label="{{value.name}}"></option></select></div></td><td><button type="button" ng-click="deleteValue(obj,vm.mould.mouldProperties)" class="btn-text">\u5220\u9664</button></td></tr></tbody></table><div class="table-btn" ng-click="addItemValue()"><span class="red-btn-add"></span> <span class="hidden-xs text-add">\u65B0\u589E</span></div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/mould/moulds.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u54C1 / <span translate="global.menu.entities.productMould">productproductMould</span></div><div class="con"><div class="overflow-h"><div class="float-left"><button class="oval-btn-normal" ui-sref="mould.new"><i class="icon iconfont webadd"></i> <span translate="platformApp.mould.home.createLabel">Create new mould</span></button> <button class="oval-btn-normal2" ng-click="deleteBatch()" ng-show="selectOne"><span>\u6279\u91CF\u5220\u9664</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'platformApp.mould.home.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button></span></div></form></div></div><div class="table-responsive pad-left-15 pad-right-15 mar-top-20"><table class="za-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span translate="platformApp.mould.id">Id</span></th><th><span translate="platformApp.mould.name">Name</span></th><th><span translate="platformApp.mould.description">description</span></th><th><span translate="platformApp.mould.category">category</span></th><th><span translate="platformApp.mould.enable">enable</span></th><th style="width: 200px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="mould in vm.moulds track by $index"><td style="display: table-cell; vertical-align: middle">{{$index+1}}</td><td style="display: table-cell; vertical-align: middle">{{mould.name}}</td><td style="display: table-cell; vertical-align: middle">{{mould.description}}</td><td>{{mould.categoryName}}</td><td><span ng-if="mould.enable">\u6709\u6548</span> <span ng-if="!mould.enable">\u65E0\u6548</span></td><td><button class="status-btn" type="submit" ui-sref="mould.edit({id:mould.id})"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button class="status-btn" type="submit" ng-click="delete(mould.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/multilingualDialog/multilingualDetail.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u591A\u8BED\u8A00\u5F55\u5165<span class="font-14" ng-if="vm.fieldName && vm.fieldValue">{{\'(\'+vm.fieldName+\':\'+vm.fieldValue+\')\'}}</span></div><button aria-label="Close" data-dismiss="modal" class="close lh35" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding: 20px;max-height: 450px;overflow: auto"><table class="table-fw font-12" style="width:100%"><thead class="table-head" style="border-color: #e5e6e7;background: #fff"><th style="width: 70px">\u5E8F\u53F7</th><th style="width: 160px">\u8BED\u79CD</th><th>\u6570\u636E</th></thead><tbody><tr><td>1</td><td>\u7B80\u4F53\u4E2D\u6587</td><td>{{vm.fieldValue}}</td></tr><tr ng-repeat="item in vm.multilingual track by $index"><td>{{$index + 2}}</td><td>{{item.key}}</td><td>{{item[vm.key]}}</td></tr></tbody></table></div><div class="c-model-foot" style="text-align: center"><button type="button" class="oval-btn-normal-empty" ng-click="vm.cancel()">\u786E\u8BA4</button></div></div><style>.modal-multilingual .modal-dialog {\n        z-index: 2200;\n        position: absolute;\n        left: 50%;\n        top: 40%;\n        transform: translate(-50%,-50%) !important;\n        height: auto;\n        width: 800px;\n        max-width: 800px;\n    }</style>');
$templateCache.put('app/entities/multilingualDialog/multilingualDialog.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u591A\u8BED\u8A00\u5F55\u5165<span class="font-14" ng-if="vm.fieldName && vm.fieldValue">{{\'(\'+vm.fieldName+\':\'+vm.fieldValue+\')\'}}</span></div><button aria-label="Close" data-dismiss="modal" class="close lh35" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding: 20px;max-height: 450px;overflow: auto"><table class="table-fw font-12" style="width:100%"><thead class="table-head" style="border-color: #e5e6e7;background: #fff"><th style="width: 70px">\u5E8F\u53F7</th><th style="width: 160px">\u8BED\u79CD</th><th>\u6570\u636E</th></thead><tbody><tr><td>1</td><td>\u7B80\u4F53\u4E2D\u6587</td><td style="text-align: left">{{vm.fieldValue}}</td></tr><tr ng-repeat="item in vm.multilingual track by $index"><td>{{$index + 2}}</td><td>{{item.key}}</td><td><input type="text" class="form-control border-radius" ng-model="item[vm.key]"></td></tr></tbody></table></div><div class="c-model-foot" style="text-align: center"><button type="button" class="oval-btn-normal" ng-click="vm.save()">\u4FDD\u5B58</button> <button type="button" class="oval-btn-normal-empty" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-multilingual .modal-dialog {\n        z-index: 2200;\n        position: absolute;\n        left: 50%;\n        top: 40%;\n        transform: translate(-50%,-50%) !important;\n        height: auto;\n        width: 800px;\n        max-width: 800px;\n    }</style>');
$templateCache.put('app/entities/page/pagesmySuffix-save.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><!-- <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> --><div class="modal-detail"><h4 class="modal-title" translate="editorApp.page.save">save</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.category" for="field_category">Category</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" id="field_category" name="field_category" ng-model="vm.page.category" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option value="{{category.name}}"></option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.themeClassify" for="field_name">themeClassify</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_name" ng-model="vm.themeClassify" ng-options="themeClassify.id as themeClassify.name for themeClassify in vm.themeClassifyList"></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.workName" for="field_workName">workName</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control" name="field_name" id="field_workName" ng-model="vm.page.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" for="type">\u5B9A\u5236\u7C7B\u578B</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="type" id="type" ng-model="vm.page.type"><option value="Custom" data-translate="editorApp.page.customType.Custom">Custom</option><option value="Currency" data-translate="editorApp.page.customType.Currency">Currency</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group" ng-if="vm.page.type == \'Custom\' "><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.customStore" for="customStore">customStore</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_name" ng-model="vm.customStore" ng-change="customStoreChange()" ng-options="store.id as store.name for store in vm.stores"></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u6A21\u677F\u66FF\u6362</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" ng-model="vm.page.replace"><option value="true">\u53EF\u66FF\u6362</option><option value="false">\u4E0D\u53EF\u66FF\u6362</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u51FA\u8840\u8BBE\u7F6E</label><div class="col-md-9 col-sm-9 col-xs-9"><div class="col-md-3 col-sm-3 col-xs-3 pad-left-0"><input type="number" min="0" class="form-control" ng-model="vm.page.bleedTop" placeholder="\u4E0A"></div><div class="col-md-3 col-sm-3 col-xs-3 pad-left-0"><input type="number" min="0" class="form-control" ng-model="vm.page.bleedBottom" placeholder="\u4E0B"></div><div class="col-md-3 col-sm-3 col-xs-3 pad-left-0"><input type="number" min="0" class="form-control" ng-model="vm.page.bleedLeft" placeholder="\u5DE6"></div><div class="col-md-3 col-sm-3 col-xs-3 pad-left-0"><input type="number" min="0" class="form-control" ng-model="vm.page.bleedRight" placeholder="\u53F3"></div></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/page/pagesmySuffix-save2.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u6A21\u677F\u7F16\u8F91</span></div></div></div><div class="modal-body"><div class="modal-body-scroll scrollbar-main"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="editorApp.page.category" for="field_category">Category</label><div class=""><select class="form-control border-radius" id="field_category" name="field_category" ng-model="vm.productXml.categoryId" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option value="{{category.name}}"></option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="editorApp.page.catalogName">catalogName</label><div class="" style="padding: 7px 0 0 30px">{{vm.productXml.productName||\'\u6682\u672A\u8BBE\u7F6E\'}}</div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u753B\u5E03\u5C3A\u5BF8</label><div class="col-md-9 col-sm-9 col-xs-9" style="padding: 7px 0 0 30px">{{vm.productXml.pageSizeW }}*{{vm.productXml.pageSizeH}}</div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="editorApp.page.xmlType">xmlType</label><div class="" style="padding: 7px 0 0 30px"><span translate="{{\'editorApp.page.xmlTypes.\'+ vm.productXml.xmlType}}">{{vm.productXml.xmlType}}</span></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="editorApp.page.themeClassify" for="themeId">themeClassify</label><div class=""><select-multiple :model="vm.productXml.themeClassifies" :multiple="true" :options="vm.themeClassifyList" :key="\'id\'" :value="\'name\'"></select-multiple></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="editorApp.page.workName" for="field_workName">workName</label><!-- <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span> --><div class=""><input type="text" class="form-control" name="field_workName" id="field_workName" ng-model="vm.productXml.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="type">\u5B9A\u5236\u7C7B\u578B</label><div class=""><select class="form-control border-radius" name="type" id="type" ng-model="vm.productXml.type"><option value="Currency" data-translate="editorApp.page.customType.Currency">Currency</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2">\u6A21\u677F\u66FF\u6362</label><div class=""><label class="i-switch"><div style="margin-left: 7px" ng-show="vm.productXml.replace">\u66FF\u6362</div><div style="margin-left: 20px" ng-show="!vm.productXml.replace">\u4E0D\u6362</div><input type="checkbox" ng-model="vm.productXml.replace" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div></div><div class="col-lg-12 col-sm-12" ng-if="vm.productXml.modelType == \'THREE\'"><div class="form-group"><label class="control-label2">3D\u6A21\u578B</label><div class=""><div class="col-md-4 col-sm-4 col-xs-4"><div class="btn-3dfile"><input type="file" name="file" class="filePrew" accept=".gltf,.glb" onchange="uploadPic(event)" ng-model-options="{debounce : 500}"> <span>{{vm.productXml.modelPath ? \'\u91CD\u65B0\u9009\u62E9\' : \'\u4E0A\u4F203D\u6A21\u578B\'}}</span></div></div><div class="col-md-4 col-sm-4 col-xs-4"><div class="btn-3dfile" ng-click="modelPathDelete()"><span>\u6E05\u7A7A3D\u6A21\u578B</span></div></div></div><div class="register-tip" style="clear: both; margin-left: 15px">\u53EA\u652F\u6301.gltf, .glb\u683C\u5F0F</div></div></div><div class="col-lg-12 col-sm-12" ng-if="vm.productXml.modelPath"><div class="form-group"><label class="control-label2"></label><div class=""><div class="c-form" ng-repeat="item in vm.modelData track by $index" ng-if="!vm.modelLoad"><label class="c-form-label" style="width: 100px">{{item.materialName}}\uFF1A</label><div class="c-form-div" style="width: 100px; margin-left: 100px"><select class="form-control border-radius" ng-model="item.page" ng-options="page.index as page.name for page in vm.page" aria-invalid="false"><option value="" class="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></div><div ng-if="vm.modelLoad">\u4E0A\u4F20\u4E2D...</div></div></div></div><div class="col-lg-12 col-sm-12" ng-if="vm.productXml.modelPath"><div class="form-group"><label class="control-label2">\u914D\u8272\u7BA1\u7406\uFF1A</label><div><div style="margin-bottom: 5px; position: relative; padding: 10px; border: 1px solid #ddd; border-radius: 6px" ng-repeat="item in vm.productXml.modelBlendent track by $index"><div style="display: flex; align-items: center; height: 35px">\u914D\u8272\u540D\u79F0\uFF1A<input type="text" class="c-input1" style="width: 150px" ng-model="item.name"></div><button type="button" class="btn btn-info" ng-click="modelBlendentSet(item)" style="margin: 5px 0 0 70px">\u8BBE\u7F6E\u914D\u8272</button> <i class="glyphicon glyphicon-remove" ng-click="removeModelBlendent($index)" style="color: red; position: absolute; right: 5px; top: 5px" role="button" tabindex="0"></i></div><div><button type="button" class="btn btn-info" ng-click="modelBlendentAdd()">\u65B0\u589E</button></div></div></div></div><div class="col-lg-12 col-sm-12" ng-if="vm.variableData"><div class="form-group"><label class="control-label2">\u6A21\u677F\u53C2\u6570</label><div style="padding: 7px 0 0 30px">{{vm.variableData}}</div></div></div></div></div><div class="modal-footer"><button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal"><span>\u4FDD\u5B58\u8BBE\u7F6E</span></button> <button type="submit" ng-click="save2()" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal"><span>\u4FDD\u5B58\u5E76\u7F16\u8F91\u6A21\u677F</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div>');
$templateCache.put('app/entities/page/pagesmySuffix.html','<div style="background: #f0f2f7!important;margin-top: 48px"><div class="listBGC" style="margin-top: -50px!important;padding: 0!important"><div class="page-top"><div class="page-nav col-lg-11 col-sm-11 col-md-11 pad-right-0 pad-left-0"><div class="nav-ul"><ul ui-sortable="sortableOptions" ng-model="template.pages.page" class="sort-ul"><li ng-repeat="page in template.pages.page track by $index" ng-click="selectPages($index)" data-index="{{$index}}" ng-style=""><div ng-class="{\'nav-active\': page.seq == currentPage.seq}" class="page-nav-box"><div data-index="{{$index}}" ng-style="{\n                                    height:\'42px\',\n                                    width:page.width*42/page.height,\n                                    margin:\'0 auto\',\n                                    background:\'#fff\',\n                                    position:\'relative\'}"><img class="top-img" data-index="{{$index}}" ng-show="page.bgImg||page.background.resource.identifier" ng-src="{{page.bgImg||\'//:0\'}}" style="width: 100%"><div data-index="{{index}}"><img data-index="{{$index}}" ng-repeat="art in page.imagearts.imageart" style="transform-origin: left bottom;position: absolute" ng-style="{\n                                                    width: art.geometry.width/(page.width/(page.width*42/page.height))/page.proportion,\n                                                    height: art.geometry.height/(page.height/42)/page.proportion,\n                                                    left: art.geometry.x/page.proportion/(page.width/(page.width*42/page.height)),\n                                                    top: art.geometry.y/page.proportion/(page.height/42),\n                                                    \'z-index\':$index+300,\n                                                    \'transform\': \'rotate(-\' + art.rotation.angle + \'deg)\'}" ng-src="{{vm.url+art.resource.identifier+\'?imageView2\'}}"></div><div data-index="{{index}}" class="imgBoxs"><img data-index="{{$index}}" ng-repeat="img in page.imageboxes.imagebox" class="img-place-holder mask" style="transform-origin: left bottom" ng-style="{\n                                                    width: img.geometry.width/(page.width/(page.width*42/page.height))/page.proportion,\n                                                    height: img.geometry.height/(page.height/42)/page.proportion,\n                                                    left: img.geometry.x/page.proportion/(page.width/(page.width*42/page.height)),\n                                                    top: img.geometry.y/page.proportion/(page.height/42),\n                                                    \'transform\': \'rotate(-\' + img.rotation.angle + \'deg)\'}" ng-src="{{img.mask.resource.identifier?vm.url+img.mask.resource.identifier+\'?imageslim\':\'content/images/otis_redding.png\'}}" data-mask="content/images/centerblur.png"></div><div ng-repeat="text in page.textboxes.textbox" class="text-box text-content cursorPointer" data-index="{{$index}}" readonly="readonly" ng-model="text.text" style="position: absolute" ng-style="{\n                                                 top: text.geometry.y/page.proportion/(page.width/(page.width*42/page.height)),\n                                                 left: text.geometry.x/page.proportion/(page.height/42),\n                                                 width: text.geometry.width/(page.width/(page.width*42/page.height))/page.proportion,\n                                                 height: text.geometry.height/(page.height/42)/page.proportion,\n                                                 \'z-index\': 998,\n                                                 \'transform\': \'rotate(-\' + text.rotation.angle + \'deg)\'\n                                                    }"><img ng-src="{{text.picCode}}" ng-if="text.picCode!=\'\'"></div><div class="barcode nav-active cursorPointer" ng-show="page.hasBarCode" readonly="readonly" ng-style="{\n                                                 top: page.barcode.y/page.proportion/((page.height+borderTop+ borderBottom)/42),\n                                                 left: page.barcode.x/page.proportion/((page.width+borderLeft+ borderRight)/((page.width+borderLeft+ borderRight)*42/(page.height+borderTop+ borderBottom))),\n                                                 width: page.barcode.width/((page.width+borderLeft+ borderRight)/((page.width+borderLeft+ borderRight)*42/(page.height+borderTop+ borderBottom)))/page.proportion,\n                                                 height: page.barcode.height/((page.height+borderTop+ borderBottom)/42)/page.proportion,\n                                                 \'z-index\': 998\n                                                    }"><img src="content/images/txm.png"></div></div><button class="page-del" ng-click="deletePage($index)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></button></div><!--<span style="height:0;display:block">{{page.seq}}</span>--></li></ul><!--\u589E\u52A0\u4E00\u9875--> <button class="page-noNav" ng-click="addPage()"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjiajiahaowubiankuang"></use></svg></button><div class="nav-ol"><ol style="overflow: hidden"><li ng-repeat="page in template.pages.page track by $index" style="margin-right: 16px"><div ng-style="{width:(page.width)*42/(page.height)}">{{$index+1}}</div><!-- <div ng-style="{width:getPageSize($index)}">{{$index+1}}</div> --></li></ol></div></div></div><div class="page-button col-lg-1 col-sm-1 col-md-1"><!--\u9000\u51FA--> <button ng-click="exitPage()"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tuichu-copy"></use></svg> <span translate="editorApp.page.exit"></span></button><!--\u4FDD\u5B58--> <button ng-click="savePage()"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-baocun"></use></svg> <span translate="editorApp.page.save"></span></button></div></div><div class="table-responsive pad-left-15 pad-right-15" style="background: #f0f2f7!important"><div class="animated fadeInRight"><div class="col-lg-12 col-sm-12 col-md-12 no-padding"><div class="home-page page-view"><div class="col-lg-9 col-sm-9 col-md-9 add-all no-padding"><header class="navbar navbar-default nav-bg" style="min-height: 40px"><div class="col-lg-8 col-sm-8 col-md-8 text-left"><button class="add-mask" ng-click="addImg()"><span class="text">\u6DFB\u52A0\u5360\u4F4D\u6846</span></button> <button class="add-text" ng-click="addText()"><span class="text">\u65B0\u589E\u6587\u672C</span></button> <button class="add-barcode" ng-click="addBarCode()" ng-class="{\'un-select\':template.pages.page[template.pageI].hasBarCode}" ng-disabled="template.pages.page[template.pageI].hasBarCode"><span class="text">\u65B0\u589E\u6761\u5F62\u7801</span></button></div><div class="col-lg-4 col-sm-4 col-md-4 text-right"><div class="col-lg-7 col-sm-7 col-md-7 text-right no-padding" ng-show="buttonShows"><button class="rollback-undo rollback-active" ng-click="copyimg()"><img src="content/images/copy.png" alt="\u590D\u5236"> <span class="text">\u590D\u5236</span></button> <button class="rollback-undo rollback-active" ng-click="pasteimg()"><img src="content/images/paste.png" alt="\u7C98\u8D34"> <span class="text">\u7C98\u8D34</span></button> <button class="rollback-undo rollback-active" ng-click="deleteTemplate()"><img src="content/images/delete2.png" alt="\u5220\u9664"> <span class="text">\u5220\u9664</span></button></div><div class="col-lg-5 col-sm-5 col-md-5 text-left no-padding" style="float: right"><button class="rollback-undo" ng-click="rollback(0)" ng-class="{\'rollback-active\':pageHistory[template.pageI].currentHistoryIndex}" ng-disabled="!pageHistory[template.pageI].currentHistoryIndex"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-iocnchexiao"></use></svg> <span class="text">\u64A4\u9500</span></button> <button class="rollback-redo rollback-active" ng-click="rollback(1)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chexiao"></use></svg> <span class="text">\u91CD\u505A</span></button></div></div></header><section class="body-content"><div class="page-right"><button ng-click="reduction()" ng-class="{\'rollback-active\':currentPage.scale!=1}" ng-disabled="currentPage.scale==1"><span translate="editorApp.page.reduction"></span></button> <button ng-click="zoomIn()" ng-class="{\'rollback-active\':1}"><span translate="editorApp.page.zoomIn"></span></button> <button ng-click="zoomOut()" ng-class="{\'rollback-active\':currentPage.scale!=1}" ng-disabled="currentPage.scale==1"><span translate="editorApp.page.zoomOut"></span></button></div><button class="leftBtn ll{{$index}}" ng-click="pageLeft()" ng-show="visibleLeft"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-fanye2"></use></svg></button><div class="col-md-12 col-sm-12 col-md-12 template-display no-padding content-scroll" style="position: relative"><div class="page-item" ng-click="template.currentMenu = \'page\'" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n                                         width: ((borderLeft+ borderRight)/currentPage.proportion + currentPage.width)*currentPage.scale,\n                                         height: ((borderTop+ borderBottom)/currentPage.proportion + currentPage.height)*currentPage.scale\n                                        }"><div class="content-container" ng-style="{\n                                            width: (currentPage.width+(borderLeft+ borderRight)/currentPage.proportion)*currentPage.scale,\n                                            height: (currentPage.height+(borderTop+ borderBottom)/currentPage.proportion)*currentPage.scale\n                                            }"><img id="bgImg" class="bg-image" ng-cloak ng-show="currentPage.bgImg||currentPage.background.resource.identifier" ng-src="{{currentPage.bgImg||\'//:0\'}}" ng-style="{width: currentPage.bgImg||currentPage.background.resource.identifier?(currentPage.width+(borderLeft+ borderRight)/currentPage.proportion)*currentPage.scale:0}"><div id="art" data-index="{{$index}}" class="img-art" ng-repeat="art in currentPage.imagearts.imageart" ng-style="{\n                                                    width: art.geometry.width*currentPage.scale/currentPage.proportion,\n                                                    height: art.geometry.height*currentPage.scale/currentPage.proportion,\n                                                    left: art.geometry.x*currentPage.scale/currentPage.proportion,\n                                                    top: art.geometry.y*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':$index+300,\n                                                    \'transform\': \'rotate(-\' + art.rotation.angle + \'deg)\'}" ng-click="selectArt($event, $index, art)"><img data-index="{{$index}}" ng-class="{\'selected\': $index == template.artI && template.currentMenu == \'Art\'}" id="art-img{{$index}}" onmousedown="moveArtStart(event)" style="width: 100%;height: 100%" ng-src="{{vm.url+art.resource.identifier+\'?imageView2\'}}"> <span class="resize-img" ng-show="$index == template.artI && template.currentMenu == \'Art\'" style="right: -50px;bottom:-50px" data-index="{{$index}}" onmousedown="resizeArtStart(event)"></span></div><div id="mask" data-index="{{$index}}" class="imgBox" ng-repeat="img in currentPage.imageboxes.imagebox" style="transform-origin: left bottom" ng-class="{\'selected\': $index == template.imgI}" ng-style="{\n                                                    width: img.geometry.width*currentPage.scale/currentPage.proportion,\n                                                    height: img.geometry.height*currentPage.scale/currentPage.proportion,\n                                                    left: img.geometry.x*currentPage.scale/currentPage.proportion,\n                                                    top: img.geometry.y*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':$index+200,\n                                                    \'transform\': \'rotate(-\' + img.rotation.angle + \'deg)\'}" ng-click="selectImg($event, $index, img)"><img data-index="{{$index}}" class="img-holder mask" id="mask-img{{$index}}" onmousedown="moveImgStart(event)" oncontextmenu="contextMenu(event)" style="width: 100%;height: 100%" ng-src="{{img.mask.resource.identifier?img.bgImg:\'content/images/otis_redding.png\'}}" data-mask="content/images/centerblur.png"> <span class="resize-img" ng-show="$index == template.imgI && template.currentMenu == \'Img\'" style="right: -50px;bottom:-50px" data-index="{{$index}}" onmousedown="resizeStart(event)"></span></div><!--\u81EA\u5B9A\u4E49\u53F3\u952E\u83DC\u5355--><div id="menus"><div class="menu clearfix" ng-click="copyimg()"><span class="floatLeft">\u590D\u5236</span><span class="floatRight">Ctrl+C</span></div><div class="menu clearfix" ng-click="pasteimg()"><span class="floatLeft">\u7C98\u8D34</span><span class="floatRight">Ctrl+V</span></div><div class="menu clearfix" ng-click="deleteTemplate()"><span class="floatLeft">\u5220\u9664</span><span class="floatRight">Delete</span></div></div><div ng-repeat="text in currentPage.textboxes.textbox" class="text-box text-content cursorPointer" id="text{{template.pageI}}{{template.textI}}" ng-class="{\'selected\': $index == template.textI && template.currentMenu == \'text\'}" ng-click="selectText($event, $index, text)" data-index="{{$index}}" onmousedown="moveTextStart(event)" oncontextmenu="contextMenuText(event)" readonly="readonly" style="border: 1px dashed rgb(240, 149, 27)" ng-style="{\n                                                 \'line-height\':\'0\',\n                                                 top: text.geometry.y*currentPage.scale/currentPage.proportion,\n                                                 left: text.geometry.x*currentPage.scale/currentPage.proportion,\n                                                 width: text.text?text.geometry.width*currentPage.scale/currentPage.proportion:100,\n                                                 height: text.text?text.geometry.height*currentPage.scale/currentPage.proportion:24,\n                                                 \'z-index\': 998,\n                                                 \'transform\': \'rotate(-\' + text.rotation.angle + \'deg)\'\n                                                    }"><img ng-src="{{text.picCode}}" ng-if="text.picCode!=\'\'" ng-style="{\n                                                    }"><p ng-if="text.picCode==\'\'" style="height: 24px;line-height: 24px">\u8BF7\u8F93\u5165\u6587\u5B57</p></div><div class="barcode cursorPointer" id="barcode{{template.pageI}}" ng-click="selectBar($event,currentPage)" onmousedown="moveBarcodeStart(event)" readonly="readonly" ng-show="currentPage.hasBarCode" ng-style="{\n                                                 \'line-height\':\'0\',\n                                                 top: currentPage.barcode.y*currentPage.scale/currentPage.proportion,\n                                                 left: currentPage.barcode.x*currentPage.scale/currentPage.proportion,\n                                                 width: currentPage.barcode.width*currentPage.scale/currentPage.proportion,\n                                                 height: currentPage.barcode.height*currentPage.scale/currentPage.proportion,\n                                                 \'z-index\': 998\n                                                    }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="border-red" id="border-red" ng-style="{\n                                            width:currentPage.width*currentPage.scale,\n                                            height:currentPage.height*currentPage.scale,\n                                            top:borderTop*currentPage.scale/currentPage.proportion,\n                                            left:borderLeft*currentPage.scale/currentPage.proportion}"></div></div></div></div><button class="rightBtn rr{{$index}}" ng-click="pageRight()" ng-show="visibleRight"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-fanye"></use></svg></button></section></div><div class="col-md-3 col-sm-3 col-md-3"><div class="template-edit"><div class="page-menu" ng-show="template.currentMenu == \'page\'"><h3>\u7B2C {{template.pageI+1}} \u9875</h3><div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u5BBD</span><div class="col-md-3 col-sm-3 col-md-3 text-center temp-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD" ng-change="updateTemplateHeightAndWidth(\'mm\')" max="" name="pageWidth" ng-model-options="{debounce:500}" ng-model="template.widthM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 temp-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD" ng-change="updateTemplateHeightAndWidth(\'mm\')" max="" name="pageWidth" ng-model-options="{debounce:500}" ng-model="template.widthPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u9AD8</span><div class="col-md-3 col-sm-3 col-md-3 text-center temp-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8" ng-change="updateTemplateHeightAndWidth(\'px\')" max="" name="pageHeight" ng-model-options="{debounce:500}" ng-model="template.heightM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 temp-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8" ng-change="updateTemplateHeightAndWidth(\'px\')" max="" name="pageHeight" ng-model-options="{debounce:500}" ng-model="template.heightPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'page\',true)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 mar-bottom-30" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-md-3 text-right no-padding">\u8DE8\u9875\u72B6\u6001\uFF1A</span><div class="col-md-9 col-sm-9 col-md-9 no-padding text-left"><button class="button-b clearInputStyle" ng-click="pageIsSpread(1)" ng-disabled="template.pageI==0||template.pageI==template.pages.page.length-1" ng-class="{\'buttonA\':currentPage.spread==true,\'cursor-no\':template.pageI==0||template.pageI==template.pages.page.length-1}">\u8DE8\u9875</button> <button class="button-i clearInputStyle" ng-click="pageIsSpread(0)" ng-class="{\'buttonA\': currentPage.spread==false}">\u975E\u8DE8\u9875</button></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 mar-bottom-30" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-md-3 text-right no-padding">\u662F\u5426\u5907\u7528\uFF1A</span><div class="col-md-9 col-sm-9 col-md-9 no-padding text-left"><button class="button-b clearInputStyle" ng-click="pageIsBackup(1)" ng-class="{\'buttonA\':currentPage.backup==true}">\u5907\u7528</button> <button class="button-i clearInputStyle" ng-click="pageIsBackup(0)" ng-class="{\'buttonA\': currentPage.backup==false}">\u975E\u5907\u7528</button></div></div></div><div class="center"><span ng-click="deletePage()" ng-disabled="template.pages.page.length==1" class="btn btn-primary">\u5220\u9664\u8BE5\u9875\u9762</span> <span ng-click="deleteBgImg()" ng-disabled="!template.pages.page[template.pageI].hasBgImg" class="btn btn-primary">\u5220\u9664\u80CC\u666F\u56FE\u7247</span></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-220"><div class="col-md-12 col-sm-12 col-lg-12 no-padding" style="text-align: center"><img src="content/images/icons/jingao.svg" style="width: 22px"> <span style="color: #ff5a57;font-size: 16px">\u8B66\u544A</span><div class="mar-top-10 mar-bottom-15"><span>\u5EFA\u8BAE\u4E0A\u4F20\u80CC\u666F\u56FE\u7247\u548C\u8499\u7248\u56FE\u5F62\u5927\u5C0F\u4E0D\u8981\u8D85\u8FC7\u5341\u5146</span><br><span>\u5426\u5219\u5C06\u5F71\u54CD\u7528\u6237\u5236\u4F5C\u4F5C\u54C1</span><br></div></div></div></div><div class="art-menu" ng-show="template.currentMenu == \'Art\'"><h3>\u7B2C {{template.pageI+1}} \u9875</h3><div class="col-md-12 col-sm-12 col-lg-12" style="padding: 14px 10px 14px 10px!important"><h4 class="maskT-text">\u7D20\u6750</h4><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u5BBD</span><div class="col-md-3 col-sm-3 col-md-3 text-center art-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateArtParameter(\'width\',\'artWidthM\',\'widthM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.artWidthM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 art-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateArtParameter(\'width\',\'artWidthM\',\'widthM\',\'artWidthPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.artWidthPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u9AD8</span><div class="col-md-3 col-sm-3 col-md-3 text-center art-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateArtParameter(\'height\',\'artHeightM\',\'heightM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.artHeightM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 art-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateArtParameter(\'height\',\'artHeightM\',\'heightM\',\'artHeightPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.artHeightPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'Art\',true)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">X</span><div class="col-md-3 col-sm-3 col-md-3 text-center art-xay-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateArtParameter(\'x\',\'artXM\',\'offsetXM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.artXM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 art-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateArtParameter(\'x\',\'artXM\',\'offsetXM\',\'artXPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.artXPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">Y</span><div class="col-md-3 col-sm-3 col-md-3 text-center art-xay-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateArtParameter(\'y\',\'artYM\',\'offsetYM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.artYM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 art-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateArtParameter(\'y\',\'artYM\',\'offsetYM\',\'artYPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.artYPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'Art\',false)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 mar-bottom-30" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-md-3 text-right no-padding">\u65CB\u8F6C\uFF1A</span><div class="col-md-6 col-sm-6 col-md-6 no-padding text-center"><input type="number" class="form-control inputColor" placeholder="\u89D2\u5EA6" ng-change="updateArtRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><span class="col-md-3 col-sm-3 col-md-3 no-padding text-left">\uFF08\u5EA6\uFF09</span></div><div class="col-md-12 col-sm-12 col-lg-12 mar-bottom-30" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-md-3 text-right no-padding">\u662F\u5426\u7EC4\u7248\uFF1A</span><div class="col-md-9 col-sm-9 col-md-9 no-padding text-left"><button class="button-b clearInputStyle" style="width: 90px" ng-click="updateOnlyShow(true)" ng-class="{\'buttonA\':template.artOnlyShow}">\u4EC5\u5236\u4F5C\u5C55\u793A</button> <button class="button-i clearInputStyle" style="width: 90px" ng-click="updateOnlyShow(false)" ng-class="{\'buttonA\': !template.artOnlyShow}">\u52A0\u5165\u7EC4\u7248</button></div></div><div class="col-md-12 col-sm-12 col-lg-12"><span ng-click="deleteArtBox()" ng-disabled="!template.pages.page[template.pageI].imagearts.imageart || !template.pages.page[template.pageI].imagearts.imageart.length" class="btn btn-primary">\u5220\u9664</span></div></div></div><div class="img-menu" ng-show="template.currentMenu == \'Img\'"><h3>\u7B2C {{template.pageI+1}} \u9875</h3><div class="col-md-12 col-sm-12 col-lg-12" style="padding: 14px 10px 14px 10px!important"><h4 class="maskT-text">\u5360\u4F4D\u6846</h4><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u5BBD</span><div class="col-md-3 col-sm-3 col-md-3 text-center img-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateImgParameter(\'width\',\'imgWidthM\',\'widthM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.imgWidthM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 img-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateImgParameter(\'width\',\'imgWidthM\',\'widthM\',\'imgWidthPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.imgWidthPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u9AD8</span><div class="col-md-3 col-sm-3 col-md-3 text-center img-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateImgParameter(\'height\',\'imgHeightM\',\'heightM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.imgHeightM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 img-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateImgParameter(\'height\',\'imgHeightM\',\'heightM\',\'imgHeightPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.imgHeightPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'Img\',true)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">X</span><div class="col-md-3 col-sm-3 col-md-3 text-center img-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateImgParameter(\'x\',\'offsetXM\',\'offsetXM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.offsetXM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 img-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateImgParameter(\'x\',\'offsetXM\',\'offsetXM\',\'offsetXPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.offsetXPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">Y</span><div class="col-md-3 col-sm-3 col-md-3 text-center img-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateImgParameter(\'y\',\'offsetYM\',\'offsetYM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.offsetYM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 img-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateImgParameter(\'y\',\'offsetYM\',\'offsetYM\',\'offsetYPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.offsetYPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'Img\',false)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 mar-bottom-30" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-md-3 text-right no-padding">\u65CB\u8F6C\uFF1A</span><div class="col-md-6 col-sm-6 col-md-6 no-padding text-center"><input type="number" class="form-control inputColor" placeholder="\u89D2\u5EA6" ng-change="updateImgRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><span class="col-md-3 col-sm-3 col-md-3 no-padding text-left">\uFF08\u5EA6\uFF09</span></div><div class="col-md-12 col-sm-12 col-lg-12"><span ng-click="deleteImgBox()" ng-disabled="!template.pages.page[template.pageI].imageboxes.imagebox || !template.pages.page[template.pageI].imageboxes.imagebox.length" class="btn btn-primary">\u5220\u9664</span></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-120"><div class="col-md-12 col-sm-12 col-lg-12 no-padding" style="text-align: center"><img src="content/images/icons/jingao.svg" style="width: 22px"> <span style="color: #ff5a57;font-size: 16px">\u8B66\u544A</span><div class="mar-top-10 mar-bottom-15"><span>\u8499\u7248\u8BF7\u4E0A\u4F20\u767D\u8272\u5185\u5BB9\u53CA\u900F\u660E\u5E95\u5C42\u56FE\u7247</span><br><span>\u5426\u5219\u4F5C\u54C1\u6548\u679C\u5C06\u51FA\u73B0\u4E25\u91CD\u8BEF\u5DEE\u3002</span><br></div></div></div></div><div class="text-menu" ng-show="template.currentMenu == \'text\'"><h3>\u7B2C {{template.pageI+1}} \u9875</h3><div style="padding: 14px 10px 14px 10px"><h4 class="maskT-text">\u6587\u672C</h4><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u5BBD</span><div class="col-md-3 col-sm-3 col-md-3 text-center text-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateTextParameter(\'width\',\'textWidthM\',\'widthM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.textWidthM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 text-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateTextParameter(\'width\',\'textWidthM\',\'widthM\',\'textWidthPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.textWidthPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u9AD8</span><div class="col-md-3 col-sm-3 col-md-3 text-center text-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateTextParameter(\'height\',\'textHeightM\',\'heightM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.textHeightM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 text-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateTextParameter(\'height\',\'textHeightM\',\'heightM\',\'textHeightPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.textHeightPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'text\',true)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">X</span><div class="col-md-3 col-sm-3 col-md-3 text-center text-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateTextParameter(\'x\',\'textXM\',\'xM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.textXM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 text-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateTextParameter(\'x\',\'textXM\',\'xM\',\'textXPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.textXPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">Y</span><div class="col-md-3 col-sm-3 col-md-3 text-center text-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateTextParameter(\'y\',\'textYM\',\'yM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.textYM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 text-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateTextParameter(\'y\',\'textYM\',\'yM\',\'textYPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.textYPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'text\',false)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-lg-3 text-right no-padding">\u65CB\u8F6C\uFF1A</span><div class="col-md-6 col-sm-6 col-lg-6 no-padding text-center"><input type="number" class="form-control inputColor" placeholder="\u89D2\u5EA6" ng-change="updateTextRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.textAngle"></div><span class="col-md-3 col-sm-3 col-lg-3 no-padding text-left">\uFF08\u5EA6\uFF09</span></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-lg-3 text-right no-padding">\u7F16\u8F91\u72B6\u6001\uFF1A</span><div class="col-md-9 col-sm-9 col-lg-9 no-padding text-left"><button class="button-b clearInputStyle" ng-click="textDynamic()" ng-class="{\'buttonA\':template.pages.page[template.pageI].textboxes.textbox[template.textI].status==\'dynamic\'}">\u53EF\u7F16\u8F91</button> <button class="button-i clearInputStyle" ng-click="textStatic()" ng-class="{\'buttonA\': template.pages.page[template.pageI].textboxes.textbox[template.textI].status==\'static\'}">\u4E0D\u53EF\u7F16\u8F91</button></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-lg-3 text-right no-padding">\u5B57\u4F53\uFF1A</span><div class="col-md-5 col-sm-5 col-lg-5 no-padding text-left"><select ng-options="item as item.family for item in vm.fontNames" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateTextFont(item)" ng-model="item"><!-- <option value="">\u9ED8\u8BA4\u5B57\u4F53</option> --></select></div><div class="col-md-4 col-sm-4 col-lg-4 no-padding text-left"><button class="button-b button-un button-text" id="textBold" ng-click="textBold(item)" ng-class="{\'buttonA\': template.pages.page[template.pageI].textboxes.textbox[template.textI].style.bold}">B</button> <button class="button-i button-un button-text" id="textItalic" ng-click="textItalic()" ng-class="{\'buttonA\': template.pages.page[template.pageI].textboxes.textbox[template.textI].style.italic}">I</button></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-lg-3 text-right no-padding">\u6587\u5B57\u989C\u8272\uFF1A</span><div class="col-md-8 col-sm-8 col-lg-8 no-padding text-center"><input type="color" class="form-control inputColor" placeholder="\u989C\u8272\u503C" ng-change="updateTextColor()" max="" ng-model-options="{debounce:500}" ng-model="template.textColor"></div><div class="col-md-1 col-sm-1 col-lg-1"></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-lg-3 text-right no-padding">\u6587\u5B57\u5927\u5C0F\uFF1A</span><div class="col-md-6 col-sm-6 col-lg-6 no-padding text-center"><input type="number" class="form-control inputColor" placeholder="\u5927\u5C0F" ng-change="updateTextSize()" max="" ng-model-options="{debounce:500}" ng-model="template.textSize"></div><span class="col-md-3 col-sm-3 col-lg-3 no-padding text-left">\uFF08px\uFF09</span></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 mar-bottom-20" style="line-height: 34px"><span class="col-md-3 col-sm-3 col-lg-3 text-right no-padding">\u6587\u5B57\u5185\u5BB9\uFF1A</span><div class="col-md-8 col-sm-8 col-lg-8 no-padding text-center"><input type="text" class="form-control inputColor" ng-change="updateTextContent()" placeholder="\u8BF7\u8F93\u5165\u6587\u5B57\u5185\u5BB9" ng-model-options="{debounce:500}" ng-model="template.text"></div><div class="col-md-1 col-sm-1 col-lg-1"></div></div><div class="center col-md-12 col-sm-12 col-lg-12"><span ng-click="deleteTextBox()" ng-disabled="!template.pages.page[template.pageI].textboxes.textbox || !template.pages.page[template.pageI].textboxes.textbox.length" class="btn btn-primary">\u5220\u9664</span></div></div></div></div><div class="img-menu" ng-show="template.currentMenu == \'Barcode\'"><h3>\u7B2C {{template.pageI+1}} \u9875</h3><div class="col-md-12 col-sm-12 col-lg-12" style="padding: 14px 10px 14px 10px!important"><h4 class="maskT-text">\u6761\u5F62\u7801</h4><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u5BBD</span><div class="col-md-3 col-sm-3 col-md-3 text-center bar-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateParameter(\'barcode\',\'width\',\'barWidthM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.barWidthM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 bar-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u5BBD\u5EA6" ng-change="updateParameter(\'barcode\',\'width\',\'barWidthM\',\'barWidthPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.barWidthPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">\u9AD8</span><div class="col-md-3 col-sm-3 col-md-3 text-center bar-wah-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateParameter(\'barcode\',\'height\',\'barHeightM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.barHeightM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 bar-wah-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="\u9AD8\u5EA6" ng-change="updateParameter(\'barcode\',\'height\',\'barHeightM\',\'barHeightPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.barHeightPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'Barcode\',true)" ng-model="dpi"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20" style="line-height: 34px"><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">X</span><div class="col-md-3 col-sm-3 col-md-3 text-center bar-xay-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateParameter(\'barcode\',\'x\',\'barXM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.barXM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 bar-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset X" ng-change="updateParameter(\'barcode\',\'x\',\'barXM\',\'barXPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.barXPx"></div><span class="col-md-1 col-sm-1 col-md-1 text-right pad-right-0 pad-left-5">Y</span><div class="col-md-3 col-sm-3 col-md-3 text-center bar-xay-mm pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateParameter(\'barcode\',\'y\',\'barYM\',\'\')" max="" ng-model-options="{debounce:500}" ng-model="template.barYM"></div><div class="col-md-3 col-sm-3 col-md-3 text-center hide1 bar-xay-px pad-lr-4"><input type="number" class="form-control inputColor" placeholder="offset Y" ng-change="updateParameter(\'barcode\',\'y\',\'barYM\',\'barYPx\')" max="" ng-model-options="{debounce:500}" ng-model="template.barYPx"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left pad-lr-6"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi,\'Barcode\',false)" ng-model="dpi"></select></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20"><span ng-click="deleteBarCode()" class="btn btn-primary">\u5220\u9664</span></div></div></div></div></div></div></div></div></div><div class="page-footer col-lg-12 col-sm-12 col-lg-12 no-padding"><div class="footer-nav text-left"><button class="footer-nav-bg" ng-click="showBgbar()" ng-class="{\'kuang-active\':isShowBg}"><span>\u80CC\u666F\u56FE\u7247</span></button> <button class="footer-nav-mask" ng-click="showMaskbar()" ng-class="{\'kuang-active\':isShowMask}"><span>\u8499\u7248\u56FE\u5F62</span></button> <button class="footer-nav-mask" ng-click="showClipArtbar()" ng-class="{\'kuang-active\':isClipArt}"><span>\u7D20\u6750</span></button></div><div class="footer-con"><div class="con-bg col-lg-12 col-sm-12 col-lg-12 no-padding" ng-show="isShowBg"><div ng-style="{width:64*template.bgImgs.bgImg.length+60}"><ul><li ng-repeat="bg in template.bgImgs.bgImg track by $index" data-index="{{$index}}" onmouseover="bgOver(event)" onmouseleave="bgLeave(event)"><img ng-src="{{bg.isEdit?vm.url+bg.identifier+\'?imageView2/2/w/50\':bg.bgImg}}" draggable="true" ondragstart="dragStart(event)" id="dragtarget{{$index}}" ng-style="{width:bg.width?bg.width:auto,height:bg.height?bg.height:auto}" data-index="{{$index}}"> <button class="bg-del{{$index}} page-del" ng-click="deleteBg($index)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></button></li></ul><!--\u589E\u52A0\u4E00\u5F20\u80CC\u666F\u56FE--><!--<div class="con-bg-add">--> <button class="page-noNav" style="height: 50px!important;position: relative"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjiajiahaowubiankuang"></use></svg> <span translate="editorApp.page.addPic" style="display: block"></span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" id="imgSelects" name="file" class="form-control add-pic" multiple="multiple" onchange="updateBg(event)" placeholder="" ng-model-options="{debounce:500}"></button><!--</div>--></div></div><div class="con-mask col-lg-12 col-sm-12 col-lg-12 no-padding" ng-show="isShowMask"><div ng-style="{width:64*template.masks.mask.length+60}"><ul><li ng-repeat="mask in template.masks.mask track by $index" data-index="{{$index}}" onmouseover="maskOver(event)" onmouseleave="maskLeave(event)"><img ng-src="{{mask.isEdit?vm.url+mask.resource.identifier+\'?imageView2/2/w/50\':mask.bgImg}}" draggable="true" ondragstart="dragStart(event)" id="dragtargetMask{{$index}}" data-mask="{{mask.resource.identifier}}" ng-style="{width:mask.width?mask.width:auto,height:mask.height?mask.height:auto}" data-index="{{$index}}"> <button class="mask-del{{$index}} page-del" ng-click="deleteMask($index)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></button></li></ul><!--<span class="con-mask-add">--><!--\u589E\u52A0\u4E00\u5F20\u8499\u7248--> <button class="page-noNav" style="height: 50px!important;position: relative"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjiajiahaowubiankuang"></use></svg> <span translate="editorApp.page.addMask" style="display: block"></span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" id="maskSelects" name="file" class="form-control add-pic" accept="image/png" onchange="updateMask(event)" multiple="multiple" placeholder="" ng-model-options="{debounce:500}"></button><!--</span>--></div></div><div class="con-mask col-lg-12 col-sm-12 col-lg-12 no-padding" ng-show="isClipArt"><div ng-style="{width:200*vm.clipArts.length+60}"><ul><li ng-repeat="clipArt in vm.clipArts track by clipArt.id" data-index="{{$index}}" onmouseover="maskOver(event)" onmouseleave="maskLeave(event)" style="width: auto"><img ng-if="vm.url && clipArt.identifier" ng-src="{{vm.url+clipArt.identifier+\'?imageView2\'}}" draggable="true" ondragstart="dragStart(event)" id="dragtargetClipArt{{$index}}" style="height: 50px" data-clipart="{{clipArt.identifier}}" data-index="{{$index}}"></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/pay-order/pay-order-detail1.html','<div class="listBGC"><div class="breadcrumb-normal">\u8D22\u52A1 / <span>\u5145\u503C\u8BB0\u5F55</span></div><div class="con"><div class="c-form"><div class="c-form-label">\u8BA2\u5355\u53F7\uFF1A</div><div class="c-form-div">{{vm.pay.number}}</div></div><div class="c-form"><div class="c-form-label">\u5145\u503C\u65B9\u5F0F\uFF1A</div><div class="c-form-div"><span data-translate="{{\'backApp.SettlementMethod.\' + vm.pay.type}}">{{vm.pay.type}}</span></div></div><div class="c-form"><div class="c-form-label">\u521B\u5EFA\u65F6\u95F4\uFF1A</div><div class="c-form-div">{{vm.pay.createdDate|date:\'medium\'}}</div></div><div class="c-form"><div class="c-form-label">\u72B6\u6001\uFF1A</div><div class="c-form-div">{{vm.pay.paid ? \'\u5DF2\u652F\u4ED8\' : \'\u672A\u652F\u4ED8\'}}</div><div class="c-form"><div class="c-form-label">\u72B6\u6001\uFF1A</div><div class="c-form-div"><div class="c-table"><table class="za-table table table-striped"><thead><th style="width: 85px"><span>\u5145\u503C\u91D1\u989D</span></th><th style="width: 85px"><span>\u7CFB\u7EDF\u8D60\u9001</span></th><th style="width: 90px"><span>\u603B\u8BA1</span></th><th style="width: 100px"><span>\u5145\u503C\u65F6\u95F4</span></th></thead><tbody><tr><td>{{vm.pay.amount|currency}}</td><td>{{vm.pay.donation |currency}}</td><td>{{(vm.pay.amount + vm.pay.donation)|currency}}</td><td>{{vm.pay.createdDate|date:\'medium\'}}</td></tr></tbody></table></div></div></div></div><div style="margin-top: 20px"><button type="button" class="oval-btn-normal" ng-click="recharge(payOrder)" ng-if="!vm.pay.paid">\u652F\u4ED8</button> <button type="button" class="oval-btn-normal-empty" ng-click="delete(payOrder)" ng-if="!vm.pay.paid">\u5220\u9664</button> <button type="button" class="oval-btn-normal-empty" ng-click="vm.cancel()">\u8FD4\u56DE</button></div><div ng-bind-html="trustHtml"></div><div class="c-isPay" ng-if="vm.isPay"><div class="c-isPay-body"><img ng-src="{{image}}" style="position: absolute;top: 18%;left: 11%;height: 50%"> <img src="content/images/wechat_pay.png" style="width: 100%"><div class="c-isPay-body-button"><button type="button" class="oval-btn-normal" ng-click="savePay()">\u786E\u8BA4\u652F\u4ED8</button> <button type="button" class="oval-btn-normal-empty" ng-click="cancelPay()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/entities/pay-order/pay-order-dialog.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u8D22\u52A1 /<span>\u5546\u6237\u5145\u503C</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"><label class="col-md-1 col-sm-1 col-xs-1 control-label readLabel">\u5546\u6237\u4F59\u989D</label><div class="col-md-8 col-sm-8 col-xs-8"><span>{{vm.store.balance||0|currency}}</span></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u5145\u503C\u91D1\u989D</span><div><ul class="c-pay-amount clearfix" style="padding-left: 75px"><li ng-repeat="item in vm.payList" ng-click="payCb(item)"><img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle_s.png" ng-show="item.id == vm.amountId"> <img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle-e.png" ng-show="item.id != vm.amountId"> <span class="c-amount">{{item.amount}}<span>\u5143</span></span></li><li ng-click="payCb1()"><img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle_s.png" ng-show="vm.otherAmount"> <img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle-e.png" ng-show="!vm.otherAmount"> <span class="c-amount" style="font-size: 14px">\u5176\u4ED6\u91D1\u989D</span></li></ul></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0" ng-if="vm.otherAmount"><div class="col-md-6 col-sm-6 col-xs-6" style="padding-left: 75px"><input type="number" min="0.01" step="0.01" class="c-input1" ng-model="vm.amount" placeholder="\u7CBE\u786E\u5230\u4E24\u4F4D\u5C0F\u6570"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u5145\u503C\u65B9\u5F0F</span><div><ul class="c-pay-amount clearfix" style="padding-left: 75px"><li ng-click="changePayMethod(\'Alipay\')" style="width: 180px"><img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle_s.png" ng-show="vm.payMethod == \'Alipay\'"> <img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle-e.png" ng-show="vm.payMethod != \'Alipay\'"> <img src="content/images/alipay.svg"></li><li ng-click="changePayMethod(\'WeChat\')" style="width: 180px"><img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle_s.png" ng-show="vm.payMethod ==\'WeChat\'"> <img style="float: left; width: 18px;margin-right: 10px" src="content/images/circle-e.png" ng-show="vm.payMethod !=\'WeChat\'"> <img src="content/images/wechatPay.svg"></li></ul></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0"><label class="col-md-1 col-sm-1 col-xs-1 control-label"></label><div class="col-md-8 col-sm-8 col-xs-8"><button type="button" class="small-btn-normal" ng-click="recharge()" style="width: 130px; height: 35px">\u53BB\u5145\u503C</button></div></div><div ng-bind-html="trustHtml"></div><div class="c-form" style="margin-top: 50px"><div class="c-form-div" style="margin-left: 35px"><img src="content/images/payOrderInfo.svg" alt="\u6E29\u99A8\u63D0\u793A"></div></div></div><div class="panel-body form-horizontal" ng-if="!!vm.prepare"><div class="col-lg-12 col-sm-12"><img src="{{image}}" style="position: absolute;top: 18%;left: 11%;height: 50%"> <img src="content/images/wechat_pay.png"></div></div></div></div><!-- <div class="listBGC" style="min-width: 1300px;">\n    <div class="con">\n        <span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A\u5546\u6237\u5145\u503C</span>\n    </div>\n    <div class="modal-body">\n        <div class="panel-body form-horizontal" ng-if="!vm.prepare">\n            <div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0">\n                <label class="col-md-1 col-sm-1 col-xs-1 control-label readLabel">\u5546\u6237\u4F59\u989D</label>\n                <div class="col-md-8 col-sm-8 col-xs-8">\n                    <span>{{vm.store.balance||0|currency}}</span>\n                </div>\n            </div>\n            <div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0">\n                <ul class="c-pay-amount clearfix" style=" padding-left: 75px;">\n                    <li ng-repeat="item in vm.payList" ng-class="{\'pitch\': item.id == vm.amountId}" ng-click="payCb(item)">\n                        <p class="c-amount">{{item.amount}}<span>\u5143</span></p>\n                    </li>\n                    <li ng-class="{\'pitch\': vm.otherAmount}" ng-click="payCb1()">\n                        <p class="c-amount" style="font-size: 14px;">\u5176\u4ED6\u91D1\u989D</p>\n                    </li>\n                </ul>\n            </div>\n            <div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0" ng-if="vm.otherAmount">\n                <label class="col-md-1 col-sm-1 col-xs-1 control-label">\u5145\u503C\u91D1\u989D</label>\n                <div class="col-md-8 col-sm-8 col-xs-8">\n                    <input type="number" min="0.01" step="0.01" class="c-input1" ng-model="vm.amount" placeholder="\u7CBE\u786E\u5230\u4E24\u4F4D\u5C0F\u6570">\n                </div>\n            </div>\n            <div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0">\n                <label class="col-md-1 col-sm-1 col-xs-1 control-label">\u5145\u503C\u65B9\u5F0F</label>\n                <div class="col-md-8 col-sm-8 col-xs-8">\n                    <img src="content/images/wechatPay.svg" alt="\u5FAE\u4FE1\u652F\u4ED8" class="outline" ng-click="changePayMethod(\'WeChat\')" ng-if="vm.payMethod!=\'WeChat\'" />\n                    <img src="content/images/wechatPaySelect.svg" alt="\u5FAE\u4FE1\u652F\u4ED8" class="outline" ng-click="changePayMethod(\'WeChat\')" ng-if="vm.payMethod==\'WeChat\'" />\n                    <img src="content/images/alipay.svg" alt="\u652F\u4ED8\u5B9D\u652F\u4ED8" class="outline" ng-click="changePayMethod(\'Alipay\')" ng-if="vm.payMethod!=\'Alipay\'" />\n                    <img src="content/images/alipaySelect.svg" alt="\u652F\u4ED8\u5B9D\u652F\u4ED8" class="outline" ng-click="changePayMethod(\'Alipay\')" ng-if="vm.payMethod==\'Alipay\'" />\n                </div>\n            </div>\n            <div class="col-lg-12 col-sm-12 col-xs-12 form-group pad-0">\n                <label class="col-md-1 col-sm-1 col-xs-1 control-label"> </label>\n                <div class="col-md-8 col-sm-8 col-xs-8">\n                    <button type="button" class="small-btn-normal" ng-click="recharge()" style=" width: 130px; height: 35px;">\u53BB\u5145\u503C</button>\n                </div>\n            </div>\n            <div ng-bind-html="trustHtml"></div>\n            <div class="c-form" style="margin-top: 50px;">\n                <div class="c-form-div" style="margin-left: 35px;">\n                    <img src="content/images/payOrderInfo.svg" alt="\u6E29\u99A8\u63D0\u793A">\n                </div>\n            </div>\n        </div>\n        <div class="panel-body form-horizontal" ng-if="!!vm.prepare">\n            <div class="col-lg-12 col-sm-12">\n                <img src={{image}} style="position: absolute;top: 18%;left: 11%;height: 50%;">\n                <img src="content/images/wechat_pay.png">\n            </div>\n        </div>\n    </div>\n</div>\n -->');
$templateCache.put('app/entities/pay-order/pay-orders.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u8D22\u52A1 /<span class="breadcrumb-normal-step"> \u6D88\u8D39\u8BB0\u5F55</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"><div style="margin-right: 20px;width: 325px;float: left"><span class="filter-text">\u6D88\u8D39\u65F6\u95F4\uFF1A</span><div><div class="c-form-div clearfix" style="width: 450px"><input class="c-input1" type="text" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.data.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" style="width: 150px; float: left" placeholder="\u5F00\u59CB\u65F6\u95F4"> <span style="display: inline-block; width: 20px; text-align: center; float: left; line-height: 35px">\u81F3</span> <input class="c-input1" type="text" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.data.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" style="width: 150px; float: left" placeholder="\u7ED3\u675F\u65F6\u95F4"></div></div></div><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u5145\u503C\u65B9\u5F0F\uFF1A</span><div><select style="width: 85%" class="form-control border-radius" ng-model="vm.data.type" ng-options="item.id as item.name for item in vm.payTypeList"></select></div></div><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u72B6\u6001\uFF1A</span><div><select style="width: 85%" class="form-control border-radius" ng-model="vm.data.paid" ng-options="item.id as item.name for item in vm.statesList"></select></div></div><div class="c-form pull-left" style="clear: none"><div class="float-left" style="padding-top: 17px"><button class="oval-btn-normal" ng-click="vm.search(vm.searchQuery)"><span>\u641C\u7D22</span></button></div></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr><th><span>\u8BA2\u5355\u53F7</span></th><th><span data-translate="backApp.payOrder.type">Type</span></th><th><span>\u72B6\u6001</span></th><th><span>\u521B\u5EFA\u65F6\u95F4</span></th><th><span>\u652F\u4ED8\u65F6\u95F4</span></th><th><span data-translate="backApp.payOrder.amount">Amount</span></th><th><span>\u7CFB\u7EDF\u8D60\u9001</span></th><th><span>\u64CD\u4F5C</span></th></tr></thead><tbody><tr ng-repeat="payOrder in vm.payOrders"><td>{{payOrder.number}}</td><td data-translate="{{\'backApp.SettlementMethod.\' + payOrder.type}}">{{payOrder.type}}</td><td>{{payOrder.paid ? \'\u5DF2\u652F\u4ED8\' : \'\u672A\u652F\u4ED8\'}}</td><td>{{payOrder.createdDate|date:\'medium\'}}</td><td>{{payOrder.paidDate|date:\'medium\'}}</td><td>{{payOrder.amount}}</td><td>{{payOrder.donation}}</td><td style="display: table-cell; vertical-align: middle"><button class="status-btn" type="submit" ui-sref="pay-order.detail1({id:payOrder.id})"><i class="icon iconfont webchakan"></i> <span class="hover-span">\u67E5\u770B</span></button> <button class="status-btn" type="submit" ng-click="recharge(payOrder)" ng-if="!payOrder.paid"><i class="icon iconfont webzhifu"></i> <span class="hover-span">\u652F\u4ED8</span></button> <button class="status-btn" type="submit" ng-click="cancel(payOrder)" ng-if="!payOrder.paid"><i class="icon iconfont webshanchu"></i> <span class="hover-span">\u5220\u9664</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/pay-order/pay-orders2.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u53D1\u7968 /<span class="breadcrumb-normal-step"> \u53D1\u7968\u7533\u8BF7</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="c-form pull-left" style="clear: none"><span class="c-form-label" style="color: var(--textHeadColor) !important;width: 80px;text-align: left">\u5145\u503C\u65F6\u95F4\uFF1A</span><div class="c-form-div clearfix" style="width: 450px;margin-left: 80px"><input id="field_startTime" type="text" class="c-input1" name="startTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" style="width: 200px; float: left" placeholder="\u5F00\u59CB\u65F6\u95F4"> <span style="display: inline-block; width: 20px; text-align: center; float: left; line-height: 35px">\u81F3</span> <input id="field_endTime" type="text" class="c-input1" name="endTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" style="width: 200px; float: left" placeholder="\u7ED3\u675F\u65F6\u95F4"></div></div><div class="c-form pull-left" style="clear: none"><div class="float-left"><button class="oval-btn-normal" ng-click="vm.loadAll()"><span>\u7B5B\u9009</span></button></div></div></div></div></div><div style="margin: 10px 0; padding: 5px; border: 1px solid red; background: #fff2f1 !important; border-radius: 5px; width: 350px">\u5F53\u524D\u9875\u6709 <span style="color: red">{{vm.count}}</span>\u4E2A\u8BA2\u5355\u53EF\u5F00\u53D1\u7968\uFF0C\u53EF\u5F00\u7968\u91D1\u989D\uFF1A <span style="color: red">\uFFE5{{vm.amount||0|number:2}}</span>\u5143</div><div class="white pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width: 100px"><i class="choose-list" ng-show="!selectAll" ng-click="chooseAll()"></i> <i class="choose-sel-all" ng-show="selectAll" ng-click="chooseAll()"></i></th><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="backApp.payOrder.type">Type</span></th><th><span data-translate="backApp.payOrder.amount">Amount</span></th><th><span data-translate="backApp.payOrder.invoiced">Invoiced</span></th><th><span data-translate="backApp.payOrder.name">Name</span></th><th><span data-translate="backApp.payOrder.createdDate">createdDate</span></th></tr></thead><tbody><tr ng-repeat="payOrder in vm.payOrders track by payOrder.id"><td><i class="choose-li" ng-click="chooseOne(payOrder)" ng-show="!payOrder.select"></i> <i class="choose-sel" ng-click="chooseOne(payOrder)" ng-show="payOrder.select"></i></td><td>{{payOrder.id}}</td><td data-translate="{{\'backApp.SettlementMethod.\' + payOrder.type}}">{{payOrder.type}}</td><td>{{payOrder.amount}}</td><td>{{payOrder.invoiced?"\u662F":"\u5426"}}</td><td>{{payOrder.name}}</td><td style="display: table-cell; vertical-align: middle">{{payOrder.createdDate|date:\'medium\'}}</td></tr></tbody></table></div><div style="text-align: left;padding: 10px 0"><button type="button" class="oval-btn-normal" ng-click="invoiceDetail()"><span>\u7D22\u53D6\u53D1\u7968</span></button>&nbsp; <span>\u5F85\u5F00\u7968\u91D1\u989D\uFF1A<span style="color: red">\uFFE5{{vm.selectAmount||0|number:2}}</span>\u5143</span></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/process/process-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProcessLabel" translate="backApp.process.home.createOrEditLabel">\u7F16\u8F91\u5DE5\u827A</h4></div><div class="modal-body"><div class="form-row"><label class="form-label" translate="backApp.process.name">\u5DE5\u827A\u540D\u79F0</label><input type="text" class="form-control form-input" name="name" ng-model="vm.process.name" readonly="readonly"></div><div class="form-row"><label class="form-label" translate="backApp.process.formLabelAlias">\u5DE5\u827A\u522B\u540D</label><input type="text" class="form-control form-input" name="alias" ng-model="vm.process.alias" placeholder="{{\'backApp.process.placeholder.alias\' | translate}}"></div><div class="form-row"><label class="form-label" translate="backApp.process.formLabelQuantityType">\u5DE5\u827A\u7C7B\u578B</label><select class="form-control form-input" disabled="disabled" readonly="readonly" name="quantityType" ng-model="vm.quantityType"><option value="SINGLE" translate="backApp.process.typeList.singleChannel">\u5355\u901A\u9053\u5DE5\u827A</option><option value="MULTIPLE" translate="backApp.process.typeList.multiSpotColor">\u591A\u5B50\u4E13\u8272\u5DE5\u827A</option></select></div><!-- <div class="form-row" ng-if="vm.process.quantityType === \'SINGLE\'">\n            <label class="form-label" translate="backApp.process.spotColor">\u4E13\u8272\u540D</label>\n            <input type="text" class="form-control form-input" name="spotColor" ng-model="vm.process.spotColor"\n                placeholder="{{\'backApp.process.placeholder.spotColor\' | translate}}">\n        </div> --><div class="form-row" ng-if="vm.process.type !== \'DIE_LINE\'"><label class="form-label" translate="backApp.process.formLabelEpitaxy">\u6269\u6536\u7C7B\u578B</label><select class="form-control form-input" name="epitaxy" ng-model="vm.process.epitaxy"><option value="">\u65E0</option><option value="EXTENSION" translate="backApp.process.epitaxyExtension">\u9614\u8FB9</option><option value="SHRINKAGE" translate="backApp.process.epitaxyShrinkage">\u6536\u7F29</option></select></div><div class="form-row" ng-if="vm.process.epitaxy && vm.process.type !== \'DIE_LINE\'"><label class="form-label" translate="backApp.process.formLabelEpitaxyValue">\u6269\u6536\u53C2\u6570</label><input type="number" class="form-control form-input" name="epitaxyValue" ng-model="vm.process.epitaxyValue" ng-model-options="{ allowInvalid: true }" ng-min="vm.getEpitaxyMin()" ng-max="vm.getEpitaxyMax()" ng-step="vm.getEpitaxyStep()" ng-keydown="vm.onEpitaxyKeyDown($event)" ng-change="vm.onEpitaxyValueChange()" placeholder="{{\'backApp.process.placeholder.epitaxyValue\' | translate}}"><select class="form-control form-input" style="max-width: 100px !important" name="unit" ng-model="vm.process.unit" ng-change="vm.onUnitChange()"><option value="">{{\'backApp.process.select\' | translate}}</option><option value="px">px</option><option value="mm">mm</option></select></div><div class="form-row"><label class="form-label" translate="backApp.process.remark">\u63CF\u8FF0</label><input type="text" class="form-control form-input" name="remark" ng-model="vm.process.remark" placeholder="{{\'backApp.process.placeholder.remark\' | translate}}"></div></div><div class="modal-footer" style="text-align: center"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="editForm.$invalid || vm.isSaving"><span translate="entity.action.save">\u4FDD\u5B58</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.cancel">\u53D6\u6D88</span></button></div></form><style>.form-row {\n        display: flex;\n        align-items: center;\n        margin-bottom: 15px;\n        flex-wrap: wrap;\n    }\n    .form-label {\n        flex: 0 0 90px;\n        text-align: right;\n        margin: 0 10px 0 0;\n        font-weight: normal;\n    }\n    .form-input {\n        flex: 1;\n        max-width: 220px;\n    }\n    .form-input-group {\n        display: flex;\n        max-width: 290px;\n        flex: 1;\n    }\n    .form-input-group .form-control {\n        flex: 1;\n    }\n    .form-input-group .input-group-addon {\n        display: flex;\n        align-items: center;\n        border-left: 0;\n        border-radius: 0 4px 4px 0;\n    }\n    .form-input-group .input-group-btn {\n        display: flex;\n    }\n    .form-hint {\n        width: 100%;\n        margin-left: 100px;\n        font-size: 12px;\n        color: #999;\n        margin-top: 4px;\n    }\n    .modal-body {\n        max-height: 60vh;\n        overflow-y: auto;\n        padding: 15px 20px;\n        margin-top: 0 !important;\n    }\n    .modal-footer {\n        margin-left: 0;\n        margin-right: 0;\n        border-top: 1px solid #e5e5e5;\n        padding: 10px;\n        width: calc(100% - 2px);\n    }</style>');
$templateCache.put('app/entities/process/process-spot-color-dialog.html','<form name="spotColorForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">\u4E13\u8272\u8BBE\u7F6E</h4></div><div class="modal-body" style="padding-bottom: 60px !important"><div class="spot-color-table-wrap"><table class="spot-color-table"><thead><tr><th class="col-no" translate="backApp.process.operationValue.serial">\u5E8F\u53F7</th><th class="col-display">\u5C55\u793A\u540D\u79F0</th><th class="col-name" translate="backApp.process.operationValue.spotColor">\u4E13\u8272\u540D</th><th class="col-color">\u9884\u89C8\u8272\u503C</th><th class="col-sort">\u6392\u5E8F</th><th class="col-action" translate="global.field.operate">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.operationValues track by $index" class="spot-color-row"><td class="col-no">{{$index + 1}}</td><td class="col-display"><input type="text" class="form-control spot-input" ng-model="item.alias" placeholder="\u8BF7\u8F93\u5165\u5C55\u793A\u540D\u79F0"></td><td class="col-name"><input type="text" class="form-control spot-input" ng-model="item.spotColor" placeholder="\u8BF7\u8F93\u5165\u4E13\u8272\u540D" required></td><td class="col-color"><input style="" type="color" ng-model="item.color"></td><td class="col-sort"><input type="number" class="form-control spot-input spot-sort-input" ng-disabled="vm.quantityType == \'SINGLE\'" ng-model="item.seq" min="1" required></td><td class="col-action"><a ng-click="vm.removeOperationValue($index)" translate="entity.action.delete">\u5220\u9664</a></td></tr><!-- <tr ng-if="vm.operationValues.length === 0">\n                        <td colspan="6" class="text-center spot-empty" translate="backApp.process.operationValue.noData">\u6682\u65E0\u6570\u636E</td>\n                    </tr> --></tbody></table></div><div class="spot-add-bar" ng-if="vm.quantityType == \'MULTIPLE\' || vm.quantityType == \'SINGLE\' && vm.operationValues.length == 0"><button type="button" class="btn btn-link spot-add-btn" ng-click="vm.addOperationValue()"><!-- <i class="glyphicon glyphicon-plus"></i> --> <span translate="backApp.process.operationValue.add">\u65B0\u589E\u5B50\u4E13\u8272</span></button></div></div><div class="modal-footer"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.cancel">\u53D6\u6D88</span></button> <button style="margin-left: 30px" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving"><span translate="entity.action.save">\u4FDD\u5B58</span></button></div></form><style>.spot-color-table-wrap {\n        overflow-x: auto;\n    }\n\n    .spot-color-table {\n        width: 100%;\n        border-collapse: collapse;\n        font-size: 13px;\n    }\n\n    .spot-color-table thead th {\n        background: #f5f6fa;\n        color: #333;\n        font-weight: 600;\n        padding: 10px 8px;\n        border-bottom: 2px solid #e0e3e9;\n        white-space: nowrap;\n    }\n\n    .spot-color-table .col-no {\n        width: 60px;\n        text-align: center;\n    }\n\n    .spot-color-table .col-display,\n    .spot-color-table .col-name {\n        min-width: 120px;\n        text-align: center;\n    }\n\n    .spot-color-table .col-color {\n        width: 80px;\n        text-align: center;\n    }\n\n    .spot-color-table .col-color input[type="color"] {\n        width: 100%;\n        height: 32px;\n        padding: 0;\n        border: 1px solid #d9d9d9;\n        border-radius: 4px;\n        cursor: pointer;\n        background: none;\n    }\n\n    .spot-color-table .col-sort {\n        width: 80px;\n        text-align: center;\n    }\n\n    .spot-color-table .col-action {\n        width: 80px;\n        text-align: center;\n    }\n\n    .spot-color-row td {\n        padding: 8px;\n        border-bottom: 1px solid #f0f1f5;\n        vertical-align: middle;\n    }\n\n    .spot-color-row:hover {\n        background: #fafbfd;\n    }\n\n    .spot-color-row:last-child td {\n        border-bottom: none;\n    }\n\n    .spot-input {\n        height: 32px;\n        font-size: 13px;\n        border-radius: 4px;\n        border: 1px solid #d9d9d9;\n        padding: 4px 8px;\n        transition: border-color .2s;\n    }\n\n    .spot-input:focus {\n        border-color: #409eff;\n        box-shadow: 0 0 0 2px rgba(64, 158, 255, .15);\n        outline: none;\n    }\n\n    .spot-sort-input {\n        width: 60px;\n        min-width: 60px;\n        text-align: center;\n    }\n\n    .spot-empty {\n        padding: 40px 0;\n        color: #999;\n        font-size: 14px;\n    }\n\n    .spot-add-bar {\n        padding: 10px 8px 0;\n    }\n\n    .spot-add-btn {\n        padding: 4px 0;\n        color: #409eff;\n        font-size: 13px;\n        text-decoration: none;\n    }\n\n    .spot-add-btn:hover,\n    .spot-add-btn:focus {\n        color: #337ecc;\n        text-decoration: none;\n    }\n\n    .spot-add-btn .glyphicon {\n        font-size: 11px;\n        margin-right: 2px;\n    }\n\n    .spot-del-btn {\n        padding: 3px 10px;\n        font-size: 12px;\n    }\n\n    .modal-body {\n        max-height: 60vh;\n        overflow-y: auto;\n        padding: 15px 20px 20px;\n    }\n\n    .modal-footer {\n        margin-left: 0;\n        margin-right: 0;\n        border-top: 1px solid #e5e5e5;\n        padding: 10px;\n        width: calc(100% - 2px);\n        display: flex;\n        justify-content: center;\n    }</style>');
$templateCache.put('app/entities/process/processes.html','<div class="listBGC" style="min-height: 700px;min-width: 1100px"><span class="breadcrumb-normal">\u5546\u54C1 / <span class="breadcrumb-normal-step" translate="global.menu.entities.process"></span></span><div class="col-lg-12 col-sm-12 form-group pad-0 store-body mar-top-15"><div class="table-responsive store-body-con"><table class="jh-table table table-striped"><thead><tr><th class="text-center" style="width: 60px"><span translate="backApp.process.serial">\u5E8F\u53F7</span></th><th class="text-center"><span translate="backApp.process.name">\u5DE5\u827A\u540D\u79F0</span></th><th class="text-center"><span translate="backApp.process.alias">\u522B\u540D</span></th><th class="text-center"><span translate="backApp.process.colQuantityType">\u7C7B\u578B</span></th><th class="text-center"><span translate="backApp.process.spotColor">\u4E13\u8272\u540D</span></th><th class="text-center"><span translate="backApp.process.colEpitaxy">\u6269\u6536\u7C7B\u578B</span></th><th class="text-center"><span translate="backApp.process.colEpitaxyValue">\u6536\u7F29\u6269\u8FB9</span></th><th class="text-center"><span translate="backApp.process.remark">\u63CF\u8FF0</span></th><th class="text-center" style="width: 80px" translate="backApp.process.operation">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="process in vm.processes track by process.id"><td class="text-center">{{$index + 1}}</td><td>{{process.name}}</td><td>{{process.alias || \'-\'}}</td><td><!-- \u70EB\u8272 UV \u591A\u5B50\u5DE5\u827A --> <span ng-if="process.type === \'HOT_STAMP\' || process.type === \'UV\' || process.type === \'FLUORESCENT\'">{{\'backApp.process.qtyTypeMultiple\' | translate}}</span> <span ng-if="process.type === \'WHITE_INK\' || process.type === \'DIE_LINE\'">{{\'backApp.process.qtyTypeSingle\' | translate}}</span></td><td><a ng-click="vm.openSpotColorDialog(process)">{{\'backApp.process.goConfig\' | translate}}</a></td><td><span ng-if="process.epitaxy"><span ng-if="process.epitaxy === \'EXTENSION\'">{{\'backApp.process.epitaxyExtension\' | translate}}</span> <span ng-if="process.epitaxy === \'SHRINKAGE\'">{{\'backApp.process.epitaxyShrinkage\' | translate}}</span> </span><span ng-if="!process.epitaxy">-</span></td><td><span ng-if="process.epitaxy"><span ng-if="process.epitaxyValue !== null && process.epitaxyValue !== undefined">{{process.epitaxyValue}}{{process.unit}}</span> </span><span ng-if="!process.epitaxy">-</span></td><td class="desc-cell" title="{{process.remark || \'-\'}}">{{process.remark || \'-\'}}</td><td class="text-center"><a ui-sref="process.edit({id:process.id})" translate="entity.action.edit">\u7F16\u8F91</a></td></tr></tbody></table></div><div class="text-center" ng-if="vm.processes.length === 0"><span translate="backApp.process.home.notFound">\u672A\u627E\u5230\u5DE5\u827A\u8BB0\u5F55</span></div></div></div><style>.store-body-con a {\n        outline: none;\n    }\n    .desc-cell {\n        max-width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }</style>');
$templateCache.put('app/entities/product/article-preview-web.html','<div class="bg view-article" style="min-height: 78vh" ng-style="{width:getUlW()}"><div class="save-page" ng-cloak><div><img src="content/images/icon/loading.gif"> <span>\u8BF7\u7A0D\u5019</span></div></div><div ng-if="vm.article.editorType != \'PICTURE\' || vm.article.editorType != \'PICTURE_PRO\' || vm.article.editorType != \'PICTURE_PRO_P"><div class="main clearfix" ng-if="!vm.isPoster && vm.bindingtype!=\'None\'&&template.pages.page.length>1"><div class="bb-custom-wrapper bb-bg" ng-style="{\n                        margin:\'0 auto\',\n                        width:getUlW()}"><div class="templateView-carousel"><ul rn-carousel="" rn-carousel-index="carouselIndex" rn-carousel-buffered="" class="carouselView5 bb-bookblock" id="bb-bookblock" ng-style="{\n                            margin:\'0 auto\',\n                            width:getUlW()}"><li ng-repeat="slide in document.pages track by $index" ng-init="outerIndex = $index" ng-class="{\'half-width\':isPull&&vm.bindingtype==\'Left\'&&($last||$first),\n                                \'half-margin\':isPull&&vm.bindingtype==\'Left\'&&$first,\n                                \'bb-white\':isPull&&!($first||$last)}" class="bb-item" style="position: relative" is-over="toggle.now" data-index="{{$index}}"><div ng-show="vm.bindingtype==\'Top\'"><div class="bb-custom-img" ng-class="{\'custom-grid\':slide.arr.background.type==\'Color\'&&!slide.arr.background.color}" ng-style="{\n                                    position:\'relative\',\n                                    overflow:\'hidden\',\n                                    opacity:$first?0:1,\n                                    \'-ms-filter\': \'alpha(opacity=\'+$first?0:1+\')!important\',\n                                    filter:\'alpha(opacity=\'+$first?0:1+\')!important\',\n                                    \'margin-top\':slide.spread==true?slide.marginTop:0,\n                                    \'margin-bottom\':slide.spread==true?slide.marginTop:0,\n                                    width:slide.w1,\n                                    height:slide.h1,\n                                    \'background-color\':slide.arr.background.color||\'#fff\'\n                                    }"><!--\u80CC\u666F\u5C42--><div style="overflow:hidden;display: inline-block;background: #fff" ng-if="slide.arr.bgImg" ng-style="{width:slide.w1,height:slide.h1}" class="background{{outerIndex}} background"><img ng-src="{{slide.arr.bgImg}}" class="remove-style" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,\n                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,\n                                             width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                             height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}"></div><div ng-repeat="level in slide.arr.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div ng-if="level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,\n                                                \'z-index\':level.seq-0+200,\n                                                \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr.pageScaleH\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr.pageScaleW,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr.pageScaleW\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr.pageScaleH,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr.pageScaleH\n                                                 }"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-if="level.imageart" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background overflow-hidden" ng-if="level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio > 12 ? level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? level.textbox.style.lineheight*slide.arr.pageScaleW* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? level.textbox.style.letterspacing*slide.arr.pageScaleW* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio > 12 ? docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight*slide.arr.pageScaleW* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing*slide.arr.pageScaleW* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr.barcode&&slide.arr.barcode.geometry" ng-style="{\n                                         \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,\n                                         \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,\n                                         \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,\n                                         \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,\n                                         \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div><div class="fc-calendar-wrap" ng-show="$first" style="overflow:hidden" ng-class="{\'custom-grid\':slide.arr.background.type==\'Color\'&&!slide.arr.background.color}" ng-style="{\n                                        position: \'relative\',\n                                        overflow:\'hidden\',\n                                        \'font-size\': 0,\n                                        \'letter-spacing\': \'-2px\',\n                                        width:slide.w1,\n                                        height:slide.h1,\n                                        \'background-color\':slide.arr.background.color||\'#fff\'\n                                    }"><!--\u80CC\u666F\u5C42--> <img ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,\n                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,\n                                             width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                             height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}" ng-if="slide.arr.bgImg" class="remove-style background{{outerIndex}} background" ng-src="{{slide.arr.bgImg}}"><div ng-repeat="level in slide.arr.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div ng-if="level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,\n                                                \'z-index\':level.seq-0+200,\n                                                \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr.pageScaleH\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr.pageScaleW,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr.pageScaleW\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr.pageScaleH,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!80p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr.pageScaleH\n                                                 }"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" data-index="{{$index}}" ng-if="level.imageart" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background overflow-hidden" ng-if="level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio > 12 ? level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? level.textbox.style.lineheight*slide.arr.pageScaleW* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? level.textbox.style.letterspacing*slide.arr.pageScaleW* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio > 12 ? docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight*slide.arr.pageScaleW* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing*slide.arr.pageScaleW* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-if="slide.arr.barcode" ng-style="{\n                                         \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,\n                                         \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,\n                                         \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,\n                                         \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,\n                                         \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div><div class="fc-calendar-wrap" ng-hide="$first||slide.spread==true" ng-class="{\'custom-grid\':slide.arr2.background.type==\'Color\'&&!slide.arr2.background.color}" ng-style="{\n                                        position: \'relative\',\n                                        overflow:\'hidden\',\n                                        \'font-size\': 0,\n                                        \'letter-spacing\': \'-2px\'\n                                        }" ng-disabled="$last&&slide.arr2==\'\'"><span style="overflow:hidden;display: inline-block" class="background{{outerIndex}} background" ng-style="{\n                                                width:$last||slide.arr2==\'\'?slide.w1:slide.w2,\n                                                height:$last||slide.arr2==\'\'?slide.h1:slide.h2,\n                                                \'background-color\':slide.arr2.background.color||\'#fff\'}"><!--\u80CC\u666F\u5C42--> <img class="remove-style" ng-if="slide.arr2.bgImg" ng-src="{{slide.arr2==\'\'?$last?\'\':\'content/images/white.png\':slide.arr2.bgImg}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:slide.arr2.background.offsetx*slide.arr2.pageScaleW,\n                                                 top:slide.arr2.background.offsety*slide.arr2.pageScaleH,\n                                                 width: slide.arr2.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                 height:slide.arr2.background.adaptation==\'Height\'?\'100%\':\'auto\'}"></span><div ng-repeat="level in slide.arr2.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div ng-if="level.imagebox" ng-hide="slide.arr2==\'\'&&$last&&!level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr2.pageScaleH,\n                                                \'z-index\':level.seq-0+200,\n                                                \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr2.pageScaleH,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr2.pageScaleH\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr2.pageScaleW,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr2.pageScaleW\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr2.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr2.pageScaleH,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr2.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr2.pageScaleH\n                                                 }"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-hide="slide.arr2==\'\'&&$last&&!level.imageart" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr2.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr2.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background overflow-hidden" ng-hide="slide.arr2==\'\'&&$last&&!level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr2.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr2.pageScaleW*slide.arr2.ratio > 12 ? level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? level.textbox.style.lineheight*slide.arr2.pageScaleW* slide.arr2.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? level.textbox.style.letterspacing*slide.arr2.pageScaleW* slide.arr2.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? (level.textbox.geometry.width*slide.arr2.pageScaleW):level.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr2.pageScaleW*slide.arr2.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr2.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr2.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr2.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr2.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr2.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr2.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr2.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr2.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr2.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr2.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr2.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr2.pageScaleW*slide.arr2.ratio > 12 ? docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? docLevel.textbox.style.lineheight*slide.arr2.pageScaleW* slide.arr2.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? docLevel.textbox.style.letterspacing*slide.arr2.pageScaleW* slide.arr2.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr2.pageScaleW):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr2.barcode" ng-style="{\n                                            \'width\': slide.arr2.barcode.geometry.width*slide.arr2.pageScaleW,\n                                             \'height\': slide.arr2.barcode.geometry.height*slide.arr2.pageScaleH,\n                                             \'left\': slide.arr2.barcode.geometry.x*slide.arr2.pageScaleW,\n                                             \'top\': slide.arr2.barcode.geometry.y*slide.arr2.pageScaleH,\n                                             \'transform\': \'rotate(-\' + slide.arr2.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div></div><div ng-show="vm.bindingtype==\'Left\'"><div class="slide-content slide1" data-index="{{$index}}" id="slide1" ng-class="{\'bb-custom-side\':(slide.arr2!=\'\'||$first||(slide.arr2==\'\'&&slide.spread==false)),\'custom-grid\':slide.arr.background.type==\'Color\'&&!slide.arr.background.color}" ng-style="{\n                                            width:getPageWaHLar(slide,true,true),\n                                            height:getPageWaHLar(slide,false,true),\n                                            \'margin-left\':$first?0:slide.marginLeft,\n                                            \'background-color\':slide.arr.background.color||\'#fff\',\n                                            position:relative}"><!--\u80CC\u666F\u5C42--> <img ng-if="slide.arr.bgImg" ng-src="{{slide.arr.bgImg||slide.arr.background.resource.identifier + \'?imageMogr2\'}}" class="background{{$index}} background" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,\n                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,\n                                             width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                             height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.arr.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div ng-if="level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,\n                                                \'z-index\':level.seq-0+200,\n                                                \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr.pageScaleH\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr.pageScaleW,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr.pageScaleW\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr.pageScaleH,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr.pageScaleH\n                                                 }"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-if="level.imageart" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background overflow-hidden" ng-if="level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (level.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio > 12 ? level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio : 12) + \'pt\',\n                                                    \'color\': level.textbox.style.color,\n                                                    \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? level.textbox.style.lineheight*slide.arr.pageScaleW* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? level.textbox.style.letterspacing*slide.arr.pageScaleW* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                    \'opacity\': level.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': level.textbox.style.align,\n                                                    \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio)+\')\',\n                                                    \'width\':  (level.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.pageScaleW*slide.arr.ratio > 12 ? docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight*slide.arr.pageScaleW* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing*slide.arr.pageScaleW* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.arr.pageScaleW* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr.barcode" ng-style="{\n                                         \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,\n                                         \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,\n                                         \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,\n                                         \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,\n                                         \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div><div class="slide-content slide1" ng-show="!orientations&&($first||$last)" ng-style="{\n                                        opacity:0,\n                                        width:slide.pageW1+slide.pageW2,\n                                        height:slide.pageH1,\n                                        position:relative}"></div><div ng-hide="isPull&&($first||$last||slide.spread==true)" id="slide2" class="slide-content bb-custom-side slide2" style="position: relative!important" ng-class="{\'custom-grid\':slide.arr2.background.type==\'Color\'&&!slide.arr2.background.color}" ng-style="{\n                                        width:getPageWaHLar(slide,true,false),\n                                        height:getPageWaHLar(slide,false,false),\n                                        \'background-color\':slide.arr2.background.color||\'#fff\'\n                                    }"><!--\u80CC\u666F\u5C42--> <img ng-if="slide.arr2.bgImg" ng-src="{{slide.arr2==\'\'?\'\':slide.arr2.bgImg}}" class="background{{$index}} background" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr2.background.offsetx*slide.arr2.pageScaleW,\n                                             top:slide.arr2.background.offsety*slide.arr2.pageScaleH,\n                                             width: slide.arr2.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                             height:slide.arr2.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.arr2.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div ng-if="level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr2.pageScaleH,\n                                                \'z-index\':level.seq-0+200,\n                                                \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr2.pageScaleH,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr2.pageScaleH\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.image.height*slide.arr2.pageScaleW,\n                                                    \'left\':level.imagebox.image.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.image.offsety*slide.arr2.pageScaleW\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr2.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr2.pageScaleH,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.arr2.pageScaleW,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.arr2.pageScaleH,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.arr2.pageScaleW,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.arr2.pageScaleH\n                                                 }"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-if="level.imageart" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr2.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr2.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background overflow-hidden" ng-if="level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr2.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr2.pageScaleW*slide.arr2.ratio > 12 ? level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? level.textbox.style.lineheight*slide.arr2.pageScaleW* slide.arr2.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? level.textbox.style.letterspacing*slide.arr2.pageScaleW* slide.arr2.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? (level.textbox.geometry.width*slide.arr2.pageScaleW):level.textbox.geometry.width/( 1 / 12 * level.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr2.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr2.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr2.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr2.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr2.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr2.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr2.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr2.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr2.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr2.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr2.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr2.pageScaleW*slide.arr2.ratio > 12 ? docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? docLevel.textbox.style.lineheight*slide.arr2.pageScaleW* slide.arr2.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? docLevel.textbox.style.letterspacing*slide.arr2.pageScaleW* slide.arr2.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.arr2.pageScaleW* slide.arr2.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr2.pageScaleW):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr2.barcode" ng-style="{\n                                            \'width\': slide.arr2.barcode.geometry.width*slide.arr2.pageScaleW,\n                                             \'height\': slide.arr2.barcode.geometry.height*slide.arr2.pageScaleH,\n                                             \'left\': slide.arr2.barcode.geometry.x*slide.arr2.pageScaleW,\n                                             \'top\': slide.arr2.barcode.geometry.y*slide.arr2.pageScaleH,\n                                             \'transform\': \'rotate(-\' + slide.arr2.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div></div></li><li ng-repeat="page in template.pages.page track by $index" ng-init="outerIndex = $index" style="display: none"><div class="select-img-box diy-box" style="position: absolute" ng-repeat="imgInput in page.imageboxes.imagebox track by $index"><img class="imgBox{{outerIndex}}{{$index}}"></div></li></ul></div></div></div><div class="main clearfix" ng-if="!vm.isPoster && (vm.bindingtype==\'None\'||template.pages.page.length<2)"><div class="bb-custom-wrapper bb-bg" ng-style="{\'margin-top\':\'50px\'}"><div class="templateView-carousel" style="width: 100%;text-align: center"><ul rn-carousel="" rn-carousel-index="carouselIndex" rn-carousel-buffered="" style="display: inline-block;overflow: auto" class="carouselView5 pad-bottom-70"><li ng-repeat="slide in template.pages.page track by $index" ng-init="outerIndex = $index" ng-style="{\n                                float:\'left\',\n                            overflow:\'hidden\',\n                            width:dWidth*0.25,\n                            \'margin\':\'10px \'+dWidth*0.03+\'px\',\n                            \'box-shadow\':\'0 2px 5px rgba(187, 187, 187, 0.6)\'}" style="position: relative; display: inline" data-index="{{$index}}"><div class="slide-content" data-index="{{$index}}" ng-class="{\'custom-grid\':slide.background.type==\'Color\'&&!slide.background.color}" ng-style="{\n                                width:dWidth*0.25,\n                                height:dWidth*0.25*slide.mediabox.height/slide.mediabox.width,\n                                \'background-color\':slide.background.color||\'#fff\'\n                                }"><!--<img ng-src="{{slide.bgImg}}" style="width: 100%" />--><!--\u80CC\u666F\u5C42--> <img ng-src="{{slide.bgImg}}" ng-if="slide.bgImg" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.background.offsetx,\n                                             top:slide.background.offsety,\n                                             width: slide.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                             height:slide.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div ng-if="level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.geometry.width,\n                                                \'height\': level.imagebox.geometry.height,\n                                                \'left\': level.imagebox.geometry.x,\n                                                \'top\': level.imagebox.geometry.y,\n                                                \'z-index\':level.seq-0+200,\n                                                \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width,\n                                                    \'height\': level.imagebox.image.height,\n                                                    \'left\':level.imagebox.image.offsetx,\n                                                    \'top\':level.imagebox.image.offsety\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width,\n                                                    \'height\': level.imagebox.image.height,\n                                                    \'left\':level.imagebox.image.offsetx,\n                                                    \'top\':level.imagebox.image.offsety\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width,\n                                                    \'height\': level.imagebox.blurredrectangle.height,\n                                                    \'left\':level.imagebox.blurredrectangle.x,\n                                                    \'top\':level.imagebox.blurredrectangle.y,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width,\n                                                    \'height\': level.imagebox.blurredrectangle.height,\n                                                    \'left\':level.imagebox.blurredrectangle.x,\n                                                    \'top\':level.imagebox.blurredrectangle.y\n                                                 }"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box" data-index="{{$index}}" ng-if="level.imageart" ng-style="{\n                                            \'z-index\':level.seq-0+200,\n                                            \'opacity\':level.imageart.transparency,\n                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                            \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'width\': level.imageart.geometry.width,\n                                            \'height\': level.imageart.geometry.height,\n                                            \'left\': level.imageart.geometry.x,\n                                            \'top\': level.imageart.geometry.y}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img id="select-sticker-{{$index}}" ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx,\n                                                    \'top\': level.imageart.offsety,\n                                                    \'width\': level.imageart.geometry.width * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box" ng-if="level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y,\n                                                left: level.textbox.geometry.x,\n                                                width: level.textbox.geometry.width,\n                                                height: level.textbox.geometry.height,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width):level.textbox.geometry.width/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width,\n                                                    height: level.textdocument.geometry.height,\n                                                    left: level.textdocument.geometry.x,\n                                                    top: level.textdocument.geometry.y,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx,\n                                                         top:level.textdocument.background.offsety,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width,\n                                                            height: docLevel.imageart.geometry.height,\n                                                            left: docLevel.imageart.geometry.x,\n                                                            top: docLevel.imageart.geometry.y,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx,\n                                                                    \'top\': docLevel.imageart.offsety,\n                                                                    \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width,\n                                                            \'height\': docLevel.textbox.geometry.height,\n                                                            \'left\': docLevel.textbox.geometry.x,\n                                                            \'top\': docLevel.textbox.geometry.y,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.ratio > 12 ? (docLevel.textbox.geometry.width):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                    \'width\': slide.barcode.geometry.width,\n                                     \'height\': slide.barcode.geometry.height,\n                                     \'left\': slide.barcode.geometry.x,\n                                     \'top\': slide.barcode.geometry.y,\n                                     \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\'\n                                    }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div></li></ul></div></div></div><div class="main clearfix" ng-if="vm.isPoster"><div ng-repeat="item in template.pages.page track by $index" ng-style="{\n                        \'width\': item.custom.width * item.custom.ratio,\n                        \'height\': item.custom.height * item.custom.ratio\n                     }" style="margin: 20px auto; overflow: hidden"><div ng-if="item.scene" style="position: relative; width: 100%; height: 100%"><div style="width: 100%; height: 100%; position: absolute" ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': item.custom.width * item.custom.ratio,\n                                \'height\': item.custom.height * item.custom.ratio,\n                                \'z-index\': item.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                                \'pointer-events\': \'none\'\n                            }"><img ng-src="{{item.scene.resource.identifier}}" alt="" ng-style="{\n                                \'width\': item.scene.resource.adaptation == \'Width\' ? \'auto\' : \'100%\',\n                                \'height\': item.scene.resource.adaptation == \'Height\' ? \'auto\' : \'100%\'\n                             }"><div ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': item.scene.imagebox.geometry.width * item.custom.ratio,\n                                \'height\': item.scene.imagebox.geometry.height * item.custom.ratio,\n                                \'left\': item.scene.imagebox.geometry.x * item.custom.ratio,\n                                \'top\': item.scene.imagebox.geometry.y * item.custom.ratio,\n                                \'transform\': \'rotate(\' + item.scene.imagebox.rotation.angle + \'deg)\',\n                            }"></div></div><div style="width: 100%; height: 100%; position: relative" ng-style="{\n                                 \'z-index\': item.scene.hierarchy == \'TOP\' ? 0 : 1\n                             }"><div ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': item.mediabox.width * item.custom.ratio,\n                                \'height\': item.mediabox.height * item.custom.ratio,\n                                \'left\': item.scene.imagebox.geometry.x * item.custom.ratio,\n                                \'top\': item.scene.imagebox.geometry.y * item.custom.ratio,\n                                \'background\': item.background.type == \'Color\' ? item.background.color : \'none\',\n                                }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><img ng-src="{{item.background.resource.identifier}}" alt="" ng-if="item.background.type != \'Color\'" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': item.background.resource.adaptation == \'Width\' ? item.mediabox.width * item.custom.ratio : \'auto\',\n                                            \'height\': item.background.resource.adaptation == \'Height\' ? item.mediabox.height * item.custom.ratio : \'auto\',\n                                            \'left\': item.background.offsetx * item.custom.ratio,\n                                            \'top\': item.background.offsety * item.custom.ratio\n                                        }"><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in item.levels.level"><div ng-if="level.imagebox" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': level.imagebox.geometry.width * item.custom.ratio,\n                                            \'height\': level.imagebox.geometry.height * item.custom.ratio,\n                                            \'left\': level.imagebox.geometry.x * item.custom.ratio,\n                                            \'top\': level.imagebox.geometry.y * item.custom.ratio,\n                                            \'z-index\':level.seq-0+200,\n                                            \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                            \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\'\n                                         }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.image.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.image.offsetx*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.image.offsety*item.custom.ratio*level.imagebox.image.scale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.image.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.image.offsetx*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.image.offsety*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'z-index\': 1\n                                                 }"> <img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*item.custom.ratio*level.imagebox.image.scale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*item.custom.ratio*level.imagebox.image.scale\n                                                 }"></div></div><div ng-if="level.imageart" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': level.imageart.geometry.width * item.custom.ratio,\n                                            \'height\': level.imageart.geometry.height * item.custom.ratio,\n                                            \'left\': level.imageart.geometry.x * item.custom.ratio,\n                                            \'top\': level.imageart.geometry.y * item.custom.ratio,\n                                            \'z-index\':level.seq-0+200,\n                                         }"><img ng-src="{{level.imageart.resource.identifier}}" alt="" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imageart.geometry.width * item.custom.ratio * level.imageart.scale,\n                                                    \'left\': level.imageart.offsetx * item.custom.ratio,\n                                                    \'top\': level.imageart.offsety * item.custom.ratio,\n                                                    \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                    \'opacity\': level.imageart.transparency,\n                                                 }"></div><div ng-if="level.textbox" class="c-xml-page-textboxe" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.textbox.geometry.width * item.custom.ratio,\n                                                \'height\': level.textbox.geometry.height * item.custom.ratio,\n                                                \'line-height\': level.textbox.geometry.height * item.custom.ratio + \'px\',\n                                                \'left\': level.textbox.geometry.x * item.custom.ratio,\n                                                \'top\': level.textbox.geometry.y * item.custom.ratio,\n                                                \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'z-index\': level.seq-0+200\n                                             }"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.style.size * item.custom.ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.style.lineheight * item.custom.ratio : (level.textbox.style.lineheight * item.custom.ratio) / (1 / 12 * level.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.style.letterspacing * item.custom.ratio : (level.textbox.style.letterspacing * item.custom.ratio) / (1 / 12 * level.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'text-align-last\': level.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\' + (1 / 12 * level.textbox.style.size * item.custom.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size * item.custom.ratio) + \')\',\n                                            \'width\': level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.geometry.width * item.custom.ratio : (level.textbox.geometry.width * item.custom.ratio) / (1 / 12 * level.textbox.style.size * item.custom.ratio) + \'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-if="level.textdocument" ng-style="{\n                                                position: \'absolute\',\n                                                width: level.textdocument.geometry.width * item.custom.ratio,\n                                                height: level.textdocument.geometry.height * item.custom.ratio,\n                                                left: level.textdocument.geometry.x * item.custom.ratio,\n                                                top: level.textdocument.geometry.y * item.custom.ratio,\n                                                \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx * item.custom.ratio,\n                                                         top:level.textdocument.background.offsety * item.custom.ratio,\n                                                         width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * item.custom.ratio:\'\',\n                                                         height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * item.custom.ratio:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width * item.custom.ratio,\n                                                            height: docLevel.imageart.geometry.height * item.custom.ratio,\n                                                            left: docLevel.imageart.geometry.x * item.custom.ratio,\n                                                            top: docLevel.imageart.geometry.y * item.custom.ratio,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx * item.custom.ratio,\n                                                                    \'top\': docLevel.imageart.offsety * item.custom.ratio,\n                                                                    \'width\': docLevel.imageart.geometry.width * item.custom.ratio}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'width\': docLevel.textbox.geometry.width * item.custom.ratio,\n                                                            \'height\': docLevel.textbox.geometry.height * item.custom.ratio,\n                                                            \'left\': docLevel.textbox.geometry.x * item.custom.ratio,\n                                                            \'top\': docLevel.textbox.geometry.y * item.custom.ratio,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (docLevel.textbox.style.size*item.custom.ratio > 12 ? docLevel.textbox.style.size* item.custom.ratio : 12) + \'pt\',\n                                                        \'color\': docLevel.textbox.style.color,\n                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (docLevel.textbox.style.size * item.custom.ratio > 12 ? docLevel.textbox.style.lineheight * item.custom.ratio : (docLevel.textbox.style.lineheight * item.custom.ratio) / (1 / 12 * docLevel.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                                        \'letter-spacing\': (docLevel.textbox.style.size * item.custom.ratio > 12 ? docLevel.textbox.style.letterspacing * item.custom.ratio : (docLevel.textbox.style.letterspacing * item.custom.ratio) / (1 / 12 * docLevel.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                                        \'opacity\': docLevel.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': docLevel.textbox.style.align,\n                                                        \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* item.custom.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* item.custom.ratio)+\')\',\n                                                        \'width\': docLevel.textbox.style.size * item.custom.ratio > 12 ? docLevel.textbox.geometry.width * item.custom.ratio : (docLevel.textbox.geometry.width * item.custom.ratio) / (1 / 12 * docLevel.textbox.style.size * item.custom.ratio) + \'px\'\n                                                      }"><span class="c-xml-page-textboxe-span" style="height: auto">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="item.barcode" ng-style="{\n                                             \'z-index\':999,\n                                             \'width\': item.barcode.geometry.width * item.custom.ratio,\n                                             \'height\': item.barcode.geometry.height * item.custom.ratio,\n                                             \'left\': item.barcode.geometry.x * item.custom.ratio,\n                                             \'top\': item.barcode.geometry.y * item.custom.ratio,\n                                             \'transform\': \'rotate(\' + item.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div></div></div></div></div><div ng-if="!item.scene" style="position: relative" ng-style="{\n                            \'width\': item.custom.width * item.custom.ratio,\n                            \'height\': item.custom.height * item.custom.ratio\n                         }"><div ng-style="{\n                            \'position\': \'absolute\',\n                            \'width\': item.mediabox.width * item.custom.ratio,\n                            \'height\': item.mediabox.height * item.custom.ratio,\n                            \'left\': item.mediabox.x * item.custom.ratio,\n                            \'top\': item.mediabox.y * item.custom.ratio,\n                            \'background\': item.background.type == \'Color\' ? item.background.color : \'none\',\n                            }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><img ng-src="{{item.background.resource.identifier}}" alt="" ng-if="item.background.type != \'Color\'" ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': item.background.resource.adaptation == \'Width\' ? item.mediabox.width * item.custom.ratio : \'auto\',\n                                        \'height\': item.background.resource.adaptation == \'Height\' ? item.mediabox.height * item.custom.ratio : \'auto\',\n                                        \'left\': item.background.offsetx * item.custom.ratio,\n                                        \'top\': item.background.offsety * item.custom.ratio\n                                    }"><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in item.levels.level"><div ng-if="level.imagebox" ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': level.imagebox.geometry.width * item.custom.ratio,\n                                        \'height\': level.imagebox.geometry.height * item.custom.ratio,\n                                        \'left\': level.imagebox.geometry.x * item.custom.ratio,\n                                        \'top\': level.imagebox.geometry.y * item.custom.ratio,\n                                        \'z-index\':level.seq-0+200,\n                                        \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                        \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                        \'-webkit-mask-size\': \'100% 100%\'\n                                     }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.image.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.image.offsetx*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.image.offsety*item.custom.ratio*level.imagebox.image.scale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.image.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.image.offsetx*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.image.offsety*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'z-index\': 1\n                                                 }"> <img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*item.custom.ratio*level.imagebox.image.scale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*item.custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*item.custom.ratio*level.imagebox.image.scale\n                                                 }"></div></div><div ng-if="level.imageart" ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': level.imageart.geometry.width * item.custom.ratio,\n                                        \'height\': level.imageart.geometry.height * item.custom.ratio,\n                                        \'left\': level.imageart.geometry.x * item.custom.ratio,\n                                        \'top\': level.imageart.geometry.y * item.custom.ratio,\n                                        \'z-index\':level.seq-0+200,\n                                     }"><img ng-src="{{level.imageart.resource.identifier}}" alt="" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imageart.geometry.width * item.custom.ratio * level.imageart.scale,\n                                                \'left\': level.imageart.offsetx * item.custom.ratio,\n                                                \'top\': level.imageart.offsety * item.custom.ratio,\n                                                \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'opacity\': level.imageart.transparency,\n                                             }"></div><div ng-if="level.textbox" ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': level.textbox.geometry.width * item.custom.ratio,\n                                        \'height\': level.textbox.geometry.height * item.custom.ratio,\n                                        \'left\': level.textbox.geometry.x * item.custom.ratio,\n                                        \'top\': level.textbox.geometry.y * item.custom.ratio,\n                                        \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                        \'z-index\': level.seq-0+200\n                                     }"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                            \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.style.size * item.custom.ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.style.lineheight * item.custom.ratio : (level.textbox.style.lineheight * item.custom.ratio) / (1 / 12 * level.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.style.letterspacing * item.custom.ratio : (level.textbox.style.letterspacing * item.custom.ratio) / (1 / 12 * level.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'text-align-last\': level.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\' + (1 / 12 * level.textbox.style.size * item.custom.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size * item.custom.ratio) + \')\',\n                                            \'width\': level.textbox.style.size * item.custom.ratio > 12 ? level.textbox.geometry.width * item.custom.ratio : (level.textbox.geometry.width * item.custom.ratio) / (1 / 12 * level.textbox.style.size * item.custom.ratio) + \'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-if="level.textdocument" ng-style="{\n                                            position: \'absolute\',\n                                            width: level.textdocument.geometry.width * item.custom.ratio,\n                                            height: level.textdocument.geometry.height * item.custom.ratio,\n                                            left: level.textdocument.geometry.x * item.custom.ratio,\n                                            top: level.textdocument.geometry.y * item.custom.ratio,\n                                            \'z-index\':level.seq-0+200,\n                                            \'opacity\':level.textdocument.transparency.toFixed(2),\n                                            filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                            \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                     position: \'absolute\',\n                                                     left:level.textdocument.background.offsetx * item.custom.ratio,\n                                                     top:level.textdocument.background.offsety * item.custom.ratio,\n                                                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * item.custom.ratio:\'\',\n                                                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * item.custom.ratio:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                        width: docLevel.imageart.geometry.width * item.custom.ratio,\n                                                        height: docLevel.imageart.geometry.height * item.custom.ratio,\n                                                        left: docLevel.imageart.geometry.x * item.custom.ratio,\n                                                        top: docLevel.imageart.geometry.y * item.custom.ratio,\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'opacity\':docLevel.imageart.transparency,\n                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': docLevel.imageart.offsetx * item.custom.ratio,\n                                                                \'top\': docLevel.imageart.offsety * item.custom.ratio,\n                                                                \'width\': docLevel.imageart.geometry.width * item.custom.ratio}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                        \'width\': docLevel.textbox.geometry.width * item.custom.ratio,\n                                                        \'height\': docLevel.textbox.geometry.height * item.custom.ratio,\n                                                        \'left\': docLevel.textbox.geometry.x * item.custom.ratio,\n                                                        \'top\': docLevel.textbox.geometry.y * item.custom.ratio,\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*item.custom.ratio > 12 ? docLevel.textbox.style.size* item.custom.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size * item.custom.ratio > 12 ? docLevel.textbox.style.lineheight * item.custom.ratio : (docLevel.textbox.style.lineheight * item.custom.ratio) / (1 / 12 * docLevel.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size * item.custom.ratio > 12 ? docLevel.textbox.style.letterspacing * item.custom.ratio : (docLevel.textbox.style.letterspacing * item.custom.ratio) / (1 / 12 * docLevel.textbox.style.size * item.custom.ratio)) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* item.custom.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* item.custom.ratio)+\')\',\n                                                    \'width\': docLevel.textbox.style.size * item.custom.ratio > 12 ? docLevel.textbox.geometry.width * item.custom.ratio : (docLevel.textbox.geometry.width * item.custom.ratio) / (1 / 12 * docLevel.textbox.style.size * item.custom.ratio) + \'px\'\n                                                  }"><span class="c-xml-page-textboxe-span" style="height: auto">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="item.barcode" ng-style="{\n                                         \'z-index\':999,\n                                         \'width\': item.barcode.geometry.width * item.custom.ratio,\n                                         \'height\': item.barcode.geometry.height * item.custom.ratio,\n                                         \'left\': item.barcode.geometry.x * item.custom.ratio,\n                                         \'top\': item.barcode.geometry.y * item.custom.ratio,\n                                         \'transform\': \'rotate(\' + item.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div></div></div></div></div></div></div><div ng-if="vm.article.editorType == \'PICTURE\' || vm.article.editorType == \'PICTURE_PRO\' || vm.article.editorType == \'PICTURE_PRO_P\'"><div class="main clearfix"><div class="clearfix" ng-if="vm.modelType == \'PICTURE\' || vm.modelType == \'PICTURE_PRO\' || vm.modelType == \'PICTURE_PRO_P\'"><div class="c-page-view-li" ng-repeat="page in vm.page track by $index"><div class="c-page-view-li-img" ng-click="single($index)" ng-style="{\n                            \'width\': page.trimbox.width * page.ratio,\n                            \'height\': page.trimbox.height * page.ratio\n                         }"><img ng-src="{{page.levels.level[0].imagebox.image.resource.identifier + \'?imageMogr2/auto-orient/rotate/\' + page.levels.level[0].imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': page.levels.level[0].imagebox.blurredrectangle.width * page.ratio,\n                                \'height\': page.levels.level[0].imagebox.blurredrectangle.height * page.ratio,\n                                \'left\':page.levels.level[0].imagebox.blurredrectangle.x * page.ratio,\n                                \'top\':page.levels.level[0].imagebox.blurredrectangle.y * page.ratio\n                             }"></div><div class="c-page-view-li-btn"><span style="font-size: 18px">{{$index+1}}</span></div></div></div></div></div></div>');
$templateCache.put('app/entities/product/editor-preview-mini.html','<div class="flipbook-viewport" style="min-height: 500px"><div class="container1"><div class="flipbook"><div class="flipbook-viewport-page" ng-repeat="item in vm.pages track by $index" ng-class="{\'double\' :item.spread, \'page\':!item.spread}"><div style="position: relative" ng-style="{\n                        \'width\': item.custom.width * item.custom.ratio,\n                        \'height\': item.custom.height * item.custom.ratio\n                     }"><div ng-style="{\n                        \'position\': \'absolute\',\n                        \'width\': item.trimbox.width * item.custom.ratio,\n                        \'height\': item.trimbox.height * item.custom.ratio,\n                        \'left\': item.trimbox.x * item.custom.ratio,\n                        \'top\': item.trimbox.y * item.custom.ratio,\n                        \'background\': item.background.type == \'Color\' ? item.background.color : \'none\',\n                        }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><img ng-src="{{item.background.resource.identifier}}" alt="" ng-if="item.background.type != \'Color\'" ng-style="{\n                                    \'position\': \'absolute\',\n                                    \'width\': item.background.resource.adaptation == \'Width\' ? item.trimbox.width * item.custom.ratio : \'auto\',\n                                    \'height\': item.background.resource.adaptation == \'Height\' ? item.trimbox.height * item.custom.ratio : \'auto\',\n                                    \'left\': item.background.offsetx * item.custom.ratio,\n                                    \'top\': item.background.offsety * item.custom.ratio\n                                }"><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in item.levels.level"><div ng-if="level.imagebox" ng-style="{\n                                    \'position\': \'absolute\',\n                                    \'width\': level.imagebox.geometry.width * item.custom.ratio,\n                                    \'height\': level.imagebox.geometry.height * item.custom.ratio,\n                                    \'left\': level.imagebox.geometry.x * item.custom.ratio,\n                                    \'top\': level.imagebox.geometry.y * item.custom.ratio,\n                                    \'z-index\':level.seq-0+200,\n                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                    \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                    \'-webkit-mask-size\': \'100% 100%\'\n                                 }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.image.width*item.custom.ratio*level.imagebox.image.scale,\n                                                \'height\': level.imagebox.image.height*item.custom.ratio*level.imagebox.image.scale,\n                                                \'left\':level.imagebox.image.offsetx*item.custom.ratio*level.imagebox.image.scale,\n                                                \'top\':level.imagebox.image.offsety*item.custom.ratio*level.imagebox.image.scale\n                                             }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.image.width*item.custom.ratio*level.imagebox.image.scale,\n                                                \'height\': level.imagebox.image.height*item.custom.ratio*level.imagebox.image.scale,\n                                                \'left\':level.imagebox.image.offsetx*item.custom.ratio*level.imagebox.image.scale,\n                                                \'top\':level.imagebox.image.offsety*item.custom.ratio*level.imagebox.image.scale\n                                             }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.blurredrectangle.width*item.custom.ratio*level.imagebox.image.scale,\n                                                \'height\': level.imagebox.blurredrectangle.height*item.custom.ratio*level.imagebox.image.scale,\n                                                \'left\':level.imagebox.blurredrectangle.x*item.custom.ratio*level.imagebox.image.scale,\n                                                \'top\':level.imagebox.blurredrectangle.y*item.custom.ratio*level.imagebox.image.scale,\n                                                \'z-index\': 1\n                                             }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!40p\'}}" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.blurredrectangle.width*item.custom.ratio*level.imagebox.image.scale,\n                                                \'height\': level.imagebox.blurredrectangle.height*item.custom.ratio*level.imagebox.image.scale,\n                                                \'left\':level.imagebox.blurredrectangle.x*item.custom.ratio*level.imagebox.image.scale,\n                                                \'top\':level.imagebox.blurredrectangle.y*item.custom.ratio*level.imagebox.image.scale\n                                             }"></div></div><div ng-if="level.imageart" ng-style="{\n                                    \'position\': \'absolute\',\n                                    \'width\': level.imageart.geometry.width * item.custom.ratio,\n                                    \'height\': level.imageart.geometry.height * item.custom.ratio,\n                                    \'left\': level.imageart.geometry.x * item.custom.ratio,\n                                    \'top\': level.imageart.geometry.y * item.custom.ratio,\n                                    \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                    \'z-index\':level.seq-0+200,\n                                 }"><img ng-src="{{level.imageart.resource.identifier}}" alt="" ng-style="{\n                                            \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                            \'position\': \'absolute\',\n                                            \'width\': level.imageart.geometry.width * item.custom.ratio * level.imageart.scale,\n                                            \'left\': level.imageart.offsetx * item.custom.ratio,\n                                            \'top\': level.imageart.offsety * item.custom.ratio,\n                                            \'opacity\': level.imageart.transparency,\n                                         }"></div><div ng-if="level.textbox" ng-style="{\n                                    \'position\': \'absolute\',\n                                    \'width\': level.textbox.geometry.width * item.custom.ratio,\n                                    \'height\': level.textbox.geometry.height * item.custom.ratio,\n                                    \'left\': level.textbox.geometry.x * item.custom.ratio,\n                                    \'top\': level.textbox.geometry.y * item.custom.ratio,\n                                    \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                    \'z-index\': level.seq-0+200\n                                 }"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                        \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                        \'font-size\': level.textbox.style.size + \'pt\',\n                                        \'color\': level.textbox.style.color,\n                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                        \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                        \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                        \'opacity\': level.textbox.transparency,\n                                        \'text-decoration\': \'none\',\n                                        \'text-align\': level.textbox.style.align,\n                                        \'text-align-last\': level.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',\n                                        transform:\'scale(\'+(item.custom.ratio)+\')\',\n                                        \'transform-origin\': \'0 0\',\n                                        width: level.textbox.geometry.width,\n                                        height: level.textbox.geometry.height\n                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-if="level.textdocument" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width * item.custom.ratio,\n                                        height: level.textdocument.geometry.height * item.custom.ratio,\n                                        left: level.textdocument.geometry.x * item.custom.ratio,\n                                        top: level.textdocument.geometry.y * item.custom.ratio,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx * item.custom.ratio,\n                                                 top:level.textdocument.background.offsety * item.custom.ratio,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * item.custom.ratio:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * item.custom.ratio:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width * item.custom.ratio,\n                                                    height: docLevel.imageart.geometry.height * item.custom.ratio,\n                                                    left: docLevel.imageart.geometry.x * item.custom.ratio,\n                                                    top: docLevel.imageart.geometry.y * item.custom.ratio,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx * item.custom.ratio,\n                                                            \'top\': docLevel.imageart.offsety * item.custom.ratio,\n                                                            \'width\': docLevel.imageart.geometry.width * item.custom.ratio}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width * item.custom.ratio,\n                                                    \'height\': docLevel.textbox.geometry.height * item.custom.ratio,\n                                                    \'left\': docLevel.textbox.geometry.x * item.custom.ratio,\n                                                    \'top\': docLevel.textbox.geometry.y * item.custom.ratio,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                \'color\': docLevel.textbox.style.color,\n                                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                \'opacity\': docLevel.textbox.transparency,\n                                                \'text-decoration\': \'none\',\n                                                \'text-align\': docLevel.textbox.style.align,\n                                                \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                transform:\'scale(\'+(item.custom.ratio)+\')\',\n                                                \'transform-origin\': \'0 0\',\n                                                width: docLevel.textbox.geometry.width,\n                                                height: docLevel.textbox.geometry.height\n                                              }"><span class="c-xml-page-textboxe-span" style="height: auto">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="item.barcode" ng-style="{\n                                     \'z-index\':999,\n                                     \'width\': item.barcode.geometry.width * item.custom.ratio,\n                                     \'height\': item.barcode.geometry.height * item.custom.ratio,\n                                     \'left\': item.barcode.geometry.x * item.custom.ratio,\n                                     \'top\': item.barcode.geometry.y * item.custom.ratio,\n                                     \'transform\': \'rotate(\' + item.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div></div></div></div></div></div></div></div><style>.flipbook-viewport .container1 {\n        position: fixed;\n        top: 50px;\n        left: 0;\n        margin: auto;\n        padding: 0;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    }\n    .flipbook-viewport .flipbook {\n         left: 0;\n         top: 10px;\n    }</style>');
$templateCache.put('app/entities/product/product-detail.html','<div class="listBGC" style="min-width: 700px"><div class="breadcrumb-normal">\u5546\u54C1\u7BA1\u7406 / <span>\u5546\u54C1{{vm.title}}</span></div><div class="con"><div class="c-form" ng-show="vm.product.prototype==\'StoreSelf\'"><div class="c-form-label" translate="backApp.product.mould">mould</div><div class="c-form-div">{{vm.product.mouldName}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.name">Name</div><div class="c-form-div">{{vm.product.name}} <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.number">number</div><div class="c-form-div">{{vm.product.number}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.category">category</div><div class="c-form-div">{{vm.product.categoryStoreName}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.productType">productType</div><div class="c-form-div" data-translate="{{\'backApp.ProductType.\' + vm.product.productType}}">{{vm.product.productType}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.editorType">editorType</div><div class="c-form-div" data-translate="{{\'backApp.EditorType.\' + vm.product.editorType}}">{{vm.product.editorType}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'DIY_EDITOR\'"><div class="c-form-label">diy\u7F16\u8F91\u5668</div><div class="c-form-div">{{vm.product.diyEditorSettingName}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\'"><div class="c-form-label" translate="backApp.product.pictureType">pictureType</div><div class="c-form-div" data-translate="{{\'backApp.pictureType.\' + vm.product.pictureType}}">{{vm.product.pictureType}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE_PRO_P\'"><div class="c-form-label" style="width: 150px">\u5200\u7EBF\u63CF\u8FB9\u5927\u5C0F</div><div class="c-form-div">{{vm.product.contourWidth > 0 ? vm.product.contourWidth + \'mm\' : \'\u6EE1\u5207\'}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE_PRO_P\' && vm.product.pictureType == \'spread\'"><div class="c-form-label" style="width: 150px">\u5DE5\u827A\u662F\u5426\u5E94\u7528\u5230\u53CD\u9762</div><div class="c-form-div">{{vm.product.reverseProcess?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-show="vm.product.editorType == \'PICTURE\'"><div class="c-form-label">\u7F16\u8F91\u63D0\u793A</div><div class="c-form-div">{{vm.product.editTip?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-show="vm.product.editTip"><div class="c-form-label">\u7F16\u8F91\u63D0\u793A\u56FE\u7247</div><div class="c-form-div" style="padding: 3px 16px"><img class="picture-border" ng-src="{{vm.product.editTipPic}}?imageMogr2/auto-orient"></div></div><div class="c-form" ng-if="(vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PHOTO_EDITOR\' || vm.product.editorType == \'PICTURE_PRO_P\') && vm.product.pictureType == \'spread\'"><div class="c-form-label" style="width: 140px">\u5141\u8BB8\u53CD\u9762\u5185\u5BB9\u7EDF\u4E00</div><div class="c-form-div">{{vm.product.allowNegativeUnify?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.bindingType">bindingType</div><div class="c-form-div" data-translate="{{\'backApp.bindingType.\'+ vm.product.bindingType}}">{{vm.product.bindingType}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.patternType">patternType</div><div class="c-form-div" data-translate="{{\'backApp.patternType.\'+ vm.product.patternType}}">{{vm.product.patternType}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.forceFill">forceFill</div><div class="c-form-div">{{vm.product.forceFill?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.aiFill">aiFill</div><div class="c-form-div">{{vm.product.aiFill?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.aiFill">aiFill</div><div class="c-form-div">{{vm.product.aiFill?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-if="vm.product.productType == \'THING\'"><div class="c-form-label">\u5173\u8054\u573A\u666F</div><div class="c-form-div"><div class="c-scene-view c-scene-view1" ng-repeat="item in vm.product.moulds" ng-if="vm.product.moulds.length>0"><div class="c-scene-view-img"><img ng-src="{{item.cover}}" alt=""></div><div class="c-scene-view-name slh">{{item.name}}</div></div></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.bokeh">bokeh</div><div class="c-form-div">{{vm.product.bokeh?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-show="vm.product.bokeh"><div class="c-form-label" translate="backApp.product.bokehType">bokehType</div><div class="c-form-div"><span data-translate="{{\'backApp.product.bokehTypes.\'+ vm.product.bokehType}}">{{vm.product.bokehType}}</span></div></div><div class="c-form" ng-if="vm.product.productType==\'BOOK\' || vm.product.productType==\'CALENDAR\'"><div class="c-form-label">\u4E8C\u7EF4\u7801</div><div class="c-form-div">{{vm.product.isCode?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.fileFormat">fileFormat</div><div class="c-form-div">{{vm.product.fileFormat}}</div></div><div class="c-form" ng-if="vm.product.fileFormat==\'PDF\'"><div class="c-form-label">\u6241\u5E73\u5316</div><div class="c-form-div">{{vm.product.flatten?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.pTicket">pTicket</div><div class="c-form-div">{{vm.product.taskBillFormName ? vm.product.taskBillFormName : \'\u4E0D\u6253\u5370\'}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.ticketRemarks">ticketRemarks</div><div class="c-form-div">{{vm.product.remarks}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.ticketPicture">ticketPicture</div><div class="c-form-div"><img class="picture-border" ng-if="vm.product.projectImg" ng-src="{{vm.product.projectImg}}?imageMogr2/auto-orient" ng-click="goToReadImage(vm.product.projectImg+\'?imageMogr2/auto-orient\')"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.addPage">addPage</div><div class="c-form-div">{{vm.product.addPage?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.coverImg">coverImg</div><div class="c-form-div"><img class="picture-border" ng-if="domain" ng-src="{{domain + vm.product.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(domain + vm.product.coverImg+\'?imageMogr2/auto-orient\')"></div></div><div class="c-form"><div class="c-form-label">\u89C4\u683C</div><div class="c-form-div" style="width: 600px"><div class="c-form-div-center" ng-repeat="property in vm.product.defaultObjectProperties"><div class="checkbox-icon checkbox-1" style="margin: 0"></div><div>{{property.propertyName}}</div></div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div" style="width: auto"><table class="za-table table" style="width: 100%"><thead><th style="width: 240px">\u7F16\u53F7</th><th style="width: 100px">\u6A21\u677F\u56FE\u7247</th><th style="width: 80px" ng-repeat="ob in vm.product.itemValues[0].objectValues">{{ob.propertyName}}</th><th style="width: 190px;min-width:190px; max-width: 190px">\u5173\u8054\u6A21\u677F</th><th style="width: 80px;min-width:80px; max-width:80px">\u6A21\u677F\u7F16\u53F7</th><th style="width: 160px;min-width:160px; max-width: 160px">\u5C55\u793A\u540D\u79F0</th><th style="width: 160px;min-width:160px; max-width: 160px">\u7F16\u53F7</th><th style="width: 100px;min-width:100px; max-width: 100px">\u5C01\u9762\u56FE\u7247</th><th style="width: 60px;min-width:60px; max-width: 60px">\u6392\u5E8F</th><th>\u80CC\u666F\u97F3\u4E50</th></thead><tbody><tr ng-repeat="itemValue in vm.product.itemValues track by $index" style="height: 70px" ng-if="!itemValue.deleted && !itemValue.cancelled"><td style="width: 240px">{{itemValue.number}}</td><td style="width: 100px"><img ng-if="!!itemValue.coverImg&&domain" class="picture-border" style="width: 76px; height: 60px" ng-src="{{domain + itemValue.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(domain + itemValue.coverImg+\'?imageMogr2/auto-orient\')"></td><td style="width: 80px" ng-repeat="ob in itemValue.objectValues">{{ob.propertyValueValue}}</td><td colspan="8"><table><tr ng-repeat="line in itemValue.productXmlLines" ng-if="!line.deleted && !line.cancelled"><td style="width: 190px;min-width:190px; max-width: 190px"><div class="col-lg-12 col-sm-12 pad-left-0 pad-right-0 text-decoration-underline">{{line.productXmlName}}</div></td><td style="width: 80px;min-width:80px; max-width: 80px">{{line.productXmlNumber}}</td><td style="width: 160px;min-width:160px; max-width: 160px">{{line.name}} <span class="iconfont webduoyuyan" ng-click="vm.multilingual2(line)"></span></td><td style="width: 160px;word-break: break-all;white-space: pre-wrap">{{line.number}}</td><td style="width: 100px;min-width:100px; max-width: 100px"><img ng-if="!!line.coverImg&&domain" class="picture-border" style="width: 76px; height: 60px" ng-src="{{line.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(line.coverImg+\'?imageMogr2/auto-orient\')"></td><td style="width: 60px;min-width:60px; max-width: 60px">{{line.seq}}</td><td>{{line.musicName}}</td></tr></table></td></tr></tbody></table></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div></div></div><div class="origin-image origin-image-dialog hide1"><div class="origin-wrap" ng-click="clickToHide()" onmousewheel="return bbimg(this)"><img id="origin-pic" onmousedown="moveImgStartDialog(event)"><div class="text-align-center mar-top-30" id="back-btn"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="clickToHide()"><span translate="entity.action.backTo">back</span></button></div></div></div>');
$templateCache.put('app/entities/product/product-dialog-create.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="breadcrumb-normal">\u5546\u54C1\u7BA1\u7406 / <span>\u5546\u54C1{{vm.title}}</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="backApp.product.mould">mould</div><div class="c-form-div"><div ng-if="!!vm.product.id">{{vm.product.mouldName}}</div><select ng-if="!vm.product.id" class="c-select1" ng-model="vm.product.mouldId" ng-change="mouldChange()" ng-options="mould.id as mould.name for mould in vm.moulds | orderBy:\'id\'"><option value=""></option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.category">\u5206\u7C7B</div><div class="c-form-div"><select class="c-select1" ng-model="vm.product.categoryStoreId" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option style="color: #b3a8a8" disabled="disabled" label="{{category.name}}"></option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.name">name</div><div class="c-form-div"><input type="text" class="c-input1" style="width: 90%" ng-model="vm.product.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="50"> <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.number">number</div><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.product.number" readonly="true" maxlength="20"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.productType">productType</div><div class="c-form-div"><select class="form-control border-radius" ng-model="vm.product.productType" ng-change="productTypeChange()"><option value="BOOK" data-translate="backApp.ProductType.BOOK">BOOK</option><option value="CALENDAR" data-translate="backApp.ProductType.CALENDAR">CALENDAR</option><option value="PHOTO" data-translate="backApp.ProductType.PHOTO">PHOTO</option><option value="THING" data-translate="backApp.ProductType.THING">THING</option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.editorType">editorType</div><div class="c-form-div"><select class="form-control border-radius" ng-model="vm.product.editorType" ng-change="editorTypeChange()" ng-options="editorType.value as editorType.name for editorType in vm.editorTypes"></select></div></div><div class="c-form" ng-if="vm.product.editorType==\'DIY_EDITOR\'"><span class="c-form-label">diy\u7F16\u8F91\u5668</span><div class="c-form-div"><select class="c-select1" ng-model="vm.product.diyEditorSettingId" ng-options="diyEditorSetting.id as diyEditorSetting.name for diyEditorSetting in vm.diyEditorSettings" ng-change="diyEditorSettingChange()"><option value=""></option></select></div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\'"><div class="c-form-label" translate="backApp.product.pictureType">pictureType</div><div class="c-form-div"><select class="c-select1" ng-model="vm.product.pictureType" ng-change="vm.product.reverseProcess = false"><option value="single" data-translate="backApp.pictureType.single">single</option><option value="spread" data-translate="backApp.pictureType.spread">spread</option></select></div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE_PRO_P\'"><div class="c-form-label">\u5200\u7EBF\u63CF\u8FB9\u5927\u5C0F</div><div class="c-form-div"><select class="c-select1" ng-model="vm.product.contourWidth" ng-options="w as (w === 0 ? \'\u6EE1\u5207\' : w + \'mm\') for w in [0,1,2,3,4,5]"></select></div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE_PRO_P\' && vm.product.pictureType == \'spread\'"><div class="c-form-label" style="width: 150px">\u5DE5\u827A\u662F\u5426\u5E94\u7528\u5230\u53CD\u9762</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.reverseProcess">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.reverseProcess">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.reverseProcess" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\' || vm.product.editorType == \'PHOTO_EDITOR\'"><div class="c-form-label">\u7F16\u8F91\u63D0\u793A</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.editTip">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.editTip">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.editTip" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form" ng-if="(vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\' || vm.product.editorType == \'PHOTO_EDITOR\') && vm.product.editTip"><div class="c-form-label">\u7F16\u8F91\u63D0\u793A\u56FE\u7247</div><div class="c-form-div"><input ng-if="!vm.product.editTipPic" type="file" name="file" class="form-control border-radius" type="file" accept="image/jpeg, image/png" onchange="updateEditTipPic(event)" ng-model-options="{debounce : 500}"> <span ng-if="!!vm.product.editTipPic"><img class="picture-border" ng-src="{{vm.product.editTipPic}}?imageMogr2/auto-orient" ng-click="goToReadImage(vm.product.editTipPic+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'editTipPic\')" style="color: red"></i></span></div></div><div class="c-form" ng-if="(vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\' || vm.product.editorType == \'PHOTO_EDITOR\') && vm.product.pictureType == \'spread\'"><div class="c-form-label" style="width: 140px">\u5141\u8BB8\u53CD\u9762\u5185\u5BB9\u7EDF\u4E00</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.allowNegativeUnify">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.allowNegativeUnify">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.allowNegativeUnify" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form" ng-if=" vm.product.editorType==\'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.forceFill">forceFill</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.forceFill">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.forceFill">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.forceFill" ng-change="forceFillChange()" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label><div class="sign pull-left"><img class="sign-img" src="content/images/notes.png"><div class="sign-text">\u5F00\u542F\u4E00\u952E\u6210\u4E66\u540E\uFF0C\u5C06\u5F3A\u5236\u7528\u6237\u9009\u62E9\u6A21\u677F\u6240\u9700\u7167\u7247\u6570\u91CF\uFF0C\u4E0D\u5F00\uFF0C\u5219\u65E0\u8BBA\u7528\u6237\u9009\u62E9\u591A\u5C11\u5F20\u7167\u7247\uFF0C\u90FD\u53EF\u4EE5\u89E6\u53D1\u7CFB\u7EDF\u4E00\u952E\u6210\u4E66\u529F\u80FD</div></div></div></div><div class="c-form" ng-if=" vm.product.editorType==\'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.aiFill">aiFill</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.aiFill">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.aiFill">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.aiFill" ng-change="aiFillChange()" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label><div class="sign pull-left"><img class="sign-img" src="content/images/notes.png"><div class="sign-text">\u5F00\u542F\u667A\u80FD\u586B\u5145\uFF0C\u4F1A\u5C06\u4E0A\u4F20\u7684\u7167\u7247\u6839\u636E\u6A21\u677F\u7684\u89C4\u683C\u81EA\u52A8\u8FDB\u884C\u6392\u7248\u5E03\u5C40\uFF08\u6240\u6709\u7167\u7247\u5B54\u5747\u4F1A\u8986\u76D6\uFF09\uFF0C\u4E0A\u4F20\u7684\u7167\u7247\u6570\u91CF\u9700\u8981\u5728\u5BF9\u5E94\u6A21\u677F\u7684\u7167\u7247\u4E0A\u4E0B\u9650\u4E2D\u3002<br>\u82E5\u6A21\u677F\u5F00\u542F\u5168\u90E8\u4E0D\u53EF\u66FF\u6362\uFF0C\u5546\u54C1\u667A\u80FD\u586B\u5145\u5931\u6548\u3002</div></div></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.bokeh">bokeh</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.bokeh">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.bokeh">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.bokeh" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><!-- \u5546\u54C1\u7684\u7C7B\u578B\u662F\u201C\u51B2\u5370\u201D\u7684\uFF0C\u8BBE\u7F6E\u865A\u5316\u7C7B\u578B\u4E3A\u201C\u900F\u660E\u201D\u5E76 \u9690\u85CF\u201C\u865A\u5316\u7C7B\u578B\u201D --><div class="c-form" ng-show="vm.product.bokeh && vm.product.productType !== \'PHOTO\' "><div class="c-form-label" translate="backApp.product.bokehType">bokehType</div><div class="c-form-div"><select class="c-select1" name="bokehType" ng-model="vm.product.bokehType" id="bokehType"><option value="Transparent" data-translate="backApp.product.bokehTypes.Transparent">Transparent</option><option value="Blurred" data-translate="backApp.product.bokehTypes.Blurred">Blurred</option></select></div></div><div class="c-form" ng-if="vm.product.productType==\'BOOK\' || vm.product.productType==\'CALENDAR\'"><div class="c-form-label">\u4E8C\u7EF4\u7801</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.isCode">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.isCode">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.isCode"> <i></i></label></div></div><div class="c-form" ng-if="vm.product.productType == \'THING\'"><div class="c-form-label">\u5173\u8054\u573A\u666F</div><div class="c-form-div"><div class="c-scene-view c-scene-view1" ng-repeat="item in vm.product.moulds" ng-if="vm.product.moulds.length>0"><div class="c-scene-view-img"><img ng-src="{{item.cover}}" alt=""></div><div class="c-scene-view-name slh">{{item.name}}</div><div class="c-scene-view-icon"><i class="iconfont webshanchu" ng-click="deleteMould($index)"></i></div></div><button type="button" class="btn btn-primary btn-save btn-info" ng-click="addGltf()">\u6DFB\u52A0\u6A21\u578B</button></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.fileFormat">fileFormat</div><div class="c-form-div"><select class="c-select1" ng-model="vm.product.fileFormat" required><option value="PDF">PDF</option><option value="PNG">PNG</option><option value="JPG">JPG</option></select></div></div><div class="c-form"><div class="c-form-label">\u6241\u5E73\u5316</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.flatten">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.flatten">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.flatten" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.pTicket">pTicket</div><div class="c-form-div"><select class="form-control border-radius" ng-model="vm.product.taskBillFormId" ng-options="form.id as form.name for form in vm.forms | orderBy:\'id\'"><option value="">\u4E0D\u6253\u5370</option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.ticketRemarks">ticketRemarks</div><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.product.remarks"></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.ticketPicture">ticketPicture</div><div class="c-form-div"><input ng-if="!vm.product.projectImg" type="file" name="file" class="form-control border-radius input-upload" type="file" accept="image/jpeg, image/png" onchange="updateProjectImg(event)" ng-model-options="{debounce : 500}"><div class="pic-upload" ng-if="!vm.product.projectImg"><img src="content/images/icon/upload_img.svg"></div><div ng-if="vm.product.projectImg"><img class="picture-border" ng-if="vm.product.projectImg" ng-src="{{vm.product.projectImg}}?imageMogr2/auto-orient" ng-click="goToReadImage(vm.product.projectImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeProjectImg()" style="color: red"></i></div></div></div><div class="c-form" ng-if="vm.product.productType==\'BOOK\' || vm.product.productType==\'CALENDAR\'"><span class="c-form-label" translate="backApp.product.patternType">patternType</span><div class="c-form-div c-form-div-center"><select class="c-select1" ng-model="vm.product.patternType"><option value="BOOK" data-translate="backApp.patternType.BOOK">BOOK</option><!-- <option value="BOOK2" data-translate="backApp.patternType.BOOK2">BOOK2</option> --><option value="OTHER" data-translate="backApp.patternType.OTHER">OTHER</option></select></div></div><div class="c-form" ng-if="vm.product.productType==\'BOOK\'"><span class="c-form-label" translate="backApp.product.bindingType">bindingType</span><div class="c-form-div c-form-div-center"><select class="c-select1" ng-model="vm.product.bindingType"><option value="Left" data-translate="backApp.bindingType.Left">Left</option><option value="LeftNew" data-translate="backApp.bindingType.LeftNew">LeftNew</option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.addPage">addPage</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.addPage">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.addPage">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.addPage" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><!-- <div class="c-form">\n            <div class="c-form-label" translate="backApp.product.outSourceId">outSourceId</div>\n            <div class="c-form-div">\n                <input type="text" class="c-input1" ng-model="vm.product.outSourceId" />\n            </div>\n        </div> --><div class="c-form"><div class="c-form-label" translate="backApp.product.coverImg">coverImg</div><div class="c-form-div" style="position: relative"><input ng-if="!vm.product.coverImg" type="file" name="file" class="form-control border-radius input-upload" type="file" accept="image/jpeg, image/png" onchange="updateImgFile1(event)" ng-model-options="{debounce : 500}"><div class="pic-upload" ng-if="!vm.product.coverImg"><img src="content/images/icon/upload_img.svg"></div><div ng-if="vm.product.coverImg"><img class="picture-border" ng-if="domain" ng-src="{{domain + vm.product.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(domain + vm.product.coverImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'coverImg\')" style="color: red"></i></div><div class="mar-top-10" style="color:#b3a8a8; font-size: 12px">\u5EFA\u8BAE\u5C3A\u5BF8\uFF1A750*380px\u30011080*540px</div></div></div><div class="c-form" ng-show="vm.properties.length"><div class="c-form-label" translate="backApp.product.objectProperty">objectProperty</div><div class="c-form-div" style="width: auto"><!-- <div class="pad-right-0 pad-left-10" ng-repeat="property in vm.properties">\n                    <div style="float:left; margin-top:2px; height: 100%;width: auto;">\n                        {{property.propertyName}}\n                    </div>\n                    <button class="small-btn-normal mar-left-10" ng-click="modalHide()">\n                        \u5FEB\u901F\u751F\u6210\n                    </button>\n                </div> --> <button class="small-btn-normal mar-left-10" ng-click="modalHide()">\u5FEB\u901F\u751F\u6210</button></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div" style="width: auto"><table class="za-table table" style="width: 100%;min-width: 1500px"><thead><th style="width: 240px">\u7F16\u53F7</th><th style="width: 100px">\u6A21\u677F\u56FE\u7247</th><th style="width: 80px" ng-repeat="ob in vm.product.itemValues[0].objectValues">{{ob.propertyName}}</th><th style="width: 192px; max-width: 192px">\u5173\u8054\u6A21\u677F</th><th style="width: 80px">\u6A21\u677F\u7F16\u53F7</th><th style="width: 180px">\u5C55\u793A\u540D\u79F0</th><th style="width: 160px">\u7F16\u53F7</th><th style="width: 100px">\u56FE\u7247</th><th style="width: 60px">\u6392\u5E8F</th><th style="width: 100px">\u80CC\u666F\u97F3\u4E50</th><th style="width: 60px">\u64CD\u4F5C</th><th>\u64CD\u4F5C</th></thead><tbody><tr ng-repeat="itemValue in vm.product.itemValues track by $index" style="height: 70px" ng-init="outerIndex = $index" ng-if="!itemValue.cancelled"><td style="width: 240px"><input type="text" class="c-input1" ng-model="itemValue.number"></td><td style="width: 100px;position: relative"><div class="btn_addPic" ng-if="!itemValue.coverImg"><input type="file" name="file" id="{{itemValue.uuid}}" class="filePrew" onchange="itemvalueLineImgFile(event)" accept="image/jpeg, image/png" ng-model-options="{debounce : 500}"> <a class="upload-text" ng-if="!itemValue.coverImg">\u8BF7\u4E0A\u4F20</a></div><span ng-if="!!itemValue.coverImg" style="margin-top: 0px"><img class="picture-border" style="width: 76px; height: 60px" ng-if="domain" ng-src="{{domain + itemValue.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(domain + itemValue.coverImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile2(itemValue)" style="color: red"></i></span></td><td style="width: 80px" ng-repeat="ob in itemValue.objectValues">{{ob.propertyValueValue}}</td><td colspan="8"><table style="min-width: 932px"><tr ng-repeat="line in itemValue.productXmlLines" ng-if="!line.cancelled"><td style="width: 192px"><div class="col-lg-12 col-sm-12 pad-left-0 pad-right-0"><button class="col-lg-9 col-sm-9 text-decoration-underline" style="background: #fff;border-radius: 4px;border: 1px solid #ccc;min-height: 34px">{{line.productXmlName||\'\'}}</button><div class="col-lg-3 col-sm-3 pad-0" ng-click="xmlOpen(itemValue,line)"><span style="color: #3fa3ff;line-height: 34px">\u4FEE\u6539</span></div></div></td><td style="width: 80px"><label class="" style="font-weight: normal">{{line.productXmlNumber}}</label></td><td style="width: 180px"><input type="text" ng-model="line.name" style="width: 60%" class="c-input1"> <span class="iconfont webduoyuyan" ng-click="vm.multilingual2(line)"></span></td><td style="width: 160px;word-break: break-all;white-space: pre-wrap">{{line.number}}</td><td style="width: 100px;position: relative"><div class="btn_addPic" ng-if="!line.coverImg" style="width: 90px; height: 90px"><a class="upload-text" ng-if="!line.coverImg">\u8BF7\u4E0A\u4F20</a> <input type="file" name="file" id="{{line.uuid}}" class="filePrew" onchange="xmlLineImgFile(event)" accept="image/jpeg, image/png" ng-model-options="{debounce : 500}"></div><span ng-if="!!line.coverImg" style="margin-top: 0px"><img class="picture-border" style="width: 76px; height: 60px" ng-src="{{line.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(line.coverImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile2(line)" style="color: red"></i></span></td><td style="width: 60px"><input style="padding: 2px" type="number" class="c-input1" min="0" max="1000" ng-model="line.seq"></td><td style="width: 100px"><div class="col-lg-12 col-sm-12 pad-right-0"><select style="padding: 2px" class="c-select1" id="field_music" name="music" ng-model="line.musicId" ng-options="music.id as music.name for music in vm.music"><option label="\u8BF7\u9009\u62E9\u97F3\u4E50"></option></select></div></td><td style="width: 60px"><span class="outline" style="color: #3fa3ff" ng-click="productXmlLineDelete(itemValue, line)">\u5220\u9664</span></td></tr><tr><td colspan="8"><div class="outline" ng-click="addXml(itemValue)" style="color: var(--btnBgBasicColor)">\u65B0\u589E\u6A21\u677F</div></td></tr></table></td><td><span class="outline" style="color: #3fa3ff" ng-click="deleteItemValue(itemValue)">\u5220\u9664</span></td></tr></tbody></table></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div><div class="origin-image origin-image-dialog hide1"><div class="origin-wrap" ng-click="clickToHide()" onmousewheel="return bbimg(this)"><img id="origin-pic" onmousedown="moveImgStartDialog(event)"><div class="text-align-center mar-top-30" id="back-btn"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="clickToHide()"><span translate="entity.action.backTo">back</span></button></div></div></div><div class="modal-property" ng-if="vm.propertyShow"><div class="modal-mask"></div><div class="content-scroll modal-con-3"><div class="modal-con-3-body"><div class="modal-con-3-t"><span class="font-16">\u89C4\u683C\u751F\u6210</span> <img src="content/images/icon/close1.svg" style="width: 16px" ng-click="modalHide()"></div><div class="modal-con-3-body-content"><div class="row" style="margin: 0; padding: 0 15px"><div class="col-md-12 col-sm-12 col-xs-12 text-left modal-default">\u89C4\u683C</div><div class="col-md-12 col-sm-12 col-xs-12 text-left" ng-repeat="property in vm.properties" style="margin: 15px 0 25px"><span class="col-md-2 col-sm-2 col-xs-2 text-right pad-0 text-ellipsis">{{property.propertyName}}\uFF1A</span><div class="col-md-10 col-sm-10 col-xs-10 text-left" ng-if="property.propertyValues.length"><div class="col-md-3 col-sm-3 col-xs-3 pad-right-0 pad-left-10 limitWidth mar-bottom-10 outline_no" ng-repeat="value in property.propertyValues" ng-click="valueClick(property, value)" ng-hide="value.cancelled"><span class="checkbox-icon checkbox-0" style="display: inline-block;margin-top: 0" ng-if="!value.selected"></span> <span class="checkbox-icon checkbox-1" style="display: inline-block;margin-top: 0" ng-if="value.selected"></span> <span>{{value.value}}</span></div></div><div class="col-md-10 col-sm-10 col-xs-10 text-left" ng-if="!property.propertyValues.length">\u6682\u65E0</div></div></div></div><div class="modal-con-3-body-foot"><button type="button" class="small-btn-normal" ng-click="propertyGener()">\u751F \u6210</button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="modalHide()">\u5173 \u95ED</button></div></div></div></div><div class="modal-property" ng-if="vm.xmlShow"><div class="modal-mask"></div><div class="content-scroll modal-con-3"><div class="modal-con-3-body"><div class="modal-con-3-t"><span>\u9009\u62E9\u6A21\u677F</span> <img src="content/images/icon/close1.svg" style="width: 16px" ng-click="xmlHide()"></div><div class="modal-con-3-body-content"><div class="row" style="margin: 0; padding: 0 15px"><form name="searchForm" class="form-search form-inline" class="col-lg-12 col-sm-12"><div class="col-lg-12 col-sm-12" style="margin: 20px auto 10px"><span ng-if="vm.product.productType == \'CALENDAR\'">\u65E5\u5386\u7C7B\u578B\uFF1A<select style="margin:0 10px 0 0" class="form-control border-radius" ng-model="vm.dynamic"><option value="">\u5168\u90E8</option><option value="true">\u52A8\u6001\u65E5\u5386</option><option value="false">\u9759\u6001\u65E5\u5386</option></select></span><select style="margin:0 10px" class="form-control border-radius" ng-model="vm.themeId" ng-options="theme.id as theme.name for theme in vm.themeClassifies | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9\u6A21\u677F\u5206\u7C7B</option></select><input type="text" class="form-control" ng-model="vm.searchQuery" placeholder="{{ \'backApp.product.home.search\' | translate }}" style="margin: 0 10px"> <button class="small-btn-normal" ng-click="vm.search(vm.searchQuery)">\u67E5 \u8BE2</button></div></form><hr class="col-lg-12 col-sm-12 pad-bottom-10" style="padding: 0px\\0"><table class="za-table table" style="width: 94%;margin-left: 4%"><thead><tr style="height: 54px;background: #fafafa"><th class="fw2">\u9009\u62E9</th><th class="fw6">\u6A21\u677F\u540D\u79F0</th><th class="fw3">\u7F16\u53F7</th><th class="fw6">\u5206\u7C7B</th><th class="fw3">P\u6570</th><th class="fw6">\u6A21\u677F\u5C3A\u5BF8</th><th class="fw6">\u914D\u8272</th><th class="fw6">\u4E0A\u4F20\u65E5\u671F</th></tr></thead><tbody><tr ng-repeat="xml in selectItemValue.productXmls track by $index" id="{{xml.id}}" style="height: 70px" ng-if="!xml.cancelled&&!xml.filter &&(!xml.choose||vm.currentXmlLine.productXmlId==xml.id)"><td><i class="choose-li" ng-click="chooseOne(xml)" ng-show="!xml.select"></i> <i class="choose-sel" ng-click="chooseOne(xml)" ng-show="xml.select"></i></td><td>{{xml.name}}</td><td class="position-relative">{{xml.number}}</td><td>{{xml.categoryName}}</td><td>{{xml.pageCount}}</td><td>{{xml.pageSizeW }}*{{xml.pageSizeH}}</td><td><select style="padding: 2px" class="form-control border-radius" id="field_music" name="music" ng-model="xml.modelBlendentUuid" ng-options="modelBlendent.uuid as modelBlendent.name for modelBlendent in xml.modelBlendents| filter:{cancelled:false}"><option label="\u9ED8\u8BA4\u914D\u8272"></option></select></td><!-- <td>{{xml.customStoreName}}</td> --><td>{{xml.createdDate| date:\'mediumDate\'}}</td></tr></tbody></table></div></div><div class="modal-con-3-body-foot"><button type="button" class="small-btn-normal" ng-click="xmlGener()">\u786E \u5B9A</button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="xmlHide()">\u53D6 \u6D88</button></div></div></div></div><style></style>');
$templateCache.put('app/entities/product/product-dialog.html','<div class="listBGC" style="min-width: 850px"><div class="breadcrumb-normal">\u5546\u54C1\u7BA1\u7406 / <span>\u5546\u54C1{{vm.title}}</span></div><div class="con"><div class="c-form"><div class="c-form-label" translate="backApp.product.name">name</div><div class="c-form-div">{{vm.product.name}}</div></div><div class="c-form"><div class="c-form-label">\u7F16\u53F7</div><div class="c-form-div">{{vm.product.number}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.category"></div><div class="c-form-div"><select class="c-select1" ng-model="vm.product.categoryStoreId" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option style="color: #b3a8a8" disabled="disabled" label="{{category.name}}"></option></select></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.productType">productType</div><div class="c-form-div" data-translate="{{\'backApp.ProductType.\' + vm.product.productType}}">{{vm.product.productType}}</div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.editorType">editorType</div><div class="c-form-div" data-translate="{{\'backApp.EditorType.\' + vm.product.editorType}}">{{vm.product.editorType}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'DIY_EDITOR\'"><div class="c-form-label">diy\u7F16\u8F91\u5668</div><div class="c-form-div">{{vm.product.diyEditorSettingName}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\'"><div class="c-form-label" translate="backApp.product.pictureType">pictureType</div><div class="c-form-div"><select class="c-select1" ng-model="vm.product.pictureType" ng-change="vm.product.reverseProcess = false"><option value="single" data-translate="backApp.pictureType.single">single</option><option value="spread" data-translate="backApp.pictureType.spread">spread</option></select></div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE_PRO_P\'"><div class="c-form-label" style="width: 150px">\u5200\u7EBF\u63CF\u8FB9\u5927\u5C0F</div><div class="c-form-div">{{vm.product.contourWidth > 0 ? vm.product.contourWidth + \'mm\' : \'\u6EE1\u5207\'}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'PICTURE_PRO_P\' && vm.product.pictureType == \'spread\'"><div class="c-form-label" style="width: 150px">\u5DE5\u827A\u662F\u5426\u5E94\u7528\u5230\u53CD\u9762</div><div class="c-form-div">{{vm.product.reverseProcess?\'\u662F\':\'\u5426\'}}</div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.forceFill">forceFill</div><div class="c-form-div"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.forceFill">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.forceFill">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.forceFill" ng-change="forceFillChange()" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label><div class="sign pull-left"><img class="sign-img" src="content/images/notes.png"><div class="sign-text">\u5F00\u542F\u4E00\u952E\u6210\u4E66\u540E\uFF0C\u5C06\u5F3A\u5236\u7528\u6237\u9009\u62E9\u6A21\u677F\u6240\u9700\u7167\u7247\u6570\u91CF\uFF0C\u4E0D\u5F00\uFF0C\u5219\u65E0\u8BBA\u7528\u6237\u9009\u62E9\u591A\u5C11\u5F20\u7167\u7247\uFF0C\u90FD\u53EF\u4EE5\u89E6\u53D1\u7CFB\u7EDF\u4E00\u952E\u6210\u4E66\u529F\u80FD</div></div></div></div><div class="c-form" ng-if="vm.product.editorType == \'NEW_EDITOR\'"><div class="c-form-label" translate="backApp.product.aiFill">aiFill</div><div class="c-form-div"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.aiFill">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.aiFill">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.aiFill" ng-change="aiFillChange()" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label><div class="sign pull-left"><img class="sign-img" src="content/images/notes.png"><div class="sign-text">\u5F00\u542F\u667A\u80FD\u586B\u5145\uFF0C\u4F1A\u5C06\u4E0A\u4F20\u7684\u7167\u7247\u6839\u636E\u6A21\u677F\u7684\u89C4\u683C\u81EA\u52A8\u8FDB\u884C\u6392\u7248\u5E03\u5C40\uFF08\u6240\u6709\u7167\u7247\u5B54\u5747\u4F1A\u8986\u76D6\uFF09\uFF0C\u4E0A\u4F20\u7684\u7167\u7247\u6570\u91CF\u9700\u8981\u5728\u5BF9\u5E94\u6A21\u677F\u7684\u7167\u7247\u4E0A\u4E0B\u9650\u4E2D\u3002<br>\u82E5\u6A21\u677F\u5F00\u542F\u5168\u90E8\u4E0D\u53EF\u66FF\u6362\uFF0C\u5546\u54C1\u667A\u80FD\u586B\u5145\u5931\u6548\u3002</div></div></div></div><div class="c-form"><div class="c-form-label" translate="backApp.product.bokeh">bokeh</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.bokeh">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.bokeh">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.bokeh" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form" ng-show="vm.product.bokeh"><div class="c-form-label" translate="backApp.product.bokehType" for="bokehType">bokehType2</div><div class="c-form-div"><select class="c-select1" name="bokehType" ng-model="vm.product.bokehType" id="bokehType"><option value="Transparent" data-translate="backApp.product.bokehTypes.Transparent">Transparent</option><option value="Blurred" data-translate="backApp.product.bokehTypes.Blurred">Blurred</option></select></div></div><div class="c-form" ng-if="vm.product.productType==\'BOOK\' || vm.product.productType==\'CALENDAR\'"><div class="c-form-label">\u4E8C\u7EF4\u7801</div><div class="c-form-div c-form-div-center"><label class="i-switch"><div style="margin-left: 7px;margin-top: -3px" ng-show="vm.product.isCode">\u5F00\u542F</div><div style="margin-left: 20px;margin-top: -3px" ng-show="!vm.product.isCode">\u5173\u95ED</div><input type="checkbox" ng-model="vm.product.isCode"> <i></i></label></div></div><div class="c-form" ng-show="(vm.product.editorType == \'PICTURE\' || vm.product.editorType == \'PICTURE_PRO\' || vm.product.editorType == \'PICTURE_PRO_P\' || vm.product.editorType == \'PHOTO_EDITOR\') && vm.product.pictureType == \'spread\'"><div class="c-form-label">\u5141\u8BB8\u53CD\u9762\u5185\u5BB9\u7EDF\u4E00</div><div class="c-form-div">{{vm.product.allowNegativeUnify?\'\u662F\':\'\u5426\'}}</div></div><!-- <div class="c-form">\n            <span class="c-form-label" translate="backApp.product.bindingType">bindingType</span>\n            <div class="c-form-div c-form-div-center">\n                <select class="c-select1" ng-model="vm.product.bindingType">\n                    <option value="Left" data-translate="backApp.bindingType.Left">Left</option>\n                    <option value="LeftNew" data-translate="backApp.bindingType.LeftNew">LeftNew</option>\n                </select>\n            </div>\n        </div> --><!-- <div class="c-form">\n            <span class="c-form-label" translate="backApp.product.patternType">patternType</span>\n            <div class="c-form-div c-form-div-center">\n                <select class="c-select1" ng-model="vm.product.patternType">\n                    <option value="BOOK" data-translate="backApp.patternType.BOOK">BOOK</option>\n                    <option value="BOOK2" data-translate="backApp.patternType.BOOK2">BOOK2</option>\n                    <option value="OTHER" data-translate="backApp.patternType.OTHER">OTHER</option>\n                </select>\n            </div>\n        </div> --><div class="c-form"><div class="c-form-label" translate="backApp.product.coverImg"></div><div class="c-form-div"><input ng-if="!vm.product.coverImg" type="file" name="file" class="form-control border-radius" type="file" accept="image/jpeg, image/png" onchange="updateImgFile1(event)" ng-model-options="{debounce : 500}"> <span ng-if="!!vm.product.coverImg"><img class="picture-border" ng-if="domain" ng-src="{{domain + vm.product.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(domain + vm.product.coverImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(\'coverImg\')" style="color: red"></i></span></div></div><!-- <div class="c-form">\n            <div class="c-form-label" translate="backApp.product.outSourceId" for="outSourceId">soutSourceId</div>\n            <div class="c-form-div">\n                <input type="text" class="c-input1" name="outSourceId" id="outSourceId" ng-model="vm.product.outSourceId"   />\n            </div>\n        </div> --><div class="c-form" ng-if="vm.product.productType == \'THING\'"><div class="c-form-label">\u5173\u8054\u573A\u666F</div><div class="c-form-div"><div class="c-scene-view c-scene-view1" ng-repeat="item in vm.product.moulds" ng-if="vm.product.moulds.length>0"><div class="c-scene-view-img"><img ng-src="{{item.cover}}" alt=""></div><div class="c-scene-view-name slh">{{item.name}}</div><div class="c-scene-view-icon"><i class="iconfont webshanchu" ng-click="deleteMould($index)"></i></div></div><button type="button" class="small-btn-normal" ng-click="addGltf()"></button></div></div><div class="c-form"><div class="c-form-label">\u89C4\u683C1</div><div class="c-form-div row"><div class="col-md-4 col-sm-4 col-xs-4 pad-right-0 pad-left-10 limitWidth" ng-repeat="property in vm.product.defaultObjectProperties"><div class="checkbox-icon checkbox-1 float-left"></div><div style="margin-left: 8px">{{property.propertyName.length > 6 ? property.propertyName.substr(0, 6) + \'...\' : property.propertyName}}</div></div><div class="col-md-4 col-sm-4 col-xs-4 pad-right-0 pad-left-10 limitWidth" ng-repeat="property in vm.properties"><div class="checkbox-icon checkbox-0 float-left"></div><div class="float-left" style="margin-left: 8px">{{property.name.length > 6 ? property.name.substr(0, 6) + \'...\' : property.name}}</div></div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div" style="width: auto"><table class="za-table table" style="width: 100%"><thead><th style="width: 240px">\u7F16\u53F7</th><th style="width: 100px">\u6A21\u677F\u56FE\u7247</th><th style="width: 80px" ng-repeat="ob in vm.product.itemValues[0].objectValues">{{ob.propertyName}}</th><th style="width: 190px;min-width:190px; max-width: 190px">\u5173\u8054\u6A21\u677F</th><th style="width: 100px;min-width:100px; max-width: 100px">\u6A21\u677F\u4EF7\u683C</th><th style="width: 180px;min-width:180px; max-width: 180px">\u5C55\u793A\u540D\u79F0</th><th style="width: 160px;min-width:160px; max-width: 160px">\u7F16\u53F7</th><th style="width: 100px;min-width:100px; max-width: 100px">\u5C01\u9762\u56FE\u7247</th><th style="width: 60px;min-width:60px; max-width: 60px">\u6392\u5E8F</th><th>\u80CC\u666F\u97F3\u4E50</th></thead><tr ng-repeat="itemValue in vm.product.itemValues track by $index" style="height: 70px" ng-if="!itemValue.deleted && !itemValue.cancelled"><td style="width: 240px">{{itemValue.number}}</td><td style="width: 100px;position: relative"><div class="btn_addPic" ng-if="!itemValue.coverImg" style="width: 90px; height: 90px"><a class="upload-text" ng-if="!itemValue.coverImg">\u8BF7\u4E0A\u4F20</a> <input ng-if="!itemValue.coverImg" type="file" name="file" id="{{itemValue.uuid}}" class="filePrew" onchange="itemvalueLineImgFile(event)" style="outline: none; margin-top: 2px; padding: 2px;opacity: 0;filter\uFF1Aalpha(opacity=0)" accept="image/jpeg, image/png" ng-model-options="{debounce : 500}"></div><span ng-if="!!itemValue.coverImg" style="margin-top: 0px"><img class="picture-border" style="width: 76px; height: 60px" ng-if="domain" ng-src="{{domain + itemValue.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(domain + itemValue.coverImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile2(itemValue)" style="color: red"></i></span></td><td style="width: 80px" ng-repeat="ob in itemValue.objectValues">{{ob.propertyValueValue}}</td><td colspan="7"><table><tr ng-repeat="line in itemValue.productXmlLines" ng-if="!line.deleted && !line.cancelled"><td style="min-width: 190px;  width: 190px; max-width: 190px"><div class="col-lg-12 col-sm-12 pad-left-0 pad-right-0 text-decoration-underline">{{line.productXmlName}}</div></td><td style="width: 100px;min-width:100px; max-width: 100px">{{line.price||0|currency}} <button class="btn-gener" ng-click="buyXml(line)" ng-if="!line.paid">\u8D2D\u4E70</button></td><td style="width: 180px;min-width:180px; max-width: 180px"><input type="text" ng-model="line.name" style="width: 60%" class="c-input1"> <span class="iconfont webduoyuyan" ng-click="vm.multilingual2(line)"></span></td><td style="width: 160px;word-break: break-all;white-space: pre-wrap">{{line.number}}</td><td style="width: 100px;min-width:100px; max-width: 100px;position: relative"><div class="btn_addPic" ng-if="!line.coverImg" style="width: 90px; height: 90px"><a class="upload-text" ng-if="!line.coverImg" style="top:30%">\u8BF7\u4E0A\u4F20</a> <input ng-if="!line.coverImg" type="file" name="file" id="{{line.uuid}}" class="filePrew" onchange="xmlLineImgFile(event)" style="outline: none; margin-top: 2px; padding: 2px;opacity: 0;filter\uFF1Aalpha(opacity=0)" accept="image/jpeg, image/png" ng-model-options="{debounce : 500}"></div><span ng-if="!!line.coverImg" style="margin-top: 0px"><img class="picture-border" style="width: 76px; height: 60px" ng-src="{{line.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(line.coverImg+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile2(line)" style="color: red"></i></span></td><td style="width: 60px;min-width:60px; max-width: 60px"><input style="padding: 2px" type="number" class="c-input1" min="0" max="1000" ng-model="line.seq"></td><td>{{line.musicName}}</td></tr></table></td></tr></table></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div><div class="origin-image origin-image-dialog hide1"><div class="origin-wrap" ng-click="clickToHide()" onmousewheel="return bbimg(this)"><img id="origin-pic" onmousedown="moveImgStartDialog(event)"><div class="text-align-center mar-top-30" id="back-btn"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="clickToHide()"><span translate="entity.action.backTo">back</span></button></div></div></div>');
$templateCache.put('app/entities/product/product-putaway.html','<div class="listBGC" style="min-width: 1300px"><div class="breadcrumb-normal">\u5546\u54C1 / <span>\u5E73\u53F0\u9009\u54C1</span></div><div class="c-book" style="padding: 20px"><div class="input-group" id="test"><input type="text" class="form-control" ng-model="vm.keyword" id="searchQuery" placeholder="\u67E5\u8BE2"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search()">\u641C\u7D22</button></span></div><div class="c-book-body mar-top-20" style="border: 1px solid #ddd"><div class="c-book-body-nav1"><ul class="clearfix"><li ng-repeat="item in vm.classifyList track by $index" ng-class="{\'bookNavOn\': item.id == vm.classify.id}" ng-click="classifyCb(item)" ng-if="vm.classifyList.length > 0"><span>{{item.name}}</span></li></ul><span ng-if="vm.classifyList.length == 0" style="color: #999; display: inline-block; line-height: 40px; text-align: center; width: 100%">\u6682\u65E0\u5546\u54C1\u5206\u7C7B</span></div><div class="c-book-body-content1"><div class="c-book-body-content-top"><ul class="clearfix" ng-if="vm.products1.length > 0"><li class="c-book-sku" ng-repeat="item in vm.products1 track by $index" ng-click="itemValueLinesCb(item)"><div class="c-book-sku-img"><img ng-src="{{domain + item.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>" alt=""></div><div class="c-book-sku-text"><span class="checkbox-icon checkbox-0" style="display: inline-block;margin-top: 0" ng-if="!item.selected"></span> <span class="checkbox-icon checkbox-1" style="display: inline-block;margin-top: 0" ng-if="item.selected"></span> <span title="{{item.name}}">{{item.name}}</span></div></li></ul><div class="c-book-skuNo" ng-if="vm.products1.length == 0"><span>\u6682\u65E0\u6570\u636E</span></div></div><div class="c-book-paging" ng-show="vm.products1.length > 0"><div id="c-paging" style="display: inline-block"></div><span style="color: #999" ng-if="vm.products.length > vm.products1.length && vm.page == 1">\u603B\u5171{{vm.products.length}}\u6761\u6570\u636E</span></div></div><div class="c-book-body-item"><div class="c-book-body-item-title">\u5DF2\u9009\u5546\u54C1</div><ul class="clearfix"><li ng-repeat="item in vm.item track by $index">{{item.name}}</li></ul></div></div><div style="text-align: center; margin-top: 20px"><button type="button" class="small-btn-normal" ng-click="save()" style="margin-right: 15px">\u63D0\u4EA4</button> <button type="buttom" class="small-btn-disabled" ng-click="skip()">\u8FD4\u56DE\u5217\u8868</button></div></div></div>');
$templateCache.put('app/entities/product/product-update-category.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span>\u8BF7\u9009\u62E9\u5546\u54C1\u5206\u7C7B</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group"><span class="col-md-2 col-sm-2 col-xs-2 control-label">\u5206\u7C7B</span><div class="col-md-4 col-sm-4 col-xs-4"><select class="form-control border-radius" ng-model="vm.categoryId" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option style="color: #b3a8a8" label="{{category.name}}"></option></select></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()" class="oval-btn-normal"><span translate="entity.action.save">Save</span></button> <button type="submit" class="oval-btn-normal-empty" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/product/product-view-article.html','<!--<div class="bg view-article" ng-cloak  ng-style="{width:getUlW()}">--><!--    <div class="save-page" ng-cloak>--><!--        <div>--><!--            <img src="content/images/icon/loading.gif">--><!--            <span>\u8BF7\u7A0D\u5019</span>--><!--        </div>--><!--    </div>--><!--    <button class="leftBtn" id="bb-nav-prev">--><!--        <img src="content/images/icon/arrow-left.png">--><!--    </button>--><!--    <button class="rightBtn" id="bb-nav-next">--><!--        <img src="content/images/icon/arrow-right.png">--><!--    </button>--><!--    <div class="main clearfix" ng-show="vm.bindingtype!=\'None\'&&template.pages.page.length>1">--><!--        <div class="bb-custom-wrapper bb-bg">--><!--            <div class="templateView-carousel">--><!--                <ul rn-carousel="" rn-carousel-index="carouselIndex" rn-carousel-buffered=""--><!--                    class="carouselView5 bb-bookblock" id="bb-bookblock"--><!--                    ng-class="{\'uad-maxwidth\':vm.bindingtype==\'Top\'&&isMaxWidth}"--><!--                    ng-style="{--><!--                        margin:\'0 auto\',--><!--                        width:getUlW()}">--><!--                    <li ng-repeat="slide in document.pages track by $index" ng-init="outerIndex = $index"--><!--                        ng-style="{--><!--                            width:getLiW(slide)}"--><!--                        ng-class="{\'half-width\':vm.bindingtype==\'Left\'&&($last||$first),--><!--                        \'half-margin\':vm.bindingtype==\'Left\'&&$first,--><!--                        \'bb-white\':!($first||$last)}"--><!--                        class="bb-item"--><!--                        style="position: relative;" is-over="toggle.now"--><!--                        data-index="{{$index}}">--><!--                        <div ng-show="vm.bindingtype==\'Top\'">--><!--                            <div class="bb-custom-img" ng-style="{--><!--                                position:\'relative\',--><!--                                overflow:\'hidden\',--><!--                                opacity:$first?0:1,--><!--                                \'-ms-filter\': \'alpha(opacity=\'+$first?0:1+\')!important\',--><!--                                filter:\'alpha(opacity=\'+$first?0:1+\')!important\',--><!--                                \'margin-top\':slide.spread==true?slide.marginTop:0,--><!--                                \'margin-bottom\':slide.spread==true?slide.marginTop:0,--><!--                                width:slide.w1,--><!--                                height:slide.h1,--><!--                                background:slide.arr.background.color--><!--                                }">--><!--                                &lt;!&ndash;\u80CC\u666F\u5C42&ndash;&gt;--><!--                                <div  style="overflow:hidden;display: inline-block;background: #fff">--><!--                                    <img ng-src="{{slide.arr.bgImg}}" ng-style="{--><!--                                        position: \'absolute\',--><!--                                        left:slide.arr.background.offsetx*slide.arr.pageScaleW,--><!--                                        top:slide.arr.background.offsety*slide.arr.pageScaleH,--><!--                                        width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',--><!--                                        height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}"/>--><!--                                </div>--><!--                                <div ng-repeat="level in slide.arr.levels.level track by $index">--><!--                                    &lt;!&ndash;\u5F02\u6027\u56FE\u7247\u5904\u7406&ndash;&gt;--><!--                                    <div class="select-img-box diy-box" style="position: absolute;"--><!--                                         ng-if="level.imagebox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                        \'z-index\':level.seq-0+200,--><!--                                        \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                        \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,--><!--                                        \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,--><!--                                        \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,--><!--                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'}">--><!--                                        <div class="relative-box">--><!--                                            <img id="imgInput{{outerIndex}}{{$index}}"--><!--                                                 class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 crossOrigin="Anonymous"--><!--                                                 ng-src="{{level.imagebox.blobUrl}}"--><!--                                                 ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'"--><!--                                                 ng-style="{--><!--                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,--><!--                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,--><!--                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH}"/>--><!--                                            <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}"--><!--                                                 crossOrigin="Anonymous" data-imgIndex="{{$index}}"--><!--                                                 ng-show="level.imagebox.bokehtype!=\'None\'"--><!--                                                 crossOrigin="Anonymous"--><!--                                                 ng-src="{{level.imagebox.blobSmall}}"--><!--                                                 ng-style="{position:\'absolute\',--><!--                                                    left:0,--><!--                                                    top:0,--><!--                                                    width:level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                                    height:level.imagebox.geometry.height*slide.arr.pageScaleH}">--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    &lt;!&ndash;\u8D34\u7EB8\u5C42&ndash;&gt;--><!--                                    <div class="sticker-edit-box background{{outerIndex}} background"--><!--                                         ng-if="level.imageart"--><!--                                         data-index="{{$index}}"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                        \'opacity\':level.imageart.transparency,--><!--                                        filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',--><!--                                        \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                        \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                        \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                        \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                        \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                        \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,--><!--                                        \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,--><!--                                        \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,--><!--                                        \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}">--><!--                                        <div--><!--                                            style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                            <img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"--><!--                                                 style="transition: opacity 0.3s;position: absolute"--><!--                                                 ng-style="{--><!--                                                \'left\': level.imageart.offsetx*slide.arr.pageScaleW,--><!--                                                \'top\': level.imageart.offsety*slide.arr.pageScaleH,--><!--                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"/>--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868&ndash;&gt;--><!--                                    <div class="text-box background{{outerIndex}} background"--><!--                                         ng-if="level.textbox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                            top: level.textbox.geometry.y*slide.arr.pageScaleH,--><!--                                            left: level.textbox.geometry.x*slide.arr.pageScaleW,--><!--                                            width: level.textbox.geometry.width*slide.arr.pageScaleW,--><!--                                            height: level.textbox.geometry.height*slide.arr.pageScaleH,--><!--                                            \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                            \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                            \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                            \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                            \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                     data-index="{{$index}}" style="min-height: 10px;"--><!--                                                     ng-style="{--><!--                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',--><!--                                                        \'font-size\': (level.textbox.style.size*slide.arr.ratio > 12 ? level.textbox.style.size* slide.arr.ratio : 12) + \'pt\',--><!--                                                        \'color\': level.textbox.style.color,--><!--                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',--><!--                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                        \'line-height\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.lineheight* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.letterspacing* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'opacity\': level.textbox.transparency,--><!--                                                        \'text-decoration\': \'none\',--><!--                                                        \'text-align\': level.textbox.style.align,--><!--                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr.ratio)+\')\',--><!--                                                        \'width\':  (level.textbox.style.size* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'--><!--                                                      }"><span style="display: inline-block; width: 100%; white-space: pre-wrap;">{{level.textbox.text}}</span></pre>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    <div data-index="{{$index}}"--><!--                                         ng-show="level.textdocument&&level.textdocument.geometry"--><!--                                         ng-style="{--><!--                                                position: \'absolute\',--><!--                                                width: level.textdocument.geometry.width*slide.arr.pageScaleW,--><!--                                                height: level.textdocument.geometry.height*slide.arr.pageScaleH,--><!--                                                left: level.textdocument.geometry.x*slide.arr.pageScaleW,--><!--                                                top: level.textdocument.geometry.y*slide.arr.pageScaleH,--><!--                                                \'z-index\':level.seq-0+200,--><!--                                                \'opacity\':level.textdocument.transparency.toFixed(2),--><!--                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',--><!--                                                \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}">--><!--                                        <div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events">--><!--                                            <img class="bg-image bg-image{{template.pageI}} pos" ng-cloak--><!--                                                 ng-if="level.textdocument.background.resource.identifier"--><!--                                                 ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}"--><!--                                                 ng-style="{--><!--                                                     position: \'absolute\',--><!--                                                     left:level.textdocument.background.offsetx*slide.arr.pageScaleW,--><!--                                                     top:level.textdocument.background.offsety*slide.arr.pageScaleH,--><!--                                                     width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr.pageScaleW:\'auto\',--><!--                                                     height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr.pageScaleH:\'auto\'}"/>--><!--                                            <div ng-repeat="docLevel in level.textdocument.levels.level track by $index"--><!--                                                 ng-init="docIndex = $index"--><!--                                                 style="position: relative;">--><!--                                                <div data-index="{{docIndex}}" class="img-art"--><!--                                                     ng-show="docLevel.imageart"--><!--                                                     ng-style="{--><!--                                                        width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,--><!--                                                        height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,--><!--                                                        left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,--><!--                                                        top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,--><!--                                                        \'z-index\':docLevel.seq-0+200,--><!--                                                        \'opacity\':docLevel.imageart.transparency,--><!--                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',--><!--                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}">--><!--                                                    <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                        <img data-index="{{$index}}"--><!--                                                             style="transition: opacity 0.3s;position: absolute"--><!--                                                             ng-style="{--><!--                                                                \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,--><!--                                                                \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,--><!--                                                                \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}"--><!--                                                             ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"/>--><!--                                                    </div>--><!--                                                </div>--><!--                                                <div class="c-xml-page-textboxe" ng-show="docLevel.textbox"--><!--                                                     style="white-space: normal;" data-index="{{docIndex}}"--><!--                                                     ng-style="{--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                        \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,--><!--                                                        \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,--><!--                                                        \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,--><!--                                                        \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,--><!--                                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}">--><!--                                                        <pre class="c-xml-page-textboxe-text web-font"--><!--                                                             ng-style="{--><!--                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',--><!--                                                        \'font-size\': (docLevel.textbox.style.size*slide.arr.ratio > 12 ? docLevel.textbox.style.size* slide.arr.ratio : 12) + \'pt\',--><!--                                                        \'color\': docLevel.textbox.style.color,--><!--                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',--><!--                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                        \'line-height\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                        \'letter-spacing\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                        \'opacity\': docLevel.textbox.transparency,--><!--                                                        \'text-decoration\': \'none\',--><!--                                                        \'text-align\': docLevel.textbox.style.align,--><!--                                                        \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                        \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr.ratio)+\')\',--><!--                                                        \'width\':  (docLevel.textbox.style.size* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'--><!--                                                      }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre>--><!--                                                </div>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                                <div class="barcode background{{outerIndex}} background"--><!--                                     ng-show="slide.arr.barcode" ng-style="{--><!--                                     \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,--><!--                                     \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,--><!--                                     \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,--><!--                                     \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,--><!--                                     \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'--><!--                                    }">--><!--                                    <img src="content/images/txm.png"--><!--                                         style="width: 100%;height: 100%;vertical-align:top;">--><!--                                </div>--><!--                            </div>--><!--                            <div class="fc-calendar-wrap" ng-show="$first" style="overflow:hidden;" ng-style="{--><!--                                        position: \'relative\',--><!--                                        overflow:\'hidden\',--><!--                                        \'font-size\': 0,--><!--                                        \'letter-spacing\': \'-2px\',--><!--                                        width:slide.w1,--><!--                                        height:slide.h1,--><!--                                        background:slide.arr.background.color--><!--                                    }">--><!--                                &lt;!&ndash;\u80CC\u666F\u5C42&ndash;&gt;--><!--                                <img ng-if="slide.arr.bgImg" ng-style="{--><!--                                             position: \'absolute\',--><!--                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,--><!--                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,--><!--                                             width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',--><!--                                             height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}"--><!--                                     class="remove-style background{{outerIndex}} background"--><!--                                     ng-src="{{slide.arr.bgImg}}"/>--><!--                                <div ng-repeat="level in slide.arr.levels.level track by $index">--><!--                                    &lt;!&ndash;\u5F02\u6027\u56FE\u7247\u5904\u7406&ndash;&gt;--><!--                                    <div class="select-img-box diy-box background{{outerIndex}} background"--><!--                                         style="position: absolute;"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-if="level.imagebox"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,--><!--                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,--><!--                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,--><!--                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'}">--><!--                                        <div class="relative-box">--><!--                                            <img class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 ng-src="{{level.imagebox.blobUrl}}"--><!--                                                 ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'"--><!--                                                 ng-style="{--><!--                                                \'font-size\':\'10px\'}"/>--><!--                                            <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'"--><!--                                                 ng-src="{{level.imagebox.blobSmall}}"--><!--                                                 ng-style="{position:\'absolute\',--><!--                                                    left:0,--><!--                                                    top:0,--><!--                                                    width:level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                                    height:level.imagebox.geometry.height*slide.arr.pageScaleH}">--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    &lt;!&ndash;\u8D34\u7EB8\u5C42&ndash;&gt;--><!--                                    <div class="sticker-edit-box background{{outerIndex}} background"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         data-index="{{$index}}" ng-if="level.imageart"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'opacity\':level.imageart.transparency,--><!--                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',--><!--                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,--><!--                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,--><!--                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,--><!--                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}">--><!--                                        <div--><!--                                            style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                            <img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"--><!--                                                 style="transition: opacity 0.3s;position: absolute"--><!--                                                 ng-style="{--><!--                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,--><!--                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,--><!--                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"/>--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868&ndash;&gt;--><!--                                    <div class="text-box background{{outerIndex}} background"--><!--                                         ng-if="level.textbox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,--><!--                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,--><!--                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,--><!--                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,--><!--                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                     data-index="{{$index}}" style="min-height: 10px;"--><!--                                                     ng-style="{--><!--                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',--><!--                                                        \'font-size\': (level.textbox.style.size*slide.arr.ratio > 12 ? level.textbox.style.size* slide.arr.ratio : 12) + \'pt\',--><!--                                                        \'color\': level.textbox.style.color,--><!--                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',--><!--                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                        \'line-height\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.lineheight* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.letterspacing* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'opacity\': level.textbox.transparency,--><!--                                                        \'text-decoration\': \'none\',--><!--                                                        \'text-align\': level.textbox.style.align,--><!--                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr.ratio)+\')\',--><!--                                                        \'width\':  (level.textbox.style.size* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'--><!--                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    <div data-index="{{$index}}"--><!--                                         ng-show="level.textdocument&&level.textdocument.geometry"--><!--                                         ng-style="{--><!--                                                    position: \'absolute\',--><!--                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,--><!--                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,--><!--                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,--><!--                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                    \'opacity\':level.textdocument.transparency.toFixed(2),--><!--                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',--><!--                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}">--><!--                                        <div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events">--><!--                                            <img class="bg-image bg-image{{template.pageI}} pos" ng-cloak--><!--                                                 ng-if="level.textdocument.background.resource.identifier"--><!--                                                 ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}"--><!--                                                 ng-style="{--><!--                                                         position: \'absolute\',--><!--                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,--><!--                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,--><!--                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr.pageScaleW:\'auto\',--><!--                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr.pageScaleH:\'auto\'}"/>--><!--                                            <div ng-repeat="docLevel in level.textdocument.levels.level track by $index"--><!--                                                 ng-init="docIndex = $index"--><!--                                                 style="position: relative;">--><!--                                                <div data-index="{{docIndex}}" class="img-art"--><!--                                                     ng-show="docLevel.imageart"--><!--                                                     ng-style="{--><!--                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,--><!--                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,--><!--                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,--><!--                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'opacity\':docLevel.imageart.transparency,--><!--                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',--><!--                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}">--><!--                                                    <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                        <img data-index="{{$index}}"--><!--                                                             style="transition: opacity 0.3s;position: absolute"--><!--                                                             ng-style="{--><!--                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,--><!--                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,--><!--                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}"--><!--                                                             ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"/>--><!--                                                    </div>--><!--                                                </div>--><!--                                                <div class="c-xml-page-textboxe" ng-show="docLevel.textbox"--><!--                                                     style="white-space: normal;" data-index="{{docIndex}}"--><!--                                                     ng-style="{--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,--><!--                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,--><!--                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,--><!--                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,--><!--                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}">--><!--                                                            <pre class="c-xml-page-textboxe-text web-font"--><!--                                                                 ng-style="{--><!--                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',--><!--                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.ratio > 12 ? docLevel.textbox.style.size* slide.arr.ratio : 12) + \'pt\',--><!--                                                            \'color\': docLevel.textbox.style.color,--><!--                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',--><!--                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'opacity\': docLevel.textbox.transparency,--><!--                                                            \'text-decoration\': \'none\',--><!--                                                            \'text-align\': docLevel.textbox.style.align,--><!--                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr.ratio)+\')\',--><!--                                                            \'width\':  (docLevel.textbox.style.size* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'--><!--                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre>--><!--                                                </div>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                                <div class="barcode background{{outerIndex}} background"--><!--                                     ng-show="slide.arr.barcode" ng-style="{--><!--                                         \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,--><!--                                         \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,--><!--                                         \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,--><!--                                         \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,--><!--                                         \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'--><!--                                        }">--><!--                                    <img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top;">--><!--                                </div>--><!--                            </div>--><!--                            <div class="fc-calendar-wrap" ng-hide="$first||slide.spread==true"--><!--                                 ng-style="{--><!--                                        position: \'relative\',--><!--                                        overflow:\'hidden\',--><!--                                        \'font-size\': 0,--><!--                                        \'letter-spacing\': \'-2px\'--><!--                                        }" ng-disabled="$last&&slide.arr2==\'\'">--><!--                                        <span style="overflow:hidden;display: inline-block;"--><!--                                              class="background{{outerIndex}} background"--><!--                                              ng-style="{--><!--                                                width:$last||slide.arr2==\'\'?slide.w1:slide.w2,--><!--                                                height:$last||slide.arr2==\'\'?slide.h1:slide.h2,--><!--                                                background:slide.arr2.background.color}">--><!--                                            &lt;!&ndash;\u80CC\u666F\u5C42&ndash;&gt;--><!--                                            <img class="remove-style" ng-if="slide.arr2.bgImg"--><!--                                                 ng-style="{--><!--                                                 position: \'absolute\',--><!--                                                 left:slide.arr2.background.offsetx*slide.arr2.pageScaleW,--><!--                                                 top:slide.arr2.background.offsety*slide.arr2.pageScaleH,--><!--                                                 width: slide.arr2.background.adaptation!=\'Height\'?\'100%\':\'auto\',--><!--                                                 height:slide.arr2.background.adaptation==\'Height\'?\'100%\':\'auto\'}"--><!--                                                 ng-src="{{slide.arr2==\'\'?$last?\'\':\'content/images/white.png\':slide.arr2.bgImg}}"/>--><!--                                        </span>--><!--                                <div ng-repeat="level in slide.arr2.levels.level track by $index">--><!--                                    &lt;!&ndash;\u5F02\u6027\u56FE\u7247\u5904\u7406&ndash;&gt;--><!--                                    <div class="select-img-box diy-box background{{outerIndex}} background"--><!--                                         style="position: absolute;"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-hide="slide.arr2==\'\'&&$last&&!level.imagebox"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'width\': level.imagebox.geometry.width*slide.arr2.pageScaleW,--><!--                                                \'height\': level.imagebox.geometry.height*slide.arr2.pageScaleH,--><!--                                                \'left\': level.imagebox.geometry.x*slide.arr2.pageScaleW,--><!--                                                \'top\': level.imagebox.geometry.y*slide.arr2.pageScaleH,--><!--                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'}">--><!--                                        <div class="relative-box">--><!--                                            <img class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 ng-src="{{level.imagebox.blobUrl}}"--><!--                                                 ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'"--><!--                                                 ng-style="{--><!--                                                \'font-size\':\'10px\'}"/>--><!--                                            <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'"--><!--                                                 ng-src="{{level.imagebox.blobSmall}}"--><!--                                                 ng-style="{position:\'absolute\',--><!--                                                    left:0,--><!--                                                    top:0,--><!--                                                    width:level.imagebox.geometry.width*slide.arr2.pageScaleW,--><!--                                                    height:level.imagebox.geometry.height*slide.arr2.pageScaleH}">--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    &lt;!&ndash;\u8D34\u7EB8\u5C42&ndash;&gt;--><!--                                    <div class="sticker-edit-box background{{outerIndex}} background"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-hide="slide.arr2==\'\'&&$last&&!level.imageart"--><!--                                         data-index="{{$index}}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'opacity\':level.imageart.transparency,--><!--                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',--><!--                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW,--><!--                                                \'height\': level.imageart.geometry.height*slide.arr2.pageScaleH,--><!--                                                \'left\': level.imageart.geometry.x*slide.arr2.pageScaleW,--><!--                                                \'top\': level.imageart.geometry.y*slide.arr2.pageScaleH}">--><!--                                        <div--><!--                                            style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                            <img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"--><!--                                                 style="transition: opacity 0.3s;position: absolute"--><!--                                                 ng-style="{--><!--                                                    \'left\': level.imageart.offsetx*slide.arr2.pageScaleW,--><!--                                                    \'top\': level.imageart.offsety*slide.arr2.pageScaleH,--><!--                                                    \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW * level.imageart.scale}"/>--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868&ndash;&gt;--><!--                                    <div class="text-box background{{outerIndex}} background"--><!--                                         ng-hide="slide.arr2==\'\'&&$last&&!level.textbox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                top: level.textbox.geometry.y*slide.arr2.pageScaleH,--><!--                                                left: level.textbox.geometry.x*slide.arr2.pageScaleW,--><!--                                                width: level.textbox.geometry.width*slide.arr2.pageScaleW,--><!--                                                height: level.textbox.geometry.height*slide.arr2.pageScaleH,--><!--                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                     data-index="{{$index}}" style="min-height: 10px;"--><!--                                                     ng-style="{--><!--                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',--><!--                                                        \'font-size\': (level.textbox.style.size*slide.arr2.ratio > 12 ? level.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',--><!--                                                        \'color\': level.textbox.style.color,--><!--                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',--><!--                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                        \'line-height\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.lineheight* slide.arr2.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.letterspacing* slide.arr2.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'opacity\': level.textbox.transparency,--><!--                                                        \'text-decoration\': \'none\',--><!--                                                        \'text-align\': level.textbox.style.align,--><!--                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr2.ratio)+\')\',--><!--                                                        \'width\':  (level.textbox.style.size* slide.arr2.ratio > 12 ? (level.textbox.geometry.width*slide.arr2.pageScaleW):level.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr2.ratio))+\'px\'--><!--                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    <div data-index="{{$index}}"--><!--                                         ng-show="level.textdocument&&level.textdocument.geometry"--><!--                                         ng-style="{--><!--                                                    position: \'absolute\',--><!--                                                    width: level.textdocument.geometry.width*slide.arr2.pageScaleW,--><!--                                                    height: level.textdocument.geometry.height*slide.arr2.pageScaleH,--><!--                                                    left: level.textdocument.geometry.x*slide.arr2.pageScaleW,--><!--                                                    top: level.textdocument.geometry.y*slide.arr2.pageScaleH,--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                    \'opacity\':level.textdocument.transparency.toFixed(2),--><!--                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',--><!--                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}">--><!--                                        <div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events">--><!--                                            <img class="bg-image bg-image{{template.pageI}} pos" ng-cloak--><!--                                                 ng-if="level.textdocument.background.resource.identifier"--><!--                                                 ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}"--><!--                                                 ng-style="{--><!--                                                         position: \'absolute\',--><!--                                                         left:level.textdocument.background.offsetx*slide.arr2.pageScaleW,--><!--                                                         top:level.textdocument.background.offsety*slide.arr2.pageScaleH,--><!--                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr2.pageScaleW:\'auto\',--><!--                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr2.pageScaleH:\'auto\'}"/>--><!--                                            <div ng-repeat="docLevel in level.textdocument.levels.level track by $index"--><!--                                                 ng-init="docIndex = $index"--><!--                                                 style="position: relative;">--><!--                                                <div data-index="{{docIndex}}" class="img-art"--><!--                                                     ng-show="docLevel.imageart"--><!--                                                     ng-style="{--><!--                                                            width: docLevel.imageart.geometry.width*slide.arr2.pageScaleW,--><!--                                                            height: docLevel.imageart.geometry.height*slide.arr2.pageScaleH,--><!--                                                            left: docLevel.imageart.geometry.x*slide.arr2.pageScaleW,--><!--                                                            top: docLevel.imageart.geometry.y*slide.arr2.pageScaleH,--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'opacity\':docLevel.imageart.transparency,--><!--                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',--><!--                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}">--><!--                                                    <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                        <img data-index="{{$index}}"--><!--                                                             style="transition: opacity 0.3s;position: absolute"--><!--                                                             ng-style="{--><!--                                                                    \'left\': docLevel.imageart.offsetx*slide.arr2.pageScaleW,--><!--                                                                    \'top\': docLevel.imageart.offsety*slide.arr2.pageScaleH,--><!--                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr2.pageScaleW * docLevel.imageart.scale}"--><!--                                                             ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"/>--><!--                                                    </div>--><!--                                                </div>--><!--                                                <div class="c-xml-page-textboxe" ng-show="docLevel.textbox"--><!--                                                     style="white-space: normal;" data-index="{{docIndex}}"--><!--                                                     ng-style="{--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'width\': docLevel.textbox.geometry.width*slide.arr2.pageScaleW,--><!--                                                            \'height\': docLevel.textbox.geometry.height*slide.arr2.pageScaleW,--><!--                                                            \'left\': docLevel.textbox.geometry.x*slide.arr2.pageScaleW,--><!--                                                            \'top\': docLevel.textbox.geometry.y*slide.arr2.pageScaleH,--><!--                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}">--><!--                                                            <pre class="c-xml-page-textboxe-text web-font"--><!--                                                                 ng-style="{--><!--                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',--><!--                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr2.ratio > 12 ? docLevel.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',--><!--                                                            \'color\': docLevel.textbox.style.color,--><!--                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',--><!--                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr2.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr2.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'opacity\': docLevel.textbox.transparency,--><!--                                                            \'text-decoration\': \'none\',--><!--                                                            \'text-align\': docLevel.textbox.style.align,--><!--                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio)+\')\',--><!--                                                            \'width\':  (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr2.pageScaleW):docLevel.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr2.ratio))+\'px\'--><!--                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre>--><!--                                                </div>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                                <div class="barcode background{{outerIndex}} background"--><!--                                     ng-show="slide.arr2.barcode" ng-style="{--><!--                                            \'width\': slide.arr2.barcode.geometry.width*slide.arr2.pageScaleW,--><!--                                             \'height\': slide.arr2.barcode.geometry.height*slide.arr2.pageScaleH,--><!--                                             \'left\': slide.arr2.barcode.geometry.x*slide.arr2.pageScaleW,--><!--                                             \'top\': slide.arr2.barcode.geometry.y*slide.arr2.pageScaleH,--><!--                                             \'transform\': \'rotate(-\' + slide.arr2.barcode.rotation.angle + \'deg)\'--><!--                                        }">--><!--                                    <img src="content/images/txm.png"--><!--                                         style="width: 100%;height: 100%;vertical-align:top;">--><!--                                </div>--><!--                            </div>--><!--                        </div>--><!--                        <div ng-show="vm.bindingtype==\'Left\'">--><!--                            <div class="slide-content slide1" data-index="{{$index}}" id="slide1"--><!--                                 ng-class="{\'bb-custom-side\':(slide.arr2!=\'\'||$first||(slide.arr2==\'\'&&slide.spread==false))}"--><!--                                 ng-style="{--><!--                                            width:getPageWaHLar(slide,true,true),--><!--                                            height:getPageWaHLar(slide,false,true),--><!--                                            \'margin-left\':$first?0:slide.marginLeft,--><!--                                            position:relative,--><!--                                            background:slide.arr.background.color}">--><!--                                &lt;!&ndash;\u80CC\u666F\u5C42&ndash;&gt;--><!--                                <img--><!--                                    ng-if="slide.arr.bgImg"--><!--                                    ng-src="{{slide.arr.bgImg||slide.arr.background.resource.identifier + \'?imageMogr2\'}}"--><!--                                    class="background{{$index}} background"--><!--                                    ng-style="{--><!--                                             position: \'absolute\',--><!--                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,--><!--                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,--><!--                                             width: slide.arr.background.adaptation!=\'Height\'?slide.arr.background.width*slide.arr.pageScaleW:\'auto\',--><!--                                             height:slide.arr.background.adaptation==\'Height\'?slide.arr.background.height*slide.arr.pageScaleH:\'auto\'}"/>--><!--                                <div ng-repeat="level in slide.arr.levels.level track by $index">--><!--                                    &lt;!&ndash;\u5F02\u6027\u56FE\u7247\u5904\u7406&ndash;&gt;--><!--                                    <div class="select-img-box diy-box background{{outerIndex}} background"--><!--                                         style="position: absolute;" ng-if="level.imagebox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,--><!--                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,--><!--                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,--><!--                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'}">--><!--                                        <div class="relative-box">--><!--                                            <img class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 ng-src="{{level.imagebox.blobUrl}}"--><!--                                                 ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'"--><!--                                                 ng-style="{\'font-size\':\'10px\'}"/>--><!--                                            <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'"--><!--                                                 ng-src="{{level.imagebox.blobSmall}}"--><!--                                                 ng-style="{position:\'absolute\',--><!--                                                    left:0,--><!--                                                    top:0,--><!--                                                    width:level.imagebox.geometry.width*slide.arr.pageScaleW,--><!--                                                    height:level.imagebox.geometry.height*slide.arr.pageScaleH}">--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    &lt;!&ndash;\u8D34\u7EB8\u5C42&ndash;&gt;--><!--                                    <div class="sticker-edit-box background{{outerIndex}} background"--><!--                                         ng-if="level.imageart"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         data-index="{{$index}}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'opacity\':level.imageart.transparency,--><!--                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',--><!--                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,--><!--                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,--><!--                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,--><!--                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}">--><!--                                        <div--><!--                                            style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                            <img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"--><!--                                                 style="transition: opacity 0.3s;position: absolute"--><!--                                                 ng-style="{--><!--                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,--><!--                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,--><!--                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"/>--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868&ndash;&gt;--><!--                                    <div class="text-box background{{outerIndex}} background"--><!--                                         ng-if="level.textbox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,--><!--                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,--><!--                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,--><!--                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,--><!--                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                     data-index="{{$index}}" style="min-height: 10px;"--><!--                                                     ng-style="{--><!--                                                    \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',--><!--                                                    \'font-size\': (level.textbox.style.size*slide.arr.ratio > 12 ? level.textbox.style.size* slide.arr.ratio : 12) + \'pt\',--><!--                                                    \'color\': level.textbox.style.color,--><!--                                                    \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',--><!--                                                    \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                    \'line-height\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.lineheight* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',--><!--                                                    \'letter-spacing\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.letterspacing* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',--><!--                                                    \'opacity\': level.textbox.transparency,--><!--                                                    \'text-decoration\': \'none\',--><!--                                                    \'text-align\': level.textbox.style.align,--><!--                                                    \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                    \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr.ratio)+\')\',--><!--                                                    \'width\':  (level.textbox.style.size* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'--><!--                                                  }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    <div data-index="{{$index}}"--><!--                                         ng-show="level.textdocument&&level.textdocument.geometry"--><!--                                         ng-style="{--><!--                                                    position: \'absolute\',--><!--                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,--><!--                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,--><!--                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,--><!--                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                    \'opacity\':level.textdocument.transparency.toFixed(2),--><!--                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',--><!--                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}">--><!--                                        <div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events">--><!--                                            <img class="bg-image bg-image{{template.pageI}} pos" ng-cloak--><!--                                                 ng-if="level.textdocument.background.resource.identifier"--><!--                                                 ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}"--><!--                                                 ng-style="{--><!--                                                         position: \'absolute\',--><!--                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,--><!--                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,--><!--                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr.pageScaleW:\'auto\',--><!--                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr.pageScaleH:\'auto\'}"/>--><!--                                            <div ng-repeat="docLevel in level.textdocument.levels.level track by $index"--><!--                                                 ng-init="docIndex = $index"--><!--                                                 style="position: relative;">--><!--                                                <div data-index="{{docIndex}}" class="img-art"--><!--                                                     ng-show="docLevel.imageart"--><!--                                                     ng-style="{--><!--                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,--><!--                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,--><!--                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,--><!--                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'opacity\':docLevel.imageart.transparency,--><!--                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',--><!--                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}">--><!--                                                    <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                        <img data-index="{{$index}}"--><!--                                                             style="transition: opacity 0.3s;position: absolute"--><!--                                                             ng-style="{--><!--                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,--><!--                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,--><!--                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}"--><!--                                                             ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"/>--><!--                                                    </div>--><!--                                                </div>--><!--                                                <div class="c-xml-page-textboxe" ng-show="docLevel.textbox"--><!--                                                     style="white-space: normal;" data-index="{{docIndex}}"--><!--                                                     ng-style="{--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,--><!--                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,--><!--                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,--><!--                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,--><!--                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}">--><!--                                                            <pre class="c-xml-page-textboxe-text web-font"--><!--                                                                 ng-style="{--><!--                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',--><!--                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.ratio > 12 ? docLevel.textbox.style.size* slide.arr.ratio : 12) + \'pt\',--><!--                                                            \'color\': docLevel.textbox.style.color,--><!--                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',--><!--                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'opacity\': docLevel.textbox.transparency,--><!--                                                            \'text-decoration\': \'none\',--><!--                                                            \'text-align\': docLevel.textbox.style.align,--><!--                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr.ratio)+\')\',--><!--                                                            \'width\':  (docLevel.textbox.style.size* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'--><!--                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre>--><!--                                                </div>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                                <div class="barcode background{{outerIndex}} background"--><!--                                     ng-show="slide.arr.barcode" ng-style="{--><!--                                    \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,--><!--                                     \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,--><!--                                     \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,--><!--                                     \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,--><!--                                     \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'--><!--                                    }">--><!--                                    <img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top;">--><!--                                </div>--><!--                            </div>--><!--                            <div class="slide-content slide1" ng-show="!orientations&&($first||$last)" ng-style="{--><!--                                    opacity:0,--><!--                                    width:getPageWaHLar(slide,true,true)*2,--><!--                                    height:getPageWaHLar(slide,false,true),--><!--                                    position:relative}"></div>--><!--                            <div ng-hide="$first||$last||slide.spread==true" id="slide2"--><!--                                 class="slide-content bb-custom-side slide2"--><!--                                 style="position: relative!important;"--><!--                                 ng-style="{--><!--                                    width:getPageWaHLar(slide,true,false),--><!--                                    height:getPageWaHLar(slide,false,false),--><!--                                    background:slide.arr2.background.color--><!--                                }">--><!--                                &lt;!&ndash;\u80CC\u666F\u5C42&ndash;&gt;--><!--                                <img ng-src="{{slide.arr2==\'\'?\'\':slide.arr2.bgImg}}"--><!--                                     ng-if="slide.arr2.bgImg"--><!--                                     class=" background{{$index}} background"--><!--                                     ng-style="{--><!--                                             position: \'absolute\',--><!--                                             left:slide.arr2.background.offsetx*slide.arr2.pageScaleW,--><!--                                             top:slide.arr2.background.offsety*slide.arr2.pageScaleH,--><!--                                             width: slide.arr2.background.adaptation!=\'Height\'?slide.arr2.background.width*slide.arr2.pageScaleW:\'auto\',--><!--                                             height:slide.arr2.background.adaptation==\'Height\'?slide.arr2.background.height*slide.arr2.pageScaleH:\'auto\'}"/>--><!--                                <div ng-repeat="level in slide.arr2.levels.level track by $index">--><!--                                    &lt;!&ndash;\u5F02\u6027\u56FE\u7247\u5904\u7406&ndash;&gt;--><!--                                    <div class="select-img-box diy-box background{{outerIndex}} background"--><!--                                         style="position: absolute;" ng-if="level.imagebox"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                         \'width\': level.imagebox.geometry.width*slide.arr2.pageScaleW,--><!--                                        \'height\': level.imagebox.geometry.height*slide.arr2.pageScaleH,--><!--                                        \'left\': level.imagebox.geometry.x*slide.arr2.pageScaleW,--><!--                                        \'top\': level.imagebox.geometry.y*slide.arr2.pageScaleH,--><!--                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'}">--><!--                                        <div class="relative-box">--><!--                                            <img id="imgInput{{outerIndex+1}}{{$index}}"--><!--                                                 class="indexSet-800 imgBoxes{{outerIndex+1}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 ng-src="{{level.imagebox.blobUrl}}"--><!--                                                 ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'"--><!--                                                 ng-style="{--><!--                                                \'font-size\':\'10px\'}"/>--><!--                                            <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}"--><!--                                                 data-imgIndex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'"--><!--                                                 ng-src="{{level.imagebox.blobSmall}}"--><!--                                                 ng-style="{position:\'absolute\',--><!--                                                    left:0,--><!--                                                    top:0,--><!--                                                    width:level.imagebox.geometry.width*slide.arr2.pageScaleW,--><!--                                                    height:level.imagebox.geometry.height*slide.arr2.pageScaleH}">--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    &lt;!&ndash;\u8D34\u7EB8\u5C42&ndash;&gt;--><!--                                    <div class="sticker-edit-box background{{outerIndex}} background"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-if="level.imageart"--><!--                                         data-index="{{$index}}"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                \'opacity\':level.imageart.transparency,--><!--                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',--><!--                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                                \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW,--><!--                                                \'height\': level.imageart.geometry.height*slide.arr2.pageScaleH,--><!--                                                \'left\': level.imageart.geometry.x*slide.arr2.pageScaleW,--><!--                                                \'top\': level.imageart.geometry.y*slide.arr2.pageScaleH}">--><!--                                        <div--><!--                                            style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                            <img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"--><!--                                                 style="transition: opacity 0.3s;position: absolute"--><!--                                                 ng-style="{--><!--                                                    \'left\': level.imageart.offsetx*slide.arr2.pageScaleW,--><!--                                                    \'top\': level.imageart.offsety*slide.arr2.pageScaleH,--><!--                                                    \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW * level.imageart.scale}"/>--><!--                                        </div>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868&ndash;&gt;--><!--                                    <div class="text-box background{{outerIndex}} background"--><!--                                         ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-if="level.textbox"--><!--                                         ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                top: level.textbox.geometry.y*slide.arr2.pageScaleH,--><!--                                                left: level.textbox.geometry.x*slide.arr2.pageScaleW,--><!--                                                width: level.textbox.geometry.width*slide.arr2.pageScaleW,--><!--                                                height: level.textbox.geometry.height*slide.arr2.pageScaleH,--><!--                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                     data-index="{{$index}}" style="min-height: 10px;"--><!--                                                     ng-style="{--><!--                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',--><!--                                                        \'font-size\': (level.textbox.style.size*slide.arr2.ratio > 12 ? level.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',--><!--                                                        \'color\': level.textbox.style.color,--><!--                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',--><!--                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                        \'line-height\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.lineheight* slide.arr2.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.letterspacing* slide.arr2.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'opacity\': level.textbox.transparency,--><!--                                                        \'text-decoration\': \'none\',--><!--                                                        \'text-align\': level.textbox.style.align,--><!--                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr2.ratio)+\')\',--><!--                                                        \'width\':  (level.textbox.style.size* slide.arr2.ratio > 12 ? (level.textbox.geometry.width*slide.arr2.pageScaleW):level.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr2.ratio))+\'px\'--><!--                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre>--><!--                                    </div>--><!--                                    &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                    <div data-index="{{$index}}"--><!--                                         ng-show="level.textdocument&&level.textdocument.geometry"--><!--                                         ng-style="{--><!--                                                    position: \'absolute\',--><!--                                                    width: level.textdocument.geometry.width*slide.arr2.pageScaleW,--><!--                                                    height: level.textdocument.geometry.height*slide.arr2.pageScaleH,--><!--                                                    left: level.textdocument.geometry.x*slide.arr2.pageScaleW,--><!--                                                    top: level.textdocument.geometry.y*slide.arr2.pageScaleH,--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                    \'opacity\':level.textdocument.transparency.toFixed(2),--><!--                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',--><!--                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}">--><!--                                        <div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events">--><!--                                            <img class="bg-image bg-image{{template.pageI}} pos" ng-cloak--><!--                                                 ng-if="level.textdocument.background.resource.identifier"--><!--                                                 ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}"--><!--                                                 ng-style="{--><!--                                                         position: \'absolute\',--><!--                                                         left:level.textdocument.background.offsetx*slide.arr2.pageScaleW,--><!--                                                         top:level.textdocument.background.offsety*slide.arr2.pageScaleH,--><!--                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr2.pageScaleW:\'auto\',--><!--                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr2.pageScaleH:\'auto\'}"/>--><!--                                            <div ng-repeat="docLevel in level.textdocument.levels.level track by $index"--><!--                                                 ng-init="docIndex = $index"--><!--                                                 style="position: relative;">--><!--                                                <div data-index="{{docIndex}}" class="img-art"--><!--                                                     ng-show="docLevel.imageart"--><!--                                                     ng-style="{--><!--                                                            width: docLevel.imageart.geometry.width*slide.arr2.pageScaleW,--><!--                                                            height: docLevel.imageart.geometry.height*slide.arr2.pageScaleH,--><!--                                                            left: docLevel.imageart.geometry.x*slide.arr2.pageScaleW,--><!--                                                            top: docLevel.imageart.geometry.y*slide.arr2.pageScaleH,--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'opacity\':docLevel.imageart.transparency,--><!--                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',--><!--                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}">--><!--                                                    <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                        <img data-index="{{$index}}"--><!--                                                             style="transition: opacity 0.3s;position: absolute"--><!--                                                             ng-style="{--><!--                                                                    \'left\': docLevel.imageart.offsetx*slide.arr2.pageScaleW,--><!--                                                                    \'top\': docLevel.imageart.offsety*slide.arr2.pageScaleH,--><!--                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr2.pageScaleW * docLevel.imageart.scale}"--><!--                                                             ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"/>--><!--                                                    </div>--><!--                                                </div>--><!--                                                <div class="c-xml-page-textboxe" ng-show="docLevel.textbox"--><!--                                                     style="white-space: normal;" data-index="{{docIndex}}"--><!--                                                     ng-style="{--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'width\': docLevel.textbox.geometry.width*slide.arr2.pageScaleW,--><!--                                                            \'height\': docLevel.textbox.geometry.height*slide.arr2.pageScaleW,--><!--                                                            \'left\': docLevel.textbox.geometry.x*slide.arr2.pageScaleW,--><!--                                                            \'top\': docLevel.textbox.geometry.y*slide.arr2.pageScaleH,--><!--                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}">--><!--                                                            <pre class="c-xml-page-textboxe-text web-font"--><!--                                                                 ng-style="{--><!--                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',--><!--                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr2.ratio > 12 ? docLevel.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',--><!--                                                            \'color\': docLevel.textbox.style.color,--><!--                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',--><!--                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr2.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr2.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'opacity\': docLevel.textbox.transparency,--><!--                                                            \'text-decoration\': \'none\',--><!--                                                            \'text-align\': docLevel.textbox.style.align,--><!--                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio)+\')\',--><!--                                                            \'width\':  (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr2.pageScaleW):docLevel.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr2.ratio))+\'px\'--><!--                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre>--><!--                                                </div>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                                <div class="barcode background{{outerIndex}} background"--><!--                                     ng-show="slide.arr2.barcode" ng-style="{--><!--                                    \'width\': slide.arr2.barcode.geometry.width*slide.arr2.pageScaleW,--><!--                                     \'height\': slide.arr2.barcode.geometry.height*slide.arr2.pageScaleH,--><!--                                     \'left\': slide.arr2.barcode.geometry.x*slide.arr2.pageScaleW,--><!--                                     \'top\': slide.arr2.barcode.geometry.y*slide.arr2.pageScaleH,--><!--                                     \'transform\': \'rotate(-\' + slide.arr2.barcode.rotation.angle + \'deg)\'--><!--                                }">--><!--                                    <img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top;">--><!--                                </div>--><!--                            </div>--><!--                        </div>--><!--                    </li>--><!--                    <li ng-repeat="page in template.pages.page track by $index" ng-init="outerIndex = $index"--><!--                        style="display: none">--><!--                        <div class="select-img-box diy-box" style="position: absolute;"--><!--                             ng-repeat="imgInput in page.imageboxes.imagebox track by $index">--><!--                            <img class="imgBox{{outerIndex}}{{$index}}"/>--><!--                        </div>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--        </div>--><!--    </div>--><!--    <div class="main clearfix" ng-show="vm.bindingtype==\'None\'||template.pages.page.length<2">--><!--        <div class="bb-custom-wrapper bb-bg" style="margin-top: 50px!important;">--><!--            <div class="templateView2-carousel">--><!--                <ul rn-carousel="" rn-carousel-index="carouselIndex" rn-carousel-buffered=""--><!--                    class="carouselView5">--><!--                    <li ng-repeat="slide in template.pages.page track by $index" ng-init="outerIndex = $index"--><!--                        class="mar-bottom-15" style="overflow: hidden"--><!--                        ng-style="{--><!--                            width:dWidth*0.7,--><!--                            margin:\'0 auto\'}"--><!--                        style="position: relative;" is-over="toggle.now"--><!--                        data-index="{{$index}}">--><!--                        <div class="slide-content mar-bottom-15" data-index="{{$index}}" ng-style="{--><!--                                width:dWidth*0.7,--><!--                                height:dWidth*0.7*slide.mediabox.height/slide.mediabox.width,--><!--                                background:slide.background.color--><!--                                }">--><!--                            &lt;!&ndash;<img ng-src="{{slide.bgImg}}" style="width: 100%" />&ndash;&gt;--><!--                            &lt;!&ndash;\u80CC\u666F\u5C42&ndash;&gt;--><!--                            <img ng-src="{{slide.bgImg}}"--><!--                                 ng-if="slide.bgImg"--><!--                                 ng-style="{--><!--                                             position: \'absolute\',--><!--                                             left:slide.background.offsetx,--><!--                                             top:slide.background.offsety,--><!--                                             width: slide.background.adaptation!=\'Height\'?slide.background.width:\'auto\',--><!--                                             height:slide.background.adaptation==\'Height\'?slide.background.height:\'auto\'}"/>--><!--                            <div ng-repeat="level in slide.levels.level track by $index">--><!--                                &lt;!&ndash;\u5F02\u6027\u56FE\u7247\u5904\u7406&ndash;&gt;--><!--                                <div class="select-img-box diy-box" style="position: absolute;"--><!--                                     ng-if="level.imagebox"--><!--                                     ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                     ng-style="{--><!--                                        \'z-index\':level.seq-0+200,--><!--                                        \'width\': level.imagebox.geometry.width,--><!--                                        \'height\': level.imagebox.geometry.height,--><!--                                        \'left\': level.imagebox.geometry.x,--><!--                                        \'top\': level.imagebox.geometry.y,--><!--                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'}">--><!--                                    <div class="relative-box">--><!--                                        <img id="imgInput{{outerIndex}}{{$index}}"--><!--                                             class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}"--><!--                                             data-imgIndex="{{$index}}"--><!--                                             ng-src="{{level.imagebox.blobUrl}}"--><!--                                             ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'"--><!--                                             ng-style="{--><!--                                                \'font-size\':\'10px\',--><!--                                                \'width\': level.imagebox.geometry.width,--><!--                                                \'height\':level.imagebox.geometry.height,--><!--                                                \'left\': level.imagebox.geometry.x,--><!--                                                \'top\': level.imagebox.geometry.y}"/>--><!--                                        <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}"--><!--                                             data-imgIndex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'"--><!--                                             ng-src="{{level.imagebox.blobSmall}}"--><!--                                             ng-style="{position:\'absolute\',--><!--                                                    left:0,--><!--                                                    top:0,--><!--                                                    width:level.imagebox.geometry.width,--><!--                                                    height:level.imagebox.geometry.height}">--><!--                                    </div>--><!--                                </div>--><!--                                &lt;!&ndash;\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                &lt;!&ndash;\u8D34\u7EB8\u5C42&ndash;&gt;--><!--                                <div class="sticker-edit-box"--><!--                                     ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                     data-index="{{$index}}" ng-if="level.imageart"--><!--                                     ng-style="{--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                            \'opacity\':level.imageart.transparency,--><!--                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',--><!--                                            \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                            \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                            \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                            \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                            \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',--><!--                                            \'width\': level.imageart.geometry.width,--><!--                                            \'height\': level.imageart.geometry.height,--><!--                                            \'left\': level.imageart.geometry.x,--><!--                                            \'top\': level.imageart.geometry.y}">--><!--                                    <div--><!--                                        style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                        <img id="select-sticker-{{$index}}"--><!--                                             ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"--><!--                                             style="transition: opacity 0.3s;position: absolute"--><!--                                             ng-style="{--><!--                                                    \'left\': level.imageart.offsetx,--><!--                                                    \'top\': level.imageart.offsety,--><!--                                                    \'width\': level.imageart.geometry.width * level.imageart.scale}"/>--><!--                                    </div>--><!--                                </div>--><!--                                &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868&ndash;&gt;--><!--                                <div class="text-box" ng-if="level.textbox"--><!--                                     ng-class="{\'leftbo-rotation\': isLeftRotation}"--><!--                                     ng-style="{--><!--                                                \'z-index\':level.seq-0+200,--><!--                                                top: level.textbox.geometry.y,--><!--                                                left: level.textbox.geometry.x,--><!--                                                width: level.textbox.geometry.width,--><!--                                                height: level.textbox.geometry.height,--><!--                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',--><!--                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                     data-index="{{$index}}" style="min-height: 10px;"--><!--                                                     ng-style="{--><!--                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',--><!--                                                        \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',--><!--                                                        \'color\': level.textbox.style.color,--><!--                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',--><!--                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                        \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',--><!--                                                        \'opacity\': level.textbox.transparency,--><!--                                                        \'text-decoration\': \'none\',--><!--                                                        \'text-align\': level.textbox.style.align,--><!--                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',--><!--                                                        \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width):level.textbox.geometry.width/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'--><!--                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre>--><!--                                </div>--><!--                                &lt;!&ndash;\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F&ndash;&gt;--><!--                                <div data-index="{{$index}}"--><!--                                     ng-show="level.textdocument&&level.textdocument.geometry"--><!--                                     ng-style="{--><!--                                                    position: \'absolute\',--><!--                                                    width: level.textdocument.geometry.width,--><!--                                                    height: level.textdocument.geometry.height,--><!--                                                    left: level.textdocument.geometry.x,--><!--                                                    top: level.textdocument.geometry.y,--><!--                                                    \'z-index\':level.seq-0+200,--><!--                                                    \'opacity\':level.textdocument.transparency.toFixed(2),--><!--                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',--><!--                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}">--><!--                                    <div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events">--><!--                                        <img class="bg-image bg-image{{template.pageI}} pos" ng-cloak--><!--                                             ng-if="level.textdocument.background.resource.identifier"--><!--                                             ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}"--><!--                                             ng-style="{--><!--                                                         position: \'absolute\',--><!--                                                         left:level.textdocument.background.offsetx,--><!--                                                         top:level.textdocument.background.offsety,--><!--                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width:\'auto\',--><!--                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height:\'auto\'}"/>--><!--                                        <div ng-repeat="docLevel in level.textdocument.levels.level track by $index"--><!--                                             ng-init="docIndex = $index"--><!--                                             style="position: relative;">--><!--                                            <div data-index="{{docIndex}}" class="img-art"--><!--                                                 ng-show="docLevel.imageart"--><!--                                                 ng-style="{--><!--                                                            width: docLevel.imageart.geometry.width,--><!--                                                            height: docLevel.imageart.geometry.height,--><!--                                                            left: docLevel.imageart.geometry.x,--><!--                                                            top: docLevel.imageart.geometry.y,--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'opacity\':docLevel.imageart.transparency,--><!--                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',--><!--                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}">--><!--                                                <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                    <img data-index="{{$index}}"--><!--                                                         style="transition: opacity 0.3s;position: absolute"--><!--                                                         ng-style="{--><!--                                                                    \'left\': docLevel.imageart.offsetx,--><!--                                                                    \'top\': docLevel.imageart.offsety,--><!--                                                                    \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale}"--><!--                                                         ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"/>--><!--                                                </div>--><!--                                            </div>--><!--                                            <div class="c-xml-page-textboxe" ng-show="docLevel.textbox"--><!--                                                 style="white-space: normal;" data-index="{{docIndex}}"--><!--                                                 ng-style="{--><!--                                                            \'z-index\':docLevel.seq-0+200,--><!--                                                            \'width\': docLevel.textbox.geometry.width,--><!--                                                            \'left\': docLevel.textbox.geometry.x,--><!--                                                            \'top\': docLevel.textbox.geometry.y,--><!--                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}">--><!--                                                            <pre class="c-xml-page-textboxe-text web-font"--><!--                                                                 ng-style="{--><!--                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',--><!--                                                            \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',--><!--                                                            \'color\': docLevel.textbox.style.color,--><!--                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',--><!--                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                            \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',--><!--                                                            \'opacity\': docLevel.textbox.transparency,--><!--                                                            \'text-decoration\': \'none\',--><!--                                                            \'text-align\': docLevel.textbox.style.align,--><!--                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',--><!--                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',--><!--                                                            \'width\':  (docLevel.textbox.style.size*slide.ratio > 12 ? (docLevel.textbox.geometry.width):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'--><!--                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                            </div>--><!--                            <div class="barcode" ng-show="slide.barcode" ng-style="{--><!--                                    \'width\': slide.barcode.geometry.width,--><!--                                     \'height\': slide.barcode.geometry.height,--><!--                                     \'left\': slide.barcode.geometry.x,--><!--                                     \'top\': slide.barcode.geometry.y,--><!--                                     \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\'--><!--                                    }">--><!--                                <img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top;">--><!--                            </div>--><!--                        </div>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--        </div>--><!--    </div>--><!--    <div class="text-align-center mar-top-30" id="back-btn"--><!--         ng-show="isShow||vm.bindingtype==\'None\'||template.pages.page.length<2">--><!--        <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="backTo()">--><!--            <span translate="entity.action.backTo">back</span>--><!--        </button>--><!--    </div>--><!--</div>--><div ng-if="vm.watchSure" style="margin-left: -176px"><article-preview-web page="0" preview-article="vm.previewArticle" file-name="vm.fileName" bindingtype="vm.product.bindingType" editor-type="vm.product.editorType" ng-if="vm.previewArticle"></article-preview-web><div class="text-align-center mar-top-30" id="back-btn"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="backTo()"><span translate="entity.action.backTo">back</span></button></div></div><div class="origin-image origin-image-dialog" ng-show="isXml"><div class="origin-wrap" ng-click="clickToHide()" onmousewheel="return bbimg(this)"><img id="origin-pic" onmousedown="moveImgStart(event)"><div class="text-align-center mar-top-30"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="backTo()"><span translate="entity.action.backTo">back</span></button></div></div></div>');
$templateCache.put('app/entities/product/products.html','<div class="listBGC" style="min-width: 1300px"><div class="breadcrumb-normal">\u5546\u54C1 / <span translate="global.menu.entities.templateManagement2">product</span></div><div class="con"><div class="overflow-h"><div class="float-left"><button class="oval-btn-normal" ui-sref="product-putaway"><span>\u5E73\u53F0\u9009\u54C1</span> <i class="icon iconfont iconjia1"></i></button> <button class="oval-btn-normal" ui-sref="product.new" perm="ROLE_PRODUCT_CREATE"><i class="icon iconfont webadd"></i> <span translate="backApp.product.home.createLabel">Create new product</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button></span></div></form></div></div><div class="table-responsive pad-left-15 pad-right-15 mar-top-20"><table class="za-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="fw8"><span data-translate="backApp.product.name">Name</span></th><th class="fw8"><span data-translate="backApp.product.number">number</span></th><th class="fw8"><span data-translate="backApp.product.category">categorys</span></th><th class="fw8"><span data-translate="backApp.product.prototype">prototype</span></th><th class="fw8"><span data-translate="backApp.product.coverImg">coverImg</span></th><th class="fw8"><span data-translate="backApp.product.bokeh">bokeh</span></th><th class="fw8"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by product.id"><td>{{product.name}}</td><td>{{product.number}}</td><td>{{product.categoryStoreName}}</td><td data-translate="{{\'backApp.product.prototypes.\' + product.prototype}}">{{product.prototype}}</td><td ng-click="goToReadImage(domain + product.coverImg+\'?imageMogr2/auto-orient\')"><img class="picture-border" alt="\u56FE\u7247\u7F3A\u5931" ng-if="domain" ng-src="{{domain + product.coverImg}}?imageMogr2/interlace/1/thumbnail/400x400>"></td><td>{{product.bokehType==\'None\'?"\u5426":"\u662F"}}</td><td style="width: 200px; max-width: 200px; min-width: 200px"><button class="status-btn" type="submit" ui-sref="product-detail({id:product.id})"><i class="icon iconfont webchakan"></i>\u67E5\u770B</button> <button class="status-btn" type="submit" ui-sref="product.edit({id:product.id})" ng-if="product.prototype!=\'StoreSelf\'"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button class="status-btn" type="submit" ui-sref="product.edit2({id:product.id})" ng-if="product.prototype==\'StoreSelf\'"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button class="status-btn" type="submit" ng-click="delete(product.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div><div class="origin-image hide1"><div class="origin-wrap" ng-click="clickToHide()" onmousewheel="return bbimg(this)"><img id="origin-pic" onmousedown="moveImgStart(event)"><div class="text-align-center mar-top-30" id="back-btn"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="clickToHide()"><span translate="entity.action.backTo">back</span></button></div></div></div>');
$templateCache.put('app/entities/product-analysis/product-analysis.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u5546\u6237 /<span class="breadcrumb-normal-step"> \u5546\u54C1\u7EDF\u8BA1</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"><div style="margin-right: 20px;width: 325px;float: left"><span class="filter-text">\u4E0B\u5355\u65F6\u95F4\uFF1A</span><div><div class="c-form-div clearfix" style="width: 450px"><input class="c-input1" type="text" name="startTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.startDate" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" style="width: 150px; float: left" placeholder="\u5F00\u59CB\u65F6\u95F4"> <span style="display: inline-block; width: 20px; text-align: center; float: left; line-height: 35px">\u81F3</span> <input class="c-input1" type="text" name="endTime" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endDate" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" style="width: 150px; float: left" placeholder="\u7ED3\u675F\u65F6\u95F4"></div></div></div><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u5546\u54C1\uFF1A</span><div><select style="width: 85%" class="form-control border-radius" ng-model="vm.product" ng-options="item.name for item in vm.products" ng-change="productChange()"><option value="">\u5168\u90E8</option></select></div></div><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u6A21\u677F\uFF1A</span><div><select style="width: 85%" class="form-control border-radius" ng-model="vm.data.productXmlId" ng-options="item.id as item.name for item in vm.productXmlsAll"><option value="">\u5168\u90E8</option></select></div></div><div style="margin-right: 20px;width: 200px;float: left"><span class="filter-text">\u7F16\u8F91\u5668\uFF1A</span><div><select style="width: 85%" class="form-control border-radius" ng-model="vm.data.editorType" ng-options="item.id as item.name for item in vm.editorTypes"><option value="">\u5168\u90E8</option></select></div></div></div><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr><th style="width: 100px"><span>\u6392\u5E8F</span></th><th><span>\u5546\u54C1\u540D\u79F0</span></th><th><span>\u5173\u8054\u6A21\u677F</span></th><th><span>\u6A21\u677F\u9875\u6570</span></th><th><span>\u8BA2\u5355\u6570\u91CF</span></th><th><span>\u603B\u9875\u6570</span></th><th><span>\u6240\u5C5E\u7F16\u8F91\u5668</span></th><th><span>\u6D41\u91CF\u8BA1\u8D39</span></th></tr></thead><tbody><tr ng-repeat="item in vm.tableData"><td>{{$index+1}}</td><td>{{item.productName}}</td><td>{{item.productXmlName}}</td><td>{{item.xmlPage}}</td><td>{{item.orderNum}}</td><td>{{item.total}}</td><td>{{vm.editorTypeStatus(item.editorType)}}</td><td>{{item.price}}</td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/product-xml/product-xml-batch-edit.html','<form name="editForm" role="form" novalidate class="listBGC listCreate pad-0" style="min-height: 250px;min-width: 700px"><div class="modal-detail"><h4 class="modal-title" translate="editorApp.page.save">save</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.category" for="field_category" style="padding-right: 26px!important">Category</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" id="field_category" name="field_category" ng-model="vm.categoryId" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option value="{{category.name}}"></option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.themeClassify" for="field_name">themeClassify</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_name" ng-model="vm.themeId" ng-options="themeClassify.id as themeClassify.name for themeClassify in vm.themeClassifyList"></select></div></div></div><!--  <div class="col-lg-10 col-sm-10 form-group">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" for="type">\u5B9A\u5236\u7C7B\u578B</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <select class="form-control" name="type" id="type" ng-model="vm.type"  ng-change="typeChage()">\n                            <option value="Custom" data-translate="editorApp.page.customType.Custom">Custom</option>\n                            <option value="Currency" data-translate="editorApp.page.customType.Currency">Currency</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="col-lg-10 col-sm-10 form-group" ng-if="vm.type == \'Custom\' ">\n                <div class="form-group">\n                    <label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="editorApp.page.customStore" for="customStore">customStore</label>\n                    <div class="col-md-9 col-sm-9 col-xs-9">\n                        <select class="form-control" name="field_name" ng-model="vm.customStoreId" ng-change="customStoreChange()" ng-options="store.id as store.name for store in vm.stores">\n                        </select>\n                    </div>\n                </div>\n            </div> --></div></div><div class="modal-footer"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button> <button type="button" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span>\u4FDD\u5B58\u8BBE\u7F6E</span></button></div></form>');
$templateCache.put('app/entities/product-xml/product-xml-cancel-article.html','<form name="editForm" role="form" novalidate class="listBGC listCreate pad-0" style="min-height: 250px;min-width: 700px"><div class="modal-detail"><h4 class="modal-title">\u63D0\u793A</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group">\u662F\u5426\u786E\u8BA4\u4F5C\u5E9F\u5F53\u524D\u65F6\u95F4\u4E4B\u524D\u7684\u6240\u6709\u4F5C\u54C1\uFF1F<br>\u6CE8:\u7528\u6237\u7684\u4F5C\u54C1\u88AB\u4F5C\u5E9F\u5C06\u5931\u6548\u65E0\u6CD5\u5236\u4F5C\uFF0C\u91CD\u65B0\u5236\u4F5C\u7684\u4F5C\u54C1\u6B63\u5E38\u7F16\u8F91\u4E0B\u5355\u3002</div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span>\u53D6\u6D88</span></button> <button type="button" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span>\u786E\u8BA4</span></button></div></form>');
$templateCache.put('app/entities/product-xml/product-xml-simple.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span translate="editorApp.productXml.home.simple">simple</span></div></div></div><div class="modal-body"><div class="modal-body-scroll scrollbar-main"><div class="col-lg-12 col-sm-12 form-group"><label class="control-label2" translate="editorApp.productXml.showPic" for="showPic">showPic</label><div class=""><div ng-class="{true:\'checkbox-0\',false:\'checkbox-1\'}[vm.productXml.showPic]" class="checkbox-icon float-left" ng-click="vm.showPicCheck(false)"></div><div ng-click="vm.showPicCheck(false)" class="checkbox-icon float-left mar-left-10">\u5426</div><div ng-class="{true:\'checkbox-1\',false:\'checkbox-0\'}[vm.productXml.showPic]" class="checkbox-icon float-left" ng-click="vm.showPicCheck(true)" style="margin-left: 30px"></div><span ng-click="vm.showPicCheck(true)" class="checkbox-icon float-left mar-left-10">\u662F</span></div></div><div class="col-lg-12 col-sm-12 form-group"><button style="border-radius: 16px" class="btn btn-primary btn-save btn-info" ng-click="load()">\u91CD\u8F7D\u6A21\u677F\u6837\u4F8B\u56FE</button></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="editorApp.productXml.documentPic" for="showPic">showPic</label><div class="col-md-10 col-sm-10 col-xs-10"><div class="col-md-3 col-sm-3 col-xs-3" ng-repeat="pic in vm.productXml.documentPics |orderBy:\'seq\'" ng-if="!pic.deleted && !pic.cancelled"><span style="color: red; position: relative; top: 20px; left: 87px" ng-click="deletePic(pic)">X</span> <span style="color: red; position: relative;top: 20px;left: -9px" ng-show="pic.added">\u65B0\u589E</span> <img style="width: 100px; height: 136px; border: 1px dashed #c1c1c1" ng-src="{{pic.identifier +\'?imageView2\'}}"> <input class="form-control border-radius text-center no-padding" style="width: 100px; height: 30px;font-size: 12px" placeholder="\u8F93\u5165\u5C55\u793A\u987A\u5E8F" ng-model="pic.seq"></div><div class="col-md-3 col-sm-3 col-xs-3"><div style="height: 136px; width:100px ;border: 1px dashed #c1c1c1;text-align: center; padding-top: 35px; margin-top: 18px"><input onchange="uploadPic(event)" id="uploadImg2" type="file" multiple="multiple" accept="image/*" name="file" value="" style="opacity: 0; position: absolute; top: 0; left: 18px; font-size: 100px; z-index: 1"> <img src="content/images/icon/add.png"><br><span>\u6DFB\u52A0\u7167\u7247</span><br><span style="color: #8A8A8A; font-size: 10px">(\u8BF7\u6309\u7167\u987A\u5E8F\u6DFB\u52A0)</span></div></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/product-xml/product-xml-version.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u6A21\u677F\u5347\u7EA7</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body"><div style="text-align: center">\u8BF7\u9009\u62E9\u6A21\u677F\u4EA7\u54C1\u7C7B\u578B</div><div style="display: flex; justify-content: center; margin-top: 20px"><div class="step-body-1-view-content-li" ng-repeat="item in vm.productList" ng-class="{\'step-body-1-view-content-li-select\' : item.id == vm.productList[vm.productSeq].id}" ng-click="productCb($index)">{{item.name}}</div></div><div style="display: flex; justify-content: center;align-items: center; margin: 20px 0" ng-if="vm.productList[vm.productSeq].id == \'BOOK\'">\u662F\u5426\u6709\u5C01\u9762\uFF1A<input type="checkbox" name="isCover" id="isCover" ng-model="vm.isCover" style="margin: 0;width: 20px"></div><div class="swiper-container" style="height: 300px;background-color: #ececec"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="page in vm.pages track by $index" style="display: flex;align-items: center;justify-content: center"><img ng-src="{{page.pagecover.identifier}}" style="max-width: 100%;max-height: 100%"></div></div><div class="swiper-button-next swiper-button-black"></div><div class="swiper-button-prev swiper-button-black"></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.step-body-1-view-content-li{\n        padding: 0 15px;\n        height: 35px;\n        border: 1px solid #ddd;\n        color: #333;\n        border-radius: 3px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n        margin: 0 10px 10px 0;\n        cursor: pointer;\n    }\n    .step-body-1-view-content-li:hover{\n        color: #ff6c5f;\n    }\n    .step-body-1-view-content-li-select{\n        background: #ff6c5f;\n        color: #fff !important;\n        border: 1px solid #ff6c5f;\n    }\n    .modal-content{\n        box-shadow: none;\n    }</style>');
$templateCache.put('app/entities/product-xml/product-xmls.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span translate="global.menu.entities.productXml">productXml</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"></div><div class="overflow-h mar-top-20" style="min-height: 32px"><span class="input-group-btn width-min btn-clear"><button class="btn btn-new-padding mar-left-10 btn-batch" ng-click="batchEdit()" ng-show="canEdit"><span>\u6279\u91CF\u7F16\u8F91</span></button> <button class="btn btn-new-padding mar-left-10 btn-batch" ng-click="batchUpdateSize()" ng-show="canEdit"><span>\u6279\u91CF\u83B7\u53D6\u5C3A\u5BF8</span></button> <button class="btn btn-new-padding mar-left-10 btn-batch" ng-click="batchUpdateCountTip()" ng-show="canEdit"><span>\u6279\u91CF\u83B7\u53D6\u7167\u7247\u6570</span></button> <button class="btn btn-new-padding mar-left-10 btn-batch" ng-click="batchApprove(\'Approved\')" ng-show="canApprove"><span>\u6279\u91CF\u901A\u8FC7</span></button> <button class="btn btn-new-padding mar-left-10 btn-batch" ng-click="batchApprove(\'Rejected\')" ng-show="canApprove"><span>\u6279\u91CF\u62D2\u7EDD</span></button> <button class="btn btn-new-padding mar-left-10 btn-batch" ng-click="batchDelete()" ng-show="canCancel"><span>\u6279\u91CF\u5220\u9664</span></button></span><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr style="font-weight: bold"><th class="fw4 border-bottom"><i class="choose-list" ng-show="!selectAll" ng-click="chooseAll()"></i> <i class="choose-sel-all" ng-show="selectAll" ng-click="chooseAll()"></i></th><th><span>\u7F16\u53F7</span></th><th><span data-translate="editorApp.productXml.name">Name</span></th><th><span data-translate="editorApp.productXml.status">status</span></th><th><span data-translate="editorApp.productXml.category">category</span></th><th><span data-translate="editorApp.productXml.themeClassify">theme</span></th><th><span data-translate="editorApp.productXml.type">type</span></th><th><span data-translate="editorApp.page.catalogName">catalogName</span></th><th><span data-translate="editorApp.page.xmlType">xmlType</span></th><th><span>\u9ED8\u8BA4\u5165\u518C\u6570</span> <img class="sign-img" src="content/images/notes.png" uib-tooltip="\u4E0D\u5F00\u542F\u5907\u7528\u9875\u66FF\u6362\uFF0C\u6A21\u677F\u9ED8\u8BA4\u9875\u53EF\u4E0A\u4F20\u7684\u7167\u7247\u6570\u91CF" tooltip-placement="right"></th><th><span>\u6781\u9650\u5165\u518C\u6570</span> <img class="sign-img" src="content/images/notes.png" uib-tooltip="\u5F00\u542F\u5907\u7528\u9875\u66FF\u6362\uFF0C\u6A21\u677F\u53EF\u4E0A\u4F20\u7684\u6700\u5C11\u7167\u7247\u6570\u91CF\u4EE5\u53CA\u6700\u591A\u7167\u7247\u6570\u91CF" tooltip-placement="right"></th><th><span>\u753B\u5E03\u5C3A\u5BF8</span></th><th style="width: 68px"><span>\u9875\u6570</span></th><th><span>\u4E0A\u4F20\u65E5\u671F</span></th><th style="width: 150px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="productXml in vm.productXmls track by productXml.id"><td><i class="choose-li" ng-click="chooseOne(productXml)" ng-show="!productXml.select"></i> <i class="choose-sel" ng-click="chooseOne(productXml)" ng-show="productXml.select"></i></td><td style="display: table-cell; vertical-align: middle">{{productXml.number}}</td><td style="display: table-cell; vertical-align: middle">{{productXml.name}}</td><td style="display: table-cell; vertical-align: middle" data-translate="{{\'editorApp.productXml.statusType.\' + productXml.status}}">{{productXml.status}}</td><td style="display: table-cell; vertical-align: middle">{{productXml.categoryName}}</td><td class="vertical-middle"><div class="slh width-100p text-center" style="width: 180px; max-width: 180px; min-width: 180px;padding-left: 10px" uib-tooltip="{{themeClassifie(productXml)}}" tooltip-placement="top"><span ng-repeat="item in productXml.themeClassifies">{{item.name}}<span ng-if="!$last">;</span></span></div></td><td style="display: table-cell; vertical-align: middle" data-translate="{{\'editorApp.productXml.customType.\' + productXml.type}}">{{productXml.type}}</td><td style="display: table-cell; vertical-align: middle">{{productXml.productName}}</td><td style="display: table-cell; vertical-align: middle" data-translate="{{\'editorApp.page.xmlTypes.\' + productXml.xmlType}}">{{productXml.xmlType}}</td><td class="vertical-middle">{{productXml.picQuantity}}\u5F20</td><td class="vertical-middle"><span ng-if="productXml.minPicQuantity!= productXml.maxPicQuantity">{{productXml.minPicQuantity}}~~{{productXml.maxPicQuantity}}\u5F20</span> <span ng-if="productXml.minPicQuantity == productXml.maxPicQuantity">{{productXml.minPicQuantity}}\u5F20</span></td><td class="vertical-middle">{{productXml.pageSizeW }}*{{productXml.pageSizeH}}</td><td class="vertical-middle">{{productXml.pageCount}}</td><td>{{productXml.createdDate | date:\'yyyy-MM-dd\' }}</td><td style="width: 260px; max-width: 260px; min-width: 200px"><button class="status-btn" type="submit" ng-click="version(productXml.id)" ng-if="!productXml.version"><i class="icon iconfont webshengji"></i> <span class="hover-span">\u5347\u7EA7</span></button> <button class="status-btn" type="submit" ng-click="confirmName(productXml.id)" ng-if="productXml.version"><i class="icon iconfont webxiugai"></i> <span class="hover-span">\u7F16\u8F91</span></button> <button class="status-btn" type="submit" ng-if="productXml.version && (productXml.status == \'Created\' || productXml.status == null)" ng-click="approve(productXml, \'Approved\')"><i class="icon iconfont webai53"></i> <span class="hover-span">\u901A\u8FC7</span></button> <button class="status-btn" type="submit" ng-if="productXml.version && (productXml.status == \'Created\' || productXml.status == null)" ng-click="approve(productXml, \'Rejected\')"><i class="icon iconfont webRectangleCopy"></i> <span class="hover-span">\u62D2\u7EDD</span></button> <button class="status-btn" type="submit" ng-if="productXml.version && productXml.status == \'Approved\'" ng-click="updateProductXmls(productXml)"><i class="icon iconfont webshuaxin"></i> <span class="hover-span">\u66F4\u65B0</span></button> <button class="status-btn" type="submit" ui-sref="product-xml-simple({id:productXml.id})" ng-if="productXml.version"><i class="icon iconfont webyangbenxinxidanshouyangtupian"></i> <span class="hover-span">\u6837\u56FE</span></button> <button class="status-btn" type="submit" ng-click="delete(productXml.id)"><i class="icon iconfont webshanchu"></i> <span class="hover-span">\u5220\u9664</span></button> <button ng-if="productXml.status == \'Approved\'" class="status-btn" type="submit" ng-click="cancelArticle(productXml.id)"><i class="icon iconfont weba-YQH_zuofeizuofeijilu"></i> <span class="hover-span" style="width: 60px !important;margin-left: -26px">\u4F5C\u5E9F\u4F5C\u54C1</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/product-xml/update-product-xml.html','<div><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u540C\u6E90\u6A21\u677F\u66F4\u65B0</span></div></div></div><div class="modal-body" style="margin-top: 0;max-height: 400px"><div class="modal-body-scroll1 scrollbar-main"><table class="jh-table table table-striped"><thead class="table-thead"><tr><th><span>\u9009\u62E9</span></th><th><span data-translate="editorApp.productXml.name">Name</span></th><th><span>\u7F16\u53F7</span></th><th><span data-translate="editorApp.productXml.category">category</span></th><th><span>\u6A21\u677F\u5C3A\u5BF8</span></th><th><span>\u4E0A\u4F20\u65F6\u95F4</span></th></tr><tbody class="table-tbody"><tr ng-repeat="productXml in vm.productXmls track by $index"><td><i class="choose-li" ng-click="chooseOne(productXml)" ng-show="!productXml.select"></i> <i class="choose-sel" ng-click="chooseOne(productXml)" ng-show="productXml.select"></i></td><td class="vertical-middle">{{productXml.name}}</td><td class="vertical-middle">{{productXml.number}}</td><td class="vertical-middle">{{productXml.categoryName}}</td><td class="vertical-middle">{{productXml.pageSizeW }}*{{productXml.pageSizeH}}</td><td>{{productXml.createdDate | date:\'yyyy-MM-dd\' }}</td></tr></tbody></thead></table></div></div><div class="modal-footer" style="text-align: right; position: unset"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()" style="border-radius: 5px;color: #888888;border: 1px solid #e5e5e5;background: #f0f0f0"><span>\u53D6\u6D88</span></button> <button type="button" ng-click="confirm()" class="small-btn-normal" style="border-radius: 5px"><span>\u786E\u8BA4</span></button></div></div><style>.modal-body-scroll1{\n        overflow: auto;\n        height: 100%;\n    }</style>');
$templateCache.put('app/entities/property/properties.html','<div class="listBGC"><div class="current-location"><div><span translate="global.menu.current-location">\u5F53\u524D\u4F4D\u7F6E:</span> <span translate="global.menu.entities.property" class="current-menu">property</span></div></div><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'backApp.property.home.search\' | translate }}"> <span class="input-group-btn width-min btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.currentSearch"><button class="btn btn-info btn-new-padding" ng-click="vm.clear()"><span translate="global.form.clear"></span></button></span></div></form></div><span class="input-group-btn width-min btn-clear" ui-sref="property.new"><button class="btn btn-info btn-new-padding"><span translate="backApp.property.home.createLabel">Create new Property</span></button></span></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span translate="backApp.property.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="alias"><span translate="backApp.property.alias">alias</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="property in vm.properties track by property.id"><td style="display: table-cell; vertical-align: middle">{{property.name}}</td><td style="display: table-cell; vertical-align: middle">{{property.alias}}</td><td class="text-right"><button type="submit" ui-sref="property-detail({id:property.id})" class="btn-sub btn1"><span class="glyphicon btn-check"></span><p class="hover-box">\u67E5\u770B</p></button> <button type="submit" ui-sref="property.edit({id:property.id})" class="btn-sub btn2"><span class="btn-edit"></span><p class="hover-box">\u7F16\u8F91</p></button> <button type="submit" ng-click="delete(property.id)" class="btn-sub btn1"><span class="btn-del"></span><p class="hover-box">\u5220\u9664</p></button></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/property/property-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.property.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="backApp.property.delete.question" translate-values="{id: \'{{vm.property.id}}\'}">Are you sure you want to delete this Property?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/property/property-detail.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="backApp.property.detail.title">property</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="backApp.property.name">Name</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.property.name}}</div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="backApp.property.alias">alias</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.property.alias}}</div></div></div><div class="col-lg-12 col-sm-12 form-group property-value"><div translate="backApp.property.value" style="width: 10%;text-align: right">value</div><div style="width: 75%;margin-left: 15px"><span ng-repeat="value in vm.property.propertyValues track by $index" ng-if="!value.cancelled" class="property-span">{{value.value}}</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-cancel" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/property/property-dialog.html','<form name="editForm" role="form" novalidate class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" id="myPropertyLabel" translate="backApp.property.home.createOrEditLabel">Create or edit a property</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.property.name" for="field_name">Name</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control border-radius" name="field_name" id="field_name" ng-model="vm.property.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.property.alias" for="field_alias">alias</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control border-radius" name="field_alias" id="field_alias" ng-model="vm.property.alias" placeholder="\u8BF7\u8F93\u5165\u522B\u540D" maxlength="20"></div></div></div><div class="col-lg-6 col-sm-6 form-group mar-bottom-0 col-lg-offset-6 col-sm-offset-6"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.property.value" for="field_value">value</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control border-radius" onkeydown="addPropertys()" name="field_name" id="field_value" ng-model="vm.property.value" placeholder="\u56DE\u8F66\u6DFB\u52A0\u5C5E\u6027\u503C"></div></div></div><div class="col-lg-10 col-sm-10 form-group" style="margin-left: 10%"><!--<span class="col-md-3 col-sm-3 col-xs-3"></span>--> <span class="property-span" ng-repeat="value in vm.property.propertyValues track by $index" ng-if="!value.cancelled">{{value.value}}&nbsp; <img src="content/images/icon/closno@2x.png" ng-click="deleteValue(value)"></span></div><span class="col-md-2 col-sm-2 col-xs-2"></span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-info btn-save" onmousedown="save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></form>');
$templateCache.put('app/entities/property-commercial/add-property-value.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u6DFB\u52A0\u5DF2\u5220\u9664\u7684\u5C5E\u6027\u503C</div><button aria-label="Close" data-dismiss="modal" class="close lh35" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding: 20px;max-height: 400px;overflow: auto"><div class="table-responsive"><table class="za-table table" style="margin-bottom: 0"><thead><tr><th style="width: 60px"><i class="choose-list" ng-show="!vm.allChecked" ng-click="vm.toggleAll()"></i> <i class="choose-sel-all" ng-show="vm.allChecked" ng-click="vm.toggleAll()"></i></th><th>\u540D\u79F0</th></tr></thead><tbody><tr ng-repeat="item in vm.delList track by $index"><td><i class="choose-li" ng-show="!item.selected" ng-click="vm.toggleItem(item)"></i> <i class="choose-sel" ng-show="item.selected" ng-click="vm.toggleItem(item)"></i></td><td style="display: table-cell; vertical-align: middle">{{item.value}}</td></tr><tr ng-if="!vm.delList.length"><td colspan="2" style="text-align: center; padding: 30px; color: #999">\u6682\u65E0\u5DF2\u5220\u9664\u7684\u5C5E\u6027\u503C</td></tr></tbody></table></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="oval-btn-normal" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="oval-btn-normal-empty" ng-click="cancel()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/entities/property-commercial/properties.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u54C1 / <span>\u5546\u54C1\u89C4\u683C</span></div><div class="con"><div class="overflow-h"><div class="float-left"><button class="oval-btn-normal" ui-sref="propertyCommercialNew"><i class="icon iconfont webadd"></i> <span translate="platformApp.property.home.createLabel">Create new Property</span></button> <button class="oval-btn-normal2" ng-click="deleteBatch()" ng-show="selectOne"><span>\u6279\u91CF\u5220\u9664</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'platformApp.property.home.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.currentSearch"><button class="btn btn-new-padding" ng-click="vm.clear()"><span translate="global.form.clear"></span></button></span></div></form></div></div><div class="table-responsive pad-left-15 pad-right-15 mar-top-20"><table class="za-table table"><thead class=""><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width: 100px"><i class="choose-list" ng-show="!selectAll" ng-click="chooseAll()"></i> <i class="choose-sel-all" ng-show="selectAll" ng-click="chooseAll()"></i></th><th><span translate="platformApp.property.name">Name</span></th><th><span translate="platformApp.property.alias">alias</span></th><!--<th jh-sort-by="propertyType"><span translate="platformApp.property.propertyType">propertyType</span> <span class="glyphicon glyphicon-sort"></span></th>--><th style="width: 200px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class=""><tr ng-repeat="property in vm.properties track by property.id"><td><i class="choose-li" ng-click="chooseOne(property)" ng-show="!property.select"></i> <i class="choose-sel" ng-click="chooseOne(property)" ng-show="property.select"></i></td><td style="display: table-cell; vertical-align: middle">{{property.name}}</td><td style="display: table-cell; vertical-align: middle">{{property.alias}}</td><td class=""><button class="status-btn" type="submit" ui-sref="propertyCommercialEdit({id:property.id})"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91<!--                                <span class="hover-span">\u7F16\u8F91</span>--></button> <button class="status-btn" type="submit" ng-click="delete(property.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664<!--                                <span class="hover-span">\u5220\u9664</span>--></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination><!--<div class="text-jump">--><!--<span translate="global.page.goto">Go to</span>--><!--<input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onKeyUp="value=value.replace(/[^\\d]/g,\'\')"/>--><!--<span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span>--><!--</div>--></div></div>');
$templateCache.put('app/entities/property-commercial/property-dialog.html','<div class="listBGC"><div class="breadcrumb-normal"><span translate="platformApp.property.detail.title">\u5546\u54C1\u89C4\u683C</span> / <span>\u89C4\u683C{{vm.title | translate}}</span></div><div class="con"><div style="display: flex"><div><div class="c-form"><div class="c-form-label" translate="platformApp.property.proName">\u89C4\u683C\u540D\u79F0\uFF1A</div><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.property.name" placeholder="{{\'platformApp.property.proNamePlaceholder\' | translate}}" maxlength="20"> <i class="iconfont webduoyuyan language" ng-click="vm.multilingual(\'propertyLanguages\',\'name\',(\'platformApp.property.proName\' | translate))"></i></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.property.proAlias">\u89C4\u683C\u522B\u540D\uFF1A</div><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.property.alias" placeholder="{{\'platformApp.property.proAliasPlaceholder\' | translate}}" maxlength="20"></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.property.proType">propertyType\uFF1A</div><div class="c-form-div" ng-if="!vm.property.id"><select class="c-select1" name="type" id="type" ng-model="vm.property.propertyType"><option value="Default" data-translate="platformApp.property.PropertyType.Default">Default</option><!--<option value="Expanded" data-translate="platformApp.property.PropertyType.Expanded">Expanded</option>--></select></div><div class="c-form-div" ng-if="!!vm.property.id"><span translate="{{\'platformApp.property.PropertyType.\'+ vm.property.propertyType}}">{{vm.property.propertyType}}</span></div></div></div><!-- \u5DE5\u827A\u89C4\u683C --><div style="margin-left: 100px"><div class="c-form"><div class="c-form-label" translate="platformApp.property.processSpec">\u5DE5\u827A\u89C4\u683C\uFF1A</div><div class="c-form-div c-form-div-center"><label class="i-switch"><input type="checkbox" ng-model="vm.property.process" ng-change="processEnableChange()" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="c-form" ng-if="vm.property.process"><div class="c-form-label" translate="platformApp.property.processSpec">\u5DE5\u827A\u89C4\u683C\uFF1A</div><div class="c-form-div"><select class="form-control border-radius" ng-model="vm.property.processOperationId" ng-change="processOperationChange()" ng-options="process.id as process.name for process in vm.processOperationList"><option value="" translate="platformApp.property.selectProcess">\u8BF7\u9009\u62E9\u5DE5\u827A</option></select></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.property.specImage">\u89C4\u683C\u56FE\u7247\uFF1A</div><div class="c-form-div c-form-div-center"><label class="i-switch"><input type="checkbox" ng-model="vm.property.showImg" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div></div></div><div class="c-form"><div class="c-form-label" translate="platformApp.property.proList">\u89C4\u683C\u5217\u8868</div><div class="c-form-div" style="width: auto"><div class="c-table1"><table class="za-table table"><thead class=""><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span translate="platformApp.property.id">\u5E8F\u53F7</span></th><th><span translate="platformApp.property.name">\u5C5E\u6027\u503C</span></th><th ng-if="vm.property.showImg"><span translate="platformApp.property.specImageShort">\u89C4\u683C\u56FE\u7247</span></th><th style="width: 200px"><span translate="global.field.operate">\u64CD\u4F5C</span></th></tr></thead><tbody class=""><tr ng-repeat="value in vm.property.propertyValues track by $index" style="height: 70px" ng-if="!value.cancelled"><td style="width: 100px">{{$index+1}}</td><td style="height: 100%"><input type="text" class="c-input1" ng-model="value.value" placeholder="{{\'platformApp.property.proValuePlaceholder\' | translate}}" maxlength="20" style="width: 80%"> <i class="iconfont webduoyuyan" ng-click="vm.multilingual(\'propertyValueLanguages\',\'value\',(\'platformApp.property.name\' | translate),$index)"></i></td><td ng-if="vm.property.showImg" style="width: 100px;min-width:100px; max-width: 100px;position: relative"><div class="btn_addPic" ng-if="!value.img" style="width: 90px; height: 90px"><a class="upload-text" ng-if="!value.img" style="top:30%" translate="platformApp.property.pleaseUpload">\u8BF7\u4E0A\u4F20</a> <input ng-if="!value.img" type="file" name="file" class="filePrew" ng-mousedown="vm.uploadTarget = value" onchange="xmlLineImgFile(event)" style="outline: none; margin-top: 2px; padding: 2px;opacity: 0;filter:alpha(opacity=0)" accept="image/jpeg, image/png"></div><span ng-if="!!value.img" style="margin-top: 0px"><img class="picture-border" style="width: 76px; height: 60px" ng-src="{{value.img}}?imageMogr2/interlace/1/thumbnail/400x400>" ng-click="goToReadImage(value.img+\'?imageMogr2/auto-orient\')"> <i class="glyphicon glyphicon-remove" ng-click="removeFile2(value)" style="color: red"></i></span></td><td style="height: 100%"><span ng-click="deleteValue(value)" class="btn-text" translate="entity.action.delete">\u5220\u9664</span></td></tr></tbody></table><div class="table-btn" ng-click="addValue()" ng-if="!vm.property.process || vm.showAddBtn"><span class="red-btn-add"></span> <span class="hidden-xs text-add" translate="platformApp.property.addCombination">\u65B0\u589E\u7EC4\u5408</span></div></div></div></div><div class="c-form"><div class="c-form-label"></div><div class="c-form-div"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div></div></div>');
$templateCache.put('app/entities/recommend-pic/recommend-pic-dialog.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u65B0\u589E/\u7F16\u8F91\u56FE\u7247</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u63A8\u8350\u5206\u7C7B</label><div class=""><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.data.themeClassifyId" ng-options="item.id as item.name for item in vm.setting | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9\u63A8\u8350\u5206\u7C7B</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u6392\u5E8F</label><div class=""><input type="number" class="form-control border-radius5" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F" ng-model="vm.data.seq" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<=0)value=null"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u56FE\u7247</label><div class="" ng-if="!vm.data.id" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start"><div class="btn_addPic"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" multiple="multiple" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><div ng-repeat="item in vm.attachments track by $index" style="position: relative; display: inline-block; text-align: center"><img style="width: 100px; height: 100px; object-fit: cover; border: 1px dashed #ccc; display: block" ng-src="{{domain + item.identifier +\'?imageView2/0/w/100/h/100\'}}"> <span style="display: block; font-size: 12px; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top: 4px">{{item.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(item,$index)" style="position: absolute; top: -8px; right: -8px; color: red; cursor: pointer; background: #fff; border-radius: 50%; padding: 2px"></i></div></div><div class="" ng-if="!!vm.data.id"><img style="width: 100px;  border: 1px dashed red" ng-src="{{domain + vm.data.identifier +\'?imageView2/0/w/100/h/100\'}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.cancel()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/recommend-pic/recommend-pic.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u63A8\u8350\u56FE\u7247</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ng-click="add()"><i class="icon iconfont webadd"></i> <span>\u4E0A\u4F20\u63A8\u8350</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="c-form pull-left" style="position: relative;left: -20px"><label class="c-form-label">\u5206\u7C7B</label><div class="c-form-div" style="width: 120px"><select ng-model="vm.themeClassifyId" ng-change="vm.transition()" class="c-select1" ng-options="c.id as c.name for c in vm.class"><option value="">\u5168\u90E8\u5206\u7C7B</option></select></div></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><div class="pic-geometry" ng-repeat="data in vm.data track by data.id"><div class="pic-model"><div><img ng-src="{{domain + data.identifier+\'?imageView2/0/w/100/h/100\'}}"></div></div><div style="padding-top:7px">{{data.themeClassifyName}}</div><div class="pic-edit"><button ng-click="edit(data)" style="color: #ffffff; top: 20%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button ng-click="delete(data.id)" style="color: #ffffff; top: 40%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></div></div></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/role/role-detail.html','<div class="listBGC" style="min-width: 1300px"><div class="current-location"><div class="table-title"><span translate="global.menu.entities.role" class="current-nav-active current-nav">role</span></div></div><form ng-show="!vm.success" name="form" role="form" ng-submit="vm.save()" novalidate show-validation><div class="container-fluid model-detail-titel"><span translate="backApp.role.home.createOrEditLabel" class="current-title"></span></div><div class="modal-body" style="background-color: white;min-height: 530px;padding-left: 100px"><div class="panel-body"><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label pad-0 text-right" translate="backApp.role.name2">name</label><div class="col-md-4 col-sm-4 col-xs-4">{{vm.role.name}}</div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><table class="jh-table table table-striped main-table"><tr ng-repeat="mod in vm.mods track by $index"><td class="fw8" style="border-right: 1px solid rgb(217, 217, 217)">{{mod.module}}</td><td><div class="col-md-3 col-sm-3 col-xs-3 text-left" style="padding-top: 10px" ng-repeat="au in mod.authorities track by $index">{{au.name}}</div></td></tr></table></div></div></div><div class="" style="padding-top:20px; text-align:left"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></form></div>');
$templateCache.put('app/entities/role/role-dialog.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="mar-top-24 mar-bottom-10"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A<a ui-sref="role">\u89D2\u8272\u7BA1\u7406</a>/\u89D2\u8272{{vm.title}}</span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label" translate="backApp.role.name">name</label><div class="col-md-8 col-sm-8 col-xs-8"><input type="text" class="form-control border-radius" ng-model="vm.role.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20 pad-0"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label pad-0 text-right" for="field_type">\u6743\u9650</label><div class="col-md-8"><table class="za-table table table-striped"><tr ng-repeat="mod in vm.mods track by $index"><td class="fw8" style="border-right: 1px solid rgb(217, 217, 217)"><i class="choose-li" ng-click="chooseMod(mod)" ng-show="!mod.selected"></i> <i class="choose-sel" ng-click="chooseMod(mod)" ng-show="mod.selected"></i> {{mod.module}}</td><td><div class="col-md-3 col-sm-3 col-xs-3 text-left" ng-repeat="au in mod.authorities track by $index"><i class="choose-li" ng-click="chooseAuthorty(mod, au)" ng-show="!au.selected"></i> <i class="choose-sel" ng-click="chooseAuthorty(mod, au)" ng-show="au.selected"></i> {{au.name}}</div></td></tr></table></div></div></div></div></div><div class="mar-top-10"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div>');
$templateCache.put('app/entities/role/roles.html','<div class="listBGC" style="min-width: 1000px"><span class="breadcrumb-normal">\u5546\u6237 / <span class="breadcrumb-normal-step" translate="global.menu.entities.role">role</span></span><div class="col-lg-12 col-sm-12 pad-0 za-role"><div class="col-lg-3 col-sm-3 pad-0 za-role-left"><div class="col-lg-12 col-sm-12 pad-0 za-role-bar"><div class="za-role-bar-head"><img src="content/images/role.png">\u89D2\u8272\u5217\u8868</div><div class="za-role-bar-list scrollbar-main"><div ng-repeat="role in vm.roles track by role.id" class="za-role-bar-li" ng-click="chooseRole(role)" ng-class="{\'za-role-bar-li-active\':role.id==vm.role.id}"><span>{{role.name}}</span> <img src="content/images/close1.png" ng-click="delete(role.id,$event)"></div></div></div><div class="searchBar2"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.roleName" id="searchQuery2" placeholder="\u8BF7\u8F93\u5165\u89D2\u8272\u540D\u79F0"> <span class="input-group-btn btn-searched"><button class="btn-search2" ng-click="vm.save()">\u6DFB\u52A0</button></span></div></form></div></div><div class="col-lg-9 col-sm-9 za-role-right"><div class="za-role-right-con" ng-if="vm.role"><div class="za-role-bar-head"><img src="content/images/role_2.png">\u6743\u9650\u5217\u8868</div><div class="za-role-right-con-body scrollbar-main"><div class="za-role-right-con-body-list" ng-repeat="mod in vm.mods track by $index"><div class="za-role-right-con-left"><img src="content/images/select.png" width="15" ng-if="!mod.selected" ng-click="chooseMod(mod)"> <img src="content/images/selected.png" width="15" ng-if="mod.selected" ng-click="chooseMod(mod)"> {{mod.module}}</div><div class="za-role-right-con-right"><span class="col-lg-3 col-sm-3" ng-repeat="au in mod.authorities track by $index"><img src="content/images/select.png" width="15" ng-if="!au.selected" ng-click="chooseAuthorty(mod, au)"> <img src="content/images/selected.png" width="15" ng-if="au.selected" ng-click="chooseAuthorty(mod, au)"> {{au.name}}</span></div><div style="clear:both;height:0px"></div></div></div></div><div class="za-role-right-save" ng-if="vm.role"><button class="btn btn-primary width-80" translate="entity.action.ok" ng-click="vm.save2()"></button></div></div></div></div>');
$templateCache.put('app/entities/sales-order/order-view-article.html','<div class="bg view-article" ng-cloak ng-style="{width:getUlW()}"><div class="save-page" ng-cloak><div><img src="content/images/icon/loading.gif"> <span>\u8BF7\u7A0D\u5019</span></div></div><button class="leftBtn" id="bb-nav-prev"><img src="content/images/icon/arrow-left.png"></button> <button class="rightBtn" id="bb-nav-next"><img src="content/images/icon/arrow-right.png"></button><div class="main clearfix" ng-show="vm.bindingtype!=\'None\'&&template.pages.page.length>1"><div class="bb-custom-wrapper bb-bg"><div class="templateView-carousel"><ul rn-carousel="" rn-carousel-index="carouselIndex" rn-carousel-buffered="" class="carouselView5 bb-bookblock" id="bb-bookblock" ng-class="{\'uad-maxwidth\':vm.bindingtype==\'Top\'&&isMaxWidth}" ng-style="{\n                        margin:\'0 auto\',\n                        width:getUlW()}"><li ng-repeat="slide in document.pages track by $index" ng-init="outerIndex = $index" ng-style="{\n                            width:getLiW(slide)}" ng-class="{\'half-width\':vm.bindingtype==\'Left\'&&($last||$first),\n                        \'half-margin\':vm.bindingtype==\'Left\'&&$first,\n                        \'bb-white\':!($first||$last)}" class="bb-item" style="position: relative" is-over="toggle.now" data-index="{{$index}}"><div ng-show="vm.bindingtype==\'Top\'"><div class="bb-custom-img" ng-style="{\n                                position:\'relative\',\n                                overflow:\'hidden\',\n                                opacity:$first?0:1,\n                                \'-ms-filter\': \'alpha(opacity=\'+$first?0:1+\')!important\',\n                                filter:\'alpha(opacity=\'+$first?0:1+\')!important\',\n                                \'margin-top\':slide.spread==true?slide.marginTop:0,\n                                \'margin-bottom\':slide.spread==true?slide.marginTop:0,\n                                width:slide.w1,\n                                height:slide.h1,\n                                background:slide.arr.background.color\n                                }"><!--\u80CC\u666F\u5C42--><div style="overflow:hidden;display: inline-block;background: #fff"><img ng-src="{{slide.arr.bgImg}}" ng-style="{\n                                        position: \'absolute\',\n                                        left:slide.arr.background.offsetx*slide.arr.pageScaleW,\n                                        top:slide.arr.background.offsety*slide.arr.pageScaleH,\n                                        width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                        height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}"></div><div ng-repeat="level in slide.arr.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div class="select-img-box diy-box" style="position: absolute" ng-if="level.imagebox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                        \'z-index\':level.seq-0+200,\n                                        \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                        \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                        \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                        \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,\n                                        \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-box"><img id="imgInput{{outerIndex}}{{$index}}" class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" crossorigin="Anonymous" ng-src="{{level.imagebox.blobUrl}}" ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'" ng-style="{\n                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH}"> <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}" crossorigin="Anonymous" data-imgindex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'" crossorigin="Anonymous" ng-src="{{level.imagebox.blobSmall}}" ng-style="{position:\'absolute\',\n                                                    left:0,\n                                                    top:0,\n                                                    width:level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                    height:level.imagebox.geometry.height*slide.arr.pageScaleH}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-if="level.imageart" data-index="{{$index}}" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.imageart.transparency,\n                                        filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                        \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,\n                                        \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,\n                                        \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,\n                                        \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx*slide.arr.pageScaleW,\n                                                \'top\': level.imageart.offsety*slide.arr.pageScaleH,\n                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background" ng-if="level.textbox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                            top: level.textbox.geometry.y*slide.arr.pageScaleH,\n                                            left: level.textbox.geometry.x*slide.arr.pageScaleW,\n                                            width: level.textbox.geometry.width*slide.arr.pageScaleW,\n                                            height: level.textbox.geometry.height*slide.arr.pageScaleH,\n                                            \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                            \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                            \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                            \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                            \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr.ratio > 12 ? level.textbox.style.size* slide.arr.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.lineheight* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.letterspacing* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                position: \'absolute\',\n                                                width: level.textdocument.geometry.width*slide.arr.pageScaleW,\n                                                height: level.textdocument.geometry.height*slide.arr.pageScaleH,\n                                                left: level.textdocument.geometry.x*slide.arr.pageScaleW,\n                                                top: level.textdocument.geometry.y*slide.arr.pageScaleH,\n                                                \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                     position: \'absolute\',\n                                                     left:level.textdocument.background.offsetx*slide.arr.pageScaleW,\n                                                     top:level.textdocument.background.offsety*slide.arr.pageScaleH,\n                                                     width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr.pageScaleW:\'auto\',\n                                                     height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr.pageScaleH:\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                        width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,\n                                                        height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,\n                                                        left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,\n                                                        top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'opacity\':docLevel.imageart.transparency,\n                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,\n                                                                \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,\n                                                                \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                        \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,\n                                                        \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,\n                                                        \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,\n                                                        \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,\n                                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (docLevel.textbox.style.size*slide.arr.ratio > 12 ? docLevel.textbox.style.size* slide.arr.ratio : 12) + \'pt\',\n                                                        \'color\': docLevel.textbox.style.color,\n                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                        \'opacity\': docLevel.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': docLevel.textbox.style.align,\n                                                        \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr.ratio)+\')\',\n                                                        \'width\':  (docLevel.textbox.style.size* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr.barcode" ng-style="{\n                                     \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,\n                                     \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,\n                                     \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,\n                                     \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,\n                                     \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'\n                                    }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div><div class="fc-calendar-wrap" ng-show="$first" style="overflow:hidden" ng-style="{\n                                        position: \'relative\',\n                                        overflow:\'hidden\',\n                                        \'font-size\': 0,\n                                        \'letter-spacing\': \'-2px\',\n                                        width:slide.w1,\n                                        height:slide.h1,\n                                        background:slide.arr.background.color\n                                    }"><!--\u80CC\u666F\u5C42--> <img ng-if="slide.arr.bgImg" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,\n                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,\n                                             width: slide.arr.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                             height:slide.arr.background.adaptation==\'Height\'?\'100%\':\'auto\'}" class="remove-style background{{outerIndex}} background" ng-src="{{slide.arr.bgImg}}"><div ng-repeat="level in slide.arr.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div class="select-img-box diy-box background{{outerIndex}} background" style="position: absolute" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-if="level.imagebox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,\n                                                \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-box"><img class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-src="{{level.imagebox.blobUrl}}" ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'" ng-style="{\n                                                \'font-size\':\'10px\'}"> <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'" ng-src="{{level.imagebox.blobSmall}}" ng-style="{position:\'absolute\',\n                                                    left:0,\n                                                    top:0,\n                                                    width:level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                    height:level.imagebox.geometry.height*slide.arr.pageScaleH}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-class="{\'leftbo-rotation\': isLeftRotation}" data-index="{{$index}}" ng-if="level.imageart" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background" ng-if="level.textbox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr.ratio > 12 ? level.textbox.style.size* slide.arr.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.lineheight* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.letterspacing* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr.pageScaleW:\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr.pageScaleH:\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.ratio > 12 ? docLevel.textbox.style.size* slide.arr.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr.barcode" ng-style="{\n                                         \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,\n                                         \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,\n                                         \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,\n                                         \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,\n                                         \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div><div class="fc-calendar-wrap" ng-hide="$first||slide.spread==true" ng-style="{\n                                        position: \'relative\',\n                                        overflow:\'hidden\',\n                                        \'font-size\': 0,\n                                        \'letter-spacing\': \'-2px\'\n                                        }" ng-disabled="$last&&slide.arr2==\'\'"><span style="overflow:hidden;display: inline-block" class="background{{outerIndex}} background" ng-style="{\n                                                width:$last||slide.arr2==\'\'?slide.w1:slide.w2,\n                                                height:$last||slide.arr2==\'\'?slide.h1:slide.h2,\n                                                background:slide.arr2.background.color}"><!--\u80CC\u666F\u5C42--> <img class="remove-style" ng-if="slide.arr2.bgImg" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:slide.arr2.background.offsetx*slide.arr2.pageScaleW,\n                                                 top:slide.arr2.background.offsety*slide.arr2.pageScaleH,\n                                                 width: slide.arr2.background.adaptation!=\'Height\'?\'100%\':\'auto\',\n                                                 height:slide.arr2.background.adaptation==\'Height\'?\'100%\':\'auto\'}" ng-src="{{slide.arr2==\'\'?$last?\'\':\'content/images/white.png\':slide.arr2.bgImg}}"></span><div ng-repeat="level in slide.arr2.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div class="select-img-box diy-box background{{outerIndex}} background" style="position: absolute" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-hide="slide.arr2==\'\'&&$last&&!level.imagebox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'width\': level.imagebox.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr2.pageScaleH,\n                                                \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-box"><img class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-src="{{level.imagebox.blobUrl}}" ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'" ng-style="{\n                                                \'font-size\':\'10px\'}"> <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'" ng-src="{{level.imagebox.blobSmall}}" ng-style="{position:\'absolute\',\n                                                    left:0,\n                                                    top:0,\n                                                    width:level.imagebox.geometry.width*slide.arr2.pageScaleW,\n                                                    height:level.imagebox.geometry.height*slide.arr2.pageScaleH}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-hide="slide.arr2==\'\'&&$last&&!level.imageart" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr2.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr2.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background" ng-hide="slide.arr2==\'\'&&$last&&!level.textbox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr2.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr2.ratio > 12 ? level.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.lineheight* slide.arr2.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.letterspacing* slide.arr2.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr2.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size* slide.arr2.ratio > 12 ? (level.textbox.geometry.width*slide.arr2.pageScaleW):level.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr2.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr2.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr2.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr2.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr2.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr2.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr2.pageScaleW:\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr2.pageScaleH:\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr2.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr2.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr2.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr2.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr2.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr2.ratio > 12 ? docLevel.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr2.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr2.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr2.pageScaleW):docLevel.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr2.barcode" ng-style="{\n                                            \'width\': slide.arr2.barcode.geometry.width*slide.arr2.pageScaleW,\n                                             \'height\': slide.arr2.barcode.geometry.height*slide.arr2.pageScaleH,\n                                             \'left\': slide.arr2.barcode.geometry.x*slide.arr2.pageScaleW,\n                                             \'top\': slide.arr2.barcode.geometry.y*slide.arr2.pageScaleH,\n                                             \'transform\': \'rotate(-\' + slide.arr2.barcode.rotation.angle + \'deg)\'\n                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div></div><div ng-show="vm.bindingtype==\'Left\'"><div class="slide-content slide1" data-index="{{$index}}" id="slide1" ng-class="{\'bb-custom-side\':(slide.arr2!=\'\'||$first||(slide.arr2==\'\'&&slide.spread==false))}" ng-style="{\n                                            width:getPageWaHLar(slide,true,true),\n                                            height:getPageWaHLar(slide,false,true),\n                                            \'margin-left\':$first?0:slide.marginLeft,\n                                            position:relative,\n                                            background:slide.arr.background.color}"><!--\u80CC\u666F\u5C42--> <img ng-if="slide.arr.bgImg" ng-src="{{slide.arr.bgImg||slide.arr.background.resource.identifier + \'?imageMogr2\'}}" class="background{{$index}} background" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr.background.offsetx*slide.arr.pageScaleW,\n                                             top:slide.arr.background.offsety*slide.arr.pageScaleH,\n                                             width: slide.arr.background.adaptation!=\'Height\'?slide.arr.background.width*slide.arr.pageScaleW:\'auto\',\n                                             height:slide.arr.background.adaptation==\'Height\'?slide.arr.background.height*slide.arr.pageScaleH:\'auto\'}"><div ng-repeat="level in slide.arr.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div class="select-img-box diy-box background{{outerIndex}} background" style="position: absolute" ng-if="level.imagebox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'width\': level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imagebox.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imagebox.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imagebox.geometry.y*slide.arr.pageScaleH,\n                                                \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-box"><img class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-src="{{level.imagebox.blobUrl}}" ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'" ng-style="{\'font-size\':\'10px\'}"> <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'" ng-src="{{level.imagebox.blobSmall}}" ng-style="{position:\'absolute\',\n                                                    left:0,\n                                                    top:0,\n                                                    width:level.imagebox.geometry.width*slide.arr.pageScaleW,\n                                                    height:level.imagebox.geometry.height*slide.arr.pageScaleH}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-if="level.imageart" ng-class="{\'leftbo-rotation\': isLeftRotation}" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background" ng-if="level.textbox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (level.textbox.style.size*slide.arr.ratio > 12 ? level.textbox.style.size* slide.arr.ratio : 12) + \'pt\',\n                                                    \'color\': level.textbox.style.color,\n                                                    \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.lineheight* slide.arr.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (level.textbox.style.size* slide.arr.ratio > 12 ? level.textbox.style.letterspacing* slide.arr.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                    \'opacity\': level.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': level.textbox.style.align,\n                                                    \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr.ratio)+\')\',\n                                                    \'width\':  (level.textbox.style.size* slide.arr.ratio > 12 ? (level.textbox.geometry.width*slide.arr.pageScaleW):level.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr.pageScaleW:\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr.pageScaleH:\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr.ratio > 12 ? docLevel.textbox.style.size* slide.arr.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size* slide.arr.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr.pageScaleW):docLevel.textbox.geometry.width*slide.arr.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr.barcode" ng-style="{\n                                    \'width\': slide.arr.barcode.geometry.width*slide.arr.pageScaleW,\n                                     \'height\': slide.arr.barcode.geometry.height*slide.arr.pageScaleH,\n                                     \'left\': slide.arr.barcode.geometry.x*slide.arr.pageScaleW,\n                                     \'top\': slide.arr.barcode.geometry.y*slide.arr.pageScaleH,\n                                     \'transform\': \'rotate(-\' + slide.arr.barcode.rotation.angle + \'deg)\'\n                                    }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div><div class="slide-content slide1" ng-show="!orientations&&($first||$last)" ng-style="{\n                                    opacity:0,\n                                    width:getPageWaHLar(slide,true,true)*2,\n                                    height:getPageWaHLar(slide,false,true),\n                                    position:relative}"></div><div ng-hide="$first||$last||slide.spread==true" id="slide2" class="slide-content bb-custom-side slide2" style="position: relative!important" ng-style="{\n                                    width:getPageWaHLar(slide,true,false),\n                                    height:getPageWaHLar(slide,false,false),\n                                    background:slide.arr2.background.color\n                                }"><!--\u80CC\u666F\u5C42--> <img ng-src="{{slide.arr2==\'\'?\'\':slide.arr2.bgImg}}" ng-if="slide.arr2.bgImg" class="background{{$index}} background" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.arr2.background.offsetx*slide.arr2.pageScaleW,\n                                             top:slide.arr2.background.offsety*slide.arr2.pageScaleH,\n                                             width: slide.arr2.background.adaptation!=\'Height\'?slide.arr2.background.width*slide.arr2.pageScaleW:\'auto\',\n                                             height:slide.arr2.background.adaptation==\'Height\'?slide.arr2.background.height*slide.arr2.pageScaleH:\'auto\'}"><div ng-repeat="level in slide.arr2.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div class="select-img-box diy-box background{{outerIndex}} background" style="position: absolute" ng-if="level.imagebox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                         \'width\': level.imagebox.geometry.width*slide.arr2.pageScaleW,\n                                        \'height\': level.imagebox.geometry.height*slide.arr2.pageScaleH,\n                                        \'left\': level.imagebox.geometry.x*slide.arr2.pageScaleW,\n                                        \'top\': level.imagebox.geometry.y*slide.arr2.pageScaleH,\n                                        \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-box"><img id="imgInput{{outerIndex+1}}{{$index}}" class="indexSet-800 imgBoxes{{outerIndex+1}}{{$index}}" data-imgindex="{{$index}}" ng-src="{{level.imagebox.blobUrl}}" ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'" ng-style="{\n                                                \'font-size\':\'10px\'}"> <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'" ng-src="{{level.imagebox.blobSmall}}" ng-style="{position:\'absolute\',\n                                                    left:0,\n                                                    top:0,\n                                                    width:level.imagebox.geometry.width*slide.arr2.pageScaleW,\n                                                    height:level.imagebox.geometry.height*slide.arr2.pageScaleH}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box background{{outerIndex}} background" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-if="level.imageart" data-index="{{$index}}" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.imageart.transparency,\n                                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                \'height\': level.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                \'left\': level.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                \'top\': level.imageart.geometry.y*slide.arr2.pageScaleH}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.arr2.pageScaleW,\n                                                    \'top\': level.imageart.offsety*slide.arr2.pageScaleH,\n                                                    \'width\': level.imageart.geometry.width*slide.arr2.pageScaleW * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box background{{outerIndex}} background" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-if="level.textbox" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                left: level.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                width: level.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                height: level.textbox.geometry.height*slide.arr2.pageScaleH,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.arr2.ratio > 12 ? level.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.lineheight* slide.arr2.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size* slide.arr2.ratio > 12 ? level.textbox.style.letterspacing* slide.arr2.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.arr2.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size* slide.arr2.ratio > 12 ? (level.textbox.geometry.width*slide.arr2.pageScaleW):level.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * level.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width*slide.arr2.pageScaleW,\n                                                    height: level.textdocument.geometry.height*slide.arr2.pageScaleH,\n                                                    left: level.textdocument.geometry.x*slide.arr2.pageScaleW,\n                                                    top: level.textdocument.geometry.y*slide.arr2.pageScaleH,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx*slide.arr2.pageScaleW,\n                                                         top:level.textdocument.background.offsety*slide.arr2.pageScaleH,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width*slide.arr2.pageScaleW:\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height*slide.arr2.pageScaleH:\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*slide.arr2.pageScaleW,\n                                                            height: docLevel.imageart.geometry.height*slide.arr2.pageScaleH,\n                                                            left: docLevel.imageart.geometry.x*slide.arr2.pageScaleW,\n                                                            top: docLevel.imageart.geometry.y*slide.arr2.pageScaleH,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx*slide.arr2.pageScaleW,\n                                                                    \'top\': docLevel.imageart.offsety*slide.arr2.pageScaleH,\n                                                                    \'width\': docLevel.imageart.geometry.width*slide.arr2.pageScaleW * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width*slide.arr2.pageScaleW,\n                                                            \'height\': docLevel.textbox.geometry.height*slide.arr2.pageScaleW,\n                                                            \'left\': docLevel.textbox.geometry.x*slide.arr2.pageScaleW,\n                                                            \'top\': docLevel.textbox.geometry.y*slide.arr2.pageScaleH,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.arr2.ratio > 12 ? docLevel.textbox.style.size* slide.arr2.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.lineheight* slide.arr2.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.arr2.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.arr2.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size* slide.arr2.ratio > 12 ? (docLevel.textbox.geometry.width*slide.arr2.pageScaleW):docLevel.textbox.geometry.width*slide.arr2.pageScaleW/( 1 / 12 * docLevel.textbox.style.size*slide.arr2.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode background{{outerIndex}} background" ng-show="slide.arr2.barcode" ng-style="{\n                                    \'width\': slide.arr2.barcode.geometry.width*slide.arr2.pageScaleW,\n                                     \'height\': slide.arr2.barcode.geometry.height*slide.arr2.pageScaleH,\n                                     \'left\': slide.arr2.barcode.geometry.x*slide.arr2.pageScaleW,\n                                     \'top\': slide.arr2.barcode.geometry.y*slide.arr2.pageScaleH,\n                                     \'transform\': \'rotate(-\' + slide.arr2.barcode.rotation.angle + \'deg)\'\n                                }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div></div></li><li ng-repeat="page in template.pages.page track by $index" ng-init="outerIndex = $index" style="display: none"><div class="select-img-box diy-box" style="position: absolute" ng-repeat="imgInput in page.imageboxes.imagebox track by $index"><img class="imgBox{{outerIndex}}{{$index}}"></div></li></ul></div></div></div><div class="main clearfix" ng-show="vm.bindingtype==\'None\'||template.pages.page.length<2"><div class="bb-custom-wrapper bb-bg" style="margin-top: 50px!important"><div class="templateView2-carousel"><ul rn-carousel="" rn-carousel-index="carouselIndex" rn-carousel-buffered="" class="carouselView5"><li ng-repeat="slide in template.pages.page track by $index" ng-init="outerIndex = $index" class="mar-bottom-15" style="overflow: hidden" ng-style="{\n                            width:dWidth*0.7,\n                            margin:\'0 auto\'}" style="position: relative" is-over="toggle.now" data-index="{{$index}}"><div class="slide-content mar-bottom-15" data-index="{{$index}}" ng-style="{\n                                width:dWidth*0.7,\n                                height:dWidth*0.7*slide.mediabox.height/slide.mediabox.width,\n                                background:slide.background.color\n                                }"><!--<img ng-src="{{slide.bgImg}}" style="width: 100%" />--><!--\u80CC\u666F\u5C42--> <img ng-src="{{slide.bgImg}}" ng-if="slide.bgImg" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.background.offsetx,\n                                             top:slide.background.offsety,\n                                             width: slide.background.adaptation!=\'Height\'?slide.background.width:\'auto\',\n                                             height:slide.background.adaptation==\'Height\'?slide.background.height:\'auto\'}"><div ng-repeat="level in slide.levels.level track by $index"><!--\u5F02\u6027\u56FE\u7247\u5904\u7406--><div class="select-img-box diy-box" style="position: absolute" ng-if="level.imagebox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                        \'z-index\':level.seq-0+200,\n                                        \'width\': level.imagebox.geometry.width,\n                                        \'height\': level.imagebox.geometry.height,\n                                        \'left\': level.imagebox.geometry.x,\n                                        \'top\': level.imagebox.geometry.y,\n                                        \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-box"><img id="imgInput{{outerIndex}}{{$index}}" class="indexSet-800 imgBoxes{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-src="{{level.imagebox.blobUrl}}" ng-show="level.imagebox.bokehtype==\'None\'||level.imagebox.bokehtype==\'Blurred\'" ng-style="{\n                                                \'font-size\':\'10px\',\n                                                \'width\': level.imagebox.geometry.width,\n                                                \'height\':level.imagebox.geometry.height,\n                                                \'left\': level.imagebox.geometry.x,\n                                                \'top\': level.imagebox.geometry.y}"> <img class="real-img imgBoxSmall{{outerIndex}}{{$index}}" data-imgindex="{{$index}}" ng-show="level.imagebox.bokehtype!=\'None\'" ng-src="{{level.imagebox.blobSmall}}" ng-style="{position:\'absolute\',\n                                                    left:0,\n                                                    top:0,\n                                                    width:level.imagebox.geometry.width,\n                                                    height:level.imagebox.geometry.height}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box" ng-class="{\'leftbo-rotation\': isLeftRotation}" data-index="{{$index}}" ng-if="level.imageart" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                            \'opacity\':level.imageart.transparency,\n                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                            \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'width\': level.imageart.geometry.width,\n                                            \'height\': level.imageart.geometry.height,\n                                            \'left\': level.imageart.geometry.x,\n                                            \'top\': level.imageart.geometry.y}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img id="select-sticker-{{$index}}" ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx,\n                                                    \'top\': level.imageart.offsety,\n                                                    \'width\': level.imageart.geometry.width * level.imageart.scale}"></div></div><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box" ng-if="level.textbox" ng-class="{\'leftbo-rotation\': isLeftRotation}" ng-style="{\n                                                \'z-index\':level.seq-0+200,\n                                                top: level.textbox.geometry.y,\n                                                left: level.textbox.geometry.x,\n                                                width: level.textbox.geometry.width,\n                                                height: level.textbox.geometry.height,\n                                                \'transform\':\'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-ms-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-moz-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'-o-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',\n                                                        \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width):level.textbox.geometry.width/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.textdocument.geometry.width,\n                                                    height: level.textdocument.geometry.height,\n                                                    left: level.textdocument.geometry.x,\n                                                    top: level.textdocument.geometry.y,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx,\n                                                         top:level.textdocument.background.offsety,\n                                                         width: level.textdocument.background.adaptation!=\'Height\'?level.textdocument.geometry.width:\'auto\',\n                                                         height:level.textdocument.background.adaptation==\'Height\'?level.textdocument.geometry.height:\'auto\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width,\n                                                            height: docLevel.imageart.geometry.height,\n                                                            left: docLevel.imageart.geometry.x,\n                                                            top: docLevel.imageart.geometry.y,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx,\n                                                                    \'top\': docLevel.imageart.offsety,\n                                                                    \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'width\': docLevel.textbox.geometry.width,\n                                                            \'left\': docLevel.textbox.geometry.x,\n                                                            \'top\': docLevel.textbox.geometry.y,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                            \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                            \'width\':  (docLevel.textbox.style.size*slide.ratio > 12 ? (docLevel.textbox.geometry.width):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                    \'width\': slide.barcode.geometry.width,\n                                     \'height\': slide.barcode.geometry.height,\n                                     \'left\': slide.barcode.geometry.x,\n                                     \'top\': slide.barcode.geometry.y,\n                                     \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\'\n                                    }"><img src="content/images/txm.png" style="width: 100%;height: 100%;vertical-align:top"></div></div></li></ul></div></div></div><div class="text-align-center mar-top-30" id="back-btn" ng-show="isShow||vm.bindingtype==\'None\'||template.pages.page.length<2"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="backTo()"><span translate="entity.action.backTo">back</span></button></div></div><div class="origin-image origin-image-dialog" ng-show="isXml"><div class="origin-wrap" ng-click="clickToHide()" onmousewheel="return bbimg(this)"><img id="origin-pic" onmousedown="moveImgStart(event)"><div class="text-align-center mar-top-30"><button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="backTo()"><span translate="entity.action.backTo">back</span></button></div></div></div>');
$templateCache.put('app/entities/sales-order/sales-order-data-export.html','<div class="listBGC"><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 fontStyle">\u4E0B\u5355\u65F6\u95F4</label><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 no-padding"><input id="field_startTime" type="text" class="form-control-edit" name="startTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')"></div><label class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fontStyle" style="text-align: center">\u81F3</label><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 no-padding"><input id="field_endTime" type="text" class="form-control-edit" name="endTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')"></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 fontStyle">\u72B6\u6001</label><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 no-padding"><select ng-model="vm.status" class="form-control-edit"><option value="">\u5168\u90E8\u8BA2\u5355</option><option value="Created">\u5F85\u652F\u4ED8</option><option value="Paid">\u5F85\u751F\u4EA7</option><option value="Completed">\u4EA4\u6613\u5B8C\u6210</option><option value="Cancelled">\u4EA4\u6613\u53D6\u6D88</option></select></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 fontStyle">\u7F16\u8F91\u5668\u7C7B\u578B</label><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 no-padding"><select class="form-control-edit" ng-model="vm.editorType"><option value="BOOK_JUNIOR" data-translate="backApp.EditorType.BOOK_JUNIOR">BOOK_JUNIOR</option><option value="BOOK_SENIOR" data-translate="backApp.EditorType.BOOK_SENIOR">BOOK_SENIOR</option><option value="POSTER" data-translate="backApp.EditorType.POSTER">POSTER</option><option value="NEW_EDITOR" data-translate="backApp.EditorType.NEW_EDITOR">NEW_EDITOR</option><option value="PICTURE" data-translate="backApp.EditorType.PICTURE">PICTURE</option><option value="PICTURE_PRO" data-translate="backApp.EditorType.PICTURE_PRO">PICTURE</option><option value="DIY_EDITOR" data-translate="backApp.EditorType.DIY_EDITOR">DIY_EDITOR</option><option value="FORM_EDITOR" data-translate="backApp.EditorType.FORM_EDITOR">FORM_EDITOR</option><option value="PHOTO_EDITOR" data-translate="backApp.EditorType.PHOTO_EDITOR">PHOTO_EDITOR</option><option value="PICTURE_PRO_P" data-translate="backApp.EditorType.PICTURE_PRO_P">PICTURE_PRO_P</option></select></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 fontStyle">\u5546\u54C1\u540D\u79F0</label><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 no-padding"><select ng-model="vm.productId" class="form-control-edit" ng-options="product.id as product.name for product in vm.products"><option value="">\u8BF7\u9009\u62E9</option></select></div></div></div><div class="col-lg-12 col-sm-12 form-group"><div class="form-group text-right"><button class="oval-btn-normal" ng-click="vm.export()"><span>\u4E0B\u8F7D</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/sales-order/sales-order-detail.html','<div class="listBGC listDetail font-12 pad-0" style="max-width: 650px"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="entity.action.view">view</span></div></div></div><uib-tabset class="uibtabs" type="tabs" active="0"><uib-tab index="0" heading="\u8BA2\u5355\u4FE1\u606F" style="background-color: #fff !important"><div class="modal-body pad-0" style="max-width: 650px"><div class="panel-body form-horizontal pad-0"><div class="col-lg-12 col-sm-12 col-xs-12 mar-top-30 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12" translate="backApp.salesOrder.number2">number</label><div class="col-md-9 col-sm-9 font-12">{{vm.salesOrder.number}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12" translate="backApp.salesOrder.sourceNumber">sourceNumber</label><div class="col-md-9 col-sm-9 font-12">{{vm.salesOrder.sourceNumber}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12" translate="backApp.salesOrder.status">status</label><div class="col-md-9 col-sm-9 col-xs-9 font-12"><span data-translate="{{\'backApp.OrderStatus.\' + vm.salesOrder.status}}">{{vm.salesOrder.status}}</span></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12" translate="backApp.salesOrder.amount">amount</label><div class="col-md-9 col-sm-9 font-12">{{vm.salesOrder.amount||0|currency}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12" translate="backApp.salesOrder.createdDate">createdDate</label><div class="col-md-9 col-sm-9 font-12">{{vm.salesOrder.createdDate|date:\'medium\'}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12" translate="backApp.salesOrder.paidDate">paidDate</label><div class="col-md-9 col-sm-9 font-12">{{vm.salesOrder.paidDate|date:\'medium\'}}</div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel font-12">\u4EA7\u54C1\u4FE1\u606F</label><div class="col-md-9 col-sm-9 font-12"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div style="margin-left: 9%;width:90%;height: calc(100vh - 440px);overflow: auto"><table class="table-fw font-12" style="width:90%"><thead class="table-head" style="border-color: #e5e6e7;background: #fff"><th class="fw5" style="background: #fff"><span translate="backApp.salesOrder.articleName">articleName</span></th><th class="fw6" style="background: #fff"><span>\u5173\u8054\u6A21\u677F</span></th><th class="fw4" style="background: #fff"><span translate="backApp.salesOrder.articleCover">articleCover</span></th><th class="fw3" style="background: #fff"><span translate="backApp.salesOrder.quantity">quantity</span></th><th class="fw3" style="background: #fff"><span>\u91D1\u989D</span></th><th class="fw4" style="background: #fff"><span>\u72B6\u6001</span></th><th class="fw6" style="background: #fff"><span>\u67E5\u770B</span></th></thead><tbody class="table-body" ng-repeat="line in vm.salesOrder.orderLines track by $index" style="border-top:1px solid #e5e6e7"><td colspan="6" style="text-align: left"><span>\u7F16\u53F7\uFF1A{{line.number}}</span> &nbsp;&nbsp;<span>\u6765\u6E90\u7F16\u53F7\uFF1A{{line.sourceNumber}}</span> <span ng-show="line.extPlatformNumber">&nbsp;&nbsp;<span>\u5E97\u94FA\u5355\u53F7\uFF1A{{line.extPlatformNumber}}</span></span></td><tr style="border-top:1px solid #e5e6e7"><td style="height: 80px!important;border-right:1px solid #e5e6e7;position: relative"><span>{{line.orderArticle.name}}</span></td><td style="border-right:1px solid #e5e6e7">{{line.orderArticle.productXmlName}}</td><td style="border-right:1px solid #e5e6e7"><img src="content/images/loading.gif" ng-show="!line.orderArticle.cover" style="margin: 15px 15px;; width: 20px"> <img style="width:50px" ng-show="line.orderArticle.cover" ng-src="{{domain + line.orderArticle.cover}}"></td><td style="border-right:1px solid #e5e6e7">{{line.copy}}</td><td style="border-right:1px solid #e5e6e7">{{line.amount}}</td><td style="border-right:1px solid #e5e6e7">{{getLineStatus(line)}}</td><td><span class="article-view" ng-click="goToView(line.orderArticle)">\u9884\u89C8&nbsp;</span> <span class="article-view" ng-click="editorArticle(line)" ng-if="line.status != \'Combinationed\'">\u4FEE\u6539\u4F5C\u54C1&nbsp;</span> <span class="article-view" ng-click="downFile(line)" ng-if="line.status == \'Combinationed\'">\u4E0B\u8F7D\u6587\u4EF6&nbsp;</span></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab index="1" heading="\u64CD\u4F5C\u65E5\u5FD7"><div style="padding: 10px; background-color: #fff; font-size: 13px"><table class="table-fw font-12" style="width:90%"><thead class="table-head" style="border-color: #e5e6e7;background: #fff"><th>\u5E8F\u53F7</th><th style="width: 160px!important;max-width: 160px;min-width: 160px">\u63CF\u8FF0</th><th>\u7528\u6237</th><th>\u65F6\u95F4</th></thead><tbody><tr ng-repeat="item in vm.historys track by $index"><td>{{$index + 1}}</td><td style="width: 150px !important" title="{{item.description}}">{{getLength(item.description)}}</td><td>{{item.createdBy || \'\'}}</td><td>{{item.createdDate | date:\'medium\'}}</td></tr></tbody></table></div><div id="biuuu_city" style="text-align: left"></div></uib-tab></uib-tabset><div class="modal-footer"><button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/sales-order/sales-order-dialog.html','<div class="listBGC" style="min-width: 1200px"><div class="list-status"><ul class="clearfix main-status"><li ui-sref-active="active" ng-class="selectTab == \'\' ?\'colorSelect\':\'\'"><a ng-click="byStatus()"><span>\u5168\u90E8\u8BA2\u5355</span></a></li><li ui-sref-active="active" ng-class="selectTab == \'Created\' ?\'colorSelect\':\'\'"><a ng-click="byStatus(\'Created\')"><span>\u5F85\u652F\u4ED8</span></a></li><li ui-sref-active="active" ng-class="selectTab == \'Paid\' ?\'colorSelect\':\'\'"><a ng-click="byStatus(\'Paid\')"><span>\u5F85\u751F\u4EA7</span></a></li><li ui-sref-active="active" ng-class="selectTab == \'Producing\' ?\'colorSelect\':\'\'"><a ng-click="byStatus(\'Producing\')"><span>\u751F\u4EA7\u4E2D</span></a></li><li ui-sref-active="active" ng-class="selectTab == \'Receiving\' ?\'colorSelect\':\'\'"><a ng-click="byStatus(\'Receiving\')"><span>\u53D1\u8D27\u4E2D</span></a></li><li ui-sref-active="active" ng-class="selectTab == \'Completed\' ?\'colorSelect\':\'\'"><a ng-click="byStatus(\'Completed\')"><span>\u4EA4\u6613\u5B8C\u6210</span></a></li><li ui-sref-active="active" ng-class="selectTab == \'Cancelled\' ?\'colorSelect\':\'\'"><a ng-click="byStatus(\'Cancelled\')"><span>\u4EA4\u6613\u53D6\u6D88</span></a></li></ul></div><div class="main-edit"><div class="screeningConditions"><div class="screeningTitle mar-bottom-15"><span class="screen-1">\u57FA\u672C\u4FE1\u606F</span></div><div class="clearfix pad-top-20"><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u8BA2\u5355\u7F16\u53F7\uFF1A</label><div class="c-form-div lh35" style="width: 200px"><span>{{vm.salesOrder.number}}</span></div></div><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u8BA2\u5355\u72B6\u6001\uFF1A</label><div class="c-form-div lh35" style="width: 200px"><span data-translate="{{\'backApp.OrderStatus.\' + vm.salesOrder.status}}">{{salesOrder.status}}</span></div></div><!-- <div class="c-form" style="float: left;clear: none;">\n                    <label class="c-form-label">\u5546\u54C1\u540D\u79F0\uFF1A</label>\n                    <div class="c-form-div lh35" style="width: 200px;">\n                        <span>{{vm.salesOrder.storeName}}</span>\n                    </div>\n                </div> --><!--                <div class="c-form" style="float: left;clear: none;">--><!--                    <label class="c-form-label">\u652F\u4ED8\u65B9\u5F0F\uFF1A</label>--><!--                    <div class="c-form-div lh35" style="width: 200px;">--><!--                        <span data-translate="{{\'backApp.salesOrder.paymentType.\' + vm.salesOrder.methodOfPayment}}">{{vm.salesOrder.methodOfPayment}}</span>--><!--                    </div>--><!--                </div>--><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u8BA2\u5355\u6765\u6E90\uFF1A</label><div class="c-form-div lh35" style="width: 200px">{{vm.salesOrder.sourceType ==\'WECHAT\' ?\'\u516C\u4F17\u53F7\':\'\u5C0F\u7A0B\u5E8F\'}}</div></div><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u8BA2\u5355\u603B\u4EF7\uFF1A</label><div class="c-form-div lh35" style="width: 200px">{{vm.salesOrder.amount | currency}}</div></div><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u4E0B\u5355\u65F6\u95F4\uFF1A</label><div class="c-form-div lh35" style="width: 200px">{{vm.salesOrder.createdDate|date:\'medium\'}}</div></div><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u652F\u4ED8\u65F6\u95F4\uFF1A</label><div class="c-form-div lh35" style="width: 200px">{{vm.salesOrder.paidDate|date:\'medium\'}}</div></div><!--                <div class="c-form" style="float: left;clear: none;">--><!--                    <label class="c-form-label">\u5FEB\u9012\u516C\u53F8\uFF1A</label>--><!--                    <div class="c-form-div lh35" style="width: 200px;">--><!--                        <select ng-model="vm.deliveryCompany" name="deliveryCompany" class="c-select1" ng-options="deliveryCompany as deliveryCompany.name for deliveryCompany in vm.logisticsCompanies">--><!--                            <option value="">\u8BF7\u9009\u62E9\u5FEB\u9012\u516C\u53F8</option>--><!--                        </select>--><!--                    </div>--><!--                </div>--><!--                <div class="c-form" style="float: left;clear: none;">--><!--                    <label class="c-form-label">\u5FEB\u9012\u5355\u53F7\uFF1A</label>--><!--                    <div class="c-form-div lh35" style="width: 200px;">--><!--                        <input type="text" class="c-input1" name="deliveryNumber" ng-model="vm.salesOrder.deliveryNumber" required>--><!--                    </div>--><!--                </div>--><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u5BA2\u670D\u5907\u6CE8\uFF1A</label><div class="c-form-div lh35" style="width: 200px"><input type="text" class="c-input1" ng-model="vm.salesOrder.customerServiceMessage" required></div></div><div style="float: left;clear: none" ng-repeat="h in vm.histories track by $index"><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u5FEB\u9012\u516C\u53F8:</label><div class="c-form-div lh35" style="width: 200px"><span>{{h.deliveryCompany}}</span></div></div><div class="c-form" style="float: left;clear: none"><label class="c-form-label">\u5FEB\u9012\u5355\u53F7\uFF1A</label><div class="c-form-div lh35" style="width: 200px"><span>{{h.deliveryNumber}}</span></div></div></div></div></div><div class="screeningConditions"><div class="screeningTitle mar-bottom-15"><span class="screen-1">\u6536\u8D27\u4FE1\u606F</span></div><div ng-if="vm.salesOrder.locations.length==0">\u6682\u65E0\u6536\u8D27\u4FE1\u606F</div><div class="clearfix pad-top-20" ng-if="vm.salesOrder.locations.length >0"><table class="jh-table table table-striped main-table"><thead class="table-head"><th class="fw3"><span>\u6536\u4EF6\u4EBA</span></th><th class="fw3"><span>\u7535\u8BDD</span></th><!-- <th class="fw3"><span >\u6570\u91CF</span></th> --><th class="fw15"><span>\u5730\u5740</span></th><!--                    <th class="fw2"><span >\u64CD\u4F5C</span></th>--></thead><tr ng-repeat="location in vm.salesOrder.locations track by $index" ng-if="!location.deleted && !location.cancelled"><td><input type="text" class="form-control-edit" name="contact" ng-model="location.contact" required></td><td><input type="text" class="form-control-edit" name="phone" ng-model="location.phone" required></td><td><div class="col-xs-3 col-sm-3 col-md-3 no-padding"><select class="none-border form-control-edit" ng-model="location.pro" ng-options="province.name for province in vm.provinces" ng-change="vm.changeProvince(location)"><option value="">\u7701\u4EFD</option></select></div><div class="col-xs-2 col-sm-2 col-md-2 no-padding"><select class="none-border form-control-edit" ng-model="location.ci" ng-options="city.name for city in location.citys" ng-change="vm.changeCity(location)"><option value="">\u57CE\u5E02</option></select></div><div class="col-xs-2 col-sm-2 col-md-2 no-padding"><select class="none-border form-control-edit" ng-model="location.dis" ng-options="district.name for district in location.districts"><option value="">\u533A\u53BF</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 no-padding"><input type="text" class="form-control-edit" name="phone" ng-model="location.address" required></div></td><!--                        <td>--><!--                            <span class="btn-text" ng-click="deleteLocation(location)">\u5220\u9664</span>--><!--                        </td>--></tr></table></div></div><div class="screeningConditions"><div class="screeningTitle mar-bottom-15"><span class="screen-1">\u6587\u4EF6\u4FE1\u606F</span></div><div class="table-responsive white pad-left-15 pad-right-15 pad-bottom-10"><table class="jh-table table table-striped main-table"><thead class="table-head"><th class="fw5"><span translate="backApp.salesOrder.articleName">articleName</span></th><th class="fw6"><span translate="backApp.salesOrder.articleSku">articleSku</span></th><th class="fw4"><span translate="backApp.salesOrder.articleCover">articleCover</span></th><th class="fw4"><span>\u652F\u4ED8\u7801</span></th><th class="fw4"><span>\u793C\u7269\u5238</span></th><th class="fw4"><span translate="backApp.salesOrder.quantity">quantity</span></th><th class="fw4"><span>\u884C\u5355\u53F7</span></th><th class="fw4"><span>\u91D1\u989D</span></th><th class="fw4"><span>\u67E5\u770B</span></th></thead><tr ng-repeat="line in vm.salesOrder.orderLines track by $index"><td>{{line.orderArticle.name}}</td><td>{{line.orderArticle.sku}}</td><td><img style="width:50px;max-height: 54px" ng-src="{{domain + line.orderArticle.cover}}"></td><td>{{line.payCodeCode}}</td><td>{{line.giftVoucherCode}}</td><td><input type="number" ng-min="0" class="form-control font-12" ng-model="line.copy"></td><td>{{line.number}}</td><td>{{line.amount}}</td><td class="article-view" ng-click="goToView(line.orderArticle)">\u67E5\u770B</td></tr></table></div></div><div><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save" ng-click="vm.save()"><span>\u786E\u8BA4</span></button> <button type="button" class="btn btn-default btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span>\u8FD4\u56DE</span></button></div></div></div>');
$templateCache.put('app/entities/sales-order/sales-orders.html','<div class="listBGC" style="min-width: 1200px;margin-top: 20px"><span class="breadcrumb-normal">\u8BA2\u5355 /<span class="breadcrumb-normal-step"> \u8BA2\u5355\u7BA1\u7406</span></span><div style="width: 100%;height: auto"><!--        <div class="screeningConditions">--><!--            <div class="screeningTitle mar-bottom-15">--><!--                <span class="screen-1">\u7B5B\u9009\u6761\u4EF6</span>--><!--                <div class="screen-2" ng-click="shrink()" ng-if="!vm.isOpen">\u7F29\u56DE <img src="content/images/icon/opened.svg" /></div>--><!--                <div class="screen-2" ng-click="shrink()" ng-if="vm.isOpen">\u5C55\u5F00 <img src="content/images/icon/retracting.svg" /></div>--><!--            </div>--><!--            <div class="clearfix" ng-if="!vm.isOpen">--><!--                <div class="row mar-bottom-15">--><!--                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" style="margin-left: -5px;">--><!--                        <label class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fontStyle">\u652F\u4ED8\u65F6\u95F4</label>--><!--                        <div class="col-xs-4 col-sm-3 col-md-3 col-lg-3 no-padding">--><!--                            <input id="field_startTime" type="text" class="form-control-edit" name="startTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')" />--><!--                        </div>--><!--                        <label class="col-xs-2 col-sm-2 col-md-2 col-lg-2 fontStyle" style="text-align: center">\u81F3</label>--><!--                        <div class="col-xs-4 col-sm-3 col-md-3 col-lg-3 no-padding">--><!--                            <input id="field_endTime" type="text" class="form-control-edit" name="endTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')" />--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--                <div class="row mar-bottom-15">--><!--                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">--><!--                        <label class="col-xs-5 col-sm-4 col-md-4 col-lg-4 fontStyle">\u5546\u54C1\u5206\u7C7B</label>--><!--                        <div class="col-xs-7 col-sm-8 col-md-8 col-lg-8 no-padding">--><!--                            <select ng-model="vm.categoryId" class="form-control-edit" ng-click="changeCategory()" ng-options="category.id as category.name for category  in vm.categorys">--><!--                                <option value="">\u8BF7\u9009\u62E9</option>--><!--                            </select>--><!--                        </div>--><!--                    </div>--><!--                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">--><!--                        <label class="col-xs-5 col-sm-4 col-md-4 col-lg-4 fontStyle">\u5546\u54C1\u540D\u79F0</label>--><!--                        <div class="col-xs-7 col-sm-8 col-md-8 col-lg-8 no-padding">--><!--                            <select ng-model="vm.productName" class="form-control-edit" ng-options="product.name as product.name for product in vm.products">--><!--                                <option value="">\u8BF7\u9009\u62E9</option>--><!--                            </select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--                <div class="col-sm-12 mar-bottom-15">--><!--                    <div class="button-operate small-btn-normal" ng-click="screens()">\u7B5B\u9009</div>--><!--                    <div class="button-operate small-btn-disabled" ng-click="resetInfo()">\u91CD\u7F6E</div>--><!--                </div>--><!--            </div>--><!--        </div>--><div class="con"><div class="screening-order"><div class="screening-title" ng-class="selectTab == \'\' ?\'colorSelect\':\'\'" ng-click="byStatus()"><span>\u5168\u90E8\u8BA2\u5355</span></div><div class="screening-title" ng-class="selectTab == \'Created\' ?\'colorSelect\':\'\'" ng-click="byStatus(\'Created\')"><span>\u5F85\u652F\u4ED8</span></div><div class="screening-title" ng-class="selectTab == \'Paid\' ?\'colorSelect\':\'\'" ng-click="byStatus(\'Paid\')"><span>\u5F85\u751F\u4EA7</span></div><div class="screening-title" ng-class="selectTab == \'CombinationError\' ?\'colorSelect\':\'\'" ng-click="byStatus(\'CombinationError\')"><span>\u7EC4\u7248\u5931\u8D25</span></div><div class="screening-title" ng-class="selectTab == \'Completed\' ?\'colorSelect\':\'\'" ng-click="byStatus(\'Completed\')"><span>\u4EA4\u6613\u5B8C\u6210</span></div><div class="screening-title" ng-class="selectTab == \'Cancelled\' ?\'colorSelect\':\'\'" ng-click="byStatus(\'Cancelled\')"><span>\u4EA4\u6613\u53D6\u6D88</span></div><div class="screening-title" ng-class="selectTab == \'Deleted\' ?\'colorSelect\':\'\'" ng-click="getDeleted()"><span>\u4EA4\u6613\u5220\u9664</span></div></div><div style="display:flex"><div class="search-condition" style="flex:1;flex-shrink: 0"><label style="flex:1">\u652F\u4ED8\u65F6\u95F4:</label><div style="display:flex"><input id="field_startTime" type="text" class="form-control-edit" name="startTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.startTime" is-open="vm.datePickerOpenStatus.startTime" ng-click="vm.openCalendar(\'startTime\')"><label style="margin: auto">~</label><input id="field_endTime" type="text" class="form-control-edit" name="endTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.endTime" is-open="vm.datePickerOpenStatus.endTime" ng-click="vm.openCalendar(\'endTime\')"></div></div><div class="search-condition" style="flex:1;flex-shrink: 0"><label style="flex:1">\u5546\u54C1\u5206\u7C7B:</label><div><select ng-model="vm.categoryId" class="form-control-edit" ng-click="changeCategory()" ng-options="category.id as category.name for category  in vm.categorys"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="search-condition" style="flex:1;flex-shrink: 0"><label style="flex:1">\u5546\u54C1\u540D\u79F0</label><div><select ng-model="vm.productName" class="form-control-edit" ng-options="product.name as product.name for product in vm.products"><option value="">\u8BF7\u9009\u62E9</option></select></div></div><div class="search-condition" style="flex:1;flex-shrink: 0;margin-top: 24px"><div class="button-operate small-btn-normal" ng-click="screens()">\u7B5B\u9009</div><div class="button-operate small-btn-disabled" ng-click="resetInfo()">\u91CD\u7F6E</div></div></div><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"><div class="float-left"><button class="oval-btn-normal" ui-sref="sales-order-data-export()"><span>\u6279\u91CF\u4E0B\u8F7D</span> <i class="icon iconfont iconjia1"></i></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="\u8F93\u5165\u8BA2\u5355\u7F16\u53F7\u641C\u7D22"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="white"><table class="za-table table"><thead><tr><th><span data-translate="backApp.salesOrder.number">Number</span></th><th><span>\u6765\u6E90\u5355\u53F7</span></th><th class="fw18"><span data-translate="backApp.salesOrder.product">product</span></th><th><span data-translate="backApp.salesOrder.amount">Amount</span></th><!-- <th><span data-translate="backApp.salesOrder.payAmount">Pay Amount</span> </th> --><th><span data-translate="backApp.salesOrder.createdDate">createdDate</span></th><th><span data-translate="backApp.salesOrder.status">Status</span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="salesOrder in vm.salesOrders track by salesOrder.id"><td style="display: table-cell; vertical-align: middle">{{salesOrder.number}}</td><td style="display: table-cell; vertical-align: middle">{{salesOrder.sourceNumber}}</td><td style="display: table-cell; vertical-align: middle" ng-click="showOrders(salesOrder)"><div ng-repeat="line in salesOrder.orderLines track by $index" ng-if="$index<=2 || salesOrder.show">{{line.orderArticle.productName}}</div><span ng-if="salesOrder.show&& salesOrder.orderLines.length>3"><img src="content/images/order_open.png"> </span><span ng-if="!salesOrder.show && salesOrder.orderLines.length>3"><img src="content/images/order_close.png"></span></td><td style="display: table-cell; vertical-align: middle">{{salesOrder.amount||0|currency}}</td><!-- <td style="display: table-cell; vertical-align: middle;">{{salesOrder.payAmount||0|currency}} </td> --><td style="display: table-cell; vertical-align: middle">{{salesOrder.createdDate|date:\'medium\'}}</td><td style="display: table-cell; vertical-align: middle"><span style="color: #0e9aef" ng-if="salesOrder.status == \'Completed\' && vm.deleted != \'Deleted\'">\u25CF \u4EA4\u6613\u5B8C\u6210</span> <span style="color: #e38462" ng-if="salesOrder.status == \'Created\' && vm.deleted != \'Deleted\'">\u25CF \u5F85\u652F\u4ED8</span> <span style="color: #03ff00" ng-if="salesOrder.status == \'Paid\' && vm.deleted != \'Deleted\'">\u25CF \u5F85\u751F\u4EA7</span> <span style="color: #441644" ng-if="salesOrder.status == \'Cancelled\' && vm.deleted != \'Deleted\'">\u25CF \u4EA4\u6613\u53D6\u6D88</span> <span style="color: #6f6f6f" ng-if="vm.deleted == \'Deleted\'">\u25CF \u4EA4\u6613\u5220\u9664</span></td><td><button class="status-btn" type="submit" ui-sref="sales-order-detail({id:salesOrder.id})"><i class="icon iconfont webchakan"></i>\u67E5\u770B <span class="hover-span">\u67E5\u770B</span></button> <button class="status-btn" type="submit" ng-click="pay(salesOrder)" ng-if="salesOrder.status==\'Created\'"><i class="icon iconfont webzhifu"></i>\u652F\u4ED8 <span class="hover-span">\u652F\u4ED8</span></button> <button class="status-btn" type="submit" ng-click="close(salesOrder)" ng-if="checkOrderLinecombinationError(salesOrder)"><i class="icon iconfont webzhifu"></i>\u5173\u95ED <span class="hover-span">\u5173\u95ED</span></button> <button class="status-btn" type="submit" ng-click="justifySalesOrder(salesOrder)" ng-if="salesOrder.status==\'Paid\'"><i class="icon iconfont webcaozuo"></i>\u7EC4\u7248 <span class="hover-span">\u7EC4\u7248</span></button> <button class="status-btn" type="submit" ng-click="orderCombinationNotify(salesOrder)" ng-if="salesOrder.status==\'Completed\'"><i class="icon iconfont webxinbaniconshangchuan-"></i>\u7EC4\u7248\u5B8C\u6210\u901A\u77E5 <span class="hover-span2">\u7EC4\u7248\u5B8C\u6210\u901A\u77E5</span></button> <button class="status-btn" type="submit" ng-click="combinationError(salesOrder)" ng-if="checkOrderLinecombinationError(salesOrder)"><i class="icon iconfont iconyinyue"></i>\u7EC4\u7248\u5931\u8D25\u65E5\u5FD7 <span class="hover-span2">\u7EC4\u7248\u5931\u8D25\u65E5\u5FD7</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/sales-order/three-preview.html','<div class="modal-view"><div class="loading-page2" ng-if="vm.loading"><img src="content/images/loading.gif" style="max-width: 100%; max-height: 100%"></div><div class="threeView-body"><div class="threeView" id="threeView1" ng-show="!vm.loading && !vm.error"></div><!--    <div class="threeLoading" ng-if="vm.loading">\u52A0\u8F7D\u4E2D...</div>--><div class="threeError" ng-if="vm.error">{{vm.errorText ? vm.errorText : \'3D\u6A21\u677F\u52A0\u8F7D\u5931\u8D25\'}}</div><div class="threeHide" ng-click="vm.clear()"></div></div></div><style>.modal-view{\n        width: 100%;\n        height: 500px;\n        background: #f3f3f3;\n    }\n    .modal-content {\n        width: 100%;\n    }</style>');
$templateCache.put('app/entities/scene/scene-dialog.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">{{vm.type == \'look\' ? \'\u67E5\u770B\u6A21\u578B\' : \'\u6A21\u578B\u7F16\u8F91\'}}</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" ng-if="vm.page == 1" style="padding: 20px 0"><div class="c-form"><label class="c-form-label">\u6A21\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.name"></div></div><div class="c-form"><label class="c-form-label">\u6A21\u578B\u56FE\u7247\uFF1A</label><div class="c-form-div"><div class="btn_addPic" ng-if="!vm.data.cover"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><div class="btn_addPic" ng-if="vm.data.cover"><img ng-src="{{vm.data.cover+\'?imageView2\'}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(item,$index)" style="color: red;position: absolute; right: 5px;top: 5px"></i></div></div></div><div class="c-form"><label class="c-form-label">3D\u6A21\u578B\uFF1A</label><div class="c-form-div" style="display: flex"><div class="mar-right-10"><div class="btn-3dfile"><input type="file" name="file" class="filePrew" accept=".gltf,.glb" onchange="uploadPic(event)" ng-model-options="{debounce : 500}"> <span>{{vm.data.modelPath ? \'\u91CD\u65B0\u9009\u62E9\' : \'\u4E0A\u4F203D\u6A21\u578B\'}}</span></div><div class="register-tip">\u53EA\u652F\u6301.gltf .glb\u683C\u5F0F</div></div><div class="btn-3dfile" ng-click="clearGltfInfo()" ng-if="vm.data.modelPath"><span>\u6E05\u7A7A3D\u6A21\u578B</span></div></div></div><div class="c-form"><label class="c-form-label">\u6A21\u578B\u6750\u8D28\uFF1A</label><div class="c-form-div lh35"><span ng-repeat="item in vm.data.modelData track by $index" ng-if="!vm.modelLoad">{{item.materialName}}<span ng-if="$index<vm.data.modelData.length-1">\u3001</span></span> <span ng-if="vm.modelLoad">\u4E0A\u4F20\u4E2D...</span></div></div></div><div class="c-model-body" ng-if="vm.page == 2" style="padding: 30px; display: flex;justify-content: space-between"><div style="width: 400px"><div>\u5173\u8054\u6750\u8D28</div><div><div style="display: flex; align-items: center;height: 35px" ng-repeat="item in vm.modelData"><span>\u7B2C{{$index+1}}\u9875\uFF1A</span><select ng-model="item.materialName" ng-options="p for p in item.modelData" ng-change="vm.changeModelData()"></select><i class="iconfont webshanchu" ng-click="deleteModelData($index)" ng-if="$index>0"></i></div><button type="button" class="btn btn-info" ng-click="addModelData()" ng-if="vm.modelData.length<vm.data.modelData.length"><i class="iconfont icon-lijigoumaiweixuanzhong font-12"></i> <span>\u6DFB\u52A0</span></button></div><div class="mar-top-20">\u573A\u666F\u80CC\u666F\uFF1A<span style="color: #999">(\u63A8\u8350\u5C3A\u5BF8\uFF1A600*600px)</span></div><div class="btn_addPic" ng-if="!vm.data.background"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" onchange="updateImgFile1(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><div class="btn_addPic" ng-if="vm.data.background"><img ng-src="{{vm.data.background+\'?imageView2\'}}"> <i class="glyphicon glyphicon-remove" ng-click="vm.data.background = \'\'" style="color: red;position: absolute; right: 5px;top: 5px"></i></div><div>\u6444\u50CF\u673A\uFF1A</div><div class="c-div-view"><div>x: {{vm.data.cameraPosition.x}}</div><div>y: {{vm.data.cameraPosition.y}}</div><div>z: {{vm.data.cameraPosition.z}}</div></div><div>\u76EE\u6807\u4F4D\u7F6E\uFF1A</div><div class="c-div-view"><div>x: {{vm.data.targetPosition.x}}</div><div>y: {{vm.data.targetPosition.y}}</div><div>z: {{vm.data.targetPosition.z}}</div></div></div><div style="width: 400px; display: flex;flex-wrap: wrap; padding-top: 30px" ng-if="vm.gltfData"><three-preview width="400" height="400" page-img="vm.demoPic" background-img="vm.data.background" model-data="vm.data.modelData" model-path="vm.data.modelPath" model-blendent="vm.data.modelBlendent" camera-position="vm.gltfData.cameraPosition" target-position="vm.gltfData.targetPosition" on-change="vm.gltfChange(text)"></three-preview><div class="btn_addPic btn_addPic1"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" onchange="updateImgFile2(event)" ng-model-options="{debounce : 500}"> <span>\u4E0A\u4F20demo\u56FE\u7247</span></div></div></div><div class="c-model-body" ng-if="vm.page == 3" style="padding: 30px; display: flex;justify-content: center; align-items: center"><three-preview width="600" height="600" page-img="vm.demoPic" background-img="vm.data.background" model-data="vm.data.modelData" model-path="vm.data.modelPath" model-blendent="vm.data.modelBlendent" camera-position="vm.gltfData.cameraPosition" target-position="vm.gltfData.targetPosition" on-change="vm.gltfChange(text)"></three-preview></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()" ng-if="vm.page == 1">\u8FD4\u56DE</button> <button type="button" class="btn btn-info" ng-click="vm.next()" ng-if="vm.page == 1">\u4E0B\u4E00\u6B65</button> <button type="button" class="btn btn-cancel" ng-click="vm.page = 1" ng-if="vm.page == 2">\u4E0A\u4E00\u6B65</button> <button type="button" class="btn btn-info" ng-click="vm.save()" ng-if="vm.page == 2">\u4FDD\u5B58</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()" ng-if="vm.page == 3">\u53D6\u6D88</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }\n    .c-div-view{\n        width: 100%;\n        border: 1px solid #ddd;\n        padding: 8px;\n        border-radius: 4px;\n        line-height: 20px;\n        margin-bottom: 20px;\n        margin-top: 5px;\n    }\n    .c-div-view input{\n        width: 160px;\n        border-color: #ddd;\n    }\n    .btn_addPic1{\n        width: 120px;\n        height: 35px;\n        text-align: center;\n        line-height: 35px;\n        border-radius: 4px;\n        margin: 20px auto;\n        background: #D7CAFF;\n        color: var(--btnBgBasicColor);\n    }</style>');
$templateCache.put('app/entities/scene/scene-modal.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u9009\u62E9\u6A21\u578B</div><div class="searchBar" style="margin-top: 10px"><form name="searchForm" class="form-search form-inline ng-pristine ng-valid"><div class="input-group pull-right" id="test"><input type="text" class="form-control ng-pristine ng-untouched ng-valid ng-empty" ng-model="vm.searchQuery" id="searchQuery" placeholder="\u67E5\u8BE2" aria-invalid="false"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search()"><span style="color: #fff">\u641C\u7D22</span></button></span></div></form></div></div><div class="c-model-body" style="padding: 0 20px"><div class="c-scene-view" ng-repeat="item in vm.data" ng-click="item.selected = !item.selected"><div class="c-scene-view-img"><img ng-src="{{item.cover}}" alt=""></div><div class="c-scene-view-name slh">{{item.name}}</div><div class="c-scene-view-icon"><i class="iconfont webweixuanzhong2" ng-if="!item.selected"></i> <i class="iconfont webdui" style="color: #FF5001" ng-if="item.selected"></i></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u4FDD\u5B58</button></div></div><style></style>');
$templateCache.put('app/entities/scene/scene.html','<div class="listBGC"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u573A\u666F\u6A21\u578B</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ng-click="add()"><i class="icon iconfont webadd"></i> <span>\u65B0\u589E\u573A\u666F</span></button></div><!--                    <span style="float: right;margin-top: 4px;" class="transition" ng-class="vm.listStyle == \'Card\' ? \'\' : \'rotate180\'" ng-click="switchStyle()"><img style="width: 25px;" src="content/images/icon/CardOrList.svg" alt=""></span>--><!--                    <div class="searchBar" style="margin-right: 10px;">--><!--                        <form name="searchForm" class="form-search form-inline">--><!--                            <div class="input-group pull-right" id="test">--><!--                                <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}">--><!--                                <span class="input-group-btn btn-searched">--><!--                                    <button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button>--><!--                                </span>--><!--                            </div>--><!--                        </form>--><!--                    </div>--></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="fw8"><span>\u573A\u666F\u56FE</span></th><th class="fw8"><span>\u540D\u79F0</span></th><th class="fw8"><span>\u64CD\u4F5C</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="data in vm.data track by data.id"><td><img style="max-width: 100px; max-height: 100px" ng-src="{{data.cover+\'?imageView2\'}}"></td><td style="line-height: 100px">{{data.name}}</td><td class="text-right"><a ng-click="look(data)">\u67E5\u770B</a> <span style="color: #e9e9e9; margin-left: 4px; margin-right: 4px">|</span> <a ng-click="edit(data)">\u7F16\u8F91</a> <span style="color: #e9e9e9; margin-left: 4px; margin-right: 4px">|</span> <a ng-click="delete(data.id)">\u5220\u9664</a></td></tr></tbody></table></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination></div></div></div><style>.el-tage.l-tag--warning {\n        background-color: #ffffff;\n        border-color: #7541e9;\n        color: #7541e9;\n    }\n    .el-tage {\n        background-color: #ecf5ff;\n        display: inline-block;\n        padding:1px 7px;\n        font-size: 12px;\n        color: #409eff;\n        border: 1px solid #d9ecff;\n        border-radius:0 0 4px 0;\n        box-sizing: border-box;\n        white-space: nowrap;\n    }</style>');
$templateCache.put('app/entities/scene/three-preview.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: 0 auto; position: relative"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/loading.gif" style="max-width: 50%; max-height: 50%"></div><img ng-src="{{vm.backgroundImg}}" alt="" ng-if="vm.backgroundImg" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%"><div id="threeView" ng-show="!vm.loading && !vm.error" style="position:absolute;left: 0;top: 0;z-index: 1;width: 100%; height: 100%"></div></div><style>.loading-page3{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }</style>');
$templateCache.put('app/entities/setting/setting-dialog.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u65B0\u589E/\u7F16\u8F91\u80CC\u666F</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u80CC\u666F\u5206\u7C7B</label><div class=""><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.data.themeClassifyId" ng-options="item.id as item.name for item in vm.setting | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9\u80CC\u666F\u5206\u7C7B</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u6392\u5E8F</label><div class=""><input type="number" class="form-control border-radius5" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F" ng-model="vm.data.seq" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<=0)value=null"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u56FE\u7247</label><div class="" ng-if="!vm.data.id" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start"><div class="btn_addPic" ng-if="!vm.data.identifier"><input type="file" name="file" class="filePrew" accept="image/jpeg, image/png" multiple="multiple" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"> <img src="content/images/icon/upload_img.svg"></div><div ng-repeat="item in vm.attachments track by $index" style="position: relative; display: inline-block; text-align: center"><img style="width: 100px; height: 100px; object-fit: cover; border: 1px dashed #ccc; display: block" ng-src="{{domain + item.identifier +\'?imageView2/0/w/100/h/100\'}}"> <span style="display: block; font-size: 12px; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top: 4px">{{item.fileName}}</span> <i class="glyphicon glyphicon-remove" ng-click="removeFile(item,$index)" style="position: absolute; top: -8px; right: -8px; color: red; cursor: pointer; background: #fff; border-radius: 50%; padding: 2px"></i></div></div><div class="" ng-if="!!vm.data.id"><img style="width: 100px;  border: 1px dashed red" ng-src="{{domain + vm.data.identifier +\'?imageView2/0/w/100/h/100\'}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.cancel()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/setting/setting.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u80CC\u666F\u7BA1\u7406</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ng-click="add()"><i class="icon iconfont webadd"></i> <span>\u65B0\u589E\u80CC\u666F</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="c-form pull-left" style="position: relative;left: -20px"><label class="c-form-label">\u5206\u7C7B</label><div class="c-form-div" style="width: 120px"><select ng-model="vm.themeClassifyId" ng-change="vm.transition()" class="c-select1" ng-options="c.id as c.name for c in vm.class"><option value="">\u5168\u90E8\u5206\u7C7B</option></select></div></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><div class="pic-geometry" ng-repeat="data in vm.data track by data.id"><div class="pic-model"><div><img ng-src="{{domain + data.identifier+\'?imageView2/0/w/100/h/100\'}}"></div></div><div style="padding-top:7px">{{data.themeClassifyName}}</div><div class="pic-edit"><button ng-click="edit(data)" style="color: #ffffff; top: 20%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91</button> <button ng-click="delete(data.id)" style="color: #ffffff; top: 40%;font-size: 14pt" class="status-btn" type="submit"><i class="icon iconfont webshanchu"></i>\u5220\u9664</button></div></div></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/store/store-detail.html','<div class="listBGC" style="min-height: 700px;min-width: 1100px"><span class="breadcrumb-normal">\u5546\u6237 / <span class="breadcrumb-normal-step" translate="global.menu.entities.storeInfo"></span></span><div class="col-lg-12 col-sm-12 form-group pad-0 store-body"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-6 col-sm-6">\u5546\u6237\u4FE1\u606F</div><div class="col-lg-6 col-sm-6 store-body-head-btn"><span ui-sref="step1">\u5FEB\u901F\u8BBE\u7F6E</span></div></div><div class="col-lg-12 col-sm-12 flex-btn-group-container store-body-con"><div class="flex-2 store-body-con-part"><div class="store-body-con-part-logo"><img src="content/images/leftbar_logo_unfold.png" ng-if="!vm.store.menuLogo"> <img alt="\u56FE\u7247\u7F3A\u5931" ng-if="!!vm.store.menuLogo" ng-src="{{domain + vm.store.menuLogo}}"><div>\u70B9\u51FB\u66FF\u6362</div><input type="file" name="file" class="form-control pad-0 input-upload2" accept="image/jpeg, image/png" onchange="uploadPic(event,\'menuLogo\')" ng-model-options="{debounce : 500}"></div><div class="store-body-con-part-name"><span class="text-ellipsis" ng-if="!vm.isEdit3">{{vm.store.name}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u8BF7\u8F93\u5165" ng-model="vm.store.name" ng-if="vm.isEdit3" style="width: 100%"> <img src="content/images/10.png" ng-click="vm.isEdit3=true" ng-if="!vm.isEdit3"><div class="store-body-con-part-name-edit" ng-if="vm.isEdit3"><button class="small-btn-normal" ng-click="saveStore()">\u4FDD\u5B58</button> <button class="small-btn-disabled" ng-click="cancelStore()">\u53D6\u6D88</button></div></div></div><div class="flex-1 store-body-con-part-info"><img src="content/images/11.png"><div class="store-body-con-part-info-text"><span>\u6FC0\u6D3B\u72B6\u6001</span><div>{{vm.store.activated ? \'\u5DF2\u6FC0\u6D3B\' : \'\u672A\u6FC0\u6D3B\'}}</div></div></div><div class="flex-1 store-body-con-part-info"><img src="content/images/12.png"><div class="store-body-con-part-info-text"><span>\u6FC0\u6D3B\u65E5\u671F</span><div>{{(vm.store.activationDate != null) ? (vm.store.activationDate | date:\'mediumDate\') : \'\u6682\u65E0\'}}</div></div></div><div class="flex-1 store-body-con-part-info"><img src="content/images/13.png"><div class="store-body-con-part-info-text"><span>\u6709\u6548\u671F</span><div>{{(vm.store.periodOfValidity != null) ? (vm.store.periodOfValidity | date:\'mediumDate\') : \'\u6682\u65E0\'}}</div></div></div></div><div class="col-lg-12 col-sm-12 mar-top-15"><div class="col-md-4 col-sm-4 col-xs-4"><div class="mar-bottom-20"><label translate="backApp.store.number2" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.number}}</span></div><div class="mar-bottom-20"><label translate="backApp.store.unique2" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.unique}}</span></div><div><label translate="backApp.store.phone1" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.phone}}</span></div></div><div class="col-md-4 col-sm-4 col-xs-4"><!-- <div class="mar-bottom-20">\n                    <label translate="backApp.store.level2" class="store-body-con-detail-label min-width-84"></label>\n                    <span class="store-body-con-detail-span">{{vm.store.level.name}}</span>\n                </div> --><div class="mar-bottom-20"><label translate="backApp.store.balance2" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.balance|currency}}</span></div><div class="mar-bottom-20"><label class="store-body-con-detail-label min-width-84">\u6388\u4FE1\u989D\u5EA6</label><span class="store-body-con-detail-span">{{vm.store.credit|currency}}</span></div><div class="mar-bottom-20"><label class="store-body-con-detail-label min-width-84">\u5DF2\u4F7F\u989D\u5EA6</label><span class="store-body-con-detail-span">{{vm.store.creditUsed|currency}}</span></div></div><div class="col-md-4 col-sm-4 col-xs-4"><div class="mar-bottom-20"><label translate="backApp.store.companyName2" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.companyName}}</span></div><div class="mar-bottom-20"><label translate="backApp.store.contact2" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.contact}}</span></div><!-- <div class="mar-bottom-20">\n                    <label translate="backApp.store.corporation2" class="store-body-con-detail-label min-width-84"></label>\n                    <span class="store-body-con-detail-span">{{vm.store.corporation}}</span>\n                </div> --><div><label translate="backApp.store.address2" class="store-body-con-detail-label min-width-84"></label><span class="store-body-con-detail-span">{{vm.store.address}}</span></div></div></div></div><div class="col-lg-5 col-sm-5 form-group pad-0 store-body"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-4 col-sm-4">\u4F5C\u54C1\u8BBE\u7F6E</div><div class="col-lg-8 col-sm-8 store-body-head-btn"><span ng-if="!vm.isEdit" ng-click="vm.isEdit=!vm.isEdit">\u7F16\u8F91</span> <span ng-if="vm.isEdit" ng-click="saveWork()">\u4FDD\u5B58</span> <span ng-if="vm.isEdit" ng-click="cancelWork()">\u53D6\u6D88</span></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div class="mar-bottom-20"><label translate="backApp.store.swap2" class="store-body-con-detail-label"></label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.swap?\'\u662F\':\'\u5426\'}}</span><label class="i-switch" ng-if="vm.isEdit"><div style="margin-left: 7px" ng-show="vm.storeWorkEdit.swap">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!vm.storeWorkEdit.swap">\u505C\u7528</div><input type="checkbox" ng-model="vm.storeWorkEdit.swap" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div><div class="mar-bottom-20"><label translate="backApp.store.bokeh2" class="store-body-con-detail-label"></label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.bokeh?\'\u662F\':\'\u5426\'}}</span><label class="i-switch" ng-if="vm.isEdit"><div style="margin-left: 7px" ng-show="vm.storeWorkEdit.bokeh">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!vm.storeWorkEdit.bokeh">\u505C\u7528</div><input type="checkbox" ng-model="vm.storeWorkEdit.bokeh" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div><div class="mar-bottom-20"><label class="store-body-con-detail-label">\u6A21\u677F\u5DE5\u5177\u56DE\u8C03\u8DEF\u5F84\uFF1A</label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.productXmlUrl}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u8BF7\u8F93\u5165\u56DE\u8C03\u8DEF\u5F84" ng-model="vm.storeWorkEdit.productXmlUrl" ng-if="vm.isEdit" style="width: 60%"></div><div class="mar-bottom-20"><label class="store-body-con-detail-label">\u6A21\u677F\u5DE5\u5177key\uFF1A</label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.productXmlKey}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u6A21\u677F\u5DE5\u5177key" ng-model="vm.storeWorkEdit.productXmlKey" ng-if="vm.isEdit" style="width: 69%"></div><div class="mar-bottom-20"><label class="store-body-con-detail-label">\u4EA7\u54C1\u5173\u8054\u7EA7\u522B\uFF1A</label><span class="store-body-con-detail-span" data-translate="{{\'backApp.store.XmlLevel.\'+ vm.storeWorkEdit.level}}" ng-if="!vm.isEdit && vm.storeWorkEdit.level!=null">{{vm.storeWorkEdit.level}}</span><select class="form-control border-radius display-inlineblock mar-bottom-10" name="level" ng-model="vm.storeWorkEdit.level" id="level" ng-if="vm.isEdit" style="width: 68%"><option value="ItemValue" data-translate="backApp.store.XmlLevel.ItemValue">ItemValue</option><option value="ProductXmlLine" data-translate="backApp.store.XmlLevel.ProductXmlLine">ProductXmlLine</option></select></div><div class="mar-bottom-20"><label class="store-body-con-detail-label">\u6309\u94AE\u6587\u6848\uFF1A</label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.buttonText}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u6309\u94AE\u6587\u6848" ng-model="vm.storeWorkEdit.buttonText" ng-if="vm.isEdit" style="width: 69%"> <span class="iconfont webduoyuyan mar-left-10" ng-if="vm.isEdit" ng-click="vm.multilingual(\'\u6309\u94AE\u6587\u6848\', vm.storeWorkEdit.buttonText, \'name\', \'buttonTextLanguages\')"></span></div><div class="mar-bottom-20"><label class="store-body-con-detail-label">\u50CF\u7D20\u4E0D\u8DB3\u63D0\u793A\uFF1A</label><label class="store-body-con-detail-label">\u56FE\u7247\u5927\u5C0F\u4F4E\u4E8E\uFF1A</label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.imgSize}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u56FE\u7247\u5927\u5C0F" ng-model="vm.storeWorkEdit.imgSize" ng-if="vm.isEdit" style="width: 70px"><label class="store-body-con-detail-label">KB</label></div><div class="mar-bottom-20" style="padding-left: 100px"><label class="store-body-con-detail-label">\u586B\u5145\u76F8\u6846\u68C0\u6D4B\u4F4E\u4E8E\uFF1A</label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.imgDpi}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u56FE\u7247dpi" ng-model="vm.storeWorkEdit.imgDpi" ng-if="vm.isEdit" style="width:70px"><label class="store-body-con-detail-label">dpi</label></div><div class="mar-bottom-20"><label class="store-body-con-detail-label">\u56FE\u7247\u7F29\u653E\u6BD4\u4F8B\uFF1A</label><span class="store-body-con-detail-span" ng-if="!vm.isEdit">{{vm.storeWorkEdit.thumbnail}}</span> <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u4F8B\u5982\uFF1A/thumbnail/800x800>\u6216\u8005/thumbnail/!20p" ng-model="vm.storeWorkEdit.thumbnail" ng-if="vm.isEdit" style="width: 69%"></div></div></div><div class="col-lg-5 col-sm-5 form-group pad-0 store-body mar-left-10"><div class="col-lg-12 col-sm-12 pad-0 store-body-head"><div class="col-lg-4 col-sm-4">\u8FD0\u8425\u8BBE\u7F6E</div><div class="col-lg-8 col-sm-8 store-body-head-btn"><span ng-if="!vm.isEdit4" ng-click="vm.isEdit4=!vm.isEdit4">\u7F16\u8F91</span> <span ng-if="vm.isEdit4" ng-click="saveOperation()">\u4FDD\u5B58</span> <span ng-if="vm.isEdit4" ng-click="cancelOperation()">\u53D6\u6D88</span></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40" ng-show="vm.store.multilingual"><div class="mar-top-24" style="display: flex;align-items: center" ng-if="!vm.isEdit4"><label translate="backApp.store.language" class="store-body-con-detail-label"></label><div class="lang" ng-repeat="language in vm.availableLanguages " style="margin-left: 10px"><span class="default-info">\u8BBE\u4E3A\u9ED8\u8BA4\u8BED\u8A00</span><div><button class="lang-btn" ng-class="{\'lang-btn-select\' : language.default}" ng-if="language.selected" ng-click="defaultLang(language)">{{language.key}}</button></div></div></div><div class="mar-top-24" style="display: flex;align-items: center" ng-if="vm.isEdit4"><label translate="backApp.store.language" class="store-body-con-detail-label"></label><div ng-repeat="lang in vm.availableLanguages"><input type="checkbox" ng-class="{\'lang-selected\': lang.selected}" style="width: 15px;height: 15px; margin-left: 15px" ng-model="lang.selected" ng-click="selectLang(lang)"><label style="margin-left: 10px; font-size: 15px">{{lang.key}}</label></div></div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div style="display: flex" ng-if="!vm.isEdit4"><label translate="backApp.store.browserIcon" class="store-body-con-detail-label"></label><div class="lang" style="margin-left: 10px;position: relative"><div ng-if="!vm.store.faviconLogo"><img src="content/images/icon/upload_img.svg"></div></div><span ng-if="vm.store.faviconLogo"><img class="picture-border" ng-src="{{domain + vm.store.faviconLogo}}"></span></div><div style="display: flex" ng-if="vm.isEdit4"><label translate="backApp.store.browserIcon" class="store-body-con-detail-label"></label><div class="lang" style="margin-left: 10px;position: relative"><input style="opacity: 0;width: 104px" ng-if="!vm.store.faviconLogo" type="file" name="file" class="form-control border-radius input-upload" accept=" image/jpeg, image/png" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"><div style="position: absolute;top: 0;left: 0px" ng-if="!vm.store.faviconLogo"><img src="content/images/icon/upload_img.svg"></div></div><span ng-if="vm.store.faviconLogo"><img class="picture-border" ng-src="{{domain + vm.store.faviconLogo}}"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(vm.store.faviconLogo)" style="color: red"></i></span></div><div style="margin: 6px 0 0 92px;color: #999">\u652F\u6301.png\u3001.jpg\u3001.jpeg</div></div><div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40"><div ng-if="!vm.isEdit4" style="padding-bottom: 20px"><div class="store-body-con-detail-label">CMYK\u8F6CRGB:{{vm.store.enableCmykToRgb ? \'\u5DF2\u542F\u7528\' : \'\u672A\u542F\u7528\'}}</div><div class="store-body-con-detail-label" ng-if="vm.store.enableCmykToRgb">\u81EA\u5B9A\u4E49\u7684ICC {{ vm.store.usingCustomIccProfile ? \'\u5DF2\u4F7F\u7528\' : \'\u672A\u4F7F\u7528\'}}</div><div ng-if="vm.store.enableCmykToRgb && vm.store.usingCustomIccProfile" style="margin-top: 10px"><div class="store-body-con-detail-label">\u6E90CMYK ICC: {{vm.store.sourceCmykIccName || \'\u672A\u4E0A\u4F20\'}}</div><div class="store-body-con-detail-label">\u76EE\u6807RGB ICC: {{vm.store.targetRgbIccName || \'\u672A\u4E0A\u4F20\'}}</div></div></div><div ng-if="vm.isEdit4" style="padding-bottom: 20px"><div style="display: flex; align-items: center"><input type="checkbox" style="width: 15px;height: 15px; margin-left: 15px;margin-top: 0" ng-model="vm.store.enableCmykToRgb"><label style="margin-left: 10px; font-size: 15px;margin-bottom: 0">\u542F\u7528CMYK\u8F6CRGB</label></div><div ng-if="vm.store.enableCmykToRgb" style="display: flex; align-items: center;padding-left: 28px"><input type="checkbox" style="width: 15px;height: 15px; margin-left: 15px;margin-top: 0" ng-model="vm.store.usingCustomIccProfile"><label style="margin-left: 10px; font-size: 15px;margin-bottom: 0">\u4F7F\u7528\u81EA\u5B9A\u4E49\u7684ICC <span style="font-size: 12px;font-weight:normal;color: #999">(\u4E0D\u9009\u62E9\u5C06\u4F7F\u7528\u5E73\u53F0\u7EDF\u4E00\u7684ICC)</span></label></div><div ng-if="vm.store.enableCmykToRgb && vm.store.usingCustomIccProfile" style="margin-top: 10px;padding-left: 28px"><div style="margin-bottom: 10px; display: flex; align-items: center"><label style="margin-left: 15px; min-width: 110px;margin-bottom: 0">\u6E90CMYK ICC:</label><span style="margin-left: 10px; color: #666">{{vm.store.sourceCmykIccName || \'\u672A\u4E0A\u4F20\'}}</span> <i class="glyphicon glyphicon-remove" ng-if="vm.store.sourceCmykIccName" ng-click="removeIccFile(\'cmyk\')" style="color: red; margin-left: 10px; cursor: pointer"></i><label class="btn btn-default btn-sm" ng-if="!vm.store.sourceCmykIccName" style="margin-left: 10px; margin-bottom: 0; cursor: pointer">+ \u4E0A\u4F20\u6587\u4EF6 <input type="file" accept=".icc" onchange="uploadIccFile(event,\'cmyk\')" style="display: none"></label></div><div style="margin-bottom: 10px; display: flex; align-items: center"><label style="margin-left: 15px; min-width: 110px;margin-bottom: 0">\u76EE\u6807RGB ICC:</label><span style="margin-left: 10px; color: #666">{{vm.store.targetRgbIccName || \'\u672A\u4E0A\u4F20\'}}</span> <i class="glyphicon glyphicon-remove" ng-if="vm.store.targetRgbIccName" ng-click="removeIccFile(\'rgb\')" style="color: red; margin-left: 10px; cursor: pointer"></i><label class="btn btn-default btn-sm" ng-if="!vm.store.targetRgbIccName" style="margin-left: 10px; margin-bottom: 0; cursor: pointer">+ \u4E0A\u4F20\u6587\u4EF6 <input type="file" accept=".icc" onchange="uploadIccFile(event,\'rgb\')" style="display: none"></label></div></div><div ng-if="vm.store.enableCmykToRgb && vm.store.usingCustomIccProfile" style="font-size: 12px;color: #999;padding-left: 15px">\u8BF7\u9009\u62E9.icc\u6587\u4EF6\uFF0C\u6CE8\u610F\u989C\u8272\u7A7A\u95F4\u4E0D\u540C\u7684icc\u4E0D\u80FD\u6DF7\u7528</div></div></div></div><!-- <div class="col-lg-7 col-sm-7 form-group pad-right-0">\n        <div class="col-lg-12 col-sm-12 pad-0 store-body">\n            <div class="col-lg-12 col-sm-12 pad-0 store-body-head">\n                <div class="col-lg-4 col-sm-4">\u7535\u5546\u914D\u7F6E</div>\n                <div class="col-lg-8 col-sm-8 store-body-head-btn">\n                    <span  ng-if="!vm.isEdit2" ng-click="vm.isEdit2=!vm.isEdit2">\u7F16\u8F91</span>\n                    <span ng-if="vm.isEdit2" ng-click="saveData()">\u4FDD\u5B58</span>\n                    <span ng-if="vm.isEdit2" ng-click="cancelData()">\u53D6\u6D88</span>\n                </div>\n            </div>\n            <div class="col-lg-12 col-sm-12 mar-top-24 pad-left-40">\n                <div class="mar-bottom-20">\n                    <label class="store-body-con-detail-label">appId\uFF1A</label>\n                    <span class="store-body-con-detail-span" ng-if="!vm.isEdit2">{{vm.data.appId}}</span>\n                    <input type="text" class="form-control border-radius display-inlineblock" readonly="true" placeholder="appId" ng-model="vm.data.appId" ng-if="vm.isEdit2" style="width: 84%">\n                </div>\n                <div class="mar-bottom-20">\n                    <label class="store-body-con-detail-label">appSecret\uFF1A</label>\n                    <span class="store-body-con-detail-span" ng-if="!vm.isEdit2">{{vm.data.appSecret}}</span>\n                    <input type="text" class="form-control border-radius display-inlineblock" readonly="true"  placeholder="appSecret" ng-model="vm.data.appSecret" ng-if="vm.isEdit2" style="width: 84%">\n                </div>\n                <div class="mar-bottom-20">\n                    <label class="store-body-con-detail-label">\u7EC4\u7248\u5B8C\u6210\u901A\u77E5\u63A5\u53E3\uFF1A</label>\n                    <span class="store-body-con-detail-span" ng-if="!vm.isEdit2">{{vm.data.combinationNotifyUrl}}</span>\n                    <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u7EC4\u7248\u5B8C\u6210\u901A\u77E5\u63A5\u53E3" ng-model="vm.data.combinationNotifyUrl" ng-if="vm.isEdit2" style="width: 76%">\n                </div>\n                <div class="mar-bottom-20">\n                    <label class="store-body-con-detail-label">\u4F5C\u54C1\u72B6\u6001\u901A\u77E5\u63A5\u53E3\uFF1A</label>\n                    <span class="store-body-con-detail-span" ng-if="!vm.isEdit2">{{vm.data.articleStatusNotifyUrl}}</span>\n                    <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u4F5C\u54C1\u72B6\u6001\u901A\u77E5\u63A5\u53E3" ng-model="vm.data.articleStatusNotifyUrl" ng-if="vm.isEdit2" style="width: 76%">\n                </div>\n                <div class="mar-bottom-20">\n                    <label class="store-body-con-detail-label">\u5FAE\u4FE1\u516C\u4F17\u53F7\u4FE1\u606F\u63A5\u53E3\uFF1A</label>\n                    <span class="store-body-con-detail-span" ng-if="!vm.isEdit2">{{vm.data.wechatInfoUrl}}</span>\n                    <input type="text" class="form-control border-radius display-inlineblock" placeholder="\u5FAE\u4FE1\u516C\u4F17\u53F7\u4FE1\u606F\u63A5\u53E3\uFF1A" ng-model="vm.data.wechatInfoUrl" ng-if="vm.isEdit2" style="width: 76%">\n                </div>\n            </div>\n        </div>\n    </div> --></div><style>.lang-btn{\n        width: 100px;\n        height: 40px;\n        background-color: white;\n        border-radius: 4px;\n        border: 1px solid #a8a8a8;\n    }\n    .lang-btn-select{\n        background-color: #e9f3ff;\n        border: 1px solid #59a0ff;\n        color: #59a0ff;\n    }\n    .default-info{\n        display: none;\n        position: absolute;\n        background-color: #404040;\n        top: -10px;\n        width: 90px;\n        color: white;\n        height: 35px;\n        border-radius: 8px;\n    }\n    .lang:hover .default-info{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .lang-selected{\n        background-color: #1989fa;\n    }</style>');
$templateCache.put('app/entities/store/store-dialog.html','<div class="listBGC"><div class="current-location"><div class="table-title"><span class="current-nav current-nav-active" ui-sref="store" translate="global.menu.entities.storeInfo">Setting</span></div></div><form ng-show="!vm.success" name="form" role="form" novalidate><div class="container-fluid model-detail-titel"><span class="current-title">\u57FA\u672C\u914D\u7F6E</span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.name" for="name">name</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control radius-5" name="name" id="name" ng-model="vm.store.name" ng-minlength="2" ng-maxlength="100" required><div ng-show="form.name.$dirty && form.name.$invalid"><p class="help-block" ng-show="form.name.$error.required" data-translate="global.messages.validate.required">this is required.</p><p class="help-block" ng-show="form.name.$error.minlength" data-translate="global.messages.validate.minlength2">this is required to be at least 2 characters.</p><p class="help-block" ng-show="form.name.$error.maxlength" data-translate="global.messages.validate.maxlength100">this cannot be longer than 100 characters.</p></div></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.number">number</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control radius-5" ng-model="vm.store.number" readonly="true"></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.phone" for="phone">phone</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control radius-5" name="phone" id="phone" ng-model="vm.store.phone" ng-pattern="/^1[3|4|5|7|8][0-9]{9}$/" required><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required" data-translate="global.messages.validate.phone.required">Your phone is required.</p><p class="help-block" ng-show="form.phone.$error.pattern" data-translate="global.messages.validate.phone.invalid">Your phone is invalid.</p></div></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u5546\u6237\u7B49\u7EA7</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control radius-5" ng-model="vm.store.level.name" readonly="true"></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.balance">balance</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="number" class="form-control radius-5" ng-model="vm.store.balance" readonly="true"></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.automaticDeduction">automaticDeduction</label><div class="col-md-4 col-sm-4 col-xs-4"><button type="button" class="btn" ng-click="automaticDeduction(false)" ng-style="{backgroundColor:!vm.store.automaticDeduction?\'red\' :\'\',color:!vm.store.automaticDeduction?\'white\':\'\',border:!vm.store.automaticDeduction?\' 1px solid #e5e6e7\':\'\'}" style="padding: 5px 10px; text-align: center; margin-right: 10px">\u5173\u95ED</button> <button type="button" class="btn" ng-click="automaticDeduction(true)" ng-style="{backgroundColor:vm.store.automaticDeduction?\'red\' :\'\',color:vm.store.automaticDeduction?\'white\':\'\',border:vm.store.automaticDeduction?\' 1px solid #e5e6e7\':\'\'}" style="padding: 5px 10px; text-align: center; margin-right: 10px">\u5F00\u542F</button> <img style="margin-top: 5px" title="\n\u5F00\u542F\u6B64\u529F\u80FD\uFF0C\u5F53\u7528\u6237\u4E0B\u5355\u6570\u8D85\u8FC7\u5F53\u524D\u5546\u54C1\u5E93\u5B58\u91CF\u65F6\uFF0C\u4F1A\u89E6\u53D1\u7CFB\u7EDF\u81EA\u52A8\u5411\u5E73\u53F0\n\u7533\u8BF7\u8BA2\u8D2D\uFF0C\u5BA2\u6237\u53EF\u4EE5\u7EE7\u7EED\u4E0B\u5355\u3002\u8BE5\u529F\u80FD\u901A\u8FC7\u4F59\u989D\u51CF\u6263\u65B9\u5F0F\u6765\u4E0E\u5E73\u53F0\u8FDB\u884C\u5546\u54C1\n\u7ED3\u7B97\uFF0C\u76F4\u5230\u4F59\u989D\u4E0D\u8DB3\u3002" src="content/images/notes.png"></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12" ng-if="vm.store.storeType == \'Company\'"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.companyCode" for="companyCode">companyCode</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control radius-5" name="companyCode" id="companyCode" ng-model="vm.store.companyCode" ng-maxlength="100" required><div ng-show="form.companyCode.$dirty && form.companyCode.$invalid"><p class="help-block" ng-show="form.companyCode.$error.required" data-translate="global.messages.validate.required">this is required.</p><p class="help-block" ng-show="form.companyCode.$error.maxlength" data-translate="global.messages.validate.maxlength100">this cannot be longer than 18 characters.</p></div></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.contact" for="field_contact">contact</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control radius-5" name="field_contact" id="field_contact" ng-model="vm.store.contact" ng-minlength="2" ng-maxlength="100" required><div ng-show="form.contact.$dirty && form.contact.$invalid"><p class="help-block" ng-show="form.contact.$error.required" data-translate="global.messages.validate.required">this is required.</p><p class="help-block" ng-show="form.contact.$error.minlength" data-translate="global.messages.validate.minlength2">this is required to be at least 4 characters.</p><p class="help-block" ng-show="form.contact.$error.maxlength" data-translate="global.messages.validate.maxlength100">this cannot be longer than 18 characters.</p></div></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" style="padding: 6px 12px" translate="backApp.store.activated">Activated</label><div class="col-md-5 col-sm-5 col-xs-5" style="padding: 8px 18px"><span>{{vm.store.activated ? \'\u5DF2\u6FC0\u6D3B\' : \'\u672A\u6FC0\u6D3B\'}}</span></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" style="padding: 6px 12px" translate="backApp.store.activationDate">activationDate</label><div class="col-md-4 col-sm-4 col-xs-4" style="padding: 8px 18px"><span>{{(vm.store.activationDate != null) ? (vm.store.activationDate | date:\'mediumDate\') : \'\u6682\u65E0\'}}</span></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" style="padding: 6px 12px" translate="backApp.store.periodOfValidity">periodOfValidity</label><div class="col-md-4 col-sm-4 col-xs-4" style="padding: 8px 18px"><span>{{(vm.store.periodOfValidity != null) ? (vm.store.periodOfValidity | date:\'mediumDate\') : \'\u6682\u65E0\'}}</span></div><div class="col-md-6 col-sm-6 col-xs-6"></div></div></div></div></form><div class="" style="padding-top:20px; text-align:left"><button type="button" ng-click="vm.save2()" ng-disabled="vm.isSaving" class="btn btn-info" style="width: 50px;text-align: center;margin-right: 10px"><span translate="entity.action.save">Save</span></button> <button type="button" ng-click="vm.cancel()" class="btn btn-cancel" style="width: 50px;text-align: center">\u8FD4\u56DE</button></div></div>');
$templateCache.put('app/entities/store/store-dialog2.html','<form name="editForm" role="form" novalidate ng-submit="vm.activation()" class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" id="myRoleLabel" translate="backApp.store.home.createOrEditLabel2"></h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="backApp.store.key" for="field_key">key</label><div class="col-md-9 col-sm-9 col-xs-9"><input class="form-control" name="field_key" placeholder="\u8BF7\u8F93\u5165\u6CE8\u518C\u6FC0\u6D3B\u7801" id="field_key" ng-model="vm.store.key" required></div></div></div></div></div><div class="modal-footer"><span class="input-group-btn width-min btn-clear"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-info"><span translate="entity.action.save">Save</span></button> </span><span class="input-group-btn width-min btn-clear"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></button></span></div></form>');
$templateCache.put('app/entities/store/store-dialog3.html','<form name="editForm" role="form" novalidate ng-submit="vm.activation()" class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" id="myRoleLabel" translate="backApp.store.home.createOrEditLabel2"></h4></div><div class="modal-body"><div class="panel-body form-horizontal" ng-if="!vm.prepare"><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel" translate="backApp.store.periodOfValidity" for="periodOfValidity">periodOfValidity</label><div class="col-md-9 col-sm-9 col-xs-9"><span>{{(vm.store.periodOfValidity != null) ? (vm.store.periodOfValidity | date:\'mediumDate\') : \'\u6682\u65E0\'}}</span></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel" translate="backApp.store.buyTime">buyTime</label><div class="col-md-9 col-sm-9 col-xs-9"><div class="pad-10 text-center1 mar-right-10 mar-bottom-15 outline" ng-style="{border:rechargeSetting.id == vm.rechargeSetting.id ? \'1px solid #fe5454\': \'1px solid #7B7B7B\'}" ng-click="selectedRecgarge(rechargeSetting)" style="min-width:124px;float: left" ng-repeat="rechargeSetting in vm.rechargeSettings track by $index"><span style="font-size: 16px" ng-style="{color:rechargeSetting.id == vm.rechargeSetting.id ? \'#fe5454\': \'#7B7B7B\'}">{{rechargeSetting.number}}\u4E2A\u6708</span><br><span style="font-size: 12px" ng-style="{color:rechargeSetting.id == vm.rechargeSetting.id ? \'#fe5454\': \'#a9a9a9\'}">\u552E\u4EF7{{rechargeSetting.price|number:2}}\u5143</span></div></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel" translate="backApp.store.payMethod">payMethod</label><div class="col-md-9 col-sm-9 col-xs-9"><div class="pad-5" style="float: left;border: 1px solid #fe5454"><img src="./content/images/icon/wechat.svg"> <span style="color: #fe5454">\u5FAE\u4FE1\u652F\u4ED8</span></div></div></div></div><div class="panel-body form-horizontal" ng-if="!!vm.prepare"><div class="col-lg-12 col-sm-12"><img src="./content/images/wechat_pay.png"> <img src="{{image}}" style="position: absolute;top: 59px;left: 88px;height: 190px"></div></div></div><div class="modal-footer"><span class="input-group-btn width-min btn-clear" ng-if="!vm.prepare"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-info"><span>\u5145\u503C</span></button> </span><span class="input-group-btn width-min btn-clear"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></button></span></div></form>');
$templateCache.put('app/entities/store/store-workEdit-edit.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="con"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A<a ui-sref="store-work">\u4F5C\u54C1\u8BBE\u7F6E</a>/\u4F5C\u54C1\u8BBE\u7F6E\u7F16\u8F91</span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.swap">swap</label><div class="col-md-5 col-sm-5 col-xs-5" style="width: 75px"><label class="col-md-1 col-sm-1 col-xs-1 i-switch m-t-xs m-b-xs mar-right-10"><input type="checkbox" ng-model="vm.storeWorkEdit.swap" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label" translate="backApp.store.bokeh">bokeh</label><div class="col-md-5 col-sm-5 col-xs-5" style="width: 75px"><label class="col-md-1 col-sm-1 col-xs-1 i-switch m-t-xs m-b-xs mar-right-10"><input type="checkbox" ng-model="vm.storeWorkEdit.bokeh" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div><div class="col-md-1 col-sm-1 col-xs-1" style="padding-top: 5px"><img onmouseover="showSkuList(event)" onmouseout="hideSkuList(event)" class="paybatch-proName" src="content/images/notes.png"><div class="paybatch-tip" style="width: 440px;z-index: 900"><div class="text-ellipsis" style="padding: 10px 0">\u5982\u679C\u5F00\u542F\u865A\u5316\u529F\u80FD\uFF0C\u5219\u7528\u6237\u5728\u7F16\u8F91\u4F5C\u54C1\u65F6\uFF0C\u5BFC\u5165\u7167\u7247\u586B\u5145\u65B9\u5F0F\u4E3A\u81EA\u9002\u5E94\u5168\u5C4F<br>\u663E\u793A\uFF0C\u5176\u4F59\u90E8\u5206\u78E8\u7802\u6548\u679C\u586B\u5145\uFF0C\u5982\u679C\u5173\u95ED\uFF0C\u5219\u7167\u7247\u62C9\u4F38\u586B\u5145\u3002</div></div></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u6A21\u677F\u5DE5\u5177\u56DE\u8C03\u8DEF\u5F84</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u56DE\u8C03\u8DEF\u5F84" ng-model="vm.storeWorkEdit.productXmlUrl"></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u6A21\u677F\u5DE5\u5177key</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6A21\u677F\u5DE5\u5177key" ng-model="vm.storeWorkEdit.productXmlKey"></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u4EA7\u54C1\u5173\u8054\u7EA7\u522B</label><div class="col-md-5 col-sm-5 col-xs-5"><select class="form-control border-radius" name="level" ng-model="vm.storeWorkEdit.level" id="level"><option value="ItemValue" data-translate="backApp.store.XmlLevel.ItemValue">ItemValue</option><option value="ProductXmlLine" data-translate="backApp.store.XmlLevel.ProductXmlLine">ProductXmlLine</option></select></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u6309\u94AE\u6587\u6848</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6309\u94AE\u6587\u6848" ng-model="vm.storeWorkEdit.buttonText"></div></div></div></div><div class="mar-top-10"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.cancel()"><span>\u53D6\u6D88</span></button></div></div>');
$templateCache.put('app/entities/store/store-workEdit.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="con"><span class="breadcrumb-normal">\u5F53\u524D\u4F4D\u7F6E\uFF1A\u4F5C\u54C1\u8BBE\u7F6E</span></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel" translate="backApp.store.swap">swap</label><div class="col-md-5 col-sm-5 col-xs-5" style="width: 45px">{{vm.storeWorkEdit.swap?\'\u662F\':\'\u5426\'}}</div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel" translate="backApp.store.bokeh">bokeh</label><div class="col-md-5 col-sm-5 col-xs-5" style="width: 45px">{{vm.storeWorkEdit.bokeh?\'\u662F\':\'\u5426\'}}</div><div class="col-md-1 col-sm-1 col-xs-1"><img onmouseover="showSkuList(event)" onmouseout="hideSkuList(event)" class="paybatch-proName" src="content/images/notes.png"><div class="paybatch-tip" style="width: 440px"><div class="text-ellipsis" style="padding: 10px 0">\u5982\u679C\u5F00\u542F\u865A\u5316\u529F\u80FD\uFF0C\u5219\u7528\u6237\u5728\u7F16\u8F91\u4F5C\u54C1\u65F6\uFF0C\u5BFC\u5165\u7167\u7247\u586B\u5145\u65B9\u5F0F\u4E3A\u81EA\u9002\u5E94\u5168\u5C4F<br>\u663E\u793A\uFF0C\u5176\u4F59\u90E8\u5206\u78E8\u7802\u6548\u679C\u586B\u5145\uFF0C\u5982\u679C\u5173\u95ED\uFF0C\u5219\u7167\u7247\u62C9\u4F38\u586B\u5145\u3002</div></div></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u6A21\u677F\u5DE5\u5177\u56DE\u8C03\u8DEF\u5F84</label><div class="col-md-5 col-sm-5 col-xs-5">{{vm.storeWorkEdit.productXmlUrl}}</div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u6A21\u677F\u5DE5\u5177key</label><div class="col-md-5 col-sm-5 col-xs-5">{{vm.storeWorkEdit.productXmlKey}}</div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u4EA7\u54C1\u5173\u8054\u7EA7\u522B</label><div class="col-md-5 col-sm-5 col-xs-5"><span data-translate="{{\'backApp.store.XmlLevel.\'+ vm.storeWorkEdit.level}}">{{vm.storeWorkEdit.level}}</span></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u6309\u94AE\u6587\u6848</label><div class="col-md-5 col-sm-5 col-xs-5">{{vm.storeWorkEdit.buttonText}}</div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u50CF\u7D20\u4E0D\u8DB3\u63D0\u793A\uFF1A</label><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u56FE\u7247\u5927\u5C0F\u4F4E\u4E8E\uFF1A</label><div class="col-md-5 col-sm-5 col-xs-5">{{vm.storeWorkEdit.imgSize}}</div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label readLabel">\u586B\u5145\u76F8\u6846\u68C0\u6D4B\u4F4E\u4E8E\uFF1A</label><div class="col-md-5 col-sm-5 col-xs-5">{{vm.storeWorkEdit.imgDpi}}</div></div></div></div><div class="mar-top-10"><button type="button" ui-sref="store-work-edit" class="small-btn-normal"><span>\u7F16\u8F91</span></button></div></div>');
$templateCache.put('app/entities/store-user/phone-editor.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u4FEE\u6539\u624B\u673A\u53F7</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2">\u8BF7\u8F93\u5165\u65B0\u7684\u624B\u673A\u53F7</label><div class="" style="position: relative"><input type="text" oninput="value=value.replace(/[^\\d]/g,\'\')" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u65B0\u7684\u624B\u673A\u53F7" ng-model="vm.data.phone" minlength="11" maxlength="11" required> <button class="col-lg-2 col-sm-2 col-xs-2 border-style1 pad-0" ng-bind="paracont" ng-disabled="vm.disabled" ng-click="getVerifyCode()" style="position: absolute; right: 2px;top: 2px; height: 89%;width: 100px">\u83B7\u53D6\u9A8C\u8BC1\u7801</button></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2">\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801</label><div class=""><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801" ng-model="vm.data.code" minlength="4" maxlength="4" required></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div><style>.ui-pnotify{\n        z-index: 99999 !important;\n    }</style>');
$templateCache.put('app/entities/store-user/store-user-detail.html','<div class="listBGC listDetail"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="backApp.storeUser.detail.title">storeUser</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="backApp.storeUser.name">name</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.storeUser.name}}</div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="backApp.storeUser.activated">Activated</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.storeUser.activated?"\u662F":"\u5426"}}</div></div></div><div class="col-lg-6 col-sm-6 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label readLabel" translate="backApp.storeUser.role">role</label><div class="col-md-9 col-sm-9 col-xs-9">{{vm.storeUser.roleName}}</div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-cancel" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/store-user/store-user-dialog.html','<div class="listBGC" style="min-height: 700px;min-width: 850px"><div class="mar-top-24 mar-bottom-10"><!--        <span class="breadcrumb-normal">\u7528\u6237 / <a ui-sref="store-user">\u7528\u6237\u7BA1\u7406</a>/\u7528\u6237{{vm.title}}</span>--> <span class="breadcrumb-normal">\u7528\u6237 / <span class="breadcrumb-normal-step">\u7528\u6237\u7BA1\u7406 / \u7528\u6237{{vm.title}}</span></span></div><div class="modal-body" style="height: calc(89vh - 121px)"><div class="panel-body form-horizontal"><!--\u7F16\u8F91\u7528\u6237\u540D--><div class="col-lg-12 col-sm-12 col-xs-12 pad-0" ng-if="!!vm.storeUser.id"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label readLabel" translate="backApp.storeUser.name">name</label><div class="col-md-4 col-sm-4 col-xs-4"><span>{{vm.storeUser.name}}</span></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div><!--\u6CE8\u518C\u7528\u6237\u540D--><div class="col-lg-12 col-sm-12 col-xs-12 pad-0" ng-if="!vm.storeUser.id"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label" translate="backApp.storeUser.name">name</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control border-radius" ng-model="vm.storeUser.name" placeholder="\u8BF7\u8F93\u5165\u7528\u6237\u540D" maxlength="20"></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div><!-- \u6CE8\u518C\u624B\u673A\u53F7 --><div class="col-lg-12 col-sm-12 col-xs-12 pad-0" ng-if="!vm.storeUser.id||!vm.storeUser.phone"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label" translate="">\u624B\u673A\u53F7</label><div class="col-md-4 col-sm-4 col-xs-4"><input type="text" class="form-control border-radius" ng-model="vm.phone" placeholder="\u624B\u673A\u53F7" maxlength="20"></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div><!-- \u9A8C\u8BC1\u7801 --><div class="col-lg-12 col-sm-12 col-xs-12 pad-0" ng-if="!vm.storeUser.id||!vm.storeUser.phone"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label" translate="">\u9A8C\u8BC1\u7801</label><div class="col-md-4 col-sm-4 col-xs-4" style="position:relative"><input type="text" class="form-control border-radius" name="verifyCode" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801" ng-model="vm.verifyCode" required> <button class="col-lg-2 col-sm-2 col-xs-2 border-style1 pad-0" ng-bind="paracont" ng-disabled="vm.disabled" ng-click="getVerifyCode()" style="position: absolute; right: 15px; transform: translate(-5%,-110%);height: 80%">\u83B7\u53D6\u9A8C\u8BC1\u7801</button></div></div></div><!-- \u6709\u624B\u673A\u53F7\u7684\u72B6\u6001 --><div class="col-lg-12 col-sm-12 col-xs-12 pad-0" ng-if="!!vm.storeUser.phone"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label readLabel" translate="\u624B\u673A\u53F7">phone</label><div class="col-md-4 col-sm-4 col-xs-4"><span>{{vm.storeUser.phone}}</span></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div><!-- \u72B6\u6001 --><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label" translate="backApp.storeUser.activated" for="field_activated"></label><div class="col-md-4 col-sm-4 col-xs-4"><label class="i-switch m-t-xs m-b-xs"><div style="margin-left: 7px" ng-show="vm.storeUser.activated">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!vm.storeUser.activated">\u505C\u7528</div><input type="checkbox" ng-model="vm.storeUser.activated" name="activated" id="field_activated" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="form-group"><label class="col-md-1 col-sm-1 col-xs-1 control-label pad-0 text-right" translate="backApp.storeUser.role" for="field_role">role</label><div class="col-md-4 col-sm-4 col-xs-4"><select class="form-control border-radius" id="field_role" name="role" ng-model="vm.storeUser.roleId" ng-options="role.id as role.name for role in vm.roles | orderBy:\'id\'"><option value=""></option></select></div></div><div class="col-md-7 col-sm-7 col-xs-7"></div></div></div></div><div class="mar-top-10"><button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></div>');
$templateCache.put('app/entities/store-user/store-users.html','<div class="listBGC" style="min-width: 1300px"><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><span class="breadcrumb-normal">\u7528\u6237 / <span translate="global.menu.entities.storeUser">storeUser</span></span><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal" ui-sref="store-user.new"><span translate="backApp.storeUser.home.createLabel">Create new storeUser</span> <i class="icon iconfont iconjia1"></i></button> <button class="oval-btn-normal-empty" ng-click="deleteBatch()" ng-show="selectOne"><span>\u6279\u91CF\u5220\u9664</span> <i class="icon iconfont iconcuo"></i></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr><th style="width: 100px"><i class="choose-list" ng-show="!selectAll" ng-click="chooseAll()"></i> <i class="choose-sel-all" ng-show="selectAll" ng-click="chooseAll()"></i></th><th><span data-translate="backApp.storeUser.name">Name</span></th><th><span data-translate="backApp.storeUser.phone">phone</span></th><th><span data-translate="backApp.storeUser.activated">Activated</span></th><th><span data-translate="backApp.storeUser.role">Role</span></th><th style="width: 300px"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="storeUser in vm.storeUsers track by storeUser.id"><td><i class="choose-li" ng-click="chooseOne(storeUser)" ng-show="!storeUser.select"></i> <i class="choose-sel" ng-click="chooseOne(storeUser)" ng-show="storeUser.select"></i></td><td ng-bind="storeUser.name" style="display: table-cell; vertical-align: middle"></td><td ng-bind="storeUser.phone" style="display: table-cell; vertical-align: middle"></td><td ng-bind="storeUser.activated?\'\u662F\':\'\u5426\'" style="display: table-cell; vertical-align: middle"></td><td ng-bind="storeUser.roleName" style="display: table-cell; vertical-align: middle"></td><td style="width: 200px; max-width: 200px; min-width: 200px"><button class="status-btn" type="submit" ui-sref="store-user.edit({id:storeUser.id})" class="btn-text" ng-hide="storeUser.isCreated||vm.account.name==storeUser.name"><i class="icon iconfont webxiugai"></i>\u7F16\u8F91 <span class="hover-span">\u7F16\u8F91</span></button> <button class="status-btn" type="submit" ng-click="editorPhone(storeUser)" class="btn-text" ng-hide="storeUser.isCreated||vm.account.name==storeUser.name"><i class="icon iconfont webxiugai"></i>\u4FEE\u6539\u624B\u673A\u53F7 <span class="hover-span" style="width:auto !important">\u4FEE\u6539\u624B\u673A\u53F7</span></button> <button class="status-btn" type="submit" ng-click="resetPassword(storeUser)" class="btn-text" ng-hide="storeUser.isCreated||vm.account.name==storeUser.name"><i class="icon iconfont webzhongzhi"></i>\u91CD\u7F6E <span class="hover-span">\u91CD\u7F6E</span></button> <button class="status-btn" type="submit" ng-click="delete(storeUser.id)"><i class="icon iconfont webshanchu"></i>\u5220\u9664 <span class="hover-span">\u5220\u9664</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/taskbill-form/taskbill-form-dialog.html','<div class="listBGC" style="min-height: 700px; width: auto" novalidate><div class="container-fluid model-detail-titel"><span class="current-title current-menu">{{!vm.form.id ? \'\u65B0\u5EFA\u4EFB\u52A1\u5355\' : \'\u7F16\u8F91\u4EFB\u52A1\u5355\'}}</span></div><div class="con taskbill" style="display: flex"><div class="modal-body" style="min-width: 620px; width: 620px;  position: relative; padding: 10px"><div style="min-height: 600px"><div class="mar-top-15"><label class="mar-right-10">\u4EFB\u52A1\u5355\u540D\u79F0:</label><input type="text" class="num-input" style="width: 200px" name="name" ng-model="vm.form.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0"> <span style="color: red">*</span></div><div class="mar-top-15"><label class="mar-right-10">\u4EFB\u52A1\u5355\u5C3A\u5BF8:</label><input type="number" class="num-input" min="10" step="1" style="width: 60px" name="w" ng-model="vm.form.width" placeholder="\u957F" ng-change="vm.onFormSizeChange()"> <span>X</span> <input type="number" class="num-input" min="10" step="1" style="width: 60px" name="w" ng-model="vm.form.height" placeholder="\u5BBD" ng-change="vm.onFormSizeChange()"> <span>mm</span> <span style="color: red">*</span></div><div class="mar-top-15"><label>\u4EFB\u52A1\u5355\u80CC\u666F:</label><input style="width: 25px; height: 25px; padding: 0" type="color" ng-model="vm.form.backgroundColor"></div><div class="mar-top-15 taskbill-items"><table style="width: 600px"><thead><th style="width: 160px; text-align: center">\u5185\u5BB9:</th><th style="width: 80px; text-align: center"></th><th style="width: 100px">\u5B57\u6BB5\u957F</th><th style="width: 100px">\u5B57\u6BB5\u5BBD</th><th style="width: 80px">\u5B57\u4F53\u5927\u5C0F</th><th style="width: 60px; text-align: center">\u52A0\u7C97</th></thead><tbody><tr ng-repeat="item in vm.form.items track by $index" style="height: 30px"><td style="text-align: right">{{item.label || item.field}}</td><td style="text-align: center"><label class="i-switch"><input type="checkbox" class="" name="enabled" ng-model="item.enabled"><i></i></label></td><td><div ng-if="item.enabled" ng-style="{\'color\': (item.x + item.width) > vm.form.width ? \'red\' : \'unset\' }"><input class="num-input" style="width: 50px; text-align: right" type="number" min="5" step="1" name="item-w" ng-model="item.width" placeholder="\u957F"> <span>mm</span></div></td><td><div ng-if="item.enabled"><input class="num-input" style="width: 50px; text-align: right" type="number" min="5" step="1" name="item-h" ng-model="item.height" placeholder="\u5BBD"> <span>mm</span></div></td><td><div ng-if="item.enabled && item.text"><input class="num-input" style="width: 50px; text-align: right" type="number" min="9" step="1" name="item-font" ng-model="item.fontSize" placeholder="\u5B57\u53F7"> <span>pt</span></div></td><td style="text-align: center"><label class="i-switch" ng-if="item.enabled && item.text"><input type="checkbox" class="ng-valid ng-dirty ng-valid-parse ng-touched" name="bold" ng-model="item.bold"><i></i></label></td></tr></tbody></table></div><div class="" style="padding-top:20px; text-align:left"><button type="button" ng-disabled="vm.isSaving" class="small-btn-normal" ng-click="vm.save()"><span translate="entity.action.save">Save</span></button> <button type="button" class="small-btn-disabled" data-dismiss="modal" ng-click="vm.close()"><span translate="entity.action.back">back</span></button></div></div></div><div style="min-width: 620px; width: calc(100% - 620px);  position: relative; background-color: #f1f2f7"><div class="taskbill-panel-container" ng-style="{\'min-height\': \'600px\', \'margin\': vm.panel.marginWidth + \'px\'}"><div id="panel-client" class="taskbill-panel-client"><div class="taskbill-panel-form" ng-style="{backgroundColor: vm.form.backgroundColor, width: vm.form.width + \'mm\', height: vm.form.height + \'mm\', \'transform\': \'translate(\' + vm.panel.offsetX + \'px,\' + vm.panel.offsetY + \'px) scale(\' + vm.panel.scale + \')\'}"><div class="form-item" ng-repeat="item in vm.form.items track by $index" ng-if="item.enabled" ng-style="{\'left\': item.x + \'mm\', \'top\': item.y + \'mm\', \'width\': item.width + \'mm\', \'height\': item.height + \'mm\', \'background-color\': \'#ABABAB\' }" ng-mousedown="vm.onItemMousedown($event, item)" title="{{item.label}}"><div ng-style="{\'cursor\': vm.selected && vm.selected.item == item && vm.selected.dragging ? \'move\' : \'pointer\'}"><div ng-if="item.text" ng-style="{\'font-size\': item.fontSize + \'pt\', \'font-weight\': item.bold ? \'bold\' : \'normal\'}">{{item.label}}:&nbsp;{{item.demoValue}}</div><div ng-if="item.field == \'Barcode\'"><img class="form-barcode-image" src="content/images/barcode.png"></div><div ng-if="item.field == \'ProjectImg\'"><img class="form-projectImg" src="content/images/projectImg.png"></div><div ng-if="item.field == \'ProductImage\' || item.field == \'PreviewImage\'"><img class="form-projectImg" src="content/images/productImage.png"></div><div ng-if="item.field == \'PreviewImage\'"><img class="form-projectImg" style="object-fit: fill" src="content/images/previewImg.png"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/taskbill-form/taskbill-form-list.html','<div class="listBGC"><div class="breadcrumb-normal">\u5546\u54C1 / <span translate="global.menu.entities.TaskbillForm">\u81EA\u5B9A\u4E49\u4EFB\u52A1\u5355</span></div><div class="con"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><span class="input-group-btn width-min btn-clear"><button class="oval-btn-normal" ui-sref="taskbill-forms.new" perm="ROLE_TASK_BILL_FORM"><span translate="backApp.taskbillForm.home.createLabel">\u65B0\u5EFA</span></button></span><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'backApp.taskbillForm.home.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C \u7D22</button></span></div></form></div></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr><th><span translate="backApp.taskbillForm.name">\u540D\u79F0</span></th><th><span translate="backApp.taskbillForm.size">\u5C3A\u5BF8</span></th><th><span translate="backApp.taskbillForm.enable">\u662F\u5426\u6709\u6548</span></th><th style="width: 200px"><span translate="global.field.operate">\u64CD\u4F5C</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="form in vm.forms track by form.id"><td style="display: table-cell; vertical-align: middle">{{form.name}}</td><td style="display: table-cell; vertical-align: middle">{{form.width}}x{{form.height}}mm</td><td style="display: table-cell; vertical-align: middle">{{form.enabled?"\u662F":"\u5426"}}</td><td class="text-right"><button type="submit" ui-sref="taskbill-forms.edit({id:form.id})" class="btn-text model-list-action" perm="ROLE_TASK_BILL_FORM">\u7F16\u8F91</button> <button type="submit" ng-click="delete(form.id)" class="btn-text">\u5220\u9664</button></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/text-xml/text-xml.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F /<span>\u6587\u5B57\u6A21\u677F</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h"></div><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr style="font-weight: bold"><th class="fw8"><span>\u6587\u5B57\u540D\u79F0</span></th><th class="fw8"><span>\u6A21\u677F\u6837\u5F0F</span></th><th class="fw8"><span>\u72B6\u6001</span></th><th class="fw8"><span>\u5206\u7C7B</span></th><th class="fw8"><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="themeClassify in vm.themeClassifyList track by themeClassify.id"><td class="vertical-middle">{{themeClassify.name}}</td><td class="vertical-middle">{{themeClassify.seq}}</td><td class="vertical-middle"><label class="i-switch" ng-click="changeStatue(themeClassify.id,$event)"><div style="margin-left: 7px" ng-show="themeClassify.used">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!themeClassify.used">\u505C\u7528</div><input type="checkbox" ng-model="themeClassify.used" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></td></tr><tr ng-repeat="item in vm.textXmls track by item.id"><td style="line-height: 100px">{{item.name}}</td><td><img style="width: 100px; height: 100px" ng-src="{{item.cover}}"></td><td style="line-height: 100px">{{vm.status(item.status)}}</td><td style="line-height: 100px">{{item.themeClassifyName}}</td><td style="width: 200px; max-width: 200px; min-width: 200px"><button class="status-btn" type="submit" ui-sref="text-xml-approve({id:item.id})" ng-if="item.status == \'Creating\' || item.status == \'Created\'"><i class="icon iconfont webai53"></i> <span class="hover-span">\u901A\u8FC7</span></button> <button class="status-btn" type="submit" ng-click="rejected(item)" ng-if="item.status == \'Creating\' || item.status == \'Created\'"><i class="icon iconfont webRectangleCopy"></i> <span class="hover-span">\u62D2\u7EDD</span></button> <button class="status-btn" type="submit" ng-click="delete(item.id)"><i class="icon iconfont webshanchu"></i> <span class="hover-span">\u5220\u9664</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/entities/theme-classify/theme-classify-detail.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="platformApp.themeClassify.detail.title">title</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="platformApp.themeClassify.name">name</label><div class="flex-center-between"><input type="text" class="form-control" style="width: 95%" ng-model="vm.themeClassify.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"> <span class="iconfont webduoyuyan" ng-click="vm.multilingual()"></span></div></div></div><div class="col-lg-12 col-sm-12" ng-if="vm.themeClassify.type == \'TECHNIQUE\'"><div class="form-group"><label class="control-label2">\u5DE5\u827A\u5206\u7C7B</label><div class="flex-center-between"><select class="form-control border-radius diy-editor-head-right-sel" ng-model="vm.themeClassify.techniqueType" style="width: 95% !important"><option value="">\u8BF7\u9009\u62E9</option><option value="gold">\u70EB\u8272</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" translate="platformApp.themeClassify.seq">seq</label><div><input type="number" class="form-control" style="width: 95%" min="0" step="1" ng-model="vm.themeClassify.seq" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F\u5E8F\u53F7"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/theme-classify/theme-classify.html','<div class="listBGC" style="min-width: 1300px"><span class="breadcrumb-normal">\u6A21\u677F / <span>{{vm.classType == \'XML\' ? \'\u6A21\u677F\u5206\u7C7B\' :vm.classType == \'BG\' ? \'\u80CC\u666F\u5206\u7C7B\' :vm.classType == \'MASK\' ? \'\u8499\u7248\u5206\u7C7B\' :vm.classType == \'CLIPART\' ? \'\u7D20\u6750\u5206\u7C7B\' :vm.classType == \'TECHNIQUE\' ? \'\u5DE5\u827A\u5206\u7C7B\' :vm.classType == \'BORDER\' ?\'\u8FB9\u6846\u5206\u7C7B\' :vm.classType == \'RECOMMENDPIC\' ?\'\u63A8\u8350\u56FE\u7247\' :vm.classType == \'FONT\' ? \'\u6587\u5B57\u6A21\u677F\u5206\u7C7B\' : \'\'}}</span></span><div class="con"><div class="container-fluid pad-bottom-10"><div class="row"><div class="overflow-h mar-top-20" style="min-height: 32px"><div class="float-left"><button class="oval-btn-normal float-left" ng-click="addClass()"><i class="icon iconfont webadd"></i><span>\u65B0\u5EFA\u5206\u7C7B</span></button></div><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"> <span class="input-group-btn btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)">\u641C\u7D22</button></span></div></form></div></div></div></div><div class="table-responsive pad-left-15 pad-right-15"><table class="za-table table table-striped"><thead><tr style="font-weight: bold"><th><span data-translate="platformApp.themeClassify.name">Name</span></th><th ng-if="vm.classType == \'TECHNIQUE\'"><span>\u5DE5\u827A\u5206\u7C7B</span></th><th><span data-translate="platformApp.themeClassify.seq">seq</span></th><th><span data-translate="platformApp.themeClassify.used">used</span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody><tr ng-repeat="themeClassify in vm.themeClassifyList track by themeClassify.id"><td class="vertical-middle">{{themeClassify.name}}</td><td class="vertical-middle" ng-if="vm.classType == \'TECHNIQUE\'">{{themeClassify.techniqueType | techniqueType}}</td><td class="vertical-middle">{{themeClassify.seq}}</td><td class="vertical-middle"><label class="i-switch" ng-click="changeStatue(themeClassify.id,$event)"><div style="margin-left: 7px" ng-show="themeClassify.used">\u542F\u7528</div><div style="margin-left: 20px" ng-show="!themeClassify.used">\u505C\u7528</div><input type="checkbox" ng-model="themeClassify.used" class="ng-valid ng-dirty ng-valid-parse ng-touched"> <i></i></label></td><td style="width: 260px; max-width: 260px; min-width: 200px"><button class="status-btn" type="submit" ng-click="editClass(themeClassify)"><i class="icon iconfont webxiugai"></i> <span class="hover-span">\u7F16\u8F91</span></button> <button class="status-btn" type="submit" ng-click="delete(themeClassify.id)"><i class="icon iconfont webshanchu"></i> <span class="hover-span">\u5220\u9664</span></button></td></tr></tbody></table></div></div><div class="text-center1" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-link-numbers="true" boundary-links="false"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar" role="navigation"><div class="navbar-wrap"><div class="navbar-top" style="z-index: 7"><div class="navbar-logo"><img src="content/images/leftbar_logo_unfold.png" ng-show="!vm.menulogo" style="height: 36px"> <img alt="\u56FE\u7247\u7F3A\u5931" ng-show="!!vm.menulogo" ng-src="{{domain + vm.menulogo}}" style="height: 36px"> <span class="navbar-logo-line"></span> <span class="navbar-logo-name">{{vm.store.name}}</span></div><div class="navbar-collapse navbar-setting" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><div ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer navbar-user"><img src="content/images/icon/account.png" class="accout-menu-icon"><p class="dropdown-toggle moduleNavbarColor mar-0" uib-dropdown-toggle href="" id="account-menu" ng-click="vm.passwords()"><span class="users-a">{{vm.account.name}}</span><br><span class="account-menu-role">{{vm.account.roleName}}</span> <b class="nav-icon users-a"></b></p><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ng-click="resetPassword()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li></ul></div></div></div><div class="shell-nav scrollbar-main"><ul><li ng-repeat="module in vm.modules track by $index" ng-init="outerIndex = $index" ng-if="module.visiable"><div class="shell-nav-head clearfix list-menu" id="z{{$index}}"><div class="shell-nav-head-fl"><img ng-src="content/images/icon/store.png" ng-show="module.id == \'store\'"> <img ng-src="content/images/icon/product.png" ng-show="module.id == \'propertyCommercial\'"> <img ng-src="content/images/icon/productxml.png" ng-show="module.id == \'product-xml\'"> <img ng-src="content/images/icon/order.png" ng-show="module.id == \'sales-order\'"> <img ng-src="content/images/icon/data.png" ng-show="module.id == \'product-analysis\'"> <img ng-src="content/images/icon/user_model.png" ng-show="module.id == \'role\'"> <img ng-src="content/images/icon/invoice.png" ng-show="module.id == \'invoice\'"> <img ng-src="content/images/icon/caiwu.png" ng-show="module.id == \'caiwu\'"></div><div class="shell-nav-head-title">{{ module.name }}</div></div><div class="shell-nav-body"><a ng-repeat="nav in module.menus" ng-if="nav.visiable" class="sub_menu" ng-click="navSelect(nav,outerIndex)" id="{{nav.id}}" classtype="{{nav.classType}}" ng-class="{\'navOn\' : vm.classType?vm.navId == nav.id&&vm.classType==nav.classType:vm.navId == nav.id}">{{nav.name}}</a></div></li></ul></div><!--        <div class="navbar-collapse side" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">--><!--            <div class="sidebar1">--><!--                <div href="#/" class="sidebar1-shrink" ng-click="vm.shrink()">--><!--                    <button class="sidebar1-btn btn1-shrik1"></button>--><!--                </div>--><!--                <ul>--><!--                    <li class="bar1-active" perm ="ROLE_BANNER,ROLE_STORE,ROLE_STORE_WECHAT,ROLE_STYLE,ROLE_LOGO_SETTING,ROLE_MESSAGE_TEMPLATE,ROLE_REGION,ROLE_COUPON,ROLE_RECHARGE,ROLE_RECHARGE_RECORD,ROLE_PRICELIST,ROLE_BRANCH_SHOP,ROLE_SELF_OPERATION,TASK_ASSIGN,TASK_LIST">--><!--                        <a ng-class="{hover: vm.lmenu == \'a_storeManagement\'}"  ng-click="vm.lmenuClick(\'a_storeManagement\');" >--><!--                            <img src="content/images/icon/store.svg" alt="\u5546\u6237">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.storeManagement">storeManagement</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active"  perm ="ROLE_PRODUCT,ROLE_PRODUCT_PURCHASE,ROLE_CATEGORY,ROLE_PROPERTY">--><!--                        <a ng-class="{hover: vm.lmenu == \'a_templateManagement\'}" ng-click="vm.lmenuClick(\'a_templateManagement\');">--><!--                            <img src="content/images/icon/product.svg" alt="\u5546\u54C1">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.templateManagement">templateManagement</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active" ng-click="vm.lmenuClick(\'a_template\')" perm="ROLE_THEME_CATEGORY,ROLE_PRODUCT_XML,ROLE_DESIGNER_CONNETCING,ROLE_MASK,ROLE_BACKGROUND,ROLE_FONT_XML,ROLE_CLIPART">--><!--                        <a ng-class="{\'hover\': vm.lmenu == \'a_template\'}">--><!--                            <img src="content/images/icon/template.svg" alt="\u6A21\u677F">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.template">template</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active" perm="ROLE_CUSTOMER">--><!--                        <a ng-class="{hover: vm.lmenu == \'a_customerManagement\'}" ng-click="vm.lmenuClick(\'a_customerManagement\');" perm="ROLE_CUSTOMER">--><!--                            <img src="content/images/icon/customer.svg" alt="\u5BA2\u6237">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.customerManagement">customerManagement</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active" ng-click="vm.lmenuClick(\'a_daManagement\');" perm="ROLE_STATISTICS">--><!--                        <a ng-class="{hover: vm.lmenu == \'a_daManagement\'}">--><!--                            <img src="content/images/icon/data.svg" alt="\u6570\u636E">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.statisticalManagement">statisticalManagement</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active" ng-click="vm.lmenuClick(\'a_storeUser\');" perm="ROLE_ROLE,ROLE_USER">--><!--                        <a ng-class="{hover: vm.lmenu == \'a_storeUser\'}">--><!--                            <img src="content/images/icon/user.svg" alt="\u7528\u6237">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.storeUser">storeUser</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active" ng-click="vm.lmenuClick(\'a_invoice\');" perm="ROLE_INVOICE_LIST,ROLE_INVOICE_SUBMIT,ROLE_INVOICE_INFOMATION,ROLE_INVOICE_EXPRESS">--><!--                        <a ng-class="{hover: vm.lmenu == \'a_invoice\'}">--><!--                            <img src="content/images/icon/invoice.svg" alt="">--><!--                            <span class="bar1-text sidespan" translate="global.menu.entities.invoice">invoice</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--            <div class="sidebar2">--><!--                <ul ng-if="vm.lmenu == \'a_storeManagement\'">--><!--                    <li ui-sref="store" ui-sref-active="active" class="menu2" perm="ROLE_STORE" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.store" class="menu2-text">Store</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref-active="active" ui-sref="logo-setting" class="menu2" perm="ROLE_LOGO_SETTING" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.storeSetting"  class="menu2-text">storeSetting</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref-active="active" ui-sref="pay-orderNew" class="menu2" perm="ROLE_RECHARGE" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.storeRecharge"  class="menu2-text">storeRecharge</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref-active="active" ui-sref="configuration" class="menu2" perm="ROLE_STORE" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.configuration"  class="menu2-text">configuration</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="creditExtension" ui-sref-active="active" class="menu2" perm="ROLE_PRODUCT">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span class="menu2-text">\u6388\u4FE1\u8BB0\u5F55</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--                <ul ng-if="vm.lmenu == \'a_templateManagement\'">--><!--                    <li ui-sref="propertyCommercial" ui-sref-active="active" class="menu2" perm="ROLE_PROPERTY">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.commoditySpecification" class="menu2-text">commoditySpecification</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="category" ui-sref-active="active" class="menu2" perm = "ROLE_CATEGORY">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span translate="global.menu.entities.commodityClassification" class="menu2-text">commodityClassification</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="mould" ui-sref-active="active" class="menu2" perm="ROLE_PRODUCT_XML">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span translate="global.menu.entities.productMould" class="menu2-text">productMould</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="product" ui-sref-active="active" class="menu2" perm="ROLE_PRODUCT">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.templateManagement2" class="menu2-text">templateManagement2</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--                <ul ng-if="vm.lmenu == \'a_template\'">--><!--                    <li ui-sref="product-xml" ui-sref-active="active" class="menu2" perm="ROLE_PRODUCT_XML">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.productXml" class="menu2-text">productXml</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="material" ui-sref-active="active" class="menu2" perm="ROLE_CLIPART" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span class="menu2-text">\u7D20\u6750\u7BA1\u7406</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="setting" ui-sref-active="active" class="menu2" perm="ROLE_BACKGROUND" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span class="menu2-text">\u80CC\u666F\u7BA1\u7406</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="masking" ui-sref-active="active" class="menu2" perm="ROLE_MASK" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span class="menu2-text">\u8499\u7248\u7BA1\u7406</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="theme-classify" ui-sref-active="active" class="menu2" perm="ROLE_THEME_CATEGORY" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span class="menu2-text">\u5206\u7C7B\u7BA1\u7406</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="text-xml" ui-sref-active="active" class="menu2" perm="ROLE_FONT_XML" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span class="menu2-text">\u6587\u5B57\u6A21\u677F</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--                <ul ng-if="vm.lmenu == \'a_customerManagement\'">--><!--                    <li ui-sref="customer" class="menu2 "  ui-sref-active="active" perm="ROLE_CUSTOMER">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.customer" class="menu2-text">Customer</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--                <ul ng-if="vm.lmenu == \'a_daManagement\'">--><!--                    &lt;!&ndash; <li ui-sref="dataAnalysis" ui-sref-active="active" class="menu2" perm="ROLE_STATISTICS">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.daManagement2" class="menu2-text">daManagement</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="userAnalysis" ui-sref-active="active" class="menu2" perm="ROLE_STATISTICS">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.userAnalysis" class="menu2-text">userAnalysis</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="salesAnalysis" ui-sref-active="active" class="menu2" perm="ROLE_STATISTICS">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.salesManagement3" class="menu2-text">salesManagement3</span>--><!--                        </a>--><!--                    </li> &ndash;&gt;--><!--                    <li ui-sref-active="active" ui-sref="product-analysis" class="menu2">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.productAnalysis" class="menu2-text">product-analysis</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--                <ul ng-if="vm.lmenu == \'a_storeUser\'">--><!--                    <li ui-sref="role" ui-sref-active="active" class="menu2" perm="ROLE_ROLE">--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span translate="global.menu.entities.role" class="menu2-text">role</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="store-user" ui-sref-active="active" class="menu2" perm="ROLE_USER" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span translate="global.menu.entities.storeUser" class="menu2-text">storeUser</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--                <ul ng-if="vm.lmenu == \'a_invoice\'">--><!--                    <li ui-sref="invoice" ui-sref-active="active" class="menu2" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span translate="global.menu.entities.invoices" class="menu2-text">invoices</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref="pay-order2" ui-sref-active="active" class="menu2"  >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span translate="global.menu.entities.invoiceApplication" class="menu2-text">invoiceApplication</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref-active="active" ui-sref="invoice-setting-list" class="menu2"  >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.invoiceSetting"  class="menu2-text">invoiceSetting</span>--><!--                        </a>--><!--                    </li>--><!--                    <li ui-sref-active="active" ui-sref="invoice-location" class="menu2" perm="ROLE_INVOICE_EXPRESS" >--><!--                        <a ng-click="vm.collapseNavbar()">--><!--                            <span data-translate="global.menu.entities.ilocationManagement"  class="menu2-text">ilocationManagement</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--            <div ng-if="vm.lmenu != \'a_home\'" class="sidebar2-shrink" ng-click="vm.sidebar2Shrik()" onmouseover="showSidebar2Shrink(event)" onmouseleave="hideSidebar2Shrink(event)">--><!--                <button class="sidebar2-btn btn2-shrik1"></button>--><!--            </div>--><!--        </div>--></div></nav>');
$templateCache.put('app/layouts/navbar/navbar_login.html','<nav class="navbar" role="navigation"><div class="navbar-wrap"><div class=""><div href="#/" class="navbar-logo"><div class="logo-text pad-log"></div></div><div class="navbar-collapse navbar-setting language-pad" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"></div></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/entities/frame-config/modal/frame-config-approve.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC" style="padding:15px"><div class="modal-detail"><span>{{vm.name}}</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2">\u540D\u79F0</label><div class=""><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" ng-model="vm.textXml.name"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u5206\u7C7B</label><div class=""><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.textXml.themeClassifyId" ng-options="item.id as item.name for item in vm.themeClassifies | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9\u5206\u7C7B</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2">\u6392\u5E8F</label><div class=""><input type="number" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F" ng-model="vm.textXml.seq" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<=0)value=null"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u56FE\u7247</label><div class=""><img style="width: 100px; height: 100px; border: 1px dashed red" ng-src="{{vm.textXml.cover}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/frame-config/modal/frame-config-look.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u67E5\u770B</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="text-align: center"><img ng-src="{{vm.url}}" alt="" style="max-width: 100%; max-height: 300px"></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/initialization/modal/img-crop.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u88C1\u5207</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="text-align: center; min-height: 400px" ng-style="{height: (vm.data.height+100)}"><div id="imgCrop"></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="cropSave()">\u786E\u5B9A</button><!--        <button type="button" class="btn btn-info" ng-click="cropRotate()">\u65CB\u8F6C</button>--> <button type="button" class="btn btn-info" ng-click="cropRemove()">\u53D6\u6D88</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/initialization/modal/shop-modal.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u8BBE\u7F6E\u786E\u8BA4</div></div><div class="c-model-body" style="padding: 20px 0; text-align: center"><span style="font-size: 18px; font-weight: 600">\u8BBE\u7F6E\u6210\u529F\uFF0C\u5982\u9700\u66F4\u6539\u4FE1\u606F\uFF0C\u8BF7\u5230\u76F8\u5E94\u83DC\u5355\u4E2D\u4FEE\u6539\u5E76\u4FDD\u5B58\u3002</span></div><button class="oval-btn-normal" ng-click="vm.save()"><span>\u786E\u8BA4</span></button></div>');
$templateCache.put('app/entities/page/modal/blendent-modal.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u8BBE\u7F6E\u914D\u8272</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body"><div class="c-form" ng-repeat="item in vm.modelData" ng-if="!item.page && item.page!==0"><label class="c-form-label" style="width: 150px">{{item.materialName}}\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><input type="text" class="c-input1" ng-model="item.color" ng-style="{background: item.color ? item.color : \'#fff\'}" style="width: 150px"> <input type="color" ng-value="item.color" ng-model="item.color" ng-change="colorChange()" style="width: 40px; height: 32px"></div></div><three-preview-modal width="300" height="300" style="background: #fff" model-data="vm.modelData1" model-path="vm.modelPath"></three-preview-modal></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u8BA4\u6DFB\u52A0</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/page/modal/three-preview-modal.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: 20px auto; position: relative"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/ixon-loading.gif"></div><div id="threeView" ng-show="!vm.loading && !vm.error" style="width: 100%; height: 100%" ng-mouseover="onMouseOver()" ng-mouseout="onMouseOut()"></div></div><style>.modal-content {\n        width: 100%;\n    }</style>');
$templateCache.put('app/entities/store/modal/join.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u4E0A\u7EA7\u5546\u6237</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="padding: 20px 0"><div class="c-form" ng-repeat="item in vm.storeList"><label class="c-form-label"></label><div class="c-form-div lh35" ng-click="chooseOne(item)"><i class="choose-list" ng-show="!item.select"></i> <i class="choose-sel-all" ng-show="item.select"></i> <span>{{item.name}}</span></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }\n    .c-form{\n        margin: 0;\n    }</style>');
$templateCache.put('app/entities/text-xml/modal/text-xml-approve.html','<div class=""><div class="container-fluid"><div class="row moduleNameBGC"><div class="modal-detail"><span>\u5BA1\u6838</span></div></div></div><div class="modal-body"><div class="modal-body-scroll"><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u5206\u7C7B</label><div class=""><select class="form-control border-radius" id="themeClassify" name="themeClassify" ng-model="vm.textXml.themeClassifyId" ng-options="item.id as item.name for item in vm.themeClassifies | orderBy:\'id\'"><option value="">\u8BF7\u9009\u62E9\u5206\u7C7B</option></select></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u6392\u5E8F</label><div class=""><input type="number" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F" ng-model="vm.textXml.seq" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value<=0)value=null"></div></div></div><div class="col-lg-12 col-sm-12"><div class="form-group"><label class="control-label2" for="themeClassify">\u56FE\u7247</label><div class=""><img style="width: 100px; height: 100px; border: 1px dashed red" ng-src="{{vm.textXml.cover}}"></div></div></div></div></div><div class="modal-footer"><button type="submit" class="small-btn-normal mar-right-10" ng-disabled="vm.isSaving" ng-click="vm.save()"><span>\u4FDD\u5B58</span></button> <button type="submit" class="small-btn-disabled" ng-click="vm.clear()"><span translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/text-xml/modal/text-xml-look.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u67E5\u770B</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body" style="text-align: center"><img ng-src="{{vm.url}}" alt="" style="max-width: 100%; max-height: 300px"></div><div class="c-model-foot" style="text-align: center"><button type="button" class="small-btn-disabled" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');}]);})();